/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Api
 * Everyday Bullion inventory management API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccountBillingInvoiceDetail,
  AccountBillingInvoiceList,
  AccountBillingPaymentList,
  AccountBillingPaymentMethodList,
  AccountBillingPaypalCaptureResult,
  AccountBillingPaypalConfig,
  AccountBillingPaypalOrder,
  AccountBillingSummary,
  AccountProfile,
  AccountProfileError,
  AccountProfileUpdate,
  AccountSecurityActivityList,
  AccountSecurityOverview,
  AccountSecuritySessionList,
  AccountSettings,
  AccountSubscriptionView,
  AccountSummary,
  AccountTrialView,
  AccountUsageView,
  ActivateImageTemplate200,
  ActivityItem,
  AddFeatureRequestCommentInput,
  AlertListResponse,
  AlertPreference,
  AlertPreferenceUpdate,
  AlertsSummary,
  AnalyticsOverview,
  AppBranding,
  AppBrandingUpdate,
  ApplyRepairAction200,
  ApprovePricingChangeBody,
  ArchiveCategory200,
  ArchiveDocumentTemplate200,
  ArchiveGeneratedDocument200,
  ArchivePricingFeeProfile200,
  AskAiRequest,
  AskAiResponse,
  AssetActivityRow,
  AssetAssignInput,
  AssetDetail,
  AssetDocumentInput,
  AssetDocumentRow,
  AssetInput,
  AssetLabel,
  AssetListResponse,
  AssetOkResponse,
  AssetReturnInput,
  AssetRow,
  AssetStaffCounts,
  AssetStatusTransitionInput,
  AssetTransferInput,
  AssetUpdate,
  AssetsOverview,
  AssetsReportSummary,
  AuditLogList,
  AuthedUser,
  AutoCreatedProduct,
  AutoLinkTikTokProductsBySku200,
  AutomationLogList,
  AutomationRegistry,
  AutomationTestRequest,
  AutomationTestResult,
  AutomationWorkflowCreate,
  AutomationWorkflowDetail,
  AutomationWorkflowList,
  AutomationWorkflowUpdate,
  BackgroundJobAccepted,
  BatchLabelRequest,
  BatchLabelResult,
  BoxSaleEligibility,
  BreakdownInventoryBody,
  BulkAddInventorySerials201,
  BulkCreateInventoryVariationsBody,
  BulkCreateInventoryVariationsError,
  BulkCreateInventoryVariationsResponse,
  BulkIdRequest,
  BulkInventoryDeleteResult,
  BulkInventoryEditRequest,
  BulkInventoryEditResult,
  BulkSalesDeleteResult,
  CanonicalMarketSnapshot,
  CaptureAccountBillingPaypalOrderBody,
  CatalogueAsyncJob,
  CatalogueAuditPage,
  CatalogueBulkReviewInput,
  CatalogueBulkReviewResult,
  CatalogueCheckInput,
  CatalogueEvidence,
  CatalogueEvidencePage,
  CatalogueIntelligenceFoundation,
  CatalogueItemHealth,
  CatalogueLockAction,
  CatalogueLockInput,
  CatalogueRecheckInput,
  CatalogueReportPage,
  CatalogueReviewInput,
  CatalogueSettings,
  CatalogueSettingsInput,
  CatalogueStatus,
  CatalogueSuggestion,
  CatalogueSuggestionPage,
  Category,
  CategoryCreate,
  CategoryUpdate,
  CentralMarketRefreshResult,
  ChannelPerformance,
  ChannelPullOrdersRequest,
  ChannelPullOrdersResult,
  CheckedInVariantSplitInput,
  CombinePackingJobs400,
  CombinePackingJobsRequest,
  CombinePackingJobsResult,
  CombinePurchaseOrdersInput,
  CombinedPurchaseOrderResult,
  ComingSoonMarkArrivedRequest,
  CommerceBoxStorageCapability,
  CompanyImportLog,
  CompleteInventoryProductImporterCanvaConnectParams,
  ComplianceAuditRow,
  ComplianceDocumentInput,
  ComplianceDocumentRow,
  ComplianceOkResponse,
  ComplianceOverview,
  ComplianceProfileDetail,
  ComplianceProfileInput,
  ComplianceProfileListResponse,
  ComplianceProfileUpdate,
  ComplianceReviewInput,
  ComplianceReviewRow,
  ComplianceReviewUpdate,
  ComplianceTaskInput,
  ComplianceTaskListResponse,
  ComplianceTaskRow,
  ComplianceTaskUpdate,
  CompositePresetResponse,
  ConfirmPackagingRequest,
  ConfirmPackagingResult,
  ConnectQuickBooks200,
  ConnectTikTokDeveloperConnection200,
  ConnectTikTokShop200,
  ConnectXero200,
  ConsignmentBatch,
  ConsignmentBatchDashboard,
  ConsignmentBatchDetail,
  ConsignmentBatchInput,
  ConsignmentBatchPayment,
  ConsignmentBatchPaymentInput,
  ConsignmentBatchUpdate,
  ContinueShopifyDeliveryBackfill200,
  ConvertScrapLotInput,
  ConvertScrapLotResult,
  CourierTestResult,
  CreateAccountBillingPaypalOrderBody,
  CreateCombinedShipment,
  CreateCombinedShipment201,
  CreateCompositePresetBody,
  CreateCourierIntegration,
  CreateCourierIntegration201,
  CreateCustomerPortfolioProduct201,
  CreateDemandPurchaseDraftsBody,
  CreateDemandTargetBody,
  CreateDocumentTemplate,
  CreateDocumentTemplate201,
  CreateFeatureRequestInput,
  CreateImageTemplate201,
  CreateImageTemplateInput,
  CreateInventoryVariationBody,
  CreatePickList,
  CreatePickList201,
  CreatePlatformBillingInvoiceInput,
  CreatePricingBulkJobBody,
  CreatePublicPage201,
  CreateRefundInput,
  CreateSalePackingNote400,
  CreateSaleZeroCostError,
  CreateShipment,
  CreateShipment201,
  CreateSocialInboxAiSuggestionBody,
  CreateWhatsappInboxNoteBody,
  CreateWhatsappInboxQuickReplyBody,
  CreateWooBrandInput,
  CreateWooCategoryInput,
  CurrentSpotPricesResponse,
  CustomField,
  CustomFieldInput,
  CustomFieldUpdate,
  CustomFieldValuesUpsert,
  CustomFieldWithValue,
  Customer,
  CustomerActivityPage,
  CustomerAnalytics,
  CustomerDetail,
  CustomerExportInline,
  CustomerExportInput,
  CustomerExportQueued,
  CustomerInput,
  CustomerInsights,
  CustomerMessageSendBody,
  CustomerMessageSendResult,
  CustomerMessagesPayload,
  CustomerMessagingCapabilities,
  CustomerNote,
  CustomerNoteInput,
  CustomerNotesPayload,
  CustomerOrderEmailNotificationRetryResult,
  CustomerOrderEmailNotificationsPage,
  CustomerOrdersExportState,
  CustomerOrdersPayload,
  CustomerOverview,
  CustomerPlatformHandle,
  CustomerPlatformHandleInput,
  CustomerPortfolioAdjustmentInput,
  CustomerPortfolioAllocationPreview,
  CustomerPortfolioCreateInput,
  CustomerPortfolioFoundation,
  CustomerPortfolioPortalConfig,
  CustomerPortfolioPurchaseInput,
  CustomerPortfolioPurchasePreview,
  CustomerPortfolioSaleInput,
  CustomerPortfolioSettingsInput,
  CustomerPortfolioSummary,
  CustomerPortfolioTransactionBulkInput,
  CustomerPortfolioTransactionBulkResult,
  CustomerPortfolioTransactionPage,
  CustomerPortfolioTransferInput,
  CustomerPurchasingInsightsResponse,
  CustomerSpendingPreparing,
  CustomerSpendingWorkspace,
  CustomerWhatsappTemplate,
  CustomerWhatsappTemplatePreset,
  CustomerWhatsappTemplatePresetInput,
  CustomerWhatsappTemplatePresetRenameInput,
  CustomerWhatsappTemplatePresetReorderInput,
  CustomerWhatsappTemplatePresetsPayload,
  DashboardAccessAck,
  DashboardSummary,
  DeactivateTikTokShopProducts200,
  DeleteCompositePreset200,
  DeleteExceptionRule200,
  DeleteInventoryCompositeArchiveEntry200,
  DeleteOrderInternalNoteParams,
  DeletePlatformBillingInvoiceResult,
  DeletePricingMarginRule200,
  DeletePricingRule200,
  DeletePublicPage200,
  DeleteSocialCalendarEvent200,
  DeleteSocialCampaign200,
  DeleteSocialLiveEvent200,
  DeleteSocialMediaAsset200,
  DeleteSocialScheduledPost200,
  DeleteTikTokShopProductMapping200,
  DeleteTitleMapping200,
  DeleteUser200,
  DeleteVariantSplitDraftParams,
  DemandForecastList,
  DisconnectSocialAccount200,
  DismissCombinedShipmentSuggestion200,
  DismissCombinedShipmentSuggestion400,
  DismissCombinedShipmentSuggestionRequest,
  DocumentPreviewResult,
  DownloadGeneratedDocument200,
  DownloadShipmentLabel200,
  DropshipCustomer,
  DropshipCustomerInput,
  DropshipCustomerWithSecret,
  DropshipDashboard,
  DropshipOrder,
  DropshipOrderInput,
  DropshipOrderResponse,
  DropshipReport,
  DropshipStockResponse,
  EbayConnectionSweepJobResponse,
  EbayConnectionSweepResultsResponse,
  EbayDiagnosePullBody,
  EbayDiagnosePullResult,
  EbayImportOrderRequest,
  EbayImportOrderResult,
  EbayMessage,
  EbayMessageMarkReadResult,
  EbayMessageReplyRequest,
  EbayMessageReplyResult,
  EbayMessageSyncResult,
  EbayMessageThread,
  EbayOrdersSyncResponse,
  EbayPullOrdersRequest,
  EbayPullOrdersResult,
  EbayPushItemResult,
  EbayRescanRequest,
  EbayRescanResult,
  EbaySyncIssueBulkBody,
  EbaySyncIssueBulkResult,
  EbaySyncIssueConfirmMappingsBody,
  EbaySyncIssueConfirmMappingsResult,
  EbaySyncIssueRetryResult,
  EbaySyncIssueSuggestionsResult,
  EbaySyncIssuesList,
  EbayTestRequest,
  EbayTestResult,
  EditPricingChangeBody,
  EmailDocumentRequest,
  EmailGeneratedDocument200,
  EmailTemplate,
  EmailTemplateInput,
  EnqueueInventorySeoReadiness200,
  EnqueueInventorySeoReadiness202,
  EnqueueInventorySeoReadinessBody,
  EntityAuditLogPage,
  ExceptionActionInput,
  ExceptionDetailResponse,
  ExceptionListResponse,
  ExceptionResponse,
  ExceptionRuleInput,
  ExceptionRuleListResponse,
  ExceptionRuleResponse,
  ExceptionRuleTestResponse,
  ExcludeCombinedShipment200,
  Expense,
  ExpenseInput,
  ExportCatalogueReportsParams,
  ExportCustomerOrdersBody,
  ExportCustomerPurchasingInsightsParams,
  ExportDemandProductsParams,
  ExportPreOrderBatchActivityParams,
  ExportSalesPerformanceBody,
  ExportSupplierDirectoryParams,
  FeatureCatalogue,
  FeatureKey,
  FeatureRequestDetail,
  FeatureRequestList,
  FindEbayOrdersParams,
  FindEbayOrdersResult,
  FlagAssignment,
  FlagAssignmentCreated,
  FlagAssignmentInput,
  FlagBulkAssignmentInput,
  FlagBulkAssignmentResult,
  FlagCreateInput,
  FlagDefinition,
  FlagUpdate,
  FloatingButtonUpdate,
  ForecastingRunResult,
  ForecastingSettings,
  ForecastingSettingsUpdate,
  ForecastingSummary,
  Ga4Stats,
  GenerateCompositeInput,
  GenerateCompositeResponse,
  GenerateDocumentRequest,
  GenerateDocumentResult,
  GenerateShipmentLabel200,
  GetAlertsUnreadCount200,
  GetAnalyticsOverviewParams,
  GetBoxSaleEligibilityParams,
  GetCanonicalMarketSnapshotParams,
  GetCompanyImportLog404,
  GetConsignmentBatches200,
  GetConsignmentBatchesParams,
  GetCustomerActivityParams,
  GetCustomerInsightsParams,
  GetCustomerPortfolioSettings200,
  GetCustomerPurchasingInsightsParams,
  GetCustomerWhatsappTemplate502,
  GetDemandOverview200,
  GetDemandOverviewParams,
  GetDemandProduct200,
  GetDemandProductParams,
  GetDemandTargets200,
  GetDemandView200,
  GetDemandViewParams,
  GetDocumentCatalog200,
  GetDocumentTemplateGroup200,
  GetDropshipReportParams,
  GetEbayCategorySuggestions200,
  GetEbayCategorySuggestionsParams,
  GetGeneratedDocument200,
  GetGmailStatus200,
  GetHrPerformanceStaffParams,
  GetHrPerformanceSummaryParams,
  GetHrShiftTimeOffOverlapParams,
  GetIntegrationActivityParams,
  GetIntegrationAdvanced200,
  GetIntegrationAdvancedParams,
  GetIntegrationLogsParams,
  GetIntegrationMappings200,
  GetIntegrationMappingsParams,
  GetIntegrationOverview200,
  GetIntegrationOverviewParams,
  GetIntegrationSettings200,
  GetIntegrationSettingsParams,
  GetIntegrationWebhooksParams,
  GetIntegrationsSummaryParams,
  GetInventoryChannelSyncEvents200,
  GetInventoryChannelSyncEventsParams,
  GetInventorySeoReadinessJob200,
  GetLiveStockExportFields200,
  GetMobileDashboardSecondaryParams,
  GetMobileProfitLossCashParams,
  GetMobileProfitLossChannelsParams,
  GetMobileProfitLossChartParams,
  GetMobileProfitLossExceptionsParams,
  GetMobileProfitLossParams,
  GetMobileProfitLossProductsParams,
  GetMobileProfitLossSummaryParams,
  GetMobileProfitLossTrendParams,
  GetMyFeatures200,
  GetMyPlatformAccess200,
  GetMyPlatformPermissions200,
  GetOrderLoss200,
  GetPackingJobShareLink200,
  GetPackingSettings200,
  GetPostageSettings200,
  GetPreOrderBatchNotesParams,
  GetPreOrderBatchParams,
  GetPricingItemContextParams,
  GetProfitLossReportParams,
  GetPublicPage200,
  GetPublicPageVersion200,
  GetPurchaseOrderOverviewParams,
  GetPushConfig200,
  GetRepairCentreIssueCount200,
  GetRepairCentreIssues200,
  GetRepairCentreLogsParams,
  GetReturnsReportSummaryParams,
  GetSalesOnHoldCount200,
  GetSalesPerformanceByChannelParams,
  GetSalesPerformanceDailyParams,
  GetSalesPerformanceParams,
  GetSalesPerformanceSessionsParams,
  GetSalesProfitBlockersParams,
  GetSalesReportParams,
  GetScrapReportSummaryParams,
  GetShipment200,
  GetShipmentGroups200,
  GetShipmentGroupsParams,
  GetSiteSettings200,
  GetSkuByChannelReportParams,
  GetSocialAiBestTimesParams,
  GetSocialAnalyticsParams,
  GetSocialAnalyticsWorkspaceParams,
  GetSocialAttributionParams,
  GetSocialBestTimeParams,
  GetSocialCapabilities200,
  GetSocialLiveMetrics200,
  GetSocialLiveOverview200,
  GetSocialSettings200,
  GetSocialTrafficParams,
  GetSpendVsProfitCardsParams,
  GetSpendVsProfitReportParams,
  GetSpotPriceHistoryParams,
  GetSupplierDirectoryParams,
  GetTikTokCategoriesParams,
  GetTikTokShopDuplicateListingsParams,
  GetTikTokShopInventoryPushStatusParams,
  GetTikTokShopMessageCapabilityParams,
  GetTikTokShopProductPushCapabilityParams,
  GetVariantSplitWorkspaceParams,
  GetVatDueSummaryParams,
  GetWebsiteSeoIndexingTrendParams,
  GetWebsiteSeoSearchTrendParams,
  GetWhatnotCategoryCatalogParams,
  GetWhatnotConditionOptionsParams,
  GetWhatsappInboxAnalyticsParams,
  HealthStatus,
  HrAbsence,
  HrAbsenceInput,
  HrAbsenceUpdate,
  HrApplyOnboardingTemplate,
  HrAuditListResponse,
  HrChangeRequest,
  HrChangeRequestReview,
  HrClockEvent,
  HrClockEventInput,
  HrClockEventUpdate,
  HrCommunication,
  HrCommunicationInput,
  HrDocument,
  HrDocumentInput,
  HrDocumentUpdate,
  HrHoursEntry,
  HrHoursInput,
  HrHoursUpdate,
  HrIncident,
  HrIncidentInput,
  HrIncidentUpdate,
  HrLossAttributionInput,
  HrMyChangeRequestInput,
  HrMyDocumentInput,
  HrMyTimeOffInput,
  HrOnboardingItem,
  HrOnboardingItemInput,
  HrOnboardingItemUpdate,
  HrOnboardingTemplate,
  HrOnboardingTemplateInput,
  HrOverview,
  HrPayCadence,
  HrPayCadenceInput,
  HrPayDetails,
  HrPayDetailsInput,
  HrPayment,
  HrPaymentCreateInput,
  HrPaymentListResponse,
  HrPaymentMarkPaidInput,
  HrPaymentUpdateInput,
  HrPerformanceLossRow,
  HrPerformanceStaffDetail,
  HrPerformanceSummary,
  HrSelfRecord,
  HrSettings,
  HrSettingsInput,
  HrShift,
  HrShiftInput,
  HrShiftUpdate,
  HrStaffDetail,
  HrStaffInput,
  HrStaffListResponse,
  HrStaffSchedule,
  HrStaffScheduleInput,
  HrStaffUpdate,
  HrTimeOffInput,
  HrTimeOffOverlap,
  HrTimeOffRequest,
  HrTimeOffReview,
  HrTimelineEvent,
  HrTrainingInput,
  HrTrainingRecord,
  HrTrainingUpdate,
  ImageTemplateListResponse,
  ImportInventory409,
  ImportInventoryPhotos200,
  ImportInventoryPhotosBody,
  ImportIssue,
  ImportLog,
  ImportRequest,
  ImportSales202,
  ImportSales409,
  ImportSummary,
  ImportTikTokShippingLabelsBody,
  ImportTikTokShopProductsBody,
  IntegrationPage,
  IntegrationQueuedAction,
  IntegrationSummary,
  IntegrationUpdate,
  IntelligenceFoundationResponse,
  IntelligenceInsight,
  IntelligenceInsightAssign,
  IntelligenceInsightList,
  IntelligenceInsightStateResult,
  IntelligenceRunResult,
  IntelligenceSettings,
  IntelligenceSettingsUpdate,
  IntelligenceSummary,
  InventoryAiAssistRequest,
  InventoryAiAssistResponse,
  InventoryCostingSettings,
  InventoryCostingSettingsInput,
  InventoryFilterMetadata,
  InventoryGridResponse,
  InventoryItem,
  InventoryItemDetail,
  InventoryItemInput,
  InventoryItemUpdate,
  InventoryLinkedChildrenResponse,
  InventoryLotDetail,
  InventoryLotSummary,
  InventoryLotVatBulkClassificationInput,
  InventoryLotVatBulkClassificationResult,
  InventoryLotVatClassification,
  InventoryLotVatClassificationInput,
  InventoryLotVatReviewPage,
  InventoryMatchSuggestion,
  InventoryMintageReviewPage,
  InventoryOperatorSnapshot,
  InventoryProductImportAnalysisRequest,
  InventoryProductImportAnalysisResponse,
  InventoryProductImporterCanvaConnect,
  InventoryProductImporterCanvaDesignRequest,
  InventoryProductImporterCanvaDesignResponse,
  InventoryProductImporterCanvaStatus,
  InventoryProductImporterCanvaTemplateConfig,
  InventoryProductImporterCanvaTemplateDataset,
  InventoryProductImporterCanvaTemplateList,
  InventoryReport,
  InventorySerialBulkAddRequest,
  InventorySerialUpdate,
  InventoryStatusUpdate,
  InventoryStockInInput,
  InventoryStockInResult,
  InventorySummary,
  InventoryTransformationDetail,
  IssuePlatformBillingInvoiceInput,
  LandedCostInput,
  LinkPreOrderBatchItemSkuInput,
  LinkedOrdersResponse,
  ListAccountBillingInvoicesParams,
  ListAccountBillingPaymentsParams,
  ListActivityLog200,
  ListActivityLogParams,
  ListAdjustmentsParams,
  ListAlertsParams,
  ListAllAutomationLogsParams,
  ListAssetsParams,
  ListAuditLogsParams,
  ListAutomationLogsParams,
  ListAutomationsParams,
  ListCalendarEventsParams,
  ListCatalogueEvidenceParams,
  ListCatalogueReportsParams,
  ListCatalogueSuggestionsParams,
  ListCategoriesParams,
  ListCombinedShipmentSuggestions200,
  ListCombinedShipmentSuggestionsParams,
  ListCombinedShipments200,
  ListCompanyImportLogs200,
  ListComplianceProfilesParams,
  ListComplianceTasksParams,
  ListCompositePresetsResponse,
  ListCourierIntegrations200,
  ListCourierProviderServices200,
  ListCustomFieldValuesParams,
  ListCustomFieldsParams,
  ListCustomerAddresses200,
  ListCustomerMessagesParams,
  ListCustomerNotesParams,
  ListCustomerOrderEmailNotificationsParams,
  ListCustomerOrdersParams,
  ListCustomerPlatformHandles200,
  ListCustomerPortalPortfolioProducts200,
  ListCustomerPortalPortfolioProductsParams,
  ListCustomerPortalPortfolioTransactionsParams,
  ListCustomerPortfolioProducts200,
  ListCustomerPortfolioProductsParams,
  ListCustomerPortfolios200,
  ListCustomerPortfoliosParams,
  ListCustomers200,
  ListCustomersParams,
  ListDemandForecastsParams,
  ListDocumentAutoRules200,
  ListDocumentLogs200,
  ListDocumentLogsParams,
  ListDocumentTemplates200,
  ListEbayMessagesParams,
  ListEbaySyncIssuesParams,
  ListEbaySyncRuns200,
  ListEbaySyncRunsParams,
  ListExceptionsParams,
  ListExpensesParams,
  ListFeatureRequestsParams,
  ListFlagAssignmentsParams,
  ListFlagsParams,
  ListForecastingRunLogs200,
  ListForecastingRunLogsParams,
  ListGeneratedDocuments200,
  ListGeneratedDocumentsParams,
  ListHrAuditParams,
  ListHrChangeRequestsParams,
  ListHrClockEventsParams,
  ListHrPaymentsParams,
  ListHrShiftsParams,
  ListHrStaffParams,
  ListHrTimeOffParams,
  ListImportLogsParams,
  ListIntelligenceInsightsParams,
  ListInventory200,
  ListInventoryGridParams,
  ListInventoryLotPurchases200,
  ListInventoryLotPurchasesParams,
  ListInventoryLots200,
  ListInventoryLotsParams,
  ListInventoryLotsVatReviewParams,
  ListInventoryMintageReviewParams,
  ListInventoryParams,
  ListInventoryPhotosForImport200,
  ListInventoryPhotosForImportParams,
  ListInventorySalesHistory200,
  ListInventorySalesHistoryParams,
  ListInventorySerials200,
  ListInventoryTransformationsParams,
  ListLatestEbayConnectionSweepResultsParams,
  ListMobileInventoryParams,
  ListNotificationDeliveryLogsParams,
  ListNotificationsParams,
  ListOrderInternalNotesParams,
  ListOrderLossesParams,
  ListPackingJobMedia200,
  ListPackingJobNotes200,
  ListPackingJobs200,
  ListPackingJobsParams,
  ListPickListImportsParams,
  ListPickLists200,
  ListPlatformTenantFeatures200,
  ListPlatformTenants200,
  ListPostageAudit200,
  ListPostageServices200,
  ListPreOrderAllocationsParams,
  ListPreOrderBatchActivityParams,
  ListPreOrderBatchProductsParams,
  ListPreOrderBatchesParams,
  ListPricingApprovals200,
  ListPricingApprovalsParams,
  ListPricingBulkJobs200,
  ListPricingFeeProfiles200,
  ListPricingFeeProfilesParams,
  ListPricingHistory200,
  ListPricingHistoryParams,
  ListPricingMarginOverrides200,
  ListPricingMarginOverridesParams,
  ListPricingMarginRules200,
  ListPricingMarginRulesParams,
  ListPricingProductsParams,
  ListPricingRules200,
  ListPricingRunLogs200,
  ListPricingRunLogsParams,
  ListPricingSchedules200,
  ListProjectsParams,
  ListPublicPageVersions200,
  ListPublicPages200,
  ListPurchaseOrderOverviewDocumentsParams,
  ListPurchaseOrderOverviewInvoicesParams,
  ListPurchaseOrderOverviewLinesParams,
  ListPurchaseOrderOverviewNotesParams,
  ListPurchaseOrderRecentAuditParams,
  ListPurchaseOrdersParams,
  ListPurchaseRecommendations200,
  ListPurchaseRecommendationsParams,
  ListPurchasingRunLogs200,
  ListPurchasingRunLogsParams,
  ListQboAccounts200,
  ListQboCustomers200,
  ListQboItems200,
  ListQboTaxCodes200,
  ListQuickBooksReconciliations200,
  ListQuickBooksReconciliationsParams,
  ListQuickBooksSyncLogs200,
  ListQuickBooksSyncLogsParams,
  ListRemindersParams,
  ListReorderRecommendations200,
  ListReorderRecommendationsParams,
  ListReturnsAuditParams,
  ListReturnsParams,
  ListSalePackingMedia200,
  ListSalePackingNotes200,
  ListSales200,
  ListSalesParams,
  ListScrapInventoryParams,
  ListSellingSessions200,
  ListSellingSessionsParams,
  ListShipmentTracking200,
  ListShipmentTrackingParams,
  ListShipments200,
  ListShipmentsParams,
  ListShopifyCollections200,
  ListShopifyCollectionsParams,
  ListShopifyDeliveryBackfillRuns200,
  ListShopifyMappingLogsParams,
  ListShopifyValidationRunsParams,
  ListShopifyWebhooks200,
  ListSiteSettingVersions200,
  ListSiteSettingVersionsParams,
  ListSocialAnalyticsSnapshotsParams,
  ListSocialCalendarParams,
  ListSocialCampaignsParams,
  ListSocialInbox200,
  ListSocialInboxParams,
  ListSocialLiveAlerts200,
  ListSocialLiveModeration200,
  ListSocialLiveOffers200,
  ListSocialLiveProducts200,
  ListSocialMedia200,
  ListSocialMediaParams,
  ListSocialPostsParams,
  ListSocialPreparedPostsParams,
  ListSocialScheduledPosts200,
  ListSocialScheduledPostsParams,
  ListSocialSyncLogsParams,
  ListStationeryParams,
  ListStockAuditParams,
  ListSupplierConsignmentParams,
  ListSupplierDocumentsParams,
  ListSupplierMonthlySummariesParams,
  ListSupplierPerformance200,
  ListSupplierPricingParams,
  ListSupplierProductsParams,
  ListSupplierPurchaseOrdersParams,
  ListSuppliersParams,
  ListSyncJobsParams,
  ListTasksParams,
  ListTikTokDeveloperConnections200,
  ListTikTokProductTypes200,
  ListTikTokShopCapabilities200,
  ListTikTokShopCapabilitiesParams,
  ListTikTokShopImportedProductsParams,
  ListTikTokShopMessagesParams,
  ListTikTokShopProductMappingsParams,
  ListTikTokShopSyncJobs200,
  ListTikTokShopSyncJobsParams,
  ListTikTokShopSyncLogs200,
  ListTikTokShopSyncLogsParams,
  ListTitleMappingsParams,
  ListVariantSplitReceipts200,
  ListVariantSplitReceiptsParams,
  ListVatDueEntriesParams,
  ListWhatsappInboxConversationsParams,
  ListWhatsappInboxOperators200,
  ListWhatsappInboxQuickReplies200,
  ListWhatsappInboxTemplates200,
  ListWhatsappTrackingBatches200,
  ListWorkflowRunsParams,
  ListXeroSyncLogs200,
  ListXeroSyncLogsParams,
  LiveStockExportMember,
  LiveStockExportMembersResponse,
  LiveStockExportOverrideUpdate,
  LiveStockExportResponse,
  LoadVariantSplitDraftParams,
  MarkAlertRead200,
  MarkAllAlertsRead200,
  MarkComingSoonArrivedResult,
  MarkNotificationsRead200,
  MarkOrderLoss200,
  MarkOrderLoss201,
  MarkOrderLossInput,
  MarkPlatformBillingInvoicePaidInput,
  MarkTikTokShopMessagesRead200,
  MarketplaceIntegration,
  MarketplaceSummary,
  MatchInventoryByIdentityParams,
  MergeInventoryBlockedResult,
  MergeInventoryRequest,
  MergeInventoryResult,
  MetalPricesResponse,
  MobileDashboardSecondary,
  MobileInventoryListResponse,
  MobileProfitLossCash,
  MobileProfitLossChannels,
  MobileProfitLossExceptions,
  MobileProfitLossProducts,
  MobileProfitLossSummary,
  MobileProfitLossTrend,
  NotificationBulkReadBody,
  NotificationCatalogue,
  NotificationDeliveryLogResponse,
  NotificationManualSend,
  NotificationManualSendResult,
  NotificationThreshold,
  NotificationThresholdUpdate,
  NotificationUserSettings,
  NotificationUserSettingsUpdate,
  NotifyWebsiteSeoPage200,
  OkResult,
  OrderAdjustmentDetail,
  OrderAdjustmentListRow,
  OrderInternalNote,
  OrderInternalNoteCreateInput,
  OrderInternalNoteUpdateInput,
  OrderInternalNotesPage,
  OrderLossListResponse,
  OrderPaymentDueDateBody,
  OrderPaymentLedger,
  PackagingForecastItem,
  PackagingMaterial,
  PackagingMaterialOption,
  PackagingPreset,
  PackagingPresetInput,
  PackagingRecommendation,
  PackagingSummary,
  PackagingUsageEntry,
  PackingConfirmationRequest,
  PackingJobCancelledBuyer,
  PackingJobDetail,
  PackingJobLineSerialUpdate,
  PackingJobMaterializeResult,
  PackingJobMedia,
  PackingJobMediaCreate,
  PackingJobMediaUpdate,
  PackingJobOrderCertUpdate,
  PackingJobUpdate,
  PackingNote,
  PackingNoteCreate,
  PackingNoteReply,
  PackingNoteResolve,
  PaidSaleFulfilmentInput,
  PaymentFulfilmentSettings,
  PeriodComparisonReport,
  PickListImportDetail,
  PickListImportListResponse,
  PickListParcelPatch,
  PickListParcelStatusInput,
  PinOrderInternalNoteBody,
  PlatformTenantFeatureUpdate,
  PoRecalcResult,
  PortalVerificationDelivery,
  PortfolioProductInput,
  PortfolioProductMappingInput,
  PortfolioProductUpdateInput,
  PostageDashboard,
  PostageReports,
  PreOrderAllocationCreateResponse,
  PreOrderAllocationInput,
  PreOrderAllocationListResponse,
  PreOrderAllocationMetadata,
  PreOrderAllocationMetadataUpdate,
  PreOrderAllocationPriceUpdate,
  PreOrderAllocationPriceUpdateResponse,
  PreOrderAllocationQuantityUpdate,
  PreOrderAllocationQuantityUpdateResponse,
  PreOrderAllocationStatusResponse,
  PreOrderBatchAllocationSummary,
  PreOrderBatchDetail,
  PreOrderBatchInput,
  PreOrderBatchItemInput,
  PreOrderBatchItemPricingCorrection,
  PreOrderBatchItemUpdate,
  PreOrderBatchListResponse,
  PreOrderBatchNotesResponse,
  PreOrderBatchProductPage,
  PreOrderBatchSkuLinkResponse,
  PreOrderBatchStatusInput,
  PreOrderBatchUpdate,
  PreOrderBulkConvertResponse,
  PreOrderContextNote,
  PreOrderContextNoteInput,
  PreOrderConvertAndPayResponse,
  PreOrderConvertResponse,
  PreOrderEtaNotificationResponse,
  PreOrderEtaUpdateInput,
  PreOrderEtaUpdatePreview,
  PreOrderEtaUpdateResponse,
  PreOrderLockPriceInput,
  PreOrderLockPriceResponse,
  PreOrderManualExpiryResponse,
  PreOrderOperatorListResponse,
  PreOrderReinstateExpiredResponse,
  PreorderStorageCorrectionInput,
  PreorderStorageCorrectionPreview,
  PreorderStorageCorrectionResult,
  PreviewDocumentRequest,
  PricingApprovalActionResult,
  PricingApprovalBreakdown,
  PricingBulkJob,
  PricingCalculationSnapshot,
  PricingChangeApproval,
  PricingDashboard,
  PricingEvaluateRequest,
  PricingExplainRequest,
  PricingExplainResult,
  PricingFeeProfile,
  PricingFeeProfileCreate,
  PricingFeeProfileUpdate,
  PricingItemContext,
  PricingMarginPreview,
  PricingMarginRule,
  PricingMarginRuleCreate,
  PricingMarginRuleUpdate,
  PricingProductPage,
  PricingRule,
  PricingRuleCreate,
  PricingRuleUpdate,
  PricingRunResult,
  PricingSchedule,
  PricingScheduleUpsert,
  PricingSettings,
  PricingSettingsUpdate,
  PricingSummary,
  PrintSaleLabelsInput,
  ProductInformationImpactInput,
  ProductInformationImpactResult,
  ProfitLossReport,
  PublicPageAiSuggestRequest,
  PublicPageAiSuggestResponse,
  PublicPageCreate,
  PublicPageUpdate,
  PublicUploadUrlResponse,
  PublishAllShopifyToGoogleYouTube200,
  PublishAllShopifyToGoogleYouTube409,
  PublishAllShopifyToWhatnot202,
  PublishAllShopifyToWhatnot409,
  PublishAllShopifyToWhatnot502,
  PublishDocumentTemplate200,
  PublishPublicPage200,
  PublishSiteSettings200,
  PullShopifyCompanies200,
  PullShopifyCompanies502,
  PullShopifyInventory200,
  PullShopifyInventory502,
  PullTikTokProductToInventory200,
  PurchaseApproveRequest,
  PurchaseApproveResult,
  PurchaseBulkApproveRequest,
  PurchaseBulkApproveResult,
  PurchaseOrderAuditSection,
  PurchaseOrderCurrencyEvidence,
  PurchaseOrderCurrencyEvidenceInput,
  PurchaseOrderDestinationSkuRecommendations,
  PurchaseOrderDestinationSkuUpdate,
  PurchaseOrderDetail,
  PurchaseOrderDocumentSection,
  PurchaseOrderExport,
  PurchaseOrderExportRequest,
  PurchaseOrderInput,
  PurchaseOrderInvoiceInput,
  PurchaseOrderInvoiceSection,
  PurchaseOrderLineItemUpdate,
  PurchaseOrderLineSection,
  PurchaseOrderListItem,
  PurchaseOrderNoteSection,
  PurchaseOrderOverview,
  PurchaseOrderProfitability,
  PurchaseOrderQuickSummary,
  PurchaseOrderRecentDestinationSkus,
  PurchaseOrderReconciliationReport,
  PurchaseOrderSavedView,
  PurchaseOrderSavedViewInput,
  PurchaseOrderSavedViewList,
  PurchaseOrderSavedViewUpdate,
  PurchaseOrderShippingSection,
  PurchaseOrderStatusInput,
  PurchaseOrderSupplierPerformance,
  PurchaseOrderUpdateInput,
  PurchaseRecommendation,
  PurchasingRunResult,
  PurchasingSettings,
  PurchasingSettingsUpdate,
  PurchasingSummary,
  PushInventoryItemToMarketplacesBody,
  PushOkResponse,
  PushSubscribeBody,
  PushSubscriptionRow,
  PushToMarketplacesResult,
  PushUnsubscribeBody,
  PutDocumentAutoRules200,
  PutDocumentAutoRulesRequest,
  QueueIntegrationSyncParams,
  QuickBooksDashboard,
  QuickBooksMappings,
  QuickBooksMappingsUpdate,
  QuickBooksReconciliation,
  QuickBooksReconciliationInput,
  QuickBooksSettings,
  QuickBooksSettingsUpdate,
  QuickBooksStatus,
  QuickBooksSyncRecordResult,
  QuickBooksSyncRequest,
  QuickBooksSyncRunResult,
  RecalcSaleCostsBody,
  RecalcSaleCostsResult,
  RecalculateCostsInput,
  ReceiveRefiningBatchInput,
  ReceiveStockInput,
  RecordOrderPaymentBody,
  RefiningBatchDetail,
  RefiningBatchFinaliseInput,
  RefiningBatchInput,
  RefiningBatchSummary,
  RefiningBatchUpdate,
  RefiningMetalRollup,
  RegisterShopifyWebhooks400,
  RegroupOrdersResult,
  RemoveBackgroundRequest,
  RemoveBackgroundResult,
  ReorderCompositeArchiveRequest,
  ReorderInventoryCompositeArchive200,
  ReorderRecommendation,
  ReorderRecommendationStatusUpdate,
  RepairActionRequest,
  RepairLog,
  RepairPreviewResult,
  RepairPurchaseOrderReadModel200,
  RepairPurchaseOrderReadModelBody,
  ReplyPackingNote400,
  RequestPlanChangeInput,
  RequestPlanChangeResult,
  RequestTrialExtensionInput,
  RequestTrialExtensionResult,
  ResetUserPassword200,
  ResolveImportIssue200,
  ResolveImportIssueRequest,
  ResolvePackingNote400,
  RestorePublicPageVersion200,
  RestoreSiteSettingVersion200,
  RetryCommerceCustomerDirectoryMetricsBody,
  RetryCustomerDirectoryMetricsBody,
  RetryEbaySyncIssueBody,
  RetryPurchaseOrderOverview200,
  ReturnAuditRow,
  ReturnDetail,
  ReturnEbayPullResult,
  ReturnEvidenceInput,
  ReturnEvidenceItem,
  ReturnInput,
  ReturnInventoryActionInput,
  ReturnInventoryActionRow,
  ReturnItemInput,
  ReturnItemUpdate,
  ReturnListResponse,
  ReturnMessageInput,
  ReturnMessageRow,
  ReturnOkResponse,
  ReturnRefundInput,
  ReturnRefundRow,
  ReturnRefundUpdate,
  ReturnShareLink,
  ReturnShareLinkInput,
  ReturnShareLinkMinted,
  ReturnStatusTransitionInput,
  ReturnToSupplierInput,
  ReturnToSupplierResult,
  ReturnUpdate,
  ReturnsOverview,
  ReturnsReportSummary,
  ReturnsSettings,
  ReturnsSettingsInput,
  RevokeOtherSessionsResult,
  RevokeSessionInput,
  RevokeSessionResult,
  RoleList,
  RoleSectionAccess,
  RoleUpdate,
  RollbackImport200,
  RoyalMailConnectionInfo,
  RunVatPlanningCatchUpBody,
  SaleAttachment,
  SaleAttachmentInput,
  SaleLabelInput,
  SaleOrder,
  SaleOrderCustomerDetailsUpdate,
  SaleOrderDetail,
  SaleOrderInput,
  SalePaymentActionResponse,
  SaleReversalResult,
  SaleStatusUpdate,
  Sales7daySummary,
  SalesAssignee,
  SalesChannel,
  SalesChannelCreateInput,
  SalesChannelUpdateInput,
  SalesPerformanceByChannelReport,
  SalesPerformanceDailyReport,
  SalesPerformanceResponse,
  SalesPerformanceSessionsReport,
  SalesProfitBlockersPage,
  SalesRecalculateCostsResult,
  SalesReport,
  SchedulePricingChangeBody,
  ScrapInventoryItemUpdate,
  ScrapInventoryItemView,
  ScrapPurchaseDetail,
  ScrapPurchaseInput,
  ScrapPurchaseSummary,
  ScrapPurchaseUpdate,
  ScrapReportSummary,
  ScrapSettings,
  ScrapSettingsInput,
  SearchCustomerPicker200,
  SearchCustomerPickerParams,
  SearchPreOrderLinkableInventory200,
  SearchPreOrderLinkableInventoryParams,
  SearchVariantSplitDestinations200,
  SearchVariantSplitDestinationsParams,
  SectionAccessConfig,
  SectionAccessUpdate,
  SellingSession,
  SellingSessionInput,
  SellingSessionPatch,
  SendPackingJobConfirmation200,
  SendPurchaseOrder200,
  SendPurchaseOrder503,
  SendPurchaseOrderInput,
  SeoIndexingTrend,
  SeoOverview,
  SeoSearchAnalytics,
  SeoSearchTrend,
  SeoUrlInspection,
  SetPackingLineSerial200,
  SetPackingOrderCert200,
  SetPickListParcelStatus200,
  SetPlatformTenantFeature200,
  SetUserPermissionsOverride200,
  SetUserRole200,
  SetUserSectionOverrides200,
  Settings,
  SettingsInput,
  ShipmentGroupAllocationInput,
  ShipmentGroupCreate,
  ShipmentGroupDetail,
  ShipmentGroupUpdate,
  ShopifyBulkRecoverLinkResult,
  ShopifyCollectionsSyncResult,
  ShopifyCreateProfileBody,
  ShopifyCustomerPullResult,
  ShopifyDefinitionValidationResult,
  ShopifyDeliveryBackfillPreview,
  ShopifyDeliveryBackfillRetryInput,
  ShopifyDeliveryBackfillRetryResult,
  ShopifyDeliveryRecoveryRequest,
  ShopifyDeliveryRecoveryResponse,
  ShopifyDuplicateProfileBody,
  ShopifyMappingLogList,
  ShopifyMappingOkResponse,
  ShopifyMappingPreviewBody,
  ShopifyMappingPreviewResult,
  ShopifyMappingProfileDetail,
  ShopifyMappingProfileList,
  ShopifyMappingPushBody,
  ShopifyMappingPushResult,
  ShopifyMappingSourceCatalog,
  ShopifyPreviewLinksResponse,
  ShopifyPublicationObservation,
  ShopifyRecoverLinkResult,
  ShopifyRecoverLinksBody,
  ShopifyReplaceMappingsBody,
  ShopifyStaleLinkList,
  ShopifySyncStatus,
  ShopifySyncedProductsResult,
  ShopifyTestResult,
  ShopifyUpdateProfileBody,
  ShopifyValidationResult,
  ShopifyValidationRunSummary,
  ShopifyWebhookRegistrationResult,
  SiteSettingPublish,
  SiteSettingUpdate,
  SkuByChannelReport,
  SmtpSettingsInput,
  SmtpSettingsRedacted,
  SocialAccount,
  SocialAccountConnect,
  SocialAiCheckRequest,
  SocialAiCheckResponse,
  SocialAiEnhanceImageRequest,
  SocialAiEnhanceImageResponse,
  SocialAiSaveEnhancedImageRequest,
  SocialAiSaveEnhancedImageResponse,
  SocialAiSuggestRequest,
  SocialAiSuggestResponse,
  SocialAnalytics,
  SocialAnalyticsSnapshotRow,
  SocialAnalyticsWorkspace,
  SocialAttributionResponse,
  SocialBestTimeResponse,
  SocialBestTimesResponse,
  SocialCalendarEvent,
  SocialCalendarEventCreate,
  SocialCalendarEventUpdate,
  SocialCalendarResponse,
  SocialCampaign,
  SocialCampaignCreate,
  SocialCampaignUpdate,
  SocialConnectionStatus,
  SocialConnectionTestResult,
  SocialCustomerContext,
  SocialDraftAiSuggestion,
  SocialEbaySummary,
  SocialHistoricSyncRequest,
  SocialHistoricSyncResult,
  SocialLinkCheckRequest,
  SocialLinkCheckResponse,
  SocialLiveCapability,
  SocialLiveEvent,
  SocialLiveEventCreate,
  SocialLiveEventUpdate,
  SocialLiveLink,
  SocialLiveWorkspace,
  SocialMediaAsset,
  SocialMediaAssetCreate,
  SocialMediaAssetUpdate,
  SocialOverview,
  SocialPlatform,
  SocialPost,
  SocialPostApprovalAction,
  SocialPostReviewAction,
  SocialPreparedOverview,
  SocialPreparedPostsPage,
  SocialRecommendation,
  SocialScheduledPost,
  SocialScheduledPostCreate,
  SocialScheduledPostUpdate,
  SocialSettingsUpdate,
  SocialSuggestTasksRequest,
  SocialSuggestTasksResponse,
  SocialSyncLog,
  SocialSyncRequest,
  SocialTrafficResponse,
  SpendVsProfitCards,
  SpendVsProfitReport,
  SplitPackingJobByLabel409,
  SplitPackingJobByLabelResult,
  SpotPriceHistoryResponse,
  StartShopifyDeliveryBackfill201,
  StationeryAdjustInput,
  StationeryItem,
  StationeryItemInput,
  StationeryItemUpdate,
  StatusSummaryResponse,
  StockAuditEntry,
  StockReconcileSummary,
  StockSyncJob,
  StreamCanonicalMarketsParams,
  StreamMarketWidgetParams,
  SubmitWebsiteSitemap200,
  Supplier,
  SupplierConsignmentPage,
  SupplierDetail,
  SupplierDirectoryPage,
  SupplierDocumentPage,
  SupplierInput,
  SupplierMonthlyPage,
  SupplierPricingPage,
  SupplierProductPage,
  SupplierPurchaseOrderPage,
  SupplierSettings,
  SupplierSummaryResponse,
  SupplierWithStats,
  SyncAllLinkedInventoryFromTikTok200,
  SyncAllLinkedInventoryFromTikTokBody,
  SyncSocialPlatform202,
  SyncTikTokProductToInventory200,
  SyncTikTokProductToInventory400,
  SyncTikTokProductToInventoryBody,
  SyncTikTokShopOrdersBody,
  SystemHealthDashboard,
  TenantMemberList,
  TenantMemberResponse,
  TenantNotificationDefault,
  TenantNotificationDefaultUpdate,
  TenantUserDirectCreate,
  TenantUserDirectResult,
  TenantUserInviteCreate,
  TenantUserInviteResult,
  TikTokAuthorisedShop,
  TikTokCategoryAttributeList,
  TikTokCategoryMappings,
  TikTokCategoryTree,
  TikTokDeveloperConnection,
  TikTokDeveloperConnectionInput,
  TikTokDeveloperConnectionUpdate,
  TikTokInventoryPushStatusList,
  TikTokLabelImportResult,
  TikTokOverrides,
  TikTokShopCredentialsInput,
  TikTokShopDashboard,
  TikTokShopDuplicateListingsResponse,
  TikTokShopImageSyncResult,
  TikTokShopImportedProductDetail,
  TikTokShopImportedProductList,
  TikTokShopListingSyncRequest,
  TikTokShopListingSyncResult,
  TikTokShopMappingImportRequest,
  TikTokShopMappingImportResult,
  TikTokShopMappingPatch,
  TikTokShopMappingUpsert,
  TikTokShopMatchRequest,
  TikTokShopMatchSuggestion,
  TikTokShopMessageCapability,
  TikTokShopMessageList,
  TikTokShopMessageMarkReadRequest,
  TikTokShopMessageReplyRequest,
  TikTokShopMessageReplyResult,
  TikTokShopMessageSyncResult,
  TikTokShopNeedsRelinkList,
  TikTokShopOrderSyncResult,
  TikTokShopOrderTrackingPushResult,
  TikTokShopProductCapability,
  TikTokShopProductDeactivateRequest,
  TikTokShopProductImportResult,
  TikTokShopProductMapping,
  TikTokShopProductMappingList,
  TikTokShopProductPushBulkRequest,
  TikTokShopProductPushBulkResult,
  TikTokShopProductPushOutcome,
  TikTokShopProductPushRequest,
  TikTokShopRefreshSkuRequest,
  TikTokShopRefreshSkuResult,
  TikTokShopResolveDuplicatesRequest,
  TikTokShopResolveDuplicatesResult,
  TikTokShopSettings,
  TikTokShopSettingsUpdate,
  TikTokShopStatus,
  TikTokShopStatusSyncResult,
  TikTokShopStockPushResult,
  TikTokShopStockResyncResult,
  TikTokShopSyncSummary,
  TikTokShopTrackingPushResult,
  TikTokShopUnmappedList,
  TikTokSyncJob,
  TitleMapping,
  TitleMappingCreate,
  TitleMappingsBulkDeleteRequest,
  TitleMappingsBulkDeleteResponse,
  TitleMatchRequest,
  TitleMatchResponse,
  TmActivityLog,
  TmAssignableUser,
  TmAttachment,
  TmAttachmentInput,
  TmCalendarEvent,
  TmChecklistItem,
  TmChecklistItemInput,
  TmChecklistItemUpdate,
  TmComment,
  TmCommentInput,
  TmDashboardSummary,
  TmPreferences,
  TmPreferencesUpdate,
  TmProjectDetail,
  TmProjectInput,
  TmProjectMember,
  TmProjectMemberInput,
  TmProjectUpdate,
  TmReminder,
  TmReminderInput,
  TmReminderSnoozeInput,
  TmReminderUpdate,
  TmSaveAsTemplateInput,
  TmTaskDetail,
  TmTaskInput,
  TmTaskTemplateDetail,
  TmTaskTemplateInput,
  TmTaskTemplateUpdate,
  TmTaskUpdate,
  TmTemplateInstantiateInput,
  TrackingIntegrationStatus,
  TrackingIntegrationTestResult,
  TrackingIntegrationUpdate,
  TrackingStatus,
  TriggerStockReconcile429,
  TriggerSyncBody,
  UnassignFlagParams,
  UnpublishPublicPage200,
  UpdateAccountSettingsInput,
  UpdateCategory200,
  UpdateCompositePresetBody,
  UpdateCourierIntegration,
  UpdateCourierIntegration200,
  UpdateCustomerPortfolioProduct200,
  UpdateCustomerPortfolioSettings200,
  UpdateDocumentTemplate,
  UpdateDocumentTemplate200,
  UpdateInventorySerial200,
  UpdateOrderLoss200,
  UpdateOrderLossInput,
  UpdatePackingJob200,
  UpdatePackingJob409,
  UpdatePickListParcel200,
  UpdatePlatformBillingInvoiceInput,
  UpdatePostageSettings,
  UpdatePostageSettings200,
  UpdatePreOrderBatchNotes200,
  UpdatePreOrderBatchNotesBody,
  UpdatePublicPage200,
  UpdateSiteSetting200,
  UpdateSocialSettings200,
  UpdateTikTokAuthorisedShopBody,
  UpdateVatClassificationBody,
  UpdateVatPlanningSettingsBody,
  UploadShipmentTracking200,
  UploadUrlRequest,
  UploadUrlResponse,
  UploadWhatsappInboxAttachmentBody,
  UserOut,
  UserPermissionsOverrideUpdate,
  UserSectionOverrideUpdate,
  UserThemeUpdate,
  ValuationHealthSummary,
  VariantSplitDraft,
  VariantSplitDraftInput,
  VariantSplitMatchInput,
  VariantSplitMatchResponse,
  VariantSplitReceiptDetail,
  VariantSplitReceiptInput,
  VariantSplitVariantInput,
  VariantSplitVariantProposalResponse,
  VariantSplitWorkspace,
  VatAcquisitionEnforcementInput,
  VatAcquisitionEnforcementState,
  VatDueEntryDetail,
  VatDueEntryPage,
  VatDueSummary,
  VatPlanningCatchUpResult,
  VatPlanningSettings,
  VatRegistrationPeriod,
  VatRegistrationPeriodEndInput,
  VatRegistrationPeriodInput,
  VatRegistrationPeriodsState,
  VatSalesPostingState,
  VatSchemaUnavailableError,
  VerifyTikTokDeveloperConnection200,
  WalkInCustomerResponse,
  WhatnotCategoryCatalog,
  WhatnotConditionOptions,
  WhatnotInventoryOverrides,
  WhatnotListingScan,
  WhatnotListingScanInput,
  WhatnotOrderAccessCheck,
  WhatnotOrderHistoryBoundary,
  WhatnotOrderRecoveryInput,
  WhatnotOrderRecoveryResult,
  WhatnotProductPublishInput,
  WhatnotProductPublishResult,
  WhatnotShippingProfiles,
  WhatnotShowSyncStatus,
  WhatnotShowWebhookConfiguration,
  WhatsappInboxAnalytics,
  WhatsappInboxAttachment,
  WhatsappInboxConversationDetail,
  WhatsappInboxConversationPage,
  WhatsappInboxConversationSummary,
  WhatsappInboxConversationUpdate,
  WhatsappInboxSendInput,
  WhatsappInboxSendResult,
  WhatsappInboxSettings,
  WhatsappInboxSettingsInput,
  WhatsappIntegrationStatus,
  WhatsappIntegrationTestResult,
  WhatsappIntegrationUpdate,
  WhatsappOwnerShippingTest,
  WhatsappOwnerShippingTestApproval,
  WhatsappOwnerShippingTestAttestation,
  WhatsappOwnerShippingTestPrepare,
  WhatsappTrackingApproval,
  WhatsappTrackingBatch,
  WhatsappTrackingBatchInput,
  WhatsappTrackingReadiness,
  WhatsappTrackingSendResult,
  WholesaleApplicationInput,
  WholesaleApplicationReceipt,
  WooTerm,
  WoocommerceSyncedProductsResult,
  Workflow,
  WorkflowInput,
  WorkflowRun,
  WorkflowTestInput,
  WorkflowTestResult,
  XeroDashboard,
  XeroSettingsUpdate,
  XeroStatus,
  XeroSyncRecordResult,
  XeroSyncRequest,
  XeroSyncRunResult
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetWhatnotShowSyncStatusUrl = () => {




  return `/api/integrations/whatnot/shows/sync`
}

/**
 * @summary Everyday Bullion show sync health
 */
export const getWhatnotShowSyncStatus = async ( options?: RequestInit): Promise<WhatnotShowSyncStatus> => {

  return customFetch<WhatnotShowSyncStatus>(getGetWhatnotShowSyncStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWhatnotShowSyncStatusQueryKey = () => {
    return [
    `/api/integrations/whatnot/shows/sync`
    ] as const;
    }


export const getGetWhatnotShowSyncStatusQueryOptions = <TData = Awaited<ReturnType<typeof getWhatnotShowSyncStatus>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatnotShowSyncStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWhatnotShowSyncStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWhatnotShowSyncStatus>>> = ({ signal }) => getWhatnotShowSyncStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWhatnotShowSyncStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWhatnotShowSyncStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getWhatnotShowSyncStatus>>>
export type GetWhatnotShowSyncStatusQueryError = ErrorType<unknown>


/**
 * @summary Everyday Bullion show sync health
 */

export function useGetWhatnotShowSyncStatus<TData = Awaited<ReturnType<typeof getWhatnotShowSyncStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatnotShowSyncStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWhatnotShowSyncStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSyncWhatnotShowsNowUrl = () => {




  return `/api/integrations/whatnot/shows/sync`
}

/**
 * @summary Reconcile the connected Everyday Bullion seller's shows
 */
export const syncWhatnotShowsNow = async ( options?: RequestInit): Promise<WhatnotShowSyncStatus> => {

  return customFetch<WhatnotShowSyncStatus>(getSyncWhatnotShowsNowUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSyncWhatnotShowsNowMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncWhatnotShowsNow>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncWhatnotShowsNow>>, TError,void, TContext> => {

const mutationKey = ['syncWhatnotShowsNow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncWhatnotShowsNow>>, void> = () => {


          return  syncWhatnotShowsNow(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncWhatnotShowsNowMutationResult = NonNullable<Awaited<ReturnType<typeof syncWhatnotShowsNow>>>

    export type SyncWhatnotShowsNowMutationError = ErrorType<unknown>

    /**
 * @summary Reconcile the connected Everyday Bullion seller's shows
 */
export const useSyncWhatnotShowsNow = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncWhatnotShowsNow>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncWhatnotShowsNow>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSyncWhatnotShowsNowMutationOptions(options));
    }

export const getConfigureWhatnotShowWebhookUrl = () => {




  return `/api/integrations/whatnot/shows/webhook`
}

/**
 * @summary Encrypt the existing app's webhook signing secret
 */
export const configureWhatnotShowWebhook = async (whatnotShowWebhookConfiguration: WhatnotShowWebhookConfiguration, options?: RequestInit): Promise<WhatnotShowSyncStatus> => {

  return customFetch<WhatnotShowSyncStatus>(getConfigureWhatnotShowWebhookUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(whatnotShowWebhookConfiguration)
  }
);}





export const getConfigureWhatnotShowWebhookMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof configureWhatnotShowWebhook>>, TError,{data: BodyType<WhatnotShowWebhookConfiguration>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof configureWhatnotShowWebhook>>, TError,{data: BodyType<WhatnotShowWebhookConfiguration>}, TContext> => {

const mutationKey = ['configureWhatnotShowWebhook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof configureWhatnotShowWebhook>>, {data: BodyType<WhatnotShowWebhookConfiguration>}> = (props) => {
          const {data} = props ?? {};

          return  configureWhatnotShowWebhook(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfigureWhatnotShowWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof configureWhatnotShowWebhook>>>
    export type ConfigureWhatnotShowWebhookMutationBody = BodyType<WhatnotShowWebhookConfiguration>
    export type ConfigureWhatnotShowWebhookMutationError = ErrorType<unknown>

    /**
 * @summary Encrypt the existing app's webhook signing secret
 */
export const useConfigureWhatnotShowWebhook = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof configureWhatnotShowWebhook>>, TError,{data: BodyType<WhatnotShowWebhookConfiguration>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof configureWhatnotShowWebhook>>,
        TError,
        {data: BodyType<WhatnotShowWebhookConfiguration>},
        TContext
      > => {
      return useMutation(getConfigureWhatnotShowWebhookMutationOptions(options));
    }

export const getGetWhatsappTrackingReadinessUrl = () => {




  return `/api/whatsapp-tracking/status`
}

/**
 * @summary Read Royal Mail tracking notification readiness
 */
export const getWhatsappTrackingReadiness = async ( options?: RequestInit): Promise<WhatsappTrackingReadiness> => {

  return customFetch<WhatsappTrackingReadiness>(getGetWhatsappTrackingReadinessUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWhatsappTrackingReadinessQueryKey = () => {
    return [
    `/api/whatsapp-tracking/status`
    ] as const;
    }


export const getGetWhatsappTrackingReadinessQueryOptions = <TData = Awaited<ReturnType<typeof getWhatsappTrackingReadiness>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatsappTrackingReadiness>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWhatsappTrackingReadinessQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWhatsappTrackingReadiness>>> = ({ signal }) => getWhatsappTrackingReadiness({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWhatsappTrackingReadiness>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWhatsappTrackingReadinessQueryResult = NonNullable<Awaited<ReturnType<typeof getWhatsappTrackingReadiness>>>
export type GetWhatsappTrackingReadinessQueryError = ErrorType<void>


/**
 * @summary Read Royal Mail tracking notification readiness
 */

export function useGetWhatsappTrackingReadiness<TData = Awaited<ReturnType<typeof getWhatsappTrackingReadiness>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatsappTrackingReadiness>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWhatsappTrackingReadinessQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetWhatsappOwnerShippingTestUrl = () => {




  return `/api/whatsapp-tracking/owner-test`
}

/**
 * @summary Read the isolated owner shipping-template test review
 */
export const getWhatsappOwnerShippingTest = async ( options?: RequestInit): Promise<WhatsappOwnerShippingTest> => {

  return customFetch<WhatsappOwnerShippingTest>(getGetWhatsappOwnerShippingTestUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWhatsappOwnerShippingTestQueryKey = () => {
    return [
    `/api/whatsapp-tracking/owner-test`
    ] as const;
    }


export const getGetWhatsappOwnerShippingTestQueryOptions = <TData = Awaited<ReturnType<typeof getWhatsappOwnerShippingTest>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatsappOwnerShippingTest>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWhatsappOwnerShippingTestQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWhatsappOwnerShippingTest>>> = ({ signal }) => getWhatsappOwnerShippingTest({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWhatsappOwnerShippingTest>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWhatsappOwnerShippingTestQueryResult = NonNullable<Awaited<ReturnType<typeof getWhatsappOwnerShippingTest>>>
export type GetWhatsappOwnerShippingTestQueryError = ErrorType<void>


/**
 * @summary Read the isolated owner shipping-template test review
 */

export function useGetWhatsappOwnerShippingTest<TData = Awaited<ReturnType<typeof getWhatsappOwnerShippingTest>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatsappOwnerShippingTest>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWhatsappOwnerShippingTestQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPrepareWhatsappOwnerShippingTestUrl = () => {




  return `/api/whatsapp-tracking/owner-test/prepare`
}

/**
 * @summary Record the limited one-time authorization and prepare its preview
 */
export const prepareWhatsappOwnerShippingTest = async (whatsappOwnerShippingTestPrepare: WhatsappOwnerShippingTestPrepare, options?: RequestInit): Promise<WhatsappOwnerShippingTest> => {

  return customFetch<WhatsappOwnerShippingTest>(getPrepareWhatsappOwnerShippingTestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(whatsappOwnerShippingTestPrepare)
  }
);}





export const getPrepareWhatsappOwnerShippingTestMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prepareWhatsappOwnerShippingTest>>, TError,{data: BodyType<WhatsappOwnerShippingTestPrepare>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof prepareWhatsappOwnerShippingTest>>, TError,{data: BodyType<WhatsappOwnerShippingTestPrepare>}, TContext> => {

const mutationKey = ['prepareWhatsappOwnerShippingTest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof prepareWhatsappOwnerShippingTest>>, {data: BodyType<WhatsappOwnerShippingTestPrepare>}> = (props) => {
          const {data} = props ?? {};

          return  prepareWhatsappOwnerShippingTest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PrepareWhatsappOwnerShippingTestMutationResult = NonNullable<Awaited<ReturnType<typeof prepareWhatsappOwnerShippingTest>>>
    export type PrepareWhatsappOwnerShippingTestMutationBody = BodyType<WhatsappOwnerShippingTestPrepare>
    export type PrepareWhatsappOwnerShippingTestMutationError = ErrorType<void>

    /**
 * @summary Record the limited one-time authorization and prepare its preview
 */
export const usePrepareWhatsappOwnerShippingTest = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prepareWhatsappOwnerShippingTest>>, TError,{data: BodyType<WhatsappOwnerShippingTestPrepare>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof prepareWhatsappOwnerShippingTest>>,
        TError,
        {data: BodyType<WhatsappOwnerShippingTestPrepare>},
        TContext
      > => {
      return useMutation(getPrepareWhatsappOwnerShippingTestMutationOptions(options));
    }

export const getAttestWhatsappOwnerShippingTestUrl = () => {




  return `/api/whatsapp-tracking/owner-test/attest`
}

/**
 * @summary Attest the exact live sender and synthetic preview for this test
 */
export const attestWhatsappOwnerShippingTest = async (whatsappOwnerShippingTestAttestation: WhatsappOwnerShippingTestAttestation, options?: RequestInit): Promise<WhatsappOwnerShippingTest> => {

  return customFetch<WhatsappOwnerShippingTest>(getAttestWhatsappOwnerShippingTestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(whatsappOwnerShippingTestAttestation)
  }
);}





export const getAttestWhatsappOwnerShippingTestMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attestWhatsappOwnerShippingTest>>, TError,{data: BodyType<WhatsappOwnerShippingTestAttestation>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof attestWhatsappOwnerShippingTest>>, TError,{data: BodyType<WhatsappOwnerShippingTestAttestation>}, TContext> => {

const mutationKey = ['attestWhatsappOwnerShippingTest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof attestWhatsappOwnerShippingTest>>, {data: BodyType<WhatsappOwnerShippingTestAttestation>}> = (props) => {
          const {data} = props ?? {};

          return  attestWhatsappOwnerShippingTest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AttestWhatsappOwnerShippingTestMutationResult = NonNullable<Awaited<ReturnType<typeof attestWhatsappOwnerShippingTest>>>
    export type AttestWhatsappOwnerShippingTestMutationBody = BodyType<WhatsappOwnerShippingTestAttestation>
    export type AttestWhatsappOwnerShippingTestMutationError = ErrorType<void>

    /**
 * @summary Attest the exact live sender and synthetic preview for this test
 */
export const useAttestWhatsappOwnerShippingTest = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attestWhatsappOwnerShippingTest>>, TError,{data: BodyType<WhatsappOwnerShippingTestAttestation>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof attestWhatsappOwnerShippingTest>>,
        TError,
        {data: BodyType<WhatsappOwnerShippingTestAttestation>},
        TContext
      > => {
      return useMutation(getAttestWhatsappOwnerShippingTestMutationOptions(options));
    }

export const getSendWhatsappOwnerShippingTestUrl = () => {




  return `/api/whatsapp-tracking/owner-test/send`
}

/**
 * @summary Explicitly approve the single fixed-recipient synthetic test message
 */
export const sendWhatsappOwnerShippingTest = async (whatsappOwnerShippingTestApproval: WhatsappOwnerShippingTestApproval, options?: RequestInit): Promise<WhatsappOwnerShippingTest> => {

  return customFetch<WhatsappOwnerShippingTest>(getSendWhatsappOwnerShippingTestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(whatsappOwnerShippingTestApproval)
  }
);}





export const getSendWhatsappOwnerShippingTestMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendWhatsappOwnerShippingTest>>, TError,{data: BodyType<WhatsappOwnerShippingTestApproval>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendWhatsappOwnerShippingTest>>, TError,{data: BodyType<WhatsappOwnerShippingTestApproval>}, TContext> => {

const mutationKey = ['sendWhatsappOwnerShippingTest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendWhatsappOwnerShippingTest>>, {data: BodyType<WhatsappOwnerShippingTestApproval>}> = (props) => {
          const {data} = props ?? {};

          return  sendWhatsappOwnerShippingTest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendWhatsappOwnerShippingTestMutationResult = NonNullable<Awaited<ReturnType<typeof sendWhatsappOwnerShippingTest>>>
    export type SendWhatsappOwnerShippingTestMutationBody = BodyType<WhatsappOwnerShippingTestApproval>
    export type SendWhatsappOwnerShippingTestMutationError = ErrorType<void>

    /**
 * @summary Explicitly approve the single fixed-recipient synthetic test message
 */
export const useSendWhatsappOwnerShippingTest = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendWhatsappOwnerShippingTest>>, TError,{data: BodyType<WhatsappOwnerShippingTestApproval>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendWhatsappOwnerShippingTest>>,
        TError,
        {data: BodyType<WhatsappOwnerShippingTestApproval>},
        TContext
      > => {
      return useMutation(getSendWhatsappOwnerShippingTestMutationOptions(options));
    }

export const getCreateWhatsappTrackingBatchUrl = () => {




  return `/api/whatsapp-tracking/batches`
}

/**
 * @summary Prepare a Royal Mail tracking message batch for review
 */
export const createWhatsappTrackingBatch = async (whatsappTrackingBatchInput: WhatsappTrackingBatchInput, options?: RequestInit): Promise<WhatsappTrackingBatch> => {

  return customFetch<WhatsappTrackingBatch>(getCreateWhatsappTrackingBatchUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(whatsappTrackingBatchInput)
  }
);}





export const getCreateWhatsappTrackingBatchMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWhatsappTrackingBatch>>, TError,{data: BodyType<WhatsappTrackingBatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createWhatsappTrackingBatch>>, TError,{data: BodyType<WhatsappTrackingBatchInput>}, TContext> => {

const mutationKey = ['createWhatsappTrackingBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWhatsappTrackingBatch>>, {data: BodyType<WhatsappTrackingBatchInput>}> = (props) => {
          const {data} = props ?? {};

          return  createWhatsappTrackingBatch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWhatsappTrackingBatchMutationResult = NonNullable<Awaited<ReturnType<typeof createWhatsappTrackingBatch>>>
    export type CreateWhatsappTrackingBatchMutationBody = BodyType<WhatsappTrackingBatchInput>
    export type CreateWhatsappTrackingBatchMutationError = ErrorType<void>

    /**
 * @summary Prepare a Royal Mail tracking message batch for review
 */
export const useCreateWhatsappTrackingBatch = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWhatsappTrackingBatch>>, TError,{data: BodyType<WhatsappTrackingBatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createWhatsappTrackingBatch>>,
        TError,
        {data: BodyType<WhatsappTrackingBatchInput>},
        TContext
      > => {
      return useMutation(getCreateWhatsappTrackingBatchMutationOptions(options));
    }

export const getCreateWhatsappTrackingBatchFromTodayUrl = () => {




  return `/api/whatsapp-tracking/batches/today`
}

/**
 * @summary Prepare today's persisted Royal Mail shipments for review
 */
export const createWhatsappTrackingBatchFromToday = async ( options?: RequestInit): Promise<WhatsappTrackingBatch> => {

  return customFetch<WhatsappTrackingBatch>(getCreateWhatsappTrackingBatchFromTodayUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCreateWhatsappTrackingBatchFromTodayMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWhatsappTrackingBatchFromToday>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createWhatsappTrackingBatchFromToday>>, TError,void, TContext> => {

const mutationKey = ['createWhatsappTrackingBatchFromToday'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWhatsappTrackingBatchFromToday>>, void> = () => {


          return  createWhatsappTrackingBatchFromToday(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWhatsappTrackingBatchFromTodayMutationResult = NonNullable<Awaited<ReturnType<typeof createWhatsappTrackingBatchFromToday>>>

    export type CreateWhatsappTrackingBatchFromTodayMutationError = ErrorType<void>

    /**
 * @summary Prepare today's persisted Royal Mail shipments for review
 */
export const useCreateWhatsappTrackingBatchFromToday = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWhatsappTrackingBatchFromToday>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createWhatsappTrackingBatchFromToday>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateWhatsappTrackingBatchFromTodayMutationOptions(options));
    }

export const getListWhatsappTrackingBatchesUrl = () => {




  return `/api/whatsapp-tracking/batches/today`
}

/**
 * @summary List recent Royal Mail tracking batches
 */
export const listWhatsappTrackingBatches = async ( options?: RequestInit): Promise<ListWhatsappTrackingBatches200> => {

  return customFetch<ListWhatsappTrackingBatches200>(getListWhatsappTrackingBatchesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListWhatsappTrackingBatchesQueryKey = () => {
    return [
    `/api/whatsapp-tracking/batches/today`
    ] as const;
    }


export const getListWhatsappTrackingBatchesQueryOptions = <TData = Awaited<ReturnType<typeof listWhatsappTrackingBatches>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWhatsappTrackingBatches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWhatsappTrackingBatchesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWhatsappTrackingBatches>>> = ({ signal }) => listWhatsappTrackingBatches({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWhatsappTrackingBatches>>, TError, TData> & { queryKey: QueryKey }
}

export type ListWhatsappTrackingBatchesQueryResult = NonNullable<Awaited<ReturnType<typeof listWhatsappTrackingBatches>>>
export type ListWhatsappTrackingBatchesQueryError = ErrorType<void>


/**
 * @summary List recent Royal Mail tracking batches
 */

export function useListWhatsappTrackingBatches<TData = Awaited<ReturnType<typeof listWhatsappTrackingBatches>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWhatsappTrackingBatches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListWhatsappTrackingBatchesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetWhatsappTrackingBatchUrl = (batchId: string,) => {




  return `/api/whatsapp-tracking/batches/${batchId}`
}

/**
 * @summary Read a Royal Mail tracking batch for review
 */
export const getWhatsappTrackingBatch = async (batchId: string, options?: RequestInit): Promise<WhatsappTrackingBatch> => {

  return customFetch<WhatsappTrackingBatch>(getGetWhatsappTrackingBatchUrl(batchId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWhatsappTrackingBatchQueryKey = (batchId: string,) => {
    return [
    `/api/whatsapp-tracking/batches/${batchId}`
    ] as const;
    }


export const getGetWhatsappTrackingBatchQueryOptions = <TData = Awaited<ReturnType<typeof getWhatsappTrackingBatch>>, TError = ErrorType<void>>(batchId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatsappTrackingBatch>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWhatsappTrackingBatchQueryKey(batchId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWhatsappTrackingBatch>>> = ({ signal }) => getWhatsappTrackingBatch(batchId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: batchId !== null && batchId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWhatsappTrackingBatch>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWhatsappTrackingBatchQueryResult = NonNullable<Awaited<ReturnType<typeof getWhatsappTrackingBatch>>>
export type GetWhatsappTrackingBatchQueryError = ErrorType<void>


/**
 * @summary Read a Royal Mail tracking batch for review
 */

export function useGetWhatsappTrackingBatch<TData = Awaited<ReturnType<typeof getWhatsappTrackingBatch>>, TError = ErrorType<void>>(
 batchId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatsappTrackingBatch>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWhatsappTrackingBatchQueryOptions(batchId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSendWhatsappTrackingBatchUrl = (batchId: string,) => {




  return `/api/whatsapp-tracking/batches/${batchId}/send`
}

/**
 * @summary Explicitly approve and send a reviewed Royal Mail batch
 */
export const sendWhatsappTrackingBatch = async (batchId: string,
    whatsappTrackingApproval: WhatsappTrackingApproval, options?: RequestInit): Promise<WhatsappTrackingSendResult> => {

  return customFetch<WhatsappTrackingSendResult>(getSendWhatsappTrackingBatchUrl(batchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(whatsappTrackingApproval)
  }
);}





export const getSendWhatsappTrackingBatchMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendWhatsappTrackingBatch>>, TError,{batchId: string;data: BodyType<WhatsappTrackingApproval>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendWhatsappTrackingBatch>>, TError,{batchId: string;data: BodyType<WhatsappTrackingApproval>}, TContext> => {

const mutationKey = ['sendWhatsappTrackingBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendWhatsappTrackingBatch>>, {batchId: string;data: BodyType<WhatsappTrackingApproval>}> = (props) => {
          const {batchId,data} = props ?? {};

          return  sendWhatsappTrackingBatch(batchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendWhatsappTrackingBatchMutationResult = NonNullable<Awaited<ReturnType<typeof sendWhatsappTrackingBatch>>>
    export type SendWhatsappTrackingBatchMutationBody = BodyType<WhatsappTrackingApproval>
    export type SendWhatsappTrackingBatchMutationError = ErrorType<void>

    /**
 * @summary Explicitly approve and send a reviewed Royal Mail batch
 */
export const useSendWhatsappTrackingBatch = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendWhatsappTrackingBatch>>, TError,{batchId: string;data: BodyType<WhatsappTrackingApproval>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendWhatsappTrackingBatch>>,
        TError,
        {batchId: string;data: BodyType<WhatsappTrackingApproval>},
        TContext
      > => {
      return useMutation(getSendWhatsappTrackingBatchMutationOptions(options));
    }

export const getListWhatsappInboxConversationsUrl = (params?: ListWhatsappInboxConversationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/whatsapp-inbox/conversations?${stringifiedParams}` : `/api/whatsapp-inbox/conversations`
}

/**
 * @summary List tenant WhatsApp conversations
 */
export const listWhatsappInboxConversations = async (params?: ListWhatsappInboxConversationsParams, options?: RequestInit): Promise<WhatsappInboxConversationPage> => {

  return customFetch<WhatsappInboxConversationPage>(getListWhatsappInboxConversationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListWhatsappInboxConversationsQueryKey = (params?: ListWhatsappInboxConversationsParams,) => {
    return [
    `/api/whatsapp-inbox/conversations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListWhatsappInboxConversationsQueryOptions = <TData = Awaited<ReturnType<typeof listWhatsappInboxConversations>>, TError = ErrorType<void>>(params?: ListWhatsappInboxConversationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWhatsappInboxConversations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWhatsappInboxConversationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWhatsappInboxConversations>>> = ({ signal }) => listWhatsappInboxConversations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWhatsappInboxConversations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListWhatsappInboxConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof listWhatsappInboxConversations>>>
export type ListWhatsappInboxConversationsQueryError = ErrorType<void>


/**
 * @summary List tenant WhatsApp conversations
 */

export function useListWhatsappInboxConversations<TData = Awaited<ReturnType<typeof listWhatsappInboxConversations>>, TError = ErrorType<void>>(
 params?: ListWhatsappInboxConversationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWhatsappInboxConversations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListWhatsappInboxConversationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetWhatsappInboxConversationUrl = (conversationId: string,) => {




  return `/api/whatsapp-inbox/conversations/${conversationId}`
}

/**
 * @summary Read a conversation timeline and linked customer context
 */
export const getWhatsappInboxConversation = async (conversationId: string, options?: RequestInit): Promise<WhatsappInboxConversationDetail> => {

  return customFetch<WhatsappInboxConversationDetail>(getGetWhatsappInboxConversationUrl(conversationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWhatsappInboxConversationQueryKey = (conversationId: string,) => {
    return [
    `/api/whatsapp-inbox/conversations/${conversationId}`
    ] as const;
    }


export const getGetWhatsappInboxConversationQueryOptions = <TData = Awaited<ReturnType<typeof getWhatsappInboxConversation>>, TError = ErrorType<void>>(conversationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatsappInboxConversation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWhatsappInboxConversationQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWhatsappInboxConversation>>> = ({ signal }) => getWhatsappInboxConversation(conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWhatsappInboxConversation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWhatsappInboxConversationQueryResult = NonNullable<Awaited<ReturnType<typeof getWhatsappInboxConversation>>>
export type GetWhatsappInboxConversationQueryError = ErrorType<void>


/**
 * @summary Read a conversation timeline and linked customer context
 */

export function useGetWhatsappInboxConversation<TData = Awaited<ReturnType<typeof getWhatsappInboxConversation>>, TError = ErrorType<void>>(
 conversationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatsappInboxConversation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWhatsappInboxConversationQueryOptions(conversationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateWhatsappInboxConversationUrl = (conversationId: string,) => {




  return `/api/whatsapp-inbox/conversations/${conversationId}`
}

/**
 * @summary Update assignment, status, priority, tags or confirmed links
 */
export const updateWhatsappInboxConversation = async (conversationId: string,
    whatsappInboxConversationUpdate: WhatsappInboxConversationUpdate, options?: RequestInit): Promise<WhatsappInboxConversationSummary> => {

  return customFetch<WhatsappInboxConversationSummary>(getUpdateWhatsappInboxConversationUrl(conversationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(whatsappInboxConversationUpdate)
  }
);}





export const getUpdateWhatsappInboxConversationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWhatsappInboxConversation>>, TError,{conversationId: string;data: BodyType<WhatsappInboxConversationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateWhatsappInboxConversation>>, TError,{conversationId: string;data: BodyType<WhatsappInboxConversationUpdate>}, TContext> => {

const mutationKey = ['updateWhatsappInboxConversation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWhatsappInboxConversation>>, {conversationId: string;data: BodyType<WhatsappInboxConversationUpdate>}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  updateWhatsappInboxConversation(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateWhatsappInboxConversationMutationResult = NonNullable<Awaited<ReturnType<typeof updateWhatsappInboxConversation>>>
    export type UpdateWhatsappInboxConversationMutationBody = BodyType<WhatsappInboxConversationUpdate>
    export type UpdateWhatsappInboxConversationMutationError = ErrorType<void>

    /**
 * @summary Update assignment, status, priority, tags or confirmed links
 */
export const useUpdateWhatsappInboxConversation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWhatsappInboxConversation>>, TError,{conversationId: string;data: BodyType<WhatsappInboxConversationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateWhatsappInboxConversation>>,
        TError,
        {conversationId: string;data: BodyType<WhatsappInboxConversationUpdate>},
        TContext
      > => {
      return useMutation(getUpdateWhatsappInboxConversationMutationOptions(options));
    }

export const getSendWhatsappInboxMessageUrl = (conversationId: string,) => {




  return `/api/whatsapp-inbox/conversations/${conversationId}/messages`
}

/**
 * @summary Queue one safe reply to a conversation
 */
export const sendWhatsappInboxMessage = async (conversationId: string,
    whatsappInboxSendInput: WhatsappInboxSendInput, options?: RequestInit): Promise<WhatsappInboxSendResult> => {

  return customFetch<WhatsappInboxSendResult>(getSendWhatsappInboxMessageUrl(conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(whatsappInboxSendInput)
  }
);}





export const getSendWhatsappInboxMessageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendWhatsappInboxMessage>>, TError,{conversationId: string;data: BodyType<WhatsappInboxSendInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendWhatsappInboxMessage>>, TError,{conversationId: string;data: BodyType<WhatsappInboxSendInput>}, TContext> => {

const mutationKey = ['sendWhatsappInboxMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendWhatsappInboxMessage>>, {conversationId: string;data: BodyType<WhatsappInboxSendInput>}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  sendWhatsappInboxMessage(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendWhatsappInboxMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendWhatsappInboxMessage>>>
    export type SendWhatsappInboxMessageMutationBody = BodyType<WhatsappInboxSendInput>
    export type SendWhatsappInboxMessageMutationError = ErrorType<void>

    /**
 * @summary Queue one safe reply to a conversation
 */
export const useSendWhatsappInboxMessage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendWhatsappInboxMessage>>, TError,{conversationId: string;data: BodyType<WhatsappInboxSendInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendWhatsappInboxMessage>>,
        TError,
        {conversationId: string;data: BodyType<WhatsappInboxSendInput>},
        TContext
      > => {
      return useMutation(getSendWhatsappInboxMessageMutationOptions(options));
    }

export const getCreateWhatsappInboxNoteUrl = (conversationId: string,) => {




  return `/api/whatsapp-inbox/conversations/${conversationId}/events`
}

/**
 * @summary Add a private staff note
 */
export const createWhatsappInboxNote = async (conversationId: string,
    createWhatsappInboxNoteBody: CreateWhatsappInboxNoteBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getCreateWhatsappInboxNoteUrl(conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createWhatsappInboxNoteBody)
  }
);}





export const getCreateWhatsappInboxNoteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWhatsappInboxNote>>, TError,{conversationId: string;data: BodyType<CreateWhatsappInboxNoteBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createWhatsappInboxNote>>, TError,{conversationId: string;data: BodyType<CreateWhatsappInboxNoteBody>}, TContext> => {

const mutationKey = ['createWhatsappInboxNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWhatsappInboxNote>>, {conversationId: string;data: BodyType<CreateWhatsappInboxNoteBody>}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  createWhatsappInboxNote(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWhatsappInboxNoteMutationResult = NonNullable<Awaited<ReturnType<typeof createWhatsappInboxNote>>>
    export type CreateWhatsappInboxNoteMutationBody = BodyType<CreateWhatsappInboxNoteBody>
    export type CreateWhatsappInboxNoteMutationError = ErrorType<void>

    /**
 * @summary Add a private staff note
 */
export const useCreateWhatsappInboxNote = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWhatsappInboxNote>>, TError,{conversationId: string;data: BodyType<CreateWhatsappInboxNoteBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createWhatsappInboxNote>>,
        TError,
        {conversationId: string;data: BodyType<CreateWhatsappInboxNoteBody>},
        TContext
      > => {
      return useMutation(getCreateWhatsappInboxNoteMutationOptions(options));
    }

export const getMarkWhatsappInboxConversationReadUrl = (conversationId: string,) => {




  return `/api/whatsapp-inbox/conversations/${conversationId}/read`
}

/**
 * @summary Mark the conversation read for the current operator
 */
export const markWhatsappInboxConversationRead = async (conversationId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getMarkWhatsappInboxConversationReadUrl(conversationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMarkWhatsappInboxConversationReadMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markWhatsappInboxConversationRead>>, TError,{conversationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markWhatsappInboxConversationRead>>, TError,{conversationId: string}, TContext> => {

const mutationKey = ['markWhatsappInboxConversationRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markWhatsappInboxConversationRead>>, {conversationId: string}> = (props) => {
          const {conversationId} = props ?? {};

          return  markWhatsappInboxConversationRead(conversationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkWhatsappInboxConversationReadMutationResult = NonNullable<Awaited<ReturnType<typeof markWhatsappInboxConversationRead>>>

    export type MarkWhatsappInboxConversationReadMutationError = ErrorType<void>

    /**
 * @summary Mark the conversation read for the current operator
 */
export const useMarkWhatsappInboxConversationRead = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markWhatsappInboxConversationRead>>, TError,{conversationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markWhatsappInboxConversationRead>>,
        TError,
        {conversationId: string},
        TContext
      > => {
      return useMutation(getMarkWhatsappInboxConversationReadMutationOptions(options));
    }

export const getUploadWhatsappInboxAttachmentUrl = (conversationId: string,) => {




  return `/api/whatsapp-inbox/conversations/${conversationId}/attachments`
}

/**
 * @summary Upload a private image or PDF for one conversation
 */
export const uploadWhatsappInboxAttachment = async (conversationId: string,
    uploadWhatsappInboxAttachmentBody: UploadWhatsappInboxAttachmentBody, options?: RequestInit): Promise<WhatsappInboxAttachment> => {
    const formData = new FormData();
formData.append(`file`, uploadWhatsappInboxAttachmentBody.file);

  return customFetch<WhatsappInboxAttachment>(getUploadWhatsappInboxAttachmentUrl(conversationId),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getUploadWhatsappInboxAttachmentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadWhatsappInboxAttachment>>, TError,{conversationId: string;data: BodyType<UploadWhatsappInboxAttachmentBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadWhatsappInboxAttachment>>, TError,{conversationId: string;data: BodyType<UploadWhatsappInboxAttachmentBody>}, TContext> => {

const mutationKey = ['uploadWhatsappInboxAttachment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadWhatsappInboxAttachment>>, {conversationId: string;data: BodyType<UploadWhatsappInboxAttachmentBody>}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  uploadWhatsappInboxAttachment(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadWhatsappInboxAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof uploadWhatsappInboxAttachment>>>
    export type UploadWhatsappInboxAttachmentMutationBody = BodyType<UploadWhatsappInboxAttachmentBody>
    export type UploadWhatsappInboxAttachmentMutationError = ErrorType<void>

    /**
 * @summary Upload a private image or PDF for one conversation
 */
export const useUploadWhatsappInboxAttachment = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadWhatsappInboxAttachment>>, TError,{conversationId: string;data: BodyType<UploadWhatsappInboxAttachmentBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadWhatsappInboxAttachment>>,
        TError,
        {conversationId: string;data: BodyType<UploadWhatsappInboxAttachmentBody>},
        TContext
      > => {
      return useMutation(getUploadWhatsappInboxAttachmentMutationOptions(options));
    }

export const getGetWhatsappInboxAttachmentUrl = (attachmentId: string,) => {




  return `/api/whatsapp-inbox/attachments/${attachmentId}`
}

/**
 * @summary Get a short-lived private attachment URL
 */
export const getWhatsappInboxAttachment = async (attachmentId: string, options?: RequestInit): Promise<WhatsappInboxAttachment> => {

  return customFetch<WhatsappInboxAttachment>(getGetWhatsappInboxAttachmentUrl(attachmentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWhatsappInboxAttachmentQueryKey = (attachmentId: string,) => {
    return [
    `/api/whatsapp-inbox/attachments/${attachmentId}`
    ] as const;
    }


export const getGetWhatsappInboxAttachmentQueryOptions = <TData = Awaited<ReturnType<typeof getWhatsappInboxAttachment>>, TError = ErrorType<void>>(attachmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatsappInboxAttachment>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWhatsappInboxAttachmentQueryKey(attachmentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWhatsappInboxAttachment>>> = ({ signal }) => getWhatsappInboxAttachment(attachmentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: attachmentId !== null && attachmentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWhatsappInboxAttachment>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWhatsappInboxAttachmentQueryResult = NonNullable<Awaited<ReturnType<typeof getWhatsappInboxAttachment>>>
export type GetWhatsappInboxAttachmentQueryError = ErrorType<void>


/**
 * @summary Get a short-lived private attachment URL
 */

export function useGetWhatsappInboxAttachment<TData = Awaited<ReturnType<typeof getWhatsappInboxAttachment>>, TError = ErrorType<void>>(
 attachmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatsappInboxAttachment>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWhatsappInboxAttachmentQueryOptions(attachmentId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetWhatsappInboxAttachmentContentUrl = (attachmentId: string,) => {




  return `/api/whatsapp-inbox/attachments/${attachmentId}/content`
}

/**
 * @summary Stream a verified inbound attachment through the authenticated API
 */
export const getWhatsappInboxAttachmentContent = async (attachmentId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetWhatsappInboxAttachmentContentUrl(attachmentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWhatsappInboxAttachmentContentQueryKey = (attachmentId: string,) => {
    return [
    `/api/whatsapp-inbox/attachments/${attachmentId}/content`
    ] as const;
    }


export const getGetWhatsappInboxAttachmentContentQueryOptions = <TData = Awaited<ReturnType<typeof getWhatsappInboxAttachmentContent>>, TError = ErrorType<void>>(attachmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatsappInboxAttachmentContent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWhatsappInboxAttachmentContentQueryKey(attachmentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWhatsappInboxAttachmentContent>>> = ({ signal }) => getWhatsappInboxAttachmentContent(attachmentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: attachmentId !== null && attachmentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWhatsappInboxAttachmentContent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWhatsappInboxAttachmentContentQueryResult = NonNullable<Awaited<ReturnType<typeof getWhatsappInboxAttachmentContent>>>
export type GetWhatsappInboxAttachmentContentQueryError = ErrorType<void>


/**
 * @summary Stream a verified inbound attachment through the authenticated API
 */

export function useGetWhatsappInboxAttachmentContent<TData = Awaited<ReturnType<typeof getWhatsappInboxAttachmentContent>>, TError = ErrorType<void>>(
 attachmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatsappInboxAttachmentContent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWhatsappInboxAttachmentContentQueryOptions(attachmentId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetWhatsappInboxSettingsUrl = () => {




  return `/api/whatsapp-inbox/settings`
}

/**
 * @summary Read inbox configuration and tenant-specific webhook URLs
 */
export const getWhatsappInboxSettings = async ( options?: RequestInit): Promise<WhatsappInboxSettings> => {

  return customFetch<WhatsappInboxSettings>(getGetWhatsappInboxSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWhatsappInboxSettingsQueryKey = () => {
    return [
    `/api/whatsapp-inbox/settings`
    ] as const;
    }


export const getGetWhatsappInboxSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getWhatsappInboxSettings>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatsappInboxSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWhatsappInboxSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWhatsappInboxSettings>>> = ({ signal }) => getWhatsappInboxSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWhatsappInboxSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWhatsappInboxSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getWhatsappInboxSettings>>>
export type GetWhatsappInboxSettingsQueryError = ErrorType<void>


/**
 * @summary Read inbox configuration and tenant-specific webhook URLs
 */

export function useGetWhatsappInboxSettings<TData = Awaited<ReturnType<typeof getWhatsappInboxSettings>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatsappInboxSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWhatsappInboxSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateWhatsappInboxSettingsUrl = () => {




  return `/api/whatsapp-inbox/settings`
}

/**
 * @summary Configure office hours, automated replies and approved template SIDs
 */
export const updateWhatsappInboxSettings = async (whatsappInboxSettingsInput: WhatsappInboxSettingsInput, options?: RequestInit): Promise<WhatsappInboxSettings> => {

  return customFetch<WhatsappInboxSettings>(getUpdateWhatsappInboxSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(whatsappInboxSettingsInput)
  }
);}





export const getUpdateWhatsappInboxSettingsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWhatsappInboxSettings>>, TError,{data: BodyType<WhatsappInboxSettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateWhatsappInboxSettings>>, TError,{data: BodyType<WhatsappInboxSettingsInput>}, TContext> => {

const mutationKey = ['updateWhatsappInboxSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWhatsappInboxSettings>>, {data: BodyType<WhatsappInboxSettingsInput>}> = (props) => {
          const {data} = props ?? {};

          return  updateWhatsappInboxSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateWhatsappInboxSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateWhatsappInboxSettings>>>
    export type UpdateWhatsappInboxSettingsMutationBody = BodyType<WhatsappInboxSettingsInput>
    export type UpdateWhatsappInboxSettingsMutationError = ErrorType<void>

    /**
 * @summary Configure office hours, automated replies and approved template SIDs
 */
export const useUpdateWhatsappInboxSettings = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWhatsappInboxSettings>>, TError,{data: BodyType<WhatsappInboxSettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateWhatsappInboxSettings>>,
        TError,
        {data: BodyType<WhatsappInboxSettingsInput>},
        TContext
      > => {
      return useMutation(getUpdateWhatsappInboxSettingsMutationOptions(options));
    }

export const getListWhatsappInboxTemplatesUrl = () => {




  return `/api/whatsapp-inbox/templates`
}

/**
 * @summary Inspect the tenant's configured WhatsApp templates
 */
export const listWhatsappInboxTemplates = async ( options?: RequestInit): Promise<ListWhatsappInboxTemplates200> => {

  return customFetch<ListWhatsappInboxTemplates200>(getListWhatsappInboxTemplatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListWhatsappInboxTemplatesQueryKey = () => {
    return [
    `/api/whatsapp-inbox/templates`
    ] as const;
    }


export const getListWhatsappInboxTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof listWhatsappInboxTemplates>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWhatsappInboxTemplates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWhatsappInboxTemplatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWhatsappInboxTemplates>>> = ({ signal }) => listWhatsappInboxTemplates({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWhatsappInboxTemplates>>, TError, TData> & { queryKey: QueryKey }
}

export type ListWhatsappInboxTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof listWhatsappInboxTemplates>>>
export type ListWhatsappInboxTemplatesQueryError = ErrorType<void>


/**
 * @summary Inspect the tenant's configured WhatsApp templates
 */

export function useListWhatsappInboxTemplates<TData = Awaited<ReturnType<typeof listWhatsappInboxTemplates>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWhatsappInboxTemplates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListWhatsappInboxTemplatesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListWhatsappInboxOperatorsUrl = () => {




  return `/api/whatsapp-inbox/operators`
}

/**
 * @summary List active tenant members available for conversation assignment
 */
export const listWhatsappInboxOperators = async ( options?: RequestInit): Promise<ListWhatsappInboxOperators200> => {

  return customFetch<ListWhatsappInboxOperators200>(getListWhatsappInboxOperatorsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListWhatsappInboxOperatorsQueryKey = () => {
    return [
    `/api/whatsapp-inbox/operators`
    ] as const;
    }


export const getListWhatsappInboxOperatorsQueryOptions = <TData = Awaited<ReturnType<typeof listWhatsappInboxOperators>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWhatsappInboxOperators>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWhatsappInboxOperatorsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWhatsappInboxOperators>>> = ({ signal }) => listWhatsappInboxOperators({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWhatsappInboxOperators>>, TError, TData> & { queryKey: QueryKey }
}

export type ListWhatsappInboxOperatorsQueryResult = NonNullable<Awaited<ReturnType<typeof listWhatsappInboxOperators>>>
export type ListWhatsappInboxOperatorsQueryError = ErrorType<void>


/**
 * @summary List active tenant members available for conversation assignment
 */

export function useListWhatsappInboxOperators<TData = Awaited<ReturnType<typeof listWhatsappInboxOperators>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWhatsappInboxOperators>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListWhatsappInboxOperatorsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListWhatsappInboxQuickRepliesUrl = () => {




  return `/api/whatsapp-inbox/quick-replies`
}

/**
 * @summary List active quick replies
 */
export const listWhatsappInboxQuickReplies = async ( options?: RequestInit): Promise<ListWhatsappInboxQuickReplies200> => {

  return customFetch<ListWhatsappInboxQuickReplies200>(getListWhatsappInboxQuickRepliesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListWhatsappInboxQuickRepliesQueryKey = () => {
    return [
    `/api/whatsapp-inbox/quick-replies`
    ] as const;
    }


export const getListWhatsappInboxQuickRepliesQueryOptions = <TData = Awaited<ReturnType<typeof listWhatsappInboxQuickReplies>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWhatsappInboxQuickReplies>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWhatsappInboxQuickRepliesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWhatsappInboxQuickReplies>>> = ({ signal }) => listWhatsappInboxQuickReplies({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWhatsappInboxQuickReplies>>, TError, TData> & { queryKey: QueryKey }
}

export type ListWhatsappInboxQuickRepliesQueryResult = NonNullable<Awaited<ReturnType<typeof listWhatsappInboxQuickReplies>>>
export type ListWhatsappInboxQuickRepliesQueryError = ErrorType<unknown>


/**
 * @summary List active quick replies
 */

export function useListWhatsappInboxQuickReplies<TData = Awaited<ReturnType<typeof listWhatsappInboxQuickReplies>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWhatsappInboxQuickReplies>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListWhatsappInboxQuickRepliesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateWhatsappInboxQuickReplyUrl = () => {




  return `/api/whatsapp-inbox/quick-replies`
}

/**
 * @summary Create a quick reply
 */
export const createWhatsappInboxQuickReply = async (createWhatsappInboxQuickReplyBody: CreateWhatsappInboxQuickReplyBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getCreateWhatsappInboxQuickReplyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createWhatsappInboxQuickReplyBody)
  }
);}





export const getCreateWhatsappInboxQuickReplyMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWhatsappInboxQuickReply>>, TError,{data: BodyType<CreateWhatsappInboxQuickReplyBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createWhatsappInboxQuickReply>>, TError,{data: BodyType<CreateWhatsappInboxQuickReplyBody>}, TContext> => {

const mutationKey = ['createWhatsappInboxQuickReply'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWhatsappInboxQuickReply>>, {data: BodyType<CreateWhatsappInboxQuickReplyBody>}> = (props) => {
          const {data} = props ?? {};

          return  createWhatsappInboxQuickReply(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWhatsappInboxQuickReplyMutationResult = NonNullable<Awaited<ReturnType<typeof createWhatsappInboxQuickReply>>>
    export type CreateWhatsappInboxQuickReplyMutationBody = BodyType<CreateWhatsappInboxQuickReplyBody>
    export type CreateWhatsappInboxQuickReplyMutationError = ErrorType<void>

    /**
 * @summary Create a quick reply
 */
export const useCreateWhatsappInboxQuickReply = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWhatsappInboxQuickReply>>, TError,{data: BodyType<CreateWhatsappInboxQuickReplyBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createWhatsappInboxQuickReply>>,
        TError,
        {data: BodyType<CreateWhatsappInboxQuickReplyBody>},
        TContext
      > => {
      return useMutation(getCreateWhatsappInboxQuickReplyMutationOptions(options));
    }

export const getDeleteWhatsappInboxQuickReplyUrl = (quickReplyId: string,) => {




  return `/api/whatsapp-inbox/quick-replies/${quickReplyId}`
}

/**
 * @summary Remove a quick reply
 */
export const deleteWhatsappInboxQuickReply = async (quickReplyId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteWhatsappInboxQuickReplyUrl(quickReplyId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteWhatsappInboxQuickReplyMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWhatsappInboxQuickReply>>, TError,{quickReplyId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteWhatsappInboxQuickReply>>, TError,{quickReplyId: string}, TContext> => {

const mutationKey = ['deleteWhatsappInboxQuickReply'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWhatsappInboxQuickReply>>, {quickReplyId: string}> = (props) => {
          const {quickReplyId} = props ?? {};

          return  deleteWhatsappInboxQuickReply(quickReplyId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteWhatsappInboxQuickReplyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWhatsappInboxQuickReply>>>

    export type DeleteWhatsappInboxQuickReplyMutationError = ErrorType<void>

    /**
 * @summary Remove a quick reply
 */
export const useDeleteWhatsappInboxQuickReply = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWhatsappInboxQuickReply>>, TError,{quickReplyId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteWhatsappInboxQuickReply>>,
        TError,
        {quickReplyId: string},
        TContext
      > => {
      return useMutation(getDeleteWhatsappInboxQuickReplyMutationOptions(options));
    }

export const getGetWhatsappInboxAnalyticsUrl = (params?: GetWhatsappInboxAnalyticsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/whatsapp-inbox/analytics?${stringifiedParams}` : `/api/whatsapp-inbox/analytics`
}

/**
 * @summary Read team-level response and workload metrics
 */
export const getWhatsappInboxAnalytics = async (params?: GetWhatsappInboxAnalyticsParams, options?: RequestInit): Promise<WhatsappInboxAnalytics> => {

  return customFetch<WhatsappInboxAnalytics>(getGetWhatsappInboxAnalyticsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWhatsappInboxAnalyticsQueryKey = (params?: GetWhatsappInboxAnalyticsParams,) => {
    return [
    `/api/whatsapp-inbox/analytics`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetWhatsappInboxAnalyticsQueryOptions = <TData = Awaited<ReturnType<typeof getWhatsappInboxAnalytics>>, TError = ErrorType<void>>(params?: GetWhatsappInboxAnalyticsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatsappInboxAnalytics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWhatsappInboxAnalyticsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWhatsappInboxAnalytics>>> = ({ signal }) => getWhatsappInboxAnalytics(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWhatsappInboxAnalytics>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWhatsappInboxAnalyticsQueryResult = NonNullable<Awaited<ReturnType<typeof getWhatsappInboxAnalytics>>>
export type GetWhatsappInboxAnalyticsQueryError = ErrorType<void>


/**
 * @summary Read team-level response and workload metrics
 */

export function useGetWhatsappInboxAnalytics<TData = Awaited<ReturnType<typeof getWhatsappInboxAnalytics>>, TError = ErrorType<void>>(
 params?: GetWhatsappInboxAnalyticsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatsappInboxAnalytics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWhatsappInboxAnalyticsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetWhatnotConditionOptionsUrl = (params: GetWhatnotConditionOptionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/integrations/whatnot/products/condition-options?${stringifiedParams}` : `/api/integrations/whatnot/products/condition-options`
}

/**
 * @summary Read Whatnot condition choices for a seller category
 */
export const getWhatnotConditionOptions = async (params: GetWhatnotConditionOptionsParams, options?: RequestInit): Promise<WhatnotConditionOptions> => {

  return customFetch<WhatnotConditionOptions>(getGetWhatnotConditionOptionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWhatnotConditionOptionsQueryKey = (params?: GetWhatnotConditionOptionsParams,) => {
    return [
    `/api/integrations/whatnot/products/condition-options`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetWhatnotConditionOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getWhatnotConditionOptions>>, TError = ErrorType<void>>(params: GetWhatnotConditionOptionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatnotConditionOptions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWhatnotConditionOptionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWhatnotConditionOptions>>> = ({ signal }) => getWhatnotConditionOptions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWhatnotConditionOptions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWhatnotConditionOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getWhatnotConditionOptions>>>
export type GetWhatnotConditionOptionsQueryError = ErrorType<void>


/**
 * @summary Read Whatnot condition choices for a seller category
 */

export function useGetWhatnotConditionOptions<TData = Awaited<ReturnType<typeof getWhatnotConditionOptions>>, TError = ErrorType<void>>(
 params: GetWhatnotConditionOptionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatnotConditionOptions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWhatnotConditionOptionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetWhatnotShippingProfilesUrl = () => {




  return `/api/integrations/whatnot/products/shipping-profiles`
}

/**
 * @summary Read shipping profiles available to the connected Whatnot seller
 */
export const getWhatnotShippingProfiles = async ( options?: RequestInit): Promise<WhatnotShippingProfiles> => {

  return customFetch<WhatnotShippingProfiles>(getGetWhatnotShippingProfilesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWhatnotShippingProfilesQueryKey = () => {
    return [
    `/api/integrations/whatnot/products/shipping-profiles`
    ] as const;
    }


export const getGetWhatnotShippingProfilesQueryOptions = <TData = Awaited<ReturnType<typeof getWhatnotShippingProfiles>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatnotShippingProfiles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWhatnotShippingProfilesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWhatnotShippingProfiles>>> = ({ signal }) => getWhatnotShippingProfiles({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWhatnotShippingProfiles>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWhatnotShippingProfilesQueryResult = NonNullable<Awaited<ReturnType<typeof getWhatnotShippingProfiles>>>
export type GetWhatnotShippingProfilesQueryError = ErrorType<void>


/**
 * @summary Read shipping profiles available to the connected Whatnot seller
 */

export function useGetWhatnotShippingProfiles<TData = Awaited<ReturnType<typeof getWhatnotShippingProfiles>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatnotShippingProfiles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWhatnotShippingProfilesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetWhatnotCategoryCatalogUrl = (params?: GetWhatnotCategoryCatalogParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/integrations/whatnot/products/categories?${stringifiedParams}` : `/api/integrations/whatnot/products/categories`
}

/**
 * Searches the connected seller's own Whatnot taxonomy. Returned category
 * IDs are provider IDs and are not mapped from another marketplace's taxonomy.
 * @summary Search the connected seller's available product categories
 */
export const getWhatnotCategoryCatalog = async (params?: GetWhatnotCategoryCatalogParams, options?: RequestInit): Promise<WhatnotCategoryCatalog> => {

  return customFetch<WhatnotCategoryCatalog>(getGetWhatnotCategoryCatalogUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWhatnotCategoryCatalogQueryKey = (params?: GetWhatnotCategoryCatalogParams,) => {
    return [
    `/api/integrations/whatnot/products/categories`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetWhatnotCategoryCatalogQueryOptions = <TData = Awaited<ReturnType<typeof getWhatnotCategoryCatalog>>, TError = ErrorType<void>>(params?: GetWhatnotCategoryCatalogParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatnotCategoryCatalog>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWhatnotCategoryCatalogQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWhatnotCategoryCatalog>>> = ({ signal }) => getWhatnotCategoryCatalog(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWhatnotCategoryCatalog>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWhatnotCategoryCatalogQueryResult = NonNullable<Awaited<ReturnType<typeof getWhatnotCategoryCatalog>>>
export type GetWhatnotCategoryCatalogQueryError = ErrorType<void>


/**
 * @summary Search the connected seller's available product categories
 */

export function useGetWhatnotCategoryCatalog<TData = Awaited<ReturnType<typeof getWhatnotCategoryCatalog>>, TError = ErrorType<void>>(
 params?: GetWhatnotCategoryCatalogParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatnotCategoryCatalog>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWhatnotCategoryCatalogQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateWhatnotInventoryOverridesUrl = (inventoryItemId: string,) => {




  return `/api/integrations/whatnot/products/${inventoryItemId}/overrides`
}

/**
 * @summary Save Whatnot-only inventory listing overrides
 */
export const updateWhatnotInventoryOverrides = async (inventoryItemId: string,
    whatnotInventoryOverrides: WhatnotInventoryOverrides, options?: RequestInit): Promise<WhatnotInventoryOverrides> => {

  return customFetch<WhatnotInventoryOverrides>(getUpdateWhatnotInventoryOverridesUrl(inventoryItemId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(whatnotInventoryOverrides)
  }
);}





export const getUpdateWhatnotInventoryOverridesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWhatnotInventoryOverrides>>, TError,{inventoryItemId: string;data: BodyType<WhatnotInventoryOverrides>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateWhatnotInventoryOverrides>>, TError,{inventoryItemId: string;data: BodyType<WhatnotInventoryOverrides>}, TContext> => {

const mutationKey = ['updateWhatnotInventoryOverrides'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWhatnotInventoryOverrides>>, {inventoryItemId: string;data: BodyType<WhatnotInventoryOverrides>}> = (props) => {
          const {inventoryItemId,data} = props ?? {};

          return  updateWhatnotInventoryOverrides(inventoryItemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateWhatnotInventoryOverridesMutationResult = NonNullable<Awaited<ReturnType<typeof updateWhatnotInventoryOverrides>>>
    export type UpdateWhatnotInventoryOverridesMutationBody = BodyType<WhatnotInventoryOverrides>
    export type UpdateWhatnotInventoryOverridesMutationError = ErrorType<void>

    /**
 * @summary Save Whatnot-only inventory listing overrides
 */
export const useUpdateWhatnotInventoryOverrides = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWhatnotInventoryOverrides>>, TError,{inventoryItemId: string;data: BodyType<WhatnotInventoryOverrides>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateWhatnotInventoryOverrides>>,
        TError,
        {inventoryItemId: string;data: BodyType<WhatnotInventoryOverrides>},
        TContext
      > => {
      return useMutation(getUpdateWhatnotInventoryOverridesMutationOptions(options));
    }

export const getPublishWhatnotInventoryProductUrl = () => {




  return `/api/integrations/whatnot/products/publish`
}

/**
 * @summary Publish or update one inventory item on Whatnot
 */
export const publishWhatnotInventoryProduct = async (whatnotProductPublishInput: WhatnotProductPublishInput, options?: RequestInit): Promise<WhatnotProductPublishResult> => {

  return customFetch<WhatnotProductPublishResult>(getPublishWhatnotInventoryProductUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(whatnotProductPublishInput)
  }
);}





export const getPublishWhatnotInventoryProductMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishWhatnotInventoryProduct>>, TError,{data: BodyType<WhatnotProductPublishInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof publishWhatnotInventoryProduct>>, TError,{data: BodyType<WhatnotProductPublishInput>}, TContext> => {

const mutationKey = ['publishWhatnotInventoryProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishWhatnotInventoryProduct>>, {data: BodyType<WhatnotProductPublishInput>}> = (props) => {
          const {data} = props ?? {};

          return  publishWhatnotInventoryProduct(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishWhatnotInventoryProductMutationResult = NonNullable<Awaited<ReturnType<typeof publishWhatnotInventoryProduct>>>
    export type PublishWhatnotInventoryProductMutationBody = BodyType<WhatnotProductPublishInput>
    export type PublishWhatnotInventoryProductMutationError = ErrorType<void>

    /**
 * @summary Publish or update one inventory item on Whatnot
 */
export const usePublishWhatnotInventoryProduct = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishWhatnotInventoryProduct>>, TError,{data: BodyType<WhatnotProductPublishInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof publishWhatnotInventoryProduct>>,
        TError,
        {data: BodyType<WhatnotProductPublishInput>},
        TContext
      > => {
      return useMutation(getPublishWhatnotInventoryProductMutationOptions(options));
    }

export const getCheckWhatnotOrderAccessUrl = () => {




  return `/api/integrations/whatnot/orders/access-check`
}

/**
 * Requires manage_integrations. Performs one read-only orders(first: 1)
 * query and returns no order identifiers or details.
 * @summary Verify Whatnot order-read access without importing an order
 */
export const checkWhatnotOrderAccess = async ( options?: RequestInit): Promise<WhatnotOrderAccessCheck> => {

  return customFetch<WhatnotOrderAccessCheck>(getCheckWhatnotOrderAccessUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCheckWhatnotOrderAccessMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkWhatnotOrderAccess>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof checkWhatnotOrderAccess>>, TError,void, TContext> => {

const mutationKey = ['checkWhatnotOrderAccess'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkWhatnotOrderAccess>>, void> = () => {


          return  checkWhatnotOrderAccess(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckWhatnotOrderAccessMutationResult = NonNullable<Awaited<ReturnType<typeof checkWhatnotOrderAccess>>>

    export type CheckWhatnotOrderAccessMutationError = ErrorType<void>

    /**
 * @summary Verify Whatnot order-read access without importing an order
 */
export const useCheckWhatnotOrderAccess = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkWhatnotOrderAccess>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof checkWhatnotOrderAccess>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCheckWhatnotOrderAccessMutationOptions(options));
    }

export const getInspectWhatnotOrderHistoryBoundaryUrl = () => {




  return `/api/integrations/whatnot/orders/history-boundary`
}

/**
 * Requires manage_integrations. Reads only order IDs and creation dates,
 * inspects at most 5,000 orders with cursor pagination, and does not import
 * orders or change an import cursor. A capped scan reports that more orders
 * are available rather than claiming to have found the provider boundary.
 * @summary Inspect the available Whatnot order-history boundary
 */
export const inspectWhatnotOrderHistoryBoundary = async ( options?: RequestInit): Promise<WhatnotOrderHistoryBoundary> => {

  return customFetch<WhatnotOrderHistoryBoundary>(getInspectWhatnotOrderHistoryBoundaryUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getInspectWhatnotOrderHistoryBoundaryMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inspectWhatnotOrderHistoryBoundary>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof inspectWhatnotOrderHistoryBoundary>>, TError,void, TContext> => {

const mutationKey = ['inspectWhatnotOrderHistoryBoundary'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inspectWhatnotOrderHistoryBoundary>>, void> = () => {


          return  inspectWhatnotOrderHistoryBoundary(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InspectWhatnotOrderHistoryBoundaryMutationResult = NonNullable<Awaited<ReturnType<typeof inspectWhatnotOrderHistoryBoundary>>>

    export type InspectWhatnotOrderHistoryBoundaryMutationError = ErrorType<void>

    /**
 * @summary Inspect the available Whatnot order-history boundary
 */
export const useInspectWhatnotOrderHistoryBoundary = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inspectWhatnotOrderHistoryBoundary>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof inspectWhatnotOrderHistoryBoundary>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getInspectWhatnotOrderHistoryBoundaryMutationOptions(options));
    }

export const getRecoverExactWhatnotOrderUrl = () => {




  return `/api/integrations/whatnot/orders/recover-exact`
}

/**
 * Requires manage_integrations. Searches at most 1,000 order records across
 * up to three explicitly supplied London calendar dates. Reads customer
 * details only for an exact matched order, imports through the canonical
 * idempotent importer, and never changes a historical import cursor.
 * @summary Recover one exact Whatnot order from a bounded date window
 */
export const recoverExactWhatnotOrder = async (whatnotOrderRecoveryInput: WhatnotOrderRecoveryInput, options?: RequestInit): Promise<WhatnotOrderRecoveryResult> => {

  return customFetch<WhatnotOrderRecoveryResult>(getRecoverExactWhatnotOrderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(whatnotOrderRecoveryInput)
  }
);}





export const getRecoverExactWhatnotOrderMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recoverExactWhatnotOrder>>, TError,{data: BodyType<WhatnotOrderRecoveryInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recoverExactWhatnotOrder>>, TError,{data: BodyType<WhatnotOrderRecoveryInput>}, TContext> => {

const mutationKey = ['recoverExactWhatnotOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recoverExactWhatnotOrder>>, {data: BodyType<WhatnotOrderRecoveryInput>}> = (props) => {
          const {data} = props ?? {};

          return  recoverExactWhatnotOrder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecoverExactWhatnotOrderMutationResult = NonNullable<Awaited<ReturnType<typeof recoverExactWhatnotOrder>>>
    export type RecoverExactWhatnotOrderMutationBody = BodyType<WhatnotOrderRecoveryInput>
    export type RecoverExactWhatnotOrderMutationError = ErrorType<void>

    /**
 * @summary Recover one exact Whatnot order from a bounded date window
 */
export const useRecoverExactWhatnotOrder = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recoverExactWhatnotOrder>>, TError,{data: BodyType<WhatnotOrderRecoveryInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recoverExactWhatnotOrder>>,
        TError,
        {data: BodyType<WhatnotOrderRecoveryInput>},
        TContext
      > => {
      return useMutation(getRecoverExactWhatnotOrderMutationOptions(options));
    }

export const getScanWhatnotListingsUrl = () => {




  return `/api/integrations/whatnot/listings/search`
}

export const scanWhatnotListings = async (whatnotListingScanInput: WhatnotListingScanInput, options?: RequestInit): Promise<WhatnotListingScan> => {

  return customFetch<WhatnotListingScan>(getScanWhatnotListingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(whatnotListingScanInput)
  }
);}





export const getScanWhatnotListingsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scanWhatnotListings>>, TError,{data: BodyType<WhatnotListingScanInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof scanWhatnotListings>>, TError,{data: BodyType<WhatnotListingScanInput>}, TContext> => {

const mutationKey = ['scanWhatnotListings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scanWhatnotListings>>, {data: BodyType<WhatnotListingScanInput>}> = (props) => {
          const {data} = props ?? {};

          return  scanWhatnotListings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScanWhatnotListingsMutationResult = NonNullable<Awaited<ReturnType<typeof scanWhatnotListings>>>
    export type ScanWhatnotListingsMutationBody = BodyType<WhatnotListingScanInput>
    export type ScanWhatnotListingsMutationError = ErrorType<void>

    export const useScanWhatnotListings = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scanWhatnotListings>>, TError,{data: BodyType<WhatnotListingScanInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof scanWhatnotListings>>,
        TError,
        {data: BodyType<WhatnotListingScanInput>},
        TContext
      > => {
      return useMutation(getScanWhatnotListingsMutationOptions(options));
    }

export const getResendCustomerPortalVerificationUrl = (id: string,) => {




  return `/api/commerce/customers/${id}/resend-verification`
}

/**
 * Requires commerce.manage and customer_accounts in the active tenant.
 * Does not verify or activate the account. A usable unexpired link is
 * preserved. Provider acceptance is not proof of inbox delivery.
 * No verification token or credential link is returned.
 * @summary Retry a pending portal account's verification email
 */
export const resendCustomerPortalVerification = async (id: string, options?: RequestInit): Promise<PortalVerificationDelivery> => {

  return customFetch<PortalVerificationDelivery>(getResendCustomerPortalVerificationUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResendCustomerPortalVerificationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendCustomerPortalVerification>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resendCustomerPortalVerification>>, TError,{id: string}, TContext> => {

const mutationKey = ['resendCustomerPortalVerification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendCustomerPortalVerification>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  resendCustomerPortalVerification(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendCustomerPortalVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof resendCustomerPortalVerification>>>

    export type ResendCustomerPortalVerificationMutationError = ErrorType<void>

    /**
 * @summary Retry a pending portal account's verification email
 */
export const useResendCustomerPortalVerification = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendCustomerPortalVerification>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resendCustomerPortalVerification>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getResendCustomerPortalVerificationMutationOptions(options));
    }

export const getListCustomerOrderEmailNotificationsUrl = (params?: ListCustomerOrderEmailNotificationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/email/customer-notifications?${stringifiedParams}` : `/api/email/customer-notifications`
}

/**
 * Requires view_admin. Returns tenant-scoped event and provider delivery
 * evidence without recipient addresses or rendered message content.
 * Provider acceptance does not establish inbox delivery.
 * @summary List delivery evidence for customer order notifications
 */
export const listCustomerOrderEmailNotifications = async (params?: ListCustomerOrderEmailNotificationsParams, options?: RequestInit): Promise<CustomerOrderEmailNotificationsPage> => {

  return customFetch<CustomerOrderEmailNotificationsPage>(getListCustomerOrderEmailNotificationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomerOrderEmailNotificationsQueryKey = (params?: ListCustomerOrderEmailNotificationsParams,) => {
    return [
    `/api/email/customer-notifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCustomerOrderEmailNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof listCustomerOrderEmailNotifications>>, TError = ErrorType<void>>(params?: ListCustomerOrderEmailNotificationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerOrderEmailNotifications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomerOrderEmailNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomerOrderEmailNotifications>>> = ({ signal }) => listCustomerOrderEmailNotifications(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomerOrderEmailNotifications>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCustomerOrderEmailNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomerOrderEmailNotifications>>>
export type ListCustomerOrderEmailNotificationsQueryError = ErrorType<void>


/**
 * @summary List delivery evidence for customer order notifications
 */

export function useListCustomerOrderEmailNotifications<TData = Awaited<ReturnType<typeof listCustomerOrderEmailNotifications>>, TError = ErrorType<void>>(
 params?: ListCustomerOrderEmailNotificationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerOrderEmailNotifications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCustomerOrderEmailNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRetryCustomerOrderEmailNotificationUrl = (id: string,) => {




  return `/api/email/customer-notifications/${id}/retry`
}

/**
 * Requires edit_settings. Only terminal failures can be retried.
 * @summary Requeue a permanently failed or exhausted customer notification
 */
export const retryCustomerOrderEmailNotification = async (id: string, options?: RequestInit): Promise<CustomerOrderEmailNotificationRetryResult> => {

  return customFetch<CustomerOrderEmailNotificationRetryResult>(getRetryCustomerOrderEmailNotificationUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRetryCustomerOrderEmailNotificationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryCustomerOrderEmailNotification>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof retryCustomerOrderEmailNotification>>, TError,{id: string}, TContext> => {

const mutationKey = ['retryCustomerOrderEmailNotification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryCustomerOrderEmailNotification>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  retryCustomerOrderEmailNotification(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryCustomerOrderEmailNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof retryCustomerOrderEmailNotification>>>

    export type RetryCustomerOrderEmailNotificationMutationError = ErrorType<void>

    /**
 * @summary Requeue a permanently failed or exhausted customer notification
 */
export const useRetryCustomerOrderEmailNotification = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryCustomerOrderEmailNotification>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof retryCustomerOrderEmailNotification>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getRetryCustomerOrderEmailNotificationMutationOptions(options));
    }

export const getRequestCentralMarketRefreshUrl = () => {




  return `/api/platform/market-data/refresh`
}

/**
 * Does not bypass provider polling intervals or shared budgets. A pending result is not evidence of an upstream observation.
 * @summary Queue a coalesced refresh for the elected market ingestion worker
 */
export const requestCentralMarketRefresh = async ( options?: RequestInit): Promise<CentralMarketRefreshResult> => {

  return customFetch<CentralMarketRefreshResult>(getRequestCentralMarketRefreshUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRequestCentralMarketRefreshMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestCentralMarketRefresh>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestCentralMarketRefresh>>, TError,void, TContext> => {

const mutationKey = ['requestCentralMarketRefresh'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestCentralMarketRefresh>>, void> = () => {


          return  requestCentralMarketRefresh(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestCentralMarketRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof requestCentralMarketRefresh>>>

    export type RequestCentralMarketRefreshMutationError = ErrorType<void>

    /**
 * @summary Queue a coalesced refresh for the elected market ingestion worker
 */
export const useRequestCentralMarketRefresh = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestCentralMarketRefresh>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestCentralMarketRefresh>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRequestCentralMarketRefreshMutationOptions(options));
    }

export const getGetCentralMarketRefreshResultUrl = (requestId: string,) => {




  return `/api/platform/market-data/refresh/${requestId}`
}

/**
 * @summary Read the elected worker's refresh outcome from any replica
 */
export const getCentralMarketRefreshResult = async (requestId: string, options?: RequestInit): Promise<CentralMarketRefreshResult> => {

  return customFetch<CentralMarketRefreshResult>(getGetCentralMarketRefreshResultUrl(requestId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCentralMarketRefreshResultQueryKey = (requestId: string,) => {
    return [
    `/api/platform/market-data/refresh/${requestId}`
    ] as const;
    }


export const getGetCentralMarketRefreshResultQueryOptions = <TData = Awaited<ReturnType<typeof getCentralMarketRefreshResult>>, TError = ErrorType<void>>(requestId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCentralMarketRefreshResult>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCentralMarketRefreshResultQueryKey(requestId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCentralMarketRefreshResult>>> = ({ signal }) => getCentralMarketRefreshResult(requestId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: requestId !== null && requestId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCentralMarketRefreshResult>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCentralMarketRefreshResultQueryResult = NonNullable<Awaited<ReturnType<typeof getCentralMarketRefreshResult>>>
export type GetCentralMarketRefreshResultQueryError = ErrorType<void>


/**
 * @summary Read the elected worker's refresh outcome from any replica
 */

export function useGetCentralMarketRefreshResult<TData = Awaited<ReturnType<typeof getCentralMarketRefreshResult>>, TError = ErrorType<void>>(
 requestId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCentralMarketRefreshResult>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCentralMarketRefreshResultQueryOptions(requestId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetDemandOverviewUrl = (params?: GetDemandOverviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/demand/overview?${stringifiedParams}` : `/api/demand/overview`
}

/**
 * @summary Get permission-aware, tenant-scoped demand overview facts
 */
export const getDemandOverview = async (params?: GetDemandOverviewParams, options?: RequestInit): Promise<GetDemandOverview200> => {

  return customFetch<GetDemandOverview200>(getGetDemandOverviewUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDemandOverviewQueryKey = (params?: GetDemandOverviewParams,) => {
    return [
    `/api/demand/overview`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDemandOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getDemandOverview>>, TError = ErrorType<void>>(params?: GetDemandOverviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDemandOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDemandOverviewQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDemandOverview>>> = ({ signal }) => getDemandOverview(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDemandOverview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDemandOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getDemandOverview>>>
export type GetDemandOverviewQueryError = ErrorType<void>


/**
 * @summary Get permission-aware, tenant-scoped demand overview facts
 */

export function useGetDemandOverview<TData = Awaited<ReturnType<typeof getDemandOverview>>, TError = ErrorType<void>>(
 params?: GetDemandOverviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDemandOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDemandOverviewQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetDemandViewUrl = (view: 'behaviour' | 'customers' | 'products' | 'channels' | 'forecast' | 'purchase-planner' | 'targets' | 'insights' | 'export.csv',
    params?: GetDemandViewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/demand/${view}?${stringifiedParams}` : `/api/demand/${view}`
}

/**
 * @summary Get a bounded demand workspace view
 */
export const getDemandView = async (view: 'behaviour' | 'customers' | 'products' | 'channels' | 'forecast' | 'purchase-planner' | 'targets' | 'insights' | 'export.csv',
    params?: GetDemandViewParams, options?: RequestInit): Promise<GetDemandView200> => {

  return customFetch<GetDemandView200>(getGetDemandViewUrl(view,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDemandViewQueryKey = (view: 'behaviour' | 'customers' | 'products' | 'channels' | 'forecast' | 'purchase-planner' | 'targets' | 'insights' | 'export.csv',
    params?: GetDemandViewParams,) => {
    return [
    `/api/demand/${view}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDemandViewQueryOptions = <TData = Awaited<ReturnType<typeof getDemandView>>, TError = ErrorType<void>>(view: 'behaviour' | 'customers' | 'products' | 'channels' | 'forecast' | 'purchase-planner' | 'targets' | 'insights' | 'export.csv',
    params?: GetDemandViewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDemandView>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDemandViewQueryKey(view,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDemandView>>> = ({ signal }) => getDemandView(view,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: view !== null && view !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDemandView>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDemandViewQueryResult = NonNullable<Awaited<ReturnType<typeof getDemandView>>>
export type GetDemandViewQueryError = ErrorType<void>


/**
 * @summary Get a bounded demand workspace view
 */

export function useGetDemandView<TData = Awaited<ReturnType<typeof getDemandView>>, TError = ErrorType<void>>(
 view: 'behaviour' | 'customers' | 'products' | 'channels' | 'forecast' | 'purchase-planner' | 'targets' | 'insights' | 'export.csv',
    params?: GetDemandViewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDemandView>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDemandViewQueryOptions(view,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetDemandProductUrl = (productId: string,
    params?: GetDemandProductParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/demand/products/${productId}?${stringifiedParams}` : `/api/demand/products/${productId}`
}

/**
 * @summary Get one tenant-owned product demand detail
 */
export const getDemandProduct = async (productId: string,
    params?: GetDemandProductParams, options?: RequestInit): Promise<GetDemandProduct200> => {

  return customFetch<GetDemandProduct200>(getGetDemandProductUrl(productId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDemandProductQueryKey = (productId: string,
    params?: GetDemandProductParams,) => {
    return [
    `/api/demand/products/${productId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDemandProductQueryOptions = <TData = Awaited<ReturnType<typeof getDemandProduct>>, TError = ErrorType<void>>(productId: string,
    params?: GetDemandProductParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDemandProduct>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDemandProductQueryKey(productId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDemandProduct>>> = ({ signal }) => getDemandProduct(productId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: productId !== null && productId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDemandProduct>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDemandProductQueryResult = NonNullable<Awaited<ReturnType<typeof getDemandProduct>>>
export type GetDemandProductQueryError = ErrorType<void>


/**
 * @summary Get one tenant-owned product demand detail
 */

export function useGetDemandProduct<TData = Awaited<ReturnType<typeof getDemandProduct>>, TError = ErrorType<void>>(
 productId: string,
    params?: GetDemandProductParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDemandProduct>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDemandProductQueryOptions(productId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetDemandTargetsUrl = () => {




  return `/api/demand/targets`
}

/**
 * @summary List tenant operating targets and current progress
 */
export const getDemandTargets = async ( options?: RequestInit): Promise<GetDemandTargets200> => {

  return customFetch<GetDemandTargets200>(getGetDemandTargetsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDemandTargetsQueryKey = () => {
    return [
    `/api/demand/targets`
    ] as const;
    }


export const getGetDemandTargetsQueryOptions = <TData = Awaited<ReturnType<typeof getDemandTargets>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDemandTargets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDemandTargetsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDemandTargets>>> = ({ signal }) => getDemandTargets({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDemandTargets>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDemandTargetsQueryResult = NonNullable<Awaited<ReturnType<typeof getDemandTargets>>>
export type GetDemandTargetsQueryError = ErrorType<unknown>


/**
 * @summary List tenant operating targets and current progress
 */

export function useGetDemandTargets<TData = Awaited<ReturnType<typeof getDemandTargets>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDemandTargets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDemandTargetsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateDemandTargetUrl = () => {




  return `/api/demand/targets`
}

/**
 * @summary Create a bounded demand target
 */
export const createDemandTarget = async (createDemandTargetBody: CreateDemandTargetBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getCreateDemandTargetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createDemandTargetBody)
  }
);}





export const getCreateDemandTargetMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDemandTarget>>, TError,{data: BodyType<CreateDemandTargetBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createDemandTarget>>, TError,{data: BodyType<CreateDemandTargetBody>}, TContext> => {

const mutationKey = ['createDemandTarget'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDemandTarget>>, {data: BodyType<CreateDemandTargetBody>}> = (props) => {
          const {data} = props ?? {};

          return  createDemandTarget(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDemandTargetMutationResult = NonNullable<Awaited<ReturnType<typeof createDemandTarget>>>
    export type CreateDemandTargetMutationBody = BodyType<CreateDemandTargetBody>
    export type CreateDemandTargetMutationError = ErrorType<void>

    /**
 * @summary Create a bounded demand target
 */
export const useCreateDemandTarget = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDemandTarget>>, TError,{data: BodyType<CreateDemandTargetBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createDemandTarget>>,
        TError,
        {data: BodyType<CreateDemandTargetBody>},
        TContext
      > => {
      return useMutation(getCreateDemandTargetMutationOptions(options));
    }

export const getExportDemandProductsUrl = (params?: ExportDemandProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/demand/export.csv?${stringifiedParams}` : `/api/demand/export.csv`
}

/**
 * @summary Export permitted product demand and stock signals as CSV
 */
export const exportDemandProducts = async (params?: ExportDemandProductsParams, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getExportDemandProductsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportDemandProductsQueryKey = (params?: ExportDemandProductsParams,) => {
    return [
    `/api/demand/export.csv`, ...(params ? [params] : [])
    ] as const;
    }


export const getExportDemandProductsQueryOptions = <TData = Awaited<ReturnType<typeof exportDemandProducts>>, TError = ErrorType<void>>(params?: ExportDemandProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportDemandProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportDemandProductsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportDemandProducts>>> = ({ signal }) => exportDemandProducts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportDemandProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type ExportDemandProductsQueryResult = NonNullable<Awaited<ReturnType<typeof exportDemandProducts>>>
export type ExportDemandProductsQueryError = ErrorType<void>


/**
 * @summary Export permitted product demand and stock signals as CSV
 */

export function useExportDemandProducts<TData = Awaited<ReturnType<typeof exportDemandProducts>>, TError = ErrorType<void>>(
 params?: ExportDemandProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportDemandProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getExportDemandProductsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateDemandPurchaseDraftsUrl = () => {




  return `/api/demand/purchase-planner/drafts`
}

/**
 * @summary Create reviewable draft purchase orders from selected recommendations
 */
export const createDemandPurchaseDrafts = async (createDemandPurchaseDraftsBody: CreateDemandPurchaseDraftsBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getCreateDemandPurchaseDraftsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createDemandPurchaseDraftsBody)
  }
);}





export const getCreateDemandPurchaseDraftsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDemandPurchaseDrafts>>, TError,{data: BodyType<CreateDemandPurchaseDraftsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createDemandPurchaseDrafts>>, TError,{data: BodyType<CreateDemandPurchaseDraftsBody>}, TContext> => {

const mutationKey = ['createDemandPurchaseDrafts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDemandPurchaseDrafts>>, {data: BodyType<CreateDemandPurchaseDraftsBody>}> = (props) => {
          const {data} = props ?? {};

          return  createDemandPurchaseDrafts(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDemandPurchaseDraftsMutationResult = NonNullable<Awaited<ReturnType<typeof createDemandPurchaseDrafts>>>
    export type CreateDemandPurchaseDraftsMutationBody = BodyType<CreateDemandPurchaseDraftsBody>
    export type CreateDemandPurchaseDraftsMutationError = ErrorType<void>

    /**
 * @summary Create reviewable draft purchase orders from selected recommendations
 */
export const useCreateDemandPurchaseDrafts = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDemandPurchaseDrafts>>, TError,{data: BodyType<CreateDemandPurchaseDraftsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createDemandPurchaseDrafts>>,
        TError,
        {data: BodyType<CreateDemandPurchaseDraftsBody>},
        TContext
      > => {
      return useMutation(getCreateDemandPurchaseDraftsMutationOptions(options));
    }

export const getGetOperationsFoundationUrl = () => {




  return `/api/operations/foundation`
}

/**
 * @summary Discover enabled Operations Workspace foundation capabilities
 */
export const getOperationsFoundation = async ( options?: RequestInit): Promise<IntelligenceFoundationResponse> => {

  return customFetch<IntelligenceFoundationResponse>(getGetOperationsFoundationUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOperationsFoundationQueryKey = () => {
    return [
    `/api/operations/foundation`
    ] as const;
    }


export const getGetOperationsFoundationQueryOptions = <TData = Awaited<ReturnType<typeof getOperationsFoundation>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOperationsFoundation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOperationsFoundationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOperationsFoundation>>> = ({ signal }) => getOperationsFoundation({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOperationsFoundation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOperationsFoundationQueryResult = NonNullable<Awaited<ReturnType<typeof getOperationsFoundation>>>
export type GetOperationsFoundationQueryError = ErrorType<void>


/**
 * @summary Discover enabled Operations Workspace foundation capabilities
 */

export function useGetOperationsFoundation<TData = Awaited<ReturnType<typeof getOperationsFoundation>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOperationsFoundation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOperationsFoundationQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCustomerJourneyFoundationUrl = () => {




  return `/api/customer-journey/foundation`
}

/**
 * @summary Discover enabled Customer Journey foundation capabilities
 */
export const getCustomerJourneyFoundation = async ( options?: RequestInit): Promise<IntelligenceFoundationResponse> => {

  return customFetch<IntelligenceFoundationResponse>(getGetCustomerJourneyFoundationUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomerJourneyFoundationQueryKey = () => {
    return [
    `/api/customer-journey/foundation`
    ] as const;
    }


export const getGetCustomerJourneyFoundationQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerJourneyFoundation>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerJourneyFoundation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerJourneyFoundationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerJourneyFoundation>>> = ({ signal }) => getCustomerJourneyFoundation({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerJourneyFoundation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerJourneyFoundationQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerJourneyFoundation>>>
export type GetCustomerJourneyFoundationQueryError = ErrorType<void>


/**
 * @summary Discover enabled Customer Journey foundation capabilities
 */

export function useGetCustomerJourneyFoundation<TData = Awaited<ReturnType<typeof getCustomerJourneyFoundation>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerJourneyFoundation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCustomerJourneyFoundationQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCatalogueIntelligenceFoundationUrl = () => {




  return `/api/catalogue-intelligence/foundation`
}

/**
 * @summary Discover Catalogue Intelligence capabilities and asynchronous states
 */
export const getCatalogueIntelligenceFoundation = async ( options?: RequestInit): Promise<CatalogueIntelligenceFoundation> => {

  return customFetch<CatalogueIntelligenceFoundation>(getGetCatalogueIntelligenceFoundationUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCatalogueIntelligenceFoundationQueryKey = () => {
    return [
    `/api/catalogue-intelligence/foundation`
    ] as const;
    }


export const getGetCatalogueIntelligenceFoundationQueryOptions = <TData = Awaited<ReturnType<typeof getCatalogueIntelligenceFoundation>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCatalogueIntelligenceFoundation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCatalogueIntelligenceFoundationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCatalogueIntelligenceFoundation>>> = ({ signal }) => getCatalogueIntelligenceFoundation({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCatalogueIntelligenceFoundation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCatalogueIntelligenceFoundationQueryResult = NonNullable<Awaited<ReturnType<typeof getCatalogueIntelligenceFoundation>>>
export type GetCatalogueIntelligenceFoundationQueryError = ErrorType<void>


/**
 * @summary Discover Catalogue Intelligence capabilities and asynchronous states
 */

export function useGetCatalogueIntelligenceFoundation<TData = Awaited<ReturnType<typeof getCatalogueIntelligenceFoundation>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCatalogueIntelligenceFoundation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCatalogueIntelligenceFoundationQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getEnqueueCatalogueIntelligenceCheckUrl = () => {




  return `/api/catalogue-intelligence/checks`
}

/**
 * @summary Enqueue a bounded asynchronous catalogue check
 */
export const enqueueCatalogueIntelligenceCheck = async (catalogueCheckInput?: CatalogueCheckInput, options?: RequestInit): Promise<CatalogueAsyncJob> => {

  return customFetch<CatalogueAsyncJob>(getEnqueueCatalogueIntelligenceCheckUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(catalogueCheckInput)
  }
);}





export const getEnqueueCatalogueIntelligenceCheckMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enqueueCatalogueIntelligenceCheck>>, TError,{data?: BodyType<CatalogueCheckInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof enqueueCatalogueIntelligenceCheck>>, TError,{data?: BodyType<CatalogueCheckInput>}, TContext> => {

const mutationKey = ['enqueueCatalogueIntelligenceCheck'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enqueueCatalogueIntelligenceCheck>>, {data?: BodyType<CatalogueCheckInput>}> = (props) => {
          const {data} = props ?? {};

          return  enqueueCatalogueIntelligenceCheck(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnqueueCatalogueIntelligenceCheckMutationResult = NonNullable<Awaited<ReturnType<typeof enqueueCatalogueIntelligenceCheck>>>
    export type EnqueueCatalogueIntelligenceCheckMutationBody = BodyType<CatalogueCheckInput> | undefined
    export type EnqueueCatalogueIntelligenceCheckMutationError = ErrorType<void>

    /**
 * @summary Enqueue a bounded asynchronous catalogue check
 */
export const useEnqueueCatalogueIntelligenceCheck = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enqueueCatalogueIntelligenceCheck>>, TError,{data?: BodyType<CatalogueCheckInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof enqueueCatalogueIntelligenceCheck>>,
        TError,
        {data?: BodyType<CatalogueCheckInput>},
        TContext
      > => {
      return useMutation(getEnqueueCatalogueIntelligenceCheckMutationOptions(options));
    }

export const getGetCatalogueIntelligenceStatusUrl = () => {




  return `/api/catalogue-intelligence/status`
}

export const getCatalogueIntelligenceStatus = async ( options?: RequestInit): Promise<CatalogueStatus> => {

  return customFetch<CatalogueStatus>(getGetCatalogueIntelligenceStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCatalogueIntelligenceStatusQueryKey = () => {
    return [
    `/api/catalogue-intelligence/status`
    ] as const;
    }


export const getGetCatalogueIntelligenceStatusQueryOptions = <TData = Awaited<ReturnType<typeof getCatalogueIntelligenceStatus>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCatalogueIntelligenceStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCatalogueIntelligenceStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCatalogueIntelligenceStatus>>> = ({ signal }) => getCatalogueIntelligenceStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCatalogueIntelligenceStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCatalogueIntelligenceStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getCatalogueIntelligenceStatus>>>
export type GetCatalogueIntelligenceStatusQueryError = ErrorType<unknown>



export function useGetCatalogueIntelligenceStatus<TData = Awaited<ReturnType<typeof getCatalogueIntelligenceStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCatalogueIntelligenceStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCatalogueIntelligenceStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCatalogueItemHealthUrl = (productKey: string,) => {




  return `/api/catalogue-intelligence/items/${productKey}/health`
}

export const getCatalogueItemHealth = async (productKey: string, options?: RequestInit): Promise<CatalogueItemHealth> => {

  return customFetch<CatalogueItemHealth>(getGetCatalogueItemHealthUrl(productKey),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCatalogueItemHealthQueryKey = (productKey: string,) => {
    return [
    `/api/catalogue-intelligence/items/${productKey}/health`
    ] as const;
    }


export const getGetCatalogueItemHealthQueryOptions = <TData = Awaited<ReturnType<typeof getCatalogueItemHealth>>, TError = ErrorType<void>>(productKey: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCatalogueItemHealth>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCatalogueItemHealthQueryKey(productKey);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCatalogueItemHealth>>> = ({ signal }) => getCatalogueItemHealth(productKey, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: productKey !== null && productKey !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCatalogueItemHealth>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCatalogueItemHealthQueryResult = NonNullable<Awaited<ReturnType<typeof getCatalogueItemHealth>>>
export type GetCatalogueItemHealthQueryError = ErrorType<void>



export function useGetCatalogueItemHealth<TData = Awaited<ReturnType<typeof getCatalogueItemHealth>>, TError = ErrorType<void>>(
 productKey: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCatalogueItemHealth>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCatalogueItemHealthQueryOptions(productKey,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetInventoryCatalogueHealthUrl = (id: string,) => {




  return `/api/inventory/${id}/catalogue-health`
}

export const getInventoryCatalogueHealth = async (id: string, options?: RequestInit): Promise<CatalogueItemHealth> => {

  return customFetch<CatalogueItemHealth>(getGetInventoryCatalogueHealthUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventoryCatalogueHealthQueryKey = (id: string,) => {
    return [
    `/api/inventory/${id}/catalogue-health`
    ] as const;
    }


export const getGetInventoryCatalogueHealthQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryCatalogueHealth>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryCatalogueHealth>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryCatalogueHealthQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryCatalogueHealth>>> = ({ signal }) => getInventoryCatalogueHealth(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryCatalogueHealth>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInventoryCatalogueHealthQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryCatalogueHealth>>>
export type GetInventoryCatalogueHealthQueryError = ErrorType<void>



export function useGetInventoryCatalogueHealth<TData = Awaited<ReturnType<typeof getInventoryCatalogueHealth>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryCatalogueHealth>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInventoryCatalogueHealthQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCatalogueReportsUrl = (params?: ListCatalogueReportsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/catalogue-intelligence/reports?${stringifiedParams}` : `/api/catalogue-intelligence/reports`
}

export const listCatalogueReports = async (params?: ListCatalogueReportsParams, options?: RequestInit): Promise<CatalogueReportPage> => {

  return customFetch<CatalogueReportPage>(getListCatalogueReportsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCatalogueReportsQueryKey = (params?: ListCatalogueReportsParams,) => {
    return [
    `/api/catalogue-intelligence/reports`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCatalogueReportsQueryOptions = <TData = Awaited<ReturnType<typeof listCatalogueReports>>, TError = ErrorType<unknown>>(params?: ListCatalogueReportsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCatalogueReports>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCatalogueReportsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCatalogueReports>>> = ({ signal }) => listCatalogueReports(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCatalogueReports>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCatalogueReportsQueryResult = NonNullable<Awaited<ReturnType<typeof listCatalogueReports>>>
export type ListCatalogueReportsQueryError = ErrorType<unknown>



export function useListCatalogueReports<TData = Awaited<ReturnType<typeof listCatalogueReports>>, TError = ErrorType<unknown>>(
 params?: ListCatalogueReportsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCatalogueReports>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCatalogueReportsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportCatalogueReportsUrl = (params?: ExportCatalogueReportsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/catalogue-intelligence/reports/export?${stringifiedParams}` : `/api/catalogue-intelligence/reports/export`
}

export const exportCatalogueReports = async (params?: ExportCatalogueReportsParams, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getExportCatalogueReportsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportCatalogueReportsQueryKey = (params?: ExportCatalogueReportsParams,) => {
    return [
    `/api/catalogue-intelligence/reports/export`, ...(params ? [params] : [])
    ] as const;
    }


export const getExportCatalogueReportsQueryOptions = <TData = Awaited<ReturnType<typeof exportCatalogueReports>>, TError = ErrorType<unknown>>(params?: ExportCatalogueReportsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportCatalogueReports>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportCatalogueReportsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportCatalogueReports>>> = ({ signal }) => exportCatalogueReports(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportCatalogueReports>>, TError, TData> & { queryKey: QueryKey }
}

export type ExportCatalogueReportsQueryResult = NonNullable<Awaited<ReturnType<typeof exportCatalogueReports>>>
export type ExportCatalogueReportsQueryError = ErrorType<unknown>



export function useExportCatalogueReports<TData = Awaited<ReturnType<typeof exportCatalogueReports>>, TError = ErrorType<unknown>>(
 params?: ExportCatalogueReportsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportCatalogueReports>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getExportCatalogueReportsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCatalogueEvidenceUrl = (params?: ListCatalogueEvidenceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/catalogue-intelligence/evidence?${stringifiedParams}` : `/api/catalogue-intelligence/evidence`
}

export const listCatalogueEvidence = async (params?: ListCatalogueEvidenceParams, options?: RequestInit): Promise<CatalogueEvidencePage> => {

  return customFetch<CatalogueEvidencePage>(getListCatalogueEvidenceUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCatalogueEvidenceQueryKey = (params?: ListCatalogueEvidenceParams,) => {
    return [
    `/api/catalogue-intelligence/evidence`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCatalogueEvidenceQueryOptions = <TData = Awaited<ReturnType<typeof listCatalogueEvidence>>, TError = ErrorType<unknown>>(params?: ListCatalogueEvidenceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCatalogueEvidence>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCatalogueEvidenceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCatalogueEvidence>>> = ({ signal }) => listCatalogueEvidence(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCatalogueEvidence>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCatalogueEvidenceQueryResult = NonNullable<Awaited<ReturnType<typeof listCatalogueEvidence>>>
export type ListCatalogueEvidenceQueryError = ErrorType<unknown>



export function useListCatalogueEvidence<TData = Awaited<ReturnType<typeof listCatalogueEvidence>>, TError = ErrorType<unknown>>(
 params?: ListCatalogueEvidenceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCatalogueEvidence>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCatalogueEvidenceQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCatalogueEvidenceUrl = (id: string,) => {




  return `/api/catalogue-intelligence/evidence/${id}`
}

export const getCatalogueEvidence = async (id: string, options?: RequestInit): Promise<CatalogueEvidence> => {

  return customFetch<CatalogueEvidence>(getGetCatalogueEvidenceUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCatalogueEvidenceQueryKey = (id: string,) => {
    return [
    `/api/catalogue-intelligence/evidence/${id}`
    ] as const;
    }


export const getGetCatalogueEvidenceQueryOptions = <TData = Awaited<ReturnType<typeof getCatalogueEvidence>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCatalogueEvidence>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCatalogueEvidenceQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCatalogueEvidence>>> = ({ signal }) => getCatalogueEvidence(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCatalogueEvidence>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCatalogueEvidenceQueryResult = NonNullable<Awaited<ReturnType<typeof getCatalogueEvidence>>>
export type GetCatalogueEvidenceQueryError = ErrorType<void>



export function useGetCatalogueEvidence<TData = Awaited<ReturnType<typeof getCatalogueEvidence>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCatalogueEvidence>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCatalogueEvidenceQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCatalogueSuggestionsUrl = (params?: ListCatalogueSuggestionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/catalogue-intelligence/suggestions?${stringifiedParams}` : `/api/catalogue-intelligence/suggestions`
}

export const listCatalogueSuggestions = async (params?: ListCatalogueSuggestionsParams, options?: RequestInit): Promise<CatalogueSuggestionPage> => {

  return customFetch<CatalogueSuggestionPage>(getListCatalogueSuggestionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCatalogueSuggestionsQueryKey = (params?: ListCatalogueSuggestionsParams,) => {
    return [
    `/api/catalogue-intelligence/suggestions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCatalogueSuggestionsQueryOptions = <TData = Awaited<ReturnType<typeof listCatalogueSuggestions>>, TError = ErrorType<unknown>>(params?: ListCatalogueSuggestionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCatalogueSuggestions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCatalogueSuggestionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCatalogueSuggestions>>> = ({ signal }) => listCatalogueSuggestions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCatalogueSuggestions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCatalogueSuggestionsQueryResult = NonNullable<Awaited<ReturnType<typeof listCatalogueSuggestions>>>
export type ListCatalogueSuggestionsQueryError = ErrorType<unknown>



export function useListCatalogueSuggestions<TData = Awaited<ReturnType<typeof listCatalogueSuggestions>>, TError = ErrorType<unknown>>(
 params?: ListCatalogueSuggestionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCatalogueSuggestions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCatalogueSuggestionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCatalogueSuggestionUrl = (id: string,) => {




  return `/api/catalogue-intelligence/suggestions/${id}`
}

export const getCatalogueSuggestion = async (id: string, options?: RequestInit): Promise<CatalogueSuggestion> => {

  return customFetch<CatalogueSuggestion>(getGetCatalogueSuggestionUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCatalogueSuggestionQueryKey = (id: string,) => {
    return [
    `/api/catalogue-intelligence/suggestions/${id}`
    ] as const;
    }


export const getGetCatalogueSuggestionQueryOptions = <TData = Awaited<ReturnType<typeof getCatalogueSuggestion>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCatalogueSuggestion>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCatalogueSuggestionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCatalogueSuggestion>>> = ({ signal }) => getCatalogueSuggestion(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCatalogueSuggestion>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCatalogueSuggestionQueryResult = NonNullable<Awaited<ReturnType<typeof getCatalogueSuggestion>>>
export type GetCatalogueSuggestionQueryError = ErrorType<void>



export function useGetCatalogueSuggestion<TData = Awaited<ReturnType<typeof getCatalogueSuggestion>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCatalogueSuggestion>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCatalogueSuggestionQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCatalogueAuditUrl = () => {




  return `/api/catalogue-intelligence/audit`
}

export const listCatalogueAudit = async ( options?: RequestInit): Promise<CatalogueAuditPage> => {

  return customFetch<CatalogueAuditPage>(getListCatalogueAuditUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCatalogueAuditQueryKey = () => {
    return [
    `/api/catalogue-intelligence/audit`
    ] as const;
    }


export const getListCatalogueAuditQueryOptions = <TData = Awaited<ReturnType<typeof listCatalogueAudit>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCatalogueAudit>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCatalogueAuditQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCatalogueAudit>>> = ({ signal }) => listCatalogueAudit({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCatalogueAudit>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCatalogueAuditQueryResult = NonNullable<Awaited<ReturnType<typeof listCatalogueAudit>>>
export type ListCatalogueAuditQueryError = ErrorType<unknown>



export function useListCatalogueAudit<TData = Awaited<ReturnType<typeof listCatalogueAudit>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCatalogueAudit>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCatalogueAuditQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCatalogueIntelligenceSettingsUrl = () => {




  return `/api/catalogue-intelligence/settings`
}

export const getCatalogueIntelligenceSettings = async ( options?: RequestInit): Promise<CatalogueSettings> => {

  return customFetch<CatalogueSettings>(getGetCatalogueIntelligenceSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCatalogueIntelligenceSettingsQueryKey = () => {
    return [
    `/api/catalogue-intelligence/settings`
    ] as const;
    }


export const getGetCatalogueIntelligenceSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getCatalogueIntelligenceSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCatalogueIntelligenceSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCatalogueIntelligenceSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCatalogueIntelligenceSettings>>> = ({ signal }) => getCatalogueIntelligenceSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCatalogueIntelligenceSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCatalogueIntelligenceSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getCatalogueIntelligenceSettings>>>
export type GetCatalogueIntelligenceSettingsQueryError = ErrorType<unknown>



export function useGetCatalogueIntelligenceSettings<TData = Awaited<ReturnType<typeof getCatalogueIntelligenceSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCatalogueIntelligenceSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCatalogueIntelligenceSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateCatalogueIntelligenceSettingsUrl = () => {




  return `/api/catalogue-intelligence/settings`
}

export const updateCatalogueIntelligenceSettings = async (catalogueSettingsInput: CatalogueSettingsInput, options?: RequestInit): Promise<CatalogueSettings> => {

  return customFetch<CatalogueSettings>(getUpdateCatalogueIntelligenceSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(catalogueSettingsInput)
  }
);}





export const getUpdateCatalogueIntelligenceSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCatalogueIntelligenceSettings>>, TError,{data: BodyType<CatalogueSettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCatalogueIntelligenceSettings>>, TError,{data: BodyType<CatalogueSettingsInput>}, TContext> => {

const mutationKey = ['updateCatalogueIntelligenceSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCatalogueIntelligenceSettings>>, {data: BodyType<CatalogueSettingsInput>}> = (props) => {
          const {data} = props ?? {};

          return  updateCatalogueIntelligenceSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCatalogueIntelligenceSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateCatalogueIntelligenceSettings>>>
    export type UpdateCatalogueIntelligenceSettingsMutationBody = BodyType<CatalogueSettingsInput>
    export type UpdateCatalogueIntelligenceSettingsMutationError = ErrorType<unknown>

    export const useUpdateCatalogueIntelligenceSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCatalogueIntelligenceSettings>>, TError,{data: BodyType<CatalogueSettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCatalogueIntelligenceSettings>>,
        TError,
        {data: BodyType<CatalogueSettingsInput>},
        TContext
      > => {
      return useMutation(getUpdateCatalogueIntelligenceSettingsMutationOptions(options));
    }

export const getLockCatalogueFieldUrl = (id: string,) => {




  return `/api/catalogue-intelligence/locks/${id}`
}

export const lockCatalogueField = async (id: string, options?: RequestInit): Promise<CatalogueLockAction> => {

  return customFetch<CatalogueLockAction>(getLockCatalogueFieldUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getLockCatalogueFieldMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lockCatalogueField>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof lockCatalogueField>>, TError,{id: string}, TContext> => {

const mutationKey = ['lockCatalogueField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lockCatalogueField>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  lockCatalogueField(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LockCatalogueFieldMutationResult = NonNullable<Awaited<ReturnType<typeof lockCatalogueField>>>

    export type LockCatalogueFieldMutationError = ErrorType<unknown>

    export const useLockCatalogueField = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lockCatalogueField>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof lockCatalogueField>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getLockCatalogueFieldMutationOptions(options));
    }

export const getUnlockCatalogueFieldUrl = (id: string,) => {




  return `/api/catalogue-intelligence/locks/${id}`
}

export const unlockCatalogueField = async (id: string, options?: RequestInit): Promise<CatalogueLockAction> => {

  return customFetch<CatalogueLockAction>(getUnlockCatalogueFieldUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUnlockCatalogueFieldMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlockCatalogueField>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unlockCatalogueField>>, TError,{id: string}, TContext> => {

const mutationKey = ['unlockCatalogueField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlockCatalogueField>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  unlockCatalogueField(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnlockCatalogueFieldMutationResult = NonNullable<Awaited<ReturnType<typeof unlockCatalogueField>>>

    export type UnlockCatalogueFieldMutationError = ErrorType<unknown>

    export const useUnlockCatalogueField = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlockCatalogueField>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof unlockCatalogueField>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getUnlockCatalogueFieldMutationOptions(options));
    }

export const getCreateCatalogueFieldLockUrl = () => {




  return `/api/catalogue-intelligence/locks`
}

export const createCatalogueFieldLock = async (catalogueLockInput: CatalogueLockInput, options?: RequestInit): Promise<CatalogueLockAction> => {

  return customFetch<CatalogueLockAction>(getCreateCatalogueFieldLockUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(catalogueLockInput)
  }
);}





export const getCreateCatalogueFieldLockMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCatalogueFieldLock>>, TError,{data: BodyType<CatalogueLockInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCatalogueFieldLock>>, TError,{data: BodyType<CatalogueLockInput>}, TContext> => {

const mutationKey = ['createCatalogueFieldLock'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCatalogueFieldLock>>, {data: BodyType<CatalogueLockInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCatalogueFieldLock(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCatalogueFieldLockMutationResult = NonNullable<Awaited<ReturnType<typeof createCatalogueFieldLock>>>
    export type CreateCatalogueFieldLockMutationBody = BodyType<CatalogueLockInput>
    export type CreateCatalogueFieldLockMutationError = ErrorType<void>

    export const useCreateCatalogueFieldLock = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCatalogueFieldLock>>, TError,{data: BodyType<CatalogueLockInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCatalogueFieldLock>>,
        TError,
        {data: BodyType<CatalogueLockInput>},
        TContext
      > => {
      return useMutation(getCreateCatalogueFieldLockMutationOptions(options));
    }

export const getBulkReviewCatalogueSuggestionsUrl = () => {




  return `/api/catalogue-intelligence/review/bulk`
}

export const bulkReviewCatalogueSuggestions = async (catalogueBulkReviewInput: CatalogueBulkReviewInput, options?: RequestInit): Promise<CatalogueBulkReviewResult> => {

  return customFetch<CatalogueBulkReviewResult>(getBulkReviewCatalogueSuggestionsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(catalogueBulkReviewInput)
  }
);}





export const getBulkReviewCatalogueSuggestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkReviewCatalogueSuggestions>>, TError,{data: BodyType<CatalogueBulkReviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkReviewCatalogueSuggestions>>, TError,{data: BodyType<CatalogueBulkReviewInput>}, TContext> => {

const mutationKey = ['bulkReviewCatalogueSuggestions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkReviewCatalogueSuggestions>>, {data: BodyType<CatalogueBulkReviewInput>}> = (props) => {
          const {data} = props ?? {};

          return  bulkReviewCatalogueSuggestions(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkReviewCatalogueSuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkReviewCatalogueSuggestions>>>
    export type BulkReviewCatalogueSuggestionsMutationBody = BodyType<CatalogueBulkReviewInput>
    export type BulkReviewCatalogueSuggestionsMutationError = ErrorType<unknown>

    export const useBulkReviewCatalogueSuggestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkReviewCatalogueSuggestions>>, TError,{data: BodyType<CatalogueBulkReviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkReviewCatalogueSuggestions>>,
        TError,
        {data: BodyType<CatalogueBulkReviewInput>},
        TContext
      > => {
      return useMutation(getBulkReviewCatalogueSuggestionsMutationOptions(options));
    }

export const getAcceptCatalogueSuggestionUrl = (id: string,) => {




  return `/api/catalogue-intelligence/review/${id}/accept`
}

export const acceptCatalogueSuggestion = async (id: string,
    catalogueReviewInput: CatalogueReviewInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getAcceptCatalogueSuggestionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(catalogueReviewInput)
  }
);}





export const getAcceptCatalogueSuggestionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptCatalogueSuggestion>>, TError,{id: string;data: BodyType<CatalogueReviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptCatalogueSuggestion>>, TError,{id: string;data: BodyType<CatalogueReviewInput>}, TContext> => {

const mutationKey = ['acceptCatalogueSuggestion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptCatalogueSuggestion>>, {id: string;data: BodyType<CatalogueReviewInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  acceptCatalogueSuggestion(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptCatalogueSuggestionMutationResult = NonNullable<Awaited<ReturnType<typeof acceptCatalogueSuggestion>>>
    export type AcceptCatalogueSuggestionMutationBody = BodyType<CatalogueReviewInput>
    export type AcceptCatalogueSuggestionMutationError = ErrorType<void>

    export const useAcceptCatalogueSuggestion = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptCatalogueSuggestion>>, TError,{id: string;data: BodyType<CatalogueReviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof acceptCatalogueSuggestion>>,
        TError,
        {id: string;data: BodyType<CatalogueReviewInput>},
        TContext
      > => {
      return useMutation(getAcceptCatalogueSuggestionMutationOptions(options));
    }

export const getRejectCatalogueSuggestionUrl = (id: string,) => {




  return `/api/catalogue-intelligence/review/${id}/reject`
}

export const rejectCatalogueSuggestion = async (id: string,
    catalogueReviewInput: CatalogueReviewInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getRejectCatalogueSuggestionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(catalogueReviewInput)
  }
);}





export const getRejectCatalogueSuggestionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectCatalogueSuggestion>>, TError,{id: string;data: BodyType<CatalogueReviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectCatalogueSuggestion>>, TError,{id: string;data: BodyType<CatalogueReviewInput>}, TContext> => {

const mutationKey = ['rejectCatalogueSuggestion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectCatalogueSuggestion>>, {id: string;data: BodyType<CatalogueReviewInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  rejectCatalogueSuggestion(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectCatalogueSuggestionMutationResult = NonNullable<Awaited<ReturnType<typeof rejectCatalogueSuggestion>>>
    export type RejectCatalogueSuggestionMutationBody = BodyType<CatalogueReviewInput>
    export type RejectCatalogueSuggestionMutationError = ErrorType<void>

    export const useRejectCatalogueSuggestion = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectCatalogueSuggestion>>, TError,{id: string;data: BodyType<CatalogueReviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rejectCatalogueSuggestion>>,
        TError,
        {id: string;data: BodyType<CatalogueReviewInput>},
        TContext
      > => {
      return useMutation(getRejectCatalogueSuggestionMutationOptions(options));
    }

export const getRecheckCatalogueSuggestionUrl = (id: string,) => {




  return `/api/catalogue-intelligence/review/${id}/recheck`
}

export const recheckCatalogueSuggestion = async (id: string,
    catalogueRecheckInput?: CatalogueRecheckInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getRecheckCatalogueSuggestionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(catalogueRecheckInput)
  }
);}





export const getRecheckCatalogueSuggestionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recheckCatalogueSuggestion>>, TError,{id: string;data?: BodyType<CatalogueRecheckInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recheckCatalogueSuggestion>>, TError,{id: string;data?: BodyType<CatalogueRecheckInput>}, TContext> => {

const mutationKey = ['recheckCatalogueSuggestion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recheckCatalogueSuggestion>>, {id: string;data?: BodyType<CatalogueRecheckInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  recheckCatalogueSuggestion(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecheckCatalogueSuggestionMutationResult = NonNullable<Awaited<ReturnType<typeof recheckCatalogueSuggestion>>>
    export type RecheckCatalogueSuggestionMutationBody = BodyType<CatalogueRecheckInput> | undefined
    export type RecheckCatalogueSuggestionMutationError = ErrorType<unknown>

    export const useRecheckCatalogueSuggestion = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recheckCatalogueSuggestion>>, TError,{id: string;data?: BodyType<CatalogueRecheckInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recheckCatalogueSuggestion>>,
        TError,
        {id: string;data?: BodyType<CatalogueRecheckInput>},
        TContext
      > => {
      return useMutation(getRecheckCatalogueSuggestionMutationOptions(options));
    }

export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSubmitWholesaleApplicationUrl = () => {




  return `/api/commerce/portal/trade/applications`
}

/**
 * @summary Submit a public wholesale application for staff review
 */
export const submitWholesaleApplication = async (wholesaleApplicationInput: WholesaleApplicationInput, options?: RequestInit): Promise<WholesaleApplicationReceipt> => {

  return customFetch<WholesaleApplicationReceipt>(getSubmitWholesaleApplicationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(wholesaleApplicationInput)
  }
);}





export const getSubmitWholesaleApplicationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitWholesaleApplication>>, TError,{data: BodyType<WholesaleApplicationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitWholesaleApplication>>, TError,{data: BodyType<WholesaleApplicationInput>}, TContext> => {

const mutationKey = ['submitWholesaleApplication'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitWholesaleApplication>>, {data: BodyType<WholesaleApplicationInput>}> = (props) => {
          const {data} = props ?? {};

          return  submitWholesaleApplication(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitWholesaleApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof submitWholesaleApplication>>>
    export type SubmitWholesaleApplicationMutationBody = BodyType<WholesaleApplicationInput>
    export type SubmitWholesaleApplicationMutationError = ErrorType<void>

    /**
 * @summary Submit a public wholesale application for staff review
 */
export const useSubmitWholesaleApplication = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitWholesaleApplication>>, TError,{data: BodyType<WholesaleApplicationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitWholesaleApplication>>,
        TError,
        {data: BodyType<WholesaleApplicationInput>},
        TContext
      > => {
      return useMutation(getSubmitWholesaleApplicationMutationOptions(options));
    }

export const getGetDashboardSummaryUrl = () => {




  return `/api/dashboard/summary`
}

/**
 * @summary Aggregate metrics for the homepage
 */
export const getDashboardSummary = async ( options?: RequestInit): Promise<DashboardSummary> => {

  return customFetch<DashboardSummary>(getGetDashboardSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDashboardSummaryQueryKey = () => {
    return [
    `/api/dashboard/summary`
    ] as const;
    }


export const getGetDashboardSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardSummary>>> = ({ signal }) => getDashboardSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardSummary>>>
export type GetDashboardSummaryQueryError = ErrorType<unknown>


/**
 * @summary Aggregate metrics for the homepage
 */

export function useGetDashboardSummary<TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDashboardSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMobileDashboardSecondaryUrl = (params?: GetMobileDashboardSecondaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/mobile-secondary?${stringifiedParams}` : `/api/dashboard/mobile-secondary`
}

/**
 * @summary Bounded permission-aware secondary data for the phone dashboard
 */
export const getMobileDashboardSecondary = async (params?: GetMobileDashboardSecondaryParams, options?: RequestInit): Promise<MobileDashboardSecondary> => {

  return customFetch<MobileDashboardSecondary>(getGetMobileDashboardSecondaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMobileDashboardSecondaryQueryKey = (params?: GetMobileDashboardSecondaryParams,) => {
    return [
    `/api/dashboard/mobile-secondary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMobileDashboardSecondaryQueryOptions = <TData = Awaited<ReturnType<typeof getMobileDashboardSecondary>>, TError = ErrorType<unknown>>(params?: GetMobileDashboardSecondaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMobileDashboardSecondary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMobileDashboardSecondaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMobileDashboardSecondary>>> = ({ signal }) => getMobileDashboardSecondary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMobileDashboardSecondary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMobileDashboardSecondaryQueryResult = NonNullable<Awaited<ReturnType<typeof getMobileDashboardSecondary>>>
export type GetMobileDashboardSecondaryQueryError = ErrorType<unknown>


/**
 * @summary Bounded permission-aware secondary data for the phone dashboard
 */

export function useGetMobileDashboardSecondary<TData = Awaited<ReturnType<typeof getMobileDashboardSecondary>>, TError = ErrorType<unknown>>(
 params?: GetMobileDashboardSecondaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMobileDashboardSecondary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMobileDashboardSecondaryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetVatDueSummaryUrl = (params?: GetVatDueSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/vat-due/summary?${stringifiedParams}` : `/api/vat-due/summary`
}

/**
 * @summary Get output VAT due from the immutable sales recognition ledger
 */
export const getVatDueSummary = async (params?: GetVatDueSummaryParams, options?: RequestInit): Promise<VatDueSummary> => {

  return customFetch<VatDueSummary>(getGetVatDueSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetVatDueSummaryQueryKey = (params?: GetVatDueSummaryParams,) => {
    return [
    `/api/vat-due/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetVatDueSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getVatDueSummary>>, TError = ErrorType<void>>(params?: GetVatDueSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVatDueSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVatDueSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVatDueSummary>>> = ({ signal }) => getVatDueSummary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVatDueSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVatDueSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getVatDueSummary>>>
export type GetVatDueSummaryQueryError = ErrorType<void>


/**
 * @summary Get output VAT due from the immutable sales recognition ledger
 */

export function useGetVatDueSummary<TData = Awaited<ReturnType<typeof getVatDueSummary>>, TError = ErrorType<void>>(
 params?: GetVatDueSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVatDueSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVatDueSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetVatPlanningSettingsUrl = () => {




  return `/api/settings/vat-planning`
}

/**
 * @summary Read tenant VAT Planning Mode
 */
export const getVatPlanningSettings = async ( options?: RequestInit): Promise<VatPlanningSettings> => {

  return customFetch<VatPlanningSettings>(getGetVatPlanningSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetVatPlanningSettingsQueryKey = () => {
    return [
    `/api/settings/vat-planning`
    ] as const;
    }


export const getGetVatPlanningSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getVatPlanningSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVatPlanningSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVatPlanningSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVatPlanningSettings>>> = ({ signal }) => getVatPlanningSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVatPlanningSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVatPlanningSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getVatPlanningSettings>>>
export type GetVatPlanningSettingsQueryError = ErrorType<unknown>


/**
 * @summary Read tenant VAT Planning Mode
 */

export function useGetVatPlanningSettings<TData = Awaited<ReturnType<typeof getVatPlanningSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVatPlanningSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVatPlanningSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateVatPlanningSettingsUrl = () => {




  return `/api/settings/vat-planning`
}

/**
 * @summary Enable or disable internal VAT Planning Mode
 */
export const updateVatPlanningSettings = async (updateVatPlanningSettingsBody: UpdateVatPlanningSettingsBody, options?: RequestInit): Promise<VatPlanningSettings> => {

  return customFetch<VatPlanningSettings>(getUpdateVatPlanningSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateVatPlanningSettingsBody)
  }
);}





export const getUpdateVatPlanningSettingsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVatPlanningSettings>>, TError,{data: BodyType<UpdateVatPlanningSettingsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateVatPlanningSettings>>, TError,{data: BodyType<UpdateVatPlanningSettingsBody>}, TContext> => {

const mutationKey = ['updateVatPlanningSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVatPlanningSettings>>, {data: BodyType<UpdateVatPlanningSettingsBody>}> = (props) => {
          const {data} = props ?? {};

          return  updateVatPlanningSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateVatPlanningSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateVatPlanningSettings>>>
    export type UpdateVatPlanningSettingsMutationBody = BodyType<UpdateVatPlanningSettingsBody>
    export type UpdateVatPlanningSettingsMutationError = ErrorType<void>

    /**
 * @summary Enable or disable internal VAT Planning Mode
 */
export const useUpdateVatPlanningSettings = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVatPlanningSettings>>, TError,{data: BodyType<UpdateVatPlanningSettingsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateVatPlanningSettings>>,
        TError,
        {data: BodyType<UpdateVatPlanningSettingsBody>},
        TContext
      > => {
      return useMutation(getUpdateVatPlanningSettingsMutationOptions(options));
    }

export const getRunVatPlanningCatchUpUrl = () => {




  return `/api/vat-due/planning-catch-up`
}

/**
 * @summary Process one bounded batch from a fixed-end VAT planning job
 */
export const runVatPlanningCatchUp = async (runVatPlanningCatchUpBody?: RunVatPlanningCatchUpBody, options?: RequestInit): Promise<VatPlanningCatchUpResult> => {

  return customFetch<VatPlanningCatchUpResult>(getRunVatPlanningCatchUpUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(runVatPlanningCatchUpBody)
  }
);}





export const getRunVatPlanningCatchUpMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runVatPlanningCatchUp>>, TError,{data?: BodyType<RunVatPlanningCatchUpBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof runVatPlanningCatchUp>>, TError,{data?: BodyType<RunVatPlanningCatchUpBody>}, TContext> => {

const mutationKey = ['runVatPlanningCatchUp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runVatPlanningCatchUp>>, {data?: BodyType<RunVatPlanningCatchUpBody>}> = (props) => {
          const {data} = props ?? {};

          return  runVatPlanningCatchUp(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunVatPlanningCatchUpMutationResult = NonNullable<Awaited<ReturnType<typeof runVatPlanningCatchUp>>>
    export type RunVatPlanningCatchUpMutationBody = BodyType<RunVatPlanningCatchUpBody> | undefined
    export type RunVatPlanningCatchUpMutationError = ErrorType<void>

    /**
 * @summary Process one bounded batch from a fixed-end VAT planning job
 */
export const useRunVatPlanningCatchUp = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runVatPlanningCatchUp>>, TError,{data?: BodyType<RunVatPlanningCatchUpBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof runVatPlanningCatchUp>>,
        TError,
        {data?: BodyType<RunVatPlanningCatchUpBody>},
        TContext
      > => {
      return useMutation(getRunVatPlanningCatchUpMutationOptions(options));
    }

export const getListVatDueEntriesUrl = (params?: ListVatDueEntriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/vat-due/entries?${stringifiedParams}` : `/api/vat-due/entries`
}

/**
 * @summary Paginated effective VAT allocation results
 */
export const listVatDueEntries = async (params?: ListVatDueEntriesParams, options?: RequestInit): Promise<VatDueEntryPage> => {

  return customFetch<VatDueEntryPage>(getListVatDueEntriesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListVatDueEntriesQueryKey = (params?: ListVatDueEntriesParams,) => {
    return [
    `/api/vat-due/entries`, ...(params ? [params] : [])
    ] as const;
    }


export const getListVatDueEntriesQueryOptions = <TData = Awaited<ReturnType<typeof listVatDueEntries>>, TError = ErrorType<unknown>>(params?: ListVatDueEntriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVatDueEntries>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVatDueEntriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVatDueEntries>>> = ({ signal }) => listVatDueEntries(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVatDueEntries>>, TError, TData> & { queryKey: QueryKey }
}

export type ListVatDueEntriesQueryResult = NonNullable<Awaited<ReturnType<typeof listVatDueEntries>>>
export type ListVatDueEntriesQueryError = ErrorType<unknown>


/**
 * @summary Paginated effective VAT allocation results
 */

export function useListVatDueEntries<TData = Awaited<ReturnType<typeof listVatDueEntries>>, TError = ErrorType<unknown>>(
 params?: ListVatDueEntriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVatDueEntries>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListVatDueEntriesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetVatDueEntryUrl = (id: string,) => {




  return `/api/vat-due/entries/${id}`
}

/**
 * @summary Get immutable VAT allocation lineage detail
 */
export const getVatDueEntry = async (id: string, options?: RequestInit): Promise<VatDueEntryDetail> => {

  return customFetch<VatDueEntryDetail>(getGetVatDueEntryUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetVatDueEntryQueryKey = (id: string,) => {
    return [
    `/api/vat-due/entries/${id}`
    ] as const;
    }


export const getGetVatDueEntryQueryOptions = <TData = Awaited<ReturnType<typeof getVatDueEntry>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVatDueEntry>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVatDueEntryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVatDueEntry>>> = ({ signal }) => getVatDueEntry(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVatDueEntry>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVatDueEntryQueryResult = NonNullable<Awaited<ReturnType<typeof getVatDueEntry>>>
export type GetVatDueEntryQueryError = ErrorType<void>


/**
 * @summary Get immutable VAT allocation lineage detail
 */

export function useGetVatDueEntry<TData = Awaited<ReturnType<typeof getVatDueEntry>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVatDueEntry>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVatDueEntryQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListInventoryLotsVatReviewUrl = (params?: ListInventoryLotsVatReviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/lots/vat-review?${stringifiedParams}` : `/api/inventory/lots/vat-review`
}

/**
 * @summary List positive-stock inventory lots requiring VAT treatment review
 */
export const listInventoryLotsVatReview = async (params?: ListInventoryLotsVatReviewParams, options?: RequestInit): Promise<InventoryLotVatReviewPage> => {

  return customFetch<InventoryLotVatReviewPage>(getListInventoryLotsVatReviewUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInventoryLotsVatReviewQueryKey = (params?: ListInventoryLotsVatReviewParams,) => {
    return [
    `/api/inventory/lots/vat-review`, ...(params ? [params] : [])
    ] as const;
    }


export const getListInventoryLotsVatReviewQueryOptions = <TData = Awaited<ReturnType<typeof listInventoryLotsVatReview>>, TError = ErrorType<void>>(params?: ListInventoryLotsVatReviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventoryLotsVatReview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInventoryLotsVatReviewQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInventoryLotsVatReview>>> = ({ signal }) => listInventoryLotsVatReview(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInventoryLotsVatReview>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInventoryLotsVatReviewQueryResult = NonNullable<Awaited<ReturnType<typeof listInventoryLotsVatReview>>>
export type ListInventoryLotsVatReviewQueryError = ErrorType<void>


/**
 * @summary List positive-stock inventory lots requiring VAT treatment review
 */

export function useListInventoryLotsVatReview<TData = Awaited<ReturnType<typeof listInventoryLotsVatReview>>, TError = ErrorType<void>>(
 params?: ListInventoryLotsVatReviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventoryLotsVatReview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInventoryLotsVatReviewQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getClassifyInventoryLotVatUrl = (lotId: string,) => {




  return `/api/inventory/lots/${lotId}/vat-classification`
}

/**
 * @summary Manually classify an inventory lot for VAT planning
 */
export const classifyInventoryLotVat = async (lotId: string,
    inventoryLotVatClassificationInput: InventoryLotVatClassificationInput, options?: RequestInit): Promise<InventoryLotVatClassification> => {

  return customFetch<InventoryLotVatClassification>(getClassifyInventoryLotVatUrl(lotId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryLotVatClassificationInput)
  }
);}





export const getClassifyInventoryLotVatMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classifyInventoryLotVat>>, TError,{lotId: string;data: BodyType<InventoryLotVatClassificationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof classifyInventoryLotVat>>, TError,{lotId: string;data: BodyType<InventoryLotVatClassificationInput>}, TContext> => {

const mutationKey = ['classifyInventoryLotVat'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof classifyInventoryLotVat>>, {lotId: string;data: BodyType<InventoryLotVatClassificationInput>}> = (props) => {
          const {lotId,data} = props ?? {};

          return  classifyInventoryLotVat(lotId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClassifyInventoryLotVatMutationResult = NonNullable<Awaited<ReturnType<typeof classifyInventoryLotVat>>>
    export type ClassifyInventoryLotVatMutationBody = BodyType<InventoryLotVatClassificationInput>
    export type ClassifyInventoryLotVatMutationError = ErrorType<void>

    /**
 * @summary Manually classify an inventory lot for VAT planning
 */
export const useClassifyInventoryLotVat = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classifyInventoryLotVat>>, TError,{lotId: string;data: BodyType<InventoryLotVatClassificationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof classifyInventoryLotVat>>,
        TError,
        {lotId: string;data: BodyType<InventoryLotVatClassificationInput>},
        TContext
      > => {
      return useMutation(getClassifyInventoryLotVatMutationOptions(options));
    }

export const getBulkClassifyInventoryLotsVatUrl = () => {




  return `/api/inventory/lots/vat-classification/bulk`
}

/**
 * @summary Apply one VAT treatment to multiple inventory lots
 */
export const bulkClassifyInventoryLotsVat = async (inventoryLotVatBulkClassificationInput: InventoryLotVatBulkClassificationInput, options?: RequestInit): Promise<InventoryLotVatBulkClassificationResult> => {

  return customFetch<InventoryLotVatBulkClassificationResult>(getBulkClassifyInventoryLotsVatUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryLotVatBulkClassificationInput)
  }
);}





export const getBulkClassifyInventoryLotsVatMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkClassifyInventoryLotsVat>>, TError,{data: BodyType<InventoryLotVatBulkClassificationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkClassifyInventoryLotsVat>>, TError,{data: BodyType<InventoryLotVatBulkClassificationInput>}, TContext> => {

const mutationKey = ['bulkClassifyInventoryLotsVat'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkClassifyInventoryLotsVat>>, {data: BodyType<InventoryLotVatBulkClassificationInput>}> = (props) => {
          const {data} = props ?? {};

          return  bulkClassifyInventoryLotsVat(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkClassifyInventoryLotsVatMutationResult = NonNullable<Awaited<ReturnType<typeof bulkClassifyInventoryLotsVat>>>
    export type BulkClassifyInventoryLotsVatMutationBody = BodyType<InventoryLotVatBulkClassificationInput>
    export type BulkClassifyInventoryLotsVatMutationError = ErrorType<void>

    /**
 * @summary Apply one VAT treatment to multiple inventory lots
 */
export const useBulkClassifyInventoryLotsVat = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkClassifyInventoryLotsVat>>, TError,{data: BodyType<InventoryLotVatBulkClassificationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkClassifyInventoryLotsVat>>,
        TError,
        {data: BodyType<InventoryLotVatBulkClassificationInput>},
        TContext
      > => {
      return useMutation(getBulkClassifyInventoryLotsVatMutationOptions(options));
    }

export const getGetCustomerPortfolioFoundationUrl = () => {




  return `/api/customer-portfolios/foundation`
}

/**
 * @summary Get the canonical customer-portfolio domain vocabulary
 */
export const getCustomerPortfolioFoundation = async ( options?: RequestInit): Promise<CustomerPortfolioFoundation> => {

  return customFetch<CustomerPortfolioFoundation>(getGetCustomerPortfolioFoundationUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomerPortfolioFoundationQueryKey = () => {
    return [
    `/api/customer-portfolios/foundation`
    ] as const;
    }


export const getGetCustomerPortfolioFoundationQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerPortfolioFoundation>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerPortfolioFoundation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerPortfolioFoundationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerPortfolioFoundation>>> = ({ signal }) => getCustomerPortfolioFoundation({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerPortfolioFoundation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerPortfolioFoundationQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerPortfolioFoundation>>>
export type GetCustomerPortfolioFoundationQueryError = ErrorType<unknown>


/**
 * @summary Get the canonical customer-portfolio domain vocabulary
 */

export function useGetCustomerPortfolioFoundation<TData = Awaited<ReturnType<typeof getCustomerPortfolioFoundation>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerPortfolioFoundation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCustomerPortfolioFoundationQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCustomerPortfolioPortalConfigUrl = () => {




  return `/api/customer-portal/portfolio-utility/config`
}

/**
 * @summary Get the customer-facing Portfolio disclaimer
 */
export const getCustomerPortfolioPortalConfig = async ( options?: RequestInit): Promise<CustomerPortfolioPortalConfig> => {

  return customFetch<CustomerPortfolioPortalConfig>(getGetCustomerPortfolioPortalConfigUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomerPortfolioPortalConfigQueryKey = () => {
    return [
    `/api/customer-portal/portfolio-utility/config`
    ] as const;
    }


export const getGetCustomerPortfolioPortalConfigQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerPortfolioPortalConfig>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerPortfolioPortalConfig>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerPortfolioPortalConfigQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerPortfolioPortalConfig>>> = ({ signal }) => getCustomerPortfolioPortalConfig({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerPortfolioPortalConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerPortfolioPortalConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerPortfolioPortalConfig>>>
export type GetCustomerPortfolioPortalConfigQueryError = ErrorType<unknown>


/**
 * @summary Get the customer-facing Portfolio disclaimer
 */

export function useGetCustomerPortfolioPortalConfig<TData = Awaited<ReturnType<typeof getCustomerPortfolioPortalConfig>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerPortfolioPortalConfig>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCustomerPortfolioPortalConfigQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCustomerPortfolioSettingsUrl = () => {




  return `/api/customer-portfolios/settings`
}

/**
 * @summary Get tenant customer-portfolio settings
 */
export const getCustomerPortfolioSettings = async ( options?: RequestInit): Promise<GetCustomerPortfolioSettings200> => {

  return customFetch<GetCustomerPortfolioSettings200>(getGetCustomerPortfolioSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomerPortfolioSettingsQueryKey = () => {
    return [
    `/api/customer-portfolios/settings`
    ] as const;
    }


export const getGetCustomerPortfolioSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerPortfolioSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerPortfolioSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerPortfolioSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerPortfolioSettings>>> = ({ signal }) => getCustomerPortfolioSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerPortfolioSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerPortfolioSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerPortfolioSettings>>>
export type GetCustomerPortfolioSettingsQueryError = ErrorType<unknown>


/**
 * @summary Get tenant customer-portfolio settings
 */

export function useGetCustomerPortfolioSettings<TData = Awaited<ReturnType<typeof getCustomerPortfolioSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerPortfolioSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCustomerPortfolioSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateCustomerPortfolioSettingsUrl = () => {




  return `/api/customer-portfolios/settings`
}

/**
 * @summary Update tenant customer-portfolio settings
 */
export const updateCustomerPortfolioSettings = async (customerPortfolioSettingsInput: CustomerPortfolioSettingsInput, options?: RequestInit): Promise<UpdateCustomerPortfolioSettings200> => {

  return customFetch<UpdateCustomerPortfolioSettings200>(getUpdateCustomerPortfolioSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerPortfolioSettingsInput)
  }
);}





export const getUpdateCustomerPortfolioSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomerPortfolioSettings>>, TError,{data: BodyType<CustomerPortfolioSettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCustomerPortfolioSettings>>, TError,{data: BodyType<CustomerPortfolioSettingsInput>}, TContext> => {

const mutationKey = ['updateCustomerPortfolioSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCustomerPortfolioSettings>>, {data: BodyType<CustomerPortfolioSettingsInput>}> = (props) => {
          const {data} = props ?? {};

          return  updateCustomerPortfolioSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCustomerPortfolioSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateCustomerPortfolioSettings>>>
    export type UpdateCustomerPortfolioSettingsMutationBody = BodyType<CustomerPortfolioSettingsInput>
    export type UpdateCustomerPortfolioSettingsMutationError = ErrorType<unknown>

    /**
 * @summary Update tenant customer-portfolio settings
 */
export const useUpdateCustomerPortfolioSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomerPortfolioSettings>>, TError,{data: BodyType<CustomerPortfolioSettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCustomerPortfolioSettings>>,
        TError,
        {data: BodyType<CustomerPortfolioSettingsInput>},
        TContext
      > => {
      return useMutation(getUpdateCustomerPortfolioSettingsMutationOptions(options));
    }

export const getListCustomerPortfolioProductsUrl = (params?: ListCustomerPortfolioProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/customer-portfolios/products?${stringifiedParams}` : `/api/customer-portfolios/products`
}

/**
 * @summary Search the visible bullion product catalogue
 */
export const listCustomerPortfolioProducts = async (params?: ListCustomerPortfolioProductsParams, options?: RequestInit): Promise<ListCustomerPortfolioProducts200> => {

  return customFetch<ListCustomerPortfolioProducts200>(getListCustomerPortfolioProductsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomerPortfolioProductsQueryKey = (params?: ListCustomerPortfolioProductsParams,) => {
    return [
    `/api/customer-portfolios/products`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCustomerPortfolioProductsQueryOptions = <TData = Awaited<ReturnType<typeof listCustomerPortfolioProducts>>, TError = ErrorType<unknown>>(params?: ListCustomerPortfolioProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerPortfolioProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomerPortfolioProductsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomerPortfolioProducts>>> = ({ signal }) => listCustomerPortfolioProducts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomerPortfolioProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCustomerPortfolioProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomerPortfolioProducts>>>
export type ListCustomerPortfolioProductsQueryError = ErrorType<unknown>


/**
 * @summary Search the visible bullion product catalogue
 */

export function useListCustomerPortfolioProducts<TData = Awaited<ReturnType<typeof listCustomerPortfolioProducts>>, TError = ErrorType<unknown>>(
 params?: ListCustomerPortfolioProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerPortfolioProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCustomerPortfolioProductsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCustomerPortfolioProductUrl = () => {




  return `/api/customer-portfolios/products`
}

/**
 * @summary Create a tenant-owned catalogue product
 */
export const createCustomerPortfolioProduct = async (portfolioProductInput: PortfolioProductInput, options?: RequestInit): Promise<CreateCustomerPortfolioProduct201> => {

  return customFetch<CreateCustomerPortfolioProduct201>(getCreateCustomerPortfolioProductUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(portfolioProductInput)
  }
);}





export const getCreateCustomerPortfolioProductMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomerPortfolioProduct>>, TError,{data: BodyType<PortfolioProductInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCustomerPortfolioProduct>>, TError,{data: BodyType<PortfolioProductInput>}, TContext> => {

const mutationKey = ['createCustomerPortfolioProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCustomerPortfolioProduct>>, {data: BodyType<PortfolioProductInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCustomerPortfolioProduct(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCustomerPortfolioProductMutationResult = NonNullable<Awaited<ReturnType<typeof createCustomerPortfolioProduct>>>
    export type CreateCustomerPortfolioProductMutationBody = BodyType<PortfolioProductInput>
    export type CreateCustomerPortfolioProductMutationError = ErrorType<unknown>

    /**
 * @summary Create a tenant-owned catalogue product
 */
export const useCreateCustomerPortfolioProduct = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomerPortfolioProduct>>, TError,{data: BodyType<PortfolioProductInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCustomerPortfolioProduct>>,
        TError,
        {data: BodyType<PortfolioProductInput>},
        TContext
      > => {
      return useMutation(getCreateCustomerPortfolioProductMutationOptions(options));
    }

export const getUpdateCustomerPortfolioProductUrl = (productId: string,) => {




  return `/api/customer-portfolios/products/${productId}`
}

/**
 * @summary Update a tenant-owned catalogue product
 */
export const updateCustomerPortfolioProduct = async (productId: string,
    portfolioProductUpdateInput: PortfolioProductUpdateInput, options?: RequestInit): Promise<UpdateCustomerPortfolioProduct200> => {

  return customFetch<UpdateCustomerPortfolioProduct200>(getUpdateCustomerPortfolioProductUrl(productId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(portfolioProductUpdateInput)
  }
);}





export const getUpdateCustomerPortfolioProductMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomerPortfolioProduct>>, TError,{productId: string;data: BodyType<PortfolioProductUpdateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCustomerPortfolioProduct>>, TError,{productId: string;data: BodyType<PortfolioProductUpdateInput>}, TContext> => {

const mutationKey = ['updateCustomerPortfolioProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCustomerPortfolioProduct>>, {productId: string;data: BodyType<PortfolioProductUpdateInput>}> = (props) => {
          const {productId,data} = props ?? {};

          return  updateCustomerPortfolioProduct(productId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCustomerPortfolioProductMutationResult = NonNullable<Awaited<ReturnType<typeof updateCustomerPortfolioProduct>>>
    export type UpdateCustomerPortfolioProductMutationBody = BodyType<PortfolioProductUpdateInput>
    export type UpdateCustomerPortfolioProductMutationError = ErrorType<unknown>

    /**
 * @summary Update a tenant-owned catalogue product
 */
export const useUpdateCustomerPortfolioProduct = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomerPortfolioProduct>>, TError,{productId: string;data: BodyType<PortfolioProductUpdateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCustomerPortfolioProduct>>,
        TError,
        {productId: string;data: BodyType<PortfolioProductUpdateInput>},
        TContext
      > => {
      return useMutation(getUpdateCustomerPortfolioProductMutationOptions(options));
    }

export const getDisableCustomerPortfolioProductUrl = (productId: string,) => {




  return `/api/customer-portfolios/products/${productId}/disable`
}

/**
 * @summary Disable a tenant-owned catalogue product
 */
export const disableCustomerPortfolioProduct = async (productId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDisableCustomerPortfolioProductUrl(productId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDisableCustomerPortfolioProductMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableCustomerPortfolioProduct>>, TError,{productId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disableCustomerPortfolioProduct>>, TError,{productId: string}, TContext> => {

const mutationKey = ['disableCustomerPortfolioProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableCustomerPortfolioProduct>>, {productId: string}> = (props) => {
          const {productId} = props ?? {};

          return  disableCustomerPortfolioProduct(productId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableCustomerPortfolioProductMutationResult = NonNullable<Awaited<ReturnType<typeof disableCustomerPortfolioProduct>>>

    export type DisableCustomerPortfolioProductMutationError = ErrorType<unknown>

    /**
 * @summary Disable a tenant-owned catalogue product
 */
export const useDisableCustomerPortfolioProduct = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableCustomerPortfolioProduct>>, TError,{productId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof disableCustomerPortfolioProduct>>,
        TError,
        {productId: string},
        TContext
      > => {
      return useMutation(getDisableCustomerPortfolioProductMutationOptions(options));
    }

export const getMapCustomerPortfolioProductUrl = (productId: string,) => {




  return `/api/customer-portfolios/products/${productId}/mapping`
}

/**
 * @summary Map a visible catalogue product to this tenant's inventory SKU
 */
export const mapCustomerPortfolioProduct = async (productId: string,
    portfolioProductMappingInput: PortfolioProductMappingInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getMapCustomerPortfolioProductUrl(productId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(portfolioProductMappingInput)
  }
);}





export const getMapCustomerPortfolioProductMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mapCustomerPortfolioProduct>>, TError,{productId: string;data: BodyType<PortfolioProductMappingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof mapCustomerPortfolioProduct>>, TError,{productId: string;data: BodyType<PortfolioProductMappingInput>}, TContext> => {

const mutationKey = ['mapCustomerPortfolioProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mapCustomerPortfolioProduct>>, {productId: string;data: BodyType<PortfolioProductMappingInput>}> = (props) => {
          const {productId,data} = props ?? {};

          return  mapCustomerPortfolioProduct(productId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MapCustomerPortfolioProductMutationResult = NonNullable<Awaited<ReturnType<typeof mapCustomerPortfolioProduct>>>
    export type MapCustomerPortfolioProductMutationBody = BodyType<PortfolioProductMappingInput>
    export type MapCustomerPortfolioProductMutationError = ErrorType<unknown>

    /**
 * @summary Map a visible catalogue product to this tenant's inventory SKU
 */
export const useMapCustomerPortfolioProduct = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mapCustomerPortfolioProduct>>, TError,{productId: string;data: BodyType<PortfolioProductMappingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof mapCustomerPortfolioProduct>>,
        TError,
        {productId: string;data: BodyType<PortfolioProductMappingInput>},
        TContext
      > => {
      return useMutation(getMapCustomerPortfolioProductMutationOptions(options));
    }

export const getListCustomerPortalPortfolioProductsUrl = (params?: ListCustomerPortalPortfolioProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/customer-portal/portfolios/products?${stringifiedParams}` : `/api/customer-portal/portfolios/products`
}

/**
 * @summary Search active bullion products for the signed-in customer
 */
export const listCustomerPortalPortfolioProducts = async (params?: ListCustomerPortalPortfolioProductsParams, options?: RequestInit): Promise<ListCustomerPortalPortfolioProducts200> => {

  return customFetch<ListCustomerPortalPortfolioProducts200>(getListCustomerPortalPortfolioProductsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomerPortalPortfolioProductsQueryKey = (params?: ListCustomerPortalPortfolioProductsParams,) => {
    return [
    `/api/customer-portal/portfolios/products`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCustomerPortalPortfolioProductsQueryOptions = <TData = Awaited<ReturnType<typeof listCustomerPortalPortfolioProducts>>, TError = ErrorType<unknown>>(params?: ListCustomerPortalPortfolioProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerPortalPortfolioProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomerPortalPortfolioProductsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomerPortalPortfolioProducts>>> = ({ signal }) => listCustomerPortalPortfolioProducts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomerPortalPortfolioProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCustomerPortalPortfolioProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomerPortalPortfolioProducts>>>
export type ListCustomerPortalPortfolioProductsQueryError = ErrorType<unknown>


/**
 * @summary Search active bullion products for the signed-in customer
 */

export function useListCustomerPortalPortfolioProducts<TData = Awaited<ReturnType<typeof listCustomerPortalPortfolioProducts>>, TError = ErrorType<unknown>>(
 params?: ListCustomerPortalPortfolioProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerPortalPortfolioProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCustomerPortalPortfolioProductsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCustomerPortalPortfolioTransactionsUrl = (portfolioId: string,
    params?: ListCustomerPortalPortfolioTransactionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/customer-portal/portfolios/${portfolioId}/transactions?${stringifiedParams}` : `/api/customer-portal/portfolios/${portfolioId}/transactions`
}

/**
 * @summary Search and paginate the signed-in customer's immutable portfolio ledger
 */
export const listCustomerPortalPortfolioTransactions = async (portfolioId: string,
    params?: ListCustomerPortalPortfolioTransactionsParams, options?: RequestInit): Promise<CustomerPortfolioTransactionPage> => {

  return customFetch<CustomerPortfolioTransactionPage>(getListCustomerPortalPortfolioTransactionsUrl(portfolioId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomerPortalPortfolioTransactionsQueryKey = (portfolioId: string,
    params?: ListCustomerPortalPortfolioTransactionsParams,) => {
    return [
    `/api/customer-portal/portfolios/${portfolioId}/transactions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCustomerPortalPortfolioTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof listCustomerPortalPortfolioTransactions>>, TError = ErrorType<unknown>>(portfolioId: string,
    params?: ListCustomerPortalPortfolioTransactionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerPortalPortfolioTransactions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomerPortalPortfolioTransactionsQueryKey(portfolioId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomerPortalPortfolioTransactions>>> = ({ signal }) => listCustomerPortalPortfolioTransactions(portfolioId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: portfolioId !== null && portfolioId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomerPortalPortfolioTransactions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCustomerPortalPortfolioTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomerPortalPortfolioTransactions>>>
export type ListCustomerPortalPortfolioTransactionsQueryError = ErrorType<unknown>


/**
 * @summary Search and paginate the signed-in customer's immutable portfolio ledger
 */

export function useListCustomerPortalPortfolioTransactions<TData = Awaited<ReturnType<typeof listCustomerPortalPortfolioTransactions>>, TError = ErrorType<unknown>>(
 portfolioId: string,
    params?: ListCustomerPortalPortfolioTransactionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerPortalPortfolioTransactions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCustomerPortalPortfolioTransactionsQueryOptions(portfolioId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPreviewCustomerPortalPortfolioPurchaseUrl = (portfolioId: string,) => {




  return `/api/customer-portal/portfolios/${portfolioId}/purchases/preview`
}

export const previewCustomerPortalPortfolioPurchase = async (portfolioId: string,
    customerPortfolioPurchaseInput: CustomerPortfolioPurchaseInput, options?: RequestInit): Promise<CustomerPortfolioPurchasePreview> => {

  return customFetch<CustomerPortfolioPurchasePreview>(getPreviewCustomerPortalPortfolioPurchaseUrl(portfolioId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerPortfolioPurchaseInput)
  }
);}





export const getPreviewCustomerPortalPortfolioPurchaseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewCustomerPortalPortfolioPurchase>>, TError,{portfolioId: string;data: BodyType<CustomerPortfolioPurchaseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewCustomerPortalPortfolioPurchase>>, TError,{portfolioId: string;data: BodyType<CustomerPortfolioPurchaseInput>}, TContext> => {

const mutationKey = ['previewCustomerPortalPortfolioPurchase'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewCustomerPortalPortfolioPurchase>>, {portfolioId: string;data: BodyType<CustomerPortfolioPurchaseInput>}> = (props) => {
          const {portfolioId,data} = props ?? {};

          return  previewCustomerPortalPortfolioPurchase(portfolioId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewCustomerPortalPortfolioPurchaseMutationResult = NonNullable<Awaited<ReturnType<typeof previewCustomerPortalPortfolioPurchase>>>
    export type PreviewCustomerPortalPortfolioPurchaseMutationBody = BodyType<CustomerPortfolioPurchaseInput>
    export type PreviewCustomerPortalPortfolioPurchaseMutationError = ErrorType<unknown>

    export const usePreviewCustomerPortalPortfolioPurchase = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewCustomerPortalPortfolioPurchase>>, TError,{portfolioId: string;data: BodyType<CustomerPortfolioPurchaseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof previewCustomerPortalPortfolioPurchase>>,
        TError,
        {portfolioId: string;data: BodyType<CustomerPortfolioPurchaseInput>},
        TContext
      > => {
      return useMutation(getPreviewCustomerPortalPortfolioPurchaseMutationOptions(options));
    }

export const getPreviewCustomerPortalPortfolioSaleUrl = (portfolioId: string,) => {




  return `/api/customer-portal/portfolios/${portfolioId}/sales/preview`
}

export const previewCustomerPortalPortfolioSale = async (portfolioId: string,
    customerPortfolioSaleInput: CustomerPortfolioSaleInput, options?: RequestInit): Promise<CustomerPortfolioAllocationPreview> => {

  return customFetch<CustomerPortfolioAllocationPreview>(getPreviewCustomerPortalPortfolioSaleUrl(portfolioId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerPortfolioSaleInput)
  }
);}





export const getPreviewCustomerPortalPortfolioSaleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewCustomerPortalPortfolioSale>>, TError,{portfolioId: string;data: BodyType<CustomerPortfolioSaleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewCustomerPortalPortfolioSale>>, TError,{portfolioId: string;data: BodyType<CustomerPortfolioSaleInput>}, TContext> => {

const mutationKey = ['previewCustomerPortalPortfolioSale'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewCustomerPortalPortfolioSale>>, {portfolioId: string;data: BodyType<CustomerPortfolioSaleInput>}> = (props) => {
          const {portfolioId,data} = props ?? {};

          return  previewCustomerPortalPortfolioSale(portfolioId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewCustomerPortalPortfolioSaleMutationResult = NonNullable<Awaited<ReturnType<typeof previewCustomerPortalPortfolioSale>>>
    export type PreviewCustomerPortalPortfolioSaleMutationBody = BodyType<CustomerPortfolioSaleInput>
    export type PreviewCustomerPortalPortfolioSaleMutationError = ErrorType<unknown>

    export const usePreviewCustomerPortalPortfolioSale = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewCustomerPortalPortfolioSale>>, TError,{portfolioId: string;data: BodyType<CustomerPortfolioSaleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof previewCustomerPortalPortfolioSale>>,
        TError,
        {portfolioId: string;data: BodyType<CustomerPortfolioSaleInput>},
        TContext
      > => {
      return useMutation(getPreviewCustomerPortalPortfolioSaleMutationOptions(options));
    }

export const getPreviewCustomerPortalPortfolioTransferUrl = (portfolioId: string,) => {




  return `/api/customer-portal/portfolios/${portfolioId}/transfers/preview`
}

export const previewCustomerPortalPortfolioTransfer = async (portfolioId: string,
    customerPortfolioTransferInput: CustomerPortfolioTransferInput, options?: RequestInit): Promise<CustomerPortfolioAllocationPreview> => {

  return customFetch<CustomerPortfolioAllocationPreview>(getPreviewCustomerPortalPortfolioTransferUrl(portfolioId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerPortfolioTransferInput)
  }
);}





export const getPreviewCustomerPortalPortfolioTransferMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewCustomerPortalPortfolioTransfer>>, TError,{portfolioId: string;data: BodyType<CustomerPortfolioTransferInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewCustomerPortalPortfolioTransfer>>, TError,{portfolioId: string;data: BodyType<CustomerPortfolioTransferInput>}, TContext> => {

const mutationKey = ['previewCustomerPortalPortfolioTransfer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewCustomerPortalPortfolioTransfer>>, {portfolioId: string;data: BodyType<CustomerPortfolioTransferInput>}> = (props) => {
          const {portfolioId,data} = props ?? {};

          return  previewCustomerPortalPortfolioTransfer(portfolioId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewCustomerPortalPortfolioTransferMutationResult = NonNullable<Awaited<ReturnType<typeof previewCustomerPortalPortfolioTransfer>>>
    export type PreviewCustomerPortalPortfolioTransferMutationBody = BodyType<CustomerPortfolioTransferInput>
    export type PreviewCustomerPortalPortfolioTransferMutationError = ErrorType<unknown>

    export const usePreviewCustomerPortalPortfolioTransfer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewCustomerPortalPortfolioTransfer>>, TError,{portfolioId: string;data: BodyType<CustomerPortfolioTransferInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof previewCustomerPortalPortfolioTransfer>>,
        TError,
        {portfolioId: string;data: BodyType<CustomerPortfolioTransferInput>},
        TContext
      > => {
      return useMutation(getPreviewCustomerPortalPortfolioTransferMutationOptions(options));
    }

export const getBulkManageCustomerPortalPortfolioTransactionsUrl = (portfolioId: string,) => {




  return `/api/customer-portal/portfolios/${portfolioId}/transactions/bulk`
}

export const bulkManageCustomerPortalPortfolioTransactions = async (portfolioId: string,
    customerPortfolioTransactionBulkInput: CustomerPortfolioTransactionBulkInput, options?: RequestInit): Promise<CustomerPortfolioTransactionBulkResult> => {

  return customFetch<CustomerPortfolioTransactionBulkResult>(getBulkManageCustomerPortalPortfolioTransactionsUrl(portfolioId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerPortfolioTransactionBulkInput)
  }
);}





export const getBulkManageCustomerPortalPortfolioTransactionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkManageCustomerPortalPortfolioTransactions>>, TError,{portfolioId: string;data: BodyType<CustomerPortfolioTransactionBulkInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkManageCustomerPortalPortfolioTransactions>>, TError,{portfolioId: string;data: BodyType<CustomerPortfolioTransactionBulkInput>}, TContext> => {

const mutationKey = ['bulkManageCustomerPortalPortfolioTransactions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkManageCustomerPortalPortfolioTransactions>>, {portfolioId: string;data: BodyType<CustomerPortfolioTransactionBulkInput>}> = (props) => {
          const {portfolioId,data} = props ?? {};

          return  bulkManageCustomerPortalPortfolioTransactions(portfolioId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkManageCustomerPortalPortfolioTransactionsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkManageCustomerPortalPortfolioTransactions>>>
    export type BulkManageCustomerPortalPortfolioTransactionsMutationBody = BodyType<CustomerPortfolioTransactionBulkInput>
    export type BulkManageCustomerPortalPortfolioTransactionsMutationError = ErrorType<unknown>

    export const useBulkManageCustomerPortalPortfolioTransactions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkManageCustomerPortalPortfolioTransactions>>, TError,{portfolioId: string;data: BodyType<CustomerPortfolioTransactionBulkInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkManageCustomerPortalPortfolioTransactions>>,
        TError,
        {portfolioId: string;data: BodyType<CustomerPortfolioTransactionBulkInput>},
        TContext
      > => {
      return useMutation(getBulkManageCustomerPortalPortfolioTransactionsMutationOptions(options));
    }

export const getListCustomerPortfoliosUrl = (params: ListCustomerPortfoliosParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/customer-portfolios?${stringifiedParams}` : `/api/customer-portfolios`
}

/**
 * @summary List a customer's portfolios
 */
export const listCustomerPortfolios = async (params: ListCustomerPortfoliosParams, options?: RequestInit): Promise<ListCustomerPortfolios200> => {

  return customFetch<ListCustomerPortfolios200>(getListCustomerPortfoliosUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomerPortfoliosQueryKey = (params?: ListCustomerPortfoliosParams,) => {
    return [
    `/api/customer-portfolios`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCustomerPortfoliosQueryOptions = <TData = Awaited<ReturnType<typeof listCustomerPortfolios>>, TError = ErrorType<unknown>>(params: ListCustomerPortfoliosParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerPortfolios>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomerPortfoliosQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomerPortfolios>>> = ({ signal }) => listCustomerPortfolios(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomerPortfolios>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCustomerPortfoliosQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomerPortfolios>>>
export type ListCustomerPortfoliosQueryError = ErrorType<unknown>


/**
 * @summary List a customer's portfolios
 */

export function useListCustomerPortfolios<TData = Awaited<ReturnType<typeof listCustomerPortfolios>>, TError = ErrorType<unknown>>(
 params: ListCustomerPortfoliosParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerPortfolios>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCustomerPortfoliosQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCustomerPortfolioUrl = () => {




  return `/api/customer-portfolios`
}

/**
 * @summary Create a customer portfolio
 */
export const createCustomerPortfolio = async (customerPortfolioCreateInput: CustomerPortfolioCreateInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getCreateCustomerPortfolioUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerPortfolioCreateInput)
  }
);}





export const getCreateCustomerPortfolioMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomerPortfolio>>, TError,{data: BodyType<CustomerPortfolioCreateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCustomerPortfolio>>, TError,{data: BodyType<CustomerPortfolioCreateInput>}, TContext> => {

const mutationKey = ['createCustomerPortfolio'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCustomerPortfolio>>, {data: BodyType<CustomerPortfolioCreateInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCustomerPortfolio(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCustomerPortfolioMutationResult = NonNullable<Awaited<ReturnType<typeof createCustomerPortfolio>>>
    export type CreateCustomerPortfolioMutationBody = BodyType<CustomerPortfolioCreateInput>
    export type CreateCustomerPortfolioMutationError = ErrorType<unknown>

    /**
 * @summary Create a customer portfolio
 */
export const useCreateCustomerPortfolio = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomerPortfolio>>, TError,{data: BodyType<CustomerPortfolioCreateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCustomerPortfolio>>,
        TError,
        {data: BodyType<CustomerPortfolioCreateInput>},
        TContext
      > => {
      return useMutation(getCreateCustomerPortfolioMutationOptions(options));
    }

export const getGetCustomerPortfolioSummaryUrl = (portfolioId: string,) => {




  return `/api/customer-portfolios/${portfolioId}/summary`
}

/**
 * @summary Get ledger-derived holdings, cost basis and P&L
 */
export const getCustomerPortfolioSummary = async (portfolioId: string, options?: RequestInit): Promise<CustomerPortfolioSummary> => {

  return customFetch<CustomerPortfolioSummary>(getGetCustomerPortfolioSummaryUrl(portfolioId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomerPortfolioSummaryQueryKey = (portfolioId: string,) => {
    return [
    `/api/customer-portfolios/${portfolioId}/summary`
    ] as const;
    }


export const getGetCustomerPortfolioSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerPortfolioSummary>>, TError = ErrorType<unknown>>(portfolioId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerPortfolioSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerPortfolioSummaryQueryKey(portfolioId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerPortfolioSummary>>> = ({ signal }) => getCustomerPortfolioSummary(portfolioId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: portfolioId !== null && portfolioId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerPortfolioSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerPortfolioSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerPortfolioSummary>>>
export type GetCustomerPortfolioSummaryQueryError = ErrorType<unknown>


/**
 * @summary Get ledger-derived holdings, cost basis and P&L
 */

export function useGetCustomerPortfolioSummary<TData = Awaited<ReturnType<typeof getCustomerPortfolioSummary>>, TError = ErrorType<unknown>>(
 portfolioId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerPortfolioSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCustomerPortfolioSummaryQueryOptions(portfolioId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCustomerPortfolioTransactionsUrl = (portfolioId: string,) => {




  return `/api/customer-portfolios/${portfolioId}/transactions`
}

export const listCustomerPortfolioTransactions = async (portfolioId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getListCustomerPortfolioTransactionsUrl(portfolioId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomerPortfolioTransactionsQueryKey = (portfolioId: string,) => {
    return [
    `/api/customer-portfolios/${portfolioId}/transactions`
    ] as const;
    }


export const getListCustomerPortfolioTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof listCustomerPortfolioTransactions>>, TError = ErrorType<unknown>>(portfolioId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerPortfolioTransactions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomerPortfolioTransactionsQueryKey(portfolioId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomerPortfolioTransactions>>> = ({ signal }) => listCustomerPortfolioTransactions(portfolioId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: portfolioId !== null && portfolioId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomerPortfolioTransactions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCustomerPortfolioTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomerPortfolioTransactions>>>
export type ListCustomerPortfolioTransactionsQueryError = ErrorType<unknown>



export function useListCustomerPortfolioTransactions<TData = Awaited<ReturnType<typeof listCustomerPortfolioTransactions>>, TError = ErrorType<unknown>>(
 portfolioId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerPortfolioTransactions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCustomerPortfolioTransactionsQueryOptions(portfolioId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCustomerPortfolioLotsUrl = (portfolioId: string,) => {




  return `/api/customer-portfolios/${portfolioId}/lots`
}

export const listCustomerPortfolioLots = async (portfolioId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getListCustomerPortfolioLotsUrl(portfolioId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomerPortfolioLotsQueryKey = (portfolioId: string,) => {
    return [
    `/api/customer-portfolios/${portfolioId}/lots`
    ] as const;
    }


export const getListCustomerPortfolioLotsQueryOptions = <TData = Awaited<ReturnType<typeof listCustomerPortfolioLots>>, TError = ErrorType<unknown>>(portfolioId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerPortfolioLots>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomerPortfolioLotsQueryKey(portfolioId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomerPortfolioLots>>> = ({ signal }) => listCustomerPortfolioLots(portfolioId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: portfolioId !== null && portfolioId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomerPortfolioLots>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCustomerPortfolioLotsQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomerPortfolioLots>>>
export type ListCustomerPortfolioLotsQueryError = ErrorType<unknown>



export function useListCustomerPortfolioLots<TData = Awaited<ReturnType<typeof listCustomerPortfolioLots>>, TError = ErrorType<unknown>>(
 portfolioId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerPortfolioLots>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCustomerPortfolioLotsQueryOptions(portfolioId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPostCustomerPortfolioPurchaseUrl = (portfolioId: string,) => {




  return `/api/customer-portfolios/${portfolioId}/purchases`
}

export const postCustomerPortfolioPurchase = async (portfolioId: string,
    customerPortfolioPurchaseInput: CustomerPortfolioPurchaseInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getPostCustomerPortfolioPurchaseUrl(portfolioId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerPortfolioPurchaseInput)
  }
);}





export const getPostCustomerPortfolioPurchaseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerPortfolioPurchase>>, TError,{portfolioId: string;data: BodyType<CustomerPortfolioPurchaseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postCustomerPortfolioPurchase>>, TError,{portfolioId: string;data: BodyType<CustomerPortfolioPurchaseInput>}, TContext> => {

const mutationKey = ['postCustomerPortfolioPurchase'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCustomerPortfolioPurchase>>, {portfolioId: string;data: BodyType<CustomerPortfolioPurchaseInput>}> = (props) => {
          const {portfolioId,data} = props ?? {};

          return  postCustomerPortfolioPurchase(portfolioId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCustomerPortfolioPurchaseMutationResult = NonNullable<Awaited<ReturnType<typeof postCustomerPortfolioPurchase>>>
    export type PostCustomerPortfolioPurchaseMutationBody = BodyType<CustomerPortfolioPurchaseInput>
    export type PostCustomerPortfolioPurchaseMutationError = ErrorType<unknown>

    export const usePostCustomerPortfolioPurchase = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerPortfolioPurchase>>, TError,{portfolioId: string;data: BodyType<CustomerPortfolioPurchaseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postCustomerPortfolioPurchase>>,
        TError,
        {portfolioId: string;data: BodyType<CustomerPortfolioPurchaseInput>},
        TContext
      > => {
      return useMutation(getPostCustomerPortfolioPurchaseMutationOptions(options));
    }

export const getPostCustomerPortfolioSaleUrl = (portfolioId: string,) => {




  return `/api/customer-portfolios/${portfolioId}/sales`
}

export const postCustomerPortfolioSale = async (portfolioId: string,
    customerPortfolioSaleInput: CustomerPortfolioSaleInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getPostCustomerPortfolioSaleUrl(portfolioId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerPortfolioSaleInput)
  }
);}





export const getPostCustomerPortfolioSaleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerPortfolioSale>>, TError,{portfolioId: string;data: BodyType<CustomerPortfolioSaleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postCustomerPortfolioSale>>, TError,{portfolioId: string;data: BodyType<CustomerPortfolioSaleInput>}, TContext> => {

const mutationKey = ['postCustomerPortfolioSale'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCustomerPortfolioSale>>, {portfolioId: string;data: BodyType<CustomerPortfolioSaleInput>}> = (props) => {
          const {portfolioId,data} = props ?? {};

          return  postCustomerPortfolioSale(portfolioId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCustomerPortfolioSaleMutationResult = NonNullable<Awaited<ReturnType<typeof postCustomerPortfolioSale>>>
    export type PostCustomerPortfolioSaleMutationBody = BodyType<CustomerPortfolioSaleInput>
    export type PostCustomerPortfolioSaleMutationError = ErrorType<unknown>

    export const usePostCustomerPortfolioSale = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerPortfolioSale>>, TError,{portfolioId: string;data: BodyType<CustomerPortfolioSaleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postCustomerPortfolioSale>>,
        TError,
        {portfolioId: string;data: BodyType<CustomerPortfolioSaleInput>},
        TContext
      > => {
      return useMutation(getPostCustomerPortfolioSaleMutationOptions(options));
    }

export const getPostCustomerPortfolioTransferUrl = (portfolioId: string,) => {




  return `/api/customer-portfolios/${portfolioId}/transfers`
}

export const postCustomerPortfolioTransfer = async (portfolioId: string,
    customerPortfolioTransferInput: CustomerPortfolioTransferInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getPostCustomerPortfolioTransferUrl(portfolioId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerPortfolioTransferInput)
  }
);}





export const getPostCustomerPortfolioTransferMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerPortfolioTransfer>>, TError,{portfolioId: string;data: BodyType<CustomerPortfolioTransferInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postCustomerPortfolioTransfer>>, TError,{portfolioId: string;data: BodyType<CustomerPortfolioTransferInput>}, TContext> => {

const mutationKey = ['postCustomerPortfolioTransfer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCustomerPortfolioTransfer>>, {portfolioId: string;data: BodyType<CustomerPortfolioTransferInput>}> = (props) => {
          const {portfolioId,data} = props ?? {};

          return  postCustomerPortfolioTransfer(portfolioId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCustomerPortfolioTransferMutationResult = NonNullable<Awaited<ReturnType<typeof postCustomerPortfolioTransfer>>>
    export type PostCustomerPortfolioTransferMutationBody = BodyType<CustomerPortfolioTransferInput>
    export type PostCustomerPortfolioTransferMutationError = ErrorType<unknown>

    export const usePostCustomerPortfolioTransfer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerPortfolioTransfer>>, TError,{portfolioId: string;data: BodyType<CustomerPortfolioTransferInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postCustomerPortfolioTransfer>>,
        TError,
        {portfolioId: string;data: BodyType<CustomerPortfolioTransferInput>},
        TContext
      > => {
      return useMutation(getPostCustomerPortfolioTransferMutationOptions(options));
    }

export const getPostCustomerPortfolioAdjustmentUrl = (portfolioId: string,) => {




  return `/api/customer-portfolios/${portfolioId}/adjustments`
}

export const postCustomerPortfolioAdjustment = async (portfolioId: string,
    customerPortfolioAdjustmentInput: CustomerPortfolioAdjustmentInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getPostCustomerPortfolioAdjustmentUrl(portfolioId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerPortfolioAdjustmentInput)
  }
);}





export const getPostCustomerPortfolioAdjustmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerPortfolioAdjustment>>, TError,{portfolioId: string;data: BodyType<CustomerPortfolioAdjustmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postCustomerPortfolioAdjustment>>, TError,{portfolioId: string;data: BodyType<CustomerPortfolioAdjustmentInput>}, TContext> => {

const mutationKey = ['postCustomerPortfolioAdjustment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCustomerPortfolioAdjustment>>, {portfolioId: string;data: BodyType<CustomerPortfolioAdjustmentInput>}> = (props) => {
          const {portfolioId,data} = props ?? {};

          return  postCustomerPortfolioAdjustment(portfolioId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCustomerPortfolioAdjustmentMutationResult = NonNullable<Awaited<ReturnType<typeof postCustomerPortfolioAdjustment>>>
    export type PostCustomerPortfolioAdjustmentMutationBody = BodyType<CustomerPortfolioAdjustmentInput>
    export type PostCustomerPortfolioAdjustmentMutationError = ErrorType<unknown>

    export const usePostCustomerPortfolioAdjustment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerPortfolioAdjustment>>, TError,{portfolioId: string;data: BodyType<CustomerPortfolioAdjustmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postCustomerPortfolioAdjustment>>,
        TError,
        {portfolioId: string;data: BodyType<CustomerPortfolioAdjustmentInput>},
        TContext
      > => {
      return useMutation(getPostCustomerPortfolioAdjustmentMutationOptions(options));
    }

export const getReverseCustomerPortfolioTransactionUrl = (portfolioId: string,
    transactionId: string,) => {




  return `/api/customer-portfolios/${portfolioId}/transactions/${transactionId}/reverse`
}

export const reverseCustomerPortfolioTransaction = async (portfolioId: string,
    transactionId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getReverseCustomerPortfolioTransactionUrl(portfolioId,transactionId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getReverseCustomerPortfolioTransactionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reverseCustomerPortfolioTransaction>>, TError,{portfolioId: string;transactionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reverseCustomerPortfolioTransaction>>, TError,{portfolioId: string;transactionId: string}, TContext> => {

const mutationKey = ['reverseCustomerPortfolioTransaction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reverseCustomerPortfolioTransaction>>, {portfolioId: string;transactionId: string}> = (props) => {
          const {portfolioId,transactionId} = props ?? {};

          return  reverseCustomerPortfolioTransaction(portfolioId,transactionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReverseCustomerPortfolioTransactionMutationResult = NonNullable<Awaited<ReturnType<typeof reverseCustomerPortfolioTransaction>>>

    export type ReverseCustomerPortfolioTransactionMutationError = ErrorType<unknown>

    export const useReverseCustomerPortfolioTransaction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reverseCustomerPortfolioTransaction>>, TError,{portfolioId: string;transactionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reverseCustomerPortfolioTransaction>>,
        TError,
        {portfolioId: string;transactionId: string},
        TContext
      > => {
      return useMutation(getReverseCustomerPortfolioTransactionMutationOptions(options));
    }

export const getGetRecentActivityUrl = () => {




  return `/api/dashboard/recent-activity`
}

/**
 * @summary Recent purchases and sales mixed
 */
export const getRecentActivity = async ( options?: RequestInit): Promise<ActivityItem[]> => {

  return customFetch<ActivityItem[]>(getGetRecentActivityUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRecentActivityQueryKey = () => {
    return [
    `/api/dashboard/recent-activity`
    ] as const;
    }


export const getGetRecentActivityQueryOptions = <TData = Awaited<ReturnType<typeof getRecentActivity>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRecentActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRecentActivityQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecentActivity>>> = ({ signal }) => getRecentActivity({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRecentActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRecentActivityQueryResult = NonNullable<Awaited<ReturnType<typeof getRecentActivity>>>
export type GetRecentActivityQueryError = ErrorType<unknown>


/**
 * @summary Recent purchases and sales mixed
 */

export function useGetRecentActivity<TData = Awaited<ReturnType<typeof getRecentActivity>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRecentActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRecentActivityQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getImportInventoryUrl = () => {




  return `/api/imports/inventory`
}

/**
 * @summary Bulk import inventory rows parsed from an XLSX/XLS file (client-side parsed). Append or update by SKU.
 */
export const importInventory = async (importRequest: ImportRequest, options?: RequestInit): Promise<ImportSummary | BackgroundJobAccepted> => {

  return customFetch<ImportSummary | BackgroundJobAccepted>(getImportInventoryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(importRequest)
  }
);}





export const getImportInventoryMutationOptions = <TError = ErrorType<ImportInventory409>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importInventory>>, TError,{data: BodyType<ImportRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importInventory>>, TError,{data: BodyType<ImportRequest>}, TContext> => {

const mutationKey = ['importInventory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importInventory>>, {data: BodyType<ImportRequest>}> = (props) => {
          const {data} = props ?? {};

          return  importInventory(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportInventoryMutationResult = NonNullable<Awaited<ReturnType<typeof importInventory>>>
    export type ImportInventoryMutationBody = BodyType<ImportRequest>
    export type ImportInventoryMutationError = ErrorType<ImportInventory409>

    /**
 * @summary Bulk import inventory rows parsed from an XLSX/XLS file (client-side parsed). Append or update by SKU.
 */
export const useImportInventory = <TError = ErrorType<ImportInventory409>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importInventory>>, TError,{data: BodyType<ImportRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importInventory>>,
        TError,
        {data: BodyType<ImportRequest>},
        TContext
      > => {
      return useMutation(getImportInventoryMutationOptions(options));
    }

export const getImportSalesUrl = () => {




  return `/api/imports/sales`
}

/**
 * @summary Bulk import sale orders + line items parsed from an XLSX/XLS file (client-side parsed). Rows sharing orderNumber become one sale; SKUs are resolved to inventory items.
 */
export const importSales = async (importRequest: ImportRequest, options?: RequestInit): Promise<ImportSummary | ImportSales202> => {

  return customFetch<ImportSummary | ImportSales202>(getImportSalesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(importRequest)
  }
);}





export const getImportSalesMutationOptions = <TError = ErrorType<ImportSales409>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importSales>>, TError,{data: BodyType<ImportRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importSales>>, TError,{data: BodyType<ImportRequest>}, TContext> => {

const mutationKey = ['importSales'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importSales>>, {data: BodyType<ImportRequest>}> = (props) => {
          const {data} = props ?? {};

          return  importSales(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportSalesMutationResult = NonNullable<Awaited<ReturnType<typeof importSales>>>
    export type ImportSalesMutationBody = BodyType<ImportRequest>
    export type ImportSalesMutationError = ErrorType<ImportSales409>

    /**
 * @summary Bulk import sale orders + line items parsed from an XLSX/XLS file (client-side parsed). Rows sharing orderNumber become one sale; SKUs are resolved to inventory items.
 */
export const useImportSales = <TError = ErrorType<ImportSales409>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importSales>>, TError,{data: BodyType<ImportRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importSales>>,
        TError,
        {data: BodyType<ImportRequest>},
        TContext
      > => {
      return useMutation(getImportSalesMutationOptions(options));
    }

export const getListImportLogsUrl = (params?: ListImportLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/imports/logs?${stringifiedParams}` : `/api/imports/logs`
}

/**
 * @summary List recent import logs (most recent first, max 100).
 */
export const listImportLogs = async (params?: ListImportLogsParams, options?: RequestInit): Promise<ImportLog[]> => {

  return customFetch<ImportLog[]>(getListImportLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListImportLogsQueryKey = (params?: ListImportLogsParams,) => {
    return [
    `/api/imports/logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListImportLogsQueryOptions = <TData = Awaited<ReturnType<typeof listImportLogs>>, TError = ErrorType<unknown>>(params?: ListImportLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listImportLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListImportLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listImportLogs>>> = ({ signal }) => listImportLogs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listImportLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListImportLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listImportLogs>>>
export type ListImportLogsQueryError = ErrorType<unknown>


/**
 * @summary List recent import logs (most recent first, max 100).
 */

export function useListImportLogs<TData = Awaited<ReturnType<typeof listImportLogs>>, TError = ErrorType<unknown>>(
 params?: ListImportLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listImportLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListImportLogsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetImportLogUrl = (id: string,) => {




  return `/api/imports/logs/${id}`
}

/**
 * @summary Single import log with live progress jsonb. Used by the polling UI for long-running Shopify pulls.
 */
export const getImportLog = async (id: string, options?: RequestInit): Promise<ImportLog> => {

  return customFetch<ImportLog>(getGetImportLogUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetImportLogQueryKey = (id: string,) => {
    return [
    `/api/imports/logs/${id}`
    ] as const;
    }


export const getGetImportLogQueryOptions = <TData = Awaited<ReturnType<typeof getImportLog>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getImportLog>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetImportLogQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getImportLog>>> = ({ signal }) => getImportLog(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getImportLog>>, TError, TData> & { queryKey: QueryKey }
}

export type GetImportLogQueryResult = NonNullable<Awaited<ReturnType<typeof getImportLog>>>
export type GetImportLogQueryError = ErrorType<void>


/**
 * @summary Single import log with live progress jsonb. Used by the polling UI for long-running Shopify pulls.
 */

export function useGetImportLog<TData = Awaited<ReturnType<typeof getImportLog>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getImportLog>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetImportLogQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListImportIssuesUrl = (id: string,) => {




  return `/api/imports/logs/${id}/issues`
}

/**
 * @summary All recoverable issues flagged during an import (missing SKU, missing customer, etc.). Used by the post-import review screen. Filtering by resolved status / issueType is client-side because per-import issue lists are small.
 */
export const listImportIssues = async (id: string, options?: RequestInit): Promise<ImportIssue[]> => {

  return customFetch<ImportIssue[]>(getListImportIssuesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListImportIssuesQueryKey = (id: string,) => {
    return [
    `/api/imports/logs/${id}/issues`
    ] as const;
    }


export const getListImportIssuesQueryOptions = <TData = Awaited<ReturnType<typeof listImportIssues>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listImportIssues>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListImportIssuesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listImportIssues>>> = ({ signal }) => listImportIssues(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listImportIssues>>, TError, TData> & { queryKey: QueryKey }
}

export type ListImportIssuesQueryResult = NonNullable<Awaited<ReturnType<typeof listImportIssues>>>
export type ListImportIssuesQueryError = ErrorType<unknown>


/**
 * @summary All recoverable issues flagged during an import (missing SKU, missing customer, etc.). Used by the post-import review screen. Filtering by resolved status / issueType is client-side because per-import issue lists are small.
 */

export function useListImportIssues<TData = Awaited<ReturnType<typeof listImportIssues>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listImportIssues>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListImportIssuesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAutoCreatedProductsUrl = (id: string,) => {




  return `/api/imports/logs/${id}/auto-created`
}

/**
 * @summary Products auto-synthesised by handleMissingSKU during this import. Each entry links to the placeholder inventory_items row awaiting admin enrichment.
 */
export const listAutoCreatedProducts = async (id: string, options?: RequestInit): Promise<AutoCreatedProduct[]> => {

  return customFetch<AutoCreatedProduct[]>(getListAutoCreatedProductsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAutoCreatedProductsQueryKey = (id: string,) => {
    return [
    `/api/imports/logs/${id}/auto-created`
    ] as const;
    }


export const getListAutoCreatedProductsQueryOptions = <TData = Awaited<ReturnType<typeof listAutoCreatedProducts>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAutoCreatedProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAutoCreatedProductsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAutoCreatedProducts>>> = ({ signal }) => listAutoCreatedProducts(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAutoCreatedProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAutoCreatedProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listAutoCreatedProducts>>>
export type ListAutoCreatedProductsQueryError = ErrorType<unknown>


/**
 * @summary Products auto-synthesised by handleMissingSKU during this import. Each entry links to the placeholder inventory_items row awaiting admin enrichment.
 */

export function useListAutoCreatedProducts<TData = Awaited<ReturnType<typeof listAutoCreatedProducts>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAutoCreatedProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAutoCreatedProductsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getResolveImportIssueUrl = (id: string,) => {




  return `/api/import-issues/${id}`
}

/**
 * @summary Apply a user-provided fix to a flagged import issue and mark it resolved. Updates the underlying sale order, sale order line, customer, or attaches a real inventory item depending on the issue type.
 */
export const resolveImportIssue = async (id: string,
    resolveImportIssueRequest: ResolveImportIssueRequest, options?: RequestInit): Promise<ResolveImportIssue200> => {

  return customFetch<ResolveImportIssue200>(getResolveImportIssueUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resolveImportIssueRequest)
  }
);}





export const getResolveImportIssueMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveImportIssue>>, TError,{id: string;data: BodyType<ResolveImportIssueRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resolveImportIssue>>, TError,{id: string;data: BodyType<ResolveImportIssueRequest>}, TContext> => {

const mutationKey = ['resolveImportIssue'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resolveImportIssue>>, {id: string;data: BodyType<ResolveImportIssueRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  resolveImportIssue(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResolveImportIssueMutationResult = NonNullable<Awaited<ReturnType<typeof resolveImportIssue>>>
    export type ResolveImportIssueMutationBody = BodyType<ResolveImportIssueRequest>
    export type ResolveImportIssueMutationError = ErrorType<void>

    /**
 * @summary Apply a user-provided fix to a flagged import issue and mark it resolved. Updates the underlying sale order, sale order line, customer, or attaches a real inventory item depending on the issue type.
 */
export const useResolveImportIssue = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveImportIssue>>, TError,{id: string;data: BodyType<ResolveImportIssueRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resolveImportIssue>>,
        TError,
        {id: string;data: BodyType<ResolveImportIssueRequest>},
        TContext
      > => {
      return useMutation(getResolveImportIssueMutationOptions(options));
    }

export const getRollbackImportUrl = (id: string,) => {




  return `/api/imports/logs/${id}/rollback`
}

/**
 * @summary Roll back an import by deleting all rows it created. Updated rows are NOT restored.
 */
export const rollbackImport = async (id: string, options?: RequestInit): Promise<RollbackImport200> => {

  return customFetch<RollbackImport200>(getRollbackImportUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRollbackImportMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rollbackImport>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rollbackImport>>, TError,{id: string}, TContext> => {

const mutationKey = ['rollbackImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rollbackImport>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  rollbackImport(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RollbackImportMutationResult = NonNullable<Awaited<ReturnType<typeof rollbackImport>>>

    export type RollbackImportMutationError = ErrorType<void>

    /**
 * @summary Roll back an import by deleting all rows it created. Updated rows are NOT restored.
 */
export const useRollbackImport = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rollbackImport>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rollbackImport>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getRollbackImportMutationOptions(options));
    }

export const getGetSocialStatusUrl = () => {




  return `/api/social/status`
}

/**
 * @summary Connection status + last sync info for every social platform.
 */
export const getSocialStatus = async ( options?: RequestInit): Promise<SocialConnectionStatus[]> => {

  return customFetch<SocialConnectionStatus[]>(getGetSocialStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSocialStatusQueryKey = () => {
    return [
    `/api/social/status`
    ] as const;
    }


export const getGetSocialStatusQueryOptions = <TData = Awaited<ReturnType<typeof getSocialStatus>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocialStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocialStatus>>> = ({ signal }) => getSocialStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSocialStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSocialStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getSocialStatus>>>
export type GetSocialStatusQueryError = ErrorType<unknown>


/**
 * @summary Connection status + last sync info for every social platform.
 */

export function useGetSocialStatus<TData = Awaited<ReturnType<typeof getSocialStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSocialStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSocialSettingsUrl = () => {




  return `/api/social/settings`
}

/**
 * @summary Read social-hub key/value settings (e.g. xHandle).
 */
export const getSocialSettings = async ( options?: RequestInit): Promise<GetSocialSettings200> => {

  return customFetch<GetSocialSettings200>(getGetSocialSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSocialSettingsQueryKey = () => {
    return [
    `/api/social/settings`
    ] as const;
    }


export const getGetSocialSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getSocialSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocialSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocialSettings>>> = ({ signal }) => getSocialSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSocialSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSocialSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSocialSettings>>>
export type GetSocialSettingsQueryError = ErrorType<unknown>


/**
 * @summary Read social-hub key/value settings (e.g. xHandle).
 */

export function useGetSocialSettings<TData = Awaited<ReturnType<typeof getSocialSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSocialSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateSocialSettingsUrl = () => {




  return `/api/social/settings`
}

/**
 * @summary Update social-hub settings.
 */
export const updateSocialSettings = async (socialSettingsUpdate: SocialSettingsUpdate, options?: RequestInit): Promise<UpdateSocialSettings200> => {

  return customFetch<UpdateSocialSettings200>(getUpdateSocialSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(socialSettingsUpdate)
  }
);}





export const getUpdateSocialSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSocialSettings>>, TError,{data: BodyType<SocialSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSocialSettings>>, TError,{data: BodyType<SocialSettingsUpdate>}, TContext> => {

const mutationKey = ['updateSocialSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSocialSettings>>, {data: BodyType<SocialSettingsUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateSocialSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSocialSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateSocialSettings>>>
    export type UpdateSocialSettingsMutationBody = BodyType<SocialSettingsUpdate>
    export type UpdateSocialSettingsMutationError = ErrorType<unknown>

    /**
 * @summary Update social-hub settings.
 */
export const useUpdateSocialSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSocialSettings>>, TError,{data: BodyType<SocialSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSocialSettings>>,
        TError,
        {data: BodyType<SocialSettingsUpdate>},
        TContext
      > => {
      return useMutation(getUpdateSocialSettingsMutationOptions(options));
    }

export const getListSocialPostsUrl = (params?: ListSocialPostsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/social/posts?${stringifiedParams}` : `/api/social/posts`
}

/**
 * @summary Cached posts pulled from each platform's API.
 */
export const listSocialPosts = async (params?: ListSocialPostsParams, options?: RequestInit): Promise<SocialPost[]> => {

  return customFetch<SocialPost[]>(getListSocialPostsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSocialPostsQueryKey = (params?: ListSocialPostsParams,) => {
    return [
    `/api/social/posts`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSocialPostsQueryOptions = <TData = Awaited<ReturnType<typeof listSocialPosts>>, TError = ErrorType<unknown>>(params?: ListSocialPostsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialPosts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSocialPostsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSocialPosts>>> = ({ signal }) => listSocialPosts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSocialPosts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSocialPostsQueryResult = NonNullable<Awaited<ReturnType<typeof listSocialPosts>>>
export type ListSocialPostsQueryError = ErrorType<unknown>


/**
 * @summary Cached posts pulled from each platform's API.
 */

export function useListSocialPosts<TData = Awaited<ReturnType<typeof listSocialPosts>>, TError = ErrorType<unknown>>(
 params?: ListSocialPostsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialPosts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSocialPostsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSocialEbaySummaryUrl = () => {




  return `/api/social/ebay-summary`
}

/**
 * @summary 90-day eBay revenue, listing count, and top product types.
 */
export const getSocialEbaySummary = async ( options?: RequestInit): Promise<SocialEbaySummary> => {

  return customFetch<SocialEbaySummary>(getGetSocialEbaySummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSocialEbaySummaryQueryKey = () => {
    return [
    `/api/social/ebay-summary`
    ] as const;
    }


export const getGetSocialEbaySummaryQueryOptions = <TData = Awaited<ReturnType<typeof getSocialEbaySummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialEbaySummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocialEbaySummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocialEbaySummary>>> = ({ signal }) => getSocialEbaySummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSocialEbaySummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSocialEbaySummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getSocialEbaySummary>>>
export type GetSocialEbaySummaryQueryError = ErrorType<unknown>


/**
 * @summary 90-day eBay revenue, listing count, and top product types.
 */

export function useGetSocialEbaySummary<TData = Awaited<ReturnType<typeof getSocialEbaySummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialEbaySummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSocialEbaySummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSocialRecommendationsUrl = () => {




  return `/api/social/recommendations`
}

/**
 * @summary Plain-English insights computed from cached posts.
 */
export const getSocialRecommendations = async ( options?: RequestInit): Promise<SocialRecommendation[]> => {

  return customFetch<SocialRecommendation[]>(getGetSocialRecommendationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSocialRecommendationsQueryKey = () => {
    return [
    `/api/social/recommendations`
    ] as const;
    }


export const getGetSocialRecommendationsQueryOptions = <TData = Awaited<ReturnType<typeof getSocialRecommendations>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialRecommendations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocialRecommendationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocialRecommendations>>> = ({ signal }) => getSocialRecommendations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSocialRecommendations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSocialRecommendationsQueryResult = NonNullable<Awaited<ReturnType<typeof getSocialRecommendations>>>
export type GetSocialRecommendationsQueryError = ErrorType<unknown>


/**
 * @summary Plain-English insights computed from cached posts.
 */

export function useGetSocialRecommendations<TData = Awaited<ReturnType<typeof getSocialRecommendations>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialRecommendations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSocialRecommendationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSyncSocialHistoricPostsUrl = () => {




  return `/api/social/posts/sync-historic`
}

/**
 * @summary Fetch up to 90 days of posts from all connected platforms and upsert into social_posts. Platforms already synced within the last hour are skipped.

 */
export const syncSocialHistoricPosts = async (socialHistoricSyncRequest?: SocialHistoricSyncRequest, options?: RequestInit): Promise<SocialHistoricSyncResult> => {

  return customFetch<SocialHistoricSyncResult>(getSyncSocialHistoricPostsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(socialHistoricSyncRequest)
  }
);}





export const getSyncSocialHistoricPostsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncSocialHistoricPosts>>, TError,{data?: BodyType<SocialHistoricSyncRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncSocialHistoricPosts>>, TError,{data?: BodyType<SocialHistoricSyncRequest>}, TContext> => {

const mutationKey = ['syncSocialHistoricPosts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncSocialHistoricPosts>>, {data?: BodyType<SocialHistoricSyncRequest>}> = (props) => {
          const {data} = props ?? {};

          return  syncSocialHistoricPosts(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncSocialHistoricPostsMutationResult = NonNullable<Awaited<ReturnType<typeof syncSocialHistoricPosts>>>
    export type SyncSocialHistoricPostsMutationBody = BodyType<SocialHistoricSyncRequest> | undefined
    export type SyncSocialHistoricPostsMutationError = ErrorType<unknown>

    /**
 * @summary Fetch up to 90 days of posts from all connected platforms and upsert into social_posts. Platforms already synced within the last hour are skipped.

 */
export const useSyncSocialHistoricPosts = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncSocialHistoricPosts>>, TError,{data?: BodyType<SocialHistoricSyncRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncSocialHistoricPosts>>,
        TError,
        {data?: BodyType<SocialHistoricSyncRequest>},
        TContext
      > => {
      return useMutation(getSyncSocialHistoricPostsMutationOptions(options));
    }

export const getSyncSocialPlatformUrl = () => {




  return `/api/social/sync`
}

/**
 * @summary Refresh cached posts for one platform from its live API.
 */
export const syncSocialPlatform = async (socialSyncRequest: SocialSyncRequest, options?: RequestInit): Promise<SyncSocialPlatform202> => {

  return customFetch<SyncSocialPlatform202>(getSyncSocialPlatformUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(socialSyncRequest)
  }
);}





export const getSyncSocialPlatformMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncSocialPlatform>>, TError,{data: BodyType<SocialSyncRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncSocialPlatform>>, TError,{data: BodyType<SocialSyncRequest>}, TContext> => {

const mutationKey = ['syncSocialPlatform'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncSocialPlatform>>, {data: BodyType<SocialSyncRequest>}> = (props) => {
          const {data} = props ?? {};

          return  syncSocialPlatform(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncSocialPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof syncSocialPlatform>>>
    export type SyncSocialPlatformMutationBody = BodyType<SocialSyncRequest>
    export type SyncSocialPlatformMutationError = ErrorType<unknown>

    /**
 * @summary Refresh cached posts for one platform from its live API.
 */
export const useSyncSocialPlatform = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncSocialPlatform>>, TError,{data: BodyType<SocialSyncRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncSocialPlatform>>,
        TError,
        {data: BodyType<SocialSyncRequest>},
        TContext
      > => {
      return useMutation(getSyncSocialPlatformMutationOptions(options));
    }

export const getListSocialSyncLogsUrl = (params?: ListSocialSyncLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/social/logs?${stringifiedParams}` : `/api/social/logs`
}

/**
 * @summary Recent sync attempts for one or all platforms.
 */
export const listSocialSyncLogs = async (params?: ListSocialSyncLogsParams, options?: RequestInit): Promise<SocialSyncLog[]> => {

  return customFetch<SocialSyncLog[]>(getListSocialSyncLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSocialSyncLogsQueryKey = (params?: ListSocialSyncLogsParams,) => {
    return [
    `/api/social/logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSocialSyncLogsQueryOptions = <TData = Awaited<ReturnType<typeof listSocialSyncLogs>>, TError = ErrorType<unknown>>(params?: ListSocialSyncLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialSyncLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSocialSyncLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSocialSyncLogs>>> = ({ signal }) => listSocialSyncLogs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSocialSyncLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSocialSyncLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listSocialSyncLogs>>>
export type ListSocialSyncLogsQueryError = ErrorType<unknown>


/**
 * @summary Recent sync attempts for one or all platforms.
 */

export function useListSocialSyncLogs<TData = Awaited<ReturnType<typeof listSocialSyncLogs>>, TError = ErrorType<unknown>>(
 params?: ListSocialSyncLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialSyncLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSocialSyncLogsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSocialOverviewUrl = () => {




  return `/api/social/overview`
}

/**
 * @summary Cross-platform overview — most-recent posts plus top/worst performer (last 7d).
 */
export const getSocialOverview = async ( options?: RequestInit): Promise<SocialOverview> => {

  return customFetch<SocialOverview>(getGetSocialOverviewUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSocialOverviewQueryKey = () => {
    return [
    `/api/social/overview`
    ] as const;
    }


export const getGetSocialOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getSocialOverview>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocialOverviewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocialOverview>>> = ({ signal }) => getSocialOverview({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSocialOverview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSocialOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getSocialOverview>>>
export type GetSocialOverviewQueryError = ErrorType<unknown>


/**
 * @summary Cross-platform overview — most-recent posts plus top/worst performer (last 7d).
 */

export function useGetSocialOverview<TData = Awaited<ReturnType<typeof getSocialOverview>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSocialOverviewQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSocialPreparedOverviewUrl = () => {




  return `/api/social/prepared/overview`
}

/**
 * @summary Tenant-scoped prepared Social overview; never calls providers.
 */
export const getSocialPreparedOverview = async ( options?: RequestInit): Promise<SocialPreparedOverview> => {

  return customFetch<SocialPreparedOverview>(getGetSocialPreparedOverviewUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSocialPreparedOverviewQueryKey = () => {
    return [
    `/api/social/prepared/overview`
    ] as const;
    }


export const getGetSocialPreparedOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getSocialPreparedOverview>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialPreparedOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocialPreparedOverviewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocialPreparedOverview>>> = ({ signal }) => getSocialPreparedOverview({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSocialPreparedOverview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSocialPreparedOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getSocialPreparedOverview>>>
export type GetSocialPreparedOverviewQueryError = ErrorType<unknown>


/**
 * @summary Tenant-scoped prepared Social overview; never calls providers.
 */

export function useGetSocialPreparedOverview<TData = Awaited<ReturnType<typeof getSocialPreparedOverview>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialPreparedOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSocialPreparedOverviewQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSocialPreparedPostsUrl = (params?: ListSocialPreparedPostsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/social/prepared/posts?${stringifiedParams}` : `/api/social/prepared/posts`
}

/**
 * @summary Bounded cursor-paginated Social posts with prepared freshness metadata.
 */
export const listSocialPreparedPosts = async (params?: ListSocialPreparedPostsParams, options?: RequestInit): Promise<SocialPreparedPostsPage> => {

  return customFetch<SocialPreparedPostsPage>(getListSocialPreparedPostsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSocialPreparedPostsQueryKey = (params?: ListSocialPreparedPostsParams,) => {
    return [
    `/api/social/prepared/posts`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSocialPreparedPostsQueryOptions = <TData = Awaited<ReturnType<typeof listSocialPreparedPosts>>, TError = ErrorType<unknown>>(params?: ListSocialPreparedPostsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialPreparedPosts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSocialPreparedPostsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSocialPreparedPosts>>> = ({ signal }) => listSocialPreparedPosts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSocialPreparedPosts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSocialPreparedPostsQueryResult = NonNullable<Awaited<ReturnType<typeof listSocialPreparedPosts>>>
export type ListSocialPreparedPostsQueryError = ErrorType<unknown>


/**
 * @summary Bounded cursor-paginated Social posts with prepared freshness metadata.
 */

export function useListSocialPreparedPosts<TData = Awaited<ReturnType<typeof listSocialPreparedPosts>>, TError = ErrorType<unknown>>(
 params?: ListSocialPreparedPostsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialPreparedPosts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSocialPreparedPostsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSocialCapabilitiesUrl = () => {




  return `/api/social/capabilities`
}

/**
 * @summary Explicit provider metric capability contract.
 */
export const getSocialCapabilities = async ( options?: RequestInit): Promise<GetSocialCapabilities200> => {

  return customFetch<GetSocialCapabilities200>(getGetSocialCapabilitiesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSocialCapabilitiesQueryKey = () => {
    return [
    `/api/social/capabilities`
    ] as const;
    }


export const getGetSocialCapabilitiesQueryOptions = <TData = Awaited<ReturnType<typeof getSocialCapabilities>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialCapabilities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocialCapabilitiesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocialCapabilities>>> = ({ signal }) => getSocialCapabilities({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSocialCapabilities>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSocialCapabilitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getSocialCapabilities>>>
export type GetSocialCapabilitiesQueryError = ErrorType<unknown>


/**
 * @summary Explicit provider metric capability contract.
 */

export function useGetSocialCapabilities<TData = Awaited<ReturnType<typeof getSocialCapabilities>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialCapabilities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSocialCapabilitiesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSocialAnalyticsUrl = (params?: GetSocialAnalyticsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/social/analytics?${stringifiedParams}` : `/api/social/analytics`
}

/**
 * @summary Engagement metrics aggregated by platform and day.
 */
export const getSocialAnalytics = async (params?: GetSocialAnalyticsParams, options?: RequestInit): Promise<SocialAnalytics> => {

  return customFetch<SocialAnalytics>(getGetSocialAnalyticsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSocialAnalyticsQueryKey = (params?: GetSocialAnalyticsParams,) => {
    return [
    `/api/social/analytics`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSocialAnalyticsQueryOptions = <TData = Awaited<ReturnType<typeof getSocialAnalytics>>, TError = ErrorType<unknown>>(params?: GetSocialAnalyticsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialAnalytics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocialAnalyticsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocialAnalytics>>> = ({ signal }) => getSocialAnalytics(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSocialAnalytics>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSocialAnalyticsQueryResult = NonNullable<Awaited<ReturnType<typeof getSocialAnalytics>>>
export type GetSocialAnalyticsQueryError = ErrorType<unknown>


/**
 * @summary Engagement metrics aggregated by platform and day.
 */

export function useGetSocialAnalytics<TData = Awaited<ReturnType<typeof getSocialAnalytics>>, TError = ErrorType<unknown>>(
 params?: GetSocialAnalyticsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialAnalytics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSocialAnalyticsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSocialAnalyticsSnapshotsUrl = (params?: ListSocialAnalyticsSnapshotsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/social/analytics/snapshots?${stringifiedParams}` : `/api/social/analytics/snapshots`
}

/**
 * @summary Raw hourly engagement snapshots for trend charts, oldest-first within the window.
 */
export const listSocialAnalyticsSnapshots = async (params?: ListSocialAnalyticsSnapshotsParams, options?: RequestInit): Promise<SocialAnalyticsSnapshotRow[]> => {

  return customFetch<SocialAnalyticsSnapshotRow[]>(getListSocialAnalyticsSnapshotsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSocialAnalyticsSnapshotsQueryKey = (params?: ListSocialAnalyticsSnapshotsParams,) => {
    return [
    `/api/social/analytics/snapshots`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSocialAnalyticsSnapshotsQueryOptions = <TData = Awaited<ReturnType<typeof listSocialAnalyticsSnapshots>>, TError = ErrorType<unknown>>(params?: ListSocialAnalyticsSnapshotsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialAnalyticsSnapshots>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSocialAnalyticsSnapshotsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSocialAnalyticsSnapshots>>> = ({ signal }) => listSocialAnalyticsSnapshots(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSocialAnalyticsSnapshots>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSocialAnalyticsSnapshotsQueryResult = NonNullable<Awaited<ReturnType<typeof listSocialAnalyticsSnapshots>>>
export type ListSocialAnalyticsSnapshotsQueryError = ErrorType<unknown>


/**
 * @summary Raw hourly engagement snapshots for trend charts, oldest-first within the window.
 */

export function useListSocialAnalyticsSnapshots<TData = Awaited<ReturnType<typeof listSocialAnalyticsSnapshots>>, TError = ErrorType<unknown>>(
 params?: ListSocialAnalyticsSnapshotsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialAnalyticsSnapshots>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSocialAnalyticsSnapshotsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSocialAnalyticsWorkspaceUrl = (params?: GetSocialAnalyticsWorkspaceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/social/analytics/workspace?${stringifiedParams}` : `/api/social/analytics/workspace`
}

/**
 * @summary Tenant-safe prepared analytics workspace with explicit metric availability.
 */
export const getSocialAnalyticsWorkspace = async (params?: GetSocialAnalyticsWorkspaceParams, options?: RequestInit): Promise<SocialAnalyticsWorkspace> => {

  return customFetch<SocialAnalyticsWorkspace>(getGetSocialAnalyticsWorkspaceUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSocialAnalyticsWorkspaceQueryKey = (params?: GetSocialAnalyticsWorkspaceParams,) => {
    return [
    `/api/social/analytics/workspace`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSocialAnalyticsWorkspaceQueryOptions = <TData = Awaited<ReturnType<typeof getSocialAnalyticsWorkspace>>, TError = ErrorType<unknown>>(params?: GetSocialAnalyticsWorkspaceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialAnalyticsWorkspace>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocialAnalyticsWorkspaceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocialAnalyticsWorkspace>>> = ({ signal }) => getSocialAnalyticsWorkspace(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSocialAnalyticsWorkspace>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSocialAnalyticsWorkspaceQueryResult = NonNullable<Awaited<ReturnType<typeof getSocialAnalyticsWorkspace>>>
export type GetSocialAnalyticsWorkspaceQueryError = ErrorType<unknown>


/**
 * @summary Tenant-safe prepared analytics workspace with explicit metric availability.
 */

export function useGetSocialAnalyticsWorkspace<TData = Awaited<ReturnType<typeof getSocialAnalyticsWorkspace>>, TError = ErrorType<unknown>>(
 params?: GetSocialAnalyticsWorkspaceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialAnalyticsWorkspace>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSocialAnalyticsWorkspaceQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSocialBestTimeUrl = (params?: GetSocialBestTimeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/social/analytics/best-time?${stringifiedParams}` : `/api/social/analytics/best-time`
}

/**
 * @summary Prepared best-time buckets labelled in the tenant business timezone.
 */
export const getSocialBestTime = async (params?: GetSocialBestTimeParams, options?: RequestInit): Promise<SocialBestTimeResponse> => {

  return customFetch<SocialBestTimeResponse>(getGetSocialBestTimeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSocialBestTimeQueryKey = (params?: GetSocialBestTimeParams,) => {
    return [
    `/api/social/analytics/best-time`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSocialBestTimeQueryOptions = <TData = Awaited<ReturnType<typeof getSocialBestTime>>, TError = ErrorType<unknown>>(params?: GetSocialBestTimeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialBestTime>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocialBestTimeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocialBestTime>>> = ({ signal }) => getSocialBestTime(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSocialBestTime>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSocialBestTimeQueryResult = NonNullable<Awaited<ReturnType<typeof getSocialBestTime>>>
export type GetSocialBestTimeQueryError = ErrorType<unknown>


/**
 * @summary Prepared best-time buckets labelled in the tenant business timezone.
 */

export function useGetSocialBestTime<TData = Awaited<ReturnType<typeof getSocialBestTime>>, TError = ErrorType<unknown>>(
 params?: GetSocialBestTimeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialBestTime>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSocialBestTimeQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSocialTrafficUrl = (params?: GetSocialTrafficParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/social/analytics/traffic?${stringifiedParams}` : `/api/social/analytics/traffic`
}

/**
 * @summary Qualified traffic rollups for the Social analytics workspace.
 */
export const getSocialTraffic = async (params?: GetSocialTrafficParams, options?: RequestInit): Promise<SocialTrafficResponse> => {

  return customFetch<SocialTrafficResponse>(getGetSocialTrafficUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSocialTrafficQueryKey = (params?: GetSocialTrafficParams,) => {
    return [
    `/api/social/analytics/traffic`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSocialTrafficQueryOptions = <TData = Awaited<ReturnType<typeof getSocialTraffic>>, TError = ErrorType<unknown>>(params?: GetSocialTrafficParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialTraffic>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocialTrafficQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocialTraffic>>> = ({ signal }) => getSocialTraffic(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSocialTraffic>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSocialTrafficQueryResult = NonNullable<Awaited<ReturnType<typeof getSocialTraffic>>>
export type GetSocialTrafficQueryError = ErrorType<unknown>


/**
 * @summary Qualified traffic rollups for the Social analytics workspace.
 */

export function useGetSocialTraffic<TData = Awaited<ReturnType<typeof getSocialTraffic>>, TError = ErrorType<unknown>>(
 params?: GetSocialTrafficParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialTraffic>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSocialTrafficQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSocialAttributionUrl = (params?: GetSocialAttributionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/social/analytics/attribution?${stringifiedParams}` : `/api/social/analytics/attribution`
}

/**
 * @summary Attribution-qualified campaign outcomes; never infers causation.
 */
export const getSocialAttribution = async (params?: GetSocialAttributionParams, options?: RequestInit): Promise<SocialAttributionResponse> => {

  return customFetch<SocialAttributionResponse>(getGetSocialAttributionUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSocialAttributionQueryKey = (params?: GetSocialAttributionParams,) => {
    return [
    `/api/social/analytics/attribution`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSocialAttributionQueryOptions = <TData = Awaited<ReturnType<typeof getSocialAttribution>>, TError = ErrorType<unknown>>(params?: GetSocialAttributionParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialAttribution>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocialAttributionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocialAttribution>>> = ({ signal }) => getSocialAttribution(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSocialAttribution>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSocialAttributionQueryResult = NonNullable<Awaited<ReturnType<typeof getSocialAttribution>>>
export type GetSocialAttributionQueryError = ErrorType<unknown>


/**
 * @summary Attribution-qualified campaign outcomes; never infers causation.
 */

export function useGetSocialAttribution<TData = Awaited<ReturnType<typeof getSocialAttribution>>, TError = ErrorType<unknown>>(
 params?: GetSocialAttributionParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialAttribution>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSocialAttributionQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSocialLiveWorkspaceUrl = () => {




  return `/api/social/live/workspace`
}

/**
 * @summary Bounded capability-aware Live workspace overview.
 */
export const getSocialLiveWorkspace = async ( options?: RequestInit): Promise<SocialLiveWorkspace> => {

  return customFetch<SocialLiveWorkspace>(getGetSocialLiveWorkspaceUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSocialLiveWorkspaceQueryKey = () => {
    return [
    `/api/social/live/workspace`
    ] as const;
    }


export const getGetSocialLiveWorkspaceQueryOptions = <TData = Awaited<ReturnType<typeof getSocialLiveWorkspace>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialLiveWorkspace>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocialLiveWorkspaceQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocialLiveWorkspace>>> = ({ signal }) => getSocialLiveWorkspace({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSocialLiveWorkspace>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSocialLiveWorkspaceQueryResult = NonNullable<Awaited<ReturnType<typeof getSocialLiveWorkspace>>>
export type GetSocialLiveWorkspaceQueryError = ErrorType<unknown>


/**
 * @summary Bounded capability-aware Live workspace overview.
 */

export function useGetSocialLiveWorkspace<TData = Awaited<ReturnType<typeof getSocialLiveWorkspace>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialLiveWorkspace>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSocialLiveWorkspaceQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSocialLiveOverviewUrl = () => {




  return `/api/social/live/overview`
}

/**
 * @summary Bounded prepared live session list.
 */
export const getSocialLiveOverview = async ( options?: RequestInit): Promise<GetSocialLiveOverview200> => {

  return customFetch<GetSocialLiveOverview200>(getGetSocialLiveOverviewUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSocialLiveOverviewQueryKey = () => {
    return [
    `/api/social/live/overview`
    ] as const;
    }


export const getGetSocialLiveOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getSocialLiveOverview>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialLiveOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocialLiveOverviewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocialLiveOverview>>> = ({ signal }) => getSocialLiveOverview({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSocialLiveOverview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSocialLiveOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getSocialLiveOverview>>>
export type GetSocialLiveOverviewQueryError = ErrorType<unknown>


/**
 * @summary Bounded prepared live session list.
 */

export function useGetSocialLiveOverview<TData = Awaited<ReturnType<typeof getSocialLiveOverview>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialLiveOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSocialLiveOverviewQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSocialLiveCapabilitiesUrl = () => {




  return `/api/social/live/capabilities`
}

/**
 * @summary Capability truth for Live controls.
 */
export const getSocialLiveCapabilities = async ( options?: RequestInit): Promise<SocialLiveCapability[]> => {

  return customFetch<SocialLiveCapability[]>(getGetSocialLiveCapabilitiesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSocialLiveCapabilitiesQueryKey = () => {
    return [
    `/api/social/live/capabilities`
    ] as const;
    }


export const getGetSocialLiveCapabilitiesQueryOptions = <TData = Awaited<ReturnType<typeof getSocialLiveCapabilities>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialLiveCapabilities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocialLiveCapabilitiesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocialLiveCapabilities>>> = ({ signal }) => getSocialLiveCapabilities({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSocialLiveCapabilities>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSocialLiveCapabilitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getSocialLiveCapabilities>>>
export type GetSocialLiveCapabilitiesQueryError = ErrorType<unknown>


/**
 * @summary Capability truth for Live controls.
 */

export function useGetSocialLiveCapabilities<TData = Awaited<ReturnType<typeof getSocialLiveCapabilities>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialLiveCapabilities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSocialLiveCapabilitiesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSocialLiveLinksUrl = () => {




  return `/api/social/live/links`
}

/**
 * @summary Existing OBS and Overlay Studio links configured by this tenant.
 */
export const getSocialLiveLinks = async ( options?: RequestInit): Promise<SocialLiveLink[]> => {

  return customFetch<SocialLiveLink[]>(getGetSocialLiveLinksUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSocialLiveLinksQueryKey = () => {
    return [
    `/api/social/live/links`
    ] as const;
    }


export const getGetSocialLiveLinksQueryOptions = <TData = Awaited<ReturnType<typeof getSocialLiveLinks>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialLiveLinks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocialLiveLinksQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocialLiveLinks>>> = ({ signal }) => getSocialLiveLinks({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSocialLiveLinks>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSocialLiveLinksQueryResult = NonNullable<Awaited<ReturnType<typeof getSocialLiveLinks>>>
export type GetSocialLiveLinksQueryError = ErrorType<unknown>


/**
 * @summary Existing OBS and Overlay Studio links configured by this tenant.
 */

export function useGetSocialLiveLinks<TData = Awaited<ReturnType<typeof getSocialLiveLinks>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialLiveLinks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSocialLiveLinksQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSocialLiveMetricsUrl = () => {




  return `/api/social/live/metrics`
}

/**
 * @summary Bounded prepared live session metrics.
 */
export const getSocialLiveMetrics = async ( options?: RequestInit): Promise<GetSocialLiveMetrics200> => {

  return customFetch<GetSocialLiveMetrics200>(getGetSocialLiveMetricsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSocialLiveMetricsQueryKey = () => {
    return [
    `/api/social/live/metrics`
    ] as const;
    }


export const getGetSocialLiveMetricsQueryOptions = <TData = Awaited<ReturnType<typeof getSocialLiveMetrics>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialLiveMetrics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocialLiveMetricsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocialLiveMetrics>>> = ({ signal }) => getSocialLiveMetrics({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSocialLiveMetrics>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSocialLiveMetricsQueryResult = NonNullable<Awaited<ReturnType<typeof getSocialLiveMetrics>>>
export type GetSocialLiveMetricsQueryError = ErrorType<unknown>


/**
 * @summary Bounded prepared live session metrics.
 */

export function useGetSocialLiveMetrics<TData = Awaited<ReturnType<typeof getSocialLiveMetrics>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialLiveMetrics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSocialLiveMetricsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSocialLiveAlertsUrl = () => {




  return `/api/social/live/alerts`
}

/**
 * @summary Live alerts from supported providers.
 */
export const listSocialLiveAlerts = async ( options?: RequestInit): Promise<ListSocialLiveAlerts200> => {

  return customFetch<ListSocialLiveAlerts200>(getListSocialLiveAlertsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSocialLiveAlertsQueryKey = () => {
    return [
    `/api/social/live/alerts`
    ] as const;
    }


export const getListSocialLiveAlertsQueryOptions = <TData = Awaited<ReturnType<typeof listSocialLiveAlerts>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialLiveAlerts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSocialLiveAlertsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSocialLiveAlerts>>> = ({ signal }) => listSocialLiveAlerts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSocialLiveAlerts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSocialLiveAlertsQueryResult = NonNullable<Awaited<ReturnType<typeof listSocialLiveAlerts>>>
export type ListSocialLiveAlertsQueryError = ErrorType<unknown>


/**
 * @summary Live alerts from supported providers.
 */

export function useListSocialLiveAlerts<TData = Awaited<ReturnType<typeof listSocialLiveAlerts>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialLiveAlerts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSocialLiveAlertsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSocialLiveModerationUrl = () => {




  return `/api/social/live/moderation`
}

/**
 * @summary Live moderation activity where a provider supports it.
 */
export const listSocialLiveModeration = async ( options?: RequestInit): Promise<ListSocialLiveModeration200> => {

  return customFetch<ListSocialLiveModeration200>(getListSocialLiveModerationUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSocialLiveModerationQueryKey = () => {
    return [
    `/api/social/live/moderation`
    ] as const;
    }


export const getListSocialLiveModerationQueryOptions = <TData = Awaited<ReturnType<typeof listSocialLiveModeration>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialLiveModeration>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSocialLiveModerationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSocialLiveModeration>>> = ({ signal }) => listSocialLiveModeration({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSocialLiveModeration>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSocialLiveModerationQueryResult = NonNullable<Awaited<ReturnType<typeof listSocialLiveModeration>>>
export type ListSocialLiveModerationQueryError = ErrorType<unknown>


/**
 * @summary Live moderation activity where a provider supports it.
 */

export function useListSocialLiveModeration<TData = Awaited<ReturnType<typeof listSocialLiveModeration>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialLiveModeration>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSocialLiveModerationQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSocialLiveProductsUrl = () => {




  return `/api/social/live/products`
}

/**
 * @summary Existing inventory/product references available to Live.
 */
export const listSocialLiveProducts = async ( options?: RequestInit): Promise<ListSocialLiveProducts200> => {

  return customFetch<ListSocialLiveProducts200>(getListSocialLiveProductsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSocialLiveProductsQueryKey = () => {
    return [
    `/api/social/live/products`
    ] as const;
    }


export const getListSocialLiveProductsQueryOptions = <TData = Awaited<ReturnType<typeof listSocialLiveProducts>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialLiveProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSocialLiveProductsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSocialLiveProducts>>> = ({ signal }) => listSocialLiveProducts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSocialLiveProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSocialLiveProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listSocialLiveProducts>>>
export type ListSocialLiveProductsQueryError = ErrorType<unknown>


/**
 * @summary Existing inventory/product references available to Live.
 */

export function useListSocialLiveProducts<TData = Awaited<ReturnType<typeof listSocialLiveProducts>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialLiveProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSocialLiveProductsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSocialLiveOffersUrl = () => {




  return `/api/social/live/offers`
}

/**
 * @summary Existing offer references available to Live.
 */
export const listSocialLiveOffers = async ( options?: RequestInit): Promise<ListSocialLiveOffers200> => {

  return customFetch<ListSocialLiveOffers200>(getListSocialLiveOffersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSocialLiveOffersQueryKey = () => {
    return [
    `/api/social/live/offers`
    ] as const;
    }


export const getListSocialLiveOffersQueryOptions = <TData = Awaited<ReturnType<typeof listSocialLiveOffers>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialLiveOffers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSocialLiveOffersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSocialLiveOffers>>> = ({ signal }) => listSocialLiveOffers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSocialLiveOffers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSocialLiveOffersQueryResult = NonNullable<Awaited<ReturnType<typeof listSocialLiveOffers>>>
export type ListSocialLiveOffersQueryError = ErrorType<unknown>


/**
 * @summary Existing offer references available to Live.
 */

export function useListSocialLiveOffers<TData = Awaited<ReturnType<typeof listSocialLiveOffers>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialLiveOffers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSocialLiveOffersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSocialInboxCustomerContextUrl = (id: string,) => {




  return `/api/social/inbox/${id}/customer-context`
}

/**
 * @summary Safe tenant-scoped customer context for an inbox thread.
 */
export const getSocialInboxCustomerContext = async (id: string, options?: RequestInit): Promise<SocialCustomerContext> => {

  return customFetch<SocialCustomerContext>(getGetSocialInboxCustomerContextUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSocialInboxCustomerContextQueryKey = (id: string,) => {
    return [
    `/api/social/inbox/${id}/customer-context`
    ] as const;
    }


export const getGetSocialInboxCustomerContextQueryOptions = <TData = Awaited<ReturnType<typeof getSocialInboxCustomerContext>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialInboxCustomerContext>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocialInboxCustomerContextQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocialInboxCustomerContext>>> = ({ signal }) => getSocialInboxCustomerContext(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSocialInboxCustomerContext>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSocialInboxCustomerContextQueryResult = NonNullable<Awaited<ReturnType<typeof getSocialInboxCustomerContext>>>
export type GetSocialInboxCustomerContextQueryError = ErrorType<unknown>


/**
 * @summary Safe tenant-scoped customer context for an inbox thread.
 */

export function useGetSocialInboxCustomerContext<TData = Awaited<ReturnType<typeof getSocialInboxCustomerContext>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialInboxCustomerContext>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSocialInboxCustomerContextQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSocialInboxUrl = (params?: ListSocialInboxParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/social/inbox?${stringifiedParams}` : `/api/social/inbox`
}

/**
 * @summary Tenant-scoped Social inbox with independent reply-state filtering.
 */
export const listSocialInbox = async (params?: ListSocialInboxParams, options?: RequestInit): Promise<ListSocialInbox200> => {

  return customFetch<ListSocialInbox200>(getListSocialInboxUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSocialInboxQueryKey = (params?: ListSocialInboxParams,) => {
    return [
    `/api/social/inbox`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSocialInboxQueryOptions = <TData = Awaited<ReturnType<typeof listSocialInbox>>, TError = ErrorType<unknown>>(params?: ListSocialInboxParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialInbox>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSocialInboxQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSocialInbox>>> = ({ signal }) => listSocialInbox(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSocialInbox>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSocialInboxQueryResult = NonNullable<Awaited<ReturnType<typeof listSocialInbox>>>
export type ListSocialInboxQueryError = ErrorType<unknown>


/**
 * @summary Tenant-scoped Social inbox with independent reply-state filtering.
 */

export function useListSocialInbox<TData = Awaited<ReturnType<typeof listSocialInbox>>, TError = ErrorType<unknown>>(
 params?: ListSocialInboxParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialInbox>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSocialInboxQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateSocialInboxAiSuggestionUrl = (id: string,) => {




  return `/api/social/inbox/${id}/ai-suggestion`
}

/**
 * @summary Generate an operator-reviewed draft reply; never persists or sends it.
 */
export const createSocialInboxAiSuggestion = async (id: string,
    createSocialInboxAiSuggestionBody?: CreateSocialInboxAiSuggestionBody, options?: RequestInit): Promise<SocialDraftAiSuggestion> => {

  return customFetch<SocialDraftAiSuggestion>(getCreateSocialInboxAiSuggestionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createSocialInboxAiSuggestionBody)
  }
);}





export const getCreateSocialInboxAiSuggestionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSocialInboxAiSuggestion>>, TError,{id: string;data?: BodyType<CreateSocialInboxAiSuggestionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSocialInboxAiSuggestion>>, TError,{id: string;data?: BodyType<CreateSocialInboxAiSuggestionBody>}, TContext> => {

const mutationKey = ['createSocialInboxAiSuggestion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSocialInboxAiSuggestion>>, {id: string;data?: BodyType<CreateSocialInboxAiSuggestionBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  createSocialInboxAiSuggestion(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSocialInboxAiSuggestionMutationResult = NonNullable<Awaited<ReturnType<typeof createSocialInboxAiSuggestion>>>
    export type CreateSocialInboxAiSuggestionMutationBody = BodyType<CreateSocialInboxAiSuggestionBody> | undefined
    export type CreateSocialInboxAiSuggestionMutationError = ErrorType<unknown>

    /**
 * @summary Generate an operator-reviewed draft reply; never persists or sends it.
 */
export const useCreateSocialInboxAiSuggestion = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSocialInboxAiSuggestion>>, TError,{id: string;data?: BodyType<CreateSocialInboxAiSuggestionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSocialInboxAiSuggestion>>,
        TError,
        {id: string;data?: BodyType<CreateSocialInboxAiSuggestionBody>},
        TContext
      > => {
      return useMutation(getCreateSocialInboxAiSuggestionMutationOptions(options));
    }

export const getListSocialScheduledPostsUrl = (params?: ListSocialScheduledPostsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/social/scheduled?${stringifiedParams}` : `/api/social/scheduled`
}

/**
 * @summary List composed posts (drafts + scheduled + sent).
 */
export const listSocialScheduledPosts = async (params?: ListSocialScheduledPostsParams, options?: RequestInit): Promise<ListSocialScheduledPosts200> => {

  return customFetch<ListSocialScheduledPosts200>(getListSocialScheduledPostsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSocialScheduledPostsQueryKey = (params?: ListSocialScheduledPostsParams,) => {
    return [
    `/api/social/scheduled`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSocialScheduledPostsQueryOptions = <TData = Awaited<ReturnType<typeof listSocialScheduledPosts>>, TError = ErrorType<unknown>>(params?: ListSocialScheduledPostsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialScheduledPosts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSocialScheduledPostsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSocialScheduledPosts>>> = ({ signal }) => listSocialScheduledPosts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSocialScheduledPosts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSocialScheduledPostsQueryResult = NonNullable<Awaited<ReturnType<typeof listSocialScheduledPosts>>>
export type ListSocialScheduledPostsQueryError = ErrorType<unknown>


/**
 * @summary List composed posts (drafts + scheduled + sent).
 */

export function useListSocialScheduledPosts<TData = Awaited<ReturnType<typeof listSocialScheduledPosts>>, TError = ErrorType<unknown>>(
 params?: ListSocialScheduledPostsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialScheduledPosts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSocialScheduledPostsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateSocialScheduledPostUrl = () => {




  return `/api/social/scheduled`
}

/**
 * @summary Create a draft or scheduled post.
 */
export const createSocialScheduledPost = async (socialScheduledPostCreate: SocialScheduledPostCreate, options?: RequestInit): Promise<SocialScheduledPost> => {

  return customFetch<SocialScheduledPost>(getCreateSocialScheduledPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(socialScheduledPostCreate)
  }
);}





export const getCreateSocialScheduledPostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSocialScheduledPost>>, TError,{data: BodyType<SocialScheduledPostCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSocialScheduledPost>>, TError,{data: BodyType<SocialScheduledPostCreate>}, TContext> => {

const mutationKey = ['createSocialScheduledPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSocialScheduledPost>>, {data: BodyType<SocialScheduledPostCreate>}> = (props) => {
          const {data} = props ?? {};

          return  createSocialScheduledPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSocialScheduledPostMutationResult = NonNullable<Awaited<ReturnType<typeof createSocialScheduledPost>>>
    export type CreateSocialScheduledPostMutationBody = BodyType<SocialScheduledPostCreate>
    export type CreateSocialScheduledPostMutationError = ErrorType<unknown>

    /**
 * @summary Create a draft or scheduled post.
 */
export const useCreateSocialScheduledPost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSocialScheduledPost>>, TError,{data: BodyType<SocialScheduledPostCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSocialScheduledPost>>,
        TError,
        {data: BodyType<SocialScheduledPostCreate>},
        TContext
      > => {
      return useMutation(getCreateSocialScheduledPostMutationOptions(options));
    }

export const getUpdateSocialScheduledPostUrl = (id: string,) => {




  return `/api/social/scheduled/${id}`
}

/**
 * @summary Edit a draft or scheduled post.
 */
export const updateSocialScheduledPost = async (id: string,
    socialScheduledPostUpdate: SocialScheduledPostUpdate, options?: RequestInit): Promise<SocialScheduledPost> => {

  return customFetch<SocialScheduledPost>(getUpdateSocialScheduledPostUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(socialScheduledPostUpdate)
  }
);}





export const getUpdateSocialScheduledPostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSocialScheduledPost>>, TError,{id: string;data: BodyType<SocialScheduledPostUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSocialScheduledPost>>, TError,{id: string;data: BodyType<SocialScheduledPostUpdate>}, TContext> => {

const mutationKey = ['updateSocialScheduledPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSocialScheduledPost>>, {id: string;data: BodyType<SocialScheduledPostUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSocialScheduledPost(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSocialScheduledPostMutationResult = NonNullable<Awaited<ReturnType<typeof updateSocialScheduledPost>>>
    export type UpdateSocialScheduledPostMutationBody = BodyType<SocialScheduledPostUpdate>
    export type UpdateSocialScheduledPostMutationError = ErrorType<unknown>

    /**
 * @summary Edit a draft or scheduled post.
 */
export const useUpdateSocialScheduledPost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSocialScheduledPost>>, TError,{id: string;data: BodyType<SocialScheduledPostUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSocialScheduledPost>>,
        TError,
        {id: string;data: BodyType<SocialScheduledPostUpdate>},
        TContext
      > => {
      return useMutation(getUpdateSocialScheduledPostMutationOptions(options));
    }

export const getDeleteSocialScheduledPostUrl = (id: string,) => {




  return `/api/social/scheduled/${id}`
}

/**
 * @summary Delete a scheduled or draft post.
 */
export const deleteSocialScheduledPost = async (id: string, options?: RequestInit): Promise<DeleteSocialScheduledPost200> => {

  return customFetch<DeleteSocialScheduledPost200>(getDeleteSocialScheduledPostUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteSocialScheduledPostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSocialScheduledPost>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSocialScheduledPost>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteSocialScheduledPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSocialScheduledPost>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteSocialScheduledPost(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSocialScheduledPostMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSocialScheduledPost>>>

    export type DeleteSocialScheduledPostMutationError = ErrorType<unknown>

    /**
 * @summary Delete a scheduled or draft post.
 */
export const useDeleteSocialScheduledPost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSocialScheduledPost>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSocialScheduledPost>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteSocialScheduledPostMutationOptions(options));
    }

export const getPublishSocialScheduledPostUrl = (id: string,) => {




  return `/api/social/scheduled/${id}/publish`
}

/**
 * @summary Publish a post to its target platforms now.
 */
export const publishSocialScheduledPost = async (id: string, options?: RequestInit): Promise<SocialScheduledPost> => {

  return customFetch<SocialScheduledPost>(getPublishSocialScheduledPostUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPublishSocialScheduledPostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishSocialScheduledPost>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof publishSocialScheduledPost>>, TError,{id: string}, TContext> => {

const mutationKey = ['publishSocialScheduledPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishSocialScheduledPost>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  publishSocialScheduledPost(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishSocialScheduledPostMutationResult = NonNullable<Awaited<ReturnType<typeof publishSocialScheduledPost>>>

    export type PublishSocialScheduledPostMutationError = ErrorType<unknown>

    /**
 * @summary Publish a post to its target platforms now.
 */
export const usePublishSocialScheduledPost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishSocialScheduledPost>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof publishSocialScheduledPost>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getPublishSocialScheduledPostMutationOptions(options));
    }

export const getCancelSocialScheduledPostUrl = (id: string,) => {




  return `/api/social/scheduled/${id}/cancel`
}

/**
 * @summary Cancel a draft or scheduled post so it will never be published.
 */
export const cancelSocialScheduledPost = async (id: string, options?: RequestInit): Promise<SocialScheduledPost> => {

  return customFetch<SocialScheduledPost>(getCancelSocialScheduledPostUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelSocialScheduledPostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelSocialScheduledPost>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelSocialScheduledPost>>, TError,{id: string}, TContext> => {

const mutationKey = ['cancelSocialScheduledPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelSocialScheduledPost>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  cancelSocialScheduledPost(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelSocialScheduledPostMutationResult = NonNullable<Awaited<ReturnType<typeof cancelSocialScheduledPost>>>

    export type CancelSocialScheduledPostMutationError = ErrorType<unknown>

    /**
 * @summary Cancel a draft or scheduled post so it will never be published.
 */
export const useCancelSocialScheduledPost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelSocialScheduledPost>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelSocialScheduledPost>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getCancelSocialScheduledPostMutationOptions(options));
    }

export const getApproveSocialScheduledPostUrl = (id: string,) => {




  return `/api/social/scheduled/${id}/approve`
}

/**
 * @summary Approve a scheduled post so it can be published.
 */
export const approveSocialScheduledPost = async (id: string,
    socialPostReviewAction?: SocialPostReviewAction, options?: RequestInit): Promise<SocialScheduledPost> => {

  return customFetch<SocialScheduledPost>(getApproveSocialScheduledPostUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(socialPostReviewAction)
  }
);}





export const getApproveSocialScheduledPostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveSocialScheduledPost>>, TError,{id: string;data?: BodyType<SocialPostReviewAction>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveSocialScheduledPost>>, TError,{id: string;data?: BodyType<SocialPostReviewAction>}, TContext> => {

const mutationKey = ['approveSocialScheduledPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveSocialScheduledPost>>, {id: string;data?: BodyType<SocialPostReviewAction>}> = (props) => {
          const {id,data} = props ?? {};

          return  approveSocialScheduledPost(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveSocialScheduledPostMutationResult = NonNullable<Awaited<ReturnType<typeof approveSocialScheduledPost>>>
    export type ApproveSocialScheduledPostMutationBody = BodyType<SocialPostReviewAction> | undefined
    export type ApproveSocialScheduledPostMutationError = ErrorType<unknown>

    /**
 * @summary Approve a scheduled post so it can be published.
 */
export const useApproveSocialScheduledPost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveSocialScheduledPost>>, TError,{id: string;data?: BodyType<SocialPostReviewAction>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveSocialScheduledPost>>,
        TError,
        {id: string;data?: BodyType<SocialPostReviewAction>},
        TContext
      > => {
      return useMutation(getApproveSocialScheduledPostMutationOptions(options));
    }

export const getRejectSocialScheduledPostUrl = (id: string,) => {




  return `/api/social/scheduled/${id}/reject`
}

/**
 * @summary Reject a scheduled post, preventing publish until revised.
 */
export const rejectSocialScheduledPost = async (id: string,
    socialPostReviewAction?: SocialPostReviewAction, options?: RequestInit): Promise<SocialScheduledPost> => {

  return customFetch<SocialScheduledPost>(getRejectSocialScheduledPostUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(socialPostReviewAction)
  }
);}





export const getRejectSocialScheduledPostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectSocialScheduledPost>>, TError,{id: string;data?: BodyType<SocialPostReviewAction>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectSocialScheduledPost>>, TError,{id: string;data?: BodyType<SocialPostReviewAction>}, TContext> => {

const mutationKey = ['rejectSocialScheduledPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectSocialScheduledPost>>, {id: string;data?: BodyType<SocialPostReviewAction>}> = (props) => {
          const {id,data} = props ?? {};

          return  rejectSocialScheduledPost(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectSocialScheduledPostMutationResult = NonNullable<Awaited<ReturnType<typeof rejectSocialScheduledPost>>>
    export type RejectSocialScheduledPostMutationBody = BodyType<SocialPostReviewAction> | undefined
    export type RejectSocialScheduledPostMutationError = ErrorType<unknown>

    /**
 * @summary Reject a scheduled post, preventing publish until revised.
 */
export const useRejectSocialScheduledPost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectSocialScheduledPost>>, TError,{id: string;data?: BodyType<SocialPostReviewAction>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rejectSocialScheduledPost>>,
        TError,
        {id: string;data?: BodyType<SocialPostReviewAction>},
        TContext
      > => {
      return useMutation(getRejectSocialScheduledPostMutationOptions(options));
    }

export const getReviewSocialScheduledPostUrl = (id: string,) => {




  return `/api/social/scheduled/${id}/approval`
}

/**
 * Combined approve/reject action. The caller must hold `social.posts.approve` when action is `approve`, or `social.posts.reject` when action is `reject`. Only posts whose approvalStatus is `pending` can be reviewed.
 * @summary Approve or reject a post that is pending approval.
 */
export const reviewSocialScheduledPost = async (id: string,
    socialPostApprovalAction: SocialPostApprovalAction, options?: RequestInit): Promise<SocialScheduledPost> => {

  return customFetch<SocialScheduledPost>(getReviewSocialScheduledPostUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(socialPostApprovalAction)
  }
);}





export const getReviewSocialScheduledPostMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewSocialScheduledPost>>, TError,{id: string;data: BodyType<SocialPostApprovalAction>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reviewSocialScheduledPost>>, TError,{id: string;data: BodyType<SocialPostApprovalAction>}, TContext> => {

const mutationKey = ['reviewSocialScheduledPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviewSocialScheduledPost>>, {id: string;data: BodyType<SocialPostApprovalAction>}> = (props) => {
          const {id,data} = props ?? {};

          return  reviewSocialScheduledPost(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReviewSocialScheduledPostMutationResult = NonNullable<Awaited<ReturnType<typeof reviewSocialScheduledPost>>>
    export type ReviewSocialScheduledPostMutationBody = BodyType<SocialPostApprovalAction>
    export type ReviewSocialScheduledPostMutationError = ErrorType<void>

    /**
 * @summary Approve or reject a post that is pending approval.
 */
export const useReviewSocialScheduledPost = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewSocialScheduledPost>>, TError,{id: string;data: BodyType<SocialPostApprovalAction>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reviewSocialScheduledPost>>,
        TError,
        {id: string;data: BodyType<SocialPostApprovalAction>},
        TContext
      > => {
      return useMutation(getReviewSocialScheduledPostMutationOptions(options));
    }

export const getListSocialLiveEventsUrl = () => {




  return `/api/social/live-events`
}

/**
 * @summary List upcoming + recent live-selling events.
 */
export const listSocialLiveEvents = async ( options?: RequestInit): Promise<SocialLiveEvent[]> => {

  return customFetch<SocialLiveEvent[]>(getListSocialLiveEventsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSocialLiveEventsQueryKey = () => {
    return [
    `/api/social/live-events`
    ] as const;
    }


export const getListSocialLiveEventsQueryOptions = <TData = Awaited<ReturnType<typeof listSocialLiveEvents>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialLiveEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSocialLiveEventsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSocialLiveEvents>>> = ({ signal }) => listSocialLiveEvents({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSocialLiveEvents>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSocialLiveEventsQueryResult = NonNullable<Awaited<ReturnType<typeof listSocialLiveEvents>>>
export type ListSocialLiveEventsQueryError = ErrorType<unknown>


/**
 * @summary List upcoming + recent live-selling events.
 */

export function useListSocialLiveEvents<TData = Awaited<ReturnType<typeof listSocialLiveEvents>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialLiveEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSocialLiveEventsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateSocialLiveEventUrl = () => {




  return `/api/social/live-events`
}

/**
 * @summary Schedule a new live-selling event.
 */
export const createSocialLiveEvent = async (socialLiveEventCreate: SocialLiveEventCreate, options?: RequestInit): Promise<SocialLiveEvent> => {

  return customFetch<SocialLiveEvent>(getCreateSocialLiveEventUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(socialLiveEventCreate)
  }
);}





export const getCreateSocialLiveEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSocialLiveEvent>>, TError,{data: BodyType<SocialLiveEventCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSocialLiveEvent>>, TError,{data: BodyType<SocialLiveEventCreate>}, TContext> => {

const mutationKey = ['createSocialLiveEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSocialLiveEvent>>, {data: BodyType<SocialLiveEventCreate>}> = (props) => {
          const {data} = props ?? {};

          return  createSocialLiveEvent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSocialLiveEventMutationResult = NonNullable<Awaited<ReturnType<typeof createSocialLiveEvent>>>
    export type CreateSocialLiveEventMutationBody = BodyType<SocialLiveEventCreate>
    export type CreateSocialLiveEventMutationError = ErrorType<unknown>

    /**
 * @summary Schedule a new live-selling event.
 */
export const useCreateSocialLiveEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSocialLiveEvent>>, TError,{data: BodyType<SocialLiveEventCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSocialLiveEvent>>,
        TError,
        {data: BodyType<SocialLiveEventCreate>},
        TContext
      > => {
      return useMutation(getCreateSocialLiveEventMutationOptions(options));
    }

export const getUpdateSocialLiveEventUrl = (id: string,) => {




  return `/api/social/live-events/${id}`
}

/**
 * @summary Edit a live event.
 */
export const updateSocialLiveEvent = async (id: string,
    socialLiveEventUpdate: SocialLiveEventUpdate, options?: RequestInit): Promise<SocialLiveEvent> => {

  return customFetch<SocialLiveEvent>(getUpdateSocialLiveEventUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(socialLiveEventUpdate)
  }
);}





export const getUpdateSocialLiveEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSocialLiveEvent>>, TError,{id: string;data: BodyType<SocialLiveEventUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSocialLiveEvent>>, TError,{id: string;data: BodyType<SocialLiveEventUpdate>}, TContext> => {

const mutationKey = ['updateSocialLiveEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSocialLiveEvent>>, {id: string;data: BodyType<SocialLiveEventUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSocialLiveEvent(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSocialLiveEventMutationResult = NonNullable<Awaited<ReturnType<typeof updateSocialLiveEvent>>>
    export type UpdateSocialLiveEventMutationBody = BodyType<SocialLiveEventUpdate>
    export type UpdateSocialLiveEventMutationError = ErrorType<unknown>

    /**
 * @summary Edit a live event.
 */
export const useUpdateSocialLiveEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSocialLiveEvent>>, TError,{id: string;data: BodyType<SocialLiveEventUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSocialLiveEvent>>,
        TError,
        {id: string;data: BodyType<SocialLiveEventUpdate>},
        TContext
      > => {
      return useMutation(getUpdateSocialLiveEventMutationOptions(options));
    }

export const getDeleteSocialLiveEventUrl = (id: string,) => {




  return `/api/social/live-events/${id}`
}

/**
 * @summary Delete a live event.
 */
export const deleteSocialLiveEvent = async (id: string, options?: RequestInit): Promise<DeleteSocialLiveEvent200> => {

  return customFetch<DeleteSocialLiveEvent200>(getDeleteSocialLiveEventUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteSocialLiveEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSocialLiveEvent>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSocialLiveEvent>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteSocialLiveEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSocialLiveEvent>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteSocialLiveEvent(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSocialLiveEventMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSocialLiveEvent>>>

    export type DeleteSocialLiveEventMutationError = ErrorType<unknown>

    /**
 * @summary Delete a live event.
 */
export const useDeleteSocialLiveEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSocialLiveEvent>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSocialLiveEvent>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteSocialLiveEventMutationOptions(options));
    }

export const getListSocialCalendarUrl = (params: ListSocialCalendarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/social/calendar?${stringifiedParams}` : `/api/social/calendar`
}

/**
 * @summary List compact Social posts and events intersecting a visible range.
 */
export const listSocialCalendar = async (params: ListSocialCalendarParams, options?: RequestInit): Promise<SocialCalendarResponse> => {

  return customFetch<SocialCalendarResponse>(getListSocialCalendarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSocialCalendarQueryKey = (params?: ListSocialCalendarParams,) => {
    return [
    `/api/social/calendar`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSocialCalendarQueryOptions = <TData = Awaited<ReturnType<typeof listSocialCalendar>>, TError = ErrorType<void>>(params: ListSocialCalendarParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialCalendar>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSocialCalendarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSocialCalendar>>> = ({ signal }) => listSocialCalendar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSocialCalendar>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSocialCalendarQueryResult = NonNullable<Awaited<ReturnType<typeof listSocialCalendar>>>
export type ListSocialCalendarQueryError = ErrorType<void>


/**
 * @summary List compact Social posts and events intersecting a visible range.
 */

export function useListSocialCalendar<TData = Awaited<ReturnType<typeof listSocialCalendar>>, TError = ErrorType<void>>(
 params: ListSocialCalendarParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialCalendar>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSocialCalendarQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateSocialCalendarEventUrl = () => {




  return `/api/social/calendar/events`
}

/**
 * @summary Create an operator planning event.
 */
export const createSocialCalendarEvent = async (socialCalendarEventCreate: SocialCalendarEventCreate, options?: RequestInit): Promise<SocialCalendarEvent> => {

  return customFetch<SocialCalendarEvent>(getCreateSocialCalendarEventUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(socialCalendarEventCreate)
  }
);}





export const getCreateSocialCalendarEventMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSocialCalendarEvent>>, TError,{data: BodyType<SocialCalendarEventCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSocialCalendarEvent>>, TError,{data: BodyType<SocialCalendarEventCreate>}, TContext> => {

const mutationKey = ['createSocialCalendarEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSocialCalendarEvent>>, {data: BodyType<SocialCalendarEventCreate>}> = (props) => {
          const {data} = props ?? {};

          return  createSocialCalendarEvent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSocialCalendarEventMutationResult = NonNullable<Awaited<ReturnType<typeof createSocialCalendarEvent>>>
    export type CreateSocialCalendarEventMutationBody = BodyType<SocialCalendarEventCreate>
    export type CreateSocialCalendarEventMutationError = ErrorType<void>

    /**
 * @summary Create an operator planning event.
 */
export const useCreateSocialCalendarEvent = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSocialCalendarEvent>>, TError,{data: BodyType<SocialCalendarEventCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSocialCalendarEvent>>,
        TError,
        {data: BodyType<SocialCalendarEventCreate>},
        TContext
      > => {
      return useMutation(getCreateSocialCalendarEventMutationOptions(options));
    }

export const getUpdateSocialCalendarEventUrl = (id: string,) => {




  return `/api/social/calendar/events/${id}`
}

/**
 * @summary Update or reschedule an operator planning event.
 */
export const updateSocialCalendarEvent = async (id: string,
    socialCalendarEventUpdate: SocialCalendarEventUpdate, options?: RequestInit): Promise<SocialCalendarEvent> => {

  return customFetch<SocialCalendarEvent>(getUpdateSocialCalendarEventUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(socialCalendarEventUpdate)
  }
);}





export const getUpdateSocialCalendarEventMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSocialCalendarEvent>>, TError,{id: string;data: BodyType<SocialCalendarEventUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSocialCalendarEvent>>, TError,{id: string;data: BodyType<SocialCalendarEventUpdate>}, TContext> => {

const mutationKey = ['updateSocialCalendarEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSocialCalendarEvent>>, {id: string;data: BodyType<SocialCalendarEventUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSocialCalendarEvent(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSocialCalendarEventMutationResult = NonNullable<Awaited<ReturnType<typeof updateSocialCalendarEvent>>>
    export type UpdateSocialCalendarEventMutationBody = BodyType<SocialCalendarEventUpdate>
    export type UpdateSocialCalendarEventMutationError = ErrorType<void>

    /**
 * @summary Update or reschedule an operator planning event.
 */
export const useUpdateSocialCalendarEvent = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSocialCalendarEvent>>, TError,{id: string;data: BodyType<SocialCalendarEventUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSocialCalendarEvent>>,
        TError,
        {id: string;data: BodyType<SocialCalendarEventUpdate>},
        TContext
      > => {
      return useMutation(getUpdateSocialCalendarEventMutationOptions(options));
    }

export const getDeleteSocialCalendarEventUrl = (id: string,) => {




  return `/api/social/calendar/events/${id}`
}

/**
 * @summary Delete an operator planning event.
 */
export const deleteSocialCalendarEvent = async (id: string, options?: RequestInit): Promise<DeleteSocialCalendarEvent200> => {

  return customFetch<DeleteSocialCalendarEvent200>(getDeleteSocialCalendarEventUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteSocialCalendarEventMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSocialCalendarEvent>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSocialCalendarEvent>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteSocialCalendarEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSocialCalendarEvent>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteSocialCalendarEvent(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSocialCalendarEventMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSocialCalendarEvent>>>

    export type DeleteSocialCalendarEventMutationError = ErrorType<void>

    /**
 * @summary Delete an operator planning event.
 */
export const useDeleteSocialCalendarEvent = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSocialCalendarEvent>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSocialCalendarEvent>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteSocialCalendarEventMutationOptions(options));
    }

export const getSuggestSocialContentUrl = () => {




  return `/api/social/ai-suggest`
}

/**
 * @summary AI-powered captions, hashtags, posting times, or post analysis.
 */
export const suggestSocialContent = async (socialAiSuggestRequest: SocialAiSuggestRequest, options?: RequestInit): Promise<SocialAiSuggestResponse> => {

  return customFetch<SocialAiSuggestResponse>(getSuggestSocialContentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(socialAiSuggestRequest)
  }
);}





export const getSuggestSocialContentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof suggestSocialContent>>, TError,{data: BodyType<SocialAiSuggestRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof suggestSocialContent>>, TError,{data: BodyType<SocialAiSuggestRequest>}, TContext> => {

const mutationKey = ['suggestSocialContent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof suggestSocialContent>>, {data: BodyType<SocialAiSuggestRequest>}> = (props) => {
          const {data} = props ?? {};

          return  suggestSocialContent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SuggestSocialContentMutationResult = NonNullable<Awaited<ReturnType<typeof suggestSocialContent>>>
    export type SuggestSocialContentMutationBody = BodyType<SocialAiSuggestRequest>
    export type SuggestSocialContentMutationError = ErrorType<unknown>

    /**
 * @summary AI-powered captions, hashtags, posting times, or post analysis.
 */
export const useSuggestSocialContent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof suggestSocialContent>>, TError,{data: BodyType<SocialAiSuggestRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof suggestSocialContent>>,
        TError,
        {data: BodyType<SocialAiSuggestRequest>},
        TContext
      > => {
      return useMutation(getSuggestSocialContentMutationOptions(options));
    }

export const getCheckSocialLinksUrl = () => {




  return `/api/social/ai-link-check`
}

/**
 * @summary Verify every URL in a draft with a real network request (broken/insecure/redirect detection).
 */
export const checkSocialLinks = async (socialLinkCheckRequest: SocialLinkCheckRequest, options?: RequestInit): Promise<SocialLinkCheckResponse> => {

  return customFetch<SocialLinkCheckResponse>(getCheckSocialLinksUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(socialLinkCheckRequest)
  }
);}





export const getCheckSocialLinksMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkSocialLinks>>, TError,{data: BodyType<SocialLinkCheckRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof checkSocialLinks>>, TError,{data: BodyType<SocialLinkCheckRequest>}, TContext> => {

const mutationKey = ['checkSocialLinks'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkSocialLinks>>, {data: BodyType<SocialLinkCheckRequest>}> = (props) => {
          const {data} = props ?? {};

          return  checkSocialLinks(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckSocialLinksMutationResult = NonNullable<Awaited<ReturnType<typeof checkSocialLinks>>>
    export type CheckSocialLinksMutationBody = BodyType<SocialLinkCheckRequest>
    export type CheckSocialLinksMutationError = ErrorType<unknown>

    /**
 * @summary Verify every URL in a draft with a real network request (broken/insecure/redirect detection).
 */
export const useCheckSocialLinks = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkSocialLinks>>, TError,{data: BodyType<SocialLinkCheckRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof checkSocialLinks>>,
        TError,
        {data: BodyType<SocialLinkCheckRequest>},
        TContext
      > => {
      return useMutation(getCheckSocialLinksMutationOptions(options));
    }

export const getAiCheckSocialContentUrl = () => {




  return `/api/social/ai-check`
}

/**
 * @summary Check a title or description field and return individual inline suggestions.
 */
export const aiCheckSocialContent = async (socialAiCheckRequest: SocialAiCheckRequest, options?: RequestInit): Promise<SocialAiCheckResponse> => {

  return customFetch<SocialAiCheckResponse>(getAiCheckSocialContentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(socialAiCheckRequest)
  }
);}





export const getAiCheckSocialContentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiCheckSocialContent>>, TError,{data: BodyType<SocialAiCheckRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof aiCheckSocialContent>>, TError,{data: BodyType<SocialAiCheckRequest>}, TContext> => {

const mutationKey = ['aiCheckSocialContent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiCheckSocialContent>>, {data: BodyType<SocialAiCheckRequest>}> = (props) => {
          const {data} = props ?? {};

          return  aiCheckSocialContent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AiCheckSocialContentMutationResult = NonNullable<Awaited<ReturnType<typeof aiCheckSocialContent>>>
    export type AiCheckSocialContentMutationBody = BodyType<SocialAiCheckRequest>
    export type AiCheckSocialContentMutationError = ErrorType<unknown>

    /**
 * @summary Check a title or description field and return individual inline suggestions.
 */
export const useAiCheckSocialContent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiCheckSocialContent>>, TError,{data: BodyType<SocialAiCheckRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof aiCheckSocialContent>>,
        TError,
        {data: BodyType<SocialAiCheckRequest>},
        TContext
      > => {
      return useMutation(getAiCheckSocialContentMutationOptions(options));
    }

export const getGetSocialAiBestTimesUrl = (params?: GetSocialAiBestTimesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/social/ai-best-times?${stringifiedParams}` : `/api/social/ai-best-times`
}

/**
 * @summary Return engagement heatmap and AI-recommended posting slots from the last 90 days.
 */
export const getSocialAiBestTimes = async (params?: GetSocialAiBestTimesParams, options?: RequestInit): Promise<SocialBestTimesResponse> => {

  return customFetch<SocialBestTimesResponse>(getGetSocialAiBestTimesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSocialAiBestTimesQueryKey = (params?: GetSocialAiBestTimesParams,) => {
    return [
    `/api/social/ai-best-times`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSocialAiBestTimesQueryOptions = <TData = Awaited<ReturnType<typeof getSocialAiBestTimes>>, TError = ErrorType<unknown>>(params?: GetSocialAiBestTimesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialAiBestTimes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocialAiBestTimesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocialAiBestTimes>>> = ({ signal }) => getSocialAiBestTimes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSocialAiBestTimes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSocialAiBestTimesQueryResult = NonNullable<Awaited<ReturnType<typeof getSocialAiBestTimes>>>
export type GetSocialAiBestTimesQueryError = ErrorType<unknown>


/**
 * @summary Return engagement heatmap and AI-recommended posting slots from the last 90 days.
 */

export function useGetSocialAiBestTimes<TData = Awaited<ReturnType<typeof getSocialAiBestTimes>>, TError = ErrorType<unknown>>(
 params?: GetSocialAiBestTimesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialAiBestTimes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSocialAiBestTimesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSuggestSocialTasksUrl = () => {




  return `/api/social/ai-suggest-tasks`
}

/**
 * @summary Return a lifecycle task plan for a post or campaign.
 */
export const suggestSocialTasks = async (socialSuggestTasksRequest: SocialSuggestTasksRequest, options?: RequestInit): Promise<SocialSuggestTasksResponse> => {

  return customFetch<SocialSuggestTasksResponse>(getSuggestSocialTasksUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(socialSuggestTasksRequest)
  }
);}





export const getSuggestSocialTasksMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof suggestSocialTasks>>, TError,{data: BodyType<SocialSuggestTasksRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof suggestSocialTasks>>, TError,{data: BodyType<SocialSuggestTasksRequest>}, TContext> => {

const mutationKey = ['suggestSocialTasks'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof suggestSocialTasks>>, {data: BodyType<SocialSuggestTasksRequest>}> = (props) => {
          const {data} = props ?? {};

          return  suggestSocialTasks(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SuggestSocialTasksMutationResult = NonNullable<Awaited<ReturnType<typeof suggestSocialTasks>>>
    export type SuggestSocialTasksMutationBody = BodyType<SocialSuggestTasksRequest>
    export type SuggestSocialTasksMutationError = ErrorType<unknown>

    /**
 * @summary Return a lifecycle task plan for a post or campaign.
 */
export const useSuggestSocialTasks = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof suggestSocialTasks>>, TError,{data: BodyType<SocialSuggestTasksRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof suggestSocialTasks>>,
        TError,
        {data: BodyType<SocialSuggestTasksRequest>},
        TContext
      > => {
      return useMutation(getSuggestSocialTasksMutationOptions(options));
    }

export const getAiEnhanceSocialImageUrl = () => {




  return `/api/social/ai-enhance-image`
}

/**
 * @summary Generate AI-enhanced image variants and return them as base64 (not saved). Call /save to persist an approved variant.
 */
export const aiEnhanceSocialImage = async (socialAiEnhanceImageRequest: SocialAiEnhanceImageRequest, options?: RequestInit): Promise<SocialAiEnhanceImageResponse> => {

  return customFetch<SocialAiEnhanceImageResponse>(getAiEnhanceSocialImageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(socialAiEnhanceImageRequest)
  }
);}





export const getAiEnhanceSocialImageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiEnhanceSocialImage>>, TError,{data: BodyType<SocialAiEnhanceImageRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof aiEnhanceSocialImage>>, TError,{data: BodyType<SocialAiEnhanceImageRequest>}, TContext> => {

const mutationKey = ['aiEnhanceSocialImage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiEnhanceSocialImage>>, {data: BodyType<SocialAiEnhanceImageRequest>}> = (props) => {
          const {data} = props ?? {};

          return  aiEnhanceSocialImage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AiEnhanceSocialImageMutationResult = NonNullable<Awaited<ReturnType<typeof aiEnhanceSocialImage>>>
    export type AiEnhanceSocialImageMutationBody = BodyType<SocialAiEnhanceImageRequest>
    export type AiEnhanceSocialImageMutationError = ErrorType<unknown>

    /**
 * @summary Generate AI-enhanced image variants and return them as base64 (not saved). Call /save to persist an approved variant.
 */
export const useAiEnhanceSocialImage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiEnhanceSocialImage>>, TError,{data: BodyType<SocialAiEnhanceImageRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof aiEnhanceSocialImage>>,
        TError,
        {data: BodyType<SocialAiEnhanceImageRequest>},
        TContext
      > => {
      return useMutation(getAiEnhanceSocialImageMutationOptions(options));
    }

export const getSaveEnhancedSocialImageUrl = () => {




  return `/api/social/ai-enhance-image/save`
}

/**
 * @summary Save one approved AI-enhanced image variant to the media library.
 */
export const saveEnhancedSocialImage = async (socialAiSaveEnhancedImageRequest: SocialAiSaveEnhancedImageRequest, options?: RequestInit): Promise<SocialAiSaveEnhancedImageResponse> => {

  return customFetch<SocialAiSaveEnhancedImageResponse>(getSaveEnhancedSocialImageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(socialAiSaveEnhancedImageRequest)
  }
);}





export const getSaveEnhancedSocialImageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveEnhancedSocialImage>>, TError,{data: BodyType<SocialAiSaveEnhancedImageRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveEnhancedSocialImage>>, TError,{data: BodyType<SocialAiSaveEnhancedImageRequest>}, TContext> => {

const mutationKey = ['saveEnhancedSocialImage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveEnhancedSocialImage>>, {data: BodyType<SocialAiSaveEnhancedImageRequest>}> = (props) => {
          const {data} = props ?? {};

          return  saveEnhancedSocialImage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveEnhancedSocialImageMutationResult = NonNullable<Awaited<ReturnType<typeof saveEnhancedSocialImage>>>
    export type SaveEnhancedSocialImageMutationBody = BodyType<SocialAiSaveEnhancedImageRequest>
    export type SaveEnhancedSocialImageMutationError = ErrorType<unknown>

    /**
 * @summary Save one approved AI-enhanced image variant to the media library.
 */
export const useSaveEnhancedSocialImage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveEnhancedSocialImage>>, TError,{data: BodyType<SocialAiSaveEnhancedImageRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveEnhancedSocialImage>>,
        TError,
        {data: BodyType<SocialAiSaveEnhancedImageRequest>},
        TContext
      > => {
      return useMutation(getSaveEnhancedSocialImageMutationOptions(options));
    }

export const getListSocialAccountsUrl = () => {




  return `/api/social/accounts`
}

/**
 * @summary List connected social-platform accounts (metadata only — tokens never returned).
 */
export const listSocialAccounts = async ( options?: RequestInit): Promise<SocialAccount[]> => {

  return customFetch<SocialAccount[]>(getListSocialAccountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSocialAccountsQueryKey = () => {
    return [
    `/api/social/accounts`
    ] as const;
    }


export const getListSocialAccountsQueryOptions = <TData = Awaited<ReturnType<typeof listSocialAccounts>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialAccounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSocialAccountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSocialAccounts>>> = ({ signal }) => listSocialAccounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSocialAccounts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSocialAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof listSocialAccounts>>>
export type ListSocialAccountsQueryError = ErrorType<unknown>


/**
 * @summary List connected social-platform accounts (metadata only — tokens never returned).
 */

export function useListSocialAccounts<TData = Awaited<ReturnType<typeof listSocialAccounts>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialAccounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSocialAccountsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getConnectSocialAccountUrl = (platform: SocialPlatform,) => {




  return `/api/social/accounts/${platform}/connect`
}

/**
 * @summary Store a newly obtained OAuth token for the given platform (upserts on externalAccountId).
 */
export const connectSocialAccount = async (platform: SocialPlatform,
    socialAccountConnect: SocialAccountConnect, options?: RequestInit): Promise<SocialAccount> => {

  return customFetch<SocialAccount>(getConnectSocialAccountUrl(platform),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(socialAccountConnect)
  }
);}





export const getConnectSocialAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectSocialAccount>>, TError,{platform: SocialPlatform;data: BodyType<SocialAccountConnect>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof connectSocialAccount>>, TError,{platform: SocialPlatform;data: BodyType<SocialAccountConnect>}, TContext> => {

const mutationKey = ['connectSocialAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectSocialAccount>>, {platform: SocialPlatform;data: BodyType<SocialAccountConnect>}> = (props) => {
          const {platform,data} = props ?? {};

          return  connectSocialAccount(platform,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConnectSocialAccountMutationResult = NonNullable<Awaited<ReturnType<typeof connectSocialAccount>>>
    export type ConnectSocialAccountMutationBody = BodyType<SocialAccountConnect>
    export type ConnectSocialAccountMutationError = ErrorType<unknown>

    /**
 * @summary Store a newly obtained OAuth token for the given platform (upserts on externalAccountId).
 */
export const useConnectSocialAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectSocialAccount>>, TError,{platform: SocialPlatform;data: BodyType<SocialAccountConnect>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof connectSocialAccount>>,
        TError,
        {platform: SocialPlatform;data: BodyType<SocialAccountConnect>},
        TContext
      > => {
      return useMutation(getConnectSocialAccountMutationOptions(options));
    }

export const getTestSocialAccountConnectionUrl = (platform: SocialPlatform,) => {




  return `/api/social/accounts/${platform}/test`
}

/**
 * @summary Read-only probe that verifies a platform's stored credentials work (fetches profile/page info).
 */
export const testSocialAccountConnection = async (platform: SocialPlatform, options?: RequestInit): Promise<SocialConnectionTestResult> => {

  return customFetch<SocialConnectionTestResult>(getTestSocialAccountConnectionUrl(platform),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTestSocialAccountConnectionQueryKey = (platform: SocialPlatform,) => {
    return [
    `/api/social/accounts/${platform}/test`
    ] as const;
    }


export const getTestSocialAccountConnectionQueryOptions = <TData = Awaited<ReturnType<typeof testSocialAccountConnection>>, TError = ErrorType<unknown>>(platform: SocialPlatform, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof testSocialAccountConnection>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestSocialAccountConnectionQueryKey(platform);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof testSocialAccountConnection>>> = ({ signal }) => testSocialAccountConnection(platform, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: platform !== null && platform !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testSocialAccountConnection>>, TError, TData> & { queryKey: QueryKey }
}

export type TestSocialAccountConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof testSocialAccountConnection>>>
export type TestSocialAccountConnectionQueryError = ErrorType<unknown>


/**
 * @summary Read-only probe that verifies a platform's stored credentials work (fetches profile/page info).
 */

export function useTestSocialAccountConnection<TData = Awaited<ReturnType<typeof testSocialAccountConnection>>, TError = ErrorType<unknown>>(
 platform: SocialPlatform, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof testSocialAccountConnection>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getTestSocialAccountConnectionQueryOptions(platform,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDisconnectSocialAccountUrl = (accountId: string,) => {




  return `/api/social/accounts/${accountId}/disconnect`
}

/**
 * @summary Mark an account as disconnected and clear stored tokens.
 */
export const disconnectSocialAccount = async (accountId: string, options?: RequestInit): Promise<DisconnectSocialAccount200> => {

  return customFetch<DisconnectSocialAccount200>(getDisconnectSocialAccountUrl(accountId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDisconnectSocialAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectSocialAccount>>, TError,{accountId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectSocialAccount>>, TError,{accountId: string}, TContext> => {

const mutationKey = ['disconnectSocialAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectSocialAccount>>, {accountId: string}> = (props) => {
          const {accountId} = props ?? {};

          return  disconnectSocialAccount(accountId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectSocialAccountMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectSocialAccount>>>

    export type DisconnectSocialAccountMutationError = ErrorType<unknown>

    /**
 * @summary Mark an account as disconnected and clear stored tokens.
 */
export const useDisconnectSocialAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectSocialAccount>>, TError,{accountId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof disconnectSocialAccount>>,
        TError,
        {accountId: string},
        TContext
      > => {
      return useMutation(getDisconnectSocialAccountMutationOptions(options));
    }

export const getListSocialMediaUrl = (params?: ListSocialMediaParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/social/media?${stringifiedParams}` : `/api/social/media`
}

/**
 * @summary List media library assets.
 */
export const listSocialMedia = async (params?: ListSocialMediaParams, options?: RequestInit): Promise<ListSocialMedia200> => {

  return customFetch<ListSocialMedia200>(getListSocialMediaUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSocialMediaQueryKey = (params?: ListSocialMediaParams,) => {
    return [
    `/api/social/media`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSocialMediaQueryOptions = <TData = Awaited<ReturnType<typeof listSocialMedia>>, TError = ErrorType<unknown>>(params?: ListSocialMediaParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialMedia>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSocialMediaQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSocialMedia>>> = ({ signal }) => listSocialMedia(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSocialMedia>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSocialMediaQueryResult = NonNullable<Awaited<ReturnType<typeof listSocialMedia>>>
export type ListSocialMediaQueryError = ErrorType<unknown>


/**
 * @summary List media library assets.
 */

export function useListSocialMedia<TData = Awaited<ReturnType<typeof listSocialMedia>>, TError = ErrorType<unknown>>(
 params?: ListSocialMediaParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialMedia>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSocialMediaQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateSocialMediaAssetUrl = () => {




  return `/api/social/media`
}

/**
 * @summary Register a media asset that has already been uploaded to object storage.
 */
export const createSocialMediaAsset = async (socialMediaAssetCreate: SocialMediaAssetCreate, options?: RequestInit): Promise<SocialMediaAsset> => {

  return customFetch<SocialMediaAsset>(getCreateSocialMediaAssetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(socialMediaAssetCreate)
  }
);}





export const getCreateSocialMediaAssetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSocialMediaAsset>>, TError,{data: BodyType<SocialMediaAssetCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSocialMediaAsset>>, TError,{data: BodyType<SocialMediaAssetCreate>}, TContext> => {

const mutationKey = ['createSocialMediaAsset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSocialMediaAsset>>, {data: BodyType<SocialMediaAssetCreate>}> = (props) => {
          const {data} = props ?? {};

          return  createSocialMediaAsset(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSocialMediaAssetMutationResult = NonNullable<Awaited<ReturnType<typeof createSocialMediaAsset>>>
    export type CreateSocialMediaAssetMutationBody = BodyType<SocialMediaAssetCreate>
    export type CreateSocialMediaAssetMutationError = ErrorType<unknown>

    /**
 * @summary Register a media asset that has already been uploaded to object storage.
 */
export const useCreateSocialMediaAsset = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSocialMediaAsset>>, TError,{data: BodyType<SocialMediaAssetCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSocialMediaAsset>>,
        TError,
        {data: BodyType<SocialMediaAssetCreate>},
        TContext
      > => {
      return useMutation(getCreateSocialMediaAssetMutationOptions(options));
    }

export const getUpdateSocialMediaAssetUrl = (id: string,) => {




  return `/api/social/media/${id}`
}

/**
 * @summary Update media asset metadata (altText, tags, isFavourite).
 */
export const updateSocialMediaAsset = async (id: string,
    socialMediaAssetUpdate: SocialMediaAssetUpdate, options?: RequestInit): Promise<SocialMediaAsset> => {

  return customFetch<SocialMediaAsset>(getUpdateSocialMediaAssetUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(socialMediaAssetUpdate)
  }
);}





export const getUpdateSocialMediaAssetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSocialMediaAsset>>, TError,{id: string;data: BodyType<SocialMediaAssetUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSocialMediaAsset>>, TError,{id: string;data: BodyType<SocialMediaAssetUpdate>}, TContext> => {

const mutationKey = ['updateSocialMediaAsset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSocialMediaAsset>>, {id: string;data: BodyType<SocialMediaAssetUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSocialMediaAsset(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSocialMediaAssetMutationResult = NonNullable<Awaited<ReturnType<typeof updateSocialMediaAsset>>>
    export type UpdateSocialMediaAssetMutationBody = BodyType<SocialMediaAssetUpdate>
    export type UpdateSocialMediaAssetMutationError = ErrorType<unknown>

    /**
 * @summary Update media asset metadata (altText, tags, isFavourite).
 */
export const useUpdateSocialMediaAsset = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSocialMediaAsset>>, TError,{id: string;data: BodyType<SocialMediaAssetUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSocialMediaAsset>>,
        TError,
        {id: string;data: BodyType<SocialMediaAssetUpdate>},
        TContext
      > => {
      return useMutation(getUpdateSocialMediaAssetMutationOptions(options));
    }

export const getDeleteSocialMediaAssetUrl = (id: string,) => {




  return `/api/social/media/${id}`
}

/**
 * @summary Delete a media library asset record (object-storage object is NOT deleted here).
 */
export const deleteSocialMediaAsset = async (id: string, options?: RequestInit): Promise<DeleteSocialMediaAsset200> => {

  return customFetch<DeleteSocialMediaAsset200>(getDeleteSocialMediaAssetUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteSocialMediaAssetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSocialMediaAsset>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSocialMediaAsset>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteSocialMediaAsset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSocialMediaAsset>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteSocialMediaAsset(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSocialMediaAssetMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSocialMediaAsset>>>

    export type DeleteSocialMediaAssetMutationError = ErrorType<unknown>

    /**
 * @summary Delete a media library asset record (object-storage object is NOT deleted here).
 */
export const useDeleteSocialMediaAsset = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSocialMediaAsset>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSocialMediaAsset>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteSocialMediaAssetMutationOptions(options));
    }

export const getMakeSocialMediaAssetPublicUrl = (id: string,) => {




  return `/api/social/media/${id}/make-public`
}

/**
 * @summary Mint a stable public URL for an asset. Idempotent — once set the URL never changes.
 */
export const makeSocialMediaAssetPublic = async (id: string, options?: RequestInit): Promise<SocialMediaAsset> => {

  return customFetch<SocialMediaAsset>(getMakeSocialMediaAssetPublicUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMakeSocialMediaAssetPublicMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof makeSocialMediaAssetPublic>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof makeSocialMediaAssetPublic>>, TError,{id: string}, TContext> => {

const mutationKey = ['makeSocialMediaAssetPublic'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof makeSocialMediaAssetPublic>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  makeSocialMediaAssetPublic(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MakeSocialMediaAssetPublicMutationResult = NonNullable<Awaited<ReturnType<typeof makeSocialMediaAssetPublic>>>

    export type MakeSocialMediaAssetPublicMutationError = ErrorType<unknown>

    /**
 * @summary Mint a stable public URL for an asset. Idempotent — once set the URL never changes.
 */
export const useMakeSocialMediaAssetPublic = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof makeSocialMediaAssetPublic>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof makeSocialMediaAssetPublic>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getMakeSocialMediaAssetPublicMutationOptions(options));
    }

export const getListInventoryPhotosForImportUrl = (params?: ListInventoryPhotosForImportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/social/media/inventory-preview?${stringifiedParams}` : `/api/social/media/inventory-preview`
}

/**
 * @summary List inventory items that have photos not yet imported into the Media Library.
 */
export const listInventoryPhotosForImport = async (params?: ListInventoryPhotosForImportParams, options?: RequestInit): Promise<ListInventoryPhotosForImport200> => {

  return customFetch<ListInventoryPhotosForImport200>(getListInventoryPhotosForImportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInventoryPhotosForImportQueryKey = (params?: ListInventoryPhotosForImportParams,) => {
    return [
    `/api/social/media/inventory-preview`, ...(params ? [params] : [])
    ] as const;
    }


export const getListInventoryPhotosForImportQueryOptions = <TData = Awaited<ReturnType<typeof listInventoryPhotosForImport>>, TError = ErrorType<unknown>>(params?: ListInventoryPhotosForImportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventoryPhotosForImport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInventoryPhotosForImportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInventoryPhotosForImport>>> = ({ signal }) => listInventoryPhotosForImport(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInventoryPhotosForImport>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInventoryPhotosForImportQueryResult = NonNullable<Awaited<ReturnType<typeof listInventoryPhotosForImport>>>
export type ListInventoryPhotosForImportQueryError = ErrorType<unknown>


/**
 * @summary List inventory items that have photos not yet imported into the Media Library.
 */

export function useListInventoryPhotosForImport<TData = Awaited<ReturnType<typeof listInventoryPhotosForImport>>, TError = ErrorType<unknown>>(
 params?: ListInventoryPhotosForImportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventoryPhotosForImport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInventoryPhotosForImportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getImportInventoryPhotosUrl = () => {




  return `/api/social/media/import-inventory`
}

/**
 * @summary Register inventory photos as Media Library assets. Pass ids[] for targeted import, or all=true for bulk.
 */
export const importInventoryPhotos = async (importInventoryPhotosBody: ImportInventoryPhotosBody, options?: RequestInit): Promise<ImportInventoryPhotos200> => {

  return customFetch<ImportInventoryPhotos200>(getImportInventoryPhotosUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(importInventoryPhotosBody)
  }
);}





export const getImportInventoryPhotosMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importInventoryPhotos>>, TError,{data: BodyType<ImportInventoryPhotosBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importInventoryPhotos>>, TError,{data: BodyType<ImportInventoryPhotosBody>}, TContext> => {

const mutationKey = ['importInventoryPhotos'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importInventoryPhotos>>, {data: BodyType<ImportInventoryPhotosBody>}> = (props) => {
          const {data} = props ?? {};

          return  importInventoryPhotos(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportInventoryPhotosMutationResult = NonNullable<Awaited<ReturnType<typeof importInventoryPhotos>>>
    export type ImportInventoryPhotosMutationBody = BodyType<ImportInventoryPhotosBody>
    export type ImportInventoryPhotosMutationError = ErrorType<unknown>

    /**
 * @summary Register inventory photos as Media Library assets. Pass ids[] for targeted import, or all=true for bulk.
 */
export const useImportInventoryPhotos = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importInventoryPhotos>>, TError,{data: BodyType<ImportInventoryPhotosBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importInventoryPhotos>>,
        TError,
        {data: BodyType<ImportInventoryPhotosBody>},
        TContext
      > => {
      return useMutation(getImportInventoryPhotosMutationOptions(options));
    }

export const getListSocialCampaignsUrl = (params?: ListSocialCampaignsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/social/campaigns?${stringifiedParams}` : `/api/social/campaigns`
}

/**
 * @summary List campaigns (active by default).
 */
export const listSocialCampaigns = async (params?: ListSocialCampaignsParams, options?: RequestInit): Promise<SocialCampaign[]> => {

  return customFetch<SocialCampaign[]>(getListSocialCampaignsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSocialCampaignsQueryKey = (params?: ListSocialCampaignsParams,) => {
    return [
    `/api/social/campaigns`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSocialCampaignsQueryOptions = <TData = Awaited<ReturnType<typeof listSocialCampaigns>>, TError = ErrorType<unknown>>(params?: ListSocialCampaignsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialCampaigns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSocialCampaignsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSocialCampaigns>>> = ({ signal }) => listSocialCampaigns(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSocialCampaigns>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSocialCampaignsQueryResult = NonNullable<Awaited<ReturnType<typeof listSocialCampaigns>>>
export type ListSocialCampaignsQueryError = ErrorType<unknown>


/**
 * @summary List campaigns (active by default).
 */

export function useListSocialCampaigns<TData = Awaited<ReturnType<typeof listSocialCampaigns>>, TError = ErrorType<unknown>>(
 params?: ListSocialCampaignsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSocialCampaigns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSocialCampaignsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateSocialCampaignUrl = () => {




  return `/api/social/campaigns`
}

/**
 * @summary Create a campaign.
 */
export const createSocialCampaign = async (socialCampaignCreate: SocialCampaignCreate, options?: RequestInit): Promise<SocialCampaign> => {

  return customFetch<SocialCampaign>(getCreateSocialCampaignUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(socialCampaignCreate)
  }
);}





export const getCreateSocialCampaignMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSocialCampaign>>, TError,{data: BodyType<SocialCampaignCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSocialCampaign>>, TError,{data: BodyType<SocialCampaignCreate>}, TContext> => {

const mutationKey = ['createSocialCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSocialCampaign>>, {data: BodyType<SocialCampaignCreate>}> = (props) => {
          const {data} = props ?? {};

          return  createSocialCampaign(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSocialCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof createSocialCampaign>>>
    export type CreateSocialCampaignMutationBody = BodyType<SocialCampaignCreate>
    export type CreateSocialCampaignMutationError = ErrorType<unknown>

    /**
 * @summary Create a campaign.
 */
export const useCreateSocialCampaign = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSocialCampaign>>, TError,{data: BodyType<SocialCampaignCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSocialCampaign>>,
        TError,
        {data: BodyType<SocialCampaignCreate>},
        TContext
      > => {
      return useMutation(getCreateSocialCampaignMutationOptions(options));
    }

export const getGetSocialCampaignUrl = (id: string,) => {




  return `/api/social/campaigns/${id}`
}

/**
 * @summary Get a single campaign.
 */
export const getSocialCampaign = async (id: string, options?: RequestInit): Promise<SocialCampaign> => {

  return customFetch<SocialCampaign>(getGetSocialCampaignUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSocialCampaignQueryKey = (id: string,) => {
    return [
    `/api/social/campaigns/${id}`
    ] as const;
    }


export const getGetSocialCampaignQueryOptions = <TData = Awaited<ReturnType<typeof getSocialCampaign>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialCampaign>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocialCampaignQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocialCampaign>>> = ({ signal }) => getSocialCampaign(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSocialCampaign>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSocialCampaignQueryResult = NonNullable<Awaited<ReturnType<typeof getSocialCampaign>>>
export type GetSocialCampaignQueryError = ErrorType<unknown>


/**
 * @summary Get a single campaign.
 */

export function useGetSocialCampaign<TData = Awaited<ReturnType<typeof getSocialCampaign>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSocialCampaign>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSocialCampaignQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateSocialCampaignUrl = (id: string,) => {




  return `/api/social/campaigns/${id}`
}

/**
 * @summary Update a campaign.
 */
export const updateSocialCampaign = async (id: string,
    socialCampaignUpdate: SocialCampaignUpdate, options?: RequestInit): Promise<SocialCampaign> => {

  return customFetch<SocialCampaign>(getUpdateSocialCampaignUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(socialCampaignUpdate)
  }
);}





export const getUpdateSocialCampaignMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSocialCampaign>>, TError,{id: string;data: BodyType<SocialCampaignUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSocialCampaign>>, TError,{id: string;data: BodyType<SocialCampaignUpdate>}, TContext> => {

const mutationKey = ['updateSocialCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSocialCampaign>>, {id: string;data: BodyType<SocialCampaignUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSocialCampaign(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSocialCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof updateSocialCampaign>>>
    export type UpdateSocialCampaignMutationBody = BodyType<SocialCampaignUpdate>
    export type UpdateSocialCampaignMutationError = ErrorType<unknown>

    /**
 * @summary Update a campaign.
 */
export const useUpdateSocialCampaign = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSocialCampaign>>, TError,{id: string;data: BodyType<SocialCampaignUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSocialCampaign>>,
        TError,
        {id: string;data: BodyType<SocialCampaignUpdate>},
        TContext
      > => {
      return useMutation(getUpdateSocialCampaignMutationOptions(options));
    }

export const getDeleteSocialCampaignUrl = (id: string,) => {




  return `/api/social/campaigns/${id}`
}

/**
 * @summary Delete a campaign (soft-delete by setting status to archived).
 */
export const deleteSocialCampaign = async (id: string, options?: RequestInit): Promise<DeleteSocialCampaign200> => {

  return customFetch<DeleteSocialCampaign200>(getDeleteSocialCampaignUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteSocialCampaignMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSocialCampaign>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSocialCampaign>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteSocialCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSocialCampaign>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteSocialCampaign(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSocialCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSocialCampaign>>>

    export type DeleteSocialCampaignMutationError = ErrorType<unknown>

    /**
 * @summary Delete a campaign (soft-delete by setting status to archived).
 */
export const useDeleteSocialCampaign = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSocialCampaign>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSocialCampaign>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteSocialCampaignMutationOptions(options));
    }

export const getGetDashboardAlertsUrl = () => {




  return `/api/dashboard/alerts`
}

/**
 * @summary Inventory alerts (missing data, unpaid, etc.)
 */
export const getDashboardAlerts = async ( options?: RequestInit): Promise<AlertsSummary> => {

  return customFetch<AlertsSummary>(getGetDashboardAlertsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDashboardAlertsQueryKey = () => {
    return [
    `/api/dashboard/alerts`
    ] as const;
    }


export const getGetDashboardAlertsQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardAlerts>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardAlerts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardAlertsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardAlerts>>> = ({ signal }) => getDashboardAlerts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardAlerts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardAlertsQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardAlerts>>>
export type GetDashboardAlertsQueryError = ErrorType<unknown>


/**
 * @summary Inventory alerts (missing data, unpaid, etc.)
 */

export function useGetDashboardAlerts<TData = Awaited<ReturnType<typeof getDashboardAlerts>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardAlerts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDashboardAlertsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListEbaySyncIssuesUrl = (params?: ListEbaySyncIssuesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/ebay-sync-issues?${stringifiedParams}` : `/api/admin/ebay-sync-issues`
}

/**
 * @summary List eBay live-sync failures (triage queue)
 */
export const listEbaySyncIssues = async (params?: ListEbaySyncIssuesParams, options?: RequestInit): Promise<EbaySyncIssuesList> => {

  return customFetch<EbaySyncIssuesList>(getListEbaySyncIssuesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEbaySyncIssuesQueryKey = (params?: ListEbaySyncIssuesParams,) => {
    return [
    `/api/admin/ebay-sync-issues`, ...(params ? [params] : [])
    ] as const;
    }


export const getListEbaySyncIssuesQueryOptions = <TData = Awaited<ReturnType<typeof listEbaySyncIssues>>, TError = ErrorType<unknown>>(params?: ListEbaySyncIssuesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEbaySyncIssues>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEbaySyncIssuesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEbaySyncIssues>>> = ({ signal }) => listEbaySyncIssues(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEbaySyncIssues>>, TError, TData> & { queryKey: QueryKey }
}

export type ListEbaySyncIssuesQueryResult = NonNullable<Awaited<ReturnType<typeof listEbaySyncIssues>>>
export type ListEbaySyncIssuesQueryError = ErrorType<unknown>


/**
 * @summary List eBay live-sync failures (triage queue)
 */

export function useListEbaySyncIssues<TData = Awaited<ReturnType<typeof listEbaySyncIssues>>, TError = ErrorType<unknown>>(
 params?: ListEbaySyncIssuesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEbaySyncIssues>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListEbaySyncIssuesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSkipEbaySyncIssuesUrl = () => {




  return `/api/admin/ebay-sync-issues/skip`
}

/**
 * @summary Permanently skip the given eBay sync issues
 */
export const skipEbaySyncIssues = async (ebaySyncIssueBulkBody: EbaySyncIssueBulkBody, options?: RequestInit): Promise<EbaySyncIssueBulkResult> => {

  return customFetch<EbaySyncIssueBulkResult>(getSkipEbaySyncIssuesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ebaySyncIssueBulkBody)
  }
);}





export const getSkipEbaySyncIssuesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipEbaySyncIssues>>, TError,{data: BodyType<EbaySyncIssueBulkBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof skipEbaySyncIssues>>, TError,{data: BodyType<EbaySyncIssueBulkBody>}, TContext> => {

const mutationKey = ['skipEbaySyncIssues'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof skipEbaySyncIssues>>, {data: BodyType<EbaySyncIssueBulkBody>}> = (props) => {
          const {data} = props ?? {};

          return  skipEbaySyncIssues(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SkipEbaySyncIssuesMutationResult = NonNullable<Awaited<ReturnType<typeof skipEbaySyncIssues>>>
    export type SkipEbaySyncIssuesMutationBody = BodyType<EbaySyncIssueBulkBody>
    export type SkipEbaySyncIssuesMutationError = ErrorType<unknown>

    /**
 * @summary Permanently skip the given eBay sync issues
 */
export const useSkipEbaySyncIssues = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipEbaySyncIssues>>, TError,{data: BodyType<EbaySyncIssueBulkBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof skipEbaySyncIssues>>,
        TError,
        {data: BodyType<EbaySyncIssueBulkBody>},
        TContext
      > => {
      return useMutation(getSkipEbaySyncIssuesMutationOptions(options));
    }

export const getRetryEbaySyncIssuesUrl = () => {




  return `/api/admin/ebay-sync-issues/retry`
}

/**
 * @summary Reset eBay sync issues to pending so the next tick re-attempts them
 */
export const retryEbaySyncIssues = async (ebaySyncIssueBulkBody: EbaySyncIssueBulkBody, options?: RequestInit): Promise<EbaySyncIssueBulkResult> => {

  return customFetch<EbaySyncIssueBulkResult>(getRetryEbaySyncIssuesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ebaySyncIssueBulkBody)
  }
);}





export const getRetryEbaySyncIssuesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryEbaySyncIssues>>, TError,{data: BodyType<EbaySyncIssueBulkBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof retryEbaySyncIssues>>, TError,{data: BodyType<EbaySyncIssueBulkBody>}, TContext> => {

const mutationKey = ['retryEbaySyncIssues'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryEbaySyncIssues>>, {data: BodyType<EbaySyncIssueBulkBody>}> = (props) => {
          const {data} = props ?? {};

          return  retryEbaySyncIssues(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryEbaySyncIssuesMutationResult = NonNullable<Awaited<ReturnType<typeof retryEbaySyncIssues>>>
    export type RetryEbaySyncIssuesMutationBody = BodyType<EbaySyncIssueBulkBody>
    export type RetryEbaySyncIssuesMutationError = ErrorType<unknown>

    /**
 * @summary Reset eBay sync issues to pending so the next tick re-attempts them
 */
export const useRetryEbaySyncIssues = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryEbaySyncIssues>>, TError,{data: BodyType<EbaySyncIssueBulkBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof retryEbaySyncIssues>>,
        TError,
        {data: BodyType<EbaySyncIssueBulkBody>},
        TContext
      > => {
      return useMutation(getRetryEbaySyncIssuesMutationOptions(options));
    }

export const getRetryEbaySyncIssueUrl = (id: string,) => {




  return `/api/admin/ebay-sync-issues/${id}/retry`
}

/**
 * @summary Immediately retry one pending eBay sync issue
 */
export const retryEbaySyncIssue = async (id: string,
    retryEbaySyncIssueBody?: RetryEbaySyncIssueBody, options?: RequestInit): Promise<EbaySyncIssueRetryResult> => {

  return customFetch<EbaySyncIssueRetryResult>(getRetryEbaySyncIssueUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(retryEbaySyncIssueBody)
  }
);}





export const getRetryEbaySyncIssueMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryEbaySyncIssue>>, TError,{id: string;data?: BodyType<RetryEbaySyncIssueBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof retryEbaySyncIssue>>, TError,{id: string;data?: BodyType<RetryEbaySyncIssueBody>}, TContext> => {

const mutationKey = ['retryEbaySyncIssue'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryEbaySyncIssue>>, {id: string;data?: BodyType<RetryEbaySyncIssueBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  retryEbaySyncIssue(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryEbaySyncIssueMutationResult = NonNullable<Awaited<ReturnType<typeof retryEbaySyncIssue>>>
    export type RetryEbaySyncIssueMutationBody = BodyType<RetryEbaySyncIssueBody> | undefined
    export type RetryEbaySyncIssueMutationError = ErrorType<void>

    /**
 * @summary Immediately retry one pending eBay sync issue
 */
export const useRetryEbaySyncIssue = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryEbaySyncIssue>>, TError,{id: string;data?: BodyType<RetryEbaySyncIssueBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof retryEbaySyncIssue>>,
        TError,
        {id: string;data?: BodyType<RetryEbaySyncIssueBody>},
        TContext
      > => {
      return useMutation(getRetryEbaySyncIssueMutationOptions(options));
    }

export const getResolveEbaySyncIssuesUrl = () => {




  return `/api/admin/ebay-sync-issues/resolve`
}

/**
 * @summary Mark eBay sync issues as resolved (operator handled out-of-band)
 */
export const resolveEbaySyncIssues = async (ebaySyncIssueBulkBody: EbaySyncIssueBulkBody, options?: RequestInit): Promise<EbaySyncIssueBulkResult> => {

  return customFetch<EbaySyncIssueBulkResult>(getResolveEbaySyncIssuesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ebaySyncIssueBulkBody)
  }
);}





export const getResolveEbaySyncIssuesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveEbaySyncIssues>>, TError,{data: BodyType<EbaySyncIssueBulkBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resolveEbaySyncIssues>>, TError,{data: BodyType<EbaySyncIssueBulkBody>}, TContext> => {

const mutationKey = ['resolveEbaySyncIssues'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resolveEbaySyncIssues>>, {data: BodyType<EbaySyncIssueBulkBody>}> = (props) => {
          const {data} = props ?? {};

          return  resolveEbaySyncIssues(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResolveEbaySyncIssuesMutationResult = NonNullable<Awaited<ReturnType<typeof resolveEbaySyncIssues>>>
    export type ResolveEbaySyncIssuesMutationBody = BodyType<EbaySyncIssueBulkBody>
    export type ResolveEbaySyncIssuesMutationError = ErrorType<unknown>

    /**
 * @summary Mark eBay sync issues as resolved (operator handled out-of-band)
 */
export const useResolveEbaySyncIssues = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveEbaySyncIssues>>, TError,{data: BodyType<EbaySyncIssueBulkBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resolveEbaySyncIssues>>,
        TError,
        {data: BodyType<EbaySyncIssueBulkBody>},
        TContext
      > => {
      return useMutation(getResolveEbaySyncIssuesMutationOptions(options));
    }

export const getGetEbaySyncIssueSuggestionsUrl = (id: string,) => {




  return `/api/admin/ebay-sync-issues/${id}/suggestions`
}

/**
 * Reads the issue's raw_payload, finds every line that has no SKU,
 * and runs the title matcher against each. Returns top candidates
 * ranked by confidence. Read-only — does NOT auto-link or persist
 * anything. Operator picks via the UI then calls confirm-mappings.
 * @summary For one blocked eBay order, suggest a SKU per unresolved line
 */
export const getEbaySyncIssueSuggestions = async (id: string, options?: RequestInit): Promise<EbaySyncIssueSuggestionsResult> => {

  return customFetch<EbaySyncIssueSuggestionsResult>(getGetEbaySyncIssueSuggestionsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEbaySyncIssueSuggestionsQueryKey = (id: string,) => {
    return [
    `/api/admin/ebay-sync-issues/${id}/suggestions`
    ] as const;
    }


export const getGetEbaySyncIssueSuggestionsQueryOptions = <TData = Awaited<ReturnType<typeof getEbaySyncIssueSuggestions>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEbaySyncIssueSuggestions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEbaySyncIssueSuggestionsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEbaySyncIssueSuggestions>>> = ({ signal }) => getEbaySyncIssueSuggestions(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEbaySyncIssueSuggestions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEbaySyncIssueSuggestionsQueryResult = NonNullable<Awaited<ReturnType<typeof getEbaySyncIssueSuggestions>>>
export type GetEbaySyncIssueSuggestionsQueryError = ErrorType<void>


/**
 * @summary For one blocked eBay order, suggest a SKU per unresolved line
 */

export function useGetEbaySyncIssueSuggestions<TData = Awaited<ReturnType<typeof getEbaySyncIssueSuggestions>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEbaySyncIssueSuggestions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEbaySyncIssueSuggestionsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getConfirmEbaySyncIssueMappingsUrl = (id: string,) => {




  return `/api/admin/ebay-sync-issues/${id}/confirm-mappings`
}

/**
 * Inserts a `title_mappings` row (source=manual) for each provided
 * mapping then resets the issue to pending so the next sync tick
 * re-imports the order — which now resolves at 100% confidence via
 * the saved mapping.
 * @summary Save operator-confirmed title→SKU mappings then retry the order
 */
export const confirmEbaySyncIssueMappings = async (id: string,
    ebaySyncIssueConfirmMappingsBody: EbaySyncIssueConfirmMappingsBody, options?: RequestInit): Promise<EbaySyncIssueConfirmMappingsResult> => {

  return customFetch<EbaySyncIssueConfirmMappingsResult>(getConfirmEbaySyncIssueMappingsUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ebaySyncIssueConfirmMappingsBody)
  }
);}





export const getConfirmEbaySyncIssueMappingsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmEbaySyncIssueMappings>>, TError,{id: string;data: BodyType<EbaySyncIssueConfirmMappingsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmEbaySyncIssueMappings>>, TError,{id: string;data: BodyType<EbaySyncIssueConfirmMappingsBody>}, TContext> => {

const mutationKey = ['confirmEbaySyncIssueMappings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmEbaySyncIssueMappings>>, {id: string;data: BodyType<EbaySyncIssueConfirmMappingsBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  confirmEbaySyncIssueMappings(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmEbaySyncIssueMappingsMutationResult = NonNullable<Awaited<ReturnType<typeof confirmEbaySyncIssueMappings>>>
    export type ConfirmEbaySyncIssueMappingsMutationBody = BodyType<EbaySyncIssueConfirmMappingsBody>
    export type ConfirmEbaySyncIssueMappingsMutationError = ErrorType<void>

    /**
 * @summary Save operator-confirmed title→SKU mappings then retry the order
 */
export const useConfirmEbaySyncIssueMappings = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmEbaySyncIssueMappings>>, TError,{id: string;data: BodyType<EbaySyncIssueConfirmMappingsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof confirmEbaySyncIssueMappings>>,
        TError,
        {id: string;data: BodyType<EbaySyncIssueConfirmMappingsBody>},
        TContext
      > => {
      return useMutation(getConfirmEbaySyncIssueMappingsMutationOptions(options));
    }

export const getDiagnoseEbayPullUrl = () => {




  return `/api/admin/ebay-sync-issues/diagnose-pull`
}

/**
 * Step-4 diagnostic for under-reporting investigations. Bypasses every
 * layer of our sync logic so a "0 orders" result here proves the data
 * isn't on eBay's side, while a non-zero count proves our cursor is
 * stuck. Defaults to a 24-hour window when sinceISO is omitted.
 * @summary Call eBay /sell/fulfillment/v1/order directly and report what's there
 */
export const diagnoseEbayPull = async (ebayDiagnosePullBody?: EbayDiagnosePullBody, options?: RequestInit): Promise<EbayDiagnosePullResult> => {

  return customFetch<EbayDiagnosePullResult>(getDiagnoseEbayPullUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ebayDiagnosePullBody)
  }
);}





export const getDiagnoseEbayPullMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof diagnoseEbayPull>>, TError,{data?: BodyType<EbayDiagnosePullBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof diagnoseEbayPull>>, TError,{data?: BodyType<EbayDiagnosePullBody>}, TContext> => {

const mutationKey = ['diagnoseEbayPull'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof diagnoseEbayPull>>, {data?: BodyType<EbayDiagnosePullBody>}> = (props) => {
          const {data} = props ?? {};

          return  diagnoseEbayPull(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DiagnoseEbayPullMutationResult = NonNullable<Awaited<ReturnType<typeof diagnoseEbayPull>>>
    export type DiagnoseEbayPullMutationBody = BodyType<EbayDiagnosePullBody> | undefined
    export type DiagnoseEbayPullMutationError = ErrorType<unknown>

    /**
 * @summary Call eBay /sell/fulfillment/v1/order directly and report what's there
 */
export const useDiagnoseEbayPull = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof diagnoseEbayPull>>, TError,{data?: BodyType<EbayDiagnosePullBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof diagnoseEbayPull>>,
        TError,
        {data?: BodyType<EbayDiagnosePullBody>},
        TContext
      > => {
      return useMutation(getDiagnoseEbayPullMutationOptions(options));
    }

export const getGetChannelPerformanceUrl = () => {




  return `/api/dashboard/channel-performance`
}

/**
 * @summary Performance breakdown by sales channel
 */
export const getChannelPerformance = async ( options?: RequestInit): Promise<ChannelPerformance[]> => {

  return customFetch<ChannelPerformance[]>(getGetChannelPerformanceUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetChannelPerformanceQueryKey = () => {
    return [
    `/api/dashboard/channel-performance`
    ] as const;
    }


export const getGetChannelPerformanceQueryOptions = <TData = Awaited<ReturnType<typeof getChannelPerformance>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getChannelPerformance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChannelPerformanceQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChannelPerformance>>> = ({ signal }) => getChannelPerformance({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChannelPerformance>>, TError, TData> & { queryKey: QueryKey }
}

export type GetChannelPerformanceQueryResult = NonNullable<Awaited<ReturnType<typeof getChannelPerformance>>>
export type GetChannelPerformanceQueryError = ErrorType<unknown>


/**
 * @summary Performance breakdown by sales channel
 */

export function useGetChannelPerformance<TData = Awaited<ReturnType<typeof getChannelPerformance>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getChannelPerformance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetChannelPerformanceQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSuppliersUrl = (params?: ListSuppliersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/suppliers?${stringifiedParams}` : `/api/suppliers`
}

export const listSuppliers = async (params?: ListSuppliersParams, options?: RequestInit): Promise<SupplierWithStats[]> => {

  return customFetch<SupplierWithStats[]>(getListSuppliersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSuppliersQueryKey = (params?: ListSuppliersParams,) => {
    return [
    `/api/suppliers`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSuppliersQueryOptions = <TData = Awaited<ReturnType<typeof listSuppliers>>, TError = ErrorType<unknown>>(params?: ListSuppliersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSuppliers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSuppliersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSuppliers>>> = ({ signal }) => listSuppliers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSuppliers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSuppliersQueryResult = NonNullable<Awaited<ReturnType<typeof listSuppliers>>>
export type ListSuppliersQueryError = ErrorType<unknown>



export function useListSuppliers<TData = Awaited<ReturnType<typeof listSuppliers>>, TError = ErrorType<unknown>>(
 params?: ListSuppliersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSuppliers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSuppliersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateSupplierUrl = () => {




  return `/api/suppliers`
}

export const createSupplier = async (supplierInput: SupplierInput, options?: RequestInit): Promise<Supplier> => {

  return customFetch<Supplier>(getCreateSupplierUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(supplierInput)
  }
);}





export const getCreateSupplierMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSupplier>>, TError,{data: BodyType<SupplierInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSupplier>>, TError,{data: BodyType<SupplierInput>}, TContext> => {

const mutationKey = ['createSupplier'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSupplier>>, {data: BodyType<SupplierInput>}> = (props) => {
          const {data} = props ?? {};

          return  createSupplier(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSupplierMutationResult = NonNullable<Awaited<ReturnType<typeof createSupplier>>>
    export type CreateSupplierMutationBody = BodyType<SupplierInput>
    export type CreateSupplierMutationError = ErrorType<unknown>

    export const useCreateSupplier = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSupplier>>, TError,{data: BodyType<SupplierInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSupplier>>,
        TError,
        {data: BodyType<SupplierInput>},
        TContext
      > => {
      return useMutation(getCreateSupplierMutationOptions(options));
    }

export const getGetSupplierUrl = (id: string,) => {




  return `/api/suppliers/${id}`
}

export const getSupplier = async (id: string, options?: RequestInit): Promise<SupplierDetail> => {

  return customFetch<SupplierDetail>(getGetSupplierUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSupplierQueryKey = (id: string,) => {
    return [
    `/api/suppliers/${id}`
    ] as const;
    }


export const getGetSupplierQueryOptions = <TData = Awaited<ReturnType<typeof getSupplier>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupplier>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupplierQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupplier>>> = ({ signal }) => getSupplier(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupplier>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupplierQueryResult = NonNullable<Awaited<ReturnType<typeof getSupplier>>>
export type GetSupplierQueryError = ErrorType<unknown>



export function useGetSupplier<TData = Awaited<ReturnType<typeof getSupplier>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupplier>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSupplierQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateSupplierUrl = (id: string,) => {




  return `/api/suppliers/${id}`
}

export const updateSupplier = async (id: string,
    supplierInput: SupplierInput, options?: RequestInit): Promise<Supplier> => {

  return customFetch<Supplier>(getUpdateSupplierUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(supplierInput)
  }
);}





export const getUpdateSupplierMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSupplier>>, TError,{id: string;data: BodyType<SupplierInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSupplier>>, TError,{id: string;data: BodyType<SupplierInput>}, TContext> => {

const mutationKey = ['updateSupplier'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSupplier>>, {id: string;data: BodyType<SupplierInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSupplier(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSupplierMutationResult = NonNullable<Awaited<ReturnType<typeof updateSupplier>>>
    export type UpdateSupplierMutationBody = BodyType<SupplierInput>
    export type UpdateSupplierMutationError = ErrorType<unknown>

    export const useUpdateSupplier = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSupplier>>, TError,{id: string;data: BodyType<SupplierInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSupplier>>,
        TError,
        {id: string;data: BodyType<SupplierInput>},
        TContext
      > => {
      return useMutation(getUpdateSupplierMutationOptions(options));
    }

export const getDeleteSupplierUrl = (id: string,) => {




  return `/api/suppliers/${id}`
}

export const deleteSupplier = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteSupplierUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteSupplierMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSupplier>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSupplier>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteSupplier'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSupplier>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteSupplier(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSupplierMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSupplier>>>

    export type DeleteSupplierMutationError = ErrorType<unknown>

    export const useDeleteSupplier = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSupplier>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSupplier>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteSupplierMutationOptions(options));
    }

export const getGetSupplierDirectoryUrl = (params?: GetSupplierDirectoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/suppliers/directory?${stringifiedParams}` : `/api/suppliers/directory`
}

/**
 * @summary Read the prepared, paginated supplier performance directory
 */
export const getSupplierDirectory = async (params?: GetSupplierDirectoryParams, options?: RequestInit): Promise<SupplierDirectoryPage> => {

  return customFetch<SupplierDirectoryPage>(getGetSupplierDirectoryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSupplierDirectoryQueryKey = (params?: GetSupplierDirectoryParams,) => {
    return [
    `/api/suppliers/directory`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSupplierDirectoryQueryOptions = <TData = Awaited<ReturnType<typeof getSupplierDirectory>>, TError = ErrorType<unknown>>(params?: GetSupplierDirectoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupplierDirectory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupplierDirectoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupplierDirectory>>> = ({ signal }) => getSupplierDirectory(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupplierDirectory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupplierDirectoryQueryResult = NonNullable<Awaited<ReturnType<typeof getSupplierDirectory>>>
export type GetSupplierDirectoryQueryError = ErrorType<unknown>


/**
 * @summary Read the prepared, paginated supplier performance directory
 */

export function useGetSupplierDirectory<TData = Awaited<ReturnType<typeof getSupplierDirectory>>, TError = ErrorType<unknown>>(
 params?: GetSupplierDirectoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupplierDirectory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSupplierDirectoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportSupplierDirectoryUrl = (params?: ExportSupplierDirectoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/suppliers/directory/export?${stringifiedParams}` : `/api/suppliers/directory/export`
}

/**
 * @summary Export a bounded, finance-redacted supplier directory CSV
 */
export const exportSupplierDirectory = async (params?: ExportSupplierDirectoryParams, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getExportSupplierDirectoryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportSupplierDirectoryQueryKey = (params?: ExportSupplierDirectoryParams,) => {
    return [
    `/api/suppliers/directory/export`, ...(params ? [params] : [])
    ] as const;
    }


export const getExportSupplierDirectoryQueryOptions = <TData = Awaited<ReturnType<typeof exportSupplierDirectory>>, TError = ErrorType<unknown>>(params?: ExportSupplierDirectoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportSupplierDirectory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportSupplierDirectoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportSupplierDirectory>>> = ({ signal }) => exportSupplierDirectory(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportSupplierDirectory>>, TError, TData> & { queryKey: QueryKey }
}

export type ExportSupplierDirectoryQueryResult = NonNullable<Awaited<ReturnType<typeof exportSupplierDirectory>>>
export type ExportSupplierDirectoryQueryError = ErrorType<unknown>


/**
 * @summary Export a bounded, finance-redacted supplier directory CSV
 */

export function useExportSupplierDirectory<TData = Awaited<ReturnType<typeof exportSupplierDirectory>>, TError = ErrorType<unknown>>(
 params?: ExportSupplierDirectoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportSupplierDirectory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getExportSupplierDirectoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSupplierSummaryUrl = (id: string,) => {




  return `/api/suppliers/${id}/summary`
}

/**
 * @summary Compact prepared supplier overview and recent monthly facts
 */
export const getSupplierSummary = async (id: string, options?: RequestInit): Promise<SupplierSummaryResponse> => {

  return customFetch<SupplierSummaryResponse>(getGetSupplierSummaryUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSupplierSummaryQueryKey = (id: string,) => {
    return [
    `/api/suppliers/${id}/summary`
    ] as const;
    }


export const getGetSupplierSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getSupplierSummary>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupplierSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupplierSummaryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupplierSummary>>> = ({ signal }) => getSupplierSummary(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupplierSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupplierSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getSupplierSummary>>>
export type GetSupplierSummaryQueryError = ErrorType<unknown>


/**
 * @summary Compact prepared supplier overview and recent monthly facts
 */

export function useGetSupplierSummary<TData = Awaited<ReturnType<typeof getSupplierSummary>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupplierSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSupplierSummaryQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSupplierMonthlySummariesUrl = (id: string,
    params?: ListSupplierMonthlySummariesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/suppliers/${id}/monthly?${stringifiedParams}` : `/api/suppliers/${id}/monthly`
}

/**
 * @summary Paginated prepared supplier monthly statistics
 */
export const listSupplierMonthlySummaries = async (id: string,
    params?: ListSupplierMonthlySummariesParams, options?: RequestInit): Promise<SupplierMonthlyPage> => {

  return customFetch<SupplierMonthlyPage>(getListSupplierMonthlySummariesUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSupplierMonthlySummariesQueryKey = (id: string,
    params?: ListSupplierMonthlySummariesParams,) => {
    return [
    `/api/suppliers/${id}/monthly`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSupplierMonthlySummariesQueryOptions = <TData = Awaited<ReturnType<typeof listSupplierMonthlySummaries>>, TError = ErrorType<unknown>>(id: string,
    params?: ListSupplierMonthlySummariesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSupplierMonthlySummaries>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSupplierMonthlySummariesQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSupplierMonthlySummaries>>> = ({ signal }) => listSupplierMonthlySummaries(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSupplierMonthlySummaries>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSupplierMonthlySummariesQueryResult = NonNullable<Awaited<ReturnType<typeof listSupplierMonthlySummaries>>>
export type ListSupplierMonthlySummariesQueryError = ErrorType<unknown>


/**
 * @summary Paginated prepared supplier monthly statistics
 */

export function useListSupplierMonthlySummaries<TData = Awaited<ReturnType<typeof listSupplierMonthlySummaries>>, TError = ErrorType<unknown>>(
 id: string,
    params?: ListSupplierMonthlySummariesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSupplierMonthlySummaries>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSupplierMonthlySummariesQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSupplierPurchaseOrdersUrl = (id: string,
    params?: ListSupplierPurchaseOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/suppliers/${id}/purchase-orders?${stringifiedParams}` : `/api/suppliers/${id}/purchase-orders`
}

/**
 * @summary Lazy paginated authoritative purchase orders for a supplier
 */
export const listSupplierPurchaseOrders = async (id: string,
    params?: ListSupplierPurchaseOrdersParams, options?: RequestInit): Promise<SupplierPurchaseOrderPage> => {

  return customFetch<SupplierPurchaseOrderPage>(getListSupplierPurchaseOrdersUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSupplierPurchaseOrdersQueryKey = (id: string,
    params?: ListSupplierPurchaseOrdersParams,) => {
    return [
    `/api/suppliers/${id}/purchase-orders`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSupplierPurchaseOrdersQueryOptions = <TData = Awaited<ReturnType<typeof listSupplierPurchaseOrders>>, TError = ErrorType<unknown>>(id: string,
    params?: ListSupplierPurchaseOrdersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSupplierPurchaseOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSupplierPurchaseOrdersQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSupplierPurchaseOrders>>> = ({ signal }) => listSupplierPurchaseOrders(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSupplierPurchaseOrders>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSupplierPurchaseOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof listSupplierPurchaseOrders>>>
export type ListSupplierPurchaseOrdersQueryError = ErrorType<unknown>


/**
 * @summary Lazy paginated authoritative purchase orders for a supplier
 */

export function useListSupplierPurchaseOrders<TData = Awaited<ReturnType<typeof listSupplierPurchaseOrders>>, TError = ErrorType<unknown>>(
 id: string,
    params?: ListSupplierPurchaseOrdersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSupplierPurchaseOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSupplierPurchaseOrdersQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSupplierProductsUrl = (id: string,
    params?: ListSupplierProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/suppliers/${id}/products?${stringifiedParams}` : `/api/suppliers/${id}/products`
}

/**
 * @summary Lazy paginated authoritative supplier PO products
 */
export const listSupplierProducts = async (id: string,
    params?: ListSupplierProductsParams, options?: RequestInit): Promise<SupplierProductPage> => {

  return customFetch<SupplierProductPage>(getListSupplierProductsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSupplierProductsQueryKey = (id: string,
    params?: ListSupplierProductsParams,) => {
    return [
    `/api/suppliers/${id}/products`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSupplierProductsQueryOptions = <TData = Awaited<ReturnType<typeof listSupplierProducts>>, TError = ErrorType<unknown>>(id: string,
    params?: ListSupplierProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSupplierProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSupplierProductsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSupplierProducts>>> = ({ signal }) => listSupplierProducts(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSupplierProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSupplierProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listSupplierProducts>>>
export type ListSupplierProductsQueryError = ErrorType<unknown>


/**
 * @summary Lazy paginated authoritative supplier PO products
 */

export function useListSupplierProducts<TData = Awaited<ReturnType<typeof listSupplierProducts>>, TError = ErrorType<unknown>>(
 id: string,
    params?: ListSupplierProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSupplierProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSupplierProductsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSupplierPricingUrl = (id: string,
    params?: ListSupplierPricingParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/suppliers/${id}/pricing?${stringifiedParams}` : `/api/suppliers/${id}/pricing`
}

/**
 * @summary Lazy paginated supplier pricing facts
 */
export const listSupplierPricing = async (id: string,
    params?: ListSupplierPricingParams, options?: RequestInit): Promise<SupplierPricingPage> => {

  return customFetch<SupplierPricingPage>(getListSupplierPricingUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSupplierPricingQueryKey = (id: string,
    params?: ListSupplierPricingParams,) => {
    return [
    `/api/suppliers/${id}/pricing`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSupplierPricingQueryOptions = <TData = Awaited<ReturnType<typeof listSupplierPricing>>, TError = ErrorType<unknown>>(id: string,
    params?: ListSupplierPricingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSupplierPricing>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSupplierPricingQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSupplierPricing>>> = ({ signal }) => listSupplierPricing(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSupplierPricing>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSupplierPricingQueryResult = NonNullable<Awaited<ReturnType<typeof listSupplierPricing>>>
export type ListSupplierPricingQueryError = ErrorType<unknown>


/**
 * @summary Lazy paginated supplier pricing facts
 */

export function useListSupplierPricing<TData = Awaited<ReturnType<typeof listSupplierPricing>>, TError = ErrorType<unknown>>(
 id: string,
    params?: ListSupplierPricingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSupplierPricing>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSupplierPricingQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSupplierDocumentsUrl = (id: string,
    params?: ListSupplierDocumentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/suppliers/${id}/documents?${stringifiedParams}` : `/api/suppliers/${id}/documents`
}

/**
 * @summary Lazy paginated supplier documents
 */
export const listSupplierDocuments = async (id: string,
    params?: ListSupplierDocumentsParams, options?: RequestInit): Promise<SupplierDocumentPage> => {

  return customFetch<SupplierDocumentPage>(getListSupplierDocumentsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSupplierDocumentsQueryKey = (id: string,
    params?: ListSupplierDocumentsParams,) => {
    return [
    `/api/suppliers/${id}/documents`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSupplierDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof listSupplierDocuments>>, TError = ErrorType<unknown>>(id: string,
    params?: ListSupplierDocumentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSupplierDocuments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSupplierDocumentsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSupplierDocuments>>> = ({ signal }) => listSupplierDocuments(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSupplierDocuments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSupplierDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listSupplierDocuments>>>
export type ListSupplierDocumentsQueryError = ErrorType<unknown>


/**
 * @summary Lazy paginated supplier documents
 */

export function useListSupplierDocuments<TData = Awaited<ReturnType<typeof listSupplierDocuments>>, TError = ErrorType<unknown>>(
 id: string,
    params?: ListSupplierDocumentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSupplierDocuments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSupplierDocumentsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSupplierConsignmentUrl = (id: string,
    params?: ListSupplierConsignmentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/suppliers/${id}/consignment?${stringifiedParams}` : `/api/suppliers/${id}/consignment`
}

/**
 * @summary Lazy paginated authoritative consignment stock for a supplier
 */
export const listSupplierConsignment = async (id: string,
    params?: ListSupplierConsignmentParams, options?: RequestInit): Promise<SupplierConsignmentPage> => {

  return customFetch<SupplierConsignmentPage>(getListSupplierConsignmentUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSupplierConsignmentQueryKey = (id: string,
    params?: ListSupplierConsignmentParams,) => {
    return [
    `/api/suppliers/${id}/consignment`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSupplierConsignmentQueryOptions = <TData = Awaited<ReturnType<typeof listSupplierConsignment>>, TError = ErrorType<unknown>>(id: string,
    params?: ListSupplierConsignmentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSupplierConsignment>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSupplierConsignmentQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSupplierConsignment>>> = ({ signal }) => listSupplierConsignment(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSupplierConsignment>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSupplierConsignmentQueryResult = NonNullable<Awaited<ReturnType<typeof listSupplierConsignment>>>
export type ListSupplierConsignmentQueryError = ErrorType<unknown>


/**
 * @summary Lazy paginated authoritative consignment stock for a supplier
 */

export function useListSupplierConsignment<TData = Awaited<ReturnType<typeof listSupplierConsignment>>, TError = ErrorType<unknown>>(
 id: string,
    params?: ListSupplierConsignmentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSupplierConsignment>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSupplierConsignmentQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSupplierSettingsUrl = (id: string,) => {




  return `/api/suppliers/${id}/settings`
}

/**
 * @summary Lazy supplier operational settings
 */
export const getSupplierSettings = async (id: string, options?: RequestInit): Promise<SupplierSettings> => {

  return customFetch<SupplierSettings>(getGetSupplierSettingsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSupplierSettingsQueryKey = (id: string,) => {
    return [
    `/api/suppliers/${id}/settings`
    ] as const;
    }


export const getGetSupplierSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getSupplierSettings>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupplierSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupplierSettingsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupplierSettings>>> = ({ signal }) => getSupplierSettings(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupplierSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupplierSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSupplierSettings>>>
export type GetSupplierSettingsQueryError = ErrorType<unknown>


/**
 * @summary Lazy supplier operational settings
 */

export function useGetSupplierSettings<TData = Awaited<ReturnType<typeof getSupplierSettings>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupplierSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSupplierSettingsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPurchaseOrdersUrl = (params?: ListPurchaseOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/purchase-orders?${stringifiedParams}` : `/api/purchase-orders`
}

export const listPurchaseOrders = async (params?: ListPurchaseOrdersParams, options?: RequestInit): Promise<PurchaseOrderListItem[]> => {

  return customFetch<PurchaseOrderListItem[]>(getListPurchaseOrdersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPurchaseOrdersQueryKey = (params?: ListPurchaseOrdersParams,) => {
    return [
    `/api/purchase-orders`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPurchaseOrdersQueryOptions = <TData = Awaited<ReturnType<typeof listPurchaseOrders>>, TError = ErrorType<unknown>>(params?: ListPurchaseOrdersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchaseOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPurchaseOrdersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPurchaseOrders>>> = ({ signal }) => listPurchaseOrders(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPurchaseOrders>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPurchaseOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof listPurchaseOrders>>>
export type ListPurchaseOrdersQueryError = ErrorType<unknown>



export function useListPurchaseOrders<TData = Awaited<ReturnType<typeof listPurchaseOrders>>, TError = ErrorType<unknown>>(
 params?: ListPurchaseOrdersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchaseOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPurchaseOrdersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreatePurchaseOrderUrl = () => {




  return `/api/purchase-orders`
}

export const createPurchaseOrder = async (purchaseOrderInput: PurchaseOrderInput, options?: RequestInit): Promise<PurchaseOrderDetail> => {

  return customFetch<PurchaseOrderDetail>(getCreatePurchaseOrderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(purchaseOrderInput)
  }
);}





export const getCreatePurchaseOrderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPurchaseOrder>>, TError,{data: BodyType<PurchaseOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPurchaseOrder>>, TError,{data: BodyType<PurchaseOrderInput>}, TContext> => {

const mutationKey = ['createPurchaseOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPurchaseOrder>>, {data: BodyType<PurchaseOrderInput>}> = (props) => {
          const {data} = props ?? {};

          return  createPurchaseOrder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePurchaseOrderMutationResult = NonNullable<Awaited<ReturnType<typeof createPurchaseOrder>>>
    export type CreatePurchaseOrderMutationBody = BodyType<PurchaseOrderInput>
    export type CreatePurchaseOrderMutationError = ErrorType<unknown>

    export const useCreatePurchaseOrder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPurchaseOrder>>, TError,{data: BodyType<PurchaseOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPurchaseOrder>>,
        TError,
        {data: BodyType<PurchaseOrderInput>},
        TContext
      > => {
      return useMutation(getCreatePurchaseOrderMutationOptions(options));
    }

export const getCombinePurchaseOrdersUrl = () => {




  return `/api/purchase-orders/combine`
}

/**
 * Creates a new purchase order with an auto-generated PO number that
 * owns ALL line items + invoices from the source POs. Costs are summed,
 * notes / tracking / invoice numbers concatenated, dates take the
 * earliest (purchaseDate) or latest (delivery / paid / landed), status
 * takes the most-advanced. Source POs are then deleted in the same
 * transaction. Refuses (409) if any source PO is linked to a Shipment
 * Group or is in Cancelled status.
 * @summary Merge 2+ POs (same supplier + currency) into ONE new PO
 */
export const combinePurchaseOrders = async (combinePurchaseOrdersInput: CombinePurchaseOrdersInput, options?: RequestInit): Promise<CombinedPurchaseOrderResult> => {

  return customFetch<CombinedPurchaseOrderResult>(getCombinePurchaseOrdersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(combinePurchaseOrdersInput)
  }
);}





export const getCombinePurchaseOrdersMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof combinePurchaseOrders>>, TError,{data: BodyType<CombinePurchaseOrdersInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof combinePurchaseOrders>>, TError,{data: BodyType<CombinePurchaseOrdersInput>}, TContext> => {

const mutationKey = ['combinePurchaseOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof combinePurchaseOrders>>, {data: BodyType<CombinePurchaseOrdersInput>}> = (props) => {
          const {data} = props ?? {};

          return  combinePurchaseOrders(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CombinePurchaseOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof combinePurchaseOrders>>>
    export type CombinePurchaseOrdersMutationBody = BodyType<CombinePurchaseOrdersInput>
    export type CombinePurchaseOrdersMutationError = ErrorType<void>

    /**
 * @summary Merge 2+ POs (same supplier + currency) into ONE new PO
 */
export const useCombinePurchaseOrders = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof combinePurchaseOrders>>, TError,{data: BodyType<CombinePurchaseOrdersInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof combinePurchaseOrders>>,
        TError,
        {data: BodyType<CombinePurchaseOrdersInput>},
        TContext
      > => {
      return useMutation(getCombinePurchaseOrdersMutationOptions(options));
    }

export const getGetPurchaseOrderUrl = (id: string,) => {




  return `/api/purchase-orders/${id}`
}

export const getPurchaseOrder = async (id: string, options?: RequestInit): Promise<PurchaseOrderDetail> => {

  return customFetch<PurchaseOrderDetail>(getGetPurchaseOrderUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPurchaseOrderQueryKey = (id: string,) => {
    return [
    `/api/purchase-orders/${id}`
    ] as const;
    }


export const getGetPurchaseOrderQueryOptions = <TData = Awaited<ReturnType<typeof getPurchaseOrder>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPurchaseOrder>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPurchaseOrderQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPurchaseOrder>>> = ({ signal }) => getPurchaseOrder(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPurchaseOrder>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPurchaseOrderQueryResult = NonNullable<Awaited<ReturnType<typeof getPurchaseOrder>>>
export type GetPurchaseOrderQueryError = ErrorType<unknown>



export function useGetPurchaseOrder<TData = Awaited<ReturnType<typeof getPurchaseOrder>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPurchaseOrder>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPurchaseOrderQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdatePurchaseOrderUrl = (id: string,) => {




  return `/api/purchase-orders/${id}`
}

export const updatePurchaseOrder = async (id: string,
    purchaseOrderUpdateInput: PurchaseOrderUpdateInput, options?: RequestInit): Promise<PurchaseOrderDetail> => {

  return customFetch<PurchaseOrderDetail>(getUpdatePurchaseOrderUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(purchaseOrderUpdateInput)
  }
);}





export const getUpdatePurchaseOrderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePurchaseOrder>>, TError,{id: string;data: BodyType<PurchaseOrderUpdateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePurchaseOrder>>, TError,{id: string;data: BodyType<PurchaseOrderUpdateInput>}, TContext> => {

const mutationKey = ['updatePurchaseOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePurchaseOrder>>, {id: string;data: BodyType<PurchaseOrderUpdateInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePurchaseOrder(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePurchaseOrderMutationResult = NonNullable<Awaited<ReturnType<typeof updatePurchaseOrder>>>
    export type UpdatePurchaseOrderMutationBody = BodyType<PurchaseOrderUpdateInput>
    export type UpdatePurchaseOrderMutationError = ErrorType<unknown>

    export const useUpdatePurchaseOrder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePurchaseOrder>>, TError,{id: string;data: BodyType<PurchaseOrderUpdateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePurchaseOrder>>,
        TError,
        {id: string;data: BodyType<PurchaseOrderUpdateInput>},
        TContext
      > => {
      return useMutation(getUpdatePurchaseOrderMutationOptions(options));
    }

export const getDeletePurchaseOrderUrl = (id: string,) => {




  return `/api/purchase-orders/${id}`
}

export const deletePurchaseOrder = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeletePurchaseOrderUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeletePurchaseOrderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePurchaseOrder>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePurchaseOrder>>, TError,{id: string}, TContext> => {

const mutationKey = ['deletePurchaseOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePurchaseOrder>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deletePurchaseOrder(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePurchaseOrderMutationResult = NonNullable<Awaited<ReturnType<typeof deletePurchaseOrder>>>

    export type DeletePurchaseOrderMutationError = ErrorType<unknown>

    export const useDeletePurchaseOrder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePurchaseOrder>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePurchaseOrder>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeletePurchaseOrderMutationOptions(options));
    }

export const getSendPurchaseOrderUrl = (id: string,) => {




  return `/api/purchase-orders/${id}/send`
}

/**
 * @summary Email a PO to its supplier via Gmail
 */
export const sendPurchaseOrder = async (id: string,
    sendPurchaseOrderInput?: SendPurchaseOrderInput, options?: RequestInit): Promise<SendPurchaseOrder200> => {

  return customFetch<SendPurchaseOrder200>(getSendPurchaseOrderUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sendPurchaseOrderInput)
  }
);}





export const getSendPurchaseOrderMutationOptions = <TError = ErrorType<SendPurchaseOrder503>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPurchaseOrder>>, TError,{id: string;data?: BodyType<SendPurchaseOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendPurchaseOrder>>, TError,{id: string;data?: BodyType<SendPurchaseOrderInput>}, TContext> => {

const mutationKey = ['sendPurchaseOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendPurchaseOrder>>, {id: string;data?: BodyType<SendPurchaseOrderInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  sendPurchaseOrder(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendPurchaseOrderMutationResult = NonNullable<Awaited<ReturnType<typeof sendPurchaseOrder>>>
    export type SendPurchaseOrderMutationBody = BodyType<SendPurchaseOrderInput> | undefined
    export type SendPurchaseOrderMutationError = ErrorType<SendPurchaseOrder503>

    /**
 * @summary Email a PO to its supplier via Gmail
 */
export const useSendPurchaseOrder = <TError = ErrorType<SendPurchaseOrder503>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPurchaseOrder>>, TError,{id: string;data?: BodyType<SendPurchaseOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendPurchaseOrder>>,
        TError,
        {id: string;data?: BodyType<SendPurchaseOrderInput>},
        TContext
      > => {
      return useMutation(getSendPurchaseOrderMutationOptions(options));
    }

export const getAppendPurchaseOrderInvoiceUrl = (id: string,) => {




  return `/api/purchase-orders/${id}/invoices`
}

/**
 * Adds another supplier invoice to an existing purchase order so that
 * multiple shipments / invoice numbers from the same supplier (e.g.
 * a Royal Bull combined DHL parcel) live under one PO with shared
 * shipping, VAT and landed-cost. The invoice's items are inserted
 * with `sourceInvoiceId` set to the new invoice. The PO header
 * (supplier, currency, shipping totals, payment status) is NOT
 * modified — those remain shared across all invoices on the PO.
 *
 * Refuses with 409 if the PO is already finalised
 * ("Landed" or "Completed"), or if `invoiceNumber` is provided and
 * another invoice on this PO already uses the same number
 * (case-insensitive). Pass an empty / null `invoiceNumber` to opt
 * out of duplicate detection.
 * @summary Append a new supplier invoice (with its own line items) to an existing PO
 */
export const appendPurchaseOrderInvoice = async (id: string,
    purchaseOrderInvoiceInput: PurchaseOrderInvoiceInput, options?: RequestInit): Promise<PurchaseOrderDetail> => {

  return customFetch<PurchaseOrderDetail>(getAppendPurchaseOrderInvoiceUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(purchaseOrderInvoiceInput)
  }
);}





export const getAppendPurchaseOrderInvoiceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appendPurchaseOrderInvoice>>, TError,{id: string;data: BodyType<PurchaseOrderInvoiceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appendPurchaseOrderInvoice>>, TError,{id: string;data: BodyType<PurchaseOrderInvoiceInput>}, TContext> => {

const mutationKey = ['appendPurchaseOrderInvoice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appendPurchaseOrderInvoice>>, {id: string;data: BodyType<PurchaseOrderInvoiceInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  appendPurchaseOrderInvoice(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppendPurchaseOrderInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof appendPurchaseOrderInvoice>>>
    export type AppendPurchaseOrderInvoiceMutationBody = BodyType<PurchaseOrderInvoiceInput>
    export type AppendPurchaseOrderInvoiceMutationError = ErrorType<void>

    /**
 * @summary Append a new supplier invoice (with its own line items) to an existing PO
 */
export const useAppendPurchaseOrderInvoice = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appendPurchaseOrderInvoice>>, TError,{id: string;data: BodyType<PurchaseOrderInvoiceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof appendPurchaseOrderInvoice>>,
        TError,
        {id: string;data: BodyType<PurchaseOrderInvoiceInput>},
        TContext
      > => {
      return useMutation(getAppendPurchaseOrderInvoiceMutationOptions(options));
    }

export const getAttachPurchaseOrderCurrencyEvidenceUrl = (id: string,) => {




  return `/api/purchase-orders/${id}/currency-evidence`
}

/**
 * Records a PO-scoped conversion rate for comparing a legacy GBP payment
 * with a foreign-currency invoice. The endpoint is idempotent for the
 * same evidence details and never creates a synthetic payment row.
 * @summary Attach authoritative conversion evidence to a purchase order
 */
export const attachPurchaseOrderCurrencyEvidence = async (id: string,
    purchaseOrderCurrencyEvidenceInput: PurchaseOrderCurrencyEvidenceInput, options?: RequestInit): Promise<PurchaseOrderCurrencyEvidence> => {

  return customFetch<PurchaseOrderCurrencyEvidence>(getAttachPurchaseOrderCurrencyEvidenceUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(purchaseOrderCurrencyEvidenceInput)
  }
);}





export const getAttachPurchaseOrderCurrencyEvidenceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attachPurchaseOrderCurrencyEvidence>>, TError,{id: string;data: BodyType<PurchaseOrderCurrencyEvidenceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof attachPurchaseOrderCurrencyEvidence>>, TError,{id: string;data: BodyType<PurchaseOrderCurrencyEvidenceInput>}, TContext> => {

const mutationKey = ['attachPurchaseOrderCurrencyEvidence'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof attachPurchaseOrderCurrencyEvidence>>, {id: string;data: BodyType<PurchaseOrderCurrencyEvidenceInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  attachPurchaseOrderCurrencyEvidence(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AttachPurchaseOrderCurrencyEvidenceMutationResult = NonNullable<Awaited<ReturnType<typeof attachPurchaseOrderCurrencyEvidence>>>
    export type AttachPurchaseOrderCurrencyEvidenceMutationBody = BodyType<PurchaseOrderCurrencyEvidenceInput>
    export type AttachPurchaseOrderCurrencyEvidenceMutationError = ErrorType<void>

    /**
 * @summary Attach authoritative conversion evidence to a purchase order
 */
export const useAttachPurchaseOrderCurrencyEvidence = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attachPurchaseOrderCurrencyEvidence>>, TError,{id: string;data: BodyType<PurchaseOrderCurrencyEvidenceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof attachPurchaseOrderCurrencyEvidence>>,
        TError,
        {id: string;data: BodyType<PurchaseOrderCurrencyEvidenceInput>},
        TContext
      > => {
      return useMutation(getAttachPurchaseOrderCurrencyEvidenceMutationOptions(options));
    }

export const getSetPurchaseOrderLandedCostUrl = (id: string,) => {




  return `/api/purchase-orders/${id}/landed-cost`
}

/**
 * @summary Finalise GBP landed cost for a PO (Stage 2)
 */
export const setPurchaseOrderLandedCost = async (id: string,
    landedCostInput: LandedCostInput, options?: RequestInit): Promise<PurchaseOrderDetail> => {

  return customFetch<PurchaseOrderDetail>(getSetPurchaseOrderLandedCostUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(landedCostInput)
  }
);}





export const getSetPurchaseOrderLandedCostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPurchaseOrderLandedCost>>, TError,{id: string;data: BodyType<LandedCostInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setPurchaseOrderLandedCost>>, TError,{id: string;data: BodyType<LandedCostInput>}, TContext> => {

const mutationKey = ['setPurchaseOrderLandedCost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setPurchaseOrderLandedCost>>, {id: string;data: BodyType<LandedCostInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  setPurchaseOrderLandedCost(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetPurchaseOrderLandedCostMutationResult = NonNullable<Awaited<ReturnType<typeof setPurchaseOrderLandedCost>>>
    export type SetPurchaseOrderLandedCostMutationBody = BodyType<LandedCostInput>
    export type SetPurchaseOrderLandedCostMutationError = ErrorType<unknown>

    /**
 * @summary Finalise GBP landed cost for a PO (Stage 2)
 */
export const useSetPurchaseOrderLandedCost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPurchaseOrderLandedCost>>, TError,{id: string;data: BodyType<LandedCostInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setPurchaseOrderLandedCost>>,
        TError,
        {id: string;data: BodyType<LandedCostInput>},
        TContext
      > => {
      return useMutation(getSetPurchaseOrderLandedCostMutationOptions(options));
    }

export const getRecalculatePurchaseOrderCostsUrl = (id: string,) => {




  return `/api/purchase-orders/${id}/recalculate-costs`
}

/**
 * @summary Preview or apply COGS recalculation after late cost changes
 */
export const recalculatePurchaseOrderCosts = async (id: string,
    recalculateCostsInput: RecalculateCostsInput, options?: RequestInit): Promise<PoRecalcResult> => {

  return customFetch<PoRecalcResult>(getRecalculatePurchaseOrderCostsUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(recalculateCostsInput)
  }
);}





export const getRecalculatePurchaseOrderCostsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recalculatePurchaseOrderCosts>>, TError,{id: string;data: BodyType<RecalculateCostsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recalculatePurchaseOrderCosts>>, TError,{id: string;data: BodyType<RecalculateCostsInput>}, TContext> => {

const mutationKey = ['recalculatePurchaseOrderCosts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recalculatePurchaseOrderCosts>>, {id: string;data: BodyType<RecalculateCostsInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  recalculatePurchaseOrderCosts(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecalculatePurchaseOrderCostsMutationResult = NonNullable<Awaited<ReturnType<typeof recalculatePurchaseOrderCosts>>>
    export type RecalculatePurchaseOrderCostsMutationBody = BodyType<RecalculateCostsInput>
    export type RecalculatePurchaseOrderCostsMutationError = ErrorType<unknown>

    /**
 * @summary Preview or apply COGS recalculation after late cost changes
 */
export const useRecalculatePurchaseOrderCosts = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recalculatePurchaseOrderCosts>>, TError,{id: string;data: BodyType<RecalculateCostsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recalculatePurchaseOrderCosts>>,
        TError,
        {id: string;data: BodyType<RecalculateCostsInput>},
        TContext
      > => {
      return useMutation(getRecalculatePurchaseOrderCostsMutationOptions(options));
    }

export const getSetPurchaseOrderStatusUrl = (id: string,) => {




  return `/api/purchase-orders/${id}/status`
}

/**
 * @summary Update the order status of a PO (manual transition)
 */
export const setPurchaseOrderStatus = async (id: string,
    purchaseOrderStatusInput: PurchaseOrderStatusInput, options?: RequestInit): Promise<PurchaseOrderDetail> => {

  return customFetch<PurchaseOrderDetail>(getSetPurchaseOrderStatusUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(purchaseOrderStatusInput)
  }
);}





export const getSetPurchaseOrderStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPurchaseOrderStatus>>, TError,{id: string;data: BodyType<PurchaseOrderStatusInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setPurchaseOrderStatus>>, TError,{id: string;data: BodyType<PurchaseOrderStatusInput>}, TContext> => {

const mutationKey = ['setPurchaseOrderStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setPurchaseOrderStatus>>, {id: string;data: BodyType<PurchaseOrderStatusInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  setPurchaseOrderStatus(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetPurchaseOrderStatusMutationResult = NonNullable<Awaited<ReturnType<typeof setPurchaseOrderStatus>>>
    export type SetPurchaseOrderStatusMutationBody = BodyType<PurchaseOrderStatusInput>
    export type SetPurchaseOrderStatusMutationError = ErrorType<unknown>

    /**
 * @summary Update the order status of a PO (manual transition)
 */
export const useSetPurchaseOrderStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPurchaseOrderStatus>>, TError,{id: string;data: BodyType<PurchaseOrderStatusInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setPurchaseOrderStatus>>,
        TError,
        {id: string;data: BodyType<PurchaseOrderStatusInput>},
        TContext
      > => {
      return useMutation(getSetPurchaseOrderStatusMutationOptions(options));
    }

export const getReceivePurchaseOrderUrl = (id: string,) => {




  return `/api/purchase-orders/${id}/receive`
}

/**
 * @summary Receive stock (full or partial) and convert to inventory
 */
export const receivePurchaseOrder = async (id: string,
    receiveStockInput: ReceiveStockInput, options?: RequestInit): Promise<PurchaseOrderDetail> => {

  return customFetch<PurchaseOrderDetail>(getReceivePurchaseOrderUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(receiveStockInput)
  }
);}





export const getReceivePurchaseOrderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receivePurchaseOrder>>, TError,{id: string;data: BodyType<ReceiveStockInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof receivePurchaseOrder>>, TError,{id: string;data: BodyType<ReceiveStockInput>}, TContext> => {

const mutationKey = ['receivePurchaseOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof receivePurchaseOrder>>, {id: string;data: BodyType<ReceiveStockInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  receivePurchaseOrder(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReceivePurchaseOrderMutationResult = NonNullable<Awaited<ReturnType<typeof receivePurchaseOrder>>>
    export type ReceivePurchaseOrderMutationBody = BodyType<ReceiveStockInput>
    export type ReceivePurchaseOrderMutationError = ErrorType<unknown>

    /**
 * @summary Receive stock (full or partial) and convert to inventory
 */
export const useReceivePurchaseOrder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receivePurchaseOrder>>, TError,{id: string;data: BodyType<ReceiveStockInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof receivePurchaseOrder>>,
        TError,
        {id: string;data: BodyType<ReceiveStockInput>},
        TContext
      > => {
      return useMutation(getReceivePurchaseOrderMutationOptions(options));
    }

export const getUpdatePurchaseOrderLineItemUrl = (id: string,
    itemId: string,) => {




  return `/api/purchase-orders/${id}/items/${itemId}`
}

/**
 * Update one or more fields of an existing line item. Only the fields
 * present in the body are changed. Allowed even after the PO is
 * Landed/Completed, but in that case the client must set
 * `confirmFinalisedEdit: true` to acknowledge that landed costs and
 * any inventory rows already created from this line will be updated
 * in place.
 *
 * Quantity rules:
 *   - new `quantity` must be >= the line's `quantityReceived` (the
 *     backend will return 400 otherwise — to remove inventory that
 *     has already been received, edit it from the Stock screen first).
 *
 * Side-effects when inventory has already been received from this line:
 *   - descriptive fields (productTitle, brand, metal, sku, etc.) are
 *     propagated to the inventory rows.
 *   - if `unitCost` / `useManualGbp` / `gbpUnitCostManual` change AND
 *     the PO is Landed/Completed, the GBP landed cost is recomputed
 *     and written back to the inventory rows, and a stock_movement
 *     audit row is recorded for each affected inventory row.
 * @summary Edit a single line item on a purchase order
 */
export const updatePurchaseOrderLineItem = async (id: string,
    itemId: string,
    purchaseOrderLineItemUpdate: PurchaseOrderLineItemUpdate, options?: RequestInit): Promise<PurchaseOrderDetail> => {

  return customFetch<PurchaseOrderDetail>(getUpdatePurchaseOrderLineItemUrl(id,itemId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(purchaseOrderLineItemUpdate)
  }
);}





export const getUpdatePurchaseOrderLineItemMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePurchaseOrderLineItem>>, TError,{id: string;itemId: string;data: BodyType<PurchaseOrderLineItemUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePurchaseOrderLineItem>>, TError,{id: string;itemId: string;data: BodyType<PurchaseOrderLineItemUpdate>}, TContext> => {

const mutationKey = ['updatePurchaseOrderLineItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePurchaseOrderLineItem>>, {id: string;itemId: string;data: BodyType<PurchaseOrderLineItemUpdate>}> = (props) => {
          const {id,itemId,data} = props ?? {};

          return  updatePurchaseOrderLineItem(id,itemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePurchaseOrderLineItemMutationResult = NonNullable<Awaited<ReturnType<typeof updatePurchaseOrderLineItem>>>
    export type UpdatePurchaseOrderLineItemMutationBody = BodyType<PurchaseOrderLineItemUpdate>
    export type UpdatePurchaseOrderLineItemMutationError = ErrorType<void>

    /**
 * @summary Edit a single line item on a purchase order
 */
export const useUpdatePurchaseOrderLineItem = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePurchaseOrderLineItem>>, TError,{id: string;itemId: string;data: BodyType<PurchaseOrderLineItemUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePurchaseOrderLineItem>>,
        TError,
        {id: string;itemId: string;data: BodyType<PurchaseOrderLineItemUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePurchaseOrderLineItemMutationOptions(options));
    }

export const getDeletePurchaseOrderLineItemUrl = (id: string,
    itemId: string,) => {




  return `/api/purchase-orders/${id}/items/${itemId}`
}

/**
 * Removes a line item. Refuses with 409 if any quantity has already
 * been received into stock — in that case, remove the inventory rows
 * from the Stock screen first (or edit the line's quantity to match
 * `quantityReceived` instead of deleting).
 *
 * Permission `edit_purchase_orders` is required. Deleting a line on a
 * Landed/Completed PO is permitted (the UI is expected to confirm
 * with the user first); the remaining lines' landed-cost allocation
 * will shift on the next recompute.
 * @summary Delete a single line item from a purchase order
 */
export const deletePurchaseOrderLineItem = async (id: string,
    itemId: string, options?: RequestInit): Promise<PurchaseOrderDetail> => {

  return customFetch<PurchaseOrderDetail>(getDeletePurchaseOrderLineItemUrl(id,itemId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeletePurchaseOrderLineItemMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePurchaseOrderLineItem>>, TError,{id: string;itemId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePurchaseOrderLineItem>>, TError,{id: string;itemId: string}, TContext> => {

const mutationKey = ['deletePurchaseOrderLineItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePurchaseOrderLineItem>>, {id: string;itemId: string}> = (props) => {
          const {id,itemId} = props ?? {};

          return  deletePurchaseOrderLineItem(id,itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePurchaseOrderLineItemMutationResult = NonNullable<Awaited<ReturnType<typeof deletePurchaseOrderLineItem>>>

    export type DeletePurchaseOrderLineItemMutationError = ErrorType<void>

    /**
 * @summary Delete a single line item from a purchase order
 */
export const useDeletePurchaseOrderLineItem = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePurchaseOrderLineItem>>, TError,{id: string;itemId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePurchaseOrderLineItem>>,
        TError,
        {id: string;itemId: string},
        TContext
      > => {
      return useMutation(getDeletePurchaseOrderLineItemMutationOptions(options));
    }

export const getSetPurchaseOrderLineDestinationSkuUrl = (id: string,
    itemId: string,) => {




  return `/api/purchase-orders/${id}/items/${itemId}/destination-sku`
}

/**
 * Updates the existing inventoryItemId destination link for quantities
 * not yet received. Requires edit_purchase_orders. The inventory item
 * must belong to the authenticated tenant. After a partial receipt, a
 * changed destination applies only to the unreceived balance and never
 * rewrites prior receipt/lot attribution. Changes are rejected once the
 * line is fully received.
 * @summary Assign, change, or clear a PO line destination SKU
 */
export const setPurchaseOrderLineDestinationSku = async (id: string,
    itemId: string,
    purchaseOrderDestinationSkuUpdate: PurchaseOrderDestinationSkuUpdate, options?: RequestInit): Promise<PurchaseOrderDetail> => {

  return customFetch<PurchaseOrderDetail>(getSetPurchaseOrderLineDestinationSkuUrl(id,itemId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(purchaseOrderDestinationSkuUpdate)
  }
);}





export const getSetPurchaseOrderLineDestinationSkuMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPurchaseOrderLineDestinationSku>>, TError,{id: string;itemId: string;data: BodyType<PurchaseOrderDestinationSkuUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setPurchaseOrderLineDestinationSku>>, TError,{id: string;itemId: string;data: BodyType<PurchaseOrderDestinationSkuUpdate>}, TContext> => {

const mutationKey = ['setPurchaseOrderLineDestinationSku'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setPurchaseOrderLineDestinationSku>>, {id: string;itemId: string;data: BodyType<PurchaseOrderDestinationSkuUpdate>}> = (props) => {
          const {id,itemId,data} = props ?? {};

          return  setPurchaseOrderLineDestinationSku(id,itemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetPurchaseOrderLineDestinationSkuMutationResult = NonNullable<Awaited<ReturnType<typeof setPurchaseOrderLineDestinationSku>>>
    export type SetPurchaseOrderLineDestinationSkuMutationBody = BodyType<PurchaseOrderDestinationSkuUpdate>
    export type SetPurchaseOrderLineDestinationSkuMutationError = ErrorType<void>

    /**
 * @summary Assign, change, or clear a PO line destination SKU
 */
export const useSetPurchaseOrderLineDestinationSku = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPurchaseOrderLineDestinationSku>>, TError,{id: string;itemId: string;data: BodyType<PurchaseOrderDestinationSkuUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setPurchaseOrderLineDestinationSku>>,
        TError,
        {id: string;itemId: string;data: BodyType<PurchaseOrderDestinationSkuUpdate>},
        TContext
      > => {
      return useMutation(getSetPurchaseOrderLineDestinationSkuMutationOptions(options));
    }

export const getListRecentPurchaseOrderDestinationSkusUrl = () => {




  return `/api/purchase-orders/destination-skus/recent`
}

/**
 * Returns up to six distinct, still-existing inventory items from recent
 * destination changes in the authenticated tenant. Requires
 * edit_purchase_orders. This read never assigns a destination.
 * @summary List recently chosen destination SKUs
 */
export const listRecentPurchaseOrderDestinationSkus = async ( options?: RequestInit): Promise<PurchaseOrderRecentDestinationSkus> => {

  return customFetch<PurchaseOrderRecentDestinationSkus>(getListRecentPurchaseOrderDestinationSkusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRecentPurchaseOrderDestinationSkusQueryKey = () => {
    return [
    `/api/purchase-orders/destination-skus/recent`
    ] as const;
    }


export const getListRecentPurchaseOrderDestinationSkusQueryOptions = <TData = Awaited<ReturnType<typeof listRecentPurchaseOrderDestinationSkus>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRecentPurchaseOrderDestinationSkus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRecentPurchaseOrderDestinationSkusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRecentPurchaseOrderDestinationSkus>>> = ({ signal }) => listRecentPurchaseOrderDestinationSkus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRecentPurchaseOrderDestinationSkus>>, TError, TData> & { queryKey: QueryKey }
}

export type ListRecentPurchaseOrderDestinationSkusQueryResult = NonNullable<Awaited<ReturnType<typeof listRecentPurchaseOrderDestinationSkus>>>
export type ListRecentPurchaseOrderDestinationSkusQueryError = ErrorType<void>


/**
 * @summary List recently chosen destination SKUs
 */

export function useListRecentPurchaseOrderDestinationSkus<TData = Awaited<ReturnType<typeof listRecentPurchaseOrderDestinationSkus>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRecentPurchaseOrderDestinationSkus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListRecentPurchaseOrderDestinationSkusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRecommendPurchaseOrderLineDestinationSkusUrl = (id: string,
    itemId: string,) => {




  return `/api/purchase-orders/${id}/items/${itemId}/destination-sku/recommendations`
}

/**
 * Uses AI only to rank a bounded, server-selected set of existing SKUs
 * belonging to the authenticated tenant. Suggestions are advisory and
 * never assign the destination. Returns at most three candidates with
 * concise rationales; returns 503 when the AI integration is unavailable.
 * Recommendations are unavailable after the line is fully received.
 * @summary Get ranked existing SKU suggestions for a PO line
 */
export const recommendPurchaseOrderLineDestinationSkus = async (id: string,
    itemId: string, options?: RequestInit): Promise<PurchaseOrderDestinationSkuRecommendations> => {

  return customFetch<PurchaseOrderDestinationSkuRecommendations>(getRecommendPurchaseOrderLineDestinationSkusUrl(id,itemId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRecommendPurchaseOrderLineDestinationSkusMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recommendPurchaseOrderLineDestinationSkus>>, TError,{id: string;itemId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recommendPurchaseOrderLineDestinationSkus>>, TError,{id: string;itemId: string}, TContext> => {

const mutationKey = ['recommendPurchaseOrderLineDestinationSkus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recommendPurchaseOrderLineDestinationSkus>>, {id: string;itemId: string}> = (props) => {
          const {id,itemId} = props ?? {};

          return  recommendPurchaseOrderLineDestinationSkus(id,itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecommendPurchaseOrderLineDestinationSkusMutationResult = NonNullable<Awaited<ReturnType<typeof recommendPurchaseOrderLineDestinationSkus>>>

    export type RecommendPurchaseOrderLineDestinationSkusMutationError = ErrorType<void>

    /**
 * @summary Get ranked existing SKU suggestions for a PO line
 */
export const useRecommendPurchaseOrderLineDestinationSkus = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recommendPurchaseOrderLineDestinationSkus>>, TError,{id: string;itemId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recommendPurchaseOrderLineDestinationSkus>>,
        TError,
        {id: string;itemId: string},
        TContext
      > => {
      return useMutation(getRecommendPurchaseOrderLineDestinationSkusMutationOptions(options));
    }

export const getGetInventorySummaryUrl = () => {




  return `/api/inventory/summary`
}

/**
 * Exact tenant-wide inventory totals, independent of list pagination and filters.
 */
export const getInventorySummary = async ( options?: RequestInit): Promise<InventorySummary> => {

  return customFetch<InventorySummary>(getGetInventorySummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventorySummaryQueryKey = () => {
    return [
    `/api/inventory/summary`
    ] as const;
    }


export const getGetInventorySummaryQueryOptions = <TData = Awaited<ReturnType<typeof getInventorySummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventorySummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventorySummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventorySummary>>> = ({ signal }) => getInventorySummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventorySummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInventorySummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getInventorySummary>>>
export type GetInventorySummaryQueryError = ErrorType<unknown>



export function useGetInventorySummary<TData = Awaited<ReturnType<typeof getInventorySummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventorySummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInventorySummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetInventoryFilterMetadataUrl = () => {




  return `/api/inventory/filter-metadata`
}

/**
 * @summary List compact inventory filter options
 */
export const getInventoryFilterMetadata = async ( options?: RequestInit): Promise<InventoryFilterMetadata> => {

  return customFetch<InventoryFilterMetadata>(getGetInventoryFilterMetadataUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventoryFilterMetadataQueryKey = () => {
    return [
    `/api/inventory/filter-metadata`
    ] as const;
    }


export const getGetInventoryFilterMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryFilterMetadata>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryFilterMetadata>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryFilterMetadataQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryFilterMetadata>>> = ({ signal }) => getInventoryFilterMetadata({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryFilterMetadata>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInventoryFilterMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryFilterMetadata>>>
export type GetInventoryFilterMetadataQueryError = ErrorType<unknown>


/**
 * @summary List compact inventory filter options
 */

export function useGetInventoryFilterMetadata<TData = Awaited<ReturnType<typeof getInventoryFilterMetadata>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryFilterMetadata>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInventoryFilterMetadataQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListInventoryMintageReviewUrl = (params?: ListInventoryMintageReviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/mintage-review?${stringifiedParams}` : `/api/inventory/mintage-review`
}

/**
 * Requires edit_inventory. Read-only; resolution happens in the item editor.
 * @summary Count and page through tenant inventory with conflicting or malformed mintage
 */
export const listInventoryMintageReview = async (params?: ListInventoryMintageReviewParams, options?: RequestInit): Promise<InventoryMintageReviewPage> => {

  return customFetch<InventoryMintageReviewPage>(getListInventoryMintageReviewUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInventoryMintageReviewQueryKey = (params?: ListInventoryMintageReviewParams,) => {
    return [
    `/api/inventory/mintage-review`, ...(params ? [params] : [])
    ] as const;
    }


export const getListInventoryMintageReviewQueryOptions = <TData = Awaited<ReturnType<typeof listInventoryMintageReview>>, TError = ErrorType<void>>(params?: ListInventoryMintageReviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventoryMintageReview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInventoryMintageReviewQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInventoryMintageReview>>> = ({ signal }) => listInventoryMintageReview(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInventoryMintageReview>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInventoryMintageReviewQueryResult = NonNullable<Awaited<ReturnType<typeof listInventoryMintageReview>>>
export type ListInventoryMintageReviewQueryError = ErrorType<void>


/**
 * @summary Count and page through tenant inventory with conflicting or malformed mintage
 */

export function useListInventoryMintageReview<TData = Awaited<ReturnType<typeof listInventoryMintageReview>>, TError = ErrorType<void>>(
 params?: ListInventoryMintageReviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventoryMintageReview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInventoryMintageReviewQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLiveStockExportUrl = () => {




  return `/api/inventory/live-stock-export`
}

/**
 * @summary Fresh, tenant-scoped Live Stock export payload for the authenticated member.
 */
export const getLiveStockExport = async ( options?: RequestInit): Promise<LiveStockExportResponse> => {

  return customFetch<LiveStockExportResponse>(getGetLiveStockExportUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLiveStockExportQueryKey = () => {
    return [
    `/api/inventory/live-stock-export`
    ] as const;
    }


export const getGetLiveStockExportQueryOptions = <TData = Awaited<ReturnType<typeof getLiveStockExport>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLiveStockExport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLiveStockExportQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLiveStockExport>>> = ({ signal }) => getLiveStockExport({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLiveStockExport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLiveStockExportQueryResult = NonNullable<Awaited<ReturnType<typeof getLiveStockExport>>>
export type GetLiveStockExportQueryError = ErrorType<void>


/**
 * @summary Fresh, tenant-scoped Live Stock export payload for the authenticated member.
 */

export function useGetLiveStockExport<TData = Awaited<ReturnType<typeof getLiveStockExport>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLiveStockExport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLiveStockExportQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListInventoryGridUrl = (params?: ListInventoryGridParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/grid?${stringifiedParams}` : `/api/inventory/grid`
}

/**
 * Compact first-page desktop Inventory rows. Uses the same tenant,
 * permission, filters, sorting, pagination, stock calculations, and
 * financial redaction as GET /inventory. Gallery/photo metadata, notes,
 * composite history, and marketplace editor fields are intentionally
 * omitted; `gridImageUrl`, compact external-listing badge state, and
 * Shopify eligibility preserve the visible grid and its row actions.
 * Fetch GET /inventory/{id} when opening a product for full details.
 */
export const listInventoryGrid = async (params?: ListInventoryGridParams, options?: RequestInit): Promise<InventoryGridResponse> => {

  return customFetch<InventoryGridResponse>(getListInventoryGridUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInventoryGridQueryKey = (params?: ListInventoryGridParams,) => {
    return [
    `/api/inventory/grid`, ...(params ? [params] : [])
    ] as const;
    }


export const getListInventoryGridQueryOptions = <TData = Awaited<ReturnType<typeof listInventoryGrid>>, TError = ErrorType<unknown>>(params?: ListInventoryGridParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventoryGrid>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInventoryGridQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInventoryGrid>>> = ({ signal }) => listInventoryGrid(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInventoryGrid>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInventoryGridQueryResult = NonNullable<Awaited<ReturnType<typeof listInventoryGrid>>>
export type ListInventoryGridQueryError = ErrorType<unknown>



export function useListInventoryGrid<TData = Awaited<ReturnType<typeof listInventoryGrid>>, TError = ErrorType<unknown>>(
 params?: ListInventoryGridParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventoryGrid>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInventoryGridQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListInventoryUrl = (params?: ListInventoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory?${stringifiedParams}` : `/api/inventory`
}

export const listInventory = async (params?: ListInventoryParams, options?: RequestInit): Promise<ListInventory200> => {

  return customFetch<ListInventory200>(getListInventoryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInventoryQueryKey = (params?: ListInventoryParams,) => {
    return [
    `/api/inventory`, ...(params ? [params] : [])
    ] as const;
    }


export const getListInventoryQueryOptions = <TData = Awaited<ReturnType<typeof listInventory>>, TError = ErrorType<unknown>>(params?: ListInventoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInventoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInventory>>> = ({ signal }) => listInventory(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInventory>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInventoryQueryResult = NonNullable<Awaited<ReturnType<typeof listInventory>>>
export type ListInventoryQueryError = ErrorType<unknown>



export function useListInventory<TData = Awaited<ReturnType<typeof listInventory>>, TError = ErrorType<unknown>>(
 params?: ListInventoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInventoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateInventoryItemUrl = () => {




  return `/api/inventory`
}

export const createInventoryItem = async (inventoryItemInput: NonReadonly<InventoryItemInput>, options?: RequestInit): Promise<InventoryItem> => {

  return customFetch<InventoryItem>(getCreateInventoryItemUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryItemInput)
  }
);}





export const getCreateInventoryItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInventoryItem>>, TError,{data: BodyType<NonReadonly<InventoryItemInput>>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInventoryItem>>, TError,{data: BodyType<NonReadonly<InventoryItemInput>>}, TContext> => {

const mutationKey = ['createInventoryItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInventoryItem>>, {data: BodyType<NonReadonly<InventoryItemInput>>}> = (props) => {
          const {data} = props ?? {};

          return  createInventoryItem(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInventoryItemMutationResult = NonNullable<Awaited<ReturnType<typeof createInventoryItem>>>
    export type CreateInventoryItemMutationBody = BodyType<NonReadonly<InventoryItemInput>>
    export type CreateInventoryItemMutationError = ErrorType<unknown>

    export const useCreateInventoryItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInventoryItem>>, TError,{data: BodyType<NonReadonly<InventoryItemInput>>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createInventoryItem>>,
        TError,
        {data: BodyType<NonReadonly<InventoryItemInput>>},
        TContext
      > => {
      return useMutation(getCreateInventoryItemMutationOptions(options));
    }

export const getListMobileInventoryUrl = (params?: ListMobileInventoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/mobile?${stringifiedParams}` : `/api/inventory/mobile`
}

/**
 * Returns a deliberately narrow, tenant-scoped inventory projection for
 * small-screen operator cards. This endpoint is independent of the
 * desktop inventory list contract and never loads rich descriptions,
 * cost lots, sales history, marketplace payloads, or per-item detail.
 * Page size is bounded to protect handheld clients and every sort has a
 * stable id tie-breaker. Pass nextCursor from one response to continue
 * with keyset pagination; cursors are bound to the active sort and filters.
 * @summary List the bounded mobile inventory card projection
 */
export const listMobileInventory = async (params?: ListMobileInventoryParams, options?: RequestInit): Promise<MobileInventoryListResponse> => {

  return customFetch<MobileInventoryListResponse>(getListMobileInventoryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMobileInventoryQueryKey = (params?: ListMobileInventoryParams,) => {
    return [
    `/api/inventory/mobile`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMobileInventoryQueryOptions = <TData = Awaited<ReturnType<typeof listMobileInventory>>, TError = ErrorType<void>>(params?: ListMobileInventoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMobileInventory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMobileInventoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMobileInventory>>> = ({ signal }) => listMobileInventory(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMobileInventory>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMobileInventoryQueryResult = NonNullable<Awaited<ReturnType<typeof listMobileInventory>>>
export type ListMobileInventoryQueryError = ErrorType<void>


/**
 * @summary List the bounded mobile inventory card projection
 */

export function useListMobileInventory<TData = Awaited<ReturnType<typeof listMobileInventory>>, TError = ErrorType<void>>(
 params?: ListMobileInventoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMobileInventory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMobileInventoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetInventoryOperatorSnapshotUrl = (id: string,) => {




  return `/api/inventory/${id}/mobile-snapshot`
}

/**
 * Loads compact operator information for an expanded mobile card. This
 * is intentionally separate from the mobile list so pricing, cost,
 * supplier mappings, flags, and linked-listing summaries are never
 * eagerly fetched for every card. Financial fields are redacted by the
 * server according to the signed-in operator's permissions.
 * @summary Get the on-demand operator snapshot for one inventory SKU
 */
export const getInventoryOperatorSnapshot = async (id: string, options?: RequestInit): Promise<InventoryOperatorSnapshot> => {

  return customFetch<InventoryOperatorSnapshot>(getGetInventoryOperatorSnapshotUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventoryOperatorSnapshotQueryKey = (id: string,) => {
    return [
    `/api/inventory/${id}/mobile-snapshot`
    ] as const;
    }


export const getGetInventoryOperatorSnapshotQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryOperatorSnapshot>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryOperatorSnapshot>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryOperatorSnapshotQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryOperatorSnapshot>>> = ({ signal }) => getInventoryOperatorSnapshot(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryOperatorSnapshot>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInventoryOperatorSnapshotQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryOperatorSnapshot>>>
export type GetInventoryOperatorSnapshotQueryError = ErrorType<void>


/**
 * @summary Get the on-demand operator snapshot for one inventory SKU
 */

export function useGetInventoryOperatorSnapshot<TData = Awaited<ReturnType<typeof getInventoryOperatorSnapshot>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryOperatorSnapshot>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInventoryOperatorSnapshotQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetInventoryMobileSummaryUrl = (id: string,) => {




  return `/api/inventory/${id}/mobile-summary`
}

/**
 * Compatibility name for the mobile expansion contract. Returns the same
 * compact, permission-filtered operator snapshot as
 * `/inventory/{id}/mobile-snapshot`.
 * @summary Get the on-demand operator snapshot for one inventory SKU
 */
export const getInventoryMobileSummary = async (id: string, options?: RequestInit): Promise<InventoryOperatorSnapshot> => {

  return customFetch<InventoryOperatorSnapshot>(getGetInventoryMobileSummaryUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventoryMobileSummaryQueryKey = (id: string,) => {
    return [
    `/api/inventory/${id}/mobile-summary`
    ] as const;
    }


export const getGetInventoryMobileSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryMobileSummary>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryMobileSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryMobileSummaryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryMobileSummary>>> = ({ signal }) => getInventoryMobileSummary(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryMobileSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInventoryMobileSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryMobileSummary>>>
export type GetInventoryMobileSummaryQueryError = ErrorType<void>


/**
 * @summary Get the on-demand operator snapshot for one inventory SKU
 */

export function useGetInventoryMobileSummary<TData = Awaited<ReturnType<typeof getInventoryMobileSummary>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryMobileSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInventoryMobileSummaryQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetInventoryMobileThumbnailUrl = (id: string,) => {




  return `/api/inventory/${id}/mobile-thumbnail`
}

/**
 * Resolves the inventory image through tenant-scoped storage access and
 * returns a bounded 160x160 WebP derivative. Legacy or unsupported source
 * images may fall back to the original authenticated image path.
 * @summary Get the authenticated 160x160 WebP inventory thumbnail
 */
export const getInventoryMobileThumbnail = async (id: string, options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getGetInventoryMobileThumbnailUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventoryMobileThumbnailQueryKey = (id: string,) => {
    return [
    `/api/inventory/${id}/mobile-thumbnail`
    ] as const;
    }


export const getGetInventoryMobileThumbnailQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryMobileThumbnail>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryMobileThumbnail>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryMobileThumbnailQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryMobileThumbnail>>> = ({ signal }) => getInventoryMobileThumbnail(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryMobileThumbnail>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInventoryMobileThumbnailQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryMobileThumbnail>>>
export type GetInventoryMobileThumbnailQueryError = ErrorType<void>


/**
 * @summary Get the authenticated 160x160 WebP inventory thumbnail
 */

export function useGetInventoryMobileThumbnail<TData = Awaited<ReturnType<typeof getInventoryMobileThumbnail>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryMobileThumbnail>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInventoryMobileThumbnailQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getMatchInventoryByIdentityUrl = (params: MatchInventoryByIdentityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/match?${stringifiedParams}` : `/api/inventory/match`
}

/**
 * Fuzzy-matches existing inventory items by `(brand, productTitle)` using
 * Postgres `pg_trgm` similarity, used by the PO receive flow's
 * "Map to existing product" panel so a new receipt can be aligned to an
 * existing product group on the inventory dashboard (which groups by
 * normalised brand + title). Returns up to 5 distinct
 * `(brand, productTitle)` groups with one representative item per group.
 *
 * Does NOT mutate anything. Rate-limited per user.
 * @summary Suggest existing inventory items that share an identity (brand + title)
 */
export const matchInventoryByIdentity = async (params: MatchInventoryByIdentityParams, options?: RequestInit): Promise<InventoryMatchSuggestion[]> => {

  return customFetch<InventoryMatchSuggestion[]>(getMatchInventoryByIdentityUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMatchInventoryByIdentityQueryKey = (params?: MatchInventoryByIdentityParams,) => {
    return [
    `/api/inventory/match`, ...(params ? [params] : [])
    ] as const;
    }


export const getMatchInventoryByIdentityQueryOptions = <TData = Awaited<ReturnType<typeof matchInventoryByIdentity>>, TError = ErrorType<void>>(params: MatchInventoryByIdentityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof matchInventoryByIdentity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMatchInventoryByIdentityQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof matchInventoryByIdentity>>> = ({ signal }) => matchInventoryByIdentity(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof matchInventoryByIdentity>>, TError, TData> & { queryKey: QueryKey }
}

export type MatchInventoryByIdentityQueryResult = NonNullable<Awaited<ReturnType<typeof matchInventoryByIdentity>>>
export type MatchInventoryByIdentityQueryError = ErrorType<void>


/**
 * @summary Suggest existing inventory items that share an identity (brand + title)
 */

export function useMatchInventoryByIdentity<TData = Awaited<ReturnType<typeof matchInventoryByIdentity>>, TError = ErrorType<void>>(
 params: MatchInventoryByIdentityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof matchInventoryByIdentity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getMatchInventoryByIdentityQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAnalyzeInventoryProductSourceUrl = () => {




  return `/api/inventory/product-importer/analyze`
}

/**
 * Fetches only allowlisted supplier pages, respects upstream access blocks,
 * and returns a review-only AI draft with source evidence. Never writes to
 * inventory. Supplier prices are deliberately excluded.
 * @summary Extract evidenced product details from a supported supplier page.
 */
export const analyzeInventoryProductSource = async (inventoryProductImportAnalysisRequest: InventoryProductImportAnalysisRequest, options?: RequestInit): Promise<InventoryProductImportAnalysisResponse> => {

  return customFetch<InventoryProductImportAnalysisResponse>(getAnalyzeInventoryProductSourceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryProductImportAnalysisRequest)
  }
);}





export const getAnalyzeInventoryProductSourceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analyzeInventoryProductSource>>, TError,{data: BodyType<InventoryProductImportAnalysisRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof analyzeInventoryProductSource>>, TError,{data: BodyType<InventoryProductImportAnalysisRequest>}, TContext> => {

const mutationKey = ['analyzeInventoryProductSource'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof analyzeInventoryProductSource>>, {data: BodyType<InventoryProductImportAnalysisRequest>}> = (props) => {
          const {data} = props ?? {};

          return  analyzeInventoryProductSource(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AnalyzeInventoryProductSourceMutationResult = NonNullable<Awaited<ReturnType<typeof analyzeInventoryProductSource>>>
    export type AnalyzeInventoryProductSourceMutationBody = BodyType<InventoryProductImportAnalysisRequest>
    export type AnalyzeInventoryProductSourceMutationError = ErrorType<void>

    /**
 * @summary Extract evidenced product details from a supported supplier page.
 */
export const useAnalyzeInventoryProductSource = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analyzeInventoryProductSource>>, TError,{data: BodyType<InventoryProductImportAnalysisRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof analyzeInventoryProductSource>>,
        TError,
        {data: BodyType<InventoryProductImportAnalysisRequest>},
        TContext
      > => {
      return useMutation(getAnalyzeInventoryProductSourceMutationOptions(options));
    }

export const getGetInventoryProductImporterCanvaStatusUrl = () => {




  return `/api/inventory/product-importer/canva/status`
}

/**
 * @summary Check app-owned Canva OAuth configuration.
 */
export const getInventoryProductImporterCanvaStatus = async ( options?: RequestInit): Promise<InventoryProductImporterCanvaStatus> => {

  return customFetch<InventoryProductImporterCanvaStatus>(getGetInventoryProductImporterCanvaStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventoryProductImporterCanvaStatusQueryKey = () => {
    return [
    `/api/inventory/product-importer/canva/status`
    ] as const;
    }


export const getGetInventoryProductImporterCanvaStatusQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryProductImporterCanvaStatus>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryProductImporterCanvaStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryProductImporterCanvaStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryProductImporterCanvaStatus>>> = ({ signal }) => getInventoryProductImporterCanvaStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryProductImporterCanvaStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInventoryProductImporterCanvaStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryProductImporterCanvaStatus>>>
export type GetInventoryProductImporterCanvaStatusQueryError = ErrorType<unknown>


/**
 * @summary Check app-owned Canva OAuth configuration.
 */

export function useGetInventoryProductImporterCanvaStatus<TData = Awaited<ReturnType<typeof getInventoryProductImporterCanvaStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryProductImporterCanvaStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInventoryProductImporterCanvaStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getStartInventoryProductImporterCanvaConnectUrl = () => {




  return `/api/inventory/product-importer/canva/connect`
}

/**
 * @summary Start Canva OAuth for the active tenant.
 */
export const startInventoryProductImporterCanvaConnect = async ( options?: RequestInit): Promise<InventoryProductImporterCanvaConnect> => {

  return customFetch<InventoryProductImporterCanvaConnect>(getStartInventoryProductImporterCanvaConnectUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getStartInventoryProductImporterCanvaConnectMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startInventoryProductImporterCanvaConnect>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startInventoryProductImporterCanvaConnect>>, TError,void, TContext> => {

const mutationKey = ['startInventoryProductImporterCanvaConnect'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startInventoryProductImporterCanvaConnect>>, void> = () => {


          return  startInventoryProductImporterCanvaConnect(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartInventoryProductImporterCanvaConnectMutationResult = NonNullable<Awaited<ReturnType<typeof startInventoryProductImporterCanvaConnect>>>

    export type StartInventoryProductImporterCanvaConnectMutationError = ErrorType<void>

    /**
 * @summary Start Canva OAuth for the active tenant.
 */
export const useStartInventoryProductImporterCanvaConnect = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startInventoryProductImporterCanvaConnect>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof startInventoryProductImporterCanvaConnect>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getStartInventoryProductImporterCanvaConnectMutationOptions(options));
    }

export const getCompleteInventoryProductImporterCanvaConnectUrl = (params?: CompleteInventoryProductImporterCanvaConnectParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/product-importer/canva/callback?${stringifiedParams}` : `/api/inventory/product-importer/canva/callback`
}

/**
 * @summary Complete the signed app-owned Canva OAuth callback.
 */
export const completeInventoryProductImporterCanvaConnect = async (params?: CompleteInventoryProductImporterCanvaConnectParams, options?: RequestInit): Promise<unknown> => {

  return customFetch<unknown>(getCompleteInventoryProductImporterCanvaConnectUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCompleteInventoryProductImporterCanvaConnectQueryKey = (params?: CompleteInventoryProductImporterCanvaConnectParams,) => {
    return [
    `/api/inventory/product-importer/canva/callback`, ...(params ? [params] : [])
    ] as const;
    }


export const getCompleteInventoryProductImporterCanvaConnectQueryOptions = <TData = Awaited<ReturnType<typeof completeInventoryProductImporterCanvaConnect>>, TError = ErrorType<void>>(params?: CompleteInventoryProductImporterCanvaConnectParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof completeInventoryProductImporterCanvaConnect>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompleteInventoryProductImporterCanvaConnectQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof completeInventoryProductImporterCanvaConnect>>> = ({ signal }) => completeInventoryProductImporterCanvaConnect(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof completeInventoryProductImporterCanvaConnect>>, TError, TData> & { queryKey: QueryKey }
}

export type CompleteInventoryProductImporterCanvaConnectQueryResult = NonNullable<Awaited<ReturnType<typeof completeInventoryProductImporterCanvaConnect>>>
export type CompleteInventoryProductImporterCanvaConnectQueryError = ErrorType<void>


/**
 * @summary Complete the signed app-owned Canva OAuth callback.
 */

export function useCompleteInventoryProductImporterCanvaConnect<TData = Awaited<ReturnType<typeof completeInventoryProductImporterCanvaConnect>>, TError = ErrorType<void>>(
 params?: CompleteInventoryProductImporterCanvaConnectParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof completeInventoryProductImporterCanvaConnect>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getCompleteInventoryProductImporterCanvaConnectQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListInventoryProductImporterCanvaTemplatesUrl = () => {




  return `/api/inventory/product-importer/canva/templates`
}

/**
 * @summary List Canva brand templates available to the connected user.
 */
export const listInventoryProductImporterCanvaTemplates = async ( options?: RequestInit): Promise<InventoryProductImporterCanvaTemplateList> => {

  return customFetch<InventoryProductImporterCanvaTemplateList>(getListInventoryProductImporterCanvaTemplatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInventoryProductImporterCanvaTemplatesQueryKey = () => {
    return [
    `/api/inventory/product-importer/canva/templates`
    ] as const;
    }


export const getListInventoryProductImporterCanvaTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof listInventoryProductImporterCanvaTemplates>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventoryProductImporterCanvaTemplates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInventoryProductImporterCanvaTemplatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInventoryProductImporterCanvaTemplates>>> = ({ signal }) => listInventoryProductImporterCanvaTemplates({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInventoryProductImporterCanvaTemplates>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInventoryProductImporterCanvaTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof listInventoryProductImporterCanvaTemplates>>>
export type ListInventoryProductImporterCanvaTemplatesQueryError = ErrorType<void>


/**
 * @summary List Canva brand templates available to the connected user.
 */

export function useListInventoryProductImporterCanvaTemplates<TData = Awaited<ReturnType<typeof listInventoryProductImporterCanvaTemplates>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventoryProductImporterCanvaTemplates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInventoryProductImporterCanvaTemplatesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSaveInventoryProductImporterCanvaTemplatesUrl = () => {




  return `/api/inventory/product-importer/canva/templates`
}

/**
 * @summary Save mapped 4:5 and 9:16 Canva brand templates.
 */
export const saveInventoryProductImporterCanvaTemplates = async (inventoryProductImporterCanvaTemplateConfig: InventoryProductImporterCanvaTemplateConfig, options?: RequestInit): Promise<InventoryProductImporterCanvaTemplateConfig> => {

  return customFetch<InventoryProductImporterCanvaTemplateConfig>(getSaveInventoryProductImporterCanvaTemplatesUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryProductImporterCanvaTemplateConfig)
  }
);}





export const getSaveInventoryProductImporterCanvaTemplatesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveInventoryProductImporterCanvaTemplates>>, TError,{data: BodyType<InventoryProductImporterCanvaTemplateConfig>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveInventoryProductImporterCanvaTemplates>>, TError,{data: BodyType<InventoryProductImporterCanvaTemplateConfig>}, TContext> => {

const mutationKey = ['saveInventoryProductImporterCanvaTemplates'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveInventoryProductImporterCanvaTemplates>>, {data: BodyType<InventoryProductImporterCanvaTemplateConfig>}> = (props) => {
          const {data} = props ?? {};

          return  saveInventoryProductImporterCanvaTemplates(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveInventoryProductImporterCanvaTemplatesMutationResult = NonNullable<Awaited<ReturnType<typeof saveInventoryProductImporterCanvaTemplates>>>
    export type SaveInventoryProductImporterCanvaTemplatesMutationBody = BodyType<InventoryProductImporterCanvaTemplateConfig>
    export type SaveInventoryProductImporterCanvaTemplatesMutationError = ErrorType<void>

    /**
 * @summary Save mapped 4:5 and 9:16 Canva brand templates.
 */
export const useSaveInventoryProductImporterCanvaTemplates = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveInventoryProductImporterCanvaTemplates>>, TError,{data: BodyType<InventoryProductImporterCanvaTemplateConfig>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveInventoryProductImporterCanvaTemplates>>,
        TError,
        {data: BodyType<InventoryProductImporterCanvaTemplateConfig>},
        TContext
      > => {
      return useMutation(getSaveInventoryProductImporterCanvaTemplatesMutationOptions(options));
    }

export const getGetInventoryProductImporterCanvaTemplateDatasetUrl = (templateId: string,) => {




  return `/api/inventory/product-importer/canva/templates/${templateId}/dataset`
}

/**
 * @summary Read fillable fields from an accessible Canva template.
 */
export const getInventoryProductImporterCanvaTemplateDataset = async (templateId: string, options?: RequestInit): Promise<InventoryProductImporterCanvaTemplateDataset> => {

  return customFetch<InventoryProductImporterCanvaTemplateDataset>(getGetInventoryProductImporterCanvaTemplateDatasetUrl(templateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventoryProductImporterCanvaTemplateDatasetQueryKey = (templateId: string,) => {
    return [
    `/api/inventory/product-importer/canva/templates/${templateId}/dataset`
    ] as const;
    }


export const getGetInventoryProductImporterCanvaTemplateDatasetQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryProductImporterCanvaTemplateDataset>>, TError = ErrorType<void>>(templateId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryProductImporterCanvaTemplateDataset>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryProductImporterCanvaTemplateDatasetQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryProductImporterCanvaTemplateDataset>>> = ({ signal }) => getInventoryProductImporterCanvaTemplateDataset(templateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryProductImporterCanvaTemplateDataset>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInventoryProductImporterCanvaTemplateDatasetQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryProductImporterCanvaTemplateDataset>>>
export type GetInventoryProductImporterCanvaTemplateDatasetQueryError = ErrorType<void>


/**
 * @summary Read fillable fields from an accessible Canva template.
 */

export function useGetInventoryProductImporterCanvaTemplateDataset<TData = Awaited<ReturnType<typeof getInventoryProductImporterCanvaTemplateDataset>>, TError = ErrorType<void>>(
 templateId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryProductImporterCanvaTemplateDataset>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInventoryProductImporterCanvaTemplateDatasetQueryOptions(templateId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateInventoryProductImporterCanvaDesignsUrl = () => {




  return `/api/inventory/product-importer/canva/designs`
}

/**
 * Creates one design for each configured aspect ratio. Uses the selected
 * supplier photo as the original Canva asset and never includes prices,
 * stock, cost, or VAT data.
 * @summary Create Canva designs from the saved templates and reviewed product facts.
 */
export const createInventoryProductImporterCanvaDesigns = async (inventoryProductImporterCanvaDesignRequest: InventoryProductImporterCanvaDesignRequest, options?: RequestInit): Promise<InventoryProductImporterCanvaDesignResponse> => {

  return customFetch<InventoryProductImporterCanvaDesignResponse>(getCreateInventoryProductImporterCanvaDesignsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryProductImporterCanvaDesignRequest)
  }
);}





export const getCreateInventoryProductImporterCanvaDesignsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInventoryProductImporterCanvaDesigns>>, TError,{data: BodyType<InventoryProductImporterCanvaDesignRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInventoryProductImporterCanvaDesigns>>, TError,{data: BodyType<InventoryProductImporterCanvaDesignRequest>}, TContext> => {

const mutationKey = ['createInventoryProductImporterCanvaDesigns'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInventoryProductImporterCanvaDesigns>>, {data: BodyType<InventoryProductImporterCanvaDesignRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createInventoryProductImporterCanvaDesigns(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInventoryProductImporterCanvaDesignsMutationResult = NonNullable<Awaited<ReturnType<typeof createInventoryProductImporterCanvaDesigns>>>
    export type CreateInventoryProductImporterCanvaDesignsMutationBody = BodyType<InventoryProductImporterCanvaDesignRequest>
    export type CreateInventoryProductImporterCanvaDesignsMutationError = ErrorType<void>

    /**
 * @summary Create Canva designs from the saved templates and reviewed product facts.
 */
export const useCreateInventoryProductImporterCanvaDesigns = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInventoryProductImporterCanvaDesigns>>, TError,{data: BodyType<InventoryProductImporterCanvaDesignRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createInventoryProductImporterCanvaDesigns>>,
        TError,
        {data: BodyType<InventoryProductImporterCanvaDesignRequest>},
        TContext
      > => {
      return useMutation(getCreateInventoryProductImporterCanvaDesignsMutationOptions(options));
    }

export const getAssistInventoryListingUrl = () => {




  return `/api/inventory/ai-assist`
}

/**
 * Grounds suggestions strictly in the supplied item fields
 * (metal/brand/year/product type/weight etc.) to produce marketplace-ready
 * listing titles and descriptions, fix spelling/grammar, or score the
 * current title + description for SEO/discoverability.
 *
 * Never writes anything — suggestions are opt-in and only the normal
 * save/publish flow persists them. Gated to `edit_inventory` and
 * rate-limited per operator (a 429 carries `Retry-After` + `retryAfterSec`
 * for a friendly cooldown toast).
 * @summary AI listing assistant — suggest titles/descriptions, fix typos, SEO score.
 */
export const assistInventoryListing = async (inventoryAiAssistRequest: InventoryAiAssistRequest, options?: RequestInit): Promise<InventoryAiAssistResponse> => {

  return customFetch<InventoryAiAssistResponse>(getAssistInventoryListingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryAiAssistRequest)
  }
);}





export const getAssistInventoryListingMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assistInventoryListing>>, TError,{data: BodyType<InventoryAiAssistRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assistInventoryListing>>, TError,{data: BodyType<InventoryAiAssistRequest>}, TContext> => {

const mutationKey = ['assistInventoryListing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assistInventoryListing>>, {data: BodyType<InventoryAiAssistRequest>}> = (props) => {
          const {data} = props ?? {};

          return  assistInventoryListing(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssistInventoryListingMutationResult = NonNullable<Awaited<ReturnType<typeof assistInventoryListing>>>
    export type AssistInventoryListingMutationBody = BodyType<InventoryAiAssistRequest>
    export type AssistInventoryListingMutationError = ErrorType<void>

    /**
 * @summary AI listing assistant — suggest titles/descriptions, fix typos, SEO score.
 */
export const useAssistInventoryListing = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assistInventoryListing>>, TError,{data: BodyType<InventoryAiAssistRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof assistInventoryListing>>,
        TError,
        {data: BodyType<InventoryAiAssistRequest>},
        TContext
      > => {
      return useMutation(getAssistInventoryListingMutationOptions(options));
    }

export const getGetInventoryShopifyPublicationUrl = (id: string,) => {




  return `/api/inventory/${id}/shopify-publication`
}

/**
 * Read-only publication checks for a linked Shopify product on Online Store, Google & YouTube, and Whatnot. Saved observations may be returned as last-known when Shopify is unavailable.
 */
export const getInventoryShopifyPublication = async (id: string, options?: RequestInit): Promise<ShopifyPublicationObservation> => {

  return customFetch<ShopifyPublicationObservation>(getGetInventoryShopifyPublicationUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventoryShopifyPublicationQueryKey = (id: string,) => {
    return [
    `/api/inventory/${id}/shopify-publication`
    ] as const;
    }


export const getGetInventoryShopifyPublicationQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryShopifyPublication>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryShopifyPublication>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryShopifyPublicationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryShopifyPublication>>> = ({ signal }) => getInventoryShopifyPublication(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryShopifyPublication>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInventoryShopifyPublicationQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryShopifyPublication>>>
export type GetInventoryShopifyPublicationQueryError = ErrorType<void>



export function useGetInventoryShopifyPublication<TData = Awaited<ReturnType<typeof getInventoryShopifyPublication>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryShopifyPublication>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInventoryShopifyPublicationQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getEnqueueInventorySeoReadinessUrl = (id: string,) => {




  return `/api/inventory/${id}/seo-readiness`
}

/**
 * Explicitly calculate and cache a tenant-scoped content-readiness checklist for saved item facts. This is not a search-ranking prediction.
 */
export const enqueueInventorySeoReadiness = async (id: string,
    enqueueInventorySeoReadinessBody: EnqueueInventorySeoReadinessBody, options?: RequestInit): Promise<EnqueueInventorySeoReadiness200 | EnqueueInventorySeoReadiness202> => {

  return customFetch<EnqueueInventorySeoReadiness200 | EnqueueInventorySeoReadiness202>(getEnqueueInventorySeoReadinessUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(enqueueInventorySeoReadinessBody)
  }
);}





export const getEnqueueInventorySeoReadinessMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enqueueInventorySeoReadiness>>, TError,{id: string;data: BodyType<EnqueueInventorySeoReadinessBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof enqueueInventorySeoReadiness>>, TError,{id: string;data: BodyType<EnqueueInventorySeoReadinessBody>}, TContext> => {

const mutationKey = ['enqueueInventorySeoReadiness'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enqueueInventorySeoReadiness>>, {id: string;data: BodyType<EnqueueInventorySeoReadinessBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  enqueueInventorySeoReadiness(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnqueueInventorySeoReadinessMutationResult = NonNullable<Awaited<ReturnType<typeof enqueueInventorySeoReadiness>>>
    export type EnqueueInventorySeoReadinessMutationBody = BodyType<EnqueueInventorySeoReadinessBody>
    export type EnqueueInventorySeoReadinessMutationError = ErrorType<void>

    export const useEnqueueInventorySeoReadiness = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enqueueInventorySeoReadiness>>, TError,{id: string;data: BodyType<EnqueueInventorySeoReadinessBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof enqueueInventorySeoReadiness>>,
        TError,
        {id: string;data: BodyType<EnqueueInventorySeoReadinessBody>},
        TContext
      > => {
      return useMutation(getEnqueueInventorySeoReadinessMutationOptions(options));
    }

export const getGetInventorySeoReadinessJobUrl = (id: string,
    jobId: string,) => {




  return `/api/inventory/${id}/seo-readiness/jobs/${jobId}`
}

/**
 * Get tenant- and inventory-scoped status for an asynchronous SEO readiness analysis.
 */
export const getInventorySeoReadinessJob = async (id: string,
    jobId: string, options?: RequestInit): Promise<GetInventorySeoReadinessJob200> => {

  return customFetch<GetInventorySeoReadinessJob200>(getGetInventorySeoReadinessJobUrl(id,jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventorySeoReadinessJobQueryKey = (id: string,
    jobId: string,) => {
    return [
    `/api/inventory/${id}/seo-readiness/jobs/${jobId}`
    ] as const;
    }


export const getGetInventorySeoReadinessJobQueryOptions = <TData = Awaited<ReturnType<typeof getInventorySeoReadinessJob>>, TError = ErrorType<void>>(id: string,
    jobId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventorySeoReadinessJob>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventorySeoReadinessJobQueryKey(id,jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventorySeoReadinessJob>>> = ({ signal }) => getInventorySeoReadinessJob(id,jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventorySeoReadinessJob>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInventorySeoReadinessJobQueryResult = NonNullable<Awaited<ReturnType<typeof getInventorySeoReadinessJob>>>
export type GetInventorySeoReadinessJobQueryError = ErrorType<void>



export function useGetInventorySeoReadinessJob<TData = Awaited<ReturnType<typeof getInventorySeoReadinessJob>>, TError = ErrorType<void>>(
 id: string,
    jobId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventorySeoReadinessJob>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInventorySeoReadinessJobQueryOptions(id,jobId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetInventoryItemUrl = (id: string,) => {




  return `/api/inventory/${id}`
}

export const getInventoryItem = async (id: string, options?: RequestInit): Promise<InventoryItemDetail> => {

  return customFetch<InventoryItemDetail>(getGetInventoryItemUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventoryItemQueryKey = (id: string,) => {
    return [
    `/api/inventory/${id}`
    ] as const;
    }


export const getGetInventoryItemQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryItem>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryItem>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryItemQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryItem>>> = ({ signal }) => getInventoryItem(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryItem>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInventoryItemQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryItem>>>
export type GetInventoryItemQueryError = ErrorType<unknown>



export function useGetInventoryItem<TData = Awaited<ReturnType<typeof getInventoryItem>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryItem>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInventoryItemQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateInventoryItemUrl = (id: string,) => {




  return `/api/inventory/${id}`
}

export const updateInventoryItem = async (id: string,
    inventoryItemUpdate: NonReadonly<InventoryItemUpdate>, options?: RequestInit): Promise<InventoryItem> => {

  return customFetch<InventoryItem>(getUpdateInventoryItemUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryItemUpdate)
  }
);}





export const getUpdateInventoryItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInventoryItem>>, TError,{id: string;data: BodyType<NonReadonly<InventoryItemUpdate>>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInventoryItem>>, TError,{id: string;data: BodyType<NonReadonly<InventoryItemUpdate>>}, TContext> => {

const mutationKey = ['updateInventoryItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInventoryItem>>, {id: string;data: BodyType<NonReadonly<InventoryItemUpdate>>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateInventoryItem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateInventoryItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateInventoryItem>>>
    export type UpdateInventoryItemMutationBody = BodyType<NonReadonly<InventoryItemUpdate>>
    export type UpdateInventoryItemMutationError = ErrorType<unknown>

    export const useUpdateInventoryItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInventoryItem>>, TError,{id: string;data: BodyType<NonReadonly<InventoryItemUpdate>>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateInventoryItem>>,
        TError,
        {id: string;data: BodyType<NonReadonly<InventoryItemUpdate>>},
        TContext
      > => {
      return useMutation(getUpdateInventoryItemMutationOptions(options));
    }

export const getDeleteInventoryItemUrl = (id: string,) => {




  return `/api/inventory/${id}`
}

export const deleteInventoryItem = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteInventoryItemUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteInventoryItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInventoryItem>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteInventoryItem>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteInventoryItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInventoryItem>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteInventoryItem(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteInventoryItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInventoryItem>>>

    export type DeleteInventoryItemMutationError = ErrorType<unknown>

    export const useDeleteInventoryItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInventoryItem>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteInventoryItem>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteInventoryItemMutationOptions(options));
    }

export const getStockInInventoryItemUrl = (id: string,) => {




  return `/api/inventory/${id}/stock-in`
}

/**
 * @summary Add stock to an existing inventory item and record the movement
 */
export const stockInInventoryItem = async (id: string,
    inventoryStockInInput: InventoryStockInInput, options?: RequestInit): Promise<InventoryStockInResult> => {

  return customFetch<InventoryStockInResult>(getStockInInventoryItemUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryStockInInput)
  }
);}





export const getStockInInventoryItemMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stockInInventoryItem>>, TError,{id: string;data: BodyType<InventoryStockInInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stockInInventoryItem>>, TError,{id: string;data: BodyType<InventoryStockInInput>}, TContext> => {

const mutationKey = ['stockInInventoryItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stockInInventoryItem>>, {id: string;data: BodyType<InventoryStockInInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  stockInInventoryItem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StockInInventoryItemMutationResult = NonNullable<Awaited<ReturnType<typeof stockInInventoryItem>>>
    export type StockInInventoryItemMutationBody = BodyType<InventoryStockInInput>
    export type StockInInventoryItemMutationError = ErrorType<void>

    /**
 * @summary Add stock to an existing inventory item and record the movement
 */
export const useStockInInventoryItem = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stockInInventoryItem>>, TError,{id: string;data: BodyType<InventoryStockInInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof stockInInventoryItem>>,
        TError,
        {id: string;data: BodyType<InventoryStockInInput>},
        TContext
      > => {
      return useMutation(getStockInInventoryItemMutationOptions(options));
    }

export const getListInventoryLotsUrl = (id: string,
    params?: ListInventoryLotsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/${id}/lots?${stringifiedParams}` : `/api/inventory/${id}/lots`
}

/**
 * @summary Paginated cost lots for one inventory product
 */
export const listInventoryLots = async (id: string,
    params?: ListInventoryLotsParams, options?: RequestInit): Promise<ListInventoryLots200> => {

  return customFetch<ListInventoryLots200>(getListInventoryLotsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInventoryLotsQueryKey = (id: string,
    params?: ListInventoryLotsParams,) => {
    return [
    `/api/inventory/${id}/lots`, ...(params ? [params] : [])
    ] as const;
    }


export const getListInventoryLotsQueryOptions = <TData = Awaited<ReturnType<typeof listInventoryLots>>, TError = ErrorType<unknown>>(id: string,
    params?: ListInventoryLotsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventoryLots>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInventoryLotsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInventoryLots>>> = ({ signal }) => listInventoryLots(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInventoryLots>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInventoryLotsQueryResult = NonNullable<Awaited<ReturnType<typeof listInventoryLots>>>
export type ListInventoryLotsQueryError = ErrorType<unknown>


/**
 * @summary Paginated cost lots for one inventory product
 */

export function useListInventoryLots<TData = Awaited<ReturnType<typeof listInventoryLots>>, TError = ErrorType<unknown>>(
 id: string,
    params?: ListInventoryLotsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventoryLots>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInventoryLotsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetInventoryLotSummaryUrl = (id: string,) => {




  return `/api/inventory/${id}/lots/summary`
}

/**
 * @summary Product-level stock and labelled costing summary
 */
export const getInventoryLotSummary = async (id: string, options?: RequestInit): Promise<InventoryLotSummary> => {

  return customFetch<InventoryLotSummary>(getGetInventoryLotSummaryUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventoryLotSummaryQueryKey = (id: string,) => {
    return [
    `/api/inventory/${id}/lots/summary`
    ] as const;
    }


export const getGetInventoryLotSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryLotSummary>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryLotSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryLotSummaryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryLotSummary>>> = ({ signal }) => getInventoryLotSummary(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryLotSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInventoryLotSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryLotSummary>>>
export type GetInventoryLotSummaryQueryError = ErrorType<unknown>


/**
 * @summary Product-level stock and labelled costing summary
 */

export function useGetInventoryLotSummary<TData = Awaited<ReturnType<typeof getInventoryLotSummary>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryLotSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInventoryLotSummaryQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListInventoryLotPurchasesUrl = (id: string,
    params?: ListInventoryLotPurchasesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/${id}/lots/purchases?${stringifiedParams}` : `/api/inventory/${id}/lots/purchases`
}

/**
 * @summary Paginated purchase and receipt history for one product
 */
export const listInventoryLotPurchases = async (id: string,
    params?: ListInventoryLotPurchasesParams, options?: RequestInit): Promise<ListInventoryLotPurchases200> => {

  return customFetch<ListInventoryLotPurchases200>(getListInventoryLotPurchasesUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInventoryLotPurchasesQueryKey = (id: string,
    params?: ListInventoryLotPurchasesParams,) => {
    return [
    `/api/inventory/${id}/lots/purchases`, ...(params ? [params] : [])
    ] as const;
    }


export const getListInventoryLotPurchasesQueryOptions = <TData = Awaited<ReturnType<typeof listInventoryLotPurchases>>, TError = ErrorType<unknown>>(id: string,
    params?: ListInventoryLotPurchasesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventoryLotPurchases>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInventoryLotPurchasesQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInventoryLotPurchases>>> = ({ signal }) => listInventoryLotPurchases(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInventoryLotPurchases>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInventoryLotPurchasesQueryResult = NonNullable<Awaited<ReturnType<typeof listInventoryLotPurchases>>>
export type ListInventoryLotPurchasesQueryError = ErrorType<unknown>


/**
 * @summary Paginated purchase and receipt history for one product
 */

export function useListInventoryLotPurchases<TData = Awaited<ReturnType<typeof listInventoryLotPurchases>>, TError = ErrorType<unknown>>(
 id: string,
    params?: ListInventoryLotPurchasesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventoryLotPurchases>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInventoryLotPurchasesQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListInventorySalesHistoryUrl = (id: string,
    params?: ListInventorySalesHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/${id}/sales-history?${stringifiedParams}` : `/api/inventory/${id}/sales-history`
}

/**
 * @summary Sale lines for one product with lot COGS and true profit
 */
export const listInventorySalesHistory = async (id: string,
    params?: ListInventorySalesHistoryParams, options?: RequestInit): Promise<ListInventorySalesHistory200> => {

  return customFetch<ListInventorySalesHistory200>(getListInventorySalesHistoryUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInventorySalesHistoryQueryKey = (id: string,
    params?: ListInventorySalesHistoryParams,) => {
    return [
    `/api/inventory/${id}/sales-history`, ...(params ? [params] : [])
    ] as const;
    }


export const getListInventorySalesHistoryQueryOptions = <TData = Awaited<ReturnType<typeof listInventorySalesHistory>>, TError = ErrorType<unknown>>(id: string,
    params?: ListInventorySalesHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventorySalesHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInventorySalesHistoryQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInventorySalesHistory>>> = ({ signal }) => listInventorySalesHistory(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInventorySalesHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInventorySalesHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof listInventorySalesHistory>>>
export type ListInventorySalesHistoryQueryError = ErrorType<unknown>


/**
 * @summary Sale lines for one product with lot COGS and true profit
 */

export function useListInventorySalesHistory<TData = Awaited<ReturnType<typeof listInventorySalesHistory>>, TError = ErrorType<unknown>>(
 id: string,
    params?: ListInventorySalesHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventorySalesHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInventorySalesHistoryQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetInventoryLotUrl = (lotId: string,) => {




  return `/api/inventory/lots/${lotId}`
}

/**
 * @summary Lot detail with corrections and sales allocations
 */
export const getInventoryLot = async (lotId: string, options?: RequestInit): Promise<InventoryLotDetail> => {

  return customFetch<InventoryLotDetail>(getGetInventoryLotUrl(lotId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventoryLotQueryKey = (lotId: string,) => {
    return [
    `/api/inventory/lots/${lotId}`
    ] as const;
    }


export const getGetInventoryLotQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryLot>>, TError = ErrorType<unknown>>(lotId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryLot>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryLotQueryKey(lotId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryLot>>> = ({ signal }) => getInventoryLot(lotId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: lotId !== null && lotId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryLot>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInventoryLotQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryLot>>>
export type GetInventoryLotQueryError = ErrorType<unknown>


/**
 * @summary Lot detail with corrections and sales allocations
 */

export function useGetInventoryLot<TData = Awaited<ReturnType<typeof getInventoryLot>>, TError = ErrorType<unknown>>(
 lotId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryLot>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInventoryLotQueryOptions(lotId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetInventoryCostingSettingsUrl = () => {




  return `/api/inventory/lots/settings`
}

/**
 * @summary Read tenant stock and costing settings
 */
export const getInventoryCostingSettings = async ( options?: RequestInit): Promise<InventoryCostingSettings> => {

  return customFetch<InventoryCostingSettings>(getGetInventoryCostingSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventoryCostingSettingsQueryKey = () => {
    return [
    `/api/inventory/lots/settings`
    ] as const;
    }


export const getGetInventoryCostingSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryCostingSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryCostingSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryCostingSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryCostingSettings>>> = ({ signal }) => getInventoryCostingSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryCostingSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInventoryCostingSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryCostingSettings>>>
export type GetInventoryCostingSettingsQueryError = ErrorType<unknown>


/**
 * @summary Read tenant stock and costing settings
 */

export function useGetInventoryCostingSettings<TData = Awaited<ReturnType<typeof getInventoryCostingSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryCostingSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInventoryCostingSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateInventoryCostingSettingsUrl = () => {




  return `/api/inventory/lots/settings`
}

/**
 * @summary Update tenant stock and costing settings
 */
export const updateInventoryCostingSettings = async (inventoryCostingSettingsInput: InventoryCostingSettingsInput, options?: RequestInit): Promise<InventoryCostingSettings> => {

  return customFetch<InventoryCostingSettings>(getUpdateInventoryCostingSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryCostingSettingsInput)
  }
);}





export const getUpdateInventoryCostingSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInventoryCostingSettings>>, TError,{data: BodyType<InventoryCostingSettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInventoryCostingSettings>>, TError,{data: BodyType<InventoryCostingSettingsInput>}, TContext> => {

const mutationKey = ['updateInventoryCostingSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInventoryCostingSettings>>, {data: BodyType<InventoryCostingSettingsInput>}> = (props) => {
          const {data} = props ?? {};

          return  updateInventoryCostingSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateInventoryCostingSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateInventoryCostingSettings>>>
    export type UpdateInventoryCostingSettingsMutationBody = BodyType<InventoryCostingSettingsInput>
    export type UpdateInventoryCostingSettingsMutationError = ErrorType<unknown>

    /**
 * @summary Update tenant stock and costing settings
 */
export const useUpdateInventoryCostingSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInventoryCostingSettings>>, TError,{data: BodyType<InventoryCostingSettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateInventoryCostingSettings>>,
        TError,
        {data: BodyType<InventoryCostingSettingsInput>},
        TContext
      > => {
      return useMutation(getUpdateInventoryCostingSettingsMutationOptions(options));
    }

export const getPatchInventoryItemTiktokOverridesUrl = (id: string,) => {




  return `/api/inventory/${id}/tiktok-overrides`
}

/**
 * @summary Save per-item TikTok Shop listing overrides, including pre-order mode. Pass null to clear all overrides.
 */
export const patchInventoryItemTiktokOverrides = async (id: string,
    tikTokOverrides: TikTokOverrides, options?: RequestInit): Promise<InventoryItem> => {

  return customFetch<InventoryItem>(getPatchInventoryItemTiktokOverridesUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tikTokOverrides)
  }
);}





export const getPatchInventoryItemTiktokOverridesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchInventoryItemTiktokOverrides>>, TError,{id: string;data: BodyType<TikTokOverrides>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchInventoryItemTiktokOverrides>>, TError,{id: string;data: BodyType<TikTokOverrides>}, TContext> => {

const mutationKey = ['patchInventoryItemTiktokOverrides'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchInventoryItemTiktokOverrides>>, {id: string;data: BodyType<TikTokOverrides>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchInventoryItemTiktokOverrides(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchInventoryItemTiktokOverridesMutationResult = NonNullable<Awaited<ReturnType<typeof patchInventoryItemTiktokOverrides>>>
    export type PatchInventoryItemTiktokOverridesMutationBody = BodyType<TikTokOverrides>
    export type PatchInventoryItemTiktokOverridesMutationError = ErrorType<unknown>

    /**
 * @summary Save per-item TikTok Shop listing overrides, including pre-order mode. Pass null to clear all overrides.
 */
export const usePatchInventoryItemTiktokOverrides = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchInventoryItemTiktokOverrides>>, TError,{id: string;data: BodyType<TikTokOverrides>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchInventoryItemTiktokOverrides>>,
        TError,
        {id: string;data: BodyType<TikTokOverrides>},
        TContext
      > => {
      return useMutation(getPatchInventoryItemTiktokOverridesMutationOptions(options));
    }

export const getGetInventoryChannelSyncEventsUrl = (id: string,
    params?: GetInventoryChannelSyncEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/${id}/channel-sync-events?${stringifiedParams}` : `/api/inventory/${id}/channel-sync-events`
}

/**
 * @summary Returns a paginated, timestamped log of every outbound stock-push
event across all channels (eBay, Shopify, WooCommerce, TikTok Shop)
for a single inventory item. Powers the "Channel Sync" tab on the
item detail page.

 */
export const getInventoryChannelSyncEvents = async (id: string,
    params?: GetInventoryChannelSyncEventsParams, options?: RequestInit): Promise<GetInventoryChannelSyncEvents200> => {

  return customFetch<GetInventoryChannelSyncEvents200>(getGetInventoryChannelSyncEventsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventoryChannelSyncEventsQueryKey = (id: string,
    params?: GetInventoryChannelSyncEventsParams,) => {
    return [
    `/api/inventory/${id}/channel-sync-events`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetInventoryChannelSyncEventsQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryChannelSyncEvents>>, TError = ErrorType<void>>(id: string,
    params?: GetInventoryChannelSyncEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryChannelSyncEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryChannelSyncEventsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryChannelSyncEvents>>> = ({ signal }) => getInventoryChannelSyncEvents(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryChannelSyncEvents>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInventoryChannelSyncEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryChannelSyncEvents>>>
export type GetInventoryChannelSyncEventsQueryError = ErrorType<void>


/**
 * @summary Returns a paginated, timestamped log of every outbound stock-push
event across all channels (eBay, Shopify, WooCommerce, TikTok Shop)
for a single inventory item. Powers the "Channel Sync" tab on the
item detail page.

 */

export function useGetInventoryChannelSyncEvents<TData = Awaited<ReturnType<typeof getInventoryChannelSyncEvents>>, TError = ErrorType<void>>(
 id: string,
    params?: GetInventoryChannelSyncEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryChannelSyncEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInventoryChannelSyncEventsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetInventoryLinkedChildrenUrl = (id: string,) => {




  return `/api/inventory/${id}/linked-children`
}

/**
 * Master-link lineage rollup. Given a master inventory item id,
 * return every child whose `masterInventoryItemId` points at it,
 * each annotated with realized-sales numbers (same `getOutputRollups`
 * helper the breakdown lineage panel uses). Money is computed in
 * integer micro-units server-side, returned as decimal strings.
 * 404 if the master doesn't exist in the caller's tenant.
 */
export const getInventoryLinkedChildren = async (id: string, options?: RequestInit): Promise<InventoryLinkedChildrenResponse> => {

  return customFetch<InventoryLinkedChildrenResponse>(getGetInventoryLinkedChildrenUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventoryLinkedChildrenQueryKey = (id: string,) => {
    return [
    `/api/inventory/${id}/linked-children`
    ] as const;
    }


export const getGetInventoryLinkedChildrenQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryLinkedChildren>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryLinkedChildren>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryLinkedChildrenQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryLinkedChildren>>> = ({ signal }) => getInventoryLinkedChildren(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryLinkedChildren>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInventoryLinkedChildrenQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryLinkedChildren>>>
export type GetInventoryLinkedChildrenQueryError = ErrorType<unknown>



export function useGetInventoryLinkedChildren<TData = Awaited<ReturnType<typeof getInventoryLinkedChildren>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryLinkedChildren>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInventoryLinkedChildrenQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateInventoryVariationUrl = (id: string,) => {




  return `/api/inventory/${id}/variations`
}

/**
 * Creates a new `inventory_items` row that inherits all metadata from
 * the parent (title, metal, purity, weight, photos, composite photo,
 * product type, eBay category, etc.) and sets `masterInventoryItemId`
 * to the parent's `id`. The `year` field is required and is set on
 * the child. SKU defaults to `{PARENT_SKU}-{year}` (uniqueness
 * checked); the operator may supply a custom suffix override.
 * Validates that the parent is not itself a child (no grandchildren).
 * Permission: `edit_inventory`.
 * @summary Create a year-specific variant child SKU for a mixed-lot parent.
 */
export const createInventoryVariation = async (id: string,
    createInventoryVariationBody: CreateInventoryVariationBody, options?: RequestInit): Promise<InventoryItem> => {

  return customFetch<InventoryItem>(getCreateInventoryVariationUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createInventoryVariationBody)
  }
);}





export const getCreateInventoryVariationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInventoryVariation>>, TError,{id: string;data: BodyType<CreateInventoryVariationBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInventoryVariation>>, TError,{id: string;data: BodyType<CreateInventoryVariationBody>}, TContext> => {

const mutationKey = ['createInventoryVariation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInventoryVariation>>, {id: string;data: BodyType<CreateInventoryVariationBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  createInventoryVariation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInventoryVariationMutationResult = NonNullable<Awaited<ReturnType<typeof createInventoryVariation>>>
    export type CreateInventoryVariationMutationBody = BodyType<CreateInventoryVariationBody>
    export type CreateInventoryVariationMutationError = ErrorType<void>

    /**
 * @summary Create a year-specific variant child SKU for a mixed-lot parent.
 */
export const useCreateInventoryVariation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInventoryVariation>>, TError,{id: string;data: BodyType<CreateInventoryVariationBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createInventoryVariation>>,
        TError,
        {id: string;data: BodyType<CreateInventoryVariationBody>},
        TContext
      > => {
      return useMutation(getCreateInventoryVariationMutationOptions(options));
    }

export const getBulkCreateInventoryVariationsUrl = (id: string,) => {




  return `/api/inventory/${id}/variations/bulk`
}

/**
 * Accepts an array of variation rows. All rows are validated first
 * (year range, per-row SKU uniqueness within the request and within
 * the tenant, grandchild guard). If any row fails validation the
 * entire request is rejected with per-row errors and nothing is
 * inserted. On success all variants are inserted in a single
 * transaction. Permission: `edit_inventory`.
 * @summary Create multiple year-variant child SKUs atomically from a CSV-like payload.
 */
export const bulkCreateInventoryVariations = async (id: string,
    bulkCreateInventoryVariationsBody: BulkCreateInventoryVariationsBody, options?: RequestInit): Promise<BulkCreateInventoryVariationsResponse> => {

  return customFetch<BulkCreateInventoryVariationsResponse>(getBulkCreateInventoryVariationsUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkCreateInventoryVariationsBody)
  }
);}





export const getBulkCreateInventoryVariationsMutationOptions = <TError = ErrorType<BulkCreateInventoryVariationsError | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkCreateInventoryVariations>>, TError,{id: string;data: BodyType<BulkCreateInventoryVariationsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkCreateInventoryVariations>>, TError,{id: string;data: BodyType<BulkCreateInventoryVariationsBody>}, TContext> => {

const mutationKey = ['bulkCreateInventoryVariations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkCreateInventoryVariations>>, {id: string;data: BodyType<BulkCreateInventoryVariationsBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  bulkCreateInventoryVariations(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkCreateInventoryVariationsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkCreateInventoryVariations>>>
    export type BulkCreateInventoryVariationsMutationBody = BodyType<BulkCreateInventoryVariationsBody>
    export type BulkCreateInventoryVariationsMutationError = ErrorType<BulkCreateInventoryVariationsError | void>

    /**
 * @summary Create multiple year-variant child SKUs atomically from a CSV-like payload.
 */
export const useBulkCreateInventoryVariations = <TError = ErrorType<BulkCreateInventoryVariationsError | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkCreateInventoryVariations>>, TError,{id: string;data: BodyType<BulkCreateInventoryVariationsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkCreateInventoryVariations>>,
        TError,
        {id: string;data: BodyType<BulkCreateInventoryVariationsBody>},
        TContext
      > => {
      return useMutation(getBulkCreateInventoryVariationsMutationOptions(options));
    }

export const getListShopifyPreviewLinksUrl = () => {




  return `/api/inventory/shopify-preview/links`
}

/**
 * Returns every non-expired "Preview on phone" (Task #71) link the
 * calling operator minted, so they can revoke a link even after the
 * QR dialog is closed (Task #82). Tenant + actor scoped — never
 * surfaces another operator's or another tenant's links. Each entry
 * carries the item's SKU + title so the operator can recognise which
 * item the link points at. Revoke via
 * `DELETE /inventory/{id}/shopify-preview/{nonce}`.
 * @summary List the calling operator's currently-live phone-preview links.
 */
export const listShopifyPreviewLinks = async ( options?: RequestInit): Promise<ShopifyPreviewLinksResponse> => {

  return customFetch<ShopifyPreviewLinksResponse>(getListShopifyPreviewLinksUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListShopifyPreviewLinksQueryKey = () => {
    return [
    `/api/inventory/shopify-preview/links`
    ] as const;
    }


export const getListShopifyPreviewLinksQueryOptions = <TData = Awaited<ReturnType<typeof listShopifyPreviewLinks>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShopifyPreviewLinks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListShopifyPreviewLinksQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listShopifyPreviewLinks>>> = ({ signal }) => listShopifyPreviewLinks({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listShopifyPreviewLinks>>, TError, TData> & { queryKey: QueryKey }
}

export type ListShopifyPreviewLinksQueryResult = NonNullable<Awaited<ReturnType<typeof listShopifyPreviewLinks>>>
export type ListShopifyPreviewLinksQueryError = ErrorType<unknown>


/**
 * @summary List the calling operator's currently-live phone-preview links.
 */

export function useListShopifyPreviewLinks<TData = Awaited<ReturnType<typeof listShopifyPreviewLinks>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShopifyPreviewLinks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListShopifyPreviewLinksQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getBulkDeleteInventoryUrl = () => {




  return `/api/inventory/bulk-delete`
}

/**
 * @summary Delete multiple inventory items in one call. Items still referenced by a sale are skipped and reported.
 */
export const bulkDeleteInventory = async (bulkIdRequest: BulkIdRequest, options?: RequestInit): Promise<BulkInventoryDeleteResult> => {

  return customFetch<BulkInventoryDeleteResult>(getBulkDeleteInventoryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkIdRequest)
  }
);}





export const getBulkDeleteInventoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteInventory>>, TError,{data: BodyType<BulkIdRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteInventory>>, TError,{data: BodyType<BulkIdRequest>}, TContext> => {

const mutationKey = ['bulkDeleteInventory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkDeleteInventory>>, {data: BodyType<BulkIdRequest>}> = (props) => {
          const {data} = props ?? {};

          return  bulkDeleteInventory(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkDeleteInventoryMutationResult = NonNullable<Awaited<ReturnType<typeof bulkDeleteInventory>>>
    export type BulkDeleteInventoryMutationBody = BodyType<BulkIdRequest>
    export type BulkDeleteInventoryMutationError = ErrorType<unknown>

    /**
 * @summary Delete multiple inventory items in one call. Items still referenced by a sale are skipped and reported.
 */
export const useBulkDeleteInventory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteInventory>>, TError,{data: BodyType<BulkIdRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkDeleteInventory>>,
        TError,
        {data: BodyType<BulkIdRequest>},
        TContext
      > => {
      return useMutation(getBulkDeleteInventoryMutationOptions(options));
    }

export const getBulkEditInventoryUrl = () => {




  return `/api/inventory/bulk-edit`
}

/**
 * @summary Apply the same field changes to multiple inventory items in one call.
Designed for batched consignment intake (e.g. assign a Jason 50/50
split across many SKUs at once). Each item is validated independently
— items that fail validation (invalid consignment terms, etc.) are
skipped with a per-id reason rather than failing the whole batch.
By default items with sales (quantitySold > 0) are skipped unless
`includeSold=true` is set.

 */
export const bulkEditInventory = async (bulkInventoryEditRequest: BulkInventoryEditRequest, options?: RequestInit): Promise<BulkInventoryEditResult> => {

  return customFetch<BulkInventoryEditResult>(getBulkEditInventoryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkInventoryEditRequest)
  }
);}





export const getBulkEditInventoryMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkEditInventory>>, TError,{data: BodyType<BulkInventoryEditRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkEditInventory>>, TError,{data: BodyType<BulkInventoryEditRequest>}, TContext> => {

const mutationKey = ['bulkEditInventory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkEditInventory>>, {data: BodyType<BulkInventoryEditRequest>}> = (props) => {
          const {data} = props ?? {};

          return  bulkEditInventory(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkEditInventoryMutationResult = NonNullable<Awaited<ReturnType<typeof bulkEditInventory>>>
    export type BulkEditInventoryMutationBody = BodyType<BulkInventoryEditRequest>
    export type BulkEditInventoryMutationError = ErrorType<void>

    /**
 * @summary Apply the same field changes to multiple inventory items in one call.
Designed for batched consignment intake (e.g. assign a Jason 50/50
split across many SKUs at once). Each item is validated independently
— items that fail validation (invalid consignment terms, etc.) are
skipped with a per-id reason rather than failing the whole batch.
By default items with sales (quantitySold > 0) are skipped unless
`includeSold=true` is set.

 */
export const useBulkEditInventory = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkEditInventory>>, TError,{data: BodyType<BulkInventoryEditRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkEditInventory>>,
        TError,
        {data: BodyType<BulkInventoryEditRequest>},
        TContext
      > => {
      return useMutation(getBulkEditInventoryMutationOptions(options));
    }

export const getMergeInventoryItemsUrl = () => {




  return `/api/inventory/merge`
}

/**
 * @summary Merge N "loser" inventory lots into one "survivor" lot. Every
sale_order_items row pointing at a loser is repointed at the
survivor (P&L history stays intact because each sale line already
snapshotted its `effectiveUnitCost` at sale time). Functional FKs
(categories, packaging presets, shopify stock-push log, dropship
orders) are repointed with conflict-skip; history FKs (imports,
title mappings, reallocations, invoice source, validation log)
are NULL-ed on the loser side. The survivor's `landedUnitCost`
is replaced by the weighted average of all lots (by available
qty, fallback to total qty when every lot is sold out — same
rule the grouped-view dashboard uses). Survivor wins on all
identity fields (title / brand / description / photos primary /
external listings primary); photo arrays + compositeArchive are
merged (survivor first, unique-by-URL from losers). All of these
defaults can be overridden per-group via `fieldSources` (identity /
images / per-channel listings / cost pin).

Ownership: mixing OWNED and CONSIGNMENT lots is allowed — the
survivor becomes a CONSIGNMENT SKU and the OWNED lots' available
units fold into `quantityOwned` (sold without crediting the
consignor; past sales are untouched). All-CONSIGNMENT merges
require the lots to share consignor + batch + payout terms.

Blockers (returns 409 with a `blockers` array, never partially
applies): different consignor, consignment batch mismatch,
consignment terms mismatch, currency mismatch, loser is a variant
master, loser referenced by inventory_transformations /
consignment_payout_lines, loser PO linked to a non-finalised
shipment group, unresolved per-channel marketplace listing
conflict (resolvable via `fieldSources.listings`).

Set `dryRun: true` to validate + compute the new cost without
writing — used by the FE merge dialog to surface a preview.

 */
export const mergeInventoryItems = async (mergeInventoryRequest: MergeInventoryRequest, options?: RequestInit): Promise<MergeInventoryResult> => {

  return customFetch<MergeInventoryResult>(getMergeInventoryItemsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mergeInventoryRequest)
  }
);}





export const getMergeInventoryItemsMutationOptions = <TError = ErrorType<void | MergeInventoryBlockedResult>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mergeInventoryItems>>, TError,{data: BodyType<MergeInventoryRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof mergeInventoryItems>>, TError,{data: BodyType<MergeInventoryRequest>}, TContext> => {

const mutationKey = ['mergeInventoryItems'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mergeInventoryItems>>, {data: BodyType<MergeInventoryRequest>}> = (props) => {
          const {data} = props ?? {};

          return  mergeInventoryItems(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MergeInventoryItemsMutationResult = NonNullable<Awaited<ReturnType<typeof mergeInventoryItems>>>
    export type MergeInventoryItemsMutationBody = BodyType<MergeInventoryRequest>
    export type MergeInventoryItemsMutationError = ErrorType<void | MergeInventoryBlockedResult>

    /**
 * @summary Merge N "loser" inventory lots into one "survivor" lot. Every
sale_order_items row pointing at a loser is repointed at the
survivor (P&L history stays intact because each sale line already
snapshotted its `effectiveUnitCost` at sale time). Functional FKs
(categories, packaging presets, shopify stock-push log, dropship
orders) are repointed with conflict-skip; history FKs (imports,
title mappings, reallocations, invoice source, validation log)
are NULL-ed on the loser side. The survivor's `landedUnitCost`
is replaced by the weighted average of all lots (by available
qty, fallback to total qty when every lot is sold out — same
rule the grouped-view dashboard uses). Survivor wins on all
identity fields (title / brand / description / photos primary /
external listings primary); photo arrays + compositeArchive are
merged (survivor first, unique-by-URL from losers). All of these
defaults can be overridden per-group via `fieldSources` (identity /
images / per-channel listings / cost pin).

Ownership: mixing OWNED and CONSIGNMENT lots is allowed — the
survivor becomes a CONSIGNMENT SKU and the OWNED lots' available
units fold into `quantityOwned` (sold without crediting the
consignor; past sales are untouched). All-CONSIGNMENT merges
require the lots to share consignor + batch + payout terms.

Blockers (returns 409 with a `blockers` array, never partially
applies): different consignor, consignment batch mismatch,
consignment terms mismatch, currency mismatch, loser is a variant
master, loser referenced by inventory_transformations /
consignment_payout_lines, loser PO linked to a non-finalised
shipment group, unresolved per-channel marketplace listing
conflict (resolvable via `fieldSources.listings`).

Set `dryRun: true` to validate + compute the new cost without
writing — used by the FE merge dialog to surface a preview.

 */
export const useMergeInventoryItems = <TError = ErrorType<void | MergeInventoryBlockedResult>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mergeInventoryItems>>, TError,{data: BodyType<MergeInventoryRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof mergeInventoryItems>>,
        TError,
        {data: BodyType<MergeInventoryRequest>},
        TContext
      > => {
      return useMutation(getMergeInventoryItemsMutationOptions(options));
    }

export const getUpdateInventoryVatClassificationUrl = (id: string,) => {




  return `/api/inventory/${id}/vat`
}

/**
 * @summary Admin-only VAT classification update (Phase 1 Slice 2). Gated by
the `manage_vat_backfill` permission. Partial PATCH semantics —
only fields explicitly present in the body are touched. Tri-state
booleans (`true` | `false` | `null`) are preserved verbatim;
`false` and `null` are NOT interchangeable. Each changed field
emits one `audit_logs` row (entityType=`VAT_TREATMENT`). The
validator runs but is non-blocking — the save always succeeds
when the body parses; warnings are returned in the response so
the UI can surface them inline.

 */
export const updateInventoryVatClassification = async (id: string,
    updateVatClassificationBody: UpdateVatClassificationBody, options?: RequestInit): Promise<InventoryItemDetail> => {

  return customFetch<InventoryItemDetail>(getUpdateInventoryVatClassificationUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateVatClassificationBody)
  }
);}





export const getUpdateInventoryVatClassificationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInventoryVatClassification>>, TError,{id: string;data: BodyType<UpdateVatClassificationBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInventoryVatClassification>>, TError,{id: string;data: BodyType<UpdateVatClassificationBody>}, TContext> => {

const mutationKey = ['updateInventoryVatClassification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInventoryVatClassification>>, {id: string;data: BodyType<UpdateVatClassificationBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateInventoryVatClassification(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateInventoryVatClassificationMutationResult = NonNullable<Awaited<ReturnType<typeof updateInventoryVatClassification>>>
    export type UpdateInventoryVatClassificationMutationBody = BodyType<UpdateVatClassificationBody>
    export type UpdateInventoryVatClassificationMutationError = ErrorType<void>

    /**
 * @summary Admin-only VAT classification update (Phase 1 Slice 2). Gated by
the `manage_vat_backfill` permission. Partial PATCH semantics —
only fields explicitly present in the body are touched. Tri-state
booleans (`true` | `false` | `null`) are preserved verbatim;
`false` and `null` are NOT interchangeable. Each changed field
emits one `audit_logs` row (entityType=`VAT_TREATMENT`). The
validator runs but is non-blocking — the save always succeeds
when the body parses; warnings are returned in the response so
the UI can surface them inline.

 */
export const useUpdateInventoryVatClassification = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInventoryVatClassification>>, TError,{id: string;data: BodyType<UpdateVatClassificationBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateInventoryVatClassification>>,
        TError,
        {id: string;data: BodyType<UpdateVatClassificationBody>},
        TContext
      > => {
      return useMutation(getUpdateInventoryVatClassificationMutationOptions(options));
    }

export const getUpdateInventoryStatusUrl = (id: string,) => {




  return `/api/inventory/${id}/status`
}

/**
 * @summary Update inventory item status (listed, reserved, sold, etc.)
 */
export const updateInventoryStatus = async (id: string,
    inventoryStatusUpdate: InventoryStatusUpdate, options?: RequestInit): Promise<InventoryItem> => {

  return customFetch<InventoryItem>(getUpdateInventoryStatusUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryStatusUpdate)
  }
);}





export const getUpdateInventoryStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInventoryStatus>>, TError,{id: string;data: BodyType<InventoryStatusUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInventoryStatus>>, TError,{id: string;data: BodyType<InventoryStatusUpdate>}, TContext> => {

const mutationKey = ['updateInventoryStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInventoryStatus>>, {id: string;data: BodyType<InventoryStatusUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateInventoryStatus(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateInventoryStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateInventoryStatus>>>
    export type UpdateInventoryStatusMutationBody = BodyType<InventoryStatusUpdate>
    export type UpdateInventoryStatusMutationError = ErrorType<unknown>

    /**
 * @summary Update inventory item status (listed, reserved, sold, etc.)
 */
export const useUpdateInventoryStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInventoryStatus>>, TError,{id: string;data: BodyType<InventoryStatusUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateInventoryStatus>>,
        TError,
        {id: string;data: BodyType<InventoryStatusUpdate>},
        TContext
      > => {
      return useMutation(getUpdateInventoryStatusMutationOptions(options));
    }

export const getReturnToSupplierUrl = () => {




  return `/api/inventory/return-to-supplier`
}

/**
 * @summary Return consignment stock to the supplier. Reduces inventory quantity,
writes stock_movement audit entries, and syncs external channels.
Only CONSIGNMENT stock can be returned. Items with active (non-Draft,
non-Cancelled) payouts are blocked to prevent financial inconsistency.

 */
export const returnToSupplier = async (returnToSupplierInput: ReturnToSupplierInput, options?: RequestInit): Promise<ReturnToSupplierResult> => {

  return customFetch<ReturnToSupplierResult>(getReturnToSupplierUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(returnToSupplierInput)
  }
);}





export const getReturnToSupplierMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof returnToSupplier>>, TError,{data: BodyType<ReturnToSupplierInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof returnToSupplier>>, TError,{data: BodyType<ReturnToSupplierInput>}, TContext> => {

const mutationKey = ['returnToSupplier'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof returnToSupplier>>, {data: BodyType<ReturnToSupplierInput>}> = (props) => {
          const {data} = props ?? {};

          return  returnToSupplier(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReturnToSupplierMutationResult = NonNullable<Awaited<ReturnType<typeof returnToSupplier>>>
    export type ReturnToSupplierMutationBody = BodyType<ReturnToSupplierInput>
    export type ReturnToSupplierMutationError = ErrorType<void>

    /**
 * @summary Return consignment stock to the supplier. Reduces inventory quantity,
writes stock_movement audit entries, and syncs external channels.
Only CONSIGNMENT stock can be returned. Items with active (non-Draft,
non-Cancelled) payouts are blocked to prevent financial inconsistency.

 */
export const useReturnToSupplier = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof returnToSupplier>>, TError,{data: BodyType<ReturnToSupplierInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof returnToSupplier>>,
        TError,
        {data: BodyType<ReturnToSupplierInput>},
        TContext
      > => {
      return useMutation(getReturnToSupplierMutationOptions(options));
    }

export const getRecalculateInventorySaleCostsUrl = (id: string,) => {




  return `/api/inventory/${id}/recalculate-sale-costs`
}

/**
 * @summary Opt-in recalculation of historical sale-line costs after an inventory
item's cost terms change. Default behaviour for sale lines is to
snapshot cost at sale time — this endpoint is the explicit way to
re-apply current terms to past sales, with safety filters and full
preview/audit. Lines that are paid out, refunded, cancelled, or
manually-overridden are always skipped.

 */
export const recalculateInventorySaleCosts = async (id: string,
    recalcSaleCostsBody: RecalcSaleCostsBody, options?: RequestInit): Promise<RecalcSaleCostsResult> => {

  return customFetch<RecalcSaleCostsResult>(getRecalculateInventorySaleCostsUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(recalcSaleCostsBody)
  }
);}





export const getRecalculateInventorySaleCostsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recalculateInventorySaleCosts>>, TError,{id: string;data: BodyType<RecalcSaleCostsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recalculateInventorySaleCosts>>, TError,{id: string;data: BodyType<RecalcSaleCostsBody>}, TContext> => {

const mutationKey = ['recalculateInventorySaleCosts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recalculateInventorySaleCosts>>, {id: string;data: BodyType<RecalcSaleCostsBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  recalculateInventorySaleCosts(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecalculateInventorySaleCostsMutationResult = NonNullable<Awaited<ReturnType<typeof recalculateInventorySaleCosts>>>
    export type RecalculateInventorySaleCostsMutationBody = BodyType<RecalcSaleCostsBody>
    export type RecalculateInventorySaleCostsMutationError = ErrorType<void>

    /**
 * @summary Opt-in recalculation of historical sale-line costs after an inventory
item's cost terms change. Default behaviour for sale lines is to
snapshot cost at sale time — this endpoint is the explicit way to
re-apply current terms to past sales, with safety filters and full
preview/audit. Lines that are paid out, refunded, cancelled, or
manually-overridden are always skipped.

 */
export const useRecalculateInventorySaleCosts = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recalculateInventorySaleCosts>>, TError,{id: string;data: BodyType<RecalcSaleCostsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recalculateInventorySaleCosts>>,
        TError,
        {id: string;data: BodyType<RecalcSaleCostsBody>},
        TContext
      > => {
      return useMutation(getRecalculateInventorySaleCostsMutationOptions(options));
    }

export const getGetRepairCentreIssuesUrl = () => {




  return `/api/inventory/repair-centre/issues`
}

/**
 * @summary Detect all inventory counter mismatches
 */
export const getRepairCentreIssues = async ( options?: RequestInit): Promise<GetRepairCentreIssues200> => {

  return customFetch<GetRepairCentreIssues200>(getGetRepairCentreIssuesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRepairCentreIssuesQueryKey = () => {
    return [
    `/api/inventory/repair-centre/issues`
    ] as const;
    }


export const getGetRepairCentreIssuesQueryOptions = <TData = Awaited<ReturnType<typeof getRepairCentreIssues>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRepairCentreIssues>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRepairCentreIssuesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRepairCentreIssues>>> = ({ signal }) => getRepairCentreIssues({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRepairCentreIssues>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRepairCentreIssuesQueryResult = NonNullable<Awaited<ReturnType<typeof getRepairCentreIssues>>>
export type GetRepairCentreIssuesQueryError = ErrorType<unknown>


/**
 * @summary Detect all inventory counter mismatches
 */

export function useGetRepairCentreIssues<TData = Awaited<ReturnType<typeof getRepairCentreIssues>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRepairCentreIssues>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRepairCentreIssuesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetRepairCentreIssueCountUrl = () => {




  return `/api/inventory/repair-centre/issue-count`
}

/**
 * @summary Get count of inventory issues (lightweight for dashboard badge)
 */
export const getRepairCentreIssueCount = async ( options?: RequestInit): Promise<GetRepairCentreIssueCount200> => {

  return customFetch<GetRepairCentreIssueCount200>(getGetRepairCentreIssueCountUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRepairCentreIssueCountQueryKey = () => {
    return [
    `/api/inventory/repair-centre/issue-count`
    ] as const;
    }


export const getGetRepairCentreIssueCountQueryOptions = <TData = Awaited<ReturnType<typeof getRepairCentreIssueCount>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRepairCentreIssueCount>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRepairCentreIssueCountQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRepairCentreIssueCount>>> = ({ signal }) => getRepairCentreIssueCount({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRepairCentreIssueCount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRepairCentreIssueCountQueryResult = NonNullable<Awaited<ReturnType<typeof getRepairCentreIssueCount>>>
export type GetRepairCentreIssueCountQueryError = ErrorType<unknown>


/**
 * @summary Get count of inventory issues (lightweight for dashboard badge)
 */

export function useGetRepairCentreIssueCount<TData = Awaited<ReturnType<typeof getRepairCentreIssueCount>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRepairCentreIssueCount>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRepairCentreIssueCountQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPreviewRepairActionUrl = () => {




  return `/api/inventory/repair-centre/preview`
}

/**
 * @summary Preview impact of a repair action before applying
 */
export const previewRepairAction = async (repairActionRequest: RepairActionRequest, options?: RequestInit): Promise<RepairPreviewResult> => {

  return customFetch<RepairPreviewResult>(getPreviewRepairActionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(repairActionRequest)
  }
);}





export const getPreviewRepairActionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewRepairAction>>, TError,{data: BodyType<RepairActionRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewRepairAction>>, TError,{data: BodyType<RepairActionRequest>}, TContext> => {

const mutationKey = ['previewRepairAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewRepairAction>>, {data: BodyType<RepairActionRequest>}> = (props) => {
          const {data} = props ?? {};

          return  previewRepairAction(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewRepairActionMutationResult = NonNullable<Awaited<ReturnType<typeof previewRepairAction>>>
    export type PreviewRepairActionMutationBody = BodyType<RepairActionRequest>
    export type PreviewRepairActionMutationError = ErrorType<void>

    /**
 * @summary Preview impact of a repair action before applying
 */
export const usePreviewRepairAction = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewRepairAction>>, TError,{data: BodyType<RepairActionRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof previewRepairAction>>,
        TError,
        {data: BodyType<RepairActionRequest>},
        TContext
      > => {
      return useMutation(getPreviewRepairActionMutationOptions(options));
    }

export const getApplyRepairActionUrl = () => {




  return `/api/inventory/repair-centre/apply`
}

/**
 * @summary Apply a repair action in a transaction with full logging
 */
export const applyRepairAction = async (repairActionRequest: RepairActionRequest, options?: RequestInit): Promise<ApplyRepairAction200> => {

  return customFetch<ApplyRepairAction200>(getApplyRepairActionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(repairActionRequest)
  }
);}





export const getApplyRepairActionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyRepairAction>>, TError,{data: BodyType<RepairActionRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof applyRepairAction>>, TError,{data: BodyType<RepairActionRequest>}, TContext> => {

const mutationKey = ['applyRepairAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof applyRepairAction>>, {data: BodyType<RepairActionRequest>}> = (props) => {
          const {data} = props ?? {};

          return  applyRepairAction(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApplyRepairActionMutationResult = NonNullable<Awaited<ReturnType<typeof applyRepairAction>>>
    export type ApplyRepairActionMutationBody = BodyType<RepairActionRequest>
    export type ApplyRepairActionMutationError = ErrorType<void>

    /**
 * @summary Apply a repair action in a transaction with full logging
 */
export const useApplyRepairAction = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyRepairAction>>, TError,{data: BodyType<RepairActionRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof applyRepairAction>>,
        TError,
        {data: BodyType<RepairActionRequest>},
        TContext
      > => {
      return useMutation(getApplyRepairActionMutationOptions(options));
    }

export const getGetRepairCentreLogsUrl = (params?: GetRepairCentreLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/repair-centre/logs?${stringifiedParams}` : `/api/inventory/repair-centre/logs`
}

/**
 * @summary Get repair centre audit log history
 */
export const getRepairCentreLogs = async (params?: GetRepairCentreLogsParams, options?: RequestInit): Promise<RepairLog[]> => {

  return customFetch<RepairLog[]>(getGetRepairCentreLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRepairCentreLogsQueryKey = (params?: GetRepairCentreLogsParams,) => {
    return [
    `/api/inventory/repair-centre/logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetRepairCentreLogsQueryOptions = <TData = Awaited<ReturnType<typeof getRepairCentreLogs>>, TError = ErrorType<unknown>>(params?: GetRepairCentreLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRepairCentreLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRepairCentreLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRepairCentreLogs>>> = ({ signal }) => getRepairCentreLogs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRepairCentreLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRepairCentreLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getRepairCentreLogs>>>
export type GetRepairCentreLogsQueryError = ErrorType<unknown>


/**
 * @summary Get repair centre audit log history
 */

export function useGetRepairCentreLogs<TData = Awaited<ReturnType<typeof getRepairCentreLogs>>, TError = ErrorType<unknown>>(
 params?: GetRepairCentreLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRepairCentreLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRepairCentreLogsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetInventoryValuationHealthUrl = () => {




  return `/api/inventory/valuation/health`
}

/**
 * @summary Valuation health check — counts of unclassified, excluded, and
spot_tracked-missing-weight items, plus the age of the last portfolio
snapshot. Gated behind advanced_inventory_valuation_enabled + view_inventory_valuation.

 */
export const getInventoryValuationHealth = async ( options?: RequestInit): Promise<ValuationHealthSummary> => {

  return customFetch<ValuationHealthSummary>(getGetInventoryValuationHealthUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventoryValuationHealthQueryKey = () => {
    return [
    `/api/inventory/valuation/health`
    ] as const;
    }


export const getGetInventoryValuationHealthQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryValuationHealth>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryValuationHealth>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryValuationHealthQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryValuationHealth>>> = ({ signal }) => getInventoryValuationHealth({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryValuationHealth>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInventoryValuationHealthQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryValuationHealth>>>
export type GetInventoryValuationHealthQueryError = ErrorType<void>


/**
 * @summary Valuation health check — counts of unclassified, excluded, and
spot_tracked-missing-weight items, plus the age of the last portfolio
snapshot. Gated behind advanced_inventory_valuation_enabled + view_inventory_valuation.

 */

export function useGetInventoryValuationHealth<TData = Awaited<ReturnType<typeof getInventoryValuationHealth>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryValuationHealth>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInventoryValuationHealthQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListInventoryTransformationsUrl = (params?: ListInventoryTransformationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/transformations?${stringifiedParams}` : `/api/inventory/transformations`
}

/**
 * @summary List breakdown transformations. Optionally filter by source or
output inventory item. Most-recent first.

 */
export const listInventoryTransformations = async (params?: ListInventoryTransformationsParams, options?: RequestInit): Promise<InventoryTransformationDetail[]> => {

  return customFetch<InventoryTransformationDetail[]>(getListInventoryTransformationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInventoryTransformationsQueryKey = (params?: ListInventoryTransformationsParams,) => {
    return [
    `/api/inventory/transformations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListInventoryTransformationsQueryOptions = <TData = Awaited<ReturnType<typeof listInventoryTransformations>>, TError = ErrorType<unknown>>(params?: ListInventoryTransformationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventoryTransformations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInventoryTransformationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInventoryTransformations>>> = ({ signal }) => listInventoryTransformations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInventoryTransformations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInventoryTransformationsQueryResult = NonNullable<Awaited<ReturnType<typeof listInventoryTransformations>>>
export type ListInventoryTransformationsQueryError = ErrorType<unknown>


/**
 * @summary List breakdown transformations. Optionally filter by source or
output inventory item. Most-recent first.

 */

export function useListInventoryTransformations<TData = Awaited<ReturnType<typeof listInventoryTransformations>>, TError = ErrorType<unknown>>(
 params?: ListInventoryTransformationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventoryTransformations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInventoryTransformationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateInventoryTransformationUrl = () => {




  return `/api/inventory/transformations`
}

/**
 * @summary Atomic SKU breakdown — consume N units of a source (typically MIX-*)
item and produce M units across one or more sellable child items.
All quantity moves, ledger writes, and counter recomputes happen in
a single DB transaction. Returns 409 if source available stock is
insufficient at commit time.

 */
export const createInventoryTransformation = async (breakdownInventoryBody: BreakdownInventoryBody, options?: RequestInit): Promise<InventoryTransformationDetail> => {

  return customFetch<InventoryTransformationDetail>(getCreateInventoryTransformationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(breakdownInventoryBody)
  }
);}





export const getCreateInventoryTransformationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInventoryTransformation>>, TError,{data: BodyType<BreakdownInventoryBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInventoryTransformation>>, TError,{data: BodyType<BreakdownInventoryBody>}, TContext> => {

const mutationKey = ['createInventoryTransformation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInventoryTransformation>>, {data: BodyType<BreakdownInventoryBody>}> = (props) => {
          const {data} = props ?? {};

          return  createInventoryTransformation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInventoryTransformationMutationResult = NonNullable<Awaited<ReturnType<typeof createInventoryTransformation>>>
    export type CreateInventoryTransformationMutationBody = BodyType<BreakdownInventoryBody>
    export type CreateInventoryTransformationMutationError = ErrorType<void>

    /**
 * @summary Atomic SKU breakdown — consume N units of a source (typically MIX-*)
item and produce M units across one or more sellable child items.
All quantity moves, ledger writes, and counter recomputes happen in
a single DB transaction. Returns 409 if source available stock is
insufficient at commit time.

 */
export const useCreateInventoryTransformation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInventoryTransformation>>, TError,{data: BodyType<BreakdownInventoryBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createInventoryTransformation>>,
        TError,
        {data: BodyType<BreakdownInventoryBody>},
        TContext
      > => {
      return useMutation(getCreateInventoryTransformationMutationOptions(options));
    }

export const getGetInventoryTransformationUrl = (id: string,) => {




  return `/api/inventory/transformations/${id}`
}

export const getInventoryTransformation = async (id: string, options?: RequestInit): Promise<InventoryTransformationDetail> => {

  return customFetch<InventoryTransformationDetail>(getGetInventoryTransformationUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventoryTransformationQueryKey = (id: string,) => {
    return [
    `/api/inventory/transformations/${id}`
    ] as const;
    }


export const getGetInventoryTransformationQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryTransformation>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryTransformation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryTransformationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryTransformation>>> = ({ signal }) => getInventoryTransformation(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryTransformation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInventoryTransformationQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryTransformation>>>
export type GetInventoryTransformationQueryError = ErrorType<void>



export function useGetInventoryTransformation<TData = Awaited<ReturnType<typeof getInventoryTransformation>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryTransformation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInventoryTransformationQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRetryCustomerDirectoryMetricsUrl = () => {




  return `/api/customers/metrics/refresh`
}

export const retryCustomerDirectoryMetrics = async (retryCustomerDirectoryMetricsBody: RetryCustomerDirectoryMetricsBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getRetryCustomerDirectoryMetricsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(retryCustomerDirectoryMetricsBody)
  }
);}





export const getRetryCustomerDirectoryMetricsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryCustomerDirectoryMetrics>>, TError,{data: BodyType<RetryCustomerDirectoryMetricsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof retryCustomerDirectoryMetrics>>, TError,{data: BodyType<RetryCustomerDirectoryMetricsBody>}, TContext> => {

const mutationKey = ['retryCustomerDirectoryMetrics'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryCustomerDirectoryMetrics>>, {data: BodyType<RetryCustomerDirectoryMetricsBody>}> = (props) => {
          const {data} = props ?? {};

          return  retryCustomerDirectoryMetrics(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryCustomerDirectoryMetricsMutationResult = NonNullable<Awaited<ReturnType<typeof retryCustomerDirectoryMetrics>>>
    export type RetryCustomerDirectoryMetricsMutationBody = BodyType<RetryCustomerDirectoryMetricsBody>
    export type RetryCustomerDirectoryMetricsMutationError = ErrorType<unknown>

    export const useRetryCustomerDirectoryMetrics = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryCustomerDirectoryMetrics>>, TError,{data: BodyType<RetryCustomerDirectoryMetricsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof retryCustomerDirectoryMetrics>>,
        TError,
        {data: BodyType<RetryCustomerDirectoryMetricsBody>},
        TContext
      > => {
      return useMutation(getRetryCustomerDirectoryMetricsMutationOptions(options));
    }

export const getRetryCommerceCustomerDirectoryMetricsUrl = () => {




  return `/api/commerce/customers/metrics/refresh`
}

export const retryCommerceCustomerDirectoryMetrics = async (retryCommerceCustomerDirectoryMetricsBody: RetryCommerceCustomerDirectoryMetricsBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getRetryCommerceCustomerDirectoryMetricsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(retryCommerceCustomerDirectoryMetricsBody)
  }
);}





export const getRetryCommerceCustomerDirectoryMetricsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryCommerceCustomerDirectoryMetrics>>, TError,{data: BodyType<RetryCommerceCustomerDirectoryMetricsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof retryCommerceCustomerDirectoryMetrics>>, TError,{data: BodyType<RetryCommerceCustomerDirectoryMetricsBody>}, TContext> => {

const mutationKey = ['retryCommerceCustomerDirectoryMetrics'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryCommerceCustomerDirectoryMetrics>>, {data: BodyType<RetryCommerceCustomerDirectoryMetricsBody>}> = (props) => {
          const {data} = props ?? {};

          return  retryCommerceCustomerDirectoryMetrics(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryCommerceCustomerDirectoryMetricsMutationResult = NonNullable<Awaited<ReturnType<typeof retryCommerceCustomerDirectoryMetrics>>>
    export type RetryCommerceCustomerDirectoryMetricsMutationBody = BodyType<RetryCommerceCustomerDirectoryMetricsBody>
    export type RetryCommerceCustomerDirectoryMetricsMutationError = ErrorType<unknown>

    export const useRetryCommerceCustomerDirectoryMetrics = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryCommerceCustomerDirectoryMetrics>>, TError,{data: BodyType<RetryCommerceCustomerDirectoryMetricsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof retryCommerceCustomerDirectoryMetrics>>,
        TError,
        {data: BodyType<RetryCommerceCustomerDirectoryMetricsBody>},
        TContext
      > => {
      return useMutation(getRetryCommerceCustomerDirectoryMetricsMutationOptions(options));
    }

export const getSearchCustomerPickerUrl = (params: SearchCustomerPickerParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/customers/search?${stringifiedParams}` : `/api/customers/search`
}

/**
 * @summary Search a bounded set of tenant customers for the Sales picker
 */
export const searchCustomerPicker = async (params: SearchCustomerPickerParams, options?: RequestInit): Promise<SearchCustomerPicker200> => {

  return customFetch<SearchCustomerPicker200>(getSearchCustomerPickerUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchCustomerPickerQueryKey = (params?: SearchCustomerPickerParams,) => {
    return [
    `/api/customers/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchCustomerPickerQueryOptions = <TData = Awaited<ReturnType<typeof searchCustomerPicker>>, TError = ErrorType<void>>(params: SearchCustomerPickerParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchCustomerPicker>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchCustomerPickerQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchCustomerPicker>>> = ({ signal }) => searchCustomerPicker(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchCustomerPicker>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchCustomerPickerQueryResult = NonNullable<Awaited<ReturnType<typeof searchCustomerPicker>>>
export type SearchCustomerPickerQueryError = ErrorType<void>


/**
 * @summary Search a bounded set of tenant customers for the Sales picker
 */

export function useSearchCustomerPicker<TData = Awaited<ReturnType<typeof searchCustomerPicker>>, TError = ErrorType<void>>(
 params: SearchCustomerPickerParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchCustomerPicker>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSearchCustomerPickerQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCustomersUrl = (params?: ListCustomersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/customers?${stringifiedParams}` : `/api/customers`
}

export const listCustomers = async (params?: ListCustomersParams, options?: RequestInit): Promise<ListCustomers200> => {

  return customFetch<ListCustomers200>(getListCustomersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomersQueryKey = (params?: ListCustomersParams,) => {
    return [
    `/api/customers`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCustomersQueryOptions = <TData = Awaited<ReturnType<typeof listCustomers>>, TError = ErrorType<unknown>>(params?: ListCustomersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomers>>> = ({ signal }) => listCustomers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCustomersQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomers>>>
export type ListCustomersQueryError = ErrorType<unknown>



export function useListCustomers<TData = Awaited<ReturnType<typeof listCustomers>>, TError = ErrorType<unknown>>(
 params?: ListCustomersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCustomersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCustomerUrl = () => {




  return `/api/customers`
}

export const createCustomer = async (customerInput: CustomerInput, options?: RequestInit): Promise<Customer> => {

  return customFetch<Customer>(getCreateCustomerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerInput)
  }
);}





export const getCreateCustomerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomer>>, TError,{data: BodyType<CustomerInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCustomer>>, TError,{data: BodyType<CustomerInput>}, TContext> => {

const mutationKey = ['createCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCustomer>>, {data: BodyType<CustomerInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCustomer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof createCustomer>>>
    export type CreateCustomerMutationBody = BodyType<CustomerInput>
    export type CreateCustomerMutationError = ErrorType<unknown>

    export const useCreateCustomer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomer>>, TError,{data: BodyType<CustomerInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCustomer>>,
        TError,
        {data: BodyType<CustomerInput>},
        TContext
      > => {
      return useMutation(getCreateCustomerMutationOptions(options));
    }

export const getExportCustomersCsvUrl = () => {




  return `/api/exports/customers`
}

/**
 * Small exports may be returned inline. Larger exports are queued as a
 * background job and downloaded through the existing export job flow.
 * Spend and profit columns are permission-redacted when the caller lacks
 * the corresponding finance view.
 * @summary Export the tenant-scoped customer directory as CSV
 */
export const exportCustomersCsv = async (customerExportInput?: CustomerExportInput, options?: RequestInit): Promise<CustomerExportInline | CustomerExportQueued> => {

  return customFetch<CustomerExportInline | CustomerExportQueued>(getExportCustomersCsvUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerExportInput)
  }
);}





export const getExportCustomersCsvMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportCustomersCsv>>, TError,{data?: BodyType<CustomerExportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof exportCustomersCsv>>, TError,{data?: BodyType<CustomerExportInput>}, TContext> => {

const mutationKey = ['exportCustomersCsv'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportCustomersCsv>>, {data?: BodyType<CustomerExportInput>}> = (props) => {
          const {data} = props ?? {};

          return  exportCustomersCsv(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExportCustomersCsvMutationResult = NonNullable<Awaited<ReturnType<typeof exportCustomersCsv>>>
    export type ExportCustomersCsvMutationBody = BodyType<CustomerExportInput> | undefined
    export type ExportCustomersCsvMutationError = ErrorType<void>

    /**
 * @summary Export the tenant-scoped customer directory as CSV
 */
export const useExportCustomersCsv = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportCustomersCsv>>, TError,{data?: BodyType<CustomerExportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof exportCustomersCsv>>,
        TError,
        {data?: BodyType<CustomerExportInput>},
        TContext
      > => {
      return useMutation(getExportCustomersCsvMutationOptions(options));
    }

export const getEnsureWalkInCustomerUrl = () => {




  return `/api/customers/walk-in`
}

/**
 * Idempotent: returns the singleton "Walk-in" customer (the row with
 * customerType='Walk-in'). Creates it if it doesn't yet exist. Used by
 * the New Sale page when staff want to record an in-person sale
 * without capturing buyer details.
 */
export const ensureWalkInCustomer = async ( options?: RequestInit): Promise<WalkInCustomerResponse> => {

  return customFetch<WalkInCustomerResponse>(getEnsureWalkInCustomerUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getEnsureWalkInCustomerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ensureWalkInCustomer>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof ensureWalkInCustomer>>, TError,void, TContext> => {

const mutationKey = ['ensureWalkInCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ensureWalkInCustomer>>, void> = () => {


          return  ensureWalkInCustomer(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnsureWalkInCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof ensureWalkInCustomer>>>

    export type EnsureWalkInCustomerMutationError = ErrorType<unknown>

    export const useEnsureWalkInCustomer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ensureWalkInCustomer>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof ensureWalkInCustomer>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getEnsureWalkInCustomerMutationOptions(options));
    }

export const getListCustomerOrdersUrl = (id: string,
    params?: ListCustomerOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/customers/${id}/orders?${stringifiedParams}` : `/api/customers/${id}/orders`
}

export const listCustomerOrders = async (id: string,
    params?: ListCustomerOrdersParams, options?: RequestInit): Promise<CustomerOrdersPayload> => {

  return customFetch<CustomerOrdersPayload>(getListCustomerOrdersUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomerOrdersQueryKey = (id: string,
    params?: ListCustomerOrdersParams,) => {
    return [
    `/api/customers/${id}/orders`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCustomerOrdersQueryOptions = <TData = Awaited<ReturnType<typeof listCustomerOrders>>, TError = ErrorType<unknown>>(id: string,
    params?: ListCustomerOrdersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomerOrdersQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomerOrders>>> = ({ signal }) => listCustomerOrders(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomerOrders>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCustomerOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomerOrders>>>
export type ListCustomerOrdersQueryError = ErrorType<unknown>



export function useListCustomerOrders<TData = Awaited<ReturnType<typeof listCustomerOrders>>, TError = ErrorType<unknown>>(
 id: string,
    params?: ListCustomerOrdersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCustomerOrdersQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportCustomerOrdersUrl = (id: string,) => {




  return `/api/customers/${id}/orders/export`
}

export const exportCustomerOrders = async (id: string,
    exportCustomerOrdersBody?: ExportCustomerOrdersBody, options?: RequestInit): Promise<CustomerOrdersExportState> => {

  return customFetch<CustomerOrdersExportState>(getExportCustomerOrdersUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(exportCustomerOrdersBody)
  }
);}





export const getExportCustomerOrdersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportCustomerOrders>>, TError,{id: string;data?: BodyType<ExportCustomerOrdersBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof exportCustomerOrders>>, TError,{id: string;data?: BodyType<ExportCustomerOrdersBody>}, TContext> => {

const mutationKey = ['exportCustomerOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportCustomerOrders>>, {id: string;data?: BodyType<ExportCustomerOrdersBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  exportCustomerOrders(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExportCustomerOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof exportCustomerOrders>>>
    export type ExportCustomerOrdersMutationBody = BodyType<ExportCustomerOrdersBody> | undefined
    export type ExportCustomerOrdersMutationError = ErrorType<unknown>

    export const useExportCustomerOrders = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportCustomerOrders>>, TError,{id: string;data?: BodyType<ExportCustomerOrdersBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof exportCustomerOrders>>,
        TError,
        {id: string;data?: BodyType<ExportCustomerOrdersBody>},
        TContext
      > => {
      return useMutation(getExportCustomerOrdersMutationOptions(options));
    }

export const getGetCustomerSpendingUrl = (id: string,) => {




  return `/api/customers/${id}/spending`
}

export const getCustomerSpending = async (id: string, options?: RequestInit): Promise<CustomerSpendingWorkspace | CustomerSpendingPreparing> => {

  return customFetch<CustomerSpendingWorkspace | CustomerSpendingPreparing>(getGetCustomerSpendingUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomerSpendingQueryKey = (id: string,) => {
    return [
    `/api/customers/${id}/spending`
    ] as const;
    }


export const getGetCustomerSpendingQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerSpending>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerSpending>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerSpendingQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerSpending>>> = ({ signal }) => getCustomerSpending(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerSpending>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerSpendingQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerSpending>>>
export type GetCustomerSpendingQueryError = ErrorType<unknown>



export function useGetCustomerSpending<TData = Awaited<ReturnType<typeof getCustomerSpending>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerSpending>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCustomerSpendingQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCustomerAnalyticsUrl = (id: string,) => {




  return `/api/customers/${id}/analytics`
}

export const getCustomerAnalytics = async (id: string, options?: RequestInit): Promise<CustomerAnalytics> => {

  return customFetch<CustomerAnalytics>(getGetCustomerAnalyticsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomerAnalyticsQueryKey = (id: string,) => {
    return [
    `/api/customers/${id}/analytics`
    ] as const;
    }


export const getGetCustomerAnalyticsQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerAnalytics>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerAnalytics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerAnalyticsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerAnalytics>>> = ({ signal }) => getCustomerAnalytics(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerAnalytics>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerAnalyticsQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerAnalytics>>>
export type GetCustomerAnalyticsQueryError = ErrorType<unknown>



export function useGetCustomerAnalytics<TData = Awaited<ReturnType<typeof getCustomerAnalytics>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerAnalytics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCustomerAnalyticsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCustomerMessagesUrl = (id: string,
    params?: ListCustomerMessagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/customers/${id}/messages?${stringifiedParams}` : `/api/customers/${id}/messages`
}

export const listCustomerMessages = async (id: string,
    params?: ListCustomerMessagesParams, options?: RequestInit): Promise<CustomerMessagesPayload> => {

  return customFetch<CustomerMessagesPayload>(getListCustomerMessagesUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomerMessagesQueryKey = (id: string,
    params?: ListCustomerMessagesParams,) => {
    return [
    `/api/customers/${id}/messages`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCustomerMessagesQueryOptions = <TData = Awaited<ReturnType<typeof listCustomerMessages>>, TError = ErrorType<unknown>>(id: string,
    params?: ListCustomerMessagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomerMessagesQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomerMessages>>> = ({ signal }) => listCustomerMessages(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomerMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCustomerMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomerMessages>>>
export type ListCustomerMessagesQueryError = ErrorType<unknown>



export function useListCustomerMessages<TData = Awaited<ReturnType<typeof listCustomerMessages>>, TError = ErrorType<unknown>>(
 id: string,
    params?: ListCustomerMessagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCustomerMessagesQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSendCustomerMessageUrl = (id: string,) => {




  return `/api/customers/${id}/messages`
}

/**
 * Operator-initiated one-off message that is NOT tied to a sale order.
 * The send is recorded in the same notification-log feed surfaced by
 * `listCustomerMessages` (attributed via the new `customer_id` column).
 * Respects the existing Twilio/email credential checks and is per-user
 * rate-limited. WhatsApp sends are free-form and only deliver inside the
 * 24h customer-service window; outside it the failure is logged.
 * @summary Send an ad-hoc email / SMS / WhatsApp message to a customer.
 */
export const sendCustomerMessage = async (id: string,
    customerMessageSendBody: CustomerMessageSendBody, options?: RequestInit): Promise<CustomerMessageSendResult> => {

  return customFetch<CustomerMessageSendResult>(getSendCustomerMessageUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerMessageSendBody)
  }
);}





export const getSendCustomerMessageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCustomerMessage>>, TError,{id: string;data: BodyType<CustomerMessageSendBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendCustomerMessage>>, TError,{id: string;data: BodyType<CustomerMessageSendBody>}, TContext> => {

const mutationKey = ['sendCustomerMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendCustomerMessage>>, {id: string;data: BodyType<CustomerMessageSendBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  sendCustomerMessage(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendCustomerMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendCustomerMessage>>>
    export type SendCustomerMessageMutationBody = BodyType<CustomerMessageSendBody>
    export type SendCustomerMessageMutationError = ErrorType<void>

    /**
 * @summary Send an ad-hoc email / SMS / WhatsApp message to a customer.
 */
export const useSendCustomerMessage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCustomerMessage>>, TError,{id: string;data: BodyType<CustomerMessageSendBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendCustomerMessage>>,
        TError,
        {id: string;data: BodyType<CustomerMessageSendBody>},
        TContext
      > => {
      return useMutation(getSendCustomerMessageMutationOptions(options));
    }

export const getGetCustomerMessagingCapabilitiesUrl = () => {




  return `/api/customers/messaging/capabilities`
}

/**
 * Safe, capability-only booleans (no phone number / SID / token) so an
 * `edit_sales` operator can tell which channels are usable from the
 * customer page WITHOUT needing `manage_integrations` / `packing.confirm`
 * (which the `getWhatsappIntegration` status endpoint requires). Email
 * readiness is decided client-side from the customer's email-on-file.
 * @summary Channel-readiness flags for the customer "Send message" dialog.
 */
export const getCustomerMessagingCapabilities = async ( options?: RequestInit): Promise<CustomerMessagingCapabilities> => {

  return customFetch<CustomerMessagingCapabilities>(getGetCustomerMessagingCapabilitiesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomerMessagingCapabilitiesQueryKey = () => {
    return [
    `/api/customers/messaging/capabilities`
    ] as const;
    }


export const getGetCustomerMessagingCapabilitiesQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerMessagingCapabilities>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerMessagingCapabilities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerMessagingCapabilitiesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerMessagingCapabilities>>> = ({ signal }) => getCustomerMessagingCapabilities({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerMessagingCapabilities>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerMessagingCapabilitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerMessagingCapabilities>>>
export type GetCustomerMessagingCapabilitiesQueryError = ErrorType<unknown>


/**
 * @summary Channel-readiness flags for the customer "Send message" dialog.
 */

export function useGetCustomerMessagingCapabilities<TData = Awaited<ReturnType<typeof getCustomerMessagingCapabilities>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerMessagingCapabilities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCustomerMessagingCapabilitiesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCustomerWhatsappTemplateUrl = () => {




  return `/api/customers/messaging/whatsapp-template`
}

/**
 * Describes the approved Content Template used for ad-hoc customer
 * WhatsApp messages outside the 24h window, so the "Send message" dialog
 * can render one input per placeholder. Tenant-level (not customer
 * specific) and `edit_sales`-gated like the send route. Returns
 * `configured: false` when no usable template is set. Hits Twilio's
 * Content API, so a 502 is returned if Twilio can't be reached.
 * @summary The tenant's approved ad-hoc WhatsApp template + its variables.
 */
export const getCustomerWhatsappTemplate = async ( options?: RequestInit): Promise<CustomerWhatsappTemplate> => {

  return customFetch<CustomerWhatsappTemplate>(getGetCustomerWhatsappTemplateUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomerWhatsappTemplateQueryKey = () => {
    return [
    `/api/customers/messaging/whatsapp-template`
    ] as const;
    }


export const getGetCustomerWhatsappTemplateQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerWhatsappTemplate>>, TError = ErrorType<GetCustomerWhatsappTemplate502>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerWhatsappTemplate>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerWhatsappTemplateQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerWhatsappTemplate>>> = ({ signal }) => getCustomerWhatsappTemplate({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerWhatsappTemplate>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerWhatsappTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerWhatsappTemplate>>>
export type GetCustomerWhatsappTemplateQueryError = ErrorType<GetCustomerWhatsappTemplate502>


/**
 * @summary The tenant's approved ad-hoc WhatsApp template + its variables.
 */

export function useGetCustomerWhatsappTemplate<TData = Awaited<ReturnType<typeof getCustomerWhatsappTemplate>>, TError = ErrorType<GetCustomerWhatsappTemplate502>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerWhatsappTemplate>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCustomerWhatsappTemplateQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCustomerWhatsappTemplatePresetsUrl = () => {




  return `/api/customers/messaging/whatsapp-template-presets`
}

/**
 * Operator-saved, reusable sets of filled WhatsApp template-variable
 * values (named per scenario, e.g. "order delayed"). Tenant-wide and
 * persisted, so any `edit_sales` operator sees them in the customer
 * "Send message" dialog for one-click selection (still editable before
 * send). Newest first.
 * @summary List the tenant's saved ad-hoc WhatsApp template presets.
 */
export const listCustomerWhatsappTemplatePresets = async ( options?: RequestInit): Promise<CustomerWhatsappTemplatePresetsPayload> => {

  return customFetch<CustomerWhatsappTemplatePresetsPayload>(getListCustomerWhatsappTemplatePresetsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomerWhatsappTemplatePresetsQueryKey = () => {
    return [
    `/api/customers/messaging/whatsapp-template-presets`
    ] as const;
    }


export const getListCustomerWhatsappTemplatePresetsQueryOptions = <TData = Awaited<ReturnType<typeof listCustomerWhatsappTemplatePresets>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerWhatsappTemplatePresets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomerWhatsappTemplatePresetsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomerWhatsappTemplatePresets>>> = ({ signal }) => listCustomerWhatsappTemplatePresets({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomerWhatsappTemplatePresets>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCustomerWhatsappTemplatePresetsQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomerWhatsappTemplatePresets>>>
export type ListCustomerWhatsappTemplatePresetsQueryError = ErrorType<unknown>


/**
 * @summary List the tenant's saved ad-hoc WhatsApp template presets.
 */

export function useListCustomerWhatsappTemplatePresets<TData = Awaited<ReturnType<typeof listCustomerWhatsappTemplatePresets>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerWhatsappTemplatePresets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCustomerWhatsappTemplatePresetsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCustomerWhatsappTemplatePresetUrl = () => {




  return `/api/customers/messaging/whatsapp-template-presets`
}

/**
 * Persists a named set of filled template-variable values for reuse.
 * Tenant-wide and `edit_sales`-gated like the send route. Returns the
 * created preset.
 * @summary Save a reusable ad-hoc WhatsApp template preset.
 */
export const createCustomerWhatsappTemplatePreset = async (customerWhatsappTemplatePresetInput: CustomerWhatsappTemplatePresetInput, options?: RequestInit): Promise<CustomerWhatsappTemplatePreset> => {

  return customFetch<CustomerWhatsappTemplatePreset>(getCreateCustomerWhatsappTemplatePresetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerWhatsappTemplatePresetInput)
  }
);}





export const getCreateCustomerWhatsappTemplatePresetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomerWhatsappTemplatePreset>>, TError,{data: BodyType<CustomerWhatsappTemplatePresetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCustomerWhatsappTemplatePreset>>, TError,{data: BodyType<CustomerWhatsappTemplatePresetInput>}, TContext> => {

const mutationKey = ['createCustomerWhatsappTemplatePreset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCustomerWhatsappTemplatePreset>>, {data: BodyType<CustomerWhatsappTemplatePresetInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCustomerWhatsappTemplatePreset(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCustomerWhatsappTemplatePresetMutationResult = NonNullable<Awaited<ReturnType<typeof createCustomerWhatsappTemplatePreset>>>
    export type CreateCustomerWhatsappTemplatePresetMutationBody = BodyType<CustomerWhatsappTemplatePresetInput>
    export type CreateCustomerWhatsappTemplatePresetMutationError = ErrorType<unknown>

    /**
 * @summary Save a reusable ad-hoc WhatsApp template preset.
 */
export const useCreateCustomerWhatsappTemplatePreset = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomerWhatsappTemplatePreset>>, TError,{data: BodyType<CustomerWhatsappTemplatePresetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCustomerWhatsappTemplatePreset>>,
        TError,
        {data: BodyType<CustomerWhatsappTemplatePresetInput>},
        TContext
      > => {
      return useMutation(getCreateCustomerWhatsappTemplatePresetMutationOptions(options));
    }

export const getReorderCustomerWhatsappTemplatePresetsUrl = () => {




  return `/api/customers/messaging/whatsapp-template-presets/reorder`
}

/**
 * Persists a new display order for the tenant's saved presets.
 * `edit_sales`-gated like create/delete. The body lists every existing
 * preset id in the desired order; unknown ids are ignored and any omitted
 * ids are appended in their previous order, so the operation is robust to
 * a stale client. Returns the full reordered list.
 * @summary Reorder the tenant's saved ad-hoc WhatsApp template presets.
 */
export const reorderCustomerWhatsappTemplatePresets = async (customerWhatsappTemplatePresetReorderInput: CustomerWhatsappTemplatePresetReorderInput, options?: RequestInit): Promise<CustomerWhatsappTemplatePresetsPayload> => {

  return customFetch<CustomerWhatsappTemplatePresetsPayload>(getReorderCustomerWhatsappTemplatePresetsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerWhatsappTemplatePresetReorderInput)
  }
);}





export const getReorderCustomerWhatsappTemplatePresetsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderCustomerWhatsappTemplatePresets>>, TError,{data: BodyType<CustomerWhatsappTemplatePresetReorderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderCustomerWhatsappTemplatePresets>>, TError,{data: BodyType<CustomerWhatsappTemplatePresetReorderInput>}, TContext> => {

const mutationKey = ['reorderCustomerWhatsappTemplatePresets'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderCustomerWhatsappTemplatePresets>>, {data: BodyType<CustomerWhatsappTemplatePresetReorderInput>}> = (props) => {
          const {data} = props ?? {};

          return  reorderCustomerWhatsappTemplatePresets(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReorderCustomerWhatsappTemplatePresetsMutationResult = NonNullable<Awaited<ReturnType<typeof reorderCustomerWhatsappTemplatePresets>>>
    export type ReorderCustomerWhatsappTemplatePresetsMutationBody = BodyType<CustomerWhatsappTemplatePresetReorderInput>
    export type ReorderCustomerWhatsappTemplatePresetsMutationError = ErrorType<unknown>

    /**
 * @summary Reorder the tenant's saved ad-hoc WhatsApp template presets.
 */
export const useReorderCustomerWhatsappTemplatePresets = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderCustomerWhatsappTemplatePresets>>, TError,{data: BodyType<CustomerWhatsappTemplatePresetReorderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reorderCustomerWhatsappTemplatePresets>>,
        TError,
        {data: BodyType<CustomerWhatsappTemplatePresetReorderInput>},
        TContext
      > => {
      return useMutation(getReorderCustomerWhatsappTemplatePresetsMutationOptions(options));
    }

export const getRenameCustomerWhatsappTemplatePresetUrl = (presetId: string,) => {




  return `/api/customers/messaging/whatsapp-template-presets/${presetId}`
}

/**
 * Changes the operator-chosen label of an existing preset. `edit_sales`-
 * gated like create/delete. Returns the updated preset.
 * @summary Rename a saved ad-hoc WhatsApp template preset.
 */
export const renameCustomerWhatsappTemplatePreset = async (presetId: string,
    customerWhatsappTemplatePresetRenameInput: CustomerWhatsappTemplatePresetRenameInput, options?: RequestInit): Promise<CustomerWhatsappTemplatePreset> => {

  return customFetch<CustomerWhatsappTemplatePreset>(getRenameCustomerWhatsappTemplatePresetUrl(presetId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerWhatsappTemplatePresetRenameInput)
  }
);}





export const getRenameCustomerWhatsappTemplatePresetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameCustomerWhatsappTemplatePreset>>, TError,{presetId: string;data: BodyType<CustomerWhatsappTemplatePresetRenameInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof renameCustomerWhatsappTemplatePreset>>, TError,{presetId: string;data: BodyType<CustomerWhatsappTemplatePresetRenameInput>}, TContext> => {

const mutationKey = ['renameCustomerWhatsappTemplatePreset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof renameCustomerWhatsappTemplatePreset>>, {presetId: string;data: BodyType<CustomerWhatsappTemplatePresetRenameInput>}> = (props) => {
          const {presetId,data} = props ?? {};

          return  renameCustomerWhatsappTemplatePreset(presetId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RenameCustomerWhatsappTemplatePresetMutationResult = NonNullable<Awaited<ReturnType<typeof renameCustomerWhatsappTemplatePreset>>>
    export type RenameCustomerWhatsappTemplatePresetMutationBody = BodyType<CustomerWhatsappTemplatePresetRenameInput>
    export type RenameCustomerWhatsappTemplatePresetMutationError = ErrorType<unknown>

    /**
 * @summary Rename a saved ad-hoc WhatsApp template preset.
 */
export const useRenameCustomerWhatsappTemplatePreset = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameCustomerWhatsappTemplatePreset>>, TError,{presetId: string;data: BodyType<CustomerWhatsappTemplatePresetRenameInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof renameCustomerWhatsappTemplatePreset>>,
        TError,
        {presetId: string;data: BodyType<CustomerWhatsappTemplatePresetRenameInput>},
        TContext
      > => {
      return useMutation(getRenameCustomerWhatsappTemplatePresetMutationOptions(options));
    }

export const getDeleteCustomerWhatsappTemplatePresetUrl = (presetId: string,) => {




  return `/api/customers/messaging/whatsapp-template-presets/${presetId}`
}

/**
 * Removes the named preset from the tenant's saved set. `edit_sales`-gated
 * like the send route. Idempotent — deleting a missing preset still
 * returns ok.
 * @summary Delete a saved ad-hoc WhatsApp template preset.
 */
export const deleteCustomerWhatsappTemplatePreset = async (presetId: string, options?: RequestInit): Promise<OkResult> => {

  return customFetch<OkResult>(getDeleteCustomerWhatsappTemplatePresetUrl(presetId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteCustomerWhatsappTemplatePresetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerWhatsappTemplatePreset>>, TError,{presetId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerWhatsappTemplatePreset>>, TError,{presetId: string}, TContext> => {

const mutationKey = ['deleteCustomerWhatsappTemplatePreset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomerWhatsappTemplatePreset>>, {presetId: string}> = (props) => {
          const {presetId} = props ?? {};

          return  deleteCustomerWhatsappTemplatePreset(presetId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomerWhatsappTemplatePresetMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomerWhatsappTemplatePreset>>>

    export type DeleteCustomerWhatsappTemplatePresetMutationError = ErrorType<unknown>

    /**
 * @summary Delete a saved ad-hoc WhatsApp template preset.
 */
export const useDeleteCustomerWhatsappTemplatePreset = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerWhatsappTemplatePreset>>, TError,{presetId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomerWhatsappTemplatePreset>>,
        TError,
        {presetId: string},
        TContext
      > => {
      return useMutation(getDeleteCustomerWhatsappTemplatePresetMutationOptions(options));
    }

export const getListCustomerAddressesUrl = (id: string,) => {




  return `/api/customers/${id}/addresses`
}

export const listCustomerAddresses = async (id: string, options?: RequestInit): Promise<ListCustomerAddresses200> => {

  return customFetch<ListCustomerAddresses200>(getListCustomerAddressesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomerAddressesQueryKey = (id: string,) => {
    return [
    `/api/customers/${id}/addresses`
    ] as const;
    }


export const getListCustomerAddressesQueryOptions = <TData = Awaited<ReturnType<typeof listCustomerAddresses>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerAddresses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomerAddressesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomerAddresses>>> = ({ signal }) => listCustomerAddresses(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomerAddresses>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCustomerAddressesQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomerAddresses>>>
export type ListCustomerAddressesQueryError = ErrorType<unknown>



export function useListCustomerAddresses<TData = Awaited<ReturnType<typeof listCustomerAddresses>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerAddresses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCustomerAddressesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCustomerNotesUrl = (id: string,
    params?: ListCustomerNotesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/customers/${id}/notes?${stringifiedParams}` : `/api/customers/${id}/notes`
}

export const listCustomerNotes = async (id: string,
    params?: ListCustomerNotesParams, options?: RequestInit): Promise<CustomerNotesPayload> => {

  return customFetch<CustomerNotesPayload>(getListCustomerNotesUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomerNotesQueryKey = (id: string,
    params?: ListCustomerNotesParams,) => {
    return [
    `/api/customers/${id}/notes`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCustomerNotesQueryOptions = <TData = Awaited<ReturnType<typeof listCustomerNotes>>, TError = ErrorType<unknown>>(id: string,
    params?: ListCustomerNotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomerNotesQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomerNotes>>> = ({ signal }) => listCustomerNotes(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomerNotes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCustomerNotesQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomerNotes>>>
export type ListCustomerNotesQueryError = ErrorType<unknown>



export function useListCustomerNotes<TData = Awaited<ReturnType<typeof listCustomerNotes>>, TError = ErrorType<unknown>>(
 id: string,
    params?: ListCustomerNotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCustomerNotesQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCustomerNoteUrl = (id: string,) => {




  return `/api/customers/${id}/notes`
}

export const createCustomerNote = async (id: string,
    customerNoteInput: CustomerNoteInput, options?: RequestInit): Promise<CustomerNote> => {

  return customFetch<CustomerNote>(getCreateCustomerNoteUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerNoteInput)
  }
);}





export const getCreateCustomerNoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomerNote>>, TError,{id: string;data: BodyType<CustomerNoteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCustomerNote>>, TError,{id: string;data: BodyType<CustomerNoteInput>}, TContext> => {

const mutationKey = ['createCustomerNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCustomerNote>>, {id: string;data: BodyType<CustomerNoteInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createCustomerNote(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCustomerNoteMutationResult = NonNullable<Awaited<ReturnType<typeof createCustomerNote>>>
    export type CreateCustomerNoteMutationBody = BodyType<CustomerNoteInput>
    export type CreateCustomerNoteMutationError = ErrorType<unknown>

    export const useCreateCustomerNote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomerNote>>, TError,{id: string;data: BodyType<CustomerNoteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCustomerNote>>,
        TError,
        {id: string;data: BodyType<CustomerNoteInput>},
        TContext
      > => {
      return useMutation(getCreateCustomerNoteMutationOptions(options));
    }

export const getDeleteCustomerNoteUrl = (id: string,
    noteId: string,) => {




  return `/api/customers/${id}/notes/${noteId}`
}

export const deleteCustomerNote = async (id: string,
    noteId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteCustomerNoteUrl(id,noteId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteCustomerNoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerNote>>, TError,{id: string;noteId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerNote>>, TError,{id: string;noteId: string}, TContext> => {

const mutationKey = ['deleteCustomerNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomerNote>>, {id: string;noteId: string}> = (props) => {
          const {id,noteId} = props ?? {};

          return  deleteCustomerNote(id,noteId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomerNoteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomerNote>>>

    export type DeleteCustomerNoteMutationError = ErrorType<unknown>

    export const useDeleteCustomerNote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerNote>>, TError,{id: string;noteId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomerNote>>,
        TError,
        {id: string;noteId: string},
        TContext
      > => {
      return useMutation(getDeleteCustomerNoteMutationOptions(options));
    }

export const getGetLinkedOrdersUrl = (id: string,) => {




  return `/api/sales/${id}/linked-orders`
}

export const getLinkedOrders = async (id: string, options?: RequestInit): Promise<LinkedOrdersResponse> => {

  return customFetch<LinkedOrdersResponse>(getGetLinkedOrdersUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLinkedOrdersQueryKey = (id: string,) => {
    return [
    `/api/sales/${id}/linked-orders`
    ] as const;
    }


export const getGetLinkedOrdersQueryOptions = <TData = Awaited<ReturnType<typeof getLinkedOrders>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLinkedOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLinkedOrdersQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLinkedOrders>>> = ({ signal }) => getLinkedOrders(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLinkedOrders>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLinkedOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof getLinkedOrders>>>
export type GetLinkedOrdersQueryError = ErrorType<unknown>



export function useGetLinkedOrders<TData = Awaited<ReturnType<typeof getLinkedOrders>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLinkedOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLinkedOrdersQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListOrderInternalNotesUrl = (id: string,
    params?: ListOrderInternalNotesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/sales/${id}/internal-notes?${stringifiedParams}` : `/api/sales/${id}/internal-notes`
}

/**
 * @summary List tenant-isolated internal notes for an order (pinned first)
 */
export const listOrderInternalNotes = async (id: string,
    params?: ListOrderInternalNotesParams, options?: RequestInit): Promise<OrderInternalNotesPage> => {

  return customFetch<OrderInternalNotesPage>(getListOrderInternalNotesUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOrderInternalNotesQueryKey = (id: string,
    params?: ListOrderInternalNotesParams,) => {
    return [
    `/api/sales/${id}/internal-notes`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOrderInternalNotesQueryOptions = <TData = Awaited<ReturnType<typeof listOrderInternalNotes>>, TError = ErrorType<void>>(id: string,
    params?: ListOrderInternalNotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOrderInternalNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrderInternalNotesQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrderInternalNotes>>> = ({ signal }) => listOrderInternalNotes(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrderInternalNotes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOrderInternalNotesQueryResult = NonNullable<Awaited<ReturnType<typeof listOrderInternalNotes>>>
export type ListOrderInternalNotesQueryError = ErrorType<void>


/**
 * @summary List tenant-isolated internal notes for an order (pinned first)
 */

export function useListOrderInternalNotes<TData = Awaited<ReturnType<typeof listOrderInternalNotes>>, TError = ErrorType<void>>(
 id: string,
    params?: ListOrderInternalNotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOrderInternalNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOrderInternalNotesQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateOrderInternalNoteUrl = (id: string,) => {




  return `/api/sales/${id}/internal-notes`
}

/**
 * @summary Add an internal note to an order
 */
export const createOrderInternalNote = async (id: string,
    orderInternalNoteCreateInput: OrderInternalNoteCreateInput, options?: RequestInit): Promise<void | OrderInternalNote> => {

  return customFetch<void | OrderInternalNote>(getCreateOrderInternalNoteUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(orderInternalNoteCreateInput)
  }
);}





export const getCreateOrderInternalNoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrderInternalNote>>, TError,{id: string;data: BodyType<OrderInternalNoteCreateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrderInternalNote>>, TError,{id: string;data: BodyType<OrderInternalNoteCreateInput>}, TContext> => {

const mutationKey = ['createOrderInternalNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrderInternalNote>>, {id: string;data: BodyType<OrderInternalNoteCreateInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createOrderInternalNote(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrderInternalNoteMutationResult = NonNullable<Awaited<ReturnType<typeof createOrderInternalNote>>>
    export type CreateOrderInternalNoteMutationBody = BodyType<OrderInternalNoteCreateInput>
    export type CreateOrderInternalNoteMutationError = ErrorType<unknown>

    /**
 * @summary Add an internal note to an order
 */
export const useCreateOrderInternalNote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrderInternalNote>>, TError,{id: string;data: BodyType<OrderInternalNoteCreateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOrderInternalNote>>,
        TError,
        {id: string;data: BodyType<OrderInternalNoteCreateInput>},
        TContext
      > => {
      return useMutation(getCreateOrderInternalNoteMutationOptions(options));
    }

export const getUpdateOrderInternalNoteUrl = (id: string,
    noteId: string,) => {




  return `/api/sales/${id}/internal-notes/${noteId}`
}

/**
 * @summary Edit an internal note using optimistic concurrency
 */
export const updateOrderInternalNote = async (id: string,
    noteId: string,
    orderInternalNoteUpdateInput: OrderInternalNoteUpdateInput, options?: RequestInit): Promise<OrderInternalNote> => {

  return customFetch<OrderInternalNote>(getUpdateOrderInternalNoteUrl(id,noteId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(orderInternalNoteUpdateInput)
  }
);}





export const getUpdateOrderInternalNoteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrderInternalNote>>, TError,{id: string;noteId: string;data: BodyType<OrderInternalNoteUpdateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrderInternalNote>>, TError,{id: string;noteId: string;data: BodyType<OrderInternalNoteUpdateInput>}, TContext> => {

const mutationKey = ['updateOrderInternalNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrderInternalNote>>, {id: string;noteId: string;data: BodyType<OrderInternalNoteUpdateInput>}> = (props) => {
          const {id,noteId,data} = props ?? {};

          return  updateOrderInternalNote(id,noteId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrderInternalNoteMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrderInternalNote>>>
    export type UpdateOrderInternalNoteMutationBody = BodyType<OrderInternalNoteUpdateInput>
    export type UpdateOrderInternalNoteMutationError = ErrorType<void>

    /**
 * @summary Edit an internal note using optimistic concurrency
 */
export const useUpdateOrderInternalNote = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrderInternalNote>>, TError,{id: string;noteId: string;data: BodyType<OrderInternalNoteUpdateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOrderInternalNote>>,
        TError,
        {id: string;noteId: string;data: BodyType<OrderInternalNoteUpdateInput>},
        TContext
      > => {
      return useMutation(getUpdateOrderInternalNoteMutationOptions(options));
    }

export const getDeleteOrderInternalNoteUrl = (id: string,
    noteId: string,
    params: DeleteOrderInternalNoteParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/sales/${id}/internal-notes/${noteId}?${stringifiedParams}` : `/api/sales/${id}/internal-notes/${noteId}`
}

/**
 * @summary Delete an internal note using optimistic concurrency
 */
export const deleteOrderInternalNote = async (id: string,
    noteId: string,
    params: DeleteOrderInternalNoteParams, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteOrderInternalNoteUrl(id,noteId,params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteOrderInternalNoteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrderInternalNote>>, TError,{id: string;noteId: string;params: DeleteOrderInternalNoteParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrderInternalNote>>, TError,{id: string;noteId: string;params: DeleteOrderInternalNoteParams}, TContext> => {

const mutationKey = ['deleteOrderInternalNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrderInternalNote>>, {id: string;noteId: string;params: DeleteOrderInternalNoteParams}> = (props) => {
          const {id,noteId,params} = props ?? {};

          return  deleteOrderInternalNote(id,noteId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrderInternalNoteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrderInternalNote>>>

    export type DeleteOrderInternalNoteMutationError = ErrorType<void>

    /**
 * @summary Delete an internal note using optimistic concurrency
 */
export const useDeleteOrderInternalNote = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrderInternalNote>>, TError,{id: string;noteId: string;params: DeleteOrderInternalNoteParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteOrderInternalNote>>,
        TError,
        {id: string;noteId: string;params: DeleteOrderInternalNoteParams},
        TContext
      > => {
      return useMutation(getDeleteOrderInternalNoteMutationOptions(options));
    }

export const getPinOrderInternalNoteUrl = (id: string,
    noteId: string,) => {




  return `/api/sales/${id}/internal-notes/${noteId}/pin`
}

/**
 * @summary Pin or unpin an internal order note
 */
export const pinOrderInternalNote = async (id: string,
    noteId: string,
    pinOrderInternalNoteBody: PinOrderInternalNoteBody, options?: RequestInit): Promise<OrderInternalNote> => {

  return customFetch<OrderInternalNote>(getPinOrderInternalNoteUrl(id,noteId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pinOrderInternalNoteBody)
  }
);}





export const getPinOrderInternalNoteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pinOrderInternalNote>>, TError,{id: string;noteId: string;data: BodyType<PinOrderInternalNoteBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pinOrderInternalNote>>, TError,{id: string;noteId: string;data: BodyType<PinOrderInternalNoteBody>}, TContext> => {

const mutationKey = ['pinOrderInternalNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pinOrderInternalNote>>, {id: string;noteId: string;data: BodyType<PinOrderInternalNoteBody>}> = (props) => {
          const {id,noteId,data} = props ?? {};

          return  pinOrderInternalNote(id,noteId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PinOrderInternalNoteMutationResult = NonNullable<Awaited<ReturnType<typeof pinOrderInternalNote>>>
    export type PinOrderInternalNoteMutationBody = BodyType<PinOrderInternalNoteBody>
    export type PinOrderInternalNoteMutationError = ErrorType<void>

    /**
 * @summary Pin or unpin an internal order note
 */
export const usePinOrderInternalNote = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pinOrderInternalNote>>, TError,{id: string;noteId: string;data: BodyType<PinOrderInternalNoteBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof pinOrderInternalNote>>,
        TError,
        {id: string;noteId: string;data: BodyType<PinOrderInternalNoteBody>},
        TContext
      > => {
      return useMutation(getPinOrderInternalNoteMutationOptions(options));
    }

export const getRegroupOrdersUrl = () => {




  return `/api/admin/regroup-orders`
}

/**
 * Re-runs the eBay combined-postage grouping pass across every
 * sale_order. Idempotent. Useful for backfilling historical data
 * the first time the feature is enabled, or after a bulk CSV
 * import. Requires manage_users.
 */
export const regroupOrders = async ( options?: RequestInit): Promise<RegroupOrdersResult> => {

  return customFetch<RegroupOrdersResult>(getRegroupOrdersUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRegroupOrdersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regroupOrders>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof regroupOrders>>, TError,void, TContext> => {

const mutationKey = ['regroupOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regroupOrders>>, void> = () => {


          return  regroupOrders(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegroupOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof regroupOrders>>>

    export type RegroupOrdersMutationError = ErrorType<unknown>

    export const useRegroupOrders = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regroupOrders>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof regroupOrders>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRegroupOrdersMutationOptions(options));
    }

export const getGetCustomerOverviewUrl = (id: string,) => {




  return `/api/customers/${id}/overview`
}

/**
 * Returns merged-identity-aware channel mix, returns and outstanding
 * balance. Each optional or permission-sensitive block carries an
 * explicit available, unavailable, or redacted state.
 * @summary Lightweight cacheable customer commerce overview
 */
export const getCustomerOverview = async (id: string, options?: RequestInit): Promise<CustomerOverview> => {

  return customFetch<CustomerOverview>(getGetCustomerOverviewUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomerOverviewQueryKey = (id: string,) => {
    return [
    `/api/customers/${id}/overview`
    ] as const;
    }


export const getGetCustomerOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerOverview>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerOverviewQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerOverview>>> = ({ signal }) => getCustomerOverview(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerOverview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerOverview>>>
export type GetCustomerOverviewQueryError = ErrorType<void>


/**
 * @summary Lightweight cacheable customer commerce overview
 */

export function useGetCustomerOverview<TData = Awaited<ReturnType<typeof getCustomerOverview>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCustomerOverviewQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCustomerActivityUrl = (id: string,
    params?: GetCustomerActivityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/customers/${id}/activity?${stringifiedParams}` : `/api/customers/${id}/activity`
}

/**
 * Returns the latest customer-scoped records across authoritative order,
 * communication, return, incident, note, identity and audit sources.
 * Results use a stable reverse-chronological keyset cursor and are capped
 * at 20 by default. Commerce events are included only with commerce.view.
 * @summary Read the unified customer activity timeline
 */
export const getCustomerActivity = async (id: string,
    params?: GetCustomerActivityParams, options?: RequestInit): Promise<CustomerActivityPage> => {

  return customFetch<CustomerActivityPage>(getGetCustomerActivityUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomerActivityQueryKey = (id: string,
    params?: GetCustomerActivityParams,) => {
    return [
    `/api/customers/${id}/activity`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerActivityQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerActivity>>, TError = ErrorType<unknown>>(id: string,
    params?: GetCustomerActivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerActivityQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerActivity>>> = ({ signal }) => getCustomerActivity(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerActivityQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerActivity>>>
export type GetCustomerActivityQueryError = ErrorType<unknown>


/**
 * @summary Read the unified customer activity timeline
 */

export function useGetCustomerActivity<TData = Awaited<ReturnType<typeof getCustomerActivity>>, TError = ErrorType<unknown>>(
 id: string,
    params?: GetCustomerActivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCustomerActivityQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCustomerUrl = (id: string,) => {




  return `/api/customers/${id}`
}

export const getCustomer = async (id: string, options?: RequestInit): Promise<CustomerDetail> => {

  return customFetch<CustomerDetail>(getGetCustomerUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomerQueryKey = (id: string,) => {
    return [
    `/api/customers/${id}`
    ] as const;
    }


export const getGetCustomerQueryOptions = <TData = Awaited<ReturnType<typeof getCustomer>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomer>>> = ({ signal }) => getCustomer(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomer>>>
export type GetCustomerQueryError = ErrorType<unknown>



export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCustomerQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateCustomerUrl = (id: string,) => {




  return `/api/customers/${id}`
}

export const updateCustomer = async (id: string,
    customerInput: CustomerInput, options?: RequestInit): Promise<Customer> => {

  return customFetch<Customer>(getUpdateCustomerUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerInput)
  }
);}





export const getUpdateCustomerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{id: string;data: BodyType<CustomerInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{id: string;data: BodyType<CustomerInput>}, TContext> => {

const mutationKey = ['updateCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCustomer>>, {id: string;data: BodyType<CustomerInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCustomer(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof updateCustomer>>>
    export type UpdateCustomerMutationBody = BodyType<CustomerInput>
    export type UpdateCustomerMutationError = ErrorType<unknown>

    export const useUpdateCustomer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{id: string;data: BodyType<CustomerInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCustomer>>,
        TError,
        {id: string;data: BodyType<CustomerInput>},
        TContext
      > => {
      return useMutation(getUpdateCustomerMutationOptions(options));
    }

export const getDeleteCustomerUrl = (id: string,) => {




  return `/api/customers/${id}`
}

export const deleteCustomer = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteCustomerUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteCustomerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomer>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomer>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomer>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCustomer(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomer>>>

    export type DeleteCustomerMutationError = ErrorType<unknown>

    export const useDeleteCustomer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomer>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomer>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteCustomerMutationOptions(options));
    }

export const getListCustomerPlatformHandlesUrl = (id: string,) => {




  return `/api/customers/${id}/platform-handles`
}

export const listCustomerPlatformHandles = async (id: string, options?: RequestInit): Promise<ListCustomerPlatformHandles200> => {

  return customFetch<ListCustomerPlatformHandles200>(getListCustomerPlatformHandlesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomerPlatformHandlesQueryKey = (id: string,) => {
    return [
    `/api/customers/${id}/platform-handles`
    ] as const;
    }


export const getListCustomerPlatformHandlesQueryOptions = <TData = Awaited<ReturnType<typeof listCustomerPlatformHandles>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerPlatformHandles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomerPlatformHandlesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomerPlatformHandles>>> = ({ signal }) => listCustomerPlatformHandles(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomerPlatformHandles>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCustomerPlatformHandlesQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomerPlatformHandles>>>
export type ListCustomerPlatformHandlesQueryError = ErrorType<unknown>



export function useListCustomerPlatformHandles<TData = Awaited<ReturnType<typeof listCustomerPlatformHandles>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerPlatformHandles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCustomerPlatformHandlesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpsertCustomerPlatformHandleUrl = (id: string,) => {




  return `/api/customers/${id}/platform-handles`
}

export const upsertCustomerPlatformHandle = async (id: string,
    customerPlatformHandleInput: CustomerPlatformHandleInput, options?: RequestInit): Promise<CustomerPlatformHandle> => {

  return customFetch<CustomerPlatformHandle>(getUpsertCustomerPlatformHandleUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerPlatformHandleInput)
  }
);}





export const getUpsertCustomerPlatformHandleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertCustomerPlatformHandle>>, TError,{id: string;data: BodyType<CustomerPlatformHandleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertCustomerPlatformHandle>>, TError,{id: string;data: BodyType<CustomerPlatformHandleInput>}, TContext> => {

const mutationKey = ['upsertCustomerPlatformHandle'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertCustomerPlatformHandle>>, {id: string;data: BodyType<CustomerPlatformHandleInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  upsertCustomerPlatformHandle(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertCustomerPlatformHandleMutationResult = NonNullable<Awaited<ReturnType<typeof upsertCustomerPlatformHandle>>>
    export type UpsertCustomerPlatformHandleMutationBody = BodyType<CustomerPlatformHandleInput>
    export type UpsertCustomerPlatformHandleMutationError = ErrorType<unknown>

    export const useUpsertCustomerPlatformHandle = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertCustomerPlatformHandle>>, TError,{id: string;data: BodyType<CustomerPlatformHandleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertCustomerPlatformHandle>>,
        TError,
        {id: string;data: BodyType<CustomerPlatformHandleInput>},
        TContext
      > => {
      return useMutation(getUpsertCustomerPlatformHandleMutationOptions(options));
    }

export const getUpdateCustomerPlatformHandleUrl = (id: string,
    handleId: string,) => {




  return `/api/customers/${id}/platform-handles/${handleId}`
}

export const updateCustomerPlatformHandle = async (id: string,
    handleId: string,
    customerPlatformHandleInput: CustomerPlatformHandleInput, options?: RequestInit): Promise<CustomerPlatformHandle> => {

  return customFetch<CustomerPlatformHandle>(getUpdateCustomerPlatformHandleUrl(id,handleId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerPlatformHandleInput)
  }
);}





export const getUpdateCustomerPlatformHandleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomerPlatformHandle>>, TError,{id: string;handleId: string;data: BodyType<CustomerPlatformHandleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCustomerPlatformHandle>>, TError,{id: string;handleId: string;data: BodyType<CustomerPlatformHandleInput>}, TContext> => {

const mutationKey = ['updateCustomerPlatformHandle'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCustomerPlatformHandle>>, {id: string;handleId: string;data: BodyType<CustomerPlatformHandleInput>}> = (props) => {
          const {id,handleId,data} = props ?? {};

          return  updateCustomerPlatformHandle(id,handleId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCustomerPlatformHandleMutationResult = NonNullable<Awaited<ReturnType<typeof updateCustomerPlatformHandle>>>
    export type UpdateCustomerPlatformHandleMutationBody = BodyType<CustomerPlatformHandleInput>
    export type UpdateCustomerPlatformHandleMutationError = ErrorType<unknown>

    export const useUpdateCustomerPlatformHandle = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomerPlatformHandle>>, TError,{id: string;handleId: string;data: BodyType<CustomerPlatformHandleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCustomerPlatformHandle>>,
        TError,
        {id: string;handleId: string;data: BodyType<CustomerPlatformHandleInput>},
        TContext
      > => {
      return useMutation(getUpdateCustomerPlatformHandleMutationOptions(options));
    }

export const getDeleteCustomerPlatformHandleUrl = (id: string,
    handleId: string,) => {




  return `/api/customers/${id}/platform-handles/${handleId}`
}

export const deleteCustomerPlatformHandle = async (id: string,
    handleId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteCustomerPlatformHandleUrl(id,handleId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteCustomerPlatformHandleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerPlatformHandle>>, TError,{id: string;handleId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerPlatformHandle>>, TError,{id: string;handleId: string}, TContext> => {

const mutationKey = ['deleteCustomerPlatformHandle'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomerPlatformHandle>>, {id: string;handleId: string}> = (props) => {
          const {id,handleId} = props ?? {};

          return  deleteCustomerPlatformHandle(id,handleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomerPlatformHandleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomerPlatformHandle>>>

    export type DeleteCustomerPlatformHandleMutationError = ErrorType<unknown>

    export const useDeleteCustomerPlatformHandle = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerPlatformHandle>>, TError,{id: string;handleId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomerPlatformHandle>>,
        TError,
        {id: string;handleId: string},
        TContext
      > => {
      return useMutation(getDeleteCustomerPlatformHandleMutationOptions(options));
    }

export const getListFlagsUrl = (params?: ListFlagsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/flags?${stringifiedParams}` : `/api/flags`
}

export const listFlags = async (params?: ListFlagsParams, options?: RequestInit): Promise<FlagDefinition[]> => {

  return customFetch<FlagDefinition[]>(getListFlagsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListFlagsQueryKey = (params?: ListFlagsParams,) => {
    return [
    `/api/flags`, ...(params ? [params] : [])
    ] as const;
    }


export const getListFlagsQueryOptions = <TData = Awaited<ReturnType<typeof listFlags>>, TError = ErrorType<unknown>>(params?: ListFlagsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFlags>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFlagsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFlags>>> = ({ signal }) => listFlags(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFlags>>, TError, TData> & { queryKey: QueryKey }
}

export type ListFlagsQueryResult = NonNullable<Awaited<ReturnType<typeof listFlags>>>
export type ListFlagsQueryError = ErrorType<unknown>



export function useListFlags<TData = Awaited<ReturnType<typeof listFlags>>, TError = ErrorType<unknown>>(
 params?: ListFlagsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFlags>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListFlagsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateFlagUrl = () => {




  return `/api/flags`
}

export const createFlag = async (flagCreateInput: FlagCreateInput, options?: RequestInit): Promise<FlagDefinition> => {

  return customFetch<FlagDefinition>(getCreateFlagUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(flagCreateInput)
  }
);}





export const getCreateFlagMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFlag>>, TError,{data: BodyType<FlagCreateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createFlag>>, TError,{data: BodyType<FlagCreateInput>}, TContext> => {

const mutationKey = ['createFlag'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFlag>>, {data: BodyType<FlagCreateInput>}> = (props) => {
          const {data} = props ?? {};

          return  createFlag(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFlagMutationResult = NonNullable<Awaited<ReturnType<typeof createFlag>>>
    export type CreateFlagMutationBody = BodyType<FlagCreateInput>
    export type CreateFlagMutationError = ErrorType<unknown>

    export const useCreateFlag = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFlag>>, TError,{data: BodyType<FlagCreateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createFlag>>,
        TError,
        {data: BodyType<FlagCreateInput>},
        TContext
      > => {
      return useMutation(getCreateFlagMutationOptions(options));
    }

export const getUpdateFlagUrl = (id: string,) => {




  return `/api/flags/${id}`
}

export const updateFlag = async (id: string,
    flagUpdate: FlagUpdate, options?: RequestInit): Promise<FlagDefinition> => {

  return customFetch<FlagDefinition>(getUpdateFlagUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(flagUpdate)
  }
);}





export const getUpdateFlagMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFlag>>, TError,{id: string;data: BodyType<FlagUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateFlag>>, TError,{id: string;data: BodyType<FlagUpdate>}, TContext> => {

const mutationKey = ['updateFlag'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFlag>>, {id: string;data: BodyType<FlagUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateFlag(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFlagMutationResult = NonNullable<Awaited<ReturnType<typeof updateFlag>>>
    export type UpdateFlagMutationBody = BodyType<FlagUpdate>
    export type UpdateFlagMutationError = ErrorType<unknown>

    export const useUpdateFlag = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFlag>>, TError,{id: string;data: BodyType<FlagUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateFlag>>,
        TError,
        {id: string;data: BodyType<FlagUpdate>},
        TContext
      > => {
      return useMutation(getUpdateFlagMutationOptions(options));
    }

export const getDeleteFlagUrl = (id: string,) => {




  return `/api/flags/${id}`
}

export const deleteFlag = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteFlagUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteFlagMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFlag>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFlag>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteFlag'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFlag>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteFlag(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteFlagMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFlag>>>

    export type DeleteFlagMutationError = ErrorType<unknown>

    export const useDeleteFlag = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFlag>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteFlag>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteFlagMutationOptions(options));
    }

export const getListFlagAssignmentsUrl = (params: ListFlagAssignmentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/flag-assignments?${stringifiedParams}` : `/api/flag-assignments`
}

export const listFlagAssignments = async (params: ListFlagAssignmentsParams, options?: RequestInit): Promise<FlagAssignment[]> => {

  return customFetch<FlagAssignment[]>(getListFlagAssignmentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListFlagAssignmentsQueryKey = (params?: ListFlagAssignmentsParams,) => {
    return [
    `/api/flag-assignments`, ...(params ? [params] : [])
    ] as const;
    }


export const getListFlagAssignmentsQueryOptions = <TData = Awaited<ReturnType<typeof listFlagAssignments>>, TError = ErrorType<unknown>>(params: ListFlagAssignmentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFlagAssignments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFlagAssignmentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFlagAssignments>>> = ({ signal }) => listFlagAssignments(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFlagAssignments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListFlagAssignmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listFlagAssignments>>>
export type ListFlagAssignmentsQueryError = ErrorType<unknown>



export function useListFlagAssignments<TData = Awaited<ReturnType<typeof listFlagAssignments>>, TError = ErrorType<unknown>>(
 params: ListFlagAssignmentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFlagAssignments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListFlagAssignmentsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAssignFlagUrl = () => {




  return `/api/flag-assignments`
}

export const assignFlag = async (flagAssignmentInput: FlagAssignmentInput, options?: RequestInit): Promise<FlagAssignmentCreated> => {

  return customFetch<FlagAssignmentCreated>(getAssignFlagUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(flagAssignmentInput)
  }
);}





export const getAssignFlagMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignFlag>>, TError,{data: BodyType<FlagAssignmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assignFlag>>, TError,{data: BodyType<FlagAssignmentInput>}, TContext> => {

const mutationKey = ['assignFlag'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignFlag>>, {data: BodyType<FlagAssignmentInput>}> = (props) => {
          const {data} = props ?? {};

          return  assignFlag(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignFlagMutationResult = NonNullable<Awaited<ReturnType<typeof assignFlag>>>
    export type AssignFlagMutationBody = BodyType<FlagAssignmentInput>
    export type AssignFlagMutationError = ErrorType<unknown>

    export const useAssignFlag = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignFlag>>, TError,{data: BodyType<FlagAssignmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof assignFlag>>,
        TError,
        {data: BodyType<FlagAssignmentInput>},
        TContext
      > => {
      return useMutation(getAssignFlagMutationOptions(options));
    }

export const getUnassignFlagUrl = (id: string,
    params?: UnassignFlagParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/flag-assignments/${id}?${stringifiedParams}` : `/api/flag-assignments/${id}`
}

export const unassignFlag = async (id: string,
    params?: UnassignFlagParams, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getUnassignFlagUrl(id,params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUnassignFlagMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unassignFlag>>, TError,{id: string;params?: UnassignFlagParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unassignFlag>>, TError,{id: string;params?: UnassignFlagParams}, TContext> => {

const mutationKey = ['unassignFlag'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unassignFlag>>, {id: string;params?: UnassignFlagParams}> = (props) => {
          const {id,params} = props ?? {};

          return  unassignFlag(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnassignFlagMutationResult = NonNullable<Awaited<ReturnType<typeof unassignFlag>>>

    export type UnassignFlagMutationError = ErrorType<unknown>

    export const useUnassignFlag = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unassignFlag>>, TError,{id: string;params?: UnassignFlagParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof unassignFlag>>,
        TError,
        {id: string;params?: UnassignFlagParams},
        TContext
      > => {
      return useMutation(getUnassignFlagMutationOptions(options));
    }

export const getListSalesAssigneesUrl = () => {




  return `/api/sales/assignees`
}

/**
 * @summary List tenant members available to the Sales assignee filter
 */
export const listSalesAssignees = async ( options?: RequestInit): Promise<SalesAssignee[]> => {

  return customFetch<SalesAssignee[]>(getListSalesAssigneesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSalesAssigneesQueryKey = () => {
    return [
    `/api/sales/assignees`
    ] as const;
    }


export const getListSalesAssigneesQueryOptions = <TData = Awaited<ReturnType<typeof listSalesAssignees>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSalesAssignees>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSalesAssigneesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSalesAssignees>>> = ({ signal }) => listSalesAssignees({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSalesAssignees>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSalesAssigneesQueryResult = NonNullable<Awaited<ReturnType<typeof listSalesAssignees>>>
export type ListSalesAssigneesQueryError = ErrorType<void>


/**
 * @summary List tenant members available to the Sales assignee filter
 */

export function useListSalesAssignees<TData = Awaited<ReturnType<typeof listSalesAssignees>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSalesAssignees>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSalesAssigneesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSalesProfitBlockersUrl = (params?: GetSalesProfitBlockersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/sales/profit-blockers?${stringifiedParams}` : `/api/sales/profit-blockers`
}

/**
 * @summary Read-only tenant-scoped list of orders whose profit is blocked by current source evidence
 */
export const getSalesProfitBlockers = async (params?: GetSalesProfitBlockersParams, options?: RequestInit): Promise<SalesProfitBlockersPage> => {

  return customFetch<SalesProfitBlockersPage>(getGetSalesProfitBlockersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSalesProfitBlockersQueryKey = (params?: GetSalesProfitBlockersParams,) => {
    return [
    `/api/sales/profit-blockers`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSalesProfitBlockersQueryOptions = <TData = Awaited<ReturnType<typeof getSalesProfitBlockers>>, TError = ErrorType<void>>(params?: GetSalesProfitBlockersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSalesProfitBlockers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSalesProfitBlockersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSalesProfitBlockers>>> = ({ signal }) => getSalesProfitBlockers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSalesProfitBlockers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSalesProfitBlockersQueryResult = NonNullable<Awaited<ReturnType<typeof getSalesProfitBlockers>>>
export type GetSalesProfitBlockersQueryError = ErrorType<void>


/**
 * @summary Read-only tenant-scoped list of orders whose profit is blocked by current source evidence
 */

export function useGetSalesProfitBlockers<TData = Awaited<ReturnType<typeof getSalesProfitBlockers>>, TError = ErrorType<void>>(
 params?: GetSalesProfitBlockersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSalesProfitBlockers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSalesProfitBlockersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSalesUrl = (params?: ListSalesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/sales?${stringifiedParams}` : `/api/sales`
}

export const listSales = async (params?: ListSalesParams, options?: RequestInit): Promise<ListSales200> => {

  return customFetch<ListSales200>(getListSalesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSalesQueryKey = (params?: ListSalesParams,) => {
    return [
    `/api/sales`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSalesQueryOptions = <TData = Awaited<ReturnType<typeof listSales>>, TError = ErrorType<unknown>>(params?: ListSalesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSales>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSalesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSales>>> = ({ signal }) => listSales(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSales>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSalesQueryResult = NonNullable<Awaited<ReturnType<typeof listSales>>>
export type ListSalesQueryError = ErrorType<unknown>



export function useListSales<TData = Awaited<ReturnType<typeof listSales>>, TError = ErrorType<unknown>>(
 params?: ListSalesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSales>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSalesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateSaleUrl = () => {




  return `/api/sales`
}

export const createSale = async (saleOrderInput: SaleOrderInput, options?: RequestInit): Promise<SaleOrderDetail> => {

  return customFetch<SaleOrderDetail>(getCreateSaleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(saleOrderInput)
  }
);}





export const getCreateSaleMutationOptions = <TError = ErrorType<CreateSaleZeroCostError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSale>>, TError,{data: BodyType<SaleOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSale>>, TError,{data: BodyType<SaleOrderInput>}, TContext> => {

const mutationKey = ['createSale'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSale>>, {data: BodyType<SaleOrderInput>}> = (props) => {
          const {data} = props ?? {};

          return  createSale(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSaleMutationResult = NonNullable<Awaited<ReturnType<typeof createSale>>>
    export type CreateSaleMutationBody = BodyType<SaleOrderInput>
    export type CreateSaleMutationError = ErrorType<CreateSaleZeroCostError>

    export const useCreateSale = <TError = ErrorType<CreateSaleZeroCostError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSale>>, TError,{data: BodyType<SaleOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSale>>,
        TError,
        {data: BodyType<SaleOrderInput>},
        TContext
      > => {
      return useMutation(getCreateSaleMutationOptions(options));
    }

export const getGetSalesOnHoldCountUrl = () => {




  return `/api/sales/on-hold-count`
}

/**
 * @summary Read the on-hold sales count for the dashboard
 */
export const getSalesOnHoldCount = async ( options?: RequestInit): Promise<GetSalesOnHoldCount200> => {

  return customFetch<GetSalesOnHoldCount200>(getGetSalesOnHoldCountUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSalesOnHoldCountQueryKey = () => {
    return [
    `/api/sales/on-hold-count`
    ] as const;
    }


export const getGetSalesOnHoldCountQueryOptions = <TData = Awaited<ReturnType<typeof getSalesOnHoldCount>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSalesOnHoldCount>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSalesOnHoldCountQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSalesOnHoldCount>>> = ({ signal }) => getSalesOnHoldCount({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSalesOnHoldCount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSalesOnHoldCountQueryResult = NonNullable<Awaited<ReturnType<typeof getSalesOnHoldCount>>>
export type GetSalesOnHoldCountQueryError = ErrorType<unknown>


/**
 * @summary Read the on-hold sales count for the dashboard
 */

export function useGetSalesOnHoldCount<TData = Awaited<ReturnType<typeof getSalesOnHoldCount>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSalesOnHoldCount>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSalesOnHoldCountQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRecoverShopifySaleDeliveryUrl = (id: string,) => {




  return `/api/sales/${id}/shopify-delivery-recovery`
}

/**
 * Fetches the explicitly verified Shopify order for this tenant-scoped
 * sale and fills only missing delivery/contact snapshot fields. It does
 * not re-import the sale or change payments, fees, or inventory.
 * @summary Refresh one Shopify sale's missing delivery details
 */
export const recoverShopifySaleDelivery = async (id: string,
    shopifyDeliveryRecoveryRequest: ShopifyDeliveryRecoveryRequest, options?: RequestInit): Promise<ShopifyDeliveryRecoveryResponse> => {

  return customFetch<ShopifyDeliveryRecoveryResponse>(getRecoverShopifySaleDeliveryUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(shopifyDeliveryRecoveryRequest)
  }
);}





export const getRecoverShopifySaleDeliveryMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recoverShopifySaleDelivery>>, TError,{id: string;data: BodyType<ShopifyDeliveryRecoveryRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recoverShopifySaleDelivery>>, TError,{id: string;data: BodyType<ShopifyDeliveryRecoveryRequest>}, TContext> => {

const mutationKey = ['recoverShopifySaleDelivery'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recoverShopifySaleDelivery>>, {id: string;data: BodyType<ShopifyDeliveryRecoveryRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  recoverShopifySaleDelivery(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecoverShopifySaleDeliveryMutationResult = NonNullable<Awaited<ReturnType<typeof recoverShopifySaleDelivery>>>
    export type RecoverShopifySaleDeliveryMutationBody = BodyType<ShopifyDeliveryRecoveryRequest>
    export type RecoverShopifySaleDeliveryMutationError = ErrorType<void>

    /**
 * @summary Refresh one Shopify sale's missing delivery details
 */
export const useRecoverShopifySaleDelivery = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recoverShopifySaleDelivery>>, TError,{id: string;data: BodyType<ShopifyDeliveryRecoveryRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recoverShopifySaleDelivery>>,
        TError,
        {id: string;data: BodyType<ShopifyDeliveryRecoveryRequest>},
        TContext
      > => {
      return useMutation(getRecoverShopifySaleDeliveryMutationOptions(options));
    }

export const getUpdateSaleCustomerDetailsUrl = (id: string,) => {




  return `/api/sales/${id}/customer-details`
}

/**
 * @summary Update order-specific customer contact and address snapshots
 */
export const updateSaleCustomerDetails = async (id: string,
    saleOrderCustomerDetailsUpdate: SaleOrderCustomerDetailsUpdate, options?: RequestInit): Promise<SaleOrderDetail> => {

  return customFetch<SaleOrderDetail>(getUpdateSaleCustomerDetailsUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(saleOrderCustomerDetailsUpdate)
  }
);}





export const getUpdateSaleCustomerDetailsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSaleCustomerDetails>>, TError,{id: string;data: BodyType<SaleOrderCustomerDetailsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSaleCustomerDetails>>, TError,{id: string;data: BodyType<SaleOrderCustomerDetailsUpdate>}, TContext> => {

const mutationKey = ['updateSaleCustomerDetails'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSaleCustomerDetails>>, {id: string;data: BodyType<SaleOrderCustomerDetailsUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSaleCustomerDetails(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSaleCustomerDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof updateSaleCustomerDetails>>>
    export type UpdateSaleCustomerDetailsMutationBody = BodyType<SaleOrderCustomerDetailsUpdate>
    export type UpdateSaleCustomerDetailsMutationError = ErrorType<void>

    /**
 * @summary Update order-specific customer contact and address snapshots
 */
export const useUpdateSaleCustomerDetails = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSaleCustomerDetails>>, TError,{id: string;data: BodyType<SaleOrderCustomerDetailsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSaleCustomerDetails>>,
        TError,
        {id: string;data: BodyType<SaleOrderCustomerDetailsUpdate>},
        TContext
      > => {
      return useMutation(getUpdateSaleCustomerDetailsMutationOptions(options));
    }

export const getGetSaleUrl = (id: string,) => {




  return `/api/sales/${id}`
}

export const getSale = async (id: string, options?: RequestInit): Promise<SaleOrderDetail> => {

  return customFetch<SaleOrderDetail>(getGetSaleUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSaleQueryKey = (id: string,) => {
    return [
    `/api/sales/${id}`
    ] as const;
    }


export const getGetSaleQueryOptions = <TData = Awaited<ReturnType<typeof getSale>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSale>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSaleQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSale>>> = ({ signal }) => getSale(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSale>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSaleQueryResult = NonNullable<Awaited<ReturnType<typeof getSale>>>
export type GetSaleQueryError = ErrorType<unknown>



export function useGetSale<TData = Awaited<ReturnType<typeof getSale>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSale>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSaleQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateSaleUrl = (id: string,) => {




  return `/api/sales/${id}`
}

export const updateSale = async (id: string,
    saleStatusUpdate: SaleStatusUpdate, options?: RequestInit): Promise<SaleOrderDetail> => {

  return customFetch<SaleOrderDetail>(getUpdateSaleUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(saleStatusUpdate)
  }
);}





export const getUpdateSaleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSale>>, TError,{id: string;data: BodyType<SaleStatusUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSale>>, TError,{id: string;data: BodyType<SaleStatusUpdate>}, TContext> => {

const mutationKey = ['updateSale'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSale>>, {id: string;data: BodyType<SaleStatusUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSale(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSaleMutationResult = NonNullable<Awaited<ReturnType<typeof updateSale>>>
    export type UpdateSaleMutationBody = BodyType<SaleStatusUpdate>
    export type UpdateSaleMutationError = ErrorType<unknown>

    export const useUpdateSale = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSale>>, TError,{id: string;data: BodyType<SaleStatusUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSale>>,
        TError,
        {id: string;data: BodyType<SaleStatusUpdate>},
        TContext
      > => {
      return useMutation(getUpdateSaleMutationOptions(options));
    }

export const getDeleteSaleUrl = (id: string,) => {




  return `/api/sales/${id}`
}

/**
 * @summary Reverse a sale, applying the consignment payout rule per line:
  • OWNED line                          → restore qty on the original
                                           inventory row.
  • CONSIGNMENT line, supplier UNPAID   → restore qty on the original
                                           consignment row (same supplier
                                           and payout terms remain
                                           attached). Supplier owed is
                                           cancelled.
  • CONSIGNMENT line, supplier PAID     → create a new OWNED inventory
    (full or partial allocation)         row at cost = paid_gbp / qty.
                                           Original consignment row is
                                           left untouched (payout
                                           history is preserved).
The sale row is deleted only when nothing forces it to be kept;
otherwise it is marked `status="Reversed"` so all linked accounting
rows continue to reference it.

 */
export const deleteSale = async (id: string, options?: RequestInit): Promise<SaleReversalResult> => {

  return customFetch<SaleReversalResult>(getDeleteSaleUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteSaleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSale>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSale>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteSale'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSale>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteSale(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSaleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSale>>>

    export type DeleteSaleMutationError = ErrorType<unknown>

    /**
 * @summary Reverse a sale, applying the consignment payout rule per line:
  • OWNED line                          → restore qty on the original
                                           inventory row.
  • CONSIGNMENT line, supplier UNPAID   → restore qty on the original
                                           consignment row (same supplier
                                           and payout terms remain
                                           attached). Supplier owed is
                                           cancelled.
  • CONSIGNMENT line, supplier PAID     → create a new OWNED inventory
    (full or partial allocation)         row at cost = paid_gbp / qty.
                                           Original consignment row is
                                           left untouched (payout
                                           history is preserved).
The sale row is deleted only when nothing forces it to be kept;
otherwise it is marked `status="Reversed"` so all linked accounting
rows continue to reference it.

 */
export const useDeleteSale = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSale>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSale>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteSaleMutationOptions(options));
    }

export const getGetPaymentFulfilmentSettingsUrl = () => {




  return `/api/sales/payment-settings`
}

/**
 * @summary Per-tenant policy for packing/shipping unpaid manual orders (Task
 */
export const getPaymentFulfilmentSettings = async ( options?: RequestInit): Promise<PaymentFulfilmentSettings> => {

  return customFetch<PaymentFulfilmentSettings>(getGetPaymentFulfilmentSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPaymentFulfilmentSettingsQueryKey = () => {
    return [
    `/api/sales/payment-settings`
    ] as const;
    }


export const getGetPaymentFulfilmentSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentFulfilmentSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPaymentFulfilmentSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentFulfilmentSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentFulfilmentSettings>>> = ({ signal }) => getPaymentFulfilmentSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentFulfilmentSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPaymentFulfilmentSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentFulfilmentSettings>>>
export type GetPaymentFulfilmentSettingsQueryError = ErrorType<unknown>


/**
 * @summary Per-tenant policy for packing/shipping unpaid manual orders (Task
 */

export function useGetPaymentFulfilmentSettings<TData = Awaited<ReturnType<typeof getPaymentFulfilmentSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPaymentFulfilmentSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPaymentFulfilmentSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdatePaymentFulfilmentSettingsUrl = () => {




  return `/api/sales/payment-settings`
}

/**
 * @summary Update the unpaid-order packing/shipping policy (requires `sales.payment.edit_settings`).
 */
export const updatePaymentFulfilmentSettings = async (paymentFulfilmentSettings: PaymentFulfilmentSettings, options?: RequestInit): Promise<PaymentFulfilmentSettings> => {

  return customFetch<PaymentFulfilmentSettings>(getUpdatePaymentFulfilmentSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(paymentFulfilmentSettings)
  }
);}





export const getUpdatePaymentFulfilmentSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePaymentFulfilmentSettings>>, TError,{data: BodyType<PaymentFulfilmentSettings>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePaymentFulfilmentSettings>>, TError,{data: BodyType<PaymentFulfilmentSettings>}, TContext> => {

const mutationKey = ['updatePaymentFulfilmentSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePaymentFulfilmentSettings>>, {data: BodyType<PaymentFulfilmentSettings>}> = (props) => {
          const {data} = props ?? {};

          return  updatePaymentFulfilmentSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePaymentFulfilmentSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updatePaymentFulfilmentSettings>>>
    export type UpdatePaymentFulfilmentSettingsMutationBody = BodyType<PaymentFulfilmentSettings>
    export type UpdatePaymentFulfilmentSettingsMutationError = ErrorType<unknown>

    /**
 * @summary Update the unpaid-order packing/shipping policy (requires `sales.payment.edit_settings`).
 */
export const useUpdatePaymentFulfilmentSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePaymentFulfilmentSettings>>, TError,{data: BodyType<PaymentFulfilmentSettings>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePaymentFulfilmentSettings>>,
        TError,
        {data: BodyType<PaymentFulfilmentSettings>},
        TContext
      > => {
      return useMutation(getUpdatePaymentFulfilmentSettingsMutationOptions(options));
    }

export const getGetOrderPaymentLedgerUrl = (id: string,) => {




  return `/api/sales/${id}/payments`
}

/**
 * @summary Payment ledger and status-change history for a manual order (Task
 */
export const getOrderPaymentLedger = async (id: string, options?: RequestInit): Promise<OrderPaymentLedger> => {

  return customFetch<OrderPaymentLedger>(getGetOrderPaymentLedgerUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrderPaymentLedgerQueryKey = (id: string,) => {
    return [
    `/api/sales/${id}/payments`
    ] as const;
    }


export const getGetOrderPaymentLedgerQueryOptions = <TData = Awaited<ReturnType<typeof getOrderPaymentLedger>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderPaymentLedger>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderPaymentLedgerQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderPaymentLedger>>> = ({ signal }) => getOrderPaymentLedger(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrderPaymentLedger>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrderPaymentLedgerQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderPaymentLedger>>>
export type GetOrderPaymentLedgerQueryError = ErrorType<unknown>


/**
 * @summary Payment ledger and status-change history for a manual order (Task
 */

export function useGetOrderPaymentLedger<TData = Awaited<ReturnType<typeof getOrderPaymentLedger>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderPaymentLedger>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrderPaymentLedgerQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRecordOrderPaymentUrl = (id: string,) => {




  return `/api/sales/${id}/payments`
}

/**
 * @summary Record a payment (or contra adjustment) against a manual order.
 */
export const recordOrderPayment = async (id: string,
    recordOrderPaymentBody: RecordOrderPaymentBody, options?: RequestInit): Promise<SalePaymentActionResponse> => {

  return customFetch<SalePaymentActionResponse>(getRecordOrderPaymentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(recordOrderPaymentBody)
  }
);}





export const getRecordOrderPaymentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordOrderPayment>>, TError,{id: string;data: BodyType<RecordOrderPaymentBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recordOrderPayment>>, TError,{id: string;data: BodyType<RecordOrderPaymentBody>}, TContext> => {

const mutationKey = ['recordOrderPayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordOrderPayment>>, {id: string;data: BodyType<RecordOrderPaymentBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  recordOrderPayment(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordOrderPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof recordOrderPayment>>>
    export type RecordOrderPaymentMutationBody = BodyType<RecordOrderPaymentBody>
    export type RecordOrderPaymentMutationError = ErrorType<unknown>

    /**
 * @summary Record a payment (or contra adjustment) against a manual order.
 */
export const useRecordOrderPayment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordOrderPayment>>, TError,{id: string;data: BodyType<RecordOrderPaymentBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recordOrderPayment>>,
        TError,
        {id: string;data: BodyType<RecordOrderPaymentBody>},
        TContext
      > => {
      return useMutation(getRecordOrderPaymentMutationOptions(options));
    }

export const getMarkOrderPaidUrl = (id: string,) => {




  return `/api/sales/${id}/payment/mark-paid`
}

/**
 * @summary Mark a manual order fully paid (records the remaining balance as a ledger entry).
 */
export const markOrderPaid = async (id: string,
    paidSaleFulfilmentInput?: PaidSaleFulfilmentInput, options?: RequestInit): Promise<SalePaymentActionResponse> => {

  return customFetch<SalePaymentActionResponse>(getMarkOrderPaidUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(paidSaleFulfilmentInput)
  }
);}





export const getMarkOrderPaidMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markOrderPaid>>, TError,{id: string;data?: BodyType<PaidSaleFulfilmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markOrderPaid>>, TError,{id: string;data?: BodyType<PaidSaleFulfilmentInput>}, TContext> => {

const mutationKey = ['markOrderPaid'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markOrderPaid>>, {id: string;data?: BodyType<PaidSaleFulfilmentInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  markOrderPaid(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkOrderPaidMutationResult = NonNullable<Awaited<ReturnType<typeof markOrderPaid>>>
    export type MarkOrderPaidMutationBody = BodyType<PaidSaleFulfilmentInput> | undefined
    export type MarkOrderPaidMutationError = ErrorType<unknown>

    /**
 * @summary Mark a manual order fully paid (records the remaining balance as a ledger entry).
 */
export const useMarkOrderPaid = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markOrderPaid>>, TError,{id: string;data?: BodyType<PaidSaleFulfilmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markOrderPaid>>,
        TError,
        {id: string;data?: BodyType<PaidSaleFulfilmentInput>},
        TContext
      > => {
      return useMutation(getMarkOrderPaidMutationOptions(options));
    }

export const getMarkOrderUnpaidUrl = (id: string,) => {




  return `/api/sales/${id}/payment/mark-unpaid`
}

/**
 * @summary Revert a manual order to Unpaid (records a contra ledger entry zeroing the balance).
 */
export const markOrderUnpaid = async (id: string, options?: RequestInit): Promise<SalePaymentActionResponse> => {

  return customFetch<SalePaymentActionResponse>(getMarkOrderUnpaidUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMarkOrderUnpaidMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markOrderUnpaid>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markOrderUnpaid>>, TError,{id: string}, TContext> => {

const mutationKey = ['markOrderUnpaid'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markOrderUnpaid>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  markOrderUnpaid(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkOrderUnpaidMutationResult = NonNullable<Awaited<ReturnType<typeof markOrderUnpaid>>>

    export type MarkOrderUnpaidMutationError = ErrorType<unknown>

    /**
 * @summary Revert a manual order to Unpaid (records a contra ledger entry zeroing the balance).
 */
export const useMarkOrderUnpaid = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markOrderUnpaid>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markOrderUnpaid>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getMarkOrderUnpaidMutationOptions(options));
    }

export const getSetOrderPaymentDueDateUrl = (id: string,) => {




  return `/api/sales/${id}/payment/due-date`
}

/**
 * @summary Set or clear the payment due date on a manual order.
 */
export const setOrderPaymentDueDate = async (id: string,
    orderPaymentDueDateBody: OrderPaymentDueDateBody, options?: RequestInit): Promise<SalePaymentActionResponse> => {

  return customFetch<SalePaymentActionResponse>(getSetOrderPaymentDueDateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(orderPaymentDueDateBody)
  }
);}





export const getSetOrderPaymentDueDateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOrderPaymentDueDate>>, TError,{id: string;data: BodyType<OrderPaymentDueDateBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setOrderPaymentDueDate>>, TError,{id: string;data: BodyType<OrderPaymentDueDateBody>}, TContext> => {

const mutationKey = ['setOrderPaymentDueDate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setOrderPaymentDueDate>>, {id: string;data: BodyType<OrderPaymentDueDateBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  setOrderPaymentDueDate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetOrderPaymentDueDateMutationResult = NonNullable<Awaited<ReturnType<typeof setOrderPaymentDueDate>>>
    export type SetOrderPaymentDueDateMutationBody = BodyType<OrderPaymentDueDateBody>
    export type SetOrderPaymentDueDateMutationError = ErrorType<unknown>

    /**
 * @summary Set or clear the payment due date on a manual order.
 */
export const useSetOrderPaymentDueDate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOrderPaymentDueDate>>, TError,{id: string;data: BodyType<OrderPaymentDueDateBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setOrderPaymentDueDate>>,
        TError,
        {id: string;data: BodyType<OrderPaymentDueDateBody>},
        TContext
      > => {
      return useMutation(getSetOrderPaymentDueDateMutationOptions(options));
    }

export const getWriteOffOrderBalanceUrl = (id: string,) => {




  return `/api/sales/${id}/payment/write-off`
}

/**
 * @summary Write off the outstanding balance of a manual order (terminal status).
 */
export const writeOffOrderBalance = async (id: string, options?: RequestInit): Promise<SalePaymentActionResponse> => {

  return customFetch<SalePaymentActionResponse>(getWriteOffOrderBalanceUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getWriteOffOrderBalanceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeOffOrderBalance>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof writeOffOrderBalance>>, TError,{id: string}, TContext> => {

const mutationKey = ['writeOffOrderBalance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeOffOrderBalance>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  writeOffOrderBalance(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteOffOrderBalanceMutationResult = NonNullable<Awaited<ReturnType<typeof writeOffOrderBalance>>>

    export type WriteOffOrderBalanceMutationError = ErrorType<unknown>

    /**
 * @summary Write off the outstanding balance of a manual order (terminal status).
 */
export const useWriteOffOrderBalance = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeOffOrderBalance>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof writeOffOrderBalance>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getWriteOffOrderBalanceMutationOptions(options));
    }

export const getCancelOrderPaymentUrl = (id: string,) => {




  return `/api/sales/${id}/payment/cancel`
}

/**
 * @summary Cancel a manual order for payment purposes (terminal status).
 */
export const cancelOrderPayment = async (id: string, options?: RequestInit): Promise<SalePaymentActionResponse> => {

  return customFetch<SalePaymentActionResponse>(getCancelOrderPaymentUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelOrderPaymentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelOrderPayment>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelOrderPayment>>, TError,{id: string}, TContext> => {

const mutationKey = ['cancelOrderPayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelOrderPayment>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  cancelOrderPayment(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelOrderPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof cancelOrderPayment>>>

    export type CancelOrderPaymentMutationError = ErrorType<unknown>

    /**
 * @summary Cancel a manual order for payment purposes (terminal status).
 */
export const useCancelOrderPayment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelOrderPayment>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelOrderPayment>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getCancelOrderPaymentMutationOptions(options));
    }

export const getBulkDeleteSalesUrl = () => {




  return `/api/sales/bulk-delete`
}

/**
 * @summary Reverse multiple sale orders in one call. Each is processed via the
same consignment-aware rule as the single delete endpoint — see
`deleteSale` for the per-line behaviour.

 */
export const bulkDeleteSales = async (bulkIdRequest: BulkIdRequest, options?: RequestInit): Promise<BulkSalesDeleteResult> => {

  return customFetch<BulkSalesDeleteResult>(getBulkDeleteSalesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkIdRequest)
  }
);}





export const getBulkDeleteSalesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteSales>>, TError,{data: BodyType<BulkIdRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteSales>>, TError,{data: BodyType<BulkIdRequest>}, TContext> => {

const mutationKey = ['bulkDeleteSales'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkDeleteSales>>, {data: BodyType<BulkIdRequest>}> = (props) => {
          const {data} = props ?? {};

          return  bulkDeleteSales(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkDeleteSalesMutationResult = NonNullable<Awaited<ReturnType<typeof bulkDeleteSales>>>
    export type BulkDeleteSalesMutationBody = BodyType<BulkIdRequest>
    export type BulkDeleteSalesMutationError = ErrorType<unknown>

    /**
 * @summary Reverse multiple sale orders in one call. Each is processed via the
same consignment-aware rule as the single delete endpoint — see
`deleteSale` for the per-line behaviour.

 */
export const useBulkDeleteSales = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteSales>>, TError,{data: BodyType<BulkIdRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkDeleteSales>>,
        TError,
        {data: BodyType<BulkIdRequest>},
        TContext
      > => {
      return useMutation(getBulkDeleteSalesMutationOptions(options));
    }

export const getRecalculateSaleCostsUrl = () => {




  return `/api/sales/recalculate-costs`
}

/**
 * @summary Recompute every sale line's unit_cost from the linked inventory item's
landed_unit_cost (using the consignment snapshot helper for non-OWNED
lines). Use this to repair imports where the source CSV mis-populated
the cost column with the sale price. Already-paid consignment lines
are skipped so historical payout amounts aren't disturbed.

 */
export const recalculateSaleCosts = async ( options?: RequestInit): Promise<SalesRecalculateCostsResult> => {

  return customFetch<SalesRecalculateCostsResult>(getRecalculateSaleCostsUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRecalculateSaleCostsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recalculateSaleCosts>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recalculateSaleCosts>>, TError,void, TContext> => {

const mutationKey = ['recalculateSaleCosts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recalculateSaleCosts>>, void> = () => {


          return  recalculateSaleCosts(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecalculateSaleCostsMutationResult = NonNullable<Awaited<ReturnType<typeof recalculateSaleCosts>>>

    export type RecalculateSaleCostsMutationError = ErrorType<unknown>

    /**
 * @summary Recompute every sale line's unit_cost from the linked inventory item's
landed_unit_cost (using the consignment snapshot helper for non-OWNED
lines). Use this to repair imports where the source CSV mis-populated
the cost column with the sale price. Already-paid consignment lines
are skipped so historical payout amounts aren't disturbed.

 */
export const useRecalculateSaleCosts = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recalculateSaleCosts>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recalculateSaleCosts>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRecalculateSaleCostsMutationOptions(options));
    }

export const getCreateSaleRefundUrl = (saleId: string,) => {




  return `/api/sales/${saleId}/refunds`
}

/**
 * @summary Create a refund (with optional restock-into-new-SKU per line) against
an existing sale order. Returned units mint a new OWNED inventory row
with sku `${origSku}-R{n}` carrying cost = consignmentSupplierPayoutPerUnitGbp
(consignment lines) or unitCost (owned lines). The original inventory
row is left untouched. Optional `pushToShopify` creates a brand-new
Shopify product for the new SKU; `pushToEbay` is captured but no-op
in v1.

 */
export const createSaleRefund = async (saleId: string,
    createRefundInput: CreateRefundInput, options?: RequestInit): Promise<OrderAdjustmentDetail> => {

  return customFetch<OrderAdjustmentDetail>(getCreateSaleRefundUrl(saleId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createRefundInput)
  }
);}





export const getCreateSaleRefundMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSaleRefund>>, TError,{saleId: string;data: BodyType<CreateRefundInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSaleRefund>>, TError,{saleId: string;data: BodyType<CreateRefundInput>}, TContext> => {

const mutationKey = ['createSaleRefund'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSaleRefund>>, {saleId: string;data: BodyType<CreateRefundInput>}> = (props) => {
          const {saleId,data} = props ?? {};

          return  createSaleRefund(saleId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSaleRefundMutationResult = NonNullable<Awaited<ReturnType<typeof createSaleRefund>>>
    export type CreateSaleRefundMutationBody = BodyType<CreateRefundInput>
    export type CreateSaleRefundMutationError = ErrorType<unknown>

    /**
 * @summary Create a refund (with optional restock-into-new-SKU per line) against
an existing sale order. Returned units mint a new OWNED inventory row
with sku `${origSku}-R{n}` carrying cost = consignmentSupplierPayoutPerUnitGbp
(consignment lines) or unitCost (owned lines). The original inventory
row is left untouched. Optional `pushToShopify` creates a brand-new
Shopify product for the new SKU; `pushToEbay` is captured but no-op
in v1.

 */
export const useCreateSaleRefund = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSaleRefund>>, TError,{saleId: string;data: BodyType<CreateRefundInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSaleRefund>>,
        TError,
        {saleId: string;data: BodyType<CreateRefundInput>},
        TContext
      > => {
      return useMutation(getCreateSaleRefundMutationOptions(options));
    }

export const getListAdjustmentsUrl = (params?: ListAdjustmentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/adjustments?${stringifiedParams}` : `/api/adjustments`
}

export const listAdjustments = async (params?: ListAdjustmentsParams, options?: RequestInit): Promise<OrderAdjustmentListRow[]> => {

  return customFetch<OrderAdjustmentListRow[]>(getListAdjustmentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdjustmentsQueryKey = (params?: ListAdjustmentsParams,) => {
    return [
    `/api/adjustments`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdjustmentsQueryOptions = <TData = Awaited<ReturnType<typeof listAdjustments>>, TError = ErrorType<unknown>>(params?: ListAdjustmentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdjustments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdjustmentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdjustments>>> = ({ signal }) => listAdjustments(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdjustments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdjustmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdjustments>>>
export type ListAdjustmentsQueryError = ErrorType<unknown>



export function useListAdjustments<TData = Awaited<ReturnType<typeof listAdjustments>>, TError = ErrorType<unknown>>(
 params?: ListAdjustmentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdjustments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdjustmentsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAdjustmentUrl = (id: string,) => {




  return `/api/adjustments/${id}`
}

export const getAdjustment = async (id: string, options?: RequestInit): Promise<OrderAdjustmentDetail> => {

  return customFetch<OrderAdjustmentDetail>(getGetAdjustmentUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdjustmentQueryKey = (id: string,) => {
    return [
    `/api/adjustments/${id}`
    ] as const;
    }


export const getGetAdjustmentQueryOptions = <TData = Awaited<ReturnType<typeof getAdjustment>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdjustment>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdjustmentQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdjustment>>> = ({ signal }) => getAdjustment(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdjustment>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdjustmentQueryResult = NonNullable<Awaited<ReturnType<typeof getAdjustment>>>
export type GetAdjustmentQueryError = ErrorType<unknown>



export function useGetAdjustment<TData = Awaited<ReturnType<typeof getAdjustment>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdjustment>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdjustmentQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListChannelsUrl = () => {




  return `/api/channels`
}

export const listChannels = async ( options?: RequestInit): Promise<SalesChannel[]> => {

  return customFetch<SalesChannel[]>(getListChannelsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListChannelsQueryKey = () => {
    return [
    `/api/channels`
    ] as const;
    }


export const getListChannelsQueryOptions = <TData = Awaited<ReturnType<typeof listChannels>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listChannels>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListChannelsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listChannels>>> = ({ signal }) => listChannels({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listChannels>>, TError, TData> & { queryKey: QueryKey }
}

export type ListChannelsQueryResult = NonNullable<Awaited<ReturnType<typeof listChannels>>>
export type ListChannelsQueryError = ErrorType<unknown>



export function useListChannels<TData = Awaited<ReturnType<typeof listChannels>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listChannels>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListChannelsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateSalesChannelUrl = () => {




  return `/api/channels`
}

export const createSalesChannel = async (salesChannelCreateInput: SalesChannelCreateInput, options?: RequestInit): Promise<SalesChannel> => {

  return customFetch<SalesChannel>(getCreateSalesChannelUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(salesChannelCreateInput)
  }
);}





export const getCreateSalesChannelMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSalesChannel>>, TError,{data: BodyType<SalesChannelCreateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSalesChannel>>, TError,{data: BodyType<SalesChannelCreateInput>}, TContext> => {

const mutationKey = ['createSalesChannel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSalesChannel>>, {data: BodyType<SalesChannelCreateInput>}> = (props) => {
          const {data} = props ?? {};

          return  createSalesChannel(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSalesChannelMutationResult = NonNullable<Awaited<ReturnType<typeof createSalesChannel>>>
    export type CreateSalesChannelMutationBody = BodyType<SalesChannelCreateInput>
    export type CreateSalesChannelMutationError = ErrorType<void>

    export const useCreateSalesChannel = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSalesChannel>>, TError,{data: BodyType<SalesChannelCreateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSalesChannel>>,
        TError,
        {data: BodyType<SalesChannelCreateInput>},
        TContext
      > => {
      return useMutation(getCreateSalesChannelMutationOptions(options));
    }

export const getUpdateSalesChannelUrl = (channelId: string,) => {




  return `/api/channels/${channelId}`
}

export const updateSalesChannel = async (channelId: string,
    salesChannelUpdateInput: SalesChannelUpdateInput, options?: RequestInit): Promise<SalesChannel> => {

  return customFetch<SalesChannel>(getUpdateSalesChannelUrl(channelId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(salesChannelUpdateInput)
  }
);}





export const getUpdateSalesChannelMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSalesChannel>>, TError,{channelId: string;data: BodyType<SalesChannelUpdateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSalesChannel>>, TError,{channelId: string;data: BodyType<SalesChannelUpdateInput>}, TContext> => {

const mutationKey = ['updateSalesChannel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSalesChannel>>, {channelId: string;data: BodyType<SalesChannelUpdateInput>}> = (props) => {
          const {channelId,data} = props ?? {};

          return  updateSalesChannel(channelId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSalesChannelMutationResult = NonNullable<Awaited<ReturnType<typeof updateSalesChannel>>>
    export type UpdateSalesChannelMutationBody = BodyType<SalesChannelUpdateInput>
    export type UpdateSalesChannelMutationError = ErrorType<void>

    export const useUpdateSalesChannel = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSalesChannel>>, TError,{channelId: string;data: BodyType<SalesChannelUpdateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSalesChannel>>,
        TError,
        {channelId: string;data: BodyType<SalesChannelUpdateInput>},
        TContext
      > => {
      return useMutation(getUpdateSalesChannelMutationOptions(options));
    }

export const getListStationeryUrl = (params?: ListStationeryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/stationery?${stringifiedParams}` : `/api/stationery`
}

/**
 * @summary List internal stationery items
 */
export const listStationery = async (params?: ListStationeryParams, options?: RequestInit): Promise<StationeryItem[]> => {

  return customFetch<StationeryItem[]>(getListStationeryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListStationeryQueryKey = (params?: ListStationeryParams,) => {
    return [
    `/api/stationery`, ...(params ? [params] : [])
    ] as const;
    }


export const getListStationeryQueryOptions = <TData = Awaited<ReturnType<typeof listStationery>>, TError = ErrorType<unknown>>(params?: ListStationeryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listStationery>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStationeryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStationery>>> = ({ signal }) => listStationery(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStationery>>, TError, TData> & { queryKey: QueryKey }
}

export type ListStationeryQueryResult = NonNullable<Awaited<ReturnType<typeof listStationery>>>
export type ListStationeryQueryError = ErrorType<unknown>


/**
 * @summary List internal stationery items
 */

export function useListStationery<TData = Awaited<ReturnType<typeof listStationery>>, TError = ErrorType<unknown>>(
 params?: ListStationeryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listStationery>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListStationeryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateStationeryItemUrl = () => {




  return `/api/stationery`
}

export const createStationeryItem = async (stationeryItemInput: StationeryItemInput, options?: RequestInit): Promise<StationeryItem> => {

  return customFetch<StationeryItem>(getCreateStationeryItemUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(stationeryItemInput)
  }
);}





export const getCreateStationeryItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStationeryItem>>, TError,{data: BodyType<StationeryItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createStationeryItem>>, TError,{data: BodyType<StationeryItemInput>}, TContext> => {

const mutationKey = ['createStationeryItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createStationeryItem>>, {data: BodyType<StationeryItemInput>}> = (props) => {
          const {data} = props ?? {};

          return  createStationeryItem(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateStationeryItemMutationResult = NonNullable<Awaited<ReturnType<typeof createStationeryItem>>>
    export type CreateStationeryItemMutationBody = BodyType<StationeryItemInput>
    export type CreateStationeryItemMutationError = ErrorType<unknown>

    export const useCreateStationeryItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStationeryItem>>, TError,{data: BodyType<StationeryItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createStationeryItem>>,
        TError,
        {data: BodyType<StationeryItemInput>},
        TContext
      > => {
      return useMutation(getCreateStationeryItemMutationOptions(options));
    }

export const getUpdateStationeryItemUrl = (id: string,) => {




  return `/api/stationery/${id}`
}

export const updateStationeryItem = async (id: string,
    stationeryItemUpdate: StationeryItemUpdate, options?: RequestInit): Promise<StationeryItem> => {

  return customFetch<StationeryItem>(getUpdateStationeryItemUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(stationeryItemUpdate)
  }
);}





export const getUpdateStationeryItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStationeryItem>>, TError,{id: string;data: BodyType<StationeryItemUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateStationeryItem>>, TError,{id: string;data: BodyType<StationeryItemUpdate>}, TContext> => {

const mutationKey = ['updateStationeryItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateStationeryItem>>, {id: string;data: BodyType<StationeryItemUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateStationeryItem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateStationeryItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateStationeryItem>>>
    export type UpdateStationeryItemMutationBody = BodyType<StationeryItemUpdate>
    export type UpdateStationeryItemMutationError = ErrorType<unknown>

    export const useUpdateStationeryItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStationeryItem>>, TError,{id: string;data: BodyType<StationeryItemUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateStationeryItem>>,
        TError,
        {id: string;data: BodyType<StationeryItemUpdate>},
        TContext
      > => {
      return useMutation(getUpdateStationeryItemMutationOptions(options));
    }

export const getDeleteStationeryItemUrl = (id: string,) => {




  return `/api/stationery/${id}`
}

export const deleteStationeryItem = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteStationeryItemUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteStationeryItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStationeryItem>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteStationeryItem>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteStationeryItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStationeryItem>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteStationeryItem(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteStationeryItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteStationeryItem>>>

    export type DeleteStationeryItemMutationError = ErrorType<unknown>

    export const useDeleteStationeryItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStationeryItem>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteStationeryItem>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteStationeryItemMutationOptions(options));
    }

export const getBulkAssignFlagsUrl = () => {




  return `/api/flag-assignments/bulk`
}

export const bulkAssignFlags = async (flagBulkAssignmentInput: FlagBulkAssignmentInput, options?: RequestInit): Promise<FlagBulkAssignmentResult> => {

  return customFetch<FlagBulkAssignmentResult>(getBulkAssignFlagsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(flagBulkAssignmentInput)
  }
);}





export const getBulkAssignFlagsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkAssignFlags>>, TError,{data: BodyType<FlagBulkAssignmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkAssignFlags>>, TError,{data: BodyType<FlagBulkAssignmentInput>}, TContext> => {

const mutationKey = ['bulkAssignFlags'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkAssignFlags>>, {data: BodyType<FlagBulkAssignmentInput>}> = (props) => {
          const {data} = props ?? {};

          return  bulkAssignFlags(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkAssignFlagsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkAssignFlags>>>
    export type BulkAssignFlagsMutationBody = BodyType<FlagBulkAssignmentInput>
    export type BulkAssignFlagsMutationError = ErrorType<unknown>

    export const useBulkAssignFlags = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkAssignFlags>>, TError,{data: BodyType<FlagBulkAssignmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkAssignFlags>>,
        TError,
        {data: BodyType<FlagBulkAssignmentInput>},
        TContext
      > => {
      return useMutation(getBulkAssignFlagsMutationOptions(options));
    }

export const getAdjustStationeryQuantityUrl = (id: string,) => {




  return `/api/stationery/${id}/adjust`
}

/**
 * @summary Increment or decrement currentQuantity by a signed delta. Result is clamped to >= 0.
 */
export const adjustStationeryQuantity = async (id: string,
    stationeryAdjustInput: StationeryAdjustInput, options?: RequestInit): Promise<StationeryItem> => {

  return customFetch<StationeryItem>(getAdjustStationeryQuantityUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(stationeryAdjustInput)
  }
);}





export const getAdjustStationeryQuantityMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adjustStationeryQuantity>>, TError,{id: string;data: BodyType<StationeryAdjustInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adjustStationeryQuantity>>, TError,{id: string;data: BodyType<StationeryAdjustInput>}, TContext> => {

const mutationKey = ['adjustStationeryQuantity'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adjustStationeryQuantity>>, {id: string;data: BodyType<StationeryAdjustInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  adjustStationeryQuantity(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdjustStationeryQuantityMutationResult = NonNullable<Awaited<ReturnType<typeof adjustStationeryQuantity>>>
    export type AdjustStationeryQuantityMutationBody = BodyType<StationeryAdjustInput>
    export type AdjustStationeryQuantityMutationError = ErrorType<unknown>

    /**
 * @summary Increment or decrement currentQuantity by a signed delta. Result is clamped to >= 0.
 */
export const useAdjustStationeryQuantity = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adjustStationeryQuantity>>, TError,{id: string;data: BodyType<StationeryAdjustInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adjustStationeryQuantity>>,
        TError,
        {id: string;data: BodyType<StationeryAdjustInput>},
        TContext
      > => {
      return useMutation(getAdjustStationeryQuantityMutationOptions(options));
    }

export const getGetPackagingPresetsUrl = (inventoryItemId: string,) => {




  return `/api/packaging/presets/${inventoryItemId}`
}

/**
 * @summary List packaging-material presets configured for an inventory SKU.
 */
export const getPackagingPresets = async (inventoryItemId: string, options?: RequestInit): Promise<PackagingPreset[]> => {

  return customFetch<PackagingPreset[]>(getGetPackagingPresetsUrl(inventoryItemId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPackagingPresetsQueryKey = (inventoryItemId: string,) => {
    return [
    `/api/packaging/presets/${inventoryItemId}`
    ] as const;
    }


export const getGetPackagingPresetsQueryOptions = <TData = Awaited<ReturnType<typeof getPackagingPresets>>, TError = ErrorType<unknown>>(inventoryItemId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPackagingPresets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPackagingPresetsQueryKey(inventoryItemId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPackagingPresets>>> = ({ signal }) => getPackagingPresets(inventoryItemId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: inventoryItemId !== null && inventoryItemId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPackagingPresets>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPackagingPresetsQueryResult = NonNullable<Awaited<ReturnType<typeof getPackagingPresets>>>
export type GetPackagingPresetsQueryError = ErrorType<unknown>


/**
 * @summary List packaging-material presets configured for an inventory SKU.
 */

export function useGetPackagingPresets<TData = Awaited<ReturnType<typeof getPackagingPresets>>, TError = ErrorType<unknown>>(
 inventoryItemId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPackagingPresets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPackagingPresetsQueryOptions(inventoryItemId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSavePackagingPresetsUrl = (inventoryItemId: string,) => {




  return `/api/packaging/presets/${inventoryItemId}`
}

/**
 * @summary Replace the full set of packaging presets for an inventory SKU.
 */
export const savePackagingPresets = async (inventoryItemId: string,
    packagingPresetInput: PackagingPresetInput, options?: RequestInit): Promise<PackagingPreset[]> => {

  return customFetch<PackagingPreset[]>(getSavePackagingPresetsUrl(inventoryItemId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(packagingPresetInput)
  }
);}





export const getSavePackagingPresetsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof savePackagingPresets>>, TError,{inventoryItemId: string;data: BodyType<PackagingPresetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof savePackagingPresets>>, TError,{inventoryItemId: string;data: BodyType<PackagingPresetInput>}, TContext> => {

const mutationKey = ['savePackagingPresets'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof savePackagingPresets>>, {inventoryItemId: string;data: BodyType<PackagingPresetInput>}> = (props) => {
          const {inventoryItemId,data} = props ?? {};

          return  savePackagingPresets(inventoryItemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SavePackagingPresetsMutationResult = NonNullable<Awaited<ReturnType<typeof savePackagingPresets>>>
    export type SavePackagingPresetsMutationBody = BodyType<PackagingPresetInput>
    export type SavePackagingPresetsMutationError = ErrorType<unknown>

    /**
 * @summary Replace the full set of packaging presets for an inventory SKU.
 */
export const useSavePackagingPresets = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof savePackagingPresets>>, TError,{inventoryItemId: string;data: BodyType<PackagingPresetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof savePackagingPresets>>,
        TError,
        {inventoryItemId: string;data: BodyType<PackagingPresetInput>},
        TContext
      > => {
      return useMutation(getSavePackagingPresetsMutationOptions(options));
    }

export const getGetPackagingSuggestionUrl = (saleOrderId: string,) => {




  return `/api/packaging/suggestion/${saleOrderId}`
}

/**
 * @summary Auto-suggest packaging materials for a sale order based on its line items' presets.
 */
export const getPackagingSuggestion = async (saleOrderId: string, options?: RequestInit): Promise<PackagingMaterial[]> => {

  return customFetch<PackagingMaterial[]>(getGetPackagingSuggestionUrl(saleOrderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPackagingSuggestionQueryKey = (saleOrderId: string,) => {
    return [
    `/api/packaging/suggestion/${saleOrderId}`
    ] as const;
    }


export const getGetPackagingSuggestionQueryOptions = <TData = Awaited<ReturnType<typeof getPackagingSuggestion>>, TError = ErrorType<unknown>>(saleOrderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPackagingSuggestion>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPackagingSuggestionQueryKey(saleOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPackagingSuggestion>>> = ({ signal }) => getPackagingSuggestion(saleOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: saleOrderId !== null && saleOrderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPackagingSuggestion>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPackagingSuggestionQueryResult = NonNullable<Awaited<ReturnType<typeof getPackagingSuggestion>>>
export type GetPackagingSuggestionQueryError = ErrorType<unknown>


/**
 * @summary Auto-suggest packaging materials for a sale order based on its line items' presets.
 */

export function useGetPackagingSuggestion<TData = Awaited<ReturnType<typeof getPackagingSuggestion>>, TError = ErrorType<unknown>>(
 saleOrderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPackagingSuggestion>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPackagingSuggestionQueryOptions(saleOrderId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPackagingRecommendationUrl = (saleOrderId: string,) => {




  return `/api/packaging/recommendation/${saleOrderId}`
}

/**
 * @summary Smart packaging recommendation that ranks every box-style stationery
item by dimensional fit against the order's products. Returns the
recommended option (smallest box that fits all items and is in stock),
all candidate options sorted best-fit first, the order's combined
dimensions, and any warnings (no fit / out of stock / missing dims).

 */
export const getPackagingRecommendation = async (saleOrderId: string, options?: RequestInit): Promise<PackagingRecommendation> => {

  return customFetch<PackagingRecommendation>(getGetPackagingRecommendationUrl(saleOrderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPackagingRecommendationQueryKey = (saleOrderId: string,) => {
    return [
    `/api/packaging/recommendation/${saleOrderId}`
    ] as const;
    }


export const getGetPackagingRecommendationQueryOptions = <TData = Awaited<ReturnType<typeof getPackagingRecommendation>>, TError = ErrorType<unknown>>(saleOrderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPackagingRecommendation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPackagingRecommendationQueryKey(saleOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPackagingRecommendation>>> = ({ signal }) => getPackagingRecommendation(saleOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: saleOrderId !== null && saleOrderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPackagingRecommendation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPackagingRecommendationQueryResult = NonNullable<Awaited<ReturnType<typeof getPackagingRecommendation>>>
export type GetPackagingRecommendationQueryError = ErrorType<unknown>


/**
 * @summary Smart packaging recommendation that ranks every box-style stationery
item by dimensional fit against the order's products. Returns the
recommended option (smallest box that fits all items and is in stock),
all candidate options sorted best-fit first, the order's combined
dimensions, and any warnings (no fit / out of stock / missing dims).

 */

export function useGetPackagingRecommendation<TData = Awaited<ReturnType<typeof getPackagingRecommendation>>, TError = ErrorType<unknown>>(
 saleOrderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPackagingRecommendation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPackagingRecommendationQueryOptions(saleOrderId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getConfirmPackagingUrl = (saleOrderId: string,) => {




  return `/api/packaging/confirm/${saleOrderId}`
}

/**
 * @summary Confirm packaging materials used and atomically deduct stationery stock. Idempotent — fails with 409 if already packed.
 */
export const confirmPackaging = async (saleOrderId: string,
    confirmPackagingRequest: ConfirmPackagingRequest, options?: RequestInit): Promise<ConfirmPackagingResult> => {

  return customFetch<ConfirmPackagingResult>(getConfirmPackagingUrl(saleOrderId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(confirmPackagingRequest)
  }
);}





export const getConfirmPackagingMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmPackaging>>, TError,{saleOrderId: string;data: BodyType<ConfirmPackagingRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmPackaging>>, TError,{saleOrderId: string;data: BodyType<ConfirmPackagingRequest>}, TContext> => {

const mutationKey = ['confirmPackaging'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmPackaging>>, {saleOrderId: string;data: BodyType<ConfirmPackagingRequest>}> = (props) => {
          const {saleOrderId,data} = props ?? {};

          return  confirmPackaging(saleOrderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmPackagingMutationResult = NonNullable<Awaited<ReturnType<typeof confirmPackaging>>>
    export type ConfirmPackagingMutationBody = BodyType<ConfirmPackagingRequest>
    export type ConfirmPackagingMutationError = ErrorType<void>

    /**
 * @summary Confirm packaging materials used and atomically deduct stationery stock. Idempotent — fails with 409 if already packed.
 */
export const useConfirmPackaging = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmPackaging>>, TError,{saleOrderId: string;data: BodyType<ConfirmPackagingRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof confirmPackaging>>,
        TError,
        {saleOrderId: string;data: BodyType<ConfirmPackagingRequest>},
        TContext
      > => {
      return useMutation(getConfirmPackagingMutationOptions(options));
    }

export const getGetPackagingUsageUrl = (saleOrderId: string,) => {




  return `/api/packaging/usage/${saleOrderId}`
}

/**
 * @summary List packaging materials recorded for a sale order.
 */
export const getPackagingUsage = async (saleOrderId: string, options?: RequestInit): Promise<PackagingUsageEntry[]> => {

  return customFetch<PackagingUsageEntry[]>(getGetPackagingUsageUrl(saleOrderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPackagingUsageQueryKey = (saleOrderId: string,) => {
    return [
    `/api/packaging/usage/${saleOrderId}`
    ] as const;
    }


export const getGetPackagingUsageQueryOptions = <TData = Awaited<ReturnType<typeof getPackagingUsage>>, TError = ErrorType<unknown>>(saleOrderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPackagingUsage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPackagingUsageQueryKey(saleOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPackagingUsage>>> = ({ signal }) => getPackagingUsage(saleOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: saleOrderId !== null && saleOrderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPackagingUsage>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPackagingUsageQueryResult = NonNullable<Awaited<ReturnType<typeof getPackagingUsage>>>
export type GetPackagingUsageQueryError = ErrorType<unknown>


/**
 * @summary List packaging materials recorded for a sale order.
 */

export function useGetPackagingUsage<TData = Awaited<ReturnType<typeof getPackagingUsage>>, TError = ErrorType<unknown>>(
 saleOrderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPackagingUsage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPackagingUsageQueryOptions(saleOrderId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPackagingMaterialsUrl = () => {




  return `/api/packaging/materials`
}

/**
 * @summary Lightweight stationery list for packing-only users (does not require purchase-order permissions).
 */
export const listPackagingMaterials = async ( options?: RequestInit): Promise<PackagingMaterialOption[]> => {

  return customFetch<PackagingMaterialOption[]>(getListPackagingMaterialsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPackagingMaterialsQueryKey = () => {
    return [
    `/api/packaging/materials`
    ] as const;
    }


export const getListPackagingMaterialsQueryOptions = <TData = Awaited<ReturnType<typeof listPackagingMaterials>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPackagingMaterials>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPackagingMaterialsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPackagingMaterials>>> = ({ signal }) => listPackagingMaterials({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPackagingMaterials>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPackagingMaterialsQueryResult = NonNullable<Awaited<ReturnType<typeof listPackagingMaterials>>>
export type ListPackagingMaterialsQueryError = ErrorType<unknown>


/**
 * @summary Lightweight stationery list for packing-only users (does not require purchase-order permissions).
 */

export function useListPackagingMaterials<TData = Awaited<ReturnType<typeof listPackagingMaterials>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPackagingMaterials>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPackagingMaterialsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPackagingForecastUrl = () => {




  return `/api/packaging/forecast`
}

/**
 * @summary Per-stationery-item 30-day usage rate, days remaining, and suggested reorder.
 */
export const getPackagingForecast = async ( options?: RequestInit): Promise<PackagingForecastItem[]> => {

  return customFetch<PackagingForecastItem[]>(getGetPackagingForecastUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPackagingForecastQueryKey = () => {
    return [
    `/api/packaging/forecast`
    ] as const;
    }


export const getGetPackagingForecastQueryOptions = <TData = Awaited<ReturnType<typeof getPackagingForecast>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPackagingForecast>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPackagingForecastQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPackagingForecast>>> = ({ signal }) => getPackagingForecast({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPackagingForecast>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPackagingForecastQueryResult = NonNullable<Awaited<ReturnType<typeof getPackagingForecast>>>
export type GetPackagingForecastQueryError = ErrorType<unknown>


/**
 * @summary Per-stationery-item 30-day usage rate, days remaining, and suggested reorder.
 */

export function useGetPackagingForecast<TData = Awaited<ReturnType<typeof getPackagingForecast>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPackagingForecast>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPackagingForecastQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCustomerInsightsUrl = (params?: GetCustomerInsightsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/customer-insights?${stringifiedParams}` : `/api/dashboard/customer-insights`
}

/**
 * @summary Top spending customers, at-risk customers, and source breakdown for the dashboard.
 */
export const getCustomerInsights = async (params?: GetCustomerInsightsParams, options?: RequestInit): Promise<CustomerInsights> => {

  return customFetch<CustomerInsights>(getGetCustomerInsightsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomerInsightsQueryKey = (params?: GetCustomerInsightsParams,) => {
    return [
    `/api/dashboard/customer-insights`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerInsightsQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerInsights>>, TError = ErrorType<unknown>>(params?: GetCustomerInsightsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerInsights>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerInsightsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerInsights>>> = ({ signal }) => getCustomerInsights(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerInsights>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerInsightsQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerInsights>>>
export type GetCustomerInsightsQueryError = ErrorType<unknown>


/**
 * @summary Top spending customers, at-risk customers, and source breakdown for the dashboard.
 */

export function useGetCustomerInsights<TData = Awaited<ReturnType<typeof getCustomerInsights>>, TError = ErrorType<unknown>>(
 params?: GetCustomerInsightsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerInsights>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCustomerInsightsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPackagingSummaryUrl = () => {




  return `/api/dashboard/packaging-summary`
}

/**
 * @summary Dashboard packaging-health card data — counts and top-urgency items.
 */
export const getPackagingSummary = async ( options?: RequestInit): Promise<PackagingSummary> => {

  return customFetch<PackagingSummary>(getGetPackagingSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPackagingSummaryQueryKey = () => {
    return [
    `/api/dashboard/packaging-summary`
    ] as const;
    }


export const getGetPackagingSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getPackagingSummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPackagingSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPackagingSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPackagingSummary>>> = ({ signal }) => getPackagingSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPackagingSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPackagingSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getPackagingSummary>>>
export type GetPackagingSummaryQueryError = ErrorType<unknown>


/**
 * @summary Dashboard packaging-health card data — counts and top-urgency items.
 */

export function useGetPackagingSummary<TData = Awaited<ReturnType<typeof getPackagingSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPackagingSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPackagingSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListExpensesUrl = (params?: ListExpensesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/expenses?${stringifiedParams}` : `/api/expenses`
}

export const listExpenses = async (params?: ListExpensesParams, options?: RequestInit): Promise<Expense[]> => {

  return customFetch<Expense[]>(getListExpensesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListExpensesQueryKey = (params?: ListExpensesParams,) => {
    return [
    `/api/expenses`, ...(params ? [params] : [])
    ] as const;
    }


export const getListExpensesQueryOptions = <TData = Awaited<ReturnType<typeof listExpenses>>, TError = ErrorType<unknown>>(params?: ListExpensesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listExpenses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExpensesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExpenses>>> = ({ signal }) => listExpenses(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listExpenses>>, TError, TData> & { queryKey: QueryKey }
}

export type ListExpensesQueryResult = NonNullable<Awaited<ReturnType<typeof listExpenses>>>
export type ListExpensesQueryError = ErrorType<unknown>



export function useListExpenses<TData = Awaited<ReturnType<typeof listExpenses>>, TError = ErrorType<unknown>>(
 params?: ListExpensesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listExpenses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListExpensesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateExpenseUrl = () => {




  return `/api/expenses`
}

export const createExpense = async (expenseInput: ExpenseInput, options?: RequestInit): Promise<Expense> => {

  return customFetch<Expense>(getCreateExpenseUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(expenseInput)
  }
);}





export const getCreateExpenseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExpense>>, TError,{data: BodyType<ExpenseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createExpense>>, TError,{data: BodyType<ExpenseInput>}, TContext> => {

const mutationKey = ['createExpense'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createExpense>>, {data: BodyType<ExpenseInput>}> = (props) => {
          const {data} = props ?? {};

          return  createExpense(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateExpenseMutationResult = NonNullable<Awaited<ReturnType<typeof createExpense>>>
    export type CreateExpenseMutationBody = BodyType<ExpenseInput>
    export type CreateExpenseMutationError = ErrorType<unknown>

    export const useCreateExpense = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExpense>>, TError,{data: BodyType<ExpenseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createExpense>>,
        TError,
        {data: BodyType<ExpenseInput>},
        TContext
      > => {
      return useMutation(getCreateExpenseMutationOptions(options));
    }

export const getDeleteExpenseUrl = (id: string,) => {




  return `/api/expenses/${id}`
}

export const deleteExpense = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteExpenseUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteExpenseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteExpense>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteExpense>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteExpense'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteExpense>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteExpense(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteExpenseMutationResult = NonNullable<Awaited<ReturnType<typeof deleteExpense>>>

    export type DeleteExpenseMutationError = ErrorType<unknown>

    export const useDeleteExpense = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteExpense>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteExpense>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteExpenseMutationOptions(options));
    }

export const getGetInventoryReportUrl = () => {




  return `/api/reports/inventory`
}

export const getInventoryReport = async ( options?: RequestInit): Promise<InventoryReport> => {

  return customFetch<InventoryReport>(getGetInventoryReportUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventoryReportQueryKey = () => {
    return [
    `/api/reports/inventory`
    ] as const;
    }


export const getGetInventoryReportQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryReport>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryReportQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryReport>>> = ({ signal }) => getInventoryReport({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInventoryReportQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryReport>>>
export type GetInventoryReportQueryError = ErrorType<unknown>



export function useGetInventoryReport<TData = Awaited<ReturnType<typeof getInventoryReport>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInventoryReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInventoryReportQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCustomerPurchasingInsightsUrl = (params?: GetCustomerPurchasingInsightsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/customer-insights?${stringifiedParams}` : `/api/reports/customer-insights`
}

/**
 * @summary Paginated customer purchasing preferences and timing evidence.
 */
export const getCustomerPurchasingInsights = async (params?: GetCustomerPurchasingInsightsParams, options?: RequestInit): Promise<CustomerPurchasingInsightsResponse> => {

  return customFetch<CustomerPurchasingInsightsResponse>(getGetCustomerPurchasingInsightsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomerPurchasingInsightsQueryKey = (params?: GetCustomerPurchasingInsightsParams,) => {
    return [
    `/api/reports/customer-insights`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerPurchasingInsightsQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerPurchasingInsights>>, TError = ErrorType<void>>(params?: GetCustomerPurchasingInsightsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerPurchasingInsights>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerPurchasingInsightsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerPurchasingInsights>>> = ({ signal }) => getCustomerPurchasingInsights(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerPurchasingInsights>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerPurchasingInsightsQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerPurchasingInsights>>>
export type GetCustomerPurchasingInsightsQueryError = ErrorType<void>


/**
 * @summary Paginated customer purchasing preferences and timing evidence.
 */

export function useGetCustomerPurchasingInsights<TData = Awaited<ReturnType<typeof getCustomerPurchasingInsights>>, TError = ErrorType<void>>(
 params?: GetCustomerPurchasingInsightsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerPurchasingInsights>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCustomerPurchasingInsightsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportCustomerPurchasingInsightsUrl = (params?: ExportCustomerPurchasingInsightsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/customer-insights/export?${stringifiedParams}` : `/api/reports/customer-insights/export`
}

/**
 * @summary Export the current customer purchasing insights filters as CSV.
 */
export const exportCustomerPurchasingInsights = async (params?: ExportCustomerPurchasingInsightsParams, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getExportCustomerPurchasingInsightsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportCustomerPurchasingInsightsQueryKey = (params?: ExportCustomerPurchasingInsightsParams,) => {
    return [
    `/api/reports/customer-insights/export`, ...(params ? [params] : [])
    ] as const;
    }


export const getExportCustomerPurchasingInsightsQueryOptions = <TData = Awaited<ReturnType<typeof exportCustomerPurchasingInsights>>, TError = ErrorType<void>>(params?: ExportCustomerPurchasingInsightsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportCustomerPurchasingInsights>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportCustomerPurchasingInsightsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportCustomerPurchasingInsights>>> = ({ signal }) => exportCustomerPurchasingInsights(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportCustomerPurchasingInsights>>, TError, TData> & { queryKey: QueryKey }
}

export type ExportCustomerPurchasingInsightsQueryResult = NonNullable<Awaited<ReturnType<typeof exportCustomerPurchasingInsights>>>
export type ExportCustomerPurchasingInsightsQueryError = ErrorType<void>


/**
 * @summary Export the current customer purchasing insights filters as CSV.
 */

export function useExportCustomerPurchasingInsights<TData = Awaited<ReturnType<typeof exportCustomerPurchasingInsights>>, TError = ErrorType<void>>(
 params?: ExportCustomerPurchasingInsightsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportCustomerPurchasingInsights>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getExportCustomerPurchasingInsightsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSalesReportUrl = (params?: GetSalesReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/sales?${stringifiedParams}` : `/api/reports/sales`
}

export const getSalesReport = async (params?: GetSalesReportParams, options?: RequestInit): Promise<SalesReport> => {

  return customFetch<SalesReport>(getGetSalesReportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSalesReportQueryKey = (params?: GetSalesReportParams,) => {
    return [
    `/api/reports/sales`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSalesReportQueryOptions = <TData = Awaited<ReturnType<typeof getSalesReport>>, TError = ErrorType<unknown>>(params?: GetSalesReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSalesReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSalesReportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSalesReport>>> = ({ signal }) => getSalesReport(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSalesReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSalesReportQueryResult = NonNullable<Awaited<ReturnType<typeof getSalesReport>>>
export type GetSalesReportQueryError = ErrorType<unknown>



export function useGetSalesReport<TData = Awaited<ReturnType<typeof getSalesReport>>, TError = ErrorType<unknown>>(
 params?: GetSalesReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSalesReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSalesReportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetProfitLossReportUrl = (params?: GetProfitLossReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/profit-loss?${stringifiedParams}` : `/api/reports/profit-loss`
}

/**
 * @summary Profit & Loss aggregated by day, ISO week, or calendar month. Per-line
profit uses the authoritative `effectiveUnitCost` rule:
`salePrice - COALESCE(consignment_supplier_payout_per_unit_gbp, unit_cost)`,
which gives the correct figure for owned, consignment-fixed, and
consignment-split lines without any branching.

 */
export const getProfitLossReport = async (params?: GetProfitLossReportParams, options?: RequestInit): Promise<ProfitLossReport> => {

  return customFetch<ProfitLossReport>(getGetProfitLossReportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProfitLossReportQueryKey = (params?: GetProfitLossReportParams,) => {
    return [
    `/api/reports/profit-loss`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetProfitLossReportQueryOptions = <TData = Awaited<ReturnType<typeof getProfitLossReport>>, TError = ErrorType<unknown>>(params?: GetProfitLossReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProfitLossReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfitLossReportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfitLossReport>>> = ({ signal }) => getProfitLossReport(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfitLossReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProfitLossReportQueryResult = NonNullable<Awaited<ReturnType<typeof getProfitLossReport>>>
export type GetProfitLossReportQueryError = ErrorType<unknown>


/**
 * @summary Profit & Loss aggregated by day, ISO week, or calendar month. Per-line
profit uses the authoritative `effectiveUnitCost` rule:
`salePrice - COALESCE(consignment_supplier_payout_per_unit_gbp, unit_cost)`,
which gives the correct figure for owned, consignment-fixed, and
consignment-split lines without any branching.

 */

export function useGetProfitLossReport<TData = Awaited<ReturnType<typeof getProfitLossReport>>, TError = ErrorType<unknown>>(
 params?: GetProfitLossReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProfitLossReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProfitLossReportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMobileProfitLossUrl = (params?: GetMobileProfitLossParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/profit-loss/mobile?${stringifiedParams}` : `/api/reports/profit-loss/mobile`
}

/**
 * @summary Bounded permission-safe mobile Profit & Loss summary
 */
export const getMobileProfitLoss = async (params?: GetMobileProfitLossParams, options?: RequestInit): Promise<MobileProfitLossSummary> => {

  return customFetch<MobileProfitLossSummary>(getGetMobileProfitLossUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMobileProfitLossQueryKey = (params?: GetMobileProfitLossParams,) => {
    return [
    `/api/reports/profit-loss/mobile`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMobileProfitLossQueryOptions = <TData = Awaited<ReturnType<typeof getMobileProfitLoss>>, TError = ErrorType<void>>(params?: GetMobileProfitLossParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMobileProfitLoss>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMobileProfitLossQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMobileProfitLoss>>> = ({ signal }) => getMobileProfitLoss(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMobileProfitLoss>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMobileProfitLossQueryResult = NonNullable<Awaited<ReturnType<typeof getMobileProfitLoss>>>
export type GetMobileProfitLossQueryError = ErrorType<void>


/**
 * @summary Bounded permission-safe mobile Profit & Loss summary
 */

export function useGetMobileProfitLoss<TData = Awaited<ReturnType<typeof getMobileProfitLoss>>, TError = ErrorType<void>>(
 params?: GetMobileProfitLossParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMobileProfitLoss>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMobileProfitLossQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMobileProfitLossSummaryUrl = (params?: GetMobileProfitLossSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/profit-loss/mobile/summary?${stringifiedParams}` : `/api/reports/profit-loss/mobile/summary`
}

/**
 * @summary Mobile Profit & Loss summary (explicit summary alias)
 */
export const getMobileProfitLossSummary = async (params?: GetMobileProfitLossSummaryParams, options?: RequestInit): Promise<MobileProfitLossSummary> => {

  return customFetch<MobileProfitLossSummary>(getGetMobileProfitLossSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMobileProfitLossSummaryQueryKey = (params?: GetMobileProfitLossSummaryParams,) => {
    return [
    `/api/reports/profit-loss/mobile/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMobileProfitLossSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getMobileProfitLossSummary>>, TError = ErrorType<void>>(params?: GetMobileProfitLossSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMobileProfitLossSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMobileProfitLossSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMobileProfitLossSummary>>> = ({ signal }) => getMobileProfitLossSummary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMobileProfitLossSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMobileProfitLossSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getMobileProfitLossSummary>>>
export type GetMobileProfitLossSummaryQueryError = ErrorType<void>


/**
 * @summary Mobile Profit & Loss summary (explicit summary alias)
 */

export function useGetMobileProfitLossSummary<TData = Awaited<ReturnType<typeof getMobileProfitLossSummary>>, TError = ErrorType<void>>(
 params?: GetMobileProfitLossSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMobileProfitLossSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMobileProfitLossSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMobileProfitLossTrendUrl = (params?: GetMobileProfitLossTrendParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/profit-loss/mobile/trend?${stringifiedParams}` : `/api/reports/profit-loss/mobile/trend`
}

/**
 * @summary Bounded mobile Profit & Loss trend series
 */
export const getMobileProfitLossTrend = async (params?: GetMobileProfitLossTrendParams, options?: RequestInit): Promise<MobileProfitLossTrend> => {

  return customFetch<MobileProfitLossTrend>(getGetMobileProfitLossTrendUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMobileProfitLossTrendQueryKey = (params?: GetMobileProfitLossTrendParams,) => {
    return [
    `/api/reports/profit-loss/mobile/trend`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMobileProfitLossTrendQueryOptions = <TData = Awaited<ReturnType<typeof getMobileProfitLossTrend>>, TError = ErrorType<unknown>>(params?: GetMobileProfitLossTrendParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMobileProfitLossTrend>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMobileProfitLossTrendQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMobileProfitLossTrend>>> = ({ signal }) => getMobileProfitLossTrend(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMobileProfitLossTrend>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMobileProfitLossTrendQueryResult = NonNullable<Awaited<ReturnType<typeof getMobileProfitLossTrend>>>
export type GetMobileProfitLossTrendQueryError = ErrorType<unknown>


/**
 * @summary Bounded mobile Profit & Loss trend series
 */

export function useGetMobileProfitLossTrend<TData = Awaited<ReturnType<typeof getMobileProfitLossTrend>>, TError = ErrorType<unknown>>(
 params?: GetMobileProfitLossTrendParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMobileProfitLossTrend>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMobileProfitLossTrendQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMobileProfitLossChartUrl = (params?: GetMobileProfitLossChartParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/profit-loss/mobile/chart?${stringifiedParams}` : `/api/reports/profit-loss/mobile/chart`
}

/**
 * @summary Bounded mobile Profit & Loss chart series
 */
export const getMobileProfitLossChart = async (params?: GetMobileProfitLossChartParams, options?: RequestInit): Promise<MobileProfitLossTrend> => {

  return customFetch<MobileProfitLossTrend>(getGetMobileProfitLossChartUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMobileProfitLossChartQueryKey = (params?: GetMobileProfitLossChartParams,) => {
    return [
    `/api/reports/profit-loss/mobile/chart`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMobileProfitLossChartQueryOptions = <TData = Awaited<ReturnType<typeof getMobileProfitLossChart>>, TError = ErrorType<unknown>>(params?: GetMobileProfitLossChartParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMobileProfitLossChart>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMobileProfitLossChartQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMobileProfitLossChart>>> = ({ signal }) => getMobileProfitLossChart(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMobileProfitLossChart>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMobileProfitLossChartQueryResult = NonNullable<Awaited<ReturnType<typeof getMobileProfitLossChart>>>
export type GetMobileProfitLossChartQueryError = ErrorType<unknown>


/**
 * @summary Bounded mobile Profit & Loss chart series
 */

export function useGetMobileProfitLossChart<TData = Awaited<ReturnType<typeof getMobileProfitLossChart>>, TError = ErrorType<unknown>>(
 params?: GetMobileProfitLossChartParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMobileProfitLossChart>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMobileProfitLossChartQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMobileProfitLossChannelsUrl = (params?: GetMobileProfitLossChannelsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/profit-loss/mobile/channels?${stringifiedParams}` : `/api/reports/profit-loss/mobile/channels`
}

/**
 * @summary Bounded prepared channel P&L ranking
 */
export const getMobileProfitLossChannels = async (params?: GetMobileProfitLossChannelsParams, options?: RequestInit): Promise<MobileProfitLossChannels> => {

  return customFetch<MobileProfitLossChannels>(getGetMobileProfitLossChannelsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMobileProfitLossChannelsQueryKey = (params?: GetMobileProfitLossChannelsParams,) => {
    return [
    `/api/reports/profit-loss/mobile/channels`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMobileProfitLossChannelsQueryOptions = <TData = Awaited<ReturnType<typeof getMobileProfitLossChannels>>, TError = ErrorType<unknown>>(params?: GetMobileProfitLossChannelsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMobileProfitLossChannels>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMobileProfitLossChannelsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMobileProfitLossChannels>>> = ({ signal }) => getMobileProfitLossChannels(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMobileProfitLossChannels>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMobileProfitLossChannelsQueryResult = NonNullable<Awaited<ReturnType<typeof getMobileProfitLossChannels>>>
export type GetMobileProfitLossChannelsQueryError = ErrorType<unknown>


/**
 * @summary Bounded prepared channel P&L ranking
 */

export function useGetMobileProfitLossChannels<TData = Awaited<ReturnType<typeof getMobileProfitLossChannels>>, TError = ErrorType<unknown>>(
 params?: GetMobileProfitLossChannelsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMobileProfitLossChannels>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMobileProfitLossChannelsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMobileProfitLossProductsUrl = (params?: GetMobileProfitLossProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/profit-loss/mobile/products?${stringifiedParams}` : `/api/reports/profit-loss/mobile/products`
}

/**
 * @summary Bounded prepared product Profit & Loss ranking
 */
export const getMobileProfitLossProducts = async (params?: GetMobileProfitLossProductsParams, options?: RequestInit): Promise<MobileProfitLossProducts> => {

  return customFetch<MobileProfitLossProducts>(getGetMobileProfitLossProductsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMobileProfitLossProductsQueryKey = (params?: GetMobileProfitLossProductsParams,) => {
    return [
    `/api/reports/profit-loss/mobile/products`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMobileProfitLossProductsQueryOptions = <TData = Awaited<ReturnType<typeof getMobileProfitLossProducts>>, TError = ErrorType<unknown>>(params?: GetMobileProfitLossProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMobileProfitLossProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMobileProfitLossProductsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMobileProfitLossProducts>>> = ({ signal }) => getMobileProfitLossProducts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMobileProfitLossProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMobileProfitLossProductsQueryResult = NonNullable<Awaited<ReturnType<typeof getMobileProfitLossProducts>>>
export type GetMobileProfitLossProductsQueryError = ErrorType<unknown>


/**
 * @summary Bounded prepared product Profit & Loss ranking
 */

export function useGetMobileProfitLossProducts<TData = Awaited<ReturnType<typeof getMobileProfitLossProducts>>, TError = ErrorType<unknown>>(
 params?: GetMobileProfitLossProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMobileProfitLossProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMobileProfitLossProductsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMobileProfitLossCashUrl = (params?: GetMobileProfitLossCashParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/profit-loss/mobile/cash?${stringifiedParams}` : `/api/reports/profit-loss/mobile/cash`
}

/**
 * @summary Prepared mobile cash capability status for the selected P&L period
 */
export const getMobileProfitLossCash = async (params?: GetMobileProfitLossCashParams, options?: RequestInit): Promise<MobileProfitLossCash> => {

  return customFetch<MobileProfitLossCash>(getGetMobileProfitLossCashUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMobileProfitLossCashQueryKey = (params?: GetMobileProfitLossCashParams,) => {
    return [
    `/api/reports/profit-loss/mobile/cash`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMobileProfitLossCashQueryOptions = <TData = Awaited<ReturnType<typeof getMobileProfitLossCash>>, TError = ErrorType<unknown>>(params?: GetMobileProfitLossCashParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMobileProfitLossCash>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMobileProfitLossCashQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMobileProfitLossCash>>> = ({ signal }) => getMobileProfitLossCash(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMobileProfitLossCash>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMobileProfitLossCashQueryResult = NonNullable<Awaited<ReturnType<typeof getMobileProfitLossCash>>>
export type GetMobileProfitLossCashQueryError = ErrorType<unknown>


/**
 * @summary Prepared mobile cash capability status for the selected P&L period
 */

export function useGetMobileProfitLossCash<TData = Awaited<ReturnType<typeof getMobileProfitLossCash>>, TError = ErrorType<unknown>>(
 params?: GetMobileProfitLossCashParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMobileProfitLossCash>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMobileProfitLossCashQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMobileProfitLossExceptionsUrl = (params?: GetMobileProfitLossExceptionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/profit-loss/mobile/exceptions?${stringifiedParams}` : `/api/reports/profit-loss/mobile/exceptions`
}

/**
 * @summary Bounded prepared P&L data-quality exceptions
 */
export const getMobileProfitLossExceptions = async (params?: GetMobileProfitLossExceptionsParams, options?: RequestInit): Promise<MobileProfitLossExceptions> => {

  return customFetch<MobileProfitLossExceptions>(getGetMobileProfitLossExceptionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMobileProfitLossExceptionsQueryKey = (params?: GetMobileProfitLossExceptionsParams,) => {
    return [
    `/api/reports/profit-loss/mobile/exceptions`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMobileProfitLossExceptionsQueryOptions = <TData = Awaited<ReturnType<typeof getMobileProfitLossExceptions>>, TError = ErrorType<unknown>>(params?: GetMobileProfitLossExceptionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMobileProfitLossExceptions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMobileProfitLossExceptionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMobileProfitLossExceptions>>> = ({ signal }) => getMobileProfitLossExceptions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMobileProfitLossExceptions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMobileProfitLossExceptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getMobileProfitLossExceptions>>>
export type GetMobileProfitLossExceptionsQueryError = ErrorType<unknown>


/**
 * @summary Bounded prepared P&L data-quality exceptions
 */

export function useGetMobileProfitLossExceptions<TData = Awaited<ReturnType<typeof getMobileProfitLossExceptions>>, TError = ErrorType<unknown>>(
 params?: GetMobileProfitLossExceptionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMobileProfitLossExceptions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMobileProfitLossExceptionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSpendVsProfitReportUrl = (params?: GetSpendVsProfitReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/spend-vs-profit?${stringifiedParams}` : `/api/reports/spend-vs-profit`
}

/**
 * @summary Spend vs Profit aggregated by day, ISO week, or calendar month. Spend
is the sum of (a) paid purchase orders (gbp_paid + all gbp_* landed
costs, bucketed by paid_at), (b) confirmed consignment payouts
(Paid/Partial, bucketed by paid_at) and (c) GBP expenses (bucketed by
date). When `includeLiabilities=true`, also adds unpaid POs (bucketed
by purchase_date, excluding Draft/Cancelled) and consignment owed
lines (bucketed by sale_date, where the customer has paid). Profit
uses the same line-level effectiveUnitCost rule as /reports/profit-loss.

 */
export const getSpendVsProfitReport = async (params?: GetSpendVsProfitReportParams, options?: RequestInit): Promise<SpendVsProfitReport> => {

  return customFetch<SpendVsProfitReport>(getGetSpendVsProfitReportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSpendVsProfitReportQueryKey = (params?: GetSpendVsProfitReportParams,) => {
    return [
    `/api/reports/spend-vs-profit`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSpendVsProfitReportQueryOptions = <TData = Awaited<ReturnType<typeof getSpendVsProfitReport>>, TError = ErrorType<unknown>>(params?: GetSpendVsProfitReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSpendVsProfitReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSpendVsProfitReportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSpendVsProfitReport>>> = ({ signal }) => getSpendVsProfitReport(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSpendVsProfitReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSpendVsProfitReportQueryResult = NonNullable<Awaited<ReturnType<typeof getSpendVsProfitReport>>>
export type GetSpendVsProfitReportQueryError = ErrorType<unknown>


/**
 * @summary Spend vs Profit aggregated by day, ISO week, or calendar month. Spend
is the sum of (a) paid purchase orders (gbp_paid + all gbp_* landed
costs, bucketed by paid_at), (b) confirmed consignment payouts
(Paid/Partial, bucketed by paid_at) and (c) GBP expenses (bucketed by
date). When `includeLiabilities=true`, also adds unpaid POs (bucketed
by purchase_date, excluding Draft/Cancelled) and consignment owed
lines (bucketed by sale_date, where the customer has paid). Profit
uses the same line-level effectiveUnitCost rule as /reports/profit-loss.

 */

export function useGetSpendVsProfitReport<TData = Awaited<ReturnType<typeof getSpendVsProfitReport>>, TError = ErrorType<unknown>>(
 params?: GetSpendVsProfitReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSpendVsProfitReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSpendVsProfitReportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSpendVsProfitCardsUrl = (params?: GetSpendVsProfitCardsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/spend-vs-profit/cards?${stringifiedParams}` : `/api/reports/spend-vs-profit/cards`
}

/**
 * Returns only the current-week and current-month card aggregates. The
 * windows use Europe/London calendar boundaries and are independent of
 * the chart date range. Stock type and supplier filters follow the full
 * spend-vs-profit report; channel does not scope these cards.
 * @summary Current-week and current-month Spend & Cash card values
 */
export const getSpendVsProfitCards = async (params?: GetSpendVsProfitCardsParams, options?: RequestInit): Promise<SpendVsProfitCards> => {

  return customFetch<SpendVsProfitCards>(getGetSpendVsProfitCardsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSpendVsProfitCardsQueryKey = (params?: GetSpendVsProfitCardsParams,) => {
    return [
    `/api/reports/spend-vs-profit/cards`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSpendVsProfitCardsQueryOptions = <TData = Awaited<ReturnType<typeof getSpendVsProfitCards>>, TError = ErrorType<unknown>>(params?: GetSpendVsProfitCardsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSpendVsProfitCards>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSpendVsProfitCardsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSpendVsProfitCards>>> = ({ signal }) => getSpendVsProfitCards(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSpendVsProfitCards>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSpendVsProfitCardsQueryResult = NonNullable<Awaited<ReturnType<typeof getSpendVsProfitCards>>>
export type GetSpendVsProfitCardsQueryError = ErrorType<unknown>


/**
 * @summary Current-week and current-month Spend & Cash card values
 */

export function useGetSpendVsProfitCards<TData = Awaited<ReturnType<typeof getSpendVsProfitCards>>, TError = ErrorType<unknown>>(
 params?: GetSpendVsProfitCardsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSpendVsProfitCards>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSpendVsProfitCardsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRequestUploadUrlUrl = () => {




  return `/api/storage/uploads/request-url`
}

/**
 * @summary Request a presigned URL for file upload
 */
export const requestUploadUrl = async (uploadUrlRequest: UploadUrlRequest, options?: RequestInit): Promise<UploadUrlResponse> => {

  return customFetch<UploadUrlResponse>(getRequestUploadUrlUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(uploadUrlRequest)
  }
);}





export const getRequestUploadUrlMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext> => {

const mutationKey = ['requestUploadUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestUploadUrl>>, {data: BodyType<UploadUrlRequest>}> = (props) => {
          const {data} = props ?? {};

          return  requestUploadUrl(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof requestUploadUrl>>>
    export type RequestUploadUrlMutationBody = BodyType<UploadUrlRequest>
    export type RequestUploadUrlMutationError = ErrorType<unknown>

    /**
 * @summary Request a presigned URL for file upload
 */
export const useRequestUploadUrl = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestUploadUrl>>,
        TError,
        {data: BodyType<UploadUrlRequest>},
        TContext
      > => {
      return useMutation(getRequestUploadUrlMutationOptions(options));
    }

export const getRequestPrivateAttachmentUploadUrlUrl = () => {




  return `/api/storage/uploads/request-private-attachment-url`
}

/**
 * Dedicated mint endpoint for sale_attachments uploads (packing photos,
 * print-pack capture, loss-evidence). Mints to the same private path
 * as `/storage/uploads/request-url` and is served via the auth-gated
 * `/api/storage/objects/<path>` route, but is documented and used
 * ONLY by the sale_attachments flows so that the original
 * `/storage/uploads/request-url` endpoint can reject image/video
 * content types and the legacy private path can finally retire.
 * @summary Request a presigned URL for a PRIVATE attachment upload (sale_attachments)
 */
export const requestPrivateAttachmentUploadUrl = async (uploadUrlRequest: UploadUrlRequest, options?: RequestInit): Promise<UploadUrlResponse> => {

  return customFetch<UploadUrlResponse>(getRequestPrivateAttachmentUploadUrlUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(uploadUrlRequest)
  }
);}





export const getRequestPrivateAttachmentUploadUrlMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPrivateAttachmentUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestPrivateAttachmentUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext> => {

const mutationKey = ['requestPrivateAttachmentUploadUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestPrivateAttachmentUploadUrl>>, {data: BodyType<UploadUrlRequest>}> = (props) => {
          const {data} = props ?? {};

          return  requestPrivateAttachmentUploadUrl(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestPrivateAttachmentUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof requestPrivateAttachmentUploadUrl>>>
    export type RequestPrivateAttachmentUploadUrlMutationBody = BodyType<UploadUrlRequest>
    export type RequestPrivateAttachmentUploadUrlMutationError = ErrorType<unknown>

    /**
 * @summary Request a presigned URL for a PRIVATE attachment upload (sale_attachments)
 */
export const useRequestPrivateAttachmentUploadUrl = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPrivateAttachmentUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestPrivateAttachmentUploadUrl>>,
        TError,
        {data: BodyType<UploadUrlRequest>},
        TContext
      > => {
      return useMutation(getRequestPrivateAttachmentUploadUrlMutationOptions(options));
    }

export const getRequestPublicUploadUrlUrl = () => {




  return `/api/storage/uploads/request-public-url`
}

/**
 * Like `/storage/uploads/request-url`, but the resulting object lands at
 * a tenant-scoped public path (`<bucket>/public/<tenantId>/<uuid>`) and
 * is fetchable WITHOUT auth via `GET /storage/public/{tenantId}/{filename}`.
 * Use for assets that need to be visible to external systems (Shopify,
 * eBay, social media). The presigned URL itself still requires the
 * caller to be an authenticated tenant member to mint.
 * @summary Request a presigned URL for a TENANT-PUBLIC file upload
 */
export const requestPublicUploadUrl = async (uploadUrlRequest: UploadUrlRequest, options?: RequestInit): Promise<PublicUploadUrlResponse> => {

  return customFetch<PublicUploadUrlResponse>(getRequestPublicUploadUrlUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(uploadUrlRequest)
  }
);}





export const getRequestPublicUploadUrlMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPublicUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestPublicUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext> => {

const mutationKey = ['requestPublicUploadUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestPublicUploadUrl>>, {data: BodyType<UploadUrlRequest>}> = (props) => {
          const {data} = props ?? {};

          return  requestPublicUploadUrl(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestPublicUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof requestPublicUploadUrl>>>
    export type RequestPublicUploadUrlMutationBody = BodyType<UploadUrlRequest>
    export type RequestPublicUploadUrlMutationError = ErrorType<unknown>

    /**
 * @summary Request a presigned URL for a TENANT-PUBLIC file upload
 */
export const useRequestPublicUploadUrl = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPublicUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestPublicUploadUrl>>,
        TError,
        {data: BodyType<UploadUrlRequest>},
        TContext
      > => {
      return useMutation(getRequestPublicUploadUrlMutationOptions(options));
    }

export const getGetMeUrl = () => {




  return `/api/me`
}

/**
 * @summary Get current authenticated user
 */
export const getMe = async ( options?: RequestInit): Promise<AuthedUser> => {

  return customFetch<AuthedUser>(getGetMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMeQueryKey = () => {
    return [
    `/api/me`
    ] as const;
    }


export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = ErrorType<unknown>


/**
 * @summary Get current authenticated user
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMyAccountProfileUrl = () => {




  return `/api/me/profile`
}

/**
 * @summary Get the authenticated user's private account profile
 */
export const getMyAccountProfile = async ( options?: RequestInit): Promise<AccountProfile> => {

  return customFetch<AccountProfile>(getGetMyAccountProfileUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyAccountProfileQueryKey = () => {
    return [
    `/api/me/profile`
    ] as const;
    }


export const getGetMyAccountProfileQueryOptions = <TData = Awaited<ReturnType<typeof getMyAccountProfile>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyAccountProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyAccountProfileQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyAccountProfile>>> = ({ signal }) => getMyAccountProfile({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyAccountProfile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyAccountProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getMyAccountProfile>>>
export type GetMyAccountProfileQueryError = ErrorType<unknown>


/**
 * @summary Get the authenticated user's private account profile
 */

export function useGetMyAccountProfile<TData = Awaited<ReturnType<typeof getMyAccountProfile>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyAccountProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyAccountProfileQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateMyAccountProfileUrl = () => {




  return `/api/me/profile`
}

/**
 * @summary Update the authenticated user's private account profile
 */
export const updateMyAccountProfile = async (accountProfileUpdate: AccountProfileUpdate, options?: RequestInit): Promise<AccountProfile> => {

  return customFetch<AccountProfile>(getUpdateMyAccountProfileUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(accountProfileUpdate)
  }
);}





export const getUpdateMyAccountProfileMutationOptions = <TError = ErrorType<AccountProfileError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyAccountProfile>>, TError,{data: BodyType<AccountProfileUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMyAccountProfile>>, TError,{data: BodyType<AccountProfileUpdate>}, TContext> => {

const mutationKey = ['updateMyAccountProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMyAccountProfile>>, {data: BodyType<AccountProfileUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateMyAccountProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMyAccountProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateMyAccountProfile>>>
    export type UpdateMyAccountProfileMutationBody = BodyType<AccountProfileUpdate>
    export type UpdateMyAccountProfileMutationError = ErrorType<AccountProfileError>

    /**
 * @summary Update the authenticated user's private account profile
 */
export const useUpdateMyAccountProfile = <TError = ErrorType<AccountProfileError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyAccountProfile>>, TError,{data: BodyType<AccountProfileUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateMyAccountProfile>>,
        TError,
        {data: BodyType<AccountProfileUpdate>},
        TContext
      > => {
      return useMutation(getUpdateMyAccountProfileMutationOptions(options));
    }

export const getListUsersUrl = () => {




  return `/api/users`
}

/**
 * @summary List users (admin only)
 */
export const listUsers = async ( options?: RequestInit): Promise<UserOut[]> => {

  return customFetch<UserOut[]>(getListUsersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUsersQueryKey = () => {
    return [
    `/api/users`
    ] as const;
    }


export const getListUsersQueryOptions = <TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({ signal }) => listUsers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>
export type ListUsersQueryError = ErrorType<unknown>


/**
 * @summary List users (admin only)
 */

export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListUsersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListRolesUrl = () => {




  return `/api/users/roles`
}

/**
 * @summary List available roles + their permissions
 */
export const listRoles = async ( options?: RequestInit): Promise<RoleList> => {

  return customFetch<RoleList>(getListRolesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRolesQueryKey = () => {
    return [
    `/api/users/roles`
    ] as const;
    }


export const getListRolesQueryOptions = <TData = Awaited<ReturnType<typeof listRoles>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRoles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRolesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRoles>>> = ({ signal }) => listRoles({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRoles>>, TError, TData> & { queryKey: QueryKey }
}

export type ListRolesQueryResult = NonNullable<Awaited<ReturnType<typeof listRoles>>>
export type ListRolesQueryError = ErrorType<unknown>


/**
 * @summary List available roles + their permissions
 */

export function useListRoles<TData = Awaited<ReturnType<typeof listRoles>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRoles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListRolesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDeleteUserUrl = (id: string,) => {




  return `/api/users/${id}`
}

/**
 * @summary Delete a user from the local app DB AND the upstream Clerk account (admin only).
 */
export const deleteUser = async (id: string, options?: RequestInit): Promise<DeleteUser200> => {

  return customFetch<DeleteUser200>(getDeleteUserUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteUserMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUser>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteUser(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUser>>>

    export type DeleteUserMutationError = ErrorType<void>

    /**
 * @summary Delete a user from the local app DB AND the upstream Clerk account (admin only).
 */
export const useDeleteUser = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteUser>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteUserMutationOptions(options));
    }

export const getResetUserPasswordUrl = (id: string,) => {




  return `/api/users/${id}/password-reset`
}

/**
 * @summary Force a password reset (admin only). Removes the upstream Clerk password and revokes all active sessions.
 */
export const resetUserPassword = async (id: string, options?: RequestInit): Promise<ResetUserPassword200> => {

  return customFetch<ResetUserPassword200>(getResetUserPasswordUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResetUserPasswordMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetUserPassword>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resetUserPassword>>, TError,{id: string}, TContext> => {

const mutationKey = ['resetUserPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetUserPassword>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  resetUserPassword(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetUserPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetUserPassword>>>

    export type ResetUserPasswordMutationError = ErrorType<void>

    /**
 * @summary Force a password reset (admin only). Removes the upstream Clerk password and revokes all active sessions.
 */
export const useResetUserPassword = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetUserPassword>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resetUserPassword>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getResetUserPasswordMutationOptions(options));
    }

export const getSetUserRoleUrl = (id: string,) => {




  return `/api/users/${id}/role`
}

/**
 * @summary Set a user's role (admin only)
 */
export const setUserRole = async (id: string,
    roleUpdate: RoleUpdate, options?: RequestInit): Promise<SetUserRole200> => {

  return customFetch<SetUserRole200>(getSetUserRoleUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(roleUpdate)
  }
);}





export const getSetUserRoleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setUserRole>>, TError,{id: string;data: BodyType<RoleUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setUserRole>>, TError,{id: string;data: BodyType<RoleUpdate>}, TContext> => {

const mutationKey = ['setUserRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setUserRole>>, {id: string;data: BodyType<RoleUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  setUserRole(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetUserRoleMutationResult = NonNullable<Awaited<ReturnType<typeof setUserRole>>>
    export type SetUserRoleMutationBody = BodyType<RoleUpdate>
    export type SetUserRoleMutationError = ErrorType<unknown>

    /**
 * @summary Set a user's role (admin only)
 */
export const useSetUserRole = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setUserRole>>, TError,{id: string;data: BodyType<RoleUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setUserRole>>,
        TError,
        {id: string;data: BodyType<RoleUpdate>},
        TContext
      > => {
      return useMutation(getSetUserRoleMutationOptions(options));
    }

export const getSetUserSectionOverridesUrl = (id: string,) => {




  return `/api/users/${id}/section-overrides`
}

/**
 * @summary Set per-user UI section access overrides (admin only)
 */
export const setUserSectionOverrides = async (id: string,
    userSectionOverrideUpdate: UserSectionOverrideUpdate, options?: RequestInit): Promise<SetUserSectionOverrides200> => {

  return customFetch<SetUserSectionOverrides200>(getSetUserSectionOverridesUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(userSectionOverrideUpdate)
  }
);}





export const getSetUserSectionOverridesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setUserSectionOverrides>>, TError,{id: string;data: BodyType<UserSectionOverrideUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setUserSectionOverrides>>, TError,{id: string;data: BodyType<UserSectionOverrideUpdate>}, TContext> => {

const mutationKey = ['setUserSectionOverrides'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setUserSectionOverrides>>, {id: string;data: BodyType<UserSectionOverrideUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  setUserSectionOverrides(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetUserSectionOverridesMutationResult = NonNullable<Awaited<ReturnType<typeof setUserSectionOverrides>>>
    export type SetUserSectionOverridesMutationBody = BodyType<UserSectionOverrideUpdate>
    export type SetUserSectionOverridesMutationError = ErrorType<unknown>

    /**
 * @summary Set per-user UI section access overrides (admin only)
 */
export const useSetUserSectionOverrides = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setUserSectionOverrides>>, TError,{id: string;data: BodyType<UserSectionOverrideUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setUserSectionOverrides>>,
        TError,
        {id: string;data: BodyType<UserSectionOverrideUpdate>},
        TContext
      > => {
      return useMutation(getSetUserSectionOverridesMutationOptions(options));
    }

export const getSetUserPermissionsOverrideUrl = (id: string,) => {




  return `/api/users/${id}/permissions-override`
}

/**
 * @summary Set per-user permission override (admin only). Replaces the role's default permissions entirely when non-null.
 */
export const setUserPermissionsOverride = async (id: string,
    userPermissionsOverrideUpdate: UserPermissionsOverrideUpdate, options?: RequestInit): Promise<SetUserPermissionsOverride200> => {

  return customFetch<SetUserPermissionsOverride200>(getSetUserPermissionsOverrideUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(userPermissionsOverrideUpdate)
  }
);}





export const getSetUserPermissionsOverrideMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setUserPermissionsOverride>>, TError,{id: string;data: BodyType<UserPermissionsOverrideUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setUserPermissionsOverride>>, TError,{id: string;data: BodyType<UserPermissionsOverrideUpdate>}, TContext> => {

const mutationKey = ['setUserPermissionsOverride'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setUserPermissionsOverride>>, {id: string;data: BodyType<UserPermissionsOverrideUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  setUserPermissionsOverride(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetUserPermissionsOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof setUserPermissionsOverride>>>
    export type SetUserPermissionsOverrideMutationBody = BodyType<UserPermissionsOverrideUpdate>
    export type SetUserPermissionsOverrideMutationError = ErrorType<void>

    /**
 * @summary Set per-user permission override (admin only). Replaces the role's default permissions entirely when non-null.
 */
export const useSetUserPermissionsOverride = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setUserPermissionsOverride>>, TError,{id: string;data: BodyType<UserPermissionsOverrideUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setUserPermissionsOverride>>,
        TError,
        {id: string;data: BodyType<UserPermissionsOverrideUpdate>},
        TContext
      > => {
      return useMutation(getSetUserPermissionsOverrideMutationOptions(options));
    }

export const getCreateTenantUserInvitationUrl = () => {




  return `/api/users/invitations`
}

/**
 * @summary Invite a user by email into the caller's own tenant (tenant admin).
 */
export const createTenantUserInvitation = async (tenantUserInviteCreate: TenantUserInviteCreate, options?: RequestInit): Promise<TenantUserInviteResult> => {

  return customFetch<TenantUserInviteResult>(getCreateTenantUserInvitationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tenantUserInviteCreate)
  }
);}





export const getCreateTenantUserInvitationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTenantUserInvitation>>, TError,{data: BodyType<TenantUserInviteCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTenantUserInvitation>>, TError,{data: BodyType<TenantUserInviteCreate>}, TContext> => {

const mutationKey = ['createTenantUserInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTenantUserInvitation>>, {data: BodyType<TenantUserInviteCreate>}> = (props) => {
          const {data} = props ?? {};

          return  createTenantUserInvitation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTenantUserInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof createTenantUserInvitation>>>
    export type CreateTenantUserInvitationMutationBody = BodyType<TenantUserInviteCreate>
    export type CreateTenantUserInvitationMutationError = ErrorType<void>

    /**
 * @summary Invite a user by email into the caller's own tenant (tenant admin).
 */
export const useCreateTenantUserInvitation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTenantUserInvitation>>, TError,{data: BodyType<TenantUserInviteCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTenantUserInvitation>>,
        TError,
        {data: BodyType<TenantUserInviteCreate>},
        TContext
      > => {
      return useMutation(getCreateTenantUserInvitationMutationOptions(options));
    }

export const getCreateTenantUserDirectUrl = () => {




  return `/api/users/members/direct`
}

/**
 * @summary Create a user with a password and add them to the caller's own tenant immediately (tenant admin).
 */
export const createTenantUserDirect = async (tenantUserDirectCreate: TenantUserDirectCreate, options?: RequestInit): Promise<TenantUserDirectResult> => {

  return customFetch<TenantUserDirectResult>(getCreateTenantUserDirectUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tenantUserDirectCreate)
  }
);}





export const getCreateTenantUserDirectMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTenantUserDirect>>, TError,{data: BodyType<TenantUserDirectCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTenantUserDirect>>, TError,{data: BodyType<TenantUserDirectCreate>}, TContext> => {

const mutationKey = ['createTenantUserDirect'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTenantUserDirect>>, {data: BodyType<TenantUserDirectCreate>}> = (props) => {
          const {data} = props ?? {};

          return  createTenantUserDirect(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTenantUserDirectMutationResult = NonNullable<Awaited<ReturnType<typeof createTenantUserDirect>>>
    export type CreateTenantUserDirectMutationBody = BodyType<TenantUserDirectCreate>
    export type CreateTenantUserDirectMutationError = ErrorType<void>

    /**
 * @summary Create a user with a password and add them to the caller's own tenant immediately (tenant admin).
 */
export const useCreateTenantUserDirect = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTenantUserDirect>>, TError,{data: BodyType<TenantUserDirectCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTenantUserDirect>>,
        TError,
        {data: BodyType<TenantUserDirectCreate>},
        TContext
      > => {
      return useMutation(getCreateTenantUserDirectMutationOptions(options));
    }

export const getGetSectionAccessConfigUrl = () => {




  return `/api/admin/section-access`
}

/**
 * @summary Get UI section access config for all roles (admin only)
 */
export const getSectionAccessConfig = async ( options?: RequestInit): Promise<SectionAccessConfig> => {

  return customFetch<SectionAccessConfig>(getGetSectionAccessConfigUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSectionAccessConfigQueryKey = () => {
    return [
    `/api/admin/section-access`
    ] as const;
    }


export const getGetSectionAccessConfigQueryOptions = <TData = Awaited<ReturnType<typeof getSectionAccessConfig>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSectionAccessConfig>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSectionAccessConfigQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSectionAccessConfig>>> = ({ signal }) => getSectionAccessConfig({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSectionAccessConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSectionAccessConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getSectionAccessConfig>>>
export type GetSectionAccessConfigQueryError = ErrorType<unknown>


/**
 * @summary Get UI section access config for all roles (admin only)
 */

export function useGetSectionAccessConfig<TData = Awaited<ReturnType<typeof getSectionAccessConfig>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSectionAccessConfig>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSectionAccessConfigQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSetRoleSectionAccessUrl = (role: string,) => {




  return `/api/admin/section-access/${role}`
}

/**
 * @summary Set UI section access for a role (admin only)
 */
export const setRoleSectionAccess = async (role: string,
    sectionAccessUpdate: SectionAccessUpdate, options?: RequestInit): Promise<RoleSectionAccess> => {

  return customFetch<RoleSectionAccess>(getSetRoleSectionAccessUrl(role),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sectionAccessUpdate)
  }
);}





export const getSetRoleSectionAccessMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setRoleSectionAccess>>, TError,{role: string;data: BodyType<SectionAccessUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setRoleSectionAccess>>, TError,{role: string;data: BodyType<SectionAccessUpdate>}, TContext> => {

const mutationKey = ['setRoleSectionAccess'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setRoleSectionAccess>>, {role: string;data: BodyType<SectionAccessUpdate>}> = (props) => {
          const {role,data} = props ?? {};

          return  setRoleSectionAccess(role,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetRoleSectionAccessMutationResult = NonNullable<Awaited<ReturnType<typeof setRoleSectionAccess>>>
    export type SetRoleSectionAccessMutationBody = BodyType<SectionAccessUpdate>
    export type SetRoleSectionAccessMutationError = ErrorType<unknown>

    /**
 * @summary Set UI section access for a role (admin only)
 */
export const useSetRoleSectionAccess = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setRoleSectionAccess>>, TError,{role: string;data: BodyType<SectionAccessUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setRoleSectionAccess>>,
        TError,
        {role: string;data: BodyType<SectionAccessUpdate>},
        TContext
      > => {
      return useMutation(getSetRoleSectionAccessMutationOptions(options));
    }

export const getListStockAuditUrl = (params?: ListStockAuditParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/stock-audit?${stringifiedParams}` : `/api/admin/stock-audit`
}

/**
 * @summary Recent stock movements with user attribution (admin only)
 */
export const listStockAudit = async (params?: ListStockAuditParams, options?: RequestInit): Promise<StockAuditEntry[]> => {

  return customFetch<StockAuditEntry[]>(getListStockAuditUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListStockAuditQueryKey = (params?: ListStockAuditParams,) => {
    return [
    `/api/admin/stock-audit`, ...(params ? [params] : [])
    ] as const;
    }


export const getListStockAuditQueryOptions = <TData = Awaited<ReturnType<typeof listStockAudit>>, TError = ErrorType<unknown>>(params?: ListStockAuditParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listStockAudit>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStockAuditQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStockAudit>>> = ({ signal }) => listStockAudit(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStockAudit>>, TError, TData> & { queryKey: QueryKey }
}

export type ListStockAuditQueryResult = NonNullable<Awaited<ReturnType<typeof listStockAudit>>>
export type ListStockAuditQueryError = ErrorType<unknown>


/**
 * @summary Recent stock movements with user attribution (admin only)
 */

export function useListStockAudit<TData = Awaited<ReturnType<typeof listStockAudit>>, TError = ErrorType<unknown>>(
 params?: ListStockAuditParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listStockAudit>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListStockAuditQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListActivityLogUrl = (params?: ListActivityLogParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/activity-log?${stringifiedParams}` : `/api/activity-log`
}

/**
 * @summary App-wide activity log (audit trail of every business action)
 */
export const listActivityLog = async (params?: ListActivityLogParams, options?: RequestInit): Promise<ListActivityLog200> => {

  return customFetch<ListActivityLog200>(getListActivityLogUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListActivityLogQueryKey = (params?: ListActivityLogParams,) => {
    return [
    `/api/activity-log`, ...(params ? [params] : [])
    ] as const;
    }


export const getListActivityLogQueryOptions = <TData = Awaited<ReturnType<typeof listActivityLog>>, TError = ErrorType<unknown>>(params?: ListActivityLogParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listActivityLog>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListActivityLogQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listActivityLog>>> = ({ signal }) => listActivityLog(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listActivityLog>>, TError, TData> & { queryKey: QueryKey }
}

export type ListActivityLogQueryResult = NonNullable<Awaited<ReturnType<typeof listActivityLog>>>
export type ListActivityLogQueryError = ErrorType<unknown>


/**
 * @summary App-wide activity log (audit trail of every business action)
 */

export function useListActivityLog<TData = Awaited<ReturnType<typeof listActivityLog>>, TError = ErrorType<unknown>>(
 params?: ListActivityLogParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listActivityLog>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListActivityLogQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPreOrderBatchActivityUrl = (id: string,
    params?: ListPreOrderBatchActivityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pre-orders/batches/${id}/activity?${stringifiedParams}` : `/api/pre-orders/batches/${id}/activity`
}

/**
 * Returns only audit rows for this tenant's batch and its related batch items, allocations, and orders. Requires the existing audit-log permission and never reads the global activity feed.
 * @summary Paginated audit activity for one pre-order batch
 */
export const listPreOrderBatchActivity = async (id: string,
    params?: ListPreOrderBatchActivityParams, options?: RequestInit): Promise<EntityAuditLogPage> => {

  return customFetch<EntityAuditLogPage>(getListPreOrderBatchActivityUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPreOrderBatchActivityQueryKey = (id: string,
    params?: ListPreOrderBatchActivityParams,) => {
    return [
    `/api/pre-orders/batches/${id}/activity`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPreOrderBatchActivityQueryOptions = <TData = Awaited<ReturnType<typeof listPreOrderBatchActivity>>, TError = ErrorType<void>>(id: string,
    params?: ListPreOrderBatchActivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPreOrderBatchActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPreOrderBatchActivityQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPreOrderBatchActivity>>> = ({ signal }) => listPreOrderBatchActivity(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPreOrderBatchActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPreOrderBatchActivityQueryResult = NonNullable<Awaited<ReturnType<typeof listPreOrderBatchActivity>>>
export type ListPreOrderBatchActivityQueryError = ErrorType<void>


/**
 * @summary Paginated audit activity for one pre-order batch
 */

export function useListPreOrderBatchActivity<TData = Awaited<ReturnType<typeof listPreOrderBatchActivity>>, TError = ErrorType<void>>(
 id: string,
    params?: ListPreOrderBatchActivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPreOrderBatchActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPreOrderBatchActivityQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportPreOrderBatchActivityUrl = (id: string,
    params?: ExportPreOrderBatchActivityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pre-orders/batches/${id}/activity/export?${stringifiedParams}` : `/api/pre-orders/batches/${id}/activity/export`
}

/**
 * @summary Export the filtered batch activity log
 */
export const exportPreOrderBatchActivity = async (id: string,
    params?: ExportPreOrderBatchActivityParams, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getExportPreOrderBatchActivityUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportPreOrderBatchActivityQueryKey = (id: string,
    params?: ExportPreOrderBatchActivityParams,) => {
    return [
    `/api/pre-orders/batches/${id}/activity/export`, ...(params ? [params] : [])
    ] as const;
    }


export const getExportPreOrderBatchActivityQueryOptions = <TData = Awaited<ReturnType<typeof exportPreOrderBatchActivity>>, TError = ErrorType<void>>(id: string,
    params?: ExportPreOrderBatchActivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportPreOrderBatchActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportPreOrderBatchActivityQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportPreOrderBatchActivity>>> = ({ signal }) => exportPreOrderBatchActivity(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportPreOrderBatchActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type ExportPreOrderBatchActivityQueryResult = NonNullable<Awaited<ReturnType<typeof exportPreOrderBatchActivity>>>
export type ExportPreOrderBatchActivityQueryError = ErrorType<void>


/**
 * @summary Export the filtered batch activity log
 */

export function useExportPreOrderBatchActivity<TData = Awaited<ReturnType<typeof exportPreOrderBatchActivity>>, TError = ErrorType<void>>(
 id: string,
    params?: ExportPreOrderBatchActivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportPreOrderBatchActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getExportPreOrderBatchActivityQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAuditLogsUrl = (params?: ListAuditLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/audit-logs?${stringifiedParams}` : `/api/audit-logs`
}

/**
 * @summary Append-only field-level audit trail (cross-entity browser)
 */
export const listAuditLogs = async (params?: ListAuditLogsParams, options?: RequestInit): Promise<AuditLogList> => {

  return customFetch<AuditLogList>(getListAuditLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAuditLogsQueryKey = (params?: ListAuditLogsParams,) => {
    return [
    `/api/audit-logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAuditLogsQueryOptions = <TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = ErrorType<unknown>>(params?: ListAuditLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAuditLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditLogs>>> = ({ signal }) => listAuditLogs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAuditLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listAuditLogs>>>
export type ListAuditLogsQueryError = ErrorType<unknown>


/**
 * @summary Append-only field-level audit trail (cross-entity browser)
 */

export function useListAuditLogs<TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = ErrorType<unknown>>(
 params?: ListAuditLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAuditLogsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetEntityAuditLogUrl = (entityType: string,
    entityId: string,) => {




  return `/api/audit-logs/${entityType}/${entityId}`
}

/**
 * Returns up to the most recent 200 audit rows for the given entity,
 * newest first. Per-entity tabs in practice never approach this many
 * rows, so cursor pagination is intentionally omitted to sidestep an
 * Orval naming collision (path-param + query-param `*Params` clash).
 * Use `GET /audit-logs` for the paginated cross-entity browser.
 * @summary Audit trail for a single entity (used by per-page tabs)
 */
export const getEntityAuditLog = async (entityType: string,
    entityId: string, options?: RequestInit): Promise<EntityAuditLogPage> => {

  return customFetch<EntityAuditLogPage>(getGetEntityAuditLogUrl(entityType,entityId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEntityAuditLogQueryKey = (entityType: string,
    entityId: string,) => {
    return [
    `/api/audit-logs/${entityType}/${entityId}`
    ] as const;
    }


export const getGetEntityAuditLogQueryOptions = <TData = Awaited<ReturnType<typeof getEntityAuditLog>>, TError = ErrorType<unknown>>(entityType: string,
    entityId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEntityAuditLog>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntityAuditLogQueryKey(entityType,entityId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntityAuditLog>>> = ({ signal }) => getEntityAuditLog(entityType,entityId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: entityType !== null && entityType !== undefined && entityId !== null && entityId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntityAuditLog>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEntityAuditLogQueryResult = NonNullable<Awaited<ReturnType<typeof getEntityAuditLog>>>
export type GetEntityAuditLogQueryError = ErrorType<unknown>


/**
 * @summary Audit trail for a single entity (used by per-page tabs)
 */

export function useGetEntityAuditLog<TData = Awaited<ReturnType<typeof getEntityAuditLog>>, TError = ErrorType<unknown>>(
 entityType: string,
    entityId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEntityAuditLog>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEntityAuditLogQueryOptions(entityType,entityId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSalesPerformanceDailyUrl = (params?: GetSalesPerformanceDailyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/sales-performance/daily?${stringifiedParams}` : `/api/reports/sales-performance/daily`
}

/**
 * @summary Daily sales performance grouped by calendar day (Europe/London).
Per-line profit uses the same authoritative `effectiveUnitCost` rule
as `/reports/profit-loss`:
`salePrice - COALESCE(consignment_supplier_payout_per_unit_gbp, unit_cost)`.
Refund netting is controlled by `refundBasis`: `refunded_at` (default,
bucketed by the day the refund was processed) or `sale_date` (rolled
back to the day the original sale happened). Refund money uses the
line-level `order_adjustment_items.refund_amount_gbp` so stockType /
channel filters apply consistently; cost reversal applies only when
`returned_quantity > 0`.

 */
export const getSalesPerformanceDaily = async (params?: GetSalesPerformanceDailyParams, options?: RequestInit): Promise<SalesPerformanceDailyReport> => {

  return customFetch<SalesPerformanceDailyReport>(getGetSalesPerformanceDailyUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSalesPerformanceDailyQueryKey = (params?: GetSalesPerformanceDailyParams,) => {
    return [
    `/api/reports/sales-performance/daily`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSalesPerformanceDailyQueryOptions = <TData = Awaited<ReturnType<typeof getSalesPerformanceDaily>>, TError = ErrorType<unknown>>(params?: GetSalesPerformanceDailyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSalesPerformanceDaily>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSalesPerformanceDailyQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSalesPerformanceDaily>>> = ({ signal }) => getSalesPerformanceDaily(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSalesPerformanceDaily>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSalesPerformanceDailyQueryResult = NonNullable<Awaited<ReturnType<typeof getSalesPerformanceDaily>>>
export type GetSalesPerformanceDailyQueryError = ErrorType<unknown>


/**
 * @summary Daily sales performance grouped by calendar day (Europe/London).
Per-line profit uses the same authoritative `effectiveUnitCost` rule
as `/reports/profit-loss`:
`salePrice - COALESCE(consignment_supplier_payout_per_unit_gbp, unit_cost)`.
Refund netting is controlled by `refundBasis`: `refunded_at` (default,
bucketed by the day the refund was processed) or `sale_date` (rolled
back to the day the original sale happened). Refund money uses the
line-level `order_adjustment_items.refund_amount_gbp` so stockType /
channel filters apply consistently; cost reversal applies only when
`returned_quantity > 0`.

 */

export function useGetSalesPerformanceDaily<TData = Awaited<ReturnType<typeof getSalesPerformanceDaily>>, TError = ErrorType<unknown>>(
 params?: GetSalesPerformanceDailyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSalesPerformanceDaily>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSalesPerformanceDailyQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSalesPerformanceByChannelUrl = (params?: GetSalesPerformanceByChannelParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/sales-performance/by-channel?${stringifiedParams}` : `/api/reports/sales-performance/by-channel`
}

/**
 * @summary Sales performance grouped by sales channel (lowercased to collapse
historical casing variants like `eBay`/`ebay`). Same filters,
effective-cost rule, and refund-netting model as
`/reports/sales-performance/daily`. Rows are sorted by net revenue
descending; `revenueSharePct` is the row's share of total NET revenue.

 */
export const getSalesPerformanceByChannel = async (params?: GetSalesPerformanceByChannelParams, options?: RequestInit): Promise<SalesPerformanceByChannelReport> => {

  return customFetch<SalesPerformanceByChannelReport>(getGetSalesPerformanceByChannelUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSalesPerformanceByChannelQueryKey = (params?: GetSalesPerformanceByChannelParams,) => {
    return [
    `/api/reports/sales-performance/by-channel`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSalesPerformanceByChannelQueryOptions = <TData = Awaited<ReturnType<typeof getSalesPerformanceByChannel>>, TError = ErrorType<unknown>>(params?: GetSalesPerformanceByChannelParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSalesPerformanceByChannel>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSalesPerformanceByChannelQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSalesPerformanceByChannel>>> = ({ signal }) => getSalesPerformanceByChannel(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSalesPerformanceByChannel>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSalesPerformanceByChannelQueryResult = NonNullable<Awaited<ReturnType<typeof getSalesPerformanceByChannel>>>
export type GetSalesPerformanceByChannelQueryError = ErrorType<unknown>


/**
 * @summary Sales performance grouped by sales channel (lowercased to collapse
historical casing variants like `eBay`/`ebay`). Same filters,
effective-cost rule, and refund-netting model as
`/reports/sales-performance/daily`. Rows are sorted by net revenue
descending; `revenueSharePct` is the row's share of total NET revenue.

 */

export function useGetSalesPerformanceByChannel<TData = Awaited<ReturnType<typeof getSalesPerformanceByChannel>>, TError = ErrorType<unknown>>(
 params?: GetSalesPerformanceByChannelParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSalesPerformanceByChannel>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSalesPerformanceByChannelQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSalesPerformanceSessionsUrl = (params?: GetSalesPerformanceSessionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/sales-performance/sessions?${stringifiedParams}` : `/api/reports/sales-performance/sessions`
}

/**
 * @summary Live-selling sessions report. Returns a hybrid list of MANUAL
sessions (operator-named, persisted in `selling_sessions`) and
AUTO-detected sessions (gap-clustered sale_orders within
`minGapMinutes` of each other, default 120). Manual sessions take
precedence: any sale whose sale_date falls inside a manual session's
window is attributed to it and ignored by the auto-detector.

Same effective-cost rule, channel/stockType/customer/refundBasis
filters, and refund-netting model as `/sales-performance/daily`.
Refunds attribute to whichever session contains the ORIGINAL sale's
sale_date; refunds whose sale falls outside any session contribute
to summary totals only. Rows are sorted by `startedAt` descending.

 */
export const getSalesPerformanceSessions = async (params?: GetSalesPerformanceSessionsParams, options?: RequestInit): Promise<SalesPerformanceSessionsReport> => {

  return customFetch<SalesPerformanceSessionsReport>(getGetSalesPerformanceSessionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSalesPerformanceSessionsQueryKey = (params?: GetSalesPerformanceSessionsParams,) => {
    return [
    `/api/reports/sales-performance/sessions`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSalesPerformanceSessionsQueryOptions = <TData = Awaited<ReturnType<typeof getSalesPerformanceSessions>>, TError = ErrorType<unknown>>(params?: GetSalesPerformanceSessionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSalesPerformanceSessions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSalesPerformanceSessionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSalesPerformanceSessions>>> = ({ signal }) => getSalesPerformanceSessions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSalesPerformanceSessions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSalesPerformanceSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof getSalesPerformanceSessions>>>
export type GetSalesPerformanceSessionsQueryError = ErrorType<unknown>


/**
 * @summary Live-selling sessions report. Returns a hybrid list of MANUAL
sessions (operator-named, persisted in `selling_sessions`) and
AUTO-detected sessions (gap-clustered sale_orders within
`minGapMinutes` of each other, default 120). Manual sessions take
precedence: any sale whose sale_date falls inside a manual session's
window is attributed to it and ignored by the auto-detector.

Same effective-cost rule, channel/stockType/customer/refundBasis
filters, and refund-netting model as `/sales-performance/daily`.
Refunds attribute to whichever session contains the ORIGINAL sale's
sale_date; refunds whose sale falls outside any session contribute
to summary totals only. Rows are sorted by `startedAt` descending.

 */

export function useGetSalesPerformanceSessions<TData = Awaited<ReturnType<typeof getSalesPerformanceSessions>>, TError = ErrorType<unknown>>(
 params?: GetSalesPerformanceSessionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSalesPerformanceSessions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSalesPerformanceSessionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSellingSessionsUrl = (params?: ListSellingSessionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/selling-sessions?${stringifiedParams}` : `/api/selling-sessions`
}

/**
 * @summary List manual selling sessions overlapping a window.
 */
export const listSellingSessions = async (params?: ListSellingSessionsParams, options?: RequestInit): Promise<ListSellingSessions200> => {

  return customFetch<ListSellingSessions200>(getListSellingSessionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSellingSessionsQueryKey = (params?: ListSellingSessionsParams,) => {
    return [
    `/api/selling-sessions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSellingSessionsQueryOptions = <TData = Awaited<ReturnType<typeof listSellingSessions>>, TError = ErrorType<unknown>>(params?: ListSellingSessionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSellingSessions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSellingSessionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSellingSessions>>> = ({ signal }) => listSellingSessions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSellingSessions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSellingSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof listSellingSessions>>>
export type ListSellingSessionsQueryError = ErrorType<unknown>


/**
 * @summary List manual selling sessions overlapping a window.
 */

export function useListSellingSessions<TData = Awaited<ReturnType<typeof listSellingSessions>>, TError = ErrorType<unknown>>(
 params?: ListSellingSessionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSellingSessions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSellingSessionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateSellingSessionUrl = () => {




  return `/api/selling-sessions`
}

/**
 * @summary Create a manual selling session. Rejects overlap with any existing session.
 */
export const createSellingSession = async (sellingSessionInput: SellingSessionInput, options?: RequestInit): Promise<SellingSession> => {

  return customFetch<SellingSession>(getCreateSellingSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellingSessionInput)
  }
);}





export const getCreateSellingSessionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSellingSession>>, TError,{data: BodyType<SellingSessionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSellingSession>>, TError,{data: BodyType<SellingSessionInput>}, TContext> => {

const mutationKey = ['createSellingSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSellingSession>>, {data: BodyType<SellingSessionInput>}> = (props) => {
          const {data} = props ?? {};

          return  createSellingSession(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSellingSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createSellingSession>>>
    export type CreateSellingSessionMutationBody = BodyType<SellingSessionInput>
    export type CreateSellingSessionMutationError = ErrorType<void>

    /**
 * @summary Create a manual selling session. Rejects overlap with any existing session.
 */
export const useCreateSellingSession = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSellingSession>>, TError,{data: BodyType<SellingSessionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSellingSession>>,
        TError,
        {data: BodyType<SellingSessionInput>},
        TContext
      > => {
      return useMutation(getCreateSellingSessionMutationOptions(options));
    }

export const getUpdateSellingSessionUrl = (id: string,) => {




  return `/api/selling-sessions/${id}`
}

export const updateSellingSession = async (id: string,
    sellingSessionPatch: SellingSessionPatch, options?: RequestInit): Promise<SellingSession> => {

  return customFetch<SellingSession>(getUpdateSellingSessionUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellingSessionPatch)
  }
);}





export const getUpdateSellingSessionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSellingSession>>, TError,{id: string;data: BodyType<SellingSessionPatch>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSellingSession>>, TError,{id: string;data: BodyType<SellingSessionPatch>}, TContext> => {

const mutationKey = ['updateSellingSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSellingSession>>, {id: string;data: BodyType<SellingSessionPatch>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSellingSession(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSellingSessionMutationResult = NonNullable<Awaited<ReturnType<typeof updateSellingSession>>>
    export type UpdateSellingSessionMutationBody = BodyType<SellingSessionPatch>
    export type UpdateSellingSessionMutationError = ErrorType<void>

    export const useUpdateSellingSession = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSellingSession>>, TError,{id: string;data: BodyType<SellingSessionPatch>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSellingSession>>,
        TError,
        {id: string;data: BodyType<SellingSessionPatch>},
        TContext
      > => {
      return useMutation(getUpdateSellingSessionMutationOptions(options));
    }

export const getDeleteSellingSessionUrl = (id: string,) => {




  return `/api/selling-sessions/${id}`
}

export const deleteSellingSession = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteSellingSessionUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteSellingSessionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSellingSession>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSellingSession>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteSellingSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSellingSession>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteSellingSession(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSellingSessionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSellingSession>>>

    export type DeleteSellingSessionMutationError = ErrorType<void>

    export const useDeleteSellingSession = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSellingSession>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSellingSession>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteSellingSessionMutationOptions(options));
    }

export const getGetSkuByChannelReportUrl = (params?: GetSkuByChannelReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/sku-by-channel?${stringifiedParams}` : `/api/reports/sku-by-channel`
}

export const getSkuByChannelReport = async (params?: GetSkuByChannelReportParams, options?: RequestInit): Promise<SkuByChannelReport> => {

  return customFetch<SkuByChannelReport>(getGetSkuByChannelReportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSkuByChannelReportQueryKey = (params?: GetSkuByChannelReportParams,) => {
    return [
    `/api/reports/sku-by-channel`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSkuByChannelReportQueryOptions = <TData = Awaited<ReturnType<typeof getSkuByChannelReport>>, TError = ErrorType<unknown>>(params?: GetSkuByChannelReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSkuByChannelReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSkuByChannelReportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSkuByChannelReport>>> = ({ signal }) => getSkuByChannelReport(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSkuByChannelReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSkuByChannelReportQueryResult = NonNullable<Awaited<ReturnType<typeof getSkuByChannelReport>>>
export type GetSkuByChannelReportQueryError = ErrorType<unknown>



export function useGetSkuByChannelReport<TData = Awaited<ReturnType<typeof getSkuByChannelReport>>, TError = ErrorType<unknown>>(
 params?: GetSkuByChannelReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSkuByChannelReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSkuByChannelReportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPeriodComparisonReportUrl = () => {




  return `/api/reports/period-comparison`
}

export const getPeriodComparisonReport = async ( options?: RequestInit): Promise<PeriodComparisonReport> => {

  return customFetch<PeriodComparisonReport>(getGetPeriodComparisonReportUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPeriodComparisonReportQueryKey = () => {
    return [
    `/api/reports/period-comparison`
    ] as const;
    }


export const getGetPeriodComparisonReportQueryOptions = <TData = Awaited<ReturnType<typeof getPeriodComparisonReport>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPeriodComparisonReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPeriodComparisonReportQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPeriodComparisonReport>>> = ({ signal }) => getPeriodComparisonReport({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPeriodComparisonReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPeriodComparisonReportQueryResult = NonNullable<Awaited<ReturnType<typeof getPeriodComparisonReport>>>
export type GetPeriodComparisonReportQueryError = ErrorType<unknown>



export function useGetPeriodComparisonReport<TData = Awaited<ReturnType<typeof getPeriodComparisonReport>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPeriodComparisonReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPeriodComparisonReportQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetGa4StatsUrl = () => {




  return `/api/dashboard/ga4`
}

export const getGa4Stats = async ( options?: RequestInit): Promise<Ga4Stats> => {

  return customFetch<Ga4Stats>(getGetGa4StatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGa4StatsQueryKey = () => {
    return [
    `/api/dashboard/ga4`
    ] as const;
    }


export const getGetGa4StatsQueryOptions = <TData = Awaited<ReturnType<typeof getGa4Stats>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGa4Stats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGa4StatsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGa4Stats>>> = ({ signal }) => getGa4Stats({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGa4Stats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGa4StatsQueryResult = NonNullable<Awaited<ReturnType<typeof getGa4Stats>>>
export type GetGa4StatsQueryError = ErrorType<unknown>



export function useGetGa4Stats<TData = Awaited<ReturnType<typeof getGa4Stats>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGa4Stats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGa4StatsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getTriggerStockReconcileUrl = () => {




  return `/api/integrations/stock-reconcile`
}

/**
 * @summary Trigger a full-sweep marketplace stock reconcile now (admin/owner-gated).
Pushes the current computed-available quantity for every inventory item
that has at least one external listing to all connected marketplaces
(eBay, Shopify, TikTok Shop, WooCommerce). A 30-second cooldown applies
per tenant to prevent double-triggering.

 */
export const triggerStockReconcile = async ( options?: RequestInit): Promise<StockReconcileSummary | BackgroundJobAccepted> => {

  return customFetch<StockReconcileSummary | BackgroundJobAccepted>(getTriggerStockReconcileUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getTriggerStockReconcileMutationOptions = <TError = ErrorType<TriggerStockReconcile429>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerStockReconcile>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof triggerStockReconcile>>, TError,void, TContext> => {

const mutationKey = ['triggerStockReconcile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggerStockReconcile>>, void> = () => {


          return  triggerStockReconcile(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TriggerStockReconcileMutationResult = NonNullable<Awaited<ReturnType<typeof triggerStockReconcile>>>

    export type TriggerStockReconcileMutationError = ErrorType<TriggerStockReconcile429>

    /**
 * @summary Trigger a full-sweep marketplace stock reconcile now (admin/owner-gated).
Pushes the current computed-available quantity for every inventory item
that has at least one external listing to all connected marketplaces
(eBay, Shopify, TikTok Shop, WooCommerce). A 30-second cooldown applies
per tenant to prevent double-triggering.

 */
export const useTriggerStockReconcile = <TError = ErrorType<TriggerStockReconcile429>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerStockReconcile>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof triggerStockReconcile>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getTriggerStockReconcileMutationOptions(options));
    }

export const getGetGmailStatusUrl = () => {




  return `/api/integrations/gmail/status`
}

export const getGmailStatus = async ( options?: RequestInit): Promise<GetGmailStatus200> => {

  return customFetch<GetGmailStatus200>(getGetGmailStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGmailStatusQueryKey = () => {
    return [
    `/api/integrations/gmail/status`
    ] as const;
    }


export const getGetGmailStatusQueryOptions = <TData = Awaited<ReturnType<typeof getGmailStatus>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGmailStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGmailStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGmailStatus>>> = ({ signal }) => getGmailStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGmailStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGmailStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getGmailStatus>>>
export type GetGmailStatusQueryError = ErrorType<unknown>



export function useGetGmailStatus<TData = Awaited<ReturnType<typeof getGmailStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGmailStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGmailStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListIntegrationsUrl = () => {




  return `/api/integrations`
}

export const listIntegrations = async ( options?: RequestInit): Promise<MarketplaceIntegration[]> => {

  return customFetch<MarketplaceIntegration[]>(getListIntegrationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListIntegrationsQueryKey = () => {
    return [
    `/api/integrations`
    ] as const;
    }


export const getListIntegrationsQueryOptions = <TData = Awaited<ReturnType<typeof listIntegrations>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listIntegrations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListIntegrationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listIntegrations>>> = ({ signal }) => listIntegrations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listIntegrations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListIntegrationsQueryResult = NonNullable<Awaited<ReturnType<typeof listIntegrations>>>
export type ListIntegrationsQueryError = ErrorType<unknown>



export function useListIntegrations<TData = Awaited<ReturnType<typeof listIntegrations>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listIntegrations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListIntegrationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetIntegrationsSummaryUrl = (params?: GetIntegrationsSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/integrations-summary?${stringifiedParams}` : `/api/integrations-summary`
}

export const getIntegrationsSummary = async (params?: GetIntegrationsSummaryParams, options?: RequestInit): Promise<IntegrationSummary> => {

  return customFetch<IntegrationSummary>(getGetIntegrationsSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetIntegrationsSummaryQueryKey = (params?: GetIntegrationsSummaryParams,) => {
    return [
    `/api/integrations-summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetIntegrationsSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationsSummary>>, TError = ErrorType<void>>(params?: GetIntegrationsSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationsSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationsSummary>>> = ({ signal }) => getIntegrationsSummary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetIntegrationsSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationsSummary>>>
export type GetIntegrationsSummaryQueryError = ErrorType<void>



export function useGetIntegrationsSummary<TData = Awaited<ReturnType<typeof getIntegrationsSummary>>, TError = ErrorType<void>>(
 params?: GetIntegrationsSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetIntegrationsSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetIntegrationOverviewUrl = (slug: string,
    params?: GetIntegrationOverviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/integrations/${slug}/overview?${stringifiedParams}` : `/api/integrations/${slug}/overview`
}

export const getIntegrationOverview = async (slug: string,
    params?: GetIntegrationOverviewParams, options?: RequestInit): Promise<GetIntegrationOverview200> => {

  return customFetch<GetIntegrationOverview200>(getGetIntegrationOverviewUrl(slug,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetIntegrationOverviewQueryKey = (slug: string,
    params?: GetIntegrationOverviewParams,) => {
    return [
    `/api/integrations/${slug}/overview`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetIntegrationOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationOverview>>, TError = ErrorType<void>>(slug: string,
    params?: GetIntegrationOverviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntegrationOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationOverviewQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationOverview>>> = ({ signal }) => getIntegrationOverview(slug,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationOverview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetIntegrationOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationOverview>>>
export type GetIntegrationOverviewQueryError = ErrorType<void>



export function useGetIntegrationOverview<TData = Awaited<ReturnType<typeof getIntegrationOverview>>, TError = ErrorType<void>>(
 slug: string,
    params?: GetIntegrationOverviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntegrationOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetIntegrationOverviewQueryOptions(slug,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetIntegrationSettingsUrl = (slug: string,
    params?: GetIntegrationSettingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/integrations/${slug}/settings?${stringifiedParams}` : `/api/integrations/${slug}/settings`
}

export const getIntegrationSettings = async (slug: string,
    params?: GetIntegrationSettingsParams, options?: RequestInit): Promise<GetIntegrationSettings200> => {

  return customFetch<GetIntegrationSettings200>(getGetIntegrationSettingsUrl(slug,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetIntegrationSettingsQueryKey = (slug: string,
    params?: GetIntegrationSettingsParams,) => {
    return [
    `/api/integrations/${slug}/settings`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetIntegrationSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationSettings>>, TError = ErrorType<unknown>>(slug: string,
    params?: GetIntegrationSettingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntegrationSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationSettingsQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationSettings>>> = ({ signal }) => getIntegrationSettings(slug,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetIntegrationSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationSettings>>>
export type GetIntegrationSettingsQueryError = ErrorType<unknown>



export function useGetIntegrationSettings<TData = Awaited<ReturnType<typeof getIntegrationSettings>>, TError = ErrorType<unknown>>(
 slug: string,
    params?: GetIntegrationSettingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntegrationSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetIntegrationSettingsQueryOptions(slug,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetIntegrationMappingsUrl = (slug: string,
    params?: GetIntegrationMappingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/integrations/${slug}/mappings?${stringifiedParams}` : `/api/integrations/${slug}/mappings`
}

export const getIntegrationMappings = async (slug: string,
    params?: GetIntegrationMappingsParams, options?: RequestInit): Promise<GetIntegrationMappings200> => {

  return customFetch<GetIntegrationMappings200>(getGetIntegrationMappingsUrl(slug,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetIntegrationMappingsQueryKey = (slug: string,
    params?: GetIntegrationMappingsParams,) => {
    return [
    `/api/integrations/${slug}/mappings`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetIntegrationMappingsQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationMappings>>, TError = ErrorType<unknown>>(slug: string,
    params?: GetIntegrationMappingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntegrationMappings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationMappingsQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationMappings>>> = ({ signal }) => getIntegrationMappings(slug,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationMappings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetIntegrationMappingsQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationMappings>>>
export type GetIntegrationMappingsQueryError = ErrorType<unknown>



export function useGetIntegrationMappings<TData = Awaited<ReturnType<typeof getIntegrationMappings>>, TError = ErrorType<unknown>>(
 slug: string,
    params?: GetIntegrationMappingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntegrationMappings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetIntegrationMappingsQueryOptions(slug,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetIntegrationActivityUrl = (slug: string,
    params?: GetIntegrationActivityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/integrations/${slug}/activity?${stringifiedParams}` : `/api/integrations/${slug}/activity`
}

export const getIntegrationActivity = async (slug: string,
    params?: GetIntegrationActivityParams, options?: RequestInit): Promise<IntegrationPage> => {

  return customFetch<IntegrationPage>(getGetIntegrationActivityUrl(slug,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetIntegrationActivityQueryKey = (slug: string,
    params?: GetIntegrationActivityParams,) => {
    return [
    `/api/integrations/${slug}/activity`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetIntegrationActivityQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationActivity>>, TError = ErrorType<void>>(slug: string,
    params?: GetIntegrationActivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntegrationActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationActivityQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationActivity>>> = ({ signal }) => getIntegrationActivity(slug,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetIntegrationActivityQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationActivity>>>
export type GetIntegrationActivityQueryError = ErrorType<void>



export function useGetIntegrationActivity<TData = Awaited<ReturnType<typeof getIntegrationActivity>>, TError = ErrorType<void>>(
 slug: string,
    params?: GetIntegrationActivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntegrationActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetIntegrationActivityQueryOptions(slug,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetIntegrationWebhooksUrl = (slug: string,
    params?: GetIntegrationWebhooksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/integrations/${slug}/webhooks?${stringifiedParams}` : `/api/integrations/${slug}/webhooks`
}

export const getIntegrationWebhooks = async (slug: string,
    params?: GetIntegrationWebhooksParams, options?: RequestInit): Promise<IntegrationPage> => {

  return customFetch<IntegrationPage>(getGetIntegrationWebhooksUrl(slug,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetIntegrationWebhooksQueryKey = (slug: string,
    params?: GetIntegrationWebhooksParams,) => {
    return [
    `/api/integrations/${slug}/webhooks`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetIntegrationWebhooksQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationWebhooks>>, TError = ErrorType<void>>(slug: string,
    params?: GetIntegrationWebhooksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntegrationWebhooks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationWebhooksQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationWebhooks>>> = ({ signal }) => getIntegrationWebhooks(slug,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationWebhooks>>, TError, TData> & { queryKey: QueryKey }
}

export type GetIntegrationWebhooksQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationWebhooks>>>
export type GetIntegrationWebhooksQueryError = ErrorType<void>



export function useGetIntegrationWebhooks<TData = Awaited<ReturnType<typeof getIntegrationWebhooks>>, TError = ErrorType<void>>(
 slug: string,
    params?: GetIntegrationWebhooksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntegrationWebhooks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetIntegrationWebhooksQueryOptions(slug,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetIntegrationAdvancedUrl = (slug: string,
    params?: GetIntegrationAdvancedParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/integrations/${slug}/advanced?${stringifiedParams}` : `/api/integrations/${slug}/advanced`
}

export const getIntegrationAdvanced = async (slug: string,
    params?: GetIntegrationAdvancedParams, options?: RequestInit): Promise<GetIntegrationAdvanced200> => {

  return customFetch<GetIntegrationAdvanced200>(getGetIntegrationAdvancedUrl(slug,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetIntegrationAdvancedQueryKey = (slug: string,
    params?: GetIntegrationAdvancedParams,) => {
    return [
    `/api/integrations/${slug}/advanced`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetIntegrationAdvancedQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationAdvanced>>, TError = ErrorType<unknown>>(slug: string,
    params?: GetIntegrationAdvancedParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntegrationAdvanced>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationAdvancedQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationAdvanced>>> = ({ signal }) => getIntegrationAdvanced(slug,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationAdvanced>>, TError, TData> & { queryKey: QueryKey }
}

export type GetIntegrationAdvancedQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationAdvanced>>>
export type GetIntegrationAdvancedQueryError = ErrorType<unknown>



export function useGetIntegrationAdvanced<TData = Awaited<ReturnType<typeof getIntegrationAdvanced>>, TError = ErrorType<unknown>>(
 slug: string,
    params?: GetIntegrationAdvancedParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntegrationAdvanced>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetIntegrationAdvancedQueryOptions(slug,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetIntegrationLogsUrl = (slug: string,
    params?: GetIntegrationLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/integrations/${slug}/logs?${stringifiedParams}` : `/api/integrations/${slug}/logs`
}

export const getIntegrationLogs = async (slug: string,
    params?: GetIntegrationLogsParams, options?: RequestInit): Promise<IntegrationPage> => {

  return customFetch<IntegrationPage>(getGetIntegrationLogsUrl(slug,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetIntegrationLogsQueryKey = (slug: string,
    params?: GetIntegrationLogsParams,) => {
    return [
    `/api/integrations/${slug}/logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetIntegrationLogsQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationLogs>>, TError = ErrorType<void>>(slug: string,
    params?: GetIntegrationLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntegrationLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationLogsQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationLogs>>> = ({ signal }) => getIntegrationLogs(slug,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetIntegrationLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationLogs>>>
export type GetIntegrationLogsQueryError = ErrorType<void>



export function useGetIntegrationLogs<TData = Awaited<ReturnType<typeof getIntegrationLogs>>, TError = ErrorType<void>>(
 slug: string,
    params?: GetIntegrationLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntegrationLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetIntegrationLogsQueryOptions(slug,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getQueueIntegrationSyncUrl = (slug: string,
    params?: QueueIntegrationSyncParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/integrations/${slug}/actions/sync?${stringifiedParams}` : `/api/integrations/${slug}/actions/sync`
}

export const queueIntegrationSync = async (slug: string,
    params?: QueueIntegrationSyncParams, options?: RequestInit): Promise<IntegrationQueuedAction> => {

  return customFetch<IntegrationQueuedAction>(getQueueIntegrationSyncUrl(slug,params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getQueueIntegrationSyncMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof queueIntegrationSync>>, TError,{slug: string;params?: QueueIntegrationSyncParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof queueIntegrationSync>>, TError,{slug: string;params?: QueueIntegrationSyncParams}, TContext> => {

const mutationKey = ['queueIntegrationSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof queueIntegrationSync>>, {slug: string;params?: QueueIntegrationSyncParams}> = (props) => {
          const {slug,params} = props ?? {};

          return  queueIntegrationSync(slug,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type QueueIntegrationSyncMutationResult = NonNullable<Awaited<ReturnType<typeof queueIntegrationSync>>>

    export type QueueIntegrationSyncMutationError = ErrorType<void>

    export const useQueueIntegrationSync = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof queueIntegrationSync>>, TError,{slug: string;params?: QueueIntegrationSyncParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof queueIntegrationSync>>,
        TError,
        {slug: string;params?: QueueIntegrationSyncParams},
        TContext
      > => {
      return useMutation(getQueueIntegrationSyncMutationOptions(options));
    }

export const getUpdateIntegrationUrl = (slug: string,) => {




  return `/api/integrations/${slug}`
}

export const updateIntegration = async (slug: string,
    integrationUpdate: IntegrationUpdate, options?: RequestInit): Promise<MarketplaceIntegration> => {

  return customFetch<MarketplaceIntegration>(getUpdateIntegrationUrl(slug),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(integrationUpdate)
  }
);}





export const getUpdateIntegrationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateIntegration>>, TError,{slug: string;data: BodyType<IntegrationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateIntegration>>, TError,{slug: string;data: BodyType<IntegrationUpdate>}, TContext> => {

const mutationKey = ['updateIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateIntegration>>, {slug: string;data: BodyType<IntegrationUpdate>}> = (props) => {
          const {slug,data} = props ?? {};

          return  updateIntegration(slug,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof updateIntegration>>>
    export type UpdateIntegrationMutationBody = BodyType<IntegrationUpdate>
    export type UpdateIntegrationMutationError = ErrorType<unknown>

    export const useUpdateIntegration = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateIntegration>>, TError,{slug: string;data: BodyType<IntegrationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateIntegration>>,
        TError,
        {slug: string;data: BodyType<IntegrationUpdate>},
        TContext
      > => {
      return useMutation(getUpdateIntegrationMutationOptions(options));
    }

export const getListWooCategoriesUrl = () => {




  return `/api/integrations/woocommerce/categories`
}

/**
 * @summary List WooCommerce product categories (proxied from WC).
 */
export const listWooCategories = async ( options?: RequestInit): Promise<WooTerm[]> => {

  return customFetch<WooTerm[]>(getListWooCategoriesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListWooCategoriesQueryKey = () => {
    return [
    `/api/integrations/woocommerce/categories`
    ] as const;
    }


export const getListWooCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof listWooCategories>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWooCategories>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWooCategoriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWooCategories>>> = ({ signal }) => listWooCategories({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWooCategories>>, TError, TData> & { queryKey: QueryKey }
}

export type ListWooCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof listWooCategories>>>
export type ListWooCategoriesQueryError = ErrorType<unknown>


/**
 * @summary List WooCommerce product categories (proxied from WC).
 */

export function useListWooCategories<TData = Awaited<ReturnType<typeof listWooCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWooCategories>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListWooCategoriesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateWooCategoryUrl = () => {




  return `/api/integrations/woocommerce/categories`
}

/**
 * @summary Create a new WC product category. Returns the existing term on `term_exists`.
 */
export const createWooCategory = async (createWooCategoryInput: CreateWooCategoryInput, options?: RequestInit): Promise<WooTerm> => {

  return customFetch<WooTerm>(getCreateWooCategoryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createWooCategoryInput)
  }
);}





export const getCreateWooCategoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWooCategory>>, TError,{data: BodyType<CreateWooCategoryInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createWooCategory>>, TError,{data: BodyType<CreateWooCategoryInput>}, TContext> => {

const mutationKey = ['createWooCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWooCategory>>, {data: BodyType<CreateWooCategoryInput>}> = (props) => {
          const {data} = props ?? {};

          return  createWooCategory(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWooCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof createWooCategory>>>
    export type CreateWooCategoryMutationBody = BodyType<CreateWooCategoryInput>
    export type CreateWooCategoryMutationError = ErrorType<unknown>

    /**
 * @summary Create a new WC product category. Returns the existing term on `term_exists`.
 */
export const useCreateWooCategory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWooCategory>>, TError,{data: BodyType<CreateWooCategoryInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createWooCategory>>,
        TError,
        {data: BodyType<CreateWooCategoryInput>},
        TContext
      > => {
      return useMutation(getCreateWooCategoryMutationOptions(options));
    }

export const getListWooBrandsUrl = () => {




  return `/api/integrations/woocommerce/brands`
}

/**
 * @summary List WooCommerce brand taxonomy terms (WC 9.6+ native brands).
 */
export const listWooBrands = async ( options?: RequestInit): Promise<WooTerm[]> => {

  return customFetch<WooTerm[]>(getListWooBrandsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListWooBrandsQueryKey = () => {
    return [
    `/api/integrations/woocommerce/brands`
    ] as const;
    }


export const getListWooBrandsQueryOptions = <TData = Awaited<ReturnType<typeof listWooBrands>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWooBrands>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWooBrandsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWooBrands>>> = ({ signal }) => listWooBrands({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWooBrands>>, TError, TData> & { queryKey: QueryKey }
}

export type ListWooBrandsQueryResult = NonNullable<Awaited<ReturnType<typeof listWooBrands>>>
export type ListWooBrandsQueryError = ErrorType<unknown>


/**
 * @summary List WooCommerce brand taxonomy terms (WC 9.6+ native brands).
 */

export function useListWooBrands<TData = Awaited<ReturnType<typeof listWooBrands>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWooBrands>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListWooBrandsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateWooBrandUrl = () => {




  return `/api/integrations/woocommerce/brands`
}

/**
 * @summary Create a new WC brand. Returns the existing term on `term_exists`.
 */
export const createWooBrand = async (createWooBrandInput: CreateWooBrandInput, options?: RequestInit): Promise<WooTerm> => {

  return customFetch<WooTerm>(getCreateWooBrandUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createWooBrandInput)
  }
);}





export const getCreateWooBrandMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWooBrand>>, TError,{data: BodyType<CreateWooBrandInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createWooBrand>>, TError,{data: BodyType<CreateWooBrandInput>}, TContext> => {

const mutationKey = ['createWooBrand'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWooBrand>>, {data: BodyType<CreateWooBrandInput>}> = (props) => {
          const {data} = props ?? {};

          return  createWooBrand(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWooBrandMutationResult = NonNullable<Awaited<ReturnType<typeof createWooBrand>>>
    export type CreateWooBrandMutationBody = BodyType<CreateWooBrandInput>
    export type CreateWooBrandMutationError = ErrorType<unknown>

    /**
 * @summary Create a new WC brand. Returns the existing term on `term_exists`.
 */
export const useCreateWooBrand = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWooBrand>>, TError,{data: BodyType<CreateWooBrandInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createWooBrand>>,
        TError,
        {data: BodyType<CreateWooBrandInput>},
        TContext
      > => {
      return useMutation(getCreateWooBrandMutationOptions(options));
    }

export const getListWooTagsUrl = () => {




  return `/api/integrations/woocommerce/tags`
}

/**
 * @summary List WooCommerce product tags (proxied from WC).
 */
export const listWooTags = async ( options?: RequestInit): Promise<WooTerm[]> => {

  return customFetch<WooTerm[]>(getListWooTagsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListWooTagsQueryKey = () => {
    return [
    `/api/integrations/woocommerce/tags`
    ] as const;
    }


export const getListWooTagsQueryOptions = <TData = Awaited<ReturnType<typeof listWooTags>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWooTags>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWooTagsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWooTags>>> = ({ signal }) => listWooTags({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWooTags>>, TError, TData> & { queryKey: QueryKey }
}

export type ListWooTagsQueryResult = NonNullable<Awaited<ReturnType<typeof listWooTags>>>
export type ListWooTagsQueryError = ErrorType<unknown>


/**
 * @summary List WooCommerce product tags (proxied from WC).
 */

export function useListWooTags<TData = Awaited<ReturnType<typeof listWooTags>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWooTags>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListWooTagsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListWoocommerceSyncedProductsUrl = () => {




  return `/api/integrations/woocommerce/synced-products`
}

/**
 * Inventory items that are currently mirrored to WooCommerce (have a
 * `externalListings.woocommerce.productId`) or have a recorded push
 * failure, plus aggregate counters for the WooCommerce integration
 * dashboard. Returns:
 *   - `counts.synced` — items with a WooCommerce product id (incl. failures)
 *   - `counts.failed` — items whose last push errored (with or without a product id)
 *   - `counts.eligible` — items NOT yet synced but ready to push (all
 *     required fields filled)
 * Used by the Integrations → WooCommerce → Synced Products tab.
 */
export const listWoocommerceSyncedProducts = async ( options?: RequestInit): Promise<WoocommerceSyncedProductsResult> => {

  return customFetch<WoocommerceSyncedProductsResult>(getListWoocommerceSyncedProductsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListWoocommerceSyncedProductsQueryKey = () => {
    return [
    `/api/integrations/woocommerce/synced-products`
    ] as const;
    }


export const getListWoocommerceSyncedProductsQueryOptions = <TData = Awaited<ReturnType<typeof listWoocommerceSyncedProducts>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWoocommerceSyncedProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWoocommerceSyncedProductsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWoocommerceSyncedProducts>>> = ({ signal }) => listWoocommerceSyncedProducts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWoocommerceSyncedProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListWoocommerceSyncedProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listWoocommerceSyncedProducts>>>
export type ListWoocommerceSyncedProductsQueryError = ErrorType<unknown>



export function useListWoocommerceSyncedProducts<TData = Awaited<ReturnType<typeof listWoocommerceSyncedProducts>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWoocommerceSyncedProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListWoocommerceSyncedProductsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getTriggerStockSyncUrl = (slug: string,) => {




  return `/api/integrations/${slug}/sync`
}

export const triggerStockSync = async (slug: string,
    triggerSyncBody?: TriggerSyncBody, options?: RequestInit): Promise<StockSyncJob> => {

  return customFetch<StockSyncJob>(getTriggerStockSyncUrl(slug),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(triggerSyncBody)
  }
);}





export const getTriggerStockSyncMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerStockSync>>, TError,{slug: string;data?: BodyType<TriggerSyncBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof triggerStockSync>>, TError,{slug: string;data?: BodyType<TriggerSyncBody>}, TContext> => {

const mutationKey = ['triggerStockSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggerStockSync>>, {slug: string;data?: BodyType<TriggerSyncBody>}> = (props) => {
          const {slug,data} = props ?? {};

          return  triggerStockSync(slug,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TriggerStockSyncMutationResult = NonNullable<Awaited<ReturnType<typeof triggerStockSync>>>
    export type TriggerStockSyncMutationBody = BodyType<TriggerSyncBody> | undefined
    export type TriggerStockSyncMutationError = ErrorType<unknown>

    export const useTriggerStockSync = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerStockSync>>, TError,{slug: string;data?: BodyType<TriggerSyncBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof triggerStockSync>>,
        TError,
        {slug: string;data?: BodyType<TriggerSyncBody>},
        TContext
      > => {
      return useMutation(getTriggerStockSyncMutationOptions(options));
    }

export const getTestShopifyConnectionUrl = () => {




  return `/api/integrations/shopify/test`
}

/**
 * Verifies stored Shopify credentials by calling /shop.json with the Admin API access token.
 */
export const testShopifyConnection = async ( options?: RequestInit): Promise<ShopifyTestResult> => {

  return customFetch<ShopifyTestResult>(getTestShopifyConnectionUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getTestShopifyConnectionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testShopifyConnection>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testShopifyConnection>>, TError,void, TContext> => {

const mutationKey = ['testShopifyConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testShopifyConnection>>, void> = () => {


          return  testShopifyConnection(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestShopifyConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof testShopifyConnection>>>

    export type TestShopifyConnectionMutationError = ErrorType<unknown>

    export const useTestShopifyConnection = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testShopifyConnection>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof testShopifyConnection>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getTestShopifyConnectionMutationOptions(options));
    }

export const getPullShopifyInventoryUrl = () => {




  return `/api/integrations/shopify/pull-inventory`
}

/**
 * Kicks off a background pull of every Shopify product+variant into the local inventory_items table (one row per variant, keyed by SKU). Returns the import_logs.id immediately so the caller can poll /imports/logs/{id} for progress.
 */
export const pullShopifyInventory = async ( options?: RequestInit): Promise<PullShopifyInventory200> => {

  return customFetch<PullShopifyInventory200>(getPullShopifyInventoryUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPullShopifyInventoryMutationOptions = <TError = ErrorType<PullShopifyInventory502>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pullShopifyInventory>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pullShopifyInventory>>, TError,void, TContext> => {

const mutationKey = ['pullShopifyInventory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pullShopifyInventory>>, void> = () => {


          return  pullShopifyInventory(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PullShopifyInventoryMutationResult = NonNullable<Awaited<ReturnType<typeof pullShopifyInventory>>>

    export type PullShopifyInventoryMutationError = ErrorType<PullShopifyInventory502>

    export const usePullShopifyInventory = <TError = ErrorType<PullShopifyInventory502>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pullShopifyInventory>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof pullShopifyInventory>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPullShopifyInventoryMutationOptions(options));
    }

export const getListShopifySyncedProductsUrl = () => {




  return `/api/integrations/shopify/synced-products`
}

/**
 * Inventory items that are currently mirrored to Shopify (have a
 * `externalListings.shopify.productId`), plus aggregate counters for
 * the Shopify integration dashboard. Returns:
 *   - `counts.synced` — items with a Shopify product id (incl. failures)
 *   - `counts.failed` — synced items whose last push errored
 *   - `counts.eligible` — items NOT yet synced but ready to push (all
 *     required fields filled)
 * Used by the Integrations → Shopify → Synced Products tab.
 */
export const listShopifySyncedProducts = async ( options?: RequestInit): Promise<ShopifySyncedProductsResult> => {

  return customFetch<ShopifySyncedProductsResult>(getListShopifySyncedProductsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListShopifySyncedProductsQueryKey = () => {
    return [
    `/api/integrations/shopify/synced-products`
    ] as const;
    }


export const getListShopifySyncedProductsQueryOptions = <TData = Awaited<ReturnType<typeof listShopifySyncedProducts>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShopifySyncedProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListShopifySyncedProductsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listShopifySyncedProducts>>> = ({ signal }) => listShopifySyncedProducts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listShopifySyncedProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListShopifySyncedProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listShopifySyncedProducts>>>
export type ListShopifySyncedProductsQueryError = ErrorType<unknown>



export function useListShopifySyncedProducts<TData = Awaited<ReturnType<typeof listShopifySyncedProducts>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShopifySyncedProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListShopifySyncedProductsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPreviewShopifyDeliveryBackfillUrl = () => {




  return `/api/integrations/shopify/delivery-backfill/preview`
}

/**
 * @summary Preview eligible Shopify delivery recovery orders
 */
export const previewShopifyDeliveryBackfill = async ( options?: RequestInit): Promise<ShopifyDeliveryBackfillPreview> => {

  return customFetch<ShopifyDeliveryBackfillPreview>(getPreviewShopifyDeliveryBackfillUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPreviewShopifyDeliveryBackfillQueryKey = () => {
    return [
    `/api/integrations/shopify/delivery-backfill/preview`
    ] as const;
    }


export const getPreviewShopifyDeliveryBackfillQueryOptions = <TData = Awaited<ReturnType<typeof previewShopifyDeliveryBackfill>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof previewShopifyDeliveryBackfill>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewShopifyDeliveryBackfillQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewShopifyDeliveryBackfill>>> = ({ signal }) => previewShopifyDeliveryBackfill({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewShopifyDeliveryBackfill>>, TError, TData> & { queryKey: QueryKey }
}

export type PreviewShopifyDeliveryBackfillQueryResult = NonNullable<Awaited<ReturnType<typeof previewShopifyDeliveryBackfill>>>
export type PreviewShopifyDeliveryBackfillQueryError = ErrorType<unknown>


/**
 * @summary Preview eligible Shopify delivery recovery orders
 */

export function usePreviewShopifyDeliveryBackfill<TData = Awaited<ReturnType<typeof previewShopifyDeliveryBackfill>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof previewShopifyDeliveryBackfill>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPreviewShopifyDeliveryBackfillQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListShopifyDeliveryBackfillRunsUrl = () => {




  return `/api/integrations/shopify/delivery-backfill/runs`
}

/**
 * @summary List recent Shopify delivery recovery runs
 */
export const listShopifyDeliveryBackfillRuns = async ( options?: RequestInit): Promise<ListShopifyDeliveryBackfillRuns200> => {

  return customFetch<ListShopifyDeliveryBackfillRuns200>(getListShopifyDeliveryBackfillRunsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListShopifyDeliveryBackfillRunsQueryKey = () => {
    return [
    `/api/integrations/shopify/delivery-backfill/runs`
    ] as const;
    }


export const getListShopifyDeliveryBackfillRunsQueryOptions = <TData = Awaited<ReturnType<typeof listShopifyDeliveryBackfillRuns>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShopifyDeliveryBackfillRuns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListShopifyDeliveryBackfillRunsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listShopifyDeliveryBackfillRuns>>> = ({ signal }) => listShopifyDeliveryBackfillRuns({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listShopifyDeliveryBackfillRuns>>, TError, TData> & { queryKey: QueryKey }
}

export type ListShopifyDeliveryBackfillRunsQueryResult = NonNullable<Awaited<ReturnType<typeof listShopifyDeliveryBackfillRuns>>>
export type ListShopifyDeliveryBackfillRunsQueryError = ErrorType<unknown>


/**
 * @summary List recent Shopify delivery recovery runs
 */

export function useListShopifyDeliveryBackfillRuns<TData = Awaited<ReturnType<typeof listShopifyDeliveryBackfillRuns>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShopifyDeliveryBackfillRuns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListShopifyDeliveryBackfillRunsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getStartShopifyDeliveryBackfillUrl = () => {




  return `/api/integrations/shopify/delivery-backfill/runs`
}

/**
 * @summary Start an explicitly requested bounded Shopify delivery backfill
 */
export const startShopifyDeliveryBackfill = async ( options?: RequestInit): Promise<StartShopifyDeliveryBackfill201> => {

  return customFetch<StartShopifyDeliveryBackfill201>(getStartShopifyDeliveryBackfillUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getStartShopifyDeliveryBackfillMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startShopifyDeliveryBackfill>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startShopifyDeliveryBackfill>>, TError,void, TContext> => {

const mutationKey = ['startShopifyDeliveryBackfill'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startShopifyDeliveryBackfill>>, void> = () => {


          return  startShopifyDeliveryBackfill(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartShopifyDeliveryBackfillMutationResult = NonNullable<Awaited<ReturnType<typeof startShopifyDeliveryBackfill>>>

    export type StartShopifyDeliveryBackfillMutationError = ErrorType<void>

    /**
 * @summary Start an explicitly requested bounded Shopify delivery backfill
 */
export const useStartShopifyDeliveryBackfill = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startShopifyDeliveryBackfill>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof startShopifyDeliveryBackfill>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getStartShopifyDeliveryBackfillMutationOptions(options));
    }

export const getContinueShopifyDeliveryBackfillUrl = (runId: string,) => {




  return `/api/integrations/shopify/delivery-backfill/runs/${runId}/continue`
}

/**
 * @summary Continue one bounded page of a resumable Shopify delivery backfill
 */
export const continueShopifyDeliveryBackfill = async (runId: string, options?: RequestInit): Promise<ContinueShopifyDeliveryBackfill200> => {

  return customFetch<ContinueShopifyDeliveryBackfill200>(getContinueShopifyDeliveryBackfillUrl(runId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getContinueShopifyDeliveryBackfillMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof continueShopifyDeliveryBackfill>>, TError,{runId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof continueShopifyDeliveryBackfill>>, TError,{runId: string}, TContext> => {

const mutationKey = ['continueShopifyDeliveryBackfill'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof continueShopifyDeliveryBackfill>>, {runId: string}> = (props) => {
          const {runId} = props ?? {};

          return  continueShopifyDeliveryBackfill(runId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ContinueShopifyDeliveryBackfillMutationResult = NonNullable<Awaited<ReturnType<typeof continueShopifyDeliveryBackfill>>>

    export type ContinueShopifyDeliveryBackfillMutationError = ErrorType<void>

    /**
 * @summary Continue one bounded page of a resumable Shopify delivery backfill
 */
export const useContinueShopifyDeliveryBackfill = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof continueShopifyDeliveryBackfill>>, TError,{runId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof continueShopifyDeliveryBackfill>>,
        TError,
        {runId: string},
        TContext
      > => {
      return useMutation(getContinueShopifyDeliveryBackfillMutationOptions(options));
    }

export const getRetryShopifyDeliveryBackfillOrdersUrl = (runId: string,) => {




  return `/api/integrations/shopify/delivery-backfill/runs/${runId}/retry`
}

/**
 * @summary Retry selected unresolved orders from a saved Shopify delivery backfill run
 */
export const retryShopifyDeliveryBackfillOrders = async (runId: string,
    shopifyDeliveryBackfillRetryInput: ShopifyDeliveryBackfillRetryInput, options?: RequestInit): Promise<ShopifyDeliveryBackfillRetryResult> => {

  return customFetch<ShopifyDeliveryBackfillRetryResult>(getRetryShopifyDeliveryBackfillOrdersUrl(runId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(shopifyDeliveryBackfillRetryInput)
  }
);}





export const getRetryShopifyDeliveryBackfillOrdersMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryShopifyDeliveryBackfillOrders>>, TError,{runId: string;data: BodyType<ShopifyDeliveryBackfillRetryInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof retryShopifyDeliveryBackfillOrders>>, TError,{runId: string;data: BodyType<ShopifyDeliveryBackfillRetryInput>}, TContext> => {

const mutationKey = ['retryShopifyDeliveryBackfillOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryShopifyDeliveryBackfillOrders>>, {runId: string;data: BodyType<ShopifyDeliveryBackfillRetryInput>}> = (props) => {
          const {runId,data} = props ?? {};

          return  retryShopifyDeliveryBackfillOrders(runId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryShopifyDeliveryBackfillOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof retryShopifyDeliveryBackfillOrders>>>
    export type RetryShopifyDeliveryBackfillOrdersMutationBody = BodyType<ShopifyDeliveryBackfillRetryInput>
    export type RetryShopifyDeliveryBackfillOrdersMutationError = ErrorType<void>

    /**
 * @summary Retry selected unresolved orders from a saved Shopify delivery backfill run
 */
export const useRetryShopifyDeliveryBackfillOrders = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryShopifyDeliveryBackfillOrders>>, TError,{runId: string;data: BodyType<ShopifyDeliveryBackfillRetryInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof retryShopifyDeliveryBackfillOrders>>,
        TError,
        {runId: string;data: BodyType<ShopifyDeliveryBackfillRetryInput>},
        TContext
      > => {
      return useMutation(getRetryShopifyDeliveryBackfillOrdersMutationOptions(options));
    }

export const getPullShopifyOrdersUrl = () => {




  return `/api/integrations/shopify/pull-orders`
}

/**
 * Pulls Shopify orders since the integration cursor, or by the requested updated/created timestamp, and creates Sale records for any not yet imported.
 */
export const pullShopifyOrders = async (channelPullOrdersRequest?: ChannelPullOrdersRequest, options?: RequestInit): Promise<ChannelPullOrdersResult> => {

  return customFetch<ChannelPullOrdersResult>(getPullShopifyOrdersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(channelPullOrdersRequest)
  }
);}





export const getPullShopifyOrdersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pullShopifyOrders>>, TError,{data?: BodyType<ChannelPullOrdersRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pullShopifyOrders>>, TError,{data?: BodyType<ChannelPullOrdersRequest>}, TContext> => {

const mutationKey = ['pullShopifyOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pullShopifyOrders>>, {data?: BodyType<ChannelPullOrdersRequest>}> = (props) => {
          const {data} = props ?? {};

          return  pullShopifyOrders(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PullShopifyOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof pullShopifyOrders>>>
    export type PullShopifyOrdersMutationBody = BodyType<ChannelPullOrdersRequest> | undefined
    export type PullShopifyOrdersMutationError = ErrorType<unknown>

    export const usePullShopifyOrders = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pullShopifyOrders>>, TError,{data?: BodyType<ChannelPullOrdersRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof pullShopifyOrders>>,
        TError,
        {data?: BodyType<ChannelPullOrdersRequest>},
        TContext
      > => {
      return useMutation(getPullShopifyOrdersMutationOptions(options));
    }

export const getPublishAllShopifyToGoogleYouTubeUrl = () => {




  return `/api/integrations/shopify/publish-all-google-youtube`
}

/**
 * Backfill: publish EVERY product on the connected Shopify store to the
 * "Google & YouTube" sales channel publication so existing products become
 * eligible for the Google Merchant Center / Google & YouTube feed. Runs in
 * the background (returns immediately). Idempotent — re-publishing an
 * already-published product is a no-op. Requires the Shopify app to carry
 * the `read_publications` and `write_publications` scopes.
 */
export const publishAllShopifyToGoogleYouTube = async ( options?: RequestInit): Promise<PublishAllShopifyToGoogleYouTube200> => {

  return customFetch<PublishAllShopifyToGoogleYouTube200>(getPublishAllShopifyToGoogleYouTubeUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPublishAllShopifyToGoogleYouTubeMutationOptions = <TError = ErrorType<PublishAllShopifyToGoogleYouTube409>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishAllShopifyToGoogleYouTube>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof publishAllShopifyToGoogleYouTube>>, TError,void, TContext> => {

const mutationKey = ['publishAllShopifyToGoogleYouTube'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishAllShopifyToGoogleYouTube>>, void> = () => {


          return  publishAllShopifyToGoogleYouTube(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishAllShopifyToGoogleYouTubeMutationResult = NonNullable<Awaited<ReturnType<typeof publishAllShopifyToGoogleYouTube>>>

    export type PublishAllShopifyToGoogleYouTubeMutationError = ErrorType<PublishAllShopifyToGoogleYouTube409>

    export const usePublishAllShopifyToGoogleYouTube = <TError = ErrorType<PublishAllShopifyToGoogleYouTube409>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishAllShopifyToGoogleYouTube>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof publishAllShopifyToGoogleYouTube>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPublishAllShopifyToGoogleYouTubeMutationOptions(options));
    }

export const getPublishAllShopifyToWhatnotUrl = () => {




  return `/api/integrations/shopify/publish-all-whatnot`
}

/**
 * Backfill only active products on the connected Shopify store to the
 * exact "Whatnot" sales channel publication. Runs in the background
 * and records scanned, published, skipped, and failed totals in the
 * import log. Idempotent — already-published products are skipped.
 * Requires the Shopify app to carry the `read_publications` and
 * `write_publications` scopes.
 */
export const publishAllShopifyToWhatnot = async ( options?: RequestInit): Promise<PublishAllShopifyToWhatnot202> => {

  return customFetch<PublishAllShopifyToWhatnot202>(getPublishAllShopifyToWhatnotUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPublishAllShopifyToWhatnotMutationOptions = <TError = ErrorType<PublishAllShopifyToWhatnot409 | PublishAllShopifyToWhatnot502>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishAllShopifyToWhatnot>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof publishAllShopifyToWhatnot>>, TError,void, TContext> => {

const mutationKey = ['publishAllShopifyToWhatnot'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishAllShopifyToWhatnot>>, void> = () => {


          return  publishAllShopifyToWhatnot(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishAllShopifyToWhatnotMutationResult = NonNullable<Awaited<ReturnType<typeof publishAllShopifyToWhatnot>>>

    export type PublishAllShopifyToWhatnotMutationError = ErrorType<PublishAllShopifyToWhatnot409 | PublishAllShopifyToWhatnot502>

    export const usePublishAllShopifyToWhatnot = <TError = ErrorType<PublishAllShopifyToWhatnot409 | PublishAllShopifyToWhatnot502>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishAllShopifyToWhatnot>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof publishAllShopifyToWhatnot>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPublishAllShopifyToWhatnotMutationOptions(options));
    }

export const getPullShopifyCustomersUrl = () => {




  return `/api/integrations/shopify/pull-customers`
}

/**
 * Bulk-pulls customers from Shopify and upserts them into the local Customers table by email (or `shopify:<email>` external ref). Idempotent — existing fields are never overwritten with blanks.
 */
export const pullShopifyCustomers = async ( options?: RequestInit): Promise<ShopifyCustomerPullResult> => {

  return customFetch<ShopifyCustomerPullResult>(getPullShopifyCustomersUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPullShopifyCustomersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pullShopifyCustomers>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pullShopifyCustomers>>, TError,void, TContext> => {

const mutationKey = ['pullShopifyCustomers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pullShopifyCustomers>>, void> = () => {


          return  pullShopifyCustomers(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PullShopifyCustomersMutationResult = NonNullable<Awaited<ReturnType<typeof pullShopifyCustomers>>>

    export type PullShopifyCustomersMutationError = ErrorType<unknown>

    export const usePullShopifyCustomers = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pullShopifyCustomers>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof pullShopifyCustomers>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPullShopifyCustomersMutationOptions(options));
    }

export const getPullShopifyCompaniesUrl = () => {




  return `/api/integrations/shopify/pull-companies`
}

/**
 * Kicks off a background sync of every Shopify B2B Company (and its contacts) into the local
 * companies + customers tables. Companies are matched by Shopify GID, then email, then name.
 * Each contact's customer is matched by email or `shopify:id:<gid>` ref and either linked
 * to an existing customer or created with `customerType="Company"`. Returns the
 * `company_import_log.id` immediately so the caller can poll
 * `/integrations/company-imports/{id}` for progress. Requires Shopify Plus with B2B enabled.
 */
export const pullShopifyCompanies = async ( options?: RequestInit): Promise<PullShopifyCompanies200> => {

  return customFetch<PullShopifyCompanies200>(getPullShopifyCompaniesUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPullShopifyCompaniesMutationOptions = <TError = ErrorType<PullShopifyCompanies502>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pullShopifyCompanies>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pullShopifyCompanies>>, TError,void, TContext> => {

const mutationKey = ['pullShopifyCompanies'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pullShopifyCompanies>>, void> = () => {


          return  pullShopifyCompanies(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PullShopifyCompaniesMutationResult = NonNullable<Awaited<ReturnType<typeof pullShopifyCompanies>>>

    export type PullShopifyCompaniesMutationError = ErrorType<PullShopifyCompanies502>

    export const usePullShopifyCompanies = <TError = ErrorType<PullShopifyCompanies502>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pullShopifyCompanies>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof pullShopifyCompanies>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPullShopifyCompaniesMutationOptions(options));
    }

export const getGetCompanyImportLogUrl = (id: string,) => {




  return `/api/integrations/company-imports/${id}`
}

/**
 * Returns the current state of a company sync run for progress polling.
 */
export const getCompanyImportLog = async (id: string, options?: RequestInit): Promise<CompanyImportLog> => {

  return customFetch<CompanyImportLog>(getGetCompanyImportLogUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCompanyImportLogQueryKey = (id: string,) => {
    return [
    `/api/integrations/company-imports/${id}`
    ] as const;
    }


export const getGetCompanyImportLogQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyImportLog>>, TError = ErrorType<GetCompanyImportLog404>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyImportLog>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyImportLogQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyImportLog>>> = ({ signal }) => getCompanyImportLog(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyImportLog>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyImportLogQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyImportLog>>>
export type GetCompanyImportLogQueryError = ErrorType<GetCompanyImportLog404>



export function useGetCompanyImportLog<TData = Awaited<ReturnType<typeof getCompanyImportLog>>, TError = ErrorType<GetCompanyImportLog404>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyImportLog>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCompanyImportLogQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCompanyImportLogsUrl = () => {




  return `/api/integrations/company-imports`
}

/**
 * Returns the most recent (up to 20) Shopify Company sync runs.
 */
export const listCompanyImportLogs = async ( options?: RequestInit): Promise<ListCompanyImportLogs200> => {

  return customFetch<ListCompanyImportLogs200>(getListCompanyImportLogsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCompanyImportLogsQueryKey = () => {
    return [
    `/api/integrations/company-imports`
    ] as const;
    }


export const getListCompanyImportLogsQueryOptions = <TData = Awaited<ReturnType<typeof listCompanyImportLogs>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCompanyImportLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCompanyImportLogsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCompanyImportLogs>>> = ({ signal }) => listCompanyImportLogs({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCompanyImportLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCompanyImportLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listCompanyImportLogs>>>
export type ListCompanyImportLogsQueryError = ErrorType<unknown>



export function useListCompanyImportLogs<TData = Awaited<ReturnType<typeof listCompanyImportLogs>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCompanyImportLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCompanyImportLogsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRegisterShopifyWebhooksUrl = () => {




  return `/api/integrations/shopify/register-webhooks`
}

/**
 * Idempotently registers the standard webhooks (orders/create, orders/updated, orders/paid, orders/fulfilled, customers/create, products/update) on the configured Shopify shop. Stale entries pointing at other URLs are removed.
 */
export const registerShopifyWebhooks = async ( options?: RequestInit): Promise<ShopifyWebhookRegistrationResult> => {

  return customFetch<ShopifyWebhookRegistrationResult>(getRegisterShopifyWebhooksUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRegisterShopifyWebhooksMutationOptions = <TError = ErrorType<RegisterShopifyWebhooks400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerShopifyWebhooks>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof registerShopifyWebhooks>>, TError,void, TContext> => {

const mutationKey = ['registerShopifyWebhooks'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerShopifyWebhooks>>, void> = () => {


          return  registerShopifyWebhooks(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegisterShopifyWebhooksMutationResult = NonNullable<Awaited<ReturnType<typeof registerShopifyWebhooks>>>

    export type RegisterShopifyWebhooksMutationError = ErrorType<RegisterShopifyWebhooks400>

    export const useRegisterShopifyWebhooks = <TError = ErrorType<RegisterShopifyWebhooks400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerShopifyWebhooks>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof registerShopifyWebhooks>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRegisterShopifyWebhooksMutationOptions(options));
    }

export const getListShopifyWebhooksUrl = () => {




  return `/api/integrations/shopify/webhooks`
}

/**
 * Lists all webhooks currently registered on the configured Shopify shop.
 */
export const listShopifyWebhooks = async ( options?: RequestInit): Promise<ListShopifyWebhooks200> => {

  return customFetch<ListShopifyWebhooks200>(getListShopifyWebhooksUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListShopifyWebhooksQueryKey = () => {
    return [
    `/api/integrations/shopify/webhooks`
    ] as const;
    }


export const getListShopifyWebhooksQueryOptions = <TData = Awaited<ReturnType<typeof listShopifyWebhooks>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShopifyWebhooks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListShopifyWebhooksQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listShopifyWebhooks>>> = ({ signal }) => listShopifyWebhooks({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listShopifyWebhooks>>, TError, TData> & { queryKey: QueryKey }
}

export type ListShopifyWebhooksQueryResult = NonNullable<Awaited<ReturnType<typeof listShopifyWebhooks>>>
export type ListShopifyWebhooksQueryError = ErrorType<unknown>



export function useListShopifyWebhooks<TData = Awaited<ReturnType<typeof listShopifyWebhooks>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShopifyWebhooks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListShopifyWebhooksQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetShopifySyncStatusUrl = () => {




  return `/api/integrations/shopify/sync-status`
}

/**
 * Diagnostic snapshot for the Shopify integration. Returns current config state, last sync timestamp, registered webhook subscriptions vs. expected topics, recent webhook deliveries, recent imported orders, and an automated diagnosis of the most likely cause when orders aren't pulling in.
 */
export const getShopifySyncStatus = async ( options?: RequestInit): Promise<ShopifySyncStatus> => {

  return customFetch<ShopifySyncStatus>(getGetShopifySyncStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetShopifySyncStatusQueryKey = () => {
    return [
    `/api/integrations/shopify/sync-status`
    ] as const;
    }


export const getGetShopifySyncStatusQueryOptions = <TData = Awaited<ReturnType<typeof getShopifySyncStatus>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopifySyncStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShopifySyncStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShopifySyncStatus>>> = ({ signal }) => getShopifySyncStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShopifySyncStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetShopifySyncStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getShopifySyncStatus>>>
export type GetShopifySyncStatusQueryError = ErrorType<unknown>



export function useGetShopifySyncStatus<TData = Awaited<ReturnType<typeof getShopifySyncStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopifySyncStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetShopifySyncStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getTestEbayConnectionUrl = () => {




  return `/api/integrations/ebay/test`
}

/**
 * Verifies stored eBay credentials by exchanging the refresh token for an access token and calling a lightweight Sell API endpoint.
 */
export const testEbayConnection = async (ebayTestRequest: EbayTestRequest, options?: RequestInit): Promise<EbayTestResult> => {

  return customFetch<EbayTestResult>(getTestEbayConnectionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ebayTestRequest)
  }
);}





export const getTestEbayConnectionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testEbayConnection>>, TError,{data: BodyType<EbayTestRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testEbayConnection>>, TError,{data: BodyType<EbayTestRequest>}, TContext> => {

const mutationKey = ['testEbayConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testEbayConnection>>, {data: BodyType<EbayTestRequest>}> = (props) => {
          const {data} = props ?? {};

          return  testEbayConnection(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestEbayConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof testEbayConnection>>>
    export type TestEbayConnectionMutationBody = BodyType<EbayTestRequest>
    export type TestEbayConnectionMutationError = ErrorType<unknown>

    export const useTestEbayConnection = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testEbayConnection>>, TError,{data: BodyType<EbayTestRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof testEbayConnection>>,
        TError,
        {data: BodyType<EbayTestRequest>},
        TContext
      > => {
      return useMutation(getTestEbayConnectionMutationOptions(options));
    }

export const getStartEbayConnectionSweepUrl = () => {




  return `/api/platform/ebay-connection-sweep`
}

/**
 * Platform operations only. Enumerates active non-platform tenants and
 * every eBay account row, checking only configured and enabled accounts.
 * Results are stored on the durable background job and never include
 * credentials or provider payloads.
 * @summary Queue an all-tenant eBay connection health sweep.
 */
export const startEbayConnectionSweep = async ( options?: RequestInit): Promise<EbayConnectionSweepJobResponse> => {

  return customFetch<EbayConnectionSweepJobResponse>(getStartEbayConnectionSweepUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getStartEbayConnectionSweepMutationOptions = <TError = ErrorType<EbayConnectionSweepJobResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startEbayConnectionSweep>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startEbayConnectionSweep>>, TError,void, TContext> => {

const mutationKey = ['startEbayConnectionSweep'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startEbayConnectionSweep>>, void> = () => {


          return  startEbayConnectionSweep(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartEbayConnectionSweepMutationResult = NonNullable<Awaited<ReturnType<typeof startEbayConnectionSweep>>>

    export type StartEbayConnectionSweepMutationError = ErrorType<EbayConnectionSweepJobResponse>

    /**
 * @summary Queue an all-tenant eBay connection health sweep.
 */
export const useStartEbayConnectionSweep = <TError = ErrorType<EbayConnectionSweepJobResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startEbayConnectionSweep>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof startEbayConnectionSweep>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getStartEbayConnectionSweepMutationOptions(options));
    }

export const getGetEbayConnectionSweepUrl = (id: string,) => {




  return `/api/platform/ebay-connection-sweep/${id}`
}

/**
 * @summary Read a queued, running, or completed eBay connection sweep.
 */
export const getEbayConnectionSweep = async (id: string, options?: RequestInit): Promise<EbayConnectionSweepJobResponse> => {

  return customFetch<EbayConnectionSweepJobResponse>(getGetEbayConnectionSweepUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEbayConnectionSweepQueryKey = (id: string,) => {
    return [
    `/api/platform/ebay-connection-sweep/${id}`
    ] as const;
    }


export const getGetEbayConnectionSweepQueryOptions = <TData = Awaited<ReturnType<typeof getEbayConnectionSweep>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEbayConnectionSweep>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEbayConnectionSweepQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEbayConnectionSweep>>> = ({ signal }) => getEbayConnectionSweep(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEbayConnectionSweep>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEbayConnectionSweepQueryResult = NonNullable<Awaited<ReturnType<typeof getEbayConnectionSweep>>>
export type GetEbayConnectionSweepQueryError = ErrorType<void>


/**
 * @summary Read a queued, running, or completed eBay connection sweep.
 */

export function useGetEbayConnectionSweep<TData = Awaited<ReturnType<typeof getEbayConnectionSweep>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEbayConnectionSweep>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEbayConnectionSweepQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLatestEbayConnectionSweepUrl = () => {




  return `/api/platform/ebay-connection-sweep/latest`
}

/**
 * @summary Read the latest eBay connection sweep.
 */
export const getLatestEbayConnectionSweep = async ( options?: RequestInit): Promise<EbayConnectionSweepJobResponse> => {

  return customFetch<EbayConnectionSweepJobResponse>(getGetLatestEbayConnectionSweepUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLatestEbayConnectionSweepQueryKey = () => {
    return [
    `/api/platform/ebay-connection-sweep/latest`
    ] as const;
    }


export const getGetLatestEbayConnectionSweepQueryOptions = <TData = Awaited<ReturnType<typeof getLatestEbayConnectionSweep>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLatestEbayConnectionSweep>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLatestEbayConnectionSweepQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLatestEbayConnectionSweep>>> = ({ signal }) => getLatestEbayConnectionSweep({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLatestEbayConnectionSweep>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLatestEbayConnectionSweepQueryResult = NonNullable<Awaited<ReturnType<typeof getLatestEbayConnectionSweep>>>
export type GetLatestEbayConnectionSweepQueryError = ErrorType<unknown>


/**
 * @summary Read the latest eBay connection sweep.
 */

export function useGetLatestEbayConnectionSweep<TData = Awaited<ReturnType<typeof getLatestEbayConnectionSweep>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLatestEbayConnectionSweep>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLatestEbayConnectionSweepQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListLatestEbayConnectionSweepResultsUrl = (params?: ListLatestEbayConnectionSweepResultsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/platform/ebay-connection-sweep/latest/results?${stringifiedParams}` : `/api/platform/ebay-connection-sweep/latest/results`
}

/**
 * @summary Filter or export the safe rows from the latest eBay connection sweep.
 */
export const listLatestEbayConnectionSweepResults = async (params?: ListLatestEbayConnectionSweepResultsParams, options?: RequestInit): Promise<EbayConnectionSweepResultsResponse | string> => {

  return customFetch<EbayConnectionSweepResultsResponse | string>(getListLatestEbayConnectionSweepResultsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLatestEbayConnectionSweepResultsQueryKey = (params?: ListLatestEbayConnectionSweepResultsParams,) => {
    return [
    `/api/platform/ebay-connection-sweep/latest/results`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLatestEbayConnectionSweepResultsQueryOptions = <TData = Awaited<ReturnType<typeof listLatestEbayConnectionSweepResults>>, TError = ErrorType<void>>(params?: ListLatestEbayConnectionSweepResultsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLatestEbayConnectionSweepResults>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLatestEbayConnectionSweepResultsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLatestEbayConnectionSweepResults>>> = ({ signal }) => listLatestEbayConnectionSweepResults(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLatestEbayConnectionSweepResults>>, TError, TData> & { queryKey: QueryKey }
}

export type ListLatestEbayConnectionSweepResultsQueryResult = NonNullable<Awaited<ReturnType<typeof listLatestEbayConnectionSweepResults>>>
export type ListLatestEbayConnectionSweepResultsQueryError = ErrorType<void>


/**
 * @summary Filter or export the safe rows from the latest eBay connection sweep.
 */

export function useListLatestEbayConnectionSweepResults<TData = Awaited<ReturnType<typeof listLatestEbayConnectionSweepResults>>, TError = ErrorType<void>>(
 params?: ListLatestEbayConnectionSweepResultsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLatestEbayConnectionSweepResults>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListLatestEbayConnectionSweepResultsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetEbayCategorySuggestionsUrl = (params: GetEbayCategorySuggestionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/integrations/ebay/category-suggestions?${stringifiedParams}` : `/api/integrations/ebay/category-suggestions`
}

/**
 * Proxies eBay's Taxonomy API `get_category_suggestions` for the
 * marketplace tied to the saved eBay credentials. Returns up to ~10
 * leaf categories with their full ancestor path so the operator can
 * pick the right one without knowing the numeric leaf id. Powers
 * the eBay category picker on the inventory detail page.
 * @summary Typeahead picker — fetch leaf eBay categories matching a query.
 */
export const getEbayCategorySuggestions = async (params: GetEbayCategorySuggestionsParams, options?: RequestInit): Promise<GetEbayCategorySuggestions200> => {

  return customFetch<GetEbayCategorySuggestions200>(getGetEbayCategorySuggestionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEbayCategorySuggestionsQueryKey = (params?: GetEbayCategorySuggestionsParams,) => {
    return [
    `/api/integrations/ebay/category-suggestions`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetEbayCategorySuggestionsQueryOptions = <TData = Awaited<ReturnType<typeof getEbayCategorySuggestions>>, TError = ErrorType<void>>(params: GetEbayCategorySuggestionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEbayCategorySuggestions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEbayCategorySuggestionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEbayCategorySuggestions>>> = ({ signal }) => getEbayCategorySuggestions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEbayCategorySuggestions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEbayCategorySuggestionsQueryResult = NonNullable<Awaited<ReturnType<typeof getEbayCategorySuggestions>>>
export type GetEbayCategorySuggestionsQueryError = ErrorType<void>


/**
 * @summary Typeahead picker — fetch leaf eBay categories matching a query.
 */

export function useGetEbayCategorySuggestions<TData = Awaited<ReturnType<typeof getEbayCategorySuggestions>>, TError = ErrorType<void>>(
 params: GetEbayCategorySuggestionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEbayCategorySuggestions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEbayCategorySuggestionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRescanEbayOrdersUrl = () => {




  return `/api/integrations/ebay/rescan`
}

/**
 * Runs both the import pass (creationdate window) and the update pass
 * (lastmodifieddate window) over the same lookback window. The update
 * pass auto-imports any unmatched-PAID orders inline (the "late-paid"
 * scenario the original import pass cannot see). Persists a row in
 * `ebay_sync_runs` so the operator has a forensic audit trail.
 * @summary Manual re-scan of recent eBay orders (import + update passes)
 */
export const rescanEbayOrders = async (ebayRescanRequest?: EbayRescanRequest, options?: RequestInit): Promise<EbayRescanResult> => {

  return customFetch<EbayRescanResult>(getRescanEbayOrdersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ebayRescanRequest)
  }
);}





export const getRescanEbayOrdersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rescanEbayOrders>>, TError,{data?: BodyType<EbayRescanRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rescanEbayOrders>>, TError,{data?: BodyType<EbayRescanRequest>}, TContext> => {

const mutationKey = ['rescanEbayOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rescanEbayOrders>>, {data?: BodyType<EbayRescanRequest>}> = (props) => {
          const {data} = props ?? {};

          return  rescanEbayOrders(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RescanEbayOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof rescanEbayOrders>>>
    export type RescanEbayOrdersMutationBody = BodyType<EbayRescanRequest> | undefined
    export type RescanEbayOrdersMutationError = ErrorType<unknown>

    /**
 * @summary Manual re-scan of recent eBay orders (import + update passes)
 */
export const useRescanEbayOrders = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rescanEbayOrders>>, TError,{data?: BodyType<EbayRescanRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rescanEbayOrders>>,
        TError,
        {data?: BodyType<EbayRescanRequest>},
        TContext
      > => {
      return useMutation(getRescanEbayOrdersMutationOptions(options));
    }

export const getListEbaySyncRunsUrl = (params?: ListEbaySyncRunsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/integrations/ebay/sync-runs?${stringifiedParams}` : `/api/integrations/ebay/sync-runs`
}

/**
 * @summary Recent eBay order sync runs (manual + scheduler)
 */
export const listEbaySyncRuns = async (params?: ListEbaySyncRunsParams, options?: RequestInit): Promise<ListEbaySyncRuns200> => {

  return customFetch<ListEbaySyncRuns200>(getListEbaySyncRunsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEbaySyncRunsQueryKey = (params?: ListEbaySyncRunsParams,) => {
    return [
    `/api/integrations/ebay/sync-runs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListEbaySyncRunsQueryOptions = <TData = Awaited<ReturnType<typeof listEbaySyncRuns>>, TError = ErrorType<unknown>>(params?: ListEbaySyncRunsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEbaySyncRuns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEbaySyncRunsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEbaySyncRuns>>> = ({ signal }) => listEbaySyncRuns(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEbaySyncRuns>>, TError, TData> & { queryKey: QueryKey }
}

export type ListEbaySyncRunsQueryResult = NonNullable<Awaited<ReturnType<typeof listEbaySyncRuns>>>
export type ListEbaySyncRunsQueryError = ErrorType<unknown>


/**
 * @summary Recent eBay order sync runs (manual + scheduler)
 */

export function useListEbaySyncRuns<TData = Awaited<ReturnType<typeof listEbaySyncRuns>>, TError = ErrorType<unknown>>(
 params?: ListEbaySyncRunsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEbaySyncRuns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListEbaySyncRunsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getFindEbayOrdersUrl = (params: FindEbayOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/integrations/ebay/find-orders?${stringifiedParams}` : `/api/integrations/ebay/find-orders`
}

/**
 * Returns recent eBay orders matching the query, with a flag indicating
 * whether each one is already imported into our DB. Used by the "Find
 * Missing Order" admin tool. Order-id-shaped queries (NN-NNNNN-NNNNN)
 * also do a direct single-order fetch so unpaid orders (which the list
 * endpoint hides) are still findable.
 * @summary Search recent eBay orders by username, name, or order id
 */
export const findEbayOrders = async (params: FindEbayOrdersParams, options?: RequestInit): Promise<FindEbayOrdersResult> => {

  return customFetch<FindEbayOrdersResult>(getFindEbayOrdersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindEbayOrdersQueryKey = (params?: FindEbayOrdersParams,) => {
    return [
    `/api/integrations/ebay/find-orders`, ...(params ? [params] : [])
    ] as const;
    }


export const getFindEbayOrdersQueryOptions = <TData = Awaited<ReturnType<typeof findEbayOrders>>, TError = ErrorType<unknown>>(params: FindEbayOrdersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof findEbayOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindEbayOrdersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findEbayOrders>>> = ({ signal }) => findEbayOrders(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findEbayOrders>>, TError, TData> & { queryKey: QueryKey }
}

export type FindEbayOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof findEbayOrders>>>
export type FindEbayOrdersQueryError = ErrorType<unknown>


/**
 * @summary Search recent eBay orders by username, name, or order id
 */

export function useFindEbayOrders<TData = Awaited<ReturnType<typeof findEbayOrders>>, TError = ErrorType<unknown>>(
 params: FindEbayOrdersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof findEbayOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFindEbayOrdersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getImportEbayOrderUrl = () => {




  return `/api/integrations/ebay/import-order`
}

/**
 * Fetches a single order via the direct /sell/fulfillment/v1/order/{id}
 * endpoint and runs it through the same per-order import transaction as
 * the scheduled sync. Used by the "Find Missing Order" tool.
 * @summary Manually import a single eBay order by id
 */
export const importEbayOrder = async (ebayImportOrderRequest: EbayImportOrderRequest, options?: RequestInit): Promise<EbayImportOrderResult> => {

  return customFetch<EbayImportOrderResult>(getImportEbayOrderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ebayImportOrderRequest)
  }
);}





export const getImportEbayOrderMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importEbayOrder>>, TError,{data: BodyType<EbayImportOrderRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importEbayOrder>>, TError,{data: BodyType<EbayImportOrderRequest>}, TContext> => {

const mutationKey = ['importEbayOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importEbayOrder>>, {data: BodyType<EbayImportOrderRequest>}> = (props) => {
          const {data} = props ?? {};

          return  importEbayOrder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportEbayOrderMutationResult = NonNullable<Awaited<ReturnType<typeof importEbayOrder>>>
    export type ImportEbayOrderMutationBody = BodyType<EbayImportOrderRequest>
    export type ImportEbayOrderMutationError = ErrorType<void>

    /**
 * @summary Manually import a single eBay order by id
 */
export const useImportEbayOrder = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importEbayOrder>>, TError,{data: BodyType<EbayImportOrderRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importEbayOrder>>,
        TError,
        {data: BodyType<EbayImportOrderRequest>},
        TContext
      > => {
      return useMutation(getImportEbayOrderMutationOptions(options));
    }

export const getPullEbayOrdersUrl = () => {




  return `/api/integrations/ebay/pull-orders`
}

/**
 * Pulls completed eBay orders since the integration's lastSyncedAt (or the requested sinceISO) and creates Sale records for any not yet imported.
 */
export const pullEbayOrders = async (ebayPullOrdersRequest?: EbayPullOrdersRequest, options?: RequestInit): Promise<EbayPullOrdersResult> => {

  return customFetch<EbayPullOrdersResult>(getPullEbayOrdersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ebayPullOrdersRequest)
  }
);}





export const getPullEbayOrdersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pullEbayOrders>>, TError,{data?: BodyType<EbayPullOrdersRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pullEbayOrders>>, TError,{data?: BodyType<EbayPullOrdersRequest>}, TContext> => {

const mutationKey = ['pullEbayOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pullEbayOrders>>, {data?: BodyType<EbayPullOrdersRequest>}> = (props) => {
          const {data} = props ?? {};

          return  pullEbayOrders(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PullEbayOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof pullEbayOrders>>>
    export type PullEbayOrdersMutationBody = BodyType<EbayPullOrdersRequest> | undefined
    export type PullEbayOrdersMutationError = ErrorType<unknown>

    export const usePullEbayOrders = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pullEbayOrders>>, TError,{data?: BodyType<EbayPullOrdersRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof pullEbayOrders>>,
        TError,
        {data?: BodyType<EbayPullOrdersRequest>},
        TContext
      > => {
      return useMutation(getPullEbayOrdersMutationOptions(options));
    }

export const getSyncEbayMessagesUrl = () => {




  return `/api/integrations/ebay/sync-messages`
}

/**
 * Fetches unread eBay member messages from the Trading API and upserts them into the local cache.
 */
export const syncEbayMessages = async ( options?: RequestInit): Promise<EbayMessageSyncResult> => {

  return customFetch<EbayMessageSyncResult>(getSyncEbayMessagesUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSyncEbayMessagesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncEbayMessages>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncEbayMessages>>, TError,void, TContext> => {

const mutationKey = ['syncEbayMessages'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncEbayMessages>>, void> = () => {


          return  syncEbayMessages(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncEbayMessagesMutationResult = NonNullable<Awaited<ReturnType<typeof syncEbayMessages>>>

    export type SyncEbayMessagesMutationError = ErrorType<unknown>

    export const useSyncEbayMessages = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncEbayMessages>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncEbayMessages>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSyncEbayMessagesMutationOptions(options));
    }

export const getListEbayMessagesUrl = (params?: ListEbayMessagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/integrations/ebay/messages?${stringifiedParams}` : `/api/integrations/ebay/messages`
}

export const listEbayMessages = async (params?: ListEbayMessagesParams, options?: RequestInit): Promise<EbayMessage[]> => {

  return customFetch<EbayMessage[]>(getListEbayMessagesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEbayMessagesQueryKey = (params?: ListEbayMessagesParams,) => {
    return [
    `/api/integrations/ebay/messages`, ...(params ? [params] : [])
    ] as const;
    }


export const getListEbayMessagesQueryOptions = <TData = Awaited<ReturnType<typeof listEbayMessages>>, TError = ErrorType<unknown>>(params?: ListEbayMessagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEbayMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEbayMessagesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEbayMessages>>> = ({ signal }) => listEbayMessages(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEbayMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type ListEbayMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof listEbayMessages>>>
export type ListEbayMessagesQueryError = ErrorType<unknown>



export function useListEbayMessages<TData = Awaited<ReturnType<typeof listEbayMessages>>, TError = ErrorType<unknown>>(
 params?: ListEbayMessagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEbayMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListEbayMessagesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetEbayMessageThreadUrl = (id: string,) => {




  return `/api/integrations/ebay/messages/${id}/thread`
}

/**
 * Returns the full conversation containing this message, ordered chronologically (oldest first), with both inbound and outbound rows.
 */
export const getEbayMessageThread = async (id: string, options?: RequestInit): Promise<EbayMessageThread> => {

  return customFetch<EbayMessageThread>(getGetEbayMessageThreadUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEbayMessageThreadQueryKey = (id: string,) => {
    return [
    `/api/integrations/ebay/messages/${id}/thread`
    ] as const;
    }


export const getGetEbayMessageThreadQueryOptions = <TData = Awaited<ReturnType<typeof getEbayMessageThread>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEbayMessageThread>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEbayMessageThreadQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEbayMessageThread>>> = ({ signal }) => getEbayMessageThread(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEbayMessageThread>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEbayMessageThreadQueryResult = NonNullable<Awaited<ReturnType<typeof getEbayMessageThread>>>
export type GetEbayMessageThreadQueryError = ErrorType<void>



export function useGetEbayMessageThread<TData = Awaited<ReturnType<typeof getEbayMessageThread>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEbayMessageThread>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEbayMessageThreadQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getReplyToEbayMessageUrl = (id: string,) => {




  return `/api/integrations/ebay/messages/${id}/reply`
}

/**
 * Send a reply to the buyer message via the eBay Trading API (AddMemberMessageAAQToPartner). Persists an outbound row in the same thread and marks the original as read on success.
 */
export const replyToEbayMessage = async (id: string,
    ebayMessageReplyRequest: EbayMessageReplyRequest, options?: RequestInit): Promise<EbayMessageReplyResult> => {

  return customFetch<EbayMessageReplyResult>(getReplyToEbayMessageUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ebayMessageReplyRequest)
  }
);}





export const getReplyToEbayMessageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replyToEbayMessage>>, TError,{id: string;data: BodyType<EbayMessageReplyRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof replyToEbayMessage>>, TError,{id: string;data: BodyType<EbayMessageReplyRequest>}, TContext> => {

const mutationKey = ['replyToEbayMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replyToEbayMessage>>, {id: string;data: BodyType<EbayMessageReplyRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  replyToEbayMessage(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplyToEbayMessageMutationResult = NonNullable<Awaited<ReturnType<typeof replyToEbayMessage>>>
    export type ReplyToEbayMessageMutationBody = BodyType<EbayMessageReplyRequest>
    export type ReplyToEbayMessageMutationError = ErrorType<void>

    export const useReplyToEbayMessage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replyToEbayMessage>>, TError,{id: string;data: BodyType<EbayMessageReplyRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof replyToEbayMessage>>,
        TError,
        {id: string;data: BodyType<EbayMessageReplyRequest>},
        TContext
      > => {
      return useMutation(getReplyToEbayMessageMutationOptions(options));
    }

export const getMarkEbayMessageReadUrl = (id: string,) => {




  return `/api/integrations/ebay/messages/${id}/mark-read`
}

export const markEbayMessageRead = async (id: string, options?: RequestInit): Promise<EbayMessageMarkReadResult> => {

  return customFetch<EbayMessageMarkReadResult>(getMarkEbayMessageReadUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMarkEbayMessageReadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markEbayMessageRead>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markEbayMessageRead>>, TError,{id: string}, TContext> => {

const mutationKey = ['markEbayMessageRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markEbayMessageRead>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  markEbayMessageRead(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkEbayMessageReadMutationResult = NonNullable<Awaited<ReturnType<typeof markEbayMessageRead>>>

    export type MarkEbayMessageReadMutationError = ErrorType<unknown>

    export const useMarkEbayMessageRead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markEbayMessageRead>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markEbayMessageRead>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getMarkEbayMessageReadMutationOptions(options));
    }

export const getPreviewProductInformationImpactUrl = (id: string,) => {




  return `/api/inventory/${id}/product-information-impact-preview`
}

/**
 * Read-only projection of unsaved master specifications onto selected, connected marketplace channels.
 */
export const previewProductInformationImpact = async (id: string,
    productInformationImpactInput: ProductInformationImpactInput, options?: RequestInit): Promise<ProductInformationImpactResult> => {

  return customFetch<ProductInformationImpactResult>(getPreviewProductInformationImpactUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(productInformationImpactInput)
  }
);}





export const getPreviewProductInformationImpactMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewProductInformationImpact>>, TError,{id: string;data: BodyType<ProductInformationImpactInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewProductInformationImpact>>, TError,{id: string;data: BodyType<ProductInformationImpactInput>}, TContext> => {

const mutationKey = ['previewProductInformationImpact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewProductInformationImpact>>, {id: string;data: BodyType<ProductInformationImpactInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  previewProductInformationImpact(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewProductInformationImpactMutationResult = NonNullable<Awaited<ReturnType<typeof previewProductInformationImpact>>>
    export type PreviewProductInformationImpactMutationBody = BodyType<ProductInformationImpactInput>
    export type PreviewProductInformationImpactMutationError = ErrorType<void>

    export const usePreviewProductInformationImpact = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewProductInformationImpact>>, TError,{id: string;data: BodyType<ProductInformationImpactInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof previewProductInformationImpact>>,
        TError,
        {id: string;data: BodyType<ProductInformationImpactInput>},
        TContext
      > => {
      return useMutation(getPreviewProductInformationImpactMutationOptions(options));
    }

export const getPushInventoryItemToMarketplacesUrl = (id: string,) => {




  return `/api/inventory/${id}/push-to-marketplaces`
}

/**
 * Re-trigger a synchronous push of one inventory item to every
 * marketplace channel it is opted in to via `syncChannels`
 * (currently shopify, ebay, woocommerce). Returns a per-channel
 * result so the UI can show which channel failed and why.
 *
 * An optional `channels` body override lets callers (e.g. the
 * VariationsPanel) push a specific child variant to one channel
 * without requiring the child to have its own syncChannels
 * configured — the override is used instead of the DB value for
 * that request only.
 */
export const pushInventoryItemToMarketplaces = async (id: string,
    pushInventoryItemToMarketplacesBody?: PushInventoryItemToMarketplacesBody, options?: RequestInit): Promise<PushToMarketplacesResult> => {

  return customFetch<PushToMarketplacesResult>(getPushInventoryItemToMarketplacesUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pushInventoryItemToMarketplacesBody)
  }
);}





export const getPushInventoryItemToMarketplacesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushInventoryItemToMarketplaces>>, TError,{id: string;data?: BodyType<PushInventoryItemToMarketplacesBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pushInventoryItemToMarketplaces>>, TError,{id: string;data?: BodyType<PushInventoryItemToMarketplacesBody>}, TContext> => {

const mutationKey = ['pushInventoryItemToMarketplaces'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pushInventoryItemToMarketplaces>>, {id: string;data?: BodyType<PushInventoryItemToMarketplacesBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  pushInventoryItemToMarketplaces(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PushInventoryItemToMarketplacesMutationResult = NonNullable<Awaited<ReturnType<typeof pushInventoryItemToMarketplaces>>>
    export type PushInventoryItemToMarketplacesMutationBody = BodyType<PushInventoryItemToMarketplacesBody> | undefined
    export type PushInventoryItemToMarketplacesMutationError = ErrorType<void>

    export const usePushInventoryItemToMarketplaces = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushInventoryItemToMarketplaces>>, TError,{id: string;data?: BodyType<PushInventoryItemToMarketplacesBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof pushInventoryItemToMarketplaces>>,
        TError,
        {id: string;data?: BodyType<PushInventoryItemToMarketplacesBody>},
        TContext
      > => {
      return useMutation(getPushInventoryItemToMarketplacesMutationOptions(options));
    }

export const getRecoverShopifyLinkUrl = (id: string,) => {




  return `/api/inventory/${id}/shopify/recover-link`
}

/**
 * Recover an inventory item whose stored Shopify product id no longer
 * exists at that id (a 404 on update — the item's
 * `externalListings.shopify.staleLink` is set). Clears the stored
 * Shopify ids and re-pushes through the normal path, which runs the
 * SKU dedup gate first: it reconnects to an existing Shopify product
 * when the SKU matches (NEVER creating a duplicate), creates a new
 * product only when the SKU is genuinely absent, and refuses to
 * create (returns failed) when the SKU lookup itself errors.
 */
export const recoverShopifyLink = async (id: string, options?: RequestInit): Promise<ShopifyRecoverLinkResult> => {

  return customFetch<ShopifyRecoverLinkResult>(getRecoverShopifyLinkUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRecoverShopifyLinkMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recoverShopifyLink>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recoverShopifyLink>>, TError,{id: string}, TContext> => {

const mutationKey = ['recoverShopifyLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recoverShopifyLink>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  recoverShopifyLink(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecoverShopifyLinkMutationResult = NonNullable<Awaited<ReturnType<typeof recoverShopifyLink>>>

    export type RecoverShopifyLinkMutationError = ErrorType<void>

    export const useRecoverShopifyLink = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recoverShopifyLink>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recoverShopifyLink>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getRecoverShopifyLinkMutationOptions(options));
    }

export const getListShopifyStaleLinksUrl = () => {




  return `/api/inventory/shopify/stale-links`
}

/**
 * List every inventory item currently flagged with a broken Shopify
 * product link (`externalListings.shopify.staleLink` is set). These are
 * the items the bulk recovery action operates on. Independent of the
 * inventory list's view/filter state so the count is always accurate.
 */
export const listShopifyStaleLinks = async ( options?: RequestInit): Promise<ShopifyStaleLinkList> => {

  return customFetch<ShopifyStaleLinkList>(getListShopifyStaleLinksUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListShopifyStaleLinksQueryKey = () => {
    return [
    `/api/inventory/shopify/stale-links`
    ] as const;
    }


export const getListShopifyStaleLinksQueryOptions = <TData = Awaited<ReturnType<typeof listShopifyStaleLinks>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShopifyStaleLinks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListShopifyStaleLinksQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listShopifyStaleLinks>>> = ({ signal }) => listShopifyStaleLinks({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listShopifyStaleLinks>>, TError, TData> & { queryKey: QueryKey }
}

export type ListShopifyStaleLinksQueryResult = NonNullable<Awaited<ReturnType<typeof listShopifyStaleLinks>>>
export type ListShopifyStaleLinksQueryError = ErrorType<unknown>



export function useListShopifyStaleLinks<TData = Awaited<ReturnType<typeof listShopifyStaleLinks>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShopifyStaleLinks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListShopifyStaleLinksQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportTiktokLiveImagesUrl = () => {




  return `/api/inventory/export-tiktok-live-images`
}

/**
 * @summary Download all live, sellable inventory images as a ZIP file for TikTok
Live Seller Media Center bulk upload. One image per SKU — composite
photo first (the template-background render), falling back to the
primary standard photo. Items with no image are skipped. Requires the
`tiktok_live_image_export_enabled` tenant setting to be true.

 */
export const exportTiktokLiveImages = async ( options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getExportTiktokLiveImagesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportTiktokLiveImagesQueryKey = () => {
    return [
    `/api/inventory/export-tiktok-live-images`
    ] as const;
    }


export const getExportTiktokLiveImagesQueryOptions = <TData = Awaited<ReturnType<typeof exportTiktokLiveImages>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportTiktokLiveImages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportTiktokLiveImagesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportTiktokLiveImages>>> = ({ signal }) => exportTiktokLiveImages({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportTiktokLiveImages>>, TError, TData> & { queryKey: QueryKey }
}

export type ExportTiktokLiveImagesQueryResult = NonNullable<Awaited<ReturnType<typeof exportTiktokLiveImages>>>
export type ExportTiktokLiveImagesQueryError = ErrorType<void>


/**
 * @summary Download all live, sellable inventory images as a ZIP file for TikTok
Live Seller Media Center bulk upload. One image per SKU — composite
photo first (the template-background render), falling back to the
primary standard photo. Items with no image are skipped. Requires the
`tiktok_live_image_export_enabled` tenant setting to be true.

 */

export function useExportTiktokLiveImages<TData = Awaited<ReturnType<typeof exportTiktokLiveImages>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportTiktokLiveImages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getExportTiktokLiveImagesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRecoverShopifyLinksUrl = () => {




  return `/api/inventory/shopify/recover-links`
}

/**
 * Bulk-recover inventory items whose stored Shopify product id no longer
 * exists (404 on update — `externalListings.shopify.staleLink` is set).
 * Each item runs the exact same per-item recovery as
 * `recoverShopifyLink`: clear the stored ids and re-push, so the SKU
 * dedup gate reconnects to an existing Shopify product by SKU or creates
 * one only when the SKU is genuinely absent — never a duplicate. Pass an
 * explicit `ids` list to recover a chosen subset; omit it to recover
 * every stale item. Items that are not actually stale (or not opted in)
 * are skipped. Processed sequentially and capped per call to protect the
 * Shopify quota; rate-limited per user. Each item is audited.
 */
export const recoverShopifyLinks = async (shopifyRecoverLinksBody?: ShopifyRecoverLinksBody, options?: RequestInit): Promise<ShopifyBulkRecoverLinkResult> => {

  return customFetch<ShopifyBulkRecoverLinkResult>(getRecoverShopifyLinksUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(shopifyRecoverLinksBody)
  }
);}





export const getRecoverShopifyLinksMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recoverShopifyLinks>>, TError,{data?: BodyType<ShopifyRecoverLinksBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recoverShopifyLinks>>, TError,{data?: BodyType<ShopifyRecoverLinksBody>}, TContext> => {

const mutationKey = ['recoverShopifyLinks'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recoverShopifyLinks>>, {data?: BodyType<ShopifyRecoverLinksBody>}> = (props) => {
          const {data} = props ?? {};

          return  recoverShopifyLinks(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecoverShopifyLinksMutationResult = NonNullable<Awaited<ReturnType<typeof recoverShopifyLinks>>>
    export type RecoverShopifyLinksMutationBody = BodyType<ShopifyRecoverLinksBody> | undefined
    export type RecoverShopifyLinksMutationError = ErrorType<void>

    export const useRecoverShopifyLinks = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recoverShopifyLinks>>, TError,{data?: BodyType<ShopifyRecoverLinksBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recoverShopifyLinks>>,
        TError,
        {data?: BodyType<ShopifyRecoverLinksBody>},
        TContext
      > => {
      return useMutation(getRecoverShopifyLinksMutationOptions(options));
    }

export const getPushEbayItemUrl = (sku: string,) => {




  return `/api/integrations/ebay/push-item/${sku}`
}

/**
 * Push the current available quantity for a single inventory item to eBay (single-item quantity-only sync).
 */
export const pushEbayItem = async (sku: string, options?: RequestInit): Promise<EbayPushItemResult> => {

  return customFetch<EbayPushItemResult>(getPushEbayItemUrl(sku),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPushEbayItemMutationOptions = <TError = ErrorType<void | EbayPushItemResult>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushEbayItem>>, TError,{sku: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pushEbayItem>>, TError,{sku: string}, TContext> => {

const mutationKey = ['pushEbayItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pushEbayItem>>, {sku: string}> = (props) => {
          const {sku} = props ?? {};

          return  pushEbayItem(sku,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PushEbayItemMutationResult = NonNullable<Awaited<ReturnType<typeof pushEbayItem>>>

    export type PushEbayItemMutationError = ErrorType<void | EbayPushItemResult>

    export const usePushEbayItem = <TError = ErrorType<void | EbayPushItemResult>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushEbayItem>>, TError,{sku: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof pushEbayItem>>,
        TError,
        {sku: string},
        TContext
      > => {
      return useMutation(getPushEbayItemMutationOptions(options));
    }

export const getGetMarketplaceSummaryUrl = () => {




  return `/api/dashboard/marketplace-summary`
}

/**
 * @summary Marketplace activity summary (recent orders, awaiting payment, unread eBay messages, last sync time).
 */
export const getMarketplaceSummary = async ( options?: RequestInit): Promise<MarketplaceSummary> => {

  return customFetch<MarketplaceSummary>(getGetMarketplaceSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMarketplaceSummaryQueryKey = () => {
    return [
    `/api/dashboard/marketplace-summary`
    ] as const;
    }


export const getGetMarketplaceSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getMarketplaceSummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketplaceSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketplaceSummary>>> = ({ signal }) => getMarketplaceSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMarketplaceSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketplaceSummary>>>
export type GetMarketplaceSummaryQueryError = ErrorType<unknown>


/**
 * @summary Marketplace activity summary (recent orders, awaiting payment, unread eBay messages, last sync time).
 */

export function useGetMarketplaceSummary<TData = Awaited<ReturnType<typeof getMarketplaceSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMarketplaceSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAnalyticsOverviewUrl = (params?: GetAnalyticsOverviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/analytics/overview?${stringifiedParams}` : `/api/analytics/overview`
}

export const getAnalyticsOverview = async (params?: GetAnalyticsOverviewParams, options?: RequestInit): Promise<AnalyticsOverview> => {

  return customFetch<AnalyticsOverview>(getGetAnalyticsOverviewUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAnalyticsOverviewQueryKey = (params?: GetAnalyticsOverviewParams,) => {
    return [
    `/api/analytics/overview`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAnalyticsOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getAnalyticsOverview>>, TError = ErrorType<unknown>>(params?: GetAnalyticsOverviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalyticsOverviewQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticsOverview>>> = ({ signal }) => getAnalyticsOverview(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsOverview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAnalyticsOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalyticsOverview>>>
export type GetAnalyticsOverviewQueryError = ErrorType<unknown>



export function useGetAnalyticsOverview<TData = Awaited<ReturnType<typeof getAnalyticsOverview>>, TError = ErrorType<unknown>>(
 params?: GetAnalyticsOverviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAnalyticsOverviewQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSyncJobsUrl = (params?: ListSyncJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/integrations/sync-jobs?${stringifiedParams}` : `/api/integrations/sync-jobs`
}

export const listSyncJobs = async (params?: ListSyncJobsParams, options?: RequestInit): Promise<StockSyncJob[]> => {

  return customFetch<StockSyncJob[]>(getListSyncJobsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSyncJobsQueryKey = (params?: ListSyncJobsParams,) => {
    return [
    `/api/integrations/sync-jobs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSyncJobsQueryOptions = <TData = Awaited<ReturnType<typeof listSyncJobs>>, TError = ErrorType<unknown>>(params?: ListSyncJobsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSyncJobs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSyncJobsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSyncJobs>>> = ({ signal }) => listSyncJobs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSyncJobs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSyncJobsQueryResult = NonNullable<Awaited<ReturnType<typeof listSyncJobs>>>
export type ListSyncJobsQueryError = ErrorType<unknown>



export function useListSyncJobs<TData = Awaited<ReturnType<typeof listSyncJobs>>, TError = ErrorType<unknown>>(
 params?: ListSyncJobsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSyncJobs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSyncJobsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSaleAttachmentsUrl = (id: string,) => {




  return `/api/sales/${id}/attachments`
}

export const listSaleAttachments = async (id: string, options?: RequestInit): Promise<SaleAttachment[]> => {

  return customFetch<SaleAttachment[]>(getListSaleAttachmentsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSaleAttachmentsQueryKey = (id: string,) => {
    return [
    `/api/sales/${id}/attachments`
    ] as const;
    }


export const getListSaleAttachmentsQueryOptions = <TData = Awaited<ReturnType<typeof listSaleAttachments>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSaleAttachments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSaleAttachmentsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSaleAttachments>>> = ({ signal }) => listSaleAttachments(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSaleAttachments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSaleAttachmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listSaleAttachments>>>
export type ListSaleAttachmentsQueryError = ErrorType<unknown>



export function useListSaleAttachments<TData = Awaited<ReturnType<typeof listSaleAttachments>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSaleAttachments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSaleAttachmentsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateSaleAttachmentUrl = (id: string,) => {




  return `/api/sales/${id}/attachments`
}

export const createSaleAttachment = async (id: string,
    saleAttachmentInput: SaleAttachmentInput, options?: RequestInit): Promise<SaleAttachment> => {

  return customFetch<SaleAttachment>(getCreateSaleAttachmentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(saleAttachmentInput)
  }
);}





export const getCreateSaleAttachmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSaleAttachment>>, TError,{id: string;data: BodyType<SaleAttachmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSaleAttachment>>, TError,{id: string;data: BodyType<SaleAttachmentInput>}, TContext> => {

const mutationKey = ['createSaleAttachment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSaleAttachment>>, {id: string;data: BodyType<SaleAttachmentInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createSaleAttachment(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSaleAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof createSaleAttachment>>>
    export type CreateSaleAttachmentMutationBody = BodyType<SaleAttachmentInput>
    export type CreateSaleAttachmentMutationError = ErrorType<unknown>

    export const useCreateSaleAttachment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSaleAttachment>>, TError,{id: string;data: BodyType<SaleAttachmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSaleAttachment>>,
        TError,
        {id: string;data: BodyType<SaleAttachmentInput>},
        TContext
      > => {
      return useMutation(getCreateSaleAttachmentMutationOptions(options));
    }

export const getListInventorySerialsUrl = (id: string,) => {




  return `/api/inventory/${id}/serials`
}

/**
 * @summary List all serial / certificate numbers recorded for an inventory item.
 */
export const listInventorySerials = async (id: string, options?: RequestInit): Promise<ListInventorySerials200> => {

  return customFetch<ListInventorySerials200>(getListInventorySerialsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInventorySerialsQueryKey = (id: string,) => {
    return [
    `/api/inventory/${id}/serials`
    ] as const;
    }


export const getListInventorySerialsQueryOptions = <TData = Awaited<ReturnType<typeof listInventorySerials>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventorySerials>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInventorySerialsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInventorySerials>>> = ({ signal }) => listInventorySerials(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInventorySerials>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInventorySerialsQueryResult = NonNullable<Awaited<ReturnType<typeof listInventorySerials>>>
export type ListInventorySerialsQueryError = ErrorType<void>


/**
 * @summary List all serial / certificate numbers recorded for an inventory item.
 */

export function useListInventorySerials<TData = Awaited<ReturnType<typeof listInventorySerials>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInventorySerials>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInventorySerialsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getBulkAddInventorySerialsUrl = (id: string,) => {




  return `/api/inventory/${id}/serials`
}

/**
 * @summary Bulk-add serial / certificate number entries for an inventory item.
Each entry can carry a serialNumber, certificateNumber, or both.
All entries are created with status=available.

 */
export const bulkAddInventorySerials = async (id: string,
    inventorySerialBulkAddRequest: InventorySerialBulkAddRequest, options?: RequestInit): Promise<BulkAddInventorySerials201> => {

  return customFetch<BulkAddInventorySerials201>(getBulkAddInventorySerialsUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventorySerialBulkAddRequest)
  }
);}





export const getBulkAddInventorySerialsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkAddInventorySerials>>, TError,{id: string;data: BodyType<InventorySerialBulkAddRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkAddInventorySerials>>, TError,{id: string;data: BodyType<InventorySerialBulkAddRequest>}, TContext> => {

const mutationKey = ['bulkAddInventorySerials'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkAddInventorySerials>>, {id: string;data: BodyType<InventorySerialBulkAddRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  bulkAddInventorySerials(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkAddInventorySerialsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkAddInventorySerials>>>
    export type BulkAddInventorySerialsMutationBody = BodyType<InventorySerialBulkAddRequest>
    export type BulkAddInventorySerialsMutationError = ErrorType<void>

    /**
 * @summary Bulk-add serial / certificate number entries for an inventory item.
Each entry can carry a serialNumber, certificateNumber, or both.
All entries are created with status=available.

 */
export const useBulkAddInventorySerials = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkAddInventorySerials>>, TError,{id: string;data: BodyType<InventorySerialBulkAddRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkAddInventorySerials>>,
        TError,
        {id: string;data: BodyType<InventorySerialBulkAddRequest>},
        TContext
      > => {
      return useMutation(getBulkAddInventorySerialsMutationOptions(options));
    }

export const getUpdateInventorySerialUrl = (id: string,
    serialId: string,) => {




  return `/api/inventory/${id}/serials/${serialId}`
}

/**
 * @summary Update a serial / certificate entry (edit fields or void it).
 */
export const updateInventorySerial = async (id: string,
    serialId: string,
    inventorySerialUpdate: InventorySerialUpdate, options?: RequestInit): Promise<UpdateInventorySerial200> => {

  return customFetch<UpdateInventorySerial200>(getUpdateInventorySerialUrl(id,serialId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventorySerialUpdate)
  }
);}





export const getUpdateInventorySerialMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInventorySerial>>, TError,{id: string;serialId: string;data: BodyType<InventorySerialUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInventorySerial>>, TError,{id: string;serialId: string;data: BodyType<InventorySerialUpdate>}, TContext> => {

const mutationKey = ['updateInventorySerial'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInventorySerial>>, {id: string;serialId: string;data: BodyType<InventorySerialUpdate>}> = (props) => {
          const {id,serialId,data} = props ?? {};

          return  updateInventorySerial(id,serialId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateInventorySerialMutationResult = NonNullable<Awaited<ReturnType<typeof updateInventorySerial>>>
    export type UpdateInventorySerialMutationBody = BodyType<InventorySerialUpdate>
    export type UpdateInventorySerialMutationError = ErrorType<void>

    /**
 * @summary Update a serial / certificate entry (edit fields or void it).
 */
export const useUpdateInventorySerial = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInventorySerial>>, TError,{id: string;serialId: string;data: BodyType<InventorySerialUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateInventorySerial>>,
        TError,
        {id: string;serialId: string;data: BodyType<InventorySerialUpdate>},
        TContext
      > => {
      return useMutation(getUpdateInventorySerialMutationOptions(options));
    }

export const getDeleteInventorySerialUrl = (id: string,
    serialId: string,) => {




  return `/api/inventory/${id}/serials/${serialId}`
}

/**
 * @summary Hard-delete a serial entry. Only available entries (status=available or
status=void) may be deleted — dispatched serials must be voided first.

 */
export const deleteInventorySerial = async (id: string,
    serialId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteInventorySerialUrl(id,serialId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteInventorySerialMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInventorySerial>>, TError,{id: string;serialId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteInventorySerial>>, TError,{id: string;serialId: string}, TContext> => {

const mutationKey = ['deleteInventorySerial'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInventorySerial>>, {id: string;serialId: string}> = (props) => {
          const {id,serialId} = props ?? {};

          return  deleteInventorySerial(id,serialId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteInventorySerialMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInventorySerial>>>

    export type DeleteInventorySerialMutationError = ErrorType<void>

    /**
 * @summary Hard-delete a serial entry. Only available entries (status=available or
status=void) may be deleted — dispatched serials must be voided first.

 */
export const useDeleteInventorySerial = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInventorySerial>>, TError,{id: string;serialId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteInventorySerial>>,
        TError,
        {id: string;serialId: string},
        TContext
      > => {
      return useMutation(getDeleteInventorySerialMutationOptions(options));
    }

export const getGetPackingSettingsUrl = () => {




  return `/api/packing/settings`
}

/**
 * @summary Packer-readable subset of tenant settings used by the /packing UI.
 */
export const getPackingSettings = async ( options?: RequestInit): Promise<GetPackingSettings200> => {

  return customFetch<GetPackingSettings200>(getGetPackingSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPackingSettingsQueryKey = () => {
    return [
    `/api/packing/settings`
    ] as const;
    }


export const getGetPackingSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getPackingSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPackingSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPackingSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPackingSettings>>> = ({ signal }) => getPackingSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPackingSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPackingSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getPackingSettings>>>
export type GetPackingSettingsQueryError = ErrorType<unknown>


/**
 * @summary Packer-readable subset of tenant settings used by the /packing UI.
 */

export function useGetPackingSettings<TData = Awaited<ReturnType<typeof getPackingSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPackingSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPackingSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSalePackingMediaUrl = (id: string,) => {




  return `/api/packing/sales/${id}/media`
}

/**
 * Returns every `packing_job_media` row attached to any packing job that
 * contains the given sale order (joined via `packing_job_items`). This
 * is what surfaces photos and videos captured during the official
 * packing flow on the sale-order detail page; legacy per-sale uploads
 * still live on `/sales/{id}/attachments`.
 * @summary List packing-job evidence media for a sale order.
 */
export const listSalePackingMedia = async (id: string, options?: RequestInit): Promise<ListSalePackingMedia200> => {

  return customFetch<ListSalePackingMedia200>(getListSalePackingMediaUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSalePackingMediaQueryKey = (id: string,) => {
    return [
    `/api/packing/sales/${id}/media`
    ] as const;
    }


export const getListSalePackingMediaQueryOptions = <TData = Awaited<ReturnType<typeof listSalePackingMedia>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSalePackingMedia>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSalePackingMediaQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSalePackingMedia>>> = ({ signal }) => listSalePackingMedia(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSalePackingMedia>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSalePackingMediaQueryResult = NonNullable<Awaited<ReturnType<typeof listSalePackingMedia>>>
export type ListSalePackingMediaQueryError = ErrorType<unknown>


/**
 * @summary List packing-job evidence media for a sale order.
 */

export function useListSalePackingMedia<TData = Awaited<ReturnType<typeof listSalePackingMedia>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSalePackingMedia>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSalePackingMediaQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDeleteSaleAttachmentUrl = (attachmentId: string,) => {




  return `/api/sales/attachments/${attachmentId}`
}

export const deleteSaleAttachment = async (attachmentId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteSaleAttachmentUrl(attachmentId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteSaleAttachmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSaleAttachment>>, TError,{attachmentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSaleAttachment>>, TError,{attachmentId: string}, TContext> => {

const mutationKey = ['deleteSaleAttachment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSaleAttachment>>, {attachmentId: string}> = (props) => {
          const {attachmentId} = props ?? {};

          return  deleteSaleAttachment(attachmentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSaleAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSaleAttachment>>>

    export type DeleteSaleAttachmentMutationError = ErrorType<unknown>

    export const useDeleteSaleAttachment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSaleAttachment>>, TError,{attachmentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSaleAttachment>>,
        TError,
        {attachmentId: string},
        TContext
      > => {
      return useMutation(getDeleteSaleAttachmentMutationOptions(options));
    }

export const getSetSaleLabelUrl = (id: string,) => {




  return `/api/sales/${id}/label`
}

/**
 * Records the object-storage path of an already-uploaded postage-label PDF on the sale order so it can be merged later via the bulk-print endpoint.
 * @summary Attach an uploaded postage-label PDF to a sale order.
 */
export const setSaleLabel = async (id: string,
    saleLabelInput: SaleLabelInput, options?: RequestInit): Promise<SaleOrder> => {

  return customFetch<SaleOrder>(getSetSaleLabelUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(saleLabelInput)
  }
);}





export const getSetSaleLabelMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSaleLabel>>, TError,{id: string;data: BodyType<SaleLabelInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setSaleLabel>>, TError,{id: string;data: BodyType<SaleLabelInput>}, TContext> => {

const mutationKey = ['setSaleLabel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setSaleLabel>>, {id: string;data: BodyType<SaleLabelInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  setSaleLabel(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetSaleLabelMutationResult = NonNullable<Awaited<ReturnType<typeof setSaleLabel>>>
    export type SetSaleLabelMutationBody = BodyType<SaleLabelInput>
    export type SetSaleLabelMutationError = ErrorType<unknown>

    /**
 * @summary Attach an uploaded postage-label PDF to a sale order.
 */
export const useSetSaleLabel = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSaleLabel>>, TError,{id: string;data: BodyType<SaleLabelInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setSaleLabel>>,
        TError,
        {id: string;data: BodyType<SaleLabelInput>},
        TContext
      > => {
      return useMutation(getSetSaleLabelMutationOptions(options));
    }

export const getDeleteSaleLabelUrl = (id: string,) => {




  return `/api/sales/${id}/label`
}

/**
 * @summary Remove the postage-label PDF reference from a sale order.
 */
export const deleteSaleLabel = async (id: string, options?: RequestInit): Promise<SaleOrder> => {

  return customFetch<SaleOrder>(getDeleteSaleLabelUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteSaleLabelMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSaleLabel>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSaleLabel>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteSaleLabel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSaleLabel>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteSaleLabel(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSaleLabelMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSaleLabel>>>

    export type DeleteSaleLabelMutationError = ErrorType<unknown>

    /**
 * @summary Remove the postage-label PDF reference from a sale order.
 */
export const useDeleteSaleLabel = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSaleLabel>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSaleLabel>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteSaleLabelMutationOptions(options));
    }

export const getPrintSaleLabelsUrl = () => {




  return `/api/sales/labels/print`
}

/**
 * Fetches each sale's labelObjectPath in the supplied order and concatenates the PDFs into one document. Sales without an uploaded label are skipped (and listed in the X-Skipped-Sales response header).
 * @summary Merge selected sale orders' uploaded label PDFs into a single combined PDF.
 */
export const printSaleLabels = async (printSaleLabelsInput: PrintSaleLabelsInput, options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getPrintSaleLabelsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(printSaleLabelsInput)
  }
);}





export const getPrintSaleLabelsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof printSaleLabels>>, TError,{data: BodyType<PrintSaleLabelsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof printSaleLabels>>, TError,{data: BodyType<PrintSaleLabelsInput>}, TContext> => {

const mutationKey = ['printSaleLabels'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof printSaleLabels>>, {data: BodyType<PrintSaleLabelsInput>}> = (props) => {
          const {data} = props ?? {};

          return  printSaleLabels(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PrintSaleLabelsMutationResult = NonNullable<Awaited<ReturnType<typeof printSaleLabels>>>
    export type PrintSaleLabelsMutationBody = BodyType<PrintSaleLabelsInput>
    export type PrintSaleLabelsMutationError = ErrorType<unknown>

    /**
 * @summary Merge selected sale orders' uploaded label PDFs into a single combined PDF.
 */
export const usePrintSaleLabels = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof printSaleLabels>>, TError,{data: BodyType<PrintSaleLabelsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof printSaleLabels>>,
        TError,
        {data: BodyType<PrintSaleLabelsInput>},
        TContext
      > => {
      return useMutation(getPrintSaleLabelsMutationOptions(options));
    }

export const getGetSettingsUrl = () => {




  return `/api/settings`
}

export const getSettings = async ( options?: RequestInit): Promise<Settings> => {

  return customFetch<Settings>(getGetSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSettingsQueryKey = () => {
    return [
    `/api/settings`
    ] as const;
    }


export const getGetSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettings>>> = ({ signal }) => getSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSettings>>>
export type GetSettingsQueryError = ErrorType<unknown>



export function useGetSettings<TData = Awaited<ReturnType<typeof getSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateSettingsUrl = () => {




  return `/api/settings`
}

export const updateSettings = async (settingsInput: SettingsInput, options?: RequestInit): Promise<Settings> => {

  return customFetch<Settings>(getUpdateSettingsUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(settingsInput)
  }
);}





export const getUpdateSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSettings>>, TError,{data: BodyType<SettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSettings>>, TError,{data: BodyType<SettingsInput>}, TContext> => {

const mutationKey = ['updateSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSettings>>, {data: BodyType<SettingsInput>}> = (props) => {
          const {data} = props ?? {};

          return  updateSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateSettings>>>
    export type UpdateSettingsMutationBody = BodyType<SettingsInput>
    export type UpdateSettingsMutationError = ErrorType<unknown>

    export const useUpdateSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSettings>>, TError,{data: BodyType<SettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSettings>>,
        TError,
        {data: BodyType<SettingsInput>},
        TContext
      > => {
      return useMutation(getUpdateSettingsMutationOptions(options));
    }

export const getGetVatAcquisitionEnforcementUrl = () => {




  return `/api/settings/vat-acquisition-enforcement`
}

/**
 * VAT Phase 2A. Kept off the main settings object on purpose: flipping
 * this changes whether stock can be received at all, so it has its own
 * audit trail and its own confirmation step in the UI, and can never be
 * toggled as a side effect of an unrelated settings save.
 * @summary Whether VAT classification is required before new stock becomes available.
 */
export const getVatAcquisitionEnforcement = async ( options?: RequestInit): Promise<VatAcquisitionEnforcementState> => {

  return customFetch<VatAcquisitionEnforcementState>(getGetVatAcquisitionEnforcementUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetVatAcquisitionEnforcementQueryKey = () => {
    return [
    `/api/settings/vat-acquisition-enforcement`
    ] as const;
    }


export const getGetVatAcquisitionEnforcementQueryOptions = <TData = Awaited<ReturnType<typeof getVatAcquisitionEnforcement>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVatAcquisitionEnforcement>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVatAcquisitionEnforcementQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVatAcquisitionEnforcement>>> = ({ signal }) => getVatAcquisitionEnforcement({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVatAcquisitionEnforcement>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVatAcquisitionEnforcementQueryResult = NonNullable<Awaited<ReturnType<typeof getVatAcquisitionEnforcement>>>
export type GetVatAcquisitionEnforcementQueryError = ErrorType<unknown>


/**
 * @summary Whether VAT classification is required before new stock becomes available.
 */

export function useGetVatAcquisitionEnforcement<TData = Awaited<ReturnType<typeof getVatAcquisitionEnforcement>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVatAcquisitionEnforcement>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVatAcquisitionEnforcementQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSetVatAcquisitionEnforcementUrl = () => {




  return `/api/settings/vat-acquisition-enforcement`
}

/**
 * Idempotent — re-sending the current state does not restart the
 * "enforced since" clock or write an audit row. Disabling clears
 * `startedAt` so a later re-enable never claims coverage for the gap.
 * @summary Turn the VAT classification requirement on or off (owner/admin only).
 */
export const setVatAcquisitionEnforcement = async (vatAcquisitionEnforcementInput: VatAcquisitionEnforcementInput, options?: RequestInit): Promise<VatAcquisitionEnforcementState> => {

  return customFetch<VatAcquisitionEnforcementState>(getSetVatAcquisitionEnforcementUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(vatAcquisitionEnforcementInput)
  }
);}





export const getSetVatAcquisitionEnforcementMutationOptions = <TError = ErrorType<void | VatSchemaUnavailableError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setVatAcquisitionEnforcement>>, TError,{data: BodyType<VatAcquisitionEnforcementInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setVatAcquisitionEnforcement>>, TError,{data: BodyType<VatAcquisitionEnforcementInput>}, TContext> => {

const mutationKey = ['setVatAcquisitionEnforcement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setVatAcquisitionEnforcement>>, {data: BodyType<VatAcquisitionEnforcementInput>}> = (props) => {
          const {data} = props ?? {};

          return  setVatAcquisitionEnforcement(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetVatAcquisitionEnforcementMutationResult = NonNullable<Awaited<ReturnType<typeof setVatAcquisitionEnforcement>>>
    export type SetVatAcquisitionEnforcementMutationBody = BodyType<VatAcquisitionEnforcementInput>
    export type SetVatAcquisitionEnforcementMutationError = ErrorType<void | VatSchemaUnavailableError>

    /**
 * @summary Turn the VAT classification requirement on or off (owner/admin only).
 */
export const useSetVatAcquisitionEnforcement = <TError = ErrorType<void | VatSchemaUnavailableError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setVatAcquisitionEnforcement>>, TError,{data: BodyType<VatAcquisitionEnforcementInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setVatAcquisitionEnforcement>>,
        TError,
        {data: BodyType<VatAcquisitionEnforcementInput>},
        TContext
      > => {
      return useMutation(getSetVatAcquisitionEnforcementMutationOptions(options));
    }

export const getGetVatSalesPostingUrl = () => {




  return `/api/settings/vat-sales-posting`
}

/**
 * @summary View VAT sales-posting enablement and prerequisite readiness.
 */
export const getVatSalesPosting = async ( options?: RequestInit): Promise<VatSalesPostingState> => {

  return customFetch<VatSalesPostingState>(getGetVatSalesPostingUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetVatSalesPostingQueryKey = () => {
    return [
    `/api/settings/vat-sales-posting`
    ] as const;
    }


export const getGetVatSalesPostingQueryOptions = <TData = Awaited<ReturnType<typeof getVatSalesPosting>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVatSalesPosting>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVatSalesPostingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVatSalesPosting>>> = ({ signal }) => getVatSalesPosting({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVatSalesPosting>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVatSalesPostingQueryResult = NonNullable<Awaited<ReturnType<typeof getVatSalesPosting>>>
export type GetVatSalesPostingQueryError = ErrorType<void>


/**
 * @summary View VAT sales-posting enablement and prerequisite readiness.
 */

export function useGetVatSalesPosting<TData = Awaited<ReturnType<typeof getVatSalesPosting>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVatSalesPosting>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVatSalesPostingQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getEnableVatSalesPostingUrl = () => {




  return `/api/settings/vat-sales-posting/enable`
}

/**
 * This operation is idempotent and one-way. It does not inspect channel
 * configurations. It only succeeds when VAT recognition is ready, a VAT
 * registration period is active, the business timezone is valid, and VAT
 * acquisition enforcement is already enabled.
 * @summary Enable VAT sales posting once (owner/admin only).
 */
export const enableVatSalesPosting = async ( options?: RequestInit): Promise<VatSalesPostingState> => {

  return customFetch<VatSalesPostingState>(getEnableVatSalesPostingUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getEnableVatSalesPostingMutationOptions = <TError = ErrorType<void | VatSalesPostingState>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableVatSalesPosting>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof enableVatSalesPosting>>, TError,void, TContext> => {

const mutationKey = ['enableVatSalesPosting'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableVatSalesPosting>>, void> = () => {


          return  enableVatSalesPosting(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableVatSalesPostingMutationResult = NonNullable<Awaited<ReturnType<typeof enableVatSalesPosting>>>

    export type EnableVatSalesPostingMutationError = ErrorType<void | VatSalesPostingState>

    /**
 * @summary Enable VAT sales posting once (owner/admin only).
 */
export const useEnableVatSalesPosting = <TError = ErrorType<void | VatSalesPostingState>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableVatSalesPosting>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof enableVatSalesPosting>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getEnableVatSalesPostingMutationOptions(options));
    }

export const getGetVatRegistrationPeriodsUrl = () => {




  return `/api/settings/vat-registration-periods`
}

/**
 * @summary View VAT registration-period configuration and storage readiness.
 */
export const getVatRegistrationPeriods = async ( options?: RequestInit): Promise<VatRegistrationPeriodsState> => {

  return customFetch<VatRegistrationPeriodsState>(getGetVatRegistrationPeriodsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetVatRegistrationPeriodsQueryKey = () => {
    return [
    `/api/settings/vat-registration-periods`
    ] as const;
    }


export const getGetVatRegistrationPeriodsQueryOptions = <TData = Awaited<ReturnType<typeof getVatRegistrationPeriods>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVatRegistrationPeriods>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVatRegistrationPeriodsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVatRegistrationPeriods>>> = ({ signal }) => getVatRegistrationPeriods({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVatRegistrationPeriods>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVatRegistrationPeriodsQueryResult = NonNullable<Awaited<ReturnType<typeof getVatRegistrationPeriods>>>
export type GetVatRegistrationPeriodsQueryError = ErrorType<void>


/**
 * @summary View VAT registration-period configuration and storage readiness.
 */

export function useGetVatRegistrationPeriods<TData = Awaited<ReturnType<typeof getVatRegistrationPeriods>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVatRegistrationPeriods>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVatRegistrationPeriodsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateVatRegistrationPeriodUrl = () => {




  return `/api/settings/vat-registration-periods`
}

/**
 * @summary Create a draft GB VAT registration period (owner/admin only).
 */
export const createVatRegistrationPeriod = async (vatRegistrationPeriodInput: VatRegistrationPeriodInput, options?: RequestInit): Promise<VatRegistrationPeriod> => {

  return customFetch<VatRegistrationPeriod>(getCreateVatRegistrationPeriodUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(vatRegistrationPeriodInput)
  }
);}





export const getCreateVatRegistrationPeriodMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVatRegistrationPeriod>>, TError,{data: BodyType<VatRegistrationPeriodInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createVatRegistrationPeriod>>, TError,{data: BodyType<VatRegistrationPeriodInput>}, TContext> => {

const mutationKey = ['createVatRegistrationPeriod'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVatRegistrationPeriod>>, {data: BodyType<VatRegistrationPeriodInput>}> = (props) => {
          const {data} = props ?? {};

          return  createVatRegistrationPeriod(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVatRegistrationPeriodMutationResult = NonNullable<Awaited<ReturnType<typeof createVatRegistrationPeriod>>>
    export type CreateVatRegistrationPeriodMutationBody = BodyType<VatRegistrationPeriodInput>
    export type CreateVatRegistrationPeriodMutationError = ErrorType<void>

    /**
 * @summary Create a draft GB VAT registration period (owner/admin only).
 */
export const useCreateVatRegistrationPeriod = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVatRegistrationPeriod>>, TError,{data: BodyType<VatRegistrationPeriodInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createVatRegistrationPeriod>>,
        TError,
        {data: BodyType<VatRegistrationPeriodInput>},
        TContext
      > => {
      return useMutation(getCreateVatRegistrationPeriodMutationOptions(options));
    }

export const getActivateVatRegistrationPeriodUrl = (periodId: string,) => {




  return `/api/settings/vat-registration-periods/${periodId}/activate`
}

/**
 * @summary Activate a valid draft VAT registration period (owner/admin only).
 */
export const activateVatRegistrationPeriod = async (periodId: string, options?: RequestInit): Promise<VatRegistrationPeriod> => {

  return customFetch<VatRegistrationPeriod>(getActivateVatRegistrationPeriodUrl(periodId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getActivateVatRegistrationPeriodMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateVatRegistrationPeriod>>, TError,{periodId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activateVatRegistrationPeriod>>, TError,{periodId: string}, TContext> => {

const mutationKey = ['activateVatRegistrationPeriod'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateVatRegistrationPeriod>>, {periodId: string}> = (props) => {
          const {periodId} = props ?? {};

          return  activateVatRegistrationPeriod(periodId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivateVatRegistrationPeriodMutationResult = NonNullable<Awaited<ReturnType<typeof activateVatRegistrationPeriod>>>

    export type ActivateVatRegistrationPeriodMutationError = ErrorType<void>

    /**
 * @summary Activate a valid draft VAT registration period (owner/admin only).
 */
export const useActivateVatRegistrationPeriod = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateVatRegistrationPeriod>>, TError,{periodId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof activateVatRegistrationPeriod>>,
        TError,
        {periodId: string},
        TContext
      > => {
      return useMutation(getActivateVatRegistrationPeriodMutationOptions(options));
    }

export const getEndVatRegistrationPeriodUrl = (periodId: string,) => {




  return `/api/settings/vat-registration-periods/${periodId}/end`
}

/**
 * @summary End an active VAT registration period (owner/admin only).
 */
export const endVatRegistrationPeriod = async (periodId: string,
    vatRegistrationPeriodEndInput: VatRegistrationPeriodEndInput, options?: RequestInit): Promise<VatRegistrationPeriod> => {

  return customFetch<VatRegistrationPeriod>(getEndVatRegistrationPeriodUrl(periodId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(vatRegistrationPeriodEndInput)
  }
);}





export const getEndVatRegistrationPeriodMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endVatRegistrationPeriod>>, TError,{periodId: string;data: BodyType<VatRegistrationPeriodEndInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof endVatRegistrationPeriod>>, TError,{periodId: string;data: BodyType<VatRegistrationPeriodEndInput>}, TContext> => {

const mutationKey = ['endVatRegistrationPeriod'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof endVatRegistrationPeriod>>, {periodId: string;data: BodyType<VatRegistrationPeriodEndInput>}> = (props) => {
          const {periodId,data} = props ?? {};

          return  endVatRegistrationPeriod(periodId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EndVatRegistrationPeriodMutationResult = NonNullable<Awaited<ReturnType<typeof endVatRegistrationPeriod>>>
    export type EndVatRegistrationPeriodMutationBody = BodyType<VatRegistrationPeriodEndInput>
    export type EndVatRegistrationPeriodMutationError = ErrorType<void>

    /**
 * @summary End an active VAT registration period (owner/admin only).
 */
export const useEndVatRegistrationPeriod = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endVatRegistrationPeriod>>, TError,{periodId: string;data: BodyType<VatRegistrationPeriodEndInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof endVatRegistrationPeriod>>,
        TError,
        {periodId: string;data: BodyType<VatRegistrationPeriodEndInput>},
        TContext
      > => {
      return useMutation(getEndVatRegistrationPeriodMutationOptions(options));
    }

export const getGetLiveStockExportFieldsUrl = () => {




  return `/api/settings/live-stock-export-fields`
}

/**
 * @summary Minimally-scoped read of just the admin-configured Live Stock CSV
export columns. Gated by `view_inventory` (NOT `view_admin`) so any
operator who can run the export — which is anyone who can list
inventory — gets the tenant's configured columns/order, while the
full Settings read/write surface stays admin-only.

 */
export const getLiveStockExportFields = async ( options?: RequestInit): Promise<GetLiveStockExportFields200> => {

  return customFetch<GetLiveStockExportFields200>(getGetLiveStockExportFieldsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLiveStockExportFieldsQueryKey = () => {
    return [
    `/api/settings/live-stock-export-fields`
    ] as const;
    }


export const getGetLiveStockExportFieldsQueryOptions = <TData = Awaited<ReturnType<typeof getLiveStockExportFields>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLiveStockExportFields>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLiveStockExportFieldsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLiveStockExportFields>>> = ({ signal }) => getLiveStockExportFields({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLiveStockExportFields>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLiveStockExportFieldsQueryResult = NonNullable<Awaited<ReturnType<typeof getLiveStockExportFields>>>
export type GetLiveStockExportFieldsQueryError = ErrorType<unknown>


/**
 * @summary Minimally-scoped read of just the admin-configured Live Stock CSV
export columns. Gated by `view_inventory` (NOT `view_admin`) so any
operator who can run the export — which is anyone who can list
inventory — gets the tenant's configured columns/order, while the
full Settings read/write surface stays admin-only.

 */

export function useGetLiveStockExportFields<TData = Awaited<ReturnType<typeof getLiveStockExportFields>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLiveStockExportFields>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLiveStockExportFieldsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListLiveStockExportMembersUrl = () => {




  return `/api/settings/live-stock-export-fields/members`
}

/**
 * @summary List tenant members and their managed Live Stock export overrides.
 */
export const listLiveStockExportMembers = async ( options?: RequestInit): Promise<LiveStockExportMembersResponse> => {

  return customFetch<LiveStockExportMembersResponse>(getListLiveStockExportMembersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLiveStockExportMembersQueryKey = () => {
    return [
    `/api/settings/live-stock-export-fields/members`
    ] as const;
    }


export const getListLiveStockExportMembersQueryOptions = <TData = Awaited<ReturnType<typeof listLiveStockExportMembers>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLiveStockExportMembers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLiveStockExportMembersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLiveStockExportMembers>>> = ({ signal }) => listLiveStockExportMembers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLiveStockExportMembers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListLiveStockExportMembersQueryResult = NonNullable<Awaited<ReturnType<typeof listLiveStockExportMembers>>>
export type ListLiveStockExportMembersQueryError = ErrorType<unknown>


/**
 * @summary List tenant members and their managed Live Stock export overrides.
 */

export function useListLiveStockExportMembers<TData = Awaited<ReturnType<typeof listLiveStockExportMembers>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLiveStockExportMembers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListLiveStockExportMembersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSetLiveStockExportMemberOverrideUrl = (userId: string,) => {




  return `/api/settings/live-stock-export-fields/members/${userId}`
}

/**
 * @summary Set or reset one tenant member's Live Stock export override.
 */
export const setLiveStockExportMemberOverride = async (userId: string,
    liveStockExportOverrideUpdate: LiveStockExportOverrideUpdate, options?: RequestInit): Promise<LiveStockExportMember> => {

  return customFetch<LiveStockExportMember>(getSetLiveStockExportMemberOverrideUrl(userId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(liveStockExportOverrideUpdate)
  }
);}





export const getSetLiveStockExportMemberOverrideMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLiveStockExportMemberOverride>>, TError,{userId: string;data: BodyType<LiveStockExportOverrideUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setLiveStockExportMemberOverride>>, TError,{userId: string;data: BodyType<LiveStockExportOverrideUpdate>}, TContext> => {

const mutationKey = ['setLiveStockExportMemberOverride'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLiveStockExportMemberOverride>>, {userId: string;data: BodyType<LiveStockExportOverrideUpdate>}> = (props) => {
          const {userId,data} = props ?? {};

          return  setLiveStockExportMemberOverride(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetLiveStockExportMemberOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof setLiveStockExportMemberOverride>>>
    export type SetLiveStockExportMemberOverrideMutationBody = BodyType<LiveStockExportOverrideUpdate>
    export type SetLiveStockExportMemberOverrideMutationError = ErrorType<void>

    /**
 * @summary Set or reset one tenant member's Live Stock export override.
 */
export const useSetLiveStockExportMemberOverride = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLiveStockExportMemberOverride>>, TError,{userId: string;data: BodyType<LiveStockExportOverrideUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setLiveStockExportMemberOverride>>,
        TError,
        {userId: string;data: BodyType<LiveStockExportOverrideUpdate>},
        TContext
      > => {
      return useMutation(getSetLiveStockExportMemberOverrideMutationOptions(options));
    }

export const getGetBrandingUrl = () => {




  return `/api/branding`
}

export const getBranding = async ( options?: RequestInit): Promise<AppBranding> => {

  return customFetch<AppBranding>(getGetBrandingUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBrandingQueryKey = () => {
    return [
    `/api/branding`
    ] as const;
    }


export const getGetBrandingQueryOptions = <TData = Awaited<ReturnType<typeof getBranding>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBranding>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrandingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBranding>>> = ({ signal }) => getBranding({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBranding>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBrandingQueryResult = NonNullable<Awaited<ReturnType<typeof getBranding>>>
export type GetBrandingQueryError = ErrorType<unknown>



export function useGetBranding<TData = Awaited<ReturnType<typeof getBranding>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBranding>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBrandingQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateBrandingUrl = () => {




  return `/api/branding`
}

export const updateBranding = async (appBrandingUpdate: AppBrandingUpdate, options?: RequestInit): Promise<AppBranding> => {

  return customFetch<AppBranding>(getUpdateBrandingUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(appBrandingUpdate)
  }
);}





export const getUpdateBrandingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBranding>>, TError,{data: BodyType<AppBrandingUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBranding>>, TError,{data: BodyType<AppBrandingUpdate>}, TContext> => {

const mutationKey = ['updateBranding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBranding>>, {data: BodyType<AppBrandingUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateBranding(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateBrandingMutationResult = NonNullable<Awaited<ReturnType<typeof updateBranding>>>
    export type UpdateBrandingMutationBody = BodyType<AppBrandingUpdate>
    export type UpdateBrandingMutationError = ErrorType<unknown>

    export const useUpdateBranding = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBranding>>, TError,{data: BodyType<AppBrandingUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateBranding>>,
        TError,
        {data: BodyType<AppBrandingUpdate>},
        TContext
      > => {
      return useMutation(getUpdateBrandingMutationOptions(options));
    }

export const getSetMyThemeUrl = () => {




  return `/api/me/theme`
}

export const setMyTheme = async (userThemeUpdate: UserThemeUpdate, options?: RequestInit): Promise<AuthedUser> => {

  return customFetch<AuthedUser>(getSetMyThemeUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(userThemeUpdate)
  }
);}





export const getSetMyThemeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setMyTheme>>, TError,{data: BodyType<UserThemeUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setMyTheme>>, TError,{data: BodyType<UserThemeUpdate>}, TContext> => {

const mutationKey = ['setMyTheme'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setMyTheme>>, {data: BodyType<UserThemeUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  setMyTheme(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetMyThemeMutationResult = NonNullable<Awaited<ReturnType<typeof setMyTheme>>>
    export type SetMyThemeMutationBody = BodyType<UserThemeUpdate>
    export type SetMyThemeMutationError = ErrorType<unknown>

    export const useSetMyTheme = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setMyTheme>>, TError,{data: BodyType<UserThemeUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setMyTheme>>,
        TError,
        {data: BodyType<UserThemeUpdate>},
        TContext
      > => {
      return useMutation(getSetMyThemeMutationOptions(options));
    }

export const getSetMyFloatingButtonUrl = () => {




  return `/api/me/floating-button`
}

/**
 * @summary Update floating Ask AI button preferences (visibility / position)
 */
export const setMyFloatingButton = async (floatingButtonUpdate: FloatingButtonUpdate, options?: RequestInit): Promise<AuthedUser> => {

  return customFetch<AuthedUser>(getSetMyFloatingButtonUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(floatingButtonUpdate)
  }
);}





export const getSetMyFloatingButtonMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setMyFloatingButton>>, TError,{data: BodyType<FloatingButtonUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setMyFloatingButton>>, TError,{data: BodyType<FloatingButtonUpdate>}, TContext> => {

const mutationKey = ['setMyFloatingButton'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setMyFloatingButton>>, {data: BodyType<FloatingButtonUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  setMyFloatingButton(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetMyFloatingButtonMutationResult = NonNullable<Awaited<ReturnType<typeof setMyFloatingButton>>>
    export type SetMyFloatingButtonMutationBody = BodyType<FloatingButtonUpdate>
    export type SetMyFloatingButtonMutationError = ErrorType<unknown>

    /**
 * @summary Update floating Ask AI button preferences (visibility / position)
 */
export const useSetMyFloatingButton = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setMyFloatingButton>>, TError,{data: BodyType<FloatingButtonUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setMyFloatingButton>>,
        TError,
        {data: BodyType<FloatingButtonUpdate>},
        TContext
      > => {
      return useMutation(getSetMyFloatingButtonMutationOptions(options));
    }

export const getGetDropshipDashboardUrl = () => {




  return `/api/dropship/dashboard`
}

export const getDropshipDashboard = async ( options?: RequestInit): Promise<DropshipDashboard> => {

  return customFetch<DropshipDashboard>(getGetDropshipDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDropshipDashboardQueryKey = () => {
    return [
    `/api/dropship/dashboard`
    ] as const;
    }


export const getGetDropshipDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getDropshipDashboard>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDropshipDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDropshipDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDropshipDashboard>>> = ({ signal }) => getDropshipDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDropshipDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDropshipDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getDropshipDashboard>>>
export type GetDropshipDashboardQueryError = ErrorType<unknown>



export function useGetDropshipDashboard<TData = Awaited<ReturnType<typeof getDropshipDashboard>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDropshipDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDropshipDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListDropshipCustomersUrl = () => {




  return `/api/dropship/customers`
}

export const listDropshipCustomers = async ( options?: RequestInit): Promise<DropshipCustomer[]> => {

  return customFetch<DropshipCustomer[]>(getListDropshipCustomersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDropshipCustomersQueryKey = () => {
    return [
    `/api/dropship/customers`
    ] as const;
    }


export const getListDropshipCustomersQueryOptions = <TData = Awaited<ReturnType<typeof listDropshipCustomers>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDropshipCustomers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDropshipCustomersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDropshipCustomers>>> = ({ signal }) => listDropshipCustomers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDropshipCustomers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDropshipCustomersQueryResult = NonNullable<Awaited<ReturnType<typeof listDropshipCustomers>>>
export type ListDropshipCustomersQueryError = ErrorType<unknown>



export function useListDropshipCustomers<TData = Awaited<ReturnType<typeof listDropshipCustomers>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDropshipCustomers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDropshipCustomersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateDropshipCustomerUrl = () => {




  return `/api/dropship/customers`
}

export const createDropshipCustomer = async (dropshipCustomerInput: DropshipCustomerInput, options?: RequestInit): Promise<DropshipCustomerWithSecret> => {

  return customFetch<DropshipCustomerWithSecret>(getCreateDropshipCustomerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(dropshipCustomerInput)
  }
);}





export const getCreateDropshipCustomerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDropshipCustomer>>, TError,{data: BodyType<DropshipCustomerInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createDropshipCustomer>>, TError,{data: BodyType<DropshipCustomerInput>}, TContext> => {

const mutationKey = ['createDropshipCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDropshipCustomer>>, {data: BodyType<DropshipCustomerInput>}> = (props) => {
          const {data} = props ?? {};

          return  createDropshipCustomer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDropshipCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof createDropshipCustomer>>>
    export type CreateDropshipCustomerMutationBody = BodyType<DropshipCustomerInput>
    export type CreateDropshipCustomerMutationError = ErrorType<unknown>

    export const useCreateDropshipCustomer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDropshipCustomer>>, TError,{data: BodyType<DropshipCustomerInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createDropshipCustomer>>,
        TError,
        {data: BodyType<DropshipCustomerInput>},
        TContext
      > => {
      return useMutation(getCreateDropshipCustomerMutationOptions(options));
    }

export const getGetDropshipCustomerUrl = (id: string,) => {




  return `/api/dropship/customers/${id}`
}

export const getDropshipCustomer = async (id: string, options?: RequestInit): Promise<DropshipCustomer> => {

  return customFetch<DropshipCustomer>(getGetDropshipCustomerUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDropshipCustomerQueryKey = (id: string,) => {
    return [
    `/api/dropship/customers/${id}`
    ] as const;
    }


export const getGetDropshipCustomerQueryOptions = <TData = Awaited<ReturnType<typeof getDropshipCustomer>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDropshipCustomer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDropshipCustomerQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDropshipCustomer>>> = ({ signal }) => getDropshipCustomer(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDropshipCustomer>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDropshipCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getDropshipCustomer>>>
export type GetDropshipCustomerQueryError = ErrorType<unknown>



export function useGetDropshipCustomer<TData = Awaited<ReturnType<typeof getDropshipCustomer>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDropshipCustomer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDropshipCustomerQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateDropshipCustomerUrl = (id: string,) => {




  return `/api/dropship/customers/${id}`
}

export const updateDropshipCustomer = async (id: string,
    dropshipCustomerInput: DropshipCustomerInput, options?: RequestInit): Promise<DropshipCustomer> => {

  return customFetch<DropshipCustomer>(getUpdateDropshipCustomerUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(dropshipCustomerInput)
  }
);}





export const getUpdateDropshipCustomerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDropshipCustomer>>, TError,{id: string;data: BodyType<DropshipCustomerInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDropshipCustomer>>, TError,{id: string;data: BodyType<DropshipCustomerInput>}, TContext> => {

const mutationKey = ['updateDropshipCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDropshipCustomer>>, {id: string;data: BodyType<DropshipCustomerInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateDropshipCustomer(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDropshipCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof updateDropshipCustomer>>>
    export type UpdateDropshipCustomerMutationBody = BodyType<DropshipCustomerInput>
    export type UpdateDropshipCustomerMutationError = ErrorType<unknown>

    export const useUpdateDropshipCustomer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDropshipCustomer>>, TError,{id: string;data: BodyType<DropshipCustomerInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDropshipCustomer>>,
        TError,
        {id: string;data: BodyType<DropshipCustomerInput>},
        TContext
      > => {
      return useMutation(getUpdateDropshipCustomerMutationOptions(options));
    }

export const getDeleteDropshipCustomerUrl = (id: string,) => {




  return `/api/dropship/customers/${id}`
}

export const deleteDropshipCustomer = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteDropshipCustomerUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteDropshipCustomerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDropshipCustomer>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDropshipCustomer>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteDropshipCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDropshipCustomer>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteDropshipCustomer(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDropshipCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDropshipCustomer>>>

    export type DeleteDropshipCustomerMutationError = ErrorType<unknown>

    export const useDeleteDropshipCustomer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDropshipCustomer>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteDropshipCustomer>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteDropshipCustomerMutationOptions(options));
    }

export const getRegenerateDropshipKeyUrl = (id: string,) => {




  return `/api/dropship/customers/${id}/regenerate-key`
}

export const regenerateDropshipKey = async (id: string, options?: RequestInit): Promise<DropshipCustomerWithSecret> => {

  return customFetch<DropshipCustomerWithSecret>(getRegenerateDropshipKeyUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRegenerateDropshipKeyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateDropshipKey>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof regenerateDropshipKey>>, TError,{id: string}, TContext> => {

const mutationKey = ['regenerateDropshipKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateDropshipKey>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  regenerateDropshipKey(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegenerateDropshipKeyMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateDropshipKey>>>

    export type RegenerateDropshipKeyMutationError = ErrorType<unknown>

    export const useRegenerateDropshipKey = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateDropshipKey>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof regenerateDropshipKey>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getRegenerateDropshipKeyMutationOptions(options));
    }

export const getListDropshipCustomerSalesUrl = (id: string,) => {




  return `/api/dropship/customers/${id}/sales`
}

export const listDropshipCustomerSales = async (id: string, options?: RequestInit): Promise<DropshipOrder[]> => {

  return customFetch<DropshipOrder[]>(getListDropshipCustomerSalesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDropshipCustomerSalesQueryKey = (id: string,) => {
    return [
    `/api/dropship/customers/${id}/sales`
    ] as const;
    }


export const getListDropshipCustomerSalesQueryOptions = <TData = Awaited<ReturnType<typeof listDropshipCustomerSales>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDropshipCustomerSales>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDropshipCustomerSalesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDropshipCustomerSales>>> = ({ signal }) => listDropshipCustomerSales(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDropshipCustomerSales>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDropshipCustomerSalesQueryResult = NonNullable<Awaited<ReturnType<typeof listDropshipCustomerSales>>>
export type ListDropshipCustomerSalesQueryError = ErrorType<unknown>



export function useListDropshipCustomerSales<TData = Awaited<ReturnType<typeof listDropshipCustomerSales>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDropshipCustomerSales>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDropshipCustomerSalesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetDropshipStockUrl = () => {




  return `/api/dropship/stock`
}

/**
 * Public stock feed for partners. Authenticated via the
 * `X-API-Key` header (or `Authorization: Bearer …`). Returns the live
 * list of items currently available for dropshipping.
 */
export const getDropshipStock = async ( options?: RequestInit): Promise<DropshipStockResponse> => {

  return customFetch<DropshipStockResponse>(getGetDropshipStockUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDropshipStockQueryKey = () => {
    return [
    `/api/dropship/stock`
    ] as const;
    }


export const getGetDropshipStockQueryOptions = <TData = Awaited<ReturnType<typeof getDropshipStock>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDropshipStock>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDropshipStockQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDropshipStock>>> = ({ signal }) => getDropshipStock({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDropshipStock>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDropshipStockQueryResult = NonNullable<Awaited<ReturnType<typeof getDropshipStock>>>
export type GetDropshipStockQueryError = ErrorType<unknown>



export function useGetDropshipStock<TData = Awaited<ReturnType<typeof getDropshipStock>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDropshipStock>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDropshipStockQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPostDropshipOrderUrl = () => {




  return `/api/dropship/order`
}

/**
 * Submit a dropship order. Authenticated via `X-API-Key`. Reduces internal
 * stock atomically. If `idempotencyKey` is supplied, repeated calls with
 * the same key for the same customer are no-ops.
 */
export const postDropshipOrder = async (dropshipOrderInput: DropshipOrderInput, options?: RequestInit): Promise<DropshipOrderResponse> => {

  return customFetch<DropshipOrderResponse>(getPostDropshipOrderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(dropshipOrderInput)
  }
);}





export const getPostDropshipOrderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDropshipOrder>>, TError,{data: BodyType<DropshipOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postDropshipOrder>>, TError,{data: BodyType<DropshipOrderInput>}, TContext> => {

const mutationKey = ['postDropshipOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postDropshipOrder>>, {data: BodyType<DropshipOrderInput>}> = (props) => {
          const {data} = props ?? {};

          return  postDropshipOrder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostDropshipOrderMutationResult = NonNullable<Awaited<ReturnType<typeof postDropshipOrder>>>
    export type PostDropshipOrderMutationBody = BodyType<DropshipOrderInput>
    export type PostDropshipOrderMutationError = ErrorType<unknown>

    export const usePostDropshipOrder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDropshipOrder>>, TError,{data: BodyType<DropshipOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postDropshipOrder>>,
        TError,
        {data: BodyType<DropshipOrderInput>},
        TContext
      > => {
      return useMutation(getPostDropshipOrderMutationOptions(options));
    }

export const getGetDropshipReportUrl = (params?: GetDropshipReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/dropship?${stringifiedParams}` : `/api/reports/dropship`
}

export const getDropshipReport = async (params?: GetDropshipReportParams, options?: RequestInit): Promise<DropshipReport> => {

  return customFetch<DropshipReport>(getGetDropshipReportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDropshipReportQueryKey = (params?: GetDropshipReportParams,) => {
    return [
    `/api/reports/dropship`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDropshipReportQueryOptions = <TData = Awaited<ReturnType<typeof getDropshipReport>>, TError = ErrorType<unknown>>(params?: GetDropshipReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDropshipReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDropshipReportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDropshipReport>>> = ({ signal }) => getDropshipReport(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDropshipReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDropshipReportQueryResult = NonNullable<Awaited<ReturnType<typeof getDropshipReport>>>
export type GetDropshipReportQueryError = ErrorType<unknown>



export function useGetDropshipReport<TData = Awaited<ReturnType<typeof getDropshipReport>>, TError = ErrorType<unknown>>(
 params?: GetDropshipReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDropshipReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDropshipReportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSales7daySummaryUrl = () => {




  return `/api/sales/7day-summary`
}

/**
 * @summary Daily sales totals for the trailing 7 days, prior-period comparison, and a 7-day projection.
 */
export const getSales7daySummary = async ( options?: RequestInit): Promise<Sales7daySummary> => {

  return customFetch<Sales7daySummary>(getGetSales7daySummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSales7daySummaryQueryKey = () => {
    return [
    `/api/sales/7day-summary`
    ] as const;
    }


export const getGetSales7daySummaryQueryOptions = <TData = Awaited<ReturnType<typeof getSales7daySummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSales7daySummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSales7daySummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSales7daySummary>>> = ({ signal }) => getSales7daySummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSales7daySummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSales7daySummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getSales7daySummary>>>
export type GetSales7daySummaryQueryError = ErrorType<unknown>


/**
 * @summary Daily sales totals for the trailing 7 days, prior-period comparison, and a 7-day projection.
 */

export function useGetSales7daySummary<TData = Awaited<ReturnType<typeof getSales7daySummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSales7daySummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSales7daySummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCanonicalMarketSnapshotUrl = (params?: GetCanonicalMarketSnapshotParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/markets/snapshot?${stringifiedParams}` : `/api/markets/snapshot`
}

/**
 * This endpoint reads only the process L1 or Redis-backed Market Data Hub and never contacts a market provider.
 * @summary Load the current canonical market snapshot from the shared live store
 */
export const getCanonicalMarketSnapshot = async (params?: GetCanonicalMarketSnapshotParams, options?: RequestInit): Promise<CanonicalMarketSnapshot> => {

  return customFetch<CanonicalMarketSnapshot>(getGetCanonicalMarketSnapshotUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCanonicalMarketSnapshotQueryKey = (params?: GetCanonicalMarketSnapshotParams,) => {
    return [
    `/api/markets/snapshot`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCanonicalMarketSnapshotQueryOptions = <TData = Awaited<ReturnType<typeof getCanonicalMarketSnapshot>>, TError = ErrorType<void>>(params?: GetCanonicalMarketSnapshotParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCanonicalMarketSnapshot>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCanonicalMarketSnapshotQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCanonicalMarketSnapshot>>> = ({ signal }) => getCanonicalMarketSnapshot(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCanonicalMarketSnapshot>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCanonicalMarketSnapshotQueryResult = NonNullable<Awaited<ReturnType<typeof getCanonicalMarketSnapshot>>>
export type GetCanonicalMarketSnapshotQueryError = ErrorType<void>


/**
 * @summary Load the current canonical market snapshot from the shared live store
 */

export function useGetCanonicalMarketSnapshot<TData = Awaited<ReturnType<typeof getCanonicalMarketSnapshot>>, TError = ErrorType<void>>(
 params?: GetCanonicalMarketSnapshotParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCanonicalMarketSnapshot>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCanonicalMarketSnapshotQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getStreamCanonicalMarketsUrl = (params?: StreamCanonicalMarketsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/markets/stream?${stringifiedParams}` : `/api/markets/stream`
}

/**
 * Server-sent event stream. Every connection and reconnection starts with a full
 * snapshot. Event IDs contain the canonical sequence; Last-Event-ID is a client
 * deduplication cursor and does not request replay of intermediate ticks.
 * @summary Receive canonical market snapshot, price, status and heartbeat events
 */
export const streamCanonicalMarkets = async (params?: StreamCanonicalMarketsParams, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getStreamCanonicalMarketsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStreamCanonicalMarketsQueryKey = (params?: StreamCanonicalMarketsParams,) => {
    return [
    `/api/markets/stream`, ...(params ? [params] : [])
    ] as const;
    }


export const getStreamCanonicalMarketsQueryOptions = <TData = Awaited<ReturnType<typeof streamCanonicalMarkets>>, TError = ErrorType<void>>(params?: StreamCanonicalMarketsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof streamCanonicalMarkets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStreamCanonicalMarketsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof streamCanonicalMarkets>>> = ({ signal }) => streamCanonicalMarkets(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof streamCanonicalMarkets>>, TError, TData> & { queryKey: QueryKey }
}

export type StreamCanonicalMarketsQueryResult = NonNullable<Awaited<ReturnType<typeof streamCanonicalMarkets>>>
export type StreamCanonicalMarketsQueryError = ErrorType<void>


/**
 * @summary Receive canonical market snapshot, price, status and heartbeat events
 */

export function useStreamCanonicalMarkets<TData = Awaited<ReturnType<typeof streamCanonicalMarkets>>, TError = ErrorType<void>>(
 params?: StreamCanonicalMarketsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof streamCanonicalMarkets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getStreamCanonicalMarketsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getStreamPublicCanonicalMarketsUrl = (slug: string,) => {




  return `/api/public/markets/${slug}/stream`
}

/**
 * @summary Receive the published market page's scoped canonical event stream
 */
export const streamPublicCanonicalMarkets = async (slug: string, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getStreamPublicCanonicalMarketsUrl(slug),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStreamPublicCanonicalMarketsQueryKey = (slug: string,) => {
    return [
    `/api/public/markets/${slug}/stream`
    ] as const;
    }


export const getStreamPublicCanonicalMarketsQueryOptions = <TData = Awaited<ReturnType<typeof streamPublicCanonicalMarkets>>, TError = ErrorType<void>>(slug: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof streamPublicCanonicalMarkets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStreamPublicCanonicalMarketsQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof streamPublicCanonicalMarkets>>> = ({ signal }) => streamPublicCanonicalMarkets(slug, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof streamPublicCanonicalMarkets>>, TError, TData> & { queryKey: QueryKey }
}

export type StreamPublicCanonicalMarketsQueryResult = NonNullable<Awaited<ReturnType<typeof streamPublicCanonicalMarkets>>>
export type StreamPublicCanonicalMarketsQueryError = ErrorType<void>


/**
 * @summary Receive the published market page's scoped canonical event stream
 */

export function useStreamPublicCanonicalMarkets<TData = Awaited<ReturnType<typeof streamPublicCanonicalMarkets>>, TError = ErrorType<void>>(
 slug: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof streamPublicCanonicalMarkets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getStreamPublicCanonicalMarketsQueryOptions(slug,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getStreamMarketWidgetUrl = (key: string,
    params?: StreamMarketWidgetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/public/market-widgets/${key}/stream?${stringifiedParams}` : `/api/public/market-widgets/${key}/stream`
}

/**
 * @summary Receive a scoped widget-key canonical event stream
 */
export const streamMarketWidget = async (key: string,
    params?: StreamMarketWidgetParams, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getStreamMarketWidgetUrl(key,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStreamMarketWidgetQueryKey = (key: string,
    params?: StreamMarketWidgetParams,) => {
    return [
    `/api/public/market-widgets/${key}/stream`, ...(params ? [params] : [])
    ] as const;
    }


export const getStreamMarketWidgetQueryOptions = <TData = Awaited<ReturnType<typeof streamMarketWidget>>, TError = ErrorType<void>>(key: string,
    params?: StreamMarketWidgetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof streamMarketWidget>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStreamMarketWidgetQueryKey(key,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof streamMarketWidget>>> = ({ signal }) => streamMarketWidget(key,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: key !== null && key !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof streamMarketWidget>>, TError, TData> & { queryKey: QueryKey }
}

export type StreamMarketWidgetQueryResult = NonNullable<Awaited<ReturnType<typeof streamMarketWidget>>>
export type StreamMarketWidgetQueryError = ErrorType<void>


/**
 * @summary Receive a scoped widget-key canonical event stream
 */

export function useStreamMarketWidget<TData = Awaited<ReturnType<typeof streamMarketWidget>>, TError = ErrorType<void>>(
 key: string,
    params?: StreamMarketWidgetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof streamMarketWidget>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getStreamMarketWidgetQueryOptions(key,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getStreamOverlayTickerMarketsUrl = (token: string,) => {




  return `/api/overlays/ticker/${token}/stream`
}

/**
 * @summary Receive an OBS ticker link's scoped canonical event stream
 */
export const streamOverlayTickerMarkets = async (token: string, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getStreamOverlayTickerMarketsUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStreamOverlayTickerMarketsQueryKey = (token: string,) => {
    return [
    `/api/overlays/ticker/${token}/stream`
    ] as const;
    }


export const getStreamOverlayTickerMarketsQueryOptions = <TData = Awaited<ReturnType<typeof streamOverlayTickerMarkets>>, TError = ErrorType<void>>(token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof streamOverlayTickerMarkets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStreamOverlayTickerMarketsQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof streamOverlayTickerMarkets>>> = ({ signal }) => streamOverlayTickerMarkets(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof streamOverlayTickerMarkets>>, TError, TData> & { queryKey: QueryKey }
}

export type StreamOverlayTickerMarketsQueryResult = NonNullable<Awaited<ReturnType<typeof streamOverlayTickerMarkets>>>
export type StreamOverlayTickerMarketsQueryError = ErrorType<void>


/**
 * @summary Receive an OBS ticker link's scoped canonical event stream
 */

export function useStreamOverlayTickerMarkets<TData = Awaited<ReturnType<typeof streamOverlayTickerMarkets>>, TError = ErrorType<void>>(
 token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof streamOverlayTickerMarkets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getStreamOverlayTickerMarketsQueryOptions(token,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getStreamMarketOverlayMarketsUrl = (key: string,) => {




  return `/api/market-overlays/${key}/stream`
}

/**
 * @summary Receive a Market Overlay Studio key's scoped canonical event stream
 */
export const streamMarketOverlayMarkets = async (key: string, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getStreamMarketOverlayMarketsUrl(key),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStreamMarketOverlayMarketsQueryKey = (key: string,) => {
    return [
    `/api/market-overlays/${key}/stream`
    ] as const;
    }


export const getStreamMarketOverlayMarketsQueryOptions = <TData = Awaited<ReturnType<typeof streamMarketOverlayMarkets>>, TError = ErrorType<void>>(key: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof streamMarketOverlayMarkets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStreamMarketOverlayMarketsQueryKey(key);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof streamMarketOverlayMarkets>>> = ({ signal }) => streamMarketOverlayMarkets(key, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: key !== null && key !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof streamMarketOverlayMarkets>>, TError, TData> & { queryKey: QueryKey }
}

export type StreamMarketOverlayMarketsQueryResult = NonNullable<Awaited<ReturnType<typeof streamMarketOverlayMarkets>>>
export type StreamMarketOverlayMarketsQueryError = ErrorType<void>


/**
 * @summary Receive a Market Overlay Studio key's scoped canonical event stream
 */

export function useStreamMarketOverlayMarkets<TData = Awaited<ReturnType<typeof streamMarketOverlayMarkets>>, TError = ErrorType<void>>(
 key: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof streamMarketOverlayMarkets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getStreamMarketOverlayMarketsQueryOptions(key,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMetalPricesUrl = () => {




  return `/api/metal-prices`
}

/**
 * @summary Compatibility projection of the canonical Market Data Hub snapshot.
 */
export const getMetalPrices = async ( options?: RequestInit): Promise<MetalPricesResponse> => {

  return customFetch<MetalPricesResponse>(getGetMetalPricesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMetalPricesQueryKey = () => {
    return [
    `/api/metal-prices`
    ] as const;
    }


export const getGetMetalPricesQueryOptions = <TData = Awaited<ReturnType<typeof getMetalPrices>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMetalPrices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMetalPricesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMetalPrices>>> = ({ signal }) => getMetalPrices({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMetalPrices>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMetalPricesQueryResult = NonNullable<Awaited<ReturnType<typeof getMetalPrices>>>
export type GetMetalPricesQueryError = ErrorType<unknown>


/**
 * @summary Compatibility projection of the canonical Market Data Hub snapshot.
 */

export function useGetMetalPrices<TData = Awaited<ReturnType<typeof getMetalPrices>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMetalPrices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMetalPricesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCurrentSpotPricesUrl = () => {




  return `/api/spot-prices/current`
}

/**
 * @summary Latest persisted spot price per metal for this tenant. Cold tenants project the canonical hub without refreshing a provider.
 */
export const getCurrentSpotPrices = async ( options?: RequestInit): Promise<CurrentSpotPricesResponse> => {

  return customFetch<CurrentSpotPricesResponse>(getGetCurrentSpotPricesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCurrentSpotPricesQueryKey = () => {
    return [
    `/api/spot-prices/current`
    ] as const;
    }


export const getGetCurrentSpotPricesQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentSpotPrices>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentSpotPrices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentSpotPricesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentSpotPrices>>> = ({ signal }) => getCurrentSpotPrices({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentSpotPrices>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCurrentSpotPricesQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentSpotPrices>>>
export type GetCurrentSpotPricesQueryError = ErrorType<unknown>


/**
 * @summary Latest persisted spot price per metal for this tenant. Cold tenants project the canonical hub without refreshing a provider.
 */

export function useGetCurrentSpotPrices<TData = Awaited<ReturnType<typeof getCurrentSpotPrices>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentSpotPrices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCurrentSpotPricesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSpotPriceHistoryUrl = (params: GetSpotPriceHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/spot-prices/history?${stringifiedParams}` : `/api/spot-prices/history`
}

/**
 * @summary Trailing N-hour spot price series for one metal (for sparklines).
 */
export const getSpotPriceHistory = async (params: GetSpotPriceHistoryParams, options?: RequestInit): Promise<SpotPriceHistoryResponse> => {

  return customFetch<SpotPriceHistoryResponse>(getGetSpotPriceHistoryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSpotPriceHistoryQueryKey = (params?: GetSpotPriceHistoryParams,) => {
    return [
    `/api/spot-prices/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSpotPriceHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getSpotPriceHistory>>, TError = ErrorType<unknown>>(params: GetSpotPriceHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSpotPriceHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSpotPriceHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSpotPriceHistory>>> = ({ signal }) => getSpotPriceHistory(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSpotPriceHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSpotPriceHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getSpotPriceHistory>>>
export type GetSpotPriceHistoryQueryError = ErrorType<unknown>


/**
 * @summary Trailing N-hour spot price series for one metal (for sparklines).
 */

export function useGetSpotPriceHistory<TData = Awaited<ReturnType<typeof getSpotPriceHistory>>, TError = ErrorType<unknown>>(
 params: GetSpotPriceHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSpotPriceHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSpotPriceHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPostAskAiUrl = () => {




  return `/api/ask-ai`
}

/**
 * @summary Enqueue an ask-AI question. Returns 202 with a job id within ~100 ms.
Poll GET /ask-ai/jobs/{id} for status and the answer.

 */
export const postAskAi = async (askAiRequest: AskAiRequest, options?: RequestInit): Promise<AskAiResponse> => {

  return customFetch<AskAiResponse>(getPostAskAiUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(askAiRequest)
  }
);}





export const getPostAskAiMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAskAi>>, TError,{data: BodyType<AskAiRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postAskAi>>, TError,{data: BodyType<AskAiRequest>}, TContext> => {

const mutationKey = ['postAskAi'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAskAi>>, {data: BodyType<AskAiRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postAskAi(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAskAiMutationResult = NonNullable<Awaited<ReturnType<typeof postAskAi>>>
    export type PostAskAiMutationBody = BodyType<AskAiRequest>
    export type PostAskAiMutationError = ErrorType<void>

    /**
 * @summary Enqueue an ask-AI question. Returns 202 with a job id within ~100 ms.
Poll GET /ask-ai/jobs/{id} for status and the answer.

 */
export const usePostAskAi = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAskAi>>, TError,{data: BodyType<AskAiRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postAskAi>>,
        TError,
        {data: BodyType<AskAiRequest>},
        TContext
      > => {
      return useMutation(getPostAskAiMutationOptions(options));
    }

export const getGetEbayOrdersSyncUrl = () => {




  return `/api/ebay/orders/sync`
}

/**
 * @summary Trigger an idempotent eBay order sync (alias for the POST endpoint; same dedup + retry logic).
 */
export const getEbayOrdersSync = async ( options?: RequestInit): Promise<EbayOrdersSyncResponse> => {

  return customFetch<EbayOrdersSyncResponse>(getGetEbayOrdersSyncUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEbayOrdersSyncQueryKey = () => {
    return [
    `/api/ebay/orders/sync`
    ] as const;
    }


export const getGetEbayOrdersSyncQueryOptions = <TData = Awaited<ReturnType<typeof getEbayOrdersSync>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEbayOrdersSync>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEbayOrdersSyncQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEbayOrdersSync>>> = ({ signal }) => getEbayOrdersSync({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEbayOrdersSync>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEbayOrdersSyncQueryResult = NonNullable<Awaited<ReturnType<typeof getEbayOrdersSync>>>
export type GetEbayOrdersSyncQueryError = ErrorType<unknown>


/**
 * @summary Trigger an idempotent eBay order sync (alias for the POST endpoint; same dedup + retry logic).
 */

export function useGetEbayOrdersSync<TData = Awaited<ReturnType<typeof getEbayOrdersSync>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEbayOrdersSync>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEbayOrdersSyncQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCategoriesUrl = (params?: ListCategoriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/categories?${stringifiedParams}` : `/api/categories`
}

/**
 * @summary List dashboard-managed categories. Each row mirrors a Shopify custom_collection.
 */
export const listCategories = async (params?: ListCategoriesParams, options?: RequestInit): Promise<Category[]> => {

  return customFetch<Category[]>(getListCategoriesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCategoriesQueryKey = (params?: ListCategoriesParams,) => {
    return [
    `/api/categories`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof listCategories>>, TError = ErrorType<unknown>>(params?: ListCategoriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCategoriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCategories>>> = ({ signal }) => listCategories(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof listCategories>>>
export type ListCategoriesQueryError = ErrorType<unknown>


/**
 * @summary List dashboard-managed categories. Each row mirrors a Shopify custom_collection.
 */

export function useListCategories<TData = Awaited<ReturnType<typeof listCategories>>, TError = ErrorType<unknown>>(
 params?: ListCategoriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCategoriesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCategoryUrl = () => {




  return `/api/categories`
}

/**
 * @summary Create a category and asynchronously mirror it to Shopify as a custom_collection.
 */
export const createCategory = async (categoryCreate: CategoryCreate, options?: RequestInit): Promise<Category> => {

  return customFetch<Category>(getCreateCategoryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(categoryCreate)
  }
);}





export const getCreateCategoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCategory>>, TError,{data: BodyType<CategoryCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCategory>>, TError,{data: BodyType<CategoryCreate>}, TContext> => {

const mutationKey = ['createCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCategory>>, {data: BodyType<CategoryCreate>}> = (props) => {
          const {data} = props ?? {};

          return  createCategory(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof createCategory>>>
    export type CreateCategoryMutationBody = BodyType<CategoryCreate>
    export type CreateCategoryMutationError = ErrorType<unknown>

    /**
 * @summary Create a category and asynchronously mirror it to Shopify as a custom_collection.
 */
export const useCreateCategory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCategory>>, TError,{data: BodyType<CategoryCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCategory>>,
        TError,
        {data: BodyType<CategoryCreate>},
        TContext
      > => {
      return useMutation(getCreateCategoryMutationOptions(options));
    }

export const getUpdateCategoryUrl = (id: string,) => {




  return `/api/categories/${id}`
}

/**
 * @summary Rename or archive a category. Renames are mirrored to the linked Shopify custom_collection (handle is preserved).
 */
export const updateCategory = async (id: string,
    categoryUpdate: CategoryUpdate, options?: RequestInit): Promise<UpdateCategory200> => {

  return customFetch<UpdateCategory200>(getUpdateCategoryUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(categoryUpdate)
  }
);}





export const getUpdateCategoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCategory>>, TError,{id: string;data: BodyType<CategoryUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCategory>>, TError,{id: string;data: BodyType<CategoryUpdate>}, TContext> => {

const mutationKey = ['updateCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCategory>>, {id: string;data: BodyType<CategoryUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCategory(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof updateCategory>>>
    export type UpdateCategoryMutationBody = BodyType<CategoryUpdate>
    export type UpdateCategoryMutationError = ErrorType<unknown>

    /**
 * @summary Rename or archive a category. Renames are mirrored to the linked Shopify custom_collection (handle is preserved).
 */
export const useUpdateCategory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCategory>>, TError,{id: string;data: BodyType<CategoryUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCategory>>,
        TError,
        {id: string;data: BodyType<CategoryUpdate>},
        TContext
      > => {
      return useMutation(getUpdateCategoryMutationOptions(options));
    }

export const getArchiveCategoryUrl = (id: string,) => {




  return `/api/categories/${id}`
}

/**
 * @summary Soft-delete a category. The linked Shopify collection is unpublished (never hard-deleted) so storefront URLs survive.
 */
export const archiveCategory = async (id: string, options?: RequestInit): Promise<ArchiveCategory200> => {

  return customFetch<ArchiveCategory200>(getArchiveCategoryUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getArchiveCategoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveCategory>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveCategory>>, TError,{id: string}, TContext> => {

const mutationKey = ['archiveCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveCategory>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  archiveCategory(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof archiveCategory>>>

    export type ArchiveCategoryMutationError = ErrorType<unknown>

    /**
 * @summary Soft-delete a category. The linked Shopify collection is unpublished (never hard-deleted) so storefront URLs survive.
 */
export const useArchiveCategory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveCategory>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof archiveCategory>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getArchiveCategoryMutationOptions(options));
    }

export const getValidateRandomShopifyProductUrl = () => {




  return `/api/integrations/shopify/validate-random`
}

/**
 * @summary Pull a random Shopify product, diff it against local inventory by SKU, persist a snapshot, and return the diff.
 */
export const validateRandomShopifyProduct = async ( options?: RequestInit): Promise<ShopifyValidationResult> => {

  return customFetch<ShopifyValidationResult>(getValidateRandomShopifyProductUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getValidateRandomShopifyProductMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateRandomShopifyProduct>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof validateRandomShopifyProduct>>, TError,void, TContext> => {

const mutationKey = ['validateRandomShopifyProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validateRandomShopifyProduct>>, void> = () => {


          return  validateRandomShopifyProduct(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ValidateRandomShopifyProductMutationResult = NonNullable<Awaited<ReturnType<typeof validateRandomShopifyProduct>>>

    export type ValidateRandomShopifyProductMutationError = ErrorType<unknown>

    /**
 * @summary Pull a random Shopify product, diff it against local inventory by SKU, persist a snapshot, and return the diff.
 */
export const useValidateRandomShopifyProduct = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateRandomShopifyProduct>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof validateRandomShopifyProduct>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getValidateRandomShopifyProductMutationOptions(options));
    }

export const getGetShopifyDefinitionValidationUrl = () => {




  return `/api/integrations/shopify/definition-validation`
}

/**
 * @summary Discover Shopify product metafield definitions and compare them with the structured field registry.
 */
export const getShopifyDefinitionValidation = async ( options?: RequestInit): Promise<ShopifyDefinitionValidationResult> => {

  return customFetch<ShopifyDefinitionValidationResult>(getGetShopifyDefinitionValidationUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetShopifyDefinitionValidationQueryKey = () => {
    return [
    `/api/integrations/shopify/definition-validation`
    ] as const;
    }


export const getGetShopifyDefinitionValidationQueryOptions = <TData = Awaited<ReturnType<typeof getShopifyDefinitionValidation>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopifyDefinitionValidation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShopifyDefinitionValidationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShopifyDefinitionValidation>>> = ({ signal }) => getShopifyDefinitionValidation({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShopifyDefinitionValidation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetShopifyDefinitionValidationQueryResult = NonNullable<Awaited<ReturnType<typeof getShopifyDefinitionValidation>>>
export type GetShopifyDefinitionValidationQueryError = ErrorType<unknown>


/**
 * @summary Discover Shopify product metafield definitions and compare them with the structured field registry.
 */

export function useGetShopifyDefinitionValidation<TData = Awaited<ReturnType<typeof getShopifyDefinitionValidation>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopifyDefinitionValidation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetShopifyDefinitionValidationQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRefreshShopifyDefinitionValidationUrl = () => {




  return `/api/integrations/shopify/definition-validation/refresh`
}

/**
 * @summary Safely refresh Shopify product metafield definitions from the Admin API.
 */
export const refreshShopifyDefinitionValidation = async ( options?: RequestInit): Promise<ShopifyDefinitionValidationResult> => {

  return customFetch<ShopifyDefinitionValidationResult>(getRefreshShopifyDefinitionValidationUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRefreshShopifyDefinitionValidationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshShopifyDefinitionValidation>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshShopifyDefinitionValidation>>, TError,void, TContext> => {

const mutationKey = ['refreshShopifyDefinitionValidation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshShopifyDefinitionValidation>>, void> = () => {


          return  refreshShopifyDefinitionValidation(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshShopifyDefinitionValidationMutationResult = NonNullable<Awaited<ReturnType<typeof refreshShopifyDefinitionValidation>>>

    export type RefreshShopifyDefinitionValidationMutationError = ErrorType<unknown>

    /**
 * @summary Safely refresh Shopify product metafield definitions from the Admin API.
 */
export const useRefreshShopifyDefinitionValidation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshShopifyDefinitionValidation>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof refreshShopifyDefinitionValidation>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRefreshShopifyDefinitionValidationMutationOptions(options));
    }

export const getListShopifyCollectionsUrl = (params?: ListShopifyCollectionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/shopify/collections?${stringifiedParams}` : `/api/shopify/collections`
}

/**
 * Returns every collection currently mirrored from Shopify into the
 * local `shopify_collections` table. The mirror is refreshed every
 * 30 minutes by the Shopify scheduler tick; a manual refresh is
 * available via `POST /integrations/shopify/sync-collections`.
 * SMART collections are read-only — Shopify auto-populates them
 * based on rules and the inventory editor surfaces them as
 * non-selectable chips so operators can see which storefront
 * categories an item lands in.
 * @summary List the local mirror of Shopify collections (custom + smart) for the inventory editor's multi-select.
 */
export const listShopifyCollections = async (params?: ListShopifyCollectionsParams, options?: RequestInit): Promise<ListShopifyCollections200> => {

  return customFetch<ListShopifyCollections200>(getListShopifyCollectionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListShopifyCollectionsQueryKey = (params?: ListShopifyCollectionsParams,) => {
    return [
    `/api/shopify/collections`, ...(params ? [params] : [])
    ] as const;
    }


export const getListShopifyCollectionsQueryOptions = <TData = Awaited<ReturnType<typeof listShopifyCollections>>, TError = ErrorType<unknown>>(params?: ListShopifyCollectionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShopifyCollections>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListShopifyCollectionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listShopifyCollections>>> = ({ signal }) => listShopifyCollections(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listShopifyCollections>>, TError, TData> & { queryKey: QueryKey }
}

export type ListShopifyCollectionsQueryResult = NonNullable<Awaited<ReturnType<typeof listShopifyCollections>>>
export type ListShopifyCollectionsQueryError = ErrorType<unknown>


/**
 * @summary List the local mirror of Shopify collections (custom + smart) for the inventory editor's multi-select.
 */

export function useListShopifyCollections<TData = Awaited<ReturnType<typeof listShopifyCollections>>, TError = ErrorType<unknown>>(
 params?: ListShopifyCollectionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShopifyCollections>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListShopifyCollectionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSyncShopifyCollectionsUrl = () => {




  return `/api/integrations/shopify/sync-collections`
}

/**
 * Pulls every custom + smart collection from Shopify and upserts into the local mirror. Returns counts. Same job runs automatically every 30 minutes.
 * @summary Manually trigger a refresh of the local Shopify collections mirror.
 */
export const syncShopifyCollections = async ( options?: RequestInit): Promise<ShopifyCollectionsSyncResult> => {

  return customFetch<ShopifyCollectionsSyncResult>(getSyncShopifyCollectionsUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSyncShopifyCollectionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncShopifyCollections>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncShopifyCollections>>, TError,void, TContext> => {

const mutationKey = ['syncShopifyCollections'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncShopifyCollections>>, void> = () => {


          return  syncShopifyCollections(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncShopifyCollectionsMutationResult = NonNullable<Awaited<ReturnType<typeof syncShopifyCollections>>>

    export type SyncShopifyCollectionsMutationError = ErrorType<unknown>

    /**
 * @summary Manually trigger a refresh of the local Shopify collections mirror.
 */
export const useSyncShopifyCollections = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncShopifyCollections>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncShopifyCollections>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSyncShopifyCollectionsMutationOptions(options));
    }

export const getRemoveCompositeSourceBackgroundUrl = (id: string,) => {




  return `/api/inventory/${id}/composite/remove-background`
}

/**
 * Pulls the source image from object storage, ships it to remove.bg,
 * and saves the returned transparent PNG back into the same uploads
 * bucket. Returns the new `objectPath` — the FE then sets that as
 * the composite source so the operator can save the composite as
 * usual. Source must be one of the item's existing photos OR the
 * currently-pinned composite source (same ownership gate as the
 * composite generate endpoint). Requires `REMOVE_BG_API_KEY`.
 * @summary Run AI background-removal on a source photo and return the new transparent-PNG object path.
 */
export const removeCompositeSourceBackground = async (id: string,
    removeBackgroundRequest: RemoveBackgroundRequest, options?: RequestInit): Promise<RemoveBackgroundResult> => {

  return customFetch<RemoveBackgroundResult>(getRemoveCompositeSourceBackgroundUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(removeBackgroundRequest)
  }
);}





export const getRemoveCompositeSourceBackgroundMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCompositeSourceBackground>>, TError,{id: string;data: BodyType<RemoveBackgroundRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeCompositeSourceBackground>>, TError,{id: string;data: BodyType<RemoveBackgroundRequest>}, TContext> => {

const mutationKey = ['removeCompositeSourceBackground'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeCompositeSourceBackground>>, {id: string;data: BodyType<RemoveBackgroundRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  removeCompositeSourceBackground(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveCompositeSourceBackgroundMutationResult = NonNullable<Awaited<ReturnType<typeof removeCompositeSourceBackground>>>
    export type RemoveCompositeSourceBackgroundMutationBody = BodyType<RemoveBackgroundRequest>
    export type RemoveCompositeSourceBackgroundMutationError = ErrorType<void>

    /**
 * @summary Run AI background-removal on a source photo and return the new transparent-PNG object path.
 */
export const useRemoveCompositeSourceBackground = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCompositeSourceBackground>>, TError,{id: string;data: BodyType<RemoveBackgroundRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeCompositeSourceBackground>>,
        TError,
        {id: string;data: BodyType<RemoveBackgroundRequest>},
        TContext
      > => {
      return useMutation(getRemoveCompositeSourceBackgroundMutationOptions(options));
    }

export const getMarkComingSoonArrivedUrl = (id: string,) => {




  return `/api/inventory/${id}/coming-soon/mark-arrived`
}

/**
 * Single-transaction move. Validates that N is positive and does not
 * exceed the item's current `quantityComingSoon`. Audited per field
 * (one row for `quantityComingSoon`, one for `quantity`).
 * @summary Move N units from `quantityComingSoon` to `quantity` once they physically arrive.
 */
export const markComingSoonArrived = async (id: string,
    comingSoonMarkArrivedRequest: ComingSoonMarkArrivedRequest, options?: RequestInit): Promise<MarkComingSoonArrivedResult> => {

  return customFetch<MarkComingSoonArrivedResult>(getMarkComingSoonArrivedUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(comingSoonMarkArrivedRequest)
  }
);}





export const getMarkComingSoonArrivedMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markComingSoonArrived>>, TError,{id: string;data: BodyType<ComingSoonMarkArrivedRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markComingSoonArrived>>, TError,{id: string;data: BodyType<ComingSoonMarkArrivedRequest>}, TContext> => {

const mutationKey = ['markComingSoonArrived'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markComingSoonArrived>>, {id: string;data: BodyType<ComingSoonMarkArrivedRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  markComingSoonArrived(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkComingSoonArrivedMutationResult = NonNullable<Awaited<ReturnType<typeof markComingSoonArrived>>>
    export type MarkComingSoonArrivedMutationBody = BodyType<ComingSoonMarkArrivedRequest>
    export type MarkComingSoonArrivedMutationError = ErrorType<void>

    /**
 * @summary Move N units from `quantityComingSoon` to `quantity` once they physically arrive.
 */
export const useMarkComingSoonArrived = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markComingSoonArrived>>, TError,{id: string;data: BodyType<ComingSoonMarkArrivedRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markComingSoonArrived>>,
        TError,
        {id: string;data: BodyType<ComingSoonMarkArrivedRequest>},
        TContext
      > => {
      return useMutation(getMarkComingSoonArrivedMutationOptions(options));
    }

export const getListShopifyValidationRunsUrl = (params?: ListShopifyValidationRunsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/integrations/shopify/validation-log?${stringifiedParams}` : `/api/integrations/shopify/validation-log`
}

/**
 * @summary Recent random-product validation runs (newest first).
 */
export const listShopifyValidationRuns = async (params?: ListShopifyValidationRunsParams, options?: RequestInit): Promise<ShopifyValidationRunSummary[]> => {

  return customFetch<ShopifyValidationRunSummary[]>(getListShopifyValidationRunsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListShopifyValidationRunsQueryKey = (params?: ListShopifyValidationRunsParams,) => {
    return [
    `/api/integrations/shopify/validation-log`, ...(params ? [params] : [])
    ] as const;
    }


export const getListShopifyValidationRunsQueryOptions = <TData = Awaited<ReturnType<typeof listShopifyValidationRuns>>, TError = ErrorType<unknown>>(params?: ListShopifyValidationRunsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShopifyValidationRuns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListShopifyValidationRunsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listShopifyValidationRuns>>> = ({ signal }) => listShopifyValidationRuns(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listShopifyValidationRuns>>, TError, TData> & { queryKey: QueryKey }
}

export type ListShopifyValidationRunsQueryResult = NonNullable<Awaited<ReturnType<typeof listShopifyValidationRuns>>>
export type ListShopifyValidationRunsQueryError = ErrorType<unknown>


/**
 * @summary Recent random-product validation runs (newest first).
 */

export function useListShopifyValidationRuns<TData = Awaited<ReturnType<typeof listShopifyValidationRuns>>, TError = ErrorType<unknown>>(
 params?: ListShopifyValidationRunsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShopifyValidationRuns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListShopifyValidationRunsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListTitleMappingsUrl = (params?: ListTitleMappingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/title-mappings?${stringifiedParams}` : `/api/title-mappings`
}

/**
 * @summary List saved raw-title → inventory item mappings (newest first).
 */
export const listTitleMappings = async (params?: ListTitleMappingsParams, options?: RequestInit): Promise<TitleMapping[]> => {

  return customFetch<TitleMapping[]>(getListTitleMappingsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTitleMappingsQueryKey = (params?: ListTitleMappingsParams,) => {
    return [
    `/api/title-mappings`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTitleMappingsQueryOptions = <TData = Awaited<ReturnType<typeof listTitleMappings>>, TError = ErrorType<unknown>>(params?: ListTitleMappingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTitleMappings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTitleMappingsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTitleMappings>>> = ({ signal }) => listTitleMappings(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTitleMappings>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTitleMappingsQueryResult = NonNullable<Awaited<ReturnType<typeof listTitleMappings>>>
export type ListTitleMappingsQueryError = ErrorType<unknown>


/**
 * @summary List saved raw-title → inventory item mappings (newest first).
 */

export function useListTitleMappings<TData = Awaited<ReturnType<typeof listTitleMappings>>, TError = ErrorType<unknown>>(
 params?: ListTitleMappingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTitleMappings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTitleMappingsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateTitleMappingUrl = () => {




  return `/api/title-mappings`
}

/**
 * @summary Save a confirmed mapping (manual confirmation from the review UI). Idempotent on lower(raw_title).
 */
export const createTitleMapping = async (titleMappingCreate: TitleMappingCreate, options?: RequestInit): Promise<TitleMapping> => {

  return customFetch<TitleMapping>(getCreateTitleMappingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(titleMappingCreate)
  }
);}





export const getCreateTitleMappingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTitleMapping>>, TError,{data: BodyType<TitleMappingCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTitleMapping>>, TError,{data: BodyType<TitleMappingCreate>}, TContext> => {

const mutationKey = ['createTitleMapping'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTitleMapping>>, {data: BodyType<TitleMappingCreate>}> = (props) => {
          const {data} = props ?? {};

          return  createTitleMapping(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTitleMappingMutationResult = NonNullable<Awaited<ReturnType<typeof createTitleMapping>>>
    export type CreateTitleMappingMutationBody = BodyType<TitleMappingCreate>
    export type CreateTitleMappingMutationError = ErrorType<unknown>

    /**
 * @summary Save a confirmed mapping (manual confirmation from the review UI). Idempotent on lower(raw_title).
 */
export const useCreateTitleMapping = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTitleMapping>>, TError,{data: BodyType<TitleMappingCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTitleMapping>>,
        TError,
        {data: BodyType<TitleMappingCreate>},
        TContext
      > => {
      return useMutation(getCreateTitleMappingMutationOptions(options));
    }

export const getDeleteTitleMappingUrl = (id: string,) => {




  return `/api/title-mappings/${id}`
}

/**
 * @summary Remove a saved mapping. Future imports will re-run the matcher from scratch.
 */
export const deleteTitleMapping = async (id: string, options?: RequestInit): Promise<DeleteTitleMapping200> => {

  return customFetch<DeleteTitleMapping200>(getDeleteTitleMappingUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTitleMappingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTitleMapping>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTitleMapping>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteTitleMapping'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTitleMapping>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteTitleMapping(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTitleMappingMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTitleMapping>>>

    export type DeleteTitleMappingMutationError = ErrorType<unknown>

    /**
 * @summary Remove a saved mapping. Future imports will re-run the matcher from scratch.
 */
export const useDeleteTitleMapping = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTitleMapping>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTitleMapping>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteTitleMappingMutationOptions(options));
    }

export const getGetSystemHealthDashboardUrl = () => {




  return `/api/audit/system-health-dashboard`
}

/**
 * @summary One-shot operator dashboard. Combines the data-quality audit summary with scheduler heartbeat, integration sync status, recent imports, unresolved import issues, stock-sync queue, and external service connectivity.
 */
export const getSystemHealthDashboard = async ( options?: RequestInit): Promise<SystemHealthDashboard> => {

  return customFetch<SystemHealthDashboard>(getGetSystemHealthDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSystemHealthDashboardQueryKey = () => {
    return [
    `/api/audit/system-health-dashboard`
    ] as const;
    }


export const getGetSystemHealthDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getSystemHealthDashboard>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSystemHealthDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSystemHealthDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSystemHealthDashboard>>> = ({ signal }) => getSystemHealthDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSystemHealthDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSystemHealthDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getSystemHealthDashboard>>>
export type GetSystemHealthDashboardQueryError = ErrorType<unknown>


/**
 * @summary One-shot operator dashboard. Combines the data-quality audit summary with scheduler heartbeat, integration sync status, recent imports, unresolved import issues, stock-sync queue, and external service connectivity.
 */

export function useGetSystemHealthDashboard<TData = Awaited<ReturnType<typeof getSystemHealthDashboard>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSystemHealthDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSystemHealthDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getMatchTitleUrl = () => {




  return `/api/title-mappings/match`
}

/**
 * @summary Run the matcher against a raw title and return ranked candidates with confidence scores. Read-only; does not save a mapping.
 */
export const matchTitle = async (titleMatchRequest: TitleMatchRequest, options?: RequestInit): Promise<TitleMatchResponse> => {

  return customFetch<TitleMatchResponse>(getMatchTitleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(titleMatchRequest)
  }
);}





export const getMatchTitleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchTitle>>, TError,{data: BodyType<TitleMatchRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof matchTitle>>, TError,{data: BodyType<TitleMatchRequest>}, TContext> => {

const mutationKey = ['matchTitle'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof matchTitle>>, {data: BodyType<TitleMatchRequest>}> = (props) => {
          const {data} = props ?? {};

          return  matchTitle(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MatchTitleMutationResult = NonNullable<Awaited<ReturnType<typeof matchTitle>>>
    export type MatchTitleMutationBody = BodyType<TitleMatchRequest>
    export type MatchTitleMutationError = ErrorType<unknown>

    /**
 * @summary Run the matcher against a raw title and return ranked candidates with confidence scores. Read-only; does not save a mapping.
 */
export const useMatchTitle = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchTitle>>, TError,{data: BodyType<TitleMatchRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof matchTitle>>,
        TError,
        {data: BodyType<TitleMatchRequest>},
        TContext
      > => {
      return useMutation(getMatchTitleMutationOptions(options));
    }

export const getBulkDeleteTitleMappingsUrl = () => {




  return `/api/title-mappings/bulk-delete`
}

/**
 * @summary Bulk-remove saved mappings by `source` (e.g. clean up all auto-saved guesses) or by explicit `ids`. The body MUST narrow the scope — calls without either filter are rejected.
 */
export const bulkDeleteTitleMappings = async (titleMappingsBulkDeleteRequest: TitleMappingsBulkDeleteRequest, options?: RequestInit): Promise<TitleMappingsBulkDeleteResponse> => {

  return customFetch<TitleMappingsBulkDeleteResponse>(getBulkDeleteTitleMappingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(titleMappingsBulkDeleteRequest)
  }
);}





export const getBulkDeleteTitleMappingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteTitleMappings>>, TError,{data: BodyType<TitleMappingsBulkDeleteRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteTitleMappings>>, TError,{data: BodyType<TitleMappingsBulkDeleteRequest>}, TContext> => {

const mutationKey = ['bulkDeleteTitleMappings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkDeleteTitleMappings>>, {data: BodyType<TitleMappingsBulkDeleteRequest>}> = (props) => {
          const {data} = props ?? {};

          return  bulkDeleteTitleMappings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkDeleteTitleMappingsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkDeleteTitleMappings>>>
    export type BulkDeleteTitleMappingsMutationBody = BodyType<TitleMappingsBulkDeleteRequest>
    export type BulkDeleteTitleMappingsMutationError = ErrorType<unknown>

    /**
 * @summary Bulk-remove saved mappings by `source` (e.g. clean up all auto-saved guesses) or by explicit `ids`. The body MUST narrow the scope — calls without either filter are rejected.
 */
export const useBulkDeleteTitleMappings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteTitleMappings>>, TError,{data: BodyType<TitleMappingsBulkDeleteRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkDeleteTitleMappings>>,
        TError,
        {data: BodyType<TitleMappingsBulkDeleteRequest>},
        TContext
      > => {
      return useMutation(getBulkDeleteTitleMappingsMutationOptions(options));
    }

export const getListWorkflowsUrl = () => {




  return `/api/workflows`
}

export const listWorkflows = async ( options?: RequestInit): Promise<Workflow[]> => {

  return customFetch<Workflow[]>(getListWorkflowsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListWorkflowsQueryKey = () => {
    return [
    `/api/workflows`
    ] as const;
    }


export const getListWorkflowsQueryOptions = <TData = Awaited<ReturnType<typeof listWorkflows>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWorkflows>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWorkflowsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWorkflows>>> = ({ signal }) => listWorkflows({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWorkflows>>, TError, TData> & { queryKey: QueryKey }
}

export type ListWorkflowsQueryResult = NonNullable<Awaited<ReturnType<typeof listWorkflows>>>
export type ListWorkflowsQueryError = ErrorType<unknown>



export function useListWorkflows<TData = Awaited<ReturnType<typeof listWorkflows>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWorkflows>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListWorkflowsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateWorkflowUrl = () => {




  return `/api/workflows`
}

export const createWorkflow = async (workflowInput: WorkflowInput, options?: RequestInit): Promise<Workflow> => {

  return customFetch<Workflow>(getCreateWorkflowUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(workflowInput)
  }
);}





export const getCreateWorkflowMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkflow>>, TError,{data: BodyType<WorkflowInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createWorkflow>>, TError,{data: BodyType<WorkflowInput>}, TContext> => {

const mutationKey = ['createWorkflow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorkflow>>, {data: BodyType<WorkflowInput>}> = (props) => {
          const {data} = props ?? {};

          return  createWorkflow(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWorkflowMutationResult = NonNullable<Awaited<ReturnType<typeof createWorkflow>>>
    export type CreateWorkflowMutationBody = BodyType<WorkflowInput>
    export type CreateWorkflowMutationError = ErrorType<unknown>

    export const useCreateWorkflow = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkflow>>, TError,{data: BodyType<WorkflowInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createWorkflow>>,
        TError,
        {data: BodyType<WorkflowInput>},
        TContext
      > => {
      return useMutation(getCreateWorkflowMutationOptions(options));
    }

export const getUpdateWorkflowUrl = (id: string,) => {




  return `/api/workflows/${id}`
}

export const updateWorkflow = async (id: string,
    workflowInput: WorkflowInput, options?: RequestInit): Promise<Workflow> => {

  return customFetch<Workflow>(getUpdateWorkflowUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(workflowInput)
  }
);}





export const getUpdateWorkflowMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkflow>>, TError,{id: string;data: BodyType<WorkflowInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateWorkflow>>, TError,{id: string;data: BodyType<WorkflowInput>}, TContext> => {

const mutationKey = ['updateWorkflow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorkflow>>, {id: string;data: BodyType<WorkflowInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateWorkflow(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorkflowMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorkflow>>>
    export type UpdateWorkflowMutationBody = BodyType<WorkflowInput>
    export type UpdateWorkflowMutationError = ErrorType<void>

    export const useUpdateWorkflow = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkflow>>, TError,{id: string;data: BodyType<WorkflowInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateWorkflow>>,
        TError,
        {id: string;data: BodyType<WorkflowInput>},
        TContext
      > => {
      return useMutation(getUpdateWorkflowMutationOptions(options));
    }

export const getDeleteWorkflowUrl = (id: string,) => {




  return `/api/workflows/${id}`
}

export const deleteWorkflow = async (id: string, options?: RequestInit): Promise<OkResult> => {

  return customFetch<OkResult>(getDeleteWorkflowUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteWorkflowMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkflow>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteWorkflow>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteWorkflow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWorkflow>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteWorkflow(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteWorkflowMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWorkflow>>>

    export type DeleteWorkflowMutationError = ErrorType<unknown>

    export const useDeleteWorkflow = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkflow>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteWorkflow>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteWorkflowMutationOptions(options));
    }

export const getTestWorkflowRouteUrl = (id: string,) => {




  return `/api/workflows/${id}/test`
}

export const testWorkflowRoute = async (id: string,
    workflowTestInput?: WorkflowTestInput, options?: RequestInit): Promise<WorkflowTestResult> => {

  return customFetch<WorkflowTestResult>(getTestWorkflowRouteUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(workflowTestInput)
  }
);}





export const getTestWorkflowRouteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testWorkflowRoute>>, TError,{id: string;data?: BodyType<WorkflowTestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testWorkflowRoute>>, TError,{id: string;data?: BodyType<WorkflowTestInput>}, TContext> => {

const mutationKey = ['testWorkflowRoute'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testWorkflowRoute>>, {id: string;data?: BodyType<WorkflowTestInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  testWorkflowRoute(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestWorkflowRouteMutationResult = NonNullable<Awaited<ReturnType<typeof testWorkflowRoute>>>
    export type TestWorkflowRouteMutationBody = BodyType<WorkflowTestInput> | undefined
    export type TestWorkflowRouteMutationError = ErrorType<unknown>

    export const useTestWorkflowRoute = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testWorkflowRoute>>, TError,{id: string;data?: BodyType<WorkflowTestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof testWorkflowRoute>>,
        TError,
        {id: string;data?: BodyType<WorkflowTestInput>},
        TContext
      > => {
      return useMutation(getTestWorkflowRouteMutationOptions(options));
    }

export const getListWorkflowRunsUrl = (params?: ListWorkflowRunsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/workflows/runs?${stringifiedParams}` : `/api/workflows/runs`
}

export const listWorkflowRuns = async (params?: ListWorkflowRunsParams, options?: RequestInit): Promise<WorkflowRun[]> => {

  return customFetch<WorkflowRun[]>(getListWorkflowRunsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListWorkflowRunsQueryKey = (params?: ListWorkflowRunsParams,) => {
    return [
    `/api/workflows/runs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListWorkflowRunsQueryOptions = <TData = Awaited<ReturnType<typeof listWorkflowRuns>>, TError = ErrorType<unknown>>(params?: ListWorkflowRunsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWorkflowRuns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWorkflowRunsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWorkflowRuns>>> = ({ signal }) => listWorkflowRuns(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWorkflowRuns>>, TError, TData> & { queryKey: QueryKey }
}

export type ListWorkflowRunsQueryResult = NonNullable<Awaited<ReturnType<typeof listWorkflowRuns>>>
export type ListWorkflowRunsQueryError = ErrorType<unknown>



export function useListWorkflowRuns<TData = Awaited<ReturnType<typeof listWorkflowRuns>>, TError = ErrorType<unknown>>(
 params?: ListWorkflowRunsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWorkflowRuns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListWorkflowRunsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListEmailTemplatesUrl = () => {




  return `/api/workflows/email-templates`
}

export const listEmailTemplates = async ( options?: RequestInit): Promise<EmailTemplate[]> => {

  return customFetch<EmailTemplate[]>(getListEmailTemplatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEmailTemplatesQueryKey = () => {
    return [
    `/api/workflows/email-templates`
    ] as const;
    }


export const getListEmailTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof listEmailTemplates>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEmailTemplates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEmailTemplatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEmailTemplates>>> = ({ signal }) => listEmailTemplates({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEmailTemplates>>, TError, TData> & { queryKey: QueryKey }
}

export type ListEmailTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof listEmailTemplates>>>
export type ListEmailTemplatesQueryError = ErrorType<unknown>



export function useListEmailTemplates<TData = Awaited<ReturnType<typeof listEmailTemplates>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEmailTemplates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListEmailTemplatesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateEmailTemplateUrl = () => {




  return `/api/workflows/email-templates`
}

export const createEmailTemplate = async (emailTemplateInput: EmailTemplateInput, options?: RequestInit): Promise<EmailTemplate> => {

  return customFetch<EmailTemplate>(getCreateEmailTemplateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailTemplateInput)
  }
);}





export const getCreateEmailTemplateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmailTemplate>>, TError,{data: BodyType<EmailTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createEmailTemplate>>, TError,{data: BodyType<EmailTemplateInput>}, TContext> => {

const mutationKey = ['createEmailTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmailTemplate>>, {data: BodyType<EmailTemplateInput>}> = (props) => {
          const {data} = props ?? {};

          return  createEmailTemplate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEmailTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof createEmailTemplate>>>
    export type CreateEmailTemplateMutationBody = BodyType<EmailTemplateInput>
    export type CreateEmailTemplateMutationError = ErrorType<void>

    export const useCreateEmailTemplate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmailTemplate>>, TError,{data: BodyType<EmailTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createEmailTemplate>>,
        TError,
        {data: BodyType<EmailTemplateInput>},
        TContext
      > => {
      return useMutation(getCreateEmailTemplateMutationOptions(options));
    }

export const getUpdateEmailTemplateUrl = (id: string,) => {




  return `/api/workflows/email-templates/${id}`
}

export const updateEmailTemplate = async (id: string,
    emailTemplateInput: EmailTemplateInput, options?: RequestInit): Promise<EmailTemplate> => {

  return customFetch<EmailTemplate>(getUpdateEmailTemplateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailTemplateInput)
  }
);}





export const getUpdateEmailTemplateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmailTemplate>>, TError,{id: string;data: BodyType<EmailTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmailTemplate>>, TError,{id: string;data: BodyType<EmailTemplateInput>}, TContext> => {

const mutationKey = ['updateEmailTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmailTemplate>>, {id: string;data: BodyType<EmailTemplateInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateEmailTemplate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmailTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmailTemplate>>>
    export type UpdateEmailTemplateMutationBody = BodyType<EmailTemplateInput>
    export type UpdateEmailTemplateMutationError = ErrorType<void>

    export const useUpdateEmailTemplate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmailTemplate>>, TError,{id: string;data: BodyType<EmailTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateEmailTemplate>>,
        TError,
        {id: string;data: BodyType<EmailTemplateInput>},
        TContext
      > => {
      return useMutation(getUpdateEmailTemplateMutationOptions(options));
    }

export const getDeleteEmailTemplateUrl = (id: string,) => {




  return `/api/workflows/email-templates/${id}`
}

export const deleteEmailTemplate = async (id: string, options?: RequestInit): Promise<OkResult> => {

  return customFetch<OkResult>(getDeleteEmailTemplateUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteEmailTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmailTemplate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEmailTemplate>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteEmailTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEmailTemplate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteEmailTemplate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteEmailTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEmailTemplate>>>

    export type DeleteEmailTemplateMutationError = ErrorType<unknown>

    export const useDeleteEmailTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmailTemplate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteEmailTemplate>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteEmailTemplateMutationOptions(options));
    }

export const getGetWorkflowSmtpUrl = () => {




  return `/api/workflows/smtp`
}

export const getWorkflowSmtp = async ( options?: RequestInit): Promise<SmtpSettingsRedacted | null> => {

  return customFetch<SmtpSettingsRedacted | null>(getGetWorkflowSmtpUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWorkflowSmtpQueryKey = () => {
    return [
    `/api/workflows/smtp`
    ] as const;
    }


export const getGetWorkflowSmtpQueryOptions = <TData = Awaited<ReturnType<typeof getWorkflowSmtp>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWorkflowSmtp>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkflowSmtpQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkflowSmtp>>> = ({ signal }) => getWorkflowSmtp({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkflowSmtp>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWorkflowSmtpQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkflowSmtp>>>
export type GetWorkflowSmtpQueryError = ErrorType<unknown>



export function useGetWorkflowSmtp<TData = Awaited<ReturnType<typeof getWorkflowSmtp>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWorkflowSmtp>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWorkflowSmtpQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPutWorkflowSmtpUrl = () => {




  return `/api/workflows/smtp`
}

export const putWorkflowSmtp = async (smtpSettingsInput: SmtpSettingsInput, options?: RequestInit): Promise<OkResult> => {

  return customFetch<OkResult>(getPutWorkflowSmtpUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(smtpSettingsInput)
  }
);}





export const getPutWorkflowSmtpMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putWorkflowSmtp>>, TError,{data: BodyType<SmtpSettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putWorkflowSmtp>>, TError,{data: BodyType<SmtpSettingsInput>}, TContext> => {

const mutationKey = ['putWorkflowSmtp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putWorkflowSmtp>>, {data: BodyType<SmtpSettingsInput>}> = (props) => {
          const {data} = props ?? {};

          return  putWorkflowSmtp(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutWorkflowSmtpMutationResult = NonNullable<Awaited<ReturnType<typeof putWorkflowSmtp>>>
    export type PutWorkflowSmtpMutationBody = BodyType<SmtpSettingsInput>
    export type PutWorkflowSmtpMutationError = ErrorType<unknown>

    export const usePutWorkflowSmtp = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putWorkflowSmtp>>, TError,{data: BodyType<SmtpSettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putWorkflowSmtp>>,
        TError,
        {data: BodyType<SmtpSettingsInput>},
        TContext
      > => {
      return useMutation(getPutWorkflowSmtpMutationOptions(options));
    }

export const getDeleteWorkflowSmtpUrl = () => {




  return `/api/workflows/smtp`
}

export const deleteWorkflowSmtp = async ( options?: RequestInit): Promise<OkResult> => {

  return customFetch<OkResult>(getDeleteWorkflowSmtpUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteWorkflowSmtpMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkflowSmtp>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteWorkflowSmtp>>, TError,void, TContext> => {

const mutationKey = ['deleteWorkflowSmtp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWorkflowSmtp>>, void> = () => {


          return  deleteWorkflowSmtp(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteWorkflowSmtpMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWorkflowSmtp>>>

    export type DeleteWorkflowSmtpMutationError = ErrorType<unknown>

    export const useDeleteWorkflowSmtp = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkflowSmtp>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteWorkflowSmtp>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteWorkflowSmtpMutationOptions(options));
    }

export const getGetQuickBooksStatusUrl = () => {




  return `/api/quickbooks/status`
}

/**
 * @summary Connection + credential status for the tenant
 */
export const getQuickBooksStatus = async ( options?: RequestInit): Promise<QuickBooksStatus> => {

  return customFetch<QuickBooksStatus>(getGetQuickBooksStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetQuickBooksStatusQueryKey = () => {
    return [
    `/api/quickbooks/status`
    ] as const;
    }


export const getGetQuickBooksStatusQueryOptions = <TData = Awaited<ReturnType<typeof getQuickBooksStatus>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQuickBooksStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuickBooksStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuickBooksStatus>>> = ({ signal }) => getQuickBooksStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuickBooksStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetQuickBooksStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getQuickBooksStatus>>>
export type GetQuickBooksStatusQueryError = ErrorType<unknown>


/**
 * @summary Connection + credential status for the tenant
 */

export function useGetQuickBooksStatus<TData = Awaited<ReturnType<typeof getQuickBooksStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQuickBooksStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetQuickBooksStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getConnectQuickBooksUrl = () => {




  return `/api/quickbooks/connect`
}

/**
 * @summary Begin the QuickBooks OAuth flow (returns the authorize URL)
 */
export const connectQuickBooks = async ( options?: RequestInit): Promise<ConnectQuickBooks200> => {

  return customFetch<ConnectQuickBooks200>(getConnectQuickBooksUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getConnectQuickBooksMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectQuickBooks>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof connectQuickBooks>>, TError,void, TContext> => {

const mutationKey = ['connectQuickBooks'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectQuickBooks>>, void> = () => {


          return  connectQuickBooks(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConnectQuickBooksMutationResult = NonNullable<Awaited<ReturnType<typeof connectQuickBooks>>>

    export type ConnectQuickBooksMutationError = ErrorType<void>

    /**
 * @summary Begin the QuickBooks OAuth flow (returns the authorize URL)
 */
export const useConnectQuickBooks = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectQuickBooks>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof connectQuickBooks>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getConnectQuickBooksMutationOptions(options));
    }

export const getDisconnectQuickBooksUrl = () => {




  return `/api/quickbooks/disconnect`
}

/**
 * @summary Disconnect QuickBooks (revokes + clears stored tokens)
 */
export const disconnectQuickBooks = async ( options?: RequestInit): Promise<OkResult> => {

  return customFetch<OkResult>(getDisconnectQuickBooksUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDisconnectQuickBooksMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectQuickBooks>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectQuickBooks>>, TError,void, TContext> => {

const mutationKey = ['disconnectQuickBooks'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectQuickBooks>>, void> = () => {


          return  disconnectQuickBooks(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectQuickBooksMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectQuickBooks>>>

    export type DisconnectQuickBooksMutationError = ErrorType<unknown>

    /**
 * @summary Disconnect QuickBooks (revokes + clears stored tokens)
 */
export const useDisconnectQuickBooks = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectQuickBooks>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof disconnectQuickBooks>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDisconnectQuickBooksMutationOptions(options));
    }

export const getGetQuickBooksSettingsUrl = () => {




  return `/api/quickbooks/settings`
}

/**
 * @summary Get the tenant's QuickBooks sync settings
 */
export const getQuickBooksSettings = async ( options?: RequestInit): Promise<QuickBooksSettings> => {

  return customFetch<QuickBooksSettings>(getGetQuickBooksSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetQuickBooksSettingsQueryKey = () => {
    return [
    `/api/quickbooks/settings`
    ] as const;
    }


export const getGetQuickBooksSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getQuickBooksSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQuickBooksSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuickBooksSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuickBooksSettings>>> = ({ signal }) => getQuickBooksSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuickBooksSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetQuickBooksSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getQuickBooksSettings>>>
export type GetQuickBooksSettingsQueryError = ErrorType<unknown>


/**
 * @summary Get the tenant's QuickBooks sync settings
 */

export function useGetQuickBooksSettings<TData = Awaited<ReturnType<typeof getQuickBooksSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQuickBooksSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetQuickBooksSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateQuickBooksSettingsUrl = () => {




  return `/api/quickbooks/settings`
}

/**
 * @summary Update the tenant's QuickBooks sync settings
 */
export const updateQuickBooksSettings = async (quickBooksSettingsUpdate: QuickBooksSettingsUpdate, options?: RequestInit): Promise<QuickBooksSettings> => {

  return customFetch<QuickBooksSettings>(getUpdateQuickBooksSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(quickBooksSettingsUpdate)
  }
);}





export const getUpdateQuickBooksSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateQuickBooksSettings>>, TError,{data: BodyType<QuickBooksSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateQuickBooksSettings>>, TError,{data: BodyType<QuickBooksSettingsUpdate>}, TContext> => {

const mutationKey = ['updateQuickBooksSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateQuickBooksSettings>>, {data: BodyType<QuickBooksSettingsUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateQuickBooksSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateQuickBooksSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateQuickBooksSettings>>>
    export type UpdateQuickBooksSettingsMutationBody = BodyType<QuickBooksSettingsUpdate>
    export type UpdateQuickBooksSettingsMutationError = ErrorType<unknown>

    /**
 * @summary Update the tenant's QuickBooks sync settings
 */
export const useUpdateQuickBooksSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateQuickBooksSettings>>, TError,{data: BodyType<QuickBooksSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateQuickBooksSettings>>,
        TError,
        {data: BodyType<QuickBooksSettingsUpdate>},
        TContext
      > => {
      return useMutation(getUpdateQuickBooksSettingsMutationOptions(options));
    }

export const getGetQuickBooksMappingsUrl = () => {




  return `/api/quickbooks/mappings`
}

/**
 * @summary Get account + tax mappings
 */
export const getQuickBooksMappings = async ( options?: RequestInit): Promise<QuickBooksMappings> => {

  return customFetch<QuickBooksMappings>(getGetQuickBooksMappingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetQuickBooksMappingsQueryKey = () => {
    return [
    `/api/quickbooks/mappings`
    ] as const;
    }


export const getGetQuickBooksMappingsQueryOptions = <TData = Awaited<ReturnType<typeof getQuickBooksMappings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQuickBooksMappings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuickBooksMappingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuickBooksMappings>>> = ({ signal }) => getQuickBooksMappings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuickBooksMappings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetQuickBooksMappingsQueryResult = NonNullable<Awaited<ReturnType<typeof getQuickBooksMappings>>>
export type GetQuickBooksMappingsQueryError = ErrorType<unknown>


/**
 * @summary Get account + tax mappings
 */

export function useGetQuickBooksMappings<TData = Awaited<ReturnType<typeof getQuickBooksMappings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQuickBooksMappings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetQuickBooksMappingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateQuickBooksMappingsUrl = () => {




  return `/api/quickbooks/mappings`
}

/**
 * @summary Replace account + tax mappings
 */
export const updateQuickBooksMappings = async (quickBooksMappingsUpdate: QuickBooksMappingsUpdate, options?: RequestInit): Promise<QuickBooksMappings> => {

  return customFetch<QuickBooksMappings>(getUpdateQuickBooksMappingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(quickBooksMappingsUpdate)
  }
);}





export const getUpdateQuickBooksMappingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateQuickBooksMappings>>, TError,{data: BodyType<QuickBooksMappingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateQuickBooksMappings>>, TError,{data: BodyType<QuickBooksMappingsUpdate>}, TContext> => {

const mutationKey = ['updateQuickBooksMappings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateQuickBooksMappings>>, {data: BodyType<QuickBooksMappingsUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateQuickBooksMappings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateQuickBooksMappingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateQuickBooksMappings>>>
    export type UpdateQuickBooksMappingsMutationBody = BodyType<QuickBooksMappingsUpdate>
    export type UpdateQuickBooksMappingsMutationError = ErrorType<unknown>

    /**
 * @summary Replace account + tax mappings
 */
export const useUpdateQuickBooksMappings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateQuickBooksMappings>>, TError,{data: BodyType<QuickBooksMappingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateQuickBooksMappings>>,
        TError,
        {data: BodyType<QuickBooksMappingsUpdate>},
        TContext
      > => {
      return useMutation(getUpdateQuickBooksMappingsMutationOptions(options));
    }

export const getListQboAccountsUrl = () => {




  return `/api/quickbooks/qbo/accounts`
}

/**
 * @summary List chart-of-accounts from QuickBooks
 */
export const listQboAccounts = async ( options?: RequestInit): Promise<ListQboAccounts200> => {

  return customFetch<ListQboAccounts200>(getListQboAccountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListQboAccountsQueryKey = () => {
    return [
    `/api/quickbooks/qbo/accounts`
    ] as const;
    }


export const getListQboAccountsQueryOptions = <TData = Awaited<ReturnType<typeof listQboAccounts>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listQboAccounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQboAccountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQboAccounts>>> = ({ signal }) => listQboAccounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listQboAccounts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListQboAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof listQboAccounts>>>
export type ListQboAccountsQueryError = ErrorType<unknown>


/**
 * @summary List chart-of-accounts from QuickBooks
 */

export function useListQboAccounts<TData = Awaited<ReturnType<typeof listQboAccounts>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listQboAccounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListQboAccountsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListQboTaxCodesUrl = () => {




  return `/api/quickbooks/qbo/taxcodes`
}

/**
 * @summary List tax codes from QuickBooks
 */
export const listQboTaxCodes = async ( options?: RequestInit): Promise<ListQboTaxCodes200> => {

  return customFetch<ListQboTaxCodes200>(getListQboTaxCodesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListQboTaxCodesQueryKey = () => {
    return [
    `/api/quickbooks/qbo/taxcodes`
    ] as const;
    }


export const getListQboTaxCodesQueryOptions = <TData = Awaited<ReturnType<typeof listQboTaxCodes>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listQboTaxCodes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQboTaxCodesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQboTaxCodes>>> = ({ signal }) => listQboTaxCodes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listQboTaxCodes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListQboTaxCodesQueryResult = NonNullable<Awaited<ReturnType<typeof listQboTaxCodes>>>
export type ListQboTaxCodesQueryError = ErrorType<unknown>


/**
 * @summary List tax codes from QuickBooks
 */

export function useListQboTaxCodes<TData = Awaited<ReturnType<typeof listQboTaxCodes>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listQboTaxCodes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListQboTaxCodesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListQboItemsUrl = () => {




  return `/api/quickbooks/qbo/items`
}

/**
 * @summary List items from QuickBooks
 */
export const listQboItems = async ( options?: RequestInit): Promise<ListQboItems200> => {

  return customFetch<ListQboItems200>(getListQboItemsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListQboItemsQueryKey = () => {
    return [
    `/api/quickbooks/qbo/items`
    ] as const;
    }


export const getListQboItemsQueryOptions = <TData = Awaited<ReturnType<typeof listQboItems>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listQboItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQboItemsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQboItems>>> = ({ signal }) => listQboItems({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listQboItems>>, TError, TData> & { queryKey: QueryKey }
}

export type ListQboItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listQboItems>>>
export type ListQboItemsQueryError = ErrorType<unknown>


/**
 * @summary List items from QuickBooks
 */

export function useListQboItems<TData = Awaited<ReturnType<typeof listQboItems>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listQboItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListQboItemsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListQboCustomersUrl = () => {




  return `/api/quickbooks/qbo/customers`
}

/**
 * @summary List customers from QuickBooks
 */
export const listQboCustomers = async ( options?: RequestInit): Promise<ListQboCustomers200> => {

  return customFetch<ListQboCustomers200>(getListQboCustomersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListQboCustomersQueryKey = () => {
    return [
    `/api/quickbooks/qbo/customers`
    ] as const;
    }


export const getListQboCustomersQueryOptions = <TData = Awaited<ReturnType<typeof listQboCustomers>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listQboCustomers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQboCustomersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQboCustomers>>> = ({ signal }) => listQboCustomers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listQboCustomers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListQboCustomersQueryResult = NonNullable<Awaited<ReturnType<typeof listQboCustomers>>>
export type ListQboCustomersQueryError = ErrorType<unknown>


/**
 * @summary List customers from QuickBooks
 */

export function useListQboCustomers<TData = Awaited<ReturnType<typeof listQboCustomers>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listQboCustomers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListQboCustomersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRunQuickBooksSyncUrl = () => {




  return `/api/quickbooks/sync`
}

/**
 * @summary Run a sync of eligible sales to QuickBooks
 */
export const runQuickBooksSync = async (quickBooksSyncRequest?: QuickBooksSyncRequest, options?: RequestInit): Promise<QuickBooksSyncRunResult> => {

  return customFetch<QuickBooksSyncRunResult>(getRunQuickBooksSyncUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(quickBooksSyncRequest)
  }
);}





export const getRunQuickBooksSyncMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runQuickBooksSync>>, TError,{data?: BodyType<QuickBooksSyncRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof runQuickBooksSync>>, TError,{data?: BodyType<QuickBooksSyncRequest>}, TContext> => {

const mutationKey = ['runQuickBooksSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runQuickBooksSync>>, {data?: BodyType<QuickBooksSyncRequest>}> = (props) => {
          const {data} = props ?? {};

          return  runQuickBooksSync(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunQuickBooksSyncMutationResult = NonNullable<Awaited<ReturnType<typeof runQuickBooksSync>>>
    export type RunQuickBooksSyncMutationBody = BodyType<QuickBooksSyncRequest> | undefined
    export type RunQuickBooksSyncMutationError = ErrorType<unknown>

    /**
 * @summary Run a sync of eligible sales to QuickBooks
 */
export const useRunQuickBooksSync = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runQuickBooksSync>>, TError,{data?: BodyType<QuickBooksSyncRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof runQuickBooksSync>>,
        TError,
        {data?: BodyType<QuickBooksSyncRequest>},
        TContext
      > => {
      return useMutation(getRunQuickBooksSyncMutationOptions(options));
    }

export const getSyncQuickBooksSaleUrl = (saleId: string,) => {




  return `/api/quickbooks/sync/sale/${saleId}`
}

/**
 * @summary Push a single sale order to QuickBooks
 */
export const syncQuickBooksSale = async (saleId: string, options?: RequestInit): Promise<QuickBooksSyncRecordResult> => {

  return customFetch<QuickBooksSyncRecordResult>(getSyncQuickBooksSaleUrl(saleId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSyncQuickBooksSaleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncQuickBooksSale>>, TError,{saleId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncQuickBooksSale>>, TError,{saleId: string}, TContext> => {

const mutationKey = ['syncQuickBooksSale'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncQuickBooksSale>>, {saleId: string}> = (props) => {
          const {saleId} = props ?? {};

          return  syncQuickBooksSale(saleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncQuickBooksSaleMutationResult = NonNullable<Awaited<ReturnType<typeof syncQuickBooksSale>>>

    export type SyncQuickBooksSaleMutationError = ErrorType<unknown>

    /**
 * @summary Push a single sale order to QuickBooks
 */
export const useSyncQuickBooksSale = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncQuickBooksSale>>, TError,{saleId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncQuickBooksSale>>,
        TError,
        {saleId: string},
        TContext
      > => {
      return useMutation(getSyncQuickBooksSaleMutationOptions(options));
    }

export const getSyncQuickBooksRefundUrl = (adjustmentId: string,) => {




  return `/api/quickbooks/sync/refund/${adjustmentId}`
}

/**
 * @summary Push a single refund (order adjustment) to QuickBooks
 */
export const syncQuickBooksRefund = async (adjustmentId: string, options?: RequestInit): Promise<QuickBooksSyncRecordResult> => {

  return customFetch<QuickBooksSyncRecordResult>(getSyncQuickBooksRefundUrl(adjustmentId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSyncQuickBooksRefundMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncQuickBooksRefund>>, TError,{adjustmentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncQuickBooksRefund>>, TError,{adjustmentId: string}, TContext> => {

const mutationKey = ['syncQuickBooksRefund'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncQuickBooksRefund>>, {adjustmentId: string}> = (props) => {
          const {adjustmentId} = props ?? {};

          return  syncQuickBooksRefund(adjustmentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncQuickBooksRefundMutationResult = NonNullable<Awaited<ReturnType<typeof syncQuickBooksRefund>>>

    export type SyncQuickBooksRefundMutationError = ErrorType<unknown>

    /**
 * @summary Push a single refund (order adjustment) to QuickBooks
 */
export const useSyncQuickBooksRefund = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncQuickBooksRefund>>, TError,{adjustmentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncQuickBooksRefund>>,
        TError,
        {adjustmentId: string},
        TContext
      > => {
      return useMutation(getSyncQuickBooksRefundMutationOptions(options));
    }

export const getListQuickBooksSyncLogsUrl = (params?: ListQuickBooksSyncLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/quickbooks/sync-logs?${stringifiedParams}` : `/api/quickbooks/sync-logs`
}

/**
 * @summary List sync log rows (newest first)
 */
export const listQuickBooksSyncLogs = async (params?: ListQuickBooksSyncLogsParams, options?: RequestInit): Promise<ListQuickBooksSyncLogs200> => {

  return customFetch<ListQuickBooksSyncLogs200>(getListQuickBooksSyncLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListQuickBooksSyncLogsQueryKey = (params?: ListQuickBooksSyncLogsParams,) => {
    return [
    `/api/quickbooks/sync-logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListQuickBooksSyncLogsQueryOptions = <TData = Awaited<ReturnType<typeof listQuickBooksSyncLogs>>, TError = ErrorType<unknown>>(params?: ListQuickBooksSyncLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listQuickBooksSyncLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuickBooksSyncLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuickBooksSyncLogs>>> = ({ signal }) => listQuickBooksSyncLogs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listQuickBooksSyncLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListQuickBooksSyncLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listQuickBooksSyncLogs>>>
export type ListQuickBooksSyncLogsQueryError = ErrorType<unknown>


/**
 * @summary List sync log rows (newest first)
 */

export function useListQuickBooksSyncLogs<TData = Awaited<ReturnType<typeof listQuickBooksSyncLogs>>, TError = ErrorType<unknown>>(
 params?: ListQuickBooksSyncLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listQuickBooksSyncLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListQuickBooksSyncLogsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRetryQuickBooksSyncLogUrl = (id: string,) => {




  return `/api/quickbooks/sync-logs/${id}/retry`
}

/**
 * @summary Retry a failed sync log row
 */
export const retryQuickBooksSyncLog = async (id: string, options?: RequestInit): Promise<QuickBooksSyncRecordResult> => {

  return customFetch<QuickBooksSyncRecordResult>(getRetryQuickBooksSyncLogUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRetryQuickBooksSyncLogMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryQuickBooksSyncLog>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof retryQuickBooksSyncLog>>, TError,{id: string}, TContext> => {

const mutationKey = ['retryQuickBooksSyncLog'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryQuickBooksSyncLog>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  retryQuickBooksSyncLog(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryQuickBooksSyncLogMutationResult = NonNullable<Awaited<ReturnType<typeof retryQuickBooksSyncLog>>>

    export type RetryQuickBooksSyncLogMutationError = ErrorType<unknown>

    /**
 * @summary Retry a failed sync log row
 */
export const useRetryQuickBooksSyncLog = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryQuickBooksSyncLog>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof retryQuickBooksSyncLog>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getRetryQuickBooksSyncLogMutationOptions(options));
    }

export const getListQuickBooksReconciliationsUrl = (params?: ListQuickBooksReconciliationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/quickbooks/reconciliation?${stringifiedParams}` : `/api/quickbooks/reconciliation`
}

/**
 * @summary List payout reconciliations
 */
export const listQuickBooksReconciliations = async (params?: ListQuickBooksReconciliationsParams, options?: RequestInit): Promise<ListQuickBooksReconciliations200> => {

  return customFetch<ListQuickBooksReconciliations200>(getListQuickBooksReconciliationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListQuickBooksReconciliationsQueryKey = (params?: ListQuickBooksReconciliationsParams,) => {
    return [
    `/api/quickbooks/reconciliation`, ...(params ? [params] : [])
    ] as const;
    }


export const getListQuickBooksReconciliationsQueryOptions = <TData = Awaited<ReturnType<typeof listQuickBooksReconciliations>>, TError = ErrorType<unknown>>(params?: ListQuickBooksReconciliationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listQuickBooksReconciliations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuickBooksReconciliationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuickBooksReconciliations>>> = ({ signal }) => listQuickBooksReconciliations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listQuickBooksReconciliations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListQuickBooksReconciliationsQueryResult = NonNullable<Awaited<ReturnType<typeof listQuickBooksReconciliations>>>
export type ListQuickBooksReconciliationsQueryError = ErrorType<unknown>


/**
 * @summary List payout reconciliations
 */

export function useListQuickBooksReconciliations<TData = Awaited<ReturnType<typeof listQuickBooksReconciliations>>, TError = ErrorType<unknown>>(
 params?: ListQuickBooksReconciliationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listQuickBooksReconciliations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListQuickBooksReconciliationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpsertQuickBooksReconciliationUrl = () => {




  return `/api/quickbooks/reconciliation`
}

/**
 * @summary Create or update a payout reconciliation
 */
export const upsertQuickBooksReconciliation = async (quickBooksReconciliationInput: QuickBooksReconciliationInput, options?: RequestInit): Promise<QuickBooksReconciliation> => {

  return customFetch<QuickBooksReconciliation>(getUpsertQuickBooksReconciliationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(quickBooksReconciliationInput)
  }
);}





export const getUpsertQuickBooksReconciliationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertQuickBooksReconciliation>>, TError,{data: BodyType<QuickBooksReconciliationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertQuickBooksReconciliation>>, TError,{data: BodyType<QuickBooksReconciliationInput>}, TContext> => {

const mutationKey = ['upsertQuickBooksReconciliation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertQuickBooksReconciliation>>, {data: BodyType<QuickBooksReconciliationInput>}> = (props) => {
          const {data} = props ?? {};

          return  upsertQuickBooksReconciliation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertQuickBooksReconciliationMutationResult = NonNullable<Awaited<ReturnType<typeof upsertQuickBooksReconciliation>>>
    export type UpsertQuickBooksReconciliationMutationBody = BodyType<QuickBooksReconciliationInput>
    export type UpsertQuickBooksReconciliationMutationError = ErrorType<unknown>

    /**
 * @summary Create or update a payout reconciliation
 */
export const useUpsertQuickBooksReconciliation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertQuickBooksReconciliation>>, TError,{data: BodyType<QuickBooksReconciliationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertQuickBooksReconciliation>>,
        TError,
        {data: BodyType<QuickBooksReconciliationInput>},
        TContext
      > => {
      return useMutation(getUpsertQuickBooksReconciliationMutationOptions(options));
    }

export const getGetQuickBooksDashboardUrl = () => {




  return `/api/quickbooks/dashboard`
}

/**
 * @summary Dashboard widget summary for QuickBooks sync health
 */
export const getQuickBooksDashboard = async ( options?: RequestInit): Promise<QuickBooksDashboard> => {

  return customFetch<QuickBooksDashboard>(getGetQuickBooksDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetQuickBooksDashboardQueryKey = () => {
    return [
    `/api/quickbooks/dashboard`
    ] as const;
    }


export const getGetQuickBooksDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getQuickBooksDashboard>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQuickBooksDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuickBooksDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuickBooksDashboard>>> = ({ signal }) => getQuickBooksDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuickBooksDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetQuickBooksDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getQuickBooksDashboard>>>
export type GetQuickBooksDashboardQueryError = ErrorType<unknown>


/**
 * @summary Dashboard widget summary for QuickBooks sync health
 */

export function useGetQuickBooksDashboard<TData = Awaited<ReturnType<typeof getQuickBooksDashboard>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQuickBooksDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetQuickBooksDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetXeroStatusUrl = () => {




  return `/api/xero/status`
}

/**
 * @summary Connection + credential status for the tenant
 */
export const getXeroStatus = async ( options?: RequestInit): Promise<XeroStatus> => {

  return customFetch<XeroStatus>(getGetXeroStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetXeroStatusQueryKey = () => {
    return [
    `/api/xero/status`
    ] as const;
    }


export const getGetXeroStatusQueryOptions = <TData = Awaited<ReturnType<typeof getXeroStatus>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getXeroStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetXeroStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getXeroStatus>>> = ({ signal }) => getXeroStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getXeroStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetXeroStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getXeroStatus>>>
export type GetXeroStatusQueryError = ErrorType<unknown>


/**
 * @summary Connection + credential status for the tenant
 */

export function useGetXeroStatus<TData = Awaited<ReturnType<typeof getXeroStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getXeroStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetXeroStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateXeroSettingsUrl = () => {




  return `/api/xero/settings`
}

/**
 * @summary Toggle refund sync (Task #1347) — mirrors QuickBooks' syncRefunds semantics
 */
export const updateXeroSettings = async (xeroSettingsUpdate: XeroSettingsUpdate, options?: RequestInit): Promise<XeroSettingsUpdate> => {

  return customFetch<XeroSettingsUpdate>(getUpdateXeroSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(xeroSettingsUpdate)
  }
);}





export const getUpdateXeroSettingsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateXeroSettings>>, TError,{data: BodyType<XeroSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateXeroSettings>>, TError,{data: BodyType<XeroSettingsUpdate>}, TContext> => {

const mutationKey = ['updateXeroSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateXeroSettings>>, {data: BodyType<XeroSettingsUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateXeroSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateXeroSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateXeroSettings>>>
    export type UpdateXeroSettingsMutationBody = BodyType<XeroSettingsUpdate>
    export type UpdateXeroSettingsMutationError = ErrorType<void>

    /**
 * @summary Toggle refund sync (Task #1347) — mirrors QuickBooks' syncRefunds semantics
 */
export const useUpdateXeroSettings = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateXeroSettings>>, TError,{data: BodyType<XeroSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateXeroSettings>>,
        TError,
        {data: BodyType<XeroSettingsUpdate>},
        TContext
      > => {
      return useMutation(getUpdateXeroSettingsMutationOptions(options));
    }

export const getConnectXeroUrl = () => {




  return `/api/xero/connect`
}

/**
 * @summary Begin the Xero OAuth flow (returns the authorize URL)
 */
export const connectXero = async ( options?: RequestInit): Promise<ConnectXero200> => {

  return customFetch<ConnectXero200>(getConnectXeroUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getConnectXeroMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectXero>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof connectXero>>, TError,void, TContext> => {

const mutationKey = ['connectXero'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectXero>>, void> = () => {


          return  connectXero(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConnectXeroMutationResult = NonNullable<Awaited<ReturnType<typeof connectXero>>>

    export type ConnectXeroMutationError = ErrorType<void>

    /**
 * @summary Begin the Xero OAuth flow (returns the authorize URL)
 */
export const useConnectXero = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectXero>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof connectXero>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getConnectXeroMutationOptions(options));
    }

export const getDisconnectXeroUrl = () => {




  return `/api/xero/disconnect`
}

/**
 * @summary Disconnect Xero (revokes + clears stored tokens)
 */
export const disconnectXero = async ( options?: RequestInit): Promise<OkResult> => {

  return customFetch<OkResult>(getDisconnectXeroUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDisconnectXeroMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectXero>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectXero>>, TError,void, TContext> => {

const mutationKey = ['disconnectXero'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectXero>>, void> = () => {


          return  disconnectXero(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectXeroMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectXero>>>

    export type DisconnectXeroMutationError = ErrorType<unknown>

    /**
 * @summary Disconnect Xero (revokes + clears stored tokens)
 */
export const useDisconnectXero = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectXero>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof disconnectXero>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDisconnectXeroMutationOptions(options));
    }

export const getRunXeroSyncUrl = () => {




  return `/api/xero/sync`
}

/**
 * @summary Run a sync of eligible (paid) sales to Xero
 */
export const runXeroSync = async (xeroSyncRequest?: XeroSyncRequest, options?: RequestInit): Promise<XeroSyncRunResult> => {

  return customFetch<XeroSyncRunResult>(getRunXeroSyncUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(xeroSyncRequest)
  }
);}





export const getRunXeroSyncMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runXeroSync>>, TError,{data?: BodyType<XeroSyncRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof runXeroSync>>, TError,{data?: BodyType<XeroSyncRequest>}, TContext> => {

const mutationKey = ['runXeroSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runXeroSync>>, {data?: BodyType<XeroSyncRequest>}> = (props) => {
          const {data} = props ?? {};

          return  runXeroSync(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunXeroSyncMutationResult = NonNullable<Awaited<ReturnType<typeof runXeroSync>>>
    export type RunXeroSyncMutationBody = BodyType<XeroSyncRequest> | undefined
    export type RunXeroSyncMutationError = ErrorType<unknown>

    /**
 * @summary Run a sync of eligible (paid) sales to Xero
 */
export const useRunXeroSync = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runXeroSync>>, TError,{data?: BodyType<XeroSyncRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof runXeroSync>>,
        TError,
        {data?: BodyType<XeroSyncRequest>},
        TContext
      > => {
      return useMutation(getRunXeroSyncMutationOptions(options));
    }

export const getSyncXeroSaleUrl = (saleId: string,) => {




  return `/api/xero/sync/sale/${saleId}`
}

/**
 * @summary Push a single sale order to Xero
 */
export const syncXeroSale = async (saleId: string, options?: RequestInit): Promise<XeroSyncRecordResult> => {

  return customFetch<XeroSyncRecordResult>(getSyncXeroSaleUrl(saleId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSyncXeroSaleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncXeroSale>>, TError,{saleId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncXeroSale>>, TError,{saleId: string}, TContext> => {

const mutationKey = ['syncXeroSale'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncXeroSale>>, {saleId: string}> = (props) => {
          const {saleId} = props ?? {};

          return  syncXeroSale(saleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncXeroSaleMutationResult = NonNullable<Awaited<ReturnType<typeof syncXeroSale>>>

    export type SyncXeroSaleMutationError = ErrorType<unknown>

    /**
 * @summary Push a single sale order to Xero
 */
export const useSyncXeroSale = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncXeroSale>>, TError,{saleId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncXeroSale>>,
        TError,
        {saleId: string},
        TContext
      > => {
      return useMutation(getSyncXeroSaleMutationOptions(options));
    }

export const getSyncXeroRefundUrl = (adjustmentId: string,) => {




  return `/api/xero/sync/refund/${adjustmentId}`
}

/**
 * @summary Push a single refund (order adjustment) to Xero as a credit note (Task #1347)
 */
export const syncXeroRefund = async (adjustmentId: string, options?: RequestInit): Promise<XeroSyncRecordResult> => {

  return customFetch<XeroSyncRecordResult>(getSyncXeroRefundUrl(adjustmentId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSyncXeroRefundMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncXeroRefund>>, TError,{adjustmentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncXeroRefund>>, TError,{adjustmentId: string}, TContext> => {

const mutationKey = ['syncXeroRefund'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncXeroRefund>>, {adjustmentId: string}> = (props) => {
          const {adjustmentId} = props ?? {};

          return  syncXeroRefund(adjustmentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncXeroRefundMutationResult = NonNullable<Awaited<ReturnType<typeof syncXeroRefund>>>

    export type SyncXeroRefundMutationError = ErrorType<unknown>

    /**
 * @summary Push a single refund (order adjustment) to Xero as a credit note (Task #1347)
 */
export const useSyncXeroRefund = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncXeroRefund>>, TError,{adjustmentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncXeroRefund>>,
        TError,
        {adjustmentId: string},
        TContext
      > => {
      return useMutation(getSyncXeroRefundMutationOptions(options));
    }

export const getListXeroSyncLogsUrl = (params?: ListXeroSyncLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/xero/sync-logs?${stringifiedParams}` : `/api/xero/sync-logs`
}

/**
 * @summary List sync log rows (newest first)
 */
export const listXeroSyncLogs = async (params?: ListXeroSyncLogsParams, options?: RequestInit): Promise<ListXeroSyncLogs200> => {

  return customFetch<ListXeroSyncLogs200>(getListXeroSyncLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListXeroSyncLogsQueryKey = (params?: ListXeroSyncLogsParams,) => {
    return [
    `/api/xero/sync-logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListXeroSyncLogsQueryOptions = <TData = Awaited<ReturnType<typeof listXeroSyncLogs>>, TError = ErrorType<unknown>>(params?: ListXeroSyncLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listXeroSyncLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListXeroSyncLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listXeroSyncLogs>>> = ({ signal }) => listXeroSyncLogs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listXeroSyncLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListXeroSyncLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listXeroSyncLogs>>>
export type ListXeroSyncLogsQueryError = ErrorType<unknown>


/**
 * @summary List sync log rows (newest first)
 */

export function useListXeroSyncLogs<TData = Awaited<ReturnType<typeof listXeroSyncLogs>>, TError = ErrorType<unknown>>(
 params?: ListXeroSyncLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listXeroSyncLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListXeroSyncLogsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRetryXeroSyncLogUrl = (id: string,) => {




  return `/api/xero/sync-logs/${id}/retry`
}

/**
 * @summary Retry a failed sync log row
 */
export const retryXeroSyncLog = async (id: string, options?: RequestInit): Promise<XeroSyncRecordResult> => {

  return customFetch<XeroSyncRecordResult>(getRetryXeroSyncLogUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRetryXeroSyncLogMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryXeroSyncLog>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof retryXeroSyncLog>>, TError,{id: string}, TContext> => {

const mutationKey = ['retryXeroSyncLog'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryXeroSyncLog>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  retryXeroSyncLog(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryXeroSyncLogMutationResult = NonNullable<Awaited<ReturnType<typeof retryXeroSyncLog>>>

    export type RetryXeroSyncLogMutationError = ErrorType<unknown>

    /**
 * @summary Retry a failed sync log row
 */
export const useRetryXeroSyncLog = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryXeroSyncLog>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof retryXeroSyncLog>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getRetryXeroSyncLogMutationOptions(options));
    }

export const getGetXeroDashboardUrl = () => {




  return `/api/xero/dashboard`
}

/**
 * @summary Dashboard widget summary for Xero sync health
 */
export const getXeroDashboard = async ( options?: RequestInit): Promise<XeroDashboard> => {

  return customFetch<XeroDashboard>(getGetXeroDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetXeroDashboardQueryKey = () => {
    return [
    `/api/xero/dashboard`
    ] as const;
    }


export const getGetXeroDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getXeroDashboard>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getXeroDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetXeroDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getXeroDashboard>>> = ({ signal }) => getXeroDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getXeroDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetXeroDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getXeroDashboard>>>
export type GetXeroDashboardQueryError = ErrorType<unknown>


/**
 * @summary Dashboard widget summary for Xero sync health
 */

export function useGetXeroDashboard<TData = Awaited<ReturnType<typeof getXeroDashboard>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getXeroDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetXeroDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetTikTokShopStatusUrl = () => {




  return `/api/tiktok_shop/status`
}

/**
 * @summary Connection + credential status for the tenant
 */
export const getTikTokShopStatus = async ( options?: RequestInit): Promise<TikTokShopStatus> => {

  return customFetch<TikTokShopStatus>(getGetTikTokShopStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTikTokShopStatusQueryKey = () => {
    return [
    `/api/tiktok_shop/status`
    ] as const;
    }


export const getGetTikTokShopStatusQueryOptions = <TData = Awaited<ReturnType<typeof getTikTokShopStatus>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTikTokShopStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTikTokShopStatus>>> = ({ signal }) => getTikTokShopStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTikTokShopStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getTikTokShopStatus>>>
export type GetTikTokShopStatusQueryError = ErrorType<unknown>


/**
 * @summary Connection + credential status for the tenant
 */

export function useGetTikTokShopStatus<TData = Awaited<ReturnType<typeof getTikTokShopStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTikTokShopStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getConnectTikTokShopUrl = () => {




  return `/api/tiktok_shop/connect`
}

/**
 * @summary Begin the TikTok Shop OAuth flow (returns the authorize URL)
 */
export const connectTikTokShop = async ( options?: RequestInit): Promise<ConnectTikTokShop200> => {

  return customFetch<ConnectTikTokShop200>(getConnectTikTokShopUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getConnectTikTokShopMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectTikTokShop>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof connectTikTokShop>>, TError,void, TContext> => {

const mutationKey = ['connectTikTokShop'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectTikTokShop>>, void> = () => {


          return  connectTikTokShop(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConnectTikTokShopMutationResult = NonNullable<Awaited<ReturnType<typeof connectTikTokShop>>>

    export type ConnectTikTokShopMutationError = ErrorType<void>

    /**
 * @summary Begin the TikTok Shop OAuth flow (returns the authorize URL)
 */
export const useConnectTikTokShop = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectTikTokShop>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof connectTikTokShop>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getConnectTikTokShopMutationOptions(options));
    }

export const getDisconnectTikTokShopUrl = () => {




  return `/api/tiktok_shop/disconnect`
}

/**
 * @summary Disconnect TikTok Shop (clears stored tokens)
 */
export const disconnectTikTokShop = async ( options?: RequestInit): Promise<OkResult> => {

  return customFetch<OkResult>(getDisconnectTikTokShopUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDisconnectTikTokShopMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectTikTokShop>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectTikTokShop>>, TError,void, TContext> => {

const mutationKey = ['disconnectTikTokShop'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectTikTokShop>>, void> = () => {


          return  disconnectTikTokShop(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectTikTokShopMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectTikTokShop>>>

    export type DisconnectTikTokShopMutationError = ErrorType<unknown>

    /**
 * @summary Disconnect TikTok Shop (clears stored tokens)
 */
export const useDisconnectTikTokShop = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectTikTokShop>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof disconnectTikTokShop>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDisconnectTikTokShopMutationOptions(options));
    }

export const getSaveTikTokShopCredentialsUrl = () => {




  return `/api/tiktok_shop/credentials`
}

/**
 * @summary Save the tenant's own TikTok Shop Partner Center app credentials (secret is write-only)
 */
export const saveTikTokShopCredentials = async (tikTokShopCredentialsInput: TikTokShopCredentialsInput, options?: RequestInit): Promise<OkResult> => {

  return customFetch<OkResult>(getSaveTikTokShopCredentialsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tikTokShopCredentialsInput)
  }
);}





export const getSaveTikTokShopCredentialsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveTikTokShopCredentials>>, TError,{data: BodyType<TikTokShopCredentialsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveTikTokShopCredentials>>, TError,{data: BodyType<TikTokShopCredentialsInput>}, TContext> => {

const mutationKey = ['saveTikTokShopCredentials'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveTikTokShopCredentials>>, {data: BodyType<TikTokShopCredentialsInput>}> = (props) => {
          const {data} = props ?? {};

          return  saveTikTokShopCredentials(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveTikTokShopCredentialsMutationResult = NonNullable<Awaited<ReturnType<typeof saveTikTokShopCredentials>>>
    export type SaveTikTokShopCredentialsMutationBody = BodyType<TikTokShopCredentialsInput>
    export type SaveTikTokShopCredentialsMutationError = ErrorType<void>

    /**
 * @summary Save the tenant's own TikTok Shop Partner Center app credentials (secret is write-only)
 */
export const useSaveTikTokShopCredentials = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveTikTokShopCredentials>>, TError,{data: BodyType<TikTokShopCredentialsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveTikTokShopCredentials>>,
        TError,
        {data: BodyType<TikTokShopCredentialsInput>},
        TContext
      > => {
      return useMutation(getSaveTikTokShopCredentialsMutationOptions(options));
    }

export const getClearTikTokShopCredentialsUrl = () => {




  return `/api/tiktok_shop/credentials`
}

/**
 * @summary Clear the tenant's own app credentials (revert to the platform app)
 */
export const clearTikTokShopCredentials = async ( options?: RequestInit): Promise<OkResult> => {

  return customFetch<OkResult>(getClearTikTokShopCredentialsUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getClearTikTokShopCredentialsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearTikTokShopCredentials>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof clearTikTokShopCredentials>>, TError,void, TContext> => {

const mutationKey = ['clearTikTokShopCredentials'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearTikTokShopCredentials>>, void> = () => {


          return  clearTikTokShopCredentials(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearTikTokShopCredentialsMutationResult = NonNullable<Awaited<ReturnType<typeof clearTikTokShopCredentials>>>

    export type ClearTikTokShopCredentialsMutationError = ErrorType<unknown>

    /**
 * @summary Clear the tenant's own app credentials (revert to the platform app)
 */
export const useClearTikTokShopCredentials = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearTikTokShopCredentials>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof clearTikTokShopCredentials>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getClearTikTokShopCredentialsMutationOptions(options));
    }

export const getListTikTokDeveloperConnectionsUrl = () => {




  return `/api/tiktok_shop/developer-connections`
}

/**
 * @summary List the tenant's TikTok developer connections with their authorised shops
 */
export const listTikTokDeveloperConnections = async ( options?: RequestInit): Promise<ListTikTokDeveloperConnections200> => {

  return customFetch<ListTikTokDeveloperConnections200>(getListTikTokDeveloperConnectionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTikTokDeveloperConnectionsQueryKey = () => {
    return [
    `/api/tiktok_shop/developer-connections`
    ] as const;
    }


export const getListTikTokDeveloperConnectionsQueryOptions = <TData = Awaited<ReturnType<typeof listTikTokDeveloperConnections>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTikTokDeveloperConnections>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTikTokDeveloperConnectionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTikTokDeveloperConnections>>> = ({ signal }) => listTikTokDeveloperConnections({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTikTokDeveloperConnections>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTikTokDeveloperConnectionsQueryResult = NonNullable<Awaited<ReturnType<typeof listTikTokDeveloperConnections>>>
export type ListTikTokDeveloperConnectionsQueryError = ErrorType<unknown>


/**
 * @summary List the tenant's TikTok developer connections with their authorised shops
 */

export function useListTikTokDeveloperConnections<TData = Awaited<ReturnType<typeof listTikTokDeveloperConnections>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTikTokDeveloperConnections>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTikTokDeveloperConnectionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateTikTokDeveloperConnectionUrl = () => {




  return `/api/tiktok_shop/developer-connections`
}

/**
 * @summary Create a developer connection (credentials optional at creation)
 */
export const createTikTokDeveloperConnection = async (tikTokDeveloperConnectionInput: TikTokDeveloperConnectionInput, options?: RequestInit): Promise<TikTokDeveloperConnection> => {

  return customFetch<TikTokDeveloperConnection>(getCreateTikTokDeveloperConnectionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tikTokDeveloperConnectionInput)
  }
);}





export const getCreateTikTokDeveloperConnectionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTikTokDeveloperConnection>>, TError,{data: BodyType<TikTokDeveloperConnectionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTikTokDeveloperConnection>>, TError,{data: BodyType<TikTokDeveloperConnectionInput>}, TContext> => {

const mutationKey = ['createTikTokDeveloperConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTikTokDeveloperConnection>>, {data: BodyType<TikTokDeveloperConnectionInput>}> = (props) => {
          const {data} = props ?? {};

          return  createTikTokDeveloperConnection(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTikTokDeveloperConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof createTikTokDeveloperConnection>>>
    export type CreateTikTokDeveloperConnectionMutationBody = BodyType<TikTokDeveloperConnectionInput>
    export type CreateTikTokDeveloperConnectionMutationError = ErrorType<void>

    /**
 * @summary Create a developer connection (credentials optional at creation)
 */
export const useCreateTikTokDeveloperConnection = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTikTokDeveloperConnection>>, TError,{data: BodyType<TikTokDeveloperConnectionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTikTokDeveloperConnection>>,
        TError,
        {data: BodyType<TikTokDeveloperConnectionInput>},
        TContext
      > => {
      return useMutation(getCreateTikTokDeveloperConnectionMutationOptions(options));
    }

export const getUpdateTikTokDeveloperConnectionUrl = (id: string,) => {




  return `/api/tiktok_shop/developer-connections/${id}`
}

/**
 * @summary Update a developer connection (metadata and/or credential rotation; secrets are write-only)
 */
export const updateTikTokDeveloperConnection = async (id: string,
    tikTokDeveloperConnectionUpdate: TikTokDeveloperConnectionUpdate, options?: RequestInit): Promise<TikTokDeveloperConnection> => {

  return customFetch<TikTokDeveloperConnection>(getUpdateTikTokDeveloperConnectionUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tikTokDeveloperConnectionUpdate)
  }
);}





export const getUpdateTikTokDeveloperConnectionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTikTokDeveloperConnection>>, TError,{id: string;data: BodyType<TikTokDeveloperConnectionUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTikTokDeveloperConnection>>, TError,{id: string;data: BodyType<TikTokDeveloperConnectionUpdate>}, TContext> => {

const mutationKey = ['updateTikTokDeveloperConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTikTokDeveloperConnection>>, {id: string;data: BodyType<TikTokDeveloperConnectionUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTikTokDeveloperConnection(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTikTokDeveloperConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof updateTikTokDeveloperConnection>>>
    export type UpdateTikTokDeveloperConnectionMutationBody = BodyType<TikTokDeveloperConnectionUpdate>
    export type UpdateTikTokDeveloperConnectionMutationError = ErrorType<void>

    /**
 * @summary Update a developer connection (metadata and/or credential rotation; secrets are write-only)
 */
export const useUpdateTikTokDeveloperConnection = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTikTokDeveloperConnection>>, TError,{id: string;data: BodyType<TikTokDeveloperConnectionUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTikTokDeveloperConnection>>,
        TError,
        {id: string;data: BodyType<TikTokDeveloperConnectionUpdate>},
        TContext
      > => {
      return useMutation(getUpdateTikTokDeveloperConnectionMutationOptions(options));
    }

export const getDeleteTikTokDeveloperConnectionUrl = (id: string,) => {




  return `/api/tiktok_shop/developer-connections/${id}`
}

/**
 * @summary Deactivate a developer connection (its authorised shops stop syncing)
 */
export const deleteTikTokDeveloperConnection = async (id: string, options?: RequestInit): Promise<OkResult> => {

  return customFetch<OkResult>(getDeleteTikTokDeveloperConnectionUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTikTokDeveloperConnectionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTikTokDeveloperConnection>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTikTokDeveloperConnection>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteTikTokDeveloperConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTikTokDeveloperConnection>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteTikTokDeveloperConnection(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTikTokDeveloperConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTikTokDeveloperConnection>>>

    export type DeleteTikTokDeveloperConnectionMutationError = ErrorType<void>

    /**
 * @summary Deactivate a developer connection (its authorised shops stop syncing)
 */
export const useDeleteTikTokDeveloperConnection = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTikTokDeveloperConnection>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTikTokDeveloperConnection>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteTikTokDeveloperConnectionMutationOptions(options));
    }

export const getVerifyTikTokDeveloperConnectionUrl = (id: string,) => {




  return `/api/tiktok_shop/developer-connections/${id}/verify`
}

/**
 * @summary Verify the connection's app credentials against the live TikTok auth endpoint
 */
export const verifyTikTokDeveloperConnection = async (id: string, options?: RequestInit): Promise<VerifyTikTokDeveloperConnection200> => {

  return customFetch<VerifyTikTokDeveloperConnection200>(getVerifyTikTokDeveloperConnectionUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getVerifyTikTokDeveloperConnectionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyTikTokDeveloperConnection>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyTikTokDeveloperConnection>>, TError,{id: string}, TContext> => {

const mutationKey = ['verifyTikTokDeveloperConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyTikTokDeveloperConnection>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  verifyTikTokDeveloperConnection(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyTikTokDeveloperConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof verifyTikTokDeveloperConnection>>>

    export type VerifyTikTokDeveloperConnectionMutationError = ErrorType<void>

    /**
 * @summary Verify the connection's app credentials against the live TikTok auth endpoint
 */
export const useVerifyTikTokDeveloperConnection = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyTikTokDeveloperConnection>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyTikTokDeveloperConnection>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getVerifyTikTokDeveloperConnectionMutationOptions(options));
    }

export const getConnectTikTokDeveloperConnectionUrl = (id: string,) => {




  return `/api/tiktok_shop/developer-connections/${id}/connect`
}

/**
 * @summary Begin the OAuth authorisation flow for this developer connection (returns the authorize URL)
 */
export const connectTikTokDeveloperConnection = async (id: string, options?: RequestInit): Promise<ConnectTikTokDeveloperConnection200> => {

  return customFetch<ConnectTikTokDeveloperConnection200>(getConnectTikTokDeveloperConnectionUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getConnectTikTokDeveloperConnectionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectTikTokDeveloperConnection>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof connectTikTokDeveloperConnection>>, TError,{id: string}, TContext> => {

const mutationKey = ['connectTikTokDeveloperConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectTikTokDeveloperConnection>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  connectTikTokDeveloperConnection(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConnectTikTokDeveloperConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof connectTikTokDeveloperConnection>>>

    export type ConnectTikTokDeveloperConnectionMutationError = ErrorType<void>

    /**
 * @summary Begin the OAuth authorisation flow for this developer connection (returns the authorize URL)
 */
export const useConnectTikTokDeveloperConnection = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectTikTokDeveloperConnection>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof connectTikTokDeveloperConnection>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getConnectTikTokDeveloperConnectionMutationOptions(options));
    }

export const getUpdateTikTokAuthorisedShopUrl = (id: string,) => {




  return `/api/tiktok_shop/authorised-shops/${id}`
}

/**
 * @summary Update an authorised shop (per-shop sync toggle)
 */
export const updateTikTokAuthorisedShop = async (id: string,
    updateTikTokAuthorisedShopBody: UpdateTikTokAuthorisedShopBody, options?: RequestInit): Promise<TikTokAuthorisedShop> => {

  return customFetch<TikTokAuthorisedShop>(getUpdateTikTokAuthorisedShopUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateTikTokAuthorisedShopBody)
  }
);}





export const getUpdateTikTokAuthorisedShopMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTikTokAuthorisedShop>>, TError,{id: string;data: BodyType<UpdateTikTokAuthorisedShopBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTikTokAuthorisedShop>>, TError,{id: string;data: BodyType<UpdateTikTokAuthorisedShopBody>}, TContext> => {

const mutationKey = ['updateTikTokAuthorisedShop'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTikTokAuthorisedShop>>, {id: string;data: BodyType<UpdateTikTokAuthorisedShopBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTikTokAuthorisedShop(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTikTokAuthorisedShopMutationResult = NonNullable<Awaited<ReturnType<typeof updateTikTokAuthorisedShop>>>
    export type UpdateTikTokAuthorisedShopMutationBody = BodyType<UpdateTikTokAuthorisedShopBody>
    export type UpdateTikTokAuthorisedShopMutationError = ErrorType<void>

    /**
 * @summary Update an authorised shop (per-shop sync toggle)
 */
export const useUpdateTikTokAuthorisedShop = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTikTokAuthorisedShop>>, TError,{id: string;data: BodyType<UpdateTikTokAuthorisedShopBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTikTokAuthorisedShop>>,
        TError,
        {id: string;data: BodyType<UpdateTikTokAuthorisedShopBody>},
        TContext
      > => {
      return useMutation(getUpdateTikTokAuthorisedShopMutationOptions(options));
    }

export const getDisconnectTikTokAuthorisedShopUrl = (id: string,) => {




  return `/api/tiktok_shop/authorised-shops/${id}/disconnect`
}

/**
 * @summary Disconnect one authorised shop (clears its stored tokens)
 */
export const disconnectTikTokAuthorisedShop = async (id: string, options?: RequestInit): Promise<OkResult> => {

  return customFetch<OkResult>(getDisconnectTikTokAuthorisedShopUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDisconnectTikTokAuthorisedShopMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectTikTokAuthorisedShop>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectTikTokAuthorisedShop>>, TError,{id: string}, TContext> => {

const mutationKey = ['disconnectTikTokAuthorisedShop'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectTikTokAuthorisedShop>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  disconnectTikTokAuthorisedShop(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectTikTokAuthorisedShopMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectTikTokAuthorisedShop>>>

    export type DisconnectTikTokAuthorisedShopMutationError = ErrorType<void>

    /**
 * @summary Disconnect one authorised shop (clears its stored tokens)
 */
export const useDisconnectTikTokAuthorisedShop = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectTikTokAuthorisedShop>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof disconnectTikTokAuthorisedShop>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDisconnectTikTokAuthorisedShopMutationOptions(options));
    }

export const getGetTikTokShopSettingsUrl = () => {




  return `/api/tiktok_shop/settings`
}

/**
 * @summary Get the tenant's TikTok Shop sync settings
 */
export const getTikTokShopSettings = async ( options?: RequestInit): Promise<TikTokShopSettings> => {

  return customFetch<TikTokShopSettings>(getGetTikTokShopSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTikTokShopSettingsQueryKey = () => {
    return [
    `/api/tiktok_shop/settings`
    ] as const;
    }


export const getGetTikTokShopSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getTikTokShopSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTikTokShopSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTikTokShopSettings>>> = ({ signal }) => getTikTokShopSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTikTokShopSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getTikTokShopSettings>>>
export type GetTikTokShopSettingsQueryError = ErrorType<unknown>


/**
 * @summary Get the tenant's TikTok Shop sync settings
 */

export function useGetTikTokShopSettings<TData = Awaited<ReturnType<typeof getTikTokShopSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTikTokShopSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateTikTokShopSettingsUrl = () => {




  return `/api/tiktok_shop/settings`
}

/**
 * @summary Update the tenant's TikTok Shop sync settings
 */
export const updateTikTokShopSettings = async (tikTokShopSettingsUpdate: TikTokShopSettingsUpdate, options?: RequestInit): Promise<TikTokShopSettings> => {

  return customFetch<TikTokShopSettings>(getUpdateTikTokShopSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tikTokShopSettingsUpdate)
  }
);}





export const getUpdateTikTokShopSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTikTokShopSettings>>, TError,{data: BodyType<TikTokShopSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTikTokShopSettings>>, TError,{data: BodyType<TikTokShopSettingsUpdate>}, TContext> => {

const mutationKey = ['updateTikTokShopSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTikTokShopSettings>>, {data: BodyType<TikTokShopSettingsUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateTikTokShopSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTikTokShopSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateTikTokShopSettings>>>
    export type UpdateTikTokShopSettingsMutationBody = BodyType<TikTokShopSettingsUpdate>
    export type UpdateTikTokShopSettingsMutationError = ErrorType<unknown>

    /**
 * @summary Update the tenant's TikTok Shop sync settings
 */
export const useUpdateTikTokShopSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTikTokShopSettings>>, TError,{data: BodyType<TikTokShopSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTikTokShopSettings>>,
        TError,
        {data: BodyType<TikTokShopSettingsUpdate>},
        TContext
      > => {
      return useMutation(getUpdateTikTokShopSettingsMutationOptions(options));
    }

export const getGetTikTokCategoryMappingsUrl = () => {




  return `/api/tiktok_shop/category-mappings`
}

/**
 * @summary Get the tenant's product-type → TikTok category ID mappings
 */
export const getTikTokCategoryMappings = async ( options?: RequestInit): Promise<TikTokCategoryMappings> => {

  return customFetch<TikTokCategoryMappings>(getGetTikTokCategoryMappingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTikTokCategoryMappingsQueryKey = () => {
    return [
    `/api/tiktok_shop/category-mappings`
    ] as const;
    }


export const getGetTikTokCategoryMappingsQueryOptions = <TData = Awaited<ReturnType<typeof getTikTokCategoryMappings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTikTokCategoryMappings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTikTokCategoryMappingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTikTokCategoryMappings>>> = ({ signal }) => getTikTokCategoryMappings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTikTokCategoryMappings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTikTokCategoryMappingsQueryResult = NonNullable<Awaited<ReturnType<typeof getTikTokCategoryMappings>>>
export type GetTikTokCategoryMappingsQueryError = ErrorType<unknown>


/**
 * @summary Get the tenant's product-type → TikTok category ID mappings
 */

export function useGetTikTokCategoryMappings<TData = Awaited<ReturnType<typeof getTikTokCategoryMappings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTikTokCategoryMappings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTikTokCategoryMappingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateTikTokCategoryMappingsUrl = () => {




  return `/api/tiktok_shop/category-mappings`
}

/**
 * @summary Replace all category mappings for this tenant
 */
export const updateTikTokCategoryMappings = async (tikTokCategoryMappings: TikTokCategoryMappings, options?: RequestInit): Promise<TikTokCategoryMappings> => {

  return customFetch<TikTokCategoryMappings>(getUpdateTikTokCategoryMappingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tikTokCategoryMappings)
  }
);}





export const getUpdateTikTokCategoryMappingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTikTokCategoryMappings>>, TError,{data: BodyType<TikTokCategoryMappings>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTikTokCategoryMappings>>, TError,{data: BodyType<TikTokCategoryMappings>}, TContext> => {

const mutationKey = ['updateTikTokCategoryMappings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTikTokCategoryMappings>>, {data: BodyType<TikTokCategoryMappings>}> = (props) => {
          const {data} = props ?? {};

          return  updateTikTokCategoryMappings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTikTokCategoryMappingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateTikTokCategoryMappings>>>
    export type UpdateTikTokCategoryMappingsMutationBody = BodyType<TikTokCategoryMappings>
    export type UpdateTikTokCategoryMappingsMutationError = ErrorType<unknown>

    /**
 * @summary Replace all category mappings for this tenant
 */
export const useUpdateTikTokCategoryMappings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTikTokCategoryMappings>>, TError,{data: BodyType<TikTokCategoryMappings>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTikTokCategoryMappings>>,
        TError,
        {data: BodyType<TikTokCategoryMappings>},
        TContext
      > => {
      return useMutation(getUpdateTikTokCategoryMappingsMutationOptions(options));
    }

export const getGetTikTokCategoriesUrl = (params?: GetTikTokCategoriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tiktok_shop/categories?${stringifiedParams}` : `/api/tiktok_shop/categories`
}

/**
 * @summary Fetch TikTok Shop category tree (proxied from TikTok API). Returns an empty list with fallback=true if the API is unavailable.
 */
export const getTikTokCategories = async (params?: GetTikTokCategoriesParams, options?: RequestInit): Promise<TikTokCategoryTree> => {

  return customFetch<TikTokCategoryTree>(getGetTikTokCategoriesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTikTokCategoriesQueryKey = (params?: GetTikTokCategoriesParams,) => {
    return [
    `/api/tiktok_shop/categories`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTikTokCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof getTikTokCategories>>, TError = ErrorType<unknown>>(params?: GetTikTokCategoriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTikTokCategories>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTikTokCategoriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTikTokCategories>>> = ({ signal }) => getTikTokCategories(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTikTokCategories>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTikTokCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getTikTokCategories>>>
export type GetTikTokCategoriesQueryError = ErrorType<unknown>


/**
 * @summary Fetch TikTok Shop category tree (proxied from TikTok API). Returns an empty list with fallback=true if the API is unavailable.
 */

export function useGetTikTokCategories<TData = Awaited<ReturnType<typeof getTikTokCategories>>, TError = ErrorType<unknown>>(
 params?: GetTikTokCategoriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTikTokCategories>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTikTokCategoriesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetTikTokCategoryAttributesUrl = (categoryId: string,) => {




  return `/api/tiktok_shop/categories/${categoryId}/attributes`
}

/**
 * @summary Fetch TikTok Shop category attributes for a specific leaf category (proxied from TikTok API, cached 24 h). Returns an empty list with fallback=true if the API is unavailable.
 */
export const getTikTokCategoryAttributes = async (categoryId: string, options?: RequestInit): Promise<TikTokCategoryAttributeList> => {

  return customFetch<TikTokCategoryAttributeList>(getGetTikTokCategoryAttributesUrl(categoryId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTikTokCategoryAttributesQueryKey = (categoryId: string,) => {
    return [
    `/api/tiktok_shop/categories/${categoryId}/attributes`
    ] as const;
    }


export const getGetTikTokCategoryAttributesQueryOptions = <TData = Awaited<ReturnType<typeof getTikTokCategoryAttributes>>, TError = ErrorType<unknown>>(categoryId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTikTokCategoryAttributes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTikTokCategoryAttributesQueryKey(categoryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTikTokCategoryAttributes>>> = ({ signal }) => getTikTokCategoryAttributes(categoryId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: categoryId !== null && categoryId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTikTokCategoryAttributes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTikTokCategoryAttributesQueryResult = NonNullable<Awaited<ReturnType<typeof getTikTokCategoryAttributes>>>
export type GetTikTokCategoryAttributesQueryError = ErrorType<unknown>


/**
 * @summary Fetch TikTok Shop category attributes for a specific leaf category (proxied from TikTok API, cached 24 h). Returns an empty list with fallback=true if the API is unavailable.
 */

export function useGetTikTokCategoryAttributes<TData = Awaited<ReturnType<typeof getTikTokCategoryAttributes>>, TError = ErrorType<unknown>>(
 categoryId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTikTokCategoryAttributes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTikTokCategoryAttributesQueryOptions(categoryId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListTikTokProductTypesUrl = () => {




  return `/api/tiktok_shop/product-types`
}

/**
 * @summary List distinct non-empty product types from inventory (for category-mapping autocomplete)
 */
export const listTikTokProductTypes = async ( options?: RequestInit): Promise<ListTikTokProductTypes200> => {

  return customFetch<ListTikTokProductTypes200>(getListTikTokProductTypesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTikTokProductTypesQueryKey = () => {
    return [
    `/api/tiktok_shop/product-types`
    ] as const;
    }


export const getListTikTokProductTypesQueryOptions = <TData = Awaited<ReturnType<typeof listTikTokProductTypes>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTikTokProductTypes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTikTokProductTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTikTokProductTypes>>> = ({ signal }) => listTikTokProductTypes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTikTokProductTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTikTokProductTypesQueryResult = NonNullable<Awaited<ReturnType<typeof listTikTokProductTypes>>>
export type ListTikTokProductTypesQueryError = ErrorType<unknown>


/**
 * @summary List distinct non-empty product types from inventory (for category-mapping autocomplete)
 */

export function useListTikTokProductTypes<TData = Awaited<ReturnType<typeof listTikTokProductTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTikTokProductTypes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTikTokProductTypesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListTikTokShopSyncLogsUrl = (params?: ListTikTokShopSyncLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tiktok_shop/sync-logs?${stringifiedParams}` : `/api/tiktok_shop/sync-logs`
}

/**
 * @summary List sync log rows (newest first)
 */
export const listTikTokShopSyncLogs = async (params?: ListTikTokShopSyncLogsParams, options?: RequestInit): Promise<ListTikTokShopSyncLogs200> => {

  return customFetch<ListTikTokShopSyncLogs200>(getListTikTokShopSyncLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTikTokShopSyncLogsQueryKey = (params?: ListTikTokShopSyncLogsParams,) => {
    return [
    `/api/tiktok_shop/sync-logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTikTokShopSyncLogsQueryOptions = <TData = Awaited<ReturnType<typeof listTikTokShopSyncLogs>>, TError = ErrorType<unknown>>(params?: ListTikTokShopSyncLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTikTokShopSyncLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTikTokShopSyncLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTikTokShopSyncLogs>>> = ({ signal }) => listTikTokShopSyncLogs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTikTokShopSyncLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTikTokShopSyncLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listTikTokShopSyncLogs>>>
export type ListTikTokShopSyncLogsQueryError = ErrorType<unknown>


/**
 * @summary List sync log rows (newest first)
 */

export function useListTikTokShopSyncLogs<TData = Awaited<ReturnType<typeof listTikTokShopSyncLogs>>, TError = ErrorType<unknown>>(
 params?: ListTikTokShopSyncLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTikTokShopSyncLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTikTokShopSyncLogsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSyncTikTokShopOrdersUrl = () => {




  return `/api/tiktok_shop/orders/sync`
}

/**
 * @summary Pull recent TikTok Shop orders into sales now (manual trigger)
 */
export const syncTikTokShopOrders = async (syncTikTokShopOrdersBody?: SyncTikTokShopOrdersBody, options?: RequestInit): Promise<TikTokShopOrderSyncResult> => {

  return customFetch<TikTokShopOrderSyncResult>(getSyncTikTokShopOrdersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(syncTikTokShopOrdersBody)
  }
);}





export const getSyncTikTokShopOrdersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncTikTokShopOrders>>, TError,{data?: BodyType<SyncTikTokShopOrdersBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncTikTokShopOrders>>, TError,{data?: BodyType<SyncTikTokShopOrdersBody>}, TContext> => {

const mutationKey = ['syncTikTokShopOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncTikTokShopOrders>>, {data?: BodyType<SyncTikTokShopOrdersBody>}> = (props) => {
          const {data} = props ?? {};

          return  syncTikTokShopOrders(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncTikTokShopOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof syncTikTokShopOrders>>>
    export type SyncTikTokShopOrdersMutationBody = BodyType<SyncTikTokShopOrdersBody> | undefined
    export type SyncTikTokShopOrdersMutationError = ErrorType<unknown>

    /**
 * @summary Pull recent TikTok Shop orders into sales now (manual trigger)
 */
export const useSyncTikTokShopOrders = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncTikTokShopOrders>>, TError,{data?: BodyType<SyncTikTokShopOrdersBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncTikTokShopOrders>>,
        TError,
        {data?: BodyType<SyncTikTokShopOrdersBody>},
        TContext
      > => {
      return useMutation(getSyncTikTokShopOrdersMutationOptions(options));
    }

export const getPushTikTokShopTrackingUrl = () => {




  return `/api/tiktok_shop/tracking/push`
}

/**
 * @summary Push dispatch tracking for eligible TikTok Shop orders now (manual trigger)
 */
export const pushTikTokShopTracking = async ( options?: RequestInit): Promise<TikTokShopTrackingPushResult> => {

  return customFetch<TikTokShopTrackingPushResult>(getPushTikTokShopTrackingUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPushTikTokShopTrackingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushTikTokShopTracking>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pushTikTokShopTracking>>, TError,void, TContext> => {

const mutationKey = ['pushTikTokShopTracking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pushTikTokShopTracking>>, void> = () => {


          return  pushTikTokShopTracking(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PushTikTokShopTrackingMutationResult = NonNullable<Awaited<ReturnType<typeof pushTikTokShopTracking>>>

    export type PushTikTokShopTrackingMutationError = ErrorType<unknown>

    /**
 * @summary Push dispatch tracking for eligible TikTok Shop orders now (manual trigger)
 */
export const usePushTikTokShopTracking = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushTikTokShopTracking>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof pushTikTokShopTracking>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPushTikTokShopTrackingMutationOptions(options));
    }

export const getResyncTikTokShopStockUrl = () => {




  return `/api/tiktok_shop/stock/resync`
}

/**
 * @summary Push absolute available quantity to TikTok Shop for every linked item
 */
export const resyncTikTokShopStock = async ( options?: RequestInit): Promise<TikTokShopStockResyncResult> => {

  return customFetch<TikTokShopStockResyncResult>(getResyncTikTokShopStockUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResyncTikTokShopStockMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resyncTikTokShopStock>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resyncTikTokShopStock>>, TError,void, TContext> => {

const mutationKey = ['resyncTikTokShopStock'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resyncTikTokShopStock>>, void> = () => {


          return  resyncTikTokShopStock(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResyncTikTokShopStockMutationResult = NonNullable<Awaited<ReturnType<typeof resyncTikTokShopStock>>>

    export type ResyncTikTokShopStockMutationError = ErrorType<unknown>

    /**
 * @summary Push absolute available quantity to TikTok Shop for every linked item
 */
export const useResyncTikTokShopStock = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resyncTikTokShopStock>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resyncTikTokShopStock>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getResyncTikTokShopStockMutationOptions(options));
    }

export const getResyncTikTokShopStockItemUrl = (itemId: string,) => {




  return `/api/tiktok_shop/stock/resync/${itemId}`
}

/**
 * @summary Push absolute available quantity to TikTok Shop for one inventory item
 */
export const resyncTikTokShopStockItem = async (itemId: string, options?: RequestInit): Promise<TikTokShopStockPushResult> => {

  return customFetch<TikTokShopStockPushResult>(getResyncTikTokShopStockItemUrl(itemId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResyncTikTokShopStockItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resyncTikTokShopStockItem>>, TError,{itemId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resyncTikTokShopStockItem>>, TError,{itemId: string}, TContext> => {

const mutationKey = ['resyncTikTokShopStockItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resyncTikTokShopStockItem>>, {itemId: string}> = (props) => {
          const {itemId} = props ?? {};

          return  resyncTikTokShopStockItem(itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResyncTikTokShopStockItemMutationResult = NonNullable<Awaited<ReturnType<typeof resyncTikTokShopStockItem>>>

    export type ResyncTikTokShopStockItemMutationError = ErrorType<unknown>

    /**
 * @summary Push absolute available quantity to TikTok Shop for one inventory item
 */
export const useResyncTikTokShopStockItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resyncTikTokShopStockItem>>, TError,{itemId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resyncTikTokShopStockItem>>,
        TError,
        {itemId: string},
        TContext
      > => {
      return useMutation(getResyncTikTokShopStockItemMutationOptions(options));
    }

export const getPushTikTokShopOrderTrackingUrl = (saleOrderId: string,) => {




  return `/api/tiktok_shop/orders/${saleOrderId}/push-tracking`
}

/**
 * @summary Push tracking / fulfilment for one sale order to TikTok Shop now
 */
export const pushTikTokShopOrderTracking = async (saleOrderId: string, options?: RequestInit): Promise<TikTokShopOrderTrackingPushResult> => {

  return customFetch<TikTokShopOrderTrackingPushResult>(getPushTikTokShopOrderTrackingUrl(saleOrderId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPushTikTokShopOrderTrackingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushTikTokShopOrderTracking>>, TError,{saleOrderId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pushTikTokShopOrderTracking>>, TError,{saleOrderId: string}, TContext> => {

const mutationKey = ['pushTikTokShopOrderTracking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pushTikTokShopOrderTracking>>, {saleOrderId: string}> = (props) => {
          const {saleOrderId} = props ?? {};

          return  pushTikTokShopOrderTracking(saleOrderId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PushTikTokShopOrderTrackingMutationResult = NonNullable<Awaited<ReturnType<typeof pushTikTokShopOrderTracking>>>

    export type PushTikTokShopOrderTrackingMutationError = ErrorType<unknown>

    /**
 * @summary Push tracking / fulfilment for one sale order to TikTok Shop now
 */
export const usePushTikTokShopOrderTracking = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushTikTokShopOrderTracking>>, TError,{saleOrderId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof pushTikTokShopOrderTracking>>,
        TError,
        {saleOrderId: string},
        TContext
      > => {
      return useMutation(getPushTikTokShopOrderTrackingMutationOptions(options));
    }

export const getRefreshTikTokShopOrderStatusesUrl = () => {




  return `/api/tiktok_shop/orders/status-refresh`
}

/**
 * @summary Pull back TikTok Shop order statuses onto sales now (manual trigger)
 */
export const refreshTikTokShopOrderStatuses = async ( options?: RequestInit): Promise<TikTokShopStatusSyncResult> => {

  return customFetch<TikTokShopStatusSyncResult>(getRefreshTikTokShopOrderStatusesUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRefreshTikTokShopOrderStatusesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshTikTokShopOrderStatuses>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshTikTokShopOrderStatuses>>, TError,void, TContext> => {

const mutationKey = ['refreshTikTokShopOrderStatuses'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshTikTokShopOrderStatuses>>, void> = () => {


          return  refreshTikTokShopOrderStatuses(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshTikTokShopOrderStatusesMutationResult = NonNullable<Awaited<ReturnType<typeof refreshTikTokShopOrderStatuses>>>

    export type RefreshTikTokShopOrderStatusesMutationError = ErrorType<unknown>

    /**
 * @summary Pull back TikTok Shop order statuses onto sales now (manual trigger)
 */
export const useRefreshTikTokShopOrderStatuses = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshTikTokShopOrderStatuses>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof refreshTikTokShopOrderStatuses>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRefreshTikTokShopOrderStatusesMutationOptions(options));
    }

export const getGetTikTokShopSyncSummaryUrl = () => {




  return `/api/tiktok_shop/sync-summary`
}

/**
 * @summary Compact TikTok Shop sync health snapshot for the dashboard widget
 */
export const getTikTokShopSyncSummary = async ( options?: RequestInit): Promise<TikTokShopSyncSummary> => {

  return customFetch<TikTokShopSyncSummary>(getGetTikTokShopSyncSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTikTokShopSyncSummaryQueryKey = () => {
    return [
    `/api/tiktok_shop/sync-summary`
    ] as const;
    }


export const getGetTikTokShopSyncSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getTikTokShopSyncSummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopSyncSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTikTokShopSyncSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTikTokShopSyncSummary>>> = ({ signal }) => getTikTokShopSyncSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopSyncSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTikTokShopSyncSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getTikTokShopSyncSummary>>>
export type GetTikTokShopSyncSummaryQueryError = ErrorType<unknown>


/**
 * @summary Compact TikTok Shop sync health snapshot for the dashboard widget
 */

export function useGetTikTokShopSyncSummary<TData = Awaited<ReturnType<typeof getTikTokShopSyncSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopSyncSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTikTokShopSyncSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetTikTokShopDashboardUrl = () => {




  return `/api/tiktok_shop/dashboard`
}

/**
 * @summary Aggregated TikTok Shop area dashboard (connections, shops, jobs, capabilities)
 */
export const getTikTokShopDashboard = async ( options?: RequestInit): Promise<TikTokShopDashboard> => {

  return customFetch<TikTokShopDashboard>(getGetTikTokShopDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTikTokShopDashboardQueryKey = () => {
    return [
    `/api/tiktok_shop/dashboard`
    ] as const;
    }


export const getGetTikTokShopDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getTikTokShopDashboard>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTikTokShopDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTikTokShopDashboard>>> = ({ signal }) => getTikTokShopDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTikTokShopDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getTikTokShopDashboard>>>
export type GetTikTokShopDashboardQueryError = ErrorType<unknown>


/**
 * @summary Aggregated TikTok Shop area dashboard (connections, shops, jobs, capabilities)
 */

export function useGetTikTokShopDashboard<TData = Awaited<ReturnType<typeof getTikTokShopDashboard>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTikTokShopDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListTikTokShopCapabilitiesUrl = (params?: ListTikTokShopCapabilitiesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tiktok_shop/capabilities?${stringifiedParams}` : `/api/tiktok_shop/capabilities`
}

/**
 * @summary Per-(tenant, developer connection) capability matrix
 */
export const listTikTokShopCapabilities = async (params?: ListTikTokShopCapabilitiesParams, options?: RequestInit): Promise<ListTikTokShopCapabilities200> => {

  return customFetch<ListTikTokShopCapabilities200>(getListTikTokShopCapabilitiesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTikTokShopCapabilitiesQueryKey = (params?: ListTikTokShopCapabilitiesParams,) => {
    return [
    `/api/tiktok_shop/capabilities`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTikTokShopCapabilitiesQueryOptions = <TData = Awaited<ReturnType<typeof listTikTokShopCapabilities>>, TError = ErrorType<unknown>>(params?: ListTikTokShopCapabilitiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTikTokShopCapabilities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTikTokShopCapabilitiesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTikTokShopCapabilities>>> = ({ signal }) => listTikTokShopCapabilities(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTikTokShopCapabilities>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTikTokShopCapabilitiesQueryResult = NonNullable<Awaited<ReturnType<typeof listTikTokShopCapabilities>>>
export type ListTikTokShopCapabilitiesQueryError = ErrorType<unknown>


/**
 * @summary Per-(tenant, developer connection) capability matrix
 */

export function useListTikTokShopCapabilities<TData = Awaited<ReturnType<typeof listTikTokShopCapabilities>>, TError = ErrorType<unknown>>(
 params?: ListTikTokShopCapabilitiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTikTokShopCapabilities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTikTokShopCapabilitiesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListTikTokShopSyncJobsUrl = (params?: ListTikTokShopSyncJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tiktok_shop/sync-jobs?${stringifiedParams}` : `/api/tiktok_shop/sync-jobs`
}

/**
 * @summary Sync Centre — list background sync jobs (newest first) with status counts
 */
export const listTikTokShopSyncJobs = async (params?: ListTikTokShopSyncJobsParams, options?: RequestInit): Promise<ListTikTokShopSyncJobs200> => {

  return customFetch<ListTikTokShopSyncJobs200>(getListTikTokShopSyncJobsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTikTokShopSyncJobsQueryKey = (params?: ListTikTokShopSyncJobsParams,) => {
    return [
    `/api/tiktok_shop/sync-jobs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTikTokShopSyncJobsQueryOptions = <TData = Awaited<ReturnType<typeof listTikTokShopSyncJobs>>, TError = ErrorType<unknown>>(params?: ListTikTokShopSyncJobsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTikTokShopSyncJobs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTikTokShopSyncJobsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTikTokShopSyncJobs>>> = ({ signal }) => listTikTokShopSyncJobs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTikTokShopSyncJobs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTikTokShopSyncJobsQueryResult = NonNullable<Awaited<ReturnType<typeof listTikTokShopSyncJobs>>>
export type ListTikTokShopSyncJobsQueryError = ErrorType<unknown>


/**
 * @summary Sync Centre — list background sync jobs (newest first) with status counts
 */

export function useListTikTokShopSyncJobs<TData = Awaited<ReturnType<typeof listTikTokShopSyncJobs>>, TError = ErrorType<unknown>>(
 params?: ListTikTokShopSyncJobsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTikTokShopSyncJobs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTikTokShopSyncJobsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRetryTikTokShopSyncJobUrl = (id: string,) => {




  return `/api/tiktok_shop/sync-jobs/${id}/retry`
}

/**
 * @summary Requeue a failed/cancelled sync job (permission-gated)
 */
export const retryTikTokShopSyncJob = async (id: string, options?: RequestInit): Promise<TikTokSyncJob> => {

  return customFetch<TikTokSyncJob>(getRetryTikTokShopSyncJobUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRetryTikTokShopSyncJobMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryTikTokShopSyncJob>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof retryTikTokShopSyncJob>>, TError,{id: string}, TContext> => {

const mutationKey = ['retryTikTokShopSyncJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryTikTokShopSyncJob>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  retryTikTokShopSyncJob(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryTikTokShopSyncJobMutationResult = NonNullable<Awaited<ReturnType<typeof retryTikTokShopSyncJob>>>

    export type RetryTikTokShopSyncJobMutationError = ErrorType<void>

    /**
 * @summary Requeue a failed/cancelled sync job (permission-gated)
 */
export const useRetryTikTokShopSyncJob = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryTikTokShopSyncJob>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof retryTikTokShopSyncJob>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getRetryTikTokShopSyncJobMutationOptions(options));
    }

export const getListTikTokShopProductMappingsUrl = (params?: ListTikTokShopProductMappingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tiktok_shop/product-mappings?${stringifiedParams}` : `/api/tiktok_shop/product-mappings`
}

/**
 * @summary List TikTok Shop product mappings (listings ↔ internal inventory)
 */
export const listTikTokShopProductMappings = async (params?: ListTikTokShopProductMappingsParams, options?: RequestInit): Promise<TikTokShopProductMappingList> => {

  return customFetch<TikTokShopProductMappingList>(getListTikTokShopProductMappingsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTikTokShopProductMappingsQueryKey = (params?: ListTikTokShopProductMappingsParams,) => {
    return [
    `/api/tiktok_shop/product-mappings`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTikTokShopProductMappingsQueryOptions = <TData = Awaited<ReturnType<typeof listTikTokShopProductMappings>>, TError = ErrorType<unknown>>(params?: ListTikTokShopProductMappingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTikTokShopProductMappings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTikTokShopProductMappingsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTikTokShopProductMappings>>> = ({ signal }) => listTikTokShopProductMappings(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTikTokShopProductMappings>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTikTokShopProductMappingsQueryResult = NonNullable<Awaited<ReturnType<typeof listTikTokShopProductMappings>>>
export type ListTikTokShopProductMappingsQueryError = ErrorType<unknown>


/**
 * @summary List TikTok Shop product mappings (listings ↔ internal inventory)
 */

export function useListTikTokShopProductMappings<TData = Awaited<ReturnType<typeof listTikTokShopProductMappings>>, TError = ErrorType<unknown>>(
 params?: ListTikTokShopProductMappingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTikTokShopProductMappings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTikTokShopProductMappingsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateTikTokShopProductMappingUrl = () => {




  return `/api/tiktok_shop/product-mappings`
}

/**
 * @summary Create or upsert a TikTok Shop product mapping
 */
export const createTikTokShopProductMapping = async (tikTokShopMappingUpsert: TikTokShopMappingUpsert, options?: RequestInit): Promise<TikTokShopProductMapping> => {

  return customFetch<TikTokShopProductMapping>(getCreateTikTokShopProductMappingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tikTokShopMappingUpsert)
  }
);}





export const getCreateTikTokShopProductMappingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTikTokShopProductMapping>>, TError,{data: BodyType<TikTokShopMappingUpsert>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTikTokShopProductMapping>>, TError,{data: BodyType<TikTokShopMappingUpsert>}, TContext> => {

const mutationKey = ['createTikTokShopProductMapping'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTikTokShopProductMapping>>, {data: BodyType<TikTokShopMappingUpsert>}> = (props) => {
          const {data} = props ?? {};

          return  createTikTokShopProductMapping(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTikTokShopProductMappingMutationResult = NonNullable<Awaited<ReturnType<typeof createTikTokShopProductMapping>>>
    export type CreateTikTokShopProductMappingMutationBody = BodyType<TikTokShopMappingUpsert>
    export type CreateTikTokShopProductMappingMutationError = ErrorType<unknown>

    /**
 * @summary Create or upsert a TikTok Shop product mapping
 */
export const useCreateTikTokShopProductMapping = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTikTokShopProductMapping>>, TError,{data: BodyType<TikTokShopMappingUpsert>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTikTokShopProductMapping>>,
        TError,
        {data: BodyType<TikTokShopMappingUpsert>},
        TContext
      > => {
      return useMutation(getCreateTikTokShopProductMappingMutationOptions(options));
    }

export const getListTikTokShopUnmappedListingsUrl = () => {




  return `/api/tiktok_shop/product-mappings/unmapped`
}

/**
 * @summary List unmapped TikTok Shop listings + queue count
 */
export const listTikTokShopUnmappedListings = async ( options?: RequestInit): Promise<TikTokShopUnmappedList> => {

  return customFetch<TikTokShopUnmappedList>(getListTikTokShopUnmappedListingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTikTokShopUnmappedListingsQueryKey = () => {
    return [
    `/api/tiktok_shop/product-mappings/unmapped`
    ] as const;
    }


export const getListTikTokShopUnmappedListingsQueryOptions = <TData = Awaited<ReturnType<typeof listTikTokShopUnmappedListings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTikTokShopUnmappedListings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTikTokShopUnmappedListingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTikTokShopUnmappedListings>>> = ({ signal }) => listTikTokShopUnmappedListings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTikTokShopUnmappedListings>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTikTokShopUnmappedListingsQueryResult = NonNullable<Awaited<ReturnType<typeof listTikTokShopUnmappedListings>>>
export type ListTikTokShopUnmappedListingsQueryError = ErrorType<unknown>


/**
 * @summary List unmapped TikTok Shop listings + queue count
 */

export function useListTikTokShopUnmappedListings<TData = Awaited<ReturnType<typeof listTikTokShopUnmappedListings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTikTokShopUnmappedListings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTikTokShopUnmappedListingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListTikTokShopNeedsRelinkUrl = () => {




  return `/api/tiktok_shop/product-mappings/needs-relink`
}

/**
 * @summary List TikTok links whose stock pushes are skipped pending re-linking
 */
export const listTikTokShopNeedsRelink = async ( options?: RequestInit): Promise<TikTokShopNeedsRelinkList> => {

  return customFetch<TikTokShopNeedsRelinkList>(getListTikTokShopNeedsRelinkUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTikTokShopNeedsRelinkQueryKey = () => {
    return [
    `/api/tiktok_shop/product-mappings/needs-relink`
    ] as const;
    }


export const getListTikTokShopNeedsRelinkQueryOptions = <TData = Awaited<ReturnType<typeof listTikTokShopNeedsRelink>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTikTokShopNeedsRelink>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTikTokShopNeedsRelinkQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTikTokShopNeedsRelink>>> = ({ signal }) => listTikTokShopNeedsRelink({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTikTokShopNeedsRelink>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTikTokShopNeedsRelinkQueryResult = NonNullable<Awaited<ReturnType<typeof listTikTokShopNeedsRelink>>>
export type ListTikTokShopNeedsRelinkQueryError = ErrorType<unknown>


/**
 * @summary List TikTok links whose stock pushes are skipped pending re-linking
 */

export function useListTikTokShopNeedsRelink<TData = Awaited<ReturnType<typeof listTikTokShopNeedsRelink>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTikTokShopNeedsRelink>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTikTokShopNeedsRelinkQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRefreshTikTokShopSkuFromTikTokUrl = () => {




  return `/api/tiktok_shop/product-mappings/refresh-from-tiktok`
}

/**
 * @summary Refresh a bad TikTok SKU id straight from TikTok (one-click re-link fix)
 */
export const refreshTikTokShopSkuFromTikTok = async (tikTokShopRefreshSkuRequest: TikTokShopRefreshSkuRequest, options?: RequestInit): Promise<TikTokShopRefreshSkuResult> => {

  return customFetch<TikTokShopRefreshSkuResult>(getRefreshTikTokShopSkuFromTikTokUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tikTokShopRefreshSkuRequest)
  }
);}





export const getRefreshTikTokShopSkuFromTikTokMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshTikTokShopSkuFromTikTok>>, TError,{data: BodyType<TikTokShopRefreshSkuRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshTikTokShopSkuFromTikTok>>, TError,{data: BodyType<TikTokShopRefreshSkuRequest>}, TContext> => {

const mutationKey = ['refreshTikTokShopSkuFromTikTok'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshTikTokShopSkuFromTikTok>>, {data: BodyType<TikTokShopRefreshSkuRequest>}> = (props) => {
          const {data} = props ?? {};

          return  refreshTikTokShopSkuFromTikTok(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshTikTokShopSkuFromTikTokMutationResult = NonNullable<Awaited<ReturnType<typeof refreshTikTokShopSkuFromTikTok>>>
    export type RefreshTikTokShopSkuFromTikTokMutationBody = BodyType<TikTokShopRefreshSkuRequest>
    export type RefreshTikTokShopSkuFromTikTokMutationError = ErrorType<unknown>

    /**
 * @summary Refresh a bad TikTok SKU id straight from TikTok (one-click re-link fix)
 */
export const useRefreshTikTokShopSkuFromTikTok = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshTikTokShopSkuFromTikTok>>, TError,{data: BodyType<TikTokShopRefreshSkuRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof refreshTikTokShopSkuFromTikTok>>,
        TError,
        {data: BodyType<TikTokShopRefreshSkuRequest>},
        TContext
      > => {
      return useMutation(getRefreshTikTokShopSkuFromTikTokMutationOptions(options));
    }

export const getExportTikTokShopProductMappingsUrl = () => {




  return `/api/tiktok_shop/product-mappings/export.csv`
}

/**
 * @summary Export TikTok Shop product mappings as CSV
 */
export const exportTikTokShopProductMappings = async ( options?: RequestInit): Promise<string> => {

  return customFetch<string>(getExportTikTokShopProductMappingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportTikTokShopProductMappingsQueryKey = () => {
    return [
    `/api/tiktok_shop/product-mappings/export.csv`
    ] as const;
    }


export const getExportTikTokShopProductMappingsQueryOptions = <TData = Awaited<ReturnType<typeof exportTikTokShopProductMappings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportTikTokShopProductMappings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportTikTokShopProductMappingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportTikTokShopProductMappings>>> = ({ signal }) => exportTikTokShopProductMappings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportTikTokShopProductMappings>>, TError, TData> & { queryKey: QueryKey }
}

export type ExportTikTokShopProductMappingsQueryResult = NonNullable<Awaited<ReturnType<typeof exportTikTokShopProductMappings>>>
export type ExportTikTokShopProductMappingsQueryError = ErrorType<unknown>


/**
 * @summary Export TikTok Shop product mappings as CSV
 */

export function useExportTikTokShopProductMappings<TData = Awaited<ReturnType<typeof exportTikTokShopProductMappings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportTikTokShopProductMappings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getExportTikTokShopProductMappingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getImportTikTokShopProductMappingsUrl = () => {




  return `/api/tiktok_shop/product-mappings/import`
}

/**
 * @summary Bulk import TikTok Shop product mappings from CSV
 */
export const importTikTokShopProductMappings = async (tikTokShopMappingImportRequest: TikTokShopMappingImportRequest, options?: RequestInit): Promise<TikTokShopMappingImportResult> => {

  return customFetch<TikTokShopMappingImportResult>(getImportTikTokShopProductMappingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tikTokShopMappingImportRequest)
  }
);}





export const getImportTikTokShopProductMappingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importTikTokShopProductMappings>>, TError,{data: BodyType<TikTokShopMappingImportRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importTikTokShopProductMappings>>, TError,{data: BodyType<TikTokShopMappingImportRequest>}, TContext> => {

const mutationKey = ['importTikTokShopProductMappings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importTikTokShopProductMappings>>, {data: BodyType<TikTokShopMappingImportRequest>}> = (props) => {
          const {data} = props ?? {};

          return  importTikTokShopProductMappings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportTikTokShopProductMappingsMutationResult = NonNullable<Awaited<ReturnType<typeof importTikTokShopProductMappings>>>
    export type ImportTikTokShopProductMappingsMutationBody = BodyType<TikTokShopMappingImportRequest>
    export type ImportTikTokShopProductMappingsMutationError = ErrorType<unknown>

    /**
 * @summary Bulk import TikTok Shop product mappings from CSV
 */
export const useImportTikTokShopProductMappings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importTikTokShopProductMappings>>, TError,{data: BodyType<TikTokShopMappingImportRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importTikTokShopProductMappings>>,
        TError,
        {data: BodyType<TikTokShopMappingImportRequest>},
        TContext
      > => {
      return useMutation(getImportTikTokShopProductMappingsMutationOptions(options));
    }

export const getMatchTikTokShopListingTitleUrl = () => {




  return `/api/tiktok_shop/product-mappings/match`
}

/**
 * @summary Suggest inventory matches for a TikTok listing title
 */
export const matchTikTokShopListingTitle = async (tikTokShopMatchRequest: TikTokShopMatchRequest, options?: RequestInit): Promise<TikTokShopMatchSuggestion> => {

  return customFetch<TikTokShopMatchSuggestion>(getMatchTikTokShopListingTitleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tikTokShopMatchRequest)
  }
);}





export const getMatchTikTokShopListingTitleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchTikTokShopListingTitle>>, TError,{data: BodyType<TikTokShopMatchRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof matchTikTokShopListingTitle>>, TError,{data: BodyType<TikTokShopMatchRequest>}, TContext> => {

const mutationKey = ['matchTikTokShopListingTitle'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof matchTikTokShopListingTitle>>, {data: BodyType<TikTokShopMatchRequest>}> = (props) => {
          const {data} = props ?? {};

          return  matchTikTokShopListingTitle(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MatchTikTokShopListingTitleMutationResult = NonNullable<Awaited<ReturnType<typeof matchTikTokShopListingTitle>>>
    export type MatchTikTokShopListingTitleMutationBody = BodyType<TikTokShopMatchRequest>
    export type MatchTikTokShopListingTitleMutationError = ErrorType<unknown>

    /**
 * @summary Suggest inventory matches for a TikTok listing title
 */
export const useMatchTikTokShopListingTitle = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchTikTokShopListingTitle>>, TError,{data: BodyType<TikTokShopMatchRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof matchTikTokShopListingTitle>>,
        TError,
        {data: BodyType<TikTokShopMatchRequest>},
        TContext
      > => {
      return useMutation(getMatchTikTokShopListingTitleMutationOptions(options));
    }

export const getUpdateTikTokShopProductMappingUrl = (id: string,) => {




  return `/api/tiktok_shop/product-mappings/${id}`
}

/**
 * @summary Update a TikTok Shop product mapping (link inventory, override)
 */
export const updateTikTokShopProductMapping = async (id: string,
    tikTokShopMappingPatch: TikTokShopMappingPatch, options?: RequestInit): Promise<TikTokShopProductMapping> => {

  return customFetch<TikTokShopProductMapping>(getUpdateTikTokShopProductMappingUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tikTokShopMappingPatch)
  }
);}





export const getUpdateTikTokShopProductMappingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTikTokShopProductMapping>>, TError,{id: string;data: BodyType<TikTokShopMappingPatch>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTikTokShopProductMapping>>, TError,{id: string;data: BodyType<TikTokShopMappingPatch>}, TContext> => {

const mutationKey = ['updateTikTokShopProductMapping'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTikTokShopProductMapping>>, {id: string;data: BodyType<TikTokShopMappingPatch>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTikTokShopProductMapping(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTikTokShopProductMappingMutationResult = NonNullable<Awaited<ReturnType<typeof updateTikTokShopProductMapping>>>
    export type UpdateTikTokShopProductMappingMutationBody = BodyType<TikTokShopMappingPatch>
    export type UpdateTikTokShopProductMappingMutationError = ErrorType<unknown>

    /**
 * @summary Update a TikTok Shop product mapping (link inventory, override)
 */
export const useUpdateTikTokShopProductMapping = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTikTokShopProductMapping>>, TError,{id: string;data: BodyType<TikTokShopMappingPatch>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTikTokShopProductMapping>>,
        TError,
        {id: string;data: BodyType<TikTokShopMappingPatch>},
        TContext
      > => {
      return useMutation(getUpdateTikTokShopProductMappingMutationOptions(options));
    }

export const getDeleteTikTokShopProductMappingUrl = (id: string,) => {




  return `/api/tiktok_shop/product-mappings/${id}`
}

/**
 * @summary Delete a TikTok Shop product mapping
 */
export const deleteTikTokShopProductMapping = async (id: string, options?: RequestInit): Promise<DeleteTikTokShopProductMapping200> => {

  return customFetch<DeleteTikTokShopProductMapping200>(getDeleteTikTokShopProductMappingUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTikTokShopProductMappingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTikTokShopProductMapping>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTikTokShopProductMapping>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteTikTokShopProductMapping'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTikTokShopProductMapping>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteTikTokShopProductMapping(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTikTokShopProductMappingMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTikTokShopProductMapping>>>

    export type DeleteTikTokShopProductMappingMutationError = ErrorType<unknown>

    /**
 * @summary Delete a TikTok Shop product mapping
 */
export const useDeleteTikTokShopProductMapping = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTikTokShopProductMapping>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTikTokShopProductMapping>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteTikTokShopProductMappingMutationOptions(options));
    }

export const getGetTikTokShopProductPushCapabilityUrl = (params?: GetTikTokShopProductPushCapabilityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tiktok_shop/products/push-capability?${stringifiedParams}` : `/api/tiktok_shop/products/push-capability`
}

/**
 * @summary Probe whether the connected shop can create/manage products
 */
export const getTikTokShopProductPushCapability = async (params?: GetTikTokShopProductPushCapabilityParams, options?: RequestInit): Promise<TikTokShopProductCapability> => {

  return customFetch<TikTokShopProductCapability>(getGetTikTokShopProductPushCapabilityUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTikTokShopProductPushCapabilityQueryKey = (params?: GetTikTokShopProductPushCapabilityParams,) => {
    return [
    `/api/tiktok_shop/products/push-capability`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTikTokShopProductPushCapabilityQueryOptions = <TData = Awaited<ReturnType<typeof getTikTokShopProductPushCapability>>, TError = ErrorType<unknown>>(params?: GetTikTokShopProductPushCapabilityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopProductPushCapability>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTikTokShopProductPushCapabilityQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTikTokShopProductPushCapability>>> = ({ signal }) => getTikTokShopProductPushCapability(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopProductPushCapability>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTikTokShopProductPushCapabilityQueryResult = NonNullable<Awaited<ReturnType<typeof getTikTokShopProductPushCapability>>>
export type GetTikTokShopProductPushCapabilityQueryError = ErrorType<unknown>


/**
 * @summary Probe whether the connected shop can create/manage products
 */

export function useGetTikTokShopProductPushCapability<TData = Awaited<ReturnType<typeof getTikTokShopProductPushCapability>>, TError = ErrorType<unknown>>(
 params?: GetTikTokShopProductPushCapabilityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopProductPushCapability>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTikTokShopProductPushCapabilityQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPushTikTokShopProductUrl = () => {




  return `/api/tiktok_shop/products/push`
}

/**
 * @summary Push a single inventory item to TikTok Shop as a product listing
 */
export const pushTikTokShopProduct = async (tikTokShopProductPushRequest: TikTokShopProductPushRequest, options?: RequestInit): Promise<TikTokShopProductPushOutcome> => {

  return customFetch<TikTokShopProductPushOutcome>(getPushTikTokShopProductUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tikTokShopProductPushRequest)
  }
);}





export const getPushTikTokShopProductMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushTikTokShopProduct>>, TError,{data: BodyType<TikTokShopProductPushRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pushTikTokShopProduct>>, TError,{data: BodyType<TikTokShopProductPushRequest>}, TContext> => {

const mutationKey = ['pushTikTokShopProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pushTikTokShopProduct>>, {data: BodyType<TikTokShopProductPushRequest>}> = (props) => {
          const {data} = props ?? {};

          return  pushTikTokShopProduct(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PushTikTokShopProductMutationResult = NonNullable<Awaited<ReturnType<typeof pushTikTokShopProduct>>>
    export type PushTikTokShopProductMutationBody = BodyType<TikTokShopProductPushRequest>
    export type PushTikTokShopProductMutationError = ErrorType<unknown>

    /**
 * @summary Push a single inventory item to TikTok Shop as a product listing
 */
export const usePushTikTokShopProduct = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushTikTokShopProduct>>, TError,{data: BodyType<TikTokShopProductPushRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof pushTikTokShopProduct>>,
        TError,
        {data: BodyType<TikTokShopProductPushRequest>},
        TContext
      > => {
      return useMutation(getPushTikTokShopProductMutationOptions(options));
    }

export const getSyncTikTokShopListingUrl = () => {




  return `/api/tiktok_shop/products/sync`
}

/**
 * @summary Full sync for one inventory item — pushes product content (title, description, images, price) to the standard listing, pushes description/images/price to linked auction listings via partial edit (preserving their manual auction setup), then fans out the current stock level to ALL active linked listings (standard + auction).
 */
export const syncTikTokShopListing = async (tikTokShopListingSyncRequest: TikTokShopListingSyncRequest, options?: RequestInit): Promise<TikTokShopListingSyncResult> => {

  return customFetch<TikTokShopListingSyncResult>(getSyncTikTokShopListingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tikTokShopListingSyncRequest)
  }
);}





export const getSyncTikTokShopListingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncTikTokShopListing>>, TError,{data: BodyType<TikTokShopListingSyncRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncTikTokShopListing>>, TError,{data: BodyType<TikTokShopListingSyncRequest>}, TContext> => {

const mutationKey = ['syncTikTokShopListing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncTikTokShopListing>>, {data: BodyType<TikTokShopListingSyncRequest>}> = (props) => {
          const {data} = props ?? {};

          return  syncTikTokShopListing(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncTikTokShopListingMutationResult = NonNullable<Awaited<ReturnType<typeof syncTikTokShopListing>>>
    export type SyncTikTokShopListingMutationBody = BodyType<TikTokShopListingSyncRequest>
    export type SyncTikTokShopListingMutationError = ErrorType<unknown>

    /**
 * @summary Full sync for one inventory item — pushes product content (title, description, images, price) to the standard listing, pushes description/images/price to linked auction listings via partial edit (preserving their manual auction setup), then fans out the current stock level to ALL active linked listings (standard + auction).
 */
export const useSyncTikTokShopListing = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncTikTokShopListing>>, TError,{data: BodyType<TikTokShopListingSyncRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncTikTokShopListing>>,
        TError,
        {data: BodyType<TikTokShopListingSyncRequest>},
        TContext
      > => {
      return useMutation(getSyncTikTokShopListingMutationOptions(options));
    }

export const getPushTikTokShopProductsBulkUrl = () => {




  return `/api/tiktok_shop/products/push-bulk`
}

/**
 * @summary Push many inventory items to TikTok Shop as product listings
 */
export const pushTikTokShopProductsBulk = async (tikTokShopProductPushBulkRequest: TikTokShopProductPushBulkRequest, options?: RequestInit): Promise<TikTokShopProductPushBulkResult | BackgroundJobAccepted> => {

  return customFetch<TikTokShopProductPushBulkResult | BackgroundJobAccepted>(getPushTikTokShopProductsBulkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tikTokShopProductPushBulkRequest)
  }
);}





export const getPushTikTokShopProductsBulkMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushTikTokShopProductsBulk>>, TError,{data: BodyType<TikTokShopProductPushBulkRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pushTikTokShopProductsBulk>>, TError,{data: BodyType<TikTokShopProductPushBulkRequest>}, TContext> => {

const mutationKey = ['pushTikTokShopProductsBulk'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pushTikTokShopProductsBulk>>, {data: BodyType<TikTokShopProductPushBulkRequest>}> = (props) => {
          const {data} = props ?? {};

          return  pushTikTokShopProductsBulk(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PushTikTokShopProductsBulkMutationResult = NonNullable<Awaited<ReturnType<typeof pushTikTokShopProductsBulk>>>
    export type PushTikTokShopProductsBulkMutationBody = BodyType<TikTokShopProductPushBulkRequest>
    export type PushTikTokShopProductsBulkMutationError = ErrorType<unknown>

    /**
 * @summary Push many inventory items to TikTok Shop as product listings
 */
export const usePushTikTokShopProductsBulk = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushTikTokShopProductsBulk>>, TError,{data: BodyType<TikTokShopProductPushBulkRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof pushTikTokShopProductsBulk>>,
        TError,
        {data: BodyType<TikTokShopProductPushBulkRequest>},
        TContext
      > => {
      return useMutation(getPushTikTokShopProductsBulkMutationOptions(options));
    }

export const getGetTikTokShopDuplicateListingsUrl = (params: GetTikTokShopDuplicateListingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tiktok_shop/products/duplicates?${stringifiedParams}` : `/api/tiktok_shop/products/duplicates`
}

/**
 * @summary List live TikTok listings sharing an inventory item's seller SKU (duplicate resolution)
 */
export const getTikTokShopDuplicateListings = async (params: GetTikTokShopDuplicateListingsParams, options?: RequestInit): Promise<TikTokShopDuplicateListingsResponse> => {

  return customFetch<TikTokShopDuplicateListingsResponse>(getGetTikTokShopDuplicateListingsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTikTokShopDuplicateListingsQueryKey = (params?: GetTikTokShopDuplicateListingsParams,) => {
    return [
    `/api/tiktok_shop/products/duplicates`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTikTokShopDuplicateListingsQueryOptions = <TData = Awaited<ReturnType<typeof getTikTokShopDuplicateListings>>, TError = ErrorType<unknown>>(params: GetTikTokShopDuplicateListingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopDuplicateListings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTikTokShopDuplicateListingsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTikTokShopDuplicateListings>>> = ({ signal }) => getTikTokShopDuplicateListings(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopDuplicateListings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTikTokShopDuplicateListingsQueryResult = NonNullable<Awaited<ReturnType<typeof getTikTokShopDuplicateListings>>>
export type GetTikTokShopDuplicateListingsQueryError = ErrorType<unknown>


/**
 * @summary List live TikTok listings sharing an inventory item's seller SKU (duplicate resolution)
 */

export function useGetTikTokShopDuplicateListings<TData = Awaited<ReturnType<typeof getTikTokShopDuplicateListings>>, TError = ErrorType<unknown>>(
 params: GetTikTokShopDuplicateListingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopDuplicateListings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTikTokShopDuplicateListingsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getResolveTikTokShopDuplicateListingsUrl = () => {




  return `/api/tiktok_shop/products/resolve-duplicates`
}

/**
 * @summary Keep one live TikTok listing for a SKU, deactivate the rest, and save the mapping
 */
export const resolveTikTokShopDuplicateListings = async (tikTokShopResolveDuplicatesRequest: TikTokShopResolveDuplicatesRequest, options?: RequestInit): Promise<TikTokShopResolveDuplicatesResult> => {

  return customFetch<TikTokShopResolveDuplicatesResult>(getResolveTikTokShopDuplicateListingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tikTokShopResolveDuplicatesRequest)
  }
);}





export const getResolveTikTokShopDuplicateListingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveTikTokShopDuplicateListings>>, TError,{data: BodyType<TikTokShopResolveDuplicatesRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resolveTikTokShopDuplicateListings>>, TError,{data: BodyType<TikTokShopResolveDuplicatesRequest>}, TContext> => {

const mutationKey = ['resolveTikTokShopDuplicateListings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resolveTikTokShopDuplicateListings>>, {data: BodyType<TikTokShopResolveDuplicatesRequest>}> = (props) => {
          const {data} = props ?? {};

          return  resolveTikTokShopDuplicateListings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResolveTikTokShopDuplicateListingsMutationResult = NonNullable<Awaited<ReturnType<typeof resolveTikTokShopDuplicateListings>>>
    export type ResolveTikTokShopDuplicateListingsMutationBody = BodyType<TikTokShopResolveDuplicatesRequest>
    export type ResolveTikTokShopDuplicateListingsMutationError = ErrorType<unknown>

    /**
 * @summary Keep one live TikTok listing for a SKU, deactivate the rest, and save the mapping
 */
export const useResolveTikTokShopDuplicateListings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveTikTokShopDuplicateListings>>, TError,{data: BodyType<TikTokShopResolveDuplicatesRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resolveTikTokShopDuplicateListings>>,
        TError,
        {data: BodyType<TikTokShopResolveDuplicatesRequest>},
        TContext
      > => {
      return useMutation(getResolveTikTokShopDuplicateListingsMutationOptions(options));
    }

export const getGetTikTokShopInventoryPushStatusUrl = (params?: GetTikTokShopInventoryPushStatusParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tiktok_shop/products/inventory-push-status?${stringifiedParams}` : `/api/tiktok_shop/products/inventory-push-status`
}

/**
 * @summary List all inventory items in the TikTok Shop channel with their current push/review status
 */
export const getTikTokShopInventoryPushStatus = async (params?: GetTikTokShopInventoryPushStatusParams, options?: RequestInit): Promise<TikTokInventoryPushStatusList> => {

  return customFetch<TikTokInventoryPushStatusList>(getGetTikTokShopInventoryPushStatusUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTikTokShopInventoryPushStatusQueryKey = (params?: GetTikTokShopInventoryPushStatusParams,) => {
    return [
    `/api/tiktok_shop/products/inventory-push-status`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTikTokShopInventoryPushStatusQueryOptions = <TData = Awaited<ReturnType<typeof getTikTokShopInventoryPushStatus>>, TError = ErrorType<unknown>>(params?: GetTikTokShopInventoryPushStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopInventoryPushStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTikTokShopInventoryPushStatusQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTikTokShopInventoryPushStatus>>> = ({ signal }) => getTikTokShopInventoryPushStatus(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopInventoryPushStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTikTokShopInventoryPushStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getTikTokShopInventoryPushStatus>>>
export type GetTikTokShopInventoryPushStatusQueryError = ErrorType<unknown>


/**
 * @summary List all inventory items in the TikTok Shop channel with their current push/review status
 */

export function useGetTikTokShopInventoryPushStatus<TData = Awaited<ReturnType<typeof getTikTokShopInventoryPushStatus>>, TError = ErrorType<unknown>>(
 params?: GetTikTokShopInventoryPushStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopInventoryPushStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTikTokShopInventoryPushStatusQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDeactivateTikTokShopProductsUrl = () => {




  return `/api/tiktok_shop/products/deactivate`
}

/**
 * @summary Deactivate TikTok Shop product listings
 */
export const deactivateTikTokShopProducts = async (tikTokShopProductDeactivateRequest: TikTokShopProductDeactivateRequest, options?: RequestInit): Promise<DeactivateTikTokShopProducts200> => {

  return customFetch<DeactivateTikTokShopProducts200>(getDeactivateTikTokShopProductsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tikTokShopProductDeactivateRequest)
  }
);}





export const getDeactivateTikTokShopProductsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateTikTokShopProducts>>, TError,{data: BodyType<TikTokShopProductDeactivateRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deactivateTikTokShopProducts>>, TError,{data: BodyType<TikTokShopProductDeactivateRequest>}, TContext> => {

const mutationKey = ['deactivateTikTokShopProducts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivateTikTokShopProducts>>, {data: BodyType<TikTokShopProductDeactivateRequest>}> = (props) => {
          const {data} = props ?? {};

          return  deactivateTikTokShopProducts(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeactivateTikTokShopProductsMutationResult = NonNullable<Awaited<ReturnType<typeof deactivateTikTokShopProducts>>>
    export type DeactivateTikTokShopProductsMutationBody = BodyType<TikTokShopProductDeactivateRequest>
    export type DeactivateTikTokShopProductsMutationError = ErrorType<unknown>

    /**
 * @summary Deactivate TikTok Shop product listings
 */
export const useDeactivateTikTokShopProducts = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateTikTokShopProducts>>, TError,{data: BodyType<TikTokShopProductDeactivateRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deactivateTikTokShopProducts>>,
        TError,
        {data: BodyType<TikTokShopProductDeactivateRequest>},
        TContext
      > => {
      return useMutation(getDeactivateTikTokShopProductsMutationOptions(options));
    }

export const getListTikTokShopImportedProductsUrl = (params?: ListTikTokShopImportedProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tiktok_shop/products/imported?${stringifiedParams}` : `/api/tiktok_shop/products/imported`
}

/**
 * @summary List TikTok Shop products imported into the per-tenant catalogue
 */
export const listTikTokShopImportedProducts = async (params?: ListTikTokShopImportedProductsParams, options?: RequestInit): Promise<TikTokShopImportedProductList> => {

  return customFetch<TikTokShopImportedProductList>(getListTikTokShopImportedProductsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTikTokShopImportedProductsQueryKey = (params?: ListTikTokShopImportedProductsParams,) => {
    return [
    `/api/tiktok_shop/products/imported`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTikTokShopImportedProductsQueryOptions = <TData = Awaited<ReturnType<typeof listTikTokShopImportedProducts>>, TError = ErrorType<unknown>>(params?: ListTikTokShopImportedProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTikTokShopImportedProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTikTokShopImportedProductsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTikTokShopImportedProducts>>> = ({ signal }) => listTikTokShopImportedProducts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTikTokShopImportedProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTikTokShopImportedProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listTikTokShopImportedProducts>>>
export type ListTikTokShopImportedProductsQueryError = ErrorType<unknown>


/**
 * @summary List TikTok Shop products imported into the per-tenant catalogue
 */

export function useListTikTokShopImportedProducts<TData = Awaited<ReturnType<typeof listTikTokShopImportedProducts>>, TError = ErrorType<unknown>>(
 params?: ListTikTokShopImportedProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTikTokShopImportedProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTikTokShopImportedProductsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getImportTikTokShopProductsUrl = () => {




  return `/api/tiktok_shop/products/import`
}

/**
 * @summary Import (mirror) the connected shop's product catalogue now
 */
export const importTikTokShopProducts = async (importTikTokShopProductsBody?: ImportTikTokShopProductsBody, options?: RequestInit): Promise<TikTokShopProductImportResult> => {

  return customFetch<TikTokShopProductImportResult>(getImportTikTokShopProductsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(importTikTokShopProductsBody)
  }
);}





export const getImportTikTokShopProductsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importTikTokShopProducts>>, TError,{data?: BodyType<ImportTikTokShopProductsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importTikTokShopProducts>>, TError,{data?: BodyType<ImportTikTokShopProductsBody>}, TContext> => {

const mutationKey = ['importTikTokShopProducts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importTikTokShopProducts>>, {data?: BodyType<ImportTikTokShopProductsBody>}> = (props) => {
          const {data} = props ?? {};

          return  importTikTokShopProducts(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportTikTokShopProductsMutationResult = NonNullable<Awaited<ReturnType<typeof importTikTokShopProducts>>>
    export type ImportTikTokShopProductsMutationBody = BodyType<ImportTikTokShopProductsBody> | undefined
    export type ImportTikTokShopProductsMutationError = ErrorType<unknown>

    /**
 * @summary Import (mirror) the connected shop's product catalogue now
 */
export const useImportTikTokShopProducts = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importTikTokShopProducts>>, TError,{data?: BodyType<ImportTikTokShopProductsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importTikTokShopProducts>>,
        TError,
        {data?: BodyType<ImportTikTokShopProductsBody>},
        TContext
      > => {
      return useMutation(getImportTikTokShopProductsMutationOptions(options));
    }

export const getGetTikTokShopImportedProductUrl = (id: string,) => {




  return `/api/tiktok_shop/products/imported/${id}`
}

/**
 * @summary Get one imported TikTok Shop product with variants, images & mappings
 */
export const getTikTokShopImportedProduct = async (id: string, options?: RequestInit): Promise<TikTokShopImportedProductDetail> => {

  return customFetch<TikTokShopImportedProductDetail>(getGetTikTokShopImportedProductUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTikTokShopImportedProductQueryKey = (id: string,) => {
    return [
    `/api/tiktok_shop/products/imported/${id}`
    ] as const;
    }


export const getGetTikTokShopImportedProductQueryOptions = <TData = Awaited<ReturnType<typeof getTikTokShopImportedProduct>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopImportedProduct>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTikTokShopImportedProductQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTikTokShopImportedProduct>>> = ({ signal }) => getTikTokShopImportedProduct(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopImportedProduct>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTikTokShopImportedProductQueryResult = NonNullable<Awaited<ReturnType<typeof getTikTokShopImportedProduct>>>
export type GetTikTokShopImportedProductQueryError = ErrorType<unknown>


/**
 * @summary Get one imported TikTok Shop product with variants, images & mappings
 */

export function useGetTikTokShopImportedProduct<TData = Awaited<ReturnType<typeof getTikTokShopImportedProduct>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopImportedProduct>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTikTokShopImportedProductQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPullTikTokShopProductImagesUrl = (id: string,) => {




  return `/api/tiktok_shop/products/imported/${id}/image-pull`
}

/**
 * @summary Copy an imported product's images into the mapped item's Gallery
 */
export const pullTikTokShopProductImages = async (id: string, options?: RequestInit): Promise<TikTokShopImageSyncResult> => {

  return customFetch<TikTokShopImageSyncResult>(getPullTikTokShopProductImagesUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPullTikTokShopProductImagesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pullTikTokShopProductImages>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pullTikTokShopProductImages>>, TError,{id: string}, TContext> => {

const mutationKey = ['pullTikTokShopProductImages'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pullTikTokShopProductImages>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  pullTikTokShopProductImages(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PullTikTokShopProductImagesMutationResult = NonNullable<Awaited<ReturnType<typeof pullTikTokShopProductImages>>>

    export type PullTikTokShopProductImagesMutationError = ErrorType<unknown>

    /**
 * @summary Copy an imported product's images into the mapped item's Gallery
 */
export const usePullTikTokShopProductImages = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pullTikTokShopProductImages>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof pullTikTokShopProductImages>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getPullTikTokShopProductImagesMutationOptions(options));
    }

export const getSyncTikTokProductToInventoryUrl = (id: string,) => {




  return `/api/tiktok_shop/products/imported/${id}/sync-to-inventory`
}

/**
 * @summary Re-sync a TikTok product's data into the linked inventory item. By default only fills in blank fields (title, brand, description, category, price, weight, dimensions, images, attributes). Pass force=true to overwrite existing non-blank values; old values are recorded in the audit log.
 */
export const syncTikTokProductToInventory = async (id: string,
    syncTikTokProductToInventoryBody?: SyncTikTokProductToInventoryBody, options?: RequestInit): Promise<SyncTikTokProductToInventory200> => {

  return customFetch<SyncTikTokProductToInventory200>(getSyncTikTokProductToInventoryUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(syncTikTokProductToInventoryBody)
  }
);}





export const getSyncTikTokProductToInventoryMutationOptions = <TError = ErrorType<SyncTikTokProductToInventory400 | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncTikTokProductToInventory>>, TError,{id: string;data?: BodyType<SyncTikTokProductToInventoryBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncTikTokProductToInventory>>, TError,{id: string;data?: BodyType<SyncTikTokProductToInventoryBody>}, TContext> => {

const mutationKey = ['syncTikTokProductToInventory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncTikTokProductToInventory>>, {id: string;data?: BodyType<SyncTikTokProductToInventoryBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  syncTikTokProductToInventory(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncTikTokProductToInventoryMutationResult = NonNullable<Awaited<ReturnType<typeof syncTikTokProductToInventory>>>
    export type SyncTikTokProductToInventoryMutationBody = BodyType<SyncTikTokProductToInventoryBody> | undefined
    export type SyncTikTokProductToInventoryMutationError = ErrorType<SyncTikTokProductToInventory400 | void>

    /**
 * @summary Re-sync a TikTok product's data into the linked inventory item. By default only fills in blank fields (title, brand, description, category, price, weight, dimensions, images, attributes). Pass force=true to overwrite existing non-blank values; old values are recorded in the audit log.
 */
export const useSyncTikTokProductToInventory = <TError = ErrorType<SyncTikTokProductToInventory400 | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncTikTokProductToInventory>>, TError,{id: string;data?: BodyType<SyncTikTokProductToInventoryBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncTikTokProductToInventory>>,
        TError,
        {id: string;data?: BodyType<SyncTikTokProductToInventoryBody>},
        TContext
      > => {
      return useMutation(getSyncTikTokProductToInventoryMutationOptions(options));
    }

export const getAutoLinkTikTokProductsBySkuUrl = () => {




  return `/api/tiktok_shop/products/auto-link-by-sku`
}

/**
 * @summary Re-run SKU matching for all imported TikTok product variants — links any variant whose Seller SKU exactly matches an inventory item SKU. Safe to run repeatedly; already-linked variants are skipped.
 */
export const autoLinkTikTokProductsBySku = async ( options?: RequestInit): Promise<AutoLinkTikTokProductsBySku200> => {

  return customFetch<AutoLinkTikTokProductsBySku200>(getAutoLinkTikTokProductsBySkuUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAutoLinkTikTokProductsBySkuMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof autoLinkTikTokProductsBySku>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof autoLinkTikTokProductsBySku>>, TError,void, TContext> => {

const mutationKey = ['autoLinkTikTokProductsBySku'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof autoLinkTikTokProductsBySku>>, void> = () => {


          return  autoLinkTikTokProductsBySku(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AutoLinkTikTokProductsBySkuMutationResult = NonNullable<Awaited<ReturnType<typeof autoLinkTikTokProductsBySku>>>

    export type AutoLinkTikTokProductsBySkuMutationError = ErrorType<unknown>

    /**
 * @summary Re-run SKU matching for all imported TikTok product variants — links any variant whose Seller SKU exactly matches an inventory item SKU. Safe to run repeatedly; already-linked variants are skipped.
 */
export const useAutoLinkTikTokProductsBySku = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof autoLinkTikTokProductsBySku>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof autoLinkTikTokProductsBySku>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAutoLinkTikTokProductsBySkuMutationOptions(options));
    }

export const getPullTikTokProductToInventoryUrl = (itemId: string,) => {




  return `/api/tiktok_shop/inventory/${itemId}/pull`
}

/**
 * @summary Pull product data from TikTok and sync it to the linked inventory item. Reads the item's active TikTok product mapping, fetches the full product detail, and writes description, brand, asking price, package dimensions, metal type, and region of origin back to the inventory item.
 */
export const pullTikTokProductToInventory = async (itemId: string, options?: RequestInit): Promise<PullTikTokProductToInventory200> => {

  return customFetch<PullTikTokProductToInventory200>(getPullTikTokProductToInventoryUrl(itemId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPullTikTokProductToInventoryMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pullTikTokProductToInventory>>, TError,{itemId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pullTikTokProductToInventory>>, TError,{itemId: string}, TContext> => {

const mutationKey = ['pullTikTokProductToInventory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pullTikTokProductToInventory>>, {itemId: string}> = (props) => {
          const {itemId} = props ?? {};

          return  pullTikTokProductToInventory(itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PullTikTokProductToInventoryMutationResult = NonNullable<Awaited<ReturnType<typeof pullTikTokProductToInventory>>>

    export type PullTikTokProductToInventoryMutationError = ErrorType<void>

    /**
 * @summary Pull product data from TikTok and sync it to the linked inventory item. Reads the item's active TikTok product mapping, fetches the full product detail, and writes description, brand, asking price, package dimensions, metal type, and region of origin back to the inventory item.
 */
export const usePullTikTokProductToInventory = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pullTikTokProductToInventory>>, TError,{itemId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof pullTikTokProductToInventory>>,
        TError,
        {itemId: string},
        TContext
      > => {
      return useMutation(getPullTikTokProductToInventoryMutationOptions(options));
    }

export const getSyncAllLinkedInventoryFromTikTokUrl = () => {




  return `/api/tiktok_shop/inventory/sync-all-linked`
}

/**
 * @summary Bulk gap-fill: schedule a TikTok → inventory backfill for up to 200 active linked mappings per call. offset allows pagination across all linked items. Runs fire-and-forget in gap-fill mode (force=false — existing fields are never overwritten). Requires tiktok_shop.products.push permission.
 */
export const syncAllLinkedInventoryFromTikTok = async (syncAllLinkedInventoryFromTikTokBody?: SyncAllLinkedInventoryFromTikTokBody, options?: RequestInit): Promise<SyncAllLinkedInventoryFromTikTok200> => {

  return customFetch<SyncAllLinkedInventoryFromTikTok200>(getSyncAllLinkedInventoryFromTikTokUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(syncAllLinkedInventoryFromTikTokBody)
  }
);}





export const getSyncAllLinkedInventoryFromTikTokMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncAllLinkedInventoryFromTikTok>>, TError,{data?: BodyType<SyncAllLinkedInventoryFromTikTokBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncAllLinkedInventoryFromTikTok>>, TError,{data?: BodyType<SyncAllLinkedInventoryFromTikTokBody>}, TContext> => {

const mutationKey = ['syncAllLinkedInventoryFromTikTok'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncAllLinkedInventoryFromTikTok>>, {data?: BodyType<SyncAllLinkedInventoryFromTikTokBody>}> = (props) => {
          const {data} = props ?? {};

          return  syncAllLinkedInventoryFromTikTok(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncAllLinkedInventoryFromTikTokMutationResult = NonNullable<Awaited<ReturnType<typeof syncAllLinkedInventoryFromTikTok>>>
    export type SyncAllLinkedInventoryFromTikTokMutationBody = BodyType<SyncAllLinkedInventoryFromTikTokBody> | undefined
    export type SyncAllLinkedInventoryFromTikTokMutationError = ErrorType<unknown>

    /**
 * @summary Bulk gap-fill: schedule a TikTok → inventory backfill for up to 200 active linked mappings per call. offset allows pagination across all linked items. Runs fire-and-forget in gap-fill mode (force=false — existing fields are never overwritten). Requires tiktok_shop.products.push permission.
 */
export const useSyncAllLinkedInventoryFromTikTok = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncAllLinkedInventoryFromTikTok>>, TError,{data?: BodyType<SyncAllLinkedInventoryFromTikTokBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncAllLinkedInventoryFromTikTok>>,
        TError,
        {data?: BodyType<SyncAllLinkedInventoryFromTikTokBody>},
        TContext
      > => {
      return useMutation(getSyncAllLinkedInventoryFromTikTokMutationOptions(options));
    }

export const getListTikTokShopMessagesUrl = (params?: ListTikTokShopMessagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tiktok_shop/messages?${stringifiedParams}` : `/api/tiktok_shop/messages`
}

/**
 * @summary List imported TikTok Shop messages for an order, customer, or conversation
 */
export const listTikTokShopMessages = async (params?: ListTikTokShopMessagesParams, options?: RequestInit): Promise<TikTokShopMessageList> => {

  return customFetch<TikTokShopMessageList>(getListTikTokShopMessagesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTikTokShopMessagesQueryKey = (params?: ListTikTokShopMessagesParams,) => {
    return [
    `/api/tiktok_shop/messages`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTikTokShopMessagesQueryOptions = <TData = Awaited<ReturnType<typeof listTikTokShopMessages>>, TError = ErrorType<unknown>>(params?: ListTikTokShopMessagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTikTokShopMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTikTokShopMessagesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTikTokShopMessages>>> = ({ signal }) => listTikTokShopMessages(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTikTokShopMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTikTokShopMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof listTikTokShopMessages>>>
export type ListTikTokShopMessagesQueryError = ErrorType<unknown>


/**
 * @summary List imported TikTok Shop messages for an order, customer, or conversation
 */

export function useListTikTokShopMessages<TData = Awaited<ReturnType<typeof listTikTokShopMessages>>, TError = ErrorType<unknown>>(
 params?: ListTikTokShopMessagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTikTokShopMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTikTokShopMessagesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetTikTokShopMessageCapabilityUrl = (params?: GetTikTokShopMessageCapabilityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tiktok_shop/messages/capability?${stringifiedParams}` : `/api/tiktok_shop/messages/capability`
}

/**
 * @summary Probe whether the connected shop can read/reply to customer messages
 */
export const getTikTokShopMessageCapability = async (params?: GetTikTokShopMessageCapabilityParams, options?: RequestInit): Promise<TikTokShopMessageCapability> => {

  return customFetch<TikTokShopMessageCapability>(getGetTikTokShopMessageCapabilityUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTikTokShopMessageCapabilityQueryKey = (params?: GetTikTokShopMessageCapabilityParams,) => {
    return [
    `/api/tiktok_shop/messages/capability`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTikTokShopMessageCapabilityQueryOptions = <TData = Awaited<ReturnType<typeof getTikTokShopMessageCapability>>, TError = ErrorType<unknown>>(params?: GetTikTokShopMessageCapabilityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopMessageCapability>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTikTokShopMessageCapabilityQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTikTokShopMessageCapability>>> = ({ signal }) => getTikTokShopMessageCapability(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopMessageCapability>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTikTokShopMessageCapabilityQueryResult = NonNullable<Awaited<ReturnType<typeof getTikTokShopMessageCapability>>>
export type GetTikTokShopMessageCapabilityQueryError = ErrorType<unknown>


/**
 * @summary Probe whether the connected shop can read/reply to customer messages
 */

export function useGetTikTokShopMessageCapability<TData = Awaited<ReturnType<typeof getTikTokShopMessageCapability>>, TError = ErrorType<unknown>>(
 params?: GetTikTokShopMessageCapabilityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTikTokShopMessageCapability>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTikTokShopMessageCapabilityQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSyncTikTokShopMessagesUrl = () => {




  return `/api/tiktok_shop/messages/sync`
}

/**
 * @summary Manually import recent TikTok Shop messages now
 */
export const syncTikTokShopMessages = async ( options?: RequestInit): Promise<TikTokShopMessageSyncResult> => {

  return customFetch<TikTokShopMessageSyncResult>(getSyncTikTokShopMessagesUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSyncTikTokShopMessagesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncTikTokShopMessages>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncTikTokShopMessages>>, TError,void, TContext> => {

const mutationKey = ['syncTikTokShopMessages'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncTikTokShopMessages>>, void> = () => {


          return  syncTikTokShopMessages(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncTikTokShopMessagesMutationResult = NonNullable<Awaited<ReturnType<typeof syncTikTokShopMessages>>>

    export type SyncTikTokShopMessagesMutationError = ErrorType<unknown>

    /**
 * @summary Manually import recent TikTok Shop messages now
 */
export const useSyncTikTokShopMessages = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncTikTokShopMessages>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncTikTokShopMessages>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSyncTikTokShopMessagesMutationOptions(options));
    }

export const getReplyTikTokShopMessageUrl = () => {




  return `/api/tiktok_shop/messages/reply`
}

/**
 * @summary Reply to a TikTok Shop conversation (where the API permits)
 */
export const replyTikTokShopMessage = async (tikTokShopMessageReplyRequest: TikTokShopMessageReplyRequest, options?: RequestInit): Promise<TikTokShopMessageReplyResult> => {

  return customFetch<TikTokShopMessageReplyResult>(getReplyTikTokShopMessageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tikTokShopMessageReplyRequest)
  }
);}





export const getReplyTikTokShopMessageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replyTikTokShopMessage>>, TError,{data: BodyType<TikTokShopMessageReplyRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof replyTikTokShopMessage>>, TError,{data: BodyType<TikTokShopMessageReplyRequest>}, TContext> => {

const mutationKey = ['replyTikTokShopMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replyTikTokShopMessage>>, {data: BodyType<TikTokShopMessageReplyRequest>}> = (props) => {
          const {data} = props ?? {};

          return  replyTikTokShopMessage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplyTikTokShopMessageMutationResult = NonNullable<Awaited<ReturnType<typeof replyTikTokShopMessage>>>
    export type ReplyTikTokShopMessageMutationBody = BodyType<TikTokShopMessageReplyRequest>
    export type ReplyTikTokShopMessageMutationError = ErrorType<unknown>

    /**
 * @summary Reply to a TikTok Shop conversation (where the API permits)
 */
export const useReplyTikTokShopMessage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replyTikTokShopMessage>>, TError,{data: BodyType<TikTokShopMessageReplyRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof replyTikTokShopMessage>>,
        TError,
        {data: BodyType<TikTokShopMessageReplyRequest>},
        TContext
      > => {
      return useMutation(getReplyTikTokShopMessageMutationOptions(options));
    }

export const getMarkTikTokShopMessagesReadUrl = () => {




  return `/api/tiktok_shop/messages/mark-read`
}

/**
 * @summary Mark a TikTok Shop conversation's inbound messages as read
 */
export const markTikTokShopMessagesRead = async (tikTokShopMessageMarkReadRequest: TikTokShopMessageMarkReadRequest, options?: RequestInit): Promise<MarkTikTokShopMessagesRead200> => {

  return customFetch<MarkTikTokShopMessagesRead200>(getMarkTikTokShopMessagesReadUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tikTokShopMessageMarkReadRequest)
  }
);}





export const getMarkTikTokShopMessagesReadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markTikTokShopMessagesRead>>, TError,{data: BodyType<TikTokShopMessageMarkReadRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markTikTokShopMessagesRead>>, TError,{data: BodyType<TikTokShopMessageMarkReadRequest>}, TContext> => {

const mutationKey = ['markTikTokShopMessagesRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markTikTokShopMessagesRead>>, {data: BodyType<TikTokShopMessageMarkReadRequest>}> = (props) => {
          const {data} = props ?? {};

          return  markTikTokShopMessagesRead(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkTikTokShopMessagesReadMutationResult = NonNullable<Awaited<ReturnType<typeof markTikTokShopMessagesRead>>>
    export type MarkTikTokShopMessagesReadMutationBody = BodyType<TikTokShopMessageMarkReadRequest>
    export type MarkTikTokShopMessagesReadMutationError = ErrorType<unknown>

    /**
 * @summary Mark a TikTok Shop conversation's inbound messages as read
 */
export const useMarkTikTokShopMessagesRead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markTikTokShopMessagesRead>>, TError,{data: BodyType<TikTokShopMessageMarkReadRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markTikTokShopMessagesRead>>,
        TError,
        {data: BodyType<TikTokShopMessageMarkReadRequest>},
        TContext
      > => {
      return useMutation(getMarkTikTokShopMessagesReadMutationOptions(options));
    }

export const getImportTikTokShippingLabelsUrl = () => {




  return `/api/tiktok_shop/import-labels`
}

/**
 * @summary Import TikTok shipping-label PDF (and optional To Ship CSV) to enrich customer real names / addresses and return matched sale order IDs for packing-screen batch filtering.

 */
export const importTikTokShippingLabels = async (importTikTokShippingLabelsBody: ImportTikTokShippingLabelsBody, options?: RequestInit): Promise<TikTokLabelImportResult> => {
    const formData = new FormData();
formData.append(`pdf`, importTikTokShippingLabelsBody.pdf);
if(importTikTokShippingLabelsBody.csv !== undefined) {
 formData.append(`csv`, importTikTokShippingLabelsBody.csv);
 }

  return customFetch<TikTokLabelImportResult>(getImportTikTokShippingLabelsUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getImportTikTokShippingLabelsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importTikTokShippingLabels>>, TError,{data: BodyType<ImportTikTokShippingLabelsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importTikTokShippingLabels>>, TError,{data: BodyType<ImportTikTokShippingLabelsBody>}, TContext> => {

const mutationKey = ['importTikTokShippingLabels'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importTikTokShippingLabels>>, {data: BodyType<ImportTikTokShippingLabelsBody>}> = (props) => {
          const {data} = props ?? {};

          return  importTikTokShippingLabels(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportTikTokShippingLabelsMutationResult = NonNullable<Awaited<ReturnType<typeof importTikTokShippingLabels>>>
    export type ImportTikTokShippingLabelsMutationBody = BodyType<ImportTikTokShippingLabelsBody>
    export type ImportTikTokShippingLabelsMutationError = ErrorType<unknown>

    /**
 * @summary Import TikTok shipping-label PDF (and optional To Ship CSV) to enrich customer real names / addresses and return matched sale order IDs for packing-screen batch filtering.

 */
export const useImportTikTokShippingLabels = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importTikTokShippingLabels>>, TError,{data: BodyType<ImportTikTokShippingLabelsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importTikTokShippingLabels>>,
        TError,
        {data: BodyType<ImportTikTokShippingLabelsBody>},
        TContext
      > => {
      return useMutation(getImportTikTokShippingLabelsMutationOptions(options));
    }

export const getListDemandForecastsUrl = (params?: ListDemandForecastsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/forecasting/forecasts?${stringifiedParams}` : `/api/forecasting/forecasts`
}

/**
 * @summary List per-SKU demand forecasts (filter + sort)
 */
export const listDemandForecasts = async (params?: ListDemandForecastsParams, options?: RequestInit): Promise<DemandForecastList> => {

  return customFetch<DemandForecastList>(getListDemandForecastsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDemandForecastsQueryKey = (params?: ListDemandForecastsParams,) => {
    return [
    `/api/forecasting/forecasts`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDemandForecastsQueryOptions = <TData = Awaited<ReturnType<typeof listDemandForecasts>>, TError = ErrorType<unknown>>(params?: ListDemandForecastsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDemandForecasts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDemandForecastsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDemandForecasts>>> = ({ signal }) => listDemandForecasts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDemandForecasts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDemandForecastsQueryResult = NonNullable<Awaited<ReturnType<typeof listDemandForecasts>>>
export type ListDemandForecastsQueryError = ErrorType<unknown>


/**
 * @summary List per-SKU demand forecasts (filter + sort)
 */

export function useListDemandForecasts<TData = Awaited<ReturnType<typeof listDemandForecasts>>, TError = ErrorType<unknown>>(
 params?: ListDemandForecastsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDemandForecasts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDemandForecastsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetForecastingSummaryUrl = () => {




  return `/api/forecasting/summary`
}

/**
 * @summary Compact forecasting health snapshot for the page + dashboard widget
 */
export const getForecastingSummary = async ( options?: RequestInit): Promise<ForecastingSummary> => {

  return customFetch<ForecastingSummary>(getGetForecastingSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetForecastingSummaryQueryKey = () => {
    return [
    `/api/forecasting/summary`
    ] as const;
    }


export const getGetForecastingSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getForecastingSummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getForecastingSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetForecastingSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getForecastingSummary>>> = ({ signal }) => getForecastingSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getForecastingSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetForecastingSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getForecastingSummary>>>
export type GetForecastingSummaryQueryError = ErrorType<unknown>


/**
 * @summary Compact forecasting health snapshot for the page + dashboard widget
 */

export function useGetForecastingSummary<TData = Awaited<ReturnType<typeof getForecastingSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getForecastingSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetForecastingSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListReorderRecommendationsUrl = (params?: ListReorderRecommendationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/forecasting/recommendations?${stringifiedParams}` : `/api/forecasting/recommendations`
}

/**
 * @summary List reorder recommendations (filter by status)
 */
export const listReorderRecommendations = async (params?: ListReorderRecommendationsParams, options?: RequestInit): Promise<ListReorderRecommendations200> => {

  return customFetch<ListReorderRecommendations200>(getListReorderRecommendationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListReorderRecommendationsQueryKey = (params?: ListReorderRecommendationsParams,) => {
    return [
    `/api/forecasting/recommendations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListReorderRecommendationsQueryOptions = <TData = Awaited<ReturnType<typeof listReorderRecommendations>>, TError = ErrorType<unknown>>(params?: ListReorderRecommendationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReorderRecommendations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListReorderRecommendationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listReorderRecommendations>>> = ({ signal }) => listReorderRecommendations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listReorderRecommendations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListReorderRecommendationsQueryResult = NonNullable<Awaited<ReturnType<typeof listReorderRecommendations>>>
export type ListReorderRecommendationsQueryError = ErrorType<unknown>


/**
 * @summary List reorder recommendations (filter by status)
 */

export function useListReorderRecommendations<TData = Awaited<ReturnType<typeof listReorderRecommendations>>, TError = ErrorType<unknown>>(
 params?: ListReorderRecommendationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReorderRecommendations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListReorderRecommendationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateReorderRecommendationUrl = (id: string,) => {




  return `/api/forecasting/recommendations/${id}`
}

/**
 * @summary Update a reorder recommendation's status (dismiss / action)
 */
export const updateReorderRecommendation = async (id: string,
    reorderRecommendationStatusUpdate: ReorderRecommendationStatusUpdate, options?: RequestInit): Promise<ReorderRecommendation> => {

  return customFetch<ReorderRecommendation>(getUpdateReorderRecommendationUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reorderRecommendationStatusUpdate)
  }
);}





export const getUpdateReorderRecommendationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReorderRecommendation>>, TError,{id: string;data: BodyType<ReorderRecommendationStatusUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateReorderRecommendation>>, TError,{id: string;data: BodyType<ReorderRecommendationStatusUpdate>}, TContext> => {

const mutationKey = ['updateReorderRecommendation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateReorderRecommendation>>, {id: string;data: BodyType<ReorderRecommendationStatusUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateReorderRecommendation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateReorderRecommendationMutationResult = NonNullable<Awaited<ReturnType<typeof updateReorderRecommendation>>>
    export type UpdateReorderRecommendationMutationBody = BodyType<ReorderRecommendationStatusUpdate>
    export type UpdateReorderRecommendationMutationError = ErrorType<unknown>

    /**
 * @summary Update a reorder recommendation's status (dismiss / action)
 */
export const useUpdateReorderRecommendation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReorderRecommendation>>, TError,{id: string;data: BodyType<ReorderRecommendationStatusUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateReorderRecommendation>>,
        TError,
        {id: string;data: BodyType<ReorderRecommendationStatusUpdate>},
        TContext
      > => {
      return useMutation(getUpdateReorderRecommendationMutationOptions(options));
    }

export const getRunForecastingNowUrl = () => {




  return `/api/forecasting/run`
}

/**
 * @summary Run a forecasting pass now (manual trigger)
 */
export const runForecastingNow = async ( options?: RequestInit): Promise<ForecastingRunResult> => {

  return customFetch<ForecastingRunResult>(getRunForecastingNowUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRunForecastingNowMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runForecastingNow>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof runForecastingNow>>, TError,void, TContext> => {

const mutationKey = ['runForecastingNow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runForecastingNow>>, void> = () => {


          return  runForecastingNow(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunForecastingNowMutationResult = NonNullable<Awaited<ReturnType<typeof runForecastingNow>>>

    export type RunForecastingNowMutationError = ErrorType<unknown>

    /**
 * @summary Run a forecasting pass now (manual trigger)
 */
export const useRunForecastingNow = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runForecastingNow>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof runForecastingNow>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRunForecastingNowMutationOptions(options));
    }

export const getListForecastingRunLogsUrl = (params?: ListForecastingRunLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/forecasting/run-logs?${stringifiedParams}` : `/api/forecasting/run-logs`
}

/**
 * @summary List forecasting run logs (newest first)
 */
export const listForecastingRunLogs = async (params?: ListForecastingRunLogsParams, options?: RequestInit): Promise<ListForecastingRunLogs200> => {

  return customFetch<ListForecastingRunLogs200>(getListForecastingRunLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListForecastingRunLogsQueryKey = (params?: ListForecastingRunLogsParams,) => {
    return [
    `/api/forecasting/run-logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListForecastingRunLogsQueryOptions = <TData = Awaited<ReturnType<typeof listForecastingRunLogs>>, TError = ErrorType<unknown>>(params?: ListForecastingRunLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listForecastingRunLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListForecastingRunLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listForecastingRunLogs>>> = ({ signal }) => listForecastingRunLogs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listForecastingRunLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListForecastingRunLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listForecastingRunLogs>>>
export type ListForecastingRunLogsQueryError = ErrorType<unknown>


/**
 * @summary List forecasting run logs (newest first)
 */

export function useListForecastingRunLogs<TData = Awaited<ReturnType<typeof listForecastingRunLogs>>, TError = ErrorType<unknown>>(
 params?: ListForecastingRunLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listForecastingRunLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListForecastingRunLogsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportDemandForecastsUrl = () => {




  return `/api/forecasting/export.csv`
}

/**
 * @summary Export all demand forecasts as CSV
 */
export const exportDemandForecasts = async ( options?: RequestInit): Promise<string> => {

  return customFetch<string>(getExportDemandForecastsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportDemandForecastsQueryKey = () => {
    return [
    `/api/forecasting/export.csv`
    ] as const;
    }


export const getExportDemandForecastsQueryOptions = <TData = Awaited<ReturnType<typeof exportDemandForecasts>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportDemandForecasts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportDemandForecastsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportDemandForecasts>>> = ({ signal }) => exportDemandForecasts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportDemandForecasts>>, TError, TData> & { queryKey: QueryKey }
}

export type ExportDemandForecastsQueryResult = NonNullable<Awaited<ReturnType<typeof exportDemandForecasts>>>
export type ExportDemandForecastsQueryError = ErrorType<unknown>


/**
 * @summary Export all demand forecasts as CSV
 */

export function useExportDemandForecasts<TData = Awaited<ReturnType<typeof exportDemandForecasts>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportDemandForecasts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getExportDemandForecastsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetForecastingSettingsUrl = () => {




  return `/api/forecasting/settings`
}

/**
 * @summary Get the tenant's forecasting settings
 */
export const getForecastingSettings = async ( options?: RequestInit): Promise<ForecastingSettings> => {

  return customFetch<ForecastingSettings>(getGetForecastingSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetForecastingSettingsQueryKey = () => {
    return [
    `/api/forecasting/settings`
    ] as const;
    }


export const getGetForecastingSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getForecastingSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getForecastingSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetForecastingSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getForecastingSettings>>> = ({ signal }) => getForecastingSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getForecastingSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetForecastingSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getForecastingSettings>>>
export type GetForecastingSettingsQueryError = ErrorType<unknown>


/**
 * @summary Get the tenant's forecasting settings
 */

export function useGetForecastingSettings<TData = Awaited<ReturnType<typeof getForecastingSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getForecastingSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetForecastingSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateForecastingSettingsUrl = () => {




  return `/api/forecasting/settings`
}

/**
 * @summary Update the tenant's forecasting settings
 */
export const updateForecastingSettings = async (forecastingSettingsUpdate: ForecastingSettingsUpdate, options?: RequestInit): Promise<ForecastingSettings> => {

  return customFetch<ForecastingSettings>(getUpdateForecastingSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(forecastingSettingsUpdate)
  }
);}





export const getUpdateForecastingSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateForecastingSettings>>, TError,{data: BodyType<ForecastingSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateForecastingSettings>>, TError,{data: BodyType<ForecastingSettingsUpdate>}, TContext> => {

const mutationKey = ['updateForecastingSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateForecastingSettings>>, {data: BodyType<ForecastingSettingsUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateForecastingSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateForecastingSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateForecastingSettings>>>
    export type UpdateForecastingSettingsMutationBody = BodyType<ForecastingSettingsUpdate>
    export type UpdateForecastingSettingsMutationError = ErrorType<unknown>

    /**
 * @summary Update the tenant's forecasting settings
 */
export const useUpdateForecastingSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateForecastingSettings>>, TError,{data: BodyType<ForecastingSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateForecastingSettings>>,
        TError,
        {data: BodyType<ForecastingSettingsUpdate>},
        TContext
      > => {
      return useMutation(getUpdateForecastingSettingsMutationOptions(options));
    }

export const getListIntelligenceInsightsUrl = (params?: ListIntelligenceInsightsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/intelligence/insights?${stringifiedParams}` : `/api/intelligence/insights`
}

/**
 * @summary List intelligence insight cards (filter + per-user dismiss/save state)
 */
export const listIntelligenceInsights = async (params?: ListIntelligenceInsightsParams, options?: RequestInit): Promise<IntelligenceInsightList> => {

  return customFetch<IntelligenceInsightList>(getListIntelligenceInsightsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListIntelligenceInsightsQueryKey = (params?: ListIntelligenceInsightsParams,) => {
    return [
    `/api/intelligence/insights`, ...(params ? [params] : [])
    ] as const;
    }


export const getListIntelligenceInsightsQueryOptions = <TData = Awaited<ReturnType<typeof listIntelligenceInsights>>, TError = ErrorType<unknown>>(params?: ListIntelligenceInsightsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listIntelligenceInsights>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListIntelligenceInsightsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listIntelligenceInsights>>> = ({ signal }) => listIntelligenceInsights(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listIntelligenceInsights>>, TError, TData> & { queryKey: QueryKey }
}

export type ListIntelligenceInsightsQueryResult = NonNullable<Awaited<ReturnType<typeof listIntelligenceInsights>>>
export type ListIntelligenceInsightsQueryError = ErrorType<unknown>


/**
 * @summary List intelligence insight cards (filter + per-user dismiss/save state)
 */

export function useListIntelligenceInsights<TData = Awaited<ReturnType<typeof listIntelligenceInsights>>, TError = ErrorType<unknown>>(
 params?: ListIntelligenceInsightsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listIntelligenceInsights>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListIntelligenceInsightsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetIntelligenceSummaryUrl = () => {




  return `/api/intelligence/summary`
}

/**
 * @summary Compact insight counts for the page header + dashboard widget
 */
export const getIntelligenceSummary = async ( options?: RequestInit): Promise<IntelligenceSummary> => {

  return customFetch<IntelligenceSummary>(getGetIntelligenceSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetIntelligenceSummaryQueryKey = () => {
    return [
    `/api/intelligence/summary`
    ] as const;
    }


export const getGetIntelligenceSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getIntelligenceSummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntelligenceSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntelligenceSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntelligenceSummary>>> = ({ signal }) => getIntelligenceSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntelligenceSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetIntelligenceSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getIntelligenceSummary>>>
export type GetIntelligenceSummaryQueryError = ErrorType<unknown>


/**
 * @summary Compact insight counts for the page header + dashboard widget
 */

export function useGetIntelligenceSummary<TData = Awaited<ReturnType<typeof getIntelligenceSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntelligenceSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetIntelligenceSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDismissIntelligenceInsightUrl = (id: string,) => {




  return `/api/intelligence/insights/${id}/dismiss`
}

/**
 * @summary Dismiss an insight for the current user
 */
export const dismissIntelligenceInsight = async (id: string, options?: RequestInit): Promise<IntelligenceInsightStateResult> => {

  return customFetch<IntelligenceInsightStateResult>(getDismissIntelligenceInsightUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDismissIntelligenceInsightMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissIntelligenceInsight>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dismissIntelligenceInsight>>, TError,{id: string}, TContext> => {

const mutationKey = ['dismissIntelligenceInsight'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dismissIntelligenceInsight>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  dismissIntelligenceInsight(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DismissIntelligenceInsightMutationResult = NonNullable<Awaited<ReturnType<typeof dismissIntelligenceInsight>>>

    export type DismissIntelligenceInsightMutationError = ErrorType<unknown>

    /**
 * @summary Dismiss an insight for the current user
 */
export const useDismissIntelligenceInsight = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissIntelligenceInsight>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof dismissIntelligenceInsight>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDismissIntelligenceInsightMutationOptions(options));
    }

export const getUndismissIntelligenceInsightUrl = (id: string,) => {




  return `/api/intelligence/insights/${id}/dismiss`
}

/**
 * @summary Un-dismiss an insight for the current user
 */
export const undismissIntelligenceInsight = async (id: string, options?: RequestInit): Promise<IntelligenceInsightStateResult> => {

  return customFetch<IntelligenceInsightStateResult>(getUndismissIntelligenceInsightUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUndismissIntelligenceInsightMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof undismissIntelligenceInsight>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof undismissIntelligenceInsight>>, TError,{id: string}, TContext> => {

const mutationKey = ['undismissIntelligenceInsight'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof undismissIntelligenceInsight>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  undismissIntelligenceInsight(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UndismissIntelligenceInsightMutationResult = NonNullable<Awaited<ReturnType<typeof undismissIntelligenceInsight>>>

    export type UndismissIntelligenceInsightMutationError = ErrorType<unknown>

    /**
 * @summary Un-dismiss an insight for the current user
 */
export const useUndismissIntelligenceInsight = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof undismissIntelligenceInsight>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof undismissIntelligenceInsight>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getUndismissIntelligenceInsightMutationOptions(options));
    }

export const getSaveIntelligenceInsightUrl = (id: string,) => {




  return `/api/intelligence/insights/${id}/save`
}

/**
 * @summary Save (bookmark) an insight for the current user
 */
export const saveIntelligenceInsight = async (id: string, options?: RequestInit): Promise<IntelligenceInsightStateResult> => {

  return customFetch<IntelligenceInsightStateResult>(getSaveIntelligenceInsightUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSaveIntelligenceInsightMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveIntelligenceInsight>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveIntelligenceInsight>>, TError,{id: string}, TContext> => {

const mutationKey = ['saveIntelligenceInsight'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveIntelligenceInsight>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  saveIntelligenceInsight(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveIntelligenceInsightMutationResult = NonNullable<Awaited<ReturnType<typeof saveIntelligenceInsight>>>

    export type SaveIntelligenceInsightMutationError = ErrorType<unknown>

    /**
 * @summary Save (bookmark) an insight for the current user
 */
export const useSaveIntelligenceInsight = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveIntelligenceInsight>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveIntelligenceInsight>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getSaveIntelligenceInsightMutationOptions(options));
    }

export const getUnsaveIntelligenceInsightUrl = (id: string,) => {




  return `/api/intelligence/insights/${id}/save`
}

/**
 * @summary Un-save an insight for the current user
 */
export const unsaveIntelligenceInsight = async (id: string, options?: RequestInit): Promise<IntelligenceInsightStateResult> => {

  return customFetch<IntelligenceInsightStateResult>(getUnsaveIntelligenceInsightUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUnsaveIntelligenceInsightMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unsaveIntelligenceInsight>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unsaveIntelligenceInsight>>, TError,{id: string}, TContext> => {

const mutationKey = ['unsaveIntelligenceInsight'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unsaveIntelligenceInsight>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  unsaveIntelligenceInsight(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnsaveIntelligenceInsightMutationResult = NonNullable<Awaited<ReturnType<typeof unsaveIntelligenceInsight>>>

    export type UnsaveIntelligenceInsightMutationError = ErrorType<unknown>

    /**
 * @summary Un-save an insight for the current user
 */
export const useUnsaveIntelligenceInsight = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unsaveIntelligenceInsight>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof unsaveIntelligenceInsight>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getUnsaveIntelligenceInsightMutationOptions(options));
    }

export const getAssignIntelligenceInsightUrl = (id: string,) => {




  return `/api/intelligence/insights/${id}/assign`
}

/**
 * @summary Assign (or unassign) an insight to an operator
 */
export const assignIntelligenceInsight = async (id: string,
    intelligenceInsightAssign: IntelligenceInsightAssign, options?: RequestInit): Promise<IntelligenceInsight> => {

  return customFetch<IntelligenceInsight>(getAssignIntelligenceInsightUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(intelligenceInsightAssign)
  }
);}





export const getAssignIntelligenceInsightMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignIntelligenceInsight>>, TError,{id: string;data: BodyType<IntelligenceInsightAssign>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assignIntelligenceInsight>>, TError,{id: string;data: BodyType<IntelligenceInsightAssign>}, TContext> => {

const mutationKey = ['assignIntelligenceInsight'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignIntelligenceInsight>>, {id: string;data: BodyType<IntelligenceInsightAssign>}> = (props) => {
          const {id,data} = props ?? {};

          return  assignIntelligenceInsight(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignIntelligenceInsightMutationResult = NonNullable<Awaited<ReturnType<typeof assignIntelligenceInsight>>>
    export type AssignIntelligenceInsightMutationBody = BodyType<IntelligenceInsightAssign>
    export type AssignIntelligenceInsightMutationError = ErrorType<unknown>

    /**
 * @summary Assign (or unassign) an insight to an operator
 */
export const useAssignIntelligenceInsight = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignIntelligenceInsight>>, TError,{id: string;data: BodyType<IntelligenceInsightAssign>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof assignIntelligenceInsight>>,
        TError,
        {id: string;data: BodyType<IntelligenceInsightAssign>},
        TContext
      > => {
      return useMutation(getAssignIntelligenceInsightMutationOptions(options));
    }

export const getRunIntelligenceNowUrl = () => {




  return `/api/intelligence/run`
}

/**
 * @summary Run an intelligence pass now (manual trigger)
 */
export const runIntelligenceNow = async ( options?: RequestInit): Promise<IntelligenceRunResult> => {

  return customFetch<IntelligenceRunResult>(getRunIntelligenceNowUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRunIntelligenceNowMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runIntelligenceNow>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof runIntelligenceNow>>, TError,void, TContext> => {

const mutationKey = ['runIntelligenceNow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runIntelligenceNow>>, void> = () => {


          return  runIntelligenceNow(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunIntelligenceNowMutationResult = NonNullable<Awaited<ReturnType<typeof runIntelligenceNow>>>

    export type RunIntelligenceNowMutationError = ErrorType<unknown>

    /**
 * @summary Run an intelligence pass now (manual trigger)
 */
export const useRunIntelligenceNow = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runIntelligenceNow>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof runIntelligenceNow>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRunIntelligenceNowMutationOptions(options));
    }

export const getGetIntelligenceSettingsUrl = () => {




  return `/api/intelligence/settings`
}

/**
 * @summary Get the tenant's intelligence settings
 */
export const getIntelligenceSettings = async ( options?: RequestInit): Promise<IntelligenceSettings> => {

  return customFetch<IntelligenceSettings>(getGetIntelligenceSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetIntelligenceSettingsQueryKey = () => {
    return [
    `/api/intelligence/settings`
    ] as const;
    }


export const getGetIntelligenceSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getIntelligenceSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntelligenceSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntelligenceSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntelligenceSettings>>> = ({ signal }) => getIntelligenceSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntelligenceSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetIntelligenceSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getIntelligenceSettings>>>
export type GetIntelligenceSettingsQueryError = ErrorType<unknown>


/**
 * @summary Get the tenant's intelligence settings
 */

export function useGetIntelligenceSettings<TData = Awaited<ReturnType<typeof getIntelligenceSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntelligenceSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetIntelligenceSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateIntelligenceSettingsUrl = () => {




  return `/api/intelligence/settings`
}

/**
 * @summary Update the tenant's intelligence settings
 */
export const updateIntelligenceSettings = async (intelligenceSettingsUpdate: IntelligenceSettingsUpdate, options?: RequestInit): Promise<IntelligenceSettings> => {

  return customFetch<IntelligenceSettings>(getUpdateIntelligenceSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(intelligenceSettingsUpdate)
  }
);}





export const getUpdateIntelligenceSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateIntelligenceSettings>>, TError,{data: BodyType<IntelligenceSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateIntelligenceSettings>>, TError,{data: BodyType<IntelligenceSettingsUpdate>}, TContext> => {

const mutationKey = ['updateIntelligenceSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateIntelligenceSettings>>, {data: BodyType<IntelligenceSettingsUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateIntelligenceSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateIntelligenceSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateIntelligenceSettings>>>
    export type UpdateIntelligenceSettingsMutationBody = BodyType<IntelligenceSettingsUpdate>
    export type UpdateIntelligenceSettingsMutationError = ErrorType<unknown>

    /**
 * @summary Update the tenant's intelligence settings
 */
export const useUpdateIntelligenceSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateIntelligenceSettings>>, TError,{data: BodyType<IntelligenceSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateIntelligenceSettings>>,
        TError,
        {data: BodyType<IntelligenceSettingsUpdate>},
        TContext
      > => {
      return useMutation(getUpdateIntelligenceSettingsMutationOptions(options));
    }

export const getGetPurchasingSummaryUrl = () => {




  return `/api/purchasing/summary`
}

/**
 * @summary Compact purchasing-automation snapshot for the page header
 */
export const getPurchasingSummary = async ( options?: RequestInit): Promise<PurchasingSummary> => {

  return customFetch<PurchasingSummary>(getGetPurchasingSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPurchasingSummaryQueryKey = () => {
    return [
    `/api/purchasing/summary`
    ] as const;
    }


export const getGetPurchasingSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getPurchasingSummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPurchasingSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPurchasingSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPurchasingSummary>>> = ({ signal }) => getPurchasingSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPurchasingSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPurchasingSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getPurchasingSummary>>>
export type GetPurchasingSummaryQueryError = ErrorType<unknown>


/**
 * @summary Compact purchasing-automation snapshot for the page header
 */

export function useGetPurchasingSummary<TData = Awaited<ReturnType<typeof getPurchasingSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPurchasingSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPurchasingSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPurchaseRecommendationsUrl = (params?: ListPurchaseRecommendationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/purchasing/recommendations?${stringifiedParams}` : `/api/purchasing/recommendations`
}

/**
 * @summary List purchase recommendations (filter by status)
 */
export const listPurchaseRecommendations = async (params?: ListPurchaseRecommendationsParams, options?: RequestInit): Promise<ListPurchaseRecommendations200> => {

  return customFetch<ListPurchaseRecommendations200>(getListPurchaseRecommendationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPurchaseRecommendationsQueryKey = (params?: ListPurchaseRecommendationsParams,) => {
    return [
    `/api/purchasing/recommendations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPurchaseRecommendationsQueryOptions = <TData = Awaited<ReturnType<typeof listPurchaseRecommendations>>, TError = ErrorType<unknown>>(params?: ListPurchaseRecommendationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchaseRecommendations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPurchaseRecommendationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPurchaseRecommendations>>> = ({ signal }) => listPurchaseRecommendations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPurchaseRecommendations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPurchaseRecommendationsQueryResult = NonNullable<Awaited<ReturnType<typeof listPurchaseRecommendations>>>
export type ListPurchaseRecommendationsQueryError = ErrorType<unknown>


/**
 * @summary List purchase recommendations (filter by status)
 */

export function useListPurchaseRecommendations<TData = Awaited<ReturnType<typeof listPurchaseRecommendations>>, TError = ErrorType<unknown>>(
 params?: ListPurchaseRecommendationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchaseRecommendations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPurchaseRecommendationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getApprovePurchaseRecommendationUrl = (id: string,) => {




  return `/api/purchasing/recommendations/${id}/approve`
}

/**
 * @summary Approve a recommendation — creates a DRAFT purchase order
 */
export const approvePurchaseRecommendation = async (id: string,
    purchaseApproveRequest?: PurchaseApproveRequest, options?: RequestInit): Promise<PurchaseApproveResult> => {

  return customFetch<PurchaseApproveResult>(getApprovePurchaseRecommendationUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(purchaseApproveRequest)
  }
);}





export const getApprovePurchaseRecommendationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePurchaseRecommendation>>, TError,{id: string;data?: BodyType<PurchaseApproveRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approvePurchaseRecommendation>>, TError,{id: string;data?: BodyType<PurchaseApproveRequest>}, TContext> => {

const mutationKey = ['approvePurchaseRecommendation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approvePurchaseRecommendation>>, {id: string;data?: BodyType<PurchaseApproveRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  approvePurchaseRecommendation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApprovePurchaseRecommendationMutationResult = NonNullable<Awaited<ReturnType<typeof approvePurchaseRecommendation>>>
    export type ApprovePurchaseRecommendationMutationBody = BodyType<PurchaseApproveRequest> | undefined
    export type ApprovePurchaseRecommendationMutationError = ErrorType<unknown>

    /**
 * @summary Approve a recommendation — creates a DRAFT purchase order
 */
export const useApprovePurchaseRecommendation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePurchaseRecommendation>>, TError,{id: string;data?: BodyType<PurchaseApproveRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approvePurchaseRecommendation>>,
        TError,
        {id: string;data?: BodyType<PurchaseApproveRequest>},
        TContext
      > => {
      return useMutation(getApprovePurchaseRecommendationMutationOptions(options));
    }

export const getDismissPurchaseRecommendationUrl = (id: string,) => {




  return `/api/purchasing/recommendations/${id}/dismiss`
}

/**
 * @summary Dismiss an open purchase recommendation
 */
export const dismissPurchaseRecommendation = async (id: string, options?: RequestInit): Promise<PurchaseRecommendation> => {

  return customFetch<PurchaseRecommendation>(getDismissPurchaseRecommendationUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDismissPurchaseRecommendationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissPurchaseRecommendation>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dismissPurchaseRecommendation>>, TError,{id: string}, TContext> => {

const mutationKey = ['dismissPurchaseRecommendation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dismissPurchaseRecommendation>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  dismissPurchaseRecommendation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DismissPurchaseRecommendationMutationResult = NonNullable<Awaited<ReturnType<typeof dismissPurchaseRecommendation>>>

    export type DismissPurchaseRecommendationMutationError = ErrorType<unknown>

    /**
 * @summary Dismiss an open purchase recommendation
 */
export const useDismissPurchaseRecommendation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissPurchaseRecommendation>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof dismissPurchaseRecommendation>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDismissPurchaseRecommendationMutationOptions(options));
    }

export const getBulkApprovePurchaseRecommendationsUrl = () => {




  return `/api/purchasing/bulk-approve`
}

/**
 * @summary Approve many recommendations into draft PO(s) (grouped by supplier)
 */
export const bulkApprovePurchaseRecommendations = async (purchaseBulkApproveRequest?: PurchaseBulkApproveRequest, options?: RequestInit): Promise<PurchaseBulkApproveResult> => {

  return customFetch<PurchaseBulkApproveResult>(getBulkApprovePurchaseRecommendationsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(purchaseBulkApproveRequest)
  }
);}





export const getBulkApprovePurchaseRecommendationsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkApprovePurchaseRecommendations>>, TError,{data?: BodyType<PurchaseBulkApproveRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkApprovePurchaseRecommendations>>, TError,{data?: BodyType<PurchaseBulkApproveRequest>}, TContext> => {

const mutationKey = ['bulkApprovePurchaseRecommendations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkApprovePurchaseRecommendations>>, {data?: BodyType<PurchaseBulkApproveRequest>}> = (props) => {
          const {data} = props ?? {};

          return  bulkApprovePurchaseRecommendations(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkApprovePurchaseRecommendationsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkApprovePurchaseRecommendations>>>
    export type BulkApprovePurchaseRecommendationsMutationBody = BodyType<PurchaseBulkApproveRequest> | undefined
    export type BulkApprovePurchaseRecommendationsMutationError = ErrorType<unknown>

    /**
 * @summary Approve many recommendations into draft PO(s) (grouped by supplier)
 */
export const useBulkApprovePurchaseRecommendations = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkApprovePurchaseRecommendations>>, TError,{data?: BodyType<PurchaseBulkApproveRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkApprovePurchaseRecommendations>>,
        TError,
        {data?: BodyType<PurchaseBulkApproveRequest>},
        TContext
      > => {
      return useMutation(getBulkApprovePurchaseRecommendationsMutationOptions(options));
    }

export const getListSupplierPerformanceUrl = () => {




  return `/api/purchasing/suppliers`
}

/**
 * @summary List supplier performance metrics (most reliable first)
 */
export const listSupplierPerformance = async ( options?: RequestInit): Promise<ListSupplierPerformance200> => {

  return customFetch<ListSupplierPerformance200>(getListSupplierPerformanceUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSupplierPerformanceQueryKey = () => {
    return [
    `/api/purchasing/suppliers`
    ] as const;
    }


export const getListSupplierPerformanceQueryOptions = <TData = Awaited<ReturnType<typeof listSupplierPerformance>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSupplierPerformance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSupplierPerformanceQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSupplierPerformance>>> = ({ signal }) => listSupplierPerformance({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSupplierPerformance>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSupplierPerformanceQueryResult = NonNullable<Awaited<ReturnType<typeof listSupplierPerformance>>>
export type ListSupplierPerformanceQueryError = ErrorType<unknown>


/**
 * @summary List supplier performance metrics (most reliable first)
 */

export function useListSupplierPerformance<TData = Awaited<ReturnType<typeof listSupplierPerformance>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSupplierPerformance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSupplierPerformanceQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRunPurchasingNowUrl = () => {




  return `/api/purchasing/run`
}

/**
 * @summary Run a purchasing pass now (manual trigger)
 */
export const runPurchasingNow = async ( options?: RequestInit): Promise<PurchasingRunResult> => {

  return customFetch<PurchasingRunResult>(getRunPurchasingNowUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRunPurchasingNowMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runPurchasingNow>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof runPurchasingNow>>, TError,void, TContext> => {

const mutationKey = ['runPurchasingNow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runPurchasingNow>>, void> = () => {


          return  runPurchasingNow(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunPurchasingNowMutationResult = NonNullable<Awaited<ReturnType<typeof runPurchasingNow>>>

    export type RunPurchasingNowMutationError = ErrorType<unknown>

    /**
 * @summary Run a purchasing pass now (manual trigger)
 */
export const useRunPurchasingNow = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runPurchasingNow>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof runPurchasingNow>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRunPurchasingNowMutationOptions(options));
    }

export const getListPurchasingRunLogsUrl = (params?: ListPurchasingRunLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/purchasing/run-logs?${stringifiedParams}` : `/api/purchasing/run-logs`
}

/**
 * @summary List purchasing run logs (newest first)
 */
export const listPurchasingRunLogs = async (params?: ListPurchasingRunLogsParams, options?: RequestInit): Promise<ListPurchasingRunLogs200> => {

  return customFetch<ListPurchasingRunLogs200>(getListPurchasingRunLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPurchasingRunLogsQueryKey = (params?: ListPurchasingRunLogsParams,) => {
    return [
    `/api/purchasing/run-logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPurchasingRunLogsQueryOptions = <TData = Awaited<ReturnType<typeof listPurchasingRunLogs>>, TError = ErrorType<unknown>>(params?: ListPurchasingRunLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchasingRunLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPurchasingRunLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPurchasingRunLogs>>> = ({ signal }) => listPurchasingRunLogs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPurchasingRunLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPurchasingRunLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listPurchasingRunLogs>>>
export type ListPurchasingRunLogsQueryError = ErrorType<unknown>


/**
 * @summary List purchasing run logs (newest first)
 */

export function useListPurchasingRunLogs<TData = Awaited<ReturnType<typeof listPurchasingRunLogs>>, TError = ErrorType<unknown>>(
 params?: ListPurchasingRunLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchasingRunLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPurchasingRunLogsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportPurchaseRecommendationsUrl = () => {




  return `/api/purchasing/export.csv`
}

/**
 * @summary Export open purchase recommendations as CSV
 */
export const exportPurchaseRecommendations = async ( options?: RequestInit): Promise<string> => {

  return customFetch<string>(getExportPurchaseRecommendationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportPurchaseRecommendationsQueryKey = () => {
    return [
    `/api/purchasing/export.csv`
    ] as const;
    }


export const getExportPurchaseRecommendationsQueryOptions = <TData = Awaited<ReturnType<typeof exportPurchaseRecommendations>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportPurchaseRecommendations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportPurchaseRecommendationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportPurchaseRecommendations>>> = ({ signal }) => exportPurchaseRecommendations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportPurchaseRecommendations>>, TError, TData> & { queryKey: QueryKey }
}

export type ExportPurchaseRecommendationsQueryResult = NonNullable<Awaited<ReturnType<typeof exportPurchaseRecommendations>>>
export type ExportPurchaseRecommendationsQueryError = ErrorType<unknown>


/**
 * @summary Export open purchase recommendations as CSV
 */

export function useExportPurchaseRecommendations<TData = Awaited<ReturnType<typeof exportPurchaseRecommendations>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportPurchaseRecommendations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getExportPurchaseRecommendationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPurchasingSettingsUrl = () => {




  return `/api/purchasing/settings`
}

/**
 * @summary Get the tenant's purchasing-automation settings
 */
export const getPurchasingSettings = async ( options?: RequestInit): Promise<PurchasingSettings> => {

  return customFetch<PurchasingSettings>(getGetPurchasingSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPurchasingSettingsQueryKey = () => {
    return [
    `/api/purchasing/settings`
    ] as const;
    }


export const getGetPurchasingSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getPurchasingSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPurchasingSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPurchasingSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPurchasingSettings>>> = ({ signal }) => getPurchasingSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPurchasingSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPurchasingSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getPurchasingSettings>>>
export type GetPurchasingSettingsQueryError = ErrorType<unknown>


/**
 * @summary Get the tenant's purchasing-automation settings
 */

export function useGetPurchasingSettings<TData = Awaited<ReturnType<typeof getPurchasingSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPurchasingSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPurchasingSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdatePurchasingSettingsUrl = () => {




  return `/api/purchasing/settings`
}

/**
 * @summary Update the tenant's purchasing-automation settings
 */
export const updatePurchasingSettings = async (purchasingSettingsUpdate: PurchasingSettingsUpdate, options?: RequestInit): Promise<PurchasingSettings> => {

  return customFetch<PurchasingSettings>(getUpdatePurchasingSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(purchasingSettingsUpdate)
  }
);}





export const getUpdatePurchasingSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePurchasingSettings>>, TError,{data: BodyType<PurchasingSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePurchasingSettings>>, TError,{data: BodyType<PurchasingSettingsUpdate>}, TContext> => {

const mutationKey = ['updatePurchasingSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePurchasingSettings>>, {data: BodyType<PurchasingSettingsUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updatePurchasingSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePurchasingSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updatePurchasingSettings>>>
    export type UpdatePurchasingSettingsMutationBody = BodyType<PurchasingSettingsUpdate>
    export type UpdatePurchasingSettingsMutationError = ErrorType<unknown>

    /**
 * @summary Update the tenant's purchasing-automation settings
 */
export const useUpdatePurchasingSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePurchasingSettings>>, TError,{data: BodyType<PurchasingSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePurchasingSettings>>,
        TError,
        {data: BodyType<PurchasingSettingsUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePurchasingSettingsMutationOptions(options));
    }

export const getGetAutomationRegistryUrl = () => {




  return `/api/automations/registry`
}

/**
 * @summary Catalog of triggers, condition operators, and action types for the builder
 */
export const getAutomationRegistry = async ( options?: RequestInit): Promise<AutomationRegistry> => {

  return customFetch<AutomationRegistry>(getGetAutomationRegistryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAutomationRegistryQueryKey = () => {
    return [
    `/api/automations/registry`
    ] as const;
    }


export const getGetAutomationRegistryQueryOptions = <TData = Awaited<ReturnType<typeof getAutomationRegistry>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAutomationRegistry>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAutomationRegistryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAutomationRegistry>>> = ({ signal }) => getAutomationRegistry({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAutomationRegistry>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAutomationRegistryQueryResult = NonNullable<Awaited<ReturnType<typeof getAutomationRegistry>>>
export type GetAutomationRegistryQueryError = ErrorType<unknown>


/**
 * @summary Catalog of triggers, condition operators, and action types for the builder
 */

export function useGetAutomationRegistry<TData = Awaited<ReturnType<typeof getAutomationRegistry>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAutomationRegistry>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAutomationRegistryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAutomationsUrl = (params?: ListAutomationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/automations?${stringifiedParams}` : `/api/automations`
}

/**
 * @summary List automation rules (newest first)
 */
export const listAutomations = async (params?: ListAutomationsParams, options?: RequestInit): Promise<AutomationWorkflowList> => {

  return customFetch<AutomationWorkflowList>(getListAutomationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAutomationsQueryKey = (params?: ListAutomationsParams,) => {
    return [
    `/api/automations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAutomationsQueryOptions = <TData = Awaited<ReturnType<typeof listAutomations>>, TError = ErrorType<unknown>>(params?: ListAutomationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAutomations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAutomationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAutomations>>> = ({ signal }) => listAutomations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAutomations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAutomationsQueryResult = NonNullable<Awaited<ReturnType<typeof listAutomations>>>
export type ListAutomationsQueryError = ErrorType<unknown>


/**
 * @summary List automation rules (newest first)
 */

export function useListAutomations<TData = Awaited<ReturnType<typeof listAutomations>>, TError = ErrorType<unknown>>(
 params?: ListAutomationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAutomations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAutomationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateAutomationUrl = () => {




  return `/api/automations`
}

/**
 * @summary Create an automation rule (trigger + optional conditions + actions)
 */
export const createAutomation = async (automationWorkflowCreate: AutomationWorkflowCreate, options?: RequestInit): Promise<AutomationWorkflowDetail> => {

  return customFetch<AutomationWorkflowDetail>(getCreateAutomationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(automationWorkflowCreate)
  }
);}





export const getCreateAutomationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAutomation>>, TError,{data: BodyType<AutomationWorkflowCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAutomation>>, TError,{data: BodyType<AutomationWorkflowCreate>}, TContext> => {

const mutationKey = ['createAutomation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAutomation>>, {data: BodyType<AutomationWorkflowCreate>}> = (props) => {
          const {data} = props ?? {};

          return  createAutomation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAutomationMutationResult = NonNullable<Awaited<ReturnType<typeof createAutomation>>>
    export type CreateAutomationMutationBody = BodyType<AutomationWorkflowCreate>
    export type CreateAutomationMutationError = ErrorType<unknown>

    /**
 * @summary Create an automation rule (trigger + optional conditions + actions)
 */
export const useCreateAutomation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAutomation>>, TError,{data: BodyType<AutomationWorkflowCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAutomation>>,
        TError,
        {data: BodyType<AutomationWorkflowCreate>},
        TContext
      > => {
      return useMutation(getCreateAutomationMutationOptions(options));
    }

export const getListAllAutomationLogsUrl = (params?: ListAllAutomationLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/automations/logs?${stringifiedParams}` : `/api/automations/logs`
}

/**
 * @summary List automation run logs across all rules (newest first)
 */
export const listAllAutomationLogs = async (params?: ListAllAutomationLogsParams, options?: RequestInit): Promise<AutomationLogList> => {

  return customFetch<AutomationLogList>(getListAllAutomationLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAllAutomationLogsQueryKey = (params?: ListAllAutomationLogsParams,) => {
    return [
    `/api/automations/logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAllAutomationLogsQueryOptions = <TData = Awaited<ReturnType<typeof listAllAutomationLogs>>, TError = ErrorType<unknown>>(params?: ListAllAutomationLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAllAutomationLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAllAutomationLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllAutomationLogs>>> = ({ signal }) => listAllAutomationLogs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAllAutomationLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAllAutomationLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listAllAutomationLogs>>>
export type ListAllAutomationLogsQueryError = ErrorType<unknown>


/**
 * @summary List automation run logs across all rules (newest first)
 */

export function useListAllAutomationLogs<TData = Awaited<ReturnType<typeof listAllAutomationLogs>>, TError = ErrorType<unknown>>(
 params?: ListAllAutomationLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAllAutomationLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAllAutomationLogsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAutomationUrl = (id: string,) => {




  return `/api/automations/${id}`
}

/**
 * @summary Get a single automation rule with its trigger, conditions, and actions
 */
export const getAutomation = async (id: string, options?: RequestInit): Promise<AutomationWorkflowDetail> => {

  return customFetch<AutomationWorkflowDetail>(getGetAutomationUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAutomationQueryKey = (id: string,) => {
    return [
    `/api/automations/${id}`
    ] as const;
    }


export const getGetAutomationQueryOptions = <TData = Awaited<ReturnType<typeof getAutomation>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAutomation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAutomationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAutomation>>> = ({ signal }) => getAutomation(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAutomation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAutomationQueryResult = NonNullable<Awaited<ReturnType<typeof getAutomation>>>
export type GetAutomationQueryError = ErrorType<unknown>


/**
 * @summary Get a single automation rule with its trigger, conditions, and actions
 */

export function useGetAutomation<TData = Awaited<ReturnType<typeof getAutomation>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAutomation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAutomationQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateAutomationUrl = (id: string,) => {




  return `/api/automations/${id}`
}

/**
 * @summary Update an automation rule (metadata, enable/disable, trigger, conditions, actions)
 */
export const updateAutomation = async (id: string,
    automationWorkflowUpdate: AutomationWorkflowUpdate, options?: RequestInit): Promise<AutomationWorkflowDetail> => {

  return customFetch<AutomationWorkflowDetail>(getUpdateAutomationUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(automationWorkflowUpdate)
  }
);}





export const getUpdateAutomationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAutomation>>, TError,{id: string;data: BodyType<AutomationWorkflowUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAutomation>>, TError,{id: string;data: BodyType<AutomationWorkflowUpdate>}, TContext> => {

const mutationKey = ['updateAutomation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAutomation>>, {id: string;data: BodyType<AutomationWorkflowUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAutomation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAutomationMutationResult = NonNullable<Awaited<ReturnType<typeof updateAutomation>>>
    export type UpdateAutomationMutationBody = BodyType<AutomationWorkflowUpdate>
    export type UpdateAutomationMutationError = ErrorType<unknown>

    /**
 * @summary Update an automation rule (metadata, enable/disable, trigger, conditions, actions)
 */
export const useUpdateAutomation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAutomation>>, TError,{id: string;data: BodyType<AutomationWorkflowUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAutomation>>,
        TError,
        {id: string;data: BodyType<AutomationWorkflowUpdate>},
        TContext
      > => {
      return useMutation(getUpdateAutomationMutationOptions(options));
    }

export const getDeleteAutomationUrl = (id: string,) => {




  return `/api/automations/${id}`
}

/**
 * @summary Delete an automation rule
 */
export const deleteAutomation = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteAutomationUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteAutomationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAutomation>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAutomation>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteAutomation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAutomation>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAutomation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAutomationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAutomation>>>

    export type DeleteAutomationMutationError = ErrorType<unknown>

    /**
 * @summary Delete an automation rule
 */
export const useDeleteAutomation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAutomation>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAutomation>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteAutomationMutationOptions(options));
    }

export const getTestAutomationUrl = (id: string,) => {




  return `/api/automations/${id}/test`
}

/**
 * @summary Test-run a rule against a sample payload (simulated, no side effects)
 */
export const testAutomation = async (id: string,
    automationTestRequest: AutomationTestRequest, options?: RequestInit): Promise<AutomationTestResult> => {

  return customFetch<AutomationTestResult>(getTestAutomationUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(automationTestRequest)
  }
);}





export const getTestAutomationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testAutomation>>, TError,{id: string;data: BodyType<AutomationTestRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testAutomation>>, TError,{id: string;data: BodyType<AutomationTestRequest>}, TContext> => {

const mutationKey = ['testAutomation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testAutomation>>, {id: string;data: BodyType<AutomationTestRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  testAutomation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestAutomationMutationResult = NonNullable<Awaited<ReturnType<typeof testAutomation>>>
    export type TestAutomationMutationBody = BodyType<AutomationTestRequest>
    export type TestAutomationMutationError = ErrorType<unknown>

    /**
 * @summary Test-run a rule against a sample payload (simulated, no side effects)
 */
export const useTestAutomation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testAutomation>>, TError,{id: string;data: BodyType<AutomationTestRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof testAutomation>>,
        TError,
        {id: string;data: BodyType<AutomationTestRequest>},
        TContext
      > => {
      return useMutation(getTestAutomationMutationOptions(options));
    }

export const getListAutomationLogsUrl = (id: string,
    params?: ListAutomationLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/automations/${id}/logs?${stringifiedParams}` : `/api/automations/${id}/logs`
}

/**
 * @summary List run logs for a single rule (newest first)
 */
export const listAutomationLogs = async (id: string,
    params?: ListAutomationLogsParams, options?: RequestInit): Promise<AutomationLogList> => {

  return customFetch<AutomationLogList>(getListAutomationLogsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAutomationLogsQueryKey = (id: string,
    params?: ListAutomationLogsParams,) => {
    return [
    `/api/automations/${id}/logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAutomationLogsQueryOptions = <TData = Awaited<ReturnType<typeof listAutomationLogs>>, TError = ErrorType<unknown>>(id: string,
    params?: ListAutomationLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAutomationLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAutomationLogsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAutomationLogs>>> = ({ signal }) => listAutomationLogs(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAutomationLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAutomationLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listAutomationLogs>>>
export type ListAutomationLogsQueryError = ErrorType<unknown>


/**
 * @summary List run logs for a single rule (newest first)
 */

export function useListAutomationLogs<TData = Awaited<ReturnType<typeof listAutomationLogs>>, TError = ErrorType<unknown>>(
 id: string,
    params?: ListAutomationLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAutomationLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAutomationLogsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPricingSummaryUrl = () => {




  return `/api/pricing/summary`
}

/**
 * @summary Compact dynamic-pricing health snapshot
 */
export const getPricingSummary = async ( options?: RequestInit): Promise<PricingSummary> => {

  return customFetch<PricingSummary>(getGetPricingSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPricingSummaryQueryKey = () => {
    return [
    `/api/pricing/summary`
    ] as const;
    }


export const getGetPricingSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getPricingSummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPricingSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPricingSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPricingSummary>>> = ({ signal }) => getPricingSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPricingSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPricingSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getPricingSummary>>>
export type GetPricingSummaryQueryError = ErrorType<unknown>


/**
 * @summary Compact dynamic-pricing health snapshot
 */

export function useGetPricingSummary<TData = Awaited<ReturnType<typeof getPricingSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPricingSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPricingSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPricingRulesUrl = () => {




  return `/api/pricing/rules`
}

/**
 * @summary List price rules (highest priority first)
 */
export const listPricingRules = async ( options?: RequestInit): Promise<ListPricingRules200> => {

  return customFetch<ListPricingRules200>(getListPricingRulesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPricingRulesQueryKey = () => {
    return [
    `/api/pricing/rules`
    ] as const;
    }


export const getListPricingRulesQueryOptions = <TData = Awaited<ReturnType<typeof listPricingRules>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingRules>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPricingRulesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPricingRules>>> = ({ signal }) => listPricingRules({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPricingRules>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPricingRulesQueryResult = NonNullable<Awaited<ReturnType<typeof listPricingRules>>>
export type ListPricingRulesQueryError = ErrorType<unknown>


/**
 * @summary List price rules (highest priority first)
 */

export function useListPricingRules<TData = Awaited<ReturnType<typeof listPricingRules>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingRules>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPricingRulesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreatePricingRuleUrl = () => {




  return `/api/pricing/rules`
}

/**
 * @summary Create a price rule
 */
export const createPricingRule = async (pricingRuleCreate: PricingRuleCreate, options?: RequestInit): Promise<PricingRule> => {

  return customFetch<PricingRule>(getCreatePricingRuleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pricingRuleCreate)
  }
);}





export const getCreatePricingRuleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPricingRule>>, TError,{data: BodyType<PricingRuleCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPricingRule>>, TError,{data: BodyType<PricingRuleCreate>}, TContext> => {

const mutationKey = ['createPricingRule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPricingRule>>, {data: BodyType<PricingRuleCreate>}> = (props) => {
          const {data} = props ?? {};

          return  createPricingRule(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePricingRuleMutationResult = NonNullable<Awaited<ReturnType<typeof createPricingRule>>>
    export type CreatePricingRuleMutationBody = BodyType<PricingRuleCreate>
    export type CreatePricingRuleMutationError = ErrorType<unknown>

    /**
 * @summary Create a price rule
 */
export const useCreatePricingRule = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPricingRule>>, TError,{data: BodyType<PricingRuleCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPricingRule>>,
        TError,
        {data: BodyType<PricingRuleCreate>},
        TContext
      > => {
      return useMutation(getCreatePricingRuleMutationOptions(options));
    }

export const getUpdatePricingRuleUrl = (id: string,) => {




  return `/api/pricing/rules/${id}`
}

/**
 * @summary Update a price rule
 */
export const updatePricingRule = async (id: string,
    pricingRuleUpdate: PricingRuleUpdate, options?: RequestInit): Promise<PricingRule> => {

  return customFetch<PricingRule>(getUpdatePricingRuleUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pricingRuleUpdate)
  }
);}





export const getUpdatePricingRuleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePricingRule>>, TError,{id: string;data: BodyType<PricingRuleUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePricingRule>>, TError,{id: string;data: BodyType<PricingRuleUpdate>}, TContext> => {

const mutationKey = ['updatePricingRule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePricingRule>>, {id: string;data: BodyType<PricingRuleUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePricingRule(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePricingRuleMutationResult = NonNullable<Awaited<ReturnType<typeof updatePricingRule>>>
    export type UpdatePricingRuleMutationBody = BodyType<PricingRuleUpdate>
    export type UpdatePricingRuleMutationError = ErrorType<unknown>

    /**
 * @summary Update a price rule
 */
export const useUpdatePricingRule = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePricingRule>>, TError,{id: string;data: BodyType<PricingRuleUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePricingRule>>,
        TError,
        {id: string;data: BodyType<PricingRuleUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePricingRuleMutationOptions(options));
    }

export const getDeletePricingRuleUrl = (id: string,) => {




  return `/api/pricing/rules/${id}`
}

/**
 * @summary Delete a price rule
 */
export const deletePricingRule = async (id: string, options?: RequestInit): Promise<DeletePricingRule200> => {

  return customFetch<DeletePricingRule200>(getDeletePricingRuleUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeletePricingRuleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePricingRule>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePricingRule>>, TError,{id: string}, TContext> => {

const mutationKey = ['deletePricingRule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePricingRule>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deletePricingRule(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePricingRuleMutationResult = NonNullable<Awaited<ReturnType<typeof deletePricingRule>>>

    export type DeletePricingRuleMutationError = ErrorType<unknown>

    /**
 * @summary Delete a price rule
 */
export const useDeletePricingRule = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePricingRule>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePricingRule>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeletePricingRuleMutationOptions(options));
    }

export const getListPricingFeeProfilesUrl = (params?: ListPricingFeeProfilesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pricing/fee-profiles?${stringifiedParams}` : `/api/pricing/fee-profiles`
}

/**
 * @summary List channel fee profiles (versioned, effective-dated)
 */
export const listPricingFeeProfiles = async (params?: ListPricingFeeProfilesParams, options?: RequestInit): Promise<ListPricingFeeProfiles200> => {

  return customFetch<ListPricingFeeProfiles200>(getListPricingFeeProfilesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPricingFeeProfilesQueryKey = (params?: ListPricingFeeProfilesParams,) => {
    return [
    `/api/pricing/fee-profiles`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPricingFeeProfilesQueryOptions = <TData = Awaited<ReturnType<typeof listPricingFeeProfiles>>, TError = ErrorType<unknown>>(params?: ListPricingFeeProfilesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingFeeProfiles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPricingFeeProfilesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPricingFeeProfiles>>> = ({ signal }) => listPricingFeeProfiles(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPricingFeeProfiles>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPricingFeeProfilesQueryResult = NonNullable<Awaited<ReturnType<typeof listPricingFeeProfiles>>>
export type ListPricingFeeProfilesQueryError = ErrorType<unknown>


/**
 * @summary List channel fee profiles (versioned, effective-dated)
 */

export function useListPricingFeeProfiles<TData = Awaited<ReturnType<typeof listPricingFeeProfiles>>, TError = ErrorType<unknown>>(
 params?: ListPricingFeeProfilesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingFeeProfiles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPricingFeeProfilesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreatePricingFeeProfileUrl = () => {




  return `/api/pricing/fee-profiles`
}

/**
 * @summary Create a fee-profile version for a channel (closes the previous open version)
 */
export const createPricingFeeProfile = async (pricingFeeProfileCreate: PricingFeeProfileCreate, options?: RequestInit): Promise<PricingFeeProfile> => {

  return customFetch<PricingFeeProfile>(getCreatePricingFeeProfileUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pricingFeeProfileCreate)
  }
);}





export const getCreatePricingFeeProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPricingFeeProfile>>, TError,{data: BodyType<PricingFeeProfileCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPricingFeeProfile>>, TError,{data: BodyType<PricingFeeProfileCreate>}, TContext> => {

const mutationKey = ['createPricingFeeProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPricingFeeProfile>>, {data: BodyType<PricingFeeProfileCreate>}> = (props) => {
          const {data} = props ?? {};

          return  createPricingFeeProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePricingFeeProfileMutationResult = NonNullable<Awaited<ReturnType<typeof createPricingFeeProfile>>>
    export type CreatePricingFeeProfileMutationBody = BodyType<PricingFeeProfileCreate>
    export type CreatePricingFeeProfileMutationError = ErrorType<unknown>

    /**
 * @summary Create a fee-profile version for a channel (closes the previous open version)
 */
export const useCreatePricingFeeProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPricingFeeProfile>>, TError,{data: BodyType<PricingFeeProfileCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPricingFeeProfile>>,
        TError,
        {data: BodyType<PricingFeeProfileCreate>},
        TContext
      > => {
      return useMutation(getCreatePricingFeeProfileMutationOptions(options));
    }

export const getUpdatePricingFeeProfileUrl = (id: string,) => {




  return `/api/pricing/fee-profiles/${id}`
}

/**
 * @summary Update a fee profile. Versions are immutable for commercial fields — changing rates/allowances/effectiveFrom atomically creates a successor version (201) and closes the predecessor; metadata-only edits (name/notes/archived/effectiveTo) update in place (200).
 */
export const updatePricingFeeProfile = async (id: string,
    pricingFeeProfileUpdate: PricingFeeProfileUpdate, options?: RequestInit): Promise<PricingFeeProfile> => {

  return customFetch<PricingFeeProfile>(getUpdatePricingFeeProfileUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pricingFeeProfileUpdate)
  }
);}





export const getUpdatePricingFeeProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePricingFeeProfile>>, TError,{id: string;data: BodyType<PricingFeeProfileUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePricingFeeProfile>>, TError,{id: string;data: BodyType<PricingFeeProfileUpdate>}, TContext> => {

const mutationKey = ['updatePricingFeeProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePricingFeeProfile>>, {id: string;data: BodyType<PricingFeeProfileUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePricingFeeProfile(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePricingFeeProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updatePricingFeeProfile>>>
    export type UpdatePricingFeeProfileMutationBody = BodyType<PricingFeeProfileUpdate>
    export type UpdatePricingFeeProfileMutationError = ErrorType<unknown>

    /**
 * @summary Update a fee profile. Versions are immutable for commercial fields — changing rates/allowances/effectiveFrom atomically creates a successor version (201) and closes the predecessor; metadata-only edits (name/notes/archived/effectiveTo) update in place (200).
 */
export const useUpdatePricingFeeProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePricingFeeProfile>>, TError,{id: string;data: BodyType<PricingFeeProfileUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePricingFeeProfile>>,
        TError,
        {id: string;data: BodyType<PricingFeeProfileUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePricingFeeProfileMutationOptions(options));
    }

export const getArchivePricingFeeProfileUrl = (id: string,) => {




  return `/api/pricing/fee-profiles/${id}`
}

/**
 * @summary Archive a fee profile (soft — snapshots keep referencing it)
 */
export const archivePricingFeeProfile = async (id: string, options?: RequestInit): Promise<ArchivePricingFeeProfile200> => {

  return customFetch<ArchivePricingFeeProfile200>(getArchivePricingFeeProfileUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getArchivePricingFeeProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archivePricingFeeProfile>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof archivePricingFeeProfile>>, TError,{id: string}, TContext> => {

const mutationKey = ['archivePricingFeeProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archivePricingFeeProfile>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  archivePricingFeeProfile(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchivePricingFeeProfileMutationResult = NonNullable<Awaited<ReturnType<typeof archivePricingFeeProfile>>>

    export type ArchivePricingFeeProfileMutationError = ErrorType<unknown>

    /**
 * @summary Archive a fee profile (soft — snapshots keep referencing it)
 */
export const useArchivePricingFeeProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archivePricingFeeProfile>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof archivePricingFeeProfile>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getArchivePricingFeeProfileMutationOptions(options));
    }

export const getListPricingMarginRulesUrl = (params?: ListPricingMarginRulesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pricing/margin-rules?${stringifiedParams}` : `/api/pricing/margin-rules`
}

/**
 * @summary List margin-protection rules
 */
export const listPricingMarginRules = async (params?: ListPricingMarginRulesParams, options?: RequestInit): Promise<ListPricingMarginRules200> => {

  return customFetch<ListPricingMarginRules200>(getListPricingMarginRulesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPricingMarginRulesQueryKey = (params?: ListPricingMarginRulesParams,) => {
    return [
    `/api/pricing/margin-rules`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPricingMarginRulesQueryOptions = <TData = Awaited<ReturnType<typeof listPricingMarginRules>>, TError = ErrorType<unknown>>(params?: ListPricingMarginRulesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingMarginRules>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPricingMarginRulesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPricingMarginRules>>> = ({ signal }) => listPricingMarginRules(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPricingMarginRules>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPricingMarginRulesQueryResult = NonNullable<Awaited<ReturnType<typeof listPricingMarginRules>>>
export type ListPricingMarginRulesQueryError = ErrorType<unknown>


/**
 * @summary List margin-protection rules
 */

export function useListPricingMarginRules<TData = Awaited<ReturnType<typeof listPricingMarginRules>>, TError = ErrorType<unknown>>(
 params?: ListPricingMarginRulesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingMarginRules>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPricingMarginRulesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreatePricingMarginRuleUrl = () => {




  return `/api/pricing/margin-rules`
}

/**
 * @summary Create a margin-protection rule
 */
export const createPricingMarginRule = async (pricingMarginRuleCreate: PricingMarginRuleCreate, options?: RequestInit): Promise<PricingMarginRule> => {

  return customFetch<PricingMarginRule>(getCreatePricingMarginRuleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pricingMarginRuleCreate)
  }
);}





export const getCreatePricingMarginRuleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPricingMarginRule>>, TError,{data: BodyType<PricingMarginRuleCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPricingMarginRule>>, TError,{data: BodyType<PricingMarginRuleCreate>}, TContext> => {

const mutationKey = ['createPricingMarginRule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPricingMarginRule>>, {data: BodyType<PricingMarginRuleCreate>}> = (props) => {
          const {data} = props ?? {};

          return  createPricingMarginRule(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePricingMarginRuleMutationResult = NonNullable<Awaited<ReturnType<typeof createPricingMarginRule>>>
    export type CreatePricingMarginRuleMutationBody = BodyType<PricingMarginRuleCreate>
    export type CreatePricingMarginRuleMutationError = ErrorType<unknown>

    /**
 * @summary Create a margin-protection rule
 */
export const useCreatePricingMarginRule = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPricingMarginRule>>, TError,{data: BodyType<PricingMarginRuleCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPricingMarginRule>>,
        TError,
        {data: BodyType<PricingMarginRuleCreate>},
        TContext
      > => {
      return useMutation(getCreatePricingMarginRuleMutationOptions(options));
    }

export const getUpdatePricingMarginRuleUrl = (id: string,) => {




  return `/api/pricing/margin-rules/${id}`
}

/**
 * @summary Update a margin-protection rule
 */
export const updatePricingMarginRule = async (id: string,
    pricingMarginRuleUpdate: PricingMarginRuleUpdate, options?: RequestInit): Promise<PricingMarginRule> => {

  return customFetch<PricingMarginRule>(getUpdatePricingMarginRuleUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pricingMarginRuleUpdate)
  }
);}





export const getUpdatePricingMarginRuleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePricingMarginRule>>, TError,{id: string;data: BodyType<PricingMarginRuleUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePricingMarginRule>>, TError,{id: string;data: BodyType<PricingMarginRuleUpdate>}, TContext> => {

const mutationKey = ['updatePricingMarginRule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePricingMarginRule>>, {id: string;data: BodyType<PricingMarginRuleUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePricingMarginRule(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePricingMarginRuleMutationResult = NonNullable<Awaited<ReturnType<typeof updatePricingMarginRule>>>
    export type UpdatePricingMarginRuleMutationBody = BodyType<PricingMarginRuleUpdate>
    export type UpdatePricingMarginRuleMutationError = ErrorType<unknown>

    /**
 * @summary Update a margin-protection rule
 */
export const useUpdatePricingMarginRule = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePricingMarginRule>>, TError,{id: string;data: BodyType<PricingMarginRuleUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePricingMarginRule>>,
        TError,
        {id: string;data: BodyType<PricingMarginRuleUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePricingMarginRuleMutationOptions(options));
    }

export const getDeletePricingMarginRuleUrl = (id: string,) => {




  return `/api/pricing/margin-rules/${id}`
}

/**
 * @summary Delete a margin-protection rule
 */
export const deletePricingMarginRule = async (id: string, options?: RequestInit): Promise<DeletePricingMarginRule200> => {

  return customFetch<DeletePricingMarginRule200>(getDeletePricingMarginRuleUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeletePricingMarginRuleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePricingMarginRule>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePricingMarginRule>>, TError,{id: string}, TContext> => {

const mutationKey = ['deletePricingMarginRule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePricingMarginRule>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deletePricingMarginRule(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePricingMarginRuleMutationResult = NonNullable<Awaited<ReturnType<typeof deletePricingMarginRule>>>

    export type DeletePricingMarginRuleMutationError = ErrorType<unknown>

    /**
 * @summary Delete a margin-protection rule
 */
export const useDeletePricingMarginRule = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePricingMarginRule>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePricingMarginRule>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeletePricingMarginRuleMutationOptions(options));
    }

export const getGetPricingCalculationSnapshotUrl = (id: string,) => {




  return `/api/pricing/snapshots/${id}`
}

/**
 * @summary Full cost-breakdown snapshot for a computed candidate price
 */
export const getPricingCalculationSnapshot = async (id: string, options?: RequestInit): Promise<PricingCalculationSnapshot> => {

  return customFetch<PricingCalculationSnapshot>(getGetPricingCalculationSnapshotUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPricingCalculationSnapshotQueryKey = (id: string,) => {
    return [
    `/api/pricing/snapshots/${id}`
    ] as const;
    }


export const getGetPricingCalculationSnapshotQueryOptions = <TData = Awaited<ReturnType<typeof getPricingCalculationSnapshot>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPricingCalculationSnapshot>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPricingCalculationSnapshotQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPricingCalculationSnapshot>>> = ({ signal }) => getPricingCalculationSnapshot(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPricingCalculationSnapshot>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPricingCalculationSnapshotQueryResult = NonNullable<Awaited<ReturnType<typeof getPricingCalculationSnapshot>>>
export type GetPricingCalculationSnapshotQueryError = ErrorType<unknown>


/**
 * @summary Full cost-breakdown snapshot for a computed candidate price
 */

export function useGetPricingCalculationSnapshot<TData = Awaited<ReturnType<typeof getPricingCalculationSnapshot>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPricingCalculationSnapshot>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPricingCalculationSnapshotQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPricingMarginOverridesUrl = (params?: ListPricingMarginOverridesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pricing/margin-overrides?${stringifiedParams}` : `/api/pricing/margin-overrides`
}

/**
 * @summary Audited margin-override history (newest first)
 */
export const listPricingMarginOverrides = async (params?: ListPricingMarginOverridesParams, options?: RequestInit): Promise<ListPricingMarginOverrides200> => {

  return customFetch<ListPricingMarginOverrides200>(getListPricingMarginOverridesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPricingMarginOverridesQueryKey = (params?: ListPricingMarginOverridesParams,) => {
    return [
    `/api/pricing/margin-overrides`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPricingMarginOverridesQueryOptions = <TData = Awaited<ReturnType<typeof listPricingMarginOverrides>>, TError = ErrorType<unknown>>(params?: ListPricingMarginOverridesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingMarginOverrides>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPricingMarginOverridesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPricingMarginOverrides>>> = ({ signal }) => listPricingMarginOverrides(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPricingMarginOverrides>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPricingMarginOverridesQueryResult = NonNullable<Awaited<ReturnType<typeof listPricingMarginOverrides>>>
export type ListPricingMarginOverridesQueryError = ErrorType<unknown>


/**
 * @summary Audited margin-override history (newest first)
 */

export function useListPricingMarginOverrides<TData = Awaited<ReturnType<typeof listPricingMarginOverrides>>, TError = ErrorType<unknown>>(
 params?: ListPricingMarginOverridesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingMarginOverrides>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPricingMarginOverridesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPricingApprovalsUrl = (params?: ListPricingApprovalsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pricing/approvals?${stringifiedParams}` : `/api/pricing/approvals`
}

/**
 * @summary List price-change approvals (filter by status)
 */
export const listPricingApprovals = async (params?: ListPricingApprovalsParams, options?: RequestInit): Promise<ListPricingApprovals200> => {

  return customFetch<ListPricingApprovals200>(getListPricingApprovalsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPricingApprovalsQueryKey = (params?: ListPricingApprovalsParams,) => {
    return [
    `/api/pricing/approvals`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPricingApprovalsQueryOptions = <TData = Awaited<ReturnType<typeof listPricingApprovals>>, TError = ErrorType<unknown>>(params?: ListPricingApprovalsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingApprovals>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPricingApprovalsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPricingApprovals>>> = ({ signal }) => listPricingApprovals(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPricingApprovals>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPricingApprovalsQueryResult = NonNullable<Awaited<ReturnType<typeof listPricingApprovals>>>
export type ListPricingApprovalsQueryError = ErrorType<unknown>


/**
 * @summary List price-change approvals (filter by status)
 */

export function useListPricingApprovals<TData = Awaited<ReturnType<typeof listPricingApprovals>>, TError = ErrorType<unknown>>(
 params?: ListPricingApprovalsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingApprovals>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPricingApprovalsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getApprovePricingChangeUrl = (id: string,) => {




  return `/api/pricing/approvals/${id}/approve`
}

/**
 * Flips the recommendation to `approved` and enqueues a pricing_publish background job which re-checks margin protection, applies the price internally, and (when `publish: true` — Approve & Push) pushes to the item's marketplace channels. Hard-blocked proposals can only be approved by a user holding the margin-override permission, with `overrideReason` and `confirmOverride: true` in the body (recorded in the audited margin-override history).
 * @summary Approve a pending price change (async apply/publish via job)
 */
export const approvePricingChange = async (id: string,
    approvePricingChangeBody?: ApprovePricingChangeBody, options?: RequestInit): Promise<PricingApprovalActionResult> => {

  return customFetch<PricingApprovalActionResult>(getApprovePricingChangeUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(approvePricingChangeBody)
  }
);}





export const getApprovePricingChangeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePricingChange>>, TError,{id: string;data?: BodyType<ApprovePricingChangeBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approvePricingChange>>, TError,{id: string;data?: BodyType<ApprovePricingChangeBody>}, TContext> => {

const mutationKey = ['approvePricingChange'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approvePricingChange>>, {id: string;data?: BodyType<ApprovePricingChangeBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  approvePricingChange(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApprovePricingChangeMutationResult = NonNullable<Awaited<ReturnType<typeof approvePricingChange>>>
    export type ApprovePricingChangeMutationBody = BodyType<ApprovePricingChangeBody> | undefined
    export type ApprovePricingChangeMutationError = ErrorType<unknown>

    /**
 * @summary Approve a pending price change (async apply/publish via job)
 */
export const useApprovePricingChange = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePricingChange>>, TError,{id: string;data?: BodyType<ApprovePricingChangeBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approvePricingChange>>,
        TError,
        {id: string;data?: BodyType<ApprovePricingChangeBody>},
        TContext
      > => {
      return useMutation(getApprovePricingChangeMutationOptions(options));
    }

export const getEditPricingChangeUrl = (id: string,) => {




  return `/api/pricing/approvals/${id}/edit`
}

/**
 * @summary Edit the proposed price on a pending recommendation
 */
export const editPricingChange = async (id: string,
    editPricingChangeBody: EditPricingChangeBody, options?: RequestInit): Promise<PricingChangeApproval> => {

  return customFetch<PricingChangeApproval>(getEditPricingChangeUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(editPricingChangeBody)
  }
);}





export const getEditPricingChangeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editPricingChange>>, TError,{id: string;data: BodyType<EditPricingChangeBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof editPricingChange>>, TError,{id: string;data: BodyType<EditPricingChangeBody>}, TContext> => {

const mutationKey = ['editPricingChange'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editPricingChange>>, {id: string;data: BodyType<EditPricingChangeBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  editPricingChange(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditPricingChangeMutationResult = NonNullable<Awaited<ReturnType<typeof editPricingChange>>>
    export type EditPricingChangeMutationBody = BodyType<EditPricingChangeBody>
    export type EditPricingChangeMutationError = ErrorType<unknown>

    /**
 * @summary Edit the proposed price on a pending recommendation
 */
export const useEditPricingChange = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editPricingChange>>, TError,{id: string;data: BodyType<EditPricingChangeBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof editPricingChange>>,
        TError,
        {id: string;data: BodyType<EditPricingChangeBody>},
        TContext
      > => {
      return useMutation(getEditPricingChangeMutationOptions(options));
    }

export const getSchedulePricingChangeUrl = (id: string,) => {




  return `/api/pricing/approvals/${id}/schedule`
}

/**
 * @summary Schedule a pending recommendation for a future date-time
 */
export const schedulePricingChange = async (id: string,
    schedulePricingChangeBody: SchedulePricingChangeBody, options?: RequestInit): Promise<PricingChangeApproval> => {

  return customFetch<PricingChangeApproval>(getSchedulePricingChangeUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(schedulePricingChangeBody)
  }
);}





export const getSchedulePricingChangeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof schedulePricingChange>>, TError,{id: string;data: BodyType<SchedulePricingChangeBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof schedulePricingChange>>, TError,{id: string;data: BodyType<SchedulePricingChangeBody>}, TContext> => {

const mutationKey = ['schedulePricingChange'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof schedulePricingChange>>, {id: string;data: BodyType<SchedulePricingChangeBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  schedulePricingChange(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SchedulePricingChangeMutationResult = NonNullable<Awaited<ReturnType<typeof schedulePricingChange>>>
    export type SchedulePricingChangeMutationBody = BodyType<SchedulePricingChangeBody>
    export type SchedulePricingChangeMutationError = ErrorType<unknown>

    /**
 * @summary Schedule a pending recommendation for a future date-time
 */
export const useSchedulePricingChange = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof schedulePricingChange>>, TError,{id: string;data: BodyType<SchedulePricingChangeBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof schedulePricingChange>>,
        TError,
        {id: string;data: BodyType<SchedulePricingChangeBody>},
        TContext
      > => {
      return useMutation(getSchedulePricingChangeMutationOptions(options));
    }

export const getIgnorePricingChangeUrl = (id: string,) => {




  return `/api/pricing/approvals/${id}/ignore`
}

/**
 * @summary Ignore (dismiss) a pending recommendation
 */
export const ignorePricingChange = async (id: string, options?: RequestInit): Promise<PricingChangeApproval> => {

  return customFetch<PricingChangeApproval>(getIgnorePricingChangeUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getIgnorePricingChangeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ignorePricingChange>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof ignorePricingChange>>, TError,{id: string}, TContext> => {

const mutationKey = ['ignorePricingChange'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ignorePricingChange>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  ignorePricingChange(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IgnorePricingChangeMutationResult = NonNullable<Awaited<ReturnType<typeof ignorePricingChange>>>

    export type IgnorePricingChangeMutationError = ErrorType<unknown>

    /**
 * @summary Ignore (dismiss) a pending recommendation
 */
export const useIgnorePricingChange = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ignorePricingChange>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof ignorePricingChange>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getIgnorePricingChangeMutationOptions(options));
    }

export const getGetPricingChangeBreakdownUrl = (id: string,) => {




  return `/api/pricing/approvals/${id}/breakdown`
}

/**
 * @summary Full calculation breakdown + push history for a recommendation
 */
export const getPricingChangeBreakdown = async (id: string, options?: RequestInit): Promise<PricingApprovalBreakdown> => {

  return customFetch<PricingApprovalBreakdown>(getGetPricingChangeBreakdownUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPricingChangeBreakdownQueryKey = (id: string,) => {
    return [
    `/api/pricing/approvals/${id}/breakdown`
    ] as const;
    }


export const getGetPricingChangeBreakdownQueryOptions = <TData = Awaited<ReturnType<typeof getPricingChangeBreakdown>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPricingChangeBreakdown>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPricingChangeBreakdownQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPricingChangeBreakdown>>> = ({ signal }) => getPricingChangeBreakdown(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPricingChangeBreakdown>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPricingChangeBreakdownQueryResult = NonNullable<Awaited<ReturnType<typeof getPricingChangeBreakdown>>>
export type GetPricingChangeBreakdownQueryError = ErrorType<unknown>


/**
 * @summary Full calculation breakdown + push history for a recommendation
 */

export function useGetPricingChangeBreakdown<TData = Awaited<ReturnType<typeof getPricingChangeBreakdown>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPricingChangeBreakdown>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPricingChangeBreakdownQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPricingHistoryUrl = (params?: ListPricingHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pricing/history?${stringifiedParams}` : `/api/pricing/history`
}

/**
 * @summary List durable price history (newest first)
 */
export const listPricingHistory = async (params?: ListPricingHistoryParams, options?: RequestInit): Promise<ListPricingHistory200> => {

  return customFetch<ListPricingHistory200>(getListPricingHistoryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPricingHistoryQueryKey = (params?: ListPricingHistoryParams,) => {
    return [
    `/api/pricing/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPricingHistoryQueryOptions = <TData = Awaited<ReturnType<typeof listPricingHistory>>, TError = ErrorType<unknown>>(params?: ListPricingHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPricingHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPricingHistory>>> = ({ signal }) => listPricingHistory(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPricingHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPricingHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof listPricingHistory>>>
export type ListPricingHistoryQueryError = ErrorType<unknown>


/**
 * @summary List durable price history (newest first)
 */

export function useListPricingHistory<TData = Awaited<ReturnType<typeof listPricingHistory>>, TError = ErrorType<unknown>>(
 params?: ListPricingHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPricingHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPricingSchedulesUrl = () => {




  return `/api/pricing/schedules`
}

/**
 * @summary List price schedules
 */
export const listPricingSchedules = async ( options?: RequestInit): Promise<ListPricingSchedules200> => {

  return customFetch<ListPricingSchedules200>(getListPricingSchedulesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPricingSchedulesQueryKey = () => {
    return [
    `/api/pricing/schedules`
    ] as const;
    }


export const getListPricingSchedulesQueryOptions = <TData = Awaited<ReturnType<typeof listPricingSchedules>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingSchedules>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPricingSchedulesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPricingSchedules>>> = ({ signal }) => listPricingSchedules({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPricingSchedules>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPricingSchedulesQueryResult = NonNullable<Awaited<ReturnType<typeof listPricingSchedules>>>
export type ListPricingSchedulesQueryError = ErrorType<unknown>


/**
 * @summary List price schedules
 */

export function useListPricingSchedules<TData = Awaited<ReturnType<typeof listPricingSchedules>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingSchedules>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPricingSchedulesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreatePricingScheduleUrl = () => {




  return `/api/pricing/schedules`
}

/**
 * @summary Create a price schedule (window / weekday / campaign)
 */
export const createPricingSchedule = async (pricingScheduleUpsert: PricingScheduleUpsert, options?: RequestInit): Promise<PricingSchedule> => {

  return customFetch<PricingSchedule>(getCreatePricingScheduleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pricingScheduleUpsert)
  }
);}





export const getCreatePricingScheduleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPricingSchedule>>, TError,{data: BodyType<PricingScheduleUpsert>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPricingSchedule>>, TError,{data: BodyType<PricingScheduleUpsert>}, TContext> => {

const mutationKey = ['createPricingSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPricingSchedule>>, {data: BodyType<PricingScheduleUpsert>}> = (props) => {
          const {data} = props ?? {};

          return  createPricingSchedule(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePricingScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof createPricingSchedule>>>
    export type CreatePricingScheduleMutationBody = BodyType<PricingScheduleUpsert>
    export type CreatePricingScheduleMutationError = ErrorType<unknown>

    /**
 * @summary Create a price schedule (window / weekday / campaign)
 */
export const useCreatePricingSchedule = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPricingSchedule>>, TError,{data: BodyType<PricingScheduleUpsert>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPricingSchedule>>,
        TError,
        {data: BodyType<PricingScheduleUpsert>},
        TContext
      > => {
      return useMutation(getCreatePricingScheduleMutationOptions(options));
    }

export const getUpdatePricingScheduleUrl = (id: string,) => {




  return `/api/pricing/schedules/${id}`
}

/**
 * @summary Update a price schedule
 */
export const updatePricingSchedule = async (id: string,
    pricingScheduleUpsert: PricingScheduleUpsert, options?: RequestInit): Promise<PricingSchedule> => {

  return customFetch<PricingSchedule>(getUpdatePricingScheduleUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pricingScheduleUpsert)
  }
);}





export const getUpdatePricingScheduleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePricingSchedule>>, TError,{id: string;data: BodyType<PricingScheduleUpsert>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePricingSchedule>>, TError,{id: string;data: BodyType<PricingScheduleUpsert>}, TContext> => {

const mutationKey = ['updatePricingSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePricingSchedule>>, {id: string;data: BodyType<PricingScheduleUpsert>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePricingSchedule(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePricingScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof updatePricingSchedule>>>
    export type UpdatePricingScheduleMutationBody = BodyType<PricingScheduleUpsert>
    export type UpdatePricingScheduleMutationError = ErrorType<unknown>

    /**
 * @summary Update a price schedule
 */
export const useUpdatePricingSchedule = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePricingSchedule>>, TError,{id: string;data: BodyType<PricingScheduleUpsert>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePricingSchedule>>,
        TError,
        {id: string;data: BodyType<PricingScheduleUpsert>},
        TContext
      > => {
      return useMutation(getUpdatePricingScheduleMutationOptions(options));
    }

export const getDeletePricingScheduleUrl = (id: string,) => {




  return `/api/pricing/schedules/${id}`
}

/**
 * @summary Delete a price schedule
 */
export const deletePricingSchedule = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeletePricingScheduleUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeletePricingScheduleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePricingSchedule>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePricingSchedule>>, TError,{id: string}, TContext> => {

const mutationKey = ['deletePricingSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePricingSchedule>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deletePricingSchedule(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePricingScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof deletePricingSchedule>>>

    export type DeletePricingScheduleMutationError = ErrorType<unknown>

    /**
 * @summary Delete a price schedule
 */
export const useDeletePricingSchedule = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePricingSchedule>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePricingSchedule>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeletePricingScheduleMutationOptions(options));
    }

export const getListPricingBulkJobsUrl = () => {




  return `/api/pricing/bulk-jobs`
}

/**
 * @summary List bulk pricing jobs (newest first)
 */
export const listPricingBulkJobs = async ( options?: RequestInit): Promise<ListPricingBulkJobs200> => {

  return customFetch<ListPricingBulkJobs200>(getListPricingBulkJobsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPricingBulkJobsQueryKey = () => {
    return [
    `/api/pricing/bulk-jobs`
    ] as const;
    }


export const getListPricingBulkJobsQueryOptions = <TData = Awaited<ReturnType<typeof listPricingBulkJobs>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingBulkJobs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPricingBulkJobsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPricingBulkJobs>>> = ({ signal }) => listPricingBulkJobs({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPricingBulkJobs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPricingBulkJobsQueryResult = NonNullable<Awaited<ReturnType<typeof listPricingBulkJobs>>>
export type ListPricingBulkJobsQueryError = ErrorType<unknown>


/**
 * @summary List bulk pricing jobs (newest first)
 */

export function useListPricingBulkJobs<TData = Awaited<ReturnType<typeof listPricingBulkJobs>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingBulkJobs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPricingBulkJobsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreatePricingBulkJobUrl = () => {




  return `/api/pricing/bulk-jobs`
}

/**
 * @summary Start a bulk pricing simulation (changes nothing until confirmed)
 */
export const createPricingBulkJob = async (createPricingBulkJobBody: CreatePricingBulkJobBody, options?: RequestInit): Promise<PricingBulkJob> => {

  return customFetch<PricingBulkJob>(getCreatePricingBulkJobUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createPricingBulkJobBody)
  }
);}





export const getCreatePricingBulkJobMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPricingBulkJob>>, TError,{data: BodyType<CreatePricingBulkJobBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPricingBulkJob>>, TError,{data: BodyType<CreatePricingBulkJobBody>}, TContext> => {

const mutationKey = ['createPricingBulkJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPricingBulkJob>>, {data: BodyType<CreatePricingBulkJobBody>}> = (props) => {
          const {data} = props ?? {};

          return  createPricingBulkJob(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePricingBulkJobMutationResult = NonNullable<Awaited<ReturnType<typeof createPricingBulkJob>>>
    export type CreatePricingBulkJobMutationBody = BodyType<CreatePricingBulkJobBody>
    export type CreatePricingBulkJobMutationError = ErrorType<unknown>

    /**
 * @summary Start a bulk pricing simulation (changes nothing until confirmed)
 */
export const useCreatePricingBulkJob = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPricingBulkJob>>, TError,{data: BodyType<CreatePricingBulkJobBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPricingBulkJob>>,
        TError,
        {data: BodyType<CreatePricingBulkJobBody>},
        TContext
      > => {
      return useMutation(getCreatePricingBulkJobMutationOptions(options));
    }

export const getGetPricingBulkJobUrl = (id: string,) => {




  return `/api/pricing/bulk-jobs/${id}`
}

/**
 * @summary Get a bulk pricing job (includes per-item simulation rows)
 */
export const getPricingBulkJob = async (id: string, options?: RequestInit): Promise<PricingBulkJob> => {

  return customFetch<PricingBulkJob>(getGetPricingBulkJobUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPricingBulkJobQueryKey = (id: string,) => {
    return [
    `/api/pricing/bulk-jobs/${id}`
    ] as const;
    }


export const getGetPricingBulkJobQueryOptions = <TData = Awaited<ReturnType<typeof getPricingBulkJob>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPricingBulkJob>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPricingBulkJobQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPricingBulkJob>>> = ({ signal }) => getPricingBulkJob(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPricingBulkJob>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPricingBulkJobQueryResult = NonNullable<Awaited<ReturnType<typeof getPricingBulkJob>>>
export type GetPricingBulkJobQueryError = ErrorType<unknown>


/**
 * @summary Get a bulk pricing job (includes per-item simulation rows)
 */

export function useGetPricingBulkJob<TData = Awaited<ReturnType<typeof getPricingBulkJob>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPricingBulkJob>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPricingBulkJobQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getConfirmPricingBulkJobUrl = (id: string,) => {




  return `/api/pricing/bulk-jobs/${id}/confirm`
}

/**
 * @summary Confirm a simulated bulk job (applies via background job)
 */
export const confirmPricingBulkJob = async (id: string, options?: RequestInit): Promise<PricingBulkJob> => {

  return customFetch<PricingBulkJob>(getConfirmPricingBulkJobUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getConfirmPricingBulkJobMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmPricingBulkJob>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmPricingBulkJob>>, TError,{id: string}, TContext> => {

const mutationKey = ['confirmPricingBulkJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmPricingBulkJob>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  confirmPricingBulkJob(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmPricingBulkJobMutationResult = NonNullable<Awaited<ReturnType<typeof confirmPricingBulkJob>>>

    export type ConfirmPricingBulkJobMutationError = ErrorType<unknown>

    /**
 * @summary Confirm a simulated bulk job (applies via background job)
 */
export const useConfirmPricingBulkJob = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmPricingBulkJob>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof confirmPricingBulkJob>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getConfirmPricingBulkJobMutationOptions(options));
    }

export const getCancelPricingBulkJobUrl = (id: string,) => {




  return `/api/pricing/bulk-jobs/${id}/cancel`
}

/**
 * @summary Cancel a bulk job before confirmation
 */
export const cancelPricingBulkJob = async (id: string, options?: RequestInit): Promise<PricingBulkJob> => {

  return customFetch<PricingBulkJob>(getCancelPricingBulkJobUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelPricingBulkJobMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelPricingBulkJob>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelPricingBulkJob>>, TError,{id: string}, TContext> => {

const mutationKey = ['cancelPricingBulkJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelPricingBulkJob>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  cancelPricingBulkJob(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelPricingBulkJobMutationResult = NonNullable<Awaited<ReturnType<typeof cancelPricingBulkJob>>>

    export type CancelPricingBulkJobMutationError = ErrorType<unknown>

    /**
 * @summary Cancel a bulk job before confirmation
 */
export const useCancelPricingBulkJob = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelPricingBulkJob>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelPricingBulkJob>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getCancelPricingBulkJobMutationOptions(options));
    }

export const getRejectPricingChangeUrl = (id: string,) => {




  return `/api/pricing/approvals/${id}/reject`
}

/**
 * @summary Reject a pending price change
 */
export const rejectPricingChange = async (id: string, options?: RequestInit): Promise<PricingChangeApproval> => {

  return customFetch<PricingChangeApproval>(getRejectPricingChangeUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRejectPricingChangeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectPricingChange>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectPricingChange>>, TError,{id: string}, TContext> => {

const mutationKey = ['rejectPricingChange'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectPricingChange>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  rejectPricingChange(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectPricingChangeMutationResult = NonNullable<Awaited<ReturnType<typeof rejectPricingChange>>>

    export type RejectPricingChangeMutationError = ErrorType<unknown>

    /**
 * @summary Reject a pending price change
 */
export const useRejectPricingChange = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectPricingChange>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rejectPricingChange>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getRejectPricingChangeMutationOptions(options));
    }

export const getRunPricingNowUrl = () => {




  return `/api/pricing/run`
}

/**
 * @summary Run a repricing pass now (manual trigger)
 */
export const runPricingNow = async ( options?: RequestInit): Promise<PricingRunResult> => {

  return customFetch<PricingRunResult>(getRunPricingNowUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRunPricingNowMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runPricingNow>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof runPricingNow>>, TError,void, TContext> => {

const mutationKey = ['runPricingNow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runPricingNow>>, void> = () => {


          return  runPricingNow(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunPricingNowMutationResult = NonNullable<Awaited<ReturnType<typeof runPricingNow>>>

    export type RunPricingNowMutationError = ErrorType<unknown>

    /**
 * @summary Run a repricing pass now (manual trigger)
 */
export const useRunPricingNow = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runPricingNow>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof runPricingNow>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRunPricingNowMutationOptions(options));
    }

export const getListPricingRunLogsUrl = (params?: ListPricingRunLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pricing/run-logs?${stringifiedParams}` : `/api/pricing/run-logs`
}

/**
 * @summary List pricing run logs (newest first)
 */
export const listPricingRunLogs = async (params?: ListPricingRunLogsParams, options?: RequestInit): Promise<ListPricingRunLogs200> => {

  return customFetch<ListPricingRunLogs200>(getListPricingRunLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPricingRunLogsQueryKey = (params?: ListPricingRunLogsParams,) => {
    return [
    `/api/pricing/run-logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPricingRunLogsQueryOptions = <TData = Awaited<ReturnType<typeof listPricingRunLogs>>, TError = ErrorType<unknown>>(params?: ListPricingRunLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingRunLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPricingRunLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPricingRunLogs>>> = ({ signal }) => listPricingRunLogs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPricingRunLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPricingRunLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listPricingRunLogs>>>
export type ListPricingRunLogsQueryError = ErrorType<unknown>


/**
 * @summary List pricing run logs (newest first)
 */

export function useListPricingRunLogs<TData = Awaited<ReturnType<typeof listPricingRunLogs>>, TError = ErrorType<unknown>>(
 params?: ListPricingRunLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingRunLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPricingRunLogsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportPricingChangesUrl = () => {




  return `/api/pricing/export.csv`
}

/**
 * @summary Export all price-change approvals as CSV
 */
export const exportPricingChanges = async ( options?: RequestInit): Promise<string> => {

  return customFetch<string>(getExportPricingChangesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportPricingChangesQueryKey = () => {
    return [
    `/api/pricing/export.csv`
    ] as const;
    }


export const getExportPricingChangesQueryOptions = <TData = Awaited<ReturnType<typeof exportPricingChanges>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportPricingChanges>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportPricingChangesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportPricingChanges>>> = ({ signal }) => exportPricingChanges({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportPricingChanges>>, TError, TData> & { queryKey: QueryKey }
}

export type ExportPricingChangesQueryResult = NonNullable<Awaited<ReturnType<typeof exportPricingChanges>>>
export type ExportPricingChangesQueryError = ErrorType<unknown>


/**
 * @summary Export all price-change approvals as CSV
 */

export function useExportPricingChanges<TData = Awaited<ReturnType<typeof exportPricingChanges>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportPricingChanges>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getExportPricingChangesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPricingSettingsUrl = () => {




  return `/api/pricing/settings`
}

/**
 * @summary Get the tenant's dynamic-pricing settings
 */
export const getPricingSettings = async ( options?: RequestInit): Promise<PricingSettings> => {

  return customFetch<PricingSettings>(getGetPricingSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPricingSettingsQueryKey = () => {
    return [
    `/api/pricing/settings`
    ] as const;
    }


export const getGetPricingSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getPricingSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPricingSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPricingSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPricingSettings>>> = ({ signal }) => getPricingSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPricingSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPricingSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getPricingSettings>>>
export type GetPricingSettingsQueryError = ErrorType<unknown>


/**
 * @summary Get the tenant's dynamic-pricing settings
 */

export function useGetPricingSettings<TData = Awaited<ReturnType<typeof getPricingSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPricingSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPricingSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdatePricingSettingsUrl = () => {




  return `/api/pricing/settings`
}

/**
 * @summary Update the tenant's dynamic-pricing settings
 */
export const updatePricingSettings = async (pricingSettingsUpdate: PricingSettingsUpdate, options?: RequestInit): Promise<PricingSettings> => {

  return customFetch<PricingSettings>(getUpdatePricingSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pricingSettingsUpdate)
  }
);}





export const getUpdatePricingSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePricingSettings>>, TError,{data: BodyType<PricingSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePricingSettings>>, TError,{data: BodyType<PricingSettingsUpdate>}, TContext> => {

const mutationKey = ['updatePricingSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePricingSettings>>, {data: BodyType<PricingSettingsUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updatePricingSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePricingSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updatePricingSettings>>>
    export type UpdatePricingSettingsMutationBody = BodyType<PricingSettingsUpdate>
    export type UpdatePricingSettingsMutationError = ErrorType<unknown>

    /**
 * @summary Update the tenant's dynamic-pricing settings
 */
export const useUpdatePricingSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePricingSettings>>, TError,{data: BodyType<PricingSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePricingSettings>>,
        TError,
        {data: BodyType<PricingSettingsUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePricingSettingsMutationOptions(options));
    }

export const getGetPricingDashboardUrl = () => {




  return `/api/pricing/dashboard`
}

/**
 * @summary Pricing dashboard KPIs
 */
export const getPricingDashboard = async ( options?: RequestInit): Promise<PricingDashboard> => {

  return customFetch<PricingDashboard>(getGetPricingDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPricingDashboardQueryKey = () => {
    return [
    `/api/pricing/dashboard`
    ] as const;
    }


export const getGetPricingDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getPricingDashboard>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPricingDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPricingDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPricingDashboard>>> = ({ signal }) => getPricingDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPricingDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPricingDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getPricingDashboard>>>
export type GetPricingDashboardQueryError = ErrorType<unknown>


/**
 * @summary Pricing dashboard KPIs
 */

export function useGetPricingDashboard<TData = Awaited<ReturnType<typeof getPricingDashboard>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPricingDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPricingDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPricingProductsUrl = (params?: ListPricingProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pricing/products?${stringifiedParams}` : `/api/pricing/products`
}

/**
 * @summary Product pricing lens (below-target margin / premium / spot / marketplace)
 */
export const listPricingProducts = async (params?: ListPricingProductsParams, options?: RequestInit): Promise<PricingProductPage> => {

  return customFetch<PricingProductPage>(getListPricingProductsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPricingProductsQueryKey = (params?: ListPricingProductsParams,) => {
    return [
    `/api/pricing/products`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPricingProductsQueryOptions = <TData = Awaited<ReturnType<typeof listPricingProducts>>, TError = ErrorType<unknown>>(params?: ListPricingProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPricingProductsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPricingProducts>>> = ({ signal }) => listPricingProducts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPricingProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPricingProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listPricingProducts>>>
export type ListPricingProductsQueryError = ErrorType<unknown>


/**
 * @summary Product pricing lens (below-target margin / premium / spot / marketplace)
 */

export function useListPricingProducts<TData = Awaited<ReturnType<typeof listPricingProducts>>, TError = ErrorType<unknown>>(
 params?: ListPricingProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPricingProductsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPricingItemContextUrl = (inventoryItemId: string,
    params?: GetPricingItemContextParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pricing/products/${inventoryItemId}/context?${stringifiedParams}` : `/api/pricing/products/${inventoryItemId}/context`
}

/**
 * @summary Pricing context for one product (recommended price, margin status, costs)
 */
export const getPricingItemContext = async (inventoryItemId: string,
    params?: GetPricingItemContextParams, options?: RequestInit): Promise<PricingItemContext> => {

  return customFetch<PricingItemContext>(getGetPricingItemContextUrl(inventoryItemId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPricingItemContextQueryKey = (inventoryItemId: string,
    params?: GetPricingItemContextParams,) => {
    return [
    `/api/pricing/products/${inventoryItemId}/context`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPricingItemContextQueryOptions = <TData = Awaited<ReturnType<typeof getPricingItemContext>>, TError = ErrorType<unknown>>(inventoryItemId: string,
    params?: GetPricingItemContextParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPricingItemContext>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPricingItemContextQueryKey(inventoryItemId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPricingItemContext>>> = ({ signal }) => getPricingItemContext(inventoryItemId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: inventoryItemId !== null && inventoryItemId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPricingItemContext>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPricingItemContextQueryResult = NonNullable<Awaited<ReturnType<typeof getPricingItemContext>>>
export type GetPricingItemContextQueryError = ErrorType<unknown>


/**
 * @summary Pricing context for one product (recommended price, margin status, costs)
 */

export function useGetPricingItemContext<TData = Awaited<ReturnType<typeof getPricingItemContext>>, TError = ErrorType<unknown>>(
 inventoryItemId: string,
    params?: GetPricingItemContextParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPricingItemContext>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPricingItemContextQueryOptions(inventoryItemId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getEvaluatePricingMarginUrl = () => {




  return `/api/pricing/evaluate`
}

/**
 * Previews what the margin gate would say about a candidate price so the UI can warn before saving. Read-only — it authorises nothing; the write route still runs the authoritative gate.
 * @summary Read-only margin-protection preview for a candidate price
 */
export const evaluatePricingMargin = async (pricingEvaluateRequest: PricingEvaluateRequest, options?: RequestInit): Promise<PricingMarginPreview> => {

  return customFetch<PricingMarginPreview>(getEvaluatePricingMarginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pricingEvaluateRequest)
  }
);}





export const getEvaluatePricingMarginMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof evaluatePricingMargin>>, TError,{data: BodyType<PricingEvaluateRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof evaluatePricingMargin>>, TError,{data: BodyType<PricingEvaluateRequest>}, TContext> => {

const mutationKey = ['evaluatePricingMargin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof evaluatePricingMargin>>, {data: BodyType<PricingEvaluateRequest>}> = (props) => {
          const {data} = props ?? {};

          return  evaluatePricingMargin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EvaluatePricingMarginMutationResult = NonNullable<Awaited<ReturnType<typeof evaluatePricingMargin>>>
    export type EvaluatePricingMarginMutationBody = BodyType<PricingEvaluateRequest>
    export type EvaluatePricingMarginMutationError = ErrorType<unknown>

    /**
 * @summary Read-only margin-protection preview for a candidate price
 */
export const useEvaluatePricingMargin = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof evaluatePricingMargin>>, TError,{data: BodyType<PricingEvaluateRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof evaluatePricingMargin>>,
        TError,
        {data: BodyType<PricingEvaluateRequest>},
        TContext
      > => {
      return useMutation(getEvaluatePricingMarginMutationOptions(options));
    }

export const getExplainPricingUrl = () => {




  return `/api/pricing/explain`
}

/**
 * @summary Read-only AI explanation of a price, margin change, or portfolio outliers
 */
export const explainPricing = async (pricingExplainRequest: PricingExplainRequest, options?: RequestInit): Promise<PricingExplainResult> => {

  return customFetch<PricingExplainResult>(getExplainPricingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pricingExplainRequest)
  }
);}





export const getExplainPricingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof explainPricing>>, TError,{data: BodyType<PricingExplainRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof explainPricing>>, TError,{data: BodyType<PricingExplainRequest>}, TContext> => {

const mutationKey = ['explainPricing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof explainPricing>>, {data: BodyType<PricingExplainRequest>}> = (props) => {
          const {data} = props ?? {};

          return  explainPricing(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExplainPricingMutationResult = NonNullable<Awaited<ReturnType<typeof explainPricing>>>
    export type ExplainPricingMutationBody = BodyType<PricingExplainRequest>
    export type ExplainPricingMutationError = ErrorType<unknown>

    /**
 * @summary Read-only AI explanation of a price, margin change, or portfolio outliers
 */
export const useExplainPricing = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof explainPricing>>, TError,{data: BodyType<PricingExplainRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof explainPricing>>,
        TError,
        {data: BodyType<PricingExplainRequest>},
        TContext
      > => {
      return useMutation(getExplainPricingMutationOptions(options));
    }

export const getGetDocumentCatalogUrl = () => {




  return `/api/documents/catalog`
}

/**
 * @summary Document types available to this tenant (HR/scrap gated)
 */
export const getDocumentCatalog = async ( options?: RequestInit): Promise<GetDocumentCatalog200> => {

  return customFetch<GetDocumentCatalog200>(getGetDocumentCatalogUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDocumentCatalogQueryKey = () => {
    return [
    `/api/documents/catalog`
    ] as const;
    }


export const getGetDocumentCatalogQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentCatalog>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDocumentCatalog>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentCatalogQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentCatalog>>> = ({ signal }) => getDocumentCatalog({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentCatalog>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDocumentCatalogQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentCatalog>>>
export type GetDocumentCatalogQueryError = ErrorType<unknown>


/**
 * @summary Document types available to this tenant (HR/scrap gated)
 */

export function useGetDocumentCatalog<TData = Awaited<ReturnType<typeof getDocumentCatalog>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDocumentCatalog>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDocumentCatalogQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListDocumentTemplatesUrl = () => {




  return `/api/documents/templates`
}

/**
 * @summary List the current version of every document template group
 */
export const listDocumentTemplates = async ( options?: RequestInit): Promise<ListDocumentTemplates200> => {

  return customFetch<ListDocumentTemplates200>(getListDocumentTemplatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDocumentTemplatesQueryKey = () => {
    return [
    `/api/documents/templates`
    ] as const;
    }


export const getListDocumentTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof listDocumentTemplates>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDocumentTemplates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDocumentTemplatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDocumentTemplates>>> = ({ signal }) => listDocumentTemplates({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDocumentTemplates>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDocumentTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof listDocumentTemplates>>>
export type ListDocumentTemplatesQueryError = ErrorType<unknown>


/**
 * @summary List the current version of every document template group
 */

export function useListDocumentTemplates<TData = Awaited<ReturnType<typeof listDocumentTemplates>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDocumentTemplates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDocumentTemplatesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateDocumentTemplateUrl = () => {




  return `/api/documents/templates`
}

/**
 * @summary Create a new document template (version 1)
 */
export const createDocumentTemplate = async (createDocumentTemplate: CreateDocumentTemplate, options?: RequestInit): Promise<CreateDocumentTemplate201> => {

  return customFetch<CreateDocumentTemplate201>(getCreateDocumentTemplateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createDocumentTemplate)
  }
);}





export const getCreateDocumentTemplateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDocumentTemplate>>, TError,{data: BodyType<CreateDocumentTemplate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createDocumentTemplate>>, TError,{data: BodyType<CreateDocumentTemplate>}, TContext> => {

const mutationKey = ['createDocumentTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDocumentTemplate>>, {data: BodyType<CreateDocumentTemplate>}> = (props) => {
          const {data} = props ?? {};

          return  createDocumentTemplate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDocumentTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof createDocumentTemplate>>>
    export type CreateDocumentTemplateMutationBody = BodyType<CreateDocumentTemplate>
    export type CreateDocumentTemplateMutationError = ErrorType<void>

    /**
 * @summary Create a new document template (version 1)
 */
export const useCreateDocumentTemplate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDocumentTemplate>>, TError,{data: BodyType<CreateDocumentTemplate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createDocumentTemplate>>,
        TError,
        {data: BodyType<CreateDocumentTemplate>},
        TContext
      > => {
      return useMutation(getCreateDocumentTemplateMutationOptions(options));
    }

export const getGetDocumentTemplateGroupUrl = (groupId: string,) => {




  return `/api/documents/templates/${groupId}`
}

/**
 * @summary Current version + full version history of a template group
 */
export const getDocumentTemplateGroup = async (groupId: string, options?: RequestInit): Promise<GetDocumentTemplateGroup200> => {

  return customFetch<GetDocumentTemplateGroup200>(getGetDocumentTemplateGroupUrl(groupId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDocumentTemplateGroupQueryKey = (groupId: string,) => {
    return [
    `/api/documents/templates/${groupId}`
    ] as const;
    }


export const getGetDocumentTemplateGroupQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentTemplateGroup>>, TError = ErrorType<void>>(groupId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDocumentTemplateGroup>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentTemplateGroupQueryKey(groupId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentTemplateGroup>>> = ({ signal }) => getDocumentTemplateGroup(groupId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: groupId !== null && groupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentTemplateGroup>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDocumentTemplateGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentTemplateGroup>>>
export type GetDocumentTemplateGroupQueryError = ErrorType<void>


/**
 * @summary Current version + full version history of a template group
 */

export function useGetDocumentTemplateGroup<TData = Awaited<ReturnType<typeof getDocumentTemplateGroup>>, TError = ErrorType<void>>(
 groupId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDocumentTemplateGroup>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDocumentTemplateGroupQueryOptions(groupId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateDocumentTemplateUrl = (groupId: string,) => {




  return `/api/documents/templates/${groupId}`
}

/**
 * @summary Edit a template (publishes a new version)
 */
export const updateDocumentTemplate = async (groupId: string,
    updateDocumentTemplate: UpdateDocumentTemplate, options?: RequestInit): Promise<UpdateDocumentTemplate200> => {

  return customFetch<UpdateDocumentTemplate200>(getUpdateDocumentTemplateUrl(groupId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateDocumentTemplate)
  }
);}





export const getUpdateDocumentTemplateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDocumentTemplate>>, TError,{groupId: string;data: BodyType<UpdateDocumentTemplate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDocumentTemplate>>, TError,{groupId: string;data: BodyType<UpdateDocumentTemplate>}, TContext> => {

const mutationKey = ['updateDocumentTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDocumentTemplate>>, {groupId: string;data: BodyType<UpdateDocumentTemplate>}> = (props) => {
          const {groupId,data} = props ?? {};

          return  updateDocumentTemplate(groupId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDocumentTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof updateDocumentTemplate>>>
    export type UpdateDocumentTemplateMutationBody = BodyType<UpdateDocumentTemplate>
    export type UpdateDocumentTemplateMutationError = ErrorType<void>

    /**
 * @summary Edit a template (publishes a new version)
 */
export const useUpdateDocumentTemplate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDocumentTemplate>>, TError,{groupId: string;data: BodyType<UpdateDocumentTemplate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDocumentTemplate>>,
        TError,
        {groupId: string;data: BodyType<UpdateDocumentTemplate>},
        TContext
      > => {
      return useMutation(getUpdateDocumentTemplateMutationOptions(options));
    }

export const getPublishDocumentTemplateUrl = (groupId: string,) => {




  return `/api/documents/templates/${groupId}/publish`
}

/**
 * @summary Publish the current version of a template
 */
export const publishDocumentTemplate = async (groupId: string, options?: RequestInit): Promise<PublishDocumentTemplate200> => {

  return customFetch<PublishDocumentTemplate200>(getPublishDocumentTemplateUrl(groupId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPublishDocumentTemplateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishDocumentTemplate>>, TError,{groupId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof publishDocumentTemplate>>, TError,{groupId: string}, TContext> => {

const mutationKey = ['publishDocumentTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishDocumentTemplate>>, {groupId: string}> = (props) => {
          const {groupId} = props ?? {};

          return  publishDocumentTemplate(groupId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishDocumentTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof publishDocumentTemplate>>>

    export type PublishDocumentTemplateMutationError = ErrorType<void>

    /**
 * @summary Publish the current version of a template
 */
export const usePublishDocumentTemplate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishDocumentTemplate>>, TError,{groupId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof publishDocumentTemplate>>,
        TError,
        {groupId: string},
        TContext
      > => {
      return useMutation(getPublishDocumentTemplateMutationOptions(options));
    }

export const getArchiveDocumentTemplateUrl = (groupId: string,) => {




  return `/api/documents/templates/${groupId}/archive`
}

/**
 * @summary Archive the current version of a template
 */
export const archiveDocumentTemplate = async (groupId: string, options?: RequestInit): Promise<ArchiveDocumentTemplate200> => {

  return customFetch<ArchiveDocumentTemplate200>(getArchiveDocumentTemplateUrl(groupId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getArchiveDocumentTemplateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveDocumentTemplate>>, TError,{groupId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveDocumentTemplate>>, TError,{groupId: string}, TContext> => {

const mutationKey = ['archiveDocumentTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveDocumentTemplate>>, {groupId: string}> = (props) => {
          const {groupId} = props ?? {};

          return  archiveDocumentTemplate(groupId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveDocumentTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof archiveDocumentTemplate>>>

    export type ArchiveDocumentTemplateMutationError = ErrorType<void>

    /**
 * @summary Archive the current version of a template
 */
export const useArchiveDocumentTemplate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveDocumentTemplate>>, TError,{groupId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof archiveDocumentTemplate>>,
        TError,
        {groupId: string},
        TContext
      > => {
      return useMutation(getArchiveDocumentTemplateMutationOptions(options));
    }

export const getPreviewDocumentUrl = () => {




  return `/api/documents/preview`
}

/**
 * @summary Render a template body against a source record without storing
 */
export const previewDocument = async (previewDocumentRequest: PreviewDocumentRequest, options?: RequestInit): Promise<DocumentPreviewResult> => {

  return customFetch<DocumentPreviewResult>(getPreviewDocumentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(previewDocumentRequest)
  }
);}





export const getPreviewDocumentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewDocument>>, TError,{data: BodyType<PreviewDocumentRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewDocument>>, TError,{data: BodyType<PreviewDocumentRequest>}, TContext> => {

const mutationKey = ['previewDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewDocument>>, {data: BodyType<PreviewDocumentRequest>}> = (props) => {
          const {data} = props ?? {};

          return  previewDocument(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof previewDocument>>>
    export type PreviewDocumentMutationBody = BodyType<PreviewDocumentRequest>
    export type PreviewDocumentMutationError = ErrorType<void>

    /**
 * @summary Render a template body against a source record without storing
 */
export const usePreviewDocument = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewDocument>>, TError,{data: BodyType<PreviewDocumentRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof previewDocument>>,
        TError,
        {data: BodyType<PreviewDocumentRequest>},
        TContext
      > => {
      return useMutation(getPreviewDocumentMutationOptions(options));
    }

export const getGenerateDocumentUrl = () => {




  return `/api/documents/generate`
}

/**
 * @summary Generate + store a document from a template/source record
 */
export const generateDocument = async (generateDocumentRequest: GenerateDocumentRequest, options?: RequestInit): Promise<GenerateDocumentResult> => {

  return customFetch<GenerateDocumentResult>(getGenerateDocumentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(generateDocumentRequest)
  }
);}





export const getGenerateDocumentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateDocument>>, TError,{data: BodyType<GenerateDocumentRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof generateDocument>>, TError,{data: BodyType<GenerateDocumentRequest>}, TContext> => {

const mutationKey = ['generateDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateDocument>>, {data: BodyType<GenerateDocumentRequest>}> = (props) => {
          const {data} = props ?? {};

          return  generateDocument(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof generateDocument>>>
    export type GenerateDocumentMutationBody = BodyType<GenerateDocumentRequest>
    export type GenerateDocumentMutationError = ErrorType<void>

    /**
 * @summary Generate + store a document from a template/source record
 */
export const useGenerateDocument = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateDocument>>, TError,{data: BodyType<GenerateDocumentRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof generateDocument>>,
        TError,
        {data: BodyType<GenerateDocumentRequest>},
        TContext
      > => {
      return useMutation(getGenerateDocumentMutationOptions(options));
    }

export const getListGeneratedDocumentsUrl = (params?: ListGeneratedDocumentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/documents?${stringifiedParams}` : `/api/documents`
}

/**
 * @summary List generated documents
 */
export const listGeneratedDocuments = async (params?: ListGeneratedDocumentsParams, options?: RequestInit): Promise<ListGeneratedDocuments200> => {

  return customFetch<ListGeneratedDocuments200>(getListGeneratedDocumentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListGeneratedDocumentsQueryKey = (params?: ListGeneratedDocumentsParams,) => {
    return [
    `/api/documents`, ...(params ? [params] : [])
    ] as const;
    }


export const getListGeneratedDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof listGeneratedDocuments>>, TError = ErrorType<unknown>>(params?: ListGeneratedDocumentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listGeneratedDocuments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGeneratedDocumentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGeneratedDocuments>>> = ({ signal }) => listGeneratedDocuments(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGeneratedDocuments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListGeneratedDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listGeneratedDocuments>>>
export type ListGeneratedDocumentsQueryError = ErrorType<unknown>


/**
 * @summary List generated documents
 */

export function useListGeneratedDocuments<TData = Awaited<ReturnType<typeof listGeneratedDocuments>>, TError = ErrorType<unknown>>(
 params?: ListGeneratedDocumentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listGeneratedDocuments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListGeneratedDocumentsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListDocumentLogsUrl = (params?: ListDocumentLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/documents/logs?${stringifiedParams}` : `/api/documents/logs`
}

/**
 * @summary Generation logs (optionally filtered by document)
 */
export const listDocumentLogs = async (params?: ListDocumentLogsParams, options?: RequestInit): Promise<ListDocumentLogs200> => {

  return customFetch<ListDocumentLogs200>(getListDocumentLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDocumentLogsQueryKey = (params?: ListDocumentLogsParams,) => {
    return [
    `/api/documents/logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDocumentLogsQueryOptions = <TData = Awaited<ReturnType<typeof listDocumentLogs>>, TError = ErrorType<unknown>>(params?: ListDocumentLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDocumentLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDocumentLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDocumentLogs>>> = ({ signal }) => listDocumentLogs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDocumentLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDocumentLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listDocumentLogs>>>
export type ListDocumentLogsQueryError = ErrorType<unknown>


/**
 * @summary Generation logs (optionally filtered by document)
 */

export function useListDocumentLogs<TData = Awaited<ReturnType<typeof listDocumentLogs>>, TError = ErrorType<unknown>>(
 params?: ListDocumentLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDocumentLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDocumentLogsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListDocumentAutoRulesUrl = () => {




  return `/api/documents/auto-rules`
}

/**
 * @summary List per-trigger document auto-generation rules
 */
export const listDocumentAutoRules = async ( options?: RequestInit): Promise<ListDocumentAutoRules200> => {

  return customFetch<ListDocumentAutoRules200>(getListDocumentAutoRulesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDocumentAutoRulesQueryKey = () => {
    return [
    `/api/documents/auto-rules`
    ] as const;
    }


export const getListDocumentAutoRulesQueryOptions = <TData = Awaited<ReturnType<typeof listDocumentAutoRules>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDocumentAutoRules>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDocumentAutoRulesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDocumentAutoRules>>> = ({ signal }) => listDocumentAutoRules({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDocumentAutoRules>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDocumentAutoRulesQueryResult = NonNullable<Awaited<ReturnType<typeof listDocumentAutoRules>>>
export type ListDocumentAutoRulesQueryError = ErrorType<unknown>


/**
 * @summary List per-trigger document auto-generation rules
 */

export function useListDocumentAutoRules<TData = Awaited<ReturnType<typeof listDocumentAutoRules>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDocumentAutoRules>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDocumentAutoRulesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPutDocumentAutoRulesUrl = () => {




  return `/api/documents/auto-rules`
}

/**
 * @summary Upsert per-trigger document auto-generation rules
 */
export const putDocumentAutoRules = async (putDocumentAutoRulesRequest: PutDocumentAutoRulesRequest, options?: RequestInit): Promise<PutDocumentAutoRules200> => {

  return customFetch<PutDocumentAutoRules200>(getPutDocumentAutoRulesUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putDocumentAutoRulesRequest)
  }
);}





export const getPutDocumentAutoRulesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putDocumentAutoRules>>, TError,{data: BodyType<PutDocumentAutoRulesRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putDocumentAutoRules>>, TError,{data: BodyType<PutDocumentAutoRulesRequest>}, TContext> => {

const mutationKey = ['putDocumentAutoRules'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putDocumentAutoRules>>, {data: BodyType<PutDocumentAutoRulesRequest>}> = (props) => {
          const {data} = props ?? {};

          return  putDocumentAutoRules(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutDocumentAutoRulesMutationResult = NonNullable<Awaited<ReturnType<typeof putDocumentAutoRules>>>
    export type PutDocumentAutoRulesMutationBody = BodyType<PutDocumentAutoRulesRequest>
    export type PutDocumentAutoRulesMutationError = ErrorType<void>

    /**
 * @summary Upsert per-trigger document auto-generation rules
 */
export const usePutDocumentAutoRules = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putDocumentAutoRules>>, TError,{data: BodyType<PutDocumentAutoRulesRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putDocumentAutoRules>>,
        TError,
        {data: BodyType<PutDocumentAutoRulesRequest>},
        TContext
      > => {
      return useMutation(getPutDocumentAutoRulesMutationOptions(options));
    }

export const getGetGeneratedDocumentUrl = (id: string,) => {




  return `/api/documents/${id}`
}

/**
 * @summary Fetch a single generated document
 */
export const getGeneratedDocument = async (id: string, options?: RequestInit): Promise<GetGeneratedDocument200> => {

  return customFetch<GetGeneratedDocument200>(getGetGeneratedDocumentUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGeneratedDocumentQueryKey = (id: string,) => {
    return [
    `/api/documents/${id}`
    ] as const;
    }


export const getGetGeneratedDocumentQueryOptions = <TData = Awaited<ReturnType<typeof getGeneratedDocument>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGeneratedDocument>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGeneratedDocumentQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGeneratedDocument>>> = ({ signal }) => getGeneratedDocument(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGeneratedDocument>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGeneratedDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof getGeneratedDocument>>>
export type GetGeneratedDocumentQueryError = ErrorType<void>


/**
 * @summary Fetch a single generated document
 */

export function useGetGeneratedDocument<TData = Awaited<ReturnType<typeof getGeneratedDocument>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGeneratedDocument>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGeneratedDocumentQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDeleteGeneratedDocumentUrl = (id: string,) => {




  return `/api/documents/${id}`
}

/**
 * @summary Delete a generated document
 */
export const deleteGeneratedDocument = async (id: string, options?: RequestInit): Promise<OkResult> => {

  return customFetch<OkResult>(getDeleteGeneratedDocumentUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteGeneratedDocumentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGeneratedDocument>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteGeneratedDocument>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteGeneratedDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteGeneratedDocument>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteGeneratedDocument(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteGeneratedDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteGeneratedDocument>>>

    export type DeleteGeneratedDocumentMutationError = ErrorType<void>

    /**
 * @summary Delete a generated document
 */
export const useDeleteGeneratedDocument = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGeneratedDocument>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteGeneratedDocument>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteGeneratedDocumentMutationOptions(options));
    }

export const getDownloadGeneratedDocumentUrl = (id: string,) => {




  return `/api/documents/${id}/download`
}

/**
 * @summary Mint a short-lived presigned download URL
 */
export const downloadGeneratedDocument = async (id: string, options?: RequestInit): Promise<DownloadGeneratedDocument200> => {

  return customFetch<DownloadGeneratedDocument200>(getDownloadGeneratedDocumentUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadGeneratedDocumentQueryKey = (id: string,) => {
    return [
    `/api/documents/${id}/download`
    ] as const;
    }


export const getDownloadGeneratedDocumentQueryOptions = <TData = Awaited<ReturnType<typeof downloadGeneratedDocument>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadGeneratedDocument>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadGeneratedDocumentQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadGeneratedDocument>>> = ({ signal }) => downloadGeneratedDocument(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadGeneratedDocument>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadGeneratedDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof downloadGeneratedDocument>>>
export type DownloadGeneratedDocumentQueryError = ErrorType<void>


/**
 * @summary Mint a short-lived presigned download URL
 */

export function useDownloadGeneratedDocument<TData = Awaited<ReturnType<typeof downloadGeneratedDocument>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadGeneratedDocument>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadGeneratedDocumentQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getEmailGeneratedDocumentUrl = (id: string,) => {




  return `/api/documents/${id}/email`
}

/**
 * @summary Email a generated document as an attachment
 */
export const emailGeneratedDocument = async (id: string,
    emailDocumentRequest: EmailDocumentRequest, options?: RequestInit): Promise<EmailGeneratedDocument200> => {

  return customFetch<EmailGeneratedDocument200>(getEmailGeneratedDocumentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailDocumentRequest)
  }
);}





export const getEmailGeneratedDocumentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailGeneratedDocument>>, TError,{id: string;data: BodyType<EmailDocumentRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof emailGeneratedDocument>>, TError,{id: string;data: BodyType<EmailDocumentRequest>}, TContext> => {

const mutationKey = ['emailGeneratedDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof emailGeneratedDocument>>, {id: string;data: BodyType<EmailDocumentRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  emailGeneratedDocument(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EmailGeneratedDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof emailGeneratedDocument>>>
    export type EmailGeneratedDocumentMutationBody = BodyType<EmailDocumentRequest>
    export type EmailGeneratedDocumentMutationError = ErrorType<void>

    /**
 * @summary Email a generated document as an attachment
 */
export const useEmailGeneratedDocument = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailGeneratedDocument>>, TError,{id: string;data: BodyType<EmailDocumentRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof emailGeneratedDocument>>,
        TError,
        {id: string;data: BodyType<EmailDocumentRequest>},
        TContext
      > => {
      return useMutation(getEmailGeneratedDocumentMutationOptions(options));
    }

export const getArchiveGeneratedDocumentUrl = (id: string,) => {




  return `/api/documents/${id}/archive`
}

/**
 * @summary Archive a generated document
 */
export const archiveGeneratedDocument = async (id: string, options?: RequestInit): Promise<ArchiveGeneratedDocument200> => {

  return customFetch<ArchiveGeneratedDocument200>(getArchiveGeneratedDocumentUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getArchiveGeneratedDocumentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveGeneratedDocument>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveGeneratedDocument>>, TError,{id: string}, TContext> => {

const mutationKey = ['archiveGeneratedDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveGeneratedDocument>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  archiveGeneratedDocument(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveGeneratedDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof archiveGeneratedDocument>>>

    export type ArchiveGeneratedDocumentMutationError = ErrorType<void>

    /**
 * @summary Archive a generated document
 */
export const useArchiveGeneratedDocument = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveGeneratedDocument>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof archiveGeneratedDocument>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getArchiveGeneratedDocumentMutationOptions(options));
    }

export const getGetRoyalMailConnectionInfoUrl = () => {




  return `/api/postage/royal-mail/connection-info`
}

/**
 * @summary Get Royal Mail product and callback-host information
 */
export const getRoyalMailConnectionInfo = async ( options?: RequestInit): Promise<RoyalMailConnectionInfo> => {

  return customFetch<RoyalMailConnectionInfo>(getGetRoyalMailConnectionInfoUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRoyalMailConnectionInfoQueryKey = () => {
    return [
    `/api/postage/royal-mail/connection-info`
    ] as const;
    }


export const getGetRoyalMailConnectionInfoQueryOptions = <TData = Awaited<ReturnType<typeof getRoyalMailConnectionInfo>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRoyalMailConnectionInfo>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRoyalMailConnectionInfoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoyalMailConnectionInfo>>> = ({ signal }) => getRoyalMailConnectionInfo({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRoyalMailConnectionInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRoyalMailConnectionInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getRoyalMailConnectionInfo>>>
export type GetRoyalMailConnectionInfoQueryError = ErrorType<unknown>


/**
 * @summary Get Royal Mail product and callback-host information
 */

export function useGetRoyalMailConnectionInfo<TData = Awaited<ReturnType<typeof getRoyalMailConnectionInfo>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRoyalMailConnectionInfo>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRoyalMailConnectionInfoQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPostageServicesUrl = () => {




  return `/api/postage/services`
}

/**
 * @summary Static catalog of supported courier services
 */
export const listPostageServices = async ( options?: RequestInit): Promise<ListPostageServices200> => {

  return customFetch<ListPostageServices200>(getListPostageServicesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPostageServicesQueryKey = () => {
    return [
    `/api/postage/services`
    ] as const;
    }


export const getListPostageServicesQueryOptions = <TData = Awaited<ReturnType<typeof listPostageServices>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPostageServices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPostageServicesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPostageServices>>> = ({ signal }) => listPostageServices({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPostageServices>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPostageServicesQueryResult = NonNullable<Awaited<ReturnType<typeof listPostageServices>>>
export type ListPostageServicesQueryError = ErrorType<unknown>


/**
 * @summary Static catalog of supported courier services
 */

export function useListPostageServices<TData = Awaited<ReturnType<typeof listPostageServices>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPostageServices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPostageServicesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPostageSettingsUrl = () => {




  return `/api/postage/settings`
}

/**
 * @summary Get (lazily create) the tenant postage settings
 */
export const getPostageSettings = async ( options?: RequestInit): Promise<GetPostageSettings200> => {

  return customFetch<GetPostageSettings200>(getGetPostageSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPostageSettingsQueryKey = () => {
    return [
    `/api/postage/settings`
    ] as const;
    }


export const getGetPostageSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getPostageSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPostageSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPostageSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPostageSettings>>> = ({ signal }) => getPostageSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPostageSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPostageSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getPostageSettings>>>
export type GetPostageSettingsQueryError = ErrorType<unknown>


/**
 * @summary Get (lazily create) the tenant postage settings
 */

export function useGetPostageSettings<TData = Awaited<ReturnType<typeof getPostageSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPostageSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPostageSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdatePostageSettingsUrl = () => {




  return `/api/postage/settings`
}

/**
 * @summary Update tenant postage settings
 */
export const updatePostageSettings = async (updatePostageSettings: UpdatePostageSettings, options?: RequestInit): Promise<UpdatePostageSettings200> => {

  return customFetch<UpdatePostageSettings200>(getUpdatePostageSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updatePostageSettings)
  }
);}





export const getUpdatePostageSettingsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePostageSettings>>, TError,{data: BodyType<UpdatePostageSettings>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePostageSettings>>, TError,{data: BodyType<UpdatePostageSettings>}, TContext> => {

const mutationKey = ['updatePostageSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePostageSettings>>, {data: BodyType<UpdatePostageSettings>}> = (props) => {
          const {data} = props ?? {};

          return  updatePostageSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePostageSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updatePostageSettings>>>
    export type UpdatePostageSettingsMutationBody = BodyType<UpdatePostageSettings>
    export type UpdatePostageSettingsMutationError = ErrorType<void>

    /**
 * @summary Update tenant postage settings
 */
export const useUpdatePostageSettings = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePostageSettings>>, TError,{data: BodyType<UpdatePostageSettings>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePostageSettings>>,
        TError,
        {data: BodyType<UpdatePostageSettings>},
        TContext
      > => {
      return useMutation(getUpdatePostageSettingsMutationOptions(options));
    }

export const getListCourierIntegrationsUrl = () => {




  return `/api/postage/couriers`
}

/**
 * @summary List connected courier accounts (secrets redacted)
 */
export const listCourierIntegrations = async ( options?: RequestInit): Promise<ListCourierIntegrations200> => {

  return customFetch<ListCourierIntegrations200>(getListCourierIntegrationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCourierIntegrationsQueryKey = () => {
    return [
    `/api/postage/couriers`
    ] as const;
    }


export const getListCourierIntegrationsQueryOptions = <TData = Awaited<ReturnType<typeof listCourierIntegrations>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCourierIntegrations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCourierIntegrationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCourierIntegrations>>> = ({ signal }) => listCourierIntegrations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCourierIntegrations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCourierIntegrationsQueryResult = NonNullable<Awaited<ReturnType<typeof listCourierIntegrations>>>
export type ListCourierIntegrationsQueryError = ErrorType<unknown>


/**
 * @summary List connected courier accounts (secrets redacted)
 */

export function useListCourierIntegrations<TData = Awaited<ReturnType<typeof listCourierIntegrations>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCourierIntegrations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCourierIntegrationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCourierIntegrationUrl = () => {




  return `/api/postage/couriers`
}

/**
 * @summary Connect a courier account
 */
export const createCourierIntegration = async (createCourierIntegration: CreateCourierIntegration, options?: RequestInit): Promise<CreateCourierIntegration201> => {

  return customFetch<CreateCourierIntegration201>(getCreateCourierIntegrationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCourierIntegration)
  }
);}





export const getCreateCourierIntegrationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCourierIntegration>>, TError,{data: BodyType<CreateCourierIntegration>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCourierIntegration>>, TError,{data: BodyType<CreateCourierIntegration>}, TContext> => {

const mutationKey = ['createCourierIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCourierIntegration>>, {data: BodyType<CreateCourierIntegration>}> = (props) => {
          const {data} = props ?? {};

          return  createCourierIntegration(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCourierIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof createCourierIntegration>>>
    export type CreateCourierIntegrationMutationBody = BodyType<CreateCourierIntegration>
    export type CreateCourierIntegrationMutationError = ErrorType<void>

    /**
 * @summary Connect a courier account
 */
export const useCreateCourierIntegration = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCourierIntegration>>, TError,{data: BodyType<CreateCourierIntegration>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCourierIntegration>>,
        TError,
        {data: BodyType<CreateCourierIntegration>},
        TContext
      > => {
      return useMutation(getCreateCourierIntegrationMutationOptions(options));
    }

export const getUpdateCourierIntegrationUrl = (id: string,) => {




  return `/api/postage/couriers/${id}`
}

/**
 * @summary Update a courier account
 */
export const updateCourierIntegration = async (id: string,
    updateCourierIntegration: UpdateCourierIntegration, options?: RequestInit): Promise<UpdateCourierIntegration200> => {

  return customFetch<UpdateCourierIntegration200>(getUpdateCourierIntegrationUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateCourierIntegration)
  }
);}





export const getUpdateCourierIntegrationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCourierIntegration>>, TError,{id: string;data: BodyType<UpdateCourierIntegration>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCourierIntegration>>, TError,{id: string;data: BodyType<UpdateCourierIntegration>}, TContext> => {

const mutationKey = ['updateCourierIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCourierIntegration>>, {id: string;data: BodyType<UpdateCourierIntegration>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCourierIntegration(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCourierIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof updateCourierIntegration>>>
    export type UpdateCourierIntegrationMutationBody = BodyType<UpdateCourierIntegration>
    export type UpdateCourierIntegrationMutationError = ErrorType<void>

    /**
 * @summary Update a courier account
 */
export const useUpdateCourierIntegration = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCourierIntegration>>, TError,{id: string;data: BodyType<UpdateCourierIntegration>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCourierIntegration>>,
        TError,
        {id: string;data: BodyType<UpdateCourierIntegration>},
        TContext
      > => {
      return useMutation(getUpdateCourierIntegrationMutationOptions(options));
    }

export const getDeleteCourierIntegrationUrl = (id: string,) => {




  return `/api/postage/couriers/${id}`
}

/**
 * @summary Disconnect a courier account
 */
export const deleteCourierIntegration = async (id: string, options?: RequestInit): Promise<OkResult> => {

  return customFetch<OkResult>(getDeleteCourierIntegrationUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteCourierIntegrationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCourierIntegration>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCourierIntegration>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteCourierIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCourierIntegration>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCourierIntegration(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCourierIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCourierIntegration>>>

    export type DeleteCourierIntegrationMutationError = ErrorType<void>

    /**
 * @summary Disconnect a courier account
 */
export const useDeleteCourierIntegration = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCourierIntegration>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCourierIntegration>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteCourierIntegrationMutationOptions(options));
    }

export const getTestCourierIntegrationUrl = (id: string,) => {




  return `/api/postage/couriers/${id}/test`
}

/**
 * @summary Test a courier account connection
 */
export const testCourierIntegration = async (id: string, options?: RequestInit): Promise<CourierTestResult> => {

  return customFetch<CourierTestResult>(getTestCourierIntegrationUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getTestCourierIntegrationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testCourierIntegration>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testCourierIntegration>>, TError,{id: string}, TContext> => {

const mutationKey = ['testCourierIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testCourierIntegration>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  testCourierIntegration(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestCourierIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof testCourierIntegration>>>

    export type TestCourierIntegrationMutationError = ErrorType<void>

    /**
 * @summary Test a courier account connection
 */
export const useTestCourierIntegration = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testCourierIntegration>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof testCourierIntegration>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getTestCourierIntegrationMutationOptions(options));
    }

export const getListCourierProviderServicesUrl = (id: string,) => {




  return `/api/postage/couriers/${id}/services`
}

/**
 * @summary List services from a connected courier account when supported
 */
export const listCourierProviderServices = async (id: string, options?: RequestInit): Promise<ListCourierProviderServices200> => {

  return customFetch<ListCourierProviderServices200>(getListCourierProviderServicesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCourierProviderServicesQueryKey = (id: string,) => {
    return [
    `/api/postage/couriers/${id}/services`
    ] as const;
    }


export const getListCourierProviderServicesQueryOptions = <TData = Awaited<ReturnType<typeof listCourierProviderServices>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCourierProviderServices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCourierProviderServicesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCourierProviderServices>>> = ({ signal }) => listCourierProviderServices(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCourierProviderServices>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCourierProviderServicesQueryResult = NonNullable<Awaited<ReturnType<typeof listCourierProviderServices>>>
export type ListCourierProviderServicesQueryError = ErrorType<void>


/**
 * @summary List services from a connected courier account when supported
 */

export function useListCourierProviderServices<TData = Awaited<ReturnType<typeof listCourierProviderServices>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCourierProviderServices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCourierProviderServicesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListShipmentsUrl = (params?: ListShipmentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/postage/shipments?${stringifiedParams}` : `/api/postage/shipments`
}

/**
 * @summary List shipments (optional status/channel filters)
 */
export const listShipments = async (params?: ListShipmentsParams, options?: RequestInit): Promise<ListShipments200> => {

  return customFetch<ListShipments200>(getListShipmentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListShipmentsQueryKey = (params?: ListShipmentsParams,) => {
    return [
    `/api/postage/shipments`, ...(params ? [params] : [])
    ] as const;
    }


export const getListShipmentsQueryOptions = <TData = Awaited<ReturnType<typeof listShipments>>, TError = ErrorType<unknown>>(params?: ListShipmentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShipments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListShipmentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listShipments>>> = ({ signal }) => listShipments(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listShipments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListShipmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listShipments>>>
export type ListShipmentsQueryError = ErrorType<unknown>


/**
 * @summary List shipments (optional status/channel filters)
 */

export function useListShipments<TData = Awaited<ReturnType<typeof listShipments>>, TError = ErrorType<unknown>>(
 params?: ListShipmentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShipments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListShipmentsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateShipmentUrl = () => {




  return `/api/postage/shipments`
}

/**
 * @summary Create a shipment record
 */
export const createShipment = async (createShipment: CreateShipment, options?: RequestInit): Promise<CreateShipment201> => {

  return customFetch<CreateShipment201>(getCreateShipmentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createShipment)
  }
);}





export const getCreateShipmentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createShipment>>, TError,{data: BodyType<CreateShipment>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createShipment>>, TError,{data: BodyType<CreateShipment>}, TContext> => {

const mutationKey = ['createShipment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createShipment>>, {data: BodyType<CreateShipment>}> = (props) => {
          const {data} = props ?? {};

          return  createShipment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateShipmentMutationResult = NonNullable<Awaited<ReturnType<typeof createShipment>>>
    export type CreateShipmentMutationBody = BodyType<CreateShipment>
    export type CreateShipmentMutationError = ErrorType<void>

    /**
 * @summary Create a shipment record
 */
export const useCreateShipment = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createShipment>>, TError,{data: BodyType<CreateShipment>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createShipment>>,
        TError,
        {data: BodyType<CreateShipment>},
        TContext
      > => {
      return useMutation(getCreateShipmentMutationOptions(options));
    }

export const getGetShipmentUrl = (id: string,) => {




  return `/api/postage/shipments/${id}`
}

/**
 * @summary Get a shipment with labels + tracking
 */
export const getShipment = async (id: string, options?: RequestInit): Promise<GetShipment200> => {

  return customFetch<GetShipment200>(getGetShipmentUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetShipmentQueryKey = (id: string,) => {
    return [
    `/api/postage/shipments/${id}`
    ] as const;
    }


export const getGetShipmentQueryOptions = <TData = Awaited<ReturnType<typeof getShipment>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShipment>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShipmentQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShipment>>> = ({ signal }) => getShipment(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShipment>>, TError, TData> & { queryKey: QueryKey }
}

export type GetShipmentQueryResult = NonNullable<Awaited<ReturnType<typeof getShipment>>>
export type GetShipmentQueryError = ErrorType<void>


/**
 * @summary Get a shipment with labels + tracking
 */

export function useGetShipment<TData = Awaited<ReturnType<typeof getShipment>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShipment>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetShipmentQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGenerateShipmentLabelUrl = (id: string,) => {




  return `/api/postage/shipments/${id}/label`
}

/**
 * @summary Generate (or regenerate) the courier label for a shipment
 */
export const generateShipmentLabel = async (id: string, options?: RequestInit): Promise<GenerateShipmentLabel200> => {

  return customFetch<GenerateShipmentLabel200>(getGenerateShipmentLabelUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getGenerateShipmentLabelMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateShipmentLabel>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof generateShipmentLabel>>, TError,{id: string}, TContext> => {

const mutationKey = ['generateShipmentLabel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateShipmentLabel>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  generateShipmentLabel(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateShipmentLabelMutationResult = NonNullable<Awaited<ReturnType<typeof generateShipmentLabel>>>

    export type GenerateShipmentLabelMutationError = ErrorType<void>

    /**
 * @summary Generate (or regenerate) the courier label for a shipment
 */
export const useGenerateShipmentLabel = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateShipmentLabel>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof generateShipmentLabel>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getGenerateShipmentLabelMutationOptions(options));
    }

export const getDownloadShipmentLabelUrl = (id: string,) => {




  return `/api/postage/shipments/${id}/label/download`
}

/**
 * @summary Mint a short-lived presigned label-download URL
 */
export const downloadShipmentLabel = async (id: string, options?: RequestInit): Promise<DownloadShipmentLabel200> => {

  return customFetch<DownloadShipmentLabel200>(getDownloadShipmentLabelUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadShipmentLabelQueryKey = (id: string,) => {
    return [
    `/api/postage/shipments/${id}/label/download`
    ] as const;
    }


export const getDownloadShipmentLabelQueryOptions = <TData = Awaited<ReturnType<typeof downloadShipmentLabel>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadShipmentLabel>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadShipmentLabelQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadShipmentLabel>>> = ({ signal }) => downloadShipmentLabel(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadShipmentLabel>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadShipmentLabelQueryResult = NonNullable<Awaited<ReturnType<typeof downloadShipmentLabel>>>
export type DownloadShipmentLabelQueryError = ErrorType<void>


/**
 * @summary Mint a short-lived presigned label-download URL
 */

export function useDownloadShipmentLabel<TData = Awaited<ReturnType<typeof downloadShipmentLabel>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadShipmentLabel>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadShipmentLabelQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGenerateBatchLabelsUrl = () => {




  return `/api/postage/labels/batch`
}

/**
 * @summary Generate labels for many shipments at once
 */
export const generateBatchLabels = async (batchLabelRequest: BatchLabelRequest, options?: RequestInit): Promise<BatchLabelResult> => {

  return customFetch<BatchLabelResult>(getGenerateBatchLabelsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(batchLabelRequest)
  }
);}





export const getGenerateBatchLabelsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateBatchLabels>>, TError,{data: BodyType<BatchLabelRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof generateBatchLabels>>, TError,{data: BodyType<BatchLabelRequest>}, TContext> => {

const mutationKey = ['generateBatchLabels'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateBatchLabels>>, {data: BodyType<BatchLabelRequest>}> = (props) => {
          const {data} = props ?? {};

          return  generateBatchLabels(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateBatchLabelsMutationResult = NonNullable<Awaited<ReturnType<typeof generateBatchLabels>>>
    export type GenerateBatchLabelsMutationBody = BodyType<BatchLabelRequest>
    export type GenerateBatchLabelsMutationError = ErrorType<void>

    /**
 * @summary Generate labels for many shipments at once
 */
export const useGenerateBatchLabels = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateBatchLabels>>, TError,{data: BodyType<BatchLabelRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof generateBatchLabels>>,
        TError,
        {data: BodyType<BatchLabelRequest>},
        TContext
      > => {
      return useMutation(getGenerateBatchLabelsMutationOptions(options));
    }

export const getListCombinedShipmentsUrl = () => {




  return `/api/postage/combined`
}

/**
 * @summary List detected/confirmed combined shipments
 */
export const listCombinedShipments = async ( options?: RequestInit): Promise<ListCombinedShipments200> => {

  return customFetch<ListCombinedShipments200>(getListCombinedShipmentsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCombinedShipmentsQueryKey = () => {
    return [
    `/api/postage/combined`
    ] as const;
    }


export const getListCombinedShipmentsQueryOptions = <TData = Awaited<ReturnType<typeof listCombinedShipments>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCombinedShipments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCombinedShipmentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCombinedShipments>>> = ({ signal }) => listCombinedShipments({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCombinedShipments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCombinedShipmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listCombinedShipments>>>
export type ListCombinedShipmentsQueryError = ErrorType<unknown>


/**
 * @summary List detected/confirmed combined shipments
 */

export function useListCombinedShipments<TData = Awaited<ReturnType<typeof listCombinedShipments>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCombinedShipments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCombinedShipmentsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCombinedShipmentUrl = () => {




  return `/api/postage/combined`
}

/**
 * @summary Confirm a combined shipment (under-lock conflict check)
 */
export const createCombinedShipment = async (createCombinedShipment: CreateCombinedShipment, options?: RequestInit): Promise<CreateCombinedShipment201> => {

  return customFetch<CreateCombinedShipment201>(getCreateCombinedShipmentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCombinedShipment)
  }
);}





export const getCreateCombinedShipmentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCombinedShipment>>, TError,{data: BodyType<CreateCombinedShipment>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCombinedShipment>>, TError,{data: BodyType<CreateCombinedShipment>}, TContext> => {

const mutationKey = ['createCombinedShipment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCombinedShipment>>, {data: BodyType<CreateCombinedShipment>}> = (props) => {
          const {data} = props ?? {};

          return  createCombinedShipment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCombinedShipmentMutationResult = NonNullable<Awaited<ReturnType<typeof createCombinedShipment>>>
    export type CreateCombinedShipmentMutationBody = BodyType<CreateCombinedShipment>
    export type CreateCombinedShipmentMutationError = ErrorType<void>

    /**
 * @summary Confirm a combined shipment (under-lock conflict check)
 */
export const useCreateCombinedShipment = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCombinedShipment>>, TError,{data: BodyType<CreateCombinedShipment>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCombinedShipment>>,
        TError,
        {data: BodyType<CreateCombinedShipment>},
        TContext
      > => {
      return useMutation(getCreateCombinedShipmentMutationOptions(options));
    }

export const getExcludeCombinedShipmentUrl = (id: string,) => {




  return `/api/postage/combined/${id}/exclude`
}

/**
 * @summary Mark a combined-shipment suggestion as excluded
 */
export const excludeCombinedShipment = async (id: string, options?: RequestInit): Promise<ExcludeCombinedShipment200> => {

  return customFetch<ExcludeCombinedShipment200>(getExcludeCombinedShipmentUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getExcludeCombinedShipmentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof excludeCombinedShipment>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof excludeCombinedShipment>>, TError,{id: string}, TContext> => {

const mutationKey = ['excludeCombinedShipment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof excludeCombinedShipment>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  excludeCombinedShipment(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExcludeCombinedShipmentMutationResult = NonNullable<Awaited<ReturnType<typeof excludeCombinedShipment>>>

    export type ExcludeCombinedShipmentMutationError = ErrorType<void>

    /**
 * @summary Mark a combined-shipment suggestion as excluded
 */
export const useExcludeCombinedShipment = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof excludeCombinedShipment>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof excludeCombinedShipment>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getExcludeCombinedShipmentMutationOptions(options));
    }

export const getListPickListsUrl = () => {




  return `/api/postage/pick-lists`
}

/**
 * @summary List generated pick lists
 */
export const listPickLists = async ( options?: RequestInit): Promise<ListPickLists200> => {

  return customFetch<ListPickLists200>(getListPickListsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPickListsQueryKey = () => {
    return [
    `/api/postage/pick-lists`
    ] as const;
    }


export const getListPickListsQueryOptions = <TData = Awaited<ReturnType<typeof listPickLists>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPickLists>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPickListsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPickLists>>> = ({ signal }) => listPickLists({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPickLists>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPickListsQueryResult = NonNullable<Awaited<ReturnType<typeof listPickLists>>>
export type ListPickListsQueryError = ErrorType<unknown>


/**
 * @summary List generated pick lists
 */

export function useListPickLists<TData = Awaited<ReturnType<typeof listPickLists>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPickLists>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPickListsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreatePickListUrl = () => {




  return `/api/postage/pick-lists`
}

/**
 * @summary Generate a pick list
 */
export const createPickList = async (createPickList: CreatePickList, options?: RequestInit): Promise<CreatePickList201> => {

  return customFetch<CreatePickList201>(getCreatePickListUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createPickList)
  }
);}





export const getCreatePickListMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPickList>>, TError,{data: BodyType<CreatePickList>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPickList>>, TError,{data: BodyType<CreatePickList>}, TContext> => {

const mutationKey = ['createPickList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPickList>>, {data: BodyType<CreatePickList>}> = (props) => {
          const {data} = props ?? {};

          return  createPickList(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePickListMutationResult = NonNullable<Awaited<ReturnType<typeof createPickList>>>
    export type CreatePickListMutationBody = BodyType<CreatePickList>
    export type CreatePickListMutationError = ErrorType<void>

    /**
 * @summary Generate a pick list
 */
export const useCreatePickList = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPickList>>, TError,{data: BodyType<CreatePickList>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPickList>>,
        TError,
        {data: BodyType<CreatePickList>},
        TContext
      > => {
      return useMutation(getCreatePickListMutationOptions(options));
    }

export const getListShipmentTrackingUrl = (params?: ListShipmentTrackingParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/postage/tracking?${stringifiedParams}` : `/api/postage/tracking`
}

/**
 * @summary List per-order tracking rows (optional uploadStatus filter)
 */
export const listShipmentTracking = async (params?: ListShipmentTrackingParams, options?: RequestInit): Promise<ListShipmentTracking200> => {

  return customFetch<ListShipmentTracking200>(getListShipmentTrackingUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListShipmentTrackingQueryKey = (params?: ListShipmentTrackingParams,) => {
    return [
    `/api/postage/tracking`, ...(params ? [params] : [])
    ] as const;
    }


export const getListShipmentTrackingQueryOptions = <TData = Awaited<ReturnType<typeof listShipmentTracking>>, TError = ErrorType<unknown>>(params?: ListShipmentTrackingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShipmentTracking>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListShipmentTrackingQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listShipmentTracking>>> = ({ signal }) => listShipmentTracking(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listShipmentTracking>>, TError, TData> & { queryKey: QueryKey }
}

export type ListShipmentTrackingQueryResult = NonNullable<Awaited<ReturnType<typeof listShipmentTracking>>>
export type ListShipmentTrackingQueryError = ErrorType<unknown>


/**
 * @summary List per-order tracking rows (optional uploadStatus filter)
 */

export function useListShipmentTracking<TData = Awaited<ReturnType<typeof listShipmentTracking>>, TError = ErrorType<unknown>>(
 params?: ListShipmentTrackingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShipmentTracking>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListShipmentTrackingQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUploadShipmentTrackingUrl = (id: string,) => {




  return `/api/postage/tracking/${id}/upload`
}

/**
 * @summary Push tracking to the originating marketplace
 */
export const uploadShipmentTracking = async (id: string, options?: RequestInit): Promise<UploadShipmentTracking200> => {

  return customFetch<UploadShipmentTracking200>(getUploadShipmentTrackingUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getUploadShipmentTrackingMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadShipmentTracking>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadShipmentTracking>>, TError,{id: string}, TContext> => {

const mutationKey = ['uploadShipmentTracking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadShipmentTracking>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  uploadShipmentTracking(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadShipmentTrackingMutationResult = NonNullable<Awaited<ReturnType<typeof uploadShipmentTracking>>>

    export type UploadShipmentTrackingMutationError = ErrorType<void>

    /**
 * @summary Push tracking to the originating marketplace
 */
export const useUploadShipmentTracking = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadShipmentTracking>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadShipmentTracking>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getUploadShipmentTrackingMutationOptions(options));
    }

export const getGetPostageDashboardUrl = () => {




  return `/api/postage/dashboard`
}

/**
 * @summary Postage dashboard counts
 */
export const getPostageDashboard = async ( options?: RequestInit): Promise<PostageDashboard> => {

  return customFetch<PostageDashboard>(getGetPostageDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPostageDashboardQueryKey = () => {
    return [
    `/api/postage/dashboard`
    ] as const;
    }


export const getGetPostageDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getPostageDashboard>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPostageDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPostageDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPostageDashboard>>> = ({ signal }) => getPostageDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPostageDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPostageDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getPostageDashboard>>>
export type GetPostageDashboardQueryError = ErrorType<unknown>


/**
 * @summary Postage dashboard counts
 */

export function useGetPostageDashboard<TData = Awaited<ReturnType<typeof getPostageDashboard>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPostageDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPostageDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPostageReportsUrl = () => {




  return `/api/postage/reports`
}

/**
 * @summary Postage spend/volume reports
 */
export const getPostageReports = async ( options?: RequestInit): Promise<PostageReports> => {

  return customFetch<PostageReports>(getGetPostageReportsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPostageReportsQueryKey = () => {
    return [
    `/api/postage/reports`
    ] as const;
    }


export const getGetPostageReportsQueryOptions = <TData = Awaited<ReturnType<typeof getPostageReports>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPostageReports>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPostageReportsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPostageReports>>> = ({ signal }) => getPostageReports({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPostageReports>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPostageReportsQueryResult = NonNullable<Awaited<ReturnType<typeof getPostageReports>>>
export type GetPostageReportsQueryError = ErrorType<unknown>


/**
 * @summary Postage spend/volume reports
 */

export function useGetPostageReports<TData = Awaited<ReturnType<typeof getPostageReports>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPostageReports>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPostageReportsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPostageAuditUrl = () => {




  return `/api/postage/audit`
}

/**
 * @summary Postage audit log
 */
export const listPostageAudit = async ( options?: RequestInit): Promise<ListPostageAudit200> => {

  return customFetch<ListPostageAudit200>(getListPostageAuditUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPostageAuditQueryKey = () => {
    return [
    `/api/postage/audit`
    ] as const;
    }


export const getListPostageAuditQueryOptions = <TData = Awaited<ReturnType<typeof listPostageAudit>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPostageAudit>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPostageAuditQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPostageAudit>>> = ({ signal }) => listPostageAudit({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPostageAudit>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPostageAuditQueryResult = NonNullable<Awaited<ReturnType<typeof listPostageAudit>>>
export type ListPostageAuditQueryError = ErrorType<unknown>


/**
 * @summary Postage audit log
 */

export function useListPostageAudit<TData = Awaited<ReturnType<typeof listPostageAudit>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPostageAudit>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPostageAuditQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCustomFieldsUrl = (params?: ListCustomFieldsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/custom-fields?${stringifiedParams}` : `/api/custom-fields`
}

/**
 * @summary List custom field definitions, optionally filtered by entity type
 */
export const listCustomFields = async (params?: ListCustomFieldsParams, options?: RequestInit): Promise<CustomField[]> => {

  return customFetch<CustomField[]>(getListCustomFieldsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomFieldsQueryKey = (params?: ListCustomFieldsParams,) => {
    return [
    `/api/custom-fields`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCustomFieldsQueryOptions = <TData = Awaited<ReturnType<typeof listCustomFields>>, TError = ErrorType<unknown>>(params?: ListCustomFieldsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomFields>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomFieldsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomFields>>> = ({ signal }) => listCustomFields(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomFields>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCustomFieldsQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomFields>>>
export type ListCustomFieldsQueryError = ErrorType<unknown>


/**
 * @summary List custom field definitions, optionally filtered by entity type
 */

export function useListCustomFields<TData = Awaited<ReturnType<typeof listCustomFields>>, TError = ErrorType<unknown>>(
 params?: ListCustomFieldsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomFields>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCustomFieldsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCustomFieldUrl = () => {




  return `/api/custom-fields`
}

export const createCustomField = async (customFieldInput: CustomFieldInput, options?: RequestInit): Promise<CustomField> => {

  return customFetch<CustomField>(getCreateCustomFieldUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customFieldInput)
  }
);}





export const getCreateCustomFieldMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomField>>, TError,{data: BodyType<CustomFieldInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCustomField>>, TError,{data: BodyType<CustomFieldInput>}, TContext> => {

const mutationKey = ['createCustomField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCustomField>>, {data: BodyType<CustomFieldInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCustomField(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCustomFieldMutationResult = NonNullable<Awaited<ReturnType<typeof createCustomField>>>
    export type CreateCustomFieldMutationBody = BodyType<CustomFieldInput>
    export type CreateCustomFieldMutationError = ErrorType<unknown>

    export const useCreateCustomField = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomField>>, TError,{data: BodyType<CustomFieldInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCustomField>>,
        TError,
        {data: BodyType<CustomFieldInput>},
        TContext
      > => {
      return useMutation(getCreateCustomFieldMutationOptions(options));
    }

export const getUpdateCustomFieldUrl = (id: string,) => {




  return `/api/custom-fields/${id}`
}

export const updateCustomField = async (id: string,
    customFieldUpdate: CustomFieldUpdate, options?: RequestInit): Promise<CustomField> => {

  return customFetch<CustomField>(getUpdateCustomFieldUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customFieldUpdate)
  }
);}





export const getUpdateCustomFieldMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomField>>, TError,{id: string;data: BodyType<CustomFieldUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCustomField>>, TError,{id: string;data: BodyType<CustomFieldUpdate>}, TContext> => {

const mutationKey = ['updateCustomField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCustomField>>, {id: string;data: BodyType<CustomFieldUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCustomField(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCustomFieldMutationResult = NonNullable<Awaited<ReturnType<typeof updateCustomField>>>
    export type UpdateCustomFieldMutationBody = BodyType<CustomFieldUpdate>
    export type UpdateCustomFieldMutationError = ErrorType<unknown>

    export const useUpdateCustomField = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomField>>, TError,{id: string;data: BodyType<CustomFieldUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCustomField>>,
        TError,
        {id: string;data: BodyType<CustomFieldUpdate>},
        TContext
      > => {
      return useMutation(getUpdateCustomFieldMutationOptions(options));
    }

export const getDeleteCustomFieldUrl = (id: string,) => {




  return `/api/custom-fields/${id}`
}

export const deleteCustomField = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteCustomFieldUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteCustomFieldMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomField>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomField>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteCustomField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomField>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCustomField(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomFieldMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomField>>>

    export type DeleteCustomFieldMutationError = ErrorType<unknown>

    export const useDeleteCustomField = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomField>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomField>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteCustomFieldMutationOptions(options));
    }

export const getListCustomFieldValuesUrl = (params: ListCustomFieldValuesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/custom-fields/values?${stringifiedParams}` : `/api/custom-fields/values`
}

/**
 * @summary List custom field definitions + their current values for one entity
 */
export const listCustomFieldValues = async (params: ListCustomFieldValuesParams, options?: RequestInit): Promise<CustomFieldWithValue[]> => {

  return customFetch<CustomFieldWithValue[]>(getListCustomFieldValuesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomFieldValuesQueryKey = (params?: ListCustomFieldValuesParams,) => {
    return [
    `/api/custom-fields/values`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCustomFieldValuesQueryOptions = <TData = Awaited<ReturnType<typeof listCustomFieldValues>>, TError = ErrorType<unknown>>(params: ListCustomFieldValuesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomFieldValues>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomFieldValuesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomFieldValues>>> = ({ signal }) => listCustomFieldValues(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomFieldValues>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCustomFieldValuesQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomFieldValues>>>
export type ListCustomFieldValuesQueryError = ErrorType<unknown>


/**
 * @summary List custom field definitions + their current values for one entity
 */

export function useListCustomFieldValues<TData = Awaited<ReturnType<typeof listCustomFieldValues>>, TError = ErrorType<unknown>>(
 params: ListCustomFieldValuesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomFieldValues>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCustomFieldValuesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpsertCustomFieldValuesUrl = () => {




  return `/api/custom-fields/values`
}

/**
 * @summary Bulk upsert values for one entity
 */
export const upsertCustomFieldValues = async (customFieldValuesUpsert: CustomFieldValuesUpsert, options?: RequestInit): Promise<CustomFieldWithValue[]> => {

  return customFetch<CustomFieldWithValue[]>(getUpsertCustomFieldValuesUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customFieldValuesUpsert)
  }
);}





export const getUpsertCustomFieldValuesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertCustomFieldValues>>, TError,{data: BodyType<CustomFieldValuesUpsert>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertCustomFieldValues>>, TError,{data: BodyType<CustomFieldValuesUpsert>}, TContext> => {

const mutationKey = ['upsertCustomFieldValues'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertCustomFieldValues>>, {data: BodyType<CustomFieldValuesUpsert>}> = (props) => {
          const {data} = props ?? {};

          return  upsertCustomFieldValues(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertCustomFieldValuesMutationResult = NonNullable<Awaited<ReturnType<typeof upsertCustomFieldValues>>>
    export type UpsertCustomFieldValuesMutationBody = BodyType<CustomFieldValuesUpsert>
    export type UpsertCustomFieldValuesMutationError = ErrorType<unknown>

    /**
 * @summary Bulk upsert values for one entity
 */
export const useUpsertCustomFieldValues = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertCustomFieldValues>>, TError,{data: BodyType<CustomFieldValuesUpsert>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertCustomFieldValues>>,
        TError,
        {data: BodyType<CustomFieldValuesUpsert>},
        TContext
      > => {
      return useMutation(getUpsertCustomFieldValuesMutationOptions(options));
    }

export const getListPickListImportsUrl = (params?: ListPickListImportsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pick-list/imports?${stringifiedParams}` : `/api/pick-list/imports`
}

/**
 * @summary Paginated list of pick list imports
 */
export const listPickListImports = async (params?: ListPickListImportsParams, options?: RequestInit): Promise<PickListImportListResponse> => {

  return customFetch<PickListImportListResponse>(getListPickListImportsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPickListImportsQueryKey = (params?: ListPickListImportsParams,) => {
    return [
    `/api/pick-list/imports`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPickListImportsQueryOptions = <TData = Awaited<ReturnType<typeof listPickListImports>>, TError = ErrorType<unknown>>(params?: ListPickListImportsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPickListImports>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPickListImportsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPickListImports>>> = ({ signal }) => listPickListImports(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPickListImports>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPickListImportsQueryResult = NonNullable<Awaited<ReturnType<typeof listPickListImports>>>
export type ListPickListImportsQueryError = ErrorType<unknown>


/**
 * @summary Paginated list of pick list imports
 */

export function useListPickListImports<TData = Awaited<ReturnType<typeof listPickListImports>>, TError = ErrorType<unknown>>(
 params?: ListPickListImportsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPickListImports>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPickListImportsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPickListImportUrl = (id: string,) => {




  return `/api/pick-list/imports/${id}`
}

/**
 * @summary Get import header + parcels
 */
export const getPickListImport = async (id: string, options?: RequestInit): Promise<PickListImportDetail> => {

  return customFetch<PickListImportDetail>(getGetPickListImportUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPickListImportQueryKey = (id: string,) => {
    return [
    `/api/pick-list/imports/${id}`
    ] as const;
    }


export const getGetPickListImportQueryOptions = <TData = Awaited<ReturnType<typeof getPickListImport>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPickListImport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPickListImportQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPickListImport>>> = ({ signal }) => getPickListImport(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPickListImport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPickListImportQueryResult = NonNullable<Awaited<ReturnType<typeof getPickListImport>>>
export type GetPickListImportQueryError = ErrorType<void>


/**
 * @summary Get import header + parcels
 */

export function useGetPickListImport<TData = Awaited<ReturnType<typeof getPickListImport>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPickListImport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPickListImportQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdatePickListParcelUrl = (id: string,) => {




  return `/api/pick-list/parcels/${id}`
}

/**
 * @summary Edit parcel fields (customer, address, items, flags, notes)
 */
export const updatePickListParcel = async (id: string,
    pickListParcelPatch: PickListParcelPatch, options?: RequestInit): Promise<UpdatePickListParcel200> => {

  return customFetch<UpdatePickListParcel200>(getUpdatePickListParcelUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pickListParcelPatch)
  }
);}





export const getUpdatePickListParcelMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePickListParcel>>, TError,{id: string;data: BodyType<PickListParcelPatch>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePickListParcel>>, TError,{id: string;data: BodyType<PickListParcelPatch>}, TContext> => {

const mutationKey = ['updatePickListParcel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePickListParcel>>, {id: string;data: BodyType<PickListParcelPatch>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePickListParcel(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePickListParcelMutationResult = NonNullable<Awaited<ReturnType<typeof updatePickListParcel>>>
    export type UpdatePickListParcelMutationBody = BodyType<PickListParcelPatch>
    export type UpdatePickListParcelMutationError = ErrorType<unknown>

    /**
 * @summary Edit parcel fields (customer, address, items, flags, notes)
 */
export const useUpdatePickListParcel = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePickListParcel>>, TError,{id: string;data: BodyType<PickListParcelPatch>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePickListParcel>>,
        TError,
        {id: string;data: BodyType<PickListParcelPatch>},
        TContext
      > => {
      return useMutation(getUpdatePickListParcelMutationOptions(options));
    }

export const getMarkOrderLossUrl = (id: string,) => {




  return `/api/sales/${id}/loss`
}

/**
 * @summary Mark a sale order as a loss / incident (creates or amends).
 */
export const markOrderLoss = async (id: string,
    markOrderLossInput: MarkOrderLossInput, options?: RequestInit): Promise<MarkOrderLoss200 | MarkOrderLoss201> => {

  return customFetch<MarkOrderLoss200 | MarkOrderLoss201>(getMarkOrderLossUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(markOrderLossInput)
  }
);}





export const getMarkOrderLossMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markOrderLoss>>, TError,{id: string;data: BodyType<MarkOrderLossInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markOrderLoss>>, TError,{id: string;data: BodyType<MarkOrderLossInput>}, TContext> => {

const mutationKey = ['markOrderLoss'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markOrderLoss>>, {id: string;data: BodyType<MarkOrderLossInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  markOrderLoss(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkOrderLossMutationResult = NonNullable<Awaited<ReturnType<typeof markOrderLoss>>>
    export type MarkOrderLossMutationBody = BodyType<MarkOrderLossInput>
    export type MarkOrderLossMutationError = ErrorType<void>

    /**
 * @summary Mark a sale order as a loss / incident (creates or amends).
 */
export const useMarkOrderLoss = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markOrderLoss>>, TError,{id: string;data: BodyType<MarkOrderLossInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markOrderLoss>>,
        TError,
        {id: string;data: BodyType<MarkOrderLossInput>},
        TContext
      > => {
      return useMutation(getMarkOrderLossMutationOptions(options));
    }

export const getListOrderLossesUrl = (params?: ListOrderLossesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/losses?${stringifiedParams}` : `/api/losses`
}

/**
 * @summary Paginated list of order losses, with filters.
 */
export const listOrderLosses = async (params?: ListOrderLossesParams, options?: RequestInit): Promise<OrderLossListResponse> => {

  return customFetch<OrderLossListResponse>(getListOrderLossesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOrderLossesQueryKey = (params?: ListOrderLossesParams,) => {
    return [
    `/api/losses`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOrderLossesQueryOptions = <TData = Awaited<ReturnType<typeof listOrderLosses>>, TError = ErrorType<unknown>>(params?: ListOrderLossesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOrderLosses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrderLossesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrderLosses>>> = ({ signal }) => listOrderLosses(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrderLosses>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOrderLossesQueryResult = NonNullable<Awaited<ReturnType<typeof listOrderLosses>>>
export type ListOrderLossesQueryError = ErrorType<unknown>


/**
 * @summary Paginated list of order losses, with filters.
 */

export function useListOrderLosses<TData = Awaited<ReturnType<typeof listOrderLosses>>, TError = ErrorType<unknown>>(
 params?: ListOrderLossesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOrderLosses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOrderLossesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetOrderLossUrl = (id: string,) => {




  return `/api/losses/${id}`
}

/**
 * @summary Get a single loss with order context.
 */
export const getOrderLoss = async (id: string, options?: RequestInit): Promise<GetOrderLoss200> => {

  return customFetch<GetOrderLoss200>(getGetOrderLossUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrderLossQueryKey = (id: string,) => {
    return [
    `/api/losses/${id}`
    ] as const;
    }


export const getGetOrderLossQueryOptions = <TData = Awaited<ReturnType<typeof getOrderLoss>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderLoss>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderLossQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderLoss>>> = ({ signal }) => getOrderLoss(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrderLoss>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrderLossQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderLoss>>>
export type GetOrderLossQueryError = ErrorType<void>


/**
 * @summary Get a single loss with order context.
 */

export function useGetOrderLoss<TData = Awaited<ReturnType<typeof getOrderLoss>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderLoss>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrderLossQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateOrderLossUrl = (id: string,) => {




  return `/api/losses/${id}`
}

/**
 * @summary Edit a loss (amount, note, type, or transition status).
 */
export const updateOrderLoss = async (id: string,
    updateOrderLossInput: UpdateOrderLossInput, options?: RequestInit): Promise<UpdateOrderLoss200> => {

  return customFetch<UpdateOrderLoss200>(getUpdateOrderLossUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateOrderLossInput)
  }
);}





export const getUpdateOrderLossMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrderLoss>>, TError,{id: string;data: BodyType<UpdateOrderLossInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrderLoss>>, TError,{id: string;data: BodyType<UpdateOrderLossInput>}, TContext> => {

const mutationKey = ['updateOrderLoss'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrderLoss>>, {id: string;data: BodyType<UpdateOrderLossInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOrderLoss(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrderLossMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrderLoss>>>
    export type UpdateOrderLossMutationBody = BodyType<UpdateOrderLossInput>
    export type UpdateOrderLossMutationError = ErrorType<void>

    /**
 * @summary Edit a loss (amount, note, type, or transition status).
 */
export const useUpdateOrderLoss = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrderLoss>>, TError,{id: string;data: BodyType<UpdateOrderLossInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOrderLoss>>,
        TError,
        {id: string;data: BodyType<UpdateOrderLossInput>},
        TContext
      > => {
      return useMutation(getUpdateOrderLossMutationOptions(options));
    }

export const getSetPickListParcelStatusUrl = (id: string,) => {




  return `/api/pick-list/parcels/${id}/status`
}

/**
 * @summary Transition parcel status (paper-trail only — no inventory side effects)
 */
export const setPickListParcelStatus = async (id: string,
    pickListParcelStatusInput: PickListParcelStatusInput, options?: RequestInit): Promise<SetPickListParcelStatus200> => {

  return customFetch<SetPickListParcelStatus200>(getSetPickListParcelStatusUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pickListParcelStatusInput)
  }
);}





export const getSetPickListParcelStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPickListParcelStatus>>, TError,{id: string;data: BodyType<PickListParcelStatusInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setPickListParcelStatus>>, TError,{id: string;data: BodyType<PickListParcelStatusInput>}, TContext> => {

const mutationKey = ['setPickListParcelStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setPickListParcelStatus>>, {id: string;data: BodyType<PickListParcelStatusInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  setPickListParcelStatus(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetPickListParcelStatusMutationResult = NonNullable<Awaited<ReturnType<typeof setPickListParcelStatus>>>
    export type SetPickListParcelStatusMutationBody = BodyType<PickListParcelStatusInput>
    export type SetPickListParcelStatusMutationError = ErrorType<unknown>

    /**
 * @summary Transition parcel status (paper-trail only — no inventory side effects)
 */
export const useSetPickListParcelStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPickListParcelStatus>>, TError,{id: string;data: BodyType<PickListParcelStatusInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setPickListParcelStatus>>,
        TError,
        {id: string;data: BodyType<PickListParcelStatusInput>},
        TContext
      > => {
      return useMutation(getSetPickListParcelStatusMutationOptions(options));
    }

export const getGenerateInventoryCompositeUrl = (id: string,) => {




  return `/api/inventory/${id}/composite`
}

/**
 * @summary Render the active template for the selected composition layout + the operator's transparent source onto a composite PNG and persist it.
 */
export const generateInventoryComposite = async (id: string,
    generateCompositeInput: GenerateCompositeInput, options?: RequestInit): Promise<GenerateCompositeResponse> => {

  return customFetch<GenerateCompositeResponse>(getGenerateInventoryCompositeUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(generateCompositeInput)
  }
);}





export const getGenerateInventoryCompositeMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateInventoryComposite>>, TError,{id: string;data: BodyType<GenerateCompositeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof generateInventoryComposite>>, TError,{id: string;data: BodyType<GenerateCompositeInput>}, TContext> => {

const mutationKey = ['generateInventoryComposite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateInventoryComposite>>, {id: string;data: BodyType<GenerateCompositeInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  generateInventoryComposite(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateInventoryCompositeMutationResult = NonNullable<Awaited<ReturnType<typeof generateInventoryComposite>>>
    export type GenerateInventoryCompositeMutationBody = BodyType<GenerateCompositeInput>
    export type GenerateInventoryCompositeMutationError = ErrorType<void>

    /**
 * @summary Render the active template for the selected composition layout + the operator's transparent source onto a composite PNG and persist it.
 */
export const useGenerateInventoryComposite = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateInventoryComposite>>, TError,{id: string;data: BodyType<GenerateCompositeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof generateInventoryComposite>>,
        TError,
        {id: string;data: BodyType<GenerateCompositeInput>},
        TContext
      > => {
      return useMutation(getGenerateInventoryCompositeMutationOptions(options));
    }

export const getClearInventoryCompositeUrl = (id: string,) => {




  return `/api/inventory/${id}/composite`
}

/**
 * @summary Clear the composite (and all 8 composite_* fields, plus the archive) from this inventory item.
 */
export const clearInventoryComposite = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getClearInventoryCompositeUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getClearInventoryCompositeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearInventoryComposite>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof clearInventoryComposite>>, TError,{id: string}, TContext> => {

const mutationKey = ['clearInventoryComposite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearInventoryComposite>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  clearInventoryComposite(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearInventoryCompositeMutationResult = NonNullable<Awaited<ReturnType<typeof clearInventoryComposite>>>

    export type ClearInventoryCompositeMutationError = ErrorType<unknown>

    /**
 * @summary Clear the composite (and all 8 composite_* fields, plus the archive) from this inventory item.
 */
export const useClearInventoryComposite = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearInventoryComposite>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof clearInventoryComposite>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getClearInventoryCompositeMutationOptions(options));
    }

export const getReorderInventoryCompositeArchiveUrl = (id: string,) => {




  return `/api/inventory/${id}/composite-archive/order`
}

/**
 * @summary Reorder the operator-curated composite archive for this inventory item.
Body must contain the EXACT same set of entry ids as the existing
archive (no add/remove/dupe) — wrong-length, unknown, or duplicate ids
return 409 so a stale FE racing a per-entry DELETE or a regenerate
cannot resurrect dropped entries. The resulting order drives the
marketplace push gallery (Shopify + eBay) for additional images,
with index 0 immediately following the current primary composite.

 */
export const reorderInventoryCompositeArchive = async (id: string,
    reorderCompositeArchiveRequest: ReorderCompositeArchiveRequest, options?: RequestInit): Promise<ReorderInventoryCompositeArchive200> => {

  return customFetch<ReorderInventoryCompositeArchive200>(getReorderInventoryCompositeArchiveUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reorderCompositeArchiveRequest)
  }
);}





export const getReorderInventoryCompositeArchiveMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderInventoryCompositeArchive>>, TError,{id: string;data: BodyType<ReorderCompositeArchiveRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderInventoryCompositeArchive>>, TError,{id: string;data: BodyType<ReorderCompositeArchiveRequest>}, TContext> => {

const mutationKey = ['reorderInventoryCompositeArchive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderInventoryCompositeArchive>>, {id: string;data: BodyType<ReorderCompositeArchiveRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  reorderInventoryCompositeArchive(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReorderInventoryCompositeArchiveMutationResult = NonNullable<Awaited<ReturnType<typeof reorderInventoryCompositeArchive>>>
    export type ReorderInventoryCompositeArchiveMutationBody = BodyType<ReorderCompositeArchiveRequest>
    export type ReorderInventoryCompositeArchiveMutationError = ErrorType<void>

    /**
 * @summary Reorder the operator-curated composite archive for this inventory item.
Body must contain the EXACT same set of entry ids as the existing
archive (no add/remove/dupe) — wrong-length, unknown, or duplicate ids
return 409 so a stale FE racing a per-entry DELETE or a regenerate
cannot resurrect dropped entries. The resulting order drives the
marketplace push gallery (Shopify + eBay) for additional images,
with index 0 immediately following the current primary composite.

 */
export const useReorderInventoryCompositeArchive = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderInventoryCompositeArchive>>, TError,{id: string;data: BodyType<ReorderCompositeArchiveRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reorderInventoryCompositeArchive>>,
        TError,
        {id: string;data: BodyType<ReorderCompositeArchiveRequest>},
        TContext
      > => {
      return useMutation(getReorderInventoryCompositeArchiveMutationOptions(options));
    }

export const getDeleteInventoryCompositeArchiveEntryUrl = (id: string,
    entryId: string,) => {




  return `/api/inventory/${id}/composite-archive/${entryId}`
}

/**
 * @summary Prune a single archived composite from this inventory item's history.
The primary compositePhotoUrl is left intact — use DELETE
/inventory/{id}/composite for the full reset. Returns the new archive
so the frontend can swap it into its query cache without a refetch.

 */
export const deleteInventoryCompositeArchiveEntry = async (id: string,
    entryId: string, options?: RequestInit): Promise<DeleteInventoryCompositeArchiveEntry200> => {

  return customFetch<DeleteInventoryCompositeArchiveEntry200>(getDeleteInventoryCompositeArchiveEntryUrl(id,entryId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteInventoryCompositeArchiveEntryMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInventoryCompositeArchiveEntry>>, TError,{id: string;entryId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteInventoryCompositeArchiveEntry>>, TError,{id: string;entryId: string}, TContext> => {

const mutationKey = ['deleteInventoryCompositeArchiveEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInventoryCompositeArchiveEntry>>, {id: string;entryId: string}> = (props) => {
          const {id,entryId} = props ?? {};

          return  deleteInventoryCompositeArchiveEntry(id,entryId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteInventoryCompositeArchiveEntryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInventoryCompositeArchiveEntry>>>

    export type DeleteInventoryCompositeArchiveEntryMutationError = ErrorType<void>

    /**
 * @summary Prune a single archived composite from this inventory item's history.
The primary compositePhotoUrl is left intact — use DELETE
/inventory/{id}/composite for the full reset. Returns the new archive
so the frontend can swap it into its query cache without a refetch.

 */
export const useDeleteInventoryCompositeArchiveEntry = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInventoryCompositeArchiveEntry>>, TError,{id: string;entryId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteInventoryCompositeArchiveEntry>>,
        TError,
        {id: string;entryId: string},
        TContext
      > => {
      return useMutation(getDeleteInventoryCompositeArchiveEntryMutationOptions(options));
    }

export const getListImageTemplatesUrl = () => {




  return `/api/admin/image-templates`
}

/**
 * @summary List all image templates for the current tenant (active first within each usage).
 */
export const listImageTemplates = async ( options?: RequestInit): Promise<ImageTemplateListResponse> => {

  return customFetch<ImageTemplateListResponse>(getListImageTemplatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListImageTemplatesQueryKey = () => {
    return [
    `/api/admin/image-templates`
    ] as const;
    }


export const getListImageTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof listImageTemplates>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listImageTemplates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListImageTemplatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listImageTemplates>>> = ({ signal }) => listImageTemplates({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listImageTemplates>>, TError, TData> & { queryKey: QueryKey }
}

export type ListImageTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof listImageTemplates>>>
export type ListImageTemplatesQueryError = ErrorType<unknown>


/**
 * @summary List all image templates for the current tenant (active first within each usage).
 */

export function useListImageTemplates<TData = Awaited<ReturnType<typeof listImageTemplates>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listImageTemplates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListImageTemplatesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateImageTemplateUrl = () => {




  return `/api/admin/image-templates`
}

/**
 * @summary Create a new image template (admin only).
 */
export const createImageTemplate = async (createImageTemplateInput: CreateImageTemplateInput, options?: RequestInit): Promise<CreateImageTemplate201> => {

  return customFetch<CreateImageTemplate201>(getCreateImageTemplateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createImageTemplateInput)
  }
);}





export const getCreateImageTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImageTemplate>>, TError,{data: BodyType<CreateImageTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createImageTemplate>>, TError,{data: BodyType<CreateImageTemplateInput>}, TContext> => {

const mutationKey = ['createImageTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createImageTemplate>>, {data: BodyType<CreateImageTemplateInput>}> = (props) => {
          const {data} = props ?? {};

          return  createImageTemplate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateImageTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof createImageTemplate>>>
    export type CreateImageTemplateMutationBody = BodyType<CreateImageTemplateInput>
    export type CreateImageTemplateMutationError = ErrorType<unknown>

    /**
 * @summary Create a new image template (admin only).
 */
export const useCreateImageTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImageTemplate>>, TError,{data: BodyType<CreateImageTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createImageTemplate>>,
        TError,
        {data: BodyType<CreateImageTemplateInput>},
        TContext
      > => {
      return useMutation(getCreateImageTemplateMutationOptions(options));
    }

export const getActivateImageTemplateUrl = (id: string,) => {




  return `/api/admin/image-templates/${id}/activate`
}

/**
 * @summary Make this template active within its usage (deactivates only that usage's active template).
 */
export const activateImageTemplate = async (id: string, options?: RequestInit): Promise<ActivateImageTemplate200> => {

  return customFetch<ActivateImageTemplate200>(getActivateImageTemplateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getActivateImageTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateImageTemplate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activateImageTemplate>>, TError,{id: string}, TContext> => {

const mutationKey = ['activateImageTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateImageTemplate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  activateImageTemplate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivateImageTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof activateImageTemplate>>>

    export type ActivateImageTemplateMutationError = ErrorType<unknown>

    /**
 * @summary Make this template active within its usage (deactivates only that usage's active template).
 */
export const useActivateImageTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateImageTemplate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof activateImageTemplate>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getActivateImageTemplateMutationOptions(options));
    }

export const getArchiveImageTemplateUrl = (id: string,) => {




  return `/api/admin/image-templates/${id}`
}

/**
 * @summary Soft-archive a template (cannot archive the active template for its usage).
 */
export const archiveImageTemplate = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getArchiveImageTemplateUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getArchiveImageTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveImageTemplate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveImageTemplate>>, TError,{id: string}, TContext> => {

const mutationKey = ['archiveImageTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveImageTemplate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  archiveImageTemplate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveImageTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof archiveImageTemplate>>>

    export type ArchiveImageTemplateMutationError = ErrorType<unknown>

    /**
 * @summary Soft-archive a template (cannot archive the active template for its usage).
 */
export const useArchiveImageTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveImageTemplate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof archiveImageTemplate>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getArchiveImageTemplateMutationOptions(options));
    }

export const getListPackingJobsUrl = (params?: ListPackingJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/packing/jobs?${stringifiedParams}` : `/api/packing/jobs`
}

/**
 * @summary List packing jobs with multi-mode search.
 */
export const listPackingJobs = async (params?: ListPackingJobsParams, options?: RequestInit): Promise<ListPackingJobs200> => {

  return customFetch<ListPackingJobs200>(getListPackingJobsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPackingJobsQueryKey = (params?: ListPackingJobsParams,) => {
    return [
    `/api/packing/jobs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPackingJobsQueryOptions = <TData = Awaited<ReturnType<typeof listPackingJobs>>, TError = ErrorType<unknown>>(params?: ListPackingJobsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPackingJobs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPackingJobsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPackingJobs>>> = ({ signal }) => listPackingJobs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPackingJobs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPackingJobsQueryResult = NonNullable<Awaited<ReturnType<typeof listPackingJobs>>>
export type ListPackingJobsQueryError = ErrorType<unknown>


/**
 * @summary List packing jobs with multi-mode search.
 */

export function useListPackingJobs<TData = Awaited<ReturnType<typeof listPackingJobs>>, TError = ErrorType<unknown>>(
 params?: ListPackingJobsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPackingJobs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPackingJobsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getMaterializePackingJobsUrl = () => {




  return `/api/packing/jobs/materialize`
}

/**
 * @summary Re-scan open sale orders and ensure each one is attached to a packing job (idempotent).
 */
export const materializePackingJobs = async ( options?: RequestInit): Promise<PackingJobMaterializeResult> => {

  return customFetch<PackingJobMaterializeResult>(getMaterializePackingJobsUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMaterializePackingJobsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof materializePackingJobs>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof materializePackingJobs>>, TError,void, TContext> => {

const mutationKey = ['materializePackingJobs'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof materializePackingJobs>>, void> = () => {


          return  materializePackingJobs(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MaterializePackingJobsMutationResult = NonNullable<Awaited<ReturnType<typeof materializePackingJobs>>>

    export type MaterializePackingJobsMutationError = ErrorType<unknown>

    /**
 * @summary Re-scan open sale orders and ensure each one is attached to a packing job (idempotent).
 */
export const useMaterializePackingJobs = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof materializePackingJobs>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof materializePackingJobs>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMaterializePackingJobsMutationOptions(options));
    }

export const getListCombinedShipmentSuggestionsUrl = (params?: ListCombinedShipmentSuggestionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/packing/combined-shipment-suggestions?${stringifiedParams}` : `/api/packing/combined-shipment-suggestions`
}

/**
 * @summary Detect potential combined shipments — customers with more than one active (not-yet-completed) packing job that could be packed and shipped together (e.g. multiple TikTok Shop orders whose addresses differed just enough to dodge auto-collapse).

 */
export const listCombinedShipmentSuggestions = async (params?: ListCombinedShipmentSuggestionsParams, options?: RequestInit): Promise<ListCombinedShipmentSuggestions200> => {

  return customFetch<ListCombinedShipmentSuggestions200>(getListCombinedShipmentSuggestionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCombinedShipmentSuggestionsQueryKey = (params?: ListCombinedShipmentSuggestionsParams,) => {
    return [
    `/api/packing/combined-shipment-suggestions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCombinedShipmentSuggestionsQueryOptions = <TData = Awaited<ReturnType<typeof listCombinedShipmentSuggestions>>, TError = ErrorType<unknown>>(params?: ListCombinedShipmentSuggestionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCombinedShipmentSuggestions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCombinedShipmentSuggestionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCombinedShipmentSuggestions>>> = ({ signal }) => listCombinedShipmentSuggestions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCombinedShipmentSuggestions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCombinedShipmentSuggestionsQueryResult = NonNullable<Awaited<ReturnType<typeof listCombinedShipmentSuggestions>>>
export type ListCombinedShipmentSuggestionsQueryError = ErrorType<unknown>


/**
 * @summary Detect potential combined shipments — customers with more than one active (not-yet-completed) packing job that could be packed and shipped together (e.g. multiple TikTok Shop orders whose addresses differed just enough to dodge auto-collapse).

 */

export function useListCombinedShipmentSuggestions<TData = Awaited<ReturnType<typeof listCombinedShipmentSuggestions>>, TError = ErrorType<unknown>>(
 params?: ListCombinedShipmentSuggestionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCombinedShipmentSuggestions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCombinedShipmentSuggestionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCombinePackingJobsUrl = () => {




  return `/api/packing/combined-shipment-suggestions/combine`
}

/**
 * @summary Merge several active packing jobs for the same customer into one (the oldest survives); their orders/items move onto the survivor, its counters recompute and the emptied jobs are cancelled. Audit-logged.

 */
export const combinePackingJobs = async (combinePackingJobsRequest: CombinePackingJobsRequest, options?: RequestInit): Promise<CombinePackingJobsResult> => {

  return customFetch<CombinePackingJobsResult>(getCombinePackingJobsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(combinePackingJobsRequest)
  }
);}





export const getCombinePackingJobsMutationOptions = <TError = ErrorType<CombinePackingJobs400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof combinePackingJobs>>, TError,{data: BodyType<CombinePackingJobsRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof combinePackingJobs>>, TError,{data: BodyType<CombinePackingJobsRequest>}, TContext> => {

const mutationKey = ['combinePackingJobs'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof combinePackingJobs>>, {data: BodyType<CombinePackingJobsRequest>}> = (props) => {
          const {data} = props ?? {};

          return  combinePackingJobs(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CombinePackingJobsMutationResult = NonNullable<Awaited<ReturnType<typeof combinePackingJobs>>>
    export type CombinePackingJobsMutationBody = BodyType<CombinePackingJobsRequest>
    export type CombinePackingJobsMutationError = ErrorType<CombinePackingJobs400>

    /**
 * @summary Merge several active packing jobs for the same customer into one (the oldest survives); their orders/items move onto the survivor, its counters recompute and the emptied jobs are cancelled. Audit-logged.

 */
export const useCombinePackingJobs = <TError = ErrorType<CombinePackingJobs400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof combinePackingJobs>>, TError,{data: BodyType<CombinePackingJobsRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof combinePackingJobs>>,
        TError,
        {data: BodyType<CombinePackingJobsRequest>},
        TContext
      > => {
      return useMutation(getCombinePackingJobsMutationOptions(options));
    }

export const getDismissCombinedShipmentSuggestionUrl = () => {




  return `/api/packing/combined-shipment-suggestions/dismiss`
}

/**
 * @summary Permanently dismiss a combined-shipment suggestion for the same customer so it stops re-surfacing. Keyed by a stable hash of the sorted jobId set, so a genuinely new pairing (jobs change) can surface again. Audit-logged.

 */
export const dismissCombinedShipmentSuggestion = async (dismissCombinedShipmentSuggestionRequest: DismissCombinedShipmentSuggestionRequest, options?: RequestInit): Promise<DismissCombinedShipmentSuggestion200> => {

  return customFetch<DismissCombinedShipmentSuggestion200>(getDismissCombinedShipmentSuggestionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(dismissCombinedShipmentSuggestionRequest)
  }
);}





export const getDismissCombinedShipmentSuggestionMutationOptions = <TError = ErrorType<DismissCombinedShipmentSuggestion400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissCombinedShipmentSuggestion>>, TError,{data: BodyType<DismissCombinedShipmentSuggestionRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dismissCombinedShipmentSuggestion>>, TError,{data: BodyType<DismissCombinedShipmentSuggestionRequest>}, TContext> => {

const mutationKey = ['dismissCombinedShipmentSuggestion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dismissCombinedShipmentSuggestion>>, {data: BodyType<DismissCombinedShipmentSuggestionRequest>}> = (props) => {
          const {data} = props ?? {};

          return  dismissCombinedShipmentSuggestion(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DismissCombinedShipmentSuggestionMutationResult = NonNullable<Awaited<ReturnType<typeof dismissCombinedShipmentSuggestion>>>
    export type DismissCombinedShipmentSuggestionMutationBody = BodyType<DismissCombinedShipmentSuggestionRequest>
    export type DismissCombinedShipmentSuggestionMutationError = ErrorType<DismissCombinedShipmentSuggestion400>

    /**
 * @summary Permanently dismiss a combined-shipment suggestion for the same customer so it stops re-surfacing. Keyed by a stable hash of the sorted jobId set, so a genuinely new pairing (jobs change) can surface again. Audit-logged.

 */
export const useDismissCombinedShipmentSuggestion = <TError = ErrorType<DismissCombinedShipmentSuggestion400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissCombinedShipmentSuggestion>>, TError,{data: BodyType<DismissCombinedShipmentSuggestionRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof dismissCombinedShipmentSuggestion>>,
        TError,
        {data: BodyType<DismissCombinedShipmentSuggestionRequest>},
        TContext
      > => {
      return useMutation(getDismissCombinedShipmentSuggestionMutationOptions(options));
    }

export const getGetPackingJobUrl = (id: string,) => {




  return `/api/packing/jobs/${id}`
}

export const getPackingJob = async (id: string, options?: RequestInit): Promise<PackingJobDetail> => {

  return customFetch<PackingJobDetail>(getGetPackingJobUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPackingJobQueryKey = (id: string,) => {
    return [
    `/api/packing/jobs/${id}`
    ] as const;
    }


export const getGetPackingJobQueryOptions = <TData = Awaited<ReturnType<typeof getPackingJob>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPackingJob>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPackingJobQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPackingJob>>> = ({ signal }) => getPackingJob(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPackingJob>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPackingJobQueryResult = NonNullable<Awaited<ReturnType<typeof getPackingJob>>>
export type GetPackingJobQueryError = ErrorType<void>



export function useGetPackingJob<TData = Awaited<ReturnType<typeof getPackingJob>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPackingJob>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPackingJobQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdatePackingJobUrl = (id: string,) => {




  return `/api/packing/jobs/${id}`
}

export const updatePackingJob = async (id: string,
    packingJobUpdate: PackingJobUpdate, options?: RequestInit): Promise<UpdatePackingJob200> => {

  return customFetch<UpdatePackingJob200>(getUpdatePackingJobUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(packingJobUpdate)
  }
);}





export const getUpdatePackingJobMutationOptions = <TError = ErrorType<UpdatePackingJob409>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePackingJob>>, TError,{id: string;data: BodyType<PackingJobUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePackingJob>>, TError,{id: string;data: BodyType<PackingJobUpdate>}, TContext> => {

const mutationKey = ['updatePackingJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePackingJob>>, {id: string;data: BodyType<PackingJobUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePackingJob(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePackingJobMutationResult = NonNullable<Awaited<ReturnType<typeof updatePackingJob>>>
    export type UpdatePackingJobMutationBody = BodyType<PackingJobUpdate>
    export type UpdatePackingJobMutationError = ErrorType<UpdatePackingJob409>

    export const useUpdatePackingJob = <TError = ErrorType<UpdatePackingJob409>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePackingJob>>, TError,{id: string;data: BodyType<PackingJobUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePackingJob>>,
        TError,
        {id: string;data: BodyType<PackingJobUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePackingJobMutationOptions(options));
    }

export const getSplitPackingJobByLabelUrl = (id: string,) => {




  return `/api/packing/jobs/${id}/split-by-label`
}

/**
 * @summary Split a pending, media-free packing job that bundles orders with disagreeing shipping labels (tracking numbers) into one job per label — the largest label group (plus any untracked orders) stays on the original job. General "Split by label" operator action, channel- agnostic; reuses the same mechanics as the automatic post-label- import split. Refuses jobs that are not pending or already carry captured media. Audit-logged.

 */
export const splitPackingJobByLabel = async (id: string, options?: RequestInit): Promise<SplitPackingJobByLabelResult> => {

  return customFetch<SplitPackingJobByLabelResult>(getSplitPackingJobByLabelUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSplitPackingJobByLabelMutationOptions = <TError = ErrorType<void | SplitPackingJobByLabel409>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof splitPackingJobByLabel>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof splitPackingJobByLabel>>, TError,{id: string}, TContext> => {

const mutationKey = ['splitPackingJobByLabel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof splitPackingJobByLabel>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  splitPackingJobByLabel(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SplitPackingJobByLabelMutationResult = NonNullable<Awaited<ReturnType<typeof splitPackingJobByLabel>>>

    export type SplitPackingJobByLabelMutationError = ErrorType<void | SplitPackingJobByLabel409>

    /**
 * @summary Split a pending, media-free packing job that bundles orders with disagreeing shipping labels (tracking numbers) into one job per label — the largest label group (plus any untracked orders) stays on the original job. General "Split by label" operator action, channel- agnostic; reuses the same mechanics as the automatic post-label- import split. Refuses jobs that are not pending or already carry captured media. Audit-logged.

 */
export const useSplitPackingJobByLabel = <TError = ErrorType<void | SplitPackingJobByLabel409>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof splitPackingJobByLabel>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof splitPackingJobByLabel>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getSplitPackingJobByLabelMutationOptions(options));
    }

export const getSendPackingJobConfirmationUrl = (id: string,) => {




  return `/api/packing/jobs/${id}/send-confirmation`
}

/**
 * @summary Send the "your parcel is sealed" confirmation to the customer via
email, WhatsApp (Twilio), and/or SMS (Twilio). On success the job
auto-transitions packed → confirmation_sent and records the send
timestamp. Calling again on a job already in confirmation_sent
triggers a resend that refreshes the timestamp.

 */
export const sendPackingJobConfirmation = async (id: string,
    packingConfirmationRequest?: PackingConfirmationRequest, options?: RequestInit): Promise<SendPackingJobConfirmation200> => {

  return customFetch<SendPackingJobConfirmation200>(getSendPackingJobConfirmationUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(packingConfirmationRequest)
  }
);}





export const getSendPackingJobConfirmationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPackingJobConfirmation>>, TError,{id: string;data?: BodyType<PackingConfirmationRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendPackingJobConfirmation>>, TError,{id: string;data?: BodyType<PackingConfirmationRequest>}, TContext> => {

const mutationKey = ['sendPackingJobConfirmation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendPackingJobConfirmation>>, {id: string;data?: BodyType<PackingConfirmationRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  sendPackingJobConfirmation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendPackingJobConfirmationMutationResult = NonNullable<Awaited<ReturnType<typeof sendPackingJobConfirmation>>>
    export type SendPackingJobConfirmationMutationBody = BodyType<PackingConfirmationRequest> | undefined
    export type SendPackingJobConfirmationMutationError = ErrorType<void>

    /**
 * @summary Send the "your parcel is sealed" confirmation to the customer via
email, WhatsApp (Twilio), and/or SMS (Twilio). On success the job
auto-transitions packed → confirmation_sent and records the send
timestamp. Calling again on a job already in confirmation_sent
triggers a resend that refreshes the timestamp.

 */
export const useSendPackingJobConfirmation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPackingJobConfirmation>>, TError,{id: string;data?: BodyType<PackingConfirmationRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendPackingJobConfirmation>>,
        TError,
        {id: string;data?: BodyType<PackingConfirmationRequest>},
        TContext
      > => {
      return useMutation(getSendPackingJobConfirmationMutationOptions(options));
    }

export const getListPackingJobMediaUrl = (id: string,) => {




  return `/api/packing/jobs/${id}/media`
}

/**
 * @summary List photo / video evidence attached to a packing job.
 */
export const listPackingJobMedia = async (id: string, options?: RequestInit): Promise<ListPackingJobMedia200> => {

  return customFetch<ListPackingJobMedia200>(getListPackingJobMediaUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPackingJobMediaQueryKey = (id: string,) => {
    return [
    `/api/packing/jobs/${id}/media`
    ] as const;
    }


export const getListPackingJobMediaQueryOptions = <TData = Awaited<ReturnType<typeof listPackingJobMedia>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPackingJobMedia>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPackingJobMediaQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPackingJobMedia>>> = ({ signal }) => listPackingJobMedia(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPackingJobMedia>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPackingJobMediaQueryResult = NonNullable<Awaited<ReturnType<typeof listPackingJobMedia>>>
export type ListPackingJobMediaQueryError = ErrorType<unknown>


/**
 * @summary List photo / video evidence attached to a packing job.
 */

export function useListPackingJobMedia<TData = Awaited<ReturnType<typeof listPackingJobMedia>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPackingJobMedia>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPackingJobMediaQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreatePackingJobMediaUrl = (id: string,) => {




  return `/api/packing/jobs/${id}/media`
}

/**
 * @summary Attach an already-uploaded object to a packing job as evidence.
 */
export const createPackingJobMedia = async (id: string,
    packingJobMediaCreate: PackingJobMediaCreate, options?: RequestInit): Promise<PackingJobMedia> => {

  return customFetch<PackingJobMedia>(getCreatePackingJobMediaUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(packingJobMediaCreate)
  }
);}





export const getCreatePackingJobMediaMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPackingJobMedia>>, TError,{id: string;data: BodyType<PackingJobMediaCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPackingJobMedia>>, TError,{id: string;data: BodyType<PackingJobMediaCreate>}, TContext> => {

const mutationKey = ['createPackingJobMedia'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPackingJobMedia>>, {id: string;data: BodyType<PackingJobMediaCreate>}> = (props) => {
          const {id,data} = props ?? {};

          return  createPackingJobMedia(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePackingJobMediaMutationResult = NonNullable<Awaited<ReturnType<typeof createPackingJobMedia>>>
    export type CreatePackingJobMediaMutationBody = BodyType<PackingJobMediaCreate>
    export type CreatePackingJobMediaMutationError = ErrorType<unknown>

    /**
 * @summary Attach an already-uploaded object to a packing job as evidence.
 */
export const useCreatePackingJobMedia = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPackingJobMedia>>, TError,{id: string;data: BodyType<PackingJobMediaCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPackingJobMedia>>,
        TError,
        {id: string;data: BodyType<PackingJobMediaCreate>},
        TContext
      > => {
      return useMutation(getCreatePackingJobMediaMutationOptions(options));
    }

export const getUpdatePackingJobMediaUrl = (mediaId: string,) => {




  return `/api/packing/media/${mediaId}`
}

/**
 * @summary Update sort order or notes on a single packing media row.
 */
export const updatePackingJobMedia = async (mediaId: string,
    packingJobMediaUpdate: PackingJobMediaUpdate, options?: RequestInit): Promise<PackingJobMedia> => {

  return customFetch<PackingJobMedia>(getUpdatePackingJobMediaUrl(mediaId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(packingJobMediaUpdate)
  }
);}





export const getUpdatePackingJobMediaMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePackingJobMedia>>, TError,{mediaId: string;data: BodyType<PackingJobMediaUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePackingJobMedia>>, TError,{mediaId: string;data: BodyType<PackingJobMediaUpdate>}, TContext> => {

const mutationKey = ['updatePackingJobMedia'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePackingJobMedia>>, {mediaId: string;data: BodyType<PackingJobMediaUpdate>}> = (props) => {
          const {mediaId,data} = props ?? {};

          return  updatePackingJobMedia(mediaId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePackingJobMediaMutationResult = NonNullable<Awaited<ReturnType<typeof updatePackingJobMedia>>>
    export type UpdatePackingJobMediaMutationBody = BodyType<PackingJobMediaUpdate>
    export type UpdatePackingJobMediaMutationError = ErrorType<unknown>

    /**
 * @summary Update sort order or notes on a single packing media row.
 */
export const useUpdatePackingJobMedia = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePackingJobMedia>>, TError,{mediaId: string;data: BodyType<PackingJobMediaUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePackingJobMedia>>,
        TError,
        {mediaId: string;data: BodyType<PackingJobMediaUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePackingJobMediaMutationOptions(options));
    }

export const getDeletePackingJobMediaUrl = (mediaId: string,) => {




  return `/api/packing/media/${mediaId}`
}

export const deletePackingJobMedia = async (mediaId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeletePackingJobMediaUrl(mediaId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeletePackingJobMediaMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePackingJobMedia>>, TError,{mediaId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePackingJobMedia>>, TError,{mediaId: string}, TContext> => {

const mutationKey = ['deletePackingJobMedia'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePackingJobMedia>>, {mediaId: string}> = (props) => {
          const {mediaId} = props ?? {};

          return  deletePackingJobMedia(mediaId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePackingJobMediaMutationResult = NonNullable<Awaited<ReturnType<typeof deletePackingJobMedia>>>

    export type DeletePackingJobMediaMutationError = ErrorType<unknown>

    export const useDeletePackingJobMedia = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePackingJobMedia>>, TError,{mediaId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePackingJobMedia>>,
        TError,
        {mediaId: string},
        TContext
      > => {
      return useMutation(getDeletePackingJobMediaMutationOptions(options));
    }

export const getListSalePackingNotesUrl = (id: string,) => {




  return `/api/sales/${id}/packing-notes`
}

/**
 * @summary List packing notes attached to a sale order (sale-detail view).
 */
export const listSalePackingNotes = async (id: string, options?: RequestInit): Promise<ListSalePackingNotes200> => {

  return customFetch<ListSalePackingNotes200>(getListSalePackingNotesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSalePackingNotesQueryKey = (id: string,) => {
    return [
    `/api/sales/${id}/packing-notes`
    ] as const;
    }


export const getListSalePackingNotesQueryOptions = <TData = Awaited<ReturnType<typeof listSalePackingNotes>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSalePackingNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSalePackingNotesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSalePackingNotes>>> = ({ signal }) => listSalePackingNotes(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSalePackingNotes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSalePackingNotesQueryResult = NonNullable<Awaited<ReturnType<typeof listSalePackingNotes>>>
export type ListSalePackingNotesQueryError = ErrorType<void>


/**
 * @summary List packing notes attached to a sale order (sale-detail view).
 */

export function useListSalePackingNotes<TData = Awaited<ReturnType<typeof listSalePackingNotes>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSalePackingNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSalePackingNotesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateSalePackingNoteUrl = (id: string,) => {




  return `/api/sales/${id}/packing-notes`
}

/**
 * @summary Add a packing note to a sale order.
 */
export const createSalePackingNote = async (id: string,
    packingNoteCreate: PackingNoteCreate, options?: RequestInit): Promise<PackingNote> => {

  return customFetch<PackingNote>(getCreateSalePackingNoteUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(packingNoteCreate)
  }
);}





export const getCreateSalePackingNoteMutationOptions = <TError = ErrorType<CreateSalePackingNote400 | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSalePackingNote>>, TError,{id: string;data: BodyType<PackingNoteCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSalePackingNote>>, TError,{id: string;data: BodyType<PackingNoteCreate>}, TContext> => {

const mutationKey = ['createSalePackingNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSalePackingNote>>, {id: string;data: BodyType<PackingNoteCreate>}> = (props) => {
          const {id,data} = props ?? {};

          return  createSalePackingNote(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSalePackingNoteMutationResult = NonNullable<Awaited<ReturnType<typeof createSalePackingNote>>>
    export type CreateSalePackingNoteMutationBody = BodyType<PackingNoteCreate>
    export type CreateSalePackingNoteMutationError = ErrorType<CreateSalePackingNote400 | void>

    /**
 * @summary Add a packing note to a sale order.
 */
export const useCreateSalePackingNote = <TError = ErrorType<CreateSalePackingNote400 | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSalePackingNote>>, TError,{id: string;data: BodyType<PackingNoteCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSalePackingNote>>,
        TError,
        {id: string;data: BodyType<PackingNoteCreate>},
        TContext
      > => {
      return useMutation(getCreateSalePackingNoteMutationOptions(options));
    }

export const getGetPackingJobShareLinkUrl = (id: string,) => {




  return `/api/packing/jobs/${id}/share-link`
}

/**
 * @summary Mint the HMAC-signed packing-media gallery link for a packing job.
Returns the URL and whether the job currently has any media attached.
The URL is null when no public base URL is resolvable (neither
REPLIT_DOMAINS nor REPLIT_DEV_DOMAIN is set). Anyone with the link
can open the no-auth gallery — identical to the link customers
receive in packed-confirmation messages.

 */
export const getPackingJobShareLink = async (id: string, options?: RequestInit): Promise<GetPackingJobShareLink200> => {

  return customFetch<GetPackingJobShareLink200>(getGetPackingJobShareLinkUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPackingJobShareLinkQueryKey = (id: string,) => {
    return [
    `/api/packing/jobs/${id}/share-link`
    ] as const;
    }


export const getGetPackingJobShareLinkQueryOptions = <TData = Awaited<ReturnType<typeof getPackingJobShareLink>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPackingJobShareLink>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPackingJobShareLinkQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPackingJobShareLink>>> = ({ signal }) => getPackingJobShareLink(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPackingJobShareLink>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPackingJobShareLinkQueryResult = NonNullable<Awaited<ReturnType<typeof getPackingJobShareLink>>>
export type GetPackingJobShareLinkQueryError = ErrorType<void>


/**
 * @summary Mint the HMAC-signed packing-media gallery link for a packing job.
Returns the URL and whether the job currently has any media attached.
The URL is null when no public base URL is resolvable (neither
REPLIT_DOMAINS nor REPLIT_DEV_DOMAIN is set). Anyone with the link
can open the no-auth gallery — identical to the link customers
receive in packed-confirmation messages.

 */

export function useGetPackingJobShareLink<TData = Awaited<ReturnType<typeof getPackingJobShareLink>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPackingJobShareLink>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPackingJobShareLinkQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPackingJobNotesUrl = (id: string,) => {




  return `/api/packing/jobs/${id}/notes`
}

/**
 * @summary List packing notes for every order on a packing job, with an
`effectiveOpen` flag computed for THIS job (a "next time" note that
was deferred on a different job re-surfaces as open here).

 */
export const listPackingJobNotes = async (id: string, options?: RequestInit): Promise<ListPackingJobNotes200> => {

  return customFetch<ListPackingJobNotes200>(getListPackingJobNotesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPackingJobNotesQueryKey = (id: string,) => {
    return [
    `/api/packing/jobs/${id}/notes`
    ] as const;
    }


export const getListPackingJobNotesQueryOptions = <TData = Awaited<ReturnType<typeof listPackingJobNotes>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPackingJobNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPackingJobNotesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPackingJobNotes>>> = ({ signal }) => listPackingJobNotes(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPackingJobNotes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPackingJobNotesQueryResult = NonNullable<Awaited<ReturnType<typeof listPackingJobNotes>>>
export type ListPackingJobNotesQueryError = ErrorType<void>


/**
 * @summary List packing notes for every order on a packing job, with an
`effectiveOpen` flag computed for THIS job (a "next time" note that
was deferred on a different job re-surfaces as open here).

 */

export function useListPackingJobNotes<TData = Awaited<ReturnType<typeof listPackingJobNotes>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPackingJobNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPackingJobNotesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPackingJobCancelledBuyerUrl = (id: string,) => {




  return `/api/packing/jobs/${id}/cancelled-buyer`
}

/**
 * @summary Non-blocking reminder data for packers — any cancelled or reversed
orders in this buyer's history (matched on the job's ebayUsername),
with the most recent 24–72h highlighted.

 */
export const getPackingJobCancelledBuyer = async (id: string, options?: RequestInit): Promise<PackingJobCancelledBuyer> => {

  return customFetch<PackingJobCancelledBuyer>(getGetPackingJobCancelledBuyerUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPackingJobCancelledBuyerQueryKey = (id: string,) => {
    return [
    `/api/packing/jobs/${id}/cancelled-buyer`
    ] as const;
    }


export const getGetPackingJobCancelledBuyerQueryOptions = <TData = Awaited<ReturnType<typeof getPackingJobCancelledBuyer>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPackingJobCancelledBuyer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPackingJobCancelledBuyerQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPackingJobCancelledBuyer>>> = ({ signal }) => getPackingJobCancelledBuyer(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPackingJobCancelledBuyer>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPackingJobCancelledBuyerQueryResult = NonNullable<Awaited<ReturnType<typeof getPackingJobCancelledBuyer>>>
export type GetPackingJobCancelledBuyerQueryError = ErrorType<void>


/**
 * @summary Non-blocking reminder data for packers — any cancelled or reversed
orders in this buyer's history (matched on the job's ebayUsername),
with the most recent 24–72h highlighted.

 */

export function useGetPackingJobCancelledBuyer<TData = Awaited<ReturnType<typeof getPackingJobCancelledBuyer>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPackingJobCancelledBuyer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPackingJobCancelledBuyerQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getResolvePackingNoteUrl = (noteId: string,) => {




  return `/api/packing/notes/${noteId}/resolve`
}

/**
 * @summary Record an explicit decision on a packing note — mark it done
(permanent) or next-time (deferred; re-surfaces on the next packing
job for the order). next-time requires a non-empty reason.

 */
export const resolvePackingNote = async (noteId: string,
    packingNoteResolve: PackingNoteResolve, options?: RequestInit): Promise<PackingNote> => {

  return customFetch<PackingNote>(getResolvePackingNoteUrl(noteId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(packingNoteResolve)
  }
);}





export const getResolvePackingNoteMutationOptions = <TError = ErrorType<ResolvePackingNote400 | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolvePackingNote>>, TError,{noteId: string;data: BodyType<PackingNoteResolve>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resolvePackingNote>>, TError,{noteId: string;data: BodyType<PackingNoteResolve>}, TContext> => {

const mutationKey = ['resolvePackingNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resolvePackingNote>>, {noteId: string;data: BodyType<PackingNoteResolve>}> = (props) => {
          const {noteId,data} = props ?? {};

          return  resolvePackingNote(noteId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResolvePackingNoteMutationResult = NonNullable<Awaited<ReturnType<typeof resolvePackingNote>>>
    export type ResolvePackingNoteMutationBody = BodyType<PackingNoteResolve>
    export type ResolvePackingNoteMutationError = ErrorType<ResolvePackingNote400 | void>

    /**
 * @summary Record an explicit decision on a packing note — mark it done
(permanent) or next-time (deferred; re-surfaces on the next packing
job for the order). next-time requires a non-empty reason.

 */
export const useResolvePackingNote = <TError = ErrorType<ResolvePackingNote400 | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolvePackingNote>>, TError,{noteId: string;data: BodyType<PackingNoteResolve>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resolvePackingNote>>,
        TError,
        {noteId: string;data: BodyType<PackingNoteResolve>},
        TContext
      > => {
      return useMutation(getResolvePackingNoteMutationOptions(options));
    }

export const getReplyPackingNoteUrl = (noteId: string,) => {




  return `/api/packing/notes/${noteId}/reply`
}

/**
 * @summary Attach / replace a free-text reply on a packing note. Replying does
NOT resolve the note — an explicit done/next-time decision is still
required.

 */
export const replyPackingNote = async (noteId: string,
    packingNoteReply: PackingNoteReply, options?: RequestInit): Promise<PackingNote> => {

  return customFetch<PackingNote>(getReplyPackingNoteUrl(noteId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(packingNoteReply)
  }
);}





export const getReplyPackingNoteMutationOptions = <TError = ErrorType<ReplyPackingNote400 | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replyPackingNote>>, TError,{noteId: string;data: BodyType<PackingNoteReply>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof replyPackingNote>>, TError,{noteId: string;data: BodyType<PackingNoteReply>}, TContext> => {

const mutationKey = ['replyPackingNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replyPackingNote>>, {noteId: string;data: BodyType<PackingNoteReply>}> = (props) => {
          const {noteId,data} = props ?? {};

          return  replyPackingNote(noteId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplyPackingNoteMutationResult = NonNullable<Awaited<ReturnType<typeof replyPackingNote>>>
    export type ReplyPackingNoteMutationBody = BodyType<PackingNoteReply>
    export type ReplyPackingNoteMutationError = ErrorType<ReplyPackingNote400 | void>

    /**
 * @summary Attach / replace a free-text reply on a packing note. Replying does
NOT resolve the note — an explicit done/next-time decision is still
required.

 */
export const useReplyPackingNote = <TError = ErrorType<ReplyPackingNote400 | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replyPackingNote>>, TError,{noteId: string;data: BodyType<PackingNoteReply>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof replyPackingNote>>,
        TError,
        {noteId: string;data: BodyType<PackingNoteReply>},
        TContext
      > => {
      return useMutation(getReplyPackingNoteMutationOptions(options));
    }

export const getSetPackingOrderCertUrl = (id: string,
    orderId: string,) => {




  return `/api/packing/jobs/${id}/orders/${orderId}/cert`
}

/**
 * @summary Record a free-text certificate / serial number for the given sale order
within a packing job. For linking a tracked inventory_serials row to a
specific sale line use PATCH /packing/jobs/{id}/lines/{lineId}/serial.

 */
export const setPackingOrderCert = async (id: string,
    orderId: string,
    packingJobOrderCertUpdate: PackingJobOrderCertUpdate, options?: RequestInit): Promise<SetPackingOrderCert200> => {

  return customFetch<SetPackingOrderCert200>(getSetPackingOrderCertUrl(id,orderId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(packingJobOrderCertUpdate)
  }
);}





export const getSetPackingOrderCertMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPackingOrderCert>>, TError,{id: string;orderId: string;data: BodyType<PackingJobOrderCertUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setPackingOrderCert>>, TError,{id: string;orderId: string;data: BodyType<PackingJobOrderCertUpdate>}, TContext> => {

const mutationKey = ['setPackingOrderCert'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setPackingOrderCert>>, {id: string;orderId: string;data: BodyType<PackingJobOrderCertUpdate>}> = (props) => {
          const {id,orderId,data} = props ?? {};

          return  setPackingOrderCert(id,orderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetPackingOrderCertMutationResult = NonNullable<Awaited<ReturnType<typeof setPackingOrderCert>>>
    export type SetPackingOrderCertMutationBody = BodyType<PackingJobOrderCertUpdate>
    export type SetPackingOrderCertMutationError = ErrorType<void>

    /**
 * @summary Record a free-text certificate / serial number for the given sale order
within a packing job. For linking a tracked inventory_serials row to a
specific sale line use PATCH /packing/jobs/{id}/lines/{lineId}/serial.

 */
export const useSetPackingOrderCert = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPackingOrderCert>>, TError,{id: string;orderId: string;data: BodyType<PackingJobOrderCertUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setPackingOrderCert>>,
        TError,
        {id: string;orderId: string;data: BodyType<PackingJobOrderCertUpdate>},
        TContext
      > => {
      return useMutation(getSetPackingOrderCertMutationOptions(options));
    }

export const getSetPackingLineSerialUrl = (id: string,
    lineId: string,) => {




  return `/api/packing/jobs/${id}/lines/${lineId}/serial`
}

/**
 * @summary Assign (or unassign) a tracked inventory_serials row to a specific sale
line within a packing job. The server validates that the selected serial
belongs to the same inventory item as the target line. On link the
serial status flips to "dispatched" and sale_order_items.serial_id is
set; on unlink (serialId: null) the reverse occurs.

 */
export const setPackingLineSerial = async (id: string,
    lineId: string,
    packingJobLineSerialUpdate: PackingJobLineSerialUpdate, options?: RequestInit): Promise<SetPackingLineSerial200> => {

  return customFetch<SetPackingLineSerial200>(getSetPackingLineSerialUrl(id,lineId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(packingJobLineSerialUpdate)
  }
);}





export const getSetPackingLineSerialMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPackingLineSerial>>, TError,{id: string;lineId: string;data: BodyType<PackingJobLineSerialUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setPackingLineSerial>>, TError,{id: string;lineId: string;data: BodyType<PackingJobLineSerialUpdate>}, TContext> => {

const mutationKey = ['setPackingLineSerial'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setPackingLineSerial>>, {id: string;lineId: string;data: BodyType<PackingJobLineSerialUpdate>}> = (props) => {
          const {id,lineId,data} = props ?? {};

          return  setPackingLineSerial(id,lineId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetPackingLineSerialMutationResult = NonNullable<Awaited<ReturnType<typeof setPackingLineSerial>>>
    export type SetPackingLineSerialMutationBody = BodyType<PackingJobLineSerialUpdate>
    export type SetPackingLineSerialMutationError = ErrorType<void>

    /**
 * @summary Assign (or unassign) a tracked inventory_serials row to a specific sale
line within a packing job. The server validates that the selected serial
belongs to the same inventory item as the target line. On link the
serial status flips to "dispatched" and sale_order_items.serial_id is
set; on unlink (serialId: null) the reverse occurs.

 */
export const useSetPackingLineSerial = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPackingLineSerial>>, TError,{id: string;lineId: string;data: BodyType<PackingJobLineSerialUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setPackingLineSerial>>,
        TError,
        {id: string;lineId: string;data: BodyType<PackingJobLineSerialUpdate>},
        TContext
      > => {
      return useMutation(getSetPackingLineSerialMutationOptions(options));
    }

export const getGetTrackingIntegrationUrl = () => {




  return `/api/integrations/tracking`
}

/**
 * @summary 17track integration status (presence + quota), never returns the API key.
 */
export const getTrackingIntegration = async ( options?: RequestInit): Promise<TrackingIntegrationStatus> => {

  return customFetch<TrackingIntegrationStatus>(getGetTrackingIntegrationUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTrackingIntegrationQueryKey = () => {
    return [
    `/api/integrations/tracking`
    ] as const;
    }


export const getGetTrackingIntegrationQueryOptions = <TData = Awaited<ReturnType<typeof getTrackingIntegration>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTrackingIntegration>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrackingIntegrationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrackingIntegration>>> = ({ signal }) => getTrackingIntegration({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrackingIntegration>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTrackingIntegrationQueryResult = NonNullable<Awaited<ReturnType<typeof getTrackingIntegration>>>
export type GetTrackingIntegrationQueryError = ErrorType<unknown>


/**
 * @summary 17track integration status (presence + quota), never returns the API key.
 */

export function useGetTrackingIntegration<TData = Awaited<ReturnType<typeof getTrackingIntegration>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTrackingIntegration>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTrackingIntegrationQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPutTrackingIntegrationUrl = () => {




  return `/api/integrations/tracking`
}

/**
 * @summary Save / replace the 17track API key for the current tenant.
 */
export const putTrackingIntegration = async (trackingIntegrationUpdate: TrackingIntegrationUpdate, options?: RequestInit): Promise<TrackingIntegrationStatus> => {

  return customFetch<TrackingIntegrationStatus>(getPutTrackingIntegrationUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(trackingIntegrationUpdate)
  }
);}





export const getPutTrackingIntegrationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTrackingIntegration>>, TError,{data: BodyType<TrackingIntegrationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putTrackingIntegration>>, TError,{data: BodyType<TrackingIntegrationUpdate>}, TContext> => {

const mutationKey = ['putTrackingIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTrackingIntegration>>, {data: BodyType<TrackingIntegrationUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  putTrackingIntegration(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutTrackingIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof putTrackingIntegration>>>
    export type PutTrackingIntegrationMutationBody = BodyType<TrackingIntegrationUpdate>
    export type PutTrackingIntegrationMutationError = ErrorType<unknown>

    /**
 * @summary Save / replace the 17track API key for the current tenant.
 */
export const usePutTrackingIntegration = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTrackingIntegration>>, TError,{data: BodyType<TrackingIntegrationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putTrackingIntegration>>,
        TError,
        {data: BodyType<TrackingIntegrationUpdate>},
        TContext
      > => {
      return useMutation(getPutTrackingIntegrationMutationOptions(options));
    }

export const getDeleteTrackingIntegrationUrl = () => {




  return `/api/integrations/tracking`
}

/**
 * @summary Remove the 17track API key for the current tenant.
 */
export const deleteTrackingIntegration = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteTrackingIntegrationUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTrackingIntegrationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTrackingIntegration>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTrackingIntegration>>, TError,void, TContext> => {

const mutationKey = ['deleteTrackingIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTrackingIntegration>>, void> = () => {


          return  deleteTrackingIntegration(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTrackingIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTrackingIntegration>>>

    export type DeleteTrackingIntegrationMutationError = ErrorType<unknown>

    /**
 * @summary Remove the 17track API key for the current tenant.
 */
export const useDeleteTrackingIntegration = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTrackingIntegration>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTrackingIntegration>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteTrackingIntegrationMutationOptions(options));
    }

export const getTestTrackingIntegrationUrl = () => {




  return `/api/integrations/tracking/test`
}

/**
 * @summary Probe 17track with the saved API key (calls /getquotalimit).
 */
export const testTrackingIntegration = async ( options?: RequestInit): Promise<TrackingIntegrationTestResult> => {

  return customFetch<TrackingIntegrationTestResult>(getTestTrackingIntegrationUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getTestTrackingIntegrationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testTrackingIntegration>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testTrackingIntegration>>, TError,void, TContext> => {

const mutationKey = ['testTrackingIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testTrackingIntegration>>, void> = () => {


          return  testTrackingIntegration(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestTrackingIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof testTrackingIntegration>>>

    export type TestTrackingIntegrationMutationError = ErrorType<unknown>

    /**
 * @summary Probe 17track with the saved API key (calls /getquotalimit).
 */
export const useTestTrackingIntegration = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testTrackingIntegration>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof testTrackingIntegration>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getTestTrackingIntegrationMutationOptions(options));
    }

export const getGetOrderTrackingEventsUrl = (id: string,) => {




  return `/api/orders/${id}/tracking-events`
}

/**
 * @summary Cached + on-demand tracking events for one sale order.
 */
export const getOrderTrackingEvents = async (id: string, options?: RequestInit): Promise<TrackingStatus> => {

  return customFetch<TrackingStatus>(getGetOrderTrackingEventsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrderTrackingEventsQueryKey = (id: string,) => {
    return [
    `/api/orders/${id}/tracking-events`
    ] as const;
    }


export const getGetOrderTrackingEventsQueryOptions = <TData = Awaited<ReturnType<typeof getOrderTrackingEvents>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderTrackingEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderTrackingEventsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderTrackingEvents>>> = ({ signal }) => getOrderTrackingEvents(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrderTrackingEvents>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrderTrackingEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderTrackingEvents>>>
export type GetOrderTrackingEventsQueryError = ErrorType<unknown>


/**
 * @summary Cached + on-demand tracking events for one sale order.
 */

export function useGetOrderTrackingEvents<TData = Awaited<ReturnType<typeof getOrderTrackingEvents>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderTrackingEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrderTrackingEventsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetWhatsappIntegrationUrl = () => {




  return `/api/integrations/whatsapp`
}

/**
 * @summary Status of the Twilio WhatsApp integration for the current tenant.
Never returns the auth token.

 */
export const getWhatsappIntegration = async ( options?: RequestInit): Promise<WhatsappIntegrationStatus> => {

  return customFetch<WhatsappIntegrationStatus>(getGetWhatsappIntegrationUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWhatsappIntegrationQueryKey = () => {
    return [
    `/api/integrations/whatsapp`
    ] as const;
    }


export const getGetWhatsappIntegrationQueryOptions = <TData = Awaited<ReturnType<typeof getWhatsappIntegration>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatsappIntegration>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWhatsappIntegrationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWhatsappIntegration>>> = ({ signal }) => getWhatsappIntegration({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWhatsappIntegration>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWhatsappIntegrationQueryResult = NonNullable<Awaited<ReturnType<typeof getWhatsappIntegration>>>
export type GetWhatsappIntegrationQueryError = ErrorType<unknown>


/**
 * @summary Status of the Twilio WhatsApp integration for the current tenant.
Never returns the auth token.

 */

export function useGetWhatsappIntegration<TData = Awaited<ReturnType<typeof getWhatsappIntegration>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWhatsappIntegration>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWhatsappIntegrationQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPutWhatsappIntegrationUrl = () => {




  return `/api/integrations/whatsapp`
}

/**
 * @summary Save / replace the Twilio credentials for the current tenant. Pre-
validates against Twilio before persisting; an empty `authToken`
keeps the existing token.

 */
export const putWhatsappIntegration = async (whatsappIntegrationUpdate: WhatsappIntegrationUpdate, options?: RequestInit): Promise<WhatsappIntegrationStatus> => {

  return customFetch<WhatsappIntegrationStatus>(getPutWhatsappIntegrationUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(whatsappIntegrationUpdate)
  }
);}





export const getPutWhatsappIntegrationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putWhatsappIntegration>>, TError,{data: BodyType<WhatsappIntegrationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putWhatsappIntegration>>, TError,{data: BodyType<WhatsappIntegrationUpdate>}, TContext> => {

const mutationKey = ['putWhatsappIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putWhatsappIntegration>>, {data: BodyType<WhatsappIntegrationUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  putWhatsappIntegration(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutWhatsappIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof putWhatsappIntegration>>>
    export type PutWhatsappIntegrationMutationBody = BodyType<WhatsappIntegrationUpdate>
    export type PutWhatsappIntegrationMutationError = ErrorType<unknown>

    /**
 * @summary Save / replace the Twilio credentials for the current tenant. Pre-
validates against Twilio before persisting; an empty `authToken`
keeps the existing token.

 */
export const usePutWhatsappIntegration = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putWhatsappIntegration>>, TError,{data: BodyType<WhatsappIntegrationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putWhatsappIntegration>>,
        TError,
        {data: BodyType<WhatsappIntegrationUpdate>},
        TContext
      > => {
      return useMutation(getPutWhatsappIntegrationMutationOptions(options));
    }

export const getDeleteWhatsappIntegrationUrl = () => {




  return `/api/integrations/whatsapp`
}

/**
 * @summary Remove the Twilio WhatsApp credentials for the current tenant.
 */
export const deleteWhatsappIntegration = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteWhatsappIntegrationUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteWhatsappIntegrationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWhatsappIntegration>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteWhatsappIntegration>>, TError,void, TContext> => {

const mutationKey = ['deleteWhatsappIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWhatsappIntegration>>, void> = () => {


          return  deleteWhatsappIntegration(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteWhatsappIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWhatsappIntegration>>>

    export type DeleteWhatsappIntegrationMutationError = ErrorType<unknown>

    /**
 * @summary Remove the Twilio WhatsApp credentials for the current tenant.
 */
export const useDeleteWhatsappIntegration = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWhatsappIntegration>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteWhatsappIntegration>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteWhatsappIntegrationMutationOptions(options));
    }

export const getTestWhatsappIntegrationUrl = () => {




  return `/api/integrations/whatsapp/test`
}

/**
 * @summary Probe Twilio with the saved credentials.
 */
export const testWhatsappIntegration = async ( options?: RequestInit): Promise<WhatsappIntegrationTestResult> => {

  return customFetch<WhatsappIntegrationTestResult>(getTestWhatsappIntegrationUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getTestWhatsappIntegrationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testWhatsappIntegration>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testWhatsappIntegration>>, TError,void, TContext> => {

const mutationKey = ['testWhatsappIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testWhatsappIntegration>>, void> = () => {


          return  testWhatsappIntegration(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestWhatsappIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof testWhatsappIntegration>>>

    export type TestWhatsappIntegrationMutationError = ErrorType<unknown>

    /**
 * @summary Probe Twilio with the saved credentials.
 */
export const useTestWhatsappIntegration = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testWhatsappIntegration>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof testWhatsappIntegration>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getTestWhatsappIntegrationMutationOptions(options));
    }

export const getRefreshOrderTrackingEventsUrl = (id: string,) => {




  return `/api/orders/${id}/tracking-events/refresh`
}

/**
 * @summary Force a live 17track refresh, bypassing the 30-min cache TTL.
 */
export const refreshOrderTrackingEvents = async (id: string, options?: RequestInit): Promise<TrackingStatus> => {

  return customFetch<TrackingStatus>(getRefreshOrderTrackingEventsUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRefreshOrderTrackingEventsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshOrderTrackingEvents>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshOrderTrackingEvents>>, TError,{id: string}, TContext> => {

const mutationKey = ['refreshOrderTrackingEvents'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshOrderTrackingEvents>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  refreshOrderTrackingEvents(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshOrderTrackingEventsMutationResult = NonNullable<Awaited<ReturnType<typeof refreshOrderTrackingEvents>>>

    export type RefreshOrderTrackingEventsMutationError = ErrorType<unknown>

    /**
 * @summary Force a live 17track refresh, bypassing the 30-min cache TTL.
 */
export const useRefreshOrderTrackingEvents = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshOrderTrackingEvents>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof refreshOrderTrackingEvents>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getRefreshOrderTrackingEventsMutationOptions(options));
    }

export const getListAlertsUrl = (params?: ListAlertsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/alerts?${stringifiedParams}` : `/api/alerts`
}

/**
 * @summary List the current user's alerts (newest first).
 */
export const listAlerts = async (params?: ListAlertsParams, options?: RequestInit): Promise<AlertListResponse> => {

  return customFetch<AlertListResponse>(getListAlertsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAlertsQueryKey = (params?: ListAlertsParams,) => {
    return [
    `/api/alerts`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAlertsQueryOptions = <TData = Awaited<ReturnType<typeof listAlerts>>, TError = ErrorType<unknown>>(params?: ListAlertsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAlerts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAlertsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAlerts>>> = ({ signal }) => listAlerts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAlerts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAlertsQueryResult = NonNullable<Awaited<ReturnType<typeof listAlerts>>>
export type ListAlertsQueryError = ErrorType<unknown>


/**
 * @summary List the current user's alerts (newest first).
 */

export function useListAlerts<TData = Awaited<ReturnType<typeof listAlerts>>, TError = ErrorType<unknown>>(
 params?: ListAlertsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAlerts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAlertsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAlertsUnreadCountUrl = () => {




  return `/api/alerts/unread-count`
}

/**
 * @summary Bell badge counter for the current user.
 */
export const getAlertsUnreadCount = async ( options?: RequestInit): Promise<GetAlertsUnreadCount200> => {

  return customFetch<GetAlertsUnreadCount200>(getGetAlertsUnreadCountUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAlertsUnreadCountQueryKey = () => {
    return [
    `/api/alerts/unread-count`
    ] as const;
    }


export const getGetAlertsUnreadCountQueryOptions = <TData = Awaited<ReturnType<typeof getAlertsUnreadCount>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAlertsUnreadCount>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAlertsUnreadCountQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAlertsUnreadCount>>> = ({ signal }) => getAlertsUnreadCount({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAlertsUnreadCount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAlertsUnreadCountQueryResult = NonNullable<Awaited<ReturnType<typeof getAlertsUnreadCount>>>
export type GetAlertsUnreadCountQueryError = ErrorType<unknown>


/**
 * @summary Bell badge counter for the current user.
 */

export function useGetAlertsUnreadCount<TData = Awaited<ReturnType<typeof getAlertsUnreadCount>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAlertsUnreadCount>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAlertsUnreadCountQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getMarkAllAlertsReadUrl = () => {




  return `/api/alerts/mark-all-read`
}

/**
 * @summary Mark every alert for the current user as read.
 */
export const markAllAlertsRead = async ( options?: RequestInit): Promise<MarkAllAlertsRead200> => {

  return customFetch<MarkAllAlertsRead200>(getMarkAllAlertsReadUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMarkAllAlertsReadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAllAlertsRead>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markAllAlertsRead>>, TError,void, TContext> => {

const mutationKey = ['markAllAlertsRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAllAlertsRead>>, void> = () => {


          return  markAllAlertsRead(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkAllAlertsReadMutationResult = NonNullable<Awaited<ReturnType<typeof markAllAlertsRead>>>

    export type MarkAllAlertsReadMutationError = ErrorType<unknown>

    /**
 * @summary Mark every alert for the current user as read.
 */
export const useMarkAllAlertsRead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAllAlertsRead>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markAllAlertsRead>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMarkAllAlertsReadMutationOptions(options));
    }

export const getMarkAlertReadUrl = (id: string,) => {




  return `/api/alerts/${id}/read`
}

/**
 * @summary Mark a single alert as read.
 */
export const markAlertRead = async (id: string, options?: RequestInit): Promise<MarkAlertRead200> => {

  return customFetch<MarkAlertRead200>(getMarkAlertReadUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMarkAlertReadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAlertRead>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markAlertRead>>, TError,{id: string}, TContext> => {

const mutationKey = ['markAlertRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAlertRead>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  markAlertRead(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkAlertReadMutationResult = NonNullable<Awaited<ReturnType<typeof markAlertRead>>>

    export type MarkAlertReadMutationError = ErrorType<unknown>

    /**
 * @summary Mark a single alert as read.
 */
export const useMarkAlertRead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAlertRead>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markAlertRead>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getMarkAlertReadMutationOptions(options));
    }

export const getGetStatusSummaryUrl = () => {




  return `/api/ui/status-summary`
}

/**
 * Returns all badge counts the authenticated user is permitted to see in a single response. Fields are omitted when the tenant does not have the corresponding feature enabled or the user lacks the required permission. Backed by in-process per-badge caches (30 s TTL) so repeated polls are served without touching the database.
 * @summary Unified navigation badge counts for the current user.
 */
export const getStatusSummary = async ( options?: RequestInit): Promise<StatusSummaryResponse> => {

  return customFetch<StatusSummaryResponse>(getGetStatusSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStatusSummaryQueryKey = () => {
    return [
    `/api/ui/status-summary`
    ] as const;
    }


export const getGetStatusSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getStatusSummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStatusSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStatusSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStatusSummary>>> = ({ signal }) => getStatusSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStatusSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStatusSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getStatusSummary>>>
export type GetStatusSummaryQueryError = ErrorType<unknown>


/**
 * @summary Unified navigation badge counts for the current user.
 */

export function useGetStatusSummary<TData = Awaited<ReturnType<typeof getStatusSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStatusSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStatusSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPushConfigUrl = () => {




  return `/api/push/config`
}

/**
 * @summary Public VAPID key for browser push subscription bootstrap (Task
 */
export const getPushConfig = async ( options?: RequestInit): Promise<GetPushConfig200> => {

  return customFetch<GetPushConfig200>(getGetPushConfigUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPushConfigQueryKey = () => {
    return [
    `/api/push/config`
    ] as const;
    }


export const getGetPushConfigQueryOptions = <TData = Awaited<ReturnType<typeof getPushConfig>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPushConfig>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPushConfigQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPushConfig>>> = ({ signal }) => getPushConfig({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPushConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPushConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getPushConfig>>>
export type GetPushConfigQueryError = ErrorType<unknown>


/**
 * @summary Public VAPID key for browser push subscription bootstrap (Task
 */

export function useGetPushConfig<TData = Awaited<ReturnType<typeof getPushConfig>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPushConfig>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPushConfigQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSubscribePushUrl = () => {




  return `/api/push/subscribe`
}

/**
 * @summary Upsert a browser push subscription for the current (tenant, user).
 */
export const subscribePush = async (pushSubscribeBody: PushSubscribeBody, options?: RequestInit): Promise<PushOkResponse> => {

  return customFetch<PushOkResponse>(getSubscribePushUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pushSubscribeBody)
  }
);}





export const getSubscribePushMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscribePush>>, TError,{data: BodyType<PushSubscribeBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof subscribePush>>, TError,{data: BodyType<PushSubscribeBody>}, TContext> => {

const mutationKey = ['subscribePush'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof subscribePush>>, {data: BodyType<PushSubscribeBody>}> = (props) => {
          const {data} = props ?? {};

          return  subscribePush(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubscribePushMutationResult = NonNullable<Awaited<ReturnType<typeof subscribePush>>>
    export type SubscribePushMutationBody = BodyType<PushSubscribeBody>
    export type SubscribePushMutationError = ErrorType<unknown>

    /**
 * @summary Upsert a browser push subscription for the current (tenant, user).
 */
export const useSubscribePush = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscribePush>>, TError,{data: BodyType<PushSubscribeBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof subscribePush>>,
        TError,
        {data: BodyType<PushSubscribeBody>},
        TContext
      > => {
      return useMutation(getSubscribePushMutationOptions(options));
    }

export const getUnsubscribePushUrl = () => {




  return `/api/push/subscribe`
}

/**
 * @summary Remove a browser push subscription by endpoint.
 */
export const unsubscribePush = async (pushUnsubscribeBody: PushUnsubscribeBody, options?: RequestInit): Promise<PushOkResponse> => {

  return customFetch<PushOkResponse>(getUnsubscribePushUrl(),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pushUnsubscribeBody)
  }
);}





export const getUnsubscribePushMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unsubscribePush>>, TError,{data: BodyType<PushUnsubscribeBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unsubscribePush>>, TError,{data: BodyType<PushUnsubscribeBody>}, TContext> => {

const mutationKey = ['unsubscribePush'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unsubscribePush>>, {data: BodyType<PushUnsubscribeBody>}> = (props) => {
          const {data} = props ?? {};

          return  unsubscribePush(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnsubscribePushMutationResult = NonNullable<Awaited<ReturnType<typeof unsubscribePush>>>
    export type UnsubscribePushMutationBody = BodyType<PushUnsubscribeBody>
    export type UnsubscribePushMutationError = ErrorType<unknown>

    /**
 * @summary Remove a browser push subscription by endpoint.
 */
export const useUnsubscribePush = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unsubscribePush>>, TError,{data: BodyType<PushUnsubscribeBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof unsubscribePush>>,
        TError,
        {data: BodyType<PushUnsubscribeBody>},
        TContext
      > => {
      return useMutation(getUnsubscribePushMutationOptions(options));
    }

export const getListPushSubscriptionsUrl = () => {




  return `/api/push/subscriptions`
}

/**
 * @summary List the caller's active push subscriptions in the current tenant.
 */
export const listPushSubscriptions = async ( options?: RequestInit): Promise<PushSubscriptionRow[]> => {

  return customFetch<PushSubscriptionRow[]>(getListPushSubscriptionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPushSubscriptionsQueryKey = () => {
    return [
    `/api/push/subscriptions`
    ] as const;
    }


export const getListPushSubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof listPushSubscriptions>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPushSubscriptions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPushSubscriptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPushSubscriptions>>> = ({ signal }) => listPushSubscriptions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPushSubscriptions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPushSubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof listPushSubscriptions>>>
export type ListPushSubscriptionsQueryError = ErrorType<unknown>


/**
 * @summary List the caller's active push subscriptions in the current tenant.
 */

export function useListPushSubscriptions<TData = Awaited<ReturnType<typeof listPushSubscriptions>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPushSubscriptions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPushSubscriptionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSendPushTestUrl = () => {




  return `/api/push/test`
}

/**
 * @summary Send a synthetic "test notification" alert to the caller.
 */
export const sendPushTest = async ( options?: RequestInit): Promise<PushOkResponse> => {

  return customFetch<PushOkResponse>(getSendPushTestUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSendPushTestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPushTest>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendPushTest>>, TError,void, TContext> => {

const mutationKey = ['sendPushTest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendPushTest>>, void> = () => {


          return  sendPushTest(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendPushTestMutationResult = NonNullable<Awaited<ReturnType<typeof sendPushTest>>>

    export type SendPushTestMutationError = ErrorType<unknown>

    /**
 * @summary Send a synthetic "test notification" alert to the caller.
 */
export const useSendPushTest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPushTest>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendPushTest>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSendPushTestMutationOptions(options));
    }

export const getListAlertPreferencesUrl = () => {




  return `/api/alert-preferences`
}

/**
 * @summary List alert-type preferences visible to the current user.
 */
export const listAlertPreferences = async ( options?: RequestInit): Promise<AlertPreference[]> => {

  return customFetch<AlertPreference[]>(getListAlertPreferencesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAlertPreferencesQueryKey = () => {
    return [
    `/api/alert-preferences`
    ] as const;
    }


export const getListAlertPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof listAlertPreferences>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAlertPreferences>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAlertPreferencesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAlertPreferences>>> = ({ signal }) => listAlertPreferences({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAlertPreferences>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAlertPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof listAlertPreferences>>>
export type ListAlertPreferencesQueryError = ErrorType<unknown>


/**
 * @summary List alert-type preferences visible to the current user.
 */

export function useListAlertPreferences<TData = Awaited<ReturnType<typeof listAlertPreferences>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAlertPreferences>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAlertPreferencesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateAlertPreferenceUrl = () => {




  return `/api/alert-preferences`
}

/**
 * @summary Upsert a single (user, alert_type) preference row.
 */
export const updateAlertPreference = async (alertPreferenceUpdate: AlertPreferenceUpdate, options?: RequestInit): Promise<AlertPreference> => {

  return customFetch<AlertPreference>(getUpdateAlertPreferenceUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(alertPreferenceUpdate)
  }
);}





export const getUpdateAlertPreferenceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAlertPreference>>, TError,{data: BodyType<AlertPreferenceUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAlertPreference>>, TError,{data: BodyType<AlertPreferenceUpdate>}, TContext> => {

const mutationKey = ['updateAlertPreference'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAlertPreference>>, {data: BodyType<AlertPreferenceUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateAlertPreference(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAlertPreferenceMutationResult = NonNullable<Awaited<ReturnType<typeof updateAlertPreference>>>
    export type UpdateAlertPreferenceMutationBody = BodyType<AlertPreferenceUpdate>
    export type UpdateAlertPreferenceMutationError = ErrorType<unknown>

    /**
 * @summary Upsert a single (user, alert_type) preference row.
 */
export const useUpdateAlertPreference = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAlertPreference>>, TError,{data: BodyType<AlertPreferenceUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAlertPreference>>,
        TError,
        {data: BodyType<AlertPreferenceUpdate>},
        TContext
      > => {
      return useMutation(getUpdateAlertPreferenceMutationOptions(options));
    }

export const getListNotificationsUrl = (params?: ListNotificationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/notifications?${stringifiedParams}` : `/api/notifications`
}

/**
 * @summary Filterable, paginated notification list for the current user.
 */
export const listNotifications = async (params?: ListNotificationsParams, options?: RequestInit): Promise<AlertListResponse> => {

  return customFetch<AlertListResponse>(getListNotificationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNotificationsQueryKey = (params?: ListNotificationsParams,) => {
    return [
    `/api/notifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getListNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof listNotifications>>, TError = ErrorType<unknown>>(params?: ListNotificationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotifications>>> = ({ signal }) => listNotifications(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData> & { queryKey: QueryKey }
}

export type ListNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof listNotifications>>>
export type ListNotificationsQueryError = ErrorType<unknown>


/**
 * @summary Filterable, paginated notification list for the current user.
 */

export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = ErrorType<unknown>>(
 params?: ListNotificationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getMarkNotificationsReadUrl = () => {




  return `/api/notifications/mark-read`
}

/**
 * @summary Mark a set of notifications read (empty/omitted ids = all unread).
 */
export const markNotificationsRead = async (notificationBulkReadBody?: NotificationBulkReadBody, options?: RequestInit): Promise<MarkNotificationsRead200> => {

  return customFetch<MarkNotificationsRead200>(getMarkNotificationsReadUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(notificationBulkReadBody)
  }
);}





export const getMarkNotificationsReadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationsRead>>, TError,{data?: BodyType<NotificationBulkReadBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markNotificationsRead>>, TError,{data?: BodyType<NotificationBulkReadBody>}, TContext> => {

const mutationKey = ['markNotificationsRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markNotificationsRead>>, {data?: BodyType<NotificationBulkReadBody>}> = (props) => {
          const {data} = props ?? {};

          return  markNotificationsRead(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkNotificationsReadMutationResult = NonNullable<Awaited<ReturnType<typeof markNotificationsRead>>>
    export type MarkNotificationsReadMutationBody = BodyType<NotificationBulkReadBody> | undefined
    export type MarkNotificationsReadMutationError = ErrorType<unknown>

    /**
 * @summary Mark a set of notifications read (empty/omitted ids = all unread).
 */
export const useMarkNotificationsRead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationsRead>>, TError,{data?: BodyType<NotificationBulkReadBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markNotificationsRead>>,
        TError,
        {data?: BodyType<NotificationBulkReadBody>},
        TContext
      > => {
      return useMutation(getMarkNotificationsReadMutationOptions(options));
    }

export const getDismissNotificationUrl = (id: string,) => {




  return `/api/notifications/${id}/dismiss`
}

/**
 * @summary Dismiss (archive) a single notification for the current user.
 */
export const dismissNotification = async (id: string, options?: RequestInit): Promise<PushOkResponse> => {

  return customFetch<PushOkResponse>(getDismissNotificationUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDismissNotificationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissNotification>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dismissNotification>>, TError,{id: string}, TContext> => {

const mutationKey = ['dismissNotification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dismissNotification>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  dismissNotification(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DismissNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof dismissNotification>>>

    export type DismissNotificationMutationError = ErrorType<unknown>

    /**
 * @summary Dismiss (archive) a single notification for the current user.
 */
export const useDismissNotification = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissNotification>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof dismissNotification>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDismissNotificationMutationOptions(options));
    }

export const getSendManualNotificationUrl = () => {




  return `/api/notifications/send`
}

/**
 * @summary Send a manual notification (perm-gated notifications.send_manual).
 */
export const sendManualNotification = async (notificationManualSend: NotificationManualSend, options?: RequestInit): Promise<NotificationManualSendResult> => {

  return customFetch<NotificationManualSendResult>(getSendManualNotificationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(notificationManualSend)
  }
);}





export const getSendManualNotificationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendManualNotification>>, TError,{data: BodyType<NotificationManualSend>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendManualNotification>>, TError,{data: BodyType<NotificationManualSend>}, TContext> => {

const mutationKey = ['sendManualNotification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendManualNotification>>, {data: BodyType<NotificationManualSend>}> = (props) => {
          const {data} = props ?? {};

          return  sendManualNotification(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendManualNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof sendManualNotification>>>
    export type SendManualNotificationMutationBody = BodyType<NotificationManualSend>
    export type SendManualNotificationMutationError = ErrorType<unknown>

    /**
 * @summary Send a manual notification (perm-gated notifications.send_manual).
 */
export const useSendManualNotification = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendManualNotification>>, TError,{data: BodyType<NotificationManualSend>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendManualNotification>>,
        TError,
        {data: BodyType<NotificationManualSend>},
        TContext
      > => {
      return useMutation(getSendManualNotificationMutationOptions(options));
    }

export const getGetNotificationCatalogueUrl = () => {




  return `/api/notification-catalogue`
}

/**
 * @summary Categories + notification-type catalogue visible to the caller.
 */
export const getNotificationCatalogue = async ( options?: RequestInit): Promise<NotificationCatalogue> => {

  return customFetch<NotificationCatalogue>(getGetNotificationCatalogueUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetNotificationCatalogueQueryKey = () => {
    return [
    `/api/notification-catalogue`
    ] as const;
    }


export const getGetNotificationCatalogueQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationCatalogue>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotificationCatalogue>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationCatalogueQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationCatalogue>>> = ({ signal }) => getNotificationCatalogue({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotificationCatalogue>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNotificationCatalogueQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationCatalogue>>>
export type GetNotificationCatalogueQueryError = ErrorType<unknown>


/**
 * @summary Categories + notification-type catalogue visible to the caller.
 */

export function useGetNotificationCatalogue<TData = Awaited<ReturnType<typeof getNotificationCatalogue>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotificationCatalogue>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetNotificationCatalogueQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetNotificationSettingsUrl = () => {




  return `/api/notification-settings`
}

/**
 * @summary Per-user quiet hours + digest settings (defaults if no row).
 */
export const getNotificationSettings = async ( options?: RequestInit): Promise<NotificationUserSettings> => {

  return customFetch<NotificationUserSettings>(getGetNotificationSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetNotificationSettingsQueryKey = () => {
    return [
    `/api/notification-settings`
    ] as const;
    }


export const getGetNotificationSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotificationSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationSettings>>> = ({ signal }) => getNotificationSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotificationSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNotificationSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationSettings>>>
export type GetNotificationSettingsQueryError = ErrorType<unknown>


/**
 * @summary Per-user quiet hours + digest settings (defaults if no row).
 */

export function useGetNotificationSettings<TData = Awaited<ReturnType<typeof getNotificationSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotificationSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetNotificationSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateNotificationSettingsUrl = () => {




  return `/api/notification-settings`
}

/**
 * @summary Upsert the caller's quiet hours + digest settings.
 */
export const updateNotificationSettings = async (notificationUserSettingsUpdate: NotificationUserSettingsUpdate, options?: RequestInit): Promise<NotificationUserSettings> => {

  return customFetch<NotificationUserSettings>(getUpdateNotificationSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(notificationUserSettingsUpdate)
  }
);}





export const getUpdateNotificationSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationSettings>>, TError,{data: BodyType<NotificationUserSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateNotificationSettings>>, TError,{data: BodyType<NotificationUserSettingsUpdate>}, TContext> => {

const mutationKey = ['updateNotificationSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNotificationSettings>>, {data: BodyType<NotificationUserSettingsUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateNotificationSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateNotificationSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateNotificationSettings>>>
    export type UpdateNotificationSettingsMutationBody = BodyType<NotificationUserSettingsUpdate>
    export type UpdateNotificationSettingsMutationError = ErrorType<unknown>

    /**
 * @summary Upsert the caller's quiet hours + digest settings.
 */
export const useUpdateNotificationSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationSettings>>, TError,{data: BodyType<NotificationUserSettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateNotificationSettings>>,
        TError,
        {data: BodyType<NotificationUserSettingsUpdate>},
        TContext
      > => {
      return useMutation(getUpdateNotificationSettingsMutationOptions(options));
    }

export const getListNotificationDefaultsUrl = () => {




  return `/api/notification-defaults`
}

/**
 * @summary Tenant per-role notification defaults (perm-gated).
 */
export const listNotificationDefaults = async ( options?: RequestInit): Promise<TenantNotificationDefault[]> => {

  return customFetch<TenantNotificationDefault[]>(getListNotificationDefaultsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNotificationDefaultsQueryKey = () => {
    return [
    `/api/notification-defaults`
    ] as const;
    }


export const getListNotificationDefaultsQueryOptions = <TData = Awaited<ReturnType<typeof listNotificationDefaults>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNotificationDefaults>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNotificationDefaultsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotificationDefaults>>> = ({ signal }) => listNotificationDefaults({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNotificationDefaults>>, TError, TData> & { queryKey: QueryKey }
}

export type ListNotificationDefaultsQueryResult = NonNullable<Awaited<ReturnType<typeof listNotificationDefaults>>>
export type ListNotificationDefaultsQueryError = ErrorType<unknown>


/**
 * @summary Tenant per-role notification defaults (perm-gated).
 */

export function useListNotificationDefaults<TData = Awaited<ReturnType<typeof listNotificationDefaults>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNotificationDefaults>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListNotificationDefaultsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateNotificationDefaultUrl = () => {




  return `/api/notification-defaults`
}

/**
 * @summary Upsert a (role, alert_type) tenant default (perm-gated).
 */
export const updateNotificationDefault = async (tenantNotificationDefaultUpdate: TenantNotificationDefaultUpdate, options?: RequestInit): Promise<TenantNotificationDefault> => {

  return customFetch<TenantNotificationDefault>(getUpdateNotificationDefaultUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tenantNotificationDefaultUpdate)
  }
);}





export const getUpdateNotificationDefaultMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationDefault>>, TError,{data: BodyType<TenantNotificationDefaultUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateNotificationDefault>>, TError,{data: BodyType<TenantNotificationDefaultUpdate>}, TContext> => {

const mutationKey = ['updateNotificationDefault'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNotificationDefault>>, {data: BodyType<TenantNotificationDefaultUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateNotificationDefault(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateNotificationDefaultMutationResult = NonNullable<Awaited<ReturnType<typeof updateNotificationDefault>>>
    export type UpdateNotificationDefaultMutationBody = BodyType<TenantNotificationDefaultUpdate>
    export type UpdateNotificationDefaultMutationError = ErrorType<unknown>

    /**
 * @summary Upsert a (role, alert_type) tenant default (perm-gated).
 */
export const useUpdateNotificationDefault = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationDefault>>, TError,{data: BodyType<TenantNotificationDefaultUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateNotificationDefault>>,
        TError,
        {data: BodyType<TenantNotificationDefaultUpdate>},
        TContext
      > => {
      return useMutation(getUpdateNotificationDefaultMutationOptions(options));
    }

export const getListNotificationThresholdsUrl = () => {




  return `/api/notification-thresholds`
}

/**
 * @summary Tenant notification thresholds (perm-gated).
 */
export const listNotificationThresholds = async ( options?: RequestInit): Promise<NotificationThreshold[]> => {

  return customFetch<NotificationThreshold[]>(getListNotificationThresholdsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNotificationThresholdsQueryKey = () => {
    return [
    `/api/notification-thresholds`
    ] as const;
    }


export const getListNotificationThresholdsQueryOptions = <TData = Awaited<ReturnType<typeof listNotificationThresholds>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNotificationThresholds>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNotificationThresholdsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotificationThresholds>>> = ({ signal }) => listNotificationThresholds({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNotificationThresholds>>, TError, TData> & { queryKey: QueryKey }
}

export type ListNotificationThresholdsQueryResult = NonNullable<Awaited<ReturnType<typeof listNotificationThresholds>>>
export type ListNotificationThresholdsQueryError = ErrorType<unknown>


/**
 * @summary Tenant notification thresholds (perm-gated).
 */

export function useListNotificationThresholds<TData = Awaited<ReturnType<typeof listNotificationThresholds>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNotificationThresholds>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListNotificationThresholdsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateNotificationThresholdUrl = () => {




  return `/api/notification-thresholds`
}

/**
 * @summary Upsert a tenant threshold setting (perm-gated).
 */
export const updateNotificationThreshold = async (notificationThresholdUpdate: NotificationThresholdUpdate, options?: RequestInit): Promise<NotificationThreshold> => {

  return customFetch<NotificationThreshold>(getUpdateNotificationThresholdUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(notificationThresholdUpdate)
  }
);}





export const getUpdateNotificationThresholdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationThreshold>>, TError,{data: BodyType<NotificationThresholdUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateNotificationThreshold>>, TError,{data: BodyType<NotificationThresholdUpdate>}, TContext> => {

const mutationKey = ['updateNotificationThreshold'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNotificationThreshold>>, {data: BodyType<NotificationThresholdUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateNotificationThreshold(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateNotificationThresholdMutationResult = NonNullable<Awaited<ReturnType<typeof updateNotificationThreshold>>>
    export type UpdateNotificationThresholdMutationBody = BodyType<NotificationThresholdUpdate>
    export type UpdateNotificationThresholdMutationError = ErrorType<unknown>

    /**
 * @summary Upsert a tenant threshold setting (perm-gated).
 */
export const useUpdateNotificationThreshold = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationThreshold>>, TError,{data: BodyType<NotificationThresholdUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateNotificationThreshold>>,
        TError,
        {data: BodyType<NotificationThresholdUpdate>},
        TContext
      > => {
      return useMutation(getUpdateNotificationThresholdMutationOptions(options));
    }

export const getListNotificationDeliveryLogsUrl = (params?: ListNotificationDeliveryLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/notification-delivery-logs?${stringifiedParams}` : `/api/notification-delivery-logs`
}

/**
 * @summary Per-channel delivery audit trail (perm-gated).
 */
export const listNotificationDeliveryLogs = async (params?: ListNotificationDeliveryLogsParams, options?: RequestInit): Promise<NotificationDeliveryLogResponse> => {

  return customFetch<NotificationDeliveryLogResponse>(getListNotificationDeliveryLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNotificationDeliveryLogsQueryKey = (params?: ListNotificationDeliveryLogsParams,) => {
    return [
    `/api/notification-delivery-logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListNotificationDeliveryLogsQueryOptions = <TData = Awaited<ReturnType<typeof listNotificationDeliveryLogs>>, TError = ErrorType<unknown>>(params?: ListNotificationDeliveryLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNotificationDeliveryLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNotificationDeliveryLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotificationDeliveryLogs>>> = ({ signal }) => listNotificationDeliveryLogs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNotificationDeliveryLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListNotificationDeliveryLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listNotificationDeliveryLogs>>>
export type ListNotificationDeliveryLogsQueryError = ErrorType<unknown>


/**
 * @summary Per-channel delivery audit trail (perm-gated).
 */

export function useListNotificationDeliveryLogs<TData = Awaited<ReturnType<typeof listNotificationDeliveryLogs>>, TError = ErrorType<unknown>>(
 params?: ListNotificationDeliveryLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNotificationDeliveryLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListNotificationDeliveryLogsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetConsignmentBatchesUrl = (params?: GetConsignmentBatchesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/consignment-batches?${stringifiedParams}` : `/api/consignment-batches`
}

/**
 * @summary List Batch Recovery consignment batches with computed metrics.
 */
export const getConsignmentBatches = async (params?: GetConsignmentBatchesParams, options?: RequestInit): Promise<GetConsignmentBatches200> => {

  return customFetch<GetConsignmentBatches200>(getGetConsignmentBatchesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConsignmentBatchesQueryKey = (params?: GetConsignmentBatchesParams,) => {
    return [
    `/api/consignment-batches`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetConsignmentBatchesQueryOptions = <TData = Awaited<ReturnType<typeof getConsignmentBatches>>, TError = ErrorType<unknown>>(params?: GetConsignmentBatchesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConsignmentBatches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConsignmentBatchesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConsignmentBatches>>> = ({ signal }) => getConsignmentBatches(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConsignmentBatches>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConsignmentBatchesQueryResult = NonNullable<Awaited<ReturnType<typeof getConsignmentBatches>>>
export type GetConsignmentBatchesQueryError = ErrorType<unknown>


/**
 * @summary List Batch Recovery consignment batches with computed metrics.
 */

export function useGetConsignmentBatches<TData = Awaited<ReturnType<typeof getConsignmentBatches>>, TError = ErrorType<unknown>>(
 params?: GetConsignmentBatchesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConsignmentBatches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetConsignmentBatchesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPostConsignmentBatchesUrl = () => {




  return `/api/consignment-batches`
}

/**
 * @summary Create a Batch Recovery consignment batch.
 */
export const postConsignmentBatches = async (consignmentBatchInput: ConsignmentBatchInput, options?: RequestInit): Promise<ConsignmentBatch> => {

  return customFetch<ConsignmentBatch>(getPostConsignmentBatchesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(consignmentBatchInput)
  }
);}





export const getPostConsignmentBatchesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConsignmentBatches>>, TError,{data: BodyType<ConsignmentBatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postConsignmentBatches>>, TError,{data: BodyType<ConsignmentBatchInput>}, TContext> => {

const mutationKey = ['postConsignmentBatches'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConsignmentBatches>>, {data: BodyType<ConsignmentBatchInput>}> = (props) => {
          const {data} = props ?? {};

          return  postConsignmentBatches(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostConsignmentBatchesMutationResult = NonNullable<Awaited<ReturnType<typeof postConsignmentBatches>>>
    export type PostConsignmentBatchesMutationBody = BodyType<ConsignmentBatchInput>
    export type PostConsignmentBatchesMutationError = ErrorType<unknown>

    /**
 * @summary Create a Batch Recovery consignment batch.
 */
export const usePostConsignmentBatches = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConsignmentBatches>>, TError,{data: BodyType<ConsignmentBatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postConsignmentBatches>>,
        TError,
        {data: BodyType<ConsignmentBatchInput>},
        TContext
      > => {
      return useMutation(getPostConsignmentBatchesMutationOptions(options));
    }

export const getGetConsignmentBatchesDashboardUrl = () => {




  return `/api/consignment-batches/dashboard`
}

/**
 * @summary Top-card aggregates across ALL active Batch Recovery batches.
 */
export const getConsignmentBatchesDashboard = async ( options?: RequestInit): Promise<ConsignmentBatchDashboard> => {

  return customFetch<ConsignmentBatchDashboard>(getGetConsignmentBatchesDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConsignmentBatchesDashboardQueryKey = () => {
    return [
    `/api/consignment-batches/dashboard`
    ] as const;
    }


export const getGetConsignmentBatchesDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getConsignmentBatchesDashboard>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConsignmentBatchesDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConsignmentBatchesDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConsignmentBatchesDashboard>>> = ({ signal }) => getConsignmentBatchesDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConsignmentBatchesDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConsignmentBatchesDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getConsignmentBatchesDashboard>>>
export type GetConsignmentBatchesDashboardQueryError = ErrorType<unknown>


/**
 * @summary Top-card aggregates across ALL active Batch Recovery batches.
 */

export function useGetConsignmentBatchesDashboard<TData = Awaited<ReturnType<typeof getConsignmentBatchesDashboard>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConsignmentBatchesDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetConsignmentBatchesDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetConsignmentBatchesIdUrl = (id: string,) => {




  return `/api/consignment-batches/${id}`
}

/**
 * @summary Batch detail (header + metrics + payments + linked inventory).
 */
export const getConsignmentBatchesId = async (id: string, options?: RequestInit): Promise<ConsignmentBatchDetail> => {

  return customFetch<ConsignmentBatchDetail>(getGetConsignmentBatchesIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConsignmentBatchesIdQueryKey = (id: string,) => {
    return [
    `/api/consignment-batches/${id}`
    ] as const;
    }


export const getGetConsignmentBatchesIdQueryOptions = <TData = Awaited<ReturnType<typeof getConsignmentBatchesId>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConsignmentBatchesId>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConsignmentBatchesIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConsignmentBatchesId>>> = ({ signal }) => getConsignmentBatchesId(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConsignmentBatchesId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConsignmentBatchesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getConsignmentBatchesId>>>
export type GetConsignmentBatchesIdQueryError = ErrorType<unknown>


/**
 * @summary Batch detail (header + metrics + payments + linked inventory).
 */

export function useGetConsignmentBatchesId<TData = Awaited<ReturnType<typeof getConsignmentBatchesId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConsignmentBatchesId>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetConsignmentBatchesIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPatchConsignmentBatchesIdUrl = (id: string,) => {




  return `/api/consignment-batches/${id}`
}

/**
 * @summary Edit a batch. `capitalOwedGbp` is locked once any sale has landed.
 */
export const patchConsignmentBatchesId = async (id: string,
    consignmentBatchUpdate: ConsignmentBatchUpdate, options?: RequestInit): Promise<ConsignmentBatch> => {

  return customFetch<ConsignmentBatch>(getPatchConsignmentBatchesIdUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(consignmentBatchUpdate)
  }
);}





export const getPatchConsignmentBatchesIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchConsignmentBatchesId>>, TError,{id: string;data: BodyType<ConsignmentBatchUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchConsignmentBatchesId>>, TError,{id: string;data: BodyType<ConsignmentBatchUpdate>}, TContext> => {

const mutationKey = ['patchConsignmentBatchesId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchConsignmentBatchesId>>, {id: string;data: BodyType<ConsignmentBatchUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchConsignmentBatchesId(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchConsignmentBatchesIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchConsignmentBatchesId>>>
    export type PatchConsignmentBatchesIdMutationBody = BodyType<ConsignmentBatchUpdate>
    export type PatchConsignmentBatchesIdMutationError = ErrorType<unknown>

    /**
 * @summary Edit a batch. `capitalOwedGbp` is locked once any sale has landed.
 */
export const usePatchConsignmentBatchesId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchConsignmentBatchesId>>, TError,{id: string;data: BodyType<ConsignmentBatchUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchConsignmentBatchesId>>,
        TError,
        {id: string;data: BodyType<ConsignmentBatchUpdate>},
        TContext
      > => {
      return useMutation(getPatchConsignmentBatchesIdMutationOptions(options));
    }

export const getPostConsignmentBatchesIdPaymentsUrl = (id: string,) => {




  return `/api/consignment-batches/${id}/payments`
}

/**
 * @summary Record a repayment against the batch.
 */
export const postConsignmentBatchesIdPayments = async (id: string,
    consignmentBatchPaymentInput: ConsignmentBatchPaymentInput, options?: RequestInit): Promise<ConsignmentBatchPayment> => {

  return customFetch<ConsignmentBatchPayment>(getPostConsignmentBatchesIdPaymentsUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(consignmentBatchPaymentInput)
  }
);}





export const getPostConsignmentBatchesIdPaymentsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConsignmentBatchesIdPayments>>, TError,{id: string;data: BodyType<ConsignmentBatchPaymentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postConsignmentBatchesIdPayments>>, TError,{id: string;data: BodyType<ConsignmentBatchPaymentInput>}, TContext> => {

const mutationKey = ['postConsignmentBatchesIdPayments'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConsignmentBatchesIdPayments>>, {id: string;data: BodyType<ConsignmentBatchPaymentInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  postConsignmentBatchesIdPayments(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostConsignmentBatchesIdPaymentsMutationResult = NonNullable<Awaited<ReturnType<typeof postConsignmentBatchesIdPayments>>>
    export type PostConsignmentBatchesIdPaymentsMutationBody = BodyType<ConsignmentBatchPaymentInput>
    export type PostConsignmentBatchesIdPaymentsMutationError = ErrorType<unknown>

    /**
 * @summary Record a repayment against the batch.
 */
export const usePostConsignmentBatchesIdPayments = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConsignmentBatchesIdPayments>>, TError,{id: string;data: BodyType<ConsignmentBatchPaymentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postConsignmentBatchesIdPayments>>,
        TError,
        {id: string;data: BodyType<ConsignmentBatchPaymentInput>},
        TContext
      > => {
      return useMutation(getPostConsignmentBatchesIdPaymentsMutationOptions(options));
    }

export const getDeleteConsignmentBatchesIdPaymentsPaymentIdUrl = (id: string,
    paymentId: string,) => {




  return `/api/consignment-batches/${id}/payments/${paymentId}`
}

/**
 * @summary Undo a recorded repayment.
 */
export const deleteConsignmentBatchesIdPaymentsPaymentId = async (id: string,
    paymentId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteConsignmentBatchesIdPaymentsPaymentIdUrl(id,paymentId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteConsignmentBatchesIdPaymentsPaymentIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConsignmentBatchesIdPaymentsPaymentId>>, TError,{id: string;paymentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteConsignmentBatchesIdPaymentsPaymentId>>, TError,{id: string;paymentId: string}, TContext> => {

const mutationKey = ['deleteConsignmentBatchesIdPaymentsPaymentId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteConsignmentBatchesIdPaymentsPaymentId>>, {id: string;paymentId: string}> = (props) => {
          const {id,paymentId} = props ?? {};

          return  deleteConsignmentBatchesIdPaymentsPaymentId(id,paymentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteConsignmentBatchesIdPaymentsPaymentIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteConsignmentBatchesIdPaymentsPaymentId>>>

    export type DeleteConsignmentBatchesIdPaymentsPaymentIdMutationError = ErrorType<unknown>

    /**
 * @summary Undo a recorded repayment.
 */
export const useDeleteConsignmentBatchesIdPaymentsPaymentId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConsignmentBatchesIdPaymentsPaymentId>>, TError,{id: string;paymentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteConsignmentBatchesIdPaymentsPaymentId>>,
        TError,
        {id: string;paymentId: string},
        TContext
      > => {
      return useMutation(getDeleteConsignmentBatchesIdPaymentsPaymentIdMutationOptions(options));
    }

export const getGetShipmentGroupsUrl = (params?: GetShipmentGroupsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/shipment-groups?${stringifiedParams}` : `/api/shipment-groups`
}

/**
 * @summary List shipment groups (optionally filter by supplier or status).
 */
export const getShipmentGroups = async (params?: GetShipmentGroupsParams, options?: RequestInit): Promise<GetShipmentGroups200> => {

  return customFetch<GetShipmentGroups200>(getGetShipmentGroupsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetShipmentGroupsQueryKey = (params?: GetShipmentGroupsParams,) => {
    return [
    `/api/shipment-groups`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetShipmentGroupsQueryOptions = <TData = Awaited<ReturnType<typeof getShipmentGroups>>, TError = ErrorType<unknown>>(params?: GetShipmentGroupsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShipmentGroups>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShipmentGroupsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShipmentGroups>>> = ({ signal }) => getShipmentGroups(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShipmentGroups>>, TError, TData> & { queryKey: QueryKey }
}

export type GetShipmentGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getShipmentGroups>>>
export type GetShipmentGroupsQueryError = ErrorType<unknown>


/**
 * @summary List shipment groups (optionally filter by supplier or status).
 */

export function useGetShipmentGroups<TData = Awaited<ReturnType<typeof getShipmentGroups>>, TError = ErrorType<unknown>>(
 params?: GetShipmentGroupsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShipmentGroups>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetShipmentGroupsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPostShipmentGroupsUrl = () => {




  return `/api/shipment-groups`
}

/**
 * @summary Combine 2+ POs from the same supplier into a new shipment group.
 */
export const postShipmentGroups = async (shipmentGroupCreate: ShipmentGroupCreate, options?: RequestInit): Promise<ShipmentGroupDetail> => {

  return customFetch<ShipmentGroupDetail>(getPostShipmentGroupsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(shipmentGroupCreate)
  }
);}





export const getPostShipmentGroupsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postShipmentGroups>>, TError,{data: BodyType<ShipmentGroupCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postShipmentGroups>>, TError,{data: BodyType<ShipmentGroupCreate>}, TContext> => {

const mutationKey = ['postShipmentGroups'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postShipmentGroups>>, {data: BodyType<ShipmentGroupCreate>}> = (props) => {
          const {data} = props ?? {};

          return  postShipmentGroups(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostShipmentGroupsMutationResult = NonNullable<Awaited<ReturnType<typeof postShipmentGroups>>>
    export type PostShipmentGroupsMutationBody = BodyType<ShipmentGroupCreate>
    export type PostShipmentGroupsMutationError = ErrorType<unknown>

    /**
 * @summary Combine 2+ POs from the same supplier into a new shipment group.
 */
export const usePostShipmentGroups = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postShipmentGroups>>, TError,{data: BodyType<ShipmentGroupCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postShipmentGroups>>,
        TError,
        {data: BodyType<ShipmentGroupCreate>},
        TContext
      > => {
      return useMutation(getPostShipmentGroupsMutationOptions(options));
    }

export const getGetShipmentGroupsIdUrl = (id: string,) => {




  return `/api/shipment-groups/${id}`
}

/**
 * @summary Shipment group detail (header + linked POs + computed allocation).
 */
export const getShipmentGroupsId = async (id: string, options?: RequestInit): Promise<ShipmentGroupDetail> => {

  return customFetch<ShipmentGroupDetail>(getGetShipmentGroupsIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetShipmentGroupsIdQueryKey = (id: string,) => {
    return [
    `/api/shipment-groups/${id}`
    ] as const;
    }


export const getGetShipmentGroupsIdQueryOptions = <TData = Awaited<ReturnType<typeof getShipmentGroupsId>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShipmentGroupsId>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShipmentGroupsIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShipmentGroupsId>>> = ({ signal }) => getShipmentGroupsId(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShipmentGroupsId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetShipmentGroupsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getShipmentGroupsId>>>
export type GetShipmentGroupsIdQueryError = ErrorType<unknown>


/**
 * @summary Shipment group detail (header + linked POs + computed allocation).
 */

export function useGetShipmentGroupsId<TData = Awaited<ReturnType<typeof getShipmentGroupsId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShipmentGroupsId>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetShipmentGroupsIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPatchShipmentGroupsIdUrl = (id: string,) => {




  return `/api/shipment-groups/${id}`
}

/**
 * @summary Update header, GBP cost buckets, or advance status. Cost edits 409 when FINALISED.
 */
export const patchShipmentGroupsId = async (id: string,
    shipmentGroupUpdate: ShipmentGroupUpdate, options?: RequestInit): Promise<ShipmentGroupDetail> => {

  return customFetch<ShipmentGroupDetail>(getPatchShipmentGroupsIdUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(shipmentGroupUpdate)
  }
);}





export const getPatchShipmentGroupsIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchShipmentGroupsId>>, TError,{id: string;data: BodyType<ShipmentGroupUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchShipmentGroupsId>>, TError,{id: string;data: BodyType<ShipmentGroupUpdate>}, TContext> => {

const mutationKey = ['patchShipmentGroupsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchShipmentGroupsId>>, {id: string;data: BodyType<ShipmentGroupUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchShipmentGroupsId(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchShipmentGroupsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchShipmentGroupsId>>>
    export type PatchShipmentGroupsIdMutationBody = BodyType<ShipmentGroupUpdate>
    export type PatchShipmentGroupsIdMutationError = ErrorType<unknown>

    /**
 * @summary Update header, GBP cost buckets, or advance status. Cost edits 409 when FINALISED.
 */
export const usePatchShipmentGroupsId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchShipmentGroupsId>>, TError,{id: string;data: BodyType<ShipmentGroupUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchShipmentGroupsId>>,
        TError,
        {id: string;data: BodyType<ShipmentGroupUpdate>},
        TContext
      > => {
      return useMutation(getPatchShipmentGroupsIdMutationOptions(options));
    }

export const getDeleteShipmentGroupsIdUrl = (id: string,) => {




  return `/api/shipment-groups/${id}`
}

/**
 * @summary Disband group — restore per-PO snapshots, clear FKs, delete group. 409 when FINALISED.
 */
export const deleteShipmentGroupsId = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteShipmentGroupsIdUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteShipmentGroupsIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteShipmentGroupsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteShipmentGroupsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteShipmentGroupsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteShipmentGroupsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteShipmentGroupsId(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteShipmentGroupsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteShipmentGroupsId>>>

    export type DeleteShipmentGroupsIdMutationError = ErrorType<unknown>

    /**
 * @summary Disband group — restore per-PO snapshots, clear FKs, delete group. 409 when FINALISED.
 */
export const useDeleteShipmentGroupsId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteShipmentGroupsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteShipmentGroupsId>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteShipmentGroupsIdMutationOptions(options));
    }

export const getPostShipmentGroupsIdAllocationsUrl = (id: string,) => {




  return `/api/shipment-groups/${id}/allocations`
}

/**
 * @summary Set per-PO manual allocation override % (must sum to 100). Null `overrides` resets to auto by-value.
 */
export const postShipmentGroupsIdAllocations = async (id: string,
    shipmentGroupAllocationInput: ShipmentGroupAllocationInput, options?: RequestInit): Promise<ShipmentGroupDetail> => {

  return customFetch<ShipmentGroupDetail>(getPostShipmentGroupsIdAllocationsUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(shipmentGroupAllocationInput)
  }
);}





export const getPostShipmentGroupsIdAllocationsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postShipmentGroupsIdAllocations>>, TError,{id: string;data: BodyType<ShipmentGroupAllocationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postShipmentGroupsIdAllocations>>, TError,{id: string;data: BodyType<ShipmentGroupAllocationInput>}, TContext> => {

const mutationKey = ['postShipmentGroupsIdAllocations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postShipmentGroupsIdAllocations>>, {id: string;data: BodyType<ShipmentGroupAllocationInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  postShipmentGroupsIdAllocations(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostShipmentGroupsIdAllocationsMutationResult = NonNullable<Awaited<ReturnType<typeof postShipmentGroupsIdAllocations>>>
    export type PostShipmentGroupsIdAllocationsMutationBody = BodyType<ShipmentGroupAllocationInput>
    export type PostShipmentGroupsIdAllocationsMutationError = ErrorType<unknown>

    /**
 * @summary Set per-PO manual allocation override % (must sum to 100). Null `overrides` resets to auto by-value.
 */
export const usePostShipmentGroupsIdAllocations = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postShipmentGroupsIdAllocations>>, TError,{id: string;data: BodyType<ShipmentGroupAllocationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postShipmentGroupsIdAllocations>>,
        TError,
        {id: string;data: BodyType<ShipmentGroupAllocationInput>},
        TContext
      > => {
      return useMutation(getPostShipmentGroupsIdAllocationsMutationOptions(options));
    }

export const getPostShipmentGroupsIdFinaliseUrl = (id: string,) => {




  return `/api/shipment-groups/${id}/finalise`
}

/**
 * @summary Allocate group costs back onto each PO's gbp_* fields, recompute landed unit cost, set each PO to `Landed`, and lock the group.
 */
export const postShipmentGroupsIdFinalise = async (id: string, options?: RequestInit): Promise<ShipmentGroupDetail> => {

  return customFetch<ShipmentGroupDetail>(getPostShipmentGroupsIdFinaliseUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPostShipmentGroupsIdFinaliseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postShipmentGroupsIdFinalise>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postShipmentGroupsIdFinalise>>, TError,{id: string}, TContext> => {

const mutationKey = ['postShipmentGroupsIdFinalise'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postShipmentGroupsIdFinalise>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postShipmentGroupsIdFinalise(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostShipmentGroupsIdFinaliseMutationResult = NonNullable<Awaited<ReturnType<typeof postShipmentGroupsIdFinalise>>>

    export type PostShipmentGroupsIdFinaliseMutationError = ErrorType<unknown>

    /**
 * @summary Allocate group costs back onto each PO's gbp_* fields, recompute landed unit cost, set each PO to `Landed`, and lock the group.
 */
export const usePostShipmentGroupsIdFinalise = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postShipmentGroupsIdFinalise>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postShipmentGroupsIdFinalise>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getPostShipmentGroupsIdFinaliseMutationOptions(options));
    }

export const getDeleteShipmentGroupsIdPosPoIdUrl = (id: string,
    poId: string,) => {




  return `/api/shipment-groups/${id}/pos/${poId}`
}

/**
 * @summary Remove one PO from the group and restore its snapshotted GBP cost fields. Refuses if it would leave <2 POs in the group. 409 when FINALISED.
 */
export const deleteShipmentGroupsIdPosPoId = async (id: string,
    poId: string, options?: RequestInit): Promise<ShipmentGroupDetail> => {

  return customFetch<ShipmentGroupDetail>(getDeleteShipmentGroupsIdPosPoIdUrl(id,poId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteShipmentGroupsIdPosPoIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteShipmentGroupsIdPosPoId>>, TError,{id: string;poId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteShipmentGroupsIdPosPoId>>, TError,{id: string;poId: string}, TContext> => {

const mutationKey = ['deleteShipmentGroupsIdPosPoId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteShipmentGroupsIdPosPoId>>, {id: string;poId: string}> = (props) => {
          const {id,poId} = props ?? {};

          return  deleteShipmentGroupsIdPosPoId(id,poId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteShipmentGroupsIdPosPoIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteShipmentGroupsIdPosPoId>>>

    export type DeleteShipmentGroupsIdPosPoIdMutationError = ErrorType<unknown>

    /**
 * @summary Remove one PO from the group and restore its snapshotted GBP cost fields. Refuses if it would leave <2 POs in the group. 409 when FINALISED.
 */
export const useDeleteShipmentGroupsIdPosPoId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteShipmentGroupsIdPosPoId>>, TError,{id: string;poId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteShipmentGroupsIdPosPoId>>,
        TError,
        {id: string;poId: string},
        TContext
      > => {
      return useMutation(getDeleteShipmentGroupsIdPosPoIdMutationOptions(options));
    }

export const getListPlatformTenantsUrl = () => {




  return `/api/platform/tenants`
}

/**
 * @summary List every tenant (platform operators only).
 */
export const listPlatformTenants = async ( options?: RequestInit): Promise<ListPlatformTenants200> => {

  return customFetch<ListPlatformTenants200>(getListPlatformTenantsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPlatformTenantsQueryKey = () => {
    return [
    `/api/platform/tenants`
    ] as const;
    }


export const getListPlatformTenantsQueryOptions = <TData = Awaited<ReturnType<typeof listPlatformTenants>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPlatformTenants>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlatformTenantsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlatformTenants>>> = ({ signal }) => listPlatformTenants({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPlatformTenants>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPlatformTenantsQueryResult = NonNullable<Awaited<ReturnType<typeof listPlatformTenants>>>
export type ListPlatformTenantsQueryError = ErrorType<void>


/**
 * @summary List every tenant (platform operators only).
 */

export function useListPlatformTenants<TData = Awaited<ReturnType<typeof listPlatformTenants>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPlatformTenants>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPlatformTenantsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPlatformTenantFeaturesUrl = (id: string,) => {




  return `/api/platform/tenants/${id}/features`
}

/**
 * @summary List feature entitlements for one tenant (platform operators only).
 */
export const listPlatformTenantFeatures = async (id: string, options?: RequestInit): Promise<ListPlatformTenantFeatures200> => {

  return customFetch<ListPlatformTenantFeatures200>(getListPlatformTenantFeaturesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPlatformTenantFeaturesQueryKey = (id: string,) => {
    return [
    `/api/platform/tenants/${id}/features`
    ] as const;
    }


export const getListPlatformTenantFeaturesQueryOptions = <TData = Awaited<ReturnType<typeof listPlatformTenantFeatures>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPlatformTenantFeatures>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlatformTenantFeaturesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlatformTenantFeatures>>> = ({ signal }) => listPlatformTenantFeatures(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPlatformTenantFeatures>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPlatformTenantFeaturesQueryResult = NonNullable<Awaited<ReturnType<typeof listPlatformTenantFeatures>>>
export type ListPlatformTenantFeaturesQueryError = ErrorType<void>


/**
 * @summary List feature entitlements for one tenant (platform operators only).
 */

export function useListPlatformTenantFeatures<TData = Awaited<ReturnType<typeof listPlatformTenantFeatures>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPlatformTenantFeatures>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPlatformTenantFeaturesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSetPlatformTenantFeatureUrl = (id: string,
    key: FeatureKey,) => {




  return `/api/platform/tenants/${id}/features/${key}`
}

/**
 * @summary Enable / disable / configure a feature entitlement for one tenant (platform operators only).
 */
export const setPlatformTenantFeature = async (id: string,
    key: FeatureKey,
    platformTenantFeatureUpdate: PlatformTenantFeatureUpdate, options?: RequestInit): Promise<SetPlatformTenantFeature200> => {

  return customFetch<SetPlatformTenantFeature200>(getSetPlatformTenantFeatureUrl(id,key),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(platformTenantFeatureUpdate)
  }
);}





export const getSetPlatformTenantFeatureMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPlatformTenantFeature>>, TError,{id: string;key: FeatureKey;data: BodyType<PlatformTenantFeatureUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setPlatformTenantFeature>>, TError,{id: string;key: FeatureKey;data: BodyType<PlatformTenantFeatureUpdate>}, TContext> => {

const mutationKey = ['setPlatformTenantFeature'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setPlatformTenantFeature>>, {id: string;key: FeatureKey;data: BodyType<PlatformTenantFeatureUpdate>}> = (props) => {
          const {id,key,data} = props ?? {};

          return  setPlatformTenantFeature(id,key,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetPlatformTenantFeatureMutationResult = NonNullable<Awaited<ReturnType<typeof setPlatformTenantFeature>>>
    export type SetPlatformTenantFeatureMutationBody = BodyType<PlatformTenantFeatureUpdate>
    export type SetPlatformTenantFeatureMutationError = ErrorType<void>

    /**
 * @summary Enable / disable / configure a feature entitlement for one tenant (platform operators only).
 */
export const useSetPlatformTenantFeature = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPlatformTenantFeature>>, TError,{id: string;key: FeatureKey;data: BodyType<PlatformTenantFeatureUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setPlatformTenantFeature>>,
        TError,
        {id: string;key: FeatureKey;data: BodyType<PlatformTenantFeatureUpdate>},
        TContext
      > => {
      return useMutation(getSetPlatformTenantFeatureMutationOptions(options));
    }

export const getGetMyFeaturesUrl = () => {




  return `/api/me/features`
}

/**
 * @summary MetalUI feature keys currently enabled for the caller's tenant.
 */
export const getMyFeatures = async ( options?: RequestInit): Promise<GetMyFeatures200> => {

  return customFetch<GetMyFeatures200>(getGetMyFeaturesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyFeaturesQueryKey = () => {
    return [
    `/api/me/features`
    ] as const;
    }


export const getGetMyFeaturesQueryOptions = <TData = Awaited<ReturnType<typeof getMyFeatures>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyFeatures>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyFeaturesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyFeatures>>> = ({ signal }) => getMyFeatures({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyFeatures>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyFeaturesQueryResult = NonNullable<Awaited<ReturnType<typeof getMyFeatures>>>
export type GetMyFeaturesQueryError = ErrorType<unknown>


/**
 * @summary MetalUI feature keys currently enabled for the caller's tenant.
 */

export function useGetMyFeatures<TData = Awaited<ReturnType<typeof getMyFeatures>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyFeatures>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyFeaturesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListTenantMembersUrl = (tenantId: string,) => {




  return `/api/admin/tenant-members/${tenantId}`
}

/**
 * @summary List every member of a tenant with per-tenant role + override (platform tenant_manager only).
 */
export const listTenantMembers = async (tenantId: string, options?: RequestInit): Promise<TenantMemberList> => {

  return customFetch<TenantMemberList>(getListTenantMembersUrl(tenantId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTenantMembersQueryKey = (tenantId: string,) => {
    return [
    `/api/admin/tenant-members/${tenantId}`
    ] as const;
    }


export const getListTenantMembersQueryOptions = <TData = Awaited<ReturnType<typeof listTenantMembers>>, TError = ErrorType<void>>(tenantId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTenantMembers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTenantMembersQueryKey(tenantId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTenantMembers>>> = ({ signal }) => listTenantMembers(tenantId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTenantMembers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTenantMembersQueryResult = NonNullable<Awaited<ReturnType<typeof listTenantMembers>>>
export type ListTenantMembersQueryError = ErrorType<void>


/**
 * @summary List every member of a tenant with per-tenant role + override (platform tenant_manager only).
 */

export function useListTenantMembers<TData = Awaited<ReturnType<typeof listTenantMembers>>, TError = ErrorType<void>>(
 tenantId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTenantMembers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTenantMembersQueryOptions(tenantId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSetTenantMemberRoleUrl = (tenantId: string,
    userId: string,) => {




  return `/api/admin/tenant-members/${tenantId}/${userId}/role`
}

/**
 * @summary Set a user's per-tenant role (platform tenant_manager only).
 */
export const setTenantMemberRole = async (tenantId: string,
    userId: string,
    roleUpdate: RoleUpdate, options?: RequestInit): Promise<TenantMemberResponse> => {

  return customFetch<TenantMemberResponse>(getSetTenantMemberRoleUrl(tenantId,userId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(roleUpdate)
  }
);}





export const getSetTenantMemberRoleMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTenantMemberRole>>, TError,{tenantId: string;userId: string;data: BodyType<RoleUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setTenantMemberRole>>, TError,{tenantId: string;userId: string;data: BodyType<RoleUpdate>}, TContext> => {

const mutationKey = ['setTenantMemberRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setTenantMemberRole>>, {tenantId: string;userId: string;data: BodyType<RoleUpdate>}> = (props) => {
          const {tenantId,userId,data} = props ?? {};

          return  setTenantMemberRole(tenantId,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetTenantMemberRoleMutationResult = NonNullable<Awaited<ReturnType<typeof setTenantMemberRole>>>
    export type SetTenantMemberRoleMutationBody = BodyType<RoleUpdate>
    export type SetTenantMemberRoleMutationError = ErrorType<void>

    /**
 * @summary Set a user's per-tenant role (platform tenant_manager only).
 */
export const useSetTenantMemberRole = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTenantMemberRole>>, TError,{tenantId: string;userId: string;data: BodyType<RoleUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setTenantMemberRole>>,
        TError,
        {tenantId: string;userId: string;data: BodyType<RoleUpdate>},
        TContext
      > => {
      return useMutation(getSetTenantMemberRoleMutationOptions(options));
    }

export const getSetTenantMemberPermissionsOverrideUrl = (tenantId: string,
    userId: string,) => {




  return `/api/admin/tenant-members/${tenantId}/${userId}/permissions-override`
}

/**
 * @summary Replace a user's per-tenant permission override, or clear it (platform tenant_manager only).
 */
export const setTenantMemberPermissionsOverride = async (tenantId: string,
    userId: string,
    userPermissionsOverrideUpdate: UserPermissionsOverrideUpdate, options?: RequestInit): Promise<TenantMemberResponse> => {

  return customFetch<TenantMemberResponse>(getSetTenantMemberPermissionsOverrideUrl(tenantId,userId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(userPermissionsOverrideUpdate)
  }
);}





export const getSetTenantMemberPermissionsOverrideMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTenantMemberPermissionsOverride>>, TError,{tenantId: string;userId: string;data: BodyType<UserPermissionsOverrideUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setTenantMemberPermissionsOverride>>, TError,{tenantId: string;userId: string;data: BodyType<UserPermissionsOverrideUpdate>}, TContext> => {

const mutationKey = ['setTenantMemberPermissionsOverride'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setTenantMemberPermissionsOverride>>, {tenantId: string;userId: string;data: BodyType<UserPermissionsOverrideUpdate>}> = (props) => {
          const {tenantId,userId,data} = props ?? {};

          return  setTenantMemberPermissionsOverride(tenantId,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetTenantMemberPermissionsOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof setTenantMemberPermissionsOverride>>>
    export type SetTenantMemberPermissionsOverrideMutationBody = BodyType<UserPermissionsOverrideUpdate>
    export type SetTenantMemberPermissionsOverrideMutationError = ErrorType<void>

    /**
 * @summary Replace a user's per-tenant permission override, or clear it (platform tenant_manager only).
 */
export const useSetTenantMemberPermissionsOverride = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTenantMemberPermissionsOverride>>, TError,{tenantId: string;userId: string;data: BodyType<UserPermissionsOverrideUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setTenantMemberPermissionsOverride>>,
        TError,
        {tenantId: string;userId: string;data: BodyType<UserPermissionsOverrideUpdate>},
        TContext
      > => {
      return useMutation(getSetTenantMemberPermissionsOverrideMutationOptions(options));
    }

export const getListPublicPagesUrl = () => {




  return `/api/platform/website/pages`
}

/**
 * @summary List MetalUI public-website pages (manage_metalui_website, edit_website_pages, or publish_website_pages).
 */
export const listPublicPages = async ( options?: RequestInit): Promise<ListPublicPages200> => {

  return customFetch<ListPublicPages200>(getListPublicPagesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPublicPagesQueryKey = () => {
    return [
    `/api/platform/website/pages`
    ] as const;
    }


export const getListPublicPagesQueryOptions = <TData = Awaited<ReturnType<typeof listPublicPages>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPublicPages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPublicPagesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPublicPages>>> = ({ signal }) => listPublicPages({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPublicPages>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPublicPagesQueryResult = NonNullable<Awaited<ReturnType<typeof listPublicPages>>>
export type ListPublicPagesQueryError = ErrorType<void>


/**
 * @summary List MetalUI public-website pages (manage_metalui_website, edit_website_pages, or publish_website_pages).
 */

export function useListPublicPages<TData = Awaited<ReturnType<typeof listPublicPages>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPublicPages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPublicPagesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreatePublicPageUrl = () => {




  return `/api/platform/website/pages`
}

/**
 * @summary Create a public-website page (manage_metalui_website).
 */
export const createPublicPage = async (publicPageCreate: PublicPageCreate, options?: RequestInit): Promise<CreatePublicPage201> => {

  return customFetch<CreatePublicPage201>(getCreatePublicPageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(publicPageCreate)
  }
);}





export const getCreatePublicPageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPublicPage>>, TError,{data: BodyType<PublicPageCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPublicPage>>, TError,{data: BodyType<PublicPageCreate>}, TContext> => {

const mutationKey = ['createPublicPage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPublicPage>>, {data: BodyType<PublicPageCreate>}> = (props) => {
          const {data} = props ?? {};

          return  createPublicPage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePublicPageMutationResult = NonNullable<Awaited<ReturnType<typeof createPublicPage>>>
    export type CreatePublicPageMutationBody = BodyType<PublicPageCreate>
    export type CreatePublicPageMutationError = ErrorType<void>

    /**
 * @summary Create a public-website page (manage_metalui_website).
 */
export const useCreatePublicPage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPublicPage>>, TError,{data: BodyType<PublicPageCreate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPublicPage>>,
        TError,
        {data: BodyType<PublicPageCreate>},
        TContext
      > => {
      return useMutation(getCreatePublicPageMutationOptions(options));
    }

export const getGetPublicPageUrl = (id: string,) => {




  return `/api/platform/website/pages/${id}`
}

/**
 * @summary Get one public-website page with its ordered blocks (manage_metalui_website, edit_website_pages, or publish_website_pages).
 */
export const getPublicPage = async (id: string, options?: RequestInit): Promise<GetPublicPage200> => {

  return customFetch<GetPublicPage200>(getGetPublicPageUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicPageQueryKey = (id: string,) => {
    return [
    `/api/platform/website/pages/${id}`
    ] as const;
    }


export const getGetPublicPageQueryOptions = <TData = Awaited<ReturnType<typeof getPublicPage>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicPage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicPageQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicPage>>> = ({ signal }) => getPublicPage(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicPage>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublicPageQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicPage>>>
export type GetPublicPageQueryError = ErrorType<void>


/**
 * @summary Get one public-website page with its ordered blocks (manage_metalui_website, edit_website_pages, or publish_website_pages).
 */

export function useGetPublicPage<TData = Awaited<ReturnType<typeof getPublicPage>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicPage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublicPageQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdatePublicPageUrl = (id: string,) => {




  return `/api/platform/website/pages/${id}`
}

/**
 * @summary Update a public page's content, SEO and blocks; snapshots a version (edit_website_pages).
 */
export const updatePublicPage = async (id: string,
    publicPageUpdate: PublicPageUpdate, options?: RequestInit): Promise<UpdatePublicPage200> => {

  return customFetch<UpdatePublicPage200>(getUpdatePublicPageUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(publicPageUpdate)
  }
);}





export const getUpdatePublicPageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePublicPage>>, TError,{id: string;data: BodyType<PublicPageUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePublicPage>>, TError,{id: string;data: BodyType<PublicPageUpdate>}, TContext> => {

const mutationKey = ['updatePublicPage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePublicPage>>, {id: string;data: BodyType<PublicPageUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePublicPage(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePublicPageMutationResult = NonNullable<Awaited<ReturnType<typeof updatePublicPage>>>
    export type UpdatePublicPageMutationBody = BodyType<PublicPageUpdate>
    export type UpdatePublicPageMutationError = ErrorType<void>

    /**
 * @summary Update a public page's content, SEO and blocks; snapshots a version (edit_website_pages).
 */
export const useUpdatePublicPage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePublicPage>>, TError,{id: string;data: BodyType<PublicPageUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePublicPage>>,
        TError,
        {id: string;data: BodyType<PublicPageUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePublicPageMutationOptions(options));
    }

export const getDeletePublicPageUrl = (id: string,) => {




  return `/api/platform/website/pages/${id}`
}

/**
 * @summary Delete a public page and its blocks/versions (manage_metalui_website).
 */
export const deletePublicPage = async (id: string, options?: RequestInit): Promise<DeletePublicPage200> => {

  return customFetch<DeletePublicPage200>(getDeletePublicPageUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeletePublicPageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePublicPage>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePublicPage>>, TError,{id: string}, TContext> => {

const mutationKey = ['deletePublicPage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePublicPage>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deletePublicPage(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePublicPageMutationResult = NonNullable<Awaited<ReturnType<typeof deletePublicPage>>>

    export type DeletePublicPageMutationError = ErrorType<void>

    /**
 * @summary Delete a public page and its blocks/versions (manage_metalui_website).
 */
export const useDeletePublicPage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePublicPage>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePublicPage>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeletePublicPageMutationOptions(options));
    }

export const getGetWebsiteSeoOverviewUrl = () => {




  return `/api/platform/website/seo`
}

/**
 * @summary SEO / Sitemap overview — sitemap URL, Google Search Console connection state, and published pages with notify status (manage_metalui_website, edit_website_pages, or publish_website_pages).
 */
export const getWebsiteSeoOverview = async ( options?: RequestInit): Promise<SeoOverview> => {

  return customFetch<SeoOverview>(getGetWebsiteSeoOverviewUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWebsiteSeoOverviewQueryKey = () => {
    return [
    `/api/platform/website/seo`
    ] as const;
    }


export const getGetWebsiteSeoOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getWebsiteSeoOverview>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWebsiteSeoOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWebsiteSeoOverviewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebsiteSeoOverview>>> = ({ signal }) => getWebsiteSeoOverview({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWebsiteSeoOverview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWebsiteSeoOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getWebsiteSeoOverview>>>
export type GetWebsiteSeoOverviewQueryError = ErrorType<void>


/**
 * @summary SEO / Sitemap overview — sitemap URL, Google Search Console connection state, and published pages with notify status (manage_metalui_website, edit_website_pages, or publish_website_pages).
 */

export function useGetWebsiteSeoOverview<TData = Awaited<ReturnType<typeof getWebsiteSeoOverview>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWebsiteSeoOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWebsiteSeoOverviewQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSubmitWebsiteSitemapUrl = () => {




  return `/api/platform/website/seo/submit-sitemap`
}

/**
 * @summary Submit the sitemap to Google Search Console (publish_website_pages).
 */
export const submitWebsiteSitemap = async ( options?: RequestInit): Promise<SubmitWebsiteSitemap200> => {

  return customFetch<SubmitWebsiteSitemap200>(getSubmitWebsiteSitemapUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSubmitWebsiteSitemapMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitWebsiteSitemap>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitWebsiteSitemap>>, TError,void, TContext> => {

const mutationKey = ['submitWebsiteSitemap'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitWebsiteSitemap>>, void> = () => {


          return  submitWebsiteSitemap(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitWebsiteSitemapMutationResult = NonNullable<Awaited<ReturnType<typeof submitWebsiteSitemap>>>

    export type SubmitWebsiteSitemapMutationError = ErrorType<void>

    /**
 * @summary Submit the sitemap to Google Search Console (publish_website_pages).
 */
export const useSubmitWebsiteSitemap = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitWebsiteSitemap>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitWebsiteSitemap>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSubmitWebsiteSitemapMutationOptions(options));
    }

export const getNotifyWebsiteSeoPageUrl = (id: string,) => {




  return `/api/platform/website/seo/notify-page/${id}`
}

/**
 * @summary Notify Google (Indexing API) that a published page changed (publish_website_pages).
 */
export const notifyWebsiteSeoPage = async (id: string, options?: RequestInit): Promise<NotifyWebsiteSeoPage200> => {

  return customFetch<NotifyWebsiteSeoPage200>(getNotifyWebsiteSeoPageUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getNotifyWebsiteSeoPageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyWebsiteSeoPage>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof notifyWebsiteSeoPage>>, TError,{id: string}, TContext> => {

const mutationKey = ['notifyWebsiteSeoPage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notifyWebsiteSeoPage>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  notifyWebsiteSeoPage(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotifyWebsiteSeoPageMutationResult = NonNullable<Awaited<ReturnType<typeof notifyWebsiteSeoPage>>>

    export type NotifyWebsiteSeoPageMutationError = ErrorType<void>

    /**
 * @summary Notify Google (Indexing API) that a published page changed (publish_website_pages).
 */
export const useNotifyWebsiteSeoPage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyWebsiteSeoPage>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof notifyWebsiteSeoPage>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getNotifyWebsiteSeoPageMutationOptions(options));
    }

export const getInspectWebsiteSeoPageUrl = (id: string,) => {




  return `/api/platform/website/seo/inspect/${id}`
}

/**
 * @summary Live indexing/coverage status for a published page's canonical URL, straight from Google's index (URL Inspection API). Read-only (manage_metalui_website, edit_website_pages, or publish_website_pages).
 */
export const inspectWebsiteSeoPage = async (id: string, options?: RequestInit): Promise<SeoUrlInspection> => {

  return customFetch<SeoUrlInspection>(getInspectWebsiteSeoPageUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getInspectWebsiteSeoPageQueryKey = (id: string,) => {
    return [
    `/api/platform/website/seo/inspect/${id}`
    ] as const;
    }


export const getInspectWebsiteSeoPageQueryOptions = <TData = Awaited<ReturnType<typeof inspectWebsiteSeoPage>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof inspectWebsiteSeoPage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInspectWebsiteSeoPageQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof inspectWebsiteSeoPage>>> = ({ signal }) => inspectWebsiteSeoPage(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof inspectWebsiteSeoPage>>, TError, TData> & { queryKey: QueryKey }
}

export type InspectWebsiteSeoPageQueryResult = NonNullable<Awaited<ReturnType<typeof inspectWebsiteSeoPage>>>
export type InspectWebsiteSeoPageQueryError = ErrorType<void>


/**
 * @summary Live indexing/coverage status for a published page's canonical URL, straight from Google's index (URL Inspection API). Read-only (manage_metalui_website, edit_website_pages, or publish_website_pages).
 */

export function useInspectWebsiteSeoPage<TData = Awaited<ReturnType<typeof inspectWebsiteSeoPage>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof inspectWebsiteSeoPage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getInspectWebsiteSeoPageQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetWebsiteSeoSearchAnalyticsUrl = () => {




  return `/api/platform/website/seo/search-analytics`
}

/**
 * @summary Top search queries with clicks/impressions/CTR/position for the connected Search Console property over the trailing 28 days. Read-only (manage_metalui_website, edit_website_pages, or publish_website_pages).
 */
export const getWebsiteSeoSearchAnalytics = async ( options?: RequestInit): Promise<SeoSearchAnalytics> => {

  return customFetch<SeoSearchAnalytics>(getGetWebsiteSeoSearchAnalyticsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWebsiteSeoSearchAnalyticsQueryKey = () => {
    return [
    `/api/platform/website/seo/search-analytics`
    ] as const;
    }


export const getGetWebsiteSeoSearchAnalyticsQueryOptions = <TData = Awaited<ReturnType<typeof getWebsiteSeoSearchAnalytics>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWebsiteSeoSearchAnalytics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWebsiteSeoSearchAnalyticsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebsiteSeoSearchAnalytics>>> = ({ signal }) => getWebsiteSeoSearchAnalytics({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWebsiteSeoSearchAnalytics>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWebsiteSeoSearchAnalyticsQueryResult = NonNullable<Awaited<ReturnType<typeof getWebsiteSeoSearchAnalytics>>>
export type GetWebsiteSeoSearchAnalyticsQueryError = ErrorType<void>


/**
 * @summary Top search queries with clicks/impressions/CTR/position for the connected Search Console property over the trailing 28 days. Read-only (manage_metalui_website, edit_website_pages, or publish_website_pages).
 */

export function useGetWebsiteSeoSearchAnalytics<TData = Awaited<ReturnType<typeof getWebsiteSeoSearchAnalytics>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWebsiteSeoSearchAnalytics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWebsiteSeoSearchAnalyticsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetWebsiteSeoSearchTrendUrl = (params?: GetWebsiteSeoSearchTrendParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/platform/website/seo/search-trend?${stringifiedParams}` : `/api/platform/website/seo/search-trend`
}

/**
 * @summary Search Analytics history (clicks/impressions/CTR/position over time), captured daily by the scheduler so operators can see week-over-week trend, not just the live snapshot. Read-only (manage_metalui_website, edit_website_pages, or publish_website_pages).
 */
export const getWebsiteSeoSearchTrend = async (params?: GetWebsiteSeoSearchTrendParams, options?: RequestInit): Promise<SeoSearchTrend> => {

  return customFetch<SeoSearchTrend>(getGetWebsiteSeoSearchTrendUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWebsiteSeoSearchTrendQueryKey = (params?: GetWebsiteSeoSearchTrendParams,) => {
    return [
    `/api/platform/website/seo/search-trend`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetWebsiteSeoSearchTrendQueryOptions = <TData = Awaited<ReturnType<typeof getWebsiteSeoSearchTrend>>, TError = ErrorType<void>>(params?: GetWebsiteSeoSearchTrendParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWebsiteSeoSearchTrend>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWebsiteSeoSearchTrendQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebsiteSeoSearchTrend>>> = ({ signal }) => getWebsiteSeoSearchTrend(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWebsiteSeoSearchTrend>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWebsiteSeoSearchTrendQueryResult = NonNullable<Awaited<ReturnType<typeof getWebsiteSeoSearchTrend>>>
export type GetWebsiteSeoSearchTrendQueryError = ErrorType<void>


/**
 * @summary Search Analytics history (clicks/impressions/CTR/position over time), captured daily by the scheduler so operators can see week-over-week trend, not just the live snapshot. Read-only (manage_metalui_website, edit_website_pages, or publish_website_pages).
 */

export function useGetWebsiteSeoSearchTrend<TData = Awaited<ReturnType<typeof getWebsiteSeoSearchTrend>>, TError = ErrorType<void>>(
 params?: GetWebsiteSeoSearchTrendParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWebsiteSeoSearchTrend>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWebsiteSeoSearchTrendQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetWebsiteSeoIndexingTrendUrl = (params?: GetWebsiteSeoIndexingTrendParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/platform/website/seo/indexing-trend?${stringifiedParams}` : `/api/platform/website/seo/indexing-trend`
}

/**
 * @summary Per-run indexed/not-indexed page counts over time, captured daily by the scheduler so operators can see indexing trend, not just the live snapshot. Read-only (manage_metalui_website, edit_website_pages, or publish_website_pages).
 */
export const getWebsiteSeoIndexingTrend = async (params?: GetWebsiteSeoIndexingTrendParams, options?: RequestInit): Promise<SeoIndexingTrend> => {

  return customFetch<SeoIndexingTrend>(getGetWebsiteSeoIndexingTrendUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWebsiteSeoIndexingTrendQueryKey = (params?: GetWebsiteSeoIndexingTrendParams,) => {
    return [
    `/api/platform/website/seo/indexing-trend`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetWebsiteSeoIndexingTrendQueryOptions = <TData = Awaited<ReturnType<typeof getWebsiteSeoIndexingTrend>>, TError = ErrorType<void>>(params?: GetWebsiteSeoIndexingTrendParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWebsiteSeoIndexingTrend>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWebsiteSeoIndexingTrendQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebsiteSeoIndexingTrend>>> = ({ signal }) => getWebsiteSeoIndexingTrend(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWebsiteSeoIndexingTrend>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWebsiteSeoIndexingTrendQueryResult = NonNullable<Awaited<ReturnType<typeof getWebsiteSeoIndexingTrend>>>
export type GetWebsiteSeoIndexingTrendQueryError = ErrorType<void>


/**
 * @summary Per-run indexed/not-indexed page counts over time, captured daily by the scheduler so operators can see indexing trend, not just the live snapshot. Read-only (manage_metalui_website, edit_website_pages, or publish_website_pages).
 */

export function useGetWebsiteSeoIndexingTrend<TData = Awaited<ReturnType<typeof getWebsiteSeoIndexingTrend>>, TError = ErrorType<void>>(
 params?: GetWebsiteSeoIndexingTrendParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWebsiteSeoIndexingTrend>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWebsiteSeoIndexingTrendQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPublishPublicPageUrl = (id: string,) => {




  return `/api/platform/website/pages/${id}/publish`
}

/**
 * @summary Publish a public page (publish_website_pages).
 */
export const publishPublicPage = async (id: string, options?: RequestInit): Promise<PublishPublicPage200> => {

  return customFetch<PublishPublicPage200>(getPublishPublicPageUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPublishPublicPageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishPublicPage>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof publishPublicPage>>, TError,{id: string}, TContext> => {

const mutationKey = ['publishPublicPage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishPublicPage>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  publishPublicPage(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishPublicPageMutationResult = NonNullable<Awaited<ReturnType<typeof publishPublicPage>>>

    export type PublishPublicPageMutationError = ErrorType<void>

    /**
 * @summary Publish a public page (publish_website_pages).
 */
export const usePublishPublicPage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishPublicPage>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof publishPublicPage>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getPublishPublicPageMutationOptions(options));
    }

export const getUnpublishPublicPageUrl = (id: string,) => {




  return `/api/platform/website/pages/${id}/unpublish`
}

/**
 * @summary Revert a public page to draft (publish_website_pages).
 */
export const unpublishPublicPage = async (id: string, options?: RequestInit): Promise<UnpublishPublicPage200> => {

  return customFetch<UnpublishPublicPage200>(getUnpublishPublicPageUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getUnpublishPublicPageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unpublishPublicPage>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unpublishPublicPage>>, TError,{id: string}, TContext> => {

const mutationKey = ['unpublishPublicPage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unpublishPublicPage>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  unpublishPublicPage(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnpublishPublicPageMutationResult = NonNullable<Awaited<ReturnType<typeof unpublishPublicPage>>>

    export type UnpublishPublicPageMutationError = ErrorType<void>

    /**
 * @summary Revert a public page to draft (publish_website_pages).
 */
export const useUnpublishPublicPage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unpublishPublicPage>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof unpublishPublicPage>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getUnpublishPublicPageMutationOptions(options));
    }

export const getAiSuggestPublicPageUrl = (id: string,) => {




  return `/api/platform/website/pages/${id}/ai-suggest`
}

/**
 * Returns AI-generated suggestions for the page's SEO metadata (target=seo) or for the text fields of a single content block (target=block + blockIndex). Read-only — the caller applies and saves the suggestion manually. 503 when the OpenAI integration is unconfigured.
 * @summary AI copy/SEO suggestions for a public page (edit_website_pages).
 */
export const aiSuggestPublicPage = async (id: string,
    publicPageAiSuggestRequest: PublicPageAiSuggestRequest, options?: RequestInit): Promise<PublicPageAiSuggestResponse> => {

  return customFetch<PublicPageAiSuggestResponse>(getAiSuggestPublicPageUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(publicPageAiSuggestRequest)
  }
);}





export const getAiSuggestPublicPageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiSuggestPublicPage>>, TError,{id: string;data: BodyType<PublicPageAiSuggestRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof aiSuggestPublicPage>>, TError,{id: string;data: BodyType<PublicPageAiSuggestRequest>}, TContext> => {

const mutationKey = ['aiSuggestPublicPage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiSuggestPublicPage>>, {id: string;data: BodyType<PublicPageAiSuggestRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  aiSuggestPublicPage(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AiSuggestPublicPageMutationResult = NonNullable<Awaited<ReturnType<typeof aiSuggestPublicPage>>>
    export type AiSuggestPublicPageMutationBody = BodyType<PublicPageAiSuggestRequest>
    export type AiSuggestPublicPageMutationError = ErrorType<void>

    /**
 * @summary AI copy/SEO suggestions for a public page (edit_website_pages).
 */
export const useAiSuggestPublicPage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiSuggestPublicPage>>, TError,{id: string;data: BodyType<PublicPageAiSuggestRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof aiSuggestPublicPage>>,
        TError,
        {id: string;data: BodyType<PublicPageAiSuggestRequest>},
        TContext
      > => {
      return useMutation(getAiSuggestPublicPageMutationOptions(options));
    }

export const getListPublicPageVersionsUrl = (id: string,) => {




  return `/api/platform/website/pages/${id}/versions`
}

/**
 * @summary List version history for one public page (platform operators only).
 */
export const listPublicPageVersions = async (id: string, options?: RequestInit): Promise<ListPublicPageVersions200> => {

  return customFetch<ListPublicPageVersions200>(getListPublicPageVersionsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPublicPageVersionsQueryKey = (id: string,) => {
    return [
    `/api/platform/website/pages/${id}/versions`
    ] as const;
    }


export const getListPublicPageVersionsQueryOptions = <TData = Awaited<ReturnType<typeof listPublicPageVersions>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPublicPageVersions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPublicPageVersionsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPublicPageVersions>>> = ({ signal }) => listPublicPageVersions(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPublicPageVersions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPublicPageVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof listPublicPageVersions>>>
export type ListPublicPageVersionsQueryError = ErrorType<void>


/**
 * @summary List version history for one public page (platform operators only).
 */

export function useListPublicPageVersions<TData = Awaited<ReturnType<typeof listPublicPageVersions>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPublicPageVersions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPublicPageVersionsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPublicPageVersionUrl = (id: string,
    versionId: string,) => {




  return `/api/platform/website/pages/${id}/versions/${versionId}`
}

/**
 * @summary Fetch one version with its full snapshot for preview (platform operators only).
 */
export const getPublicPageVersion = async (id: string,
    versionId: string, options?: RequestInit): Promise<GetPublicPageVersion200> => {

  return customFetch<GetPublicPageVersion200>(getGetPublicPageVersionUrl(id,versionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicPageVersionQueryKey = (id: string,
    versionId: string,) => {
    return [
    `/api/platform/website/pages/${id}/versions/${versionId}`
    ] as const;
    }


export const getGetPublicPageVersionQueryOptions = <TData = Awaited<ReturnType<typeof getPublicPageVersion>>, TError = ErrorType<void>>(id: string,
    versionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicPageVersion>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicPageVersionQueryKey(id,versionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicPageVersion>>> = ({ signal }) => getPublicPageVersion(id,versionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && versionId !== null && versionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicPageVersion>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublicPageVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicPageVersion>>>
export type GetPublicPageVersionQueryError = ErrorType<void>


/**
 * @summary Fetch one version with its full snapshot for preview (platform operators only).
 */

export function useGetPublicPageVersion<TData = Awaited<ReturnType<typeof getPublicPageVersion>>, TError = ErrorType<void>>(
 id: string,
    versionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicPageVersion>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublicPageVersionQueryOptions(id,versionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRestorePublicPageVersionUrl = (id: string,
    versionId: string,) => {




  return `/api/platform/website/pages/${id}/versions/${versionId}/restore`
}

/**
 * @summary Restore a public page to a prior version snapshot (platform edit_website_pages only).
 */
export const restorePublicPageVersion = async (id: string,
    versionId: string, options?: RequestInit): Promise<RestorePublicPageVersion200> => {

  return customFetch<RestorePublicPageVersion200>(getRestorePublicPageVersionUrl(id,versionId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRestorePublicPageVersionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restorePublicPageVersion>>, TError,{id: string;versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof restorePublicPageVersion>>, TError,{id: string;versionId: string}, TContext> => {

const mutationKey = ['restorePublicPageVersion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restorePublicPageVersion>>, {id: string;versionId: string}> = (props) => {
          const {id,versionId} = props ?? {};

          return  restorePublicPageVersion(id,versionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RestorePublicPageVersionMutationResult = NonNullable<Awaited<ReturnType<typeof restorePublicPageVersion>>>

    export type RestorePublicPageVersionMutationError = ErrorType<void>

    /**
 * @summary Restore a public page to a prior version snapshot (platform edit_website_pages only).
 */
export const useRestorePublicPageVersion = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restorePublicPageVersion>>, TError,{id: string;versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof restorePublicPageVersion>>,
        TError,
        {id: string;versionId: string},
        TContext
      > => {
      return useMutation(getRestorePublicPageVersionMutationOptions(options));
    }

export const getGetSiteSettingsUrl = () => {




  return `/api/platform/website/site-settings`
}

/**
 * @summary Get all global public-site settings (nav, footer, theme, logos, forms) with draft + published data (any website permission).
 */
export const getSiteSettings = async ( options?: RequestInit): Promise<GetSiteSettings200> => {

  return customFetch<GetSiteSettings200>(getGetSiteSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSiteSettingsQueryKey = () => {
    return [
    `/api/platform/website/site-settings`
    ] as const;
    }


export const getGetSiteSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getSiteSettings>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSiteSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSiteSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSiteSettings>>> = ({ signal }) => getSiteSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSiteSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSiteSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSiteSettings>>>
export type GetSiteSettingsQueryError = ErrorType<void>


/**
 * @summary Get all global public-site settings (nav, footer, theme, logos, forms) with draft + published data (any website permission).
 */

export function useGetSiteSettings<TData = Awaited<ReturnType<typeof getSiteSettings>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSiteSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSiteSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateSiteSettingUrl = () => {




  return `/api/platform/website/site-settings`
}

/**
 * @summary Update one global site setting's draft data; snapshots a version (edit_website_pages).
 */
export const updateSiteSetting = async (siteSettingUpdate: SiteSettingUpdate, options?: RequestInit): Promise<UpdateSiteSetting200> => {

  return customFetch<UpdateSiteSetting200>(getUpdateSiteSettingUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(siteSettingUpdate)
  }
);}





export const getUpdateSiteSettingMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSiteSetting>>, TError,{data: BodyType<SiteSettingUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSiteSetting>>, TError,{data: BodyType<SiteSettingUpdate>}, TContext> => {

const mutationKey = ['updateSiteSetting'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSiteSetting>>, {data: BodyType<SiteSettingUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateSiteSetting(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSiteSettingMutationResult = NonNullable<Awaited<ReturnType<typeof updateSiteSetting>>>
    export type UpdateSiteSettingMutationBody = BodyType<SiteSettingUpdate>
    export type UpdateSiteSettingMutationError = ErrorType<void>

    /**
 * @summary Update one global site setting's draft data; snapshots a version (edit_website_pages).
 */
export const useUpdateSiteSetting = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSiteSetting>>, TError,{data: BodyType<SiteSettingUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSiteSetting>>,
        TError,
        {data: BodyType<SiteSettingUpdate>},
        TContext
      > => {
      return useMutation(getUpdateSiteSettingMutationOptions(options));
    }

export const getPublishSiteSettingsUrl = () => {




  return `/api/platform/website/site-settings/publish`
}

/**
 * @summary Publish global site settings (copy draft to published); omit key to publish all. Snapshots a version (publish_website_pages).
 */
export const publishSiteSettings = async (siteSettingPublish?: SiteSettingPublish, options?: RequestInit): Promise<PublishSiteSettings200> => {

  return customFetch<PublishSiteSettings200>(getPublishSiteSettingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(siteSettingPublish)
  }
);}





export const getPublishSiteSettingsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishSiteSettings>>, TError,{data?: BodyType<SiteSettingPublish>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof publishSiteSettings>>, TError,{data?: BodyType<SiteSettingPublish>}, TContext> => {

const mutationKey = ['publishSiteSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishSiteSettings>>, {data?: BodyType<SiteSettingPublish>}> = (props) => {
          const {data} = props ?? {};

          return  publishSiteSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishSiteSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof publishSiteSettings>>>
    export type PublishSiteSettingsMutationBody = BodyType<SiteSettingPublish> | undefined
    export type PublishSiteSettingsMutationError = ErrorType<void>

    /**
 * @summary Publish global site settings (copy draft to published); omit key to publish all. Snapshots a version (publish_website_pages).
 */
export const usePublishSiteSettings = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishSiteSettings>>, TError,{data?: BodyType<SiteSettingPublish>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof publishSiteSettings>>,
        TError,
        {data?: BodyType<SiteSettingPublish>},
        TContext
      > => {
      return useMutation(getPublishSiteSettingsMutationOptions(options));
    }

export const getListSiteSettingVersionsUrl = (params: ListSiteSettingVersionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/platform/website/site-settings/versions?${stringifiedParams}` : `/api/platform/website/site-settings/versions`
}

/**
 * @summary List version history for one global site setting key (any website permission).
 */
export const listSiteSettingVersions = async (params: ListSiteSettingVersionsParams, options?: RequestInit): Promise<ListSiteSettingVersions200> => {

  return customFetch<ListSiteSettingVersions200>(getListSiteSettingVersionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSiteSettingVersionsQueryKey = (params?: ListSiteSettingVersionsParams,) => {
    return [
    `/api/platform/website/site-settings/versions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSiteSettingVersionsQueryOptions = <TData = Awaited<ReturnType<typeof listSiteSettingVersions>>, TError = ErrorType<void>>(params: ListSiteSettingVersionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSiteSettingVersions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSiteSettingVersionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteSettingVersions>>> = ({ signal }) => listSiteSettingVersions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSiteSettingVersions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSiteSettingVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof listSiteSettingVersions>>>
export type ListSiteSettingVersionsQueryError = ErrorType<void>


/**
 * @summary List version history for one global site setting key (any website permission).
 */

export function useListSiteSettingVersions<TData = Awaited<ReturnType<typeof listSiteSettingVersions>>, TError = ErrorType<void>>(
 params: ListSiteSettingVersionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSiteSettingVersions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSiteSettingVersionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRestoreSiteSettingVersionUrl = (versionId: string,) => {




  return `/api/platform/website/site-settings/versions/${versionId}/restore`
}

/**
 * @summary Restore a global site setting's draft to a prior version snapshot (edit_website_pages).
 */
export const restoreSiteSettingVersion = async (versionId: string, options?: RequestInit): Promise<RestoreSiteSettingVersion200> => {

  return customFetch<RestoreSiteSettingVersion200>(getRestoreSiteSettingVersionUrl(versionId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRestoreSiteSettingVersionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreSiteSettingVersion>>, TError,{versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof restoreSiteSettingVersion>>, TError,{versionId: string}, TContext> => {

const mutationKey = ['restoreSiteSettingVersion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreSiteSettingVersion>>, {versionId: string}> = (props) => {
          const {versionId} = props ?? {};

          return  restoreSiteSettingVersion(versionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RestoreSiteSettingVersionMutationResult = NonNullable<Awaited<ReturnType<typeof restoreSiteSettingVersion>>>

    export type RestoreSiteSettingVersionMutationError = ErrorType<void>

    /**
 * @summary Restore a global site setting's draft to a prior version snapshot (edit_website_pages).
 */
export const useRestoreSiteSettingVersion = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreSiteSettingVersion>>, TError,{versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof restoreSiteSettingVersion>>,
        TError,
        {versionId: string},
        TContext
      > => {
      return useMutation(getRestoreSiteSettingVersionMutationOptions(options));
    }

export const getGetMyPlatformAccessUrl = () => {




  return `/api/me/platform-access`
}

/**
 * @summary Whether the caller may manage cross-tenant MetalUI platform controls.
 */
export const getMyPlatformAccess = async ( options?: RequestInit): Promise<GetMyPlatformAccess200> => {

  return customFetch<GetMyPlatformAccess200>(getGetMyPlatformAccessUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyPlatformAccessQueryKey = () => {
    return [
    `/api/me/platform-access`
    ] as const;
    }


export const getGetMyPlatformAccessQueryOptions = <TData = Awaited<ReturnType<typeof getMyPlatformAccess>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyPlatformAccess>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyPlatformAccessQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyPlatformAccess>>> = ({ signal }) => getMyPlatformAccess({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyPlatformAccess>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyPlatformAccessQueryResult = NonNullable<Awaited<ReturnType<typeof getMyPlatformAccess>>>
export type GetMyPlatformAccessQueryError = ErrorType<unknown>


/**
 * @summary Whether the caller may manage cross-tenant MetalUI platform controls.
 */

export function useGetMyPlatformAccess<TData = Awaited<ReturnType<typeof getMyPlatformAccess>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyPlatformAccess>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyPlatformAccessQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMyPlatformPermissionsUrl = () => {




  return `/api/me/platform-permissions`
}

/**
 * @summary Returns the list of platform permission keys the caller holds. Empty for non-platform users.
 */
export const getMyPlatformPermissions = async ( options?: RequestInit): Promise<GetMyPlatformPermissions200> => {

  return customFetch<GetMyPlatformPermissions200>(getGetMyPlatformPermissionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyPlatformPermissionsQueryKey = () => {
    return [
    `/api/me/platform-permissions`
    ] as const;
    }


export const getGetMyPlatformPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof getMyPlatformPermissions>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyPlatformPermissions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyPlatformPermissionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyPlatformPermissions>>> = ({ signal }) => getMyPlatformPermissions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyPlatformPermissions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyPlatformPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyPlatformPermissions>>>
export type GetMyPlatformPermissionsQueryError = ErrorType<unknown>


/**
 * @summary Returns the list of platform permission keys the caller holds. Empty for non-platform users.
 */

export function useGetMyPlatformPermissions<TData = Awaited<ReturnType<typeof getMyPlatformPermissions>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyPlatformPermissions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyPlatformPermissionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListTasksUrl = (params?: ListTasksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tasks/tasks?${stringifiedParams}` : `/api/tasks/tasks`
}

/**
 * @summary List tasks (scope = mine | team | all)
 */
export const listTasks = async (params?: ListTasksParams, options?: RequestInit): Promise<TmTaskDetail[]> => {

  return customFetch<TmTaskDetail[]>(getListTasksUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTasksQueryKey = (params?: ListTasksParams,) => {
    return [
    `/api/tasks/tasks`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTasksQueryOptions = <TData = Awaited<ReturnType<typeof listTasks>>, TError = ErrorType<unknown>>(params?: ListTasksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTasksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTasks>>> = ({ signal }) => listTasks(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTasksQueryResult = NonNullable<Awaited<ReturnType<typeof listTasks>>>
export type ListTasksQueryError = ErrorType<unknown>


/**
 * @summary List tasks (scope = mine | team | all)
 */

export function useListTasks<TData = Awaited<ReturnType<typeof listTasks>>, TError = ErrorType<unknown>>(
 params?: ListTasksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTasksQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateTaskUrl = () => {




  return `/api/tasks/tasks`
}

/**
 * @summary Create a task
 */
export const createTask = async (tmTaskInput: TmTaskInput, options?: RequestInit): Promise<TmTaskDetail> => {

  return customFetch<TmTaskDetail>(getCreateTaskUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tmTaskInput)
  }
);}





export const getCreateTaskMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,{data: BodyType<TmTaskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,{data: BodyType<TmTaskInput>}, TContext> => {

const mutationKey = ['createTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTask>>, {data: BodyType<TmTaskInput>}> = (props) => {
          const {data} = props ?? {};

          return  createTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createTask>>>
    export type CreateTaskMutationBody = BodyType<TmTaskInput>
    export type CreateTaskMutationError = ErrorType<unknown>

    /**
 * @summary Create a task
 */
export const useCreateTask = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,{data: BodyType<TmTaskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTask>>,
        TError,
        {data: BodyType<TmTaskInput>},
        TContext
      > => {
      return useMutation(getCreateTaskMutationOptions(options));
    }

export const getGetTaskUrl = (id: string,) => {




  return `/api/tasks/tasks/${id}`
}

export const getTask = async (id: string, options?: RequestInit): Promise<TmTaskDetail> => {

  return customFetch<TmTaskDetail>(getGetTaskUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTaskQueryKey = (id: string,) => {
    return [
    `/api/tasks/tasks/${id}`
    ] as const;
    }


export const getGetTaskQueryOptions = <TData = Awaited<ReturnType<typeof getTask>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTask>>> = ({ signal }) => getTask(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTaskQueryResult = NonNullable<Awaited<ReturnType<typeof getTask>>>
export type GetTaskQueryError = ErrorType<unknown>



export function useGetTask<TData = Awaited<ReturnType<typeof getTask>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTaskQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateTaskUrl = (id: string,) => {




  return `/api/tasks/tasks/${id}`
}

export const updateTask = async (id: string,
    tmTaskUpdate: TmTaskUpdate, options?: RequestInit): Promise<TmTaskDetail> => {

  return customFetch<TmTaskDetail>(getUpdateTaskUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tmTaskUpdate)
  }
);}





export const getUpdateTaskMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTask>>, TError,{id: string;data: BodyType<TmTaskUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTask>>, TError,{id: string;data: BodyType<TmTaskUpdate>}, TContext> => {

const mutationKey = ['updateTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTask>>, {id: string;data: BodyType<TmTaskUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTask(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof updateTask>>>
    export type UpdateTaskMutationBody = BodyType<TmTaskUpdate>
    export type UpdateTaskMutationError = ErrorType<unknown>

    export const useUpdateTask = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTask>>, TError,{id: string;data: BodyType<TmTaskUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTask>>,
        TError,
        {id: string;data: BodyType<TmTaskUpdate>},
        TContext
      > => {
      return useMutation(getUpdateTaskMutationOptions(options));
    }

export const getDeleteTaskUrl = (id: string,) => {




  return `/api/tasks/tasks/${id}`
}

export const deleteTask = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteTaskUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTaskMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTask>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTask>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTask>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteTask(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTaskMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTask>>>

    export type DeleteTaskMutationError = ErrorType<unknown>

    export const useDeleteTask = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTask>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTask>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteTaskMutationOptions(options));
    }

export const getCompleteTaskUrl = (id: string,) => {




  return `/api/tasks/tasks/${id}/complete`
}

export const completeTask = async (id: string, options?: RequestInit): Promise<TmTaskDetail> => {

  return customFetch<TmTaskDetail>(getCompleteTaskUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCompleteTaskMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeTask>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof completeTask>>, TError,{id: string}, TContext> => {

const mutationKey = ['completeTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeTask>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  completeTask(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteTaskMutationResult = NonNullable<Awaited<ReturnType<typeof completeTask>>>

    export type CompleteTaskMutationError = ErrorType<unknown>

    export const useCompleteTask = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeTask>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof completeTask>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getCompleteTaskMutationOptions(options));
    }

export const getReopenTaskUrl = (id: string,) => {




  return `/api/tasks/tasks/${id}/reopen`
}

export const reopenTask = async (id: string, options?: RequestInit): Promise<TmTaskDetail> => {

  return customFetch<TmTaskDetail>(getReopenTaskUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getReopenTaskMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenTask>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reopenTask>>, TError,{id: string}, TContext> => {

const mutationKey = ['reopenTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reopenTask>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  reopenTask(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReopenTaskMutationResult = NonNullable<Awaited<ReturnType<typeof reopenTask>>>

    export type ReopenTaskMutationError = ErrorType<unknown>

    export const useReopenTask = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenTask>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reopenTask>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getReopenTaskMutationOptions(options));
    }

export const getSaveTaskAsTemplateUrl = (id: string,) => {




  return `/api/tasks/tasks/${id}/save-as-template`
}

/**
 * @summary Save an existing task (with its checklist) as a reusable template
 */
export const saveTaskAsTemplate = async (id: string,
    tmSaveAsTemplateInput: TmSaveAsTemplateInput, options?: RequestInit): Promise<TmTaskTemplateDetail> => {

  return customFetch<TmTaskTemplateDetail>(getSaveTaskAsTemplateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tmSaveAsTemplateInput)
  }
);}





export const getSaveTaskAsTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveTaskAsTemplate>>, TError,{id: string;data: BodyType<TmSaveAsTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveTaskAsTemplate>>, TError,{id: string;data: BodyType<TmSaveAsTemplateInput>}, TContext> => {

const mutationKey = ['saveTaskAsTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveTaskAsTemplate>>, {id: string;data: BodyType<TmSaveAsTemplateInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  saveTaskAsTemplate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveTaskAsTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof saveTaskAsTemplate>>>
    export type SaveTaskAsTemplateMutationBody = BodyType<TmSaveAsTemplateInput>
    export type SaveTaskAsTemplateMutationError = ErrorType<unknown>

    /**
 * @summary Save an existing task (with its checklist) as a reusable template
 */
export const useSaveTaskAsTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveTaskAsTemplate>>, TError,{id: string;data: BodyType<TmSaveAsTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveTaskAsTemplate>>,
        TError,
        {id: string;data: BodyType<TmSaveAsTemplateInput>},
        TContext
      > => {
      return useMutation(getSaveTaskAsTemplateMutationOptions(options));
    }

export const getListTaskTemplatesUrl = () => {




  return `/api/tasks/templates`
}

/**
 * @summary List reusable task templates
 */
export const listTaskTemplates = async ( options?: RequestInit): Promise<TmTaskTemplateDetail[]> => {

  return customFetch<TmTaskTemplateDetail[]>(getListTaskTemplatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTaskTemplatesQueryKey = () => {
    return [
    `/api/tasks/templates`
    ] as const;
    }


export const getListTaskTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof listTaskTemplates>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTaskTemplates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTaskTemplatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTaskTemplates>>> = ({ signal }) => listTaskTemplates({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTaskTemplates>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTaskTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof listTaskTemplates>>>
export type ListTaskTemplatesQueryError = ErrorType<unknown>


/**
 * @summary List reusable task templates
 */

export function useListTaskTemplates<TData = Awaited<ReturnType<typeof listTaskTemplates>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTaskTemplates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTaskTemplatesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateTaskTemplateUrl = () => {




  return `/api/tasks/templates`
}

/**
 * @summary Create a task template
 */
export const createTaskTemplate = async (tmTaskTemplateInput: TmTaskTemplateInput, options?: RequestInit): Promise<TmTaskTemplateDetail> => {

  return customFetch<TmTaskTemplateDetail>(getCreateTaskTemplateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tmTaskTemplateInput)
  }
);}





export const getCreateTaskTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTaskTemplate>>, TError,{data: BodyType<TmTaskTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTaskTemplate>>, TError,{data: BodyType<TmTaskTemplateInput>}, TContext> => {

const mutationKey = ['createTaskTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTaskTemplate>>, {data: BodyType<TmTaskTemplateInput>}> = (props) => {
          const {data} = props ?? {};

          return  createTaskTemplate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTaskTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof createTaskTemplate>>>
    export type CreateTaskTemplateMutationBody = BodyType<TmTaskTemplateInput>
    export type CreateTaskTemplateMutationError = ErrorType<unknown>

    /**
 * @summary Create a task template
 */
export const useCreateTaskTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTaskTemplate>>, TError,{data: BodyType<TmTaskTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTaskTemplate>>,
        TError,
        {data: BodyType<TmTaskTemplateInput>},
        TContext
      > => {
      return useMutation(getCreateTaskTemplateMutationOptions(options));
    }

export const getGetTaskTemplateUrl = (id: string,) => {




  return `/api/tasks/templates/${id}`
}

export const getTaskTemplate = async (id: string, options?: RequestInit): Promise<TmTaskTemplateDetail> => {

  return customFetch<TmTaskTemplateDetail>(getGetTaskTemplateUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTaskTemplateQueryKey = (id: string,) => {
    return [
    `/api/tasks/templates/${id}`
    ] as const;
    }


export const getGetTaskTemplateQueryOptions = <TData = Awaited<ReturnType<typeof getTaskTemplate>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTaskTemplate>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskTemplateQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskTemplate>>> = ({ signal }) => getTaskTemplate(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskTemplate>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTaskTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskTemplate>>>
export type GetTaskTemplateQueryError = ErrorType<unknown>



export function useGetTaskTemplate<TData = Awaited<ReturnType<typeof getTaskTemplate>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTaskTemplate>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTaskTemplateQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateTaskTemplateUrl = (id: string,) => {




  return `/api/tasks/templates/${id}`
}

export const updateTaskTemplate = async (id: string,
    tmTaskTemplateUpdate: TmTaskTemplateUpdate, options?: RequestInit): Promise<TmTaskTemplateDetail> => {

  return customFetch<TmTaskTemplateDetail>(getUpdateTaskTemplateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tmTaskTemplateUpdate)
  }
);}





export const getUpdateTaskTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTaskTemplate>>, TError,{id: string;data: BodyType<TmTaskTemplateUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTaskTemplate>>, TError,{id: string;data: BodyType<TmTaskTemplateUpdate>}, TContext> => {

const mutationKey = ['updateTaskTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTaskTemplate>>, {id: string;data: BodyType<TmTaskTemplateUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTaskTemplate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTaskTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof updateTaskTemplate>>>
    export type UpdateTaskTemplateMutationBody = BodyType<TmTaskTemplateUpdate>
    export type UpdateTaskTemplateMutationError = ErrorType<unknown>

    export const useUpdateTaskTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTaskTemplate>>, TError,{id: string;data: BodyType<TmTaskTemplateUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTaskTemplate>>,
        TError,
        {id: string;data: BodyType<TmTaskTemplateUpdate>},
        TContext
      > => {
      return useMutation(getUpdateTaskTemplateMutationOptions(options));
    }

export const getDeleteTaskTemplateUrl = (id: string,) => {




  return `/api/tasks/templates/${id}`
}

export const deleteTaskTemplate = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteTaskTemplateUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTaskTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTaskTemplate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTaskTemplate>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteTaskTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTaskTemplate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteTaskTemplate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTaskTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTaskTemplate>>>

    export type DeleteTaskTemplateMutationError = ErrorType<unknown>

    export const useDeleteTaskTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTaskTemplate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTaskTemplate>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteTaskTemplateMutationOptions(options));
    }

export const getInstantiateTaskTemplateUrl = (id: string,) => {




  return `/api/tasks/templates/${id}/instantiate`
}

/**
 * @summary Create a new task from a template
 */
export const instantiateTaskTemplate = async (id: string,
    tmTemplateInstantiateInput?: TmTemplateInstantiateInput, options?: RequestInit): Promise<TmTaskDetail> => {

  return customFetch<TmTaskDetail>(getInstantiateTaskTemplateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tmTemplateInstantiateInput)
  }
);}





export const getInstantiateTaskTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instantiateTaskTemplate>>, TError,{id: string;data?: BodyType<TmTemplateInstantiateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof instantiateTaskTemplate>>, TError,{id: string;data?: BodyType<TmTemplateInstantiateInput>}, TContext> => {

const mutationKey = ['instantiateTaskTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof instantiateTaskTemplate>>, {id: string;data?: BodyType<TmTemplateInstantiateInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  instantiateTaskTemplate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InstantiateTaskTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof instantiateTaskTemplate>>>
    export type InstantiateTaskTemplateMutationBody = BodyType<TmTemplateInstantiateInput> | undefined
    export type InstantiateTaskTemplateMutationError = ErrorType<unknown>

    /**
 * @summary Create a new task from a template
 */
export const useInstantiateTaskTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instantiateTaskTemplate>>, TError,{id: string;data?: BodyType<TmTemplateInstantiateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof instantiateTaskTemplate>>,
        TError,
        {id: string;data?: BodyType<TmTemplateInstantiateInput>},
        TContext
      > => {
      return useMutation(getInstantiateTaskTemplateMutationOptions(options));
    }

export const getAddChecklistItemUrl = (id: string,) => {




  return `/api/tasks/tasks/${id}/checklist`
}

export const addChecklistItem = async (id: string,
    tmChecklistItemInput: TmChecklistItemInput, options?: RequestInit): Promise<TmChecklistItem> => {

  return customFetch<TmChecklistItem>(getAddChecklistItemUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tmChecklistItemInput)
  }
);}





export const getAddChecklistItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addChecklistItem>>, TError,{id: string;data: BodyType<TmChecklistItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addChecklistItem>>, TError,{id: string;data: BodyType<TmChecklistItemInput>}, TContext> => {

const mutationKey = ['addChecklistItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addChecklistItem>>, {id: string;data: BodyType<TmChecklistItemInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  addChecklistItem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddChecklistItemMutationResult = NonNullable<Awaited<ReturnType<typeof addChecklistItem>>>
    export type AddChecklistItemMutationBody = BodyType<TmChecklistItemInput>
    export type AddChecklistItemMutationError = ErrorType<unknown>

    export const useAddChecklistItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addChecklistItem>>, TError,{id: string;data: BodyType<TmChecklistItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addChecklistItem>>,
        TError,
        {id: string;data: BodyType<TmChecklistItemInput>},
        TContext
      > => {
      return useMutation(getAddChecklistItemMutationOptions(options));
    }

export const getUpdateChecklistItemUrl = (itemId: string,) => {




  return `/api/tasks/checklist/${itemId}`
}

export const updateChecklistItem = async (itemId: string,
    tmChecklistItemUpdate: TmChecklistItemUpdate, options?: RequestInit): Promise<TmChecklistItem> => {

  return customFetch<TmChecklistItem>(getUpdateChecklistItemUrl(itemId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tmChecklistItemUpdate)
  }
);}





export const getUpdateChecklistItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChecklistItem>>, TError,{itemId: string;data: BodyType<TmChecklistItemUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateChecklistItem>>, TError,{itemId: string;data: BodyType<TmChecklistItemUpdate>}, TContext> => {

const mutationKey = ['updateChecklistItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateChecklistItem>>, {itemId: string;data: BodyType<TmChecklistItemUpdate>}> = (props) => {
          const {itemId,data} = props ?? {};

          return  updateChecklistItem(itemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateChecklistItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateChecklistItem>>>
    export type UpdateChecklistItemMutationBody = BodyType<TmChecklistItemUpdate>
    export type UpdateChecklistItemMutationError = ErrorType<unknown>

    export const useUpdateChecklistItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChecklistItem>>, TError,{itemId: string;data: BodyType<TmChecklistItemUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateChecklistItem>>,
        TError,
        {itemId: string;data: BodyType<TmChecklistItemUpdate>},
        TContext
      > => {
      return useMutation(getUpdateChecklistItemMutationOptions(options));
    }

export const getDeleteChecklistItemUrl = (itemId: string,) => {




  return `/api/tasks/checklist/${itemId}`
}

export const deleteChecklistItem = async (itemId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteChecklistItemUrl(itemId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteChecklistItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteChecklistItem>>, TError,{itemId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteChecklistItem>>, TError,{itemId: string}, TContext> => {

const mutationKey = ['deleteChecklistItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteChecklistItem>>, {itemId: string}> = (props) => {
          const {itemId} = props ?? {};

          return  deleteChecklistItem(itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteChecklistItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteChecklistItem>>>

    export type DeleteChecklistItemMutationError = ErrorType<unknown>

    export const useDeleteChecklistItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteChecklistItem>>, TError,{itemId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteChecklistItem>>,
        TError,
        {itemId: string},
        TContext
      > => {
      return useMutation(getDeleteChecklistItemMutationOptions(options));
    }

export const getListTaskCommentsUrl = (id: string,) => {




  return `/api/tasks/tasks/${id}/comments`
}

export const listTaskComments = async (id: string, options?: RequestInit): Promise<TmComment[]> => {

  return customFetch<TmComment[]>(getListTaskCommentsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTaskCommentsQueryKey = (id: string,) => {
    return [
    `/api/tasks/tasks/${id}/comments`
    ] as const;
    }


export const getListTaskCommentsQueryOptions = <TData = Awaited<ReturnType<typeof listTaskComments>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTaskComments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTaskCommentsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTaskComments>>> = ({ signal }) => listTaskComments(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTaskComments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTaskCommentsQueryResult = NonNullable<Awaited<ReturnType<typeof listTaskComments>>>
export type ListTaskCommentsQueryError = ErrorType<unknown>



export function useListTaskComments<TData = Awaited<ReturnType<typeof listTaskComments>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTaskComments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTaskCommentsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddTaskCommentUrl = (id: string,) => {




  return `/api/tasks/tasks/${id}/comments`
}

export const addTaskComment = async (id: string,
    tmCommentInput: TmCommentInput, options?: RequestInit): Promise<TmComment> => {

  return customFetch<TmComment>(getAddTaskCommentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tmCommentInput)
  }
);}





export const getAddTaskCommentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addTaskComment>>, TError,{id: string;data: BodyType<TmCommentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addTaskComment>>, TError,{id: string;data: BodyType<TmCommentInput>}, TContext> => {

const mutationKey = ['addTaskComment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addTaskComment>>, {id: string;data: BodyType<TmCommentInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  addTaskComment(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddTaskCommentMutationResult = NonNullable<Awaited<ReturnType<typeof addTaskComment>>>
    export type AddTaskCommentMutationBody = BodyType<TmCommentInput>
    export type AddTaskCommentMutationError = ErrorType<unknown>

    export const useAddTaskComment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addTaskComment>>, TError,{id: string;data: BodyType<TmCommentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addTaskComment>>,
        TError,
        {id: string;data: BodyType<TmCommentInput>},
        TContext
      > => {
      return useMutation(getAddTaskCommentMutationOptions(options));
    }

export const getAddTaskAttachmentUrl = (id: string,) => {




  return `/api/tasks/tasks/${id}/attachments`
}

export const addTaskAttachment = async (id: string,
    tmAttachmentInput: TmAttachmentInput, options?: RequestInit): Promise<TmAttachment> => {

  return customFetch<TmAttachment>(getAddTaskAttachmentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tmAttachmentInput)
  }
);}





export const getAddTaskAttachmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addTaskAttachment>>, TError,{id: string;data: BodyType<TmAttachmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addTaskAttachment>>, TError,{id: string;data: BodyType<TmAttachmentInput>}, TContext> => {

const mutationKey = ['addTaskAttachment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addTaskAttachment>>, {id: string;data: BodyType<TmAttachmentInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  addTaskAttachment(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddTaskAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof addTaskAttachment>>>
    export type AddTaskAttachmentMutationBody = BodyType<TmAttachmentInput>
    export type AddTaskAttachmentMutationError = ErrorType<unknown>

    export const useAddTaskAttachment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addTaskAttachment>>, TError,{id: string;data: BodyType<TmAttachmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addTaskAttachment>>,
        TError,
        {id: string;data: BodyType<TmAttachmentInput>},
        TContext
      > => {
      return useMutation(getAddTaskAttachmentMutationOptions(options));
    }

export const getDeleteTaskAttachmentUrl = (attId: string,) => {




  return `/api/tasks/attachments/${attId}`
}

export const deleteTaskAttachment = async (attId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteTaskAttachmentUrl(attId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTaskAttachmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTaskAttachment>>, TError,{attId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTaskAttachment>>, TError,{attId: string}, TContext> => {

const mutationKey = ['deleteTaskAttachment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTaskAttachment>>, {attId: string}> = (props) => {
          const {attId} = props ?? {};

          return  deleteTaskAttachment(attId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTaskAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTaskAttachment>>>

    export type DeleteTaskAttachmentMutationError = ErrorType<unknown>

    export const useDeleteTaskAttachment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTaskAttachment>>, TError,{attId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTaskAttachment>>,
        TError,
        {attId: string},
        TContext
      > => {
      return useMutation(getDeleteTaskAttachmentMutationOptions(options));
    }

export const getListTaskActivityUrl = (id: string,) => {




  return `/api/tasks/tasks/${id}/activity`
}

export const listTaskActivity = async (id: string, options?: RequestInit): Promise<TmActivityLog[]> => {

  return customFetch<TmActivityLog[]>(getListTaskActivityUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTaskActivityQueryKey = (id: string,) => {
    return [
    `/api/tasks/tasks/${id}/activity`
    ] as const;
    }


export const getListTaskActivityQueryOptions = <TData = Awaited<ReturnType<typeof listTaskActivity>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTaskActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTaskActivityQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTaskActivity>>> = ({ signal }) => listTaskActivity(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTaskActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTaskActivityQueryResult = NonNullable<Awaited<ReturnType<typeof listTaskActivity>>>
export type ListTaskActivityQueryError = ErrorType<unknown>



export function useListTaskActivity<TData = Awaited<ReturnType<typeof listTaskActivity>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTaskActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTaskActivityQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListRemindersUrl = (params?: ListRemindersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tasks/reminders?${stringifiedParams}` : `/api/tasks/reminders`
}

export const listReminders = async (params?: ListRemindersParams, options?: RequestInit): Promise<TmReminder[]> => {

  return customFetch<TmReminder[]>(getListRemindersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRemindersQueryKey = (params?: ListRemindersParams,) => {
    return [
    `/api/tasks/reminders`, ...(params ? [params] : [])
    ] as const;
    }


export const getListRemindersQueryOptions = <TData = Awaited<ReturnType<typeof listReminders>>, TError = ErrorType<unknown>>(params?: ListRemindersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReminders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRemindersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listReminders>>> = ({ signal }) => listReminders(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listReminders>>, TError, TData> & { queryKey: QueryKey }
}

export type ListRemindersQueryResult = NonNullable<Awaited<ReturnType<typeof listReminders>>>
export type ListRemindersQueryError = ErrorType<unknown>



export function useListReminders<TData = Awaited<ReturnType<typeof listReminders>>, TError = ErrorType<unknown>>(
 params?: ListRemindersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReminders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListRemindersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateReminderUrl = () => {




  return `/api/tasks/reminders`
}

export const createReminder = async (tmReminderInput: TmReminderInput, options?: RequestInit): Promise<TmReminder[]> => {

  return customFetch<TmReminder[]>(getCreateReminderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tmReminderInput)
  }
);}





export const getCreateReminderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReminder>>, TError,{data: BodyType<TmReminderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createReminder>>, TError,{data: BodyType<TmReminderInput>}, TContext> => {

const mutationKey = ['createReminder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createReminder>>, {data: BodyType<TmReminderInput>}> = (props) => {
          const {data} = props ?? {};

          return  createReminder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateReminderMutationResult = NonNullable<Awaited<ReturnType<typeof createReminder>>>
    export type CreateReminderMutationBody = BodyType<TmReminderInput>
    export type CreateReminderMutationError = ErrorType<unknown>

    export const useCreateReminder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReminder>>, TError,{data: BodyType<TmReminderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createReminder>>,
        TError,
        {data: BodyType<TmReminderInput>},
        TContext
      > => {
      return useMutation(getCreateReminderMutationOptions(options));
    }

export const getUpdateReminderUrl = (id: string,) => {




  return `/api/tasks/reminders/${id}`
}

export const updateReminder = async (id: string,
    tmReminderUpdate: TmReminderUpdate, options?: RequestInit): Promise<TmReminder> => {

  return customFetch<TmReminder>(getUpdateReminderUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tmReminderUpdate)
  }
);}





export const getUpdateReminderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReminder>>, TError,{id: string;data: BodyType<TmReminderUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateReminder>>, TError,{id: string;data: BodyType<TmReminderUpdate>}, TContext> => {

const mutationKey = ['updateReminder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateReminder>>, {id: string;data: BodyType<TmReminderUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateReminder(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateReminderMutationResult = NonNullable<Awaited<ReturnType<typeof updateReminder>>>
    export type UpdateReminderMutationBody = BodyType<TmReminderUpdate>
    export type UpdateReminderMutationError = ErrorType<unknown>

    export const useUpdateReminder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReminder>>, TError,{id: string;data: BodyType<TmReminderUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateReminder>>,
        TError,
        {id: string;data: BodyType<TmReminderUpdate>},
        TContext
      > => {
      return useMutation(getUpdateReminderMutationOptions(options));
    }

export const getDeleteReminderUrl = (id: string,) => {




  return `/api/tasks/reminders/${id}`
}

export const deleteReminder = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteReminderUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteReminderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteReminder>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteReminder>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteReminder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteReminder>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteReminder(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteReminderMutationResult = NonNullable<Awaited<ReturnType<typeof deleteReminder>>>

    export type DeleteReminderMutationError = ErrorType<unknown>

    export const useDeleteReminder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteReminder>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteReminder>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteReminderMutationOptions(options));
    }

export const getSnoozeReminderUrl = (id: string,) => {




  return `/api/tasks/reminders/${id}/snooze`
}

export const snoozeReminder = async (id: string,
    tmReminderSnoozeInput: TmReminderSnoozeInput, options?: RequestInit): Promise<TmReminder> => {

  return customFetch<TmReminder>(getSnoozeReminderUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tmReminderSnoozeInput)
  }
);}





export const getSnoozeReminderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof snoozeReminder>>, TError,{id: string;data: BodyType<TmReminderSnoozeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof snoozeReminder>>, TError,{id: string;data: BodyType<TmReminderSnoozeInput>}, TContext> => {

const mutationKey = ['snoozeReminder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof snoozeReminder>>, {id: string;data: BodyType<TmReminderSnoozeInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  snoozeReminder(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SnoozeReminderMutationResult = NonNullable<Awaited<ReturnType<typeof snoozeReminder>>>
    export type SnoozeReminderMutationBody = BodyType<TmReminderSnoozeInput>
    export type SnoozeReminderMutationError = ErrorType<unknown>

    export const useSnoozeReminder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof snoozeReminder>>, TError,{id: string;data: BodyType<TmReminderSnoozeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof snoozeReminder>>,
        TError,
        {id: string;data: BodyType<TmReminderSnoozeInput>},
        TContext
      > => {
      return useMutation(getSnoozeReminderMutationOptions(options));
    }

export const getMarkReminderDoneUrl = (id: string,) => {




  return `/api/tasks/reminders/${id}/done`
}

export const markReminderDone = async (id: string, options?: RequestInit): Promise<TmReminder> => {

  return customFetch<TmReminder>(getMarkReminderDoneUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMarkReminderDoneMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markReminderDone>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markReminderDone>>, TError,{id: string}, TContext> => {

const mutationKey = ['markReminderDone'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markReminderDone>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  markReminderDone(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkReminderDoneMutationResult = NonNullable<Awaited<ReturnType<typeof markReminderDone>>>

    export type MarkReminderDoneMutationError = ErrorType<unknown>

    export const useMarkReminderDone = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markReminderDone>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markReminderDone>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getMarkReminderDoneMutationOptions(options));
    }

export const getDismissReminderUrl = (id: string,) => {




  return `/api/tasks/reminders/${id}/dismiss`
}

export const dismissReminder = async (id: string, options?: RequestInit): Promise<TmReminder> => {

  return customFetch<TmReminder>(getDismissReminderUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDismissReminderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissReminder>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dismissReminder>>, TError,{id: string}, TContext> => {

const mutationKey = ['dismissReminder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dismissReminder>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  dismissReminder(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DismissReminderMutationResult = NonNullable<Awaited<ReturnType<typeof dismissReminder>>>

    export type DismissReminderMutationError = ErrorType<unknown>

    export const useDismissReminder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissReminder>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof dismissReminder>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDismissReminderMutationOptions(options));
    }

export const getListProjectsUrl = (params?: ListProjectsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tasks/projects?${stringifiedParams}` : `/api/tasks/projects`
}

export const listProjects = async (params?: ListProjectsParams, options?: RequestInit): Promise<TmProjectDetail[]> => {

  return customFetch<TmProjectDetail[]>(getListProjectsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProjectsQueryKey = (params?: ListProjectsParams,) => {
    return [
    `/api/tasks/projects`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProjectsQueryOptions = <TData = Awaited<ReturnType<typeof listProjects>>, TError = ErrorType<unknown>>(params?: ListProjectsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjects>>> = ({ signal }) => listProjects(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData> & { queryKey: QueryKey }
}

export type ListProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof listProjects>>>
export type ListProjectsQueryError = ErrorType<unknown>



export function useListProjects<TData = Awaited<ReturnType<typeof listProjects>>, TError = ErrorType<unknown>>(
 params?: ListProjectsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListProjectsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateProjectUrl = () => {




  return `/api/tasks/projects`
}

export const createProject = async (tmProjectInput: TmProjectInput, options?: RequestInit): Promise<TmProjectDetail> => {

  return customFetch<TmProjectDetail>(getCreateProjectUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tmProjectInput)
  }
);}





export const getCreateProjectMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,{data: BodyType<TmProjectInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,{data: BodyType<TmProjectInput>}, TContext> => {

const mutationKey = ['createProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProject>>, {data: BodyType<TmProjectInput>}> = (props) => {
          const {data} = props ?? {};

          return  createProject(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof createProject>>>
    export type CreateProjectMutationBody = BodyType<TmProjectInput>
    export type CreateProjectMutationError = ErrorType<unknown>

    export const useCreateProject = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,{data: BodyType<TmProjectInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createProject>>,
        TError,
        {data: BodyType<TmProjectInput>},
        TContext
      > => {
      return useMutation(getCreateProjectMutationOptions(options));
    }

export const getGetProjectUrl = (id: string,) => {




  return `/api/tasks/projects/${id}`
}

export const getProject = async (id: string, options?: RequestInit): Promise<TmProjectDetail> => {

  return customFetch<TmProjectDetail>(getGetProjectUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProjectQueryKey = (id: string,) => {
    return [
    `/api/tasks/projects/${id}`
    ] as const;
    }


export const getGetProjectQueryOptions = <TData = Awaited<ReturnType<typeof getProject>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProject>>> = ({ signal }) => getProject(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProjectQueryResult = NonNullable<Awaited<ReturnType<typeof getProject>>>
export type GetProjectQueryError = ErrorType<unknown>



export function useGetProject<TData = Awaited<ReturnType<typeof getProject>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProjectQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateProjectUrl = (id: string,) => {




  return `/api/tasks/projects/${id}`
}

export const updateProject = async (id: string,
    tmProjectUpdate: TmProjectUpdate, options?: RequestInit): Promise<TmProjectDetail> => {

  return customFetch<TmProjectDetail>(getUpdateProjectUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tmProjectUpdate)
  }
);}





export const getUpdateProjectMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,{id: string;data: BodyType<TmProjectUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,{id: string;data: BodyType<TmProjectUpdate>}, TContext> => {

const mutationKey = ['updateProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProject>>, {id: string;data: BodyType<TmProjectUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateProject(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof updateProject>>>
    export type UpdateProjectMutationBody = BodyType<TmProjectUpdate>
    export type UpdateProjectMutationError = ErrorType<unknown>

    export const useUpdateProject = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,{id: string;data: BodyType<TmProjectUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateProject>>,
        TError,
        {id: string;data: BodyType<TmProjectUpdate>},
        TContext
      > => {
      return useMutation(getUpdateProjectMutationOptions(options));
    }

export const getDeleteProjectUrl = (id: string,) => {




  return `/api/tasks/projects/${id}`
}

export const deleteProject = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteProjectUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteProjectMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProject>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteProject(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProject>>>

    export type DeleteProjectMutationError = ErrorType<unknown>

    export const useDeleteProject = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteProject>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteProjectMutationOptions(options));
    }

export const getListProjectTasksUrl = (id: string,) => {




  return `/api/tasks/projects/${id}/tasks`
}

export const listProjectTasks = async (id: string, options?: RequestInit): Promise<TmTaskDetail[]> => {

  return customFetch<TmTaskDetail[]>(getListProjectTasksUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProjectTasksQueryKey = (id: string,) => {
    return [
    `/api/tasks/projects/${id}/tasks`
    ] as const;
    }


export const getListProjectTasksQueryOptions = <TData = Awaited<ReturnType<typeof listProjectTasks>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProjectTasks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectTasksQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectTasks>>> = ({ signal }) => listProjectTasks(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjectTasks>>, TError, TData> & { queryKey: QueryKey }
}

export type ListProjectTasksQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectTasks>>>
export type ListProjectTasksQueryError = ErrorType<unknown>



export function useListProjectTasks<TData = Awaited<ReturnType<typeof listProjectTasks>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProjectTasks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListProjectTasksQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListProjectCommentsUrl = (id: string,) => {




  return `/api/tasks/projects/${id}/comments`
}

export const listProjectComments = async (id: string, options?: RequestInit): Promise<TmComment[]> => {

  return customFetch<TmComment[]>(getListProjectCommentsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProjectCommentsQueryKey = (id: string,) => {
    return [
    `/api/tasks/projects/${id}/comments`
    ] as const;
    }


export const getListProjectCommentsQueryOptions = <TData = Awaited<ReturnType<typeof listProjectComments>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProjectComments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectCommentsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectComments>>> = ({ signal }) => listProjectComments(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjectComments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListProjectCommentsQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectComments>>>
export type ListProjectCommentsQueryError = ErrorType<unknown>



export function useListProjectComments<TData = Awaited<ReturnType<typeof listProjectComments>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProjectComments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListProjectCommentsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddProjectCommentUrl = (id: string,) => {




  return `/api/tasks/projects/${id}/comments`
}

export const addProjectComment = async (id: string,
    tmCommentInput: TmCommentInput, options?: RequestInit): Promise<TmComment> => {

  return customFetch<TmComment>(getAddProjectCommentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tmCommentInput)
  }
);}





export const getAddProjectCommentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addProjectComment>>, TError,{id: string;data: BodyType<TmCommentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addProjectComment>>, TError,{id: string;data: BodyType<TmCommentInput>}, TContext> => {

const mutationKey = ['addProjectComment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addProjectComment>>, {id: string;data: BodyType<TmCommentInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  addProjectComment(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddProjectCommentMutationResult = NonNullable<Awaited<ReturnType<typeof addProjectComment>>>
    export type AddProjectCommentMutationBody = BodyType<TmCommentInput>
    export type AddProjectCommentMutationError = ErrorType<unknown>

    export const useAddProjectComment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addProjectComment>>, TError,{id: string;data: BodyType<TmCommentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addProjectComment>>,
        TError,
        {id: string;data: BodyType<TmCommentInput>},
        TContext
      > => {
      return useMutation(getAddProjectCommentMutationOptions(options));
    }

export const getListProjectActivityUrl = (id: string,) => {




  return `/api/tasks/projects/${id}/activity`
}

export const listProjectActivity = async (id: string, options?: RequestInit): Promise<TmActivityLog[]> => {

  return customFetch<TmActivityLog[]>(getListProjectActivityUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProjectActivityQueryKey = (id: string,) => {
    return [
    `/api/tasks/projects/${id}/activity`
    ] as const;
    }


export const getListProjectActivityQueryOptions = <TData = Awaited<ReturnType<typeof listProjectActivity>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProjectActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectActivityQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectActivity>>> = ({ signal }) => listProjectActivity(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjectActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type ListProjectActivityQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectActivity>>>
export type ListProjectActivityQueryError = ErrorType<unknown>



export function useListProjectActivity<TData = Awaited<ReturnType<typeof listProjectActivity>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProjectActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListProjectActivityQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddProjectMemberUrl = (id: string,) => {




  return `/api/tasks/projects/${id}/members`
}

export const addProjectMember = async (id: string,
    tmProjectMemberInput: TmProjectMemberInput, options?: RequestInit): Promise<TmProjectMember> => {

  return customFetch<TmProjectMember>(getAddProjectMemberUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tmProjectMemberInput)
  }
);}





export const getAddProjectMemberMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addProjectMember>>, TError,{id: string;data: BodyType<TmProjectMemberInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addProjectMember>>, TError,{id: string;data: BodyType<TmProjectMemberInput>}, TContext> => {

const mutationKey = ['addProjectMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addProjectMember>>, {id: string;data: BodyType<TmProjectMemberInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  addProjectMember(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddProjectMemberMutationResult = NonNullable<Awaited<ReturnType<typeof addProjectMember>>>
    export type AddProjectMemberMutationBody = BodyType<TmProjectMemberInput>
    export type AddProjectMemberMutationError = ErrorType<unknown>

    export const useAddProjectMember = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addProjectMember>>, TError,{id: string;data: BodyType<TmProjectMemberInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addProjectMember>>,
        TError,
        {id: string;data: BodyType<TmProjectMemberInput>},
        TContext
      > => {
      return useMutation(getAddProjectMemberMutationOptions(options));
    }

export const getRemoveProjectMemberUrl = (id: string,
    userId: string,) => {




  return `/api/tasks/projects/${id}/members/${userId}`
}

export const removeProjectMember = async (id: string,
    userId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getRemoveProjectMemberUrl(id,userId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveProjectMemberMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeProjectMember>>, TError,{id: string;userId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeProjectMember>>, TError,{id: string;userId: string}, TContext> => {

const mutationKey = ['removeProjectMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeProjectMember>>, {id: string;userId: string}> = (props) => {
          const {id,userId} = props ?? {};

          return  removeProjectMember(id,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveProjectMemberMutationResult = NonNullable<Awaited<ReturnType<typeof removeProjectMember>>>

    export type RemoveProjectMemberMutationError = ErrorType<unknown>

    export const useRemoveProjectMember = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeProjectMember>>, TError,{id: string;userId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeProjectMember>>,
        TError,
        {id: string;userId: string},
        TContext
      > => {
      return useMutation(getRemoveProjectMemberMutationOptions(options));
    }

export const getListAssignableUsersUrl = () => {




  return `/api/tasks/assignable-users`
}

/**
 * @summary Active-tenant members assignable to tasks/projects
 */
export const listAssignableUsers = async ( options?: RequestInit): Promise<TmAssignableUser[]> => {

  return customFetch<TmAssignableUser[]>(getListAssignableUsersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAssignableUsersQueryKey = () => {
    return [
    `/api/tasks/assignable-users`
    ] as const;
    }


export const getListAssignableUsersQueryOptions = <TData = Awaited<ReturnType<typeof listAssignableUsers>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAssignableUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAssignableUsersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAssignableUsers>>> = ({ signal }) => listAssignableUsers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAssignableUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAssignableUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listAssignableUsers>>>
export type ListAssignableUsersQueryError = ErrorType<unknown>


/**
 * @summary Active-tenant members assignable to tasks/projects
 */

export function useListAssignableUsers<TData = Awaited<ReturnType<typeof listAssignableUsers>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAssignableUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAssignableUsersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetTaskPreferencesUrl = () => {




  return `/api/tasks/preferences`
}

export const getTaskPreferences = async ( options?: RequestInit): Promise<TmPreferences> => {

  return customFetch<TmPreferences>(getGetTaskPreferencesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTaskPreferencesQueryKey = () => {
    return [
    `/api/tasks/preferences`
    ] as const;
    }


export const getGetTaskPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof getTaskPreferences>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTaskPreferences>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskPreferencesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskPreferences>>> = ({ signal }) => getTaskPreferences({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskPreferences>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTaskPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskPreferences>>>
export type GetTaskPreferencesQueryError = ErrorType<unknown>



export function useGetTaskPreferences<TData = Awaited<ReturnType<typeof getTaskPreferences>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTaskPreferences>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTaskPreferencesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateTaskPreferencesUrl = () => {




  return `/api/tasks/preferences`
}

export const updateTaskPreferences = async (tmPreferencesUpdate: TmPreferencesUpdate, options?: RequestInit): Promise<TmPreferences> => {

  return customFetch<TmPreferences>(getUpdateTaskPreferencesUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tmPreferencesUpdate)
  }
);}





export const getUpdateTaskPreferencesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTaskPreferences>>, TError,{data: BodyType<TmPreferencesUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTaskPreferences>>, TError,{data: BodyType<TmPreferencesUpdate>}, TContext> => {

const mutationKey = ['updateTaskPreferences'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTaskPreferences>>, {data: BodyType<TmPreferencesUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateTaskPreferences(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTaskPreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof updateTaskPreferences>>>
    export type UpdateTaskPreferencesMutationBody = BodyType<TmPreferencesUpdate>
    export type UpdateTaskPreferencesMutationError = ErrorType<unknown>

    export const useUpdateTaskPreferences = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTaskPreferences>>, TError,{data: BodyType<TmPreferencesUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTaskPreferences>>,
        TError,
        {data: BodyType<TmPreferencesUpdate>},
        TContext
      > => {
      return useMutation(getUpdateTaskPreferencesMutationOptions(options));
    }

export const getRegenerateCalendarTokenUrl = () => {




  return `/api/tasks/preferences/regenerate-calendar-token`
}

export const regenerateCalendarToken = async ( options?: RequestInit): Promise<TmPreferences> => {

  return customFetch<TmPreferences>(getRegenerateCalendarTokenUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRegenerateCalendarTokenMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateCalendarToken>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof regenerateCalendarToken>>, TError,void, TContext> => {

const mutationKey = ['regenerateCalendarToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateCalendarToken>>, void> = () => {


          return  regenerateCalendarToken(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegenerateCalendarTokenMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateCalendarToken>>>

    export type RegenerateCalendarTokenMutationError = ErrorType<unknown>

    export const useRegenerateCalendarToken = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateCalendarToken>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof regenerateCalendarToken>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRegenerateCalendarTokenMutationOptions(options));
    }

export const getGetTaskDashboardSummaryUrl = () => {




  return `/api/tasks/dashboard-summary`
}

export const getTaskDashboardSummary = async ( options?: RequestInit): Promise<TmDashboardSummary> => {

  return customFetch<TmDashboardSummary>(getGetTaskDashboardSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTaskDashboardSummaryQueryKey = () => {
    return [
    `/api/tasks/dashboard-summary`
    ] as const;
    }


export const getGetTaskDashboardSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getTaskDashboardSummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTaskDashboardSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskDashboardSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskDashboardSummary>>> = ({ signal }) => getTaskDashboardSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskDashboardSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTaskDashboardSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskDashboardSummary>>>
export type GetTaskDashboardSummaryQueryError = ErrorType<unknown>



export function useGetTaskDashboardSummary<TData = Awaited<ReturnType<typeof getTaskDashboardSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTaskDashboardSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTaskDashboardSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCalendarEventsUrl = (params?: ListCalendarEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tasks/calendar-events?${stringifiedParams}` : `/api/tasks/calendar-events`
}

export const listCalendarEvents = async (params?: ListCalendarEventsParams, options?: RequestInit): Promise<TmCalendarEvent[]> => {

  return customFetch<TmCalendarEvent[]>(getListCalendarEventsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCalendarEventsQueryKey = (params?: ListCalendarEventsParams,) => {
    return [
    `/api/tasks/calendar-events`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCalendarEventsQueryOptions = <TData = Awaited<ReturnType<typeof listCalendarEvents>>, TError = ErrorType<unknown>>(params?: ListCalendarEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCalendarEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCalendarEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCalendarEvents>>> = ({ signal }) => listCalendarEvents(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCalendarEvents>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCalendarEventsQueryResult = NonNullable<Awaited<ReturnType<typeof listCalendarEvents>>>
export type ListCalendarEventsQueryError = ErrorType<unknown>



export function useListCalendarEvents<TData = Awaited<ReturnType<typeof listCalendarEvents>>, TError = ErrorType<unknown>>(
 params?: ListCalendarEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCalendarEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCalendarEventsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListScrapPurchasesUrl = () => {




  return `/api/scrap/purchases`
}

/**
 * @summary List scrap purchases
 */
export const listScrapPurchases = async ( options?: RequestInit): Promise<ScrapPurchaseSummary[]> => {

  return customFetch<ScrapPurchaseSummary[]>(getListScrapPurchasesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListScrapPurchasesQueryKey = () => {
    return [
    `/api/scrap/purchases`
    ] as const;
    }


export const getListScrapPurchasesQueryOptions = <TData = Awaited<ReturnType<typeof listScrapPurchases>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listScrapPurchases>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListScrapPurchasesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listScrapPurchases>>> = ({ signal }) => listScrapPurchases({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listScrapPurchases>>, TError, TData> & { queryKey: QueryKey }
}

export type ListScrapPurchasesQueryResult = NonNullable<Awaited<ReturnType<typeof listScrapPurchases>>>
export type ListScrapPurchasesQueryError = ErrorType<unknown>


/**
 * @summary List scrap purchases
 */

export function useListScrapPurchases<TData = Awaited<ReturnType<typeof listScrapPurchases>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listScrapPurchases>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListScrapPurchasesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateScrapPurchaseUrl = () => {




  return `/api/scrap/purchases`
}

/**
 * @summary Record a new scrap purchase
 */
export const createScrapPurchase = async (scrapPurchaseInput: ScrapPurchaseInput, options?: RequestInit): Promise<ScrapPurchaseDetail> => {

  return customFetch<ScrapPurchaseDetail>(getCreateScrapPurchaseUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scrapPurchaseInput)
  }
);}





export const getCreateScrapPurchaseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createScrapPurchase>>, TError,{data: BodyType<ScrapPurchaseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createScrapPurchase>>, TError,{data: BodyType<ScrapPurchaseInput>}, TContext> => {

const mutationKey = ['createScrapPurchase'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createScrapPurchase>>, {data: BodyType<ScrapPurchaseInput>}> = (props) => {
          const {data} = props ?? {};

          return  createScrapPurchase(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateScrapPurchaseMutationResult = NonNullable<Awaited<ReturnType<typeof createScrapPurchase>>>
    export type CreateScrapPurchaseMutationBody = BodyType<ScrapPurchaseInput>
    export type CreateScrapPurchaseMutationError = ErrorType<unknown>

    /**
 * @summary Record a new scrap purchase
 */
export const useCreateScrapPurchase = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createScrapPurchase>>, TError,{data: BodyType<ScrapPurchaseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createScrapPurchase>>,
        TError,
        {data: BodyType<ScrapPurchaseInput>},
        TContext
      > => {
      return useMutation(getCreateScrapPurchaseMutationOptions(options));
    }

export const getGetScrapPurchaseUrl = (id: string,) => {




  return `/api/scrap/purchases/${id}`
}

export const getScrapPurchase = async (id: string, options?: RequestInit): Promise<ScrapPurchaseDetail> => {

  return customFetch<ScrapPurchaseDetail>(getGetScrapPurchaseUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetScrapPurchaseQueryKey = (id: string,) => {
    return [
    `/api/scrap/purchases/${id}`
    ] as const;
    }


export const getGetScrapPurchaseQueryOptions = <TData = Awaited<ReturnType<typeof getScrapPurchase>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getScrapPurchase>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScrapPurchaseQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScrapPurchase>>> = ({ signal }) => getScrapPurchase(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getScrapPurchase>>, TError, TData> & { queryKey: QueryKey }
}

export type GetScrapPurchaseQueryResult = NonNullable<Awaited<ReturnType<typeof getScrapPurchase>>>
export type GetScrapPurchaseQueryError = ErrorType<unknown>



export function useGetScrapPurchase<TData = Awaited<ReturnType<typeof getScrapPurchase>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getScrapPurchase>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetScrapPurchaseQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateScrapPurchaseUrl = (id: string,) => {




  return `/api/scrap/purchases/${id}`
}

export const updateScrapPurchase = async (id: string,
    scrapPurchaseUpdate: ScrapPurchaseUpdate, options?: RequestInit): Promise<ScrapPurchaseDetail> => {

  return customFetch<ScrapPurchaseDetail>(getUpdateScrapPurchaseUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scrapPurchaseUpdate)
  }
);}





export const getUpdateScrapPurchaseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateScrapPurchase>>, TError,{id: string;data: BodyType<ScrapPurchaseUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateScrapPurchase>>, TError,{id: string;data: BodyType<ScrapPurchaseUpdate>}, TContext> => {

const mutationKey = ['updateScrapPurchase'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateScrapPurchase>>, {id: string;data: BodyType<ScrapPurchaseUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateScrapPurchase(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateScrapPurchaseMutationResult = NonNullable<Awaited<ReturnType<typeof updateScrapPurchase>>>
    export type UpdateScrapPurchaseMutationBody = BodyType<ScrapPurchaseUpdate>
    export type UpdateScrapPurchaseMutationError = ErrorType<unknown>

    export const useUpdateScrapPurchase = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateScrapPurchase>>, TError,{id: string;data: BodyType<ScrapPurchaseUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateScrapPurchase>>,
        TError,
        {id: string;data: BodyType<ScrapPurchaseUpdate>},
        TContext
      > => {
      return useMutation(getUpdateScrapPurchaseMutationOptions(options));
    }

export const getDeleteScrapPurchaseUrl = (id: string,) => {




  return `/api/scrap/purchases/${id}`
}

export const deleteScrapPurchase = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteScrapPurchaseUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteScrapPurchaseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteScrapPurchase>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteScrapPurchase>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteScrapPurchase'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteScrapPurchase>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteScrapPurchase(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteScrapPurchaseMutationResult = NonNullable<Awaited<ReturnType<typeof deleteScrapPurchase>>>

    export type DeleteScrapPurchaseMutationError = ErrorType<unknown>

    export const useDeleteScrapPurchase = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteScrapPurchase>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteScrapPurchase>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteScrapPurchaseMutationOptions(options));
    }

export const getListScrapInventoryUrl = (params?: ListScrapInventoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/scrap/inventory?${stringifiedParams}` : `/api/scrap/inventory`
}

/**
 * @summary List scrap inventory lots
 */
export const listScrapInventory = async (params?: ListScrapInventoryParams, options?: RequestInit): Promise<ScrapInventoryItemView[]> => {

  return customFetch<ScrapInventoryItemView[]>(getListScrapInventoryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListScrapInventoryQueryKey = (params?: ListScrapInventoryParams,) => {
    return [
    `/api/scrap/inventory`, ...(params ? [params] : [])
    ] as const;
    }


export const getListScrapInventoryQueryOptions = <TData = Awaited<ReturnType<typeof listScrapInventory>>, TError = ErrorType<unknown>>(params?: ListScrapInventoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listScrapInventory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListScrapInventoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listScrapInventory>>> = ({ signal }) => listScrapInventory(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listScrapInventory>>, TError, TData> & { queryKey: QueryKey }
}

export type ListScrapInventoryQueryResult = NonNullable<Awaited<ReturnType<typeof listScrapInventory>>>
export type ListScrapInventoryQueryError = ErrorType<unknown>


/**
 * @summary List scrap inventory lots
 */

export function useListScrapInventory<TData = Awaited<ReturnType<typeof listScrapInventory>>, TError = ErrorType<unknown>>(
 params?: ListScrapInventoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listScrapInventory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListScrapInventoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateScrapInventoryItemUrl = (id: string,) => {




  return `/api/scrap/inventory/${id}`
}

export const updateScrapInventoryItem = async (id: string,
    scrapInventoryItemUpdate: ScrapInventoryItemUpdate, options?: RequestInit): Promise<ScrapInventoryItemView> => {

  return customFetch<ScrapInventoryItemView>(getUpdateScrapInventoryItemUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scrapInventoryItemUpdate)
  }
);}





export const getUpdateScrapInventoryItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateScrapInventoryItem>>, TError,{id: string;data: BodyType<ScrapInventoryItemUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateScrapInventoryItem>>, TError,{id: string;data: BodyType<ScrapInventoryItemUpdate>}, TContext> => {

const mutationKey = ['updateScrapInventoryItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateScrapInventoryItem>>, {id: string;data: BodyType<ScrapInventoryItemUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateScrapInventoryItem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateScrapInventoryItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateScrapInventoryItem>>>
    export type UpdateScrapInventoryItemMutationBody = BodyType<ScrapInventoryItemUpdate>
    export type UpdateScrapInventoryItemMutationError = ErrorType<unknown>

    export const useUpdateScrapInventoryItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateScrapInventoryItem>>, TError,{id: string;data: BodyType<ScrapInventoryItemUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateScrapInventoryItem>>,
        TError,
        {id: string;data: BodyType<ScrapInventoryItemUpdate>},
        TContext
      > => {
      return useMutation(getUpdateScrapInventoryItemMutationOptions(options));
    }

export const getListRefiningBatchesUrl = () => {




  return `/api/scrap/refining-batches`
}

/**
 * @summary List refining batches
 */
export const listRefiningBatches = async ( options?: RequestInit): Promise<RefiningBatchSummary[]> => {

  return customFetch<RefiningBatchSummary[]>(getListRefiningBatchesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRefiningBatchesQueryKey = () => {
    return [
    `/api/scrap/refining-batches`
    ] as const;
    }


export const getListRefiningBatchesQueryOptions = <TData = Awaited<ReturnType<typeof listRefiningBatches>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRefiningBatches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRefiningBatchesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRefiningBatches>>> = ({ signal }) => listRefiningBatches({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRefiningBatches>>, TError, TData> & { queryKey: QueryKey }
}

export type ListRefiningBatchesQueryResult = NonNullable<Awaited<ReturnType<typeof listRefiningBatches>>>
export type ListRefiningBatchesQueryError = ErrorType<unknown>


/**
 * @summary List refining batches
 */

export function useListRefiningBatches<TData = Awaited<ReturnType<typeof listRefiningBatches>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRefiningBatches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListRefiningBatchesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateRefiningBatchUrl = () => {




  return `/api/scrap/refining-batches`
}

/**
 * @summary Create a refining batch from N scrap lots
 */
export const createRefiningBatch = async (refiningBatchInput: RefiningBatchInput, options?: RequestInit): Promise<RefiningBatchDetail> => {

  return customFetch<RefiningBatchDetail>(getCreateRefiningBatchUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(refiningBatchInput)
  }
);}





export const getCreateRefiningBatchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRefiningBatch>>, TError,{data: BodyType<RefiningBatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRefiningBatch>>, TError,{data: BodyType<RefiningBatchInput>}, TContext> => {

const mutationKey = ['createRefiningBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRefiningBatch>>, {data: BodyType<RefiningBatchInput>}> = (props) => {
          const {data} = props ?? {};

          return  createRefiningBatch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRefiningBatchMutationResult = NonNullable<Awaited<ReturnType<typeof createRefiningBatch>>>
    export type CreateRefiningBatchMutationBody = BodyType<RefiningBatchInput>
    export type CreateRefiningBatchMutationError = ErrorType<unknown>

    /**
 * @summary Create a refining batch from N scrap lots
 */
export const useCreateRefiningBatch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRefiningBatch>>, TError,{data: BodyType<RefiningBatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createRefiningBatch>>,
        TError,
        {data: BodyType<RefiningBatchInput>},
        TContext
      > => {
      return useMutation(getCreateRefiningBatchMutationOptions(options));
    }

export const getGetRefiningMetalRollupUrl = () => {




  return `/api/scrap/refining-batches/metal-rollup`
}

/**
 * @summary Per-metal P&L rollup across all finalised refining batches
 */
export const getRefiningMetalRollup = async ( options?: RequestInit): Promise<RefiningMetalRollup[]> => {

  return customFetch<RefiningMetalRollup[]>(getGetRefiningMetalRollupUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRefiningMetalRollupQueryKey = () => {
    return [
    `/api/scrap/refining-batches/metal-rollup`
    ] as const;
    }


export const getGetRefiningMetalRollupQueryOptions = <TData = Awaited<ReturnType<typeof getRefiningMetalRollup>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRefiningMetalRollup>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRefiningMetalRollupQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRefiningMetalRollup>>> = ({ signal }) => getRefiningMetalRollup({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRefiningMetalRollup>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRefiningMetalRollupQueryResult = NonNullable<Awaited<ReturnType<typeof getRefiningMetalRollup>>>
export type GetRefiningMetalRollupQueryError = ErrorType<unknown>


/**
 * @summary Per-metal P&L rollup across all finalised refining batches
 */

export function useGetRefiningMetalRollup<TData = Awaited<ReturnType<typeof getRefiningMetalRollup>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRefiningMetalRollup>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRefiningMetalRollupQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetRefiningBatchUrl = (id: string,) => {




  return `/api/scrap/refining-batches/${id}`
}

export const getRefiningBatch = async (id: string, options?: RequestInit): Promise<RefiningBatchDetail> => {

  return customFetch<RefiningBatchDetail>(getGetRefiningBatchUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRefiningBatchQueryKey = (id: string,) => {
    return [
    `/api/scrap/refining-batches/${id}`
    ] as const;
    }


export const getGetRefiningBatchQueryOptions = <TData = Awaited<ReturnType<typeof getRefiningBatch>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRefiningBatch>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRefiningBatchQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRefiningBatch>>> = ({ signal }) => getRefiningBatch(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRefiningBatch>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRefiningBatchQueryResult = NonNullable<Awaited<ReturnType<typeof getRefiningBatch>>>
export type GetRefiningBatchQueryError = ErrorType<unknown>



export function useGetRefiningBatch<TData = Awaited<ReturnType<typeof getRefiningBatch>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRefiningBatch>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRefiningBatchQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateRefiningBatchUrl = (id: string,) => {




  return `/api/scrap/refining-batches/${id}`
}

export const updateRefiningBatch = async (id: string,
    refiningBatchUpdate: RefiningBatchUpdate, options?: RequestInit): Promise<RefiningBatchDetail> => {

  return customFetch<RefiningBatchDetail>(getUpdateRefiningBatchUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(refiningBatchUpdate)
  }
);}





export const getUpdateRefiningBatchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRefiningBatch>>, TError,{id: string;data: BodyType<RefiningBatchUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRefiningBatch>>, TError,{id: string;data: BodyType<RefiningBatchUpdate>}, TContext> => {

const mutationKey = ['updateRefiningBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRefiningBatch>>, {id: string;data: BodyType<RefiningBatchUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateRefiningBatch(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRefiningBatchMutationResult = NonNullable<Awaited<ReturnType<typeof updateRefiningBatch>>>
    export type UpdateRefiningBatchMutationBody = BodyType<RefiningBatchUpdate>
    export type UpdateRefiningBatchMutationError = ErrorType<unknown>

    export const useUpdateRefiningBatch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRefiningBatch>>, TError,{id: string;data: BodyType<RefiningBatchUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateRefiningBatch>>,
        TError,
        {id: string;data: BodyType<RefiningBatchUpdate>},
        TContext
      > => {
      return useMutation(getUpdateRefiningBatchMutationOptions(options));
    }

export const getFinaliseRefiningBatchUrl = (id: string,) => {




  return `/api/scrap/refining-batches/${id}/finalise`
}

/**
 * @summary Record refining results and finalise the batch
 */
export const finaliseRefiningBatch = async (id: string,
    refiningBatchFinaliseInput: RefiningBatchFinaliseInput, options?: RequestInit): Promise<RefiningBatchDetail> => {

  return customFetch<RefiningBatchDetail>(getFinaliseRefiningBatchUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(refiningBatchFinaliseInput)
  }
);}





export const getFinaliseRefiningBatchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finaliseRefiningBatch>>, TError,{id: string;data: BodyType<RefiningBatchFinaliseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof finaliseRefiningBatch>>, TError,{id: string;data: BodyType<RefiningBatchFinaliseInput>}, TContext> => {

const mutationKey = ['finaliseRefiningBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finaliseRefiningBatch>>, {id: string;data: BodyType<RefiningBatchFinaliseInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  finaliseRefiningBatch(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FinaliseRefiningBatchMutationResult = NonNullable<Awaited<ReturnType<typeof finaliseRefiningBatch>>>
    export type FinaliseRefiningBatchMutationBody = BodyType<RefiningBatchFinaliseInput>
    export type FinaliseRefiningBatchMutationError = ErrorType<unknown>

    /**
 * @summary Record refining results and finalise the batch
 */
export const useFinaliseRefiningBatch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finaliseRefiningBatch>>, TError,{id: string;data: BodyType<RefiningBatchFinaliseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof finaliseRefiningBatch>>,
        TError,
        {id: string;data: BodyType<RefiningBatchFinaliseInput>},
        TContext
      > => {
      return useMutation(getFinaliseRefiningBatchMutationOptions(options));
    }

export const getReceiveRefiningBatchUrl = (id: string,) => {




  return `/api/scrap/refining-batches/${id}/receive`
}

/**
 * @summary Mark a batch as received with a lump-sum payout from the refiner
 */
export const receiveRefiningBatch = async (id: string,
    receiveRefiningBatchInput: ReceiveRefiningBatchInput, options?: RequestInit): Promise<RefiningBatchDetail> => {

  return customFetch<RefiningBatchDetail>(getReceiveRefiningBatchUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(receiveRefiningBatchInput)
  }
);}





export const getReceiveRefiningBatchMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receiveRefiningBatch>>, TError,{id: string;data: BodyType<ReceiveRefiningBatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof receiveRefiningBatch>>, TError,{id: string;data: BodyType<ReceiveRefiningBatchInput>}, TContext> => {

const mutationKey = ['receiveRefiningBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof receiveRefiningBatch>>, {id: string;data: BodyType<ReceiveRefiningBatchInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  receiveRefiningBatch(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReceiveRefiningBatchMutationResult = NonNullable<Awaited<ReturnType<typeof receiveRefiningBatch>>>
    export type ReceiveRefiningBatchMutationBody = BodyType<ReceiveRefiningBatchInput>
    export type ReceiveRefiningBatchMutationError = ErrorType<void>

    /**
 * @summary Mark a batch as received with a lump-sum payout from the refiner
 */
export const useReceiveRefiningBatch = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receiveRefiningBatch>>, TError,{id: string;data: BodyType<ReceiveRefiningBatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof receiveRefiningBatch>>,
        TError,
        {id: string;data: BodyType<ReceiveRefiningBatchInput>},
        TContext
      > => {
      return useMutation(getReceiveRefiningBatchMutationOptions(options));
    }

export const getConvertScrapLotUrl = (id: string,) => {




  return `/api/scrap/inventory/${id}/convert`
}

/**
 * @summary Convert a REFINED scrap lot into a sellable inventory item
 */
export const convertScrapLot = async (id: string,
    convertScrapLotInput: ConvertScrapLotInput, options?: RequestInit): Promise<ConvertScrapLotResult> => {

  return customFetch<ConvertScrapLotResult>(getConvertScrapLotUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(convertScrapLotInput)
  }
);}





export const getConvertScrapLotMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof convertScrapLot>>, TError,{id: string;data: BodyType<ConvertScrapLotInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof convertScrapLot>>, TError,{id: string;data: BodyType<ConvertScrapLotInput>}, TContext> => {

const mutationKey = ['convertScrapLot'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof convertScrapLot>>, {id: string;data: BodyType<ConvertScrapLotInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  convertScrapLot(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConvertScrapLotMutationResult = NonNullable<Awaited<ReturnType<typeof convertScrapLot>>>
    export type ConvertScrapLotMutationBody = BodyType<ConvertScrapLotInput>
    export type ConvertScrapLotMutationError = ErrorType<unknown>

    /**
 * @summary Convert a REFINED scrap lot into a sellable inventory item
 */
export const useConvertScrapLot = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof convertScrapLot>>, TError,{id: string;data: BodyType<ConvertScrapLotInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof convertScrapLot>>,
        TError,
        {id: string;data: BodyType<ConvertScrapLotInput>},
        TContext
      > => {
      return useMutation(getConvertScrapLotMutationOptions(options));
    }

export const getGetScrapReportSummaryUrl = (params?: GetScrapReportSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/scrap/reports/summary?${stringifiedParams}` : `/api/scrap/reports/summary`
}

/**
 * @summary Scrap module reporting summary
 */
export const getScrapReportSummary = async (params?: GetScrapReportSummaryParams, options?: RequestInit): Promise<ScrapReportSummary> => {

  return customFetch<ScrapReportSummary>(getGetScrapReportSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetScrapReportSummaryQueryKey = (params?: GetScrapReportSummaryParams,) => {
    return [
    `/api/scrap/reports/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetScrapReportSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getScrapReportSummary>>, TError = ErrorType<unknown>>(params?: GetScrapReportSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getScrapReportSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScrapReportSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScrapReportSummary>>> = ({ signal }) => getScrapReportSummary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getScrapReportSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetScrapReportSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getScrapReportSummary>>>
export type GetScrapReportSummaryQueryError = ErrorType<unknown>


/**
 * @summary Scrap module reporting summary
 */

export function useGetScrapReportSummary<TData = Awaited<ReturnType<typeof getScrapReportSummary>>, TError = ErrorType<unknown>>(
 params?: GetScrapReportSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getScrapReportSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetScrapReportSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetScrapSettingsUrl = () => {




  return `/api/scrap/settings`
}

export const getScrapSettings = async ( options?: RequestInit): Promise<ScrapSettings> => {

  return customFetch<ScrapSettings>(getGetScrapSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetScrapSettingsQueryKey = () => {
    return [
    `/api/scrap/settings`
    ] as const;
    }


export const getGetScrapSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getScrapSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getScrapSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScrapSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScrapSettings>>> = ({ signal }) => getScrapSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getScrapSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetScrapSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getScrapSettings>>>
export type GetScrapSettingsQueryError = ErrorType<unknown>



export function useGetScrapSettings<TData = Awaited<ReturnType<typeof getScrapSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getScrapSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetScrapSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateScrapSettingsUrl = () => {




  return `/api/scrap/settings`
}

export const updateScrapSettings = async (scrapSettingsInput: ScrapSettingsInput, options?: RequestInit): Promise<ScrapSettings> => {

  return customFetch<ScrapSettings>(getUpdateScrapSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scrapSettingsInput)
  }
);}





export const getUpdateScrapSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateScrapSettings>>, TError,{data: BodyType<ScrapSettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateScrapSettings>>, TError,{data: BodyType<ScrapSettingsInput>}, TContext> => {

const mutationKey = ['updateScrapSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateScrapSettings>>, {data: BodyType<ScrapSettingsInput>}> = (props) => {
          const {data} = props ?? {};

          return  updateScrapSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateScrapSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateScrapSettings>>>
    export type UpdateScrapSettingsMutationBody = BodyType<ScrapSettingsInput>
    export type UpdateScrapSettingsMutationError = ErrorType<unknown>

    export const useUpdateScrapSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateScrapSettings>>, TError,{data: BodyType<ScrapSettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateScrapSettings>>,
        TError,
        {data: BodyType<ScrapSettingsInput>},
        TContext
      > => {
      return useMutation(getUpdateScrapSettingsMutationOptions(options));
    }

export const getGetHrOverviewUrl = () => {




  return `/api/hr/overview`
}

/**
 * @summary HR dashboard summary counts
 */
export const getHrOverview = async ( options?: RequestInit): Promise<HrOverview> => {

  return customFetch<HrOverview>(getGetHrOverviewUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHrOverviewQueryKey = () => {
    return [
    `/api/hr/overview`
    ] as const;
    }


export const getGetHrOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getHrOverview>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHrOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHrOverviewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHrOverview>>> = ({ signal }) => getHrOverview({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHrOverview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHrOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getHrOverview>>>
export type GetHrOverviewQueryError = ErrorType<unknown>


/**
 * @summary HR dashboard summary counts
 */

export function useGetHrOverview<TData = Awaited<ReturnType<typeof getHrOverview>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHrOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetHrOverviewQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListHrStaffUrl = (params?: ListHrStaffParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/staff?${stringifiedParams}` : `/api/hr/staff`
}

/**
 * @summary List staff records
 */
export const listHrStaff = async (params?: ListHrStaffParams, options?: RequestInit): Promise<HrStaffListResponse> => {

  return customFetch<HrStaffListResponse>(getListHrStaffUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHrStaffQueryKey = (params?: ListHrStaffParams,) => {
    return [
    `/api/hr/staff`, ...(params ? [params] : [])
    ] as const;
    }


export const getListHrStaffQueryOptions = <TData = Awaited<ReturnType<typeof listHrStaff>>, TError = ErrorType<unknown>>(params?: ListHrStaffParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrStaff>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHrStaffQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHrStaff>>> = ({ signal }) => listHrStaff(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHrStaff>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHrStaffQueryResult = NonNullable<Awaited<ReturnType<typeof listHrStaff>>>
export type ListHrStaffQueryError = ErrorType<unknown>


/**
 * @summary List staff records
 */

export function useListHrStaff<TData = Awaited<ReturnType<typeof listHrStaff>>, TError = ErrorType<unknown>>(
 params?: ListHrStaffParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrStaff>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHrStaffQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateHrStaffUrl = () => {




  return `/api/hr/staff`
}

/**
 * @summary Create a staff record
 */
export const createHrStaff = async (hrStaffInput: HrStaffInput, options?: RequestInit): Promise<HrStaffDetail> => {

  return customFetch<HrStaffDetail>(getCreateHrStaffUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrStaffInput)
  }
);}





export const getCreateHrStaffMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrStaff>>, TError,{data: BodyType<HrStaffInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createHrStaff>>, TError,{data: BodyType<HrStaffInput>}, TContext> => {

const mutationKey = ['createHrStaff'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHrStaff>>, {data: BodyType<HrStaffInput>}> = (props) => {
          const {data} = props ?? {};

          return  createHrStaff(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHrStaffMutationResult = NonNullable<Awaited<ReturnType<typeof createHrStaff>>>
    export type CreateHrStaffMutationBody = BodyType<HrStaffInput>
    export type CreateHrStaffMutationError = ErrorType<unknown>

    /**
 * @summary Create a staff record
 */
export const useCreateHrStaff = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrStaff>>, TError,{data: BodyType<HrStaffInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createHrStaff>>,
        TError,
        {data: BodyType<HrStaffInput>},
        TContext
      > => {
      return useMutation(getCreateHrStaffMutationOptions(options));
    }

export const getGetHrStaffUrl = (id: string,) => {




  return `/api/hr/staff/${id}`
}

export const getHrStaff = async (id: string, options?: RequestInit): Promise<HrStaffDetail> => {

  return customFetch<HrStaffDetail>(getGetHrStaffUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHrStaffQueryKey = (id: string,) => {
    return [
    `/api/hr/staff/${id}`
    ] as const;
    }


export const getGetHrStaffQueryOptions = <TData = Awaited<ReturnType<typeof getHrStaff>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHrStaff>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHrStaffQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHrStaff>>> = ({ signal }) => getHrStaff(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHrStaff>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHrStaffQueryResult = NonNullable<Awaited<ReturnType<typeof getHrStaff>>>
export type GetHrStaffQueryError = ErrorType<unknown>



export function useGetHrStaff<TData = Awaited<ReturnType<typeof getHrStaff>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHrStaff>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetHrStaffQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateHrStaffUrl = (id: string,) => {




  return `/api/hr/staff/${id}`
}

export const updateHrStaff = async (id: string,
    hrStaffUpdate: HrStaffUpdate, options?: RequestInit): Promise<HrStaffDetail> => {

  return customFetch<HrStaffDetail>(getUpdateHrStaffUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrStaffUpdate)
  }
);}





export const getUpdateHrStaffMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrStaff>>, TError,{id: string;data: BodyType<HrStaffUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateHrStaff>>, TError,{id: string;data: BodyType<HrStaffUpdate>}, TContext> => {

const mutationKey = ['updateHrStaff'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHrStaff>>, {id: string;data: BodyType<HrStaffUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateHrStaff(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHrStaffMutationResult = NonNullable<Awaited<ReturnType<typeof updateHrStaff>>>
    export type UpdateHrStaffMutationBody = BodyType<HrStaffUpdate>
    export type UpdateHrStaffMutationError = ErrorType<unknown>

    export const useUpdateHrStaff = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrStaff>>, TError,{id: string;data: BodyType<HrStaffUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateHrStaff>>,
        TError,
        {id: string;data: BodyType<HrStaffUpdate>},
        TContext
      > => {
      return useMutation(getUpdateHrStaffMutationOptions(options));
    }

export const getArchiveHrStaffUrl = (id: string,) => {




  return `/api/hr/staff/${id}/archive`
}

/**
 * @summary Archive (soft-disable) a staff record
 */
export const archiveHrStaff = async (id: string, options?: RequestInit): Promise<HrStaffDetail> => {

  return customFetch<HrStaffDetail>(getArchiveHrStaffUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getArchiveHrStaffMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveHrStaff>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveHrStaff>>, TError,{id: string}, TContext> => {

const mutationKey = ['archiveHrStaff'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveHrStaff>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  archiveHrStaff(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveHrStaffMutationResult = NonNullable<Awaited<ReturnType<typeof archiveHrStaff>>>

    export type ArchiveHrStaffMutationError = ErrorType<unknown>

    /**
 * @summary Archive (soft-disable) a staff record
 */
export const useArchiveHrStaff = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveHrStaff>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof archiveHrStaff>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getArchiveHrStaffMutationOptions(options));
    }

export const getGetHrStaffPayUrl = (id: string,) => {




  return `/api/hr/staff/${id}/pay`
}

export const getHrStaffPay = async (id: string, options?: RequestInit): Promise<HrPayDetails> => {

  return customFetch<HrPayDetails>(getGetHrStaffPayUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHrStaffPayQueryKey = (id: string,) => {
    return [
    `/api/hr/staff/${id}/pay`
    ] as const;
    }


export const getGetHrStaffPayQueryOptions = <TData = Awaited<ReturnType<typeof getHrStaffPay>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHrStaffPay>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHrStaffPayQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHrStaffPay>>> = ({ signal }) => getHrStaffPay(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHrStaffPay>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHrStaffPayQueryResult = NonNullable<Awaited<ReturnType<typeof getHrStaffPay>>>
export type GetHrStaffPayQueryError = ErrorType<unknown>



export function useGetHrStaffPay<TData = Awaited<ReturnType<typeof getHrStaffPay>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHrStaffPay>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetHrStaffPayQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpsertHrStaffPayUrl = (id: string,) => {




  return `/api/hr/staff/${id}/pay`
}

export const upsertHrStaffPay = async (id: string,
    hrPayDetailsInput: HrPayDetailsInput, options?: RequestInit): Promise<HrPayDetails> => {

  return customFetch<HrPayDetails>(getUpsertHrStaffPayUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrPayDetailsInput)
  }
);}





export const getUpsertHrStaffPayMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertHrStaffPay>>, TError,{id: string;data: BodyType<HrPayDetailsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertHrStaffPay>>, TError,{id: string;data: BodyType<HrPayDetailsInput>}, TContext> => {

const mutationKey = ['upsertHrStaffPay'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertHrStaffPay>>, {id: string;data: BodyType<HrPayDetailsInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  upsertHrStaffPay(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertHrStaffPayMutationResult = NonNullable<Awaited<ReturnType<typeof upsertHrStaffPay>>>
    export type UpsertHrStaffPayMutationBody = BodyType<HrPayDetailsInput>
    export type UpsertHrStaffPayMutationError = ErrorType<unknown>

    export const useUpsertHrStaffPay = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertHrStaffPay>>, TError,{id: string;data: BodyType<HrPayDetailsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertHrStaffPay>>,
        TError,
        {id: string;data: BodyType<HrPayDetailsInput>},
        TContext
      > => {
      return useMutation(getUpsertHrStaffPayMutationOptions(options));
    }

export const getListHrStaffHoursUrl = (id: string,) => {




  return `/api/hr/staff/${id}/hours`
}

export const listHrStaffHours = async (id: string, options?: RequestInit): Promise<HrHoursEntry[]> => {

  return customFetch<HrHoursEntry[]>(getListHrStaffHoursUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHrStaffHoursQueryKey = (id: string,) => {
    return [
    `/api/hr/staff/${id}/hours`
    ] as const;
    }


export const getListHrStaffHoursQueryOptions = <TData = Awaited<ReturnType<typeof listHrStaffHours>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrStaffHours>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHrStaffHoursQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHrStaffHours>>> = ({ signal }) => listHrStaffHours(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHrStaffHours>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHrStaffHoursQueryResult = NonNullable<Awaited<ReturnType<typeof listHrStaffHours>>>
export type ListHrStaffHoursQueryError = ErrorType<unknown>



export function useListHrStaffHours<TData = Awaited<ReturnType<typeof listHrStaffHours>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrStaffHours>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHrStaffHoursQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateHrStaffHoursUrl = (id: string,) => {




  return `/api/hr/staff/${id}/hours`
}

export const createHrStaffHours = async (id: string,
    hrHoursInput: HrHoursInput, options?: RequestInit): Promise<HrHoursEntry> => {

  return customFetch<HrHoursEntry>(getCreateHrStaffHoursUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrHoursInput)
  }
);}





export const getCreateHrStaffHoursMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrStaffHours>>, TError,{id: string;data: BodyType<HrHoursInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createHrStaffHours>>, TError,{id: string;data: BodyType<HrHoursInput>}, TContext> => {

const mutationKey = ['createHrStaffHours'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHrStaffHours>>, {id: string;data: BodyType<HrHoursInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createHrStaffHours(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHrStaffHoursMutationResult = NonNullable<Awaited<ReturnType<typeof createHrStaffHours>>>
    export type CreateHrStaffHoursMutationBody = BodyType<HrHoursInput>
    export type CreateHrStaffHoursMutationError = ErrorType<unknown>

    export const useCreateHrStaffHours = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrStaffHours>>, TError,{id: string;data: BodyType<HrHoursInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createHrStaffHours>>,
        TError,
        {id: string;data: BodyType<HrHoursInput>},
        TContext
      > => {
      return useMutation(getCreateHrStaffHoursMutationOptions(options));
    }

export const getUpdateHrHoursUrl = (id: string,) => {




  return `/api/hr/hours/${id}`
}

/**
 * @summary Edit, submit, approve or reject an hours entry
 */
export const updateHrHours = async (id: string,
    hrHoursUpdate: HrHoursUpdate, options?: RequestInit): Promise<HrHoursEntry> => {

  return customFetch<HrHoursEntry>(getUpdateHrHoursUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrHoursUpdate)
  }
);}





export const getUpdateHrHoursMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrHours>>, TError,{id: string;data: BodyType<HrHoursUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateHrHours>>, TError,{id: string;data: BodyType<HrHoursUpdate>}, TContext> => {

const mutationKey = ['updateHrHours'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHrHours>>, {id: string;data: BodyType<HrHoursUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateHrHours(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHrHoursMutationResult = NonNullable<Awaited<ReturnType<typeof updateHrHours>>>
    export type UpdateHrHoursMutationBody = BodyType<HrHoursUpdate>
    export type UpdateHrHoursMutationError = ErrorType<unknown>

    /**
 * @summary Edit, submit, approve or reject an hours entry
 */
export const useUpdateHrHours = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrHours>>, TError,{id: string;data: BodyType<HrHoursUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateHrHours>>,
        TError,
        {id: string;data: BodyType<HrHoursUpdate>},
        TContext
      > => {
      return useMutation(getUpdateHrHoursMutationOptions(options));
    }

export const getDeleteHrHoursUrl = (id: string,) => {




  return `/api/hr/hours/${id}`
}

export const deleteHrHours = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteHrHoursUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteHrHoursMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHrHours>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteHrHours>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteHrHours'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHrHours>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteHrHours(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteHrHoursMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHrHours>>>

    export type DeleteHrHoursMutationError = ErrorType<unknown>

    export const useDeleteHrHours = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHrHours>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteHrHours>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteHrHoursMutationOptions(options));
    }

export const getListHrStaffDocumentsUrl = (id: string,) => {




  return `/api/hr/staff/${id}/documents`
}

export const listHrStaffDocuments = async (id: string, options?: RequestInit): Promise<HrDocument[]> => {

  return customFetch<HrDocument[]>(getListHrStaffDocumentsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHrStaffDocumentsQueryKey = (id: string,) => {
    return [
    `/api/hr/staff/${id}/documents`
    ] as const;
    }


export const getListHrStaffDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof listHrStaffDocuments>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrStaffDocuments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHrStaffDocumentsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHrStaffDocuments>>> = ({ signal }) => listHrStaffDocuments(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHrStaffDocuments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHrStaffDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listHrStaffDocuments>>>
export type ListHrStaffDocumentsQueryError = ErrorType<unknown>



export function useListHrStaffDocuments<TData = Awaited<ReturnType<typeof listHrStaffDocuments>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrStaffDocuments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHrStaffDocumentsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateHrStaffDocumentUrl = (id: string,) => {




  return `/api/hr/staff/${id}/documents`
}

export const createHrStaffDocument = async (id: string,
    hrDocumentInput: HrDocumentInput, options?: RequestInit): Promise<HrDocument> => {

  return customFetch<HrDocument>(getCreateHrStaffDocumentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrDocumentInput)
  }
);}





export const getCreateHrStaffDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrStaffDocument>>, TError,{id: string;data: BodyType<HrDocumentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createHrStaffDocument>>, TError,{id: string;data: BodyType<HrDocumentInput>}, TContext> => {

const mutationKey = ['createHrStaffDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHrStaffDocument>>, {id: string;data: BodyType<HrDocumentInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createHrStaffDocument(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHrStaffDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof createHrStaffDocument>>>
    export type CreateHrStaffDocumentMutationBody = BodyType<HrDocumentInput>
    export type CreateHrStaffDocumentMutationError = ErrorType<unknown>

    export const useCreateHrStaffDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrStaffDocument>>, TError,{id: string;data: BodyType<HrDocumentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createHrStaffDocument>>,
        TError,
        {id: string;data: BodyType<HrDocumentInput>},
        TContext
      > => {
      return useMutation(getCreateHrStaffDocumentMutationOptions(options));
    }

export const getUpdateHrDocumentUrl = (id: string,) => {




  return `/api/hr/documents/${id}`
}

export const updateHrDocument = async (id: string,
    hrDocumentUpdate: HrDocumentUpdate, options?: RequestInit): Promise<HrDocument> => {

  return customFetch<HrDocument>(getUpdateHrDocumentUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrDocumentUpdate)
  }
);}





export const getUpdateHrDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrDocument>>, TError,{id: string;data: BodyType<HrDocumentUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateHrDocument>>, TError,{id: string;data: BodyType<HrDocumentUpdate>}, TContext> => {

const mutationKey = ['updateHrDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHrDocument>>, {id: string;data: BodyType<HrDocumentUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateHrDocument(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHrDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof updateHrDocument>>>
    export type UpdateHrDocumentMutationBody = BodyType<HrDocumentUpdate>
    export type UpdateHrDocumentMutationError = ErrorType<unknown>

    export const useUpdateHrDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrDocument>>, TError,{id: string;data: BodyType<HrDocumentUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateHrDocument>>,
        TError,
        {id: string;data: BodyType<HrDocumentUpdate>},
        TContext
      > => {
      return useMutation(getUpdateHrDocumentMutationOptions(options));
    }

export const getDeleteHrDocumentUrl = (id: string,) => {




  return `/api/hr/documents/${id}`
}

export const deleteHrDocument = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteHrDocumentUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteHrDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHrDocument>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteHrDocument>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteHrDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHrDocument>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteHrDocument(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteHrDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHrDocument>>>

    export type DeleteHrDocumentMutationError = ErrorType<unknown>

    export const useDeleteHrDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHrDocument>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteHrDocument>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteHrDocumentMutationOptions(options));
    }

export const getListHrStaffAbsencesUrl = (id: string,) => {




  return `/api/hr/staff/${id}/absences`
}

export const listHrStaffAbsences = async (id: string, options?: RequestInit): Promise<HrAbsence[]> => {

  return customFetch<HrAbsence[]>(getListHrStaffAbsencesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHrStaffAbsencesQueryKey = (id: string,) => {
    return [
    `/api/hr/staff/${id}/absences`
    ] as const;
    }


export const getListHrStaffAbsencesQueryOptions = <TData = Awaited<ReturnType<typeof listHrStaffAbsences>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrStaffAbsences>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHrStaffAbsencesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHrStaffAbsences>>> = ({ signal }) => listHrStaffAbsences(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHrStaffAbsences>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHrStaffAbsencesQueryResult = NonNullable<Awaited<ReturnType<typeof listHrStaffAbsences>>>
export type ListHrStaffAbsencesQueryError = ErrorType<unknown>



export function useListHrStaffAbsences<TData = Awaited<ReturnType<typeof listHrStaffAbsences>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrStaffAbsences>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHrStaffAbsencesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateHrStaffAbsenceUrl = (id: string,) => {




  return `/api/hr/staff/${id}/absences`
}

export const createHrStaffAbsence = async (id: string,
    hrAbsenceInput: HrAbsenceInput, options?: RequestInit): Promise<HrAbsence> => {

  return customFetch<HrAbsence>(getCreateHrStaffAbsenceUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrAbsenceInput)
  }
);}





export const getCreateHrStaffAbsenceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrStaffAbsence>>, TError,{id: string;data: BodyType<HrAbsenceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createHrStaffAbsence>>, TError,{id: string;data: BodyType<HrAbsenceInput>}, TContext> => {

const mutationKey = ['createHrStaffAbsence'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHrStaffAbsence>>, {id: string;data: BodyType<HrAbsenceInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createHrStaffAbsence(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHrStaffAbsenceMutationResult = NonNullable<Awaited<ReturnType<typeof createHrStaffAbsence>>>
    export type CreateHrStaffAbsenceMutationBody = BodyType<HrAbsenceInput>
    export type CreateHrStaffAbsenceMutationError = ErrorType<unknown>

    export const useCreateHrStaffAbsence = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrStaffAbsence>>, TError,{id: string;data: BodyType<HrAbsenceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createHrStaffAbsence>>,
        TError,
        {id: string;data: BodyType<HrAbsenceInput>},
        TContext
      > => {
      return useMutation(getCreateHrStaffAbsenceMutationOptions(options));
    }

export const getUpdateHrAbsenceUrl = (id: string,) => {




  return `/api/hr/absences/${id}`
}

export const updateHrAbsence = async (id: string,
    hrAbsenceUpdate: HrAbsenceUpdate, options?: RequestInit): Promise<HrAbsence> => {

  return customFetch<HrAbsence>(getUpdateHrAbsenceUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrAbsenceUpdate)
  }
);}





export const getUpdateHrAbsenceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrAbsence>>, TError,{id: string;data: BodyType<HrAbsenceUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateHrAbsence>>, TError,{id: string;data: BodyType<HrAbsenceUpdate>}, TContext> => {

const mutationKey = ['updateHrAbsence'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHrAbsence>>, {id: string;data: BodyType<HrAbsenceUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateHrAbsence(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHrAbsenceMutationResult = NonNullable<Awaited<ReturnType<typeof updateHrAbsence>>>
    export type UpdateHrAbsenceMutationBody = BodyType<HrAbsenceUpdate>
    export type UpdateHrAbsenceMutationError = ErrorType<unknown>

    export const useUpdateHrAbsence = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrAbsence>>, TError,{id: string;data: BodyType<HrAbsenceUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateHrAbsence>>,
        TError,
        {id: string;data: BodyType<HrAbsenceUpdate>},
        TContext
      > => {
      return useMutation(getUpdateHrAbsenceMutationOptions(options));
    }

export const getDeleteHrAbsenceUrl = (id: string,) => {




  return `/api/hr/absences/${id}`
}

export const deleteHrAbsence = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteHrAbsenceUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteHrAbsenceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHrAbsence>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteHrAbsence>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteHrAbsence'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHrAbsence>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteHrAbsence(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteHrAbsenceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHrAbsence>>>

    export type DeleteHrAbsenceMutationError = ErrorType<unknown>

    export const useDeleteHrAbsence = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHrAbsence>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteHrAbsence>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteHrAbsenceMutationOptions(options));
    }

export const getListHrTimeOffUrl = (params?: ListHrTimeOffParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/time-off?${stringifiedParams}` : `/api/hr/time-off`
}

/**
 * @summary Time-off request inbox (all staff)
 */
export const listHrTimeOff = async (params?: ListHrTimeOffParams, options?: RequestInit): Promise<HrTimeOffRequest[]> => {

  return customFetch<HrTimeOffRequest[]>(getListHrTimeOffUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHrTimeOffQueryKey = (params?: ListHrTimeOffParams,) => {
    return [
    `/api/hr/time-off`, ...(params ? [params] : [])
    ] as const;
    }


export const getListHrTimeOffQueryOptions = <TData = Awaited<ReturnType<typeof listHrTimeOff>>, TError = ErrorType<unknown>>(params?: ListHrTimeOffParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrTimeOff>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHrTimeOffQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHrTimeOff>>> = ({ signal }) => listHrTimeOff(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHrTimeOff>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHrTimeOffQueryResult = NonNullable<Awaited<ReturnType<typeof listHrTimeOff>>>
export type ListHrTimeOffQueryError = ErrorType<unknown>


/**
 * @summary Time-off request inbox (all staff)
 */

export function useListHrTimeOff<TData = Awaited<ReturnType<typeof listHrTimeOff>>, TError = ErrorType<unknown>>(
 params?: ListHrTimeOffParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrTimeOff>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHrTimeOffQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateHrStaffTimeOffUrl = (id: string,) => {




  return `/api/hr/staff/${id}/time-off`
}

/**
 * @summary Create a time-off request on behalf of a staff member
 */
export const createHrStaffTimeOff = async (id: string,
    hrTimeOffInput: HrTimeOffInput, options?: RequestInit): Promise<HrTimeOffRequest> => {

  return customFetch<HrTimeOffRequest>(getCreateHrStaffTimeOffUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrTimeOffInput)
  }
);}





export const getCreateHrStaffTimeOffMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrStaffTimeOff>>, TError,{id: string;data: BodyType<HrTimeOffInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createHrStaffTimeOff>>, TError,{id: string;data: BodyType<HrTimeOffInput>}, TContext> => {

const mutationKey = ['createHrStaffTimeOff'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHrStaffTimeOff>>, {id: string;data: BodyType<HrTimeOffInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createHrStaffTimeOff(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHrStaffTimeOffMutationResult = NonNullable<Awaited<ReturnType<typeof createHrStaffTimeOff>>>
    export type CreateHrStaffTimeOffMutationBody = BodyType<HrTimeOffInput>
    export type CreateHrStaffTimeOffMutationError = ErrorType<unknown>

    /**
 * @summary Create a time-off request on behalf of a staff member
 */
export const useCreateHrStaffTimeOff = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrStaffTimeOff>>, TError,{id: string;data: BodyType<HrTimeOffInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createHrStaffTimeOff>>,
        TError,
        {id: string;data: BodyType<HrTimeOffInput>},
        TContext
      > => {
      return useMutation(getCreateHrStaffTimeOffMutationOptions(options));
    }

export const getReviewHrTimeOffUrl = (id: string,) => {




  return `/api/hr/time-off/${id}`
}

/**
 * @summary Approve, reject or request info on a time-off request
 */
export const reviewHrTimeOff = async (id: string,
    hrTimeOffReview: HrTimeOffReview, options?: RequestInit): Promise<HrTimeOffRequest> => {

  return customFetch<HrTimeOffRequest>(getReviewHrTimeOffUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrTimeOffReview)
  }
);}





export const getReviewHrTimeOffMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewHrTimeOff>>, TError,{id: string;data: BodyType<HrTimeOffReview>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reviewHrTimeOff>>, TError,{id: string;data: BodyType<HrTimeOffReview>}, TContext> => {

const mutationKey = ['reviewHrTimeOff'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviewHrTimeOff>>, {id: string;data: BodyType<HrTimeOffReview>}> = (props) => {
          const {id,data} = props ?? {};

          return  reviewHrTimeOff(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReviewHrTimeOffMutationResult = NonNullable<Awaited<ReturnType<typeof reviewHrTimeOff>>>
    export type ReviewHrTimeOffMutationBody = BodyType<HrTimeOffReview>
    export type ReviewHrTimeOffMutationError = ErrorType<unknown>

    /**
 * @summary Approve, reject or request info on a time-off request
 */
export const useReviewHrTimeOff = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewHrTimeOff>>, TError,{id: string;data: BodyType<HrTimeOffReview>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reviewHrTimeOff>>,
        TError,
        {id: string;data: BodyType<HrTimeOffReview>},
        TContext
      > => {
      return useMutation(getReviewHrTimeOffMutationOptions(options));
    }

export const getListHrChangeRequestsUrl = (params?: ListHrChangeRequestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/change-requests?${stringifiedParams}` : `/api/hr/change-requests`
}

export const listHrChangeRequests = async (params?: ListHrChangeRequestsParams, options?: RequestInit): Promise<HrChangeRequest[]> => {

  return customFetch<HrChangeRequest[]>(getListHrChangeRequestsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHrChangeRequestsQueryKey = (params?: ListHrChangeRequestsParams,) => {
    return [
    `/api/hr/change-requests`, ...(params ? [params] : [])
    ] as const;
    }


export const getListHrChangeRequestsQueryOptions = <TData = Awaited<ReturnType<typeof listHrChangeRequests>>, TError = ErrorType<unknown>>(params?: ListHrChangeRequestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrChangeRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHrChangeRequestsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHrChangeRequests>>> = ({ signal }) => listHrChangeRequests(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHrChangeRequests>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHrChangeRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof listHrChangeRequests>>>
export type ListHrChangeRequestsQueryError = ErrorType<unknown>



export function useListHrChangeRequests<TData = Awaited<ReturnType<typeof listHrChangeRequests>>, TError = ErrorType<unknown>>(
 params?: ListHrChangeRequestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrChangeRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHrChangeRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getReviewHrChangeRequestUrl = (id: string,) => {




  return `/api/hr/change-requests/${id}`
}

/**
 * @summary Approve or reject a staff detail-change request
 */
export const reviewHrChangeRequest = async (id: string,
    hrChangeRequestReview: HrChangeRequestReview, options?: RequestInit): Promise<HrChangeRequest> => {

  return customFetch<HrChangeRequest>(getReviewHrChangeRequestUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrChangeRequestReview)
  }
);}





export const getReviewHrChangeRequestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewHrChangeRequest>>, TError,{id: string;data: BodyType<HrChangeRequestReview>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reviewHrChangeRequest>>, TError,{id: string;data: BodyType<HrChangeRequestReview>}, TContext> => {

const mutationKey = ['reviewHrChangeRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviewHrChangeRequest>>, {id: string;data: BodyType<HrChangeRequestReview>}> = (props) => {
          const {id,data} = props ?? {};

          return  reviewHrChangeRequest(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReviewHrChangeRequestMutationResult = NonNullable<Awaited<ReturnType<typeof reviewHrChangeRequest>>>
    export type ReviewHrChangeRequestMutationBody = BodyType<HrChangeRequestReview>
    export type ReviewHrChangeRequestMutationError = ErrorType<unknown>

    /**
 * @summary Approve or reject a staff detail-change request
 */
export const useReviewHrChangeRequest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewHrChangeRequest>>, TError,{id: string;data: BodyType<HrChangeRequestReview>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reviewHrChangeRequest>>,
        TError,
        {id: string;data: BodyType<HrChangeRequestReview>},
        TContext
      > => {
      return useMutation(getReviewHrChangeRequestMutationOptions(options));
    }

export const getListHrStaffCommunicationsUrl = (id: string,) => {




  return `/api/hr/staff/${id}/communications`
}

export const listHrStaffCommunications = async (id: string, options?: RequestInit): Promise<HrCommunication[]> => {

  return customFetch<HrCommunication[]>(getListHrStaffCommunicationsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHrStaffCommunicationsQueryKey = (id: string,) => {
    return [
    `/api/hr/staff/${id}/communications`
    ] as const;
    }


export const getListHrStaffCommunicationsQueryOptions = <TData = Awaited<ReturnType<typeof listHrStaffCommunications>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrStaffCommunications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHrStaffCommunicationsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHrStaffCommunications>>> = ({ signal }) => listHrStaffCommunications(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHrStaffCommunications>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHrStaffCommunicationsQueryResult = NonNullable<Awaited<ReturnType<typeof listHrStaffCommunications>>>
export type ListHrStaffCommunicationsQueryError = ErrorType<unknown>



export function useListHrStaffCommunications<TData = Awaited<ReturnType<typeof listHrStaffCommunications>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrStaffCommunications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHrStaffCommunicationsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateHrStaffCommunicationUrl = (id: string,) => {




  return `/api/hr/staff/${id}/communications`
}

export const createHrStaffCommunication = async (id: string,
    hrCommunicationInput: HrCommunicationInput, options?: RequestInit): Promise<HrCommunication> => {

  return customFetch<HrCommunication>(getCreateHrStaffCommunicationUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrCommunicationInput)
  }
);}





export const getCreateHrStaffCommunicationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrStaffCommunication>>, TError,{id: string;data: BodyType<HrCommunicationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createHrStaffCommunication>>, TError,{id: string;data: BodyType<HrCommunicationInput>}, TContext> => {

const mutationKey = ['createHrStaffCommunication'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHrStaffCommunication>>, {id: string;data: BodyType<HrCommunicationInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createHrStaffCommunication(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHrStaffCommunicationMutationResult = NonNullable<Awaited<ReturnType<typeof createHrStaffCommunication>>>
    export type CreateHrStaffCommunicationMutationBody = BodyType<HrCommunicationInput>
    export type CreateHrStaffCommunicationMutationError = ErrorType<unknown>

    export const useCreateHrStaffCommunication = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrStaffCommunication>>, TError,{id: string;data: BodyType<HrCommunicationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createHrStaffCommunication>>,
        TError,
        {id: string;data: BodyType<HrCommunicationInput>},
        TContext
      > => {
      return useMutation(getCreateHrStaffCommunicationMutationOptions(options));
    }

export const getListHrStaffTrainingUrl = (id: string,) => {




  return `/api/hr/staff/${id}/training`
}

export const listHrStaffTraining = async (id: string, options?: RequestInit): Promise<HrTrainingRecord[]> => {

  return customFetch<HrTrainingRecord[]>(getListHrStaffTrainingUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHrStaffTrainingQueryKey = (id: string,) => {
    return [
    `/api/hr/staff/${id}/training`
    ] as const;
    }


export const getListHrStaffTrainingQueryOptions = <TData = Awaited<ReturnType<typeof listHrStaffTraining>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrStaffTraining>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHrStaffTrainingQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHrStaffTraining>>> = ({ signal }) => listHrStaffTraining(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHrStaffTraining>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHrStaffTrainingQueryResult = NonNullable<Awaited<ReturnType<typeof listHrStaffTraining>>>
export type ListHrStaffTrainingQueryError = ErrorType<unknown>



export function useListHrStaffTraining<TData = Awaited<ReturnType<typeof listHrStaffTraining>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrStaffTraining>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHrStaffTrainingQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateHrStaffTrainingUrl = (id: string,) => {




  return `/api/hr/staff/${id}/training`
}

export const createHrStaffTraining = async (id: string,
    hrTrainingInput: HrTrainingInput, options?: RequestInit): Promise<HrTrainingRecord> => {

  return customFetch<HrTrainingRecord>(getCreateHrStaffTrainingUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrTrainingInput)
  }
);}





export const getCreateHrStaffTrainingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrStaffTraining>>, TError,{id: string;data: BodyType<HrTrainingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createHrStaffTraining>>, TError,{id: string;data: BodyType<HrTrainingInput>}, TContext> => {

const mutationKey = ['createHrStaffTraining'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHrStaffTraining>>, {id: string;data: BodyType<HrTrainingInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createHrStaffTraining(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHrStaffTrainingMutationResult = NonNullable<Awaited<ReturnType<typeof createHrStaffTraining>>>
    export type CreateHrStaffTrainingMutationBody = BodyType<HrTrainingInput>
    export type CreateHrStaffTrainingMutationError = ErrorType<unknown>

    export const useCreateHrStaffTraining = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrStaffTraining>>, TError,{id: string;data: BodyType<HrTrainingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createHrStaffTraining>>,
        TError,
        {id: string;data: BodyType<HrTrainingInput>},
        TContext
      > => {
      return useMutation(getCreateHrStaffTrainingMutationOptions(options));
    }

export const getUpdateHrTrainingUrl = (id: string,) => {




  return `/api/hr/training/${id}`
}

export const updateHrTraining = async (id: string,
    hrTrainingUpdate: HrTrainingUpdate, options?: RequestInit): Promise<HrTrainingRecord> => {

  return customFetch<HrTrainingRecord>(getUpdateHrTrainingUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrTrainingUpdate)
  }
);}





export const getUpdateHrTrainingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrTraining>>, TError,{id: string;data: BodyType<HrTrainingUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateHrTraining>>, TError,{id: string;data: BodyType<HrTrainingUpdate>}, TContext> => {

const mutationKey = ['updateHrTraining'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHrTraining>>, {id: string;data: BodyType<HrTrainingUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateHrTraining(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHrTrainingMutationResult = NonNullable<Awaited<ReturnType<typeof updateHrTraining>>>
    export type UpdateHrTrainingMutationBody = BodyType<HrTrainingUpdate>
    export type UpdateHrTrainingMutationError = ErrorType<unknown>

    export const useUpdateHrTraining = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrTraining>>, TError,{id: string;data: BodyType<HrTrainingUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateHrTraining>>,
        TError,
        {id: string;data: BodyType<HrTrainingUpdate>},
        TContext
      > => {
      return useMutation(getUpdateHrTrainingMutationOptions(options));
    }

export const getDeleteHrTrainingUrl = (id: string,) => {




  return `/api/hr/training/${id}`
}

export const deleteHrTraining = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteHrTrainingUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteHrTrainingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHrTraining>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteHrTraining>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteHrTraining'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHrTraining>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteHrTraining(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteHrTrainingMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHrTraining>>>

    export type DeleteHrTrainingMutationError = ErrorType<unknown>

    export const useDeleteHrTraining = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHrTraining>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteHrTraining>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteHrTrainingMutationOptions(options));
    }

export const getListHrStaffOnboardingUrl = (id: string,) => {




  return `/api/hr/staff/${id}/onboarding`
}

export const listHrStaffOnboarding = async (id: string, options?: RequestInit): Promise<HrOnboardingItem[]> => {

  return customFetch<HrOnboardingItem[]>(getListHrStaffOnboardingUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHrStaffOnboardingQueryKey = (id: string,) => {
    return [
    `/api/hr/staff/${id}/onboarding`
    ] as const;
    }


export const getListHrStaffOnboardingQueryOptions = <TData = Awaited<ReturnType<typeof listHrStaffOnboarding>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrStaffOnboarding>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHrStaffOnboardingQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHrStaffOnboarding>>> = ({ signal }) => listHrStaffOnboarding(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHrStaffOnboarding>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHrStaffOnboardingQueryResult = NonNullable<Awaited<ReturnType<typeof listHrStaffOnboarding>>>
export type ListHrStaffOnboardingQueryError = ErrorType<unknown>



export function useListHrStaffOnboarding<TData = Awaited<ReturnType<typeof listHrStaffOnboarding>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrStaffOnboarding>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHrStaffOnboardingQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateHrStaffOnboardingItemUrl = (id: string,) => {




  return `/api/hr/staff/${id}/onboarding`
}

export const createHrStaffOnboardingItem = async (id: string,
    hrOnboardingItemInput: HrOnboardingItemInput, options?: RequestInit): Promise<HrOnboardingItem> => {

  return customFetch<HrOnboardingItem>(getCreateHrStaffOnboardingItemUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrOnboardingItemInput)
  }
);}





export const getCreateHrStaffOnboardingItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrStaffOnboardingItem>>, TError,{id: string;data: BodyType<HrOnboardingItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createHrStaffOnboardingItem>>, TError,{id: string;data: BodyType<HrOnboardingItemInput>}, TContext> => {

const mutationKey = ['createHrStaffOnboardingItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHrStaffOnboardingItem>>, {id: string;data: BodyType<HrOnboardingItemInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createHrStaffOnboardingItem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHrStaffOnboardingItemMutationResult = NonNullable<Awaited<ReturnType<typeof createHrStaffOnboardingItem>>>
    export type CreateHrStaffOnboardingItemMutationBody = BodyType<HrOnboardingItemInput>
    export type CreateHrStaffOnboardingItemMutationError = ErrorType<unknown>

    export const useCreateHrStaffOnboardingItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrStaffOnboardingItem>>, TError,{id: string;data: BodyType<HrOnboardingItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createHrStaffOnboardingItem>>,
        TError,
        {id: string;data: BodyType<HrOnboardingItemInput>},
        TContext
      > => {
      return useMutation(getCreateHrStaffOnboardingItemMutationOptions(options));
    }

export const getApplyHrOnboardingTemplateUrl = (id: string,) => {




  return `/api/hr/staff/${id}/onboarding/apply-template`
}

/**
 * @summary Apply an onboarding template to a staff member
 */
export const applyHrOnboardingTemplate = async (id: string,
    hrApplyOnboardingTemplate: HrApplyOnboardingTemplate, options?: RequestInit): Promise<HrOnboardingItem[]> => {

  return customFetch<HrOnboardingItem[]>(getApplyHrOnboardingTemplateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrApplyOnboardingTemplate)
  }
);}





export const getApplyHrOnboardingTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyHrOnboardingTemplate>>, TError,{id: string;data: BodyType<HrApplyOnboardingTemplate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof applyHrOnboardingTemplate>>, TError,{id: string;data: BodyType<HrApplyOnboardingTemplate>}, TContext> => {

const mutationKey = ['applyHrOnboardingTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof applyHrOnboardingTemplate>>, {id: string;data: BodyType<HrApplyOnboardingTemplate>}> = (props) => {
          const {id,data} = props ?? {};

          return  applyHrOnboardingTemplate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApplyHrOnboardingTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof applyHrOnboardingTemplate>>>
    export type ApplyHrOnboardingTemplateMutationBody = BodyType<HrApplyOnboardingTemplate>
    export type ApplyHrOnboardingTemplateMutationError = ErrorType<unknown>

    /**
 * @summary Apply an onboarding template to a staff member
 */
export const useApplyHrOnboardingTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyHrOnboardingTemplate>>, TError,{id: string;data: BodyType<HrApplyOnboardingTemplate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof applyHrOnboardingTemplate>>,
        TError,
        {id: string;data: BodyType<HrApplyOnboardingTemplate>},
        TContext
      > => {
      return useMutation(getApplyHrOnboardingTemplateMutationOptions(options));
    }

export const getUpdateHrOnboardingItemUrl = (id: string,) => {




  return `/api/hr/onboarding-items/${id}`
}

export const updateHrOnboardingItem = async (id: string,
    hrOnboardingItemUpdate: HrOnboardingItemUpdate, options?: RequestInit): Promise<HrOnboardingItem> => {

  return customFetch<HrOnboardingItem>(getUpdateHrOnboardingItemUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrOnboardingItemUpdate)
  }
);}





export const getUpdateHrOnboardingItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrOnboardingItem>>, TError,{id: string;data: BodyType<HrOnboardingItemUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateHrOnboardingItem>>, TError,{id: string;data: BodyType<HrOnboardingItemUpdate>}, TContext> => {

const mutationKey = ['updateHrOnboardingItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHrOnboardingItem>>, {id: string;data: BodyType<HrOnboardingItemUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateHrOnboardingItem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHrOnboardingItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateHrOnboardingItem>>>
    export type UpdateHrOnboardingItemMutationBody = BodyType<HrOnboardingItemUpdate>
    export type UpdateHrOnboardingItemMutationError = ErrorType<unknown>

    export const useUpdateHrOnboardingItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrOnboardingItem>>, TError,{id: string;data: BodyType<HrOnboardingItemUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateHrOnboardingItem>>,
        TError,
        {id: string;data: BodyType<HrOnboardingItemUpdate>},
        TContext
      > => {
      return useMutation(getUpdateHrOnboardingItemMutationOptions(options));
    }

export const getDeleteHrOnboardingItemUrl = (id: string,) => {




  return `/api/hr/onboarding-items/${id}`
}

export const deleteHrOnboardingItem = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteHrOnboardingItemUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteHrOnboardingItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHrOnboardingItem>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteHrOnboardingItem>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteHrOnboardingItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHrOnboardingItem>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteHrOnboardingItem(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteHrOnboardingItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHrOnboardingItem>>>

    export type DeleteHrOnboardingItemMutationError = ErrorType<unknown>

    export const useDeleteHrOnboardingItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHrOnboardingItem>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteHrOnboardingItem>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteHrOnboardingItemMutationOptions(options));
    }

export const getListHrOnboardingTemplatesUrl = () => {




  return `/api/hr/onboarding-templates`
}

export const listHrOnboardingTemplates = async ( options?: RequestInit): Promise<HrOnboardingTemplate[]> => {

  return customFetch<HrOnboardingTemplate[]>(getListHrOnboardingTemplatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHrOnboardingTemplatesQueryKey = () => {
    return [
    `/api/hr/onboarding-templates`
    ] as const;
    }


export const getListHrOnboardingTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof listHrOnboardingTemplates>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrOnboardingTemplates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHrOnboardingTemplatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHrOnboardingTemplates>>> = ({ signal }) => listHrOnboardingTemplates({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHrOnboardingTemplates>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHrOnboardingTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof listHrOnboardingTemplates>>>
export type ListHrOnboardingTemplatesQueryError = ErrorType<unknown>



export function useListHrOnboardingTemplates<TData = Awaited<ReturnType<typeof listHrOnboardingTemplates>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrOnboardingTemplates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHrOnboardingTemplatesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateHrOnboardingTemplateUrl = () => {




  return `/api/hr/onboarding-templates`
}

export const createHrOnboardingTemplate = async (hrOnboardingTemplateInput: HrOnboardingTemplateInput, options?: RequestInit): Promise<HrOnboardingTemplate> => {

  return customFetch<HrOnboardingTemplate>(getCreateHrOnboardingTemplateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrOnboardingTemplateInput)
  }
);}





export const getCreateHrOnboardingTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrOnboardingTemplate>>, TError,{data: BodyType<HrOnboardingTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createHrOnboardingTemplate>>, TError,{data: BodyType<HrOnboardingTemplateInput>}, TContext> => {

const mutationKey = ['createHrOnboardingTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHrOnboardingTemplate>>, {data: BodyType<HrOnboardingTemplateInput>}> = (props) => {
          const {data} = props ?? {};

          return  createHrOnboardingTemplate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHrOnboardingTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof createHrOnboardingTemplate>>>
    export type CreateHrOnboardingTemplateMutationBody = BodyType<HrOnboardingTemplateInput>
    export type CreateHrOnboardingTemplateMutationError = ErrorType<unknown>

    export const useCreateHrOnboardingTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrOnboardingTemplate>>, TError,{data: BodyType<HrOnboardingTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createHrOnboardingTemplate>>,
        TError,
        {data: BodyType<HrOnboardingTemplateInput>},
        TContext
      > => {
      return useMutation(getCreateHrOnboardingTemplateMutationOptions(options));
    }

export const getUpdateHrOnboardingTemplateUrl = (id: string,) => {




  return `/api/hr/onboarding-templates/${id}`
}

export const updateHrOnboardingTemplate = async (id: string,
    hrOnboardingTemplateInput: HrOnboardingTemplateInput, options?: RequestInit): Promise<HrOnboardingTemplate> => {

  return customFetch<HrOnboardingTemplate>(getUpdateHrOnboardingTemplateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrOnboardingTemplateInput)
  }
);}





export const getUpdateHrOnboardingTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrOnboardingTemplate>>, TError,{id: string;data: BodyType<HrOnboardingTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateHrOnboardingTemplate>>, TError,{id: string;data: BodyType<HrOnboardingTemplateInput>}, TContext> => {

const mutationKey = ['updateHrOnboardingTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHrOnboardingTemplate>>, {id: string;data: BodyType<HrOnboardingTemplateInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateHrOnboardingTemplate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHrOnboardingTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof updateHrOnboardingTemplate>>>
    export type UpdateHrOnboardingTemplateMutationBody = BodyType<HrOnboardingTemplateInput>
    export type UpdateHrOnboardingTemplateMutationError = ErrorType<unknown>

    export const useUpdateHrOnboardingTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrOnboardingTemplate>>, TError,{id: string;data: BodyType<HrOnboardingTemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateHrOnboardingTemplate>>,
        TError,
        {id: string;data: BodyType<HrOnboardingTemplateInput>},
        TContext
      > => {
      return useMutation(getUpdateHrOnboardingTemplateMutationOptions(options));
    }

export const getDeleteHrOnboardingTemplateUrl = (id: string,) => {




  return `/api/hr/onboarding-templates/${id}`
}

export const deleteHrOnboardingTemplate = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteHrOnboardingTemplateUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteHrOnboardingTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHrOnboardingTemplate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteHrOnboardingTemplate>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteHrOnboardingTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHrOnboardingTemplate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteHrOnboardingTemplate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteHrOnboardingTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHrOnboardingTemplate>>>

    export type DeleteHrOnboardingTemplateMutationError = ErrorType<unknown>

    export const useDeleteHrOnboardingTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHrOnboardingTemplate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteHrOnboardingTemplate>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteHrOnboardingTemplateMutationOptions(options));
    }

export const getListHrStaffIncidentsUrl = (id: string,) => {




  return `/api/hr/staff/${id}/incidents`
}

export const listHrStaffIncidents = async (id: string, options?: RequestInit): Promise<HrIncident[]> => {

  return customFetch<HrIncident[]>(getListHrStaffIncidentsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHrStaffIncidentsQueryKey = (id: string,) => {
    return [
    `/api/hr/staff/${id}/incidents`
    ] as const;
    }


export const getListHrStaffIncidentsQueryOptions = <TData = Awaited<ReturnType<typeof listHrStaffIncidents>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrStaffIncidents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHrStaffIncidentsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHrStaffIncidents>>> = ({ signal }) => listHrStaffIncidents(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHrStaffIncidents>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHrStaffIncidentsQueryResult = NonNullable<Awaited<ReturnType<typeof listHrStaffIncidents>>>
export type ListHrStaffIncidentsQueryError = ErrorType<unknown>



export function useListHrStaffIncidents<TData = Awaited<ReturnType<typeof listHrStaffIncidents>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrStaffIncidents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHrStaffIncidentsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateHrStaffIncidentUrl = (id: string,) => {




  return `/api/hr/staff/${id}/incidents`
}

export const createHrStaffIncident = async (id: string,
    hrIncidentInput: HrIncidentInput, options?: RequestInit): Promise<HrIncident> => {

  return customFetch<HrIncident>(getCreateHrStaffIncidentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrIncidentInput)
  }
);}





export const getCreateHrStaffIncidentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrStaffIncident>>, TError,{id: string;data: BodyType<HrIncidentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createHrStaffIncident>>, TError,{id: string;data: BodyType<HrIncidentInput>}, TContext> => {

const mutationKey = ['createHrStaffIncident'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHrStaffIncident>>, {id: string;data: BodyType<HrIncidentInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createHrStaffIncident(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHrStaffIncidentMutationResult = NonNullable<Awaited<ReturnType<typeof createHrStaffIncident>>>
    export type CreateHrStaffIncidentMutationBody = BodyType<HrIncidentInput>
    export type CreateHrStaffIncidentMutationError = ErrorType<unknown>

    export const useCreateHrStaffIncident = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrStaffIncident>>, TError,{id: string;data: BodyType<HrIncidentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createHrStaffIncident>>,
        TError,
        {id: string;data: BodyType<HrIncidentInput>},
        TContext
      > => {
      return useMutation(getCreateHrStaffIncidentMutationOptions(options));
    }

export const getUpdateHrIncidentUrl = (id: string,) => {




  return `/api/hr/incidents/${id}`
}

export const updateHrIncident = async (id: string,
    hrIncidentUpdate: HrIncidentUpdate, options?: RequestInit): Promise<HrIncident> => {

  return customFetch<HrIncident>(getUpdateHrIncidentUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrIncidentUpdate)
  }
);}





export const getUpdateHrIncidentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrIncident>>, TError,{id: string;data: BodyType<HrIncidentUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateHrIncident>>, TError,{id: string;data: BodyType<HrIncidentUpdate>}, TContext> => {

const mutationKey = ['updateHrIncident'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHrIncident>>, {id: string;data: BodyType<HrIncidentUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateHrIncident(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHrIncidentMutationResult = NonNullable<Awaited<ReturnType<typeof updateHrIncident>>>
    export type UpdateHrIncidentMutationBody = BodyType<HrIncidentUpdate>
    export type UpdateHrIncidentMutationError = ErrorType<unknown>

    export const useUpdateHrIncident = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrIncident>>, TError,{id: string;data: BodyType<HrIncidentUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateHrIncident>>,
        TError,
        {id: string;data: BodyType<HrIncidentUpdate>},
        TContext
      > => {
      return useMutation(getUpdateHrIncidentMutationOptions(options));
    }

export const getListHrStaffTimelineUrl = (id: string,) => {




  return `/api/hr/staff/${id}/timeline`
}

export const listHrStaffTimeline = async (id: string, options?: RequestInit): Promise<HrTimelineEvent[]> => {

  return customFetch<HrTimelineEvent[]>(getListHrStaffTimelineUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHrStaffTimelineQueryKey = (id: string,) => {
    return [
    `/api/hr/staff/${id}/timeline`
    ] as const;
    }


export const getListHrStaffTimelineQueryOptions = <TData = Awaited<ReturnType<typeof listHrStaffTimeline>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrStaffTimeline>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHrStaffTimelineQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHrStaffTimeline>>> = ({ signal }) => listHrStaffTimeline(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHrStaffTimeline>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHrStaffTimelineQueryResult = NonNullable<Awaited<ReturnType<typeof listHrStaffTimeline>>>
export type ListHrStaffTimelineQueryError = ErrorType<unknown>



export function useListHrStaffTimeline<TData = Awaited<ReturnType<typeof listHrStaffTimeline>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrStaffTimeline>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHrStaffTimelineQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetHrSettingsUrl = () => {




  return `/api/hr/settings`
}

export const getHrSettings = async ( options?: RequestInit): Promise<HrSettings> => {

  return customFetch<HrSettings>(getGetHrSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHrSettingsQueryKey = () => {
    return [
    `/api/hr/settings`
    ] as const;
    }


export const getGetHrSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getHrSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHrSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHrSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHrSettings>>> = ({ signal }) => getHrSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHrSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHrSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getHrSettings>>>
export type GetHrSettingsQueryError = ErrorType<unknown>



export function useGetHrSettings<TData = Awaited<ReturnType<typeof getHrSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHrSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetHrSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateHrSettingsUrl = () => {




  return `/api/hr/settings`
}

export const updateHrSettings = async (hrSettingsInput: HrSettingsInput, options?: RequestInit): Promise<HrSettings> => {

  return customFetch<HrSettings>(getUpdateHrSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrSettingsInput)
  }
);}





export const getUpdateHrSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrSettings>>, TError,{data: BodyType<HrSettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateHrSettings>>, TError,{data: BodyType<HrSettingsInput>}, TContext> => {

const mutationKey = ['updateHrSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHrSettings>>, {data: BodyType<HrSettingsInput>}> = (props) => {
          const {data} = props ?? {};

          return  updateHrSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHrSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateHrSettings>>>
    export type UpdateHrSettingsMutationBody = BodyType<HrSettingsInput>
    export type UpdateHrSettingsMutationError = ErrorType<unknown>

    export const useUpdateHrSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrSettings>>, TError,{data: BodyType<HrSettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateHrSettings>>,
        TError,
        {data: BodyType<HrSettingsInput>},
        TContext
      > => {
      return useMutation(getUpdateHrSettingsMutationOptions(options));
    }

export const getListHrPaymentsUrl = (params?: ListHrPaymentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/payments?${stringifiedParams}` : `/api/hr/payments`
}

/**
 * @summary List employee payments (admin/owner-only)
 */
export const listHrPayments = async (params?: ListHrPaymentsParams, options?: RequestInit): Promise<HrPaymentListResponse> => {

  return customFetch<HrPaymentListResponse>(getListHrPaymentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHrPaymentsQueryKey = (params?: ListHrPaymentsParams,) => {
    return [
    `/api/hr/payments`, ...(params ? [params] : [])
    ] as const;
    }


export const getListHrPaymentsQueryOptions = <TData = Awaited<ReturnType<typeof listHrPayments>>, TError = ErrorType<unknown>>(params?: ListHrPaymentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrPayments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHrPaymentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHrPayments>>> = ({ signal }) => listHrPayments(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHrPayments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHrPaymentsQueryResult = NonNullable<Awaited<ReturnType<typeof listHrPayments>>>
export type ListHrPaymentsQueryError = ErrorType<unknown>


/**
 * @summary List employee payments (admin/owner-only)
 */

export function useListHrPayments<TData = Awaited<ReturnType<typeof listHrPayments>>, TError = ErrorType<unknown>>(
 params?: ListHrPaymentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrPayments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHrPaymentsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateHrPaymentUrl = () => {




  return `/api/hr/payments`
}

/**
 * @summary Record an employee payment
 */
export const createHrPayment = async (hrPaymentCreateInput: HrPaymentCreateInput, options?: RequestInit): Promise<HrPayment> => {

  return customFetch<HrPayment>(getCreateHrPaymentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrPaymentCreateInput)
  }
);}





export const getCreateHrPaymentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrPayment>>, TError,{data: BodyType<HrPaymentCreateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createHrPayment>>, TError,{data: BodyType<HrPaymentCreateInput>}, TContext> => {

const mutationKey = ['createHrPayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHrPayment>>, {data: BodyType<HrPaymentCreateInput>}> = (props) => {
          const {data} = props ?? {};

          return  createHrPayment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHrPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof createHrPayment>>>
    export type CreateHrPaymentMutationBody = BodyType<HrPaymentCreateInput>
    export type CreateHrPaymentMutationError = ErrorType<unknown>

    /**
 * @summary Record an employee payment
 */
export const useCreateHrPayment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrPayment>>, TError,{data: BodyType<HrPaymentCreateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createHrPayment>>,
        TError,
        {data: BodyType<HrPaymentCreateInput>},
        TContext
      > => {
      return useMutation(getCreateHrPaymentMutationOptions(options));
    }

export const getUpdateHrPaymentUrl = (id: string,) => {




  return `/api/hr/payments/${id}`
}

export const updateHrPayment = async (id: string,
    hrPaymentUpdateInput: HrPaymentUpdateInput, options?: RequestInit): Promise<HrPayment> => {

  return customFetch<HrPayment>(getUpdateHrPaymentUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrPaymentUpdateInput)
  }
);}





export const getUpdateHrPaymentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrPayment>>, TError,{id: string;data: BodyType<HrPaymentUpdateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateHrPayment>>, TError,{id: string;data: BodyType<HrPaymentUpdateInput>}, TContext> => {

const mutationKey = ['updateHrPayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHrPayment>>, {id: string;data: BodyType<HrPaymentUpdateInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateHrPayment(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHrPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof updateHrPayment>>>
    export type UpdateHrPaymentMutationBody = BodyType<HrPaymentUpdateInput>
    export type UpdateHrPaymentMutationError = ErrorType<unknown>

    export const useUpdateHrPayment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrPayment>>, TError,{id: string;data: BodyType<HrPaymentUpdateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateHrPayment>>,
        TError,
        {id: string;data: BodyType<HrPaymentUpdateInput>},
        TContext
      > => {
      return useMutation(getUpdateHrPaymentMutationOptions(options));
    }

export const getDeleteHrPaymentUrl = (id: string,) => {




  return `/api/hr/payments/${id}`
}

export const deleteHrPayment = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteHrPaymentUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteHrPaymentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHrPayment>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteHrPayment>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteHrPayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHrPayment>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteHrPayment(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteHrPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHrPayment>>>

    export type DeleteHrPaymentMutationError = ErrorType<unknown>

    export const useDeleteHrPayment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHrPayment>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteHrPayment>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteHrPaymentMutationOptions(options));
    }

export const getMarkHrPaymentPaidUrl = (id: string,) => {




  return `/api/hr/payments/${id}/mark-paid`
}

/**
 * @summary Mark an employee payment as paid
 */
export const markHrPaymentPaid = async (id: string,
    hrPaymentMarkPaidInput: HrPaymentMarkPaidInput, options?: RequestInit): Promise<HrPayment> => {

  return customFetch<HrPayment>(getMarkHrPaymentPaidUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrPaymentMarkPaidInput)
  }
);}





export const getMarkHrPaymentPaidMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markHrPaymentPaid>>, TError,{id: string;data: BodyType<HrPaymentMarkPaidInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markHrPaymentPaid>>, TError,{id: string;data: BodyType<HrPaymentMarkPaidInput>}, TContext> => {

const mutationKey = ['markHrPaymentPaid'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markHrPaymentPaid>>, {id: string;data: BodyType<HrPaymentMarkPaidInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  markHrPaymentPaid(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkHrPaymentPaidMutationResult = NonNullable<Awaited<ReturnType<typeof markHrPaymentPaid>>>
    export type MarkHrPaymentPaidMutationBody = BodyType<HrPaymentMarkPaidInput>
    export type MarkHrPaymentPaidMutationError = ErrorType<unknown>

    /**
 * @summary Mark an employee payment as paid
 */
export const useMarkHrPaymentPaid = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markHrPaymentPaid>>, TError,{id: string;data: BodyType<HrPaymentMarkPaidInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markHrPaymentPaid>>,
        TError,
        {id: string;data: BodyType<HrPaymentMarkPaidInput>},
        TContext
      > => {
      return useMutation(getMarkHrPaymentPaidMutationOptions(options));
    }

export const getGetHrPayCadenceUrl = (id: string,) => {




  return `/api/hr/staff/${id}/pay-cadence`
}

/**
 * @summary Get a staff member's pay cadence
 */
export const getHrPayCadence = async (id: string, options?: RequestInit): Promise<HrPayCadence | null> => {

  return customFetch<HrPayCadence | null>(getGetHrPayCadenceUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHrPayCadenceQueryKey = (id: string,) => {
    return [
    `/api/hr/staff/${id}/pay-cadence`
    ] as const;
    }


export const getGetHrPayCadenceQueryOptions = <TData = Awaited<ReturnType<typeof getHrPayCadence>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHrPayCadence>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHrPayCadenceQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHrPayCadence>>> = ({ signal }) => getHrPayCadence(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHrPayCadence>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHrPayCadenceQueryResult = NonNullable<Awaited<ReturnType<typeof getHrPayCadence>>>
export type GetHrPayCadenceQueryError = ErrorType<unknown>


/**
 * @summary Get a staff member's pay cadence
 */

export function useGetHrPayCadence<TData = Awaited<ReturnType<typeof getHrPayCadence>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHrPayCadence>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetHrPayCadenceQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPutHrPayCadenceUrl = (id: string,) => {




  return `/api/hr/staff/${id}/pay-cadence`
}

/**
 * @summary Create or update a staff member's pay cadence
 */
export const putHrPayCadence = async (id: string,
    hrPayCadenceInput: HrPayCadenceInput, options?: RequestInit): Promise<HrPayCadence> => {

  return customFetch<HrPayCadence>(getPutHrPayCadenceUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrPayCadenceInput)
  }
);}





export const getPutHrPayCadenceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putHrPayCadence>>, TError,{id: string;data: BodyType<HrPayCadenceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putHrPayCadence>>, TError,{id: string;data: BodyType<HrPayCadenceInput>}, TContext> => {

const mutationKey = ['putHrPayCadence'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putHrPayCadence>>, {id: string;data: BodyType<HrPayCadenceInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  putHrPayCadence(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutHrPayCadenceMutationResult = NonNullable<Awaited<ReturnType<typeof putHrPayCadence>>>
    export type PutHrPayCadenceMutationBody = BodyType<HrPayCadenceInput>
    export type PutHrPayCadenceMutationError = ErrorType<unknown>

    /**
 * @summary Create or update a staff member's pay cadence
 */
export const usePutHrPayCadence = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putHrPayCadence>>, TError,{id: string;data: BodyType<HrPayCadenceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putHrPayCadence>>,
        TError,
        {id: string;data: BodyType<HrPayCadenceInput>},
        TContext
      > => {
      return useMutation(getPutHrPayCadenceMutationOptions(options));
    }

export const getListHrAuditUrl = (params?: ListHrAuditParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/audit?${stringifiedParams}` : `/api/hr/audit`
}

/**
 * @summary HR audit log
 */
export const listHrAudit = async (params?: ListHrAuditParams, options?: RequestInit): Promise<HrAuditListResponse> => {

  return customFetch<HrAuditListResponse>(getListHrAuditUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHrAuditQueryKey = (params?: ListHrAuditParams,) => {
    return [
    `/api/hr/audit`, ...(params ? [params] : [])
    ] as const;
    }


export const getListHrAuditQueryOptions = <TData = Awaited<ReturnType<typeof listHrAudit>>, TError = ErrorType<unknown>>(params?: ListHrAuditParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrAudit>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHrAuditQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHrAudit>>> = ({ signal }) => listHrAudit(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHrAudit>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHrAuditQueryResult = NonNullable<Awaited<ReturnType<typeof listHrAudit>>>
export type ListHrAuditQueryError = ErrorType<unknown>


/**
 * @summary HR audit log
 */

export function useListHrAudit<TData = Awaited<ReturnType<typeof listHrAudit>>, TError = ErrorType<unknown>>(
 params?: ListHrAuditParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrAudit>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHrAuditQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetHrMyRecordUrl = () => {




  return `/api/hr/me`
}

/**
 * @summary Current user's own staff record + self-service visibility
 */
export const getHrMyRecord = async ( options?: RequestInit): Promise<HrSelfRecord> => {

  return customFetch<HrSelfRecord>(getGetHrMyRecordUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHrMyRecordQueryKey = () => {
    return [
    `/api/hr/me`
    ] as const;
    }


export const getGetHrMyRecordQueryOptions = <TData = Awaited<ReturnType<typeof getHrMyRecord>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHrMyRecord>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHrMyRecordQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHrMyRecord>>> = ({ signal }) => getHrMyRecord({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHrMyRecord>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHrMyRecordQueryResult = NonNullable<Awaited<ReturnType<typeof getHrMyRecord>>>
export type GetHrMyRecordQueryError = ErrorType<unknown>


/**
 * @summary Current user's own staff record + self-service visibility
 */

export function useGetHrMyRecord<TData = Awaited<ReturnType<typeof getHrMyRecord>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHrMyRecord>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetHrMyRecordQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListHrMyChangeRequestsUrl = () => {




  return `/api/hr/me/change-requests`
}

export const listHrMyChangeRequests = async ( options?: RequestInit): Promise<HrChangeRequest[]> => {

  return customFetch<HrChangeRequest[]>(getListHrMyChangeRequestsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHrMyChangeRequestsQueryKey = () => {
    return [
    `/api/hr/me/change-requests`
    ] as const;
    }


export const getListHrMyChangeRequestsQueryOptions = <TData = Awaited<ReturnType<typeof listHrMyChangeRequests>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrMyChangeRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHrMyChangeRequestsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHrMyChangeRequests>>> = ({ signal }) => listHrMyChangeRequests({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHrMyChangeRequests>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHrMyChangeRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof listHrMyChangeRequests>>>
export type ListHrMyChangeRequestsQueryError = ErrorType<unknown>



export function useListHrMyChangeRequests<TData = Awaited<ReturnType<typeof listHrMyChangeRequests>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrMyChangeRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHrMyChangeRequestsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateHrMyChangeRequestUrl = () => {




  return `/api/hr/me/change-requests`
}

export const createHrMyChangeRequest = async (hrMyChangeRequestInput: HrMyChangeRequestInput, options?: RequestInit): Promise<HrChangeRequest> => {

  return customFetch<HrChangeRequest>(getCreateHrMyChangeRequestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrMyChangeRequestInput)
  }
);}





export const getCreateHrMyChangeRequestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrMyChangeRequest>>, TError,{data: BodyType<HrMyChangeRequestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createHrMyChangeRequest>>, TError,{data: BodyType<HrMyChangeRequestInput>}, TContext> => {

const mutationKey = ['createHrMyChangeRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHrMyChangeRequest>>, {data: BodyType<HrMyChangeRequestInput>}> = (props) => {
          const {data} = props ?? {};

          return  createHrMyChangeRequest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHrMyChangeRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createHrMyChangeRequest>>>
    export type CreateHrMyChangeRequestMutationBody = BodyType<HrMyChangeRequestInput>
    export type CreateHrMyChangeRequestMutationError = ErrorType<unknown>

    export const useCreateHrMyChangeRequest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrMyChangeRequest>>, TError,{data: BodyType<HrMyChangeRequestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createHrMyChangeRequest>>,
        TError,
        {data: BodyType<HrMyChangeRequestInput>},
        TContext
      > => {
      return useMutation(getCreateHrMyChangeRequestMutationOptions(options));
    }

export const getListHrMyTimeOffUrl = () => {




  return `/api/hr/me/time-off`
}

export const listHrMyTimeOff = async ( options?: RequestInit): Promise<HrTimeOffRequest[]> => {

  return customFetch<HrTimeOffRequest[]>(getListHrMyTimeOffUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHrMyTimeOffQueryKey = () => {
    return [
    `/api/hr/me/time-off`
    ] as const;
    }


export const getListHrMyTimeOffQueryOptions = <TData = Awaited<ReturnType<typeof listHrMyTimeOff>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrMyTimeOff>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHrMyTimeOffQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHrMyTimeOff>>> = ({ signal }) => listHrMyTimeOff({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHrMyTimeOff>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHrMyTimeOffQueryResult = NonNullable<Awaited<ReturnType<typeof listHrMyTimeOff>>>
export type ListHrMyTimeOffQueryError = ErrorType<unknown>



export function useListHrMyTimeOff<TData = Awaited<ReturnType<typeof listHrMyTimeOff>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrMyTimeOff>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHrMyTimeOffQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateHrMyTimeOffUrl = () => {




  return `/api/hr/me/time-off`
}

export const createHrMyTimeOff = async (hrMyTimeOffInput: HrMyTimeOffInput, options?: RequestInit): Promise<HrTimeOffRequest> => {

  return customFetch<HrTimeOffRequest>(getCreateHrMyTimeOffUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrMyTimeOffInput)
  }
);}





export const getCreateHrMyTimeOffMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrMyTimeOff>>, TError,{data: BodyType<HrMyTimeOffInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createHrMyTimeOff>>, TError,{data: BodyType<HrMyTimeOffInput>}, TContext> => {

const mutationKey = ['createHrMyTimeOff'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHrMyTimeOff>>, {data: BodyType<HrMyTimeOffInput>}> = (props) => {
          const {data} = props ?? {};

          return  createHrMyTimeOff(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHrMyTimeOffMutationResult = NonNullable<Awaited<ReturnType<typeof createHrMyTimeOff>>>
    export type CreateHrMyTimeOffMutationBody = BodyType<HrMyTimeOffInput>
    export type CreateHrMyTimeOffMutationError = ErrorType<unknown>

    export const useCreateHrMyTimeOff = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrMyTimeOff>>, TError,{data: BodyType<HrMyTimeOffInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createHrMyTimeOff>>,
        TError,
        {data: BodyType<HrMyTimeOffInput>},
        TContext
      > => {
      return useMutation(getCreateHrMyTimeOffMutationOptions(options));
    }

export const getCancelHrMyTimeOffUrl = (id: string,) => {




  return `/api/hr/me/time-off/${id}/cancel`
}

export const cancelHrMyTimeOff = async (id: string, options?: RequestInit): Promise<HrTimeOffRequest> => {

  return customFetch<HrTimeOffRequest>(getCancelHrMyTimeOffUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelHrMyTimeOffMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelHrMyTimeOff>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelHrMyTimeOff>>, TError,{id: string}, TContext> => {

const mutationKey = ['cancelHrMyTimeOff'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelHrMyTimeOff>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  cancelHrMyTimeOff(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelHrMyTimeOffMutationResult = NonNullable<Awaited<ReturnType<typeof cancelHrMyTimeOff>>>

    export type CancelHrMyTimeOffMutationError = ErrorType<unknown>

    export const useCancelHrMyTimeOff = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelHrMyTimeOff>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelHrMyTimeOff>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getCancelHrMyTimeOffMutationOptions(options));
    }

export const getListHrMyDocumentsUrl = () => {




  return `/api/hr/me/documents`
}

export const listHrMyDocuments = async ( options?: RequestInit): Promise<HrDocument[]> => {

  return customFetch<HrDocument[]>(getListHrMyDocumentsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHrMyDocumentsQueryKey = () => {
    return [
    `/api/hr/me/documents`
    ] as const;
    }


export const getListHrMyDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof listHrMyDocuments>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrMyDocuments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHrMyDocumentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHrMyDocuments>>> = ({ signal }) => listHrMyDocuments({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHrMyDocuments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHrMyDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listHrMyDocuments>>>
export type ListHrMyDocumentsQueryError = ErrorType<unknown>



export function useListHrMyDocuments<TData = Awaited<ReturnType<typeof listHrMyDocuments>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrMyDocuments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHrMyDocumentsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateHrMyDocumentUrl = () => {




  return `/api/hr/me/documents`
}

export const createHrMyDocument = async (hrMyDocumentInput: HrMyDocumentInput, options?: RequestInit): Promise<HrDocument> => {

  return customFetch<HrDocument>(getCreateHrMyDocumentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrMyDocumentInput)
  }
);}





export const getCreateHrMyDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrMyDocument>>, TError,{data: BodyType<HrMyDocumentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createHrMyDocument>>, TError,{data: BodyType<HrMyDocumentInput>}, TContext> => {

const mutationKey = ['createHrMyDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHrMyDocument>>, {data: BodyType<HrMyDocumentInput>}> = (props) => {
          const {data} = props ?? {};

          return  createHrMyDocument(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHrMyDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof createHrMyDocument>>>
    export type CreateHrMyDocumentMutationBody = BodyType<HrMyDocumentInput>
    export type CreateHrMyDocumentMutationError = ErrorType<unknown>

    export const useCreateHrMyDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrMyDocument>>, TError,{data: BodyType<HrMyDocumentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createHrMyDocument>>,
        TError,
        {data: BodyType<HrMyDocumentInput>},
        TContext
      > => {
      return useMutation(getCreateHrMyDocumentMutationOptions(options));
    }

export const getListHrMyOnboardingUrl = () => {




  return `/api/hr/me/onboarding`
}

export const listHrMyOnboarding = async ( options?: RequestInit): Promise<HrOnboardingItem[]> => {

  return customFetch<HrOnboardingItem[]>(getListHrMyOnboardingUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHrMyOnboardingQueryKey = () => {
    return [
    `/api/hr/me/onboarding`
    ] as const;
    }


export const getListHrMyOnboardingQueryOptions = <TData = Awaited<ReturnType<typeof listHrMyOnboarding>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrMyOnboarding>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHrMyOnboardingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHrMyOnboarding>>> = ({ signal }) => listHrMyOnboarding({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHrMyOnboarding>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHrMyOnboardingQueryResult = NonNullable<Awaited<ReturnType<typeof listHrMyOnboarding>>>
export type ListHrMyOnboardingQueryError = ErrorType<unknown>



export function useListHrMyOnboarding<TData = Awaited<ReturnType<typeof listHrMyOnboarding>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrMyOnboarding>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHrMyOnboardingQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListHrMyTrainingUrl = () => {




  return `/api/hr/me/training`
}

export const listHrMyTraining = async ( options?: RequestInit): Promise<HrTrainingRecord[]> => {

  return customFetch<HrTrainingRecord[]>(getListHrMyTrainingUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHrMyTrainingQueryKey = () => {
    return [
    `/api/hr/me/training`
    ] as const;
    }


export const getListHrMyTrainingQueryOptions = <TData = Awaited<ReturnType<typeof listHrMyTraining>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrMyTraining>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHrMyTrainingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHrMyTraining>>> = ({ signal }) => listHrMyTraining({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHrMyTraining>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHrMyTrainingQueryResult = NonNullable<Awaited<ReturnType<typeof listHrMyTraining>>>
export type ListHrMyTrainingQueryError = ErrorType<unknown>



export function useListHrMyTraining<TData = Awaited<ReturnType<typeof listHrMyTraining>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrMyTraining>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHrMyTrainingQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListHrMyAbsencesUrl = () => {




  return `/api/hr/me/absences`
}

export const listHrMyAbsences = async ( options?: RequestInit): Promise<HrAbsence[]> => {

  return customFetch<HrAbsence[]>(getListHrMyAbsencesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHrMyAbsencesQueryKey = () => {
    return [
    `/api/hr/me/absences`
    ] as const;
    }


export const getListHrMyAbsencesQueryOptions = <TData = Awaited<ReturnType<typeof listHrMyAbsences>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrMyAbsences>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHrMyAbsencesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHrMyAbsences>>> = ({ signal }) => listHrMyAbsences({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHrMyAbsences>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHrMyAbsencesQueryResult = NonNullable<Awaited<ReturnType<typeof listHrMyAbsences>>>
export type ListHrMyAbsencesQueryError = ErrorType<unknown>



export function useListHrMyAbsences<TData = Awaited<ReturnType<typeof listHrMyAbsences>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrMyAbsences>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHrMyAbsencesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListHrMyCommunicationsUrl = () => {




  return `/api/hr/me/communications`
}

export const listHrMyCommunications = async ( options?: RequestInit): Promise<HrCommunication[]> => {

  return customFetch<HrCommunication[]>(getListHrMyCommunicationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHrMyCommunicationsQueryKey = () => {
    return [
    `/api/hr/me/communications`
    ] as const;
    }


export const getListHrMyCommunicationsQueryOptions = <TData = Awaited<ReturnType<typeof listHrMyCommunications>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrMyCommunications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHrMyCommunicationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHrMyCommunications>>> = ({ signal }) => listHrMyCommunications({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHrMyCommunications>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHrMyCommunicationsQueryResult = NonNullable<Awaited<ReturnType<typeof listHrMyCommunications>>>
export type ListHrMyCommunicationsQueryError = ErrorType<unknown>



export function useListHrMyCommunications<TData = Awaited<ReturnType<typeof listHrMyCommunications>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrMyCommunications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHrMyCommunicationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListHrMyShiftsUrl = () => {




  return `/api/hr/me/shifts`
}

/**
 * @summary List the signed-in employee's own upcoming rota shifts
 */
export const listHrMyShifts = async ( options?: RequestInit): Promise<HrShift[]> => {

  return customFetch<HrShift[]>(getListHrMyShiftsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHrMyShiftsQueryKey = () => {
    return [
    `/api/hr/me/shifts`
    ] as const;
    }


export const getListHrMyShiftsQueryOptions = <TData = Awaited<ReturnType<typeof listHrMyShifts>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrMyShifts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHrMyShiftsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHrMyShifts>>> = ({ signal }) => listHrMyShifts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHrMyShifts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHrMyShiftsQueryResult = NonNullable<Awaited<ReturnType<typeof listHrMyShifts>>>
export type ListHrMyShiftsQueryError = ErrorType<unknown>


/**
 * @summary List the signed-in employee's own upcoming rota shifts
 */

export function useListHrMyShifts<TData = Awaited<ReturnType<typeof listHrMyShifts>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrMyShifts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHrMyShiftsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetHrPerformanceSummaryUrl = (params?: GetHrPerformanceSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/performance/summary?${stringifiedParams}` : `/api/hr/performance/summary`
}

/**
 * @summary Team performance summary + per-employee leaderboard
 */
export const getHrPerformanceSummary = async (params?: GetHrPerformanceSummaryParams, options?: RequestInit): Promise<HrPerformanceSummary> => {

  return customFetch<HrPerformanceSummary>(getGetHrPerformanceSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHrPerformanceSummaryQueryKey = (params?: GetHrPerformanceSummaryParams,) => {
    return [
    `/api/hr/performance/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetHrPerformanceSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getHrPerformanceSummary>>, TError = ErrorType<unknown>>(params?: GetHrPerformanceSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHrPerformanceSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHrPerformanceSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHrPerformanceSummary>>> = ({ signal }) => getHrPerformanceSummary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHrPerformanceSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHrPerformanceSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getHrPerformanceSummary>>>
export type GetHrPerformanceSummaryQueryError = ErrorType<unknown>


/**
 * @summary Team performance summary + per-employee leaderboard
 */

export function useGetHrPerformanceSummary<TData = Awaited<ReturnType<typeof getHrPerformanceSummary>>, TError = ErrorType<unknown>>(
 params?: GetHrPerformanceSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHrPerformanceSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetHrPerformanceSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetHrPerformanceStaffUrl = (params: GetHrPerformanceStaffParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/performance/staff?${stringifiedParams}` : `/api/hr/performance/staff`
}

/**
 * @summary Per-employee performance drill-down
 */
export const getHrPerformanceStaff = async (params: GetHrPerformanceStaffParams, options?: RequestInit): Promise<HrPerformanceStaffDetail> => {

  return customFetch<HrPerformanceStaffDetail>(getGetHrPerformanceStaffUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHrPerformanceStaffQueryKey = (params?: GetHrPerformanceStaffParams,) => {
    return [
    `/api/hr/performance/staff`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetHrPerformanceStaffQueryOptions = <TData = Awaited<ReturnType<typeof getHrPerformanceStaff>>, TError = ErrorType<unknown>>(params: GetHrPerformanceStaffParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHrPerformanceStaff>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHrPerformanceStaffQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHrPerformanceStaff>>> = ({ signal }) => getHrPerformanceStaff(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHrPerformanceStaff>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHrPerformanceStaffQueryResult = NonNullable<Awaited<ReturnType<typeof getHrPerformanceStaff>>>
export type GetHrPerformanceStaffQueryError = ErrorType<unknown>


/**
 * @summary Per-employee performance drill-down
 */

export function useGetHrPerformanceStaff<TData = Awaited<ReturnType<typeof getHrPerformanceStaff>>, TError = ErrorType<unknown>>(
 params: GetHrPerformanceStaffParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHrPerformanceStaff>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetHrPerformanceStaffQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateHrStaffScheduleUrl = (id: string,) => {




  return `/api/hr/performance/staff/${id}/schedule`
}

/**
 * @summary Set an employee's expected working schedule
 */
export const updateHrStaffSchedule = async (id: string,
    hrStaffScheduleInput: HrStaffScheduleInput, options?: RequestInit): Promise<HrStaffSchedule> => {

  return customFetch<HrStaffSchedule>(getUpdateHrStaffScheduleUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrStaffScheduleInput)
  }
);}





export const getUpdateHrStaffScheduleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrStaffSchedule>>, TError,{id: string;data: BodyType<HrStaffScheduleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateHrStaffSchedule>>, TError,{id: string;data: BodyType<HrStaffScheduleInput>}, TContext> => {

const mutationKey = ['updateHrStaffSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHrStaffSchedule>>, {id: string;data: BodyType<HrStaffScheduleInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateHrStaffSchedule(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHrStaffScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof updateHrStaffSchedule>>>
    export type UpdateHrStaffScheduleMutationBody = BodyType<HrStaffScheduleInput>
    export type UpdateHrStaffScheduleMutationError = ErrorType<unknown>

    /**
 * @summary Set an employee's expected working schedule
 */
export const useUpdateHrStaffSchedule = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrStaffSchedule>>, TError,{id: string;data: BodyType<HrStaffScheduleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateHrStaffSchedule>>,
        TError,
        {id: string;data: BodyType<HrStaffScheduleInput>},
        TContext
      > => {
      return useMutation(getUpdateHrStaffScheduleMutationOptions(options));
    }

export const getListHrClockEventsUrl = (params: ListHrClockEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/performance/clock-events?${stringifiedParams}` : `/api/hr/performance/clock-events`
}

/**
 * @summary List clock in/out events for an employee in a range
 */
export const listHrClockEvents = async (params: ListHrClockEventsParams, options?: RequestInit): Promise<HrClockEvent[]> => {

  return customFetch<HrClockEvent[]>(getListHrClockEventsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHrClockEventsQueryKey = (params?: ListHrClockEventsParams,) => {
    return [
    `/api/hr/performance/clock-events`, ...(params ? [params] : [])
    ] as const;
    }


export const getListHrClockEventsQueryOptions = <TData = Awaited<ReturnType<typeof listHrClockEvents>>, TError = ErrorType<unknown>>(params: ListHrClockEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrClockEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHrClockEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHrClockEvents>>> = ({ signal }) => listHrClockEvents(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHrClockEvents>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHrClockEventsQueryResult = NonNullable<Awaited<ReturnType<typeof listHrClockEvents>>>
export type ListHrClockEventsQueryError = ErrorType<unknown>


/**
 * @summary List clock in/out events for an employee in a range
 */

export function useListHrClockEvents<TData = Awaited<ReturnType<typeof listHrClockEvents>>, TError = ErrorType<unknown>>(
 params: ListHrClockEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrClockEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHrClockEventsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateHrClockEventUrl = () => {




  return `/api/hr/performance/clock-events`
}

/**
 * @summary Record a clock in/out event (admin override)
 */
export const createHrClockEvent = async (hrClockEventInput: HrClockEventInput, options?: RequestInit): Promise<HrClockEvent> => {

  return customFetch<HrClockEvent>(getCreateHrClockEventUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrClockEventInput)
  }
);}





export const getCreateHrClockEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrClockEvent>>, TError,{data: BodyType<HrClockEventInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createHrClockEvent>>, TError,{data: BodyType<HrClockEventInput>}, TContext> => {

const mutationKey = ['createHrClockEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHrClockEvent>>, {data: BodyType<HrClockEventInput>}> = (props) => {
          const {data} = props ?? {};

          return  createHrClockEvent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHrClockEventMutationResult = NonNullable<Awaited<ReturnType<typeof createHrClockEvent>>>
    export type CreateHrClockEventMutationBody = BodyType<HrClockEventInput>
    export type CreateHrClockEventMutationError = ErrorType<unknown>

    /**
 * @summary Record a clock in/out event (admin override)
 */
export const useCreateHrClockEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrClockEvent>>, TError,{data: BodyType<HrClockEventInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createHrClockEvent>>,
        TError,
        {data: BodyType<HrClockEventInput>},
        TContext
      > => {
      return useMutation(getCreateHrClockEventMutationOptions(options));
    }

export const getUpdateHrClockEventUrl = (eventId: string,) => {




  return `/api/hr/performance/clock-events/${eventId}`
}

/**
 * @summary Edit a clock in/out event (admin override)
 */
export const updateHrClockEvent = async (eventId: string,
    hrClockEventUpdate: HrClockEventUpdate, options?: RequestInit): Promise<HrClockEvent> => {

  return customFetch<HrClockEvent>(getUpdateHrClockEventUrl(eventId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrClockEventUpdate)
  }
);}





export const getUpdateHrClockEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrClockEvent>>, TError,{eventId: string;data: BodyType<HrClockEventUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateHrClockEvent>>, TError,{eventId: string;data: BodyType<HrClockEventUpdate>}, TContext> => {

const mutationKey = ['updateHrClockEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHrClockEvent>>, {eventId: string;data: BodyType<HrClockEventUpdate>}> = (props) => {
          const {eventId,data} = props ?? {};

          return  updateHrClockEvent(eventId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHrClockEventMutationResult = NonNullable<Awaited<ReturnType<typeof updateHrClockEvent>>>
    export type UpdateHrClockEventMutationBody = BodyType<HrClockEventUpdate>
    export type UpdateHrClockEventMutationError = ErrorType<unknown>

    /**
 * @summary Edit a clock in/out event (admin override)
 */
export const useUpdateHrClockEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrClockEvent>>, TError,{eventId: string;data: BodyType<HrClockEventUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateHrClockEvent>>,
        TError,
        {eventId: string;data: BodyType<HrClockEventUpdate>},
        TContext
      > => {
      return useMutation(getUpdateHrClockEventMutationOptions(options));
    }

export const getDeleteHrClockEventUrl = (eventId: string,) => {




  return `/api/hr/performance/clock-events/${eventId}`
}

/**
 * @summary Delete a clock in/out event
 */
export const deleteHrClockEvent = async (eventId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteHrClockEventUrl(eventId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteHrClockEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHrClockEvent>>, TError,{eventId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteHrClockEvent>>, TError,{eventId: string}, TContext> => {

const mutationKey = ['deleteHrClockEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHrClockEvent>>, {eventId: string}> = (props) => {
          const {eventId} = props ?? {};

          return  deleteHrClockEvent(eventId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteHrClockEventMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHrClockEvent>>>

    export type DeleteHrClockEventMutationError = ErrorType<unknown>

    /**
 * @summary Delete a clock in/out event
 */
export const useDeleteHrClockEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHrClockEvent>>, TError,{eventId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteHrClockEvent>>,
        TError,
        {eventId: string},
        TContext
      > => {
      return useMutation(getDeleteHrClockEventMutationOptions(options));
    }

export const getUpdateHrLossAttributionUrl = (lossId: string,) => {




  return `/api/hr/performance/losses/${lossId}/attribution`
}

/**
 * @summary Attribute (or clear) a loss to an employee
 */
export const updateHrLossAttribution = async (lossId: string,
    hrLossAttributionInput: HrLossAttributionInput, options?: RequestInit): Promise<HrPerformanceLossRow> => {

  return customFetch<HrPerformanceLossRow>(getUpdateHrLossAttributionUrl(lossId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrLossAttributionInput)
  }
);}





export const getUpdateHrLossAttributionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrLossAttribution>>, TError,{lossId: string;data: BodyType<HrLossAttributionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateHrLossAttribution>>, TError,{lossId: string;data: BodyType<HrLossAttributionInput>}, TContext> => {

const mutationKey = ['updateHrLossAttribution'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHrLossAttribution>>, {lossId: string;data: BodyType<HrLossAttributionInput>}> = (props) => {
          const {lossId,data} = props ?? {};

          return  updateHrLossAttribution(lossId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHrLossAttributionMutationResult = NonNullable<Awaited<ReturnType<typeof updateHrLossAttribution>>>
    export type UpdateHrLossAttributionMutationBody = BodyType<HrLossAttributionInput>
    export type UpdateHrLossAttributionMutationError = ErrorType<unknown>

    /**
 * @summary Attribute (or clear) a loss to an employee
 */
export const useUpdateHrLossAttribution = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrLossAttribution>>, TError,{lossId: string;data: BodyType<HrLossAttributionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateHrLossAttribution>>,
        TError,
        {lossId: string;data: BodyType<HrLossAttributionInput>},
        TContext
      > => {
      return useMutation(getUpdateHrLossAttributionMutationOptions(options));
    }

export const getListHrShiftsUrl = (params?: ListHrShiftsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/performance/shifts?${stringifiedParams}` : `/api/hr/performance/shifts`
}

/**
 * @summary List rota shifts in a date range (optionally for one employee)
 */
export const listHrShifts = async (params?: ListHrShiftsParams, options?: RequestInit): Promise<HrShift[]> => {

  return customFetch<HrShift[]>(getListHrShiftsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHrShiftsQueryKey = (params?: ListHrShiftsParams,) => {
    return [
    `/api/hr/performance/shifts`, ...(params ? [params] : [])
    ] as const;
    }


export const getListHrShiftsQueryOptions = <TData = Awaited<ReturnType<typeof listHrShifts>>, TError = ErrorType<unknown>>(params?: ListHrShiftsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrShifts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHrShiftsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHrShifts>>> = ({ signal }) => listHrShifts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHrShifts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHrShiftsQueryResult = NonNullable<Awaited<ReturnType<typeof listHrShifts>>>
export type ListHrShiftsQueryError = ErrorType<unknown>


/**
 * @summary List rota shifts in a date range (optionally for one employee)
 */

export function useListHrShifts<TData = Awaited<ReturnType<typeof listHrShifts>>, TError = ErrorType<unknown>>(
 params?: ListHrShiftsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHrShifts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHrShiftsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateHrShiftUrl = () => {




  return `/api/hr/performance/shifts`
}

/**
 * @summary Assign a rota shift to an employee (fires hr_shift_assigned)
 */
export const createHrShift = async (hrShiftInput: HrShiftInput, options?: RequestInit): Promise<HrShift> => {

  return customFetch<HrShift>(getCreateHrShiftUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrShiftInput)
  }
);}





export const getCreateHrShiftMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrShift>>, TError,{data: BodyType<HrShiftInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createHrShift>>, TError,{data: BodyType<HrShiftInput>}, TContext> => {

const mutationKey = ['createHrShift'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHrShift>>, {data: BodyType<HrShiftInput>}> = (props) => {
          const {data} = props ?? {};

          return  createHrShift(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHrShiftMutationResult = NonNullable<Awaited<ReturnType<typeof createHrShift>>>
    export type CreateHrShiftMutationBody = BodyType<HrShiftInput>
    export type CreateHrShiftMutationError = ErrorType<unknown>

    /**
 * @summary Assign a rota shift to an employee (fires hr_shift_assigned)
 */
export const useCreateHrShift = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHrShift>>, TError,{data: BodyType<HrShiftInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createHrShift>>,
        TError,
        {data: BodyType<HrShiftInput>},
        TContext
      > => {
      return useMutation(getCreateHrShiftMutationOptions(options));
    }

export const getGetHrShiftTimeOffOverlapUrl = (params: GetHrShiftTimeOffOverlapParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/performance/time-off-overlap?${stringifiedParams}` : `/api/hr/performance/time-off-overlap`
}

/**
 * @summary Approved time-off for an employee overlapping a date (rota conflict warning)
 */
export const getHrShiftTimeOffOverlap = async (params: GetHrShiftTimeOffOverlapParams, options?: RequestInit): Promise<HrTimeOffOverlap[]> => {

  return customFetch<HrTimeOffOverlap[]>(getGetHrShiftTimeOffOverlapUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHrShiftTimeOffOverlapQueryKey = (params?: GetHrShiftTimeOffOverlapParams,) => {
    return [
    `/api/hr/performance/time-off-overlap`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetHrShiftTimeOffOverlapQueryOptions = <TData = Awaited<ReturnType<typeof getHrShiftTimeOffOverlap>>, TError = ErrorType<unknown>>(params: GetHrShiftTimeOffOverlapParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHrShiftTimeOffOverlap>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHrShiftTimeOffOverlapQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHrShiftTimeOffOverlap>>> = ({ signal }) => getHrShiftTimeOffOverlap(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHrShiftTimeOffOverlap>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHrShiftTimeOffOverlapQueryResult = NonNullable<Awaited<ReturnType<typeof getHrShiftTimeOffOverlap>>>
export type GetHrShiftTimeOffOverlapQueryError = ErrorType<unknown>


/**
 * @summary Approved time-off for an employee overlapping a date (rota conflict warning)
 */

export function useGetHrShiftTimeOffOverlap<TData = Awaited<ReturnType<typeof getHrShiftTimeOffOverlap>>, TError = ErrorType<unknown>>(
 params: GetHrShiftTimeOffOverlapParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHrShiftTimeOffOverlap>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetHrShiftTimeOffOverlapQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateHrShiftUrl = (shiftId: string,) => {




  return `/api/hr/performance/shifts/${shiftId}`
}

/**
 * @summary Update a rota shift (reassign/date change re-fires hr_shift_assigned)
 */
export const updateHrShift = async (shiftId: string,
    hrShiftUpdate: HrShiftUpdate, options?: RequestInit): Promise<HrShift> => {

  return customFetch<HrShift>(getUpdateHrShiftUrl(shiftId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hrShiftUpdate)
  }
);}





export const getUpdateHrShiftMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrShift>>, TError,{shiftId: string;data: BodyType<HrShiftUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateHrShift>>, TError,{shiftId: string;data: BodyType<HrShiftUpdate>}, TContext> => {

const mutationKey = ['updateHrShift'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHrShift>>, {shiftId: string;data: BodyType<HrShiftUpdate>}> = (props) => {
          const {shiftId,data} = props ?? {};

          return  updateHrShift(shiftId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHrShiftMutationResult = NonNullable<Awaited<ReturnType<typeof updateHrShift>>>
    export type UpdateHrShiftMutationBody = BodyType<HrShiftUpdate>
    export type UpdateHrShiftMutationError = ErrorType<unknown>

    /**
 * @summary Update a rota shift (reassign/date change re-fires hr_shift_assigned)
 */
export const useUpdateHrShift = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHrShift>>, TError,{shiftId: string;data: BodyType<HrShiftUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateHrShift>>,
        TError,
        {shiftId: string;data: BodyType<HrShiftUpdate>},
        TContext
      > => {
      return useMutation(getUpdateHrShiftMutationOptions(options));
    }

export const getDeleteHrShiftUrl = (shiftId: string,) => {




  return `/api/hr/performance/shifts/${shiftId}`
}

/**
 * @summary Delete a rota shift
 */
export const deleteHrShift = async (shiftId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteHrShiftUrl(shiftId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteHrShiftMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHrShift>>, TError,{shiftId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteHrShift>>, TError,{shiftId: string}, TContext> => {

const mutationKey = ['deleteHrShift'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHrShift>>, {shiftId: string}> = (props) => {
          const {shiftId} = props ?? {};

          return  deleteHrShift(shiftId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteHrShiftMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHrShift>>>

    export type DeleteHrShiftMutationError = ErrorType<unknown>

    /**
 * @summary Delete a rota shift
 */
export const useDeleteHrShift = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHrShift>>, TError,{shiftId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteHrShift>>,
        TError,
        {shiftId: string},
        TContext
      > => {
      return useMutation(getDeleteHrShiftMutationOptions(options));
    }

export const getGetReturnsOverviewUrl = () => {




  return `/api/returns/overview`
}

/**
 * @summary Returns dashboard summary counts
 */
export const getReturnsOverview = async ( options?: RequestInit): Promise<ReturnsOverview> => {

  return customFetch<ReturnsOverview>(getGetReturnsOverviewUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReturnsOverviewQueryKey = () => {
    return [
    `/api/returns/overview`
    ] as const;
    }


export const getGetReturnsOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getReturnsOverview>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReturnsOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReturnsOverviewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReturnsOverview>>> = ({ signal }) => getReturnsOverview({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReturnsOverview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetReturnsOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getReturnsOverview>>>
export type GetReturnsOverviewQueryError = ErrorType<unknown>


/**
 * @summary Returns dashboard summary counts
 */

export function useGetReturnsOverview<TData = Awaited<ReturnType<typeof getReturnsOverview>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReturnsOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetReturnsOverviewQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListReturnsUrl = (params?: ListReturnsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/returns?${stringifiedParams}` : `/api/returns`
}

/**
 * @summary List returns
 */
export const listReturns = async (params?: ListReturnsParams, options?: RequestInit): Promise<ReturnListResponse> => {

  return customFetch<ReturnListResponse>(getListReturnsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListReturnsQueryKey = (params?: ListReturnsParams,) => {
    return [
    `/api/returns`, ...(params ? [params] : [])
    ] as const;
    }


export const getListReturnsQueryOptions = <TData = Awaited<ReturnType<typeof listReturns>>, TError = ErrorType<unknown>>(params?: ListReturnsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReturns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListReturnsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listReturns>>> = ({ signal }) => listReturns(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listReturns>>, TError, TData> & { queryKey: QueryKey }
}

export type ListReturnsQueryResult = NonNullable<Awaited<ReturnType<typeof listReturns>>>
export type ListReturnsQueryError = ErrorType<unknown>


/**
 * @summary List returns
 */

export function useListReturns<TData = Awaited<ReturnType<typeof listReturns>>, TError = ErrorType<unknown>>(
 params?: ListReturnsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReturns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListReturnsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateReturnUrl = () => {




  return `/api/returns`
}

/**
 * @summary Create a manual return
 */
export const createReturn = async (returnInput: ReturnInput, options?: RequestInit): Promise<ReturnDetail> => {

  return customFetch<ReturnDetail>(getCreateReturnUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(returnInput)
  }
);}





export const getCreateReturnMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReturn>>, TError,{data: BodyType<ReturnInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createReturn>>, TError,{data: BodyType<ReturnInput>}, TContext> => {

const mutationKey = ['createReturn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createReturn>>, {data: BodyType<ReturnInput>}> = (props) => {
          const {data} = props ?? {};

          return  createReturn(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateReturnMutationResult = NonNullable<Awaited<ReturnType<typeof createReturn>>>
    export type CreateReturnMutationBody = BodyType<ReturnInput>
    export type CreateReturnMutationError = ErrorType<unknown>

    /**
 * @summary Create a manual return
 */
export const useCreateReturn = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReturn>>, TError,{data: BodyType<ReturnInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createReturn>>,
        TError,
        {data: BodyType<ReturnInput>},
        TContext
      > => {
      return useMutation(getCreateReturnMutationOptions(options));
    }

export const getGetReturnUrl = (id: string,) => {




  return `/api/returns/${id}`
}

export const getReturn = async (id: string, options?: RequestInit): Promise<ReturnDetail> => {

  return customFetch<ReturnDetail>(getGetReturnUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReturnQueryKey = (id: string,) => {
    return [
    `/api/returns/${id}`
    ] as const;
    }


export const getGetReturnQueryOptions = <TData = Awaited<ReturnType<typeof getReturn>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReturn>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReturnQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReturn>>> = ({ signal }) => getReturn(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReturn>>, TError, TData> & { queryKey: QueryKey }
}

export type GetReturnQueryResult = NonNullable<Awaited<ReturnType<typeof getReturn>>>
export type GetReturnQueryError = ErrorType<unknown>



export function useGetReturn<TData = Awaited<ReturnType<typeof getReturn>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReturn>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetReturnQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateReturnUrl = (id: string,) => {




  return `/api/returns/${id}`
}

export const updateReturn = async (id: string,
    returnUpdate: ReturnUpdate, options?: RequestInit): Promise<ReturnDetail> => {

  return customFetch<ReturnDetail>(getUpdateReturnUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(returnUpdate)
  }
);}





export const getUpdateReturnMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReturn>>, TError,{id: string;data: BodyType<ReturnUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateReturn>>, TError,{id: string;data: BodyType<ReturnUpdate>}, TContext> => {

const mutationKey = ['updateReturn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateReturn>>, {id: string;data: BodyType<ReturnUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateReturn(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateReturnMutationResult = NonNullable<Awaited<ReturnType<typeof updateReturn>>>
    export type UpdateReturnMutationBody = BodyType<ReturnUpdate>
    export type UpdateReturnMutationError = ErrorType<unknown>

    export const useUpdateReturn = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReturn>>, TError,{id: string;data: BodyType<ReturnUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateReturn>>,
        TError,
        {id: string;data: BodyType<ReturnUpdate>},
        TContext
      > => {
      return useMutation(getUpdateReturnMutationOptions(options));
    }

export const getTransitionReturnStatusUrl = (id: string,) => {




  return `/api/returns/${id}/status`
}

/**
 * @summary Apply a status transition to a return
 */
export const transitionReturnStatus = async (id: string,
    returnStatusTransitionInput: ReturnStatusTransitionInput, options?: RequestInit): Promise<ReturnDetail> => {

  return customFetch<ReturnDetail>(getTransitionReturnStatusUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(returnStatusTransitionInput)
  }
);}





export const getTransitionReturnStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transitionReturnStatus>>, TError,{id: string;data: BodyType<ReturnStatusTransitionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof transitionReturnStatus>>, TError,{id: string;data: BodyType<ReturnStatusTransitionInput>}, TContext> => {

const mutationKey = ['transitionReturnStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof transitionReturnStatus>>, {id: string;data: BodyType<ReturnStatusTransitionInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  transitionReturnStatus(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TransitionReturnStatusMutationResult = NonNullable<Awaited<ReturnType<typeof transitionReturnStatus>>>
    export type TransitionReturnStatusMutationBody = BodyType<ReturnStatusTransitionInput>
    export type TransitionReturnStatusMutationError = ErrorType<unknown>

    /**
 * @summary Apply a status transition to a return
 */
export const useTransitionReturnStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transitionReturnStatus>>, TError,{id: string;data: BodyType<ReturnStatusTransitionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof transitionReturnStatus>>,
        TError,
        {id: string;data: BodyType<ReturnStatusTransitionInput>},
        TContext
      > => {
      return useMutation(getTransitionReturnStatusMutationOptions(options));
    }

export const getAddReturnItemUrl = (id: string,) => {




  return `/api/returns/${id}/items`
}

export const addReturnItem = async (id: string,
    returnItemInput: ReturnItemInput, options?: RequestInit): Promise<ReturnDetail> => {

  return customFetch<ReturnDetail>(getAddReturnItemUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(returnItemInput)
  }
);}





export const getAddReturnItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addReturnItem>>, TError,{id: string;data: BodyType<ReturnItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addReturnItem>>, TError,{id: string;data: BodyType<ReturnItemInput>}, TContext> => {

const mutationKey = ['addReturnItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addReturnItem>>, {id: string;data: BodyType<ReturnItemInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  addReturnItem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddReturnItemMutationResult = NonNullable<Awaited<ReturnType<typeof addReturnItem>>>
    export type AddReturnItemMutationBody = BodyType<ReturnItemInput>
    export type AddReturnItemMutationError = ErrorType<unknown>

    export const useAddReturnItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addReturnItem>>, TError,{id: string;data: BodyType<ReturnItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addReturnItem>>,
        TError,
        {id: string;data: BodyType<ReturnItemInput>},
        TContext
      > => {
      return useMutation(getAddReturnItemMutationOptions(options));
    }

export const getUpdateReturnItemUrl = (itemId: string,) => {




  return `/api/returns/items/${itemId}`
}

export const updateReturnItem = async (itemId: string,
    returnItemUpdate: ReturnItemUpdate, options?: RequestInit): Promise<ReturnDetail> => {

  return customFetch<ReturnDetail>(getUpdateReturnItemUrl(itemId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(returnItemUpdate)
  }
);}





export const getUpdateReturnItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReturnItem>>, TError,{itemId: string;data: BodyType<ReturnItemUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateReturnItem>>, TError,{itemId: string;data: BodyType<ReturnItemUpdate>}, TContext> => {

const mutationKey = ['updateReturnItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateReturnItem>>, {itemId: string;data: BodyType<ReturnItemUpdate>}> = (props) => {
          const {itemId,data} = props ?? {};

          return  updateReturnItem(itemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateReturnItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateReturnItem>>>
    export type UpdateReturnItemMutationBody = BodyType<ReturnItemUpdate>
    export type UpdateReturnItemMutationError = ErrorType<unknown>

    export const useUpdateReturnItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReturnItem>>, TError,{itemId: string;data: BodyType<ReturnItemUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateReturnItem>>,
        TError,
        {itemId: string;data: BodyType<ReturnItemUpdate>},
        TContext
      > => {
      return useMutation(getUpdateReturnItemMutationOptions(options));
    }

export const getDeleteReturnItemUrl = (itemId: string,) => {




  return `/api/returns/items/${itemId}`
}

export const deleteReturnItem = async (itemId: string, options?: RequestInit): Promise<ReturnDetail> => {

  return customFetch<ReturnDetail>(getDeleteReturnItemUrl(itemId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteReturnItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteReturnItem>>, TError,{itemId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteReturnItem>>, TError,{itemId: string}, TContext> => {

const mutationKey = ['deleteReturnItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteReturnItem>>, {itemId: string}> = (props) => {
          const {itemId} = props ?? {};

          return  deleteReturnItem(itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteReturnItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteReturnItem>>>

    export type DeleteReturnItemMutationError = ErrorType<unknown>

    export const useDeleteReturnItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteReturnItem>>, TError,{itemId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteReturnItem>>,
        TError,
        {itemId: string},
        TContext
      > => {
      return useMutation(getDeleteReturnItemMutationOptions(options));
    }

export const getListReturnEvidenceUrl = (id: string,) => {




  return `/api/returns/${id}/evidence`
}

export const listReturnEvidence = async (id: string, options?: RequestInit): Promise<ReturnEvidenceItem[]> => {

  return customFetch<ReturnEvidenceItem[]>(getListReturnEvidenceUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListReturnEvidenceQueryKey = (id: string,) => {
    return [
    `/api/returns/${id}/evidence`
    ] as const;
    }


export const getListReturnEvidenceQueryOptions = <TData = Awaited<ReturnType<typeof listReturnEvidence>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReturnEvidence>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListReturnEvidenceQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listReturnEvidence>>> = ({ signal }) => listReturnEvidence(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listReturnEvidence>>, TError, TData> & { queryKey: QueryKey }
}

export type ListReturnEvidenceQueryResult = NonNullable<Awaited<ReturnType<typeof listReturnEvidence>>>
export type ListReturnEvidenceQueryError = ErrorType<unknown>



export function useListReturnEvidence<TData = Awaited<ReturnType<typeof listReturnEvidence>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReturnEvidence>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListReturnEvidenceQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddReturnEvidenceUrl = (id: string,) => {




  return `/api/returns/${id}/evidence`
}

/**
 * @summary Register an already-uploaded private object as evidence
 */
export const addReturnEvidence = async (id: string,
    returnEvidenceInput: ReturnEvidenceInput, options?: RequestInit): Promise<ReturnEvidenceItem> => {

  return customFetch<ReturnEvidenceItem>(getAddReturnEvidenceUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(returnEvidenceInput)
  }
);}





export const getAddReturnEvidenceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addReturnEvidence>>, TError,{id: string;data: BodyType<ReturnEvidenceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addReturnEvidence>>, TError,{id: string;data: BodyType<ReturnEvidenceInput>}, TContext> => {

const mutationKey = ['addReturnEvidence'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addReturnEvidence>>, {id: string;data: BodyType<ReturnEvidenceInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  addReturnEvidence(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddReturnEvidenceMutationResult = NonNullable<Awaited<ReturnType<typeof addReturnEvidence>>>
    export type AddReturnEvidenceMutationBody = BodyType<ReturnEvidenceInput>
    export type AddReturnEvidenceMutationError = ErrorType<unknown>

    /**
 * @summary Register an already-uploaded private object as evidence
 */
export const useAddReturnEvidence = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addReturnEvidence>>, TError,{id: string;data: BodyType<ReturnEvidenceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addReturnEvidence>>,
        TError,
        {id: string;data: BodyType<ReturnEvidenceInput>},
        TContext
      > => {
      return useMutation(getAddReturnEvidenceMutationOptions(options));
    }

export const getDeleteReturnEvidenceUrl = (evidenceId: string,) => {




  return `/api/returns/evidence/${evidenceId}`
}

export const deleteReturnEvidence = async (evidenceId: string, options?: RequestInit): Promise<ReturnOkResponse> => {

  return customFetch<ReturnOkResponse>(getDeleteReturnEvidenceUrl(evidenceId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteReturnEvidenceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteReturnEvidence>>, TError,{evidenceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteReturnEvidence>>, TError,{evidenceId: string}, TContext> => {

const mutationKey = ['deleteReturnEvidence'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteReturnEvidence>>, {evidenceId: string}> = (props) => {
          const {evidenceId} = props ?? {};

          return  deleteReturnEvidence(evidenceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteReturnEvidenceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteReturnEvidence>>>

    export type DeleteReturnEvidenceMutationError = ErrorType<unknown>

    export const useDeleteReturnEvidence = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteReturnEvidence>>, TError,{evidenceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteReturnEvidence>>,
        TError,
        {evidenceId: string},
        TContext
      > => {
      return useMutation(getDeleteReturnEvidenceMutationOptions(options));
    }

export const getListReturnShareLinksUrl = (id: string,) => {




  return `/api/returns/${id}/share-links`
}

export const listReturnShareLinks = async (id: string, options?: RequestInit): Promise<ReturnShareLink[]> => {

  return customFetch<ReturnShareLink[]>(getListReturnShareLinksUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListReturnShareLinksQueryKey = (id: string,) => {
    return [
    `/api/returns/${id}/share-links`
    ] as const;
    }


export const getListReturnShareLinksQueryOptions = <TData = Awaited<ReturnType<typeof listReturnShareLinks>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReturnShareLinks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListReturnShareLinksQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listReturnShareLinks>>> = ({ signal }) => listReturnShareLinks(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listReturnShareLinks>>, TError, TData> & { queryKey: QueryKey }
}

export type ListReturnShareLinksQueryResult = NonNullable<Awaited<ReturnType<typeof listReturnShareLinks>>>
export type ListReturnShareLinksQueryError = ErrorType<unknown>



export function useListReturnShareLinks<TData = Awaited<ReturnType<typeof listReturnShareLinks>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReturnShareLinks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListReturnShareLinksQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateReturnShareLinkUrl = (id: string,) => {




  return `/api/returns/${id}/share-links`
}

/**
 * @summary Mint a tokenised, expiring evidence share link
 */
export const createReturnShareLink = async (id: string,
    returnShareLinkInput: ReturnShareLinkInput, options?: RequestInit): Promise<ReturnShareLinkMinted> => {

  return customFetch<ReturnShareLinkMinted>(getCreateReturnShareLinkUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(returnShareLinkInput)
  }
);}





export const getCreateReturnShareLinkMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReturnShareLink>>, TError,{id: string;data: BodyType<ReturnShareLinkInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createReturnShareLink>>, TError,{id: string;data: BodyType<ReturnShareLinkInput>}, TContext> => {

const mutationKey = ['createReturnShareLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createReturnShareLink>>, {id: string;data: BodyType<ReturnShareLinkInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createReturnShareLink(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateReturnShareLinkMutationResult = NonNullable<Awaited<ReturnType<typeof createReturnShareLink>>>
    export type CreateReturnShareLinkMutationBody = BodyType<ReturnShareLinkInput>
    export type CreateReturnShareLinkMutationError = ErrorType<unknown>

    /**
 * @summary Mint a tokenised, expiring evidence share link
 */
export const useCreateReturnShareLink = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReturnShareLink>>, TError,{id: string;data: BodyType<ReturnShareLinkInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createReturnShareLink>>,
        TError,
        {id: string;data: BodyType<ReturnShareLinkInput>},
        TContext
      > => {
      return useMutation(getCreateReturnShareLinkMutationOptions(options));
    }

export const getRevokeReturnShareLinkUrl = (linkId: string,) => {




  return `/api/returns/share-links/${linkId}/revoke`
}

export const revokeReturnShareLink = async (linkId: string, options?: RequestInit): Promise<ReturnShareLink> => {

  return customFetch<ReturnShareLink>(getRevokeReturnShareLinkUrl(linkId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRevokeReturnShareLinkMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeReturnShareLink>>, TError,{linkId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeReturnShareLink>>, TError,{linkId: string}, TContext> => {

const mutationKey = ['revokeReturnShareLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeReturnShareLink>>, {linkId: string}> = (props) => {
          const {linkId} = props ?? {};

          return  revokeReturnShareLink(linkId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeReturnShareLinkMutationResult = NonNullable<Awaited<ReturnType<typeof revokeReturnShareLink>>>

    export type RevokeReturnShareLinkMutationError = ErrorType<unknown>

    export const useRevokeReturnShareLink = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeReturnShareLink>>, TError,{linkId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokeReturnShareLink>>,
        TError,
        {linkId: string},
        TContext
      > => {
      return useMutation(getRevokeReturnShareLinkMutationOptions(options));
    }

export const getListReturnRefundsUrl = (id: string,) => {




  return `/api/returns/${id}/refunds`
}

export const listReturnRefunds = async (id: string, options?: RequestInit): Promise<ReturnRefundRow[]> => {

  return customFetch<ReturnRefundRow[]>(getListReturnRefundsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListReturnRefundsQueryKey = (id: string,) => {
    return [
    `/api/returns/${id}/refunds`
    ] as const;
    }


export const getListReturnRefundsQueryOptions = <TData = Awaited<ReturnType<typeof listReturnRefunds>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReturnRefunds>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListReturnRefundsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listReturnRefunds>>> = ({ signal }) => listReturnRefunds(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listReturnRefunds>>, TError, TData> & { queryKey: QueryKey }
}

export type ListReturnRefundsQueryResult = NonNullable<Awaited<ReturnType<typeof listReturnRefunds>>>
export type ListReturnRefundsQueryError = ErrorType<unknown>



export function useListReturnRefunds<TData = Awaited<ReturnType<typeof listReturnRefunds>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReturnRefunds>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListReturnRefundsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateReturnRefundUrl = (id: string,) => {




  return `/api/returns/${id}/refunds`
}

/**
 * @summary Request a refund against a return
 */
export const createReturnRefund = async (id: string,
    returnRefundInput: ReturnRefundInput, options?: RequestInit): Promise<ReturnRefundRow> => {

  return customFetch<ReturnRefundRow>(getCreateReturnRefundUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(returnRefundInput)
  }
);}





export const getCreateReturnRefundMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReturnRefund>>, TError,{id: string;data: BodyType<ReturnRefundInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createReturnRefund>>, TError,{id: string;data: BodyType<ReturnRefundInput>}, TContext> => {

const mutationKey = ['createReturnRefund'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createReturnRefund>>, {id: string;data: BodyType<ReturnRefundInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createReturnRefund(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateReturnRefundMutationResult = NonNullable<Awaited<ReturnType<typeof createReturnRefund>>>
    export type CreateReturnRefundMutationBody = BodyType<ReturnRefundInput>
    export type CreateReturnRefundMutationError = ErrorType<unknown>

    /**
 * @summary Request a refund against a return
 */
export const useCreateReturnRefund = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReturnRefund>>, TError,{id: string;data: BodyType<ReturnRefundInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createReturnRefund>>,
        TError,
        {id: string;data: BodyType<ReturnRefundInput>},
        TContext
      > => {
      return useMutation(getCreateReturnRefundMutationOptions(options));
    }

export const getUpdateReturnRefundUrl = (refundId: string,) => {




  return `/api/returns/refunds/${refundId}`
}

/**
 * @summary Approve / issue / fail a refund
 */
export const updateReturnRefund = async (refundId: string,
    returnRefundUpdate: ReturnRefundUpdate, options?: RequestInit): Promise<ReturnRefundRow> => {

  return customFetch<ReturnRefundRow>(getUpdateReturnRefundUrl(refundId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(returnRefundUpdate)
  }
);}





export const getUpdateReturnRefundMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReturnRefund>>, TError,{refundId: string;data: BodyType<ReturnRefundUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateReturnRefund>>, TError,{refundId: string;data: BodyType<ReturnRefundUpdate>}, TContext> => {

const mutationKey = ['updateReturnRefund'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateReturnRefund>>, {refundId: string;data: BodyType<ReturnRefundUpdate>}> = (props) => {
          const {refundId,data} = props ?? {};

          return  updateReturnRefund(refundId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateReturnRefundMutationResult = NonNullable<Awaited<ReturnType<typeof updateReturnRefund>>>
    export type UpdateReturnRefundMutationBody = BodyType<ReturnRefundUpdate>
    export type UpdateReturnRefundMutationError = ErrorType<unknown>

    /**
 * @summary Approve / issue / fail a refund
 */
export const useUpdateReturnRefund = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReturnRefund>>, TError,{refundId: string;data: BodyType<ReturnRefundUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateReturnRefund>>,
        TError,
        {refundId: string;data: BodyType<ReturnRefundUpdate>},
        TContext
      > => {
      return useMutation(getUpdateReturnRefundMutationOptions(options));
    }

export const getListReturnInventoryActionsUrl = (id: string,) => {




  return `/api/returns/${id}/inventory-actions`
}

export const listReturnInventoryActions = async (id: string, options?: RequestInit): Promise<ReturnInventoryActionRow[]> => {

  return customFetch<ReturnInventoryActionRow[]>(getListReturnInventoryActionsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListReturnInventoryActionsQueryKey = (id: string,) => {
    return [
    `/api/returns/${id}/inventory-actions`
    ] as const;
    }


export const getListReturnInventoryActionsQueryOptions = <TData = Awaited<ReturnType<typeof listReturnInventoryActions>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReturnInventoryActions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListReturnInventoryActionsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listReturnInventoryActions>>> = ({ signal }) => listReturnInventoryActions(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listReturnInventoryActions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListReturnInventoryActionsQueryResult = NonNullable<Awaited<ReturnType<typeof listReturnInventoryActions>>>
export type ListReturnInventoryActionsQueryError = ErrorType<unknown>



export function useListReturnInventoryActions<TData = Awaited<ReturnType<typeof listReturnInventoryActions>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReturnInventoryActions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListReturnInventoryActionsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateReturnInventoryActionUrl = (id: string,) => {




  return `/api/returns/${id}/inventory-actions`
}

/**
 * @summary Apply an inventory disposition for a returned item
 */
export const createReturnInventoryAction = async (id: string,
    returnInventoryActionInput: ReturnInventoryActionInput, options?: RequestInit): Promise<ReturnInventoryActionRow> => {

  return customFetch<ReturnInventoryActionRow>(getCreateReturnInventoryActionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(returnInventoryActionInput)
  }
);}





export const getCreateReturnInventoryActionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReturnInventoryAction>>, TError,{id: string;data: BodyType<ReturnInventoryActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createReturnInventoryAction>>, TError,{id: string;data: BodyType<ReturnInventoryActionInput>}, TContext> => {

const mutationKey = ['createReturnInventoryAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createReturnInventoryAction>>, {id: string;data: BodyType<ReturnInventoryActionInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createReturnInventoryAction(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateReturnInventoryActionMutationResult = NonNullable<Awaited<ReturnType<typeof createReturnInventoryAction>>>
    export type CreateReturnInventoryActionMutationBody = BodyType<ReturnInventoryActionInput>
    export type CreateReturnInventoryActionMutationError = ErrorType<unknown>

    /**
 * @summary Apply an inventory disposition for a returned item
 */
export const useCreateReturnInventoryAction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReturnInventoryAction>>, TError,{id: string;data: BodyType<ReturnInventoryActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createReturnInventoryAction>>,
        TError,
        {id: string;data: BodyType<ReturnInventoryActionInput>},
        TContext
      > => {
      return useMutation(getCreateReturnInventoryActionMutationOptions(options));
    }

export const getListReturnMessagesUrl = (id: string,) => {




  return `/api/returns/${id}/messages`
}

export const listReturnMessages = async (id: string, options?: RequestInit): Promise<ReturnMessageRow[]> => {

  return customFetch<ReturnMessageRow[]>(getListReturnMessagesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListReturnMessagesQueryKey = (id: string,) => {
    return [
    `/api/returns/${id}/messages`
    ] as const;
    }


export const getListReturnMessagesQueryOptions = <TData = Awaited<ReturnType<typeof listReturnMessages>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReturnMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListReturnMessagesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listReturnMessages>>> = ({ signal }) => listReturnMessages(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listReturnMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type ListReturnMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof listReturnMessages>>>
export type ListReturnMessagesQueryError = ErrorType<unknown>



export function useListReturnMessages<TData = Awaited<ReturnType<typeof listReturnMessages>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReturnMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListReturnMessagesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSendReturnMessageUrl = (id: string,) => {




  return `/api/returns/${id}/messages`
}

/**
 * @summary Send a customer message about a return
 */
export const sendReturnMessage = async (id: string,
    returnMessageInput: ReturnMessageInput, options?: RequestInit): Promise<ReturnMessageRow> => {

  return customFetch<ReturnMessageRow>(getSendReturnMessageUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(returnMessageInput)
  }
);}





export const getSendReturnMessageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendReturnMessage>>, TError,{id: string;data: BodyType<ReturnMessageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendReturnMessage>>, TError,{id: string;data: BodyType<ReturnMessageInput>}, TContext> => {

const mutationKey = ['sendReturnMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendReturnMessage>>, {id: string;data: BodyType<ReturnMessageInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  sendReturnMessage(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendReturnMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendReturnMessage>>>
    export type SendReturnMessageMutationBody = BodyType<ReturnMessageInput>
    export type SendReturnMessageMutationError = ErrorType<unknown>

    /**
 * @summary Send a customer message about a return
 */
export const useSendReturnMessage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendReturnMessage>>, TError,{id: string;data: BodyType<ReturnMessageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendReturnMessage>>,
        TError,
        {id: string;data: BodyType<ReturnMessageInput>},
        TContext
      > => {
      return useMutation(getSendReturnMessageMutationOptions(options));
    }

export const getSyncReturnFromEbayUrl = (id: string,) => {




  return `/api/returns/${id}/ebay/sync`
}

/**
 * @summary Best-effort pull of the latest eBay return state
 */
export const syncReturnFromEbay = async (id: string, options?: RequestInit): Promise<ReturnDetail> => {

  return customFetch<ReturnDetail>(getSyncReturnFromEbayUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSyncReturnFromEbayMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncReturnFromEbay>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncReturnFromEbay>>, TError,{id: string}, TContext> => {

const mutationKey = ['syncReturnFromEbay'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncReturnFromEbay>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  syncReturnFromEbay(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncReturnFromEbayMutationResult = NonNullable<Awaited<ReturnType<typeof syncReturnFromEbay>>>

    export type SyncReturnFromEbayMutationError = ErrorType<unknown>

    /**
 * @summary Best-effort pull of the latest eBay return state
 */
export const useSyncReturnFromEbay = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncReturnFromEbay>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncReturnFromEbay>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getSyncReturnFromEbayMutationOptions(options));
    }

export const getPullEbayReturnsUrl = () => {




  return `/api/returns/ebay/pull`
}

/**
 * @summary Best-effort import of new/updated eBay returns for this tenant
 */
export const pullEbayReturns = async ( options?: RequestInit): Promise<ReturnEbayPullResult> => {

  return customFetch<ReturnEbayPullResult>(getPullEbayReturnsUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPullEbayReturnsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pullEbayReturns>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pullEbayReturns>>, TError,void, TContext> => {

const mutationKey = ['pullEbayReturns'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pullEbayReturns>>, void> = () => {


          return  pullEbayReturns(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PullEbayReturnsMutationResult = NonNullable<Awaited<ReturnType<typeof pullEbayReturns>>>

    export type PullEbayReturnsMutationError = ErrorType<unknown>

    /**
 * @summary Best-effort import of new/updated eBay returns for this tenant
 */
export const usePullEbayReturns = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pullEbayReturns>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof pullEbayReturns>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPullEbayReturnsMutationOptions(options));
    }

export const getSyncReturnFromTiktokUrl = (id: string,) => {




  return `/api/returns/${id}/tiktok/sync`
}

/**
 * @summary Best-effort pull of the latest TikTok Shop return state
 */
export const syncReturnFromTiktok = async (id: string, options?: RequestInit): Promise<ReturnDetail> => {

  return customFetch<ReturnDetail>(getSyncReturnFromTiktokUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSyncReturnFromTiktokMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncReturnFromTiktok>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncReturnFromTiktok>>, TError,{id: string}, TContext> => {

const mutationKey = ['syncReturnFromTiktok'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncReturnFromTiktok>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  syncReturnFromTiktok(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncReturnFromTiktokMutationResult = NonNullable<Awaited<ReturnType<typeof syncReturnFromTiktok>>>

    export type SyncReturnFromTiktokMutationError = ErrorType<unknown>

    /**
 * @summary Best-effort pull of the latest TikTok Shop return state
 */
export const useSyncReturnFromTiktok = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncReturnFromTiktok>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncReturnFromTiktok>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getSyncReturnFromTiktokMutationOptions(options));
    }

export const getPullTiktokReturnsUrl = () => {




  return `/api/returns/tiktok/pull`
}

/**
 * @summary Best-effort import of new/updated TikTok Shop returns for this tenant
 */
export const pullTiktokReturns = async ( options?: RequestInit): Promise<ReturnEbayPullResult> => {

  return customFetch<ReturnEbayPullResult>(getPullTiktokReturnsUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPullTiktokReturnsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pullTiktokReturns>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pullTiktokReturns>>, TError,void, TContext> => {

const mutationKey = ['pullTiktokReturns'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pullTiktokReturns>>, void> = () => {


          return  pullTiktokReturns(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PullTiktokReturnsMutationResult = NonNullable<Awaited<ReturnType<typeof pullTiktokReturns>>>

    export type PullTiktokReturnsMutationError = ErrorType<unknown>

    /**
 * @summary Best-effort import of new/updated TikTok Shop returns for this tenant
 */
export const usePullTiktokReturns = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pullTiktokReturns>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof pullTiktokReturns>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPullTiktokReturnsMutationOptions(options));
    }

export const getListReturnsAuditUrl = (params?: ListReturnsAuditParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/returns/audit?${stringifiedParams}` : `/api/returns/audit`
}

export const listReturnsAudit = async (params?: ListReturnsAuditParams, options?: RequestInit): Promise<ReturnAuditRow[]> => {

  return customFetch<ReturnAuditRow[]>(getListReturnsAuditUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListReturnsAuditQueryKey = (params?: ListReturnsAuditParams,) => {
    return [
    `/api/returns/audit`, ...(params ? [params] : [])
    ] as const;
    }


export const getListReturnsAuditQueryOptions = <TData = Awaited<ReturnType<typeof listReturnsAudit>>, TError = ErrorType<unknown>>(params?: ListReturnsAuditParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReturnsAudit>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListReturnsAuditQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listReturnsAudit>>> = ({ signal }) => listReturnsAudit(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listReturnsAudit>>, TError, TData> & { queryKey: QueryKey }
}

export type ListReturnsAuditQueryResult = NonNullable<Awaited<ReturnType<typeof listReturnsAudit>>>
export type ListReturnsAuditQueryError = ErrorType<unknown>



export function useListReturnsAudit<TData = Awaited<ReturnType<typeof listReturnsAudit>>, TError = ErrorType<unknown>>(
 params?: ListReturnsAuditParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReturnsAudit>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListReturnsAuditQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetReturnsReportSummaryUrl = (params?: GetReturnsReportSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/returns/reports/summary?${stringifiedParams}` : `/api/returns/reports/summary`
}

export const getReturnsReportSummary = async (params?: GetReturnsReportSummaryParams, options?: RequestInit): Promise<ReturnsReportSummary> => {

  return customFetch<ReturnsReportSummary>(getGetReturnsReportSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReturnsReportSummaryQueryKey = (params?: GetReturnsReportSummaryParams,) => {
    return [
    `/api/returns/reports/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetReturnsReportSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getReturnsReportSummary>>, TError = ErrorType<unknown>>(params?: GetReturnsReportSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReturnsReportSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReturnsReportSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReturnsReportSummary>>> = ({ signal }) => getReturnsReportSummary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReturnsReportSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetReturnsReportSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getReturnsReportSummary>>>
export type GetReturnsReportSummaryQueryError = ErrorType<unknown>



export function useGetReturnsReportSummary<TData = Awaited<ReturnType<typeof getReturnsReportSummary>>, TError = ErrorType<unknown>>(
 params?: GetReturnsReportSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReturnsReportSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetReturnsReportSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetReturnsSettingsUrl = () => {




  return `/api/returns/settings`
}

export const getReturnsSettings = async ( options?: RequestInit): Promise<ReturnsSettings> => {

  return customFetch<ReturnsSettings>(getGetReturnsSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReturnsSettingsQueryKey = () => {
    return [
    `/api/returns/settings`
    ] as const;
    }


export const getGetReturnsSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getReturnsSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReturnsSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReturnsSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReturnsSettings>>> = ({ signal }) => getReturnsSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReturnsSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetReturnsSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getReturnsSettings>>>
export type GetReturnsSettingsQueryError = ErrorType<unknown>



export function useGetReturnsSettings<TData = Awaited<ReturnType<typeof getReturnsSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReturnsSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetReturnsSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateReturnsSettingsUrl = () => {




  return `/api/returns/settings`
}

export const updateReturnsSettings = async (returnsSettingsInput: ReturnsSettingsInput, options?: RequestInit): Promise<ReturnsSettings> => {

  return customFetch<ReturnsSettings>(getUpdateReturnsSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(returnsSettingsInput)
  }
);}





export const getUpdateReturnsSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReturnsSettings>>, TError,{data: BodyType<ReturnsSettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateReturnsSettings>>, TError,{data: BodyType<ReturnsSettingsInput>}, TContext> => {

const mutationKey = ['updateReturnsSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateReturnsSettings>>, {data: BodyType<ReturnsSettingsInput>}> = (props) => {
          const {data} = props ?? {};

          return  updateReturnsSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateReturnsSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateReturnsSettings>>>
    export type UpdateReturnsSettingsMutationBody = BodyType<ReturnsSettingsInput>
    export type UpdateReturnsSettingsMutationError = ErrorType<unknown>

    export const useUpdateReturnsSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReturnsSettings>>, TError,{data: BodyType<ReturnsSettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateReturnsSettings>>,
        TError,
        {data: BodyType<ReturnsSettingsInput>},
        TContext
      > => {
      return useMutation(getUpdateReturnsSettingsMutationOptions(options));
    }

export const getGetAssetsOverviewUrl = () => {




  return `/api/assets/overview`
}

/**
 * @summary Asset Tracking dashboard summary counts
 */
export const getAssetsOverview = async ( options?: RequestInit): Promise<AssetsOverview> => {

  return customFetch<AssetsOverview>(getGetAssetsOverviewUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAssetsOverviewQueryKey = () => {
    return [
    `/api/assets/overview`
    ] as const;
    }


export const getGetAssetsOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getAssetsOverview>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAssetsOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssetsOverviewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssetsOverview>>> = ({ signal }) => getAssetsOverview({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssetsOverview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAssetsOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getAssetsOverview>>>
export type GetAssetsOverviewQueryError = ErrorType<unknown>


/**
 * @summary Asset Tracking dashboard summary counts
 */

export function useGetAssetsOverview<TData = Awaited<ReturnType<typeof getAssetsOverview>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAssetsOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAssetsOverviewQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAssetsReportSummaryUrl = () => {




  return `/api/assets/reports/summary`
}

/**
 * @summary Asset report / export summary
 */
export const getAssetsReportSummary = async ( options?: RequestInit): Promise<AssetsReportSummary> => {

  return customFetch<AssetsReportSummary>(getGetAssetsReportSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAssetsReportSummaryQueryKey = () => {
    return [
    `/api/assets/reports/summary`
    ] as const;
    }


export const getGetAssetsReportSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getAssetsReportSummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAssetsReportSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssetsReportSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssetsReportSummary>>> = ({ signal }) => getAssetsReportSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssetsReportSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAssetsReportSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getAssetsReportSummary>>>
export type GetAssetsReportSummaryQueryError = ErrorType<unknown>


/**
 * @summary Asset report / export summary
 */

export function useGetAssetsReportSummary<TData = Awaited<ReturnType<typeof getAssetsReportSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAssetsReportSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAssetsReportSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAssetsStaffCountsUrl = () => {




  return `/api/assets/staff-counts`
}

/**
 * @summary Per-staff active asset counts (for HR staff list badges)
 */
export const getAssetsStaffCounts = async ( options?: RequestInit): Promise<AssetStaffCounts> => {

  return customFetch<AssetStaffCounts>(getGetAssetsStaffCountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAssetsStaffCountsQueryKey = () => {
    return [
    `/api/assets/staff-counts`
    ] as const;
    }


export const getGetAssetsStaffCountsQueryOptions = <TData = Awaited<ReturnType<typeof getAssetsStaffCounts>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAssetsStaffCounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssetsStaffCountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssetsStaffCounts>>> = ({ signal }) => getAssetsStaffCounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssetsStaffCounts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAssetsStaffCountsQueryResult = NonNullable<Awaited<ReturnType<typeof getAssetsStaffCounts>>>
export type GetAssetsStaffCountsQueryError = ErrorType<unknown>


/**
 * @summary Per-staff active asset counts (for HR staff list badges)
 */

export function useGetAssetsStaffCounts<TData = Awaited<ReturnType<typeof getAssetsStaffCounts>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAssetsStaffCounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAssetsStaffCountsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAssetsForStaffUrl = (staffId: string,) => {




  return `/api/assets/staff/${staffId}`
}

/**
 * @summary Assets currently assigned to an HR staff member
 */
export const listAssetsForStaff = async (staffId: string, options?: RequestInit): Promise<AssetRow[]> => {

  return customFetch<AssetRow[]>(getListAssetsForStaffUrl(staffId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAssetsForStaffQueryKey = (staffId: string,) => {
    return [
    `/api/assets/staff/${staffId}`
    ] as const;
    }


export const getListAssetsForStaffQueryOptions = <TData = Awaited<ReturnType<typeof listAssetsForStaff>>, TError = ErrorType<unknown>>(staffId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAssetsForStaff>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAssetsForStaffQueryKey(staffId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAssetsForStaff>>> = ({ signal }) => listAssetsForStaff(staffId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: staffId !== null && staffId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAssetsForStaff>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAssetsForStaffQueryResult = NonNullable<Awaited<ReturnType<typeof listAssetsForStaff>>>
export type ListAssetsForStaffQueryError = ErrorType<unknown>


/**
 * @summary Assets currently assigned to an HR staff member
 */

export function useListAssetsForStaff<TData = Awaited<ReturnType<typeof listAssetsForStaff>>, TError = ErrorType<unknown>>(
 staffId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAssetsForStaff>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAssetsForStaffQueryOptions(staffId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAssetsUrl = (params?: ListAssetsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/assets?${stringifiedParams}` : `/api/assets`
}

/**
 * @summary List assets
 */
export const listAssets = async (params?: ListAssetsParams, options?: RequestInit): Promise<AssetListResponse> => {

  return customFetch<AssetListResponse>(getListAssetsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAssetsQueryKey = (params?: ListAssetsParams,) => {
    return [
    `/api/assets`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAssetsQueryOptions = <TData = Awaited<ReturnType<typeof listAssets>>, TError = ErrorType<unknown>>(params?: ListAssetsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAssets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAssetsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAssets>>> = ({ signal }) => listAssets(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAssets>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAssetsQueryResult = NonNullable<Awaited<ReturnType<typeof listAssets>>>
export type ListAssetsQueryError = ErrorType<unknown>


/**
 * @summary List assets
 */

export function useListAssets<TData = Awaited<ReturnType<typeof listAssets>>, TError = ErrorType<unknown>>(
 params?: ListAssetsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAssets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAssetsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateAssetUrl = () => {




  return `/api/assets`
}

/**
 * @summary Create an asset
 */
export const createAsset = async (assetInput: AssetInput, options?: RequestInit): Promise<AssetDetail> => {

  return customFetch<AssetDetail>(getCreateAssetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(assetInput)
  }
);}





export const getCreateAssetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAsset>>, TError,{data: BodyType<AssetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAsset>>, TError,{data: BodyType<AssetInput>}, TContext> => {

const mutationKey = ['createAsset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAsset>>, {data: BodyType<AssetInput>}> = (props) => {
          const {data} = props ?? {};

          return  createAsset(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAssetMutationResult = NonNullable<Awaited<ReturnType<typeof createAsset>>>
    export type CreateAssetMutationBody = BodyType<AssetInput>
    export type CreateAssetMutationError = ErrorType<unknown>

    /**
 * @summary Create an asset
 */
export const useCreateAsset = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAsset>>, TError,{data: BodyType<AssetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAsset>>,
        TError,
        {data: BodyType<AssetInput>},
        TContext
      > => {
      return useMutation(getCreateAssetMutationOptions(options));
    }

export const getDeleteAssetDocumentUrl = (documentId: string,) => {




  return `/api/assets/documents/${documentId}`
}

export const deleteAssetDocument = async (documentId: string, options?: RequestInit): Promise<AssetOkResponse> => {

  return customFetch<AssetOkResponse>(getDeleteAssetDocumentUrl(documentId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteAssetDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAssetDocument>>, TError,{documentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAssetDocument>>, TError,{documentId: string}, TContext> => {

const mutationKey = ['deleteAssetDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAssetDocument>>, {documentId: string}> = (props) => {
          const {documentId} = props ?? {};

          return  deleteAssetDocument(documentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAssetDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAssetDocument>>>

    export type DeleteAssetDocumentMutationError = ErrorType<unknown>

    export const useDeleteAssetDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAssetDocument>>, TError,{documentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAssetDocument>>,
        TError,
        {documentId: string},
        TContext
      > => {
      return useMutation(getDeleteAssetDocumentMutationOptions(options));
    }

export const getGetAssetUrl = (id: string,) => {




  return `/api/assets/${id}`
}

export const getAsset = async (id: string, options?: RequestInit): Promise<AssetDetail> => {

  return customFetch<AssetDetail>(getGetAssetUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAssetQueryKey = (id: string,) => {
    return [
    `/api/assets/${id}`
    ] as const;
    }


export const getGetAssetQueryOptions = <TData = Awaited<ReturnType<typeof getAsset>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssetQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAsset>>> = ({ signal }) => getAsset(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAssetQueryResult = NonNullable<Awaited<ReturnType<typeof getAsset>>>
export type GetAssetQueryError = ErrorType<unknown>



export function useGetAsset<TData = Awaited<ReturnType<typeof getAsset>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAssetQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateAssetUrl = (id: string,) => {




  return `/api/assets/${id}`
}

export const updateAsset = async (id: string,
    assetUpdate: AssetUpdate, options?: RequestInit): Promise<AssetDetail> => {

  return customFetch<AssetDetail>(getUpdateAssetUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(assetUpdate)
  }
);}





export const getUpdateAssetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAsset>>, TError,{id: string;data: BodyType<AssetUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAsset>>, TError,{id: string;data: BodyType<AssetUpdate>}, TContext> => {

const mutationKey = ['updateAsset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAsset>>, {id: string;data: BodyType<AssetUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAsset(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAssetMutationResult = NonNullable<Awaited<ReturnType<typeof updateAsset>>>
    export type UpdateAssetMutationBody = BodyType<AssetUpdate>
    export type UpdateAssetMutationError = ErrorType<unknown>

    export const useUpdateAsset = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAsset>>, TError,{id: string;data: BodyType<AssetUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAsset>>,
        TError,
        {id: string;data: BodyType<AssetUpdate>},
        TContext
      > => {
      return useMutation(getUpdateAssetMutationOptions(options));
    }

export const getDeleteAssetUrl = (id: string,) => {




  return `/api/assets/${id}`
}

/**
 * @summary Archive (soft-delete) an asset
 */
export const deleteAsset = async (id: string, options?: RequestInit): Promise<AssetOkResponse> => {

  return customFetch<AssetOkResponse>(getDeleteAssetUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteAssetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAsset>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAsset>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteAsset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAsset>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAsset(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAssetMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAsset>>>

    export type DeleteAssetMutationError = ErrorType<unknown>

    /**
 * @summary Archive (soft-delete) an asset
 */
export const useDeleteAsset = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAsset>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAsset>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteAssetMutationOptions(options));
    }

export const getAssignAssetUrl = (id: string,) => {




  return `/api/assets/${id}/assign`
}

/**
 * @summary Assign an asset to a user or HR staff member
 */
export const assignAsset = async (id: string,
    assetAssignInput: AssetAssignInput, options?: RequestInit): Promise<AssetDetail> => {

  return customFetch<AssetDetail>(getAssignAssetUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(assetAssignInput)
  }
);}





export const getAssignAssetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignAsset>>, TError,{id: string;data: BodyType<AssetAssignInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assignAsset>>, TError,{id: string;data: BodyType<AssetAssignInput>}, TContext> => {

const mutationKey = ['assignAsset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignAsset>>, {id: string;data: BodyType<AssetAssignInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  assignAsset(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignAssetMutationResult = NonNullable<Awaited<ReturnType<typeof assignAsset>>>
    export type AssignAssetMutationBody = BodyType<AssetAssignInput>
    export type AssignAssetMutationError = ErrorType<unknown>

    /**
 * @summary Assign an asset to a user or HR staff member
 */
export const useAssignAsset = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignAsset>>, TError,{id: string;data: BodyType<AssetAssignInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof assignAsset>>,
        TError,
        {id: string;data: BodyType<AssetAssignInput>},
        TContext
      > => {
      return useMutation(getAssignAssetMutationOptions(options));
    }

export const getReturnAssetUrl = (id: string,) => {




  return `/api/assets/${id}/return`
}

/**
 * @summary Return an assigned asset
 */
export const returnAsset = async (id: string,
    assetReturnInput: AssetReturnInput, options?: RequestInit): Promise<AssetDetail> => {

  return customFetch<AssetDetail>(getReturnAssetUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(assetReturnInput)
  }
);}





export const getReturnAssetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof returnAsset>>, TError,{id: string;data: BodyType<AssetReturnInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof returnAsset>>, TError,{id: string;data: BodyType<AssetReturnInput>}, TContext> => {

const mutationKey = ['returnAsset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof returnAsset>>, {id: string;data: BodyType<AssetReturnInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  returnAsset(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReturnAssetMutationResult = NonNullable<Awaited<ReturnType<typeof returnAsset>>>
    export type ReturnAssetMutationBody = BodyType<AssetReturnInput>
    export type ReturnAssetMutationError = ErrorType<unknown>

    /**
 * @summary Return an assigned asset
 */
export const useReturnAsset = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof returnAsset>>, TError,{id: string;data: BodyType<AssetReturnInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof returnAsset>>,
        TError,
        {id: string;data: BodyType<AssetReturnInput>},
        TContext
      > => {
      return useMutation(getReturnAssetMutationOptions(options));
    }

export const getTransferAssetUrl = (id: string,) => {




  return `/api/assets/${id}/transfer`
}

/**
 * @summary Transfer an asset to a new location
 */
export const transferAsset = async (id: string,
    assetTransferInput: AssetTransferInput, options?: RequestInit): Promise<AssetDetail> => {

  return customFetch<AssetDetail>(getTransferAssetUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(assetTransferInput)
  }
);}





export const getTransferAssetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transferAsset>>, TError,{id: string;data: BodyType<AssetTransferInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof transferAsset>>, TError,{id: string;data: BodyType<AssetTransferInput>}, TContext> => {

const mutationKey = ['transferAsset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof transferAsset>>, {id: string;data: BodyType<AssetTransferInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  transferAsset(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TransferAssetMutationResult = NonNullable<Awaited<ReturnType<typeof transferAsset>>>
    export type TransferAssetMutationBody = BodyType<AssetTransferInput>
    export type TransferAssetMutationError = ErrorType<unknown>

    /**
 * @summary Transfer an asset to a new location
 */
export const useTransferAsset = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transferAsset>>, TError,{id: string;data: BodyType<AssetTransferInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof transferAsset>>,
        TError,
        {id: string;data: BodyType<AssetTransferInput>},
        TContext
      > => {
      return useMutation(getTransferAssetMutationOptions(options));
    }

export const getTransitionAssetStatusUrl = (id: string,) => {




  return `/api/assets/${id}/status`
}

/**
 * @summary Apply a lifecycle status transition (lost / repair / retired / etc.)
 */
export const transitionAssetStatus = async (id: string,
    assetStatusTransitionInput: AssetStatusTransitionInput, options?: RequestInit): Promise<AssetDetail> => {

  return customFetch<AssetDetail>(getTransitionAssetStatusUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(assetStatusTransitionInput)
  }
);}





export const getTransitionAssetStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transitionAssetStatus>>, TError,{id: string;data: BodyType<AssetStatusTransitionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof transitionAssetStatus>>, TError,{id: string;data: BodyType<AssetStatusTransitionInput>}, TContext> => {

const mutationKey = ['transitionAssetStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof transitionAssetStatus>>, {id: string;data: BodyType<AssetStatusTransitionInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  transitionAssetStatus(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TransitionAssetStatusMutationResult = NonNullable<Awaited<ReturnType<typeof transitionAssetStatus>>>
    export type TransitionAssetStatusMutationBody = BodyType<AssetStatusTransitionInput>
    export type TransitionAssetStatusMutationError = ErrorType<unknown>

    /**
 * @summary Apply a lifecycle status transition (lost / repair / retired / etc.)
 */
export const useTransitionAssetStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transitionAssetStatus>>, TError,{id: string;data: BodyType<AssetStatusTransitionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof transitionAssetStatus>>,
        TError,
        {id: string;data: BodyType<AssetStatusTransitionInput>},
        TContext
      > => {
      return useMutation(getTransitionAssetStatusMutationOptions(options));
    }

export const getListAssetActivityUrl = (id: string,) => {




  return `/api/assets/${id}/activity`
}

export const listAssetActivity = async (id: string, options?: RequestInit): Promise<AssetActivityRow[]> => {

  return customFetch<AssetActivityRow[]>(getListAssetActivityUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAssetActivityQueryKey = (id: string,) => {
    return [
    `/api/assets/${id}/activity`
    ] as const;
    }


export const getListAssetActivityQueryOptions = <TData = Awaited<ReturnType<typeof listAssetActivity>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAssetActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAssetActivityQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAssetActivity>>> = ({ signal }) => listAssetActivity(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAssetActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAssetActivityQueryResult = NonNullable<Awaited<ReturnType<typeof listAssetActivity>>>
export type ListAssetActivityQueryError = ErrorType<unknown>



export function useListAssetActivity<TData = Awaited<ReturnType<typeof listAssetActivity>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAssetActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAssetActivityQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAssetDocumentsUrl = (id: string,) => {




  return `/api/assets/${id}/documents`
}

export const listAssetDocuments = async (id: string, options?: RequestInit): Promise<AssetDocumentRow[]> => {

  return customFetch<AssetDocumentRow[]>(getListAssetDocumentsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAssetDocumentsQueryKey = (id: string,) => {
    return [
    `/api/assets/${id}/documents`
    ] as const;
    }


export const getListAssetDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof listAssetDocuments>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAssetDocuments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAssetDocumentsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAssetDocuments>>> = ({ signal }) => listAssetDocuments(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAssetDocuments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAssetDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listAssetDocuments>>>
export type ListAssetDocumentsQueryError = ErrorType<unknown>



export function useListAssetDocuments<TData = Awaited<ReturnType<typeof listAssetDocuments>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAssetDocuments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAssetDocumentsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddAssetDocumentUrl = (id: string,) => {




  return `/api/assets/${id}/documents`
}

/**
 * @summary Register an already-uploaded private object as an asset photo/document
 */
export const addAssetDocument = async (id: string,
    assetDocumentInput: AssetDocumentInput, options?: RequestInit): Promise<AssetDocumentRow> => {

  return customFetch<AssetDocumentRow>(getAddAssetDocumentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(assetDocumentInput)
  }
);}





export const getAddAssetDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addAssetDocument>>, TError,{id: string;data: BodyType<AssetDocumentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addAssetDocument>>, TError,{id: string;data: BodyType<AssetDocumentInput>}, TContext> => {

const mutationKey = ['addAssetDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addAssetDocument>>, {id: string;data: BodyType<AssetDocumentInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  addAssetDocument(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddAssetDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof addAssetDocument>>>
    export type AddAssetDocumentMutationBody = BodyType<AssetDocumentInput>
    export type AddAssetDocumentMutationError = ErrorType<unknown>

    /**
 * @summary Register an already-uploaded private object as an asset photo/document
 */
export const useAddAssetDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addAssetDocument>>, TError,{id: string;data: BodyType<AssetDocumentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addAssetDocument>>,
        TError,
        {id: string;data: BodyType<AssetDocumentInput>},
        TContext
      > => {
      return useMutation(getAddAssetDocumentMutationOptions(options));
    }

export const getGetAssetLabelUrl = (id: string,) => {




  return `/api/assets/${id}/label`
}

/**
 * @summary QR / barcode label payload for an asset
 */
export const getAssetLabel = async (id: string, options?: RequestInit): Promise<AssetLabel> => {

  return customFetch<AssetLabel>(getGetAssetLabelUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAssetLabelQueryKey = (id: string,) => {
    return [
    `/api/assets/${id}/label`
    ] as const;
    }


export const getGetAssetLabelQueryOptions = <TData = Awaited<ReturnType<typeof getAssetLabel>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAssetLabel>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssetLabelQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssetLabel>>> = ({ signal }) => getAssetLabel(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssetLabel>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAssetLabelQueryResult = NonNullable<Awaited<ReturnType<typeof getAssetLabel>>>
export type GetAssetLabelQueryError = ErrorType<unknown>


/**
 * @summary QR / barcode label payload for an asset
 */

export function useGetAssetLabel<TData = Awaited<ReturnType<typeof getAssetLabel>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAssetLabel>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAssetLabelQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetComplianceOverviewUrl = () => {




  return `/api/compliance/overview`
}

/**
 * @summary Compliance Vault dashboard summary counts
 */
export const getComplianceOverview = async ( options?: RequestInit): Promise<ComplianceOverview> => {

  return customFetch<ComplianceOverview>(getGetComplianceOverviewUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetComplianceOverviewQueryKey = () => {
    return [
    `/api/compliance/overview`
    ] as const;
    }


export const getGetComplianceOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getComplianceOverview>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getComplianceOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetComplianceOverviewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getComplianceOverview>>> = ({ signal }) => getComplianceOverview({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getComplianceOverview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetComplianceOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getComplianceOverview>>>
export type GetComplianceOverviewQueryError = ErrorType<unknown>


/**
 * @summary Compliance Vault dashboard summary counts
 */

export function useGetComplianceOverview<TData = Awaited<ReturnType<typeof getComplianceOverview>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getComplianceOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetComplianceOverviewQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListComplianceProfilesUrl = (params?: ListComplianceProfilesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/compliance/profiles?${stringifiedParams}` : `/api/compliance/profiles`
}

/**
 * @summary List compliance profiles (customers/suppliers)
 */
export const listComplianceProfiles = async (params?: ListComplianceProfilesParams, options?: RequestInit): Promise<ComplianceProfileListResponse> => {

  return customFetch<ComplianceProfileListResponse>(getListComplianceProfilesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListComplianceProfilesQueryKey = (params?: ListComplianceProfilesParams,) => {
    return [
    `/api/compliance/profiles`, ...(params ? [params] : [])
    ] as const;
    }


export const getListComplianceProfilesQueryOptions = <TData = Awaited<ReturnType<typeof listComplianceProfiles>>, TError = ErrorType<unknown>>(params?: ListComplianceProfilesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listComplianceProfiles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListComplianceProfilesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listComplianceProfiles>>> = ({ signal }) => listComplianceProfiles(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listComplianceProfiles>>, TError, TData> & { queryKey: QueryKey }
}

export type ListComplianceProfilesQueryResult = NonNullable<Awaited<ReturnType<typeof listComplianceProfiles>>>
export type ListComplianceProfilesQueryError = ErrorType<unknown>


/**
 * @summary List compliance profiles (customers/suppliers)
 */

export function useListComplianceProfiles<TData = Awaited<ReturnType<typeof listComplianceProfiles>>, TError = ErrorType<unknown>>(
 params?: ListComplianceProfilesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listComplianceProfiles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListComplianceProfilesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateComplianceProfileUrl = () => {




  return `/api/compliance/profiles`
}

/**
 * @summary Create a compliance profile for a customer or supplier
 */
export const createComplianceProfile = async (complianceProfileInput: ComplianceProfileInput, options?: RequestInit): Promise<ComplianceProfileDetail> => {

  return customFetch<ComplianceProfileDetail>(getCreateComplianceProfileUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(complianceProfileInput)
  }
);}





export const getCreateComplianceProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createComplianceProfile>>, TError,{data: BodyType<ComplianceProfileInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createComplianceProfile>>, TError,{data: BodyType<ComplianceProfileInput>}, TContext> => {

const mutationKey = ['createComplianceProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createComplianceProfile>>, {data: BodyType<ComplianceProfileInput>}> = (props) => {
          const {data} = props ?? {};

          return  createComplianceProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateComplianceProfileMutationResult = NonNullable<Awaited<ReturnType<typeof createComplianceProfile>>>
    export type CreateComplianceProfileMutationBody = BodyType<ComplianceProfileInput>
    export type CreateComplianceProfileMutationError = ErrorType<unknown>

    /**
 * @summary Create a compliance profile for a customer or supplier
 */
export const useCreateComplianceProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createComplianceProfile>>, TError,{data: BodyType<ComplianceProfileInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createComplianceProfile>>,
        TError,
        {data: BodyType<ComplianceProfileInput>},
        TContext
      > => {
      return useMutation(getCreateComplianceProfileMutationOptions(options));
    }

export const getGetComplianceProfileBySubjectUrl = (subjectType: 'customer' | 'supplier',
    subjectId: string,) => {




  return `/api/compliance/profiles/by-subject/${subjectType}/${subjectId}`
}

/**
 * @summary Fetch the compliance profile for a subject (customer/supplier), if any
 */
export const getComplianceProfileBySubject = async (subjectType: 'customer' | 'supplier',
    subjectId: string, options?: RequestInit): Promise<ComplianceProfileDetail> => {

  return customFetch<ComplianceProfileDetail>(getGetComplianceProfileBySubjectUrl(subjectType,subjectId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetComplianceProfileBySubjectQueryKey = (subjectType: 'customer' | 'supplier',
    subjectId: string,) => {
    return [
    `/api/compliance/profiles/by-subject/${subjectType}/${subjectId}`
    ] as const;
    }


export const getGetComplianceProfileBySubjectQueryOptions = <TData = Awaited<ReturnType<typeof getComplianceProfileBySubject>>, TError = ErrorType<void>>(subjectType: 'customer' | 'supplier',
    subjectId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getComplianceProfileBySubject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetComplianceProfileBySubjectQueryKey(subjectType,subjectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getComplianceProfileBySubject>>> = ({ signal }) => getComplianceProfileBySubject(subjectType,subjectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: subjectType !== null && subjectType !== undefined && subjectId !== null && subjectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getComplianceProfileBySubject>>, TError, TData> & { queryKey: QueryKey }
}

export type GetComplianceProfileBySubjectQueryResult = NonNullable<Awaited<ReturnType<typeof getComplianceProfileBySubject>>>
export type GetComplianceProfileBySubjectQueryError = ErrorType<void>


/**
 * @summary Fetch the compliance profile for a subject (customer/supplier), if any
 */

export function useGetComplianceProfileBySubject<TData = Awaited<ReturnType<typeof getComplianceProfileBySubject>>, TError = ErrorType<void>>(
 subjectType: 'customer' | 'supplier',
    subjectId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getComplianceProfileBySubject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetComplianceProfileBySubjectQueryOptions(subjectType,subjectId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetComplianceProfileUrl = (id: string,) => {




  return `/api/compliance/profiles/${id}`
}

export const getComplianceProfile = async (id: string, options?: RequestInit): Promise<ComplianceProfileDetail> => {

  return customFetch<ComplianceProfileDetail>(getGetComplianceProfileUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetComplianceProfileQueryKey = (id: string,) => {
    return [
    `/api/compliance/profiles/${id}`
    ] as const;
    }


export const getGetComplianceProfileQueryOptions = <TData = Awaited<ReturnType<typeof getComplianceProfile>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getComplianceProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetComplianceProfileQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getComplianceProfile>>> = ({ signal }) => getComplianceProfile(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getComplianceProfile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetComplianceProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getComplianceProfile>>>
export type GetComplianceProfileQueryError = ErrorType<unknown>



export function useGetComplianceProfile<TData = Awaited<ReturnType<typeof getComplianceProfile>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getComplianceProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetComplianceProfileQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateComplianceProfileUrl = (id: string,) => {




  return `/api/compliance/profiles/${id}`
}

export const updateComplianceProfile = async (id: string,
    complianceProfileUpdate: ComplianceProfileUpdate, options?: RequestInit): Promise<ComplianceProfileDetail> => {

  return customFetch<ComplianceProfileDetail>(getUpdateComplianceProfileUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(complianceProfileUpdate)
  }
);}





export const getUpdateComplianceProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateComplianceProfile>>, TError,{id: string;data: BodyType<ComplianceProfileUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateComplianceProfile>>, TError,{id: string;data: BodyType<ComplianceProfileUpdate>}, TContext> => {

const mutationKey = ['updateComplianceProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateComplianceProfile>>, {id: string;data: BodyType<ComplianceProfileUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateComplianceProfile(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateComplianceProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateComplianceProfile>>>
    export type UpdateComplianceProfileMutationBody = BodyType<ComplianceProfileUpdate>
    export type UpdateComplianceProfileMutationError = ErrorType<unknown>

    export const useUpdateComplianceProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateComplianceProfile>>, TError,{id: string;data: BodyType<ComplianceProfileUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateComplianceProfile>>,
        TError,
        {id: string;data: BodyType<ComplianceProfileUpdate>},
        TContext
      > => {
      return useMutation(getUpdateComplianceProfileMutationOptions(options));
    }

export const getDeleteComplianceProfileUrl = (id: string,) => {




  return `/api/compliance/profiles/${id}`
}

/**
 * @summary Delete a compliance profile and its checks/documents/tasks
 */
export const deleteComplianceProfile = async (id: string, options?: RequestInit): Promise<ComplianceOkResponse> => {

  return customFetch<ComplianceOkResponse>(getDeleteComplianceProfileUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteComplianceProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteComplianceProfile>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteComplianceProfile>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteComplianceProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteComplianceProfile>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteComplianceProfile(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteComplianceProfileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteComplianceProfile>>>

    export type DeleteComplianceProfileMutationError = ErrorType<unknown>

    /**
 * @summary Delete a compliance profile and its checks/documents/tasks
 */
export const useDeleteComplianceProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteComplianceProfile>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteComplianceProfile>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteComplianceProfileMutationOptions(options));
    }

export const getListComplianceReviewsUrl = (id: string,) => {




  return `/api/compliance/profiles/${id}/reviews`
}

/**
 * @summary List recorded KYC/AML/identity checks for a profile
 */
export const listComplianceReviews = async (id: string, options?: RequestInit): Promise<ComplianceReviewRow[]> => {

  return customFetch<ComplianceReviewRow[]>(getListComplianceReviewsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListComplianceReviewsQueryKey = (id: string,) => {
    return [
    `/api/compliance/profiles/${id}/reviews`
    ] as const;
    }


export const getListComplianceReviewsQueryOptions = <TData = Awaited<ReturnType<typeof listComplianceReviews>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listComplianceReviews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListComplianceReviewsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listComplianceReviews>>> = ({ signal }) => listComplianceReviews(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listComplianceReviews>>, TError, TData> & { queryKey: QueryKey }
}

export type ListComplianceReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof listComplianceReviews>>>
export type ListComplianceReviewsQueryError = ErrorType<unknown>


/**
 * @summary List recorded KYC/AML/identity checks for a profile
 */

export function useListComplianceReviews<TData = Awaited<ReturnType<typeof listComplianceReviews>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listComplianceReviews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListComplianceReviewsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateComplianceReviewUrl = (id: string,) => {




  return `/api/compliance/profiles/${id}/reviews`
}

/**
 * @summary Record a KYC/AML/identity check against a profile
 */
export const createComplianceReview = async (id: string,
    complianceReviewInput: ComplianceReviewInput, options?: RequestInit): Promise<ComplianceReviewRow> => {

  return customFetch<ComplianceReviewRow>(getCreateComplianceReviewUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(complianceReviewInput)
  }
);}





export const getCreateComplianceReviewMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createComplianceReview>>, TError,{id: string;data: BodyType<ComplianceReviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createComplianceReview>>, TError,{id: string;data: BodyType<ComplianceReviewInput>}, TContext> => {

const mutationKey = ['createComplianceReview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createComplianceReview>>, {id: string;data: BodyType<ComplianceReviewInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createComplianceReview(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateComplianceReviewMutationResult = NonNullable<Awaited<ReturnType<typeof createComplianceReview>>>
    export type CreateComplianceReviewMutationBody = BodyType<ComplianceReviewInput>
    export type CreateComplianceReviewMutationError = ErrorType<unknown>

    /**
 * @summary Record a KYC/AML/identity check against a profile
 */
export const useCreateComplianceReview = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createComplianceReview>>, TError,{id: string;data: BodyType<ComplianceReviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createComplianceReview>>,
        TError,
        {id: string;data: BodyType<ComplianceReviewInput>},
        TContext
      > => {
      return useMutation(getCreateComplianceReviewMutationOptions(options));
    }

export const getUpdateComplianceReviewUrl = (reviewId: string,) => {




  return `/api/compliance/reviews/${reviewId}`
}

export const updateComplianceReview = async (reviewId: string,
    complianceReviewUpdate: ComplianceReviewUpdate, options?: RequestInit): Promise<ComplianceReviewRow> => {

  return customFetch<ComplianceReviewRow>(getUpdateComplianceReviewUrl(reviewId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(complianceReviewUpdate)
  }
);}





export const getUpdateComplianceReviewMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateComplianceReview>>, TError,{reviewId: string;data: BodyType<ComplianceReviewUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateComplianceReview>>, TError,{reviewId: string;data: BodyType<ComplianceReviewUpdate>}, TContext> => {

const mutationKey = ['updateComplianceReview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateComplianceReview>>, {reviewId: string;data: BodyType<ComplianceReviewUpdate>}> = (props) => {
          const {reviewId,data} = props ?? {};

          return  updateComplianceReview(reviewId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateComplianceReviewMutationResult = NonNullable<Awaited<ReturnType<typeof updateComplianceReview>>>
    export type UpdateComplianceReviewMutationBody = BodyType<ComplianceReviewUpdate>
    export type UpdateComplianceReviewMutationError = ErrorType<unknown>

    export const useUpdateComplianceReview = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateComplianceReview>>, TError,{reviewId: string;data: BodyType<ComplianceReviewUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateComplianceReview>>,
        TError,
        {reviewId: string;data: BodyType<ComplianceReviewUpdate>},
        TContext
      > => {
      return useMutation(getUpdateComplianceReviewMutationOptions(options));
    }

export const getDeleteComplianceReviewUrl = (reviewId: string,) => {




  return `/api/compliance/reviews/${reviewId}`
}

export const deleteComplianceReview = async (reviewId: string, options?: RequestInit): Promise<ComplianceOkResponse> => {

  return customFetch<ComplianceOkResponse>(getDeleteComplianceReviewUrl(reviewId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteComplianceReviewMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteComplianceReview>>, TError,{reviewId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteComplianceReview>>, TError,{reviewId: string}, TContext> => {

const mutationKey = ['deleteComplianceReview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteComplianceReview>>, {reviewId: string}> = (props) => {
          const {reviewId} = props ?? {};

          return  deleteComplianceReview(reviewId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteComplianceReviewMutationResult = NonNullable<Awaited<ReturnType<typeof deleteComplianceReview>>>

    export type DeleteComplianceReviewMutationError = ErrorType<unknown>

    export const useDeleteComplianceReview = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteComplianceReview>>, TError,{reviewId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteComplianceReview>>,
        TError,
        {reviewId: string},
        TContext
      > => {
      return useMutation(getDeleteComplianceReviewMutationOptions(options));
    }

export const getListComplianceDocumentsUrl = (id: string,) => {




  return `/api/compliance/profiles/${id}/documents`
}

export const listComplianceDocuments = async (id: string, options?: RequestInit): Promise<ComplianceDocumentRow[]> => {

  return customFetch<ComplianceDocumentRow[]>(getListComplianceDocumentsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListComplianceDocumentsQueryKey = (id: string,) => {
    return [
    `/api/compliance/profiles/${id}/documents`
    ] as const;
    }


export const getListComplianceDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof listComplianceDocuments>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listComplianceDocuments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListComplianceDocumentsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listComplianceDocuments>>> = ({ signal }) => listComplianceDocuments(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listComplianceDocuments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListComplianceDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listComplianceDocuments>>>
export type ListComplianceDocumentsQueryError = ErrorType<unknown>



export function useListComplianceDocuments<TData = Awaited<ReturnType<typeof listComplianceDocuments>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listComplianceDocuments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListComplianceDocumentsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddComplianceDocumentUrl = (id: string,) => {




  return `/api/compliance/profiles/${id}/documents`
}

/**
 * @summary Register an already-uploaded private object as a compliance document
 */
export const addComplianceDocument = async (id: string,
    complianceDocumentInput: ComplianceDocumentInput, options?: RequestInit): Promise<ComplianceDocumentRow> => {

  return customFetch<ComplianceDocumentRow>(getAddComplianceDocumentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(complianceDocumentInput)
  }
);}





export const getAddComplianceDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addComplianceDocument>>, TError,{id: string;data: BodyType<ComplianceDocumentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addComplianceDocument>>, TError,{id: string;data: BodyType<ComplianceDocumentInput>}, TContext> => {

const mutationKey = ['addComplianceDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addComplianceDocument>>, {id: string;data: BodyType<ComplianceDocumentInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  addComplianceDocument(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddComplianceDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof addComplianceDocument>>>
    export type AddComplianceDocumentMutationBody = BodyType<ComplianceDocumentInput>
    export type AddComplianceDocumentMutationError = ErrorType<unknown>

    /**
 * @summary Register an already-uploaded private object as a compliance document
 */
export const useAddComplianceDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addComplianceDocument>>, TError,{id: string;data: BodyType<ComplianceDocumentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addComplianceDocument>>,
        TError,
        {id: string;data: BodyType<ComplianceDocumentInput>},
        TContext
      > => {
      return useMutation(getAddComplianceDocumentMutationOptions(options));
    }

export const getDeleteComplianceDocumentUrl = (documentId: string,) => {




  return `/api/compliance/documents/${documentId}`
}

export const deleteComplianceDocument = async (documentId: string, options?: RequestInit): Promise<ComplianceOkResponse> => {

  return customFetch<ComplianceOkResponse>(getDeleteComplianceDocumentUrl(documentId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteComplianceDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteComplianceDocument>>, TError,{documentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteComplianceDocument>>, TError,{documentId: string}, TContext> => {

const mutationKey = ['deleteComplianceDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteComplianceDocument>>, {documentId: string}> = (props) => {
          const {documentId} = props ?? {};

          return  deleteComplianceDocument(documentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteComplianceDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteComplianceDocument>>>

    export type DeleteComplianceDocumentMutationError = ErrorType<unknown>

    export const useDeleteComplianceDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteComplianceDocument>>, TError,{documentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteComplianceDocument>>,
        TError,
        {documentId: string},
        TContext
      > => {
      return useMutation(getDeleteComplianceDocumentMutationOptions(options));
    }

export const getListComplianceProfileAuditUrl = (id: string,) => {




  return `/api/compliance/profiles/${id}/audit`
}

/**
 * @summary Append-only audit history for a compliance profile
 */
export const listComplianceProfileAudit = async (id: string, options?: RequestInit): Promise<ComplianceAuditRow[]> => {

  return customFetch<ComplianceAuditRow[]>(getListComplianceProfileAuditUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListComplianceProfileAuditQueryKey = (id: string,) => {
    return [
    `/api/compliance/profiles/${id}/audit`
    ] as const;
    }


export const getListComplianceProfileAuditQueryOptions = <TData = Awaited<ReturnType<typeof listComplianceProfileAudit>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listComplianceProfileAudit>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListComplianceProfileAuditQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listComplianceProfileAudit>>> = ({ signal }) => listComplianceProfileAudit(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listComplianceProfileAudit>>, TError, TData> & { queryKey: QueryKey }
}

export type ListComplianceProfileAuditQueryResult = NonNullable<Awaited<ReturnType<typeof listComplianceProfileAudit>>>
export type ListComplianceProfileAuditQueryError = ErrorType<unknown>


/**
 * @summary Append-only audit history for a compliance profile
 */

export function useListComplianceProfileAudit<TData = Awaited<ReturnType<typeof listComplianceProfileAudit>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listComplianceProfileAudit>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListComplianceProfileAuditQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListComplianceTasksUrl = (params?: ListComplianceTasksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/compliance/tasks?${stringifiedParams}` : `/api/compliance/tasks`
}

/**
 * @summary List compliance tasks
 */
export const listComplianceTasks = async (params?: ListComplianceTasksParams, options?: RequestInit): Promise<ComplianceTaskListResponse> => {

  return customFetch<ComplianceTaskListResponse>(getListComplianceTasksUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListComplianceTasksQueryKey = (params?: ListComplianceTasksParams,) => {
    return [
    `/api/compliance/tasks`, ...(params ? [params] : [])
    ] as const;
    }


export const getListComplianceTasksQueryOptions = <TData = Awaited<ReturnType<typeof listComplianceTasks>>, TError = ErrorType<unknown>>(params?: ListComplianceTasksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listComplianceTasks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListComplianceTasksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listComplianceTasks>>> = ({ signal }) => listComplianceTasks(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listComplianceTasks>>, TError, TData> & { queryKey: QueryKey }
}

export type ListComplianceTasksQueryResult = NonNullable<Awaited<ReturnType<typeof listComplianceTasks>>>
export type ListComplianceTasksQueryError = ErrorType<unknown>


/**
 * @summary List compliance tasks
 */

export function useListComplianceTasks<TData = Awaited<ReturnType<typeof listComplianceTasks>>, TError = ErrorType<unknown>>(
 params?: ListComplianceTasksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listComplianceTasks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListComplianceTasksQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateComplianceTaskUrl = () => {




  return `/api/compliance/tasks`
}

/**
 * @summary Create a compliance task
 */
export const createComplianceTask = async (complianceTaskInput: ComplianceTaskInput, options?: RequestInit): Promise<ComplianceTaskRow> => {

  return customFetch<ComplianceTaskRow>(getCreateComplianceTaskUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(complianceTaskInput)
  }
);}





export const getCreateComplianceTaskMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createComplianceTask>>, TError,{data: BodyType<ComplianceTaskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createComplianceTask>>, TError,{data: BodyType<ComplianceTaskInput>}, TContext> => {

const mutationKey = ['createComplianceTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createComplianceTask>>, {data: BodyType<ComplianceTaskInput>}> = (props) => {
          const {data} = props ?? {};

          return  createComplianceTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateComplianceTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createComplianceTask>>>
    export type CreateComplianceTaskMutationBody = BodyType<ComplianceTaskInput>
    export type CreateComplianceTaskMutationError = ErrorType<unknown>

    /**
 * @summary Create a compliance task
 */
export const useCreateComplianceTask = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createComplianceTask>>, TError,{data: BodyType<ComplianceTaskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createComplianceTask>>,
        TError,
        {data: BodyType<ComplianceTaskInput>},
        TContext
      > => {
      return useMutation(getCreateComplianceTaskMutationOptions(options));
    }

export const getUpdateComplianceTaskUrl = (taskId: string,) => {




  return `/api/compliance/tasks/${taskId}`
}

export const updateComplianceTask = async (taskId: string,
    complianceTaskUpdate: ComplianceTaskUpdate, options?: RequestInit): Promise<ComplianceTaskRow> => {

  return customFetch<ComplianceTaskRow>(getUpdateComplianceTaskUrl(taskId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(complianceTaskUpdate)
  }
);}





export const getUpdateComplianceTaskMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateComplianceTask>>, TError,{taskId: string;data: BodyType<ComplianceTaskUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateComplianceTask>>, TError,{taskId: string;data: BodyType<ComplianceTaskUpdate>}, TContext> => {

const mutationKey = ['updateComplianceTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateComplianceTask>>, {taskId: string;data: BodyType<ComplianceTaskUpdate>}> = (props) => {
          const {taskId,data} = props ?? {};

          return  updateComplianceTask(taskId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateComplianceTaskMutationResult = NonNullable<Awaited<ReturnType<typeof updateComplianceTask>>>
    export type UpdateComplianceTaskMutationBody = BodyType<ComplianceTaskUpdate>
    export type UpdateComplianceTaskMutationError = ErrorType<unknown>

    export const useUpdateComplianceTask = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateComplianceTask>>, TError,{taskId: string;data: BodyType<ComplianceTaskUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateComplianceTask>>,
        TError,
        {taskId: string;data: BodyType<ComplianceTaskUpdate>},
        TContext
      > => {
      return useMutation(getUpdateComplianceTaskMutationOptions(options));
    }

export const getDeleteComplianceTaskUrl = (taskId: string,) => {




  return `/api/compliance/tasks/${taskId}`
}

export const deleteComplianceTask = async (taskId: string, options?: RequestInit): Promise<ComplianceOkResponse> => {

  return customFetch<ComplianceOkResponse>(getDeleteComplianceTaskUrl(taskId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteComplianceTaskMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteComplianceTask>>, TError,{taskId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteComplianceTask>>, TError,{taskId: string}, TContext> => {

const mutationKey = ['deleteComplianceTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteComplianceTask>>, {taskId: string}> = (props) => {
          const {taskId} = props ?? {};

          return  deleteComplianceTask(taskId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteComplianceTaskMutationResult = NonNullable<Awaited<ReturnType<typeof deleteComplianceTask>>>

    export type DeleteComplianceTaskMutationError = ErrorType<unknown>

    export const useDeleteComplianceTask = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteComplianceTask>>, TError,{taskId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteComplianceTask>>,
        TError,
        {taskId: string},
        TContext
      > => {
      return useMutation(getDeleteComplianceTaskMutationOptions(options));
    }

export const getGetShopifyMappingSourceCatalogUrl = () => {




  return `/api/shopify/field-mappings/source-fields`
}

/**
 * Static catalogue used by the Field Mapping editor: every internal source field an admin can map, the Shopify native targets, the available transform kinds, and common metafield types. Gated by `shopify.field_mappings.view`.
 * @summary Catalogue of mappable source fields, native targets, transforms
 */
export const getShopifyMappingSourceCatalog = async ( options?: RequestInit): Promise<ShopifyMappingSourceCatalog> => {

  return customFetch<ShopifyMappingSourceCatalog>(getGetShopifyMappingSourceCatalogUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetShopifyMappingSourceCatalogQueryKey = () => {
    return [
    `/api/shopify/field-mappings/source-fields`
    ] as const;
    }


export const getGetShopifyMappingSourceCatalogQueryOptions = <TData = Awaited<ReturnType<typeof getShopifyMappingSourceCatalog>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopifyMappingSourceCatalog>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShopifyMappingSourceCatalogQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShopifyMappingSourceCatalog>>> = ({ signal }) => getShopifyMappingSourceCatalog({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShopifyMappingSourceCatalog>>, TError, TData> & { queryKey: QueryKey }
}

export type GetShopifyMappingSourceCatalogQueryResult = NonNullable<Awaited<ReturnType<typeof getShopifyMappingSourceCatalog>>>
export type GetShopifyMappingSourceCatalogQueryError = ErrorType<unknown>


/**
 * @summary Catalogue of mappable source fields, native targets, transforms
 */

export function useGetShopifyMappingSourceCatalog<TData = Awaited<ReturnType<typeof getShopifyMappingSourceCatalog>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopifyMappingSourceCatalog>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetShopifyMappingSourceCatalogQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListShopifyMappingProfilesUrl = () => {




  return `/api/shopify/field-mappings/profiles`
}

/**
 * @summary List this tenant's Shopify mapping profiles
 */
export const listShopifyMappingProfiles = async ( options?: RequestInit): Promise<ShopifyMappingProfileList> => {

  return customFetch<ShopifyMappingProfileList>(getListShopifyMappingProfilesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListShopifyMappingProfilesQueryKey = () => {
    return [
    `/api/shopify/field-mappings/profiles`
    ] as const;
    }


export const getListShopifyMappingProfilesQueryOptions = <TData = Awaited<ReturnType<typeof listShopifyMappingProfiles>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShopifyMappingProfiles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListShopifyMappingProfilesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listShopifyMappingProfiles>>> = ({ signal }) => listShopifyMappingProfiles({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listShopifyMappingProfiles>>, TError, TData> & { queryKey: QueryKey }
}

export type ListShopifyMappingProfilesQueryResult = NonNullable<Awaited<ReturnType<typeof listShopifyMappingProfiles>>>
export type ListShopifyMappingProfilesQueryError = ErrorType<unknown>


/**
 * @summary List this tenant's Shopify mapping profiles
 */

export function useListShopifyMappingProfiles<TData = Awaited<ReturnType<typeof listShopifyMappingProfiles>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShopifyMappingProfiles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListShopifyMappingProfilesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateShopifyMappingProfileUrl = () => {




  return `/api/shopify/field-mappings/profiles`
}

/**
 * Creates a profile. When `copyFromProfileId` is given the new profile copies that profile's mappings; otherwise it is seeded with the built-in default mappings (which reproduce today's push). Gated by `shopify.field_mappings.manage_profiles`.
 * @summary Create a new mapping profile
 */
export const createShopifyMappingProfile = async (shopifyCreateProfileBody: ShopifyCreateProfileBody, options?: RequestInit): Promise<ShopifyMappingProfileDetail> => {

  return customFetch<ShopifyMappingProfileDetail>(getCreateShopifyMappingProfileUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(shopifyCreateProfileBody)
  }
);}





export const getCreateShopifyMappingProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createShopifyMappingProfile>>, TError,{data: BodyType<ShopifyCreateProfileBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createShopifyMappingProfile>>, TError,{data: BodyType<ShopifyCreateProfileBody>}, TContext> => {

const mutationKey = ['createShopifyMappingProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createShopifyMappingProfile>>, {data: BodyType<ShopifyCreateProfileBody>}> = (props) => {
          const {data} = props ?? {};

          return  createShopifyMappingProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateShopifyMappingProfileMutationResult = NonNullable<Awaited<ReturnType<typeof createShopifyMappingProfile>>>
    export type CreateShopifyMappingProfileMutationBody = BodyType<ShopifyCreateProfileBody>
    export type CreateShopifyMappingProfileMutationError = ErrorType<unknown>

    /**
 * @summary Create a new mapping profile
 */
export const useCreateShopifyMappingProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createShopifyMappingProfile>>, TError,{data: BodyType<ShopifyCreateProfileBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createShopifyMappingProfile>>,
        TError,
        {data: BodyType<ShopifyCreateProfileBody>},
        TContext
      > => {
      return useMutation(getCreateShopifyMappingProfileMutationOptions(options));
    }

export const getGetShopifyMappingProfileUrl = (profileId: string,) => {




  return `/api/shopify/field-mappings/profiles/${profileId}`
}

/**
 * @summary Get a mapping profile and its ordered field mappings
 */
export const getShopifyMappingProfile = async (profileId: string, options?: RequestInit): Promise<ShopifyMappingProfileDetail> => {

  return customFetch<ShopifyMappingProfileDetail>(getGetShopifyMappingProfileUrl(profileId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetShopifyMappingProfileQueryKey = (profileId: string,) => {
    return [
    `/api/shopify/field-mappings/profiles/${profileId}`
    ] as const;
    }


export const getGetShopifyMappingProfileQueryOptions = <TData = Awaited<ReturnType<typeof getShopifyMappingProfile>>, TError = ErrorType<void>>(profileId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopifyMappingProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShopifyMappingProfileQueryKey(profileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShopifyMappingProfile>>> = ({ signal }) => getShopifyMappingProfile(profileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: profileId !== null && profileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShopifyMappingProfile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetShopifyMappingProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getShopifyMappingProfile>>>
export type GetShopifyMappingProfileQueryError = ErrorType<void>


/**
 * @summary Get a mapping profile and its ordered field mappings
 */

export function useGetShopifyMappingProfile<TData = Awaited<ReturnType<typeof getShopifyMappingProfile>>, TError = ErrorType<void>>(
 profileId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopifyMappingProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetShopifyMappingProfileQueryOptions(profileId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateShopifyMappingProfileUrl = (profileId: string,) => {




  return `/api/shopify/field-mappings/profiles/${profileId}`
}

/**
 * Update a profile's name, description, or active state. Setting `isActive: true` activates this profile (and deactivates any other — at most one active per tenant). Gated by `shopify.field_mappings.manage_profiles`.
 * @summary Rename / re-describe / activate a profile
 */
export const updateShopifyMappingProfile = async (profileId: string,
    shopifyUpdateProfileBody: ShopifyUpdateProfileBody, options?: RequestInit): Promise<ShopifyMappingProfileDetail> => {

  return customFetch<ShopifyMappingProfileDetail>(getUpdateShopifyMappingProfileUrl(profileId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(shopifyUpdateProfileBody)
  }
);}





export const getUpdateShopifyMappingProfileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateShopifyMappingProfile>>, TError,{profileId: string;data: BodyType<ShopifyUpdateProfileBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateShopifyMappingProfile>>, TError,{profileId: string;data: BodyType<ShopifyUpdateProfileBody>}, TContext> => {

const mutationKey = ['updateShopifyMappingProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateShopifyMappingProfile>>, {profileId: string;data: BodyType<ShopifyUpdateProfileBody>}> = (props) => {
          const {profileId,data} = props ?? {};

          return  updateShopifyMappingProfile(profileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateShopifyMappingProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateShopifyMappingProfile>>>
    export type UpdateShopifyMappingProfileMutationBody = BodyType<ShopifyUpdateProfileBody>
    export type UpdateShopifyMappingProfileMutationError = ErrorType<void>

    /**
 * @summary Rename / re-describe / activate a profile
 */
export const useUpdateShopifyMappingProfile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateShopifyMappingProfile>>, TError,{profileId: string;data: BodyType<ShopifyUpdateProfileBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateShopifyMappingProfile>>,
        TError,
        {profileId: string;data: BodyType<ShopifyUpdateProfileBody>},
        TContext
      > => {
      return useMutation(getUpdateShopifyMappingProfileMutationOptions(options));
    }

export const getDeleteShopifyMappingProfileUrl = (profileId: string,) => {




  return `/api/shopify/field-mappings/profiles/${profileId}`
}

/**
 * Deletes a non-default profile. The built-in default profile cannot be deleted. Deleting the active profile leaves the tenant with no active profile (push reverts to legacy behaviour). Gated by `shopify.field_mappings.manage_profiles`.
 * @summary Delete a mapping profile
 */
export const deleteShopifyMappingProfile = async (profileId: string, options?: RequestInit): Promise<ShopifyMappingOkResponse> => {

  return customFetch<ShopifyMappingOkResponse>(getDeleteShopifyMappingProfileUrl(profileId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteShopifyMappingProfileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteShopifyMappingProfile>>, TError,{profileId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteShopifyMappingProfile>>, TError,{profileId: string}, TContext> => {

const mutationKey = ['deleteShopifyMappingProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteShopifyMappingProfile>>, {profileId: string}> = (props) => {
          const {profileId} = props ?? {};

          return  deleteShopifyMappingProfile(profileId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteShopifyMappingProfileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteShopifyMappingProfile>>>

    export type DeleteShopifyMappingProfileMutationError = ErrorType<void>

    /**
 * @summary Delete a mapping profile
 */
export const useDeleteShopifyMappingProfile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteShopifyMappingProfile>>, TError,{profileId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteShopifyMappingProfile>>,
        TError,
        {profileId: string},
        TContext
      > => {
      return useMutation(getDeleteShopifyMappingProfileMutationOptions(options));
    }

export const getDuplicateShopifyMappingProfileUrl = (profileId: string,) => {




  return `/api/shopify/field-mappings/profiles/${profileId}/duplicate`
}

/**
 * @summary Duplicate a profile (with all its mappings)
 */
export const duplicateShopifyMappingProfile = async (profileId: string,
    shopifyDuplicateProfileBody: ShopifyDuplicateProfileBody, options?: RequestInit): Promise<ShopifyMappingProfileDetail> => {

  return customFetch<ShopifyMappingProfileDetail>(getDuplicateShopifyMappingProfileUrl(profileId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(shopifyDuplicateProfileBody)
  }
);}





export const getDuplicateShopifyMappingProfileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateShopifyMappingProfile>>, TError,{profileId: string;data: BodyType<ShopifyDuplicateProfileBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof duplicateShopifyMappingProfile>>, TError,{profileId: string;data: BodyType<ShopifyDuplicateProfileBody>}, TContext> => {

const mutationKey = ['duplicateShopifyMappingProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof duplicateShopifyMappingProfile>>, {profileId: string;data: BodyType<ShopifyDuplicateProfileBody>}> = (props) => {
          const {profileId,data} = props ?? {};

          return  duplicateShopifyMappingProfile(profileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DuplicateShopifyMappingProfileMutationResult = NonNullable<Awaited<ReturnType<typeof duplicateShopifyMappingProfile>>>
    export type DuplicateShopifyMappingProfileMutationBody = BodyType<ShopifyDuplicateProfileBody>
    export type DuplicateShopifyMappingProfileMutationError = ErrorType<void>

    /**
 * @summary Duplicate a profile (with all its mappings)
 */
export const useDuplicateShopifyMappingProfile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateShopifyMappingProfile>>, TError,{profileId: string;data: BodyType<ShopifyDuplicateProfileBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof duplicateShopifyMappingProfile>>,
        TError,
        {profileId: string;data: BodyType<ShopifyDuplicateProfileBody>},
        TContext
      > => {
      return useMutation(getDuplicateShopifyMappingProfileMutationOptions(options));
    }

export const getResetShopifyMappingProfileUrl = (profileId: string,) => {




  return `/api/shopify/field-mappings/profiles/${profileId}/reset`
}

/**
 * Replaces the profile's mappings with the built-in default set (which reproduces today's push). Gated by `shopify.field_mappings.manage_profiles`.
 * @summary Reset a profile's mappings to the built-in default
 */
export const resetShopifyMappingProfile = async (profileId: string, options?: RequestInit): Promise<ShopifyMappingProfileDetail> => {

  return customFetch<ShopifyMappingProfileDetail>(getResetShopifyMappingProfileUrl(profileId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResetShopifyMappingProfileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetShopifyMappingProfile>>, TError,{profileId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resetShopifyMappingProfile>>, TError,{profileId: string}, TContext> => {

const mutationKey = ['resetShopifyMappingProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetShopifyMappingProfile>>, {profileId: string}> = (props) => {
          const {profileId} = props ?? {};

          return  resetShopifyMappingProfile(profileId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetShopifyMappingProfileMutationResult = NonNullable<Awaited<ReturnType<typeof resetShopifyMappingProfile>>>

    export type ResetShopifyMappingProfileMutationError = ErrorType<void>

    /**
 * @summary Reset a profile's mappings to the built-in default
 */
export const useResetShopifyMappingProfile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetShopifyMappingProfile>>, TError,{profileId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resetShopifyMappingProfile>>,
        TError,
        {profileId: string},
        TContext
      > => {
      return useMutation(getResetShopifyMappingProfileMutationOptions(options));
    }

export const getReplaceShopifyFieldMappingsUrl = (profileId: string,) => {




  return `/api/shopify/field-mappings/profiles/${profileId}/mappings`
}

/**
 * Atomically replaces the profile's mapping rows with the supplied set. Gated by `shopify.field_mappings.manage`.
 * @summary Replace the full ordered set of field mappings for a profile
 */
export const replaceShopifyFieldMappings = async (profileId: string,
    shopifyReplaceMappingsBody: ShopifyReplaceMappingsBody, options?: RequestInit): Promise<ShopifyMappingProfileDetail> => {

  return customFetch<ShopifyMappingProfileDetail>(getReplaceShopifyFieldMappingsUrl(profileId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(shopifyReplaceMappingsBody)
  }
);}





export const getReplaceShopifyFieldMappingsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceShopifyFieldMappings>>, TError,{profileId: string;data: BodyType<ShopifyReplaceMappingsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof replaceShopifyFieldMappings>>, TError,{profileId: string;data: BodyType<ShopifyReplaceMappingsBody>}, TContext> => {

const mutationKey = ['replaceShopifyFieldMappings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceShopifyFieldMappings>>, {profileId: string;data: BodyType<ShopifyReplaceMappingsBody>}> = (props) => {
          const {profileId,data} = props ?? {};

          return  replaceShopifyFieldMappings(profileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplaceShopifyFieldMappingsMutationResult = NonNullable<Awaited<ReturnType<typeof replaceShopifyFieldMappings>>>
    export type ReplaceShopifyFieldMappingsMutationBody = BodyType<ShopifyReplaceMappingsBody>
    export type ReplaceShopifyFieldMappingsMutationError = ErrorType<void>

    /**
 * @summary Replace the full ordered set of field mappings for a profile
 */
export const useReplaceShopifyFieldMappings = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceShopifyFieldMappings>>, TError,{profileId: string;data: BodyType<ShopifyReplaceMappingsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof replaceShopifyFieldMappings>>,
        TError,
        {profileId: string;data: BodyType<ShopifyReplaceMappingsBody>},
        TContext
      > => {
      return useMutation(getReplaceShopifyFieldMappingsMutationOptions(options));
    }

export const getPreviewShopifyFieldMappingUrl = () => {




  return `/api/shopify/field-mappings/preview`
}

/**
 * Runs the mapping engine against a real inventory item and returns the resolved native fields, metafields, warnings and missing-required list — WITHOUT pushing anything to Shopify. Used by the "Test with a product" preview. Gated by `shopify.field_mappings.test`.
 * @summary Resolve the mapped Shopify payload for one item (no push)
 */
export const previewShopifyFieldMapping = async (shopifyMappingPreviewBody: ShopifyMappingPreviewBody, options?: RequestInit): Promise<ShopifyMappingPreviewResult> => {

  return customFetch<ShopifyMappingPreviewResult>(getPreviewShopifyFieldMappingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(shopifyMappingPreviewBody)
  }
);}





export const getPreviewShopifyFieldMappingMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewShopifyFieldMapping>>, TError,{data: BodyType<ShopifyMappingPreviewBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewShopifyFieldMapping>>, TError,{data: BodyType<ShopifyMappingPreviewBody>}, TContext> => {

const mutationKey = ['previewShopifyFieldMapping'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewShopifyFieldMapping>>, {data: BodyType<ShopifyMappingPreviewBody>}> = (props) => {
          const {data} = props ?? {};

          return  previewShopifyFieldMapping(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewShopifyFieldMappingMutationResult = NonNullable<Awaited<ReturnType<typeof previewShopifyFieldMapping>>>
    export type PreviewShopifyFieldMappingMutationBody = BodyType<ShopifyMappingPreviewBody>
    export type PreviewShopifyFieldMappingMutationError = ErrorType<void>

    /**
 * @summary Resolve the mapped Shopify payload for one item (no push)
 */
export const usePreviewShopifyFieldMapping = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewShopifyFieldMapping>>, TError,{data: BodyType<ShopifyMappingPreviewBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof previewShopifyFieldMapping>>,
        TError,
        {data: BodyType<ShopifyMappingPreviewBody>},
        TContext
      > => {
      return useMutation(getPreviewShopifyFieldMappingMutationOptions(options));
    }

export const getPushShopifyFieldMappingUrl = () => {




  return `/api/shopify/field-mappings/push`
}

/**
 * Pushes a single inventory item to Shopify applying the tenant's active mapping profile, optionally limited to a scope (all/price/stock/images/ description/metafields). Writes a mapping log row. Gated by `shopify.field_mappings.push`.
 * @summary Push one item to Shopify using the active profile (optionally scoped)
 */
export const pushShopifyFieldMapping = async (shopifyMappingPushBody: ShopifyMappingPushBody, options?: RequestInit): Promise<ShopifyMappingPushResult> => {

  return customFetch<ShopifyMappingPushResult>(getPushShopifyFieldMappingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(shopifyMappingPushBody)
  }
);}





export const getPushShopifyFieldMappingMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushShopifyFieldMapping>>, TError,{data: BodyType<ShopifyMappingPushBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pushShopifyFieldMapping>>, TError,{data: BodyType<ShopifyMappingPushBody>}, TContext> => {

const mutationKey = ['pushShopifyFieldMapping'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pushShopifyFieldMapping>>, {data: BodyType<ShopifyMappingPushBody>}> = (props) => {
          const {data} = props ?? {};

          return  pushShopifyFieldMapping(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PushShopifyFieldMappingMutationResult = NonNullable<Awaited<ReturnType<typeof pushShopifyFieldMapping>>>
    export type PushShopifyFieldMappingMutationBody = BodyType<ShopifyMappingPushBody>
    export type PushShopifyFieldMappingMutationError = ErrorType<void>

    /**
 * @summary Push one item to Shopify using the active profile (optionally scoped)
 */
export const usePushShopifyFieldMapping = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushShopifyFieldMapping>>, TError,{data: BodyType<ShopifyMappingPushBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof pushShopifyFieldMapping>>,
        TError,
        {data: BodyType<ShopifyMappingPushBody>},
        TContext
      > => {
      return useMutation(getPushShopifyFieldMappingMutationOptions(options));
    }

export const getListShopifyMappingLogsUrl = (params?: ListShopifyMappingLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/shopify/field-mappings/logs?${stringifiedParams}` : `/api/shopify/field-mappings/logs`
}

/**
 * @summary List recent mapping-driven push logs
 */
export const listShopifyMappingLogs = async (params?: ListShopifyMappingLogsParams, options?: RequestInit): Promise<ShopifyMappingLogList> => {

  return customFetch<ShopifyMappingLogList>(getListShopifyMappingLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListShopifyMappingLogsQueryKey = (params?: ListShopifyMappingLogsParams,) => {
    return [
    `/api/shopify/field-mappings/logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListShopifyMappingLogsQueryOptions = <TData = Awaited<ReturnType<typeof listShopifyMappingLogs>>, TError = ErrorType<unknown>>(params?: ListShopifyMappingLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShopifyMappingLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListShopifyMappingLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listShopifyMappingLogs>>> = ({ signal }) => listShopifyMappingLogs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listShopifyMappingLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListShopifyMappingLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listShopifyMappingLogs>>>
export type ListShopifyMappingLogsQueryError = ErrorType<unknown>


/**
 * @summary List recent mapping-driven push logs
 */

export function useListShopifyMappingLogs<TData = Awaited<ReturnType<typeof listShopifyMappingLogs>>, TError = ErrorType<unknown>>(
 params?: ListShopifyMappingLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShopifyMappingLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListShopifyMappingLogsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAccountSummaryUrl = () => {




  return `/api/account/summary`
}

/**
 * @summary Tenant account portal summary (details, features, subscription, announcements, onboarding)
 */
export const getAccountSummary = async ( options?: RequestInit): Promise<AccountSummary> => {

  return customFetch<AccountSummary>(getGetAccountSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAccountSummaryQueryKey = () => {
    return [
    `/api/account/summary`
    ] as const;
    }


export const getGetAccountSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getAccountSummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountSummary>>> = ({ signal }) => getAccountSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountSummary>>>
export type GetAccountSummaryQueryError = ErrorType<unknown>


/**
 * @summary Tenant account portal summary (details, features, subscription, announcements, onboarding)
 */

export function useGetAccountSummary<TData = Awaited<ReturnType<typeof getAccountSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateAccountSettingsUrl = () => {




  return `/api/account/settings`
}

/**
 * @summary Update tenant account settings (contact, company note, onboarding)
 */
export const updateAccountSettings = async (updateAccountSettingsInput: UpdateAccountSettingsInput, options?: RequestInit): Promise<AccountSettings> => {

  return customFetch<AccountSettings>(getUpdateAccountSettingsUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateAccountSettingsInput)
  }
);}





export const getUpdateAccountSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccountSettings>>, TError,{data: BodyType<UpdateAccountSettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAccountSettings>>, TError,{data: BodyType<UpdateAccountSettingsInput>}, TContext> => {

const mutationKey = ['updateAccountSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAccountSettings>>, {data: BodyType<UpdateAccountSettingsInput>}> = (props) => {
          const {data} = props ?? {};

          return  updateAccountSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAccountSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateAccountSettings>>>
    export type UpdateAccountSettingsMutationBody = BodyType<UpdateAccountSettingsInput>
    export type UpdateAccountSettingsMutationError = ErrorType<unknown>

    /**
 * @summary Update tenant account settings (contact, company note, onboarding)
 */
export const useUpdateAccountSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccountSettings>>, TError,{data: BodyType<UpdateAccountSettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAccountSettings>>,
        TError,
        {data: BodyType<UpdateAccountSettingsInput>},
        TContext
      > => {
      return useMutation(getUpdateAccountSettingsMutationOptions(options));
    }

export const getUpdateAccountBrandingUrl = () => {




  return `/api/account/branding`
}

/**
 * @summary Tenant self-serve invoice/app branding update (only when the platform has granted branding_self_service_enabled; requires tenant_account.manage)
 */
export const updateAccountBranding = async (appBrandingUpdate: AppBrandingUpdate, options?: RequestInit): Promise<AppBranding> => {

  return customFetch<AppBranding>(getUpdateAccountBrandingUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(appBrandingUpdate)
  }
);}





export const getUpdateAccountBrandingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccountBranding>>, TError,{data: BodyType<AppBrandingUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAccountBranding>>, TError,{data: BodyType<AppBrandingUpdate>}, TContext> => {

const mutationKey = ['updateAccountBranding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAccountBranding>>, {data: BodyType<AppBrandingUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateAccountBranding(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAccountBrandingMutationResult = NonNullable<Awaited<ReturnType<typeof updateAccountBranding>>>
    export type UpdateAccountBrandingMutationBody = BodyType<AppBrandingUpdate>
    export type UpdateAccountBrandingMutationError = ErrorType<unknown>

    /**
 * @summary Tenant self-serve invoice/app branding update (only when the platform has granted branding_self_service_enabled; requires tenant_account.manage)
 */
export const useUpdateAccountBranding = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccountBranding>>, TError,{data: BodyType<AppBrandingUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAccountBranding>>,
        TError,
        {data: BodyType<AppBrandingUpdate>},
        TContext
      > => {
      return useMutation(getUpdateAccountBrandingMutationOptions(options));
    }

export const getListFeatureRequestsUrl = (params?: ListFeatureRequestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/account/feature-requests?${stringifiedParams}` : `/api/account/feature-requests`
}

/**
 * @summary List this tenant's feature requests
 */
export const listFeatureRequests = async (params?: ListFeatureRequestsParams, options?: RequestInit): Promise<FeatureRequestList> => {

  return customFetch<FeatureRequestList>(getListFeatureRequestsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListFeatureRequestsQueryKey = (params?: ListFeatureRequestsParams,) => {
    return [
    `/api/account/feature-requests`, ...(params ? [params] : [])
    ] as const;
    }


export const getListFeatureRequestsQueryOptions = <TData = Awaited<ReturnType<typeof listFeatureRequests>>, TError = ErrorType<unknown>>(params?: ListFeatureRequestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFeatureRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFeatureRequestsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFeatureRequests>>> = ({ signal }) => listFeatureRequests(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFeatureRequests>>, TError, TData> & { queryKey: QueryKey }
}

export type ListFeatureRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof listFeatureRequests>>>
export type ListFeatureRequestsQueryError = ErrorType<unknown>


/**
 * @summary List this tenant's feature requests
 */

export function useListFeatureRequests<TData = Awaited<ReturnType<typeof listFeatureRequests>>, TError = ErrorType<unknown>>(
 params?: ListFeatureRequestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFeatureRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListFeatureRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateFeatureRequestUrl = () => {




  return `/api/account/feature-requests`
}

/**
 * @summary Submit a new feature request
 */
export const createFeatureRequest = async (createFeatureRequestInput: CreateFeatureRequestInput, options?: RequestInit): Promise<FeatureRequestDetail> => {

  return customFetch<FeatureRequestDetail>(getCreateFeatureRequestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createFeatureRequestInput)
  }
);}





export const getCreateFeatureRequestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFeatureRequest>>, TError,{data: BodyType<CreateFeatureRequestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createFeatureRequest>>, TError,{data: BodyType<CreateFeatureRequestInput>}, TContext> => {

const mutationKey = ['createFeatureRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFeatureRequest>>, {data: BodyType<CreateFeatureRequestInput>}> = (props) => {
          const {data} = props ?? {};

          return  createFeatureRequest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFeatureRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createFeatureRequest>>>
    export type CreateFeatureRequestMutationBody = BodyType<CreateFeatureRequestInput>
    export type CreateFeatureRequestMutationError = ErrorType<unknown>

    /**
 * @summary Submit a new feature request
 */
export const useCreateFeatureRequest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFeatureRequest>>, TError,{data: BodyType<CreateFeatureRequestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createFeatureRequest>>,
        TError,
        {data: BodyType<CreateFeatureRequestInput>},
        TContext
      > => {
      return useMutation(getCreateFeatureRequestMutationOptions(options));
    }

export const getGetFeatureRequestUrl = (id: string,) => {




  return `/api/account/feature-requests/${id}`
}

/**
 * @summary Get a feature request with its timeline + comments
 */
export const getFeatureRequest = async (id: string, options?: RequestInit): Promise<FeatureRequestDetail> => {

  return customFetch<FeatureRequestDetail>(getGetFeatureRequestUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFeatureRequestQueryKey = (id: string,) => {
    return [
    `/api/account/feature-requests/${id}`
    ] as const;
    }


export const getGetFeatureRequestQueryOptions = <TData = Awaited<ReturnType<typeof getFeatureRequest>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFeatureRequest>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeatureRequestQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeatureRequest>>> = ({ signal }) => getFeatureRequest(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeatureRequest>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFeatureRequestQueryResult = NonNullable<Awaited<ReturnType<typeof getFeatureRequest>>>
export type GetFeatureRequestQueryError = ErrorType<void>


/**
 * @summary Get a feature request with its timeline + comments
 */

export function useGetFeatureRequest<TData = Awaited<ReturnType<typeof getFeatureRequest>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFeatureRequest>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetFeatureRequestQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCancelFeatureRequestUrl = (id: string,) => {




  return `/api/account/feature-requests/${id}/cancel`
}

/**
 * @summary Cancel an open feature request you submitted
 */
export const cancelFeatureRequest = async (id: string, options?: RequestInit): Promise<FeatureRequestDetail> => {

  return customFetch<FeatureRequestDetail>(getCancelFeatureRequestUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelFeatureRequestMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelFeatureRequest>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelFeatureRequest>>, TError,{id: string}, TContext> => {

const mutationKey = ['cancelFeatureRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelFeatureRequest>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  cancelFeatureRequest(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelFeatureRequestMutationResult = NonNullable<Awaited<ReturnType<typeof cancelFeatureRequest>>>

    export type CancelFeatureRequestMutationError = ErrorType<void>

    /**
 * @summary Cancel an open feature request you submitted
 */
export const useCancelFeatureRequest = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelFeatureRequest>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelFeatureRequest>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getCancelFeatureRequestMutationOptions(options));
    }

export const getAddFeatureRequestCommentUrl = (id: string,) => {




  return `/api/account/feature-requests/${id}/comments`
}

/**
 * @summary Add a comment to a feature request
 */
export const addFeatureRequestComment = async (id: string,
    addFeatureRequestCommentInput: AddFeatureRequestCommentInput, options?: RequestInit): Promise<FeatureRequestDetail> => {

  return customFetch<FeatureRequestDetail>(getAddFeatureRequestCommentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addFeatureRequestCommentInput)
  }
);}





export const getAddFeatureRequestCommentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFeatureRequestComment>>, TError,{id: string;data: BodyType<AddFeatureRequestCommentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addFeatureRequestComment>>, TError,{id: string;data: BodyType<AddFeatureRequestCommentInput>}, TContext> => {

const mutationKey = ['addFeatureRequestComment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addFeatureRequestComment>>, {id: string;data: BodyType<AddFeatureRequestCommentInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  addFeatureRequestComment(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddFeatureRequestCommentMutationResult = NonNullable<Awaited<ReturnType<typeof addFeatureRequestComment>>>
    export type AddFeatureRequestCommentMutationBody = BodyType<AddFeatureRequestCommentInput>
    export type AddFeatureRequestCommentMutationError = ErrorType<void>

    /**
 * @summary Add a comment to a feature request
 */
export const useAddFeatureRequestComment = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFeatureRequestComment>>, TError,{id: string;data: BodyType<AddFeatureRequestCommentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addFeatureRequestComment>>,
        TError,
        {id: string;data: BodyType<AddFeatureRequestCommentInput>},
        TContext
      > => {
      return useMutation(getAddFeatureRequestCommentMutationOptions(options));
    }

export const getRecordDashboardAccessUrl = () => {




  return `/api/account/dashboard-access`
}

/**
 * @summary Record (audit) that the caller crossed from the Client Area into the tenant dashboard via single-sign-on; navigation happens client-side
 */
export const recordDashboardAccess = async ( options?: RequestInit): Promise<DashboardAccessAck> => {

  return customFetch<DashboardAccessAck>(getRecordDashboardAccessUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRecordDashboardAccessMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordDashboardAccess>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recordDashboardAccess>>, TError,void, TContext> => {

const mutationKey = ['recordDashboardAccess'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordDashboardAccess>>, void> = () => {


          return  recordDashboardAccess(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordDashboardAccessMutationResult = NonNullable<Awaited<ReturnType<typeof recordDashboardAccess>>>

    export type RecordDashboardAccessMutationError = ErrorType<unknown>

    /**
 * @summary Record (audit) that the caller crossed from the Client Area into the tenant dashboard via single-sign-on; navigation happens client-side
 */
export const useRecordDashboardAccess = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordDashboardAccess>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recordDashboardAccess>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRecordDashboardAccessMutationOptions(options));
    }

export const getGetFeatureCatalogueUrl = () => {




  return `/api/account/feature-catalogue`
}

/**
 * @summary Browsable module marketplace — every feature module with benefits, icon, live enabled status, and any open request
 */
export const getFeatureCatalogue = async ( options?: RequestInit): Promise<FeatureCatalogue> => {

  return customFetch<FeatureCatalogue>(getGetFeatureCatalogueUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFeatureCatalogueQueryKey = () => {
    return [
    `/api/account/feature-catalogue`
    ] as const;
    }


export const getGetFeatureCatalogueQueryOptions = <TData = Awaited<ReturnType<typeof getFeatureCatalogue>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFeatureCatalogue>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeatureCatalogueQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeatureCatalogue>>> = ({ signal }) => getFeatureCatalogue({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeatureCatalogue>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFeatureCatalogueQueryResult = NonNullable<Awaited<ReturnType<typeof getFeatureCatalogue>>>
export type GetFeatureCatalogueQueryError = ErrorType<unknown>


/**
 * @summary Browsable module marketplace — every feature module with benefits, icon, live enabled status, and any open request
 */

export function useGetFeatureCatalogue<TData = Awaited<ReturnType<typeof getFeatureCatalogue>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFeatureCatalogue>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetFeatureCatalogueQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAccountSubscriptionUrl = () => {




  return `/api/account/subscription`
}

/**
 * @summary Client Plan & Subscription view — current plan (price/features/limits/ support/trial terms), comparable plans with upgrade/downgrade relation, and any pending plan-change request
 */
export const getAccountSubscription = async ( options?: RequestInit): Promise<AccountSubscriptionView> => {

  return customFetch<AccountSubscriptionView>(getGetAccountSubscriptionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAccountSubscriptionQueryKey = () => {
    return [
    `/api/account/subscription`
    ] as const;
    }


export const getGetAccountSubscriptionQueryOptions = <TData = Awaited<ReturnType<typeof getAccountSubscription>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountSubscription>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountSubscriptionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountSubscription>>> = ({ signal }) => getAccountSubscription({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountSubscription>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountSubscriptionQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountSubscription>>>
export type GetAccountSubscriptionQueryError = ErrorType<unknown>


/**
 * @summary Client Plan & Subscription view — current plan (price/features/limits/ support/trial terms), comparable plans with upgrade/downgrade relation, and any pending plan-change request
 */

export function useGetAccountSubscription<TData = Awaited<ReturnType<typeof getAccountSubscription>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountSubscription>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountSubscriptionQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRequestPlanChangeUrl = () => {




  return `/api/account/subscription/request`
}

/**
 * @summary Request a plan upgrade/downgrade/renewal/cancellation. Upgrades route to billing when the platform allows online upgrades; otherwise (and for all other types) a plan-change request is created for platform admins
 */
export const requestPlanChange = async (requestPlanChangeInput: RequestPlanChangeInput, options?: RequestInit): Promise<RequestPlanChangeResult> => {

  return customFetch<RequestPlanChangeResult>(getRequestPlanChangeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(requestPlanChangeInput)
  }
);}





export const getRequestPlanChangeMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPlanChange>>, TError,{data: BodyType<RequestPlanChangeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestPlanChange>>, TError,{data: BodyType<RequestPlanChangeInput>}, TContext> => {

const mutationKey = ['requestPlanChange'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestPlanChange>>, {data: BodyType<RequestPlanChangeInput>}> = (props) => {
          const {data} = props ?? {};

          return  requestPlanChange(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestPlanChangeMutationResult = NonNullable<Awaited<ReturnType<typeof requestPlanChange>>>
    export type RequestPlanChangeMutationBody = BodyType<RequestPlanChangeInput>
    export type RequestPlanChangeMutationError = ErrorType<void>

    /**
 * @summary Request a plan upgrade/downgrade/renewal/cancellation. Upgrades route to billing when the platform allows online upgrades; otherwise (and for all other types) a plan-change request is created for platform admins
 */
export const useRequestPlanChange = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPlanChange>>, TError,{data: BodyType<RequestPlanChangeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestPlanChange>>,
        TError,
        {data: BodyType<RequestPlanChangeInput>},
        TContext
      > => {
      return useMutation(getRequestPlanChangeMutationOptions(options));
    }

export const getGetAccountUsageUrl = () => {




  return `/api/account/usage`
}

/**
 * @summary Client Usage & Limits view — live usage of each tracked plan limit (team members, orders this month, inventory items, media storage, marketplaces, AI queries, scheduled posts) with per-metric status
 */
export const getAccountUsage = async ( options?: RequestInit): Promise<AccountUsageView> => {

  return customFetch<AccountUsageView>(getGetAccountUsageUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAccountUsageQueryKey = () => {
    return [
    `/api/account/usage`
    ] as const;
    }


export const getGetAccountUsageQueryOptions = <TData = Awaited<ReturnType<typeof getAccountUsage>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountUsage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountUsageQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountUsage>>> = ({ signal }) => getAccountUsage({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountUsage>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountUsageQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountUsage>>>
export type GetAccountUsageQueryError = ErrorType<unknown>


/**
 * @summary Client Usage & Limits view — live usage of each tracked plan limit (team members, orders this month, inventory items, media storage, marketplaces, AI queries, scheduled posts) with per-metric status
 */

export function useGetAccountUsage<TData = Awaited<ReturnType<typeof getAccountUsage>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountUsage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountUsageQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAccountTrialUrl = () => {




  return `/api/account/trial`
}

/**
 * @summary Client Trial Status — the tenant's most recent trial (countdown + derived status), the plan's included features, current usage, the conversion plan info for the upgrade CTA, and any pending extension request. `trial` is null when the tenant has never had a trial.
 */
export const getAccountTrial = async ( options?: RequestInit): Promise<AccountTrialView> => {

  return customFetch<AccountTrialView>(getGetAccountTrialUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAccountTrialQueryKey = () => {
    return [
    `/api/account/trial`
    ] as const;
    }


export const getGetAccountTrialQueryOptions = <TData = Awaited<ReturnType<typeof getAccountTrial>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountTrial>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountTrialQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountTrial>>> = ({ signal }) => getAccountTrial({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountTrial>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountTrialQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountTrial>>>
export type GetAccountTrialQueryError = ErrorType<unknown>


/**
 * @summary Client Trial Status — the tenant's most recent trial (countdown + derived status), the plan's included features, current usage, the conversion plan info for the upgrade CTA, and any pending extension request. `trial` is null when the tenant has never had a trial.
 */

export function useGetAccountTrial<TData = Awaited<ReturnType<typeof getAccountTrial>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountTrial>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountTrialQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRequestTrialExtensionUrl = () => {




  return `/api/account/trial/request-extension`
}

/**
 * @summary Ask the platform to extend this trial. Records the request in the trial metadata, notifies platform operators, and audits. Idempotent — a second call while a request is already pending returns the existing one.
 */
export const requestTrialExtension = async (requestTrialExtensionInput?: RequestTrialExtensionInput, options?: RequestInit): Promise<RequestTrialExtensionResult> => {

  return customFetch<RequestTrialExtensionResult>(getRequestTrialExtensionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(requestTrialExtensionInput)
  }
);}





export const getRequestTrialExtensionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestTrialExtension>>, TError,{data?: BodyType<RequestTrialExtensionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestTrialExtension>>, TError,{data?: BodyType<RequestTrialExtensionInput>}, TContext> => {

const mutationKey = ['requestTrialExtension'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestTrialExtension>>, {data?: BodyType<RequestTrialExtensionInput>}> = (props) => {
          const {data} = props ?? {};

          return  requestTrialExtension(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestTrialExtensionMutationResult = NonNullable<Awaited<ReturnType<typeof requestTrialExtension>>>
    export type RequestTrialExtensionMutationBody = BodyType<RequestTrialExtensionInput> | undefined
    export type RequestTrialExtensionMutationError = ErrorType<void>

    /**
 * @summary Ask the platform to extend this trial. Records the request in the trial metadata, notifies platform operators, and audits. Idempotent — a second call while a request is already pending returns the existing one.
 */
export const useRequestTrialExtension = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestTrialExtension>>, TError,{data?: BodyType<RequestTrialExtensionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestTrialExtension>>,
        TError,
        {data?: BodyType<RequestTrialExtensionInput>},
        TContext
      > => {
      return useMutation(getRequestTrialExtensionMutationOptions(options));
    }

export const getGetAccountBillingUrl = () => {




  return `/api/account/billing`
}

/**
 * @summary Client Billing summary — billing status, address + VAT details, next payment date, outstanding/overdue balance, billing contacts, recent invoices + payments, and stored payment methods.
 */
export const getAccountBilling = async ( options?: RequestInit): Promise<AccountBillingSummary> => {

  return customFetch<AccountBillingSummary>(getGetAccountBillingUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAccountBillingQueryKey = () => {
    return [
    `/api/account/billing`
    ] as const;
    }


export const getGetAccountBillingQueryOptions = <TData = Awaited<ReturnType<typeof getAccountBilling>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountBilling>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountBillingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountBilling>>> = ({ signal }) => getAccountBilling({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountBilling>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountBillingQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountBilling>>>
export type GetAccountBillingQueryError = ErrorType<unknown>


/**
 * @summary Client Billing summary — billing status, address + VAT details, next payment date, outstanding/overdue balance, billing contacts, recent invoices + payments, and stored payment methods.
 */

export function useGetAccountBilling<TData = Awaited<ReturnType<typeof getAccountBilling>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountBilling>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountBillingQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAccountBillingInvoicesUrl = (params?: ListAccountBillingInvoicesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/account/billing/invoices?${stringifiedParams}` : `/api/account/billing/invoices`
}

/**
 * @summary List this tenant's MetalUI invoices (platform→tenant).
 */
export const listAccountBillingInvoices = async (params?: ListAccountBillingInvoicesParams, options?: RequestInit): Promise<AccountBillingInvoiceList> => {

  return customFetch<AccountBillingInvoiceList>(getListAccountBillingInvoicesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAccountBillingInvoicesQueryKey = (params?: ListAccountBillingInvoicesParams,) => {
    return [
    `/api/account/billing/invoices`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAccountBillingInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof listAccountBillingInvoices>>, TError = ErrorType<unknown>>(params?: ListAccountBillingInvoicesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccountBillingInvoices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAccountBillingInvoicesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccountBillingInvoices>>> = ({ signal }) => listAccountBillingInvoices(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAccountBillingInvoices>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAccountBillingInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof listAccountBillingInvoices>>>
export type ListAccountBillingInvoicesQueryError = ErrorType<unknown>


/**
 * @summary List this tenant's MetalUI invoices (platform→tenant).
 */

export function useListAccountBillingInvoices<TData = Awaited<ReturnType<typeof listAccountBillingInvoices>>, TError = ErrorType<unknown>>(
 params?: ListAccountBillingInvoicesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccountBillingInvoices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAccountBillingInvoicesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAccountBillingInvoiceUrl = (id: string,) => {




  return `/api/account/billing/invoices/${id}`
}

/**
 * @summary Get one MetalUI invoice with its line items + VAT breakdown.
 */
export const getAccountBillingInvoice = async (id: string, options?: RequestInit): Promise<AccountBillingInvoiceDetail> => {

  return customFetch<AccountBillingInvoiceDetail>(getGetAccountBillingInvoiceUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAccountBillingInvoiceQueryKey = (id: string,) => {
    return [
    `/api/account/billing/invoices/${id}`
    ] as const;
    }


export const getGetAccountBillingInvoiceQueryOptions = <TData = Awaited<ReturnType<typeof getAccountBillingInvoice>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountBillingInvoice>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountBillingInvoiceQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountBillingInvoice>>> = ({ signal }) => getAccountBillingInvoice(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountBillingInvoice>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountBillingInvoiceQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountBillingInvoice>>>
export type GetAccountBillingInvoiceQueryError = ErrorType<void>


/**
 * @summary Get one MetalUI invoice with its line items + VAT breakdown.
 */

export function useGetAccountBillingInvoice<TData = Awaited<ReturnType<typeof getAccountBillingInvoice>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountBillingInvoice>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountBillingInvoiceQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAccountBillingPaymentsUrl = (params?: ListAccountBillingPaymentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/account/billing/payments?${stringifiedParams}` : `/api/account/billing/payments`
}

/**
 * @summary Payment history (amounts, dates, linked invoices).
 */
export const listAccountBillingPayments = async (params?: ListAccountBillingPaymentsParams, options?: RequestInit): Promise<AccountBillingPaymentList> => {

  return customFetch<AccountBillingPaymentList>(getListAccountBillingPaymentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAccountBillingPaymentsQueryKey = (params?: ListAccountBillingPaymentsParams,) => {
    return [
    `/api/account/billing/payments`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAccountBillingPaymentsQueryOptions = <TData = Awaited<ReturnType<typeof listAccountBillingPayments>>, TError = ErrorType<unknown>>(params?: ListAccountBillingPaymentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccountBillingPayments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAccountBillingPaymentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccountBillingPayments>>> = ({ signal }) => listAccountBillingPayments(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAccountBillingPayments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAccountBillingPaymentsQueryResult = NonNullable<Awaited<ReturnType<typeof listAccountBillingPayments>>>
export type ListAccountBillingPaymentsQueryError = ErrorType<unknown>


/**
 * @summary Payment history (amounts, dates, linked invoices).
 */

export function useListAccountBillingPayments<TData = Awaited<ReturnType<typeof listAccountBillingPayments>>, TError = ErrorType<unknown>>(
 params?: ListAccountBillingPaymentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccountBillingPayments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAccountBillingPaymentsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAccountBillingPaymentMethodsUrl = () => {




  return `/api/account/billing/payment-methods`
}

/**
 * @summary List the tenant's stored payment methods (foundation for PayPal).
 */
export const listAccountBillingPaymentMethods = async ( options?: RequestInit): Promise<AccountBillingPaymentMethodList> => {

  return customFetch<AccountBillingPaymentMethodList>(getListAccountBillingPaymentMethodsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAccountBillingPaymentMethodsQueryKey = () => {
    return [
    `/api/account/billing/payment-methods`
    ] as const;
    }


export const getListAccountBillingPaymentMethodsQueryOptions = <TData = Awaited<ReturnType<typeof listAccountBillingPaymentMethods>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccountBillingPaymentMethods>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAccountBillingPaymentMethodsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccountBillingPaymentMethods>>> = ({ signal }) => listAccountBillingPaymentMethods({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAccountBillingPaymentMethods>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAccountBillingPaymentMethodsQueryResult = NonNullable<Awaited<ReturnType<typeof listAccountBillingPaymentMethods>>>
export type ListAccountBillingPaymentMethodsQueryError = ErrorType<unknown>


/**
 * @summary List the tenant's stored payment methods (foundation for PayPal).
 */

export function useListAccountBillingPaymentMethods<TData = Awaited<ReturnType<typeof listAccountBillingPaymentMethods>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccountBillingPaymentMethods>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAccountBillingPaymentMethodsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAccountBillingPaypalConfigUrl = () => {




  return `/api/account/billing/paypal/config`
}

/**
 * @summary Whether online (PayPal) invoice payment is available, and which environment is active. No credentials are ever exposed.
 */
export const getAccountBillingPaypalConfig = async ( options?: RequestInit): Promise<AccountBillingPaypalConfig> => {

  return customFetch<AccountBillingPaypalConfig>(getGetAccountBillingPaypalConfigUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAccountBillingPaypalConfigQueryKey = () => {
    return [
    `/api/account/billing/paypal/config`
    ] as const;
    }


export const getGetAccountBillingPaypalConfigQueryOptions = <TData = Awaited<ReturnType<typeof getAccountBillingPaypalConfig>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountBillingPaypalConfig>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountBillingPaypalConfigQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountBillingPaypalConfig>>> = ({ signal }) => getAccountBillingPaypalConfig({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountBillingPaypalConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountBillingPaypalConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountBillingPaypalConfig>>>
export type GetAccountBillingPaypalConfigQueryError = ErrorType<unknown>


/**
 * @summary Whether online (PayPal) invoice payment is available, and which environment is active. No credentials are ever exposed.
 */

export function useGetAccountBillingPaypalConfig<TData = Awaited<ReturnType<typeof getAccountBillingPaypalConfig>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountBillingPaypalConfig>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountBillingPaypalConfigQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateAccountBillingPaypalOrderUrl = () => {




  return `/api/account/billing/paypal/create-order`
}

/**
 * @summary Start a PayPal payment for one or many of the tenant's unpaid invoices. Returns the PayPal approval URL the browser should be redirected to.
 */
export const createAccountBillingPaypalOrder = async (createAccountBillingPaypalOrderBody: CreateAccountBillingPaypalOrderBody, options?: RequestInit): Promise<AccountBillingPaypalOrder> => {

  return customFetch<AccountBillingPaypalOrder>(getCreateAccountBillingPaypalOrderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createAccountBillingPaypalOrderBody)
  }
);}





export const getCreateAccountBillingPaypalOrderMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccountBillingPaypalOrder>>, TError,{data: BodyType<CreateAccountBillingPaypalOrderBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAccountBillingPaypalOrder>>, TError,{data: BodyType<CreateAccountBillingPaypalOrderBody>}, TContext> => {

const mutationKey = ['createAccountBillingPaypalOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAccountBillingPaypalOrder>>, {data: BodyType<CreateAccountBillingPaypalOrderBody>}> = (props) => {
          const {data} = props ?? {};

          return  createAccountBillingPaypalOrder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAccountBillingPaypalOrderMutationResult = NonNullable<Awaited<ReturnType<typeof createAccountBillingPaypalOrder>>>
    export type CreateAccountBillingPaypalOrderMutationBody = BodyType<CreateAccountBillingPaypalOrderBody>
    export type CreateAccountBillingPaypalOrderMutationError = ErrorType<void>

    /**
 * @summary Start a PayPal payment for one or many of the tenant's unpaid invoices. Returns the PayPal approval URL the browser should be redirected to.
 */
export const useCreateAccountBillingPaypalOrder = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccountBillingPaypalOrder>>, TError,{data: BodyType<CreateAccountBillingPaypalOrderBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAccountBillingPaypalOrder>>,
        TError,
        {data: BodyType<CreateAccountBillingPaypalOrderBody>},
        TContext
      > => {
      return useMutation(getCreateAccountBillingPaypalOrderMutationOptions(options));
    }

export const getCaptureAccountBillingPaypalOrderUrl = () => {




  return `/api/account/billing/paypal/capture`
}

/**
 * @summary Capture an approved PayPal order and mark the mapped invoices paid. Server-verified against PayPal and idempotent; on failure invoices are left unpaid so the tenant can retry.
 */
export const captureAccountBillingPaypalOrder = async (captureAccountBillingPaypalOrderBody: CaptureAccountBillingPaypalOrderBody, options?: RequestInit): Promise<AccountBillingPaypalCaptureResult> => {

  return customFetch<AccountBillingPaypalCaptureResult>(getCaptureAccountBillingPaypalOrderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(captureAccountBillingPaypalOrderBody)
  }
);}





export const getCaptureAccountBillingPaypalOrderMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof captureAccountBillingPaypalOrder>>, TError,{data: BodyType<CaptureAccountBillingPaypalOrderBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof captureAccountBillingPaypalOrder>>, TError,{data: BodyType<CaptureAccountBillingPaypalOrderBody>}, TContext> => {

const mutationKey = ['captureAccountBillingPaypalOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof captureAccountBillingPaypalOrder>>, {data: BodyType<CaptureAccountBillingPaypalOrderBody>}> = (props) => {
          const {data} = props ?? {};

          return  captureAccountBillingPaypalOrder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CaptureAccountBillingPaypalOrderMutationResult = NonNullable<Awaited<ReturnType<typeof captureAccountBillingPaypalOrder>>>
    export type CaptureAccountBillingPaypalOrderMutationBody = BodyType<CaptureAccountBillingPaypalOrderBody>
    export type CaptureAccountBillingPaypalOrderMutationError = ErrorType<void>

    /**
 * @summary Capture an approved PayPal order and mark the mapped invoices paid. Server-verified against PayPal and idempotent; on failure invoices are left unpaid so the tenant can retry.
 */
export const useCaptureAccountBillingPaypalOrder = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof captureAccountBillingPaypalOrder>>, TError,{data: BodyType<CaptureAccountBillingPaypalOrderBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof captureAccountBillingPaypalOrder>>,
        TError,
        {data: BodyType<CaptureAccountBillingPaypalOrderBody>},
        TContext
      > => {
      return useMutation(getCaptureAccountBillingPaypalOrderMutationOptions(options));
    }

export const getGetAccountSecurityOverviewUrl = () => {




  return `/api/account/security/overview`
}

/**
 * @summary Account security posture for the signed-in user — password set?, 2FA on?, TOTP / backup codes, and a Clerk profile deep-link target.
 */
export const getAccountSecurityOverview = async ( options?: RequestInit): Promise<AccountSecurityOverview> => {

  return customFetch<AccountSecurityOverview>(getGetAccountSecurityOverviewUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAccountSecurityOverviewQueryKey = () => {
    return [
    `/api/account/security/overview`
    ] as const;
    }


export const getGetAccountSecurityOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getAccountSecurityOverview>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountSecurityOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountSecurityOverviewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountSecurityOverview>>> = ({ signal }) => getAccountSecurityOverview({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountSecurityOverview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountSecurityOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountSecurityOverview>>>
export type GetAccountSecurityOverviewQueryError = ErrorType<unknown>


/**
 * @summary Account security posture for the signed-in user — password set?, 2FA on?, TOTP / backup codes, and a Clerk profile deep-link target.
 */

export function useGetAccountSecurityOverview<TData = Awaited<ReturnType<typeof getAccountSecurityOverview>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountSecurityOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountSecurityOverviewQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAccountSecuritySessionsUrl = () => {




  return `/api/account/security/sessions`
}

/**
 * @summary List the signed-in user's active Clerk sessions (device / browser / OS / IP / location, last-active, created, expiry), flagging the current one.
 */
export const listAccountSecuritySessions = async ( options?: RequestInit): Promise<AccountSecuritySessionList> => {

  return customFetch<AccountSecuritySessionList>(getListAccountSecuritySessionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAccountSecuritySessionsQueryKey = () => {
    return [
    `/api/account/security/sessions`
    ] as const;
    }


export const getListAccountSecuritySessionsQueryOptions = <TData = Awaited<ReturnType<typeof listAccountSecuritySessions>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccountSecuritySessions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAccountSecuritySessionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccountSecuritySessions>>> = ({ signal }) => listAccountSecuritySessions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAccountSecuritySessions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAccountSecuritySessionsQueryResult = NonNullable<Awaited<ReturnType<typeof listAccountSecuritySessions>>>
export type ListAccountSecuritySessionsQueryError = ErrorType<unknown>


/**
 * @summary List the signed-in user's active Clerk sessions (device / browser / OS / IP / location, last-active, created, expiry), flagging the current one.
 */

export function useListAccountSecuritySessions<TData = Awaited<ReturnType<typeof listAccountSecuritySessions>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccountSecuritySessions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAccountSecuritySessionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRevokeAccountSecuritySessionUrl = () => {




  return `/api/account/security/sessions/revoke`
}

/**
 * @summary Sign out ONE of the caller's own sessions (ownership-checked). Writes a control-plane audit row and emits a user notification.
 */
export const revokeAccountSecuritySession = async (revokeSessionInput: RevokeSessionInput, options?: RequestInit): Promise<RevokeSessionResult> => {

  return customFetch<RevokeSessionResult>(getRevokeAccountSecuritySessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(revokeSessionInput)
  }
);}





export const getRevokeAccountSecuritySessionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeAccountSecuritySession>>, TError,{data: BodyType<RevokeSessionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeAccountSecuritySession>>, TError,{data: BodyType<RevokeSessionInput>}, TContext> => {

const mutationKey = ['revokeAccountSecuritySession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeAccountSecuritySession>>, {data: BodyType<RevokeSessionInput>}> = (props) => {
          const {data} = props ?? {};

          return  revokeAccountSecuritySession(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeAccountSecuritySessionMutationResult = NonNullable<Awaited<ReturnType<typeof revokeAccountSecuritySession>>>
    export type RevokeAccountSecuritySessionMutationBody = BodyType<RevokeSessionInput>
    export type RevokeAccountSecuritySessionMutationError = ErrorType<void>

    /**
 * @summary Sign out ONE of the caller's own sessions (ownership-checked). Writes a control-plane audit row and emits a user notification.
 */
export const useRevokeAccountSecuritySession = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeAccountSecuritySession>>, TError,{data: BodyType<RevokeSessionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokeAccountSecuritySession>>,
        TError,
        {data: BodyType<RevokeSessionInput>},
        TContext
      > => {
      return useMutation(getRevokeAccountSecuritySessionMutationOptions(options));
    }

export const getRevokeOtherAccountSecuritySessionsUrl = () => {




  return `/api/account/security/sessions/revoke-others`
}

/**
 * @summary Sign out everywhere else — revoke all the caller's active sessions except the current one. Audited + notifies the user.
 */
export const revokeOtherAccountSecuritySessions = async ( options?: RequestInit): Promise<RevokeOtherSessionsResult> => {

  return customFetch<RevokeOtherSessionsResult>(getRevokeOtherAccountSecuritySessionsUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRevokeOtherAccountSecuritySessionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeOtherAccountSecuritySessions>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeOtherAccountSecuritySessions>>, TError,void, TContext> => {

const mutationKey = ['revokeOtherAccountSecuritySessions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeOtherAccountSecuritySessions>>, void> = () => {


          return  revokeOtherAccountSecuritySessions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeOtherAccountSecuritySessionsMutationResult = NonNullable<Awaited<ReturnType<typeof revokeOtherAccountSecuritySessions>>>

    export type RevokeOtherAccountSecuritySessionsMutationError = ErrorType<unknown>

    /**
 * @summary Sign out everywhere else — revoke all the caller's active sessions except the current one. Audited + notifies the user.
 */
export const useRevokeOtherAccountSecuritySessions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeOtherAccountSecuritySessions>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokeOtherAccountSecuritySessions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRevokeOtherAccountSecuritySessionsMutationOptions(options));
    }

export const getGetAccountSecurityActivityUrl = () => {




  return `/api/account/security/activity`
}

/**
 * @summary The signed-in user's own security-activity log (sign-ins, password / 2FA changes, session revokes), newest first.
 */
export const getAccountSecurityActivity = async ( options?: RequestInit): Promise<AccountSecurityActivityList> => {

  return customFetch<AccountSecurityActivityList>(getGetAccountSecurityActivityUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAccountSecurityActivityQueryKey = () => {
    return [
    `/api/account/security/activity`
    ] as const;
    }


export const getGetAccountSecurityActivityQueryOptions = <TData = Awaited<ReturnType<typeof getAccountSecurityActivity>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountSecurityActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountSecurityActivityQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountSecurityActivity>>> = ({ signal }) => getAccountSecurityActivity({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountSecurityActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountSecurityActivityQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountSecurityActivity>>>
export type GetAccountSecurityActivityQueryError = ErrorType<unknown>


/**
 * @summary The signed-in user's own security-activity log (sign-ins, password / 2FA changes, session revokes), newest first.
 */

export function useGetAccountSecurityActivity<TData = Awaited<ReturnType<typeof getAccountSecurityActivity>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountSecurityActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountSecurityActivityQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreatePlatformBillingInvoiceUrl = (id: string,) => {




  return `/api/platform/tenants/${id}/billing/invoices`
}

/**
 * @summary Create (optionally issue) a MetalUI invoice for a tenant.
 */
export const createPlatformBillingInvoice = async (id: string,
    createPlatformBillingInvoiceInput: CreatePlatformBillingInvoiceInput, options?: RequestInit): Promise<AccountBillingInvoiceDetail> => {

  return customFetch<AccountBillingInvoiceDetail>(getCreatePlatformBillingInvoiceUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createPlatformBillingInvoiceInput)
  }
);}





export const getCreatePlatformBillingInvoiceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPlatformBillingInvoice>>, TError,{id: string;data: BodyType<CreatePlatformBillingInvoiceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPlatformBillingInvoice>>, TError,{id: string;data: BodyType<CreatePlatformBillingInvoiceInput>}, TContext> => {

const mutationKey = ['createPlatformBillingInvoice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPlatformBillingInvoice>>, {id: string;data: BodyType<CreatePlatformBillingInvoiceInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createPlatformBillingInvoice(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePlatformBillingInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof createPlatformBillingInvoice>>>
    export type CreatePlatformBillingInvoiceMutationBody = BodyType<CreatePlatformBillingInvoiceInput>
    export type CreatePlatformBillingInvoiceMutationError = ErrorType<void>

    /**
 * @summary Create (optionally issue) a MetalUI invoice for a tenant.
 */
export const useCreatePlatformBillingInvoice = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPlatformBillingInvoice>>, TError,{id: string;data: BodyType<CreatePlatformBillingInvoiceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPlatformBillingInvoice>>,
        TError,
        {id: string;data: BodyType<CreatePlatformBillingInvoiceInput>},
        TContext
      > => {
      return useMutation(getCreatePlatformBillingInvoiceMutationOptions(options));
    }

export const getIssuePlatformBillingInvoiceUrl = (invoiceId: string,) => {




  return `/api/platform/billing/invoices/${invoiceId}/issue`
}

/**
 * @summary Issue a draft MetalUI invoice (stamps issue/due dates + branding).
 */
export const issuePlatformBillingInvoice = async (invoiceId: string,
    issuePlatformBillingInvoiceInput?: IssuePlatformBillingInvoiceInput, options?: RequestInit): Promise<AccountBillingInvoiceDetail> => {

  return customFetch<AccountBillingInvoiceDetail>(getIssuePlatformBillingInvoiceUrl(invoiceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(issuePlatformBillingInvoiceInput)
  }
);}





export const getIssuePlatformBillingInvoiceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof issuePlatformBillingInvoice>>, TError,{invoiceId: string;data?: BodyType<IssuePlatformBillingInvoiceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof issuePlatformBillingInvoice>>, TError,{invoiceId: string;data?: BodyType<IssuePlatformBillingInvoiceInput>}, TContext> => {

const mutationKey = ['issuePlatformBillingInvoice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof issuePlatformBillingInvoice>>, {invoiceId: string;data?: BodyType<IssuePlatformBillingInvoiceInput>}> = (props) => {
          const {invoiceId,data} = props ?? {};

          return  issuePlatformBillingInvoice(invoiceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IssuePlatformBillingInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof issuePlatformBillingInvoice>>>
    export type IssuePlatformBillingInvoiceMutationBody = BodyType<IssuePlatformBillingInvoiceInput> | undefined
    export type IssuePlatformBillingInvoiceMutationError = ErrorType<void>

    /**
 * @summary Issue a draft MetalUI invoice (stamps issue/due dates + branding).
 */
export const useIssuePlatformBillingInvoice = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof issuePlatformBillingInvoice>>, TError,{invoiceId: string;data?: BodyType<IssuePlatformBillingInvoiceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof issuePlatformBillingInvoice>>,
        TError,
        {invoiceId: string;data?: BodyType<IssuePlatformBillingInvoiceInput>},
        TContext
      > => {
      return useMutation(getIssuePlatformBillingInvoiceMutationOptions(options));
    }

export const getMarkPlatformBillingInvoicePaidUrl = (invoiceId: string,) => {




  return `/api/platform/billing/invoices/${invoiceId}/mark-paid`
}

/**
 * @summary Record a manual payment against a MetalUI invoice.
 */
export const markPlatformBillingInvoicePaid = async (invoiceId: string,
    markPlatformBillingInvoicePaidInput: MarkPlatformBillingInvoicePaidInput, options?: RequestInit): Promise<AccountBillingInvoiceDetail> => {

  return customFetch<AccountBillingInvoiceDetail>(getMarkPlatformBillingInvoicePaidUrl(invoiceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(markPlatformBillingInvoicePaidInput)
  }
);}





export const getMarkPlatformBillingInvoicePaidMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markPlatformBillingInvoicePaid>>, TError,{invoiceId: string;data: BodyType<MarkPlatformBillingInvoicePaidInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markPlatformBillingInvoicePaid>>, TError,{invoiceId: string;data: BodyType<MarkPlatformBillingInvoicePaidInput>}, TContext> => {

const mutationKey = ['markPlatformBillingInvoicePaid'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markPlatformBillingInvoicePaid>>, {invoiceId: string;data: BodyType<MarkPlatformBillingInvoicePaidInput>}> = (props) => {
          const {invoiceId,data} = props ?? {};

          return  markPlatformBillingInvoicePaid(invoiceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkPlatformBillingInvoicePaidMutationResult = NonNullable<Awaited<ReturnType<typeof markPlatformBillingInvoicePaid>>>
    export type MarkPlatformBillingInvoicePaidMutationBody = BodyType<MarkPlatformBillingInvoicePaidInput>
    export type MarkPlatformBillingInvoicePaidMutationError = ErrorType<void>

    /**
 * @summary Record a manual payment against a MetalUI invoice.
 */
export const useMarkPlatformBillingInvoicePaid = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markPlatformBillingInvoicePaid>>, TError,{invoiceId: string;data: BodyType<MarkPlatformBillingInvoicePaidInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markPlatformBillingInvoicePaid>>,
        TError,
        {invoiceId: string;data: BodyType<MarkPlatformBillingInvoicePaidInput>},
        TContext
      > => {
      return useMutation(getMarkPlatformBillingInvoicePaidMutationOptions(options));
    }

export const getUpdatePlatformBillingInvoiceUrl = (invoiceId: string,) => {




  return `/api/platform/billing/invoices/${invoiceId}`
}

/**
 * @summary Edit a DRAFT MetalUI invoice (line items / notes / due date).
 */
export const updatePlatformBillingInvoice = async (invoiceId: string,
    updatePlatformBillingInvoiceInput: UpdatePlatformBillingInvoiceInput, options?: RequestInit): Promise<AccountBillingInvoiceDetail> => {

  return customFetch<AccountBillingInvoiceDetail>(getUpdatePlatformBillingInvoiceUrl(invoiceId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updatePlatformBillingInvoiceInput)
  }
);}





export const getUpdatePlatformBillingInvoiceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatformBillingInvoice>>, TError,{invoiceId: string;data: BodyType<UpdatePlatformBillingInvoiceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePlatformBillingInvoice>>, TError,{invoiceId: string;data: BodyType<UpdatePlatformBillingInvoiceInput>}, TContext> => {

const mutationKey = ['updatePlatformBillingInvoice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePlatformBillingInvoice>>, {invoiceId: string;data: BodyType<UpdatePlatformBillingInvoiceInput>}> = (props) => {
          const {invoiceId,data} = props ?? {};

          return  updatePlatformBillingInvoice(invoiceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePlatformBillingInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof updatePlatformBillingInvoice>>>
    export type UpdatePlatformBillingInvoiceMutationBody = BodyType<UpdatePlatformBillingInvoiceInput>
    export type UpdatePlatformBillingInvoiceMutationError = ErrorType<void>

    /**
 * @summary Edit a DRAFT MetalUI invoice (line items / notes / due date).
 */
export const useUpdatePlatformBillingInvoice = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatformBillingInvoice>>, TError,{invoiceId: string;data: BodyType<UpdatePlatformBillingInvoiceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePlatformBillingInvoice>>,
        TError,
        {invoiceId: string;data: BodyType<UpdatePlatformBillingInvoiceInput>},
        TContext
      > => {
      return useMutation(getUpdatePlatformBillingInvoiceMutationOptions(options));
    }

export const getDeletePlatformBillingInvoiceUrl = (invoiceId: string,) => {




  return `/api/platform/billing/invoices/${invoiceId}`
}

/**
 * @summary Delete a DRAFT MetalUI invoice (issued invoices are immutable).
 */
export const deletePlatformBillingInvoice = async (invoiceId: string, options?: RequestInit): Promise<DeletePlatformBillingInvoiceResult> => {

  return customFetch<DeletePlatformBillingInvoiceResult>(getDeletePlatformBillingInvoiceUrl(invoiceId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeletePlatformBillingInvoiceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePlatformBillingInvoice>>, TError,{invoiceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePlatformBillingInvoice>>, TError,{invoiceId: string}, TContext> => {

const mutationKey = ['deletePlatformBillingInvoice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePlatformBillingInvoice>>, {invoiceId: string}> = (props) => {
          const {invoiceId} = props ?? {};

          return  deletePlatformBillingInvoice(invoiceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePlatformBillingInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof deletePlatformBillingInvoice>>>

    export type DeletePlatformBillingInvoiceMutationError = ErrorType<void>

    /**
 * @summary Delete a DRAFT MetalUI invoice (issued invoices are immutable).
 */
export const useDeletePlatformBillingInvoice = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePlatformBillingInvoice>>, TError,{invoiceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePlatformBillingInvoice>>,
        TError,
        {invoiceId: string},
        TContext
      > => {
      return useMutation(getDeletePlatformBillingInvoiceMutationOptions(options));
    }

export const getListCompositePresetsUrl = () => {




  return `/api/image-studio/composite-presets`
}

/**
 * @summary List composite presets (platform defaults + tenant-owned).
 */
export const listCompositePresets = async ( options?: RequestInit): Promise<ListCompositePresetsResponse> => {

  return customFetch<ListCompositePresetsResponse>(getListCompositePresetsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCompositePresetsQueryKey = () => {
    return [
    `/api/image-studio/composite-presets`
    ] as const;
    }


export const getListCompositePresetsQueryOptions = <TData = Awaited<ReturnType<typeof listCompositePresets>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCompositePresets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCompositePresetsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCompositePresets>>> = ({ signal }) => listCompositePresets({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCompositePresets>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCompositePresetsQueryResult = NonNullable<Awaited<ReturnType<typeof listCompositePresets>>>
export type ListCompositePresetsQueryError = ErrorType<void>


/**
 * @summary List composite presets (platform defaults + tenant-owned).
 */

export function useListCompositePresets<TData = Awaited<ReturnType<typeof listCompositePresets>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCompositePresets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCompositePresetsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCompositePresetUrl = () => {




  return `/api/image-studio/composite-presets`
}

/**
 * @summary Create a new tenant-owned composite preset.
 */
export const createCompositePreset = async (createCompositePresetBody: CreateCompositePresetBody, options?: RequestInit): Promise<CompositePresetResponse> => {

  return customFetch<CompositePresetResponse>(getCreateCompositePresetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCompositePresetBody)
  }
);}





export const getCreateCompositePresetMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompositePreset>>, TError,{data: BodyType<CreateCompositePresetBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCompositePreset>>, TError,{data: BodyType<CreateCompositePresetBody>}, TContext> => {

const mutationKey = ['createCompositePreset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCompositePreset>>, {data: BodyType<CreateCompositePresetBody>}> = (props) => {
          const {data} = props ?? {};

          return  createCompositePreset(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCompositePresetMutationResult = NonNullable<Awaited<ReturnType<typeof createCompositePreset>>>
    export type CreateCompositePresetMutationBody = BodyType<CreateCompositePresetBody>
    export type CreateCompositePresetMutationError = ErrorType<void>

    /**
 * @summary Create a new tenant-owned composite preset.
 */
export const useCreateCompositePreset = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompositePreset>>, TError,{data: BodyType<CreateCompositePresetBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCompositePreset>>,
        TError,
        {data: BodyType<CreateCompositePresetBody>},
        TContext
      > => {
      return useMutation(getCreateCompositePresetMutationOptions(options));
    }

export const getUpdateCompositePresetUrl = (presetId: string,) => {




  return `/api/image-studio/composite-presets/${presetId}`
}

/**
 * @summary Rename or update settings on a tenant-owned preset.
 */
export const updateCompositePreset = async (presetId: string,
    updateCompositePresetBody: UpdateCompositePresetBody, options?: RequestInit): Promise<CompositePresetResponse> => {

  return customFetch<CompositePresetResponse>(getUpdateCompositePresetUrl(presetId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateCompositePresetBody)
  }
);}





export const getUpdateCompositePresetMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompositePreset>>, TError,{presetId: string;data: BodyType<UpdateCompositePresetBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCompositePreset>>, TError,{presetId: string;data: BodyType<UpdateCompositePresetBody>}, TContext> => {

const mutationKey = ['updateCompositePreset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCompositePreset>>, {presetId: string;data: BodyType<UpdateCompositePresetBody>}> = (props) => {
          const {presetId,data} = props ?? {};

          return  updateCompositePreset(presetId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCompositePresetMutationResult = NonNullable<Awaited<ReturnType<typeof updateCompositePreset>>>
    export type UpdateCompositePresetMutationBody = BodyType<UpdateCompositePresetBody>
    export type UpdateCompositePresetMutationError = ErrorType<void>

    /**
 * @summary Rename or update settings on a tenant-owned preset.
 */
export const useUpdateCompositePreset = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompositePreset>>, TError,{presetId: string;data: BodyType<UpdateCompositePresetBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCompositePreset>>,
        TError,
        {presetId: string;data: BodyType<UpdateCompositePresetBody>},
        TContext
      > => {
      return useMutation(getUpdateCompositePresetMutationOptions(options));
    }

export const getDeleteCompositePresetUrl = (presetId: string,) => {




  return `/api/image-studio/composite-presets/${presetId}`
}

/**
 * @summary Delete a tenant-owned composite preset.
 */
export const deleteCompositePreset = async (presetId: string, options?: RequestInit): Promise<DeleteCompositePreset200> => {

  return customFetch<DeleteCompositePreset200>(getDeleteCompositePresetUrl(presetId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteCompositePresetMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompositePreset>>, TError,{presetId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCompositePreset>>, TError,{presetId: string}, TContext> => {

const mutationKey = ['deleteCompositePreset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCompositePreset>>, {presetId: string}> = (props) => {
          const {presetId} = props ?? {};

          return  deleteCompositePreset(presetId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCompositePresetMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCompositePreset>>>

    export type DeleteCompositePresetMutationError = ErrorType<void>

    /**
 * @summary Delete a tenant-owned composite preset.
 */
export const useDeleteCompositePreset = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompositePreset>>, TError,{presetId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCompositePreset>>,
        TError,
        {presetId: string},
        TContext
      > => {
      return useMutation(getDeleteCompositePresetMutationOptions(options));
    }

export const getListPreOrderBatchesUrl = (params?: ListPreOrderBatchesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pre-orders/batches?${stringifiedParams}` : `/api/pre-orders/batches`
}

/**
 * Completed batches are omitted by default, but remain available through an explicit completed status filter or a non-empty text search.
 * @summary List pre-order batches with derived reserved/available counts
 */
export const listPreOrderBatches = async (params?: ListPreOrderBatchesParams, options?: RequestInit): Promise<PreOrderBatchListResponse> => {

  return customFetch<PreOrderBatchListResponse>(getListPreOrderBatchesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPreOrderBatchesQueryKey = (params?: ListPreOrderBatchesParams,) => {
    return [
    `/api/pre-orders/batches`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPreOrderBatchesQueryOptions = <TData = Awaited<ReturnType<typeof listPreOrderBatches>>, TError = ErrorType<unknown>>(params?: ListPreOrderBatchesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPreOrderBatches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPreOrderBatchesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPreOrderBatches>>> = ({ signal }) => listPreOrderBatches(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPreOrderBatches>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPreOrderBatchesQueryResult = NonNullable<Awaited<ReturnType<typeof listPreOrderBatches>>>
export type ListPreOrderBatchesQueryError = ErrorType<unknown>


/**
 * @summary List pre-order batches with derived reserved/available counts
 */

export function useListPreOrderBatches<TData = Awaited<ReturnType<typeof listPreOrderBatches>>, TError = ErrorType<unknown>>(
 params?: ListPreOrderBatchesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPreOrderBatches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPreOrderBatchesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreatePreOrderBatchUrl = () => {




  return `/api/pre-orders/batches`
}

/**
 * @summary Create a pre-order batch (starts as draft)
 */
export const createPreOrderBatch = async (preOrderBatchInput: PreOrderBatchInput, options?: RequestInit): Promise<PreOrderBatchDetail> => {

  return customFetch<PreOrderBatchDetail>(getCreatePreOrderBatchUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(preOrderBatchInput)
  }
);}





export const getCreatePreOrderBatchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPreOrderBatch>>, TError,{data: BodyType<PreOrderBatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPreOrderBatch>>, TError,{data: BodyType<PreOrderBatchInput>}, TContext> => {

const mutationKey = ['createPreOrderBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPreOrderBatch>>, {data: BodyType<PreOrderBatchInput>}> = (props) => {
          const {data} = props ?? {};

          return  createPreOrderBatch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePreOrderBatchMutationResult = NonNullable<Awaited<ReturnType<typeof createPreOrderBatch>>>
    export type CreatePreOrderBatchMutationBody = BodyType<PreOrderBatchInput>
    export type CreatePreOrderBatchMutationError = ErrorType<unknown>

    /**
 * @summary Create a pre-order batch (starts as draft)
 */
export const useCreatePreOrderBatch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPreOrderBatch>>, TError,{data: BodyType<PreOrderBatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPreOrderBatch>>,
        TError,
        {data: BodyType<PreOrderBatchInput>},
        TContext
      > => {
      return useMutation(getCreatePreOrderBatchMutationOptions(options));
    }

export const getGetPreOrderBatchUrl = (id: string,
    params?: GetPreOrderBatchParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pre-orders/batches/${id}?${stringifiedParams}` : `/api/pre-orders/batches/${id}`
}

/**
 * @summary Batch detail with items (or compact aggregate-only summary)
 */
export const getPreOrderBatch = async (id: string,
    params?: GetPreOrderBatchParams, options?: RequestInit): Promise<PreOrderBatchDetail> => {

  return customFetch<PreOrderBatchDetail>(getGetPreOrderBatchUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPreOrderBatchQueryKey = (id: string,
    params?: GetPreOrderBatchParams,) => {
    return [
    `/api/pre-orders/batches/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPreOrderBatchQueryOptions = <TData = Awaited<ReturnType<typeof getPreOrderBatch>>, TError = ErrorType<void>>(id: string,
    params?: GetPreOrderBatchParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPreOrderBatch>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPreOrderBatchQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPreOrderBatch>>> = ({ signal }) => getPreOrderBatch(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPreOrderBatch>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPreOrderBatchQueryResult = NonNullable<Awaited<ReturnType<typeof getPreOrderBatch>>>
export type GetPreOrderBatchQueryError = ErrorType<void>


/**
 * @summary Batch detail with items (or compact aggregate-only summary)
 */

export function useGetPreOrderBatch<TData = Awaited<ReturnType<typeof getPreOrderBatch>>, TError = ErrorType<void>>(
 id: string,
    params?: GetPreOrderBatchParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPreOrderBatch>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPreOrderBatchQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdatePreOrderBatchUrl = (id: string,) => {




  return `/api/pre-orders/batches/${id}`
}

/**
 * @summary Edit batch header fields
 */
export const updatePreOrderBatch = async (id: string,
    preOrderBatchUpdate: PreOrderBatchUpdate, options?: RequestInit): Promise<PreOrderBatchDetail> => {

  return customFetch<PreOrderBatchDetail>(getUpdatePreOrderBatchUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(preOrderBatchUpdate)
  }
);}





export const getUpdatePreOrderBatchMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePreOrderBatch>>, TError,{id: string;data: BodyType<PreOrderBatchUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePreOrderBatch>>, TError,{id: string;data: BodyType<PreOrderBatchUpdate>}, TContext> => {

const mutationKey = ['updatePreOrderBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePreOrderBatch>>, {id: string;data: BodyType<PreOrderBatchUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePreOrderBatch(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePreOrderBatchMutationResult = NonNullable<Awaited<ReturnType<typeof updatePreOrderBatch>>>
    export type UpdatePreOrderBatchMutationBody = BodyType<PreOrderBatchUpdate>
    export type UpdatePreOrderBatchMutationError = ErrorType<void>

    /**
 * @summary Edit batch header fields
 */
export const useUpdatePreOrderBatch = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePreOrderBatch>>, TError,{id: string;data: BodyType<PreOrderBatchUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePreOrderBatch>>,
        TError,
        {id: string;data: BodyType<PreOrderBatchUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePreOrderBatchMutationOptions(options));
    }

export const getDeletePreOrderBatchUrl = (id: string,) => {




  return `/api/pre-orders/batches/${id}`
}

/**
 * @summary Delete a batch (draft/cancelled only; blocked if active allocations exist)
 */
export const deletePreOrderBatch = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeletePreOrderBatchUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeletePreOrderBatchMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePreOrderBatch>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePreOrderBatch>>, TError,{id: string}, TContext> => {

const mutationKey = ['deletePreOrderBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePreOrderBatch>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deletePreOrderBatch(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePreOrderBatchMutationResult = NonNullable<Awaited<ReturnType<typeof deletePreOrderBatch>>>

    export type DeletePreOrderBatchMutationError = ErrorType<void>

    /**
 * @summary Delete a batch (draft/cancelled only; blocked if active allocations exist)
 */
export const useDeletePreOrderBatch = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePreOrderBatch>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePreOrderBatch>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeletePreOrderBatchMutationOptions(options));
    }

export const getListPreOrderBatchProductsUrl = (id: string,
    params?: ListPreOrderBatchProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pre-orders/batches/${id}/products?${stringifiedParams}` : `/api/pre-orders/batches/${id}/products`
}

/**
 * @summary Bounded cursor page of authoritative batch product lines
 */
export const listPreOrderBatchProducts = async (id: string,
    params?: ListPreOrderBatchProductsParams, options?: RequestInit): Promise<PreOrderBatchProductPage> => {

  return customFetch<PreOrderBatchProductPage>(getListPreOrderBatchProductsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPreOrderBatchProductsQueryKey = (id: string,
    params?: ListPreOrderBatchProductsParams,) => {
    return [
    `/api/pre-orders/batches/${id}/products`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPreOrderBatchProductsQueryOptions = <TData = Awaited<ReturnType<typeof listPreOrderBatchProducts>>, TError = ErrorType<void>>(id: string,
    params?: ListPreOrderBatchProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPreOrderBatchProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPreOrderBatchProductsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPreOrderBatchProducts>>> = ({ signal }) => listPreOrderBatchProducts(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPreOrderBatchProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPreOrderBatchProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listPreOrderBatchProducts>>>
export type ListPreOrderBatchProductsQueryError = ErrorType<void>


/**
 * @summary Bounded cursor page of authoritative batch product lines
 */

export function useListPreOrderBatchProducts<TData = Awaited<ReturnType<typeof listPreOrderBatchProducts>>, TError = ErrorType<void>>(
 id: string,
    params?: ListPreOrderBatchProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPreOrderBatchProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPreOrderBatchProductsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPreOrderBatchNotesUrl = (id: string,
    params?: GetPreOrderBatchNotesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pre-orders/batches/${id}/notes?${stringifiedParams}` : `/api/pre-orders/batches/${id}/notes`
}

/**
 * @summary Lazily read the legacy batch note and contextual notes
 */
export const getPreOrderBatchNotes = async (id: string,
    params?: GetPreOrderBatchNotesParams, options?: RequestInit): Promise<PreOrderBatchNotesResponse> => {

  return customFetch<PreOrderBatchNotesResponse>(getGetPreOrderBatchNotesUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPreOrderBatchNotesQueryKey = (id: string,
    params?: GetPreOrderBatchNotesParams,) => {
    return [
    `/api/pre-orders/batches/${id}/notes`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPreOrderBatchNotesQueryOptions = <TData = Awaited<ReturnType<typeof getPreOrderBatchNotes>>, TError = ErrorType<void>>(id: string,
    params?: GetPreOrderBatchNotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPreOrderBatchNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPreOrderBatchNotesQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPreOrderBatchNotes>>> = ({ signal }) => getPreOrderBatchNotes(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPreOrderBatchNotes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPreOrderBatchNotesQueryResult = NonNullable<Awaited<ReturnType<typeof getPreOrderBatchNotes>>>
export type GetPreOrderBatchNotesQueryError = ErrorType<void>


/**
 * @summary Lazily read the legacy batch note and contextual notes
 */

export function useGetPreOrderBatchNotes<TData = Awaited<ReturnType<typeof getPreOrderBatchNotes>>, TError = ErrorType<void>>(
 id: string,
    params?: GetPreOrderBatchNotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPreOrderBatchNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPreOrderBatchNotesQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddPreOrderBatchNoteUrl = (id: string,) => {




  return `/api/pre-orders/batches/${id}/notes`
}

/**
 * @summary Add an immutable batch- or allocation-linked internal note
 */
export const addPreOrderBatchNote = async (id: string,
    preOrderContextNoteInput: PreOrderContextNoteInput, options?: RequestInit): Promise<PreOrderContextNote> => {

  return customFetch<PreOrderContextNote>(getAddPreOrderBatchNoteUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(preOrderContextNoteInput)
  }
);}





export const getAddPreOrderBatchNoteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPreOrderBatchNote>>, TError,{id: string;data: BodyType<PreOrderContextNoteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addPreOrderBatchNote>>, TError,{id: string;data: BodyType<PreOrderContextNoteInput>}, TContext> => {

const mutationKey = ['addPreOrderBatchNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addPreOrderBatchNote>>, {id: string;data: BodyType<PreOrderContextNoteInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  addPreOrderBatchNote(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddPreOrderBatchNoteMutationResult = NonNullable<Awaited<ReturnType<typeof addPreOrderBatchNote>>>
    export type AddPreOrderBatchNoteMutationBody = BodyType<PreOrderContextNoteInput>
    export type AddPreOrderBatchNoteMutationError = ErrorType<void>

    /**
 * @summary Add an immutable batch- or allocation-linked internal note
 */
export const useAddPreOrderBatchNote = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPreOrderBatchNote>>, TError,{id: string;data: BodyType<PreOrderContextNoteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addPreOrderBatchNote>>,
        TError,
        {id: string;data: BodyType<PreOrderContextNoteInput>},
        TContext
      > => {
      return useMutation(getAddPreOrderBatchNoteMutationOptions(options));
    }

export const getUpdatePreOrderBatchNotesUrl = (id: string,) => {




  return `/api/pre-orders/batches/${id}/notes`
}

/**
 * @summary Update the batch note
 */
export const updatePreOrderBatchNotes = async (id: string,
    updatePreOrderBatchNotesBody: UpdatePreOrderBatchNotesBody, options?: RequestInit): Promise<UpdatePreOrderBatchNotes200> => {

  return customFetch<UpdatePreOrderBatchNotes200>(getUpdatePreOrderBatchNotesUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updatePreOrderBatchNotesBody)
  }
);}





export const getUpdatePreOrderBatchNotesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePreOrderBatchNotes>>, TError,{id: string;data: BodyType<UpdatePreOrderBatchNotesBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePreOrderBatchNotes>>, TError,{id: string;data: BodyType<UpdatePreOrderBatchNotesBody>}, TContext> => {

const mutationKey = ['updatePreOrderBatchNotes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePreOrderBatchNotes>>, {id: string;data: BodyType<UpdatePreOrderBatchNotesBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePreOrderBatchNotes(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePreOrderBatchNotesMutationResult = NonNullable<Awaited<ReturnType<typeof updatePreOrderBatchNotes>>>
    export type UpdatePreOrderBatchNotesMutationBody = BodyType<UpdatePreOrderBatchNotesBody>
    export type UpdatePreOrderBatchNotesMutationError = ErrorType<void>

    /**
 * @summary Update the batch note
 */
export const useUpdatePreOrderBatchNotes = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePreOrderBatchNotes>>, TError,{id: string;data: BodyType<UpdatePreOrderBatchNotesBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePreOrderBatchNotes>>,
        TError,
        {id: string;data: BodyType<UpdatePreOrderBatchNotesBody>},
        TContext
      > => {
      return useMutation(getUpdatePreOrderBatchNotesMutationOptions(options));
    }

export const getTransitionPreOrderBatchStatusUrl = (id: string,) => {




  return `/api/pre-orders/batches/${id}/status`
}

/**
 * @summary Advance / change batch status (readiness-validated)
 */
export const transitionPreOrderBatchStatus = async (id: string,
    preOrderBatchStatusInput: PreOrderBatchStatusInput, options?: RequestInit): Promise<PreOrderBatchDetail> => {

  return customFetch<PreOrderBatchDetail>(getTransitionPreOrderBatchStatusUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(preOrderBatchStatusInput)
  }
);}





export const getTransitionPreOrderBatchStatusMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transitionPreOrderBatchStatus>>, TError,{id: string;data: BodyType<PreOrderBatchStatusInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof transitionPreOrderBatchStatus>>, TError,{id: string;data: BodyType<PreOrderBatchStatusInput>}, TContext> => {

const mutationKey = ['transitionPreOrderBatchStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof transitionPreOrderBatchStatus>>, {id: string;data: BodyType<PreOrderBatchStatusInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  transitionPreOrderBatchStatus(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TransitionPreOrderBatchStatusMutationResult = NonNullable<Awaited<ReturnType<typeof transitionPreOrderBatchStatus>>>
    export type TransitionPreOrderBatchStatusMutationBody = BodyType<PreOrderBatchStatusInput>
    export type TransitionPreOrderBatchStatusMutationError = ErrorType<void>

    /**
 * @summary Advance / change batch status (readiness-validated)
 */
export const useTransitionPreOrderBatchStatus = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transitionPreOrderBatchStatus>>, TError,{id: string;data: BodyType<PreOrderBatchStatusInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof transitionPreOrderBatchStatus>>,
        TError,
        {id: string;data: BodyType<PreOrderBatchStatusInput>},
        TContext
      > => {
      return useMutation(getTransitionPreOrderBatchStatusMutationOptions(options));
    }

export const getAddPreOrderBatchItemUrl = (id: string,) => {




  return `/api/pre-orders/batches/${id}/items`
}

/**
 * @summary Add a product line to a batch
 */
export const addPreOrderBatchItem = async (id: string,
    preOrderBatchItemInput: PreOrderBatchItemInput, options?: RequestInit): Promise<PreOrderBatchDetail> => {

  return customFetch<PreOrderBatchDetail>(getAddPreOrderBatchItemUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(preOrderBatchItemInput)
  }
);}





export const getAddPreOrderBatchItemMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPreOrderBatchItem>>, TError,{id: string;data: BodyType<PreOrderBatchItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addPreOrderBatchItem>>, TError,{id: string;data: BodyType<PreOrderBatchItemInput>}, TContext> => {

const mutationKey = ['addPreOrderBatchItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addPreOrderBatchItem>>, {id: string;data: BodyType<PreOrderBatchItemInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  addPreOrderBatchItem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddPreOrderBatchItemMutationResult = NonNullable<Awaited<ReturnType<typeof addPreOrderBatchItem>>>
    export type AddPreOrderBatchItemMutationBody = BodyType<PreOrderBatchItemInput>
    export type AddPreOrderBatchItemMutationError = ErrorType<void>

    /**
 * @summary Add a product line to a batch
 */
export const useAddPreOrderBatchItem = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPreOrderBatchItem>>, TError,{id: string;data: BodyType<PreOrderBatchItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addPreOrderBatchItem>>,
        TError,
        {id: string;data: BodyType<PreOrderBatchItemInput>},
        TContext
      > => {
      return useMutation(getAddPreOrderBatchItemMutationOptions(options));
    }

export const getUpdatePreOrderBatchItemUrl = (id: string,
    itemId: string,) => {




  return `/api/pre-orders/batches/${id}/items/${itemId}`
}

/**
 * @summary Edit a batch item
 */
export const updatePreOrderBatchItem = async (id: string,
    itemId: string,
    preOrderBatchItemUpdate: PreOrderBatchItemUpdate, options?: RequestInit): Promise<PreOrderBatchDetail> => {

  return customFetch<PreOrderBatchDetail>(getUpdatePreOrderBatchItemUrl(id,itemId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(preOrderBatchItemUpdate)
  }
);}





export const getUpdatePreOrderBatchItemMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePreOrderBatchItem>>, TError,{id: string;itemId: string;data: BodyType<PreOrderBatchItemUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePreOrderBatchItem>>, TError,{id: string;itemId: string;data: BodyType<PreOrderBatchItemUpdate>}, TContext> => {

const mutationKey = ['updatePreOrderBatchItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePreOrderBatchItem>>, {id: string;itemId: string;data: BodyType<PreOrderBatchItemUpdate>}> = (props) => {
          const {id,itemId,data} = props ?? {};

          return  updatePreOrderBatchItem(id,itemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePreOrderBatchItemMutationResult = NonNullable<Awaited<ReturnType<typeof updatePreOrderBatchItem>>>
    export type UpdatePreOrderBatchItemMutationBody = BodyType<PreOrderBatchItemUpdate>
    export type UpdatePreOrderBatchItemMutationError = ErrorType<void>

    /**
 * @summary Edit a batch item
 */
export const useUpdatePreOrderBatchItem = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePreOrderBatchItem>>, TError,{id: string;itemId: string;data: BodyType<PreOrderBatchItemUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePreOrderBatchItem>>,
        TError,
        {id: string;itemId: string;data: BodyType<PreOrderBatchItemUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePreOrderBatchItemMutationOptions(options));
    }

export const getDeletePreOrderBatchItemUrl = (id: string,
    itemId: string,) => {




  return `/api/pre-orders/batches/${id}/items/${itemId}`
}

/**
 * @summary Remove a batch item (blocked once batch is open or later)
 */
export const deletePreOrderBatchItem = async (id: string,
    itemId: string, options?: RequestInit): Promise<PreOrderBatchDetail> => {

  return customFetch<PreOrderBatchDetail>(getDeletePreOrderBatchItemUrl(id,itemId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeletePreOrderBatchItemMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePreOrderBatchItem>>, TError,{id: string;itemId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePreOrderBatchItem>>, TError,{id: string;itemId: string}, TContext> => {

const mutationKey = ['deletePreOrderBatchItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePreOrderBatchItem>>, {id: string;itemId: string}> = (props) => {
          const {id,itemId} = props ?? {};

          return  deletePreOrderBatchItem(id,itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePreOrderBatchItemMutationResult = NonNullable<Awaited<ReturnType<typeof deletePreOrderBatchItem>>>

    export type DeletePreOrderBatchItemMutationError = ErrorType<void>

    /**
 * @summary Remove a batch item (blocked once batch is open or later)
 */
export const useDeletePreOrderBatchItem = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePreOrderBatchItem>>, TError,{id: string;itemId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePreOrderBatchItem>>,
        TError,
        {id: string;itemId: string},
        TContext
      > => {
      return useMutation(getDeletePreOrderBatchItemMutationOptions(options));
    }

export const getCorrectOpenPreOrderBatchItemPricingUrl = (id: string,
    itemId: string,) => {




  return `/api/pre-orders/batches/${id}/items/${itemId}/pricing`
}

/**
 * Updates only the purchase and selling pricing terms used for future allocations. Existing allocation snapshots, sales, invoices, payments, and locked market-price snapshots remain unchanged.
 * @summary Correct future pricing terms on an open batch item
 */
export const correctOpenPreOrderBatchItemPricing = async (id: string,
    itemId: string,
    preOrderBatchItemPricingCorrection: PreOrderBatchItemPricingCorrection, options?: RequestInit): Promise<PreOrderBatchDetail> => {

  return customFetch<PreOrderBatchDetail>(getCorrectOpenPreOrderBatchItemPricingUrl(id,itemId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(preOrderBatchItemPricingCorrection)
  }
);}





export const getCorrectOpenPreOrderBatchItemPricingMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof correctOpenPreOrderBatchItemPricing>>, TError,{id: string;itemId: string;data: BodyType<PreOrderBatchItemPricingCorrection>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof correctOpenPreOrderBatchItemPricing>>, TError,{id: string;itemId: string;data: BodyType<PreOrderBatchItemPricingCorrection>}, TContext> => {

const mutationKey = ['correctOpenPreOrderBatchItemPricing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof correctOpenPreOrderBatchItemPricing>>, {id: string;itemId: string;data: BodyType<PreOrderBatchItemPricingCorrection>}> = (props) => {
          const {id,itemId,data} = props ?? {};

          return  correctOpenPreOrderBatchItemPricing(id,itemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CorrectOpenPreOrderBatchItemPricingMutationResult = NonNullable<Awaited<ReturnType<typeof correctOpenPreOrderBatchItemPricing>>>
    export type CorrectOpenPreOrderBatchItemPricingMutationBody = BodyType<PreOrderBatchItemPricingCorrection>
    export type CorrectOpenPreOrderBatchItemPricingMutationError = ErrorType<void>

    /**
 * @summary Correct future pricing terms on an open batch item
 */
export const useCorrectOpenPreOrderBatchItemPricing = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof correctOpenPreOrderBatchItemPricing>>, TError,{id: string;itemId: string;data: BodyType<PreOrderBatchItemPricingCorrection>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof correctOpenPreOrderBatchItemPricing>>,
        TError,
        {id: string;itemId: string;data: BodyType<PreOrderBatchItemPricingCorrection>},
        TContext
      > => {
      return useMutation(getCorrectOpenPreOrderBatchItemPricingMutationOptions(options));
    }

export const getSearchPreOrderLinkableInventoryUrl = (params: SearchPreOrderLinkableInventoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pre-orders/linkable-inventory?${stringifiedParams}` : `/api/pre-orders/linkable-inventory`
}

/**
 * Requires pre_orders.manage and view_inventory. Searches the full tenant catalogue by SKU or title, excluding shared-pool children, placeholders and review rows before limiting to 20 results. Exact SKU matches rank first. Existing on-hand stock does not disqualify a SKU.
 * @summary Search eligible standalone inventory SKUs for pre-order linking
 */
export const searchPreOrderLinkableInventory = async (params: SearchPreOrderLinkableInventoryParams, options?: RequestInit): Promise<SearchPreOrderLinkableInventory200> => {

  return customFetch<SearchPreOrderLinkableInventory200>(getSearchPreOrderLinkableInventoryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchPreOrderLinkableInventoryQueryKey = (params?: SearchPreOrderLinkableInventoryParams,) => {
    return [
    `/api/pre-orders/linkable-inventory`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchPreOrderLinkableInventoryQueryOptions = <TData = Awaited<ReturnType<typeof searchPreOrderLinkableInventory>>, TError = ErrorType<void>>(params: SearchPreOrderLinkableInventoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchPreOrderLinkableInventory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchPreOrderLinkableInventoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchPreOrderLinkableInventory>>> = ({ signal }) => searchPreOrderLinkableInventory(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchPreOrderLinkableInventory>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchPreOrderLinkableInventoryQueryResult = NonNullable<Awaited<ReturnType<typeof searchPreOrderLinkableInventory>>>
export type SearchPreOrderLinkableInventoryQueryError = ErrorType<void>


/**
 * @summary Search eligible standalone inventory SKUs for pre-order linking
 */

export function useSearchPreOrderLinkableInventory<TData = Awaited<ReturnType<typeof searchPreOrderLinkableInventory>>, TError = ErrorType<void>>(
 params: SearchPreOrderLinkableInventoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchPreOrderLinkableInventory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSearchPreOrderLinkableInventoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getLinkPreOrderBatchItemSkuUrl = (id: string,
    itemId: string,) => {




  return `/api/pre-orders/batches/${id}/items/${itemId}/link-sku`
}

/**
 * Links a batch item to its real inventory SKU at ANY batch status (including Open for Pre-Order and later). Only the inventory pointer changes — the frozen commercial fields (quantity, price, VAT, product identity) are untouched. Re-points every active/confirmed allocation's sale line and any stock assignments, and retires the auto-created placeholder once it is no longer referenced. Rejects re-linking when stock has already been received against the current SKU. If the post-link stock assignment sweep fails, the link remains committed and the response includes an assignment warning; repeating this request with the same SKU safely retries assignment.
 * @summary Link (or re-point) the real inventory SKU for a batch item
 */
export const linkPreOrderBatchItemSku = async (id: string,
    itemId: string,
    linkPreOrderBatchItemSkuInput: LinkPreOrderBatchItemSkuInput, options?: RequestInit): Promise<PreOrderBatchSkuLinkResponse> => {

  return customFetch<PreOrderBatchSkuLinkResponse>(getLinkPreOrderBatchItemSkuUrl(id,itemId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(linkPreOrderBatchItemSkuInput)
  }
);}





export const getLinkPreOrderBatchItemSkuMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkPreOrderBatchItemSku>>, TError,{id: string;itemId: string;data: BodyType<LinkPreOrderBatchItemSkuInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof linkPreOrderBatchItemSku>>, TError,{id: string;itemId: string;data: BodyType<LinkPreOrderBatchItemSkuInput>}, TContext> => {

const mutationKey = ['linkPreOrderBatchItemSku'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linkPreOrderBatchItemSku>>, {id: string;itemId: string;data: BodyType<LinkPreOrderBatchItemSkuInput>}> = (props) => {
          const {id,itemId,data} = props ?? {};

          return  linkPreOrderBatchItemSku(id,itemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LinkPreOrderBatchItemSkuMutationResult = NonNullable<Awaited<ReturnType<typeof linkPreOrderBatchItemSku>>>
    export type LinkPreOrderBatchItemSkuMutationBody = BodyType<LinkPreOrderBatchItemSkuInput>
    export type LinkPreOrderBatchItemSkuMutationError = ErrorType<void>

    /**
 * @summary Link (or re-point) the real inventory SKU for a batch item
 */
export const useLinkPreOrderBatchItemSku = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkPreOrderBatchItemSku>>, TError,{id: string;itemId: string;data: BodyType<LinkPreOrderBatchItemSkuInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof linkPreOrderBatchItemSku>>,
        TError,
        {id: string;itemId: string;data: BodyType<LinkPreOrderBatchItemSkuInput>},
        TContext
      > => {
      return useMutation(getLinkPreOrderBatchItemSkuMutationOptions(options));
    }

export const getListPreOrderAllocationsUrl = (id: string,
    params?: ListPreOrderAllocationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pre-orders/batches/${id}/allocations?${stringifiedParams}` : `/api/pre-orders/batches/${id}/allocations`
}

/**
 * Use `unclassified` as the allocationType filter for legacy rows without a type, and `unassigned` as operatorUserId for rows without an assigned operator.
 * @summary List customer allocations for a batch
 */
export const listPreOrderAllocations = async (id: string,
    params?: ListPreOrderAllocationsParams, options?: RequestInit): Promise<PreOrderAllocationListResponse> => {

  return customFetch<PreOrderAllocationListResponse>(getListPreOrderAllocationsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPreOrderAllocationsQueryKey = (id: string,
    params?: ListPreOrderAllocationsParams,) => {
    return [
    `/api/pre-orders/batches/${id}/allocations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPreOrderAllocationsQueryOptions = <TData = Awaited<ReturnType<typeof listPreOrderAllocations>>, TError = ErrorType<void>>(id: string,
    params?: ListPreOrderAllocationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPreOrderAllocations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPreOrderAllocationsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPreOrderAllocations>>> = ({ signal }) => listPreOrderAllocations(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPreOrderAllocations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPreOrderAllocationsQueryResult = NonNullable<Awaited<ReturnType<typeof listPreOrderAllocations>>>
export type ListPreOrderAllocationsQueryError = ErrorType<void>


/**
 * @summary List customer allocations for a batch
 */

export function useListPreOrderAllocations<TData = Awaited<ReturnType<typeof listPreOrderAllocations>>, TError = ErrorType<void>>(
 id: string,
    params?: ListPreOrderAllocationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPreOrderAllocations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPreOrderAllocationsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreatePreOrderAllocationUrl = (id: string,) => {




  return `/api/pre-orders/batches/${id}/allocations`
}

/**
 * @summary Reserve pre-order stock for a customer (creates a reserved pre-order sale)
 */
export const createPreOrderAllocation = async (id: string,
    preOrderAllocationInput: PreOrderAllocationInput, options?: RequestInit): Promise<PreOrderAllocationCreateResponse> => {

  return customFetch<PreOrderAllocationCreateResponse>(getCreatePreOrderAllocationUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(preOrderAllocationInput)
  }
);}





export const getCreatePreOrderAllocationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPreOrderAllocation>>, TError,{id: string;data: BodyType<PreOrderAllocationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPreOrderAllocation>>, TError,{id: string;data: BodyType<PreOrderAllocationInput>}, TContext> => {

const mutationKey = ['createPreOrderAllocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPreOrderAllocation>>, {id: string;data: BodyType<PreOrderAllocationInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createPreOrderAllocation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePreOrderAllocationMutationResult = NonNullable<Awaited<ReturnType<typeof createPreOrderAllocation>>>
    export type CreatePreOrderAllocationMutationBody = BodyType<PreOrderAllocationInput>
    export type CreatePreOrderAllocationMutationError = ErrorType<void>

    /**
 * @summary Reserve pre-order stock for a customer (creates a reserved pre-order sale)
 */
export const useCreatePreOrderAllocation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPreOrderAllocation>>, TError,{id: string;data: BodyType<PreOrderAllocationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPreOrderAllocation>>,
        TError,
        {id: string;data: BodyType<PreOrderAllocationInput>},
        TContext
      > => {
      return useMutation(getCreatePreOrderAllocationMutationOptions(options));
    }

export const getUpdatePreOrderAllocationQuantityUrl = (allocationId: string,) => {




  return `/api/pre-orders/allocations/${allocationId}/quantity`
}

/**
 * Changes only the allocation and linked sale-line quantity. Existing customer, agreed unit price, payment records, and sibling lines are preserved.
 * @summary Change the quantity on an existing pre-order allocation
 */
export const updatePreOrderAllocationQuantity = async (allocationId: string,
    preOrderAllocationQuantityUpdate: PreOrderAllocationQuantityUpdate, options?: RequestInit): Promise<PreOrderAllocationQuantityUpdateResponse> => {

  return customFetch<PreOrderAllocationQuantityUpdateResponse>(getUpdatePreOrderAllocationQuantityUrl(allocationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(preOrderAllocationQuantityUpdate)
  }
);}





export const getUpdatePreOrderAllocationQuantityMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePreOrderAllocationQuantity>>, TError,{allocationId: string;data: BodyType<PreOrderAllocationQuantityUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePreOrderAllocationQuantity>>, TError,{allocationId: string;data: BodyType<PreOrderAllocationQuantityUpdate>}, TContext> => {

const mutationKey = ['updatePreOrderAllocationQuantity'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePreOrderAllocationQuantity>>, {allocationId: string;data: BodyType<PreOrderAllocationQuantityUpdate>}> = (props) => {
          const {allocationId,data} = props ?? {};

          return  updatePreOrderAllocationQuantity(allocationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePreOrderAllocationQuantityMutationResult = NonNullable<Awaited<ReturnType<typeof updatePreOrderAllocationQuantity>>>
    export type UpdatePreOrderAllocationQuantityMutationBody = BodyType<PreOrderAllocationQuantityUpdate>
    export type UpdatePreOrderAllocationQuantityMutationError = ErrorType<void>

    /**
 * @summary Change the quantity on an existing pre-order allocation
 */
export const useUpdatePreOrderAllocationQuantity = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePreOrderAllocationQuantity>>, TError,{allocationId: string;data: BodyType<PreOrderAllocationQuantityUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePreOrderAllocationQuantity>>,
        TError,
        {allocationId: string;data: BodyType<PreOrderAllocationQuantityUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePreOrderAllocationQuantityMutationOptions(options));
    }

export const getUpdatePreOrderAllocationMetadataUrl = (allocationId: string,) => {




  return `/api/pre-orders/allocations/${allocationId}/metadata`
}

/**
 * Metadata-only update. Does not modify stock, payment, sale, fulfilment, Box, or dispatch state.
 * @summary Change allocation classification or assigned operator
 */
export const updatePreOrderAllocationMetadata = async (allocationId: string,
    preOrderAllocationMetadataUpdate: PreOrderAllocationMetadataUpdate, options?: RequestInit): Promise<PreOrderAllocationMetadata> => {

  return customFetch<PreOrderAllocationMetadata>(getUpdatePreOrderAllocationMetadataUrl(allocationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(preOrderAllocationMetadataUpdate)
  }
);}





export const getUpdatePreOrderAllocationMetadataMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePreOrderAllocationMetadata>>, TError,{allocationId: string;data: BodyType<PreOrderAllocationMetadataUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePreOrderAllocationMetadata>>, TError,{allocationId: string;data: BodyType<PreOrderAllocationMetadataUpdate>}, TContext> => {

const mutationKey = ['updatePreOrderAllocationMetadata'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePreOrderAllocationMetadata>>, {allocationId: string;data: BodyType<PreOrderAllocationMetadataUpdate>}> = (props) => {
          const {allocationId,data} = props ?? {};

          return  updatePreOrderAllocationMetadata(allocationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePreOrderAllocationMetadataMutationResult = NonNullable<Awaited<ReturnType<typeof updatePreOrderAllocationMetadata>>>
    export type UpdatePreOrderAllocationMetadataMutationBody = BodyType<PreOrderAllocationMetadataUpdate>
    export type UpdatePreOrderAllocationMetadataMutationError = ErrorType<void>

    /**
 * @summary Change allocation classification or assigned operator
 */
export const useUpdatePreOrderAllocationMetadata = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePreOrderAllocationMetadata>>, TError,{allocationId: string;data: BodyType<PreOrderAllocationMetadataUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePreOrderAllocationMetadata>>,
        TError,
        {allocationId: string;data: BodyType<PreOrderAllocationMetadataUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePreOrderAllocationMetadataMutationOptions(options));
    }

export const getListPreOrderOperatorsUrl = () => {




  return `/api/pre-orders/operators`
}

/**
 * @summary List active tenant staff eligible for allocation assignment
 */
export const listPreOrderOperators = async ( options?: RequestInit): Promise<PreOrderOperatorListResponse> => {

  return customFetch<PreOrderOperatorListResponse>(getListPreOrderOperatorsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPreOrderOperatorsQueryKey = () => {
    return [
    `/api/pre-orders/operators`
    ] as const;
    }


export const getListPreOrderOperatorsQueryOptions = <TData = Awaited<ReturnType<typeof listPreOrderOperators>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPreOrderOperators>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPreOrderOperatorsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPreOrderOperators>>> = ({ signal }) => listPreOrderOperators({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPreOrderOperators>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPreOrderOperatorsQueryResult = NonNullable<Awaited<ReturnType<typeof listPreOrderOperators>>>
export type ListPreOrderOperatorsQueryError = ErrorType<void>


/**
 * @summary List active tenant staff eligible for allocation assignment
 */

export function useListPreOrderOperators<TData = Awaited<ReturnType<typeof listPreOrderOperators>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPreOrderOperators>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPreOrderOperatorsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdatePreOrderAllocationPriceUrl = (allocationId: string,) => {




  return `/api/pre-orders/allocations/${allocationId}/price`
}

/**
 * Changes only this allocation's price snapshot and linked sale line. Batch terms, portal offers, sibling sale lines, other allocations, VAT treatment, and payment records are preserved. Issued invoices or other locked documents prevent the edit; excess payments remain customer credit due and are never refunded automatically.
 * @summary Change the agreed unit price on one pre-order allocation
 */
export const updatePreOrderAllocationPrice = async (allocationId: string,
    preOrderAllocationPriceUpdate: PreOrderAllocationPriceUpdate, options?: RequestInit): Promise<PreOrderAllocationPriceUpdateResponse> => {

  return customFetch<PreOrderAllocationPriceUpdateResponse>(getUpdatePreOrderAllocationPriceUrl(allocationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(preOrderAllocationPriceUpdate)
  }
);}





export const getUpdatePreOrderAllocationPriceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePreOrderAllocationPrice>>, TError,{allocationId: string;data: BodyType<PreOrderAllocationPriceUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePreOrderAllocationPrice>>, TError,{allocationId: string;data: BodyType<PreOrderAllocationPriceUpdate>}, TContext> => {

const mutationKey = ['updatePreOrderAllocationPrice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePreOrderAllocationPrice>>, {allocationId: string;data: BodyType<PreOrderAllocationPriceUpdate>}> = (props) => {
          const {allocationId,data} = props ?? {};

          return  updatePreOrderAllocationPrice(allocationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePreOrderAllocationPriceMutationResult = NonNullable<Awaited<ReturnType<typeof updatePreOrderAllocationPrice>>>
    export type UpdatePreOrderAllocationPriceMutationBody = BodyType<PreOrderAllocationPriceUpdate>
    export type UpdatePreOrderAllocationPriceMutationError = ErrorType<void>

    /**
 * @summary Change the agreed unit price on one pre-order allocation
 */
export const useUpdatePreOrderAllocationPrice = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePreOrderAllocationPrice>>, TError,{allocationId: string;data: BodyType<PreOrderAllocationPriceUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePreOrderAllocationPrice>>,
        TError,
        {allocationId: string;data: BodyType<PreOrderAllocationPriceUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePreOrderAllocationPriceMutationOptions(options));
    }

export const getGetPreOrderBatchAllocationSummaryUrl = (id: string,) => {




  return `/api/pre-orders/batches/${id}/allocation-summary`
}

/**
 * @summary Get complete batch reservation counts independent of list pagination
 */
export const getPreOrderBatchAllocationSummary = async (id: string, options?: RequestInit): Promise<PreOrderBatchAllocationSummary> => {

  return customFetch<PreOrderBatchAllocationSummary>(getGetPreOrderBatchAllocationSummaryUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPreOrderBatchAllocationSummaryQueryKey = (id: string,) => {
    return [
    `/api/pre-orders/batches/${id}/allocation-summary`
    ] as const;
    }


export const getGetPreOrderBatchAllocationSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getPreOrderBatchAllocationSummary>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPreOrderBatchAllocationSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPreOrderBatchAllocationSummaryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPreOrderBatchAllocationSummary>>> = ({ signal }) => getPreOrderBatchAllocationSummary(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPreOrderBatchAllocationSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPreOrderBatchAllocationSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getPreOrderBatchAllocationSummary>>>
export type GetPreOrderBatchAllocationSummaryQueryError = ErrorType<void>


/**
 * @summary Get complete batch reservation counts independent of list pagination
 */

export function useGetPreOrderBatchAllocationSummary<TData = Awaited<ReturnType<typeof getPreOrderBatchAllocationSummary>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPreOrderBatchAllocationSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPreOrderBatchAllocationSummaryQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreatePreOrderEtaUpdateUrl = (id: string,) => {




  return `/api/pre-orders/batches/${id}/eta-updates`
}

/**
 * @summary Save a product- or batch-scoped ETA update for active reservations
 */
export const createPreOrderEtaUpdate = async (id: string,
    preOrderEtaUpdateInput: PreOrderEtaUpdateInput, options?: RequestInit): Promise<PreOrderEtaUpdateResponse> => {

  return customFetch<PreOrderEtaUpdateResponse>(getCreatePreOrderEtaUpdateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(preOrderEtaUpdateInput)
  }
);}





export const getCreatePreOrderEtaUpdateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPreOrderEtaUpdate>>, TError,{id: string;data: BodyType<PreOrderEtaUpdateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPreOrderEtaUpdate>>, TError,{id: string;data: BodyType<PreOrderEtaUpdateInput>}, TContext> => {

const mutationKey = ['createPreOrderEtaUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPreOrderEtaUpdate>>, {id: string;data: BodyType<PreOrderEtaUpdateInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createPreOrderEtaUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePreOrderEtaUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof createPreOrderEtaUpdate>>>
    export type CreatePreOrderEtaUpdateMutationBody = BodyType<PreOrderEtaUpdateInput>
    export type CreatePreOrderEtaUpdateMutationError = ErrorType<void>

    /**
 * @summary Save a product- or batch-scoped ETA update for active reservations
 */
export const useCreatePreOrderEtaUpdate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPreOrderEtaUpdate>>, TError,{id: string;data: BodyType<PreOrderEtaUpdateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPreOrderEtaUpdate>>,
        TError,
        {id: string;data: BodyType<PreOrderEtaUpdateInput>},
        TContext
      > => {
      return useMutation(getCreatePreOrderEtaUpdateMutationOptions(options));
    }

export const getGetPreOrderEtaUpdatePreviewUrl = (id: string,
    updateId: string,) => {




  return `/api/pre-orders/batches/${id}/eta-updates/${updateId}/preview`
}

/**
 * @summary Preview the current active-reservation recipients for an ETA update
 */
export const getPreOrderEtaUpdatePreview = async (id: string,
    updateId: string, options?: RequestInit): Promise<PreOrderEtaUpdatePreview> => {

  return customFetch<PreOrderEtaUpdatePreview>(getGetPreOrderEtaUpdatePreviewUrl(id,updateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPreOrderEtaUpdatePreviewQueryKey = (id: string,
    updateId: string,) => {
    return [
    `/api/pre-orders/batches/${id}/eta-updates/${updateId}/preview`
    ] as const;
    }


export const getGetPreOrderEtaUpdatePreviewQueryOptions = <TData = Awaited<ReturnType<typeof getPreOrderEtaUpdatePreview>>, TError = ErrorType<void>>(id: string,
    updateId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPreOrderEtaUpdatePreview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPreOrderEtaUpdatePreviewQueryKey(id,updateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPreOrderEtaUpdatePreview>>> = ({ signal }) => getPreOrderEtaUpdatePreview(id,updateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && updateId !== null && updateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPreOrderEtaUpdatePreview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPreOrderEtaUpdatePreviewQueryResult = NonNullable<Awaited<ReturnType<typeof getPreOrderEtaUpdatePreview>>>
export type GetPreOrderEtaUpdatePreviewQueryError = ErrorType<void>


/**
 * @summary Preview the current active-reservation recipients for an ETA update
 */

export function useGetPreOrderEtaUpdatePreview<TData = Awaited<ReturnType<typeof getPreOrderEtaUpdatePreview>>, TError = ErrorType<void>>(
 id: string,
    updateId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPreOrderEtaUpdatePreview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPreOrderEtaUpdatePreviewQueryOptions(id,updateId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getNotifyPreOrderEtaUpdateRecipientsUrl = (id: string,
    updateId: string,) => {




  return `/api/pre-orders/batches/${id}/eta-updates/${updateId}/notify`
}

/**
 * A batch-scoped audit claim is stored before dispatch. Retries do not send a second message for a recipient already attempted for this update. SMS and WhatsApp are not supported by this workflow.
 * @summary Send a deduplicated transactional email for an ETA update
 */
export const notifyPreOrderEtaUpdateRecipients = async (id: string,
    updateId: string, options?: RequestInit): Promise<PreOrderEtaNotificationResponse> => {

  return customFetch<PreOrderEtaNotificationResponse>(getNotifyPreOrderEtaUpdateRecipientsUrl(id,updateId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getNotifyPreOrderEtaUpdateRecipientsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyPreOrderEtaUpdateRecipients>>, TError,{id: string;updateId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof notifyPreOrderEtaUpdateRecipients>>, TError,{id: string;updateId: string}, TContext> => {

const mutationKey = ['notifyPreOrderEtaUpdateRecipients'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notifyPreOrderEtaUpdateRecipients>>, {id: string;updateId: string}> = (props) => {
          const {id,updateId} = props ?? {};

          return  notifyPreOrderEtaUpdateRecipients(id,updateId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotifyPreOrderEtaUpdateRecipientsMutationResult = NonNullable<Awaited<ReturnType<typeof notifyPreOrderEtaUpdateRecipients>>>

    export type NotifyPreOrderEtaUpdateRecipientsMutationError = ErrorType<void>

    /**
 * @summary Send a deduplicated transactional email for an ETA update
 */
export const useNotifyPreOrderEtaUpdateRecipients = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyPreOrderEtaUpdateRecipients>>, TError,{id: string;updateId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof notifyPreOrderEtaUpdateRecipients>>,
        TError,
        {id: string;updateId: string},
        TContext
      > => {
      return useMutation(getNotifyPreOrderEtaUpdateRecipientsMutationOptions(options));
    }

export const getReinstateExpiredPreOrderAllocationsUrl = (id: string,) => {




  return `/api/pre-orders/batches/${id}/allocations/reinstate-expired`
}

/**
 * Everyday Bullion scans expired allocations across every batch in its tenant; other tenants retain the existing batch-scoped recovery. Each sale, linked batch, reservation, and allocation is locked and rechecked. Recovery restores only unpaid, unissued, unfulfilled reservations whose allocations are wholly eligible and whose batch capacity remains available. Existing sales, sale lines, payment history, invoices, fulfilment, stock, inventory, and cost records are unchanged. Skipped allocations include exclusive reason counts and safe batch/allocation references for operator review, with no customer, invoice, or payment details.
 * @summary Reinstate eligible expired allocations for review
 */
export const reinstateExpiredPreOrderAllocations = async (id: string, options?: RequestInit): Promise<PreOrderReinstateExpiredResponse> => {

  return customFetch<PreOrderReinstateExpiredResponse>(getReinstateExpiredPreOrderAllocationsUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getReinstateExpiredPreOrderAllocationsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reinstateExpiredPreOrderAllocations>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reinstateExpiredPreOrderAllocations>>, TError,{id: string}, TContext> => {

const mutationKey = ['reinstateExpiredPreOrderAllocations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reinstateExpiredPreOrderAllocations>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  reinstateExpiredPreOrderAllocations(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReinstateExpiredPreOrderAllocationsMutationResult = NonNullable<Awaited<ReturnType<typeof reinstateExpiredPreOrderAllocations>>>

    export type ReinstateExpiredPreOrderAllocationsMutationError = ErrorType<void>

    /**
 * @summary Reinstate eligible expired allocations for review
 */
export const useReinstateExpiredPreOrderAllocations = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reinstateExpiredPreOrderAllocations>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reinstateExpiredPreOrderAllocations>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getReinstateExpiredPreOrderAllocationsMutationOptions(options));
    }

export const getExpireManualPreOrderReservationUrl = (id: string,
    allocationId: string,) => {




  return `/api/pre-orders/batches/${id}/allocations/${allocationId}/expire`
}

/**
 * Only available for batches configured for manual-only expiry. Locks the sale first, rechecks all linked allocations, payment, invoice and fulfilment state, then expires eligible allocations in this batch as one audited operation. Sale, invoice, payment, fulfilment and cost records are unchanged.
 * @summary Manually expire an overdue invoice-level reservation
 */
export const expireManualPreOrderReservation = async (id: string,
    allocationId: string, options?: RequestInit): Promise<PreOrderManualExpiryResponse> => {

  return customFetch<PreOrderManualExpiryResponse>(getExpireManualPreOrderReservationUrl(id,allocationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getExpireManualPreOrderReservationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof expireManualPreOrderReservation>>, TError,{id: string;allocationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof expireManualPreOrderReservation>>, TError,{id: string;allocationId: string}, TContext> => {

const mutationKey = ['expireManualPreOrderReservation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof expireManualPreOrderReservation>>, {id: string;allocationId: string}> = (props) => {
          const {id,allocationId} = props ?? {};

          return  expireManualPreOrderReservation(id,allocationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExpireManualPreOrderReservationMutationResult = NonNullable<Awaited<ReturnType<typeof expireManualPreOrderReservation>>>

    export type ExpireManualPreOrderReservationMutationError = ErrorType<void>

    /**
 * @summary Manually expire an overdue invoice-level reservation
 */
export const useExpireManualPreOrderReservation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof expireManualPreOrderReservation>>, TError,{id: string;allocationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof expireManualPreOrderReservation>>,
        TError,
        {id: string;allocationId: string},
        TContext
      > => {
      return useMutation(getExpireManualPreOrderReservationMutationOptions(options));
    }

export const getBulkConvertPreOrderAllocationsUrl = (id: string,) => {




  return `/api/pre-orders/batches/${id}/allocations/bulk-convert`
}

/**
 * @summary Confirm every reserved pre-order sale on a batch in one action
 */
export const bulkConvertPreOrderAllocations = async (id: string, options?: RequestInit): Promise<PreOrderBulkConvertResponse> => {

  return customFetch<PreOrderBulkConvertResponse>(getBulkConvertPreOrderAllocationsUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getBulkConvertPreOrderAllocationsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkConvertPreOrderAllocations>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkConvertPreOrderAllocations>>, TError,{id: string}, TContext> => {

const mutationKey = ['bulkConvertPreOrderAllocations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkConvertPreOrderAllocations>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  bulkConvertPreOrderAllocations(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkConvertPreOrderAllocationsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkConvertPreOrderAllocations>>>

    export type BulkConvertPreOrderAllocationsMutationError = ErrorType<void>

    /**
 * @summary Confirm every reserved pre-order sale on a batch in one action
 */
export const useBulkConvertPreOrderAllocations = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkConvertPreOrderAllocations>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkConvertPreOrderAllocations>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getBulkConvertPreOrderAllocationsMutationOptions(options));
    }

export const getCancelPreOrderAllocationUrl = (allocationId: string,) => {




  return `/api/pre-orders/allocations/${allocationId}/cancel`
}

/**
 * @summary Cancel an active allocation (releases its reserved capacity)
 */
export const cancelPreOrderAllocation = async (allocationId: string, options?: RequestInit): Promise<PreOrderAllocationStatusResponse> => {

  return customFetch<PreOrderAllocationStatusResponse>(getCancelPreOrderAllocationUrl(allocationId),
  {
    ...options,
    method: 'PATCH'


  }
);}





export const getCancelPreOrderAllocationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelPreOrderAllocation>>, TError,{allocationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelPreOrderAllocation>>, TError,{allocationId: string}, TContext> => {

const mutationKey = ['cancelPreOrderAllocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelPreOrderAllocation>>, {allocationId: string}> = (props) => {
          const {allocationId} = props ?? {};

          return  cancelPreOrderAllocation(allocationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelPreOrderAllocationMutationResult = NonNullable<Awaited<ReturnType<typeof cancelPreOrderAllocation>>>

    export type CancelPreOrderAllocationMutationError = ErrorType<void>

    /**
 * @summary Cancel an active allocation (releases its reserved capacity)
 */
export const useCancelPreOrderAllocation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelPreOrderAllocation>>, TError,{allocationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelPreOrderAllocation>>,
        TError,
        {allocationId: string},
        TContext
      > => {
      return useMutation(getCancelPreOrderAllocationMutationOptions(options));
    }

export const getConvertPreOrderAllocationUrl = (allocationId: string,) => {




  return `/api/pre-orders/allocations/${allocationId}/convert`
}

/**
 * @summary Confirm the reserved pre-order sale for an allocation
 */
export const convertPreOrderAllocation = async (allocationId: string, options?: RequestInit): Promise<PreOrderConvertResponse> => {

  return customFetch<PreOrderConvertResponse>(getConvertPreOrderAllocationUrl(allocationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getConvertPreOrderAllocationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof convertPreOrderAllocation>>, TError,{allocationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof convertPreOrderAllocation>>, TError,{allocationId: string}, TContext> => {

const mutationKey = ['convertPreOrderAllocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof convertPreOrderAllocation>>, {allocationId: string}> = (props) => {
          const {allocationId} = props ?? {};

          return  convertPreOrderAllocation(allocationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConvertPreOrderAllocationMutationResult = NonNullable<Awaited<ReturnType<typeof convertPreOrderAllocation>>>

    export type ConvertPreOrderAllocationMutationError = ErrorType<void>

    /**
 * @summary Confirm the reserved pre-order sale for an allocation
 */
export const useConvertPreOrderAllocation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof convertPreOrderAllocation>>, TError,{allocationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof convertPreOrderAllocation>>,
        TError,
        {allocationId: string},
        TContext
      > => {
      return useMutation(getConvertPreOrderAllocationMutationOptions(options));
    }

export const getConvertAndPayPreOrderAllocationUrl = (allocationId: string,) => {




  return `/api/pre-orders/allocations/${allocationId}/convert-and-pay`
}

/**
 * One-tap "Mark as Paid" for a pre-order allocation. In a single transaction: confirms every active allocation on the sale (Reserved → Sold, same as /convert) and records the full remaining balance through the payment ledger so the order becomes Paid. Idempotent. Requires both pre_orders.manage and sales.payment.mark_paid.
 * @summary Confirm the reserved pre-order sale AND mark it paid in full, atomically
 */
export const convertAndPayPreOrderAllocation = async (allocationId: string,
    paidSaleFulfilmentInput?: PaidSaleFulfilmentInput, options?: RequestInit): Promise<PreOrderConvertAndPayResponse> => {

  return customFetch<PreOrderConvertAndPayResponse>(getConvertAndPayPreOrderAllocationUrl(allocationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(paidSaleFulfilmentInput)
  }
);}





export const getConvertAndPayPreOrderAllocationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof convertAndPayPreOrderAllocation>>, TError,{allocationId: string;data?: BodyType<PaidSaleFulfilmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof convertAndPayPreOrderAllocation>>, TError,{allocationId: string;data?: BodyType<PaidSaleFulfilmentInput>}, TContext> => {

const mutationKey = ['convertAndPayPreOrderAllocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof convertAndPayPreOrderAllocation>>, {allocationId: string;data?: BodyType<PaidSaleFulfilmentInput>}> = (props) => {
          const {allocationId,data} = props ?? {};

          return  convertAndPayPreOrderAllocation(allocationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConvertAndPayPreOrderAllocationMutationResult = NonNullable<Awaited<ReturnType<typeof convertAndPayPreOrderAllocation>>>
    export type ConvertAndPayPreOrderAllocationMutationBody = BodyType<PaidSaleFulfilmentInput> | undefined
    export type ConvertAndPayPreOrderAllocationMutationError = ErrorType<void>

    /**
 * @summary Confirm the reserved pre-order sale AND mark it paid in full, atomically
 */
export const useConvertAndPayPreOrderAllocation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof convertAndPayPreOrderAllocation>>, TError,{allocationId: string;data?: BodyType<PaidSaleFulfilmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof convertAndPayPreOrderAllocation>>,
        TError,
        {allocationId: string;data?: BodyType<PaidSaleFulfilmentInput>},
        TContext
      > => {
      return useMutation(getConvertAndPayPreOrderAllocationMutationOptions(options));
    }

export const getLockPreOrderBatchPriceUrl = (id: string,) => {




  return `/api/pre-orders/batches/${id}/lock-price`
}

/**
 * Records the locked customer selling spot (GBP/ozt) and, optionally, the supplier spot + FX rate or an exact GBP purchase unit price, plus a timestamp and note. Transactionally and idempotently resolves every still-pending spot-linked allocation from its own formula snapshot, storing the resolved per-line price and updating the sale's balance due. Already-invoiced/paid allocations are never repriced. Creates no stock, COGS, revenue, or accounting entries. Requires pre_orders.manage.
 * @summary Lock the market price for a batch's spot-linked pre-orders
 */
export const lockPreOrderBatchPrice = async (id: string,
    preOrderLockPriceInput: PreOrderLockPriceInput, options?: RequestInit): Promise<PreOrderLockPriceResponse> => {

  return customFetch<PreOrderLockPriceResponse>(getLockPreOrderBatchPriceUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(preOrderLockPriceInput)
  }
);}





export const getLockPreOrderBatchPriceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lockPreOrderBatchPrice>>, TError,{id: string;data: BodyType<PreOrderLockPriceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof lockPreOrderBatchPrice>>, TError,{id: string;data: BodyType<PreOrderLockPriceInput>}, TContext> => {

const mutationKey = ['lockPreOrderBatchPrice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lockPreOrderBatchPrice>>, {id: string;data: BodyType<PreOrderLockPriceInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  lockPreOrderBatchPrice(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LockPreOrderBatchPriceMutationResult = NonNullable<Awaited<ReturnType<typeof lockPreOrderBatchPrice>>>
    export type LockPreOrderBatchPriceMutationBody = BodyType<PreOrderLockPriceInput>
    export type LockPreOrderBatchPriceMutationError = ErrorType<void>

    /**
 * @summary Lock the market price for a batch's spot-linked pre-orders
 */
export const useLockPreOrderBatchPrice = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lockPreOrderBatchPrice>>, TError,{id: string;data: BodyType<PreOrderLockPriceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof lockPreOrderBatchPrice>>,
        TError,
        {id: string;data: BodyType<PreOrderLockPriceInput>},
        TContext
      > => {
      return useMutation(getLockPreOrderBatchPriceMutationOptions(options));
    }

export const getReleasePreOrderBatchPaymentsUrl = (id: string,) => {




  return `/api/pre-orders/batches/${id}/release-payments`
}

/**
 * Blocked until the batch's spot-linked selling price is locked. Confirms every reserved sale on the batch and issues a real payable invoice for each confirmed sale via the existing invoice-generation flow, with the full resolved balance due (no deposit). Price lock and payment release stay separate persisted events. Requires pre_orders.manage.
 * @summary Supplier dispatched — issue payable invoices for resolved allocations
 */
export const releasePreOrderBatchPayments = async (id: string, options?: RequestInit): Promise<PreOrderBulkConvertResponse> => {

  return customFetch<PreOrderBulkConvertResponse>(getReleasePreOrderBatchPaymentsUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getReleasePreOrderBatchPaymentsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof releasePreOrderBatchPayments>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof releasePreOrderBatchPayments>>, TError,{id: string}, TContext> => {

const mutationKey = ['releasePreOrderBatchPayments'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof releasePreOrderBatchPayments>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  releasePreOrderBatchPayments(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReleasePreOrderBatchPaymentsMutationResult = NonNullable<Awaited<ReturnType<typeof releasePreOrderBatchPayments>>>

    export type ReleasePreOrderBatchPaymentsMutationError = ErrorType<void>

    /**
 * @summary Supplier dispatched — issue payable invoices for resolved allocations
 */
export const useReleasePreOrderBatchPayments = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof releasePreOrderBatchPayments>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof releasePreOrderBatchPayments>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getReleasePreOrderBatchPaymentsMutationOptions(options));
    }

export const getListExceptionsUrl = (params?: ListExceptionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/exceptions?${stringifiedParams}` : `/api/exceptions`
}

/**
 * @summary List exceptions with filters + active severity counts
 */
export const listExceptions = async (params?: ListExceptionsParams, options?: RequestInit): Promise<ExceptionListResponse> => {

  return customFetch<ExceptionListResponse>(getListExceptionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListExceptionsQueryKey = (params?: ListExceptionsParams,) => {
    return [
    `/api/exceptions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListExceptionsQueryOptions = <TData = Awaited<ReturnType<typeof listExceptions>>, TError = ErrorType<unknown>>(params?: ListExceptionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listExceptions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExceptionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExceptions>>> = ({ signal }) => listExceptions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listExceptions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListExceptionsQueryResult = NonNullable<Awaited<ReturnType<typeof listExceptions>>>
export type ListExceptionsQueryError = ErrorType<unknown>


/**
 * @summary List exceptions with filters + active severity counts
 */

export function useListExceptions<TData = Awaited<ReturnType<typeof listExceptions>>, TError = ErrorType<unknown>>(
 params?: ListExceptionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listExceptions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListExceptionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListExceptionRulesUrl = () => {




  return `/api/exceptions/rules`
}

/**
 * @summary List exception rules
 */
export const listExceptionRules = async ( options?: RequestInit): Promise<ExceptionRuleListResponse> => {

  return customFetch<ExceptionRuleListResponse>(getListExceptionRulesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListExceptionRulesQueryKey = () => {
    return [
    `/api/exceptions/rules`
    ] as const;
    }


export const getListExceptionRulesQueryOptions = <TData = Awaited<ReturnType<typeof listExceptionRules>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listExceptionRules>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExceptionRulesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExceptionRules>>> = ({ signal }) => listExceptionRules({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listExceptionRules>>, TError, TData> & { queryKey: QueryKey }
}

export type ListExceptionRulesQueryResult = NonNullable<Awaited<ReturnType<typeof listExceptionRules>>>
export type ListExceptionRulesQueryError = ErrorType<unknown>


/**
 * @summary List exception rules
 */

export function useListExceptionRules<TData = Awaited<ReturnType<typeof listExceptionRules>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listExceptionRules>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListExceptionRulesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateExceptionRuleUrl = () => {




  return `/api/exceptions/rules`
}

/**
 * @summary Create an exception rule
 */
export const createExceptionRule = async (exceptionRuleInput: ExceptionRuleInput, options?: RequestInit): Promise<ExceptionRuleResponse> => {

  return customFetch<ExceptionRuleResponse>(getCreateExceptionRuleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(exceptionRuleInput)
  }
);}





export const getCreateExceptionRuleMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExceptionRule>>, TError,{data: BodyType<ExceptionRuleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createExceptionRule>>, TError,{data: BodyType<ExceptionRuleInput>}, TContext> => {

const mutationKey = ['createExceptionRule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createExceptionRule>>, {data: BodyType<ExceptionRuleInput>}> = (props) => {
          const {data} = props ?? {};

          return  createExceptionRule(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateExceptionRuleMutationResult = NonNullable<Awaited<ReturnType<typeof createExceptionRule>>>
    export type CreateExceptionRuleMutationBody = BodyType<ExceptionRuleInput>
    export type CreateExceptionRuleMutationError = ErrorType<void>

    /**
 * @summary Create an exception rule
 */
export const useCreateExceptionRule = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExceptionRule>>, TError,{data: BodyType<ExceptionRuleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createExceptionRule>>,
        TError,
        {data: BodyType<ExceptionRuleInput>},
        TContext
      > => {
      return useMutation(getCreateExceptionRuleMutationOptions(options));
    }

export const getTestExceptionRuleUrl = () => {




  return `/api/exceptions/rules/test`
}

/**
 * @summary Dry-run a rule against the tenant's current active exceptions
 */
export const testExceptionRule = async (exceptionRuleInput: ExceptionRuleInput, options?: RequestInit): Promise<ExceptionRuleTestResponse> => {

  return customFetch<ExceptionRuleTestResponse>(getTestExceptionRuleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(exceptionRuleInput)
  }
);}





export const getTestExceptionRuleMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testExceptionRule>>, TError,{data: BodyType<ExceptionRuleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testExceptionRule>>, TError,{data: BodyType<ExceptionRuleInput>}, TContext> => {

const mutationKey = ['testExceptionRule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testExceptionRule>>, {data: BodyType<ExceptionRuleInput>}> = (props) => {
          const {data} = props ?? {};

          return  testExceptionRule(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestExceptionRuleMutationResult = NonNullable<Awaited<ReturnType<typeof testExceptionRule>>>
    export type TestExceptionRuleMutationBody = BodyType<ExceptionRuleInput>
    export type TestExceptionRuleMutationError = ErrorType<void>

    /**
 * @summary Dry-run a rule against the tenant's current active exceptions
 */
export const useTestExceptionRule = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testExceptionRule>>, TError,{data: BodyType<ExceptionRuleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof testExceptionRule>>,
        TError,
        {data: BodyType<ExceptionRuleInput>},
        TContext
      > => {
      return useMutation(getTestExceptionRuleMutationOptions(options));
    }

export const getUpdateExceptionRuleUrl = (id: string,) => {




  return `/api/exceptions/rules/${id}`
}

/**
 * @summary Update an exception rule
 */
export const updateExceptionRule = async (id: string,
    exceptionRuleInput: ExceptionRuleInput, options?: RequestInit): Promise<ExceptionRuleResponse> => {

  return customFetch<ExceptionRuleResponse>(getUpdateExceptionRuleUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(exceptionRuleInput)
  }
);}





export const getUpdateExceptionRuleMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateExceptionRule>>, TError,{id: string;data: BodyType<ExceptionRuleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateExceptionRule>>, TError,{id: string;data: BodyType<ExceptionRuleInput>}, TContext> => {

const mutationKey = ['updateExceptionRule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateExceptionRule>>, {id: string;data: BodyType<ExceptionRuleInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateExceptionRule(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateExceptionRuleMutationResult = NonNullable<Awaited<ReturnType<typeof updateExceptionRule>>>
    export type UpdateExceptionRuleMutationBody = BodyType<ExceptionRuleInput>
    export type UpdateExceptionRuleMutationError = ErrorType<void>

    /**
 * @summary Update an exception rule
 */
export const useUpdateExceptionRule = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateExceptionRule>>, TError,{id: string;data: BodyType<ExceptionRuleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateExceptionRule>>,
        TError,
        {id: string;data: BodyType<ExceptionRuleInput>},
        TContext
      > => {
      return useMutation(getUpdateExceptionRuleMutationOptions(options));
    }

export const getDeleteExceptionRuleUrl = (id: string,) => {




  return `/api/exceptions/rules/${id}`
}

/**
 * @summary Delete an exception rule
 */
export const deleteExceptionRule = async (id: string, options?: RequestInit): Promise<DeleteExceptionRule200> => {

  return customFetch<DeleteExceptionRule200>(getDeleteExceptionRuleUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteExceptionRuleMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteExceptionRule>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteExceptionRule>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteExceptionRule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteExceptionRule>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteExceptionRule(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteExceptionRuleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteExceptionRule>>>

    export type DeleteExceptionRuleMutationError = ErrorType<void>

    /**
 * @summary Delete an exception rule
 */
export const useDeleteExceptionRule = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteExceptionRule>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteExceptionRule>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteExceptionRuleMutationOptions(options));
    }

export const getGetExceptionUrl = (id: string,) => {




  return `/api/exceptions/${id}`
}

/**
 * @summary Exception detail with recent occurrences
 */
export const getException = async (id: string, options?: RequestInit): Promise<ExceptionDetailResponse> => {

  return customFetch<ExceptionDetailResponse>(getGetExceptionUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetExceptionQueryKey = (id: string,) => {
    return [
    `/api/exceptions/${id}`
    ] as const;
    }


export const getGetExceptionQueryOptions = <TData = Awaited<ReturnType<typeof getException>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getException>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExceptionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getException>>> = ({ signal }) => getException(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getException>>, TError, TData> & { queryKey: QueryKey }
}

export type GetExceptionQueryResult = NonNullable<Awaited<ReturnType<typeof getException>>>
export type GetExceptionQueryError = ErrorType<void>


/**
 * @summary Exception detail with recent occurrences
 */

export function useGetException<TData = Awaited<ReturnType<typeof getException>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getException>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetExceptionQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getApplyExceptionActionUrl = (id: string,) => {




  return `/api/exceptions/${id}/actions`
}

/**
 * @summary Apply a workflow action (assign/acknowledge/resolve/dismiss/snooze/waiting/reopen)
 */
export const applyExceptionAction = async (id: string,
    exceptionActionInput: ExceptionActionInput, options?: RequestInit): Promise<ExceptionResponse> => {

  return customFetch<ExceptionResponse>(getApplyExceptionActionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(exceptionActionInput)
  }
);}





export const getApplyExceptionActionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyExceptionAction>>, TError,{id: string;data: BodyType<ExceptionActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof applyExceptionAction>>, TError,{id: string;data: BodyType<ExceptionActionInput>}, TContext> => {

const mutationKey = ['applyExceptionAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof applyExceptionAction>>, {id: string;data: BodyType<ExceptionActionInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  applyExceptionAction(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApplyExceptionActionMutationResult = NonNullable<Awaited<ReturnType<typeof applyExceptionAction>>>
    export type ApplyExceptionActionMutationBody = BodyType<ExceptionActionInput>
    export type ApplyExceptionActionMutationError = ErrorType<void>

    /**
 * @summary Apply a workflow action (assign/acknowledge/resolve/dismiss/snooze/waiting/reopen)
 */
export const useApplyExceptionAction = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyExceptionAction>>, TError,{id: string;data: BodyType<ExceptionActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof applyExceptionAction>>,
        TError,
        {id: string;data: BodyType<ExceptionActionInput>},
        TContext
      > => {
      return useMutation(getApplyExceptionActionMutationOptions(options));
    }

export const getReconcilePurchaseOrderReadModelUrl = () => {




  return `/api/purchase-orders/reconciliation`
}

/**
 * @summary Compare authoritative purchase-order facts with prepared workflow rows
 */
export const reconcilePurchaseOrderReadModel = async ( options?: RequestInit): Promise<PurchaseOrderReconciliationReport> => {

  return customFetch<PurchaseOrderReconciliationReport>(getReconcilePurchaseOrderReadModelUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReconcilePurchaseOrderReadModelQueryKey = () => {
    return [
    `/api/purchase-orders/reconciliation`
    ] as const;
    }


export const getReconcilePurchaseOrderReadModelQueryOptions = <TData = Awaited<ReturnType<typeof reconcilePurchaseOrderReadModel>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof reconcilePurchaseOrderReadModel>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReconcilePurchaseOrderReadModelQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reconcilePurchaseOrderReadModel>>> = ({ signal }) => reconcilePurchaseOrderReadModel({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reconcilePurchaseOrderReadModel>>, TError, TData> & { queryKey: QueryKey }
}

export type ReconcilePurchaseOrderReadModelQueryResult = NonNullable<Awaited<ReturnType<typeof reconcilePurchaseOrderReadModel>>>
export type ReconcilePurchaseOrderReadModelQueryError = ErrorType<void>


/**
 * @summary Compare authoritative purchase-order facts with prepared workflow rows
 */

export function useReconcilePurchaseOrderReadModel<TData = Awaited<ReturnType<typeof reconcilePurchaseOrderReadModel>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof reconcilePurchaseOrderReadModel>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getReconcilePurchaseOrderReadModelQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRepairPurchaseOrderReadModelUrl = () => {




  return `/api/purchase-orders/reconciliation/repair`
}

/**
 * @summary Rebuild disposable purchase-order workflow summaries
 */
export const repairPurchaseOrderReadModel = async (repairPurchaseOrderReadModelBody?: RepairPurchaseOrderReadModelBody, options?: RequestInit): Promise<RepairPurchaseOrderReadModel200> => {

  return customFetch<RepairPurchaseOrderReadModel200>(getRepairPurchaseOrderReadModelUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(repairPurchaseOrderReadModelBody)
  }
);}





export const getRepairPurchaseOrderReadModelMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof repairPurchaseOrderReadModel>>, TError,{data?: BodyType<RepairPurchaseOrderReadModelBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof repairPurchaseOrderReadModel>>, TError,{data?: BodyType<RepairPurchaseOrderReadModelBody>}, TContext> => {

const mutationKey = ['repairPurchaseOrderReadModel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof repairPurchaseOrderReadModel>>, {data?: BodyType<RepairPurchaseOrderReadModelBody>}> = (props) => {
          const {data} = props ?? {};

          return  repairPurchaseOrderReadModel(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RepairPurchaseOrderReadModelMutationResult = NonNullable<Awaited<ReturnType<typeof repairPurchaseOrderReadModel>>>
    export type RepairPurchaseOrderReadModelMutationBody = BodyType<RepairPurchaseOrderReadModelBody> | undefined
    export type RepairPurchaseOrderReadModelMutationError = ErrorType<void>

    /**
 * @summary Rebuild disposable purchase-order workflow summaries
 */
export const useRepairPurchaseOrderReadModel = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof repairPurchaseOrderReadModel>>, TError,{data?: BodyType<RepairPurchaseOrderReadModelBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof repairPurchaseOrderReadModel>>,
        TError,
        {data?: BodyType<RepairPurchaseOrderReadModelBody>},
        TContext
      > => {
      return useMutation(getRepairPurchaseOrderReadModelMutationOptions(options));
    }

export const getRetryPurchaseOrderOverviewUrl = () => {




  return `/api/purchase-orders/overview`
}

/**
 * Resets only failed read-model queue state for the current tenant and
 * starts one new bounded repair window. Authoritative purchase-order,
 * payment, receipt, inventory, and finance rows are not modified.
 * @summary Retry an exhausted disposable purchase-order overview repair
 */
export const retryPurchaseOrderOverview = async ( options?: RequestInit): Promise<RetryPurchaseOrderOverview200> => {

  return customFetch<RetryPurchaseOrderOverview200>(getRetryPurchaseOrderOverviewUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRetryPurchaseOrderOverviewMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryPurchaseOrderOverview>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof retryPurchaseOrderOverview>>, TError,void, TContext> => {

const mutationKey = ['retryPurchaseOrderOverview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryPurchaseOrderOverview>>, void> = () => {


          return  retryPurchaseOrderOverview(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryPurchaseOrderOverviewMutationResult = NonNullable<Awaited<ReturnType<typeof retryPurchaseOrderOverview>>>

    export type RetryPurchaseOrderOverviewMutationError = ErrorType<void>

    /**
 * @summary Retry an exhausted disposable purchase-order overview repair
 */
export const useRetryPurchaseOrderOverview = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryPurchaseOrderOverview>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof retryPurchaseOrderOverview>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRetryPurchaseOrderOverviewMutationOptions(options));
    }

export const getGetPurchaseOrderOverviewUrl = (params?: GetPurchaseOrderOverviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/purchase-orders/overview?${stringifiedParams}` : `/api/purchase-orders/overview`
}

/**
 * @summary Cursor-paginated compact purchase-order overview
 */
export const getPurchaseOrderOverview = async (params?: GetPurchaseOrderOverviewParams, options?: RequestInit): Promise<PurchaseOrderOverview> => {

  return customFetch<PurchaseOrderOverview>(getGetPurchaseOrderOverviewUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPurchaseOrderOverviewQueryKey = (params?: GetPurchaseOrderOverviewParams,) => {
    return [
    `/api/purchase-orders/overview`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPurchaseOrderOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getPurchaseOrderOverview>>, TError = ErrorType<void>>(params?: GetPurchaseOrderOverviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPurchaseOrderOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPurchaseOrderOverviewQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPurchaseOrderOverview>>> = ({ signal }) => getPurchaseOrderOverview(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPurchaseOrderOverview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPurchaseOrderOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getPurchaseOrderOverview>>>
export type GetPurchaseOrderOverviewQueryError = ErrorType<void>


/**
 * @summary Cursor-paginated compact purchase-order overview
 */

export function useGetPurchaseOrderOverview<TData = Awaited<ReturnType<typeof getPurchaseOrderOverview>>, TError = ErrorType<void>>(
 params?: GetPurchaseOrderOverviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPurchaseOrderOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPurchaseOrderOverviewQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPurchaseOrderSavedViewsUrl = () => {




  return `/api/purchase-orders/saved-views`
}

/**
 * @summary List the current operator's and tenant-shared Purchase Order views
 */
export const listPurchaseOrderSavedViews = async ( options?: RequestInit): Promise<PurchaseOrderSavedViewList> => {

  return customFetch<PurchaseOrderSavedViewList>(getListPurchaseOrderSavedViewsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPurchaseOrderSavedViewsQueryKey = () => {
    return [
    `/api/purchase-orders/saved-views`
    ] as const;
    }


export const getListPurchaseOrderSavedViewsQueryOptions = <TData = Awaited<ReturnType<typeof listPurchaseOrderSavedViews>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchaseOrderSavedViews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPurchaseOrderSavedViewsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPurchaseOrderSavedViews>>> = ({ signal }) => listPurchaseOrderSavedViews({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPurchaseOrderSavedViews>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPurchaseOrderSavedViewsQueryResult = NonNullable<Awaited<ReturnType<typeof listPurchaseOrderSavedViews>>>
export type ListPurchaseOrderSavedViewsQueryError = ErrorType<unknown>


/**
 * @summary List the current operator's and tenant-shared Purchase Order views
 */

export function useListPurchaseOrderSavedViews<TData = Awaited<ReturnType<typeof listPurchaseOrderSavedViews>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchaseOrderSavedViews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPurchaseOrderSavedViewsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreatePurchaseOrderSavedViewUrl = () => {




  return `/api/purchase-orders/saved-views`
}

/**
 * @summary Save a named Purchase Order view
 */
export const createPurchaseOrderSavedView = async (purchaseOrderSavedViewInput: PurchaseOrderSavedViewInput, options?: RequestInit): Promise<PurchaseOrderSavedView> => {

  return customFetch<PurchaseOrderSavedView>(getCreatePurchaseOrderSavedViewUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(purchaseOrderSavedViewInput)
  }
);}





export const getCreatePurchaseOrderSavedViewMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPurchaseOrderSavedView>>, TError,{data: BodyType<PurchaseOrderSavedViewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPurchaseOrderSavedView>>, TError,{data: BodyType<PurchaseOrderSavedViewInput>}, TContext> => {

const mutationKey = ['createPurchaseOrderSavedView'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPurchaseOrderSavedView>>, {data: BodyType<PurchaseOrderSavedViewInput>}> = (props) => {
          const {data} = props ?? {};

          return  createPurchaseOrderSavedView(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePurchaseOrderSavedViewMutationResult = NonNullable<Awaited<ReturnType<typeof createPurchaseOrderSavedView>>>
    export type CreatePurchaseOrderSavedViewMutationBody = BodyType<PurchaseOrderSavedViewInput>
    export type CreatePurchaseOrderSavedViewMutationError = ErrorType<void>

    /**
 * @summary Save a named Purchase Order view
 */
export const useCreatePurchaseOrderSavedView = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPurchaseOrderSavedView>>, TError,{data: BodyType<PurchaseOrderSavedViewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPurchaseOrderSavedView>>,
        TError,
        {data: BodyType<PurchaseOrderSavedViewInput>},
        TContext
      > => {
      return useMutation(getCreatePurchaseOrderSavedViewMutationOptions(options));
    }

export const getUpdatePurchaseOrderSavedViewUrl = (id: string,) => {




  return `/api/purchase-orders/saved-views/${id}`
}

/**
 * @summary Update the current operator's Purchase Order view
 */
export const updatePurchaseOrderSavedView = async (id: string,
    purchaseOrderSavedViewUpdate: PurchaseOrderSavedViewUpdate, options?: RequestInit): Promise<PurchaseOrderSavedView> => {

  return customFetch<PurchaseOrderSavedView>(getUpdatePurchaseOrderSavedViewUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(purchaseOrderSavedViewUpdate)
  }
);}





export const getUpdatePurchaseOrderSavedViewMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePurchaseOrderSavedView>>, TError,{id: string;data: BodyType<PurchaseOrderSavedViewUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePurchaseOrderSavedView>>, TError,{id: string;data: BodyType<PurchaseOrderSavedViewUpdate>}, TContext> => {

const mutationKey = ['updatePurchaseOrderSavedView'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePurchaseOrderSavedView>>, {id: string;data: BodyType<PurchaseOrderSavedViewUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePurchaseOrderSavedView(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePurchaseOrderSavedViewMutationResult = NonNullable<Awaited<ReturnType<typeof updatePurchaseOrderSavedView>>>
    export type UpdatePurchaseOrderSavedViewMutationBody = BodyType<PurchaseOrderSavedViewUpdate>
    export type UpdatePurchaseOrderSavedViewMutationError = ErrorType<void>

    /**
 * @summary Update the current operator's Purchase Order view
 */
export const useUpdatePurchaseOrderSavedView = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePurchaseOrderSavedView>>, TError,{id: string;data: BodyType<PurchaseOrderSavedViewUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePurchaseOrderSavedView>>,
        TError,
        {id: string;data: BodyType<PurchaseOrderSavedViewUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePurchaseOrderSavedViewMutationOptions(options));
    }

export const getDeletePurchaseOrderSavedViewUrl = (id: string,) => {




  return `/api/purchase-orders/saved-views/${id}`
}

/**
 * @summary Delete the current operator's Purchase Order view
 */
export const deletePurchaseOrderSavedView = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeletePurchaseOrderSavedViewUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeletePurchaseOrderSavedViewMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePurchaseOrderSavedView>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePurchaseOrderSavedView>>, TError,{id: string}, TContext> => {

const mutationKey = ['deletePurchaseOrderSavedView'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePurchaseOrderSavedView>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deletePurchaseOrderSavedView(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePurchaseOrderSavedViewMutationResult = NonNullable<Awaited<ReturnType<typeof deletePurchaseOrderSavedView>>>

    export type DeletePurchaseOrderSavedViewMutationError = ErrorType<void>

    /**
 * @summary Delete the current operator's Purchase Order view
 */
export const useDeletePurchaseOrderSavedView = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePurchaseOrderSavedView>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePurchaseOrderSavedView>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeletePurchaseOrderSavedViewMutationOptions(options));
    }

export const getGetPurchaseOrderQuickSummaryUrl = (id: string,) => {




  return `/api/purchase-orders/${id}/overview/quick-summary`
}

export const getPurchaseOrderQuickSummary = async (id: string, options?: RequestInit): Promise<PurchaseOrderQuickSummary> => {

  return customFetch<PurchaseOrderQuickSummary>(getGetPurchaseOrderQuickSummaryUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPurchaseOrderQuickSummaryQueryKey = (id: string,) => {
    return [
    `/api/purchase-orders/${id}/overview/quick-summary`
    ] as const;
    }


export const getGetPurchaseOrderQuickSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getPurchaseOrderQuickSummary>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPurchaseOrderQuickSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPurchaseOrderQuickSummaryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPurchaseOrderQuickSummary>>> = ({ signal }) => getPurchaseOrderQuickSummary(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPurchaseOrderQuickSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPurchaseOrderQuickSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getPurchaseOrderQuickSummary>>>
export type GetPurchaseOrderQuickSummaryQueryError = ErrorType<void>



export function useGetPurchaseOrderQuickSummary<TData = Awaited<ReturnType<typeof getPurchaseOrderQuickSummary>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPurchaseOrderQuickSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPurchaseOrderQuickSummaryQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPurchaseOrderOverviewInvoicesUrl = (id: string,
    params?: ListPurchaseOrderOverviewInvoicesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/purchase-orders/${id}/overview/invoices?${stringifiedParams}` : `/api/purchase-orders/${id}/overview/invoices`
}

export const listPurchaseOrderOverviewInvoices = async (id: string,
    params?: ListPurchaseOrderOverviewInvoicesParams, options?: RequestInit): Promise<PurchaseOrderInvoiceSection> => {

  return customFetch<PurchaseOrderInvoiceSection>(getListPurchaseOrderOverviewInvoicesUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPurchaseOrderOverviewInvoicesQueryKey = (id: string,
    params?: ListPurchaseOrderOverviewInvoicesParams,) => {
    return [
    `/api/purchase-orders/${id}/overview/invoices`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPurchaseOrderOverviewInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof listPurchaseOrderOverviewInvoices>>, TError = ErrorType<unknown>>(id: string,
    params?: ListPurchaseOrderOverviewInvoicesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchaseOrderOverviewInvoices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPurchaseOrderOverviewInvoicesQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPurchaseOrderOverviewInvoices>>> = ({ signal }) => listPurchaseOrderOverviewInvoices(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPurchaseOrderOverviewInvoices>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPurchaseOrderOverviewInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof listPurchaseOrderOverviewInvoices>>>
export type ListPurchaseOrderOverviewInvoicesQueryError = ErrorType<unknown>



export function useListPurchaseOrderOverviewInvoices<TData = Awaited<ReturnType<typeof listPurchaseOrderOverviewInvoices>>, TError = ErrorType<unknown>>(
 id: string,
    params?: ListPurchaseOrderOverviewInvoicesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchaseOrderOverviewInvoices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPurchaseOrderOverviewInvoicesQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPurchaseOrderOverviewLinesUrl = (id: string,
    params?: ListPurchaseOrderOverviewLinesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/purchase-orders/${id}/overview/lines?${stringifiedParams}` : `/api/purchase-orders/${id}/overview/lines`
}

export const listPurchaseOrderOverviewLines = async (id: string,
    params?: ListPurchaseOrderOverviewLinesParams, options?: RequestInit): Promise<PurchaseOrderLineSection> => {

  return customFetch<PurchaseOrderLineSection>(getListPurchaseOrderOverviewLinesUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPurchaseOrderOverviewLinesQueryKey = (id: string,
    params?: ListPurchaseOrderOverviewLinesParams,) => {
    return [
    `/api/purchase-orders/${id}/overview/lines`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPurchaseOrderOverviewLinesQueryOptions = <TData = Awaited<ReturnType<typeof listPurchaseOrderOverviewLines>>, TError = ErrorType<unknown>>(id: string,
    params?: ListPurchaseOrderOverviewLinesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchaseOrderOverviewLines>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPurchaseOrderOverviewLinesQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPurchaseOrderOverviewLines>>> = ({ signal }) => listPurchaseOrderOverviewLines(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPurchaseOrderOverviewLines>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPurchaseOrderOverviewLinesQueryResult = NonNullable<Awaited<ReturnType<typeof listPurchaseOrderOverviewLines>>>
export type ListPurchaseOrderOverviewLinesQueryError = ErrorType<unknown>



export function useListPurchaseOrderOverviewLines<TData = Awaited<ReturnType<typeof listPurchaseOrderOverviewLines>>, TError = ErrorType<unknown>>(
 id: string,
    params?: ListPurchaseOrderOverviewLinesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchaseOrderOverviewLines>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPurchaseOrderOverviewLinesQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPurchaseOrderOverviewShippingUrl = (id: string,) => {




  return `/api/purchase-orders/${id}/overview/shipping`
}

export const getPurchaseOrderOverviewShipping = async (id: string, options?: RequestInit): Promise<PurchaseOrderShippingSection> => {

  return customFetch<PurchaseOrderShippingSection>(getGetPurchaseOrderOverviewShippingUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPurchaseOrderOverviewShippingQueryKey = (id: string,) => {
    return [
    `/api/purchase-orders/${id}/overview/shipping`
    ] as const;
    }


export const getGetPurchaseOrderOverviewShippingQueryOptions = <TData = Awaited<ReturnType<typeof getPurchaseOrderOverviewShipping>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPurchaseOrderOverviewShipping>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPurchaseOrderOverviewShippingQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPurchaseOrderOverviewShipping>>> = ({ signal }) => getPurchaseOrderOverviewShipping(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPurchaseOrderOverviewShipping>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPurchaseOrderOverviewShippingQueryResult = NonNullable<Awaited<ReturnType<typeof getPurchaseOrderOverviewShipping>>>
export type GetPurchaseOrderOverviewShippingQueryError = ErrorType<unknown>



export function useGetPurchaseOrderOverviewShipping<TData = Awaited<ReturnType<typeof getPurchaseOrderOverviewShipping>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPurchaseOrderOverviewShipping>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPurchaseOrderOverviewShippingQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPurchaseOrderOverviewNotesUrl = (id: string,
    params?: ListPurchaseOrderOverviewNotesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/purchase-orders/${id}/overview/notes?${stringifiedParams}` : `/api/purchase-orders/${id}/overview/notes`
}

export const listPurchaseOrderOverviewNotes = async (id: string,
    params?: ListPurchaseOrderOverviewNotesParams, options?: RequestInit): Promise<PurchaseOrderNoteSection> => {

  return customFetch<PurchaseOrderNoteSection>(getListPurchaseOrderOverviewNotesUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPurchaseOrderOverviewNotesQueryKey = (id: string,
    params?: ListPurchaseOrderOverviewNotesParams,) => {
    return [
    `/api/purchase-orders/${id}/overview/notes`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPurchaseOrderOverviewNotesQueryOptions = <TData = Awaited<ReturnType<typeof listPurchaseOrderOverviewNotes>>, TError = ErrorType<unknown>>(id: string,
    params?: ListPurchaseOrderOverviewNotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchaseOrderOverviewNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPurchaseOrderOverviewNotesQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPurchaseOrderOverviewNotes>>> = ({ signal }) => listPurchaseOrderOverviewNotes(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPurchaseOrderOverviewNotes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPurchaseOrderOverviewNotesQueryResult = NonNullable<Awaited<ReturnType<typeof listPurchaseOrderOverviewNotes>>>
export type ListPurchaseOrderOverviewNotesQueryError = ErrorType<unknown>



export function useListPurchaseOrderOverviewNotes<TData = Awaited<ReturnType<typeof listPurchaseOrderOverviewNotes>>, TError = ErrorType<unknown>>(
 id: string,
    params?: ListPurchaseOrderOverviewNotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchaseOrderOverviewNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPurchaseOrderOverviewNotesQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPurchaseOrderOverviewDocumentsUrl = (id: string,
    params?: ListPurchaseOrderOverviewDocumentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/purchase-orders/${id}/overview/documents?${stringifiedParams}` : `/api/purchase-orders/${id}/overview/documents`
}

export const listPurchaseOrderOverviewDocuments = async (id: string,
    params?: ListPurchaseOrderOverviewDocumentsParams, options?: RequestInit): Promise<PurchaseOrderDocumentSection> => {

  return customFetch<PurchaseOrderDocumentSection>(getListPurchaseOrderOverviewDocumentsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPurchaseOrderOverviewDocumentsQueryKey = (id: string,
    params?: ListPurchaseOrderOverviewDocumentsParams,) => {
    return [
    `/api/purchase-orders/${id}/overview/documents`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPurchaseOrderOverviewDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof listPurchaseOrderOverviewDocuments>>, TError = ErrorType<unknown>>(id: string,
    params?: ListPurchaseOrderOverviewDocumentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchaseOrderOverviewDocuments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPurchaseOrderOverviewDocumentsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPurchaseOrderOverviewDocuments>>> = ({ signal }) => listPurchaseOrderOverviewDocuments(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPurchaseOrderOverviewDocuments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPurchaseOrderOverviewDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listPurchaseOrderOverviewDocuments>>>
export type ListPurchaseOrderOverviewDocumentsQueryError = ErrorType<unknown>



export function useListPurchaseOrderOverviewDocuments<TData = Awaited<ReturnType<typeof listPurchaseOrderOverviewDocuments>>, TError = ErrorType<unknown>>(
 id: string,
    params?: ListPurchaseOrderOverviewDocumentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchaseOrderOverviewDocuments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPurchaseOrderOverviewDocumentsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPurchaseOrderOverviewProfitabilityUrl = (id: string,) => {




  return `/api/purchase-orders/${id}/overview/profitability`
}

export const getPurchaseOrderOverviewProfitability = async (id: string, options?: RequestInit): Promise<PurchaseOrderProfitability> => {

  return customFetch<PurchaseOrderProfitability>(getGetPurchaseOrderOverviewProfitabilityUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPurchaseOrderOverviewProfitabilityQueryKey = (id: string,) => {
    return [
    `/api/purchase-orders/${id}/overview/profitability`
    ] as const;
    }


export const getGetPurchaseOrderOverviewProfitabilityQueryOptions = <TData = Awaited<ReturnType<typeof getPurchaseOrderOverviewProfitability>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPurchaseOrderOverviewProfitability>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPurchaseOrderOverviewProfitabilityQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPurchaseOrderOverviewProfitability>>> = ({ signal }) => getPurchaseOrderOverviewProfitability(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPurchaseOrderOverviewProfitability>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPurchaseOrderOverviewProfitabilityQueryResult = NonNullable<Awaited<ReturnType<typeof getPurchaseOrderOverviewProfitability>>>
export type GetPurchaseOrderOverviewProfitabilityQueryError = ErrorType<unknown>



export function useGetPurchaseOrderOverviewProfitability<TData = Awaited<ReturnType<typeof getPurchaseOrderOverviewProfitability>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPurchaseOrderOverviewProfitability>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPurchaseOrderOverviewProfitabilityQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPurchaseOrderSupplierPerformanceUrl = (id: string,) => {




  return `/api/purchase-orders/${id}/overview/supplier-performance`
}

export const getPurchaseOrderSupplierPerformance = async (id: string, options?: RequestInit): Promise<PurchaseOrderSupplierPerformance> => {

  return customFetch<PurchaseOrderSupplierPerformance>(getGetPurchaseOrderSupplierPerformanceUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPurchaseOrderSupplierPerformanceQueryKey = (id: string,) => {
    return [
    `/api/purchase-orders/${id}/overview/supplier-performance`
    ] as const;
    }


export const getGetPurchaseOrderSupplierPerformanceQueryOptions = <TData = Awaited<ReturnType<typeof getPurchaseOrderSupplierPerformance>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPurchaseOrderSupplierPerformance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPurchaseOrderSupplierPerformanceQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPurchaseOrderSupplierPerformance>>> = ({ signal }) => getPurchaseOrderSupplierPerformance(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPurchaseOrderSupplierPerformance>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPurchaseOrderSupplierPerformanceQueryResult = NonNullable<Awaited<ReturnType<typeof getPurchaseOrderSupplierPerformance>>>
export type GetPurchaseOrderSupplierPerformanceQueryError = ErrorType<unknown>



export function useGetPurchaseOrderSupplierPerformance<TData = Awaited<ReturnType<typeof getPurchaseOrderSupplierPerformance>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPurchaseOrderSupplierPerformance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPurchaseOrderSupplierPerformanceQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPurchaseOrderRecentAuditUrl = (id: string,
    params?: ListPurchaseOrderRecentAuditParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/purchase-orders/${id}/overview/audit?${stringifiedParams}` : `/api/purchase-orders/${id}/overview/audit`
}

export const listPurchaseOrderRecentAudit = async (id: string,
    params?: ListPurchaseOrderRecentAuditParams, options?: RequestInit): Promise<PurchaseOrderAuditSection> => {

  return customFetch<PurchaseOrderAuditSection>(getListPurchaseOrderRecentAuditUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPurchaseOrderRecentAuditQueryKey = (id: string,
    params?: ListPurchaseOrderRecentAuditParams,) => {
    return [
    `/api/purchase-orders/${id}/overview/audit`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPurchaseOrderRecentAuditQueryOptions = <TData = Awaited<ReturnType<typeof listPurchaseOrderRecentAudit>>, TError = ErrorType<unknown>>(id: string,
    params?: ListPurchaseOrderRecentAuditParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchaseOrderRecentAudit>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPurchaseOrderRecentAuditQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPurchaseOrderRecentAudit>>> = ({ signal }) => listPurchaseOrderRecentAudit(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPurchaseOrderRecentAudit>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPurchaseOrderRecentAuditQueryResult = NonNullable<Awaited<ReturnType<typeof listPurchaseOrderRecentAudit>>>
export type ListPurchaseOrderRecentAuditQueryError = ErrorType<unknown>



export function useListPurchaseOrderRecentAudit<TData = Awaited<ReturnType<typeof listPurchaseOrderRecentAudit>>, TError = ErrorType<unknown>>(
 id: string,
    params?: ListPurchaseOrderRecentAuditParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchaseOrderRecentAudit>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPurchaseOrderRecentAuditQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRequestPurchaseOrderExportUrl = () => {




  return `/api/purchase-orders/export`
}

/**
 * @summary Request an export of overview rows
 */
export const requestPurchaseOrderExport = async (purchaseOrderExportRequest: PurchaseOrderExportRequest, options?: RequestInit): Promise<PurchaseOrderExport> => {

  return customFetch<PurchaseOrderExport>(getRequestPurchaseOrderExportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(purchaseOrderExportRequest)
  }
);}





export const getRequestPurchaseOrderExportMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPurchaseOrderExport>>, TError,{data: BodyType<PurchaseOrderExportRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestPurchaseOrderExport>>, TError,{data: BodyType<PurchaseOrderExportRequest>}, TContext> => {

const mutationKey = ['requestPurchaseOrderExport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestPurchaseOrderExport>>, {data: BodyType<PurchaseOrderExportRequest>}> = (props) => {
          const {data} = props ?? {};

          return  requestPurchaseOrderExport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestPurchaseOrderExportMutationResult = NonNullable<Awaited<ReturnType<typeof requestPurchaseOrderExport>>>
    export type RequestPurchaseOrderExportMutationBody = BodyType<PurchaseOrderExportRequest>
    export type RequestPurchaseOrderExportMutationError = ErrorType<void>

    /**
 * @summary Request an export of overview rows
 */
export const useRequestPurchaseOrderExport = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPurchaseOrderExport>>, TError,{data: BodyType<PurchaseOrderExportRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestPurchaseOrderExport>>,
        TError,
        {data: BodyType<PurchaseOrderExportRequest>},
        TContext
      > => {
      return useMutation(getRequestPurchaseOrderExportMutationOptions(options));
    }

export const getGetSalesPerformanceUrl = (params: GetSalesPerformanceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/sales-performance?${stringifiedParams}` : `/api/sales-performance`
}

export const getSalesPerformance = async (params: GetSalesPerformanceParams, options?: RequestInit): Promise<SalesPerformanceResponse | void> => {

  return customFetch<SalesPerformanceResponse | void>(getGetSalesPerformanceUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSalesPerformanceQueryKey = (params?: GetSalesPerformanceParams,) => {
    return [
    `/api/sales-performance`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSalesPerformanceQueryOptions = <TData = Awaited<ReturnType<typeof getSalesPerformance>>, TError = ErrorType<unknown>>(params: GetSalesPerformanceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSalesPerformance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSalesPerformanceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSalesPerformance>>> = ({ signal }) => getSalesPerformance(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSalesPerformance>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSalesPerformanceQueryResult = NonNullable<Awaited<ReturnType<typeof getSalesPerformance>>>
export type GetSalesPerformanceQueryError = ErrorType<unknown>



export function useGetSalesPerformance<TData = Awaited<ReturnType<typeof getSalesPerformance>>, TError = ErrorType<unknown>>(
 params: GetSalesPerformanceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSalesPerformance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSalesPerformanceQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportSalesPerformanceUrl = () => {




  return `/api/exports/sales-performance`
}

export const exportSalesPerformance = async (exportSalesPerformanceBody: ExportSalesPerformanceBody, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getExportSalesPerformanceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(exportSalesPerformanceBody)
  }
);}





export const getExportSalesPerformanceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportSalesPerformance>>, TError,{data: BodyType<ExportSalesPerformanceBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof exportSalesPerformance>>, TError,{data: BodyType<ExportSalesPerformanceBody>}, TContext> => {

const mutationKey = ['exportSalesPerformance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportSalesPerformance>>, {data: BodyType<ExportSalesPerformanceBody>}> = (props) => {
          const {data} = props ?? {};

          return  exportSalesPerformance(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExportSalesPerformanceMutationResult = NonNullable<Awaited<ReturnType<typeof exportSalesPerformance>>>
    export type ExportSalesPerformanceMutationBody = BodyType<ExportSalesPerformanceBody>
    export type ExportSalesPerformanceMutationError = ErrorType<void>

    export const useExportSalesPerformance = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportSalesPerformance>>, TError,{data: BodyType<ExportSalesPerformanceBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof exportSalesPerformance>>,
        TError,
        {data: BodyType<ExportSalesPerformanceBody>},
        TContext
      > => {
      return useMutation(getExportSalesPerformanceMutationOptions(options));
    }

export const getGetVariantSplitWorkspaceUrl = (id: string,
    params: GetVariantSplitWorkspaceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/purchase-orders/${id}/variant-split/workspace?${stringifiedParams}` : `/api/purchase-orders/${id}/variant-split/workspace`
}

export const getVariantSplitWorkspace = async (id: string,
    params: GetVariantSplitWorkspaceParams, options?: RequestInit): Promise<VariantSplitWorkspace> => {

  return customFetch<VariantSplitWorkspace>(getGetVariantSplitWorkspaceUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetVariantSplitWorkspaceQueryKey = (id: string,
    params?: GetVariantSplitWorkspaceParams,) => {
    return [
    `/api/purchase-orders/${id}/variant-split/workspace`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetVariantSplitWorkspaceQueryOptions = <TData = Awaited<ReturnType<typeof getVariantSplitWorkspace>>, TError = ErrorType<void>>(id: string,
    params: GetVariantSplitWorkspaceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVariantSplitWorkspace>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVariantSplitWorkspaceQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVariantSplitWorkspace>>> = ({ signal }) => getVariantSplitWorkspace(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVariantSplitWorkspace>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVariantSplitWorkspaceQueryResult = NonNullable<Awaited<ReturnType<typeof getVariantSplitWorkspace>>>
export type GetVariantSplitWorkspaceQueryError = ErrorType<void>



export function useGetVariantSplitWorkspace<TData = Awaited<ReturnType<typeof getVariantSplitWorkspace>>, TError = ErrorType<void>>(
 id: string,
    params: GetVariantSplitWorkspaceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVariantSplitWorkspace>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVariantSplitWorkspaceQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getMatchVariantSplitYearsUrl = (id: string,) => {




  return `/api/purchase-orders/${id}/variant-split/match`
}

export const matchVariantSplitYears = async (id: string,
    variantSplitMatchInput: VariantSplitMatchInput, options?: RequestInit): Promise<VariantSplitMatchResponse> => {

  return customFetch<VariantSplitMatchResponse>(getMatchVariantSplitYearsUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(variantSplitMatchInput)
  }
);}





export const getMatchVariantSplitYearsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchVariantSplitYears>>, TError,{id: string;data: BodyType<VariantSplitMatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof matchVariantSplitYears>>, TError,{id: string;data: BodyType<VariantSplitMatchInput>}, TContext> => {

const mutationKey = ['matchVariantSplitYears'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof matchVariantSplitYears>>, {id: string;data: BodyType<VariantSplitMatchInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  matchVariantSplitYears(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MatchVariantSplitYearsMutationResult = NonNullable<Awaited<ReturnType<typeof matchVariantSplitYears>>>
    export type MatchVariantSplitYearsMutationBody = BodyType<VariantSplitMatchInput>
    export type MatchVariantSplitYearsMutationError = ErrorType<unknown>

    export const useMatchVariantSplitYears = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchVariantSplitYears>>, TError,{id: string;data: BodyType<VariantSplitMatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof matchVariantSplitYears>>,
        TError,
        {id: string;data: BodyType<VariantSplitMatchInput>},
        TContext
      > => {
      return useMutation(getMatchVariantSplitYearsMutationOptions(options));
    }

export const getSearchVariantSplitDestinationsUrl = (id: string,
    params: SearchVariantSplitDestinationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/purchase-orders/${id}/variant-split/destinations/search?${stringifiedParams}` : `/api/purchase-orders/${id}/variant-split/destinations/search`
}

export const searchVariantSplitDestinations = async (id: string,
    params: SearchVariantSplitDestinationsParams, options?: RequestInit): Promise<SearchVariantSplitDestinations200> => {

  return customFetch<SearchVariantSplitDestinations200>(getSearchVariantSplitDestinationsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchVariantSplitDestinationsQueryKey = (id: string,
    params?: SearchVariantSplitDestinationsParams,) => {
    return [
    `/api/purchase-orders/${id}/variant-split/destinations/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchVariantSplitDestinationsQueryOptions = <TData = Awaited<ReturnType<typeof searchVariantSplitDestinations>>, TError = ErrorType<unknown>>(id: string,
    params: SearchVariantSplitDestinationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchVariantSplitDestinations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchVariantSplitDestinationsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchVariantSplitDestinations>>> = ({ signal }) => searchVariantSplitDestinations(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchVariantSplitDestinations>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchVariantSplitDestinationsQueryResult = NonNullable<Awaited<ReturnType<typeof searchVariantSplitDestinations>>>
export type SearchVariantSplitDestinationsQueryError = ErrorType<unknown>



export function useSearchVariantSplitDestinations<TData = Awaited<ReturnType<typeof searchVariantSplitDestinations>>, TError = ErrorType<unknown>>(
 id: string,
    params: SearchVariantSplitDestinationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchVariantSplitDestinations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSearchVariantSplitDestinationsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getLoadVariantSplitDraftUrl = (id: string,
    params: LoadVariantSplitDraftParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/purchase-orders/${id}/variant-split/draft?${stringifiedParams}` : `/api/purchase-orders/${id}/variant-split/draft`
}

export const loadVariantSplitDraft = async (id: string,
    params: LoadVariantSplitDraftParams, options?: RequestInit): Promise<VariantSplitDraft> => {

  return customFetch<VariantSplitDraft>(getLoadVariantSplitDraftUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLoadVariantSplitDraftQueryKey = (id: string,
    params?: LoadVariantSplitDraftParams,) => {
    return [
    `/api/purchase-orders/${id}/variant-split/draft`, ...(params ? [params] : [])
    ] as const;
    }


export const getLoadVariantSplitDraftQueryOptions = <TData = Awaited<ReturnType<typeof loadVariantSplitDraft>>, TError = ErrorType<void>>(id: string,
    params: LoadVariantSplitDraftParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof loadVariantSplitDraft>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLoadVariantSplitDraftQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof loadVariantSplitDraft>>> = ({ signal }) => loadVariantSplitDraft(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof loadVariantSplitDraft>>, TError, TData> & { queryKey: QueryKey }
}

export type LoadVariantSplitDraftQueryResult = NonNullable<Awaited<ReturnType<typeof loadVariantSplitDraft>>>
export type LoadVariantSplitDraftQueryError = ErrorType<void>



export function useLoadVariantSplitDraft<TData = Awaited<ReturnType<typeof loadVariantSplitDraft>>, TError = ErrorType<void>>(
 id: string,
    params: LoadVariantSplitDraftParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof loadVariantSplitDraft>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getLoadVariantSplitDraftQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSaveVariantSplitDraftUrl = (id: string,) => {




  return `/api/purchase-orders/${id}/variant-split/draft`
}

export const saveVariantSplitDraft = async (id: string,
    variantSplitDraftInput: VariantSplitDraftInput, options?: RequestInit): Promise<VariantSplitDraft> => {

  return customFetch<VariantSplitDraft>(getSaveVariantSplitDraftUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(variantSplitDraftInput)
  }
);}





export const getSaveVariantSplitDraftMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveVariantSplitDraft>>, TError,{id: string;data: BodyType<VariantSplitDraftInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveVariantSplitDraft>>, TError,{id: string;data: BodyType<VariantSplitDraftInput>}, TContext> => {

const mutationKey = ['saveVariantSplitDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveVariantSplitDraft>>, {id: string;data: BodyType<VariantSplitDraftInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  saveVariantSplitDraft(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveVariantSplitDraftMutationResult = NonNullable<Awaited<ReturnType<typeof saveVariantSplitDraft>>>
    export type SaveVariantSplitDraftMutationBody = BodyType<VariantSplitDraftInput>
    export type SaveVariantSplitDraftMutationError = ErrorType<unknown>

    export const useSaveVariantSplitDraft = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveVariantSplitDraft>>, TError,{id: string;data: BodyType<VariantSplitDraftInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveVariantSplitDraft>>,
        TError,
        {id: string;data: BodyType<VariantSplitDraftInput>},
        TContext
      > => {
      return useMutation(getSaveVariantSplitDraftMutationOptions(options));
    }

export const getDeleteVariantSplitDraftUrl = (id: string,
    params: DeleteVariantSplitDraftParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/purchase-orders/${id}/variant-split/draft?${stringifiedParams}` : `/api/purchase-orders/${id}/variant-split/draft`
}

export const deleteVariantSplitDraft = async (id: string,
    params: DeleteVariantSplitDraftParams, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteVariantSplitDraftUrl(id,params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteVariantSplitDraftMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVariantSplitDraft>>, TError,{id: string;params: DeleteVariantSplitDraftParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteVariantSplitDraft>>, TError,{id: string;params: DeleteVariantSplitDraftParams}, TContext> => {

const mutationKey = ['deleteVariantSplitDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVariantSplitDraft>>, {id: string;params: DeleteVariantSplitDraftParams}> = (props) => {
          const {id,params} = props ?? {};

          return  deleteVariantSplitDraft(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteVariantSplitDraftMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVariantSplitDraft>>>

    export type DeleteVariantSplitDraftMutationError = ErrorType<unknown>

    export const useDeleteVariantSplitDraft = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVariantSplitDraft>>, TError,{id: string;params: DeleteVariantSplitDraftParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteVariantSplitDraft>>,
        TError,
        {id: string;params: DeleteVariantSplitDraftParams},
        TContext
      > => {
      return useMutation(getDeleteVariantSplitDraftMutationOptions(options));
    }

export const getCreateVariantSplitYearSkuUrl = (id: string,) => {




  return `/api/purchase-orders/${id}/variant-split/variants`
}

export const createVariantSplitYearSku = async (id: string,
    variantSplitVariantInput: VariantSplitVariantInput, options?: RequestInit): Promise<VariantSplitVariantProposalResponse> => {

  return customFetch<VariantSplitVariantProposalResponse>(getCreateVariantSplitYearSkuUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(variantSplitVariantInput)
  }
);}





export const getCreateVariantSplitYearSkuMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVariantSplitYearSku>>, TError,{id: string;data: BodyType<VariantSplitVariantInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createVariantSplitYearSku>>, TError,{id: string;data: BodyType<VariantSplitVariantInput>}, TContext> => {

const mutationKey = ['createVariantSplitYearSku'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVariantSplitYearSku>>, {id: string;data: BodyType<VariantSplitVariantInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createVariantSplitYearSku(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVariantSplitYearSkuMutationResult = NonNullable<Awaited<ReturnType<typeof createVariantSplitYearSku>>>
    export type CreateVariantSplitYearSkuMutationBody = BodyType<VariantSplitVariantInput>
    export type CreateVariantSplitYearSkuMutationError = ErrorType<void>

    export const useCreateVariantSplitYearSku = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVariantSplitYearSku>>, TError,{id: string;data: BodyType<VariantSplitVariantInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createVariantSplitYearSku>>,
        TError,
        {id: string;data: BodyType<VariantSplitVariantInput>},
        TContext
      > => {
      return useMutation(getCreateVariantSplitYearSkuMutationOptions(options));
    }

export const getFinaliseVariantSplitReceiptUrl = (id: string,) => {




  return `/api/purchase-orders/${id}/variant-split/receive`
}

export const finaliseVariantSplitReceipt = async (id: string,
    variantSplitReceiptInput: VariantSplitReceiptInput, options?: RequestInit): Promise<void | VariantSplitReceiptDetail> => {

  return customFetch<void | VariantSplitReceiptDetail>(getFinaliseVariantSplitReceiptUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(variantSplitReceiptInput)
  }
);}





export const getFinaliseVariantSplitReceiptMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finaliseVariantSplitReceipt>>, TError,{id: string;data: BodyType<VariantSplitReceiptInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof finaliseVariantSplitReceipt>>, TError,{id: string;data: BodyType<VariantSplitReceiptInput>}, TContext> => {

const mutationKey = ['finaliseVariantSplitReceipt'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finaliseVariantSplitReceipt>>, {id: string;data: BodyType<VariantSplitReceiptInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  finaliseVariantSplitReceipt(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FinaliseVariantSplitReceiptMutationResult = NonNullable<Awaited<ReturnType<typeof finaliseVariantSplitReceipt>>>
    export type FinaliseVariantSplitReceiptMutationBody = BodyType<VariantSplitReceiptInput>
    export type FinaliseVariantSplitReceiptMutationError = ErrorType<void>

    export const useFinaliseVariantSplitReceipt = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finaliseVariantSplitReceipt>>, TError,{id: string;data: BodyType<VariantSplitReceiptInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof finaliseVariantSplitReceipt>>,
        TError,
        {id: string;data: BodyType<VariantSplitReceiptInput>},
        TContext
      > => {
      return useMutation(getFinaliseVariantSplitReceiptMutationOptions(options));
    }

export const getFinaliseCheckedInVariantSplitUrl = (id: string,) => {




  return `/api/purchase-orders/${id}/variant-split/checked-in`
}

export const finaliseCheckedInVariantSplit = async (id: string,
    checkedInVariantSplitInput: CheckedInVariantSplitInput, options?: RequestInit): Promise<void | VariantSplitReceiptDetail> => {

  return customFetch<void | VariantSplitReceiptDetail>(getFinaliseCheckedInVariantSplitUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(checkedInVariantSplitInput)
  }
);}





export const getFinaliseCheckedInVariantSplitMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finaliseCheckedInVariantSplit>>, TError,{id: string;data: BodyType<CheckedInVariantSplitInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof finaliseCheckedInVariantSplit>>, TError,{id: string;data: BodyType<CheckedInVariantSplitInput>}, TContext> => {

const mutationKey = ['finaliseCheckedInVariantSplit'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finaliseCheckedInVariantSplit>>, {id: string;data: BodyType<CheckedInVariantSplitInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  finaliseCheckedInVariantSplit(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FinaliseCheckedInVariantSplitMutationResult = NonNullable<Awaited<ReturnType<typeof finaliseCheckedInVariantSplit>>>
    export type FinaliseCheckedInVariantSplitMutationBody = BodyType<CheckedInVariantSplitInput>
    export type FinaliseCheckedInVariantSplitMutationError = ErrorType<void>

    export const useFinaliseCheckedInVariantSplit = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finaliseCheckedInVariantSplit>>, TError,{id: string;data: BodyType<CheckedInVariantSplitInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof finaliseCheckedInVariantSplit>>,
        TError,
        {id: string;data: BodyType<CheckedInVariantSplitInput>},
        TContext
      > => {
      return useMutation(getFinaliseCheckedInVariantSplitMutationOptions(options));
    }

export const getListVariantSplitReceiptsUrl = (id: string,
    params?: ListVariantSplitReceiptsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/purchase-orders/${id}/variant-split/receipts?${stringifiedParams}` : `/api/purchase-orders/${id}/variant-split/receipts`
}

export const listVariantSplitReceipts = async (id: string,
    params?: ListVariantSplitReceiptsParams, options?: RequestInit): Promise<ListVariantSplitReceipts200> => {

  return customFetch<ListVariantSplitReceipts200>(getListVariantSplitReceiptsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListVariantSplitReceiptsQueryKey = (id: string,
    params?: ListVariantSplitReceiptsParams,) => {
    return [
    `/api/purchase-orders/${id}/variant-split/receipts`, ...(params ? [params] : [])
    ] as const;
    }


export const getListVariantSplitReceiptsQueryOptions = <TData = Awaited<ReturnType<typeof listVariantSplitReceipts>>, TError = ErrorType<unknown>>(id: string,
    params?: ListVariantSplitReceiptsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVariantSplitReceipts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVariantSplitReceiptsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVariantSplitReceipts>>> = ({ signal }) => listVariantSplitReceipts(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVariantSplitReceipts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListVariantSplitReceiptsQueryResult = NonNullable<Awaited<ReturnType<typeof listVariantSplitReceipts>>>
export type ListVariantSplitReceiptsQueryError = ErrorType<unknown>



export function useListVariantSplitReceipts<TData = Awaited<ReturnType<typeof listVariantSplitReceipts>>, TError = ErrorType<unknown>>(
 id: string,
    params?: ListVariantSplitReceiptsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVariantSplitReceipts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListVariantSplitReceiptsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetVariantSplitReceiptUrl = (id: string,
    receiptId: string,) => {




  return `/api/purchase-orders/${id}/variant-split/receipts/${receiptId}`
}

export const getVariantSplitReceipt = async (id: string,
    receiptId: string, options?: RequestInit): Promise<VariantSplitReceiptDetail> => {

  return customFetch<VariantSplitReceiptDetail>(getGetVariantSplitReceiptUrl(id,receiptId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetVariantSplitReceiptQueryKey = (id: string,
    receiptId: string,) => {
    return [
    `/api/purchase-orders/${id}/variant-split/receipts/${receiptId}`
    ] as const;
    }


export const getGetVariantSplitReceiptQueryOptions = <TData = Awaited<ReturnType<typeof getVariantSplitReceipt>>, TError = ErrorType<void>>(id: string,
    receiptId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVariantSplitReceipt>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVariantSplitReceiptQueryKey(id,receiptId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVariantSplitReceipt>>> = ({ signal }) => getVariantSplitReceipt(id,receiptId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && receiptId !== null && receiptId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVariantSplitReceipt>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVariantSplitReceiptQueryResult = NonNullable<Awaited<ReturnType<typeof getVariantSplitReceipt>>>
export type GetVariantSplitReceiptQueryError = ErrorType<void>



export function useGetVariantSplitReceipt<TData = Awaited<ReturnType<typeof getVariantSplitReceipt>>, TError = ErrorType<void>>(
 id: string,
    receiptId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVariantSplitReceipt>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVariantSplitReceiptQueryOptions(id,receiptId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCommerceBoxStorageCapabilityUrl = () => {




  return `/api/commerce/boxes/storage-capability`
}

export const getCommerceBoxStorageCapability = async ( options?: RequestInit): Promise<CommerceBoxStorageCapability> => {

  return customFetch<CommerceBoxStorageCapability>(getGetCommerceBoxStorageCapabilityUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCommerceBoxStorageCapabilityQueryKey = () => {
    return [
    `/api/commerce/boxes/storage-capability`
    ] as const;
    }


export const getGetCommerceBoxStorageCapabilityQueryOptions = <TData = Awaited<ReturnType<typeof getCommerceBoxStorageCapability>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCommerceBoxStorageCapability>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCommerceBoxStorageCapabilityQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommerceBoxStorageCapability>>> = ({ signal }) => getCommerceBoxStorageCapability({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCommerceBoxStorageCapability>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCommerceBoxStorageCapabilityQueryResult = NonNullable<Awaited<ReturnType<typeof getCommerceBoxStorageCapability>>>
export type GetCommerceBoxStorageCapabilityQueryError = ErrorType<void>



export function useGetCommerceBoxStorageCapability<TData = Awaited<ReturnType<typeof getCommerceBoxStorageCapability>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCommerceBoxStorageCapability>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCommerceBoxStorageCapabilityQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetBoxSaleEligibilityUrl = (saleOrderId: string,
    params?: GetBoxSaleEligibilityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/commerce/boxes/shipping/sales/${saleOrderId}/eligibility?${stringifiedParams}` : `/api/commerce/boxes/shipping/sales/${saleOrderId}/eligibility`
}

export const getBoxSaleEligibility = async (saleOrderId: string,
    params?: GetBoxSaleEligibilityParams, options?: RequestInit): Promise<BoxSaleEligibility> => {

  return customFetch<BoxSaleEligibility>(getGetBoxSaleEligibilityUrl(saleOrderId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBoxSaleEligibilityQueryKey = (saleOrderId: string,
    params?: GetBoxSaleEligibilityParams,) => {
    return [
    `/api/commerce/boxes/shipping/sales/${saleOrderId}/eligibility`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetBoxSaleEligibilityQueryOptions = <TData = Awaited<ReturnType<typeof getBoxSaleEligibility>>, TError = ErrorType<void>>(saleOrderId: string,
    params?: GetBoxSaleEligibilityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBoxSaleEligibility>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBoxSaleEligibilityQueryKey(saleOrderId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBoxSaleEligibility>>> = ({ signal }) => getBoxSaleEligibility(saleOrderId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: saleOrderId !== null && saleOrderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBoxSaleEligibility>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBoxSaleEligibilityQueryResult = NonNullable<Awaited<ReturnType<typeof getBoxSaleEligibility>>>
export type GetBoxSaleEligibilityQueryError = ErrorType<void>



export function useGetBoxSaleEligibility<TData = Awaited<ReturnType<typeof getBoxSaleEligibility>>, TError = ErrorType<void>>(
 saleOrderId: string,
    params?: GetBoxSaleEligibilityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBoxSaleEligibility>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBoxSaleEligibilityQueryOptions(saleOrderId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPreorderStorageCorrectionPreviewUrl = (saleOrderId: string,) => {




  return `/api/commerce/boxes/shipping/sales/${saleOrderId}/preorder-storage-correction`
}

export const getPreorderStorageCorrectionPreview = async (saleOrderId: string, options?: RequestInit): Promise<PreorderStorageCorrectionPreview> => {

  return customFetch<PreorderStorageCorrectionPreview>(getGetPreorderStorageCorrectionPreviewUrl(saleOrderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPreorderStorageCorrectionPreviewQueryKey = (saleOrderId: string,) => {
    return [
    `/api/commerce/boxes/shipping/sales/${saleOrderId}/preorder-storage-correction`
    ] as const;
    }


export const getGetPreorderStorageCorrectionPreviewQueryOptions = <TData = Awaited<ReturnType<typeof getPreorderStorageCorrectionPreview>>, TError = ErrorType<void>>(saleOrderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPreorderStorageCorrectionPreview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPreorderStorageCorrectionPreviewQueryKey(saleOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPreorderStorageCorrectionPreview>>> = ({ signal }) => getPreorderStorageCorrectionPreview(saleOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: saleOrderId !== null && saleOrderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPreorderStorageCorrectionPreview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPreorderStorageCorrectionPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof getPreorderStorageCorrectionPreview>>>
export type GetPreorderStorageCorrectionPreviewQueryError = ErrorType<void>



export function useGetPreorderStorageCorrectionPreview<TData = Awaited<ReturnType<typeof getPreorderStorageCorrectionPreview>>, TError = ErrorType<void>>(
 saleOrderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPreorderStorageCorrectionPreview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPreorderStorageCorrectionPreviewQueryOptions(saleOrderId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getApplyPreorderStorageCorrectionUrl = (saleOrderId: string,) => {




  return `/api/commerce/boxes/shipping/sales/${saleOrderId}/preorder-storage-correction`
}

export const applyPreorderStorageCorrection = async (saleOrderId: string,
    preorderStorageCorrectionInput: PreorderStorageCorrectionInput, options?: RequestInit): Promise<PreorderStorageCorrectionResult> => {

  return customFetch<PreorderStorageCorrectionResult>(getApplyPreorderStorageCorrectionUrl(saleOrderId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(preorderStorageCorrectionInput)
  }
);}





export const getApplyPreorderStorageCorrectionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyPreorderStorageCorrection>>, TError,{saleOrderId: string;data: BodyType<PreorderStorageCorrectionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof applyPreorderStorageCorrection>>, TError,{saleOrderId: string;data: BodyType<PreorderStorageCorrectionInput>}, TContext> => {

const mutationKey = ['applyPreorderStorageCorrection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof applyPreorderStorageCorrection>>, {saleOrderId: string;data: BodyType<PreorderStorageCorrectionInput>}> = (props) => {
          const {saleOrderId,data} = props ?? {};

          return  applyPreorderStorageCorrection(saleOrderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApplyPreorderStorageCorrectionMutationResult = NonNullable<Awaited<ReturnType<typeof applyPreorderStorageCorrection>>>
    export type ApplyPreorderStorageCorrectionMutationBody = BodyType<PreorderStorageCorrectionInput>
    export type ApplyPreorderStorageCorrectionMutationError = ErrorType<void>

    export const useApplyPreorderStorageCorrection = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyPreorderStorageCorrection>>, TError,{saleOrderId: string;data: BodyType<PreorderStorageCorrectionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof applyPreorderStorageCorrection>>,
        TError,
        {saleOrderId: string;data: BodyType<PreorderStorageCorrectionInput>},
        TContext
      > => {
      return useMutation(getApplyPreorderStorageCorrectionMutationOptions(options));
    }

